import e, { keyframes as t, css as n, ThemeProvider as i } from "styled-components";
import r, { forwardRef as o, Component as a, PureComponent as s, createElement as l, Children as u } from "react";
import c, { unstable_batchedUpdates as p, findDOMNode as f } from "react-dom";
import { renderToStaticMarkup as h } from "react-dom/server";
var d = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function g(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function m(e, t, n) {
  return e(n = {
    path: t,
    exports: {},
    require: function require(e, t) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation.
      
      Permission to use, copy, modify, and/or distribute this software for any
      purpose with or without fee is hereby granted.
      
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
      REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
      AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
      INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
      LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
      OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
      PERFORMANCE OF THIS SOFTWARE.
      ***************************************************************************** */
      (null == t && n.path);
    }
  }, n.exports), n.exports;
}

var _y2 = function y(e, t) {
  return (_y2 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) {
      t.hasOwnProperty(n) && (e[n] = t[n]);
    }
  })(e, t);
};

function _(e, t) {
  function n() {
    this.constructor = e;
  }

  _y2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}

var _v2 = function v() {
  return (_v2 = Object.assign || function (e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function b(e, t) {
  var n = {};

  for (var i in e) {
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(e); r < i.length; r++) {
      t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (n[i[r]] = e[i[r]]);
    }
  }

  return n;
}

function w(e, t, n, i) {
  var r,
      o = arguments.length,
      a = o < 3 ? t : null === i ? i = Object.getOwnPropertyDescriptor(t, n) : i;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, i);else for (var s = e.length - 1; s >= 0; s--) {
    (r = e[s]) && (a = (o < 3 ? r(a) : o > 3 ? r(t, n, a) : r(t, n)) || a);
  }
  return o > 3 && a && Object.defineProperty(t, n, a), a;
}

function x(e, t, n, i) {
  return new (n || (n = Promise))(function (r, o) {
    function a(e) {
      try {
        l(i.next(e));
      } catch (e) {
        o(e);
      }
    }

    function s(e) {
      try {
        l(i.throw(e));
      } catch (e) {
        o(e);
      }
    }

    function l(e) {
      var t;
      e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(a, s);
    }

    l((i = i.apply(e, t || [])).next());
  });
}

function k(e, t) {
  var n,
      i,
      r,
      o,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & r[0]) throw r[1];
      return r[1];
    },
    trys: [],
    ops: []
  };
  return o = {
    next: s(0),
    throw: s(1),
    return: s(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;

  function s(o) {
    return function (s) {
      return function (o) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (n = 1, i && (r = 2 & o[0] ? i.return : o[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, o[1])).done) return r;

            switch (i = 0, r && (o = [2 & o[0], r.value]), o[0]) {
              case 0:
              case 1:
                r = o;
                break;

              case 4:
                return a.label++, {
                  value: o[1],
                  done: !1
                };

              case 5:
                a.label++, i = o[1], o = [0];
                continue;

              case 7:
                o = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                  a = 0;
                  continue;
                }

                if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                  a.label = o[1];
                  break;
                }

                if (6 === o[0] && a.label < r[1]) {
                  a.label = r[1], r = o;
                  break;
                }

                if (r && a.label < r[2]) {
                  a.label = r[2], a.ops.push(o);
                  break;
                }

                r[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            o = t.call(e, a);
          } catch (e) {
            o = [6, e], i = 0;
          } finally {
            n = r = 0;
          }
        }

        if (5 & o[0]) throw o[1];
        return {
          value: o[0] ? o[1] : void 0,
          done: !0
        };
      }([o, s]);
    };
  }
}

function T(e) {
  var t = "function" == typeof Symbol && Symbol.iterator,
      n = t && e[t],
      i = 0;
  if (n) return n.call(e);
  if (e && "number" == typeof e.length) return {
    next: function next() {
      return e && i >= e.length && (e = void 0), {
        value: e && e[i++],
        done: !e
      };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function S(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var i,
      r,
      o = n.call(e),
      a = [];

  try {
    for (; (void 0 === t || t-- > 0) && !(i = o.next()).done;) {
      a.push(i.value);
    }
  } catch (e) {
    r = {
      error: e
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (r) throw r.error;
    }
  }

  return a;
}

function C() {
  for (var e = [], t = 0; t < arguments.length; t++) {
    e = e.concat(S(arguments[t]));
  }

  return e;
}

function E(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", {
    value: t
  }) : e.raw = t, e;
}

var O = function () {
  function e(e, t, n) {
    void 0 === t && (t = {
      x: 1,
      y: 1
    }), void 0 === n && (n = 0), this.position = e, this.scale = t, this.rotation = n;
  }

  return Object.defineProperty(e, "IDENTITY", {
    get: function get() {
      return new e({
        x: 0,
        y: 0
      });
    },
    enumerable: !0,
    configurable: !0
  }), e;
}(),
    R = function () {
  function e(e, t) {
    "number" == typeof e ? (this.x = e, this.y = t) : (this.x = e.x, this.y = e.y);
  }

  return e.fromSize = function (t) {
    return new e(t.width, t.height);
  }, e.distance = function (e, t) {
    var n = t.x - e.x,
        i = t.y - e.y;
    return Math.sqrt(n * n + i * i);
  }, e.dot = function (e, t) {
    return e.x * t.x + e.y * t.y;
  }, e.lerp = function (t, n, i) {
    var r = Math.min(Math.max(i, 0), 1);
    return new e(t.x * r + n.x * (1 - r), t.y * r + n.y * (1 - r));
  }, e.lerpUnclamped = function (t, n, i) {
    return new e(t.x * i + n.x * (1 - i), t.y * i + n.y * (1 - i));
  }, e.proportionalFit = function (e, t) {
    return e.x / e.y > t.x / t.y ? t.multiply(e.y / t.y) : t.multiply(e.x / t.x);
  }, Object.defineProperty(e.prototype, "magnitude", {
    get: function get() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "normalized", {
    get: function get() {
      var t = this.magnitude;
      return new e(this.x / t, this.y / t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "floored", {
    get: function get() {
      return new e(Math.floor(this.x), Math.floor(this.y));
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rounded", {
    get: function get() {
      return new e(Math.round(this.x), Math.round(this.y));
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "min", {
    get: function get() {
      return Math.min(this.x, this.y);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "max", {
    get: function get() {
      return Math.max(this.x, this.y);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "abs", {
    get: function get() {
      return new e(Math.abs(this.x), Math.abs(this.y));
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "swapped", {
    get: function get() {
      return new e(this.y, this.x);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.clone = function () {
    return new e(this.x, this.y);
  }, e.prototype.add = function (t, n) {
    return "number" == typeof t ? new e(this.x + t, this.y + n) : new e(this.x + t.x, this.y + t.y);
  }, e.prototype.subtract = function (t, n) {
    return "number" == typeof t ? new e(this.x - t, this.y - n) : new e(this.x - t.x, this.y - t.y);
  }, e.prototype.multiply = function (t, n) {
    return "number" == typeof t ? new e(this.x * t, this.y * (void 0 === n ? t : n)) : new e(this.x * t.x, this.y * t.y);
  }, e.prototype.divide = function (t, n) {
    return "number" == typeof t ? new e(this.x / t, this.y / (void 0 === n ? t : n)) : new e(this.x / t.x, this.y / t.y);
  }, e.prototype.equals = function (e) {
    return this.x === e.x && this.y === e.y;
  }, e.prototype.clamp = function (t, n) {
    return new e(Math.max(t.x, Math.min(n.x, this.x)), Math.max(t.y, Math.min(n.y, this.y)));
  }, e.ZERO = new e(0, 0), e.ONE = new e(1, 1), e.UP = new e(0, 1), e.DOWN = new e(0, -1), e.RIGHT = new e(1, 0), e.LEFT = new e(-1, 0), e;
}(),
    I = function () {
  function e(e, t, n, i) {
    if ("number" == typeof e) {
      if ("number" != typeof t || void 0 === n || void 0 === i) throw new Error("Invalid arguments passed to Rect. Expected (number, number, number, number)");
      this.origin = {
        x: e,
        y: t
      }, this.size = {
        width: n || 0,
        height: i || 0
      };
    } else {
      if (this.origin = e, "number" == typeof t) throw new Error("Invalid arguments passed to Rect. Expected (Float2, Size)");
      this.size = t;
    }
  }

  return e.contains = function (e, t) {
    return t.x >= e.minX && t.x <= e.maxX && t.y >= e.minY && t.y <= e.maxY;
  }, Object.defineProperty(e.prototype, "minX", {
    get: function get() {
      return this.origin.x;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "minY", {
    get: function get() {
      return this.origin.y;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "midX", {
    get: function get() {
      return this.origin.x + .5 * this.size.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "midY", {
    get: function get() {
      return this.origin.y + .5 * this.size.height;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "maxX", {
    get: function get() {
      return this.origin.x + this.size.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "maxY", {
    get: function get() {
      return this.origin.y + this.size.height;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "width", {
    get: function get() {
      return this.size.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "height", {
    get: function get() {
      return this.size.height;
    },
    enumerable: !0,
    configurable: !0
  }), e.ZERO = new e({
    x: 0,
    y: 0
  }, {
    width: 0,
    height: 0
  }), e;
}(),
    A = function () {
  function e(e, t, n, i, r, o) {
    this.a = e, this.b = t, this.c = n, this.d = i, this.tx = r, this.ty = o;
  }

  return e.fromScale = function (t, n) {
    return new e(t, 0, 0, n, 0, 0);
  }, e.fromRotation = function (t) {
    var n = Math.cos(t),
        i = Math.sin(t);
    return new e(n, -i, i, n, 0, 0);
  }, e.fromRotationDeg = function (e) {
    var t = Math.PI * e / 180;
    return this.fromRotation(t);
  }, e.fromTranslation = function (t, n) {
    return new e(1, 0, 0, 1, t, n);
  }, e.fromTRS = function (t, n, i, r, o) {
    var a = Math.cos(i),
        s = Math.sin(i);
    return new e(r * a, -o * s, r * s, o * a, t, n);
  }, e.multiply = function (t, n) {
    return new e(t.a * n.a + t.b * n.c, t.a * n.b + t.b * n.d, t.c * n.a + t.d * n.c, t.c * n.b + t.d * n.d, t.a * n.tx + t.b * n.ty + t.tx, t.c * n.tx + t.d * n.ty + t.ty);
  }, e.transformPoint = function (e, t) {
    return {
      x: e.a * t.x + e.b * t.y + e.tx,
      y: e.c * t.x + e.d * t.y + e.ty
    };
  }, e.getInverted = function (t) {
    var n = t.a * t.d - t.b * t.c;
    if (0 === n) return t;
    var i = 1 / n;
    return new e(i * t.d, -i * t.b, -i * t.c, i * t.a, i * (t.b * t.ty - t.d * t.tx), i * (t.c * t.tx - t.a * t.ty));
  }, e.IDENTITY = e.fromScale(1, 1), e;
}();

function M(e) {
  return "number" == typeof e;
}

function F() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
    var t = 16 * Math.random() | 0;
    return ("x" === e ? t : 3 & t | 8).toString(16);
  });
}

window.performance.now.bind(window.performance);

var D,
    P,
    z,
    L = function () {
  function e(e) {
    this.text = e, this.lastOffsetWidth = -1;
    var t = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
    this.element = document.createElement("div"), this.element.setAttribute("aria-hidden", "true"), this.element.appendChild(document.createTextNode(e)), this.collapsible = document.createElement("span"), this.expandable = document.createElement("span"), this.collapsibleInner = document.createElement("span"), this.expandableInner = document.createElement("span"), this.collapsible.style.cssText = t, this.expandable.style.cssText = t, this.expandableInner.style.cssText = t, this.collapsibleInner.style.cssText = "display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;", this.collapsible.appendChild(this.collapsibleInner), this.expandable.appendChild(this.expandableInner), this.element.appendChild(this.collapsible), this.element.appendChild(this.expandable);
  }

  return e.prototype.getElement = function () {
    return this.element;
  }, e.prototype.setFont = function (e) {
    this.element.style.cssText = "max-width:none;\n      min-width:20px;\n      min-height:20px;\n      display:inline-block;\n      overflow:hidden;\n      position:absolute;\n      width:auto;\n      margin:0;\n      padding:0;\n      top:-999px;\n      white-space:nowrap;\n      font-synthesis:none;\n      font:" + e + ";";
  }, e.prototype.getWidth = function () {
    return this.element.offsetWidth;
  }, e.prototype.setWidth = function (e) {
    this.element.style.width = e + "px";
  }, e.prototype.onResize = function (e) {
    var t = this,
        n = function n() {
      t.onScroll(e);
    };

    this.collapsible.addEventListener("scroll", n), this.expandable.addEventListener("scroll", n), this.reset();
  }, e.prototype.reset = function () {
    var e = this.getWidth(),
        t = e + 100;
    return this.expandableInner.style.width = t + "px", this.expandable.scrollLeft = t, this.collapsible.scrollLeft = this.collapsible.scrollWidth + 100, this.lastOffsetWidth !== e && (this.lastOffsetWidth = e, !0);
  }, e.prototype.onScroll = function (e) {
    this.reset() && null !== this.element.parentNode && e(this.lastOffsetWidth);
  }, e;
}(),
    B = function () {
  function e(e) {
    this.font = _v2({
      fontFamily: "normal",
      fontStyle: "normal",
      fontWeight: "normal",
      fontStretch: "normal"
    }, e);
  }

  return e.getUserAgent = function () {
    return window.navigator.userAgent;
  }, e.getNavigatorVendor = function () {
    return window.navigator.vendor;
  }, e.hasWebKitFallbackBug = function () {
    if (null === e.HAS_WEBKIT_FALLBACK_BUG) {
      var t = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(e.getUserAgent());
      e.HAS_WEBKIT_FALLBACK_BUG = !!t && (parseInt(t[1], 10) < 536 || 536 === parseInt(t[1], 10) && parseInt(t[2], 10) <= 11);
    }

    return e.HAS_WEBKIT_FALLBACK_BUG;
  }, e.hasSafari10Bug = function () {
    if (null === e.HAS_SAFARI_10_BUG) if (e.supportsNativeFontLoading() && /Apple/.test(e.getNavigatorVendor())) {
      var t = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(e.getUserAgent());
      e.HAS_SAFARI_10_BUG = !!t && parseInt(t[1], 10) < 603;
    } else e.HAS_SAFARI_10_BUG = !1;
    return e.HAS_SAFARI_10_BUG;
  }, e.supportsNativeFontLoading = function () {
    return null === e.SUPPORTS_NATIVE_FONT_LOADING && (e.SUPPORTS_NATIVE_FONT_LOADING = !!document.fonts), e.SUPPORTS_NATIVE_FONT_LOADING;
  }, e.supportsStretch = function () {
    if (null === e.SUPPORTS_STRETCH) {
      var t = document.createElement("div");

      try {
        t.style.font = "condensend 100px sans-serif";
      } catch (t) {
        e.SUPPORTS_STRETCH = !1;
      }

      e.SUPPORTS_STRETCH = "" !== t.style.font;
    }

    return e.SUPPORTS_STRETCH;
  }, e.prototype.load = function (t, n) {
    var i = this,
        r = null,
        o = n || e.DEFAULT_TIMEOUT,
        a = this.getTime();
    return new Promise(function (t, n) {
      if (e.supportsNativeFontLoading() && !e.hasSafari10Bug()) {
        var s = new Promise(function (e, t) {
          var r = function r() {
            i.getTime() - a >= o ? t(new Error(o + "ms timeout exceeded")) : document.fonts.load(i.getStyle('"' + i.font.fontFamily + '"'), "BESbswy").then(function (t) {
              t.length >= 1 ? e() : setTimeout(r, 25);
            }, n);
          };

          r();
        }),
            l = new Promise(function (e, t) {
          r = setTimeout(function () {
            t(new Error(o + " ms timeout exceeded"));
          }, o);
        });
        Promise.race([l, s]).then(function () {
          clearTimeout(r), t(i);
        }, n);
      } else {
        var u = new L("BESbswy"),
            c = new L("BESbswy"),
            p = new L("BESbswy"),
            f = -1,
            h = -1,
            d = -1,
            g = -1,
            m = -1,
            y = -1,
            _ = document.createElement("div"),
            v = function v() {
          null !== _.parentNode && _.parentNode.removeChild(_);
        },
            b = function b() {
          if ((-1 !== f && -1 !== h || -1 !== f && -1 !== d || -1 !== h && -1 !== d) && (f === h || f === d || h === d)) {
            if (e.hasWebKitFallbackBug() && (f === g && h === g && d === g || f === m && h === m && d === m || f === y && h === y && d === y)) return;
            v(), clearTimeout(r), t(i);
          }
        };

        _.dir = "ltr", u.setFont(i.getStyle("sans-serif")), c.setFont(i.getStyle("serif")), p.setFont(i.getStyle("monospace")), _.appendChild(u.getElement()), _.appendChild(c.getElement()), _.appendChild(p.getElement()), document.body.appendChild(_), g = u.getWidth(), m = c.getWidth(), y = p.getWidth();

        var w = function w() {
          if (i.getTime() - a >= o) v(), n(new Error(o + " ms timeout exceeded"));else {
            var e = document.hidden;
            !0 !== e && void 0 !== e || (f = u.getWidth(), h = c.getWidth(), d = p.getWidth(), b()), r = setTimeout(w, 50);
          }
        };

        w(), u.onResize(function (e) {
          f = e, b();
        }), u.setFont(i.getStyle('"' + i.font.fontFamily + '",sans-serif')), c.onResize(function (e) {
          h = e, b();
        }), c.setFont(i.getStyle('"' + i.font.fontFamily + '",serif')), p.onResize(function (e) {
          d = e, b();
        }), p.setFont(i.getStyle('"' + i.font.fontFamily + '",monospace'));
      }
    });
  }, e.prototype.getStyle = function (t) {
    return [this.font.fontStyle, this.font.fontWeight, e.supportsStretch() ? this.font.fontStretch : "", "100px", t].join(" ");
  }, e.prototype.getTime = function () {
    return new Date().getTime();
  }, e.HAS_WEBKIT_FALLBACK_BUG = null, e.HAS_SAFARI_10_BUG = null, e.SUPPORTS_STRETCH = null, e.SUPPORTS_NATIVE_FONT_LOADING = null, e.DEFAULT_TIMEOUT = 3e3, e;
}();

function N(e) {
  return !Object.prototype.hasOwnProperty.call(e, "name");
}

function U(e) {
  return !Object.prototype.hasOwnProperty.call(e, "name");
}

!function (e) {
  e.UNDO = "undo", e.REDO = "redo", e.DELETE = "delete", e.BRING_TO_FRONT = "bringtofront", e.EDIT = "edit", e.DUPLICATE = "duplicate", e.ADD = "add", e.FLIP = "flip", e.INVERT = "invert", e.CLOSE = "close", e.EXPORT = "export";
}(D || (D = {})), function (e) {
  e.LIBRARY = "library", e.ART_FILTER = "artFilter", e.TRANSFORM = "transform", e.FILTER = "filter", e.ADJUSTMENT = "adjustment", e.FOCUS = "focus", e.STICKER = "sticker", e.TEXT = "text", e.TEXT_DESIGN = "textdesign", e.OVERLAY = "overlay", e.FRAME = "frame", e.BRUSH = "brush";
}(P || (P = {})), function (e) {
  e.LARGE = "large", e.MEDIUM = "medium", e.SMALL = "small";
}(z || (z = {}));

var j,
    W,
    H,
    G = function G() {
  this.enabled = !0, this.threshold = 20, this.snapToHorizontalCenter = !0, this.snapToVerticalCenter = !0, this.snapToLeft = .1, this.snapToRight = .1, this.snapToTop = .1, this.snapToBottom = .1;
},
    V = function V() {
  this.enabled = !0, this.threshold = 20, this.angles = [0, 45, 90, 135, 180, 225, 270, 315];
},
    X = function X() {
  this.position = new G(), this.rotation = new V();
};

!function (e) {
  e.MP4 = "video/mp4", e.MOV = "video/quicktime";
}(j || (j = {})), function (e) {
  e.H264 = "h264", e.HEVC = "hevc";
}(W || (W = {})), function (e) {
  e.OBJECT = "object";
}(H || (H = {}));

var Y,
    q,
    K = function K() {};

!function (e) {
  e.IMAGE = "image", e.DATA_URL = "data-url", e.BLOB = "blob", e.MSBLOB = "ms-blob";
}(Y || (Y = {})), function (e) {
  e.PNG = "image/png", e.JPEG = "image/jpeg", e.RAW = "raw";
}(q || (q = {}));

var Z,
    Q = function Q() {
  this.order = "default", this.language = "en", this.theme = "dark", this.assetBaseUrl = "assets/", this.displayResizeWarning = !0, this.displayCloseWarning = !0, this.displayToolControlBarTitle = !0, this.forceCrop = !1, this.enableZoom = !0, this.defaultTool = P.FILTER;
};

P.FILTER, P.FOCUS, P.ADJUSTMENT, P.LIBRARY, P.OVERLAY, P.STICKER, P.TEXT, P.TEXT_DESIGN, P.FRAME, P.BRUSH, P.TRANSFORM, function (e) {
  e.BRIGHTNESS = "brightness", e.CONTRAST = "contrast", e.SATURATION = "saturation", e.CLARITY = "clarity", e.SHADOWS = "shadows", e.HIGHLIGHTS = "highlights", e.EXPOSURE = "exposure", e.GAMMA = "gamma", e.BLACKS = "blacks", e.WHITES = "whites", e.TEMPERATURE = "temperature", e.SHARPNESS = "sharpness";
}(Z || (Z = {}));

var J = function J() {
  this.categories = [];
},
    $ = function $() {
  this.categories = [], this.flattenCategories = !1, this.enablePreviewThumbnails = !1;
};

function ee(e) {
  return void 0 !== e.lightColor;
}

function te(e) {
  return void 0 !== e.lutURI;
}

var ne,
    ie = function ie() {
  this.items = [];
};

!function (e) {
  e.RADIAL = "radial", e.LINEAR = "linear", e.MIRRORED = "mirrored", e.GAUSSIAN = "gaussian";
}(ne || (ne = {}));

var re,
    oe = function oe() {
  this.items = [];
},
    ae = function () {
  function e(e) {
    this.name = e.name, this.coverImageUrl = e.coverImageUrl;
  }

  return e.prototype.loadCoverImage = function (e) {
    var t = this;
    return void 0 === e && (e = "anonymous"), new Promise(function (n, i) {
      var r = new Image();
      r.addEventListener("load", function () {
        n(r);
      }), r.addEventListener("error", function () {
        i(new Error("Failed to load image at " + t.coverImage));
      }), r.crossOrigin = e, r.src = t.coverImageUrl, t.coverImage = r;
    });
  }, e;
}(),
    se = function () {
  function e(e) {
    this.category = e.title, this.thumbUrl = e.thumbUrl, this.rawUrl = e.rawUrl;
  }

  return e.prototype.loadThumbImage = function (e) {
    var t = this;
    return void 0 === e && (e = "anonymous"), new Promise(function (n, i) {
      var r = new Image();
      r.addEventListener("load", function () {
        n(r);
      }), r.addEventListener("error", function () {
        i(new Error("Failed to load image at " + t.thumbUrl));
      }), r.crossOrigin = e, r.src = t.thumbUrl, t.thumbImage = r;
    });
  }, e.prototype.getThumbImage = function () {
    return this.thumbUrl;
  }, e;
}(),
    le = function le() {
  this.enableWebcam = !1, this.enableUpload = !1;
},
    ue = function () {
  function e() {}

  return e.prototype.getData = function (e) {
    return new Promise(function (t, n) {
      var i = new XMLHttpRequest();
      i.open("GET", e, !0), i.responseType = "json", i.onload = function () {
        var e = i.status;
        200 === e ? t(i.response) : n(new Error("HTTP Status " + e));
      }, i.send();
    });
  }, e;
}(),
    ce = function () {
  function e(e) {
    this.data = {}, this.data = e;
  }

  return e.prototype.loadJSON = function (e) {
    return new ue().getData(e);
  }, e.prototype.getCategories = function () {
    return Promise.resolve([]);
  }, e.prototype.searchImages = function (e) {
    return Promise.resolve([]);
  }, e;
}(),
    pe = function pe() {
  this.items = [];
};

!function (e) {
  e.NORMAL = "normal", e.OVERLAY = "overlay", e.SOFT_LIGHT = "softLight", e.HARD_LIGHT = "hardLight", e.MULTIPLY = "multiply", e.DARKEN = "darken", e.COLOR_BURN = "colorBurn", e.SCREEN = "screen", e.LIGHTEN = "lighten";
}(re || (re = {}));

var fe = function fe() {
  this.categories = [], this.canvasActions = [D.BRING_TO_FRONT, D.FLIP, D.DUPLICATE, D.DELETE], this.enableCustomUpload = !0, this.customStickerTintMode = "none";
};

function he(e) {
  return void 0 !== e.sticker;
}

function de(e) {
  return void 0 !== e.thumbnail;
}

var ge = function ge() {
  this.fonts = [], this.canvasActions = [D.EDIT, D.BRING_TO_FRONT, D.DUPLICATE, D.DELETE], this.disableAutoScaling = !1;
};

function me(e) {
  return void 0 === e.provider || "file" === e.provider;
}

function ye(e) {
  return "google" === e.provider;
}

var _e,
    ve,
    be = function be() {},
    we = function we() {
  this.items = [], this.canvasActions = [D.EDIT, D.BRING_TO_FRONT, D.INVERT, D.DUPLICATE, D.DELETE];
},
    xe = function xe() {
  this.categories = [], this.enableRotation = !0, this.enableFlip = !0;
};

!function (e) {
  e.CommonCategory = "imgly_transforms_common", e.FacebookCategory = "imgly_transforms_facebook", e.TwitterCategory = "imgly_transforms_twitter", e.InstagramCategory = "imgly_transforms_instagram", e.Custom = "imgly_transform_common_custom", e.Square = "imgly_transform_common_square", e.ThreeByFour = "imgly_transform_common_3", e.FourByThree = "imgly_transform_common_4", e.NineBySixteen = "imgly_transform_common_9", e.SixteenByNine = "imgly_transform_common_16", e.FacebookPost = "imgly_transform_facebook_post", e.FacebookProfile = "imgly_transform_facebook_profile", e.FacebookTitle = "imgly_transform_facebook_title", e.InstagramLandscape = "imgly_transform_instagram_landscape", e.InstagramPortrait = "imgly_transform_instagram_portrait", e.InstagramSquare = "imgly_transform_instagram_square", e.InstagramStory = "imgly_transform_instagram_story", e.TwitterPost = "imgly_transform_twitter_post", e.TwitterProfile = "imgly_transform_twitter_profile", e.TwitterTitle = "imgly_transform_twitter_title";
}(_e || (_e = {})), function (e) {
  e.EXPORT = "export", e.CLOSE = "close", e.HISTORY_CHANGE = "historyChange", e.EDITOR_READY = "editorReady";
}(ve || (ve = {}));

var ke,
    Te = function () {
  function e() {
    this.events = {};
  }

  return e.prototype.addListener = function (e, t) {
    return (this.events[e] || (this.events[e] = [])).push(t), this;
  }, e.prototype.removeListener = function (e, t) {
    var n = this.events[e];
    if (!n) return this;
    var i = n.lastIndexOf(t);
    return -1 === i || n.splice(i, 1), this;
  }, e.prototype.removeAllListeners = function (e) {
    return this.events[e] = void 0, this;
  }, e.prototype.on = function (e, t) {
    return this.addListener(e, t);
  }, e.prototype.off = function (e, t) {
    return this.removeListener(e, t);
  }, e.prototype.emit = function (e) {
    for (var t = [], n = 1; n < arguments.length; n++) {
      t[n - 1] = arguments[n];
    }

    var i = this.events[e];
    return !(!i || !i.length) && (i.slice(0).forEach(function (e) {
      return e.apply(null, t);
    }), !0);
  }, e;
}();

!function (e) {
  e.BEGAN_IMAGE_DOWNSCALING = "beganImageDownscaling", e.IMAGE_DOWNSCALED = "imageDownscaled";
}(ke || (ke = {}));

var Se = function (e) {
  function t(t, n) {
    var i = e.call(this) || this;
    return i.image = t, i.options = n, i;
  }

  return _(t, e), t.prototype.needsResize = function () {
    var e = this.resizedDimensions();
    return e.x < this.image.width || e.y < this.image.height;
  }, t.prototype.resizedDimensions = function () {
    var e = this.options,
        t = {
      width: this.image.width,
      height: this.image.height
    },
        n = R.fromSize(t),
        i = R.fromSize(t),
        r = e.maxMegaPixels;

    if (r) {
      var o = 1e6 * (function () {
        if ("undefined" == typeof navigator) return !1;
        var e = navigator.userAgent || navigator.vendor || window.opera;
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4));
      }() ? r.mobile : r.desktop),
          a = t.width / t.height,
          s = t.height / t.width,
          l = new R(Math.floor(Math.sqrt(o * a)), Math.floor(Math.sqrt(o * s)));
      l.x <= t.width && l.y <= t.height && (n = l);
    }

    var u = e.maxDimensions;
    u && (u.height < t.height || u.width < t.width) && (i = new R(u.width, u.height));
    var c = new R(Math.min(n.x, i.x), Math.min(n.y, i.y));
    return R.proportionalFit(c, R.fromSize(t)).floored;
  }, t.prototype.downscaleIfNecessary = function () {
    var e = this.resizedDimensions();
    if (!(e.x < this.image.width || e.y < this.image.height)) return this.image;
    this.emit(ke.BEGAN_IMAGE_DOWNSCALING, this.image);
    var t = document.createElement("canvas");
    t.width = e.x, t.height = e.y;
    var n = t.getContext("2d"),
        i = this.image;
    return n.drawImage(i, 0, 0, i.width, i.height, 0, 0, e.x, e.y), this.emit(ke.IMAGE_DOWNSCALED), t;
  }, t.prototype.downscaleImageIfNecessary = function () {
    var e = this.image,
        t = this.resizedDimensions();
    if (!(t.x < this.image.width || t.y < this.image.height)) return e;
    this.emit(ke.BEGAN_IMAGE_DOWNSCALING, e);
    var n = new Image();
    return n.width = t.x, n.height = t.y, n.src = e.src, this.emit(ke.IMAGE_DOWNSCALED), n;
  }, t;
}(Te);

function Ce(e, t) {
  for (var n = 0, i = e.length - 1; i >= 0; i--) {
    var r = e[i];
    "." === r ? e.splice(i, 1) : ".." === r ? (e.splice(i, 1), n++) : n && (e.splice(i, 1), n--);
  }

  if (t) for (; n--; n) {
    e.unshift("..");
  }
  return e;
}

var Ee = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,
    Oe = function Oe(e) {
  return Ee.exec(e).slice(1);
};

function Re() {
  for (var e = "", t = !1, n = arguments.length - 1; n >= -1 && !t; n--) {
    var i = n >= 0 ? arguments[n] : "/";
    if ("string" != typeof i) throw new TypeError("Arguments to path.resolve must be strings");
    i && (e = i + "/" + e, t = "/" === i.charAt(0));
  }

  return (t ? "/" : "") + (e = Ce(Fe(e.split("/"), function (e) {
    return !!e;
  }), !t).join("/")) || ".";
}

function Ie(e) {
  var t = Ae(e),
      n = "/" === Pe(e, -1);
  return (e = Ce(Fe(e.split("/"), function (e) {
    return !!e;
  }), !t).join("/")) || t || (e = "."), e && n && (e += "/"), (t ? "/" : "") + e;
}

function Ae(e) {
  return "/" === e.charAt(0);
}

var Me = {
  extname: function extname(e) {
    return Oe(e)[3];
  },
  basename: function basename(e, t) {
    var n = Oe(e)[2];
    return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
  },
  dirname: function dirname(e) {
    var t = Oe(e),
        n = t[0],
        i = t[1];
    return n || i ? (i && (i = i.substr(0, i.length - 1)), n + i) : ".";
  },
  sep: "/",
  delimiter: ":",
  relative: function relative(e, t) {
    function n(e) {
      for (var t = 0; t < e.length && "" === e[t]; t++) {
        ;
      }

      for (var n = e.length - 1; n >= 0 && "" === e[n]; n--) {
        ;
      }

      return t > n ? [] : e.slice(t, n - t + 1);
    }

    e = Re(e).substr(1), t = Re(t).substr(1);

    for (var i = n(e.split("/")), r = n(t.split("/")), o = Math.min(i.length, r.length), a = o, s = 0; s < o; s++) {
      if (i[s] !== r[s]) {
        a = s;
        break;
      }
    }

    var l = [];

    for (s = a; s < i.length; s++) {
      l.push("..");
    }

    return (l = l.concat(r.slice(a))).join("/");
  },
  join: function join() {
    var e = Array.prototype.slice.call(arguments, 0);
    return Ie(Fe(e, function (e, t) {
      if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
      return e;
    }).join("/"));
  },
  isAbsolute: Ae,
  normalize: Ie,
  resolve: Re
};

function Fe(e, t) {
  if (e.filter) return e.filter(t);

  for (var n = [], i = 0; i < e.length; i++) {
    t(e[i], i, e) && n.push(e[i]);
  }

  return n;
}

var De,
    Pe = "b" === "ab".substr(-1) ? function (e, t, n) {
  return e.substr(t, n);
} : function (e, t, n) {
  return t < 0 && (t = e.length + t), e.substr(t, n);
},
    ze = [{
  identifier: "imgly_overlay_golden",
  name: "Golden",
  defaultBlendMode: re.LIGHTEN,
  overlayURI: "./items/imgly_overlay_golden.jpg",
  thumbnailURI: "./items/imgly_overlay_golden_thumb.jpg"
}, {
  identifier: "imgly_overlay_lightleak1",
  name: "Lightleak",
  defaultBlendMode: re.SCREEN,
  overlayURI: "./items/imgly_overlay_lightleak1.jpg",
  thumbnailURI: "./items/imgly_overlay_lightleak1_thumb.jpg"
}, {
  identifier: "imgly_overlay_rain",
  name: "Rain",
  defaultBlendMode: re.OVERLAY,
  overlayURI: "./items/imgly_overlay_rain.jpg",
  thumbnailURI: "./items/imgly_overlay_rain_thumb.jpg"
}, {
  identifier: "imgly_overlay_mosaic",
  name: "Mosaic",
  defaultBlendMode: re.MULTIPLY,
  overlayURI: "./items/imgly_overlay_mosaic.jpg",
  thumbnailURI: "./items/imgly_overlay_mosaic_thumb.jpg"
}, {
  identifier: "imgly_overlay_vintage",
  name: "Vintage",
  defaultBlendMode: re.DARKEN,
  overlayURI: "./items/imgly_overlay_vintage.jpg",
  thumbnailURI: "./items/imgly_overlay_vintage_thumb.jpg"
}, {
  identifier: "imgly_overlay_paper",
  name: "Paper",
  defaultBlendMode: re.MULTIPLY,
  overlayURI: "./items/imgly_overlay_paper.jpg",
  thumbnailURI: "./items/imgly_overlay_paper_thumb.jpg"
}, {
  identifier: "imgly_overlay_bokeh",
  name: "Bokeh",
  defaultBlendMode: re.LIGHTEN,
  overlayURI: "./items/imgly_overlay_bokeh.jpg",
  thumbnailURI: "./items/imgly_overlay_bokeh_thumb.jpg"
}, {
  identifier: "imgly_overlay_hearts",
  name: "Hearts",
  defaultBlendMode: re.SCREEN,
  overlayURI: "./items/imgly_overlay_hearts.jpg",
  thumbnailURI: "./items/imgly_overlay_hearts_thumb.jpg"
}, {
  identifier: "imgly_overlay_lightleak2",
  name: "Lightleak 2",
  defaultBlendMode: re.LIGHTEN,
  overlayURI: "./items/imgly_overlay_lightleak2.jpg",
  thumbnailURI: "./items/imgly_overlay_lightleak2_thumb.jpg"
}, {
  identifier: "imgly_overlay_wood",
  name: "Wood",
  defaultBlendMode: re.MULTIPLY,
  overlayURI: "./items/imgly_overlay_wood.jpg",
  thumbnailURI: "./items/imgly_overlay_wood_thumb.jpg"
}, {
  identifier: "imgly_overlay_chop",
  name: "Chop",
  defaultBlendMode: re.MULTIPLY,
  overlayURI: "./items/imgly_overlay_chop.jpg",
  thumbnailURI: "./items/imgly_overlay_chop_thumb.jpg"
}, {
  identifier: "imgly_overlay_metal",
  name: "Metal",
  defaultBlendMode: re.OVERLAY,
  overlayURI: "./items/imgly_overlay_metal.jpg",
  thumbnailURI: "./items/imgly_overlay_metal_thumb.jpg"
}, {
  identifier: "imgly_overlay_painting",
  name: "Painting",
  defaultBlendMode: re.OVERLAY,
  overlayURI: "./items/imgly_overlay_painting.jpg",
  thumbnailURI: "./items/imgly_overlay_painting_thumb.jpg"
}, {
  identifier: "imgly_overlay_grain",
  name: "Grain",
  defaultBlendMode: re.OVERLAY,
  overlayURI: "./items/imgly_overlay_grain.jpg",
  thumbnailURI: "./items/imgly_overlay_grain_thumb.jpg"
}, {
  identifier: "imgly_overlay_clouds",
  name: "Clouds",
  defaultBlendMode: re.SOFT_LIGHT,
  overlayURI: "./items/imgly_overlay_clouds.jpg",
  thumbnailURI: "./items/imgly_overlay_clouds_thumb.jpg"
}, {
  identifier: "imgly_overlay_wall1",
  name: "Wall",
  defaultBlendMode: re.LIGHTEN,
  overlayURI: "./items/imgly_overlay_wall1.jpg",
  thumbnailURI: "./items/imgly_overlay_wall1_thumb.jpg"
}, {
  identifier: "imgly_overlay_wall2",
  name: "Wall 2",
  defaultBlendMode: re.OVERLAY,
  overlayURI: "./items/imgly_overlay_wall2.jpg",
  thumbnailURI: "./items/imgly_overlay_wall2_thumb.jpg"
}],
    Le = [{
  identifier: "imgly_filter_category_duotone",
  name: "DuoTone",
  thumbnailURI: "./categories/duotone.jpg",
  items: [{
    identifier: "imgly_duotone_desert",
    name: "Desert",
    thumbnailURI: "./items/imgly_duotone_desert.jpg",
    lightColor: "#e1de9a",
    darkColor: "#cb2129",
    defaultIntensity: .5
  }, {
    identifier: "imgly_duotone_peach",
    name: "Peach",
    thumbnailURI: "./items/imgly_duotone_peach.jpg",
    lightColor: "#e9abb8",
    darkColor: "#0040ff",
    defaultIntensity: .5
  }, {
    identifier: "imgly_duotone_clash",
    name: "Clash",
    thumbnailURI: "./items/imgly_duotone_clash.jpg",
    lightColor: "#f41a0f",
    darkColor: "#23007c",
    defaultIntensity: .5
  }, {
    identifier: "imgly_duotone_plum",
    name: "Plum",
    thumbnailURI: "./items/imgly_duotone_plum.jpg",
    lightColor: "#74d7ff",
    darkColor: "#23007c",
    defaultIntensity: .5
  }, {
    identifier: "imgly_duotone_breezy",
    name: "Breezy",
    thumbnailURI: "./items/imgly_duotone_breezy.jpg",
    lightColor: "#68fdff",
    darkColor: "#c20000",
    defaultIntensity: .5
  }, {
    identifier: "imgly_duotone_deepblue",
    name: "Deep Blue",
    thumbnailURI: "./items/imgly_duotone_deepblue.jpg",
    lightColor: "#2de9eb",
    darkColor: "#58007c",
    defaultIntensity: .5
  }, {
    identifier: "imgly_duotone_frog",
    name: "Frog",
    thumbnailURI: "./items/imgly_duotone_frog.jpg",
    lightColor: "#5bff60",
    darkColor: "#7f23a9",
    defaultIntensity: .5
  }, {
    identifier: "imgly_duotone_sunset",
    name: "Sunset",
    thumbnailURI: "./items/imgly_duotone_sunset.jpg",
    lightColor: "#f8ea46",
    darkColor: "#c400be",
    defaultIntensity: .5
  }]
}, {
  identifier: "imgly_filter_category_bw",
  name: "B & W",
  thumbnailURI: "./categories/b&w.jpg",
  items: [{
    identifier: "imgly_lut_ad1920",
    name: "1920 A.D.",
    thumbnailURI: "./items/imgly_lut_ad1920.jpg",
    lutURI: "./items/imgly_lut_ad1920_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_bw",
    name: "Greyed",
    thumbnailURI: "./items/imgly_lut_bw.jpg",
    lutURI: "./items/imgly_lut_bw_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_x400",
    name: "Dusty",
    thumbnailURI: "./items/imgly_lut_x400.jpg",
    lutURI: "./items/imgly_lut_dusty_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_litho",
    name: "Litho",
    thumbnailURI: "./items/imgly_lut_litho.jpg",
    lutURI: "./items/imgly_lut_litho_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_sepiahigh",
    name: "Sepia",
    thumbnailURI: "./items/imgly_lut_sepiahigh.jpg",
    lutURI: "./items/imgly_lut_sepia_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_plate",
    name: "Weathered",
    thumbnailURI: "./items/imgly_lut_plate.jpg",
    lutURI: "./items/imgly_lut_weathered_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_sin",
    name: "Hard Stuff",
    thumbnailURI: "./items/imgly_lut_sin.jpg",
    lutURI: "./items/imgly_lut_hard_stuff_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }]
}, {
  identifier: "imgly_filter_category_vintage",
  name: "Vintage",
  thumbnailURI: "./categories/vintage.jpg",
  items: [{
    identifier: "imgly_lut_blues",
    name: "Polaroid",
    thumbnailURI: "./items/imgly_lut_blues.jpg",
    lutURI: "./items/imgly_lut_polaroid_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_front",
    name: "Sunny 70s",
    thumbnailURI: "./items/imgly_lut_front.jpg",
    lutURI: "./items/imgly_lut_sunny_70s_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_texas",
    name: "Oldtimer",
    thumbnailURI: "./items/imgly_lut_texas.jpg",
    lutURI: "./items/imgly_lut_oldtimer_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_celsius",
    name: "Inferno",
    thumbnailURI: "./items/imgly_lut_celsius.jpg",
    lutURI: "./items/imgly_lut_inferno_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_cool",
    name: "Snappy",
    thumbnailURI: "./items/imgly_lut_cool.jpg",
    lutURI: "./items/imgly_lut_snappy_5_5_128.png",
    defaultIntensity: 1
  }]
}, {
  identifier: "imgly_filter_category_smooth",
  name: "Smooth",
  thumbnailURI: "./categories/smooth.jpg",
  items: [{
    identifier: "imgly_lut_chest",
    name: "Chestnut",
    thumbnailURI: "./items/imgly_lut_chest.jpg",
    lutURI: "./items/imgly_lut_chestnut_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_winter",
    name: "Softy",
    thumbnailURI: "./items/imgly_lut_winter.jpg",
    lutURI: "./items/imgly_lut_softly_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_kdynamic",
    name: "Pebble",
    thumbnailURI: "./items/imgly_lut_kdynamic.jpg",
    lutURI: "./items/imgly_lut_pebble_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_fall",
    name: "Moss",
    thumbnailURI: "./items/imgly_lut_fall.jpg",
    lutURI: "./items/imgly_lut_moss_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_lenin",
    name: "Lemon",
    thumbnailURI: "./items/imgly_lut_lenin.jpg",
    lutURI: "./items/imgly_lut_lemon_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_pola669",
    name: "Green Gap",
    thumbnailURI: "./items/imgly_lut_pola669.jpg",
    lutURI: "./items/imgly_lut_green_gap_5_5_128.png",
    defaultIntensity: 1
  }]
}, {
  identifier: "imgly_filter_category_cold",
  name: "Cold",
  thumbnailURI: "./categories/cold.jpg",
  items: [{
    identifier: "imgly_lut_elder",
    name: "Colla",
    thumbnailURI: "./items/imgly_lut_elder.jpg",
    lutURI: "./items/imgly_lut_colla_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_orchid",
    name: "Solanus",
    thumbnailURI: "./items/imgly_lut_orchid.jpg",
    lutURI: "./items/imgly_lut_solanus_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_bleached",
    name: "Kalmen",
    thumbnailURI: "./items/imgly_lut_bleached.jpg",
    lutURI: "./items/imgly_lut_kalmen_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_bleachedblue",
    name: "Joran",
    thumbnailURI: "./items/imgly_lut_bleachedblue.jpg",
    lutURI: "./items/imgly_lut_joran_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_breeze",
    name: "Levante",
    thumbnailURI: "./items/imgly_lut_breeze.jpg",
    lutURI: "./items/imgly_lut_levante_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_blueshadows",
    name: "Zephyr",
    thumbnailURI: "./items/imgly_lut_blueshadows.jpg",
    lutURI: "./items/imgly_lut_zephyr_5_5_128.png",
    defaultIntensity: 1
  }]
}, {
  identifier: "imgly_filter_category_warm",
  name: "Warm",
  thumbnailURI: "./categories/warm.jpg",
  items: [{
    identifier: "imgly_lut_sunset",
    name: "Golden",
    thumbnailURI: "./items/imgly_lut_sunset.jpg",
    lutURI: "./items/imgly_lut_golden_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_eighties",
    name: "Low Fire",
    thumbnailURI: "./items/imgly_lut_eighties.jpg",
    lutURI: "./items/imgly_lut_low_fire_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_evening",
    name: "Sunrise",
    thumbnailURI: "./items/imgly_lut_evening.jpg",
    lutURI: "./items/imgly_lut_sunrise_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_k2",
    name: "Flat Black",
    thumbnailURI: "./items/imgly_lut_k2.jpg",
    lutURI: "./items/imgly_lut_flat_black_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_nogreen",
    name: "Pumpkin",
    thumbnailURI: "./items/imgly_lut_nogreen.jpg",
    lutURI: "./items/imgly_lut_pumpkin_5_5_128.png",
    defaultIntensity: 1
  }]
}, {
  identifier: "imgly_filter_category_legacy",
  name: "Legacy",
  thumbnailURI: "./categories/legacy.jpg",
  items: [{
    identifier: "imgly_lut_ancient",
    name: "Ancient",
    thumbnailURI: "./items/imgly_lut_ancient.jpg",
    lutURI: "./items/imgly_lut_ancient_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_cottoncandy",
    name: "Candy",
    thumbnailURI: "./items/imgly_lut_cottoncandy.jpg",
    lutURI: "./items/imgly_lut_cottoncandy_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_classic",
    name: "Classic",
    thumbnailURI: "./items/imgly_lut_classic.jpg",
    lutURI: "./items/imgly_lut_classic_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_colorful",
    name: "Colorful",
    thumbnailURI: "./items/imgly_lut_colorful.jpg",
    lutURI: "./items/imgly_lut_colorful_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_creamy",
    name: "Creamy",
    thumbnailURI: "./items/imgly_lut_creamy.jpg",
    lutURI: "./items/imgly_lut_creamy_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_fixie",
    name: "Fixie",
    thumbnailURI: "./items/imgly_lut_fixie.jpg",
    lutURI: "./items/imgly_lut_fixie_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_food",
    name: "Food",
    thumbnailURI: "./items/imgly_lut_food.jpg",
    lutURI: "./items/imgly_lut_food_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_fridge",
    name: "Fridge",
    thumbnailURI: "./items/imgly_lut_fridge.jpg",
    lutURI: "./items/imgly_lut_fridge_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_glam",
    name: "Glam",
    thumbnailURI: "./items/imgly_lut_glam.jpg",
    lutURI: "./items/imgly_lut_glam_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_gobblin",
    name: "Gobblin",
    thumbnailURI: "./items/imgly_lut_gobblin.jpg",
    lutURI: "./items/imgly_lut_gobblin_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_highcontrast",
    name: "Hicon",
    thumbnailURI: "./items/imgly_lut_highcontrast.jpg",
    lutURI: "./items/imgly_lut_highcontrast_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_highcarb",
    name: "High Carb",
    thumbnailURI: "./items/imgly_lut_highcarb.jpg",
    lutURI: "./items/imgly_lut_highcarb_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_k1",
    name: "K1",
    thumbnailURI: "./items/imgly_lut_k1.jpg",
    lutURI: "./items/imgly_lut_k1_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_k6",
    name: "K6",
    thumbnailURI: "./items/imgly_lut_k6.jpg",
    lutURI: "./items/imgly_lut_k6_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_keen",
    name: "Keen",
    thumbnailURI: "./items/imgly_lut_keen.jpg",
    lutURI: "./items/imgly_lut_keen_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_lomo",
    name: "Lomo",
    thumbnailURI: "./items/imgly_lut_lomo.jpg",
    lutURI: "./items/imgly_lut_lomo_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_lomo100",
    name: "Lomo 100",
    thumbnailURI: "./items/imgly_lut_lomo100.jpg",
    lutURI: "./items/imgly_lut_lomo100_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_lucid",
    name: "Lucid",
    thumbnailURI: "./items/imgly_lut_lucid.jpg",
    lutURI: "./items/imgly_lut_lucid_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_mellow",
    name: "Mellow",
    thumbnailURI: "./items/imgly_lut_mellow.jpg",
    lutURI: "./items/imgly_lut_mellow_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: "imgly_lut_neat",
    name: "Neat",
    thumbnailURI: "./items/imgly_lut_neat.jpg",
    lutURI: "./items/imgly_lut_neat_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_pale",
    name: "Pale",
    thumbnailURI: "./items/imgly_lut_pale.jpg",
    lutURI: "./items/imgly_lut_pale_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_pitched",
    name: "Pitched",
    thumbnailURI: "./items/imgly_lut_pitched.jpg",
    lutURI: "./items/imgly_lut_pitched_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_polasx",
    name: "Pola SX",
    thumbnailURI: "./items/imgly_lut_polasx.jpg",
    lutURI: "./items/imgly_lut_polasx_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_pro400",
    name: "Pro 400",
    thumbnailURI: "./items/imgly_lut_pro400.jpg",
    lutURI: "./items/imgly_lut_pro400_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_quozi",
    name: "Quozi",
    thumbnailURI: "./items/imgly_lut_quozi.jpg",
    lutURI: "./items/imgly_lut_quozi_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_settled",
    name: "Settled",
    thumbnailURI: "./items/imgly_lut_settled.jpg",
    lutURI: "./items/imgly_lut_settled_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_seventies",
    name: "Seventies",
    thumbnailURI: "./items/imgly_lut_seventies.jpg",
    lutURI: "./items/imgly_lut_seventies_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_soft",
    name: "Soft",
    thumbnailURI: "./items/imgly_lut_soft.jpg",
    lutURI: "./items/imgly_lut_soft_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_steel",
    name: "Steel",
    thumbnailURI: "./items/imgly_lut_steel.jpg",
    lutURI: "./items/imgly_lut_steel_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_summer",
    name: "Summer",
    thumbnailURI: "./items/imgly_lut_summer.jpg",
    lutURI: "./items/imgly_lut_summer_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_tender",
    name: "Tender",
    thumbnailURI: "./items/imgly_lut_tender.jpg",
    lutURI: "./items/imgly_lut_tender_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: "imgly_lut_twilight",
    name: "Twilight",
    thumbnailURI: "./items/imgly_lut_twilight.jpg",
    lutURI: "./items/imgly_lut_twilight_5_5_128.png",
    defaultIntensity: 1
  }]
}],
    Be = [{
  identifier: "imgly_font_open_sans_bold",
  fontFamily: "Open Sans",
  fontWeight: "bold",
  fontURI: "./fonts/imgly_font_open_sans_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2189,
    descender: -640
  }
}, {
  identifier: "imgly_font_aleo_bold",
  fontFamily: "Aleo",
  fontWeight: "bold",
  fontURI: "./fonts/imgly_font_aleo_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1919,
    descender: -409
  }
}, {
  identifier: "imgly_font_amaticsc",
  fontFamily: "Amaticsc",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_amaticsc.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2332,
    descender: -583
  }
}, {
  identifier: "imgly_font_bernier_regular",
  fontFamily: "Bernier",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_bernier_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2007,
    descender: -552
  }
}, {
  identifier: "imgly_font_cheque_regular",
  fontFamily: "Cheque",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_cheque_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2007,
    descender: -552
  }
}, {
  identifier: "imgly_font_gagalin_regular",
  fontFamily: "Gagalin",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_gagalin_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1987,
    descender: -628
  }
}, {
  identifier: "imgly_font_hagin_caps_thin",
  fontFamily: "Hagin Caps",
  fontWeight: 200,
  fontURI: "./fonts/imgly_font_hagin_caps_thin.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1964,
    descender: -482
  }
}, {
  identifier: "imgly_font_intro_inline",
  fontFamily: "Intro Inline",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_intro_inline.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1944,
    descender: -548
  }
}, {
  identifier: "imgly_font_lobster",
  fontFamily: "Lobster",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_lobster.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2048,
    descender: -552
  }
}, {
  identifier: "imgly_font_nexa_script",
  fontFamily: "Nexa Script",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_nexa_script.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1835,
    descender: -663
  }
}, {
  identifier: "imgly_font_panton_blackitalic_caps",
  fontFamily: "Panton",
  fontWeight: 800,
  fontStyle: "italic",
  fontURI: "./fonts/imgly_font_panton_blackitalic_caps.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2033,
    descender: -572
  }
}, {
  identifier: "imgly_font_panton_lightitalic_caps",
  fontFamily: "Panton",
  fontWeight: 200,
  fontStyle: "italic",
  fontURI: "./fonts/imgly_font_panton_lightitalic_caps.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1961,
    descender: -556
  }
}, {
  identifier: "imgly_font_perfograma",
  fontFamily: "Perfograma",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_perfograma.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1982,
    descender: -842
  }
}, {
  identifier: "imgly_font_trash_hand",
  fontFamily: "Trash Hand",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_trash_hand.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1554,
    descender: -663
  }
}, {
  identifier: "imgly_font_abril_fatface_regular",
  fontFamily: "Abril Fatface",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_abril_fatface_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1058,
    descender: -291
  }
}, {
  identifier: "imgly_font_montserrat_light",
  fontFamily: "Montserrat Light",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_montserrat_light.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 968,
    descender: -251
  }
}, {
  identifier: "imgly_font_wolesbro",
  fontFamily: "Wolesbro",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_wolesbro.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1849,
    descender: -1123
  }
}, {
  identifier: "imgly_font_permanent_marker",
  fontFamily: "Permanent Marker",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_permanent_marker.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2272,
    descender: -686
  }
}, {
  identifier: "imgly_font_panton_light_italic_caps",
  fontFamily: "Panton Caps",
  fontWeight: "lighter",
  fontStyle: "italic",
  fontURI: "./fonts/imgly_font_panton_light_italic_caps.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 940,
    descender: -260
  }
}, {
  identifier: "imgly_font_panton_black_italic_caps",
  fontFamily: "Panton Caps",
  fontWeight: 800,
  fontStyle: "italic",
  fontURI: "./fonts/imgly_font_panton_black_italic_caps.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 940,
    descender: -260
  }
}, {
  identifier: "imgly_font_panton_light_caps",
  fontFamily: "Panton Caps",
  fontWeight: "lighter",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_panton_light_caps.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 940,
    descender: -260
  }
}, {
  identifier: "imgly_font_panton_black_caps",
  fontFamily: "Panton Caps",
  fontWeight: 800,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_panton_black_caps.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 940,
    descender: -260
  }
}, {
  identifier: "imgly_font_amberlight",
  fontFamily: "Amberlight",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_amberlight.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 750,
    descender: -250
  }
}, {
  identifier: "imgly_font_ultra",
  fontFamily: "Ultra",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_ultra.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2066,
    descender: -561
  }
}, {
  identifier: "imgly_font_galano_grotesque_bold",
  fontFamily: "Galano Grotesque",
  fontWeight: "bold",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_galano_grotesque_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 800,
    descender: -200
  }
}, {
  identifier: "imgly_font_bungee_inline",
  fontFamily: "Bungee Inline",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_bungee_inline.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 860,
    descender: -140
  }
}, {
  identifier: "imgly_font_petit_formal_script",
  fontFamily: "Petit Formal Script",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_petit_formal_script.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2033,
    descender: -527
  }
}, {
  identifier: "imgly_font_summer_font_light",
  fontFamily: "Summer Font",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_summer_font_light.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2189,
    descender: -600
  }
}, {
  identifier: "imgly_font_handycheera_regular",
  fontFamily: "Handycheera",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_handycheera_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2199,
    descender: -808
  }
}, {
  identifier: "imgly_font_rasa_regular",
  fontFamily: "Rasa",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_rasa_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2750,
    ascender: 2300,
    descender: -1050
  }
}, {
  identifier: "imgly_font_rasa_500",
  fontFamily: "Rasa",
  fontWeight: 500,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_rasa_500.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2750,
    ascender: 2300,
    descender: -1050
  }
}, {
  identifier: "imgly_font_campton_bold",
  fontFamily: "Campton Book",
  fontWeight: "bold",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_campton_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 770,
    descender: -294
  }
}, {
  identifier: "imgly_font_ostrich_sans_black",
  fontFamily: "Ostrich",
  fontWeight: 800,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_ostrich_sans_black.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1513,
    descender: -235
  }
}, {
  identifier: "imgly_font_ostrich_sans_bold",
  fontFamily: "Ostrich",
  fontWeight: "bold",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_ostrich_sans_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1513,
    descender: -235
  }
}, {
  identifier: "imgly_font_ostrich_sans_heavy",
  fontFamily: "Ostrich",
  fontWeight: 900,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_ostrich_sans_heavy.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 674,
    descender: 0
  }
}],
    Ne = [{
  identifier: ne.RADIAL,
  thumbnailURI: "./items/radial.png"
}, {
  identifier: ne.MIRRORED,
  thumbnailURI: "./items/mirrored.png"
}, {
  identifier: ne.LINEAR,
  thumbnailURI: "./items/linear.png"
}, {
  identifier: ne.GAUSSIAN,
  thumbnailURI: "./items/gaussian.png"
}],
    Ue = [{
  identifier: "basics",
  name: "Basics",
  items: [{
    identifier: Z.BRIGHTNESS
  }, {
    identifier: Z.CONTRAST
  }, {
    identifier: Z.SATURATION
  }, {
    identifier: Z.GAMMA
  }]
}, {
  identifier: "refinements",
  name: "Refinements",
  items: [{
    identifier: Z.CLARITY
  }, {
    identifier: Z.SHADOWS
  }, {
    identifier: Z.HIGHLIGHTS
  }, {
    identifier: Z.EXPOSURE
  }, {
    identifier: Z.BLACKS
  }, {
    identifier: Z.WHITES
  }, {
    identifier: Z.TEMPERATURE
  }, {
    identifier: Z.SHARPNESS
  }]
}],
    je = [{
  identifier: "imgly_sticker_emoticons",
  name: "Emoticons",
  thumbnailURI: "./categories/emoticons.png",
  items: [{
    identifier: "imgly_sticker_emoticons_grin",
    stickerURI: "./emoticons/imgly_sticker_emoticons_grin.svg",
    tintMode: "none",
    name: "Grin",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_laugh",
    stickerURI: "./emoticons/imgly_sticker_emoticons_laugh.svg",
    tintMode: "none",
    name: "Laugh",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_smile",
    stickerURI: "./emoticons/imgly_sticker_emoticons_smile.svg",
    tintMode: "none",
    name: "Smile",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_wink",
    stickerURI: "./emoticons/imgly_sticker_emoticons_wink.svg",
    tintMode: "none",
    name: "Wink",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_tongue_out_wink",
    stickerURI: "./emoticons/imgly_sticker_emoticons_tongue_out_wink.svg",
    tintMode: "none",
    name: "Tongue out wink",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_angel",
    stickerURI: "./emoticons/imgly_sticker_emoticons_angel.svg",
    tintMode: "none",
    name: "Angel",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_kisses",
    stickerURI: "./emoticons/imgly_sticker_emoticons_kisses.svg",
    tintMode: "none",
    name: "Kisses",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_loving",
    stickerURI: "./emoticons/imgly_sticker_emoticons_loving.svg",
    tintMode: "none",
    name: "Loving",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_kiss",
    stickerURI: "./emoticons/imgly_sticker_emoticons_kiss.svg",
    tintMode: "none",
    name: "Kiss",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_wave",
    stickerURI: "./emoticons/imgly_sticker_emoticons_wave.svg",
    tintMode: "none",
    name: "Wave",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_nerd",
    stickerURI: "./emoticons/imgly_sticker_emoticons_nerd.svg",
    tintMode: "none",
    name: "Nerd",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_cool",
    stickerURI: "./emoticons/imgly_sticker_emoticons_cool.svg",
    tintMode: "none",
    name: "Cool",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_blush",
    stickerURI: "./emoticons/imgly_sticker_emoticons_blush.svg",
    tintMode: "none",
    name: "Blush",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_duckface",
    stickerURI: "./emoticons/imgly_sticker_emoticons_duckface.svg",
    tintMode: "none",
    name: "Duckface",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_furious",
    stickerURI: "./emoticons/imgly_sticker_emoticons_furious.svg",
    tintMode: "none",
    name: "Furious",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_angry",
    stickerURI: "./emoticons/imgly_sticker_emoticons_angry.svg",
    tintMode: "none",
    name: "Angry",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_steaming_furious",
    stickerURI: "./emoticons/imgly_sticker_emoticons_steaming_furious.svg",
    tintMode: "none",
    name: "Steaming Furious",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sad",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sad.svg",
    tintMode: "none",
    name: "Sad",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_anxious",
    stickerURI: "./emoticons/imgly_sticker_emoticons_anxious.svg",
    tintMode: "none",
    name: "Anxious",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_cry",
    stickerURI: "./emoticons/imgly_sticker_emoticons_cry.svg",
    tintMode: "none",
    name: "Cry",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sobbing",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sobbing.svg",
    tintMode: "none",
    name: "Sobbing",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_loud_cry",
    stickerURI: "./emoticons/imgly_sticker_emoticons_loud_cry.svg",
    tintMode: "none",
    name: "Loud Cry",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_wide_grin",
    stickerURI: "./emoticons/imgly_sticker_emoticons_wide_grin.svg",
    tintMode: "none",
    name: "Wide grin",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_impatient",
    stickerURI: "./emoticons/imgly_sticker_emoticons_impatient.svg",
    tintMode: "none",
    name: "Impatient",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_tired",
    stickerURI: "./emoticons/imgly_sticker_emoticons_tired.svg",
    tintMode: "none",
    name: "Tired",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_asleep",
    stickerURI: "./emoticons/imgly_sticker_emoticons_asleep.svg",
    tintMode: "none",
    name: "Asleep",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sleepy",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sleepy.svg",
    tintMode: "none",
    name: "Sleepy",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_deceased",
    stickerURI: "./emoticons/imgly_sticker_emoticons_deceased.svg",
    tintMode: "none",
    name: "Deceased",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_attention",
    stickerURI: "./emoticons/imgly_sticker_emoticons_attention.svg",
    tintMode: "none",
    name: "Attention",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_question",
    stickerURI: "./emoticons/imgly_sticker_emoticons_question.svg",
    tintMode: "none",
    name: "Question",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_not_speaking_to_you",
    stickerURI: "./emoticons/imgly_sticker_emoticons_not_speaking_to_you.svg",
    tintMode: "none",
    name: "Not speaking to you",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sick",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sick.svg",
    tintMode: "none",
    name: "Sick",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_pumpkin",
    stickerURI: "./emoticons/imgly_sticker_emoticons_pumpkin.svg",
    tintMode: "none",
    name: "Pumpkin",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_boxer",
    stickerURI: "./emoticons/imgly_sticker_emoticons_boxer.svg",
    tintMode: "none",
    name: "Boxer",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_idea",
    stickerURI: "./emoticons/imgly_sticker_emoticons_idea.svg",
    tintMode: "none",
    name: "Idea",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_smoking",
    stickerURI: "./emoticons/imgly_sticker_emoticons_smoking.svg",
    tintMode: "none",
    name: "Smoking",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_beer",
    stickerURI: "./emoticons/imgly_sticker_emoticons_beer.svg",
    tintMode: "none",
    name: "Beer",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_skateboard",
    stickerURI: "./emoticons/imgly_sticker_emoticons_skateboard.svg",
    tintMode: "none",
    name: "Skateboard",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_guitar",
    stickerURI: "./emoticons/imgly_sticker_emoticons_guitar.svg",
    tintMode: "none",
    name: "Guitar",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_music",
    stickerURI: "./emoticons/imgly_sticker_emoticons_music.svg",
    tintMode: "none",
    name: "Music",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sunbathing",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sunbathing.svg",
    tintMode: "none",
    name: "Sunbathing",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_hippie",
    stickerURI: "./emoticons/imgly_sticker_emoticons_hippie.svg",
    tintMode: "none",
    name: "Hippie",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_humourous",
    stickerURI: "./emoticons/imgly_sticker_emoticons_humourous.svg",
    tintMode: "none",
    name: "Humourous",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_hitman",
    stickerURI: "./emoticons/imgly_sticker_emoticons_hitman.svg",
    tintMode: "none",
    name: "Hitman",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_harry_potter",
    stickerURI: "./emoticons/imgly_sticker_emoticons_harry_potter.svg",
    tintMode: "none",
    name: "Harry Potter",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_business",
    stickerURI: "./emoticons/imgly_sticker_emoticons_business.svg",
    tintMode: "none",
    name: "Business",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_batman",
    stickerURI: "./emoticons/imgly_sticker_emoticons_batman.svg",
    tintMode: "none",
    name: "Batman",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_skull",
    stickerURI: "./emoticons/imgly_sticker_emoticons_skull.svg",
    tintMode: "none",
    name: "Skull",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_ninja",
    stickerURI: "./emoticons/imgly_sticker_emoticons_ninja.svg",
    tintMode: "none",
    name: "Ninja",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_masked",
    stickerURI: "./emoticons/imgly_sticker_emoticons_masked.svg",
    tintMode: "none",
    name: "Masked",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_alien",
    stickerURI: "./emoticons/imgly_sticker_emoticons_alien.svg",
    tintMode: "none",
    name: "Alien",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_wrestler",
    stickerURI: "./emoticons/imgly_sticker_emoticons_wrestler.svg",
    tintMode: "none",
    name: "Wrestler",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_devil",
    stickerURI: "./emoticons/imgly_sticker_emoticons_devil.svg",
    tintMode: "none",
    name: "Devil",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_star",
    stickerURI: "./emoticons/imgly_sticker_emoticons_star.svg",
    tintMode: "none",
    name: "Star",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_baby_chicken",
    stickerURI: "./emoticons/imgly_sticker_emoticons_baby_chicken.svg",
    tintMode: "none",
    name: "Baby Chicken",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_rabbit",
    stickerURI: "./emoticons/imgly_sticker_emoticons_rabbit.svg",
    tintMode: "none",
    name: "Rabbit",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_pig",
    stickerURI: "./emoticons/imgly_sticker_emoticons_pig.svg",
    tintMode: "none",
    name: "Pig",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_chicken",
    stickerURI: "./emoticons/imgly_sticker_emoticons_chicken.svg",
    tintMode: "none",
    name: "Chicken",
    resizeMode: "keepAspect"
  }]
}, {
  identifier: "imgly_sticker_shapes",
  name: "Shapes",
  thumbnailURI: "./categories/shapes.png",
  items: [{
    identifier: "imgly_sticker_shapes_badge_01",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_01.svg",
    tintMode: "solid",
    name: "Shape Badge 01",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_04",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_04.svg",
    tintMode: "solid",
    name: "Shape Badge 04",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_12",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_12.svg",
    tintMode: "solid",
    name: "Shape Badge 12",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_06",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_06.svg",
    tintMode: "solid",
    name: "Shape Badge 06",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_13",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_13.svg",
    tintMode: "solid",
    name: "Shape Badge 13",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_36",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_36.svg",
    tintMode: "solid",
    name: "Shape Badge 36",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_08",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_08.svg",
    tintMode: "solid",
    name: "Shape Badge 08",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_11",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_11.svg",
    tintMode: "solid",
    name: "Shape Badge 11",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_35",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_35.svg",
    tintMode: "solid",
    name: "Shape Badge 35",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_28",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_28.svg",
    tintMode: "solid",
    name: "Shape Badge 28",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_32",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_32.svg",
    tintMode: "solid",
    name: "Shape Badge 32",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_15",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_15.svg",
    tintMode: "solid",
    name: "Shape Badge 15",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_20",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_20.svg",
    tintMode: "solid",
    name: "Shape Badge 20",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_18",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_18.svg",
    tintMode: "solid",
    name: "Shape Badge 18",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_19",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_19.svg",
    tintMode: "solid",
    name: "Shape Badge 19",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_arrow_02",
    stickerURI: "./shapes/imgly_sticker_shapes_arrow_02.svg",
    tintMode: "solid",
    name: "Shape Arrow 02",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_arrow_03",
    stickerURI: "./shapes/imgly_sticker_shapes_arrow_03.svg",
    tintMode: "solid",
    name: "Shape Arrow 03",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_spray_01",
    stickerURI: "./shapes/imgly_sticker_shapes_spray_01.svg",
    tintMode: "solid",
    name: "Shape Spray 01",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_spray_04",
    stickerURI: "./shapes/imgly_sticker_shapes_spray_04.svg",
    tintMode: "solid",
    name: "Shape Spray 04",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_spray_03",
    stickerURI: "./shapes/imgly_sticker_shapes_spray_03.svg",
    tintMode: "solid",
    name: "Shape Spray 03",
    resizeMode: "keepAspect"
  }]
}],
    We = [{
  thumbnailURI: "./items/dark/imgly_text_design_icon_thislayoutisgreat.png",
  identifier: "imgly_text_design_blocks",
  name: "Blocks"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_fatandfast.png",
  identifier: "imgly_text_design_rotated",
  name: "Rotated"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_summerfeeling.png",
  identifier: "imgly_text_design_blocks_light",
  name: "Blocks Light"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_typewithstyle.png",
  identifier: "imgly_text_design_equal_width",
  name: "Equal Width"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_inthebox.png",
  identifier: "imgly_text_design_masked",
  name: "Masked"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_bluefriday.png",
  identifier: "imgly_text_design_celebrate",
  name: "Celebrate"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_decorative.png",
  identifier: "imgly_text_design_sunshine",
  name: "Sunshine"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_specialdeals.png",
  identifier: "imgly_text_design_masked_badge",
  name: "Masked Badge"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_doublelines.png",
  identifier: "imgly_text_design_blocks_condensed",
  name: "Blocks Condensed"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_celebrate.png",
  identifier: "imgly_text_design_celebrate_simple",
  name: "Celebrate Simple"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_beerandburger.png",
  identifier: "imgly_text_design_equal_width_fat",
  name: "Equal Width Fat"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_watercolor.png",
  identifier: "imgly_text_design_watercolor",
  name: "Watercolor"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_particle.png",
  identifier: "imgly_text_design_particles",
  name: "Particles"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_yeah.png",
  identifier: "imgly_text_design_masked_speech_bubble",
  name: "Masked Speech Bubble"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_thisisadream.png",
  identifier: "imgly_text_design_masked_speech_bubble_comic",
  name: "Masked Speech Bubble Comic"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_fatface.png",
  identifier: "imgly_text_design_multiline",
  name: "Multiline"
}],
    He = [{
  thumbnailURI: "./items/light/imgly_text_design_icon_thislayoutisgreat.png",
  identifier: "imgly_text_design_blocks",
  name: "Blocks"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_fatandfast.png",
  identifier: "imgly_text_design_rotated",
  name: "Rotated"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_summerfeeling.png",
  identifier: "imgly_text_design_blocks_light",
  name: "Blocks Light"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_typewithstyle.png",
  identifier: "imgly_text_design_equal_width",
  name: "Equal Width"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_inthebox.png",
  identifier: "imgly_text_design_masked",
  name: "Masked"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_bluefriday.png",
  identifier: "imgly_text_design_celebrate",
  name: "Celebrate"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_decorative.png",
  identifier: "imgly_text_design_sunshine",
  name: "Sunshine"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_specialdeals.png",
  identifier: "imgly_text_design_masked_badge",
  name: "Masked Badge"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_doublelines.png",
  identifier: "imgly_text_design_blocks_condensed",
  name: "Blocks Condensed"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_celebrate.png",
  identifier: "imgly_text_design_celebrate_simple",
  name: "Celebrate Simple"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_beerandburger.png",
  identifier: "imgly_text_design_equal_width_fat",
  name: "Equal Width Fat"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_watercolor.png",
  identifier: "imgly_text_design_watercolor",
  name: "Watercolor"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_particle.png",
  identifier: "imgly_text_design_particles",
  name: "Particles"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_yeah.png",
  identifier: "imgly_text_design_masked_speech_bubble",
  name: "Masked Speech Bubble"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_thisisadream.png",
  identifier: "imgly_text_design_masked_speech_bubble_comic",
  name: "Masked Speech Bubble Comic"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_fatface.png",
  identifier: "imgly_text_design_multiline",
  name: "Multiline"
}],
    Ge = [{
  identifier: "imgly_frame_dia",
  name: "Dia",
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_dia/imgly_frame_dia_thumb.png",
  imageGroups: {
    top: {
      mid: {
        image: "./items/imgly_frame_dia/imgly_frame_dia_top.png",
        mode: "repeat"
      }
    },
    left: {
      start: "./items/imgly_frame_dia/imgly_frame_dia_top_corner_left.png",
      mid: "./items/imgly_frame_dia/imgly_frame_dia_left.png",
      end: "./items/imgly_frame_dia/imgly_frame_dia_bottom_corner_left.png"
    },
    right: {
      start: "./items/imgly_frame_dia/imgly_frame_dia_top_corner_right.png",
      mid: "./items/imgly_frame_dia/imgly_frame_dia_right.png",
      end: "./items/imgly_frame_dia/imgly_frame_dia_bottom_corner_right.png"
    },
    bottom: {
      mid: {
        image: "./items/imgly_frame_dia/imgly_frame_dia_bottom.png",
        mode: "repeat"
      }
    }
  }
}, {
  identifier: "imgly_frame_art_decor",
  name: "Art Decor",
  tintable: !0,
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_art_decor/imgly_frame_art_decor_thumb.png",
  imageGroups: {
    top: {
      start: "./items/imgly_frame_art_decor/imgly_frame_art_decor_top_corner_left.png",
      mid: {
        image: "./items/imgly_frame_art_decor/imgly_frame_art_decor_top.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_art_decor/imgly_frame_art_decor_top_corner_right.png"
    },
    left: {
      mid: {
        image: "./items/imgly_frame_art_decor/imgly_frame_art_decor_left.png",
        mode: "stretch"
      }
    },
    right: {
      mid: {
        image: "./items/imgly_frame_art_decor/imgly_frame_art_decor_right.png",
        mode: "stretch"
      }
    },
    bottom: {
      start: "./items/imgly_frame_art_decor/imgly_frame_art_decor_bottom_corner_left.png",
      mid: {
        image: "./items/imgly_frame_art_decor/imgly_frame_art_decor_bottom.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_art_decor/imgly_frame_art_decor_bottom_corner_right.png"
    }
  }
}, {
  identifier: "imgly_frame_black_passepartout",
  name: "Black Passepartout",
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_thumb.png",
  imageGroups: {
    top: {
      start: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top_corner_left.png",
      mid: {
        image: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top_corner_right.png"
    },
    left: {
      mid: {
        image: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_left.png",
        mode: "stretch"
      }
    },
    right: {
      mid: {
        image: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_right.png",
        mode: "stretch"
      }
    },
    bottom: {
      start: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom_corner_left.png",
      mid: {
        image: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom_corner_right.png"
    }
  }
}, {
  identifier: "imgly_frame_wood_passepartout",
  name: "Wood Passepartout",
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_thumb.png",
  imageGroups: {
    top: {
      start: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top_corner_left.png",
      mid: {
        image: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top_corner_right.png"
    },
    left: {
      mid: {
        image: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_left.png",
        mode: "stretch"
      }
    },
    right: {
      mid: {
        image: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_right.png",
        mode: "stretch"
      }
    },
    bottom: {
      start: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom_corner_left.png",
      mid: {
        image: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom_corner_right.png"
    }
  }
}, {
  identifier: "imgly_frame_lowpoly_shadow",
  name: "Low Poly",
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_thumb.png",
  imageGroups: {
    top: {
      start: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top_corner_left.png",
      mid: {
        image: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top_corner_right.png"
    },
    left: {
      mid: {
        image: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_left.png",
        mode: "stretch"
      }
    },
    right: {
      mid: {
        image: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_right.png",
        mode: "stretch"
      }
    },
    bottom: {
      start: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom_corner_left.png",
      mid: {
        image: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom_corner_right.png"
    }
  }
}],
    Ve = [{
  identifier: "imgly_transforms_common",
  name: "Common",
  items: [{
    identifier: "imgly_transform_common_custom",
    name: "Custom",
    thumbnailURI: "",
    ratio: "*"
  }, {
    identifier: "imgly_transform_common_square",
    name: "Square",
    thumbnailURI: "",
    ratio: 1
  }, {
    identifier: "imgly_transform_common_4",
    name: "4:3",
    thumbnailURI: "",
    ratio: 4 / 3
  }, {
    identifier: "imgly_transform_common_16",
    name: "16:9",
    thumbnailURI: "",
    ratio: 16 / 9
  }, {
    identifier: "imgly_transform_common_3",
    name: "3:4",
    thumbnailURI: "",
    ratio: 3 / 4
  }, {
    identifier: "imgly_transform_common_9",
    name: "9:16",
    thumbnailURI: "",
    ratio: 9 / 16
  }]
}, {
  identifier: "imgly_transforms_facebook",
  name: "Facebook",
  items: [{
    identifier: "imgly_transform_facebook_profile",
    name: "Profile",
    thumbnailURI: "",
    dimensions: {
      x: 300,
      y: 300
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_facebook_title",
    name: "Title",
    thumbnailURI: "",
    dimensions: {
      x: 1200,
      y: 627
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_facebook_post",
    name: "Post",
    thumbnailURI: "",
    dimensions: {
      x: 940,
      y: 788
    },
    forceDimensions: !0,
    lockDimensions: !0
  }]
}, {
  identifier: "imgly_transforms_instagram",
  name: "Instagram",
  items: [{
    identifier: "imgly_transform_instagram_landscape",
    name: "Landscape",
    thumbnailURI: "",
    dimensions: {
      x: 1080,
      y: 566
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_instagram_portrait",
    name: "Portrait",
    thumbnailURI: "",
    dimensions: {
      x: 1080,
      y: 1350
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_instagram_square",
    name: "Square",
    thumbnailURI: "",
    dimensions: {
      x: 1080,
      y: 1080
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_instagram_story",
    name: "Story",
    thumbnailURI: "",
    dimensions: {
      x: 1080,
      y: 1920
    },
    forceDimensions: !0,
    lockDimensions: !0
  }]
}, {
  identifier: "imgly_transforms_twitter",
  name: "Twitter",
  items: [{
    identifier: "imgly_transform_twitter_post",
    name: "Post",
    thumbnailURI: "",
    dimensions: {
      x: 1024,
      y: 512
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_twitter_profile",
    name: "Profile",
    thumbnailURI: "",
    dimensions: {
      x: 400,
      y: 400
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_twitter_title",
    name: "Title",
    thumbnailURI: "",
    dimensions: {
      x: 1500,
      y: 500
    },
    forceDimensions: !0,
    lockDimensions: !0
  }]
}],
    Xe = ["imgly_font_open_sans_bold", "imgly_font_aleo_bold", "imgly_font_amaticsc", "imgly_font_bernier_regular", "imgly_font_cheque_regular", "imgly_font_gagalin_regular", "imgly_font_hagin_caps_thin", "imgly_font_intro_inline", "imgly_font_lobster", "imgly_font_nexa_script", "imgly_font_ostrich_sans_black", "imgly_font_ostrich_sans_bold", "imgly_font_panton_blackitalic_caps", "imgly_font_panton_lightitalic_caps", "imgly_font_perfograma", "imgly_font_trash_hand"],
    Ye = ["imgly_font_abril_fatface_regular", "imgly_font_montserrat_light", "imgly_font_wolesbro", "imgly_font_permanent_marker", "imgly_font_panton_light_italic_caps", "imgly_font_panton_black_italic_caps", "imgly_font_panton_light_caps", "imgly_font_panton_black_caps", "imgly_font_amberlight", "imgly_font_ultra", "imgly_font_galano_grotesque_bold", "imgly_font_bungee_inline", "imgly_font_petit_formal_script", "imgly_font_summer_font_light", "imgly_font_handycheera_regular", "imgly_font_rasa_regular", "imgly_font_rasa_500", "imgly_font_campton_bold", "imgly_font_ostrich_sans_bold", "imgly_font_ostrich_sans_heavy"],
    qe = function qe() {
  return window && window.navigator && window.navigator.userAgent || "";
},
    Ke = function Ke(e) {
  return void 0 === e && (e = qe()), -1 !== e.indexOf("Edge");
},
    Ze = function Ze(e) {
  return void 0 === e && (e = qe()), !!e.match(/msie|trident/i);
},
    Qe = function Qe(e) {
  try {
    return new URL(e), !0;
  } catch (e) {
    return !1;
  }
},
    Je = function () {
  function e(e) {
    this.assetManager = e, this.injectedFonts = {}, this.loadedFonts = {};
  }

  return e.createFontFacesCSS = function (e, t) {
    return e.map(function (e) {
      var n = t(e.fontURI);
      return '@font-face {\n        font-family: "' + e.fontFamily + "\";\n        src: url('" + n + "') format('" + (e.format || "woff") + "');\n        font-weight: " + (e.fontWeight || "normal") + ";\n        font-style: " + (e.fontStyle || "normal") + ";\n      }";
    });
  }, e.prototype.getFontWithId = function (e) {
    var t = this.assetManager.getFontAsset(e);
    if (!t) throw new Error("The requested font does not exist as an asset.");
    return t;
  }, e.prototype.isFontLoaded = function (e) {
    return void 0 !== this.loadedFonts[e];
  }, e.prototype.injectAllFonts = function () {
    var e = this.assetManager.getFontAssets();
    this.injectFonts(e);
  }, e.prototype.loadAllFonts = function () {
    return x(this, void 0, void 0, function () {
      var e;
      return k(this, function (t) {
        return e = this.assetManager.getFontAssets(), [2, this.loadFonts(e)];
      });
    });
  }, e.prototype.loadFontsWithIdentifiers = function (e) {
    return x(this, void 0, void 0, function () {
      var t,
          n = this;
      return k(this, function (i) {
        return t = e.map(function (e) {
          return n.getFontWithId(e);
        }), [2, this.loadFonts(t)];
      });
    });
  }, e.prototype.loadFonts = function (e) {
    return x(this, void 0, void 0, function () {
      var t,
          n = this;
      return k(this, function (i) {
        return this.injectFonts(e), t = new Array(), e.forEach(function (e) {
          t.push(n.loadFont(e, !1));
        }), [2, new Promise(function (e, n) {
          Promise.all(t).then(function () {
            return e();
          }).catch(function (e) {
            return n(e);
          });
        })];
      });
    });
  }, e.prototype.loadFont = function (e, t) {
    return void 0 === t && (t = !0), x(this, void 0, void 0, function () {
      var n = this;
      return k(this, function (i) {
        return [2, new Promise(function (i, r) {
          n.isFontLoaded(e.identifier) && i(), t && n.injectFonts([e]), new B(e).load().then(function () {
            n.loadedFonts[e.identifier] = e, i();
          }).catch(function () {
            r(e.identifier);
          });
        })];
      });
    });
  }, e.prototype.loadFontWithIdentifier = function (e, t) {
    return void 0 === t && (t = !0), x(this, void 0, void 0, function () {
      var n;
      return k(this, function (i) {
        if (!(n = this.assetManager.getFontAsset(e))) throw new Error("The requested font asset with identifier " + e + " does not exist!");
        return [2, this.loadFont(n, t)];
      });
    });
  }, e.prototype.injectFonts = function (e, t) {
    void 0 === t && (t = this.assetManager.getPathForCategory("font"));
    var n = e.filter(ye),
        i = e.filter(me);
    n.length > 0 && this.addGoogleFontLinks(n), i.length > 0 && this.addWebFontCSS(i, t);
  }, e.prototype.addGoogleFontLinks = function (e) {
    var t = this,
        n = e.filter(function (e) {
      return !t.injectedFonts[e.identifier];
    });

    if (0 !== n.length) {
      var i = document.createElement("link");
      i.rel = "stylesheet", i.href = "https://fonts.googleapis.com/css?family=" + n.map(function (e) {
        return e.fontFamily;
      }).join(","), document.getElementsByTagName("head")[0].appendChild(i), e.forEach(function (e) {
        t.injectedFonts[e.identifier] = e;
      });
    }
  }, e.prototype.addWebFontCSS = function (t, n) {
    var i = this,
        r = t.filter(function (e) {
      return !i.injectedFonts[e.identifier];
    });

    if (0 !== r.length) {
      var o = "\n      /* Injected by PhotoEditorSDK */\n      " + e.createFontFacesCSS(r, n).join("\n") + "\n    ",
          a = document.createElement("style");
      a.innerHTML = o, document.head.appendChild(a), t.forEach(function (e) {
        i.injectedFonts[e.identifier] = e;
      });
    }
  }, e;
}(),
    $e = function () {
  function e(e) {
    var t = this;
    this.basePath = "assets/", this.getAssets = function (e) {
      switch (e) {
        case "overlay":
          return t.overlayAssets;

        case "filter":
          return t.filterCategories;

        case "font":
          return t.fontAssets;

        case "focus":
          return t.focusAssets;

        case "adjustment":
          return t.adjustmentCategories;

        case "sticker":
          return t.stickerCategories;

        case "textdesign":
          return t.textDesignAssets;

        case "frame":
          return t.frameAssets;

        case "transform":
          return t.transformCategories;
      }

      return [];
    }, this.getPath = function (e) {
      for (var n = [], i = 1; i < arguments.length; i++) {
        n[i - 1] = arguments[i];
      }

      var r = Me.join.apply(Me, C([e], n));
      if (n && 0 !== n.length && Qe(Me.join.apply(Me, C(n)))) return Me.join.apply(Me, C(n));
      if ((!n || 0 === n.length) && Qe(e)) return e;

      if (t.basePath.match(/(ftp|http|https):\/\//)) {
        var o = t.basePath.length;
        return "/" !== t.basePath[o - 1] && (t.basePath = t.basePath + "/"), t.basePath + r;
      }

      return Me.join(t.basePath, r);
    }, this.getPathForCategory = function (e) {
      return function () {
        for (var n = [], i = 0; i < arguments.length; i++) {
          n[i] = arguments[i];
        }

        return t.getPath.apply(t, C([e], n));
      };
    }, this.addCustomStickerAsset = function (e, n, i) {
      e.forEach(function (e) {
        var r = e.thumbnailURI,
            o = e.name,
            a = e.sticker,
            s = e.identifier,
            l = e.tintMode,
            u = e.resizeMode,
            c = t.stickerCategories.find(function (e) {
          return e.identifier === n;
        }),
            p = {
          identifier: s,
          name: o,
          thumbnailURI: r,
          sticker: a,
          tintMode: l,
          resizeMode: u
        };
        if (c && de(c)) c.items.push(p);else {
          var f = {
            identifier: n,
            name: i,
            thumbnail: r,
            items: [p]
          };
          t.stickerCategories = C([f], t.stickerCategories);
        }
      }), t.stickerAssets = t.stickerCategories.reduce(t.allOptions, []);
    }, this.getItemPath = function (e, t, n) {
      var i = e.find(function (e) {
        return e.identifier === t;
      });
      return i && (i[n] || i.path) || "";
    }, this.isNonExistingFont = function (e) {
      return !Be.find(function (t) {
        return t.identifier === e.identifier;
      });
    }, e && e.basePath && (this.basePath = e.basePath);
    var n = Le.reduce(this.allOptions, []);
    e && e.filter ? this.filterCategories = this.configuredCategory(Le, e.filter, n) : this.filterCategories = Le, this.lutFilterAssets = this.filterCategories.reduce(this.allOptions, []).filter(function (e) {
      return te(e);
    }), this.duoToneFilterAssets = this.filterCategories.reduce(this.allOptions, []).filter(function (e) {
      return ee(e);
    });
    var i = Ue.reduce(this.allOptions, []);
    e && e.adjustment ? this.adjustmentCategories = this.configuredCategory(Ue, e.adjustment, i) : this.adjustmentCategories = Ue, this.fontAssets = Be.reduce(this.allOptions, []);
    var r = Xe.map(function (e) {
      return t.getFontAsset(e);
    });

    if (e && e.text && e.text.fonts && e.text.fonts.length > 0) {
      var o = e.text.fonts.filter(this.isNonExistingFont),
          a = e.text.fonts.filter(function (e) {
        return !t.isNonExistingFont(e);
      }).map(function (e) {
        return t.getFontAsset(e.identifier);
      });
      r = e.text.fonts ? C(a, o) : r, this.fontAssets = e.text.fonts ? C(this.fontAssets, o) : this.fontAssets;
    }

    this.textToolFontAssets = r;
    var s = e && e.focus && e.focus.items && e.focus.items.length ? e.focus.items.map(function (e) {
      return Ne.find(function (t) {
        return t.identifier === e.identifier;
      });
    }) : Ne;
    this.focusAssets = s, e && e.overlay && e.overlay.items ? this.overlayAssets = this.configuredItem(e.overlay.items, ze, ze) : this.overlayAssets = ze, e && e.frame && e.frame.items ? this.frameAssets = this.configuredItem(e.frame.items, Ge, Ge) : this.frameAssets = Ge;
    var l = je.reduce(this.allOptions, []);
    e && e.sticker ? this.stickerCategories = this.configuredCategory(je, e.sticker, l) : this.stickerCategories = je, this.stickerAssets = this.stickerCategories.reduce(this.allOptions, []);
    var u = We;
    e && "light" === e.theme && (u = He), this.textDesignAssets = e && e.textdesign && e.textdesign.items && e.textdesign.items.length ? e.textdesign.items.map(function (e) {
      return u.find(function (t) {
        return t.identifier === e.identifier;
      });
    }) : u, this.textDesignToolFontAssets = Ye.map(function (e) {
      return t.getFontAsset(e);
    });
    var c = Ve.reduce(this.allOptions, []);
    e && e.transform ? this.transformCategories = this.configuredCategory(Ve, e.transform, c) : this.transformCategories = Ve, this.transformAssets = this.transformCategories.reduce(this.allOptions, []), this.fontManager = new Je(this);
  }

  return e.prototype.getFontManager = function () {
    return this.fontManager;
  }, e.prototype.getAssetSource = function (e, t) {
    switch (e) {
      case "filter":
        if (this.getLUTFilterAsset(t)) return this.getPath(e, this.getItemPath(this.lutFilterAssets, t, "lutURI"));
        break;

      case "overlay":
        return this.getPath(e, this.getItemPath(this.overlayAssets, t, "overlayURI"));

      case "font":
        return this.getPath(e, this.getItemPath(this.fontAssets, t, "fontURI"));

      case "sticker":
        var n = this.stickerAssets.find(function (e) {
          return e.identifier === t;
        });

        if (n) {
          if (he(n)) return n.sticker;

          if (t.includes("imgly_sticker") && n.stickerURI.includes(".svg") && Ze()) {
            var i = this.getPath(e, this.getItemPath(this.stickerAssets, t, "stickerURI")).split("/");
            return i.splice(i.length - 1, 0, "base"), i[i.length - 1] = i[i.length - 1].replace(".svg", ".png"), i.join("/");
          }

          return this.getPath(e, this.getItemPath(this.stickerAssets, t, "stickerURI"));
        }

        throw new Error("Cannot resolve this type of sticker asset yet");

      case "textdesign":
        return this.getPath(e, "engine", t);

      case "frame":
        return this.getPath(e, t);
    }

    throw new Error("Cannot resolve this type of asset yet");
  }, e.prototype.getDuotoneFilterAsset = function (e) {
    return this.duoToneFilterAssets.filter(function (t) {
      return t.identifier === e;
    })[0];
  }, e.prototype.getLUTFilterAsset = function (e) {
    return this.lutFilterAssets.filter(function (t) {
      return t.identifier === e;
    })[0];
  }, e.prototype.getOverlayAsset = function (e) {
    return this.overlayAssets.filter(function (t) {
      return t.identifier === e;
    })[0];
  }, e.prototype.getStickerAsset = function (e) {
    return this.stickerAssets.filter(function (t) {
      return t.identifier === e;
    })[0];
  }, e.prototype.getFontAsset = function (e) {
    return this.fontAssets.filter(function (t) {
      return t.identifier === e;
    })[0];
  }, e.prototype.getTextDesignAssets = function (e) {
    return this.textDesignAssets.filter(function (t) {
      return t.identifier === e;
    })[0];
  }, e.prototype.getFrameAsset = function (e) {
    return this.frameAssets.filter(function (t) {
      return t.identifier === e;
    })[0];
  }, e.prototype.getFontAssets = function () {
    return this.fontAssets;
  }, e.prototype.getFontAssetsForText = function () {
    return this.textToolFontAssets;
  }, e.prototype.getFontAssetsForTextDesign = function () {
    return this.textDesignToolFontAssets;
  }, e.prototype.getFrameAssets = function () {
    return this.frameAssets;
  }, e.prototype.allOptions = function (e, t) {
    return Object.prototype.hasOwnProperty.call(t, "items") ? C(e, t.items) : C(e, [t]);
  }, e.prototype.configuredCategory = function (e, t, n) {
    var i = this;
    return t.categories && t.categories.length ? t.categories.map(function (t) {
      var r = e.find(function (e) {
        return e.identifier === t.identifier;
      });
      return r ? _v2(_v2(_v2({}, r), t), {
        items: i.configuredItem(t.items, n, r.items).filter(Boolean)
      }) : _v2(_v2({}, t), {
        items: i.configuredItem(t.items, n, t.items).filter(Boolean)
      });
    }) : e;
  }, e.prototype.configuredItem = function (e, t, n) {
    return e && e.length ? e.map(function (e) {
      var n = t.find(function (t) {
        return t.identifier === e.identifier;
      });
      return n ? _v2(_v2({}, n), e) : e;
    }).filter(Boolean) : n;
  }, e;
}(),
    et = g(m(function (e, t) {
  var n;
  "undefined" != typeof self && self, n = function n() {
    return function (e) {
      var t = {};

      function n(i) {
        if (t[i]) return t[i].exports;
        var r = t[i] = {
          i: i,
          l: !1,
          exports: {}
        };
        return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, i) {
        n.o(e, t) || Object.defineProperty(e, t, {
          configurable: !1,
          enumerable: !0,
          get: i
        });
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 225);
    }([function (e, t, n) {
      e.exports = {
        default: n(227),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(237),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(229),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(232),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = n(240).default;
    }, function (e, t, n) {
      e.exports = {
        default: n(277),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(264),
        __esModule: !0
      };
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(335)),
          g = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = function (e) {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          y(this, t);

          var i = _(this, (t.__proto__ || f()(t)).call(this, e, g({
            intensity: {
              type: h.OptionType.NUMBER,
              default: 1,
              setter: function setter(e) {
                return this._stack && this._stack.setIntensity(e), e;
              }
            },
            dirty: {
              type: h.OptionType.BOOLEAN,
              default: !0
            }
          }, n)));

          return i._stack = new d.a(i._options.intensity), i;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "render",
          value: function value(e, t, n) {
            var i = this;
            return this._stack.render(e, t, n).then(function (e) {
              return i.setDirty(!1), e;
            });
          }
        }, {
          key: "setDirtyForRenderer",
          value: function value(e, t) {
            this._stack.setDirtyForRenderer(e, t);
          }
        }, {
          key: "disposeRenderTextures",
          value: function value() {
            this._stack.disposeRenderTextures();
          }
        }, {
          key: "dispose",
          value: function value() {
            this._stack.dispose();
          }
        }]), t;
      }(h.Configurable);

      v.identifier = null, v.isIdentity = !1, v.displayName = null, v.PrimitivesStack = d.a, t.a = v;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(337);
      n.d(t, "Brightness", function () {
        return i.a;
      });
      var r = n(339);
      n.d(t, "Contrast", function () {
        return r.a;
      });
      var o = n(341);
      n.d(t, "ColorMatrixPrimitive", function () {
        return o.a;
      });
      var a = n(343);
      n.d(t, "Desaturation", function () {
        return a.a;
      });
      var s = n(345);
      n.d(t, "DuoTone", function () {
        return s.a;
      });
      var l = n(347);
      n.d(t, "Gamma", function () {
        return l.a;
      });
      var u = n(349);
      n.d(t, "Glow", function () {
        return u.a;
      });
      var c = n(351);
      n.d(t, "Gobblin", function () {
        return c.a;
      });
      var p = n(353);
      n.d(t, "Grayscale", function () {
        return p.a;
      });
      var f = n(174);
      n.d(t, "LookupTable", function () {
        return f.a;
      });
      var h = n(356);
      n.d(t, "LookupTableImage", function () {
        return h.a;
      });
      var d = n(358);
      n.d(t, "Saturation", function () {
        return d.a;
      });
      var g = n(360);
      n.d(t, "SoftColorOverlay", function () {
        return g.a;
      });
      var m = n(362);
      n.d(t, "ToneCurve", function () {
        return m.a;
      });
      var y = n(363);
      n.d(t, "X400", function () {
        return y.a;
      });

      var _ = n(365);

      n.d(t, "ThreeDLookupTableImage", function () {
        return _.a;
      });
    }, function (e, t, n) {
      n.d(t, "h", function () {
        return h;
      }), n.d(t, "n", function () {
        return _;
      }), n.d(t, "k", function () {
        return d;
      }), n.d(t, "d", function () {
        return f;
      }), n.d(t, "b", function () {
        return p;
      }), n.d(t, "a", function () {
        return c;
      }), n.d(t, "i", function () {
        return g;
      }), n.d(t, "j", function () {
        return y;
      }), n.d(t, "e", function () {
        return m;
      });
      var i = n(239),
          r = n(482),
          o = n(24),
          a = n(91),
          s = n(73),
          l = n(31),
          u = n.n(l);
      n.d(t, "m", function () {
        return i.a;
      }), n.d(t, "c", function () {
        return r.a;
      }), n.d(t, "g", function () {
        return o.a;
      }), n.d(t, "l", function () {
        return a.b;
      }), n.d(t, "f", function () {
        return s.a;
      });

      var c = u.a.Base64,
          p = u.a.Color,
          f = (u.a.Math.ColorMatrix, u.a.EventEmitter),
          h = (u.a.EXIF, u.a.OptionType, u.a.Promise),
          d = u.a.Utils,
          g = u.a.RenderType,
          m = u.a.ImageFormat,
          y = u.a,
          _ = (u.a.UniformType, u.a.Math.Vector2);

      u.a.Math.Rectangle, u.a.Math.Range, "undefined" != typeof window && window.performance && window.performance.now ? window.performance.now.bind(window.performance) : n(87);
    }, function (e, t, n) {
      e.exports = {
        default: n(252),
        __esModule: !0
      };
    }, function (e, t) {
      var n = e.exports = {
        version: "2.6.11"
      };
      "number" == typeof __e && (__e = n);
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return f;
      }), n.d(t, "j", function () {
        return h;
      });
      var i = n(24),
          r = n(66),
          o = n(154),
          a = n(155),
          s = n(45),
          l = n(67),
          u = n(32),
          c = n(156),
          p = n(40);
      n.d(t, "b", function () {
        return r.a;
      }), n.d(t, "g", function () {
        return o.a;
      }), n.d(t, "k", function () {
        return s.a;
      }), n.d(t, "h", function () {
        return a.a;
      }), n.d(t, "d", function () {
        return l.a;
      }), n.d(t, "f", function () {
        return i.a;
      }), n.d(t, "i", function () {
        return u.a;
      }), n.d(t, "c", function () {
        return p;
      }), n.d(t, "e", function () {
        return c.a;
      });
      var f = 2e3,
          h = 20;
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return _;
      });
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(140), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function g(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function m(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var y = function (e) {
        function t() {
          var e;
          g(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = m(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._fragmentSource = null, o._inputTextureSizeMap = {}, o._inputLogicalSizeMap = {}, o._inputShapeMap = {}, o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "requiresFloatTextures",
          value: function value() {
            return !0;
          }
        }, {
          key: "setTargetTextureSize",
          value: function value(e) {
            this._targetTextureSize = e;
          }
        }, {
          key: "setTargetLogicalSize",
          value: function value(e) {
            this._targetSize = e;
          }
        }, {
          key: "setTextureSizeForInputWithName",
          value: function value(e, t) {
            this._inputTextureSizeMap[t] = e;
          }
        }, {
          key: "setLogicalSizeForInputWithName",
          value: function value(e, t) {
            this._inputLogicalSizeMap[t] = e;
          }
        }, {
          key: "getShaderForRenderer",
          value: function value(e) {
            return this._fragmentSource || (this._fragmentSource = this._buildFragmentShader()), function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "getShaderForRenderer", this).call(this, e);
          }
        }, {
          key: "outputLogicalShape",
          value: function value() {
            if (!this._options.outputLogicalShape) {
              var e = this._calculateOutputShape();

              this._options.outputLogicalShape = e;
            }

            return this._options.outputLogicalShape;
          }
        }, {
          key: "_applyWebGL",
          value: function value(e, t, n) {
            var i = this,
                r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
                a = o;
            a || (a = this.getShaderForRenderer(e));
            var s = e.getContext(),
                l = {},
                u = e.getCurrentRenderTarget().getProjectionMatrix().toArray();
            l.u_projMatrix = u, l.output_texRC = this._targetTextureSize, l.output_sizeRC = this._targetSize, l.output_shape = this.outputLogicalShape(), this._options.inputs.forEach(function (e) {
              try {
                l[e.name + "_texRC"] = i._inputTextureSizeMap[e.name], l[e.name + "_sizeRC"] = i._inputLogicalSizeMap[e.name], l[e.name + "_shape"] = e.logicalShape;
              } catch (t) {
                throw new Error("Missing texture or logical size for input " + e.name + " in filter " + i.constructor.name + ".");
              }
            }, this), this._updateAdditionalUniforms(a), a.setUniforms(l), a.syncUniforms();
            var c = t.getBaseTexture(),
                p = e.getOrCreateGLTexture(c);
            s.activeTexture(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, p), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, c.getGLRepeat(s, "x")), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, c.getGLRepeat(s, "y")), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, c.getGLFilter(s, "min")), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, c.getGLFilter(s, "mag")), s.bindFramebuffer(s.FRAMEBUFFER, n._framebuffer), r && s.clear(s.COLOR_BUFFER_BIT), s.drawElements(s.TRIANGLES, 6, s.UNSIGNED_SHORT, 0);
          }
        }, {
          key: "getShaderIdentifier",
          value: function value() {
            var e = this.outputLogicalShape().length,
                t = this.getInputs().map(function (e) {
              return e.name + "_" + e.logicalShape.length;
            }).join("");
            return this.constructor.name + "_" + e + "_" + t + "_" + this._getTensorOperationSource();
          }
        }, {
          key: "_updateAdditionalUniforms",
          value: function value(e) {}
        }, {
          key: "_calculateOutputShape",
          value: function value() {
            return this.getInputs()[0].logicalShape;
          }
        }, {
          key: "prepareUniforms",
          value: function value() {
            var e = this;
            this._uniforms.output_texRC = {
              type: h.UniformType.FLOAT2,
              value: [0, 0]
            }, this._uniforms.output_sizeRC = {
              type: h.UniformType.FLOAT2,
              value: [0, 0]
            };

            var t = this._calculateOutputShape();

            this._uniforms.output_shape = {
              type: 2 === t.length ? h.UniformType.INT2 : h.UniformType.INT4,
              value: t
            };
            var n = 1,
                i = [];
            this.getInputs().forEach(function (t) {
              if (-1 !== i.indexOf(t.name)) throw new Error("Input names must be unique.");
              var r = t.name + "_texRC",
                  o = t.name + "_sizeRC",
                  a = t.name + "_shape";

              switch (e._uniforms[r] = {
                type: h.UniformType.FLOAT2,
                value: [0, 0]
              }, e._uniforms[o] = {
                type: h.UniformType.FLOAT2,
                value: [0, 0]
              }, e._uniforms[a] = {
                type: 2 === t.logicalShape.length ? h.UniformType.INT2 : h.UniformType.INT4,
                value: t.logicalShape
              }, t.type) {
                case _.PREVIOUS:
                  e._uniforms[t.name] = {
                    type: h.UniformType.SAMPLER2D,
                    value: 0
                  };
                  break;

                case _.DATA:
                  e._uniforms[t.name] = {
                    type: h.UniformType.SAMPLER2D,
                    value: n++
                  };
              }
            }), this.getInputs().forEach(function (t) {
              t.type === _.INDEX && (e._uniforms[t.name] = {
                type: h.UniformType.SAMPLER2D,
                value: n++
              });
            }), delete this._availableUniforms.u_image, delete this._uniforms.u_image;
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      void main () {\n        setOutput(0.0);\n      }\n    ";
          }
        }, {
          key: "_buildFragmentShader",
          value: function value() {
            var e = this,
                t = n(471),
                i = this.outputLogicalShape();
            return 2 === i.length ? t += this._create2DOutputInterfaceSnippet() : 4 === i.length && (t += this._create4DOutputInterfaceSnippet()), this._options.inputs.forEach(function (n) {
              t += e._createInputInterfaceSnippet(n);
            }), t += this._createOutputSnippet(), t += this._getTensorOperationSource();
          }
        }, {
          key: "_createOutputSnippet",
          value: function value() {
            return "\n      void setOutput(float val) {\n        gl_FragColor = vec4(val, 0, 0, 0);\n      }\n    ";
          }
        }, {
          key: "_create2DOutputInterfaceSnippet",
          value: function value() {
            return "\n      uniform ivec2 output_shape;\n      ivec2 getOutputCoords() {\n        vec2 adjustedFragCoord = gl_FragCoord.xy - halfCR;\n        int index = int(adjustedFragCoord.y * output_sizeRC.y + adjustedFragCoord.x);\n        int r = index / output_shape[1];\n        int c = index - r * output_shape[1];\n\n        return ivec2(r, c);\n      }\n    ";
          }
        }, {
          key: "_create4DOutputInterfaceSnippet",
          value: function value() {
            return "\n      uniform ivec4 output_shape;\n      ivec4 getOutputCoords() {\n        vec2 adjustedFragCoord = gl_FragCoord.xy - halfCR;\n        int index = int(adjustedFragCoord.y * output_sizeRC.y + adjustedFragCoord.x);\n\n        int stride2 = output_shape[3];\n        int stride1 = output_shape[2] * stride2;\n        int stride0 = output_shape[1] * stride1;\n\n        int r = index / stride0;\n        index -= r * stride0;\n\n        int c = index / stride1;\n        index -= c * stride1;\n\n        int d = index / stride2;\n        int d2 = index - d * stride2;\n\n        return ivec4(r, c, d, d2);\n      }\n    ";
          }
        }, {
          key: "_createInputInterfaceSnippet",
          value: function value(e) {
            var t = "",
                n = e.name,
                i = e.logicalShape,
                r = n + "_texRC",
                o = n + "_sizeRC",
                a = n + "_shape";
            return t += "\n      uniform sampler2D " + n + ";\n      uniform vec2 " + r + ";\n      uniform vec2 " + o + ";\n      uniform " + (2 === i.length ? "ivec2" : "ivec4") + " " + a + ";\n    ", t += "\n      float get" + this._capitalize(n) + "Flat(int index) {\n        vec2 uv = UVfrom1D(" + r + ", " + o + ", index);\n        return sampleTexture(" + n + ", uv);\n      }\n    ", 2 === i.length ? t += "\n        float get" + this._capitalize(n) + "(int row, int col) {\n          vec2 uv = UVfrom2D(" + r + ", " + o + ", " + a + "[1], row, col);\n          return sampleTexture(" + n + ", uv);\n        }\n      " : 4 === i.length && (t += "\n      float get" + this._capitalize(n) + "(int row, int col, int depth, int depth2) {\n        int stride2 = " + a + "[3];\n        int stride1 = " + a + "[2] * stride2;\n        int stride0 = " + a + "[1] * stride1;\n\n        vec2 uv = UVfrom4D(" + r + ", " + o + ", stride0, stride1, stride2, row, col, depth, depth2);\n        return sampleTexture(" + n + ", uv);\n      }\n\n      float get" + this._capitalize(n) + "(ivec4 coords) {\n        return get" + this._capitalize(n) + "(coords.x, coords.y, coords.z, coords.w);\n      }\n    "), t;
          }
        }, {
          key: "_capitalize",
          value: function value(e) {
            return e.charAt(0).toUpperCase() + e.slice(1);
          }
        }, {
          key: "_getInputWithName",
          value: function value(e) {
            return h.Utils.Array.find(this._options.inputs, function (t) {
              return t.name === e;
            });
          }
        }]), t;
      }(h.Engine.Filter),
          _ = {
        PREVIOUS: "previous",
        INDEX: "index",
        DATA: "data"
      };

      y.prototype.availableOptions = {
        inputs: {
          type: h.OptionType.ARRAY
        },
        outputLogicalShape: {
          type: h.OptionType.ARRAY
        },
        outputTextureDimensions: {
          type: h.OptionType.ARRAY
        }
      }, t.b = y;
    }, function (e, t, n) {
      var i = n(16),
          r = n(11),
          o = n(30),
          a = n(34),
          s = n(43),
          l = function l(e, t, n) {
        var u,
            c,
            p,
            f = e & l.F,
            h = e & l.G,
            d = e & l.S,
            g = e & l.P,
            m = e & l.B,
            y = e & l.W,
            _ = h ? r : r[t] || (r[t] = {}),
            v = _.prototype,
            b = h ? i : d ? i[t] : (i[t] || {}).prototype;

        for (u in h && (n = t), n) {
          (c = !f && b && void 0 !== b[u]) && s(_, u) || (p = c ? b[u] : n[u], _[u] = h && "function" != typeof b[u] ? n[u] : m && c ? o(p, i) : y && b[u] == p ? function (e) {
            var t = function t(_t2, n, i) {
              if (this instanceof e) {
                switch (arguments.length) {
                  case 0:
                    return new e();

                  case 1:
                    return new e(_t2);

                  case 2:
                    return new e(_t2, n);
                }

                return new e(_t2, n, i);
              }

              return e.apply(this, arguments);
            };

            return t.prototype = e.prototype, t;
          }(p) : g && "function" == typeof p ? o(Function.call, p) : p, g && ((_.virtual || (_.virtual = {}))[u] = p, e & l.R && v && !v[u] && a(v, u, p)));
        }
      };

      l.F = 1, l.G = 2, l.S = 4, l.P = 8, l.B = 16, l.W = 32, l.U = 64, l.R = 128, e.exports = l;
    }, function (e, t, n) {
      e.exports = {
        default: n(260),
        __esModule: !0
      };
    }, function (e, t) {
      var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = n);
    }, function (e, t, n) {
      var i = n(101)("wks"),
          r = n(84),
          o = n(16).Symbol,
          a = "function" == typeof o;
      (e.exports = function (e) {
        return i[e] || (i[e] = a && o[e] || (a ? o : r)("Symbol." + e));
      }).store = i;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "update",
          value: function value() {}
        }, {
          key: "getFilter",
          value: function value() {
            return this._filter;
          }
        }, {
          key: "dispose",
          value: function value() {
            this._filter && (this._filter.dispose(), this._filter = null);
          }
        }]), t;
      }(p.Configurable);

      t.a = g;
    }, function (e, t, n) {
      e.exports = !n(42)(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return a;
      });

      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._seed = void 0 === t ? e.TimeSeed() : t;
        }

        return o(e, [{
          key: "seed",
          value: function value(t) {
            this._seed = void 0 === t ? e.TimeSeed() : t;
          }
        }, {
          key: "next",
          value: function value() {
            var t = 0 | this._seed,
                n = t / e.SEED_DIVIDER | 0,
                i = t % e.SEED_DIVIDER | 0;
            return (t = e.SEED_LOW_MULTIPLY * i - e.SEED_HIGH_MULTIPLY * n) <= 0 && (t += e.MAX), -1 === t && (t = e.MAX - 1), this._seed = t, t;
          }
        }, {
          key: "nextInRange",
          value: function value(e, t) {
            return void 0 === t && (t = e, e = 0), e + this.next() % (t - e + 1);
          }
        }, {
          key: "nextBool",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            return this.nextInRange(e + t - 1) >= e;
          }
        }, {
          key: "pickNext",
          value: function value(e) {
            return Array.isArray(e) ? e[this.next() % e.length] : null;
          }
        }], [{
          key: "TimeSeed",
          value: function value() {
            return Date.now();
          }
        }]), e;
      }();

      a.MAX = 2147483647, a.SEED_DIVIDER = 127773, a.SEED_LOW_MULTIPLY = 16807, a.SEED_HIGH_MULTIPLY = 2836;
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return f;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(4),
          l = (n.n(s), r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      }),
          u = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function c(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var p = s.Math.Rectangle,
          f = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
          c(this, e), this.top = t, this.left = n, this.bottom = i, this.right = r;
        }

        return u(e, [{
          key: "multiply",
          value: function value(e) {
            this.top *= e, this.left *= e, this.bottom *= e, this.right *= e;
          }
        }, {
          key: "toObject",
          value: function value() {
            return l({}, this);
          }
        }, {
          key: "equals",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            return Math.abs(e.top - this.top) <= t && Math.abs(e.left - this.left) <= t && Math.abs(e.bottom - this.bottom) <= t && Math.abs(e.right - this.right) <= t;
          }
        }, {
          key: "scale",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                t = arguments[1];
            return void 0 === t && (t = e), this.top *= t, this.bottom *= t, this.left *= e, this.right *= e, this;
          }
        }, {
          key: "clone",
          value: function value() {
            return new e(this.top, this.left, this.bottom, this.right);
          }
        }, {
          key: "applyToRectangle",
          value: function value(e) {
            return new p(e.x + this.left, e.y + this.top, e.width - this.left - this.right, e.height - this.top - this.bottom);
          }
        }], [{
          key: "ZERO",
          get: function get() {
            return new e(0, 0, 0, 0);
          }
        }]), e;
      }();
    }, function (e, t, n) {
      var i = n(28),
          r = n(136),
          o = n(95),
          a = Object.defineProperty;
      t.f = n(19) ? Object.defineProperty : function (e, t, n) {
        if (i(e), t = o(t, !0), i(n), r) try {
          return a(e, t, n);
        } catch (e) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (e[t] = n.value), e;
      };
    }, function (e, t) {
      e.exports = function (e) {
        return "object" == typeof e ? null !== e : "function" == typeof e;
      };
    }, function (e, t, n) {
      (function (e) {
        var i = n(15),
            r = n.n(i),
            o = n(0),
            a = n.n(o),
            s = n(153),
            l = n.n(s),
            u = n(32),
            c = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var i = t[n];
              i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
            }
          }

          return function (t, n, i) {
            return n && e(t.prototype, n), i && e(t, i), t;
          };
        }();

        function p(e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = Array(e.length); t < e.length; t++) {
              n[t] = e[t];
            }

            return n;
          }

          return r()(e);
        }

        function f(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        var h = [{
          name: "trace",
          type: "trace",
          background: "#EEEEEE",
          color: "#AAAAAA"
        }, {
          name: "info",
          type: "log",
          background: "#BDE5F8",
          color: "#00529B"
        }, {
          name: "warn",
          type: "warn",
          background: "#FEEFB3",
          color: "#9F6000"
        }, {
          name: "error",
          type: "error",
          background: "#FFBABA",
          color: "#D8000C"
        }, {
          name: "log",
          type: "log",
          background: "#EEEEEE",
          color: "#1f4f6b"
        }],
            d = function d() {
          return console && console.group && console.groupCollapsed && console.groupEnd;
        },
            g = function g() {
          return (!e || e && e.browser) && "undefined" != typeof navigator && navigator.userAgent.match(/Gecko|WebKit/i) && !navigator.userAgent.match(/Trident/);
        },
            m = function m(e, t) {
          return ["background: #2D7BFF; line-height: 20px; padding: 4px 0", "background: #2B2B2B; color: white; line-height: 20px; padding: 4px 0", "background: #2D7BFF; line-height: 20px; padding: 4px 0", "background: " + e + "; color: " + t + "; line-height: 20px; padding: 4px 0; font-weight: bold", "background: #2B2B2B; color: white; line-height: 20px; padding: 4px 0", "background: #2D7BFF; line-height: 20px; padding: 4px 0"];
        },
            y = new (function () {
          function e() {
            var t = this,
                n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "warn",
                i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : h;
            f(this, e), this._levels = [].concat(p(i)), this._maxLevel = this.getLevelIndexByName(n), this._consoleFuncs = {
              trace: function trace() {
                var e, t;
                d() ? ((e = console).groupCollapsed.apply(e, arguments), console.trace(), console.groupEnd()) : (t = console).trace.apply(t, arguments);
              }
            }, this._levels.forEach(function (e) {
              var n = e.name;

              t[n] = function (e) {
                for (var i = arguments.length, r = Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) {
                  r[o - 1] = arguments[o];
                }

                t._log.apply(t, [n, e].concat(r));
              };
            });
          }

          return c(e, [{
            key: "getLevelIndexByName",
            value: function value(e) {
              return u.a.Array.findIndex(this._levels, function (t) {
                return t.name === e;
              });
            }
          }, {
            key: "getLevelObjectByName",
            value: function value(e) {
              return u.a.Array.find(this._levels, function (t) {
                return t.name === e;
              });
            }
          }, {
            key: "canLog",
            value: function value(e) {
              var t = this.getLevelIndexByName(e);
              return !(t < 0) && t >= this._maxLevel;
            }
          }, {
            key: "setLevel",
            value: function value(e) {
              var t = this.getLevelIndexByName(e);
              t < 0 || (this._maxLevel = t);
            }
          }, {
            key: "_log",
            value: function value(e, t) {
              for (var n = arguments.length, i = Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++) {
                i[r - 2] = arguments[r];
              }

              var o = this.getLevelObjectByName(e);

              if (o && this.canLog(e)) {
                o.name;
                var a,
                    s = o.type,
                    c = o.background,
                    f = o.color,
                    h = i.filter(function (e) {
                  return void 0 !== e;
                }).map(function (e) {
                  return e.toObject ? JSON.parse(l()(e.toObject())) : e;
                }),
                    y = this._consoleFuncs[s] || console[s] ? function () {
                  var e;
                  return (e = console)[s].apply(e, arguments);
                } : function () {
                  var e;
                  return (e = console).log.apply(e, arguments);
                },
                    _ = h.length,
                    v = m(c, f);

                if (!g()) {
                  var b = h.length;
                  return b <= 0 ? void y("PhotoEditorSDK | " + t + " ") : 1 === b && "string" == typeof h[0] ? void y("PhotoEditorSDK | " + t + " | " + h[0]) : void y.apply(void 0, ["PhotoEditorSDK | " + t + " | "].concat(p(h)));
                }

                _ <= 0 ? y.apply(void 0, ["%c  %c PhotoEditorSDK %c  %c " + t + " %c %c  "].concat(p(v))) : 1 !== _ || "string" != typeof h[0] ? d() ? ((a = console).groupCollapsed.apply(a, ["%c  %c PhotoEditorSDK %c  %c " + t + " %c"].concat(p(u.a.Array.init(v)))), y.apply(void 0, p(h)), console.groupEnd()) : y.apply(void 0, ["%c  %c PhotoEditorSDK %c  %c " + t + " %c"].concat(p(u.a.Array.init(v)), p(h))) : y.apply(void 0, ["%c  %c PhotoEditorSDK %c  %c " + t + " %c  " + h[0] + "  %c  "].concat(p(v)));
              }
            }
          }, {
            key: "image",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                  t = arguments[1],
                  n = new window.Image(),
                  i = function i() {
                var t = n.width,
                    i = n.height;
                e && console.log(e), console.log("%c+", "\n        font-size: 1px;\n        padding: 0px " + Math.floor(t / 2) + "px;\n        line-height: " + i + "px;\n        background: url(" + n.src + ");\n        color: transparent;\n        background-repeat: no-repeat;\n        background-size: " + t + "px " + i + "px;");
              };

              return n.onload = i, t instanceof window.HTMLCanvasElement ? n.src = t.toDataURL() : t instanceof window.Image ? (n = t, i()) : "string" == typeof t ? n.src = t : this.log(e, t), n;
            }
          }, {
            key: "texture",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                  t = arguments[1];

              if (t) {
                var n = t.getBaseTexture(),
                    i = n.getRenderers(),
                    r = u.a.Array.find(i, function (e) {
                  return e && "WebGL" === e.constructor.type;
                }),
                    o = n.getFrame(),
                    a = o.width,
                    s = o.height;

                if (r) {
                  var l = r.getContext(),
                      c = n.getGLTextureForRenderer(r);
                  this.logGlTexture(l, c, a, s, e);
                } else y.image(e, n.getSource());
              } else this.log(e, "texture: null or undefined");
            }
          }, {
            key: "logGlTexture",
            value: function value(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 150,
                  i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 150,
                  r = arguments[4];
              e.bindTexture(e.TEXTURE_2D, t);
              var o = e.createFramebuffer();
              e.bindFramebuffer(e.FRAMEBUFFER, o), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0);
              var a = new Uint8Array(n * i * 4);
              e.readPixels(0, 0, n, i, e.RGBA, e.UNSIGNED_BYTE, a), e.deleteFramebuffer(o);
              var s = document.createElement("canvas");
              s.width = n, s.height = i;
              var l = s.getContext("2d"),
                  u = l.createImageData(n, i);
              return u.data.set(a), l.putImageData(u, 0, 0), y.image(r, s);
            }
          }]), e;
        }())("warn");

        t.a = y;
      }).call(t, n(152));
    }, function (e, t, n) {
      e.exports = {
        default: n(272),
        __esModule: !0
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return x;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(92)),
          g = n(21),
          m = n(79),
          y = n(52),
          _ = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = function (e) {
        function t() {
          return b(this, t), w(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_calculateLayoutElements",
          value: function value() {
            var e = this.serializeOptions(),
                t = e.attributes,
                n = e.imageInsets,
                i = e.size,
                r = (e.width, this.getWords().joined(1)[0] || ""),
                o = t.fontIdentifier,
                a = new m.a({
              text: r,
              fontIdentifier: o
            });
            a.fitWidth(this._getTextFrame().width);
            var s = a.getTextMetrics().height + n.top + n.bottom;
            i.height = s;

            var l = this._getTextFrame();

            return [new y.a({
              text: r,
              frame: l,
              font: a
            })];
          }
        }]), t;
      }(d.a);

      x.prototype.availableOptions = _({}, d.a.prototype.availableOptions, {
        imageInsets: {
          type: h.OptionType.OBJECT,
          default: new g.a()
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return b;
      });
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(10),
          c = n.n(u),
          p = n(80),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = function (e) {
        function t() {
          return y(this, t), _(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        var n, i;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "loadImages",
          value: (n = f.a.mark(function e(t) {
            var n, i, r;
            return f.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    n = [], i = 0;

                  case 2:
                    if (!(i < t.length)) {
                      e.next = 10;
                      break;
                    }

                    return r = t[i], e.next = 6, this.addImage(r.path, r.fullPath, r.image);

                  case 6:
                    n.push(r);

                  case 7:
                    i++, e.next = 2;
                    break;

                  case 10:
                    return e.abrupt("return", n);

                  case 11:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }), i = function i() {
            var e = n.apply(this, arguments);
            return new c.a(function (t, n) {
              return function i(r, o) {
                try {
                  var a = e[r](o),
                      s = a.value;
                } catch (e) {
                  return void n(e);
                }

                if (!a.done) return c.a.resolve(s).then(function (e) {
                  i("next", e);
                }, function (e) {
                  i("throw", e);
                });
                t(s);
              }("next");
            });
          }, function (e) {
            return i.apply(this, arguments);
          })
        }, {
          key: "addImage",
          value: function value(e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "anonymous",
                r = this.getImages();
            return n ? (r[e] = {
              fullPath: t,
              image: n
            }, c.a.resolve({
              fullPath: t,
              image: n
            })) : new c.a(function (o, a) {
              (n = new g.Image()).onload = function () {
                r[e] = {
                  fullPath: t,
                  image: n
                }, o({
                  fullPath: t,
                  image: n
                });
              }, n.crossOrigin = g.Utils.getCrossOriginValue(i), n.onerror = a, n.src = t;
            });
          }
        }, {
          key: "getImage",
          value: function value(e) {
            var t = this.getImages()[e];
            return t ? t.image : null;
          }
        }, {
          key: "getVariation",
          value: function value(e) {
            return this.getFonts()[e];
          }
        }, {
          key: "addFont",
          value: function value(e, t) {
            return this.getFonts()[e] = t, t;
          }
        }]), t;
      }(g.Configurable);

      v.prototype.availableOptions = {
        images: {
          type: g.OptionType.OBJECT,
          default: {}
        },
        fonts: {
          type: g.OptionType.OBJECT,
          default: {}
        }
      };
      var b = new v();
    }, function (e, t, n) {
      var i = n(23);

      e.exports = function (e) {
        if (!i(e)) throw TypeError(e + " is not an object!");
        return e;
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(270),
        __esModule: !0
      };
    }, function (e, t, n) {
      var i = n(56);

      e.exports = function (e, t, n) {
        if (i(e), void 0 === t) return e;

        switch (n) {
          case 1:
            return function (n) {
              return e.call(t, n);
            };

          case 2:
            return function (n, i) {
              return e.call(t, n, i);
            };

          case 3:
            return function (n, i, r) {
              return e.call(t, n, i, r);
            };
        }

        return function () {
          return e.apply(t, arguments);
        };
      };
    }, function (e, t, n) {
      /*!
       * This file is part of PhotoEditorSDK.
       *
       * Copyright (C) 2016-2019 img.ly GmbH <contact@img.ly>
       * All rights reserved.
       *
       * Redistribution and use in source and binary forms, without
       * modification, are permitted provided that the following license agreement
       * is approved and a legal/financial contract was signed by the user.
       * The license agreement can be found under following link:
       *
       * https://www.photoeditorsdk.com/LICENSE.txt
       */
      e.exports = n(4), n(323);
    }, function (e, t, n) {
      (function (e) {
        var i = n(6),
            r = n.n(i),
            o = n(15),
            a = n.n(o),
            s = n(36),
            l = n.n(s),
            u = n(37),
            c = n.n(u),
            p = n(0),
            f = n.n(p),
            h = n(10),
            d = n.n(h),
            g = n(39),
            m = n.n(g),
            y = n(1),
            _ = n.n(y),
            v = n(65),
            b = n(269),
            w = r.a || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var i in n) {
              Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
            }
          }

          return e;
        },
            x = "function" == typeof c.a && "symbol" == typeof l.a ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof c.a && e.constructor === c.a && e !== c.a.prototype ? "symbol" : typeof e;
        },
            k = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var i = t[n];
              i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), f()(e, i.key, i);
            }
          }

          return function (t, n, i) {
            return n && e(t.prototype, n), i && e(t, i), t;
          };
        }();

        function T(e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = Array(e.length); t < e.length; t++) {
              n[t] = e[t];
            }

            return n;
          }

          return a()(e);
        }

        var S = function () {
          function t() {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t);
          }

          return k(t, null, [{
            key: "isArray",
            value: function value(e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            }
          }, {
            key: "mapRange",
            value: function value(e, t, n) {
              return (e - t.getMin()) * n.getLength() / t.getLength() + n.getMin();
            }
          }, {
            key: "isPlainObject",
            value: function value(e) {
              if ("object" !== (void 0 === e ? "undefined" : x(e)) || !e) return !1;

              if ("function" == typeof _.a) {
                var t = _()(e);

                return t === Object.prototype || null === t;
              }

              return "[object Object]" === Object.prototype.toString.call(e);
            }
          }, {
            key: "isMobile",
            value: function value() {
              if ("undefined" == typeof navigator) return !1;
              var e = navigator.userAgent || navigator.vendor || window.opera;
              return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4));
            }
          }, {
            key: "isBrowser",
            value: function value() {
              return "undefined" != typeof window;
            }
          }, {
            key: "isNode",
            value: function value() {
              return "undefined" == typeof window && void 0 !== e;
            }
          }, {
            key: "values",
            value: function value(e) {
              var t = [];

              for (var n in e) {
                t.push(e[n]);
              }

              return t;
            }
          }, {
            key: "generateUUID",
            value: function value() {
              var e = new Date().getTime();
              return void 0 !== window.performance && "function" == typeof window.performance.now && (e += window.performance.now()), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
                var n = (e + 16 * Math.random()) % 16 | 0;
                return e = Math.floor(e / 16), ("x" === t ? n : 3 & n | 8).toString(16);
              });
            }
          }, {
            key: "isDOMElement",
            value: function value(e) {
              return "object" === ("undefined" == typeof HTMLElement ? "undefined" : x(HTMLElement)) ? e instanceof HTMLElement : e && "object" === (void 0 === e ? "undefined" : x(e)) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName;
            }
          }, {
            key: "isTouchEvent",
            value: function value(e) {
              return -1 !== e.type.indexOf("touch");
            }
          }, {
            key: "resizeVectorToFit",
            value: function value(e, t) {
              var n = Math.min(t.x / e.x, t.y / e.y);
              return e.clone().multiply(n);
            }
          }, {
            key: "resizeVectorToFill",
            value: function value(e, t) {
              var n = e.x / e.y;
              return n > t.x / t.y ? t.clone().set(t.y * n, t.y) : t.clone().set(t.x, t.x / n);
            }
          }, {
            key: "isExtendable",
            value: function value(e) {
              return null != e && ("object" === (void 0 === e ? "undefined" : x(e)) || "function" == typeof e);
            }
          }, {
            key: "defaults",
            value: function value(e) {
              var t = {};

              for (var n in e) {
                t[n] = e[n];
              }

              for (var i = arguments.length, r = Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) {
                r[o - 1] = arguments[o];
              }

              for (var a = 0; a < r.length; a++) {
                var s = r[a];

                for (var l in s) {
                  void 0 === t[l] && (t[l] = s[l]);
                }
              }

              return t;
            }
          }, {
            key: "deepMerge",
            value: function value(e) {
              for (var n = function e(n, i) {
                if (void 0 === i) return e(null, n);
                if (Array.isArray(i)) return [].concat(T(i));
                if (!t.isPlainObject(i)) return i;
                if (!t.isPlainObject(n)) return w({}, i);
                var r = w({}, n);
                return m()(i).forEach(function (t) {
                  var o = i[t];
                  void 0 !== o && (r[t] = e(n[t], o));
                }), r;
              }, i = arguments.length, r = Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) {
                r[o - 1] = arguments[o];
              }

              return r.reduce(n, e);
            }
          }, {
            key: "deepDefaults",
            value: function value(e) {
              for (var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) {
                i[r - 1] = arguments[r];
              }

              var o = [].concat(i).reverse();
              return t.deepMerge.apply(t, T(o).concat([e]));
            }
          }, {
            key: "deepClone",
            value: function value(e) {
              var n = {};

              for (var i in e) {
                t.isExtendable(e[i]) ? n[i] = t.deepClone(e[i]) : n[i] = e[i];
              }

              return n;
            }
          }, {
            key: "getDeepProperty",
            value: function value(e, t) {
              return "string" == typeof t ? e[t] : Array.isArray(t) ? t.reduce(function (e, t) {
                return e ? "function" == typeof t ? function (e, t) {
                  var n = void 0;

                  try {
                    n = t(e);
                  } catch (e) {
                    if (!(e instanceof TypeError)) throw e;
                  }

                  return n;
                }(e, t) : e[t] : null;
              }, e) : void 0;
            }
          }, {
            key: "extend",
            value: function value(e) {
              var t = {};

              for (var n in e) {
                t[n] = e[n];
              }

              for (var i = arguments.length, r = Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) {
                r[o - 1] = arguments[o];
              }

              for (var a = 0; a < r.length; a++) {
                var s = r[a];

                for (var l in s) {
                  t[l] = s[l];
                }
              }

              return t;
            }
          }, {
            key: "clone",
            value: function value(e) {
              return this.extend({}, e);
            }
          }, {
            key: "createBlobURIFromDataURI",
            value: function value(t) {
              var n = "undefined" == typeof window ? e : window;
              if (!(n.Blob && n.URL && ArrayBuffer && Uint8Array)) return t;

              for (var i = v.a.decode(t.split(",")[1]), r = t.split(",")[0].split(":")[1].split(";")[0], o = new ArrayBuffer(i.length), a = new Uint8Array(o), s = 0; s < i.length; s++) {
                a[s] = i[s];
              }

              var l = new n.Blob([o], {
                type: r
              });
              return n.URL.createObjectURL(l);
            }
          }, {
            key: "getUUID",
            value: function value() {
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
                var t = 16 * Math.random() | 0;
                return ("x" === e ? t : 3 & t | 8).toString(16);
              });
            }
          }, {
            key: "createCanvas",
            value: function value() {
              return document.createElement("canvas");
            }
          }, {
            key: "convertHtmlImageToRGBACanvas",
            value: function value(e, n) {
              var i = n || t.createCanvas();
              i.width = e.width, i.height = e.height;
              var r = i.getContext("2d");
              return r.clearRect(0, 0, i.width, i.height), r.drawImage(e, 0, 0, e.width, e.height), i;
            }
          }, {
            key: "isPowerOfTwo",
            value: function value(e) {
              return 0 == (e.x & e.x - 1) && 0 == (e.y & e.y - 1);
            }
          }, {
            key: "nextLowestPOT",
            value: function value(e) {
              for (var t = 1; t < 32; t <<= 1) {
                e |= e >> t;
              }

              return e - (e >> 1);
            }
          }, {
            key: "nextHighestPOT",
            value: function value(e) {
              e--;

              for (var t = 1; t < 32; t <<= 1) {
                e |= e >> t;
              }

              return e + 1;
            }
          }, {
            key: "moveArrayItem",
            value: function value(e, t, n) {
              if (n >= e.length) for (var i = n - e.length; 1 + i--;) {
                e.push(void 0);
              }
              e.splice(n, 0, e.splice(t, 1)[0]);
            }
          }, {
            key: "ensureCanvasDimensions",
            value: function value(e, t) {
              return (e.width !== t.x || e.height !== t.y) && (e.width = t.x, e.height = t.y, !0);
            }
          }, {
            key: "byteArrayToString",
            value: function value(e) {
              return e.map(function (e) {
                return String.fromCharCode(e);
              }).join("");
            }
          }, {
            key: "clamp",
            value: function value(e, t, n) {
              return Math.max(t, Math.min(e, n));
            }
          }, {
            key: "wildCardMatch",
            value: function value(e, t) {
              return new RegExp("^" + t.split("*").join(".*") + "$").test(e);
            }
          }, {
            key: "flipObject",
            value: function value(e) {
              var t = {};

              for (var n in e) {
                t[e[n]] = n;
              }

              return t;
            }
          }, {
            key: "cloneOptions",
            value: function value(e) {
              var t = {};

              for (var n in e) {
                var i = e[n];
                Array.isArray(i) ? i = i.slice() : i.clone && (i = i.clone()), t[n] = i;
              }

              return t;
            }
          }, {
            key: "ISODateString",
            value: function value(e) {
              function t(e) {
                return e < 10 ? "0" + e : e;
              }

              return e.getUTCFullYear() + "-" + t(e.getUTCMonth() + 1) + "-" + t(e.getUTCDate()) + "T" + t(e.getUTCHours()) + ":" + t(e.getUTCMinutes()) + ":" + t(e.getUTCSeconds()) + "Z";
            }
          }, {
            key: "getCrossOriginValue",
            value: function value(e) {
              return e ? "none" !== e ? e : void 0 : "anonymous";
            }
          }, {
            key: "shallowEqual",
            value: function value(e, t) {
              if (e === t) return !0;
              if ("object" !== (void 0 === e ? "undefined" : x(e)) || null === e || "object" !== (void 0 === t ? "undefined" : x(t)) || null === t) return !1;
              var n = m()(e),
                  i = m()(t);
              if (n.length !== i.length) return !1;

              for (var r = hasOwnProperty.bind(t), o = 0; o < n.length; o++) {
                if (!r(n[o]) || e[n[o]] !== t[n[o]]) return !1;
              }

              return !0;
            }
          }, {
            key: "enableIf",
            value: function value(e, t) {
              return e ? t : void 0;
            }
          }, {
            key: "invariant",
            value: function value(e, t) {
              if (!e) throw new Error(t);
            }
          }, {
            key: "executePromises",
            value: function value(e) {
              var t = e.length,
                  n = 0,
                  i = [],
                  r = [];
              return new d.a(function (o, a) {
                var s = function s() {
                  ++n >= t && (r.length <= 0 ? o(i) : a(r));
                },
                    l = function l(e) {
                  i.push(e), s();
                },
                    u = function u(e) {
                  r.push(e), s();
                };

                e.forEach(function (e) {
                  e.then(l).catch(u);
                });
              });
            }
          }]), t;
        }();

        S.Array = b.a, t.a = S;
      }).call(t, n(64));
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return u;
      });
      var i = n(0),
          r = n.n(i),
          o = n(4),
          a = (n.n(o), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function s(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var l = o.Math.Rectangle,
          u = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          s(this, e), this.width = t, this.height = n;
        }

        return a(e, [{
          key: "set",
          value: function value(e, t) {
            this.width = e, this.height = t;
          }
        }, {
          key: "aspect",
          value: function value() {
            return this.width / this.height;
          }
        }, {
          key: "rectangle",
          value: function value(e, t) {
            return new l(e, t, this.width, this.height);
          }
        }, {
          key: "clone",
          value: function value() {
            return new e(this.width, this.height);
          }
        }, {
          key: "scale",
          value: function value(e, t) {
            return void 0 === t && (t = e), this.width *= e, this.height *= t, this;
          }
        }, {
          key: "copy",
          value: function value(e) {
            return this.width = e.width, this.height = e.height, this;
          }
        }, {
          key: "fitInWidthWithOther",
          value: function value(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new e();
            return this.copy(e.fitTwoInWidth(t, this, n)[0]), this;
          }
        }], [{
          key: "fitTwoInWidth",
          value: function value(t, n, i) {
            var r = n.width * i.height + n.height * i.width,
                o = i.height * t / r,
                a = n.width * o,
                s = n.height * o;
            return [new e(a, s), new e(t - a, s)];
          }
        }]), e;
      }();
    }, function (e, t, n) {
      var i = n(22),
          r = n(57);
      e.exports = n(19) ? function (e, t, n) {
        return i.f(e, t, r(1, n));
      } : function (e, t, n) {
        return e[t] = n, e;
      };
    }, function (e, t, n) {
      var i = n(97),
          r = n(98);

      e.exports = function (e) {
        return i(r(e));
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(241),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(246),
        __esModule: !0
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(0),
          r = n.n(i),
          o = n(86),
          a = n(40),
          s = n(65),
          l = n(67),
          u = n(91),
          c = n(32),
          p = n(70),
          f = n(66),
          h = n(24),
          d = n(46),
          g = n(156),
          m = n(302),
          y = n(313);
      n.d(t, "requestAnimationFrame", function () {
        return y.b;
      }), n.d(t, "cancelAnimationFrame", function () {
        return y.a;
      }), n.d(t, "Engine", function () {
        return o.a;
      }), n.d(t, "EventEmitter", function () {
        return l.a;
      }), n.d(t, "Events", function () {
        return u.a;
      }), n.d(t, "Utils", function () {
        return c.a;
      }), n.d(t, "Configurable", function () {
        return p.a;
      }), n.d(t, "Color", function () {
        return f.a;
      }), n.d(t, "Constants", function () {
        return a;
      }), n.d(t, "Log", function () {
        return h.a;
      }), n.d(t, "Promise", function () {
        return d.a;
      }), n.d(t, "GLUtils", function () {
        return g.a;
      }), n.d(t, "Base64", function () {
        return s.a;
      }), n.d(t, "LicenseChecker", function () {
        return m.b;
      }), n.d(t, "FreeLicenseChecker", function () {
        return m.a;
      });

      var _ = n(165);

      n.d(t, "Vector2", function () {
        return _.Vector2;
      }), n.d(t, "Vector3", function () {
        return _.Vector3;
      }), n.d(t, "Range", function () {
        return _.Range;
      }), n.d(t, "Rectangle", function () {
        return _.Rectangle;
      }), n.d(t, "Matrix", function () {
        return _.Matrix;
      }), n.d(t, "ColorMatrix", function () {
        return _.ColorMatrix;
      }), n.d(t, "CubicBezierCurve", function () {
        return _.CubicBezierCurve;
      }), void 0 === Function.prototype.name && void 0 !== r.a && Object.defineProperty(Function.prototype, "name", {
        get: function get() {
          var e = /function\s([^(]{1,})\(/.exec(this.toString());
          return e && e.length > 1 ? e[1].trim() : "";
        },
        set: function set(e) {}
      });
    }, function (e, t, n) {
      e.exports = {
        default: n(267),
        __esModule: !0
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), n.d(t, "RenderType", function () {
        return i;
      }), n.d(t, "ImageFormat", function () {
        return r;
      }), n.d(t, "OptionType", function () {
        return o;
      }), n.d(t, "UniformType", function () {
        return a;
      }), n.d(t, "RendererType", function () {
        return s;
      });
      var i = {
        IMAGE: "image",
        DATAURL: "data-url",
        BUFFER: "buffer",
        BLOB: "blob",
        MSBLOB: "ms-blob"
      },
          r = {
        PNG: "image/png",
        JPEG: "image/jpeg",
        RAW: "raw"
      },
          o = {
        NUMBER: "number",
        VECTOR2: "vector2",
        COLOR_MATRIX: "color-matrix",
        COLOR: "color",
        ARRAY: "array",
        OBJECT: "object",
        STRING: "string",
        BOOLEAN: "boolean",
        CONFIGURABLE: "configurable",
        IMAGE: "image",
        FUNCTION: "function",
        TEXTURE: "texture",
        ALL: "*"
      },
          a = {
        SAMPLER2D: "sampler2d",
        INT: "i",
        INT1: "1i",
        INT2: "2i",
        INT3: "3i",
        INT4: "4i",
        FLOAT: "f",
        FLOAT1: "1f",
        FLOAT2: "2f",
        FLOAT_VECTOR2: "2fv",
        FLOAT3: "3f",
        FLOAT4: "4f",
        MAT3: "mat3",
        MAT3FV: "mat3fv",
        MAT4: "mat4"
      },
          s = {
        WEBGL: "webgl",
        CANVAS: "canvas"
      };
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(9),
          l = n(490),
          u = n(24),
          c = n(199),
          p = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          h = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._ui = t, this._options = n, this._fonts = [], this._variationsByIdentifier = {}, this._fontsByFontFamily = {}, this._initFonts();
        }

        return f(e, [{
          key: "_initFonts",
          value: function value() {
            var e,
                t = this,
                n = this._options,
                i = n.fonts,
                r = n.replaceFonts,
                o = n.availableVariations;
            e = this._ui.getEditor().getSDK()._l.areCustomAssetsAllowed();
            var a = s.c.DEFAULTS.FONTS;
            e && (a = r ? i : a.concat(i || []));
            var p = void 0;
            a = a.map(function (n) {
              var i = n.fontFamily,
                  r = n.variations;
              if (e && o && (r = r.filter(function (e) {
                return -1 !== o.indexOf(e.identifier);
              })), 0 === r.length) return null;
              var a = new l.a({
                fontFamily: i
              });
              return r = r.map(function (e) {
                var n = new c.a(e);
                return n.setFontFamily(i), n.setFont(a), e.default && !p && (p = n), null == n.getTextMetrics() && u.a.warn("Missing font metrics for " + n.getIdentifier() + ". The SDK will fall back to basic font rendering, which may lead to layout issues. Please provide font metrics for your custom fonts. See https://docs.photoeditorsdk.com/guides/html5/ for more details."), t._variationsByIdentifier[n.getIdentifier()] = n, n;
              }), a.setVariations(r), t._fontsByFontFamily[i] = a, a;
            }).filter(function (e) {
              return e;
            }), p || (p = a[0].getVariations()[0]), this._defaultVariation = p, this._fonts = a;
          }
        }, {
          key: "getFonts",
          value: function value() {
            return this._fonts;
          }
        }, {
          key: "getFontByFontFamily",
          value: function value(e) {
            return this._fontsByFontFamily[e];
          }
        }, {
          key: "getVariationByIdentifier",
          value: function value(e) {
            return this._variationsByIdentifier[e];
          }
        }, {
          key: "getVariationsByIdentifier",
          value: function value() {
            return p({}, this._variationsByIdentifier);
          }
        }, {
          key: "getDefaultVariation",
          value: function value() {
            return this._defaultVariation;
          }
        }]), e;
      }();

      t.a = h;
    }, function (e, t) {
      e.exports = function (e) {
        try {
          return !!e();
        } catch (e) {
          return !0;
        }
      };
    }, function (e, t) {
      var n = {}.hasOwnProperty;

      e.exports = function (e, t) {
        return n.call(e, t);
      };
    }, function (e, t, n) {
      var i = n(98);

      e.exports = function (e) {
        return Object(i(e));
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.x = t, this.y = n, void 0 === this.x && (this.x = 0), void 0 === this.y && (this.y = 0);
        }

        return o(e, [{
          key: "set",
          value: function value(e, t) {
            return this.x = e, this.y = t, this;
          }
        }, {
          key: "clone",
          value: function value() {
            return new e(this.x, this.y);
          }
        }, {
          key: "copy",
          value: function value(e) {
            return this.x = e.x, this.y = e.y, this;
          }
        }, {
          key: "clamp",
          value: function value(t, n) {
            var i = null != t,
                r = null != n;
            return t instanceof e || !i || (t = new e(t, t)), n instanceof e || !r || (n = new e(n, n)), i && (this.x = Math.max(t.x, this.x), this.y = Math.max(t.y, this.y)), r && (this.x = Math.min(n.x, this.x), this.y = Math.min(n.y, this.y)), this;
          }
        }, {
          key: "divide",
          value: function value(t, n) {
            return t instanceof e ? (this.x /= t.x, this.y /= t.y) : (this.x /= t, this.y /= void 0 === n ? t : n), this;
          }
        }, {
          key: "subtract",
          value: function value(t, n) {
            return t instanceof e ? (this.x -= t.x, this.y -= t.y) : (this.x -= t, this.y -= void 0 === n ? t : n), this;
          }
        }, {
          key: "multiply",
          value: function value(t, n) {
            return t instanceof e ? (this.x *= t.x, this.y *= t.y) : (this.x *= t, this.y *= void 0 === n ? t : n), this;
          }
        }, {
          key: "add",
          value: function value(t, n) {
            return t instanceof e ? (this.x += t.x, this.y += t.y) : (this.x += t, this.y += void 0 === n ? t : n), this;
          }
        }, {
          key: "dot",
          value: function value(t, n) {
            return t instanceof e ? this.x * t.x + this.y * t.y : this.x * t + this.y * (void 0 === n ? t : n);
          }
        }, {
          key: "equals",
          value: function value(t, n) {
            return t instanceof e ? t.x === this.x && t.y === this.y : t === this.x && n === this.y;
          }
        }, {
          key: "flip",
          value: function value() {
            var e = this.x;
            return this.x = this.y, this.y = e, this;
          }
        }, {
          key: "round",
          value: function value() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
          }
        }, {
          key: "ceil",
          value: function value() {
            return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
          }
        }, {
          key: "floor",
          value: function value() {
            return this.x = 0 | this.x, this.y = 0 | this.y, this;
          }
        }, {
          key: "abs",
          value: function value() {
            return this.x = Math.abs(this.x), this.y = Math.abs(this.y), this;
          }
        }, {
          key: "len",
          value: function value() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
          }
        }, {
          key: "min",
          value: function value() {
            return Math.min(this.x, this.y);
          }
        }, {
          key: "max",
          value: function value() {
            return Math.max(this.x, this.y);
          }
        }, {
          key: "toObject",
          value: function value() {
            return {
              x: this.x,
              y: this.y
            };
          }
        }, {
          key: "toString",
          value: function value() {
            return "Vector2({ x: " + this.x + ", y: " + this.y + " })";
          }
        }, {
          key: "roundDecimal",
          value: function value(e) {
            return this.x = parseFloat(this.x.toFixed(e)), this.y = parseFloat(this.y.toFixed(e)), this;
          }
        }, {
          key: "asArray",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return e ? [this.y, this.x] : [this.x, this.y];
          }
        }], [{
          key: "fromObject",
          value: function value(t) {
            return new e(t.x, t.y);
          }
        }, {
          key: "NULL",
          get: function get() {
            return new e(0, 0);
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      (function (e) {
        var i = n(36),
            r = n.n(i),
            o = n(37),
            a = n.n(o),
            s = n(10),
            l = n.n(s),
            u = n(0),
            c = n.n(u),
            p = n(289),
            f = n.n(p),
            h = "function" == typeof a.a && "symbol" == typeof r.a ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof a.a && e.constructor === a.a && e !== a.a.prototype ? "symbol" : typeof e;
        },
            d = void 0 === e ? window : e,
            g = void 0 !== l.a ? l.a : function () {
          var e,
              t,
              n,
              i = Object.prototype.toString,
              r = void 0 !== f.a ? function (e) {
            return f()(e);
          } : setTimeout;

          try {
            Object.defineProperty({}, "x", {}), e = function e(_e2, t, n, i) {
              return c()(_e2, t, {
                value: n,
                writable: !0,
                configurable: !1 !== i
              });
            };
          } catch (t) {
            e = function e(_e3, t, n) {
              return _e3[t] = n, _e3;
            };
          }

          function o(e, i) {
            n.add(e, i), t || (t = r(n.drain));
          }

          function a(e) {
            var t,
                n = void 0 === e ? "undefined" : h(e);
            return null == e || "object" != n && "function" != n || (t = e.then), "function" == typeof t && t;
          }

          function s() {
            for (var e = 0; e < this.chain.length; e++) {
              l(this, 1 === this.state ? this.chain[e].success : this.chain[e].failure, this.chain[e]);
            }

            this.chain.length = 0;
          }

          function l(e, t, n) {
            var i, r;

            try {
              !1 === t ? n.reject(e.msg) : (i = !0 === t ? e.msg : t.call(void 0, e.msg)) === n.promise ? n.reject(TypeError("Promise-chain cycle")) : (r = a(i)) ? r.call(i, n.resolve, n.reject) : n.resolve(i);
            } catch (e) {
              n.reject(e);
            }
          }

          function u(e) {
            var t,
                n = this;

            if (!n.triggered) {
              n.triggered = !0, n.def && (n = n.def);

              try {
                (t = a(e)) ? o(function () {
                  var i = new g(n);

                  try {
                    t.call(e, function () {
                      u.apply(i, arguments);
                    }, function () {
                      p.apply(i, arguments);
                    });
                  } catch (e) {
                    p.call(i, e);
                  }
                }) : (n.msg = e, n.state = 1, n.chain.length > 0 && o(s, n));
              } catch (e) {
                p.call(new g(n), e);
              }
            }
          }

          function p(e) {
            var t = this;
            t.triggered || (t.triggered = !0, t.def && (t = t.def), t.msg = e, t.state = 2, t.chain.length > 0 && o(s, t));
          }

          function d(e, t, n, i) {
            for (var r = 0; r < t.length; r++) {
              !function (r) {
                e.resolve(t[r]).then(function (e) {
                  n(r, e);
                }, i);
              }(r);
            }
          }

          function g(e) {
            this.def = e, this.triggered = !1;
          }

          function m(e) {
            this.promise = e, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
          }

          function y(e) {
            if ("function" != typeof e) throw TypeError("Not a function");
            if (0 !== this.__NPO__) throw TypeError("Not a promise");
            this.__NPO__ = 1;
            var t = new m(this);
            this.then = function (e, n) {
              var i = {
                success: "function" != typeof e || e,
                failure: "function" == typeof n && n
              };
              return i.promise = new this.constructor(function (e, t) {
                if ("function" != typeof e || "function" != typeof t) throw TypeError("Not a function");
                i.resolve = e, i.reject = t;
              }), t.chain.push(i), 0 !== t.state && o(s, t), i.promise;
            }, this.catch = function (e) {
              return this.then(void 0, e);
            };

            try {
              e.call(void 0, function (e) {
                u.call(t, e);
              }, function (e) {
                p.call(t, e);
              });
            } catch (e) {
              p.call(t, e);
            }
          }

          n = function () {
            var e, n, i;

            function r(e, t) {
              this.fn = e, this.self = t, this.next = void 0;
            }

            return {
              add: function add(t, o) {
                i = new r(t, o), n ? n.next = i : e = i, n = i, i = void 0;
              },
              drain: function drain() {
                var i = e;

                for (e = n = t = void 0; i;) {
                  i.fn.call(i.self), i = i.next;
                }
              }
            };
          }();

          var _ = e({}, "constructor", y, !1);

          return y.prototype = _, e(_, "__NPO__", 0, !1), e(y, "resolve", function (e) {
            return e && "object" == (void 0 === e ? "undefined" : h(e)) && 1 === e.__NPO__ ? e : new this(function (t, n) {
              if ("function" != typeof t || "function" != typeof n) throw TypeError("Not a function");
              t(e);
            });
          }), e(y, "reject", function (e) {
            return new this(function (t, n) {
              if ("function" != typeof t || "function" != typeof n) throw TypeError("Not a function");
              n(e);
            });
          }), e(y, "all", function (e) {
            var t = this;
            return "[object Array]" != i.call(e) ? t.reject(TypeError("Not an array")) : 0 === e.length ? t.resolve([]) : new t(function (n, i) {
              if ("function" != typeof n || "function" != typeof i) throw TypeError("Not a function");
              var r = e.length,
                  o = Array(r),
                  a = 0;
              d(t, e, function (e, t) {
                o[e] = t, ++a === r && n(o);
              }, i);
            });
          }), e(y, "race", function (e) {
            var t = this;
            return "[object Array]" != i.call(e) ? t.reject(TypeError("Not an array")) : new t(function (n, i) {
              if ("function" != typeof n || "function" != typeof i) throw TypeError("Not a function");
              d(t, e, function (e, t) {
                n(t);
              }, i);
            });
          }), y;
        }();
        d.Promise = d.Promise || g, t.a = g;
      }).call(t, n(64));
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return c;
      });
      var i = n(15),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(4),
          l = (n.n(s), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function u(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return r()(e);
      }

      var c = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.words = [], t && this.splitIntoWords(t);
        }

        return l(e, [{
          key: "splitIntoWords",
          value: function value(e) {
            return this.words = e.match(/\S+/g) || [], [].concat(u(this.words));
          }
        }, {
          key: "get",
          value: function value() {
            return [].concat(u(this.words));
          }
        }, {
          key: "getWord",
          value: function value(e) {
            return this.words[e];
          }
        }, {
          key: "set",
          value: function value(e) {
            return this.words = [].concat(u(e)), this;
          }
        }, {
          key: "slice",
          value: function value(t, n) {
            return e.fromWords(this.words.slice(t, n));
          }
        }, {
          key: "getLowerCase",
          value: function value() {
            return this.words.map(function (e) {
              return e.toLowerCase();
            });
          }
        }, {
          key: "getUpperCase",
          value: function value() {
            return this.words.map(function (e) {
              return e.toUpperCase();
            });
          }
        }, {
          key: "size",
          value: function value() {
            return this.words.length;
          }
        }, {
          key: "countNumberOfCharacters",
          value: function value() {
            return this.words.reduce(function (e, t) {
              return e + t.length;
            }, 0);
          }
        }, {
          key: "joined",
          value: function value(e) {
            var t = this,
                n = this.size(),
                i = Math.floor(n / e),
                r = n % e,
                o = 0,
                a = 0;
            return s.Utils.Array.range(0, e).map(function (e) {
              o = a;
              var l = i + (e < r ? 1 : 0);
              return a = Math.min(o + l, n), s.Utils.Array.range(o, a).reduce(function (e, n) {
                return e + (n === o ? "" : " ") + t.words[n];
              }, "");
            });
          }
        }], [{
          key: "fromWords",
          value: function value(t) {
            var n = new e();
            return n.words = [].concat(u(t)), n;
          }
        }]), e;
      }();
    }, function (e, t, n) {
      n.d(t, "d", function () {
        return f;
      }), n.d(t, "c", function () {
        return h;
      }), n.d(t, "f", function () {
        return d;
      }), n.d(t, "e", function () {
        return g;
      }), n.d(t, "b", function () {
        return y;
      }), n.d(t, "a", function () {
        return _;
      });

      var i = n(29),
          r = n.n(i),
          o = n(25),
          a = n.n(o),
          s = n(4),
          l = (n.n(s), function (e, t) {
        if (Array.isArray(e)) return e;
        if (r()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var s, l = a()(e); !(i = (s = l.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && l.return && l.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }),
          u = s.Math.Rectangle,
          c = s.Math.Vector2,
          p = function p(e, t, n, i) {
        e.drawImage(t, n.x, n.y, n.width, n.height, i.x, i.y, i.width, i.height);
      },
          f = function f(e, t, n) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "source-over",
            r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        e.save(), e.fillStyle = n.toRGBA(), e.globalCompositeOperation = i, e.fillRect(t.x, t.y, t.width, t.height), r && (e.strokeStyle = n.toRGBA(), e.strokeWith = 1, e.strokeRect(t.x, t.y, t.width, t.height)), e.restore();
      },
          h = function h(e, t, n, i) {
        var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "source-over",
            o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
        e.save(), e.fillStyle = i.toRGBA(), e.globalCompositeOperation = r, n = Math.min(Math.max(n, 0), .5 * Math.min(t.height, t.width));
        var a = t.x,
            s = t.x + t.width,
            l = t.y,
            u = t.y + t.height;
        e.beginPath(), e.moveTo(a + n, l), e.arcTo(s, l, s, u, n), e.arcTo(s, u, a, u, n), e.arcTo(a, u, a, l, n), e.arcTo(a, l, s, l, n), e.closePath(), e.fill(), o && e.stroke(), e.restore();
      },
          d = function d(e, t, n) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 4;
        e.save(), e.strokeStyle = n.toRGBA(), e.lineWidth = i, e.strokeRect(t.x, t.y, t.width, t.height), e.restore();
      },
          g = function g(e, t, n) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "source-over";
        e.save();
        var r = t.height / 2,
            o = t.y + r,
            a = t.x + r,
            s = t.x + t.width;

        for (e.fillStyle = n.toRGBA(), e.globalCompositeOperation = i; a < s;) {
          e.beginPath(), e.arc(a, o, r, 0, 2 * Math.PI), e.fill(), a += 4 * r;
        }

        e.restore();
      },
          m = function m(e, t) {
        var n = t.applyToRectangle(e),
            i = e.x,
            r = e.y,
            o = e.width,
            a = e.height;
        return {
          corners: [u.FromDiagonalPoints(new c(0, 0), new c(n.x, n.y)), u.FromDiagonalPoints(new c(0, n.y + n.height), new c(n.x, a)), u.FromDiagonalPoints(new c(n.x + n.width, n.y + n.height), new c(o, a)), u.FromDiagonalPoints(new c(n.x + n.width, 0), new c(o, n.y))].map(function (e) {
            return e.translate(i, r);
          }),
          bars: [u.FromDiagonalPoints(new c(n.x, 0), new c(n.x + n.width, n.y)), u.FromDiagonalPoints(new c(0, n.y), new c(n.x, n.y + n.height)), u.FromDiagonalPoints(new c(n.x, n.y + n.height), new c(n.x + n.width, a)), u.FromDiagonalPoints(new c(n.x + n.width, n.y), new c(o, n.y + n.height))].map(function (e) {
            return e.translate(i, r);
          }),
          center: n
        };
      },
          y = function y(e, t, n, i) {
        var r = t.naturalWidth || t.width,
            o = t.naturalHeight || t.height,
            a = m(new u(0, 0, r, o), i),
            c = m(n, i);
        p(e, t, a.center, c.center), s.Utils.Array.zip(a.corners, c.corners).forEach(function (n) {
          var i = l(n, 2),
              r = i[0],
              o = i[1];
          return p(e, t, r, o);
        }), s.Utils.Array.zip(a.bars, c.bars).forEach(function (n) {
          var i = l(n, 2),
              r = i[0],
              o = i[1];
          return p(e, t, r, o);
        });
      },
          _ = function _(e, t, n, i) {
        var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "source-atop";

        if (e.save(), i && (e.globalAlpha = i.a), e.drawImage(t, n.x, n.y, n.width, n.height), i && (e.globalAlpha = 1), i) {
          var o = i.clone();
          o.a = 1, f(e, n, o, r);
        }

        e.restore();
      };
    }, function (e, t, n) {
      var i = n(137),
          r = n(102);

      e.exports = Object.keys || function (e) {
        return i(e, r);
      };
    }, function (e, t, n) {
      var i = n(242)(!0);
      n(104)(String, "String", function (e) {
        this._t = String(e), this._i = 0;
      }, function () {
        var e,
            t = this._t,
            n = this._i;
        return n >= t.length ? {
          value: void 0,
          done: !0
        } : (e = i(t, n), this._i += e.length, {
          value: e,
          done: !1
        });
      });
    }, function (e, t) {
      e.exports = {};
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return f;
      });
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(4);

      function c(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function p(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      n.n(u);

      var f = function (e) {
        function t() {
          return c(this, t), p(this, (t.__proto__ || l()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.Configurable);

      f.prototype.availableOptions = {
        text: {
          type: u.OptionType.STRING,
          default: ""
        },
        frame: {
          type: u.OptionType.OBJECT,
          default: null
        },
        font: {
          type: u.OptionType.OBJECT,
          default: null
        }
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return E;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(77)),
          y = n(47),
          _ = n(81),
          v = n(127),
          b = n(27),
          w = n(20),
          x = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          k = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          T = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function S(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function C(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var E = function (e) {
        function t() {
          var e;
          S(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = C(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          return o._rowType = _.a.Box, o._alignmentRandomizer = new w.a(0), o._isMaskedRandomizer = new w.a(0), o._seedPool.push(o._alignmentRandomizer), o._seedPool.push(o._isMaskedRandomizer), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), k(t, [{
          key: "getImagePaths",
          value: function value() {
            return [_.a.Box.getImagePath()];
          }
        }, {
          key: "_modifiedText",
          value: function value(e) {
            return T(t.prototype.__proto__ || d()(t.prototype), "_modifiedText", this).call(this, e).toLowerCase();
          }
        }, {
          key: "_modifiedLines",
          value: function value(e) {
            var t = new y.a();
            return t.set([e.reduce(function (e, t) {
              return e + ("" === e ? "" : "\n") + t.joined(1)[0];
            }, "")]), [t];
          }
        }, {
          key: "_layoutRows",
          value: function value(e, n) {
            var i = T(t.prototype.__proto__ || d()(t.prototype), "_layoutRows", this).call(this, e, n),
                r = i[0];

            if (r && this.getSquareLayout()) {
              var o = r.getSize();
              o.height = o.width;
            }

            return i;
          }
        }, {
          key: "getAlignment",
          value: function value() {
            return this._alignmentRandomizer.pickNext(this.constructor.ValidAlignments || t.ValidAlignments);
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, t, n, i) {
            var r = this.getAlignment(),
                o = this._rowType,
                a = b.a.getImage(o.getImagePath());
            i.setAlignment(r);
            var s = new v.a({
              words: e,
              width: n,
              attributes: i,
              image: a,
              imageInsets: o.insetsForWidth(n),
              capInsets: o.getCapInsets(),
              backgroundColor: g.Color.WHITE,
              centerOffset: 0,
              textScaleFactor: .7,
              isMasked: this._isMaskedRandomizer.nextBool()
            });
            this._rowType === _.a.Box && (s.serverImageSmoothingFix = !0);
            var l = s.getSize();
            return this.getSquareLayout() ? l.height = l.width : l.height = Math.max(l.height, l.width * o.getMinimumHeightRatio()), s;
          }
        }]), t;
      }(m.a);

      E.defaultFontIdentifiers = ["imgly_font_galano_grotesque_bold"], E.Alignment = {
        Left: "left",
        Center: "center",
        Right: "right"
      }, E.ValidAlignments = [E.Alignment.Left, E.Alignment.Center, E.Alignment.Right], E.identifier = "imgly_text_design_masked", E.prototype.availableOptions = x({}, m.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: E.defaultFontIdentifiers
        },
        squareLayout: {
          type: g.OptionType.BOOLEAN,
          default: !0
        }
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }

        return o(e, null, [{
          key: "getSizeOfLogicalShape",
          value: function value(e) {
            for (var t = e[0], n = 1; n < e.length; n++) {
              t *= e[n];
            }

            return t;
          }
        }, {
          key: "getTextureDimensionsForLogicalShape",
          value: function value(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2048,
                i = e.getSizeOfLogicalShape(t);
            if (t.length <= 1 && i <= n) return [i, 1];
            if (2 === t.length && t[0] <= n && t[1] <= n) return t;
            if (3 === t.length && t[0] * t[1] <= n && t[2] <= n) return [t[0] * t[1], t[2]];
            if (3 === t.length && t[0] <= n && t[1] * t[2] <= n) return [t[0], t[1] * t[2]];
            if (4 === t.length && t[0] * t[1] * t[2] <= n && t[3] <= n) return [t[0] * t[1] * t[2], t[3]];
            if (4 === t.length && t[0] <= n && t[1] * t[2] * t[3] <= n) return [t[0], t[1] * t[2] * t[3]];

            for (var r = Math.floor(Math.sqrt(i)); r > 1; --r) {
              if (i % r == 0) return [r, i / r];
            }

            return [1, i];
          }
        }, {
          key: "isSameShape",
          value: function value(e, t) {
            if (e.length !== t.length) return !1;

            for (var n = 0; n < e.length; n++) {
              if (e[n] !== t[n]) return !1;
            }

            return !0;
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      var i = n(15),
          r = n.n(i),
          o = n(6),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(506),
          c = n.n(u),
          p = n(39),
          f = n.n(p),
          h = n(9),
          d = a.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return r()(e);
      }

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var _ = function () {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          y(this, e), this._ui = t, this._options = n, this._defaultLayouts = h.j.Operations.SpriteOperation.TextDesignSprite.Layouts, this._legacyLayouts = h.j.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts, this._layouts = [], this._init();
        }

        return g(e, [{
          key: "_init",
          value: function value() {
            var e = this._options.availableLayouts,
                t = d({}, this._defaultLayouts, this._legacyLayouts);
            this._layouts = f()(t).map(function (e) {
              return {
                identifier: t[e].identifier,
                layout: t[e]
              };
            }), e && (e.push.apply(e, m(c()(this._legacyLayouts).map(function (e) {
              return e.identifier;
            }))), this._layouts = this._layouts.filter(function (t) {
              return e.indexOf(t.identifier) >= 0;
            }));
          }
        }, {
          key: "getLayoutByIdentifier",
          value: function value(e) {
            var t = h.k.Array.find(this._layouts, function (t) {
              return t.identifier === e;
            });
            return t && t.layout;
          }
        }, {
          key: "getLayouts",
          value: function value() {
            return [].concat(m(this._layouts));
          }
        }, {
          key: "getDefaultLayout",
          value: function value() {
            return this.getLayouts()[0];
          }
        }]), e;
      }();

      t.a = _;
    }, function (e, t) {
      e.exports = function (e) {
        if ("function" != typeof e) throw TypeError(e + " is not a function!");
        return e;
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        return {
          enumerable: !(1 & e),
          configurable: !(2 & e),
          writable: !(4 & e),
          value: t
        };
      };
    }, function (e, t) {
      t.f = {}.propertyIsEnumerable;
    }, function (e, t) {
      var n = {}.toString;

      e.exports = function (e) {
        return n.call(e).slice(8, -1);
      };
    }, function (e, t) {
      e.exports = !0;
    }, function (e, t, n) {
      var i = n(22).f,
          r = n(43),
          o = n(17)("toStringTag");

      e.exports = function (e, t, n) {
        e && !r(e = n ? e : e.prototype, o) && i(e, o, {
          configurable: !0,
          value: t
        });
      };
    }, function (e, t, n) {
      n(244);

      for (var i = n(16), r = n(34), o = n(51), a = n(17)("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), l = 0; l < s.length; l++) {
        var u = s[l],
            c = i[u],
            p = c && c.prototype;
        p && !p[a] && r(p, a, u), o[u] = o.Array;
      }
    }, function (e, t, n) {
      var i = n(30),
          r = n(145),
          o = n(146),
          a = n(28),
          s = n(83),
          l = n(111),
          u = {},
          c = {};
      (t = e.exports = function (e, t, n, p, f) {
        var h,
            d,
            g,
            m,
            y = f ? function () {
          return e;
        } : l(e),
            _ = i(n, p, t ? 2 : 1),
            v = 0;

        if ("function" != typeof y) throw TypeError(e + " is not iterable!");

        if (o(y)) {
          for (h = s(e.length); h > v; v++) {
            if ((m = t ? _(a(d = e[v])[0], d[1]) : _(e[v])) === u || m === c) return m;
          }
        } else for (g = y.call(e); !(d = g.next()).done;) {
          if ((m = r(g, _, d.value, t)) === u || m === c) return m;
        }
      }).BREAK = u, t.RETURN = c;
    }, function (e, t) {
      var n;

      n = function () {
        return this;
      }();

      try {
        n = n || Function("return this")() || (0, eval)("this");
      } catch (e) {
        "object" == typeof window && (n = window);
      }

      e.exports = n;
    }, function (e, t, n) {
      /*
       * Extracted from MinifyJpeg (Copyright (c) 2014 Hiroaki Matoba, MIT License):
       * https://github.com/hMatoba/MinifyJpeg
       * @license
       */
      var i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          r = {
        encode: function encode(e) {
          var t = "",
              n = void 0,
              r = void 0,
              o = void 0,
              a = void 0,
              s = void 0,
              l = void 0,
              u = void 0,
              c = 0;

          do {
            a = (n = e[c++]) >> 2, s = (3 & n) << 4 | (r = e[c++]) >> 4, l = (15 & r) << 2 | (o = e[c++]) >> 6, u = 63 & o, isNaN(r) ? l = u = 64 : isNaN(o) && (u = 64), t = t + i.charAt(a) + i.charAt(s) + i.charAt(l) + i.charAt(u), n = r = o = "", a = s = l = u = "";
          } while (c < e.length);

          return t;
        },
        decode: function decode(e) {
          var t = void 0,
              n = void 0,
              r = void 0,
              o = void 0,
              a = void 0,
              s = void 0,
              l = 0,
              u = [];
          if (/[^A-Za-z0-9+/=]/g.exec(e)) throw new Error("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding.");
          e = e.replace(/[^A-Za-z0-9+/=]/g, "");

          do {
            t = i.indexOf(e.charAt(l++)) << 2 | (o = i.indexOf(e.charAt(l++))) >> 4, n = (15 & o) << 4 | (a = i.indexOf(e.charAt(l++))) >> 2, r = (3 & a) << 6 | (s = i.indexOf(e.charAt(l++))), u.push(t), 64 !== a && u.push(n), 64 !== s && u.push(r), t = n = r = "", o = a = s = "";
          } while (l < e.length);

          return u;
        }
      };
      t.a = r;
    }, function (e, t, n) {
      var i = n(29),
          r = n.n(i),
          o = n(25),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = function u(e, t) {
        if (Array.isArray(e)) return e;
        if (r()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var s, l = a()(e); !(i = (s = l.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && l.return && l.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          c = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var f = function () {
        function e(t, n, i) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
          p(this, e), this.r = t, this.g = n, this.b = i, this.a = r;
        }

        return c(e, [{
          key: "toRGBA",
          value: function value() {
            return "rgba(" + [Math.round(255 * this.r), Math.round(255 * this.g), Math.round(255 * this.b), this.a.toFixed(2)].join(",") + ")";
          }
        }, {
          key: "set",
          value: function value(e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.a;
            return this.r = e, this.g = t, this.b = n, this.a = i, this;
          }
        }, {
          key: "toRGB",
          value: function value() {
            return [Math.round(255 * this.r), Math.round(255 * this.g), Math.round(255 * this.b)];
          }
        }, {
          key: "toHex",
          value: function value() {
            return "#" + [this._componentToHex(Math.round(255 * this.r)), this._componentToHex(Math.round(255 * this.g)), this._componentToHex(Math.round(255 * this.b))].join("");
          }
        }, {
          key: "toGLColor",
          value: function value() {
            return [this.r, this.g, this.b, this.a];
          }
        }, {
          key: "toArray",
          value: function value() {
            return this.toGLColor();
          }
        }, {
          key: "toRGBGLColor",
          value: function value() {
            return [this.r, this.g, this.b];
          }
        }, {
          key: "toHSV",
          value: function value() {
            var e,
                t = Math.max(this.r, this.g, this.b),
                n = Math.min(this.r, this.g, this.b),
                i = void 0,
                r = t,
                o = t - n;
            if (e = 0 === t ? 0 : o / t, t === n) i = 0;else {
              switch (t) {
                case this.r:
                  i = (this.g - this.b) / o, this.g < this.b && (i += 6);
                  break;

                case this.g:
                  i = (this.b - this.r) / o + 2;
                  break;

                case this.b:
                  i = (this.r - this.g) / o + 4;
              }

              i /= 6;
            }
            return [i, e, r];
          }
        }, {
          key: "fromHSV",
          value: function value(t, n, i) {
            return this.copy(e.fromHSV(t, n, i)), this;
          }
        }, {
          key: "clone",
          value: function value() {
            return new e(this.r, this.g, this.b, this.a);
          }
        }, {
          key: "add",
          value: function value(e) {
            return this.r += e.r, this.g += e.g, this.b += e.b, this.a += e.a, this;
          }
        }, {
          key: "minus",
          value: function value(e) {
            return this.r -= e.r, this.g -= e.g, this.b -= e.b, this.a -= e.a, this;
          }
        }, {
          key: "multiplyScalar",
          value: function value(e) {
            return this.r *= e, this.g *= e, this.b *= e, this.a *= e, this;
          }
        }, {
          key: "divideScalar",
          value: function value(e) {
            return this.r /= e, this.g /= e, this.b /= e, this.a /= e, this;
          }
        }, {
          key: "clamp",
          value: function value(e, t) {
            return this.r = Math.min(Math.max(this.r, e), t), this.g = Math.min(Math.max(this.g, e), t), this.b = Math.min(Math.max(this.b, e), t), this.a = Math.min(Math.max(this.a, e), t), this;
          }
        }, {
          key: "mix",
          value: function value(e, t) {
            return this.r = (1 - t) * this.r + t * e.r, this.g = (1 - t) * this.g + t * e.g, this.b = (1 - t) * this.b + t * e.b, this.a = (1 - t) * this.a + t * e.a, this;
          }
        }, {
          key: "copy",
          value: function value(e) {
            return this.r = e.r, this.g = e.g, this.b = e.b, this.a = e.a, this;
          }
        }, {
          key: "equals",
          value: function value(e) {
            return this.r === e.r && this.g === e.g && this.b === e.b && this.a === e.a;
          }
        }, {
          key: "_componentToHex",
          value: function value(e) {
            var t = e.toString(16);
            return 1 === t.length ? "0" + t : t;
          }
        }, {
          key: "toString",
          value: function value() {
            return "Color(" + this.r + ", " + this.g + ", " + this.b + ", " + this.a + ")";
          }
        }], [{
          key: "fromHSV",
          value: function value(t, n, i) {
            var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
                o = [],
                a = o[0],
                s = o[1],
                l = o[2],
                u = Math.floor(6 * t),
                c = 6 * t - u,
                p = i * (1 - n),
                f = i * (1 - c * n),
                h = i * (1 - (1 - c) * n);

            switch (u % 6) {
              case 0:
                a = i, s = h, l = p;
                break;

              case 1:
                a = f, s = i, l = p;
                break;

              case 2:
                a = p, s = i, l = h;
                break;

              case 3:
                a = p, s = f, l = i;
                break;

              case 4:
                a = h, s = p, l = i;
                break;

              case 5:
                a = i, s = p, l = f;
            }

            return new e(a, s, l, r);
          }
        }, {
          key: "fromArray",
          value: function value(t) {
            return new e(t[0], t[1], t[2], t[3]);
          }
        }, {
          key: "fromHex",
          value: function value(t) {
            var n = t.match(/[0-9A-fa-f]{1,2}/g),
                i = u(n, 3),
                r = i[0],
                o = i[1],
                a = i[2];
            return new e(parseInt(r, 16) / 255, parseInt(o, 16) / 255, parseInt(a, 16) / 255, 1);
          }
        }, {
          key: "TRANSPARENT",
          get: function get() {
            return new e(0, 0, 0, 0);
          }
        }, {
          key: "WHITE",
          get: function get() {
            return new e(1, 1, 1, 1);
          }
        }, {
          key: "BLACK",
          get: function get() {
            return new e(0, 0, 0, 1);
          }
        }, {
          key: "RED",
          get: function get() {
            return new e(1, 0, 0, 1);
          }
        }, {
          key: "BLUE",
          get: function get() {
            return new e(0, 0, 1, 1);
          }
        }, {
          key: "GREEN",
          get: function get() {
            return new e(0, 1, 0, 1);
          }
        }]), e;
      }();

      t.a = f;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(24),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._maxListeners = 12, this._events = {}, this._pipeDestinations = [];
        }

        return a(e, [{
          key: "pipeEvents",
          value: function value(e) {
            this._pipeDestinations.push(e);
          }
        }, {
          key: "unpipeEvents",
          value: function value(e) {
            var t = this._pipeDestinations.indexOf(e);

            -1 !== t && this._pipeDestinations.splice(t, 1);
          }
        }, {
          key: "on",
          value: function value(e, t) {
            if (void 0 === e) throw new Error("Invalid event type: `" + e + "`");
            if ("function" != typeof t) throw new TypeError();
            var n = this._events[e] || (this._events[e] = []);
            return -1 !== n.indexOf(t) || (n.push(t), this._maxListeners && n.length > this._maxListeners && (o.a.warn("EventEmitter", "Possible memory leak detected, added " + n.length + " `" + e + "` listeners (current limit is " + this._maxListeners + ")"), "undefined" != typeof console && console.trace())), this;
          }
        }, {
          key: "once",
          value: function value(e, t) {
            if (void 0 === e) throw new Error("Invalid event type: `" + e + "`");
            var n = this;
            return this.on(e, function i() {
              n.off(e, i), t.apply(null, arguments);
            });
          }
        }, {
          key: "off",
          value: function value(e) {
            if (void 0 === e) throw new Error("Invalid event type: `" + e + "`");
            if (0 == (arguments.length <= 1 ? 0 : arguments.length - 1)) return this._events[e] = null, this;
            var t = arguments.length <= 1 ? void 0 : arguments[1];
            if ("function" != typeof t) throw new TypeError();
            var n = this._events[e];
            if (!n || !n.length) return this;
            var i = n.indexOf(t);
            return -1 === i || n.splice(i, 1), this;
          }
        }, {
          key: "emit",
          value: function value(e) {
            for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
              n[i - 1] = arguments[i];
            }

            if (void 0 === e) throw new Error("Invalid event type: `" + e + "`");

            this._pipeDestinations.forEach(function (t) {
              t.emit.apply(t, [e].concat(n));
            });

            var r = this._events[e];
            return !(!r || !r.length || (r.slice(0).forEach(function (e) {
              return e.apply(null, n);
            }), 0));
          }
        }, {
          key: "setMaxListeners",
          value: function value(e) {
            if (parseInt(e, 10) !== e) throw new TypeError();
            this._maxListeners = e;
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(15),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(12),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          g = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || f()(t)).call(this));

          return n.id = t.id++, n._onSourceLoaded = n._onSourceLoaded.bind(n), n._renderers = [], n._glTextures = {}, n._source = e, n._dirty = !0, n._glUnit = 0, n._mipMapping = !1, n._magFilter = t.DefaultMagFilter, n._minFilter = t.DefaultMinFilter, n._repeatX = t.ClampToEdge, n._repeatY = t.ClampToEdge, n._pixelRatio = 1, n._loaded = !1, n._frame = new h.h(0, 0, 100, 100), e && n._loadSource(), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "resizeTo",
          value: function value(e) {
            this._frame.width === e.x && this._frame.height === e.y || (this._frame.width = e.x, this._frame.height = e.y, this._dirty = !0);
          }
        }, {
          key: "_loadSource",
          value: function value() {
            var e = this._source,
                t = e.complete,
                n = "Canvas" === e.constructor.name || e.tagName && "CANVAS" === e.tagName.toUpperCase();
            if (t || n) return this._onSourceLoaded();
            e.addEventListener && e.addEventListener("load", this._onSourceLoaded);
          }
        }, {
          key: "_onSourceLoaded",
          value: function value() {
            this._loaded = !0, this.emit("loaded"), this.update();
          }
        }, {
          key: "_updateGLFilters",
          value: function value() {
            var e = new h.k(this._source.width, this._source.height);
            h.i.isPowerOfTwo(e) ? (h.f.info(this.constructor.name, "Mip-mapping enabled"), this._minFilter = t.TrilinearFilter, this._mipMapping = !0) : (this._minFilter = t.LinearFilter, this._mipMapping = !1);
          }
        }, {
          key: "update",
          value: function value() {
            this._frame.width === this._source.width && this._frame.height === this._source.height || (this._frame = new h.h(0, 0, this._source.width, this._source.height), this._dirty = !0), this._updateGLFilters(), this.emit("update");
          }
        }, {
          key: "getRenderers",
          value: function value() {
            return [].concat(function (e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = Array(e.length); t < e.length; t++) {
                  n[t] = e[t];
                }

                return n;
              }

              return r()(e);
            }(this._renderers));
          }
        }, {
          key: "getGLFilter",
          value: function value(e, t) {
            switch (t) {
              case "min":
                return this.constructor.getGLFilter(e, this._minFilter);

              case "mag":
                return this.constructor.getGLFilter(e, this._magFilter);
            }
          }
        }, {
          key: "isLoaded",
          value: function value() {
            return this._loaded;
          }
        }, {
          key: "setLoaded",
          value: function value(e) {
            this._loaded = e;
          }
        }, {
          key: "getSource",
          value: function value() {
            return this._source;
          }
        }, {
          key: "setSource",
          value: function value(e) {
            this._source = e;
          }
        }, {
          key: "getGLTextureForRenderer",
          value: function value(e) {
            return this._glTextures[e.id];
          }
        }, {
          key: "setGLTextureForRenderer",
          value: function value(e, t) {
            this._renderers[t.id] = t, this._glTextures[t.id] = e;
          }
        }, {
          key: "getFrame",
          value: function value() {
            return this._frame;
          }
        }, {
          key: "setFrame",
          value: function value(e) {
            this._frame = e;
          }
        }, {
          key: "getDimensions",
          value: function value() {
            return new h.k(this._frame.width, this._frame.height);
          }
        }, {
          key: "getPixelRatio",
          value: function value() {
            return this._pixelRatio;
          }
        }, {
          key: "setPixelRatio",
          value: function value(e) {
            this._pixelRatio = e;
          }
        }, {
          key: "getGLUnit",
          value: function value() {
            return this._glUnit;
          }
        }, {
          key: "setGLUnit",
          value: function value(e) {
            this._glUnit = e;
          }
        }, {
          key: "setMinFilter",
          value: function value(e) {
            this._minFilter = e;
          }
        }, {
          key: "getMinFilter",
          value: function value() {
            return this._minFilter;
          }
        }, {
          key: "setMagFilter",
          value: function value(e) {
            this._magFilter = e;
          }
        }, {
          key: "getMagFilter",
          value: function value() {
            return this._magFilter;
          }
        }, {
          key: "setRepeatX",
          value: function value(e) {
            this._repeatX = e;
          }
        }, {
          key: "getRepeatX",
          value: function value() {
            return this._repeatX;
          }
        }, {
          key: "setRepeatY",
          value: function value(e) {
            this._repeatY = e;
          }
        }, {
          key: "getRepeatY",
          value: function value() {
            return this._repeatY;
          }
        }, {
          key: "getGLRepeat",
          value: function value(e, n) {
            switch ("x" === n ? this.getRepeatX() : this.getRepeatY()) {
              case t.ClampToEdge:
                return e.CLAMP_TO_EDGE;

              case t.Repeat:
                return e.REPEAT;

              case t.MirroredRepeat:
                return e.MIRRORED_REPEAT;
            }
          }
        }, {
          key: "isDirty",
          value: function value() {
            return this._dirty;
          }
        }, {
          key: "setDirty",
          value: function value(e) {
            this._dirty = e;
          }
        }, {
          key: "disposeGLTextures",
          value: function value() {
            var e = this;

            this._renderers.forEach(function (t) {
              e.disposeGLTexturesForRenderer(t);
            });
          }
        }, {
          key: "disposeGLTexturesForRenderer",
          value: function value(e) {
            this._glTextures[e.id] && (e.getContext().deleteTexture(this._glTextures[e.id]), delete this._glTextures[e.id], this._renderers[e.id] || delete this._renderers[e.id]);
          }
        }, {
          key: "isMipMappingEnabled",
          value: function value() {
            return this._mipMapping;
          }
        }, {
          key: "setMipMappingEnabled",
          value: function value(e) {
            this._mipMapping = e;
          }
        }, {
          key: "dispose",
          value: function value() {
            this.disposeGLTextures(), this._source = void 0;
          }
        }], [{
          key: "getGLFilter",
          value: function value(e, n) {
            switch (n) {
              case t.LinearFilter:
                return e.LINEAR;

              case t.NearestFilter:
                return e.NEAREST;

              case t.BilinearFilter:
                return e.LINEAR_MIPMAP_NEAREST;

              case t.TrilinearFilter:
                return e.LINEAR_MIPMAP_LINEAR;
            }
          }
        }]), t;
      }(h.d);

      g.NearestFilter = 0, g.LinearFilter = 1, g.BilinearFilter = 2, g.TrilinearFilter = 3, g.DefaultMagFilter = g.NearestFilter, g.DefaultMinFilter = g.LinearFilter, g.ClampToEdge = 0, g.Repeat = 1, g.MirroredRepeat = 2, g.id = 0, t.a = g;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(12),
          d = n(70),
          g = n(117),
          m = n(116),
          y = n(71),
          _ = n.n(y),
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          b = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function w(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var k = h.c.OptionType,
          T = h.c.UniformType,
          S = h.c.RendererType,
          C = function (e) {
        function t() {
          return w(this, t), x(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_initOptions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this._shaders = [], this._availableUniforms = m.a.defaultUniforms, this._attributes = m.a.defaultAttributes, this._vertexSource = m.a.defaultVertexSource, this._fragmentSource = m.a.defaultFragmentSource, this._initUniforms(), b(t.prototype.__proto__ || f()(t.prototype), "_initOptions", this).call(this, e);
          }
        }, {
          key: "_initUniforms",
          value: function value() {
            for (var e in this._uniforms = {}, this._availableUniforms) {
              var t = this._availableUniforms[e];
              this._uniforms[e] = {
                type: t.type,
                value: t.default || null
              };
            }

            for (var n in this.availableOptions) {
              var i = this.availableOptions[n];
              i.uniformType ? this._uniforms["u_" + n] = {
                type: i.uniformType,
                value: i.default || null
              } : h.f.trace(this.constructor.name, "Option `" + n + "` is missing a `uniformType`!");
            }
          }
        }, {
          key: "setOption",
          value: function value(e, n) {
            var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
            b(t.prototype.__proto__ || f()(t.prototype), "setOption", this).call(this, e, n, i);
            var r = n,
                o = this.availableOptions[e];

            if (o.uniformType) {
              var a = "u_" + e;

              switch (o.type) {
                case k.COLOR:
                  o.uniformType === T.FLOAT4 ? r = n.toGLColor() : o.uniformType === T.FLOAT3 && (r = n.toRGBGLColor());
                  break;

                case k.VECTOR2:
                  r = [n.x, n.y];
                  break;

                case k.COLOR_MATRIX:
                  r = [n.a, n.b, n.c, n.d, n.f, n.g, n.h, n.i, n.k, n.l, n.m, n.n, n.p, n.q, n.r, n.s];
                  var s = [n.e, n.j, n.o, n.t];
                  this._uniforms[a + "_vec"] = {
                    value: s,
                    type: T.FLOAT4
                  };
              }

              this.setUniform(a, r);
            }
          }
        }, {
          key: "setUniform",
          value: function value(e, t) {
            this._uniforms[e].value = t;
          }
        }, {
          key: "setUniforms",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

            for (var n in e) {
              this._uniforms[n].value = e[n], t && this.syncUniform(n);
            }
          }
        }, {
          key: "syncUniform",
          value: function value(e) {
            this._shaders.forEach(function (t) {
              t.syncUniform(e);
            });
          }
        }, {
          key: "syncUniforms",
          value: function value() {
            this._shaders.forEach(function (e) {
              e.syncUniforms();
            });
          }
        }, {
          key: "getShaderForRenderer",
          value: function value(e) {
            var t = e.getContext(),
                n = this._shaders[t.id];
            return n || (n = new g.a(e, this._vertexSource, this._fragmentSource, this._uniforms, this._attributes), this._shaders[t.id] = n), n;
          }
        }, {
          key: "apply",
          value: function value(e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            e.isOfType(S.WEBGL) ? this._applyWebGL(e, t, n, i) : e.isOfType(S.CANVAS) && this._applyCanvas(e, t, n, i);
          }
        }, {
          key: "_applyWebGL",
          value: function value(e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                r = e.getContext(),
                o = this.getShaderForRenderer(e);
            e.setRenderTarget(n), i && n.clear(), e.setShader(o);
            var a = e.getCurrentRenderTarget().getProjectionMatrix().toArray();
            o.setUniform("u_projMatrix", a), o.syncUniforms(), r.activeTexture(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, t.getTexture()), r.drawElements(r.TRIANGLES, 6, r.UNSIGNED_SHORT, 0);
          }
        }, {
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = t.getCanvas(),
                r = n.getContext();
            h.f.warn(this.constructor.name, "`_applyCanvas` is not implemented. Just copying image data from `inputTarget` to `outputTarget`."), r.clearRect(0, 0, i.width, i.height), r.drawImage(i, 0, 0);
          }
        }, {
          key: "dispose",
          value: function value() {
            this._shaders.forEach(function (e) {
              return e.dispose();
            }), this._shaders = [];
          }
        }, {
          key: "_blurImage",
          value: function value(e, t, n) {
            var i = e.getCanvas(),
                r = Math.min(1, 10 / (n * Math.min(i.width, i.height))),
                o = h.i.createCanvas();
            o.width = Math.round(i.width * r), o.height = Math.round(i.height * r);
            var a = o.getContext("2d");
            a.drawImage(i, 0, 0, i.width, i.height, 0, 0, o.width, o.height);
            var s = n * Math.min(o.width, o.height),
                l = a.getImageData(0, 0, o.width, o.height);
            _.a.stackBlurCanvasRGBA(l, 0, 0, o.width, o.height, s), a.putImageData(l, 0, 0), t.getContext().drawImage(o, 0, 0, o.width, o.height, 0, 0, i.width, i.height);
          }
        }]), t;
      }(d.a);

      t.a = C;
    }, function (e, t, n) {
      var i = n(36),
          r = n.n(i),
          o = n(37),
          a = n.n(o),
          s = n(6),
          l = n.n(s),
          u = n(0),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(39),
          m = n.n(g),
          y = n(1),
          _ = n.n(y),
          v = n(46),
          b = n(24),
          w = n(67),
          x = n(45),
          k = n(66),
          T = n(32),
          S = n(90),
          C = n(164),
          E = n(40),
          O = "function" == typeof a.a && "symbol" == typeof r.a ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof a.a && e.constructor === a.a && e !== a.a.prototype ? "symbol" : typeof e;
      },
          R = l.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          I = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), c()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function A(e, t, n) {
        return t in e ? c()(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      function M(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function F(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var D = function (e) {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          M(this, t);
          var i = F(this, (t.__proto__ || _()(t)).call(this));
          return i.availableOptions = i.availableOptions || {}, i.availableOptions = T.a.extend(i.availableOptions, n), i._onConfigurableUpdate = i._onConfigurableUpdate.bind(i), i._initOptions(e), i;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), I(t, [{
          key: "_buildConfigError",
          value: function value(e) {
            var t = "";
            return this.constructor.name && (t = this.constructor.name + ": "), t += e, new Error(t);
          }
        }, {
          key: "_onOptionsChange",
          value: function value() {}
        }, {
          key: "validateSettings",
          value: function value() {
            var e = this;
            return new v.a(function (t, n) {
              for (var i in e.availableOptions) {
                if (e.availableOptions[i].required && void 0 === e._options[i]) return n(e._buildConfigError("Option `" + i + "` is required."));
              }

              t();
            });
          }
        }, {
          key: "_initOptions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this._options = {};
            var n = void 0,
                i = void 0,
                r = void 0,
                o = this;

            for (n in this.availableOptions) {
              if (r = n.charAt(0).toUpperCase() + n.slice(1), i = this.availableOptions[n], -1 === [E.OptionType.STRING, E.OptionType.NUMBER, E.OptionType.BOOLEAN, E.OptionType.OBJECT, E.OptionType.VECTOR2, E.OptionType.COLOR, E.OptionType.CONFIGURABLE, E.OptionType.COLOR_MATRIX, E.OptionType.ARRAY, E.OptionType.IMAGE, E.OptionType.FUNCTION, E.OptionType.ALL].indexOf(i.type)) throw this._buildConfigError("Unknown option type: `" + i.type + "`");

              var a = function a(e, t) {
                o["set" + r] = function (t, n, i) {
                  o.setOption(e, t, n, i);
                }, o["get" + r] = function () {
                  return o.getOption(e);
                };
              };

              if (a(n, i), i.type === E.OptionType.CONFIGURABLE && (this._options[n] = new t(void 0, i.structure || {}), this._options[n].on("update", this._onConfigurableUpdate)), !(n in e) || void 0 === e[n]) if (void 0 !== i.default) {
                var s = i.default;
                "function" == typeof i.default && (s = i.default()), this["set" + r](s, !1, !0);
              } else i.type !== E.OptionType.CONFIGURABLE && (this._options[n] = void 0);
            }

            for (n in e) {
              if (void 0 === this.availableOptions[n]) throw new Error("Invalid option: " + n);
              void 0 !== e[n] && this["set" + (r = n.charAt(0).toUpperCase() + n.slice(1))](e[n], !1, !0);
            }
          }
        }, {
          key: "set",
          value: function value(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

            for (var n in e) {
              this.setOption(n, e[n], !1);
            }

            this._onOptionsChange(), t && this.emit("update", this, e);
          }
        }, {
          key: "getOption",
          value: function value(e) {
            return this._options[e];
          }
        }, {
          key: "hasOption",
          value: function value(e) {
            return !!this.availableOptions[e];
          }
        }, {
          key: "getOptionDefault",
          value: function value(e) {
            var t = this.availableOptions[e];
            if (!t) throw new Error("Invalid option: " + e);
            return t.default;
          }
        }, {
          key: "resetOptions",
          value: function value() {
            this.set(this.getDefaultOptions());
          }
        }, {
          key: "getDefaultOptions",
          value: function value() {
            var e = {};

            for (var t in this.availableOptions) {
              var n = this.availableOptions[t].default;
              void 0 !== n && (e[t] = n);
            }

            return e;
          }
        }, {
          key: "getOptions",
          value: function value() {
            return R({}, this._options);
          }
        }, {
          key: "equals",
          value: function value(e) {
            var t = e.getOptions();
            return this.optionsEqual(t);
          }
        }, {
          key: "optionsEqual",
          value: function value(e) {
            for (var t in e) {
              var n = e[t];
              if (!this._optionEquals(t, n)) return !1;
            }

            return !0;
          }
        }, {
          key: "_optionEquals",
          value: function value(e, t) {
            if (void 0 === this.availableOptions[e]) throw new Error("Invalid option: " + e);
            var n = this.availableOptions[e].type,
                i = this._options[e];
            if (i === t) return !0;
            if (void 0 === t || void 0 === i) return !1;

            switch (n) {
              case E.OptionType.OBJECT:
                return "function" == typeof i.optionsEqual ? i.optionsEqual(t._options) : i === t;

              case E.OptionType.STRING:
              case E.OptionType.NUMBER:
              case E.OptionType.BOOLEAN:
              case E.OptionType.FUNCTION:
              case "*":
                return i === t;

              case E.OptionType.VECTOR2:
                return i.equals(t);

              case E.OptionType.COLOR:
              case E.OptionType.COLOR_MATRIX:
                return t.equals(i);

              case E.OptionType.CONFIGURABLE:
                return i.optionsEqual(t);

              case E.OptionType.ARRAY:
                return this._arrayOptionEquals(e, t);

              case E.OptionType.IMAGE:
                return i.src === t.src;
            }
          }
        }, {
          key: "_arrayOptionEquals",
          value: function value(e, n) {
            var i = this._options[e];
            if (n.length !== i.length) return !1;

            for (var r = !0, o = 0; o < i.length; o++) {
              var a = i[o],
                  s = n[o];

              if (a instanceof t) {
                if (void 0 === s || !a.optionsEqual(s)) {
                  r = !1;
                  break;
                }
              } else if (s !== a) {
                r = !1;
                break;
              }
            }

            return r;
          }
        }, {
          key: "serializeOptions",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : m()(this._options),
                n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                i = {};
            return t.forEach(function (t) {
              if (void 0 === e.availableOptions[t]) return b.a.warn("Trying to serialize a key that does not exist: " + t);
              !1 !== e.availableOptions[t].serializable && (i[t] = e.serializeOption(t, n));
            }), i;
          }
        }, {
          key: "serializeOption",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = this.availableOptions[e],
                i = n.type,
                r = this._options[e];
            if (!r) return r;
            if (!1 === n.serializable) throw new Error("Option `" + e + "` is not serializable.");

            switch (i) {
              case E.OptionType.STRING:
              case E.OptionType.NUMBER:
              case E.OptionType.BOOLEAN:
              case E.OptionType.OBJECT:
              case E.OptionType.FUNCTION:
              case E.OptionType.ALL:
                return r;

              case E.OptionType.VECTOR2:
                return t ? r.toObject() : r.clone();

              case E.OptionType.COLOR:
              case E.OptionType.COLOR_MATRIX:
                return t ? r.toArray() : r.clone();

              case E.OptionType.CONFIGURABLE:
                return r.serializeOptions(void 0, t);

              case E.OptionType.ARRAY:
                return r.slice(0);

              case E.OptionType.IMAGE:
                return t ? r.src : r;
            }
          }
        }, {
          key: "setOption",
          value: function value(e, n) {
            var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                o = this.availableOptions[e];
            if (!o) throw new Error("Invalid option: " + e);

            if (void 0 !== o.setter && (n = o.setter.call(this, n, r)), void 0 !== o.validation && o.validation(n), null == n) {
              if (o.required) throw this._buildConfigError("Option `" + e + "` is required.");
              this._options[e] = n;
            } else switch (o.type) {
              case E.OptionType.STRING:
                if ((void 0 === n ? "undefined" : O(n)) !== E.OptionType.STRING) throw this._buildConfigError("Option `" + e + "` has to be a string.");
                var a = o.available;
                if (void 0 !== a && -1 === a.indexOf(n)) throw this._buildConfigError("Invalid value for `" + e + "` (valid values are: " + o.available.join(", ") + ")");
                this._options[e] = n;
                break;

              case E.OptionType.NUMBER:
                if ((void 0 === n ? "undefined" : O(n)) !== E.OptionType.NUMBER) throw this._buildConfigError("Option `" + e + "` has to be a number.");
                this._options[e] = n;
                break;

              case E.OptionType.BOOLEAN:
                if ((void 0 === n ? "undefined" : O(n)) !== E.OptionType.BOOLEAN) throw this._buildConfigError("Option `" + e + "` has to be a boolean.");
                this._options[e] = n;
                break;

              case E.OptionType.VECTOR2:
                if (!(n instanceof x.a || "object" === (void 0 === n ? "undefined" : O(n)) && "x" in n && "y" in n)) throw this._buildConfigError("Option `" + e + "` has to be an instance of Vector2 or an Object holding x and y values.");
                n instanceof x.a ? this._options[e] = n.clone() : this._options[e] = x.a.fromObject(n);
                break;

              case E.OptionType.COLOR:
                if (!(n instanceof k.a)) throw this._buildConfigError("Option `" + e + "` has to be an instance of Color.");
                this._options[e] = n;
                break;

              case E.OptionType.COLOR_MATRIX:
                if (!(n instanceof C.a)) throw this._buildConfigError("Option `" + e + "` has to be an instance of ColorMatrix.");
                this._options[e] = n.clone();
                break;

              case E.OptionType.FUNCTION:
                if ("function" != typeof n) throw this._buildConfigError("Option `" + e + "` has to be a function.");
                this._options[e] = n;
                break;

              case E.OptionType.OBJECT:
              case "*":
                this._options[e] = n;
                break;

              case E.OptionType.IMAGE:
                if ("string" == typeof n) {
                  var s = new S.a();
                  s.crossOrigin = T.a.getCrossOriginValue(o.crossOrigin), s.src = n, this._options[e] = s;
                } else {
                  if (!(n instanceof S.a || "undefined" != typeof HTMLCanvasElement && n instanceof HTMLCanvasElement || "undefined" != typeof HTMLImageElement && n instanceof HTMLImageElement)) throw this._buildConfigError("Option `" + e + "` has to be an Image, Canvas or String.");
                  this._options[e] = n;
                }

                break;

              case E.OptionType.CONFIGURABLE:
                n instanceof t ? this._options[e] = n : this._options[e].set(n);
                break;

              case E.OptionType.ARRAY:
                if (!(n instanceof Array)) throw this._buildConfigError("Option `" + e + "` has to be an Array.");
                this._options[e] = n.slice(0);
                break;

              default:
                throw this._buildConfigError("Unknown option type: `" + o.type + "`");
            }

            i && (this._onOptionsChange(), this.emit("update", this, A({}, e, n)));
          }
        }, {
          key: "_onConfigurableUpdate",
          value: function value() {
            for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            this.emit.apply(this, ["update"].concat(t));
          }
        }, {
          key: "hasChanges",
          value: function value() {
            var e = this.getDefaultOptions();
            return !this.optionsEqual(e);
          }
        }]), t;
      }(w.a);

      t.a = D;
    }, function (e, t, n) {
      /*!
      StackBlur - a fast almost Gaussian Blur For Canvas
      
      Version:  0.5
      Author:   Mario Klingemann
      Contact:  mario@quasimondo.com
      Website:  http://www.quasimondo.com/StackBlurForCanvas
      Twitter:  @quasimondo
      
      In case you find this class useful - especially in commercial projects -
      I am not totally unhappy for a small donation to my PayPal account
      mario@quasimondo.de
      
      Or support me on flattr:
      https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript
      
      Copyright (c) 2010 Mario Klingemann
      
      Permission is hereby granted, free of charge, to any person
      obtaining a copy of this software and associated documentation
      files (the "Software"), to deal in the Software without
      restriction, including without limitation the rights to use,
      copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the
      Software is furnished to do so, subject to the following
      conditions:
      
      The above copyright notice and this permission notice shall be
      included in all copies or substantial portions of the Software.
      
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
      EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
      OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
      NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
      HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
      WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
      FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
      OTHER DEALINGS IN THE SOFTWARE.
      @license
      */
      var i = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259],
          r = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];

      function o() {
        this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
      }

      e.exports = {
        stackBlurCanvasRGBA: function stackBlurCanvasRGBA(e, t, n, a, s, l) {
          if (!(isNaN(l) || l < 1)) {
            l |= 0;

            var u,
                c,
                p,
                f,
                h,
                d,
                g,
                m,
                y,
                _,
                v,
                b,
                w,
                x,
                k,
                T,
                S,
                C,
                E,
                O,
                R,
                I,
                A,
                M,
                F,
                D = e.data,
                P = l + l + 1,
                z = a - 1,
                L = s - 1,
                B = l + 1,
                N = B * (B + 1) / 2,
                U = new o(),
                j = U;

            for (p = 1; p < P; p++) {
              j = j.next = new o(), p == B && (F = j);
            }

            j.next = U;
            var W = null,
                H = null;
            g = d = 0;
            var G = i[l],
                V = r[l];

            for (c = 0; c < s; c++) {
              for (T = S = C = E = m = y = _ = v = 0, b = B * (O = D[d]), w = B * (R = D[d + 1]), x = B * (I = D[d + 2]), k = B * (A = D[d + 3]), m += N * O, y += N * R, _ += N * I, v += N * A, j = U, p = 0; p < B; p++) {
                j.r = O, j.g = R, j.b = I, j.a = A, j = j.next;
              }

              for (p = 1; p < B; p++) {
                f = d + ((z < p ? z : p) << 2), m += (j.r = O = D[f]) * (M = B - p), y += (j.g = R = D[f + 1]) * M, _ += (j.b = I = D[f + 2]) * M, v += (j.a = A = D[f + 3]) * M, T += O, S += R, C += I, E += A, j = j.next;
              }

              for (W = U, H = F, u = 0; u < a; u++) {
                D[d + 3] = A = v * G >> V, 0 !== A ? (A = 255 / A, D[d] = (m * G >> V) * A, D[d + 1] = (y * G >> V) * A, D[d + 2] = (_ * G >> V) * A) : D[d] = D[d + 1] = D[d + 2] = 0, m -= b, y -= w, _ -= x, v -= k, b -= W.r, w -= W.g, x -= W.b, k -= W.a, f = g + ((f = u + l + 1) < z ? f : z) << 2, m += T += W.r = D[f], y += S += W.g = D[f + 1], _ += C += W.b = D[f + 2], v += E += W.a = D[f + 3], W = W.next, b += O = H.r, w += R = H.g, x += I = H.b, k += A = H.a, T -= O, S -= R, C -= I, E -= A, H = H.next, d += 4;
              }

              g += a;
            }

            for (u = 0; u < a; u++) {
              for (S = C = E = T = y = _ = v = m = 0, b = B * (O = D[d = u << 2]), w = B * (R = D[d + 1]), x = B * (I = D[d + 2]), k = B * (A = D[d + 3]), m += N * O, y += N * R, _ += N * I, v += N * A, j = U, p = 0; p < B; p++) {
                j.r = O, j.g = R, j.b = I, j.a = A, j = j.next;
              }

              for (h = a, p = 1; p <= l; p++) {
                d = h + u << 2, m += (j.r = O = D[d]) * (M = B - p), y += (j.g = R = D[d + 1]) * M, _ += (j.b = I = D[d + 2]) * M, v += (j.a = A = D[d + 3]) * M, T += O, S += R, C += I, E += A, j = j.next, p < L && (h += a);
              }

              for (d = u, W = U, H = F, c = 0; c < s; c++) {
                D[3 + (f = d << 2)] = A = v * G >> V, A > 0 ? (A = 255 / A, D[f] = m * G >> V, D[f + 1] = y * G >> V, D[f + 2] = _ * G >> V) : D[f] = D[f + 1] = D[f + 2] = 0, m -= b, y -= w, _ -= x, v -= k, b -= W.r, w -= W.g, x -= W.b, k -= W.a, f = u + ((f = c + B) < L ? f : L) * a << 2, m += T += W.r = D[f], y += S += W.g = D[f + 1], _ += C += W.b = D[f + 2], v += E += W.a = D[f + 3], W = W.next, b += O = H.r, w += R = H.g, x += I = H.b, k += A = H.a, T -= O, S -= R, C -= I, E -= A, H = H.next, d += a;
              }
            }
          }
        }
      };
    }, function (e, t, n) {
      (function (e) {
        var i = n(0),
            r = n.n(i),
            o = n(46),
            a = n(305),
            s = n.n(a),
            l = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var i = t[n];
              i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
            }
          }

          return function (t, n, i) {
            return n && e(t.prototype, n), i && e(t, i), t;
          };
        }(),
            u = "undefined" != typeof window ? window : e,
            c = function () {
          function e(t) {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, e), this._url = t, this._parsedUrl = s.a.parse(this._url, !0);
          }

          return l(e, [{
            key: "_isJSONPRequest",
            value: function value() {
              var e = this._parsedUrl.query;

              for (var t in e) {
                if ("?" === e[t]) return !0;
              }

              return !1;
            }
          }, {
            key: "load",
            value: function value() {
              return this._isJSONPRequest() ? this._loadJSONP() : this._loadJSON();
            }
          }, {
            key: "_loadJSON",
            value: function value() {
              var e = this;
              return new o.a(function (t, n) {
                var i = void 0;
                u.XDomainRequest ? ((i = new u.XDomainRequest()).onload = function () {
                  var e = JSON.parse(i.responseText);
                  t(e);
                }, i.onerror = function (e) {
                  n(e);
                }, i.open("GET", e._url, !0), i.send()) : u.XMLHttpRequest && ((i = new XMLHttpRequest()).onreadystatechange = function (e) {
                  if (4 === i.readyState) if (200 === i.status) {
                    var r = JSON.parse(i.responseText);
                    t(r);
                  } else n(new Error("HTTP Status " + i.status));
                }, i.open("GET", e._url, !0), i.send());
              });
            }
          }, {
            key: "_loadJSONP",
            value: function value() {
              var e = this,
                  t = !1,
                  n = !1,
                  i = "pesdk" + Math.round(99999999999999 * Math.random());
              return new o.a(function (r, o) {
                var a = e._createJSONPNode(i);

                u[i] = function (i) {
                  e._removeJSONPNode(a), t || (n = !0, r(i));
                }, u.setTimeout(function () {
                  n || (e._removeJSONPNode(a), t = !0, o(new Error("Timeout of 5 seconds exceeded.")));
                }, 5e3);
              });
            }
          }, {
            key: "_createJSONPNode",
            value: function value(e) {
              var t = this._buildJSONPUrl(e),
                  n = document.querySelector("head"),
                  i = document.createElement("script");

              return i.src = t, n.appendChild(i), i;
            }
          }, {
            key: "_removeJSONPNode",
            value: function value(e) {
              e.parentNode.removeChild(e);
            }
          }, {
            key: "_buildJSONPUrl",
            value: function value(e) {
              var t = this._parsedUrl.query,
                  n = null;

              for (var i in t) {
                if ("?" === t[i]) {
                  n = i;
                  break;
                }
              }

              return delete this._parsedUrl.search, t[n] = e, s.a.format(this._parsedUrl);
            }
          }]), e;
        }();

        t.a = c;
      }).call(t, n(64));
    }, function (e, t, n) {
      var i = n(29),
          r = n.n(i),
          o = n(25),
          a = n.n(o),
          s = n(10),
          l = n.n(s),
          u = function u(e, t) {
        if (Array.isArray(e)) return e;
        if (r()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var s, l = a()(e); !(i = (s = l.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && l.return && l.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };

      t.a = {
        load: function load(e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            cors: !0,
            value: "anonymous"
          },
              i = function i() {
            return e.substr(0, 5), l.a.resolve([e, e]);
          };

          return i().then(function (e) {
            var i = u(e, 2),
                r = i[0],
                o = i[1];
            return t._createAndLoadImage(r, o, n);
          });
        },
        loadImage: function loadImage(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            cors: !0,
            value: "anonymous"
          };
          return this._loadWithoutExif(e, t);
        },
        _loadWithoutExif: function _loadWithoutExif(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            cors: !0,
            value: "anonymous"
          };
          return new l.a(function (n, i) {
            var r = new window.Image();
            r.addEventListener("load", function () {
              n(r);
            }), r.addEventListener("error", function () {
              i(new Error("Failed to load image at " + e));
            }), t.cors && (r.crossOrigin = t.value), r.src = e;
          });
        },
        _createAndLoadImage: function _createAndLoadImage(e, t) {
          var n = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
            cors: !0,
            value: "anonymous"
          };
          return new l.a(function (e, r) {
            var o = n._loadWithoutExif(t, i).then(function (t) {
              return e(t);
            }),
                a = new l.a(function (e, r) {
              n._loadAsDataURL(t, i).then(function (t) {
                var n = new window.Image();
                n.addEventListener("load", function () {
                  e(n);
                }), n.src = t, n.rawSource = t;
              }).catch(function (t) {
                o.then(function (t) {
                  return e(t);
                });
              });
            });

            return n._stringEndsWith(t, ".svg") ? o.then(function (t) {
              return e(t);
            }) : a.then(function (t) {
              return e(t);
            });
          });
        },
        _stringEndsWith: function _stringEndsWith(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.length;
          return (void 0 === n || n > e.length) && (n = e.length), e.substring(n - t.length, n) === t;
        },
        _loadAsDataURL: function _loadAsDataURL(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            cors: !0,
            value: "anonymous"
          };
          return new l.a(function (n, i) {
            var r = new XMLHttpRequest();
            r.onload = function () {
              var e = new FileReader();
              e.onloadend = function () {
                e.error && i(e.error), n(e.result);
              }, e.readAsDataURL(r.response);
            }, r.open("GET", e), r.responseType = "blob", r.withCredentials = t.cors && "use-credentials" === t.value, r.send();
          });
        },
        loadXHR: function loadXHR(e, t) {
          return new l.a(function (n, i) {
            var r = void 0;
            window.XDomainRequest ? (r = new window.XDomainRequest(), t && r.overrideMimeType(t), r.onload = function () {
              n(r);
            }, r.onerror = function (e) {
              i(e);
            }) : window.XMLHttpRequest && (r = new window.XMLHttpRequest(), t && r.overrideMimeType(t), r.onreadystatechange = function (e) {
              4 === r.readyState && (200 === r.status ? n(r) : i(new Error("HTTP Status " + r.status)));
            }), r.open("GET", e, !0), r.send();
          });
        }
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(71)),
          h = (n.n(f), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = p.Math.Vector2,
          y = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(r)));
          return a._fragmentSource = n(333), a._lastBlurRadius = null, a._lastDimensions = new m(0, 0), a._blurredRenderTarget = new p.Engine.CanvasRenderTarget(100, 100, 1), a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;

            if ("low" !== this._options.blurQuality) {
              var o = t.getCanvas(),
                  a = t.getContext(),
                  s = n.getContext();
              this._lastBlurRadius === this._options.blurRadius && s.drawImage(o, 0, 0);

              for (var l = a.getImageData(0, 0, o.width, o.height), u = s.getImageData(0, 0, o.width, o.height), c = this._options.blurRadius, p = this._options.delta, f = 30, h = 0; h < o.width; h++) {
                for (var d = 0; d < o.height; d++) {
                  var g = h + d * o.width,
                      y = 4 * g,
                      _ = 0,
                      v = 0,
                      b = 0,
                      w = 0,
                      x = 0;
                  r && (c = r(h / o.width, d / o.height));

                  for (var k = this._random(h, 1 - d / o.height), T = -f; T <= f; T++) {
                    var S = (T + k - .5) / f,
                        C = 1 - Math.abs(S),
                        E = p.x * S * c,
                        O = p.y * S * c,
                        R = Math.max(Math.min(h + E, o.width - 1), 0),
                        I = Math.max(Math.min(d + O, o.height - 1), 0),
                        A = 4 * (Math.round(I) * o.width + Math.round(R)),
                        M = l.data[A + 3],
                        F = M * l.data[A],
                        D = M * l.data[A + 1],
                        P = M * l.data[A + 2];
                    _ += F * C, v += D * C, b += P * C, w += M * C, x += C;
                  }

                  _ /= x, v /= x, b /= x, w /= x, u.data[y] = _ / w, u.data[y + 1] = v / w, u.data[y + 2] = b / w, u.data[y + 3] = w;
                }
              }

              s.putImageData(u, 0, 0), this._lastDimensions.copy(new m(o.width, o.height));
            } else this._renderLQBlur(e, t, n, i);
          }
        }, {
          key: "_renderLQBlur",
          value: function value(e, t, n, i) {
            var r = t.getDimensions(),
                o = !this._lastDimensions.equals(r);
            this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()), this._blurredRenderTarget.resizeTo(t.getDimensions()), n.setPixelRatio(t.getPixelRatio()), n.resizeTo(t.getDimensions()), (this._lastBlurRadius !== this._options.blurRadius || o) && (this._blurImage(t, this._blurredRenderTarget, this._options.blurRadius), this._lastBlurRadius = this._options.blurRadius), n.getContext().drawImage(this._blurredRenderTarget.getCanvas(), 0, 0), this._lastDimensions.copy(r);
          }
        }, {
          key: "_random",
          value: function value(e, t) {
            var n = 12.9898 * e + 78.233 * t,
                i = n - 3.14 * Math.floor(n / 3.14),
                r = 43758.5453 * Math.sin(i);
            return r - Math.floor(r);
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        blurRadius: {
          type: p.OptionType.NUMBER,
          default: 30,
          uniformType: p.UniformType.FLOAT
        },
        delta: {
          type: p.OptionType.VECTOR2,
          default: new m(1, 1),
          uniformType: p.UniformType.FLOAT2
        },
        texSize: {
          type: p.OptionType.VECTOR2,
          default: new m(100, 100),
          uniformType: p.UniformType.FLOAT2
        },
        blurQuality: {
          type: p.OptionType.STRING,
          default: "low"
        }
      }, t.a = y;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          g = h.Math.Vector2,
          m = function (e) {
        function t(e, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var i = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || f()(t)).call(this, n));

          return i._isDisposed = !1, i._operation = e, i._dirtiness = {}, i.id = h.Utils.getUUID(), i._renderTextures = {}, i._identitySprite = new h.Engine.Sprite(), i._sprite = new h.Engine.Sprite(), i._hitTestSprite = new h.Engine.Sprite(), i._renderers = [], i;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "applyScale",
          value: function value(e) {}
        }, {
          key: "applyRotation",
          value: function value(e) {
            var t = this._operation.getInputDimensions(),
                n = 180 * this.getRotation() / Math.PI;

            n += e, this.setRotation(n * Math.PI / 180);

            var i = (e + 360) % 360 * Math.PI / 180,
                r = Math.cos(i),
                o = Math.sin(i),
                a = this._options.position.clone().subtract(.5).multiply(t),
                s = new g(a.x * r - a.y * o, a.x * o + a.y * r).divide(t.clone().flip());

            this.setPosition(new g(.5, .5).add(s));
          }
        }, {
          key: "applyFlip",
          value: function value(e) {
            var t = this.getPosition().clone();

            switch (e) {
              case "horizontal":
                t.x = 1 - this._options.position.x;
                break;

              case "vertical":
                t.y = 1 - this._options.position.y;
            }

            this.setPosition(t);
          }
        }, {
          key: "applyTransform",
          value: function value(e) {
            var t = {};
            t.rotation = e.applyToRotation(this.getRotation()), t.position = e.applyToRelativePoint(this.getPosition()), this._options.dimensions && (t.dimensions = e.applyToDimensions(this.getDimensions())), this.set(t, !1);
          }
        }, {
          key: "getDisplayObject",
          value: function value() {
            return this._sprite;
          }
        }, {
          key: "getHitTestDisplayObject",
          value: function value() {
            return this._sprite;
          }
        }, {
          key: "_getTexture",
          value: function value() {
            throw new Error("Sprite#_getTexture is abstract and not implemented in child class.");
          }
        }, {
          key: "_prepareRenderTexture",
          value: function value(e) {
            if (this._renderTexture) this._renderTexture.clear();else {
              var t = this._getTexture();

              this._renderTextureContainer = new h.Engine.Container(), this._renderTextureSprite = new h.Engine.Sprite(t), this._renderTextureContainer.addChild(this._renderTextureSprite), this._renderTexture = this._getRenderTexture(e.getRenderer(), t.getDimensions());
            }
          }
        }, {
          key: "_rendersToRenderTexture",
          value: function value(e) {
            return e.getOptions().smoothDownscaling && e.getRenderer().isOfType(h.RendererType.WEBGL);
          }
        }, {
          key: "_optionEquals",
          value: function value(e, n) {
            return "type" === e || function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "_optionEquals", this).call(this, e, n);
          }
        }, {
          key: "update",
          value: function value(e, t) {
            this._isDisposed || (this._rendersToRenderTexture(e) && (this._prepareRenderTexture(e), this._renderToRenderTexture(e)), this._updateSprite(t));
          }
        }, {
          key: "_updateSprite",
          value: function value(e) {
            var t = this;
            [this._sprite, this._hitTestSprite].forEach(function (n) {
              if (n.getTexture()) {
                n.setAnchor(t._options.anchor), n.setPosition(t._options.position.clone().multiply(e)), void 0 !== t._options.alpha && n.setAlpha(t._options.alpha);
                var i = t._options.dimensions;
                i && (i = i.clone().multiply(t._operation.getSDK().getTextureScale()), n.setWidth(i.x), n.setHeight(i.y)), n.updateTransform();
                var r = n.getTexture().getFrame(),
                    o = new g(r.width, r.height);
                n.setPivot(t._options.pivot.clone().multiply(o)), n.setRotation(t._options.rotation), n.updateTransform();
              }
            });
          }
        }, {
          key: "_renderToRenderTexture",
          value: function value(e) {
            var t = this._getTexture().getDimensions(),
                n = this._getRenderTexture(e.getRenderer(), t),
                i = t.clone();

            if (this._options.smoothDownscaling && (i.x = h.Utils.nextHighestPOT(i.x), i.y = h.Utils.nextHighestPOT(i.y)), this._renderTexture.resizeTo(i), this._renderTexture.render(this._renderTextureContainer), this._options.smoothDownscaling) {
              var r = i.clone().subtract(t.x, t.y).divide(i),
                  o = n.getUVs().getUVs();
              o[0].x = o[3].x = 0, o[1].x = o[2].x = 1 - r.x, o[0].y = o[1].y = 0, o[2].y = o[3].y = 1 - r.y;
            }

            this._sprite.setTexture(n);
          }
        }, {
          key: "isDirtyForRenderer",
          value: function value(e) {
            return e.id in this._dirtiness || (this._dirtiness[e.id] = !0), this._dirtiness[e.id];
          }
        }, {
          key: "setDirtyForRenderer",
          value: function value(e, t) {
            this._renderers[t.id] = t, this._dirtiness[t.id] = e;
          }
        }, {
          key: "setDirty",
          value: function value(e) {
            for (var t in this._dirtiness) {
              this.setDirtyForRenderer(e, this._renderers[t]);
            }
          }
        }, {
          key: "_getRenderTexture",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new g(100, 100);
            return this._renderTextures[e.id] || (this._renderTextures[e.id] = new h.Engine.RenderTexture(e, t.x, t.y, 1)), this._renderTextures[e.id];
          }
        }, {
          key: "dispose",
          value: function value() {
            for (var e in this._isDisposed = !0, this._renderTextures) {
              this._renderTextures[e].dispose();
            }
          }
        }, {
          key: "canBeDuplicated",
          value: function value() {
            return !0;
          }
        }, {
          key: "canBeDeleted",
          value: function value() {
            return !0;
          }
        }, {
          key: "canMaskCanvas",
          value: function value() {
            return !1;
          }
        }, {
          key: "canAdjustPadding",
          value: function value() {
            return !1;
          }
        }, {
          key: "canBeTakenToFront",
          value: function value() {
            return !0;
          }
        }, {
          key: "canBeFlippedHorizontally",
          value: function value() {
            return !0;
          }
        }]), t;
      }(h.Configurable);

      t.a = m;
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return M;
      });

      var i = n(6),
          r = n.n(i),
          o = n(15),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(5),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = (n.n(y), n(77)),
          v = n(432),
          b = n(123),
          w = n(26),
          x = n(124),
          k = n(78),
          T = n(27),
          S = n(20),
          C = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          E = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          O = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = c()(t, n);

        if (void 0 === r) {
          var o = m()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function R(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return a()(e);
      }

      function I(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function A(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var M = function (e) {
        function t() {
          var e;
          I(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = A(this, (e = t.__proto__ || m()(t)).call.apply(e, [this].concat(i)));
          return o.getImagePaths = function () {
            var e = o.getBanderoles();
            return e && e.map(function (e) {
              return e.getImagePath();
            }) || [];
          }, o.onImagesLoaded = function () {
            var e = o.getBanderoles();
            e && e.forEach(function (e) {
              var t = T.a.getImage(e.getImagePath());
              t ? e.setImage(t) : y.Log.warn("TextDesignBlocks#onImagesLoaded: Image not found '" + e.getImagePath() + "'");
            });
          }, o._rowTypeLessThan3WordsRandomizer = new S.a(0), o._rowTypeMoreThan3WordsRandomizer = new S.a(0), o._banderolesRandomizer = new S.a(0), o._seedPool = [].concat(R(o._seedPool), [o._rowTypeLessThan3WordsRandomizer, o._rowTypeMoreThan3WordsRandomizer, o._banderolesRandomizer]), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), E(t, [{
          key: "_modifiedText",
          value: function value(e) {
            return O(t.prototype.__proto__ || m()(t.prototype), "_modifiedText", this).call(this, e).toUpperCase();
          }
        }, {
          key: "generateLayoutData",
          value: function value(e, n) {
            return this._options.hasMaskedText = !1, O(t.prototype.__proto__ || m()(t.prototype), "generateLayoutData", this).call(this, e, n);
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, t, n, i) {
            if (e.size() < 3) {
              var r = 0 === this._rowTypeLessThan3WordsRandomizer.nextInRange(0, 2);

              return this._layoutRow(e, n, i, r);
            }

            var o = this._rowTypeMoreThan3WordsRandomizer.nextInRange(0, 3);

            switch (o) {
              case 0:
                return new v.a({
                  words: e,
                  width: n,
                  attributes: i,
                  orientation: v.a.Orientations.Left
                });

              case 1:
                return new v.a({
                  words: e,
                  width: n,
                  attributes: i,
                  orientation: v.a.Orientations.Right
                });

              case 2:
                return this._layoutRow(e, n, i, !0);

              case 3:
                return new w.a({
                  words: e,
                  width: n,
                  attributes: i
                });

              default:
                throw new Error("TextDesignBlocks#_randomLayoutRow: Invalid randomValue generated: " + o + ".");
            }
          }
        }, {
          key: "_layoutRow",
          value: function value(e, t, n, i) {
            if (this.getHasMaskedText() && (i = !1), i) {
              this.setHasMaskedText(!0);

              var r = this._banderolesRandomizer.pickNext(this.getBanderoles()),
                  o = new x.a({
                words: e,
                width: t,
                attributes: new k.a({
                  alignment: "left",
                  fontIdentifier: r.getFontIdentifier()
                }),
                image: r.getImage(),
                imageInsets: r.insetsForWidth(t),
                capInsets: null,
                backgroundColor: y.Color.WHITE
              });

              return r.getNeedsImageSmoothingFix() && (o.serverImageSmoothingFix = !0), o;
            }

            return new w.a({
              words: e,
              width: t,
              attributes: n
            });
          }
        }]), t;
      }(_.a);

      M.defaultFontIdentifiers = ["imgly_font_campton_bold"], M.identifier = "imgly_text_design_blocks", M.defaultBanderoles = [b.a.Rectangle, b.a.Small], M.prototype.availableOptions = C({}, _.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: y.OptionType.ARRAY,
          default: M.defaultFontIdentifiers
        },
        relativeLineSpacing: {
          type: y.OptionType.NUMBER,
          default: .025 / 3
        },
        hasMaskedText: {
          type: y.OptionType.BOOLEAN,
          default: !1
        },
        banderoles: {
          type: y.OptionType.ARRAY,
          default: M.defaultBanderoles
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return T;
      });

      var i = n(15),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(426),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(20)),
          y = n(21),
          _ = n(47),
          v = n(429),
          b = n(78),
          w = n(26),
          x = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function k(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return r()(e);
      }

      var T = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || d()(t)).call(this, e));

          return n._relativeInsets = new y.a(), n._background = null, n._fontRandomizer = new m.a(0), n._lineNumberRandomizer = new m.a(0), n._wordsPerLineRandomizer = new m.a(0), n._seedPool = [n._fontRandomizer, n._lineNumberRandomizer, n._wordsPerLineRandomizer], n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), x(t, [{
          key: "seed",
          value: function value(e) {
            this._seedPool.forEach(function (t) {
              return t.seed(e);
            });
          }
        }, {
          key: "getImagePaths",
          value: function value() {
            return [];
          }
        }, {
          key: "onImagesLoaded",
          value: function value() {}
        }, {
          key: "getMaximumNumberOfTries",
          value: function value() {
            return 10;
          }
        }, {
          key: "getMinLineCountOfRandom",
          value: function value() {
            return 4;
          }
        }, {
          key: "getRandomAdditionalLinePercentage",
          value: function value() {
            return .4;
          }
        }, {
          key: "_fontForRow",
          value: function value(e, t) {
            return this._fontRandomizer.pickNext(this.getFontIdentifiers());
          }
        }, {
          key: "_modifiedText",
          value: function value(e) {
            return e.replace("\n", " ").replace("\t", " ");
          }
        }, {
          key: "_minimumNumberOfLines",
          value: function value(e) {
            return Math.ceil(Math.sqrt(e.size()));
          }
        }, {
          key: "_maximumNumberOfLines",
          value: function value(e) {
            return e.size();
          }
        }, {
          key: "_calculatedNumberOfLines",
          value: function value(e) {
            var t = this._minimumNumberOfLines(e);

            if (e.size() >= this.getMinLineCountOfRandom()) {
              var n = Math.floor(Math.max(1, t * this.getRandomAdditionalLinePercentage()));
              t += this._lineNumberRandomizer.nextInRange(0, n);
            }

            return Math.min(t, this._maximumNumberOfLines(e));
          }
        }, {
          key: "_randomizedNumberOfWordsPerLine",
          value: function value(e, t) {
            var n = this;
            if (e > t) return g.Log.warn("TextDesign#_randomizedNumberOfWordsPerLine: Invalid number of lines"), t;
            var i = g.Utils.Array.repeat(1, e);
            return g.Utils.Array.range(e, t).forEach(function (t) {
              var r = n._wordsPerLineRandomizer.nextInRange(0, e - 1);

              i[r] += 1;
            }), i;
          }
        }, {
          key: "_textLines",
          value: function value(e) {
            var t = new _.a(e),
                n = this._calculatedNumberOfLines(t);

            return this._randomizedNumberOfWordsPerLine(n, t.size()).reduce(function (e, n) {
              return {
                index: e.index + n,
                lines: [].concat(k(e.lines), [t.slice(e.index, Math.min(e.index + n, t.size()))])
              };
            }, {
              index: 0,
              lines: []
            }).lines;
          }
        }, {
          key: "_validTextLines",
          value: function value(e) {
            var t = this._textLines(e),
                n = 0;

            do {
              if ((n = g.Utils.Array.findIndex(t, function (e) {
                return e.countNumberOfCharacters() < 3;
              })) >= 0) {
                var i = t[n - 1],
                    r = t[n + 1];
                (i ? i.countNumberOfCharacters() : f.a) < (r ? r.countNumberOfCharacters() : f.a) && i ? (i.words = [].concat(k(i.words), k(t[n].words)), t = [].concat(k(t.slice(0, n)), k(t.slice(n + 1)))) : r && (r.words = [].concat(k(t[n].words), k(r.words)), t = [].concat(k(t.slice(0, n)), k(t.slice(n + 1))));
              }
            } while (n > -1 && t.length > 1);

            return t;
          }
        }, {
          key: "_modifiedLines",
          value: function value(e) {
            return e;
          }
        }, {
          key: "_getBackground",
          value: function value() {
            return this._background;
          }
        }, {
          key: "generateLayoutData",
          value: function value(e, t) {
            var n = this._modifiedText(e),
                i = this._modifiedLines(this._validTextLines(n)),
                r = t * (1 - this._relativeInsets.left - this._relativeInsets.right),
                o = this._layoutRows(i, r);

            return new v.a({
              text: n,
              relativeInsets: this._relativeInsets.clone(),
              relativeLineSpacing: this.getRelativeLineSpacing(),
              background: this._background || this._getBackground(),
              lines: i,
              rows: o,
              width: t
            });
          }
        }, {
          key: "_layoutRows",
          value: function value(e, t) {
            var n = this;
            return e.map(function (e, i) {
              return n._randomLayoutRow(e, i, t, new b.a({
                fontIdentifier: n._fontForRow(i, e)
              })).layout();
            });
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, t, n, i) {
            return new w.a({
              words: e,
              width: n,
              attributes: i
            });
          }
        }]), t;
      }(g.Configurable);

      T.defaultFontIdentifiers = [], T.identifier = "textdesign", T.prototype.availableOptions = {
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: []
        },
        relativeLineSpacing: {
          type: g.OptionType.NUMBER,
          default: 0
        }
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return f;
      });
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(4);

      function c(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function p(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      n.n(u);

      var f = function (e) {
        function t() {
          return c(this, t), p(this, (t.__proto__ || l()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.Configurable);

      f.prototype.availableOptions = {
        tintColor: {
          type: u.OptionType.COLOR,
          default: u.Color.BLACK
        },
        textColor: {
          type: u.OptionType.COLOR,
          default: u.Color.BLACK
        },
        alignment: {
          type: u.OptionType.STRING,
          default: "left",
          available: ["left", "center", "right"]
        },
        lineSpacing: {
          type: u.OptionType.NUMBER,
          default: 1
        },
        fontIdentifier: {
          type: u.OptionType.STRING,
          default: "imgly_font_open_sans_bold"
        }
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return w;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(33)),
          y = n(27),
          _ = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          b = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      },
          w = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || d()(t)).call(this, e)),
              i = y.a.getVariation(n.getFontIdentifier());

          return i || g.Log.warn("TextDesignFont: Unable to find font '" + n._fontIdentifier + "'"), n.set({
            fontVariation: i
          }), n._metrics = null, n._canvas = g.Utils.createCanvas(), n._context = n._canvas.getContext("2d"), n._isDirty = !0, n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_onOptionsChange",
          value: function value() {
            this._isDirty = !0;
          }
        }, {
          key: "setOption",
          value: function value(e, n) {
            var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            b(t.prototype.__proto__ || d()(t.prototype), "setOption", this).call(this, e, n, i, r), "fontIdentifier" !== e || r || this.updateFontVariation();
          }
        }, {
          key: "updateFontVariation",
          value: function value() {
            var e = y.a.getVariation(this.getFontIdentifier());
            return e || g.Log.warn("TextDesignFont: Unable to find font '" + this._fontIdentifier + "'"), this.setFontVariation(e), e;
          }
        }, {
          key: "setOptions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this._options = _({}, this._options, e), this._isDirty = !0;
          }
        }, {
          key: "_applyTextOptions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._context,
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = _({}, this._options, t),
                i = n.fontSize,
                r = n.fontVariation,
                o = n.lineHeight,
                a = n.textColor,
                s = n.alignment,
                l = r.serializeOptions(),
                u = l.fontStyle,
                c = l.fontWeight,
                p = l.fontFamily;

            e.font = u + " " + c + " " + i + "px / " + o + " " + p, e.fillStyle = a, e.textBaseline = "alphabetic", e.textAlign = s || "left";
          }
        }, {
          key: "getTextMetrics",
          value: function value() {
            return this._metrics && !this._isDirty || this._calculateTextMetrics(), _({}, this._metrics);
          }
        }, {
          key: "getSizeValue",
          value: function value() {
            return this._metrics && !this._isDirty || this._calculateTextMetrics(), new m.a(this._metrics.width, this._metrics.height);
          }
        }, {
          key: "fitWidth",
          value: function value(e) {
            if (this.getFontVariation()) {
              this._applyTextOptions(this._context, {
                fontSize: 50
              });

              var t = e / this._context.measureText(this.getText()).width,
                  n = Math.floor(50 * t);

              return this.setFontSize(n), this._calculateTextMetrics(), this.getTextMetrics();
            }

            g.Log.warn("TextDesignFont#fitText: missing font variation");
          }
        }, {
          key: "fitHeight",
          value: function value(e) {
            if (this.getFontVariation()) {
              var t = e / this._calculateTextMetrics({
                fontSize: 50
              }).height,
                  n = Math.floor(50 * t);

              return this.setFontSize(n), this._calculateTextMetrics(), this.getTextMetrics();
            }

            g.Log.warn("TextDesignFont#fitText: missing font variation");
          }
        }, {
          key: "_calculateTextMetrics",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = this._canvas,
                n = this._context,
                i = _({}, this._options, e),
                r = this.getText();

            this._applyTextOptions(n, i);

            var o = Math.ceil(n.measureText(r).width),
                a = Math.floor(o + 2 * i.fontSize),
                s = Math.floor(3 * i.fontSize);
            t.width = a, t.height = s;
            var l = Math.floor(i.fontSize),
                u = Math.floor(.6 * s);
            this._applyTextOptions(n, i), n.fillText(r, l, u);
            var c = n.getImageData(0, 0, t.width, t.height).data,
                p = C(c, a, s, u, this._options.excludeAccents),
                f = S(c, a, s, u, this._options.excludeAccents),
                h = o,
                d = p + f;
            return this._metrics = {
              width: h,
              height: d,
              ascender: p,
              descender: f
            }, this._isDirty = !1, _({}, this._metrics);
          }
        }, {
          key: "draw",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._context,
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                i = arguments[3],
                r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
            e.save(), this._metrics && !this._isDirty || this._calculateTextMetrics(), this._applyTextOptions(e, i), e.fillText(this.getText(), t, n + this._metrics.ascender), r && (R(e, t, n, this._metrics.width, this._metrics.height), O(e, n + this._metrics.ascender, t, t + this._metrics.width)), e.restore();
          }
        }]), t;
      }(g.Configurable),
          x = function x(e, t, n, i) {
        var r = n * (4 * i) + 4 * t;
        return {
          r: e[r],
          g: e[r + 1],
          b: e[r + 2],
          a: e[r + 3]
        };
      },
          k = function k(e) {
        return e.a <= 254;
      },
          T = function T(e, t, n) {
        for (var i = !0, r = 0; r < n; r++) {
          var o = x(e, r, t, n);

          if (!k(o)) {
            i = !1;
            break;
          }
        }

        return i;
      },
          S = function S(e, t, n, i) {
        for (var r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = 0, a = i + 1; a < n; a++) {
          if (T(e, a, t)) {
            if (r) break;
          } else o = a - i + 1;
        }

        return o;
      },
          C = function C(e, t, n, i) {
        for (var r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = 0, a = i - 1; a >= 0; a--) {
          if (T(e, a, t)) {
            if (r) break;
          } else o = i - a;
        }

        return o;
      },
          E = function E(e, t, n, i, r) {
        e.beginPath(), e.moveTo(t, n), e.lineTo(i, r), e.stroke();
      },
          O = function O(e, t, n, i) {
        var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "red";
        e.save(), e.strokeStyle = r, E(e, n, t, i, t), e.restore();
      },
          R = function R(e, t, n, i, r) {
        var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "blue";
        e.save(), e.strokeStyle = o, e.strokeRect(t, n, i, r), e.restore();
      };

      w.prototype.availableOptions = {
        text: {
          type: g.OptionType.STRING,
          default: ""
        },
        fontIdentifier: {
          type: g.OptionType.STRING,
          default: "imgly_font_open_sans_bold"
        },
        fontVariation: {
          type: g.OptionType.OBJECT,
          default: null
        },
        lineHeight: {
          type: g.OptionType.NUMBER,
          default: 1
        },
        fontSize: {
          type: g.OptionType.NUMBER,
          default: 22
        },
        textColor: {
          type: g.OptionType.STRING,
          default: "black"
        },
        strokeStyle: {
          type: g.OptionType.STRING,
          default: "black"
        },
        outlineWidth: {
          type: g.OptionType.NUMBER,
          default: 0
        },
        textBaseline: {
          type: g.OptionType.STRING,
          default: "alphabetic"
        },
        excludeAccents: {
          type: g.OptionType.BOOLEAN,
          default: !1
        }
      };
    }, function (e, t, n) {
      e.exports = n(430);
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return m;
      });

      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(21)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = function (e) {
        function t() {
          return d(this, t), g(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "insetsForWidth",
          value: function value(e) {
            return this.getRelativeInsets().clone().scale(e);
          }
        }]), t;
      }(p.Configurable);

      m.prototype.availableOptions = {
        imagePath: {
          type: p.OptionType.STRING,
          default: ""
        },
        minimumHeightRatio: {
          type: p.OptionType.NUMBER,
          default: 0
        },
        sizeToFitContent: {
          type: p.OptionType.BOOLEAN,
          default: !0
        },
        capInsets: {
          type: p.OptionType.OBJECT,
          default: new f.a()
        },
        relativeInsets: {
          type: p.OptionType.OBJECT,
          default: new f.a()
        }
      }, m.Box = new m({
        imagePath: "text-design/images/imgly_text_design_asset_black_background.png",
        relativeInsets: new f.a(.1, .1, .1, .1)
      }), m.Badge1 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_badge1.png",
        relativeInsets: new f.a(.3, .18, .2, .18)
      }), m.Badge2 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_badge2.png",
        relativeInsets: new f.a(.3, .18, .2, .18)
      }), m.Badge3 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_badge3.png",
        relativeInsets: new f.a(.3, .18, .2, .18)
      }), m.Badge4 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_badge4.png",
        relativeInsets: new f.a(.3, .18, .2, .18)
      }), m.SpeechBubble1 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_speech_bubble_small2.png",
        relativeInsets: new f.a(.04, .07, .12, .07),
        capInsets: new f.a(57, 171, 123, 51)
      }), m.SpeechBubble2 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_speech_bubble3.png",
        relativeInsets: new f.a(.04, .07, .12, .07),
        capInsets: new f.a(6, 105, 87, 15)
      }), m.SpeechBubble3 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_speech_bubble_small.png",
        relativeInsets: new f.a(.165664675, .2, .165664675, .2),
        minimumHeightRatio: .7
      }), m.SpeechBubble4 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_speech_bubble4.png",
        relativeInsets: new f.a(.124800224, .2, .291200523, .2),
        minimumHeightRatio: .7
      }), m.SpeechBubble5 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_speech_bubble5.png",
        relativeInsets: new f.a(.114892823, .27, .15984926, .27)
      }), m.Watercolor1 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_watercolor_01.png",
        minimumHeightRatio: .7,
        relativeInsets: new f.a(.2, .25, .2, .25)
      }), m.Watercolor2 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_watercolor_02.png",
        minimumHeightRatio: .7,
        relativeInsets: new f.a(.08, .25, .3, .25)
      }), m.Watercolor3 = new m({
        imagePath: "text-design/images/imgly_text_design_asset_watercolor_03.png",
        minimumHeightRatio: .7,
        relativeInsets: new f.a(.1, .2, .15, .2)
      });
    }, function (e, t, n) {
      var i = n(28),
          r = n(234),
          o = n(102),
          a = n(100)("IE_PROTO"),
          s = function s() {},
          _l2 = function l() {
        var e,
            t = n(94)("iframe"),
            i = o.length;

        for (t.style.display = "none", n(138).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _l2 = e.F; i--;) {
          delete _l2.prototype[o[i]];
        }

        return _l2();
      };

      e.exports = Object.create || function (e, t) {
        var n;
        return null !== e ? (s.prototype = i(e), n = new s(), s.prototype = null, n[a] = e) : n = _l2(), void 0 === t ? n : r(n, t);
      };
    }, function (e, t, n) {
      var i = n(99),
          r = Math.min;

      e.exports = function (e) {
        return e > 0 ? r(i(e), 9007199254740991) : 0;
      };
    }, function (e, t) {
      var n = 0,
          i = Math.random();

      e.exports = function (e) {
        return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + i).toString(36));
      };
    }, function (e, t, n) {
      var i = n(59),
          r = n(17)("toStringTag"),
          o = "Arguments" == i(function () {
        return arguments;
      }());

      e.exports = function (e) {
        var t, n, a;
        return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
          try {
            return e[t];
          } catch (e) {}
        }(t = Object(e), r)) ? n : o ? i(t) : "Object" == (a = i(t)) && "function" == typeof t.callee ? "Arguments" : a;
      };
    }, function (e, t, n) {
      var i = n(259),
          r = n(276),
          o = n(115),
          a = n(119),
          s = n(118),
          l = n(162),
          u = n(68),
          c = n(163),
          p = n(285),
          f = n(89),
          h = n(88),
          d = n(286),
          g = n(288),
          m = n(117),
          y = n(69),
          _ = n(292),
          v = n(161),
          b = {
        WebGLRenderer: r.a,
        CanvasRenderer: i.a,
        WebGLFilterManager: a.a,
        CanvasFilterManager: o.a,
        DisplayObject: s.a,
        Container: l.a,
        BaseTexture: u.a,
        Texture: c.a,
        RenderTexture: p.a,
        WebGLRenderTarget: f.a,
        CanvasRenderTarget: h.a,
        Sprite: d.a,
        Shaders: g.a,
        Shader: m.a,
        Filter: y.a,
        Filters: _,
        PixelArrayImage: v.a,
        autoDetectRenderer: function autoDetectRenderer(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return r.a.isSupported() ? new r.a(e, t, n) : new i.a(e, t, n);
        }
      };

      t.a = b;
    }, function (e, t, n) {
      (function (t) {
        (function () {
          var n, i, r;
          "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
            return performance.now();
          } : null != t && t.hrtime ? (e.exports = function () {
            return (n() - r) / 1e6;
          }, i = t.hrtime, r = (n = function n() {
            var e;
            return 1e9 * (e = i())[0] + e[1];
          })()) : Date.now ? (e.exports = function () {
            return Date.now() - r;
          }, r = Date.now()) : (e.exports = function () {
            return new Date().getTime() - r;
          }, r = new Date().getTime());
        }).call(this);
      }).call(t, n(152));
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(12),
          a = n(68),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t, n, i, r, o) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._width = t, this._height = n, this._pixelRatio = i, this._baseTexture = new a.a(), this._canvas = r || this._createCanvas(), this._context = o || this._canvas.getContext("2d"), this._baseTexture.setSource(this._canvas), this._canvas.width = this._width * this._pixelRatio, this._canvas.height = this._height * this._pixelRatio, this._filterStack = [{
            renderTarget: this,
            filter: []
          }];
        }

        return s(e, [{
          key: "_createCanvas",
          value: function value() {
            return o.i.createCanvas();
          }
        }, {
          key: "clear",
          value: function value() {
            var e = this._context;
            e.setTransform(1, 0, 0, 1, 0, 0), e.clearRect(0, 0, this._width * this._pixelRatio, this._height * this._pixelRatio);
          }
        }, {
          key: "resizeTo",
          value: function value(e) {
            this._baseTexture.resizeTo(e), this._width !== e.x && (this._width = e.x, this._canvas.width = this._width * this._pixelRatio), this._height !== e.y && (this._height = e.y, this._canvas.height = this._height * this._pixelRatio);
          }
        }, {
          key: "getCanvas",
          value: function value() {
            return this._canvas;
          }
        }, {
          key: "getContext",
          value: function value() {
            return this._context;
          }
        }, {
          key: "getFilterStack",
          value: function value() {
            return this._filterStack;
          }
        }, {
          key: "getWidth",
          value: function value() {
            return this._width;
          }
        }, {
          key: "getHeight",
          value: function value() {
            return this._height;
          }
        }, {
          key: "getPixelRatio",
          value: function value() {
            return this._pixelRatio;
          }
        }, {
          key: "setPixelRatio",
          value: function value(e) {
            this._pixelRatio = e;
          }
        }, {
          key: "getDimensions",
          value: function value() {
            return new o.k(this._width, this._height);
          }
        }, {
          key: "getBaseTexture",
          value: function value() {
            return this._baseTexture;
          }
        }, {
          key: "dispose",
          value: function value() {
            this._canvas = null, this._context = null, this._baseTexture.dispose();
          }
        }]), e;
      }();

      t.a = l;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(12),
          a = n(68),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function l(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var u = function () {
        function e(t, n, i, r) {
          var s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
          l(this, e), this._renderer = t, this._gl = t.getContext(), this._width = n, this._height = i, this._frame = null, this._pixelRatio = r, this._projectionMatrix = new o.g(), this._mipMapping = !1, this._baseTexture = new a.a();

          var u = this._baseTexture.getFrame();

          u.width = n, u.height = i, this._baseTexture.setPixelRatio(r), this._baseTexture.setLoaded(!0), this._framebuffer = null, this._isRoot = s, this._filterStack = [{
            renderTarget: this,
            filter: []
          }], s || this._initFrameBuffer();
        }

        return s(e, [{
          key: "resizeTo",
          value: function value(e) {
            this._width = 0 | e.x, this._height = 0 | e.y, this._baseTexture.resizeTo(e), this._isRoot || this._resizeTexture(), this._baseTexture.setMinFilter(this._getMinFilter()), this._baseTexture.setMagFilter(this._getMagFilter()), this._calculateProjectionMatrix();
          }
        }, {
          key: "_getMinFilter",
          value: function value() {
            var e = a.a.DefaultMinFilter;
            return this._mipMapping && (e = a.a.TrilinearFilter), e;
          }
        }, {
          key: "_getMagFilter",
          value: function value() {
            return a.a.DefaultMagFilter;
          }
        }, {
          key: "_resizeTexture",
          value: function value() {
            var e = this._gl,
                t = this._width * this._pixelRatio,
                n = this._height * this._pixelRatio;
            this._texture && (e.deleteTexture(this._texture), this._texture = null), this._texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this._texture), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, t, n, 0, e.RGBA, e.UNSIGNED_BYTE, null), e.bindFramebuffer(e.FRAMEBUFFER, this._framebuffer), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, this._texture, 0), this._baseTexture.setGLTextureForRenderer(this._texture, this._renderer), this._renderer._options.debug && o.e.checkFramebufferStatus("WebGLRenderTarget#_initFramebuffer", e);
            var i = new o.k(this._width, this._height);
            o.i.isPowerOfTwo(i) ? (o.f.info("WebGLRenderTarget", "Mip-mapping enabled"), this._mipMapping = !0) : this._mipMapping = !1, this._baseTexture.setMipMappingEnabled(this._mipMapping);
          }
        }, {
          key: "activate",
          value: function value() {
            var e = this._gl;
            e.bindFramebuffer(e.FRAMEBUFFER, this._framebuffer), this._calculateProjectionMatrix(), e.viewport(0, 0, this._width * this._pixelRatio, this._height * this._pixelRatio), e.disable(e.STENCIL_TEST);
          }
        }, {
          key: "clear",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : o.b.TRANSPARENT,
                t = this._gl;
            t.bindFramebuffer(t.FRAMEBUFFER, this._framebuffer), this._renderer._options.debug && o.e.checkFramebufferStatus("WebGLRenderTarget#clear", t), t.clearColor.apply(t, e.toGLColor()), t.clear(t.COLOR_BUFFER_BIT);
          }
        }, {
          key: "_calculateProjectionMatrix",
          value: function value() {
            var e = this._projectionMatrix;
            e.reset();
            var t = this._frame || new o.h(0, 0, this._width, this._height),
                n = t.x,
                i = t.y;
            this._isRoot ? (e.a = 1 / this._width * 2, e.d = -1 / this._height * 2, e.tx = -1 - n * e.a, e.ty = 1 - i * e.d) : (e.a = 1 / this._width * 2, e.d = 1 / this._height * 2, e.tx = -1 - n * e.a, e.ty = -1 - i * e.d);
          }
        }, {
          key: "_initFrameBuffer",
          value: function value() {
            var e = this._gl;
            this._framebuffer && (e.deleteFramebuffer(this._framebuffer), this._framebuffer = null), this._texture && (e.deleteTexture(this._texture), this._texture = null), this._framebuffer = e.createFramebuffer(), this._texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this._texture), e.bindFramebuffer(e.FRAMEBUFFER, this._framebuffer), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, this._texture, 0), this._baseTexture.setGLTextureForRenderer(this._texture, this._renderer), this.resizeTo(new o.k(this._width, this._height)), this._renderer._options.debug && o.e.checkFramebufferStatus("WebGLRenderTarget#_initFramebuffer", e);
          }
        }, {
          key: "getProjectionMatrix",
          value: function value() {
            return this._projectionMatrix;
          }
        }, {
          key: "getTexture",
          value: function value() {
            return this._texture;
          }
        }, {
          key: "getFrame",
          value: function value() {
            return this._frame;
          }
        }, {
          key: "setFrame",
          value: function value(e) {
            this._frame = e;
          }
        }, {
          key: "getFilterStack",
          value: function value() {
            return this._filterStack;
          }
        }, {
          key: "getPixelRatio",
          value: function value() {
            return this._pixelRatio;
          }
        }, {
          key: "setPixelRatio",
          value: function value(e) {
            this._pixelRatio = e, this._isRoot || this._resizeTexture();
          }
        }, {
          key: "getBaseTexture",
          value: function value() {
            return this._baseTexture;
          }
        }, {
          key: "dispose",
          value: function value() {
            var e = this._gl;
            this._baseTexture.dispose(), this._framebuffer && (e.deleteFramebuffer(this._framebuffer), this._framebuffer = null), this._texture && (e.deleteTexture(this._texture), this._texture = null);
          }
        }]), e;
      }();

      t.a = u;
    }, function (e, t, n) {
      var i;
      i = window.Image, t.a = i;
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return r;
      });
      var i = n(301),
          r = {
        EXPORT: "export",
        CLOSE: "close",
        OPERATION_CREATED: "operation:created",
        OPERATION_UPDATED: "operation:updated",
        OPERATION_REMOVED: "operation:removed",
        EDITOR_READY: "editor:ready",
        WINDOW_RESIZE: "window:resize",
        ZOOM_DONE: "editor:zoom_done",
        HISTORY_UNDO: "history:undo",
        HISTORY_UPDATED: "history:update",
        FEATURES_DISABLED: "editor:features:disabled",
        FEATURES_ENABLED: "editor:features:enabled",
        FEATURES_UPDATED: "editor:features:updated",
        TRANSFORM_REAPPLY_RATIO: "transform:reapply_ratio"
      };
      t.b = {
        DEFAULTS: {
          ART_FILTERS: i.a,
          FILTERS: [{
            identifier: "imgly_filters_duotone",
            defaultName: "DuoTone",
            assetFileName: "duotone",
            filters: [{
              identifier: "imgly_duotone_desert",
              defaultName: "Desert",
              lightColor: "#e1de9a",
              darkColor: "#cb2129"
            }, {
              identifier: "imgly_duotone_peach",
              defaultName: "Peach",
              lightColor: "#e9abb8",
              darkColor: "#0040ff"
            }, {
              identifier: "imgly_duotone_clash",
              defaultName: "Clash",
              lightColor: "#f41a0f",
              darkColor: "#23007c"
            }, {
              identifier: "imgly_duotone_plum",
              defaultName: "Plum",
              lightColor: "#74d7ff",
              darkColor: "#23007c"
            }, {
              identifier: "imgly_duotone_breezy",
              defaultName: "Breezy",
              lightColor: "#68fdff",
              darkColor: "#c20000"
            }, {
              identifier: "imgly_duotone_deepblue",
              defaultName: "Deep Blue",
              lightColor: "#2de9eb",
              darkColor: "#58007c"
            }, {
              identifier: "imgly_duotone_frog",
              defaultName: "Frog",
              lightColor: "#5bff60",
              darkColor: "#7f23a9"
            }, {
              identifier: "imgly_duotone_sunset",
              defaultName: "Sunset",
              lightColor: "#f8ea46",
              darkColor: "#c400be"
            }]
          }, {
            identifier: "imgly_filters_bw",
            assetFileName: "b&w",
            defaultName: "Black & White",
            filters: [{
              identifier: "imgly_lut_ad1920",
              defaultName: "1920 A.D.",
              lutImage: "filters/imgly_lut_ad1920_5_5_128.png"
            }, {
              identifier: "imgly_lut_bw",
              defaultName: "Greyed",
              lutImage: "filters/imgly_lut_bw_5_5_128.png"
            }, {
              identifier: "imgly_lut_x400",
              defaultName: "Dusty",
              lutImage: "filters/imgly_lut_dusty_5_5_128.png"
            }, {
              identifier: "imgly_lut_litho",
              defaultName: "Litho",
              lutImage: "filters/imgly_lut_litho_5_5_128.png"
            }, {
              identifier: "imgly_lut_sepiahigh",
              defaultName: "Sepia",
              lutImage: "filters/imgly_lut_sepia_5_5_128.png"
            }, {
              identifier: "imgly_lut_plate",
              defaultName: "Weathered",
              lutImage: "filters/imgly_lut_weathered_5_5_128.png"
            }, {
              identifier: "imgly_lut_sin",
              defaultName: "Hard Stuff",
              lutImage: "filters/imgly_lut_hard_stuff_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }]
          }, {
            identifier: "imgly_filters_retro",
            assetFileName: "vintage",
            defaultName: "Vintage",
            filters: [{
              identifier: "imgly_lut_blues",
              defaultName: "Polaroid",
              lutImage: "filters/imgly_lut_polaroid_5_5_128.png"
            }, {
              identifier: "imgly_lut_front",
              defaultName: "Sunny 70s",
              lutImage: "filters/imgly_lut_sunny_70s_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_texas",
              defaultName: "Oldtimer",
              lutImage: "filters/imgly_lut_oldtimer_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_celsius",
              defaultName: "Inferno",
              lutImage: "filters/imgly_lut_inferno_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_cool",
              defaultName: "Snappy",
              lutImage: "filters/imgly_lut_snappy_5_5_128.png"
            }]
          }, {
            identifier: "imgly_filters_analog",
            assetFileName: "smooth",
            defaultName: "Smooth",
            filters: [{
              identifier: "imgly_lut_chest",
              defaultName: "Chestnut",
              lutImage: "filters/imgly_lut_chestnut_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_winter",
              defaultName: "Softly",
              lutImage: "filters/imgly_lut_softly_5_5_128.png"
            }, {
              identifier: "imgly_lut_kdynamic",
              defaultName: "Pebble",
              lutImage: "filters/imgly_lut_pebble_5_5_128.png"
            }, {
              identifier: "imgly_lut_fall",
              defaultName: "Moss",
              lutImage: "filters/imgly_lut_moss_5_5_128.png"
            }, {
              identifier: "imgly_lut_lenin",
              defaultName: "Lemon",
              lutImage: "filters/imgly_lut_lemon_5_5_128.png"
            }, {
              identifier: "imgly_lut_pola669",
              defaultName: "Green Gap",
              lutImage: "filters/imgly_lut_green_gap_5_5_128.png"
            }]
          }, {
            identifier: "imgly_filters_winter",
            assetFileName: "cold",
            defaultName: "Cold",
            filters: [{
              identifier: "imgly_lut_elder",
              defaultName: "Colla",
              lutImage: "filters/imgly_lut_colla_5_5_128.png"
            }, {
              identifier: "imgly_lut_orchid",
              defaultName: "Solanus",
              lutImage: "filters/imgly_lut_solanus_5_5_128.png"
            }, {
              identifier: "imgly_lut_bleached",
              defaultName: "Kalmen",
              lutImage: "filters/imgly_lut_kalmen_5_5_128.png"
            }, {
              identifier: "imgly_lut_bleachedblue",
              defaultName: "Joran",
              lutImage: "filters/imgly_lut_joran_5_5_128.png"
            }, {
              identifier: "imgly_lut_breeze",
              defaultName: "Levante",
              lutImage: "filters/imgly_lut_levante_5_5_128.png"
            }, {
              identifier: "imgly_lut_blueshadows",
              defaultName: "Zephyr",
              lutImage: "filters/imgly_lut_zephyr_5_5_128.png"
            }]
          }, {
            identifier: "imgly_filters_summer",
            assetFileName: "warm",
            defaultName: "Warm",
            filters: [{
              identifier: "imgly_lut_sunset",
              defaultName: "Golden",
              lutImage: "filters/imgly_lut_golden_5_5_128.png"
            }, {
              identifier: "imgly_lut_eighties",
              defaultName: "Low Fire",
              lutImage: "filters/imgly_lut_low_fire_5_5_128.png"
            }, {
              identifier: "imgly_lut_evening",
              defaultName: "Sunrise",
              lutImage: "filters/imgly_lut_sunrise_5_5_128.png"
            }, {
              identifier: "imgly_lut_k2",
              defaultName: "Flat Black",
              lutImage: "filters/imgly_lut_flat_black_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_nogreen",
              defaultName: "Pumpkin",
              lutImage: "filters/imgly_lut_pumpkin_5_5_128.png"
            }]
          }, {
            identifier: "imgly_filters_legacy",
            defaultName: "Legacy",
            assetFileName: "legacy",
            filters: [{
              identifier: "imgly_lut_ancient",
              defaultName: "Ancient",
              lutImage: "filters/imgly_lut_ancient_5_5_128.png"
            }, {
              identifier: "imgly_lut_cottoncandy",
              defaultName: "Candy",
              lutImage: "filters/imgly_lut_cottoncandy_5_5_128.png"
            }, {
              identifier: "imgly_lut_classic",
              defaultName: "Classic",
              lutImage: "filters/imgly_lut_classic_5_5_128.png"
            }, {
              identifier: "imgly_lut_colorful",
              defaultName: "Colorful",
              lutImage: "filters/imgly_lut_colorful_5_5_128.png"
            }, {
              identifier: "imgly_lut_creamy",
              defaultName: "Creamy",
              lutImage: "filters/imgly_lut_creamy_5_5_128.png"
            }, {
              identifier: "imgly_lut_fixie",
              defaultName: "Fixie",
              lutImage: "filters/imgly_lut_fixie_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_food",
              defaultName: "Food",
              lutImage: "filters/imgly_lut_food_5_5_128.png"
            }, {
              identifier: "imgly_lut_fridge",
              defaultName: "Fridge",
              lutImage: "filters/imgly_lut_fridge_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_glam",
              defaultName: "Glam",
              lutImage: "filters/imgly_lut_glam_5_5_128.png"
            }, {
              identifier: "imgly_lut_gobblin",
              defaultName: "Gobblin",
              lutImage: "filters/imgly_lut_gobblin_5_5_128.png"
            }, {
              identifier: "imgly_lut_highcontrast",
              defaultName: "Hicon",
              lutImage: "filters/imgly_lut_highcontrast_5_5_128.png"
            }, {
              identifier: "imgly_lut_highcarb",
              defaultName: "High Carb",
              lutImage: "filters/imgly_lut_highcarb_5_5_128.png"
            }, {
              identifier: "imgly_lut_k1",
              defaultName: "K1",
              lutImage: "filters/imgly_lut_k1_5_5_128.png"
            }, {
              identifier: "imgly_lut_k6",
              defaultName: "K6",
              lutImage: "filters/imgly_lut_k6_5_5_128.png"
            }, {
              identifier: "imgly_lut_keen",
              defaultName: "Keen",
              lutImage: "filters/imgly_lut_keen_5_5_128.png"
            }, {
              identifier: "imgly_lut_lomo",
              defaultName: "Lomo",
              lutImage: "filters/imgly_lut_lomo_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_lomo100",
              defaultName: "Lomo 100",
              lutImage: "filters/imgly_lut_lomo100_5_5_128.png"
            }, {
              identifier: "imgly_lut_lucid",
              defaultName: "Lucid",
              lutImage: "filters/imgly_lut_lucid_5_5_128.png"
            }, {
              identifier: "imgly_lut_mellow",
              defaultName: "Mellow",
              lutImage: "filters/imgly_lut_mellow_8_8_512.png",
              resolution: 512,
              horizontalTileCount: 8,
              verticalTileCount: 8
            }, {
              identifier: "imgly_lut_neat",
              defaultName: "Neat",
              lutImage: "filters/imgly_lut_neat_5_5_128.png"
            }, {
              identifier: "imgly_lut_pale",
              defaultName: "Pale",
              lutImage: "filters/imgly_lut_pale_5_5_128.png"
            }, {
              identifier: "imgly_lut_pitched",
              defaultName: "Pitched",
              lutImage: "filters/imgly_lut_pitched_5_5_128.png"
            }, {
              identifier: "imgly_lut_polasx",
              defaultName: "Pola SX",
              lutImage: "filters/imgly_lut_polasx_5_5_128.png"
            }, {
              identifier: "imgly_lut_pro400",
              defaultName: "Pro 400",
              lutImage: "filters/imgly_lut_pro400_5_5_128.png"
            }, {
              identifier: "imgly_lut_quozi",
              defaultName: "Quozi",
              lutImage: "filters/imgly_lut_quozi_5_5_128.png"
            }, {
              identifier: "imgly_lut_settled",
              defaultName: "Settled",
              lutImage: "filters/imgly_lut_settled_5_5_128.png"
            }, {
              identifier: "imgly_lut_seventies",
              defaultName: "Seventies",
              lutImage: "filters/imgly_lut_seventies_5_5_128.png"
            }, {
              identifier: "imgly_lut_soft",
              defaultName: "Soft",
              lutImage: "filters/imgly_lut_soft_5_5_128.png"
            }, {
              identifier: "imgly_lut_steel",
              defaultName: "Steel",
              lutImage: "filters/imgly_lut_steel_5_5_128.png"
            }, {
              identifier: "imgly_lut_summer",
              defaultName: "Summer",
              lutImage: "filters/imgly_lut_summer_5_5_128.png"
            }, {
              identifier: "imgly_lut_tender",
              defaultName: "Tender",
              lutImage: "filters/imgly_lut_tender_5_5_128.png"
            }, {
              identifier: "imgly_lut_twilight",
              defaultName: "Twilight",
              lutImage: "filters/imgly_lut_twilight_5_5_128.png"
            }]
          }],
          OVERLAYS: [{
            identifier: "imgly_overlay_golden",
            defaultName: "Golden",
            image: "overlays/imgly_overlay_golden.jpg",
            thumbnail: "overlays/imgly_overlay_golden_thumb.jpg",
            blendMode: "lighten"
          }, {
            identifier: "imgly_overlay_bokeh",
            defaultName: "Bokeh",
            image: "overlays/imgly_overlay_bokeh.jpg",
            thumbnail: "overlays/imgly_overlay_bokeh_thumb.jpg",
            blendMode: "lighten"
          }, {
            identifier: "imgly_overlay_hearts",
            defaultName: "Hearts",
            image: "overlays/imgly_overlay_hearts.jpg",
            thumbnail: "overlays/imgly_overlay_hearts_thumb.jpg",
            blendMode: "screen"
          }, {
            identifier: "imgly_overlay_lightleak1",
            defaultName: "Light Leak",
            image: "overlays/imgly_overlay_lightleak1.jpg",
            thumbnail: "overlays/imgly_overlay_lightleak1_thumb.jpg",
            blendMode: "screen"
          }, {
            identifier: "imgly_overlay_lightleak2",
            defaultName: "Light Leak 2",
            image: "overlays/imgly_overlay_lightleak2.jpg",
            thumbnail: "overlays/imgly_overlay_lightleak2_thumb.jpg",
            blendMode: "lighten"
          }, {
            identifier: "imgly_overlay_rain",
            defaultName: "Rain",
            image: "overlays/imgly_overlay_rain.jpg",
            thumbnail: "overlays/imgly_overlay_rain_thumb.jpg",
            blendMode: "overlay"
          }, {
            identifier: "imgly_overlay_wood",
            defaultName: "Wood",
            image: "overlays/imgly_overlay_wood.jpg",
            thumbnail: "overlays/imgly_overlay_wood_thumb.jpg",
            blendMode: "multiply"
          }, {
            identifier: "imgly_overlay_mosaic",
            defaultName: "Mosaic",
            image: "overlays/imgly_overlay_mosaic.jpg",
            thumbnail: "overlays/imgly_overlay_mosaic_thumb.jpg",
            blendMode: "multiply"
          }, {
            identifier: "imgly_overlay_chop",
            defaultName: "Chop",
            image: "overlays/imgly_overlay_chop.jpg",
            thumbnail: "overlays/imgly_overlay_chop_thumb.jpg",
            blendMode: "multiply"
          }, {
            identifier: "imgly_overlay_vintage",
            defaultName: "Vintage",
            image: "overlays/imgly_overlay_vintage.jpg",
            thumbnail: "overlays/imgly_overlay_vintage_thumb.jpg",
            blendMode: "darken"
          }, {
            identifier: "imgly_overlay_metal",
            defaultName: "Metal",
            image: "overlays/imgly_overlay_metal.jpg",
            thumbnail: "overlays/imgly_overlay_metal_thumb.jpg",
            blendMode: "overlay"
          }, {
            identifier: "imgly_overlay_paper",
            defaultName: "Paper",
            image: "overlays/imgly_overlay_paper.jpg",
            thumbnail: "overlays/imgly_overlay_paper_thumb.jpg",
            blendMode: "multiply"
          }, {
            identifier: "imgly_overlay_painting",
            defaultName: "Painting",
            image: "overlays/imgly_overlay_painting.jpg",
            thumbnail: "overlays/imgly_overlay_painting_thumb.jpg",
            blendMode: "overlay"
          }, {
            identifier: "imgly_overlay_grain",
            defaultName: "Grain",
            image: "overlays/imgly_overlay_grain.jpg",
            thumbnail: "overlays/imgly_overlay_grain_thumb.jpg",
            blendMode: "overlay"
          }, {
            identifier: "imgly_overlay_clouds",
            defaultName: "Clouds",
            image: "overlays/imgly_overlay_clouds.jpg",
            thumbnail: "overlays/imgly_overlay_clouds_thumb.jpg",
            blendMode: "softLight"
          }, {
            identifier: "imgly_overlay_wall1",
            defaultName: "Wall",
            image: "overlays/imgly_overlay_wall1.jpg",
            thumbnail: "overlays/imgly_overlay_wall1_thumb.jpg",
            blendMode: "lighten"
          }, {
            identifier: "imgly_overlay_wall2",
            defaultName: "Wall 2",
            image: "overlays/imgly_overlay_wall2.jpg",
            thumbnail: "overlays/imgly_overlay_wall2_thumb.jpg",
            blendMode: "overlay"
          }],
          FRAME_CATEGORIES: [{
            identifier: "imgly_frame_generic",
            defaultName: "Generic",
            metaData: {
              backgroundImage: "frames/generic.png"
            },
            frames: [{
              identifier: "imgly_frame_dia",
              defaultName: "Dia",
              layoutMode: "horizontal-inside",
              thumbnail: "frames/imgly_frame_dia/imgly_frame_dia_thumb.png",
              imageGroups: {
                top: {
                  mid: {
                    image: "frames/imgly_frame_dia/imgly_frame_dia_top.png",
                    mode: "repeat"
                  }
                },
                left: {
                  start: "frames/imgly_frame_dia/imgly_frame_dia_top_corner_left.png",
                  mid: "frames/imgly_frame_dia/imgly_frame_dia_left.png",
                  end: "frames/imgly_frame_dia/imgly_frame_dia_bottom_corner_left.png"
                },
                right: {
                  start: "frames/imgly_frame_dia/imgly_frame_dia_top_corner_right.png",
                  mid: "frames/imgly_frame_dia/imgly_frame_dia_right.png",
                  end: "frames/imgly_frame_dia/imgly_frame_dia_bottom_corner_right.png"
                },
                bottom: {
                  mid: {
                    image: "frames/imgly_frame_dia/imgly_frame_dia_bottom.png",
                    mode: "repeat"
                  }
                }
              }
            }, {
              identifier: "imgly_frame_art_decor",
              defaultName: "Art Decor",
              tintable: !0,
              layoutMode: "horizontal-inside",
              thumbnail: "frames/imgly_frame_art_decor/imgly_frame_art_decor_thumb.png",
              imageGroups: {
                top: {
                  start: "frames/imgly_frame_art_decor/imgly_frame_art_decor_top_corner_left.png",
                  mid: {
                    image: "frames/imgly_frame_art_decor/imgly_frame_art_decor_top.png",
                    mode: "stretch"
                  },
                  end: "frames/imgly_frame_art_decor/imgly_frame_art_decor_top_corner_right.png"
                },
                left: {
                  mid: {
                    image: "frames/imgly_frame_art_decor/imgly_frame_art_decor_left.png",
                    mode: "stretch"
                  }
                },
                right: {
                  mid: {
                    image: "frames/imgly_frame_art_decor/imgly_frame_art_decor_right.png",
                    mode: "stretch"
                  }
                },
                bottom: {
                  start: "frames/imgly_frame_art_decor/imgly_frame_art_decor_bottom_corner_left.png",
                  mid: {
                    image: "frames/imgly_frame_art_decor/imgly_frame_art_decor_bottom.png",
                    mode: "stretch"
                  },
                  end: "frames/imgly_frame_art_decor/imgly_frame_art_decor_bottom_corner_right.png"
                }
              }
            }, {
              identifier: "imgly_frame_black_passepartout",
              defaultName: "Black Passepartout",
              layoutMode: "horizontal-inside",
              thumbnail: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_thumb.png",
              imageGroups: {
                top: {
                  start: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top_corner_left.png",
                  mid: {
                    image: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top.png",
                    mode: "stretch"
                  },
                  end: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top_corner_right.png"
                },
                left: {
                  mid: {
                    image: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_left.png",
                    mode: "stretch"
                  }
                },
                right: {
                  mid: {
                    image: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_right.png",
                    mode: "stretch"
                  }
                },
                bottom: {
                  start: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom_corner_left.png",
                  mid: {
                    image: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom.png",
                    mode: "stretch"
                  },
                  end: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom_corner_right.png"
                }
              }
            }, {
              identifier: "imgly_frame_lowpoly_shadow",
              defaultName: "Low Poly",
              layoutMode: "horizontal-inside",
              thumbnail: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_thumb.png",
              imageGroups: {
                top: {
                  start: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top_corner_left.png",
                  mid: {
                    image: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top.png",
                    mode: "stretch"
                  },
                  end: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top_corner_right.png"
                },
                left: {
                  mid: {
                    image: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_left.png",
                    mode: "stretch"
                  }
                },
                right: {
                  mid: {
                    image: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_right.png",
                    mode: "stretch"
                  }
                },
                bottom: {
                  start: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom_corner_left.png",
                  mid: {
                    image: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom.png",
                    mode: "stretch"
                  },
                  end: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom_corner_right.png"
                }
              }
            }, {
              identifier: "imgly_frame_wood_passepartout",
              defaultName: "Wood Passepartout",
              layoutMode: "horizontal-inside",
              thumbnail: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_thumb.png",
              imageGroups: {
                top: {
                  start: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top_corner_left.png",
                  mid: {
                    image: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top.png",
                    mode: "stretch"
                  },
                  end: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top_corner_right.png"
                },
                left: {
                  mid: {
                    image: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_left.png",
                    mode: "stretch"
                  }
                },
                right: {
                  mid: {
                    image: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_right.png",
                    mode: "stretch"
                  }
                },
                bottom: {
                  start: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom_corner_left.png",
                  mid: {
                    image: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom.png",
                    mode: "stretch"
                  },
                  end: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom_corner_right.png"
                }
              }
            }]
          }],
          STICKER_CATEGORIES: [{
            identifier: "imgly_sticker_emoticons",
            defaultName: "Emoticons",
            metaData: {
              backgroundImage: "stickers/emoticons/background.png"
            },
            stickers: [{
              identifier: "imgly_sticker_emoticons_alien",
              defaultName: "Alien",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_alien.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_alien.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_alien.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_alien.png"],
                  width: 1e3,
                  height: 935
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_angel",
              defaultName: "Angel",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_angel.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_angel.png"],
                  width: 62,
                  height: 64
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_angel.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_angel.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_angry",
              defaultName: "Angry",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_angry.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_angry.png"],
                  width: 62,
                  height: 62
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_angry.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_angry.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_anxious",
              defaultName: "Anxious",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_anxious.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_anxious.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_anxious.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_anxious.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_asleep",
              defaultName: "Asleep",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_asleep.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_asleep.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_asleep.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_asleep.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_attention",
              defaultName: "Attention",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_attention.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_attention.png"],
                  width: 62,
                  height: 60
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_attention.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_attention.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_baby_chicken",
              defaultName: "Baby Chicken",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_baby_chicken.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_baby_chicken.png"],
                  width: 61,
                  height: 42
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_baby_chicken.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_baby_chicken.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_batman",
              defaultName: "Batman",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_batman.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_batman.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_batman.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_batman.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_beer",
              defaultName: "Beer",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_beer.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_beer.png"],
                  width: 62,
                  height: 59
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_beer.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_beer.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_blush",
              defaultName: "Blush",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_blush.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_blush.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_blush.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_blush.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_boxer",
              defaultName: "Boxer",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_boxer.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_boxer.png"],
                  width: 62,
                  height: 62
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_boxer.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_boxer.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_business",
              defaultName: "Business",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_business.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_business.png"],
                  width: 60,
                  height: 63
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_business.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_business.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_chicken",
              defaultName: "Chicken",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_chicken.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_chicken.png"],
                  width: 63,
                  height: 55
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_chicken.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_chicken.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_cool",
              defaultName: "Cool",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_cool.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_cool.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_cool.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_cool.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_cry",
              defaultName: "Cry",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_cry.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_cry.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_cry.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_cry.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_deceased",
              defaultName: "Deceased",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_deceased.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_deceased.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_deceased.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_deceased.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_devil",
              defaultName: "Devil",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_devil.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_devil.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_devil.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_devil.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_duckface",
              defaultName: "Duckface",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_duckface.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_duckface.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_duckface.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_duckface.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_furious",
              defaultName: "Furious",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_furious.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_furious.png"],
                  width: 62,
                  height: 61
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_furious.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_furious.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_grin",
              defaultName: "Grin",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_grin.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_grin.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_grin.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_grin.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_guitar",
              defaultName: "Guitar",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_guitar.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_guitar.png"],
                  width: 64,
                  height: 60
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_guitar.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_guitar.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_harry_potter",
              defaultName: "Harry Potter",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_harry_potter.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_harry_potter.png"],
                  width: 64,
                  height: 62
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_harry_potter.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_harry_potter.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_hippie",
              defaultName: "Hippie",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_hippie.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_hippie.png"],
                  width: 62,
                  height: 62
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_hippie.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_hippie.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_hitman",
              defaultName: "Hitman",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_hitman.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_hitman.png"],
                  width: 64,
                  height: 60
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_hitman.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_hitman.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_humourous",
              defaultName: "Humourous",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_humourous.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_humourous.png"],
                  width: 64,
                  height: 64
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_humourous.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_humourous.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_idea",
              defaultName: "Idea",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_idea.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_idea.png"],
                  width: 64,
                  height: 62
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_idea.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_idea.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_impatient",
              defaultName: "Impatient",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_impatient.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_impatient.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_impatient.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_impatient.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_kiss",
              defaultName: "Kiss",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_kiss.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_kiss.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_kiss.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_kiss.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_kisses",
              defaultName: "Kisses",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_kisses.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_kisses.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_kisses.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_kisses.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_laugh",
              defaultName: "Laugh",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_laugh.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_laugh.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_laugh.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_laugh.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_loud_cry",
              defaultName: "Loud Cry",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_loud_cry.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_loud_cry.png"],
                  width: 64,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_loud_cry.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_loud_cry.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_loving",
              defaultName: "Loving",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_loving.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_loving.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_loving.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_loving.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_masked",
              defaultName: "Masked",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_masked.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_masked.png"],
                  width: 62,
                  height: 62
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_masked.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_masked.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_music",
              defaultName: "Music",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_music.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_music.png"],
                  width: 62,
                  height: 54
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_music.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_music.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_nerd",
              defaultName: "Nerd",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_nerd.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_nerd.png"]
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_nerd.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_nerd.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_ninja",
              defaultName: "Ninja",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_ninja.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_ninja.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_ninja.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_ninja.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_not_speaking_to_you",
              defaultName: "Not Speaking To You",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_not_speaking_to_you.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_not_speaking_to_you.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_not_speaking_to_you.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_not_speaking_to_you.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_pig",
              defaultName: "Pig",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_pig.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_pig.png"],
                  width: 63,
                  height: 41
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_pig.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_pig.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_pumpkin",
              defaultName: "Pumpkin",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_pumpkin.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_pumpkin.png"],
                  width: 62,
                  height: 60
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_pumpkin.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_pumpkin.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_question",
              defaultName: "Question",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_question.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_question.png"],
                  width: 62,
                  height: 62
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_question.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_question.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_rabbit",
              defaultName: "Rabbit",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_rabbit.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_rabbit.png"],
                  width: 65,
                  height: 47
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_rabbit.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_rabbit.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_sad",
              defaultName: "Sad",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sad.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sad.png"]
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sad.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sad.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_sick",
              defaultName: "Sick",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sick.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sick.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sick.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sick.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_skateboard",
              defaultName: "Skateboard",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_skateboard.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_skateboard.png"],
                  width: 62,
                  height: 64
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_skateboard.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_skateboard.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_skull",
              defaultName: "Skull",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_skull.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_skull.png"],
                  width: 62,
                  height: 62
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_skull.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_skull.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_sleepy",
              defaultName: "Sleepy",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sleepy.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sleepy.png"],
                  width: 62,
                  height: 60
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sleepy.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sleepy.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_smile",
              defaultName: "Smile",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_smile.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_smile.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_smile.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_smile.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_smoking",
              defaultName: "Smoking",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_smoking.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_smoking.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_smoking.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_smoking.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_sobbing",
              defaultName: "Sobbing",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sobbing.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sobbing.png"],
                  width: 62,
                  height: 59
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sobbing.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sobbing.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_star",
              defaultName: "Star",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_star.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_star.png"],
                  width: 64,
                  height: 64
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_star.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_star.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_steaming_furious",
              defaultName: "Steaming Furious",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_steaming_furious.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_steaming_furious.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_steaming_furious.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_steaming_furious.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_sunbathing",
              defaultName: "Sunbathing",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sunbathing.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sunbathing.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sunbathing.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sunbathing.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_tired",
              defaultName: "Tired",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_tired.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_tired.png"],
                  width: 62,
                  height: 60
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_tired.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_tired.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_tongue_out_wink",
              defaultName: "Tongue Out Wink",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_tongue_out_wink.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_tongue_out_wink.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_tongue_out_wink.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_tongue_out_wink.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_wave",
              defaultName: "Wave",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wave.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_wave.png"],
                  width: 62,
                  height: 60
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wave.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_wave.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_wide_grin",
              defaultName: "Wide Grin",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wide_grin.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_wide_grin.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wide_grin.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_wide_grin.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_wink",
              defaultName: "Wink",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wink.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_wink.png"],
                  width: 62,
                  height: 58
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wink.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_wink.png"]
                }
              }
            }, {
              identifier: "imgly_sticker_emoticons_wrestler",
              defaultName: "Wrestler",
              images: {
                mediaThumb: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wrestler.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_wrestler.png"],
                  width: 62,
                  height: 60
                },
                mediaBase: {
                  uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wrestler.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_wrestler.png"]
                }
              }
            }]
          }, {
            identifier: "imgly_sticker_shapes",
            defaultName: "Shapes",
            metaData: {
              backgroundImage: "stickers/shapes/background.png"
            },
            stickers: [{
              identifier: "imgly_sticker_shapes_arrow_02",
              defaultName: "Arrow 1",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_arrow_02.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_arrow_02.png"],
                  width: 2e3,
                  height: 1236
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_arrow_02.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_arrow_02.png"],
                  width: 2e3,
                  height: 1236
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_arrow_03",
              defaultName: "Arrow 2",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_arrow_03.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_arrow_03.png"],
                  width: 2e3,
                  height: 2e3
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_arrow_03.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_arrow_03.png"],
                  width: 2e3,
                  height: 2e3
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_01",
              defaultName: "Badge 1",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_01.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_01.png"],
                  width: 2e3,
                  height: 2e3
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_01.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_01.png"],
                  width: 2e3,
                  height: 2e3
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_04",
              defaultName: "Badge 2",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_04.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_04.png"],
                  width: 2e3,
                  height: 1589
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_04.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_04.png"],
                  width: 2e3,
                  height: 1589
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_06",
              defaultName: "Badge 3",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_06.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_06.png"],
                  width: 2e3,
                  height: 1733
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_06.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_06.png"],
                  width: 2e3,
                  height: 1733
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_08",
              defaultName: "Badge 4",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_08.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_08.png"],
                  width: 2e3,
                  height: 2e3
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_08.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_08.png"],
                  width: 2e3,
                  height: 2e3
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_11",
              defaultName: "Badge 5",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_11.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_11.png"],
                  width: 2e3,
                  height: 2e3
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_11.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_11.png"],
                  width: 2e3,
                  height: 2e3
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_12",
              defaultName: "Badge 6",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_12.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_12.png"],
                  width: 2001,
                  height: 1903
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_12.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_12.png"],
                  width: 2001,
                  height: 1903
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_13",
              defaultName: "Badge 7",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_13.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_13.png"],
                  width: 2e3,
                  height: 1718
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_13.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_13.png"],
                  width: 2e3,
                  height: 1718
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_15",
              defaultName: "Badge 8",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_15.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_15.png"],
                  width: 1618,
                  height: 2e3
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_15.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_15.png"],
                  width: 1618,
                  height: 2e3
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_18",
              defaultName: "Badge 9",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_18.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_18.png"],
                  width: 1198,
                  height: 2e3
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_18.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_18.png"],
                  width: 1198,
                  height: 2e3
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_19",
              defaultName: "Badge 10",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_19.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_19.png"],
                  width: 2127,
                  height: 481
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_19.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_19.png"],
                  width: 2127,
                  height: 481
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_20",
              defaultName: "Badge 11",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_20.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_20.png"],
                  width: 2e3,
                  height: 1404
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_20.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_20.png"],
                  width: 2e3,
                  height: 1404
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_28",
              defaultName: "Badge 12",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_28.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_28.png"],
                  width: 2e3,
                  height: 2e3
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_28.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_28.png"],
                  width: 2e3,
                  height: 2e3
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_32",
              defaultName: "Badge 13",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_32.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_32.png"],
                  width: 1960,
                  height: 2e3
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_32.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_32.png"],
                  width: 1960,
                  height: 2e3
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_35",
              defaultName: "Badge 14",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_35.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_35.png"],
                  width: 2e3,
                  height: 2002
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_35.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_35.png"],
                  width: 2e3,
                  height: 2002
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_badge_36",
              defaultName: "Badge 15",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_36.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_36.png"],
                  width: 2e3,
                  height: 1668
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_36.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_36.png"],
                  width: 2e3,
                  height: 1668
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_spray_01",
              defaultName: "Spray 1",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_01.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_spray_01.png"],
                  width: 1912,
                  height: 2039
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_01.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_spray_01.png"],
                  width: 1912,
                  height: 2039
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_spray_03",
              defaultName: "Spray 2",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_03.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_spray_03.png"],
                  width: 1681,
                  height: 1779
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_03.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_spray_03.png"],
                  width: 1681,
                  height: 1779
                }
              }
            }, {
              identifier: "imgly_sticker_shapes_spray_04",
              defaultName: "Spray 3",
              tintMode: "solid",
              images: {
                mediaThumb: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_04.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_spray_04.png"],
                  width: 1407,
                  height: 2248
                },
                mediaBase: {
                  uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_04.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_spray_04.png"],
                  width: 1407,
                  height: 2248
                }
              }
            }]
          }]
        }
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return m;
      });

      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(33)),
          h = n(78),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          g = p.Math.Rectangle,
          m = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this, e));

          return n.setSize(new f.a(n.getWidth(), 0)), n.serverImageSmoothingFix = !1, n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "_getFrame",
          value: function value() {
            var e = this.getSize();
            return new g(0, 0, e.width, e.height);
          }
        }, {
          key: "_getTextFrame",
          value: function value() {
            return this._getFrame();
          }
        }, {
          key: "_getTextFrameForElement",
          value: function value(e) {
            return e.getFrame().clone();
          }
        }, {
          key: "_calculateLayoutElements",
          value: function value() {
            p.Log.warn("TextDesignRow is an abstract class.");
          }
        }, {
          key: "_getLayoutElements",
          value: function value() {
            return this._options.elements.length <= 0 && this.layout(), this.getElements();
          }
        }, {
          key: "_fontSize",
          value: function value(e) {
            return p.Log.warn("TextDesignRow#_fontSize not implemented. @TODO: Is it necessary?"), 0;
          }
        }, {
          key: "layout",
          value: function value() {
            return this.setElements(this._calculateLayoutElements()), this;
          }
        }, {
          key: "textFrame",
          value: function value(e, t) {
            return e.getFrame().clone();
          }
        }, {
          key: "willRender",
          value: function value(e) {}
        }, {
          key: "didRender",
          value: function value(e) {}
        }, {
          key: "render",
          value: function value(e) {
            var t = this;
            e.save(), this._getLayoutElements().forEach(function (n) {
              var i = n.serializeOptions(),
                  r = (i.text, i.frame),
                  o = i.font,
                  a = t.getAttributes();
              o.draw(e, r.x, r.y, {
                textColor: a.getTextColor().toRGBA(),
                alignment: a.getAlignment()
              });
            }), e.restore();
          }
        }]), t;
      }(p.Configurable);

      m.prototype.availableOptions = {
        words: {
          type: p.OptionType.OBJECT,
          default: null
        },
        width: {
          type: p.OptionType.NUMBER,
          default: 100
        },
        attributes: {
          type: p.OptionType.CONFIGURABLE,
          default: new h.a()
        },
        shearingAngle: {
          type: p.OptionType.NUMBER,
          default: 0
        },
        elements: {
          type: p.OptionType.ARRAY,
          default: []
        },
        size: {
          type: p.OptionType.OBJECT,
          default: null
        }
      };
    }, function (e, t, n) {
      var i,
          r = n(0),
          o = n.n(r);

      function a(e, t, n) {
        return t in e ? o()(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      var s = n(9).j.Engine.Filters.OverlayFilter;
      t.a = (a(i = {}, s.BLEND_MODES.NORMAL, "normal"), a(i, s.BLEND_MODES.OVERLAY, "overlay"), a(i, s.BLEND_MODES.HARD_LIGHT, "hard light"), a(i, s.BLEND_MODES.SOFT_LIGHT, "soft light"), a(i, s.BLEND_MODES.MULTIPLY, "multiply"), a(i, s.BLEND_MODES.DARKEN, "darken"), a(i, s.BLEND_MODES.LIGHTEN, "lighten"), a(i, s.BLEND_MODES.SCREEN, "screen"), a(i, s.BLEND_MODES.COLOR_BURN, "color burn"), i);
    }, function (e, t, n) {
      var i = n(23),
          r = n(16).document,
          o = i(r) && i(r.createElement);

      e.exports = function (e) {
        return o ? r.createElement(e) : {};
      };
    }, function (e, t, n) {
      var i = n(23);

      e.exports = function (e, t) {
        if (!i(e)) return e;
        var n, r;
        if (t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
        if ("function" == typeof (n = e.valueOf) && !i(r = n.call(e))) return r;
        if (!t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (e, t, n) {
      var i = n(58),
          r = n(57),
          o = n(35),
          a = n(95),
          s = n(43),
          l = n(136),
          u = Object.getOwnPropertyDescriptor;
      t.f = n(19) ? u : function (e, t) {
        if (e = o(e), t = a(t, !0), l) try {
          return u(e, t);
        } catch (e) {}
        if (s(e, t)) return r(!i.f.call(e, t), e[t]);
      };
    }, function (e, t, n) {
      var i = n(59);
      e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
        return "String" == i(e) ? e.split("") : Object(e);
      };
    }, function (e, t) {
      e.exports = function (e) {
        if (null == e) throw TypeError("Can't call method on  " + e);
        return e;
      };
    }, function (e, t) {
      var n = Math.ceil,
          i = Math.floor;

      e.exports = function (e) {
        return isNaN(e = +e) ? 0 : (e > 0 ? i : n)(e);
      };
    }, function (e, t, n) {
      var i = n(101)("keys"),
          r = n(84);

      e.exports = function (e) {
        return i[e] || (i[e] = r(e));
      };
    }, function (e, t, n) {
      var i = n(11),
          r = n(16),
          o = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});
      (e.exports = function (e, t) {
        return o[e] || (o[e] = void 0 !== t ? t : {});
      })("versions", []).push({
        version: i.version,
        mode: n(60) ? "pure" : "global",
        copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
      });
    }, function (e, t) {
      e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function (e, t, n) {
      var i = n(14),
          r = n(11),
          o = n(42);

      e.exports = function (e, t) {
        var n = (r.Object || {})[e] || Object[e],
            a = {};
        a[e] = t(n), i(i.S + i.F * o(function () {
          n(1);
        }), "Object", a);
      };
    }, function (e, t, n) {
      var i = n(60),
          r = n(14),
          o = n(141),
          a = n(34),
          s = n(51),
          l = n(243),
          u = n(61),
          c = n(139),
          p = n(17)("iterator"),
          f = !([].keys && "next" in [].keys()),
          h = function h() {
        return this;
      };

      e.exports = function (e, t, n, d, g, m, y) {
        l(n, t, d);

        var _,
            v,
            b,
            w = function w(e) {
          if (!f && e in S) return S[e];

          switch (e) {
            case "keys":
            case "values":
              return function () {
                return new n(this, e);
              };
          }

          return function () {
            return new n(this, e);
          };
        },
            x = t + " Iterator",
            k = "values" == g,
            T = !1,
            S = e.prototype,
            C = S[p] || S["@@iterator"] || g && S[g],
            E = C || w(g),
            O = g ? k ? w("entries") : E : void 0,
            R = "Array" == t && S.entries || C;

        if (R && (b = c(R.call(new e()))) !== Object.prototype && b.next && (u(b, x, !0), i || "function" == typeof b[p] || a(b, p, h)), k && C && "values" !== C.name && (T = !0, E = function E() {
          return C.call(this);
        }), i && !y || !f && !T && S[p] || a(S, p, E), s[t] = E, s[x] = h, g) if (_ = {
          values: k ? E : w("values"),
          keys: m ? E : w("keys"),
          entries: O
        }, y) for (v in _) {
          v in S || o(S, v, _[v]);
        } else r(r.P + r.F * (f || T), t, _);
        return _;
      };
    }, function (e, t, n) {
      t.f = n(17);
    }, function (e, t, n) {
      var i = n(84)("meta"),
          r = n(23),
          o = n(43),
          a = n(22).f,
          s = 0,
          l = Object.isExtensible || function () {
        return !0;
      },
          u = !n(42)(function () {
        return l(Object.preventExtensions({}));
      }),
          c = function c(e) {
        a(e, i, {
          value: {
            i: "O" + ++s,
            w: {}
          }
        });
      },
          p = e.exports = {
        KEY: i,
        NEED: !1,
        fastKey: function fastKey(e, t) {
          if (!r(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

          if (!o(e, i)) {
            if (!l(e)) return "F";
            if (!t) return "E";
            c(e);
          }

          return e[i].i;
        },
        getWeak: function getWeak(e, t) {
          if (!o(e, i)) {
            if (!l(e)) return !0;
            if (!t) return !1;
            c(e);
          }

          return e[i].w;
        },
        onFreeze: function onFreeze(e) {
          return u && p.NEED && l(e) && !o(e, i) && c(e), e;
        }
      };
    }, function (e, t, n) {
      var i = n(16),
          r = n(11),
          o = n(60),
          a = n(105),
          s = n(22).f;

      e.exports = function (e) {
        var t = r.Symbol || (r.Symbol = o ? {} : i.Symbol || {});
        "_" == e.charAt(0) || e in t || s(t, e, {
          value: a.f(e)
        });
      };
    }, function (e, t) {
      t.f = Object.getOwnPropertySymbols;
    }, function (e, t) {}, function (e, t) {
      e.exports = function (e, t, n, i) {
        if (!(e instanceof t) || void 0 !== i && i in e) throw TypeError(n + ": incorrect invocation!");
        return e;
      };
    }, function (e, t, n) {
      var i = n(85),
          r = n(17)("iterator"),
          o = n(51);

      e.exports = n(11).getIteratorMethod = function (e) {
        if (null != e) return e[r] || e["@@iterator"] || o[i(e)];
      };
    }, function (e, t, n) {
      var i,
          r,
          o,
          a = n(30),
          s = n(254),
          l = n(138),
          u = n(94),
          c = n(16),
          p = c.process,
          f = c.setImmediate,
          h = c.clearImmediate,
          d = c.MessageChannel,
          g = c.Dispatch,
          m = 0,
          y = {},
          _ = function _() {
        var e = +this;

        if (y.hasOwnProperty(e)) {
          var t = y[e];
          delete y[e], t();
        }
      },
          v = function v(e) {
        _.call(e.data);
      };

      f && h || (f = function f(e) {
        for (var t = [], n = 1; arguments.length > n;) {
          t.push(arguments[n++]);
        }

        return y[++m] = function () {
          s("function" == typeof e ? e : Function(e), t);
        }, i(m), m;
      }, h = function h(e) {
        delete y[e];
      }, "process" == n(59)(p) ? i = function i(e) {
        p.nextTick(a(_, e, 1));
      } : g && g.now ? i = function i(e) {
        g.now(a(_, e, 1));
      } : d ? (o = (r = new d()).port2, r.port1.onmessage = v, i = a(o.postMessage, o, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (i = function i(e) {
        c.postMessage(e + "", "*");
      }, c.addEventListener("message", v, !1)) : i = "onreadystatechange" in u("script") ? function (e) {
        l.appendChild(u("script")).onreadystatechange = function () {
          l.removeChild(this), _.call(e);
        };
      } : function (e) {
        setTimeout(a(_, e, 1), 0);
      }), e.exports = {
        set: f,
        clear: h
      };
    }, function (e, t, n) {
      var i = n(56);

      function r(e) {
        var t, n;
        this.promise = new e(function (e, i) {
          if (void 0 !== t || void 0 !== n) throw TypeError("Bad Promise constructor");
          t = e, n = i;
        }), this.resolve = i(t), this.reject = i(n);
      }

      e.exports.f = function (e) {
        return new r(e);
      };
    }, function (e, t, n) {
      var i = n(34);

      e.exports = function (e, t, n) {
        for (var r in t) {
          n && e[r] ? e[r] = t[r] : i(e, r, t[r]);
        }

        return e;
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(12),
          a = n(88),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._renderer = t, this._filterStack = [{
            renderTarget: t.getCurrentRenderTarget(),
            filters: []
          }], this._currentFrame = null, this._textures = [], this._textureFrame = new o.h(0, 0, t.getWidth(), t.getHeight());
        }

        return s(e, [{
          key: "resizeTo",
          value: function value(e) {
            this._textureFrame.width = e.x, this._textureFrame.height = e.y, this._textures.forEach(function (t) {
              return t.resizeTo(e);
            });
          }
        }, {
          key: "pushFilters",
          value: function value(e, t) {
            var n = e.getBounds();
            this._currentFrame = n;

            var i = this._getOrCreateRenderTarget();

            this._renderer.setRenderTarget(i), this._filterStack.push({
              renderTarget: i,
              filters: t
            }), i.clear();
          }
        }, {
          key: "popFilters",
          value: function value() {
            var e = this._filterStack.pop(),
                t = e.filters,
                n = e.renderTarget,
                i = this._filterStack[this._filterStack.length - 1].renderTarget;

            return 1 === t.length ? (t[0].apply(this._renderer, n, i), this._textures.push(n)) : this._applyFilters(t, n, i), t;
          }
        }, {
          key: "_applyFilters",
          value: function value(e, t, n) {
            var i = this,
                r = t,
                o = this._getOrCreateRenderTarget(!0),
                a = e[e.length - 1];

            e.forEach(function (e, t) {
              if (e === a) e.apply(i._renderer, r, n);else {
                e.apply(i._renderer, r, o);
                var s = r;
                r = o, o = s;
              }
            }), this._textures.push(r), this._textures.push(o);
          }
        }, {
          key: "_getOrCreateRenderTarget",
          value: function value(e) {
            var t = this._textures.pop();

            return t || (t = new a.a(this._textureFrame.width, this._textureFrame.height, 1)), e && t.clear(), t;
          }
        }, {
          key: "setFilterStack",
          value: function value(e) {
            this._filterStack = e;
          }
        }, {
          key: "dispose",
          value: function value() {}
        }]), e;
      }();

      t.a = l;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(12),
          c = n(117),
          p = u.c.UniformType,
          f = function (e) {
        function t(e, n, i) {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), n = n || t.defaultVertexSource, i = i || t.defaultFragmentSource, function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || l()(t)).call(this, e, n, i, t.defaultUniforms, t.defaultAttributes));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(c.a);

      f.defaultVertexSource = n(280), f.defaultFragmentSource = n(281);
      var h = new u.g();
      f.defaultUniforms = {
        u_image: {
          type: p.SAMPLER2D,
          value: 0
        },
        u_projMatrix: {
          type: p.MAT3,
          value: h.toArray()
        }
      }, f.defaultAttributes = ["a_position", "a_texCoord", "a_color"], t.a = f;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(39),
          a = n.n(o),
          s = n(12),
          l = n(40),
          u = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          c = s.f,
          p = s.i,
          f = function () {
        function e(t, n, i, r, o) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._renderer = t, this._vertexSource = n, this._fragmentSource = i, this._uniforms = r || {}, this._uniformLocations = {}, this._attributes = o || [], this._attributeLocations = {}, this._onContextChange = this._onContextChange.bind(this), this._renderer.on("context", this._onContextChange), this._init();
        }

        return u(e, [{
          key: "_init",
          value: function value() {
            this._compile(), this._renderer.getContext().useProgram(this._program), this._cacheUniformLocations(), this._cacheAttributeLocations();
          }
        }, {
          key: "_onContextChange",
          value: function value() {
            this._init();
          }
        }, {
          key: "setupBuffers",
          value: function value(e, t) {
            var n = this._renderer.getContext();

            n.bindBuffer(n.ARRAY_BUFFER, e), n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, t), n.vertexAttribPointer(this._attributeLocations.a_position, 2, n.FLOAT, !1, s.j, 0), n.vertexAttribPointer(this._attributeLocations.a_texCoord, 2, n.FLOAT, !1, s.j, 8), n.vertexAttribPointer(this._attributeLocations.a_color, 4, n.UNSIGNED_BYTE, !0, s.j, 16);
          }
        }, {
          key: "syncUniforms",
          value: function value() {
            var e = this;
            a()(this._uniforms).forEach(function (t) {
              e.syncUniform(t);
            });
          }
        }, {
          key: "syncUniform",
          value: function value(e) {
            var t = this._renderer.getContext(),
                n = this._uniforms[e],
                i = this._uniformLocations[e];

            switch (n.type) {
              case l.UniformType.SAMPLER2D:
                t.uniform1i(i, n.value);
                break;

              case l.UniformType.INT:
              case l.UniformType.INT1:
                t.uniform1i(i, n.value);
                break;

              case l.UniformType.INT2:
                t.uniform2i(i, n.value[0], n.value[1]);
                break;

              case l.UniformType.INT3:
                t.uniform3i(i, n.value[0], n.value[1], n.value[2]);
                break;

              case l.UniformType.INT4:
                t.uniform4i(i, n.value[0], n.value[1], n.value[2], n.value[3]);
                break;

              case l.UniformType.FLOAT:
              case l.UniformType.FLOAT1:
                t.uniform1f(i, n.value);
                break;

              case l.UniformType.FLOAT2:
                t.uniform2f(i, n.value[0], n.value[1]);
                break;

              case l.UniformType.FLOAT3:
                t.uniform3f(i, n.value[0], n.value[1], n.value[2]);
                break;

              case l.UniformType.FLOAT4:
                t.uniform4f(i, n.value[0], n.value[1], n.value[2], n.value[3]);
                break;

              case l.UniformType.FLOAT_VECTOR2:
                t.uniform2fv(i, n.value);
                break;

              case l.UniformType.MAT3:
              case l.UniformType.MAT3FV:
                t.uniformMatrix3fv(i, !1, n.value);
                break;

              case l.UniformType.MAT4:
                t.uniformMatrix4fv(i, !1, n.value);
                break;

              default:
                c.warn(this.constructor.name, "Unknown uniform type: " + n.type);
            }
          }
        }, {
          key: "_cacheAttributeLocations",
          value: function value() {
            var e = this,
                t = this._renderer.getContext();

            this._attributes.forEach(function (n) {
              e._attributeLocations[n] = t.getAttribLocation(e._program, n);
            });
          }
        }, {
          key: "_cacheUniformLocations",
          value: function value() {
            var e = this,
                t = this._renderer.getContext();

            a()(this._uniforms).forEach(function (n) {
              e._uniformLocations[n] = t.getUniformLocation(e._program, n);
            });
          }
        }, {
          key: "_addPrecisionToSource",
          value: function value(e) {
            var t = this._renderer.getMaxFloatPrecision(),
                n = "mediump";

            return p.isMobile() && "highp" === t && (n = "highp"), "precision " + n + " float;\n" + e;
          }
        }, {
          key: "_compile",
          value: function value() {
            var e = this._renderer.getContext(),
                t = this._compileShader(e.VERTEX_SHADER, this._vertexSource);

            this._vertexShader = t;

            var n = this._addPrecisionToSource(this._fragmentSource),
                i = this._compileShader(e.FRAGMENT_SHADER, n);

            this._fragmentShader = i;
            var r = e.createProgram();
            if (e.attachShader(r, t), e.attachShader(r, i), e.linkProgram(r), e.getProgramParameter(r, e.LINK_STATUS)) this._program = r;else {
              var o = e.getProgramInfoLog(r);
              e.isContextLost() && (o = "WebGL context lost"), e.deleteProgram(r), c.error(this.constructor.name, "WebGL program linking error: " + o);
            }
          }
        }, {
          key: "_compileShader",
          value: function value(e, t) {
            var n = this._renderer.getContext(),
                i = n.createShader(e);

            if (n.shaderSource(i, t), n.compileShader(i), !n.getShaderParameter(i, n.COMPILE_STATUS)) {
              var r = n.getShaderInfoLog(i);
              n.isContextLost() && (r = "WebGL context lost"), n.deleteShader(i), c.error(this.constructor.name, "WebGL shader compilation error: " + r);
            }

            return i;
          }
        }, {
          key: "setUniform",
          value: function value(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            this._uniforms[e].value = t, n && this.syncUniform(e);
          }
        }, {
          key: "setUniforms",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

            for (var n in e) {
              this._uniforms[n].value = e[n], t && this.syncUniform(n);
            }
          }
        }, {
          key: "getUniforms",
          value: function value() {
            return this._uniforms;
          }
        }, {
          key: "getAttributes",
          value: function value() {
            return this._attributes;
          }
        }, {
          key: "getAttributeLocations",
          value: function value() {
            return this._attributeLocations;
          }
        }, {
          key: "getProgram",
          value: function value() {
            return this._program;
          }
        }, {
          key: "dispose",
          value: function value() {
            var e = this._renderer.getContext();

            e.deleteProgram(this._program), e.deleteShader(this._vertexShader), e.deleteShader(this._fragmentShader), this._uniforms = null, this._uniformLocations = null, this._attributes = null, this._attributeLocations = null, this._renderer.off("context", this._onContextChange);
          }
        }]), e;
      }();

      t.a = f;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(12),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._position = new o.k(0, 0), this._scale = new o.k(1, 1), this._pivot = new o.k(0, 0), this._rotation = 0, this._lastRotation = null, this._alpha = 1, this._visible = !0, this._worldTransform = new o.g(), this._parent = null, this._shaders = [], this._boundsNeedUpdate = !0, this._bounds = new o.h(0, 0, 1, 1), this._localBoundsNeedUpdate = !0, this._localBounds = new o.h(0, 0, 1, 1), this._tint = 16777215, this._filterRectangle = new o.h(0, 0, 0, 0);
        }

        return a(e, [{
          key: "renderWebGL",
          value: function value(e) {
            o.f.warn(this.constructor.name, "`renderWebGL` is abstract and not implemented in inherited class");
          }
        }, {
          key: "renderCanvas",
          value: function value(e) {
            o.f.warn(this.constructor.name, "`renderCanvas` is abstract and not implemented in inherited class");
          }
        }, {
          key: "updateTransform",
          value: function value() {
            var e = this._parent ? this._parent.getWorldTransform() : o.g.IDENTITY,
                t = this._worldTransform;
            this._rotation !== this._lastRotation && (this._sinRotation = Math.sin(this._rotation), this._cosRotation = Math.cos(this._rotation), this._lastRotation = this._rotation), t.a = this._cosRotation * this._scale.x, t.b = this._sinRotation * this._scale.x, t.c = -this._sinRotation * this._scale.y, t.d = this._cosRotation * this._scale.y, t.tx = this._position.x, t.ty = this._position.y, (this._pivot.x || this._pivot.y) && (t.tx -= this._pivot.x * t.a + this._pivot.y * t.c, t.ty -= this._pivot.x * t.b + this._pivot.y * t.d), t.multiply(e), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "addShader",
          value: function value(e) {
            this._shaders.push(e);
          }
        }, {
          key: "removeShader",
          value: function value(e) {
            var t = this._shaders.indexOf(e);

            return -1 !== t && (this._shaders.splice(t, 1), !0);
          }
        }, {
          key: "removeShaderAt",
          value: function value(e) {
            return !!this._shaders[e] && (this._shaders.splice(e, 1), !0);
          }
        }, {
          key: "getBounds",
          value: function value() {
            return this._bounds.clone();
          }
        }, {
          key: "getPosition",
          value: function value() {
            return this._position;
          }
        }, {
          key: "setPosition",
          value: function value(e, t) {
            e instanceof o.k ? this._position.copy(e) : this._position.set(e, t), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "getScale",
          value: function value() {
            return this._scale;
          }
        }, {
          key: "setScale",
          value: function value(e, t) {
            e instanceof o.k ? this._scale.copy(e) : this._scale.set(e, t), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "getPivot",
          value: function value() {
            return this._pivot;
          }
        }, {
          key: "setPivot",
          value: function value(e, t) {
            e instanceof o.k ? this._pivot.copy(e) : this._pivot.set(e, t), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "getRotation",
          value: function value() {
            return this._rotation;
          }
        }, {
          key: "setRotation",
          value: function value(e) {
            this._rotation = e, this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "getAlpha",
          value: function value() {
            return this._alpha;
          }
        }, {
          key: "setAlpha",
          value: function value(e) {
            this._alpha = e;
          }
        }, {
          key: "getWorldAlpha",
          value: function value() {
            return this._parent ? this._parent.getAlpha() * this._alpha : this._alpha;
          }
        }, {
          key: "getWorldTransform",
          value: function value() {
            return this._worldTransform;
          }
        }, {
          key: "getParent",
          value: function value() {
            return this._parent;
          }
        }, {
          key: "setParent",
          value: function value(e) {
            this._parent = e;
          }
        }, {
          key: "getFilterRectangle",
          value: function value() {
            return this._filterRectangle;
          }
        }, {
          key: "setFilterRectangle",
          value: function value(e) {
            this._filterRectangle.copy(e);
          }
        }, {
          key: "getTint",
          value: function value() {
            return this._tint;
          }
        }, {
          key: "setTint",
          value: function value(e) {
            this._tint = e;
          }
        }, {
          key: "isVisible",
          value: function value() {
            return this._visible;
          }
        }, {
          key: "setVisible",
          value: function value(e) {
            this._visible = e;
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(12),
          a = n(89),
          s = n(160),
          l = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          u = o.c.RendererType,
          c = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._renderer = t, this._filterStack = [{
            filters: []
          }], this._currentFrame = null, this._renderTargets = [], this._textureFrame = new o.h(0, 0, t.getWidth(), t.getHeight()), this._onContextChange = this._onContextChange.bind(this), this._renderer.on("context", this._onContextChange), this._onContextChange();
        }

        return l(e, [{
          key: "resizeTo",
          value: function value(e) {
            this._textureFrame.width = e.x, this._textureFrame.height = e.y, this._renderTargets.forEach(function (t) {
              return t.resizeTo(e);
            });
          }
        }, {
          key: "getFilterStack",
          value: function value() {
            return this._filterStack;
          }
        }, {
          key: "setFilterStack",
          value: function value(e) {
            this._filterStack = e;
          }
        }, {
          key: "_getOrCreateRenderTarget",
          value: function value(e) {
            var t = this._renderTargets.pop();

            return t || (t = new a.a(this._renderer, this._textureFrame.width, this._textureFrame.height, 1)), t.setFrame(this._currentFrame), e && t.clear(), t;
          }
        }, {
          key: "pushFilters",
          value: function value(e, t) {
            var n = e.getBounds();
            this._currentFrame = n;
            var i = e.getFilterRectangle();
            i.width > 0 && i.height > 0 && (this._currentFrame = i);

            var r = this._getOrCreateRenderTarget();

            this._renderer.setRenderTarget(r), r.clear(), this._filterStack.push({
              renderTarget: r,
              filters: t
            });
          }
        }, {
          key: "popFilters",
          value: function value() {
            var e = this._filterStack.pop(),
                t = e.filters,
                n = e.renderTarget,
                i = this._filterStack[this._filterStack.length - 1].renderTarget;

            this._quad.map(this._textureFrame, n.getFrame());

            var r = t[0].getShaderForRenderer(this._renderer),
                o = this._quad.getVertexBuffer(),
                a = this._quad.getIndexBuffer(),
                s = this._renderer.getContext();

            s.bindBuffer(s.ARRAY_BUFFER, o), s.bindBuffer(s.ELEMENT_ARRAY_BUFFER, a);
            var l = r.getAttributeLocations();
            return s.vertexAttribPointer(l.a_position, 2, s.FLOAT, !1, 0, 0), s.vertexAttribPointer(l.a_texCoord, 2, s.FLOAT, !1, 0, 32), s.vertexAttribPointer(l.a_color, 4, s.FLOAT, !1, 0, 64), this._renderer.updateTexture(n.getBaseTexture(), !1), 1 === t.length ? (t[0].apply(this._renderer, n, i), this._renderTargets.push(n)) : this._applyFilters(t, n, i), t;
          }
        }, {
          key: "_applyFilters",
          value: function value(e, t, n) {
            var i = this,
                r = t,
                o = this._getOrCreateRenderTarget(!0);

            this._renderer.updateTexture(o.getBaseTexture(), !1);

            var a = e[e.length - 1];
            e.forEach(function (e, t) {
              if (e === a) e.apply(i._renderer, r, n, !0);else {
                e.apply(i._renderer, r, o, !0);
                var s = r;
                r = o, o = s;
              }
            }), this._renderTargets.push(r), this._renderTargets.push(o);
          }
        }, {
          key: "_onContextChange",
          value: function value() {
            this._renderTargets.length = 0, this._renderer.isOfType(u.WEBGL) && (this._quad && this._quad.dispose(), this._quad = new s.a(this._renderer));
          }
        }, {
          key: "dispose",
          value: function value() {
            this._renderer.off("context", this._onContextChange), this._quad && this._quad.dispose(), this._renderTargets.forEach(function (e) {
              e.dispose();
            });
          }
        }]), e;
      }();

      t.a = c;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(65),
          a = n(121),
          s = n(32),
          l = n(122),
          u = n(318),
          c = n(319),
          p = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      s.a.invariant;
      /*
       * Based on https://github.com/exif-js/exif-js by Jacob Seidelin
       * Licensed under MIT
       * @license
       */

      var f = l.a.MARKERS,
          h = new RegExp("^data:image/jpeg;base64,", "i"),
          d = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._buf = t, this._stream = new a.a(this._buf), this._stream.setHead(0), this._segments = this._sliceIntoSegments(this._buf), this._exifData = new c.a(this._getMarkerBuffer(f.EXIF)), this._jfifData = new u.a(this._getMarkerBuffer(f.JFIF));
        }

        return p(e, [{
          key: "restoreSegmentsInArray",
          value: function value(e) {
            return e = this.restoreExifTagsToImageData(e), this.restoreJfifSegmentToImageData(e);
          }
        }, {
          key: "restoreSegments",
          value: function value(t) {
            var n = e.fromDataURL(t);
            return n = this.restoreSegmentsInArray(n), e.toDataURL(n);
          }
        }, {
          key: "restoreExifTagsToImageData",
          value: function value(e) {
            if (!this._exifData.isValid()) return e;

            var t = this._sliceIntoSegments(e)[1][0],
                n = e.slice(0, t),
                i = e.slice(t),
                r = n.concat(this._exifData.getBuffer());

            return r = r.concat(i);
          }
        }, {
          key: "restoreJfifSegmentToImageData",
          value: function value(e) {
            if (!this._jfifData.isValid()) return e;

            var t = this._sliceIntoSegments(e),
                n = this._findSegment(f.JFIF, t);

            if (!n) return e;
            var i = n[0],
                r = n[1],
                o = e.slice(0, i),
                a = e.slice(i, r),
                s = e.slice(r),
                l = new u.a(a);
            return l.setDensityX(this._jfifData.getDensityX()), l.setDensityY(this._jfifData.getDensityY()), l.setUnitDensity(this._jfifData.getUnitDensity()), o.concat(a).concat(s);
          }
        }, {
          key: "restoreExifTags",
          value: function value(t) {
            var n = e.fromDataURL(t),
                i = this.restoreExifTagsToImageData(n);
            return e.toDataURL(i);
          }
        }, {
          key: "restoreJfifSegment",
          value: function value(t) {
            if (!this._jfifData.isValid()) return t;
            var n = e.fromDataURL(t),
                i = this.restoreJfifSegmentToImageData(n);
            return e.toDataURL(i);
          }
        }, {
          key: "setOrientation",
          value: function value(e) {
            return this._exifData.setOrientation(e);
          }
        }, {
          key: "_findSegment",
          value: function value(e) {
            for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._segments, n = 0; n < t.length; n++) {
              var i = t[n][0],
                  r = t[n][1];

              this._stream.setHead(i);

              var o = this._stream.peekInt16();

              if (o === e) return [i, r];
            }

            return !1;
          }
        }, {
          key: "_getLastSegment",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._segments;
            return e[e.length - 1];
          }
        }, {
          key: "_getMarkerBuffer",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._segments,
                n = this._findSegment(e, t);

            if (n) {
              var i = n[0],
                  r = n[1];
              return this._buf.slice(i, r);
            }

            return !1;
          }
        }, {
          key: "_sliceIntoSegments",
          value: function value(e) {
            for (var t = new a.a(e), n = []; t.getHead() < e.length;) {
              var i = t.readInt16();

              if (i !== f.SOI) {
                if (i === f.SOS) break;
                if (!(i >= 65280 && i <= 65535)) throw new Error("Invalid marker: 0x" + i.toString(16));
                var r = t.readInt16(),
                    o = t.getHead() + r - 2;
                n.push([t.getHead() - 4, o]), t.setHead(o);
              }
            }

            return this._stream.setHead(0), n;
          }
        }, {
          key: "getTags",
          value: function value() {
            return this._exifData.getTags();
          }
        }, {
          key: "getTagData",
          value: function value() {
            return this._exifData.getTagData();
          }
        }, {
          key: "dispose",
          value: function value() {
            this._buf = [], this._segments = [];
          }
        }], [{
          key: "toDataURL",
          value: function value(e) {
            return "data:image/jpeg;base64," + o.a.encode(e);
          }
        }, {
          key: "fromDataURL",
          value: function value(e) {
            var t = e.replace("data:image/jpeg;base64,", "");
            return o.a.decode(t);
          }
        }, {
          key: "isJPEG",
          value: function value(e) {
            return h.test(e);
          }
        }, {
          key: "bufferIsJPEG",
          value: function value(e) {
            return 255 === e[0] && 216 === e[1] && 255 === e[2];
          }
        }, {
          key: "fromBase64String",
          value: function value(t) {
            var n = t.replace("data:image/jpeg;base64,", "");
            return new e(o.a.decode(n));
          }
        }]), e;
      }();

      t.a = d;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._head = 0, this._buf = t;
        }

        return o(e, [{
          key: "peekInt8",
          value: function value() {
            return this._buf[this._head];
          }
        }, {
          key: "peekInt16",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = this._buf[this._head],
                n = this._buf[this._head + 1];
            return e ? (n << 8) + t : (t << 8) + n;
          }
        }, {
          key: "peekInt24",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = this._buf[this._head],
                n = this._buf[this._head + 1],
                i = this._buf[this._head + 2];
            return e ? (i << 16) + (n << 8) + t : (t << 16) + (n << 8) + i;
          }
        }, {
          key: "peekInt32",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = this._buf[this._head],
                n = this._buf[this._head + 1],
                i = this._buf[this._head + 2],
                r = this._buf[this._head + 3];
            return e ? (r << 32) + (i << 16) + (n << 8) + t : (t << 32) + (n << 16) + (i << 8) + r;
          }
        }, {
          key: "writeInt8",
          value: function value(e) {
            this._buf[this._head] = 255 & e;
          }
        }, {
          key: "writeInt16",
          value: function value(e) {
            this._buf[this._head] = e >> 8, this._buf[this._head + 1] = 255 & e;
          }
        }, {
          key: "readInt8",
          value: function value() {
            var e = this.peekInt8();
            return this._head += 1, e;
          }
        }, {
          key: "readInt16",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = this.peekInt16(e);
            return this._head += 2, t;
          }
        }, {
          key: "readInt24",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = this.peekInt24(e);
            return this._head += 3, t;
          }
        }, {
          key: "readInt32",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = this.peekInt32(e);
            return this._head += 4, t;
          }
        }, {
          key: "readString",
          value: function value(e) {
            for (var t = "", n = 0; n < e; n++) {
              var i = this.readInt8();
              t += String.fromCharCode(i);
            }

            return t;
          }
        }, {
          key: "getHead",
          value: function value() {
            return this._head;
          }
        }, {
          key: "setHead",
          value: function value(e) {
            this._head = e;
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      t.a = {
        MARKERS: {
          SOI: 65496,
          SOS: 65498,
          APP0: 65504,
          APP1: 65505,
          JFIF: 65504,
          EXIF: 65505
        },
        EXIF_TAGS: {
          256: "ImageWidth",
          257: "ImageHeight",
          34665: "ExifIFDPointer",
          34853: "GPSInfoIFDPointer",
          40965: "InteroperabilityIFDPointer",
          258: "BitsPerSample",
          259: "Compression",
          262: "PhotometricInterpretation",
          274: "Orientation",
          277: "SamplesPerPixel",
          284: "PlanarConfiguration",
          530: "YCbCrSubSampling",
          531: "YCbCrPositioning",
          282: "XResolution",
          283: "YResolution",
          296: "ResolutionUnit",
          273: "StripOffsets",
          278: "RowsPerStrip",
          279: "StripByteCounts",
          513: "JPEGInterchangeFormat",
          514: "JPEGInterchangeFormatLength",
          301: "TransferFunction",
          318: "WhitePoint",
          319: "PrimaryChromaticities",
          529: "YCbCrCoefficients",
          532: "ReferenceBlackWhite",
          306: "DateTime",
          270: "ImageDescription",
          271: "Make",
          272: "Model",
          305: "Software",
          315: "Artist",
          33432: "Copyright"
        }
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return m;
      });

      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(21)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = function (e) {
        function t() {
          return d(this, t), g(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "insetsForWidth",
          value: function value(e) {
            return this.getRelativeInsets().clone().scale(e);
          }
        }], [{
          key: "Small",
          get: function get() {
            return new t({
              imagePath: "text-design/images/imgly_text_design_asset_banderole_small.png",
              fontIdentifier: "imgly_font_campton_bold",
              relativeInsets: new f.a(.05, .2, .05, .2)
            });
          }
        }, {
          key: "Rectangle",
          get: function get() {
            return new t({
              imagePath: "text-design/images/imgly_text_design_asset_black_background.png",
              fontIdentifier: "imgly_font_campton_bold",
              relativeInsets: new f.a(.05, .05, .05, .05),
              needsImageSmoothingFix: !0
            });
          }
        }, {
          key: "Celebrate1",
          get: function get() {
            return new t({
              imagePath: "text-design/images/imgly_text_design_asset_celebrate_01.png",
              fontIdentifier: "imgly_font_rasa_500",
              relativeInsets: new f.a(.05, .2, .05, .2)
            });
          }
        }, {
          key: "Celebrate2",
          get: function get() {
            return new t({
              imagePath: "text-design/images/imgly_text_design_asset_celebrate_02.png",
              fontIdentifier: "imgly_font_rasa_500",
              relativeInsets: new f.a(.05, .2, .05, .2)
            });
          }
        }]), t;
      }(p.Configurable);

      m.prototype.availableOptions = {
        image: {
          type: p.OptionType.IMAGE,
          default: null
        },
        imagePath: {
          type: p.OptionType.STRING,
          default: null
        },
        relativeInsets: {
          type: p.OptionType.OBJECT,
          default: new f.a()
        },
        fontIdentifier: {
          type: p.OptionType.STRING,
          default: "imgly_font_open_sans_bold"
        },
        needsImageSmoothingFix: {
          type: p.OptionType.BOOLEAN,
          default: !1
        }
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return T;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(21)),
          y = n(26),
          _ = n(48),
          v = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          b = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          w = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function x(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function k(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var T = function (e) {
        function t() {
          return x(this, t), k(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), b(t, [{
          key: "_getTextColor",
          value: function value() {
            return this.getAutoAdjustTextColor() && !this.getIsMasked() ? this.getBackgroundColor().equals(g.Color.WHITE) ? g.Color.BLACK : g.Color.WHITE : this.getAttributes().getTextColor().clone();
          }
        }, {
          key: "_getTextFrame",
          value: function value() {
            return this.getImageInsets().applyToRectangle(this._getFrame());
          }
        }, {
          key: "_getTextFrameForElement",
          value: function value(e) {
            var n = w(t.prototype.__proto__ || d()(t.prototype), "_getTextFrameForElement", this).call(this, e),
                i = this.getImageInsets();
            return (this.getIsMasked() || this.getIsUsedInInvertedLayout()) && (n.y -= i.top), n;
          }
        }, {
          key: "willRender",
          value: function value(e) {
            this.getAttributes().setTextColor(this._getTextColor());
            var t = this.getImage();

            if (t) {
              var n = this.getCapInsets(),
                  i = this._getFrame();

              n && !n.equals(m.a.ZERO) ? Object(_.b)(e, t, i, n) : e.drawImage(t, i.x, i.y, i.width, i.height), Object(_.d)(e, i, this.getBackgroundColor(), "source-atop", !0);
            }

            (this.getIsMasked() || this.getIsUsedInInvertedLayout()) && t && (e.save(), e.globalCompositeOperation = "destination-out");
          }
        }, {
          key: "didRender",
          value: function value(e) {
            w(t.prototype.__proto__ || d()(t.prototype), "didRender", this).call(this, e), (this.getIsMasked() || this.getIsUsedInInvertedLayout()) && e.restore();
          }
        }]), t;
      }(y.a);

      T.prototype.availableOptions = v({}, y.a.prototype.availableOptions, {
        image: {
          type: g.OptionType.IMAGE,
          default: null
        },
        capInsets: {
          type: g.OptionType.OBJECT,
          default: new m.a()
        },
        backgroundColor: {
          type: g.OptionType.COLOR,
          default: g.Color.WHITE
        },
        autoAdjustTextColor: {
          type: g.OptionType.BOOLEAN,
          default: !0
        },
        isMasked: {
          type: g.OptionType.BOOLEAN,
          default: !0
        },
        isUsedInInvertedLayout: {
          type: g.OptionType.BOOLEAN,
          default: !1
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return E;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(26)),
          y = n(79),
          _ = n(52),
          v = n(33),
          b = n(48),
          w = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          x = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          k = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function T(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function S(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var C = g.Math.Rectangle,
          E = function (e) {
        function t() {
          return T(this, t), S(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), x(t, [{
          key: "getImageSize",
          value: function value() {
            var e = this.getLeftImage(),
                t = this.getRightImage(),
                n = this.getWords(),
                i = this.getAttributes().getFontIdentifier(),
                r = e ? new v.a(e.width, e.height) : new v.a(),
                o = n.joined(1)[0];
            if (!o) return r;
            var a = new y.a({
              text: o,
              fontIdentifier: i,
              fontSize: 50
            }).getSizeValue(),
                s = t ? 2 : 1;
            r.scale(s, 1);
            var l = r.clone().fitInWidthWithOther(this._getFrame().width, a);
            return l.scale(1 / s, 1), l;
          }
        }, {
          key: "_getTextFrame",
          value: function value() {
            var e = k(t.prototype.__proto__ || d()(t.prototype), "_getTextFrame", this).call(this).clone(),
                n = this.getImageSize(),
                i = this.getRightImage(),
                r = this.getImagePosition();
            return i ? (e.x += n.width, e.width -= 2 * n.width) : r === t.ImagePosition.Left && (e.x += n.width), e;
          }
        }, {
          key: "_calculateLayoutElements",
          value: function value() {
            var e = k(t.prototype.__proto__ || d()(t.prototype), "_calculateLayoutElements", this).call(this),
                n = this._getFrame(),
                i = this.getRightImage(),
                r = this.getImageSize(),
                o = this.getImagePosition(),
                a = this._getTextFrame(),
                s = this.getAttributes().getFontIdentifier(),
                l = new y.a({
              text: "stickerClock",
              fontIdentifier: s
            });

            l.fitWidth(this._getTextFrame().width);
            var u = new C().set(n.x, n.y, r.width, r.height);

            if (i || o !== t.ImagePosition.Right || (u.x += a.width), e.push(new _.a({
              text: "stickerClock",
              frame: u,
              font: l
            })), i) {
              var c = e[0];

              if (c) {
                var p = u.clone();
                p.translate(c.getFrame().width + p.width, 0), e.push(new _.a({
                  text: "stickerClock",
                  frame: p,
                  font: l
                }));
              }
            }

            return e;
          }
        }, {
          key: "render",
          value: function value(e) {
            var t = this._getLayoutElements(),
                n = this.getAttributes(),
                i = n.getTextColor(),
                r = this.getLeftImage(),
                o = this.getRightImage(),
                a = t[0],
                s = t[1],
                l = a.serializeOptions().font,
                u = this._getTextFrameForElement(a);

            if (l.draw(e, u.x, u.y, {
              textColor: n.getTextColor().toRGBA(),
              alignment: n.getAlignment()
            }), r) {
              var c = s.getFrame();
              e.drawImage(r, c.x, c.y, c.width, c.height), Object(b.d)(e, c, i, "source-atop");
            }

            if (t.length > 2) {
              var p = t[2].getFrame().clone();
              e.drawImage(o, p.x, p.y, p.width, p.height), Object(b.d)(e, p, i, "source-atop");
            }
          }
        }]), t;
      }(m.a);

      E.ImagePosition = {
        Left: "LEFT",
        right: "RIGHT"
      }, E.prototype.availableOptions = w({}, m.a.prototype.availableOptions, {
        leftImage: {
          type: g.OptionType.IMAGE,
          default: null
        },
        rightImage: {
          type: g.OptionType.IMAGE,
          default: null
        },
        imagePosition: {
          type: g.OptionType.STRING,
          default: E.ImagePosition.Left,
          available: [E.ImagePosition.Left, E.ImagePosition.Right]
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return S;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(92)),
          g = n(47),
          m = n(78),
          y = n(52),
          _ = n(79),
          v = n(48),
          b = n(33),
          w = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          x = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function k(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function T(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var S = function (e) {
        function t() {
          var e;
          k(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = T(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o.setSize(new b.a(o.getWidth(), o.getHeight())), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), x(t, [{
          key: "_getImageFrame",
          value: function value() {
            var e = this._getTextFrame().clone(),
                t = this.getImage();

            if (this.getDrawingModeAspectFit() && t) {
              var n = Math.min(e.width / t.width, e.height / t.height),
                  i = t.width * n,
                  r = t.height * n;
              e.x += (e.width - i) / 2, e.y += (e.height - r) / 2, e.width = i, e.height = r;
            }

            return e;
          }
        }, {
          key: "_calculateLayoutElements",
          value: function value() {
            return [new y.a({
              text: "",
              frame: this._getImageFrame(),
              font: new _.a()
            })];
          }
        }, {
          key: "render",
          value: function value(e) {
            var t = this.getImage(),
                n = this._getImageFrame(),
                i = this.getAttributes().getTextColor();

            Object(v.a)(e, t, n, i);
          }
        }]), t;
      }(d.a);

      S.RowImages = {
        decorative1: "text-design/images/imgly_text_design_asset_decorative_01.png",
        decorative2: "text-design/images/imgly_text_design_asset_decorative_02.png",
        decorative3: "text-design/images/imgly_text_design_asset_decorative_05.png",
        decorative4: "text-design/images/imgly_text_design_asset_decorative_06.png",
        celebrate1: "text-design/images/imgly_text_design_asset_celebrate_03.png",
        celebrate2: "text-design/images/imgly_text_design_asset_celebrate_04.png",
        celebrate3: "text-design/images/imgly_text_design_asset_celebrate_05.png"
      }, S.prototype.availableOptions = w({}, d.a.prototype.availableOptions, {
        words: {
          type: h.OptionType.OBJECT,
          default: new g.a()
        },
        height: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        image: {
          type: h.OptionType.IMAGE,
          default: null
        },
        imagePath: {
          type: h.OptionType.STRING,
          default: S.RowImages.decorative1
        },
        drawingModeAspectFit: {
          type: h.OptionType.BOOLEAN,
          default: !1
        },
        attributes: {
          type: h.OptionType.CONFIGURABLE,
          default: new m.a()
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return x;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(124)),
          g = n(52),
          m = n(79),
          y = (n(177), n(438)),
          _ = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = function (e) {
        function t() {
          return b(this, t), w(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_calculateLayoutElements",
          value: function value() {
            var e = this.getWords(),
                t = this._getTextFrame(),
                n = this.getAttributes().getFontIdentifier(),
                i = this.getImageInsets(),
                r = new m.a({
              text: e.getWord(0),
              fontIdentifier: n
            });

            r.fitWidth(t.width);
            var o = new g.a({
              text: e.getWord(0),
              frame: t,
              font: r
            });
            o.setFrame(this._getTextFrameForElement(o));
            var a = this.getSize();
            return (this.getSizeToFitContent() || a.height <= 1) && (a.height = i.top + o.getFrame().height + i.bottom), a.height = Math.max(a.height, this.getMinimumHeight()), [o];
          }
        }, {
          key: "_getTextFrameForElement",
          value: function value(e) {
            var t = this.getWords().getWord(0),
                n = this.getAttributes(),
                i = n.getFontIdentifier(),
                r = this.getImageInsets(),
                o = this.getImageInsets().applyToRectangle(this._getFrame()).scale(this.getTextScaleFactor()),
                a = new y.a({
              text: t,
              fontIdentifier: i,
              alignment: n.getAlignment(),
              lineHeight: 1
            });
            a.fitInFrame(o);
            var s = a.getSize();
            o.height = s.height;
            var l = s.height * this.getRowScaleFactor();
            this.getSizeToFitContent() && (l += r.top + r.bottom);

            var u = this._getFrame(),
                c = n.getAlignment();

            if (this.getCenteredVertically()) o.y = u.height / 2 - l / 2 + r.top;else switch (c) {
              case "left":
                o.y = u.height - l - r.bottom;
                break;

              case "center":
                o.y = u.height / 2 - l / 2 + l * this.getCenterOffset(), o.x = (u.width - o.width) / 2;
                break;

              case "right":
                o.x = u.width - o.width - r.right;
            }
            return o;
          }
        }, {
          key: "render",
          value: function value(e) {
            var t = this;
            e.save(), this._getLayoutElements().forEach(function (n) {
              var i = n.serializeOptions(),
                  r = i.text,
                  o = i.frame,
                  a = t.getAttributes(),
                  s = a.getFontIdentifier(),
                  l = new y.a({
                text: r,
                fontIdentifier: s,
                alignment: a.getAlignment(),
                lineHeight: 1,
                textColor: a.getTextColor().toRGBA()
              });
              o = t._getTextFrameForElement(n), l.fitInFrame(o), l.draw(e, o.x, o.y);
            }), e.restore();
          }
        }]), t;
      }(d.a);

      x.prototype.availableOptions = _({}, d.a.prototype.availableOptions, {
        centerOffset: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        sizeToFitContent: {
          type: h.OptionType.BOOLEAN,
          default: !1
        },
        textScaleFactor: {
          type: h.OptionType.NUMBER,
          default: .95
        },
        rowScaleFactor: {
          type: h.OptionType.NUMBER,
          default: 1
        },
        minimumHeight: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        centeredVertically: {
          type: h.OptionType.BOOLEAN,
          default: !1
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return k;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(81)),
          y = n(53),
          _ = n(20),
          v = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          b = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function w(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var k = function (e) {
        function t() {
          var e;
          w(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = x(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          return o._possibleRowTypes = [m.a.SpeechBubble1, m.a.SpeechBubble3], o._rowTypesRandomizer = new _.a(0), o._isMaskedRandomizer = new _.a(0), o._seedPool.push(o._rowTypesRandomizer), o._seedPool.push(o._isMaskedRandomizer), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), b(t, [{
          key: "getImagePaths",
          value: function value() {
            return this._possibleRowTypes.map(function (e) {
              return e.getImagePath();
            });
          }
        }, {
          key: "_rowTypes",
          value: function value(e) {
            return this._possibleRowTypes;
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, n, i, r) {
            this._rowType = this._rowTypesRandomizer.pickNext(this._rowTypes(e)), r.setLineSpacing(.9);

            var o = function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = l()(t, n);

              if (void 0 === r) {
                var o = d()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var a = r.get;
              return void 0 !== a ? a.call(i) : void 0;
            }(t.prototype.__proto__ || d()(t.prototype), "_randomLayoutRow", this).call(this, e, n, i, r);

            return o.set({
              textScaleFactor: 1,
              minimumHeight: i * this._rowType.getMinimumHeightRatio(),
              sizeToFitContent: this._rowType.getSizeToFitContent(),
              centeredVertically: !0
            }), o;
          }
        }]), t;
      }(y.a);

      k.defaultFontIdentifiers = ["imgly_font_panton_black_caps", "imgly_font_panton_light_caps", "imgly_font_panton_black_italic_caps", "imgly_font_panton_light_italic_caps"], k.identifier = "imgly_text_design_masked_speech_bubble", k.prototype.availableOptions = v({}, y.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: k.defaultFontIdentifiers
        },
        squareLayout: {
          type: g.OptionType.BOOLEAN,
          default: !1
        },
        alignment: {
          type: g.OptionType.STRING,
          default: "left",
          available: y.a.ValidAlignments
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return L;
      });

      var i = n(6),
          r = n.n(i),
          o = n(29),
          a = n.n(o),
          s = n(25),
          l = n.n(s),
          u = n(15),
          c = n.n(u),
          p = n(0),
          f = n.n(p),
          h = n(5),
          d = n.n(h),
          g = n(2),
          m = n.n(g),
          y = n(3),
          _ = n.n(y),
          v = n(1),
          b = n.n(v),
          w = n(4),
          x = (n.n(w), n(77)),
          k = n(26),
          T = n(27),
          S = n(21),
          C = n(47),
          E = n(126),
          O = n(125),
          R = n(20),
          I = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          A = function A(e, t) {
        if (Array.isArray(e)) return e;
        if (a()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var a, s = l()(e); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && s.return && s.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          M = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), f()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          F = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = d()(t, n);

        if (void 0 === r) {
          var o = b()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function D(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return c()(e);
      }

      function P(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function z(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var L = function (e) {
        function t() {
          var e;
          P(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = z(this, (e = t.__proto__ || b()(t)).call.apply(e, [this].concat(i)));
          return o._relativeInsets = new S.a(0, 0, 0, 0), o._INVALID_FONTS_IF_LESS_THEN_5_CHARS = ["imgly_font_montserrat_light"], o._INVALID_FONTS_IF_LESS_THEN_4_CHARS = ["imgly_font_montserrat_light", "imgly_font_wolesbro"], o._lineCount = 0, o._decorativeRowCreated = !1, o._useImageRowRandomizer = new R.a(0), o._rowTypeRandomizer = new R.a(0), o._lineDecorativeTypeRandomizer = new R.a(0), o._seedPool.push(o._useImageRowRandomizer), o._seedPool.push(o._rowTypeRandomizer), o._seedPool.push(o._lineDecorativeTypeRandomizer), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = _()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (m.a ? m()(e, t) : e.__proto__ = t);
        }(t, e), M(t, [{
          key: "getImagePaths",
          value: function value() {
            return [].concat(D(t.DecoratorImages), D(t.RowImages));
          }
        }, {
          key: "_fontForRow",
          value: function value(e, t) {
            var n = this,
                i = t.countNumberOfCharacters(),
                r = this.getFontIdentifiers();
            return i < 4 ? r = r.filter(function (e) {
              return n._INVALID_FONTS_IF_LESS_THEN_4_CHARS.indexOf(e) < 0;
            }) : i < 5 && (r = r.filter(function (e) {
              return n._INVALID_FONTS_IF_LESS_THEN_5_CHARS.indexOf(e) < 0;
            })), r[e % r.length];
          }
        }, {
          key: "_modifiedText",
          value: function value(e) {
            return F(t.prototype.__proto__ || b()(t.prototype), "_modifiedText", this).call(this, e).toUpperCase();
          }
        }, {
          key: "_modifiedLines",
          value: function value(e) {
            return this._lineCount = e.length, e;
          }
        }, {
          key: "generateLayoutData",
          value: function value(e, n) {
            return this._decorativeRowCreated = !1, F(t.prototype.__proto__ || b()(t.prototype), "generateLayoutData", this).call(this, e, n);
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, t, n, i) {
            var r = e;

            switch (i.getFontIdentifier()) {
              case "imgly_font_wolesbro":
                r = new C.a().set(e.getLowerCase());
                break;

              case "imgly_font_permanent_marker":
                r = new C.a().set(e.getUpperCase());
            }

            var o = this.getDecorativeRowsInTheMiddleOnly() && (0 === t || t === this._lineCount - 1);
            if (this._useImageRowRandomizer.nextBool() || this._decorativeRowCreated || o) return new k.a({
              words: r,
              width: n,
              attributes: i
            });
            this._decorativeRowCreated = !0;

            var a = this._randomDecoratorImages(),
                s = A(a, 2),
                l = s[0],
                u = s[1];

            return new O.a({
              words: e,
              width: n,
              attributes: i,
              leftImage: l,
              rightImage: u
            });
          }
        }, {
          key: "_layoutRows",
          value: function value(e, n) {
            var i = F(t.prototype.__proto__ || b()(t.prototype), "_layoutRows", this).call(this, e, n);
            if (!this.getDecorationsVisible()) return i;
            var r = .0625 * n,
                o = new E.a({
              width: n,
              height: r,
              image: T.a.getImage(this._rowTypeRandomizer.pickNext(t.RowImages))
            }).layout(),
                a = new E.a({
              width: n,
              height: r,
              image: T.a.getImage(this._rowTypeRandomizer.pickNext(t.RowImages))
            }).layout();
            return [o].concat(D(i), [a]);
          }
        }, {
          key: "_randomDecoratorImages",
          value: function value() {
            return this._lineDecorativeTypeRandomizer.nextInRange(0, 1) ? t.DecoratorImages.slice(0, 2).map(function (e) {
              return T.a.getImage(e);
            }) : t.DecoratorImages.slice(2).map(function (e) {
              return T.a.getImage(e);
            });
          }
        }]), t;
      }(x.a);

      L.defaultFontIdentifiers = ["imgly_font_permanent_marker", "imgly_font_wolesbro", "imgly_font_wolesbro", "imgly_font_montserrat_light"], L.identifier = "imgly_text_design_sunshine", L.RowImages = [E.a.RowImages.decorative1, E.a.RowImages.decorative2, E.a.RowImages.decorative3, E.a.RowImages.decorative4], L.DecoratorImages = ["text-design/images/imgly_text_design_asset_decorative_03.png", "text-design/images/imgly_text_design_asset_decorative_04.png", "text-design/images/imgly_text_design_asset_decorative_07.png", "text-design/images/imgly_text_design_asset_decorative_08.png"], L.prototype.availableOptions = I({}, x.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: w.OptionType.ARRAY,
          default: L.defaultFontIdentifiers
        },
        relativeLineSpacing: {
          type: w.OptionType.NUMBER,
          default: .025 / 3 * 4
        },
        decorationsVisible: {
          type: w.OptionType.BOOLEAN,
          default: !0
        },
        decorativeRowsInTheMiddleOnly: {
          type: w.OptionType.BOOLEAN,
          default: !1
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return k;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(183)),
          g = n(27),
          m = n(48),
          y = n(446),
          _ = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = h.Math.Rectangle,
          k = function (e) {
        function t() {
          var e;
          b(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = w(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._MAX_TRIES = 1e3, o._PRECISION = 1e3, o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "render",
          value: function value(e, t, n, i, r) {
            var o = this._options,
                a = o.imagePaths,
                s = o.relativeParticleSize;

            if (!(a.length <= 0)) {
              var l = t.width / t.height,
                  u = new x(Math.round(n.left * this._PRECISION), Math.round(n.top * this._PRECISION * l), this._PRECISION, this._PRECISION);
              u.width -= u.x + Math.round(n.right * this._PRECISION), u.height -= u.y + Math.round(n.bottom * this._PRECISION * l);

              for (var c = [], p = 0, f = 0; p < this.getParticleCount() && f < this._MAX_TRIES;) {
                var h = s / 2,
                    d = Math.round(h * this._PRECISION),
                    _ = Math.round(h * this._PRECISION * l),
                    v = Math.floor(this._PRECISION) - d,
                    b = Math.floor(this._PRECISION) - _,
                    w = r.nextInRange(d, v),
                    k = r.nextInRange(_, b),
                    T = new x(w - d, k - _, 2 * d, 2 * _);

                T.intersects(u) || this.hasCollision(c, T) || (c.push(new y.a({
                  frame: T
                })), p += 1), f += 1;
              }

              for (var S = 0; S < c.length; S++) {
                var C = c[S],
                    E = r.pickNext(a),
                    O = g.a.getImage(E),
                    R = r.nextInRange(140, 230) / 255,
                    I = t.width / this._PRECISION,
                    A = t.height / this._PRECISION,
                    M = C.getContentFrame();
                M.x *= I, M.y *= A, M.width *= I, M.height *= A;
                var F = i.clone();
                F.a = R, Object(m.a)(e, O, M, F, "source-atop");
              }
            }
          }
        }, {
          key: "hasCollision",
          value: function value(e, t) {
            for (var n = 0; n < e.length; n++) {
              if (t.intersects(e[n].getFrame())) return !0;
            }

            return !1;
          }
        }]), t;
      }(d.a);

      k.prototype.availableOptions = _({}, d.a.prototype.availableOptions, {
        particleCount: {
          type: h.OptionType.NUMBER,
          default: 50
        },
        relativeParticleSize: {
          type: h.OptionType.NUMBER,
          default: .08
        },
        imagePaths: {
          type: h.OptionType.ARRAY,
          default: []
        }
      });
    }, function (e, t, n) {
      e.exports = {
        default: n(457),
        __esModule: !0
      };
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(13)),
          g = n(54),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = function (e) {
        function t() {
          return y(this, t), _(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            var e = this._getInputWithName("x").logicalShape;

            if (4 !== e.length) throw new Error("UnpackRGBAFilter expects 4D inputs");
            var t = e[0];
            if (3 !== e[3]) throw new Error("Expected RGB values");
            if (1 !== t) throw new Error("PackRGBAFilter does not support batches of images.");
            var n = this._options.outputSize;
            if (2 !== n.length) throw new Error("Expected outputSize of length 2");
            if (n[0] * n[1] != g.a.getSizeOfLogicalShape(e) / 3) throw new Error("Input shape " + e + " can't be broken up into 3 channels.");
            return n;
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      void main ()\n      {\n        ivec2 outputCoords = getOutputCoords();\n        int row = outputCoords.x;\n        int col = outputCoords.y;\n        float r = getX(0, row, col, 0);\n        float g = getX(0, row, col, 1);\n        float b = getX(0, row, col, 2);\n        gl_FragColor = vec4(r, g, b, 1.0);\n      }\n    ";
          }
        }, {
          key: "requiresFloatTextures",
          value: function value() {
            return !1;
          }
        }]), t;
      }(d.b);

      v.prototype.availableOptions = r()({
        outputSize: {
          type: h.OptionType.ARRAY
        }
      }, d.b.prototype.availableOptions), t.a = v;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }

        return o(e, null, [{
          key: "calculatePadding",
          value: function value(e, t, n, i, r, o, a) {
            var s = void 0,
                l = void 0,
                u = void 0;

            if ("same" === e) {
              var c = ((s = Math.ceil(t / i)) - 1) * i + o - t,
                  p = ((l = Math.ceil(n / r)) - 1) * r + a - n,
                  f = Math.floor(c / 2),
                  h = c - f,
                  d = Math.floor(p / 2);
              u = {
                top: f,
                bottom: h,
                left: d,
                right: p - d,
                type: "SAME"
              };
            } else {
              if ("valid" !== e) throw Error("Unknown padding parameter: " + e);
              u = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                type: "VALID"
              }, s = Math.ceil((t - o + 1) / i), l = Math.ceil((n - a + 1) / r);
            }

            return {
              padInfo: u,
              outHeight: s,
              outWidth: l
            };
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(6),
          a = n.n(o),
          s = n(25),
          l = n.n(s),
          u = n(31),
          c = (n.n(u), n(9)),
          p = n(91),
          f = n(72),
          h = n(494),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          g = function () {
        function e(t, n, i) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._ui = t, this._options = n, this._dynamicAssetsLibrary = i || this._ui.getEditor().getDynamicAssetsLibrary() || new h.a(), this._categoriesById = {}, this._categories = [], this._stickersById = {}, this._customStickerCanvas = u.Utils.createCanvas(), this.reload();
        }

        return d(e, [{
          key: "reload",
          value: function value() {
            this._categoriesById = {}, this._categories = [], this._stickersById = {};

            var e = this._ui.getEditor().getSDK()._l.areCustomAssetsAllowed();

            this._addCategories(p.b.DEFAULTS.STICKER_CATEGORIES);

            var t = this._options,
                n = t.categories,
                i = t.replaceCategories;

            if (e && this._options.categories ? this._addCategories(n, i) : (this._updateCategoriesMap(), this._updateAllCategory()), e) {
              var r = this._dynamicAssetsLibrary.getAssets("sticker");

              if (r.length > 0) {
                var o = this._createCustomStickerCategory(r);

                this._addCategories([o], !1, !0);
              }
            }
          }
        }, {
          key: "loadExternal",
          value: function value(e) {
            var t = this;
            return new f.a(e).load().then(function (e) {
              t._addCategories(e.categories, t._options.replaceCategories);
            });
          }
        }, {
          key: "_addCategories",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            this._categories = t ? e.slice(0) : n ? this._mergeCategories(e, this._categories) : this._mergeCategories(this._categories, e), this._updateCategoriesMap(), this._updateAllCategory();
          }
        }, {
          key: "_mergeCategories",
          value: function value(e, t) {
            e = c.m.cloneCategories(e, "stickers");
            var n = !0,
                i = !1,
                r = void 0;

            try {
              for (var o, s = l()(t); !(n = (o = s.next()).done); n = !0) {
                var u = o.value,
                    p = !1,
                    f = !0,
                    h = !1,
                    d = void 0;

                try {
                  for (var g, m = l()(e); !(f = (g = m.next()).done); f = !0) {
                    var y = g.value;

                    if (u.identifier === y.identifier) {
                      var _ = !0,
                          v = !1,
                          b = void 0;

                      try {
                        for (var w, x = l()(u.stickers); !(_ = (w = x.next()).done); _ = !0) {
                          var k = w.value,
                              T = !1,
                              S = !0,
                              C = !1,
                              E = void 0;

                          try {
                            for (var O, R = l()(y.stickers); !(S = (O = R.next()).done); S = !0) {
                              var I = O.value;

                              if (k.identifier === I.identifier) {
                                a()(I, k), T = !0;
                                break;
                              }
                            }
                          } catch (e) {
                            C = !0, E = e;
                          } finally {
                            try {
                              !S && R.return && R.return();
                            } finally {
                              if (C) throw E;
                            }
                          }

                          T || y.stickers.push(k);
                        }
                      } catch (e) {
                        v = !0, b = e;
                      } finally {
                        try {
                          !_ && x.return && x.return();
                        } finally {
                          if (v) throw b;
                        }
                      }

                      p = !0;
                      break;
                    }
                  }
                } catch (e) {
                  h = !0, d = e;
                } finally {
                  try {
                    !f && m.return && m.return();
                  } finally {
                    if (h) throw d;
                  }
                }

                p || e.push(u);
              }
            } catch (e) {
              i = !0, r = e;
            } finally {
              try {
                !n && s.return && s.return();
              } finally {
                if (i) throw r;
              }
            }

            return e;
          }
        }, {
          key: "_updateCategoriesMap",
          value: function value() {
            var e = this;
            this._categoriesById = {}, this._categories.forEach(function (t) {
              e._categoriesById[t.identifier] = t;
            }), this._categories.forEach(function (t) {
              t.stickers.forEach(function (t) {
                e._stickersById[t.identifier] = t;
              });
            }), void 0 !== this._options.availableStickers && null !== this._options.availableStickers && (this._categories.forEach(function (t) {
              "imgly_sticker_custom" !== t.identifier && (t.stickers = t.stickers.filter(function (t) {
                return -1 !== e._options.availableStickers.indexOf(t.identifier);
              }));
            }), this._categories = this._categories.filter(function (e) {
              return e.stickers.length > 0;
            })), this._updateAllCategory();
          }
        }, {
          key: "_updateAllCategory",
          value: function value() {
            this._allCategory = {
              identifier: "all",
              defaultName: "All",
              stickers: this._categories.map(function (e) {
                return e.stickers;
              }).reduce(function (e, t) {
                return e.concat(t);
              }, [])
            }, this._categoriesById.all = this._allCategory;
          }
        }, {
          key: "renderStickerThumbnailFromImage",
          value: function value(e) {
            var t = this._customStickerCanvas,
                n = t.getContext("2d");
            n.save();
            var i = 62 / e.width,
                r = i * e.height;
            t.width = 62, t.height = 62, n.clearRect(0, 0, e.width, e.height), n.translate(0, .5 * (t.height - r)), n.scale(i, i), n.drawImage(e, 0, 0);
            var o = t.toDataURL("image/png");
            return n.restore(), {
              data: o,
              width: 62,
              height: r
            };
          }
        }, {
          key: "addCustomStickerFromImage",
          value: function value(e, t) {
            var n = this,
                i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "none",
                r = function r(e) {
              var t = n._ui.getEditor().getSDK().getRenderer(),
                  i = new c.n(e.width, e.height),
                  r = 1e6 * n._ui.getEditor().getMaxMegapixels(),
                  o = t.getMaxDimensions(),
                  a = i.x * i.y > r,
                  s = null !== o && (i.x > o || i.y > o);

              if (a) {
                var l = e.width / e.height,
                    u = e.height / e.width;
                o = new c.n(Math.sqrt(r * l), Math.sqrt(r * u)).floor().max();
              }

              var p = i.clone();
              return (a || s) && (i.x / i.y > 1 ? (p.x = o, p.y = o / i.x * i.y) : (p.x = o / i.y * i.x, p.y = o)), p;
            },
                o = function o(e, t) {
              var n = e.x / e.y;
              return n > 1 ? new c.n(t, t / n) : new c.n(t * n, t);
            },
                a = "data:image/svg" === e.src.substring(0, 14),
                s = this._ui.getEditor().getSDK();

            e = s.correctExifOrientation(e);
            var l = o(new c.n(e.width, e.height), 2048),
                p = a ? l : r(e),
                f = this._customStickerCanvas,
                h = f.getContext("2d");
            h.save();
            var d = this.renderStickerThumbnailFromImage(e);
            a ? (e.width > e.height ? (f.width = 2048, f.height = 2048 / e.width * e.height) : (f.height = 2048, f.width = 2048 / e.height * e.width), e.width = f.width, e.height = f.height) : (f.width = p.x, f.height = p.y, h.scale(p.x / e.width, p.y / e.height)), h.drawImage(e, 0, 0, e.width, e.height);
            var g = f.toDataURL();
            h.restore();
            var m = {
              identifier: u.Utils.generateUUID(),
              defaultName: t || "",
              tintMode: i,
              images: {
                mediaThumb: {
                  uris: [d.data],
                  rawData: !0,
                  width: d.width,
                  height: d.height
                },
                mediaBase: {
                  uris: a ? [g, e.src] : [g],
                  rawData: !0,
                  isSVG: a,
                  width: p.x,
                  height: p.y
                }
              }
            },
                y = this._dynamicAssetsLibrary;
            y.addAsset("sticker", m, !0);

            var _ = y.getAssets("sticker");

            if (1 === _.length) {
              var v = this._createCustomStickerCategory(_);

              this._addCategories([v], !1, !0);
            } else this.getCategory("imgly_sticker_custom").stickers = _, this._updateAllCategory();

            this._updateCategoriesMap();
          }
        }, {
          key: "_createCustomStickerCategory",
          value: function value(e) {
            return {
              identifier: "imgly_sticker_custom",
              defaultName: "Custom",
              metaData: {
                backgroundImage: e[e.length - 1].images.mediaBase.uris[0],
                rawData: !0
              },
              stickers: e
            };
          }
        }, {
          key: "getStickersForCategory",
          value: function value(e) {
            if (!this._categoriesById[e]) throw new Error("Unknown sticker category '" + e + "'");
            return this._categoriesById[e].stickers;
          }
        }, {
          key: "getStickerByIdentifier",
          value: function value(e) {
            return this._stickersById[e];
          }
        }, {
          key: "getCategories",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return e ? [this._allCategory].concat(this._categories) : this._categories;
          }
        }, {
          key: "getCategory",
          value: function value(e) {
            return this._categoriesById[e];
          }
        }], [{
          key: "getURLForSticker",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "base",
                n = e.images,
                i = "base" === t && n.mediaBase || n.mediaThumb,
                r = i.uris || [i.uri];

            if (void 0 === c.m.Browser || c.m.Browser.getIEVersion()) {
              var o = r.filter(function (e) {
                return !/\.svg$/i.test(e);
              });
              return o.length ? o[0] : r[0];
            }

            var a = r.filter(function (e) {
              return /\.svg$/i.test(e);
            });
            return a.length ? a[0] : r[0];
          }
        }]), e;
      }();

      t.a = g;
    }, function (e, t, n) {
      var i = n(36),
          r = n.n(i),
          o = n(37),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(10),
          c = n.n(u),
          p = n(496),
          f = n(499),
          h = "function" == typeof a.a && "symbol" == typeof r.a ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof a.a && e.constructor === a.a && e !== a.a.prototype ? "symbol" : typeof e;
      },
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          g = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._ui = t, this._fonts = n, this._loadedFonts = [];
        }

        return d(e, [{
          key: "setFonts",
          value: function value(e) {
            this._fonts = e;
          }
        }, {
          key: "needsToLoad",
          value: function value() {
            for (var e = this, t = function t(_t3) {
              var n = void 0;
              return e._fonts[_t3].getVariations().forEach(function (e) {
                n = n || e.getProvider();
              }), n ? {
                v: !0
              } : "continue";
            }, n = 0; n < this._fonts.length; n++) {
              var i = t(n);

              switch (i) {
                case "continue":
                  continue;

                default:
                  if ("object" === (void 0 === i ? "undefined" : h(i))) return i.v;
              }
            }
          }
        }, {
          key: "fontLoaded",
          value: function value(e) {
            var t = e.getFontFamily();
            return -1 !== this._loadedFonts.indexOf(t);
          }
        }, {
          key: "setFontLoaded",
          value: function value(e) {
            if (!this.fontLoaded(e)) {
              var t = e.getFontFamily();

              this._loadedFonts.push(t);
            }
          }
        }, {
          key: "load",
          value: function value() {
            var e = this,
                t = this._fonts,
                n = {
              google: new p.a(this._ui),
              file: new f.a(this._ui)
            },
                i = function i() {
              for (var e in n) {
                n[e].dispose();
              }
            };

            t.filter(function (t) {
              return !e.fontLoaded(t);
            }).forEach(function (e) {
              e.getVariations().forEach(function (e) {
                var t = e.getProvider();
                t && n[t].add(e);
              });
            });
            var r = [];

            for (var o in n) {
              r.push(n[o].load());
            }

            return c.a.all(r).then(function () {
              i(), t.forEach(function (t) {
                e.setFontLoaded(t);
              });
            }).catch(function (e) {
              throw i(), e;
            });
          }
        }]), e;
      }();

      t.a = g;
    }, function (e, t, n) {
      e.exports = !n(19) && !n(42)(function () {
        return 7 != Object.defineProperty(n(94)("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (e, t, n) {
      var i = n(43),
          r = n(35),
          o = n(235)(!1),
          a = n(100)("IE_PROTO");

      e.exports = function (e, t) {
        var n,
            s = r(e),
            l = 0,
            u = [];

        for (n in s) {
          n != a && i(s, n) && u.push(n);
        }

        for (; t.length > l;) {
          i(s, n = t[l++]) && (~o(u, n) || u.push(n));
        }

        return u;
      };
    }, function (e, t, n) {
      var i = n(16).document;
      e.exports = i && i.documentElement;
    }, function (e, t, n) {
      var i = n(43),
          r = n(44),
          o = n(100)("IE_PROTO"),
          a = Object.prototype;

      e.exports = Object.getPrototypeOf || function (e) {
        return e = r(e), i(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? a : null;
      };
    }, function (e, t, n) {
      var i = n(36),
          r = n.n(i),
          o = n(37),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(10),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(38),
          _ = n(166),
          v = n(169),
          b = n(120),
          w = (n(90), n(320)),
          x = n(168),
          k = "function" == typeof a.a && "symbol" == typeof r.a ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof a.a && e.constructor === a.a && e !== a.a.prototype ? "symbol" : typeof e;
      },
          T = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function S(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function C(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }
      /*
       * This file is part of PhotoEditorSDK.
       *
       * Copyright (C) 2016-2019 img.ly GmbH <contact@img.ly>
       * All rights reserved.
       *
       * Redistribution and use in source and binary forms, without
       * modification, are permitted provided that the following license agreement
       * is approved and a legal/financial contract was signed by the user.
       * The license agreement can be found under following link:
       *
       * https://www.photoeditorsdk.com/LICENSE.txt
       * @license
       */


      var E = function E(e) {
        return A.byteArrayToString(z.decode(e));
      },
          O = y.Rectangle,
          R = y.Constants,
          I = y.Engine,
          A = y.Utils,
          M = y.EventEmitter,
          F = y.Events,
          D = y.Vector2,
          P = y.Log,
          z = y.Base64,
          L = y.Color,
          B = R.RenderType,
          N = R.ImageFormat,
          U = R.RendererType,
          j = function (e) {
        function t(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          S(this, t);
          var r = C(this, (t.__proto__ || m()(t)).call(this));
          r._onOperationUpdate = r._onOperationUpdate.bind(r), r._onContextRestored = r._onContextRestored.bind(r);
          var o = n(170),
              a = o.version;

          if (r.version = a, r[E("VG04Z1lHRndhVXRsZVdBZ2IzQjBhVzl1SUdkcGRtVnU=")] = !0, r._preferredRenderer = e, r._options = A.defaults(i, {
            extensions: {},
            renderMode: "dynamic",
            versionCheck: !0,
            displayWelcomeMessage: !0,
            image: null,
            canvas: null,
            transparent: !1,
            clearColor: L.TRANSPARENT,
            textureQuality: 1,
            zoom: 1,
            spriteScale: 1,
            rotation: 0,
            smoothDownscaling: !1,
            smoothUpscaling: !1,
            crossOrigin: "anonymous",
            logLevel: "warn",
            pixelRatio: "undefined" != typeof window && window.devicePixelRatio || 1
          }), r._options.smoothUpscaling && (I.BaseTexture.DefaultMagFilter = I.BaseTexture.LinearFilter), r._options.extensions = A.defaults(r._options.extensions, {
            operations: [],
            controls: [],
            languages: []
          }), P.setLevel(r._options.logLevel), r[E("Wm5KbFpVeHBZMlZ1YzAxdlpHVT0=")] = !1, r[E("X29wdGlvbnM=")][E("bGljZW5zZQ==")]) {
            if (!r._v()) return C(r);
            var s = y[E("TGljZW5zZUNoZWNrZXI=")];
            r._l = new s(r[E("X29wdGlvbnM=")][E("bGljZW5zZQ==")]), r._cv(!0).then(function () {
              r._ct();
            }).catch(function (e) {
              P.error(E("TGljZW5zaW5n"), e.message);
            });
          } else r[E("Wm5KbFpVeHBZMlZ1YzAxdlpHVT0=")] = !0, r._l = new y[E("RnJlZUxpY2Vuc2VDaGVja2Vy")]();

          return r._defaultRenderMode = r._options.renderMode, r._renderMode = r._options.renderMode, r._textureQuality = r._options.textureQuality, r._offset = new D(), r._zoom = r._options.zoom, r._spriteScale = r._options.spriteScale, r._rotation = r._options.rotation, r._operations = {}, r._operationsStack = null, r.setOperationsStack(new v.a()), r._container = new I.Container(), r._sprite = new I.Sprite(), r._container.addChild(r._sprite), r._inputTexture = r._options.inputTexture, r._currentInputTexture = null, r._currentTexture = null, r._resizedTexture = null, r._resizedContainer = new I.Container(), r._resizedSprite = new I.Sprite(), r._resizedContainer.addChild(r._resizedSprite), r._texturesToDispose = [], r.setSmoothDownscaling(r._options.smoothDownscaling), r._registerOperations(), r._initRenderer(), r._renderer.constructor.type, r._options.displayWelcomeMessage, r[E("Wm5KbFpVeHBZMlZ1YzAxdlpHVT0=")] && P.log(E("VGhlIFBob3RvRWRpdG9yIFNESyBpcyBhIGNvbW1lcmNpYWwgcHJvZHVjdC4gQmVmb3JlIGJlaW5nIGFibGUgdG8gdXNlIGl0IHdpdGhvdXQgbGltaXRhdGlvbnMsIHlvdSBuZWVkIHRvIHVubG9jayB0aGUgU0RLIHdpdGggYSBsaWNlbnNlIGZpbGUuIFlvdSBjYW4gb2J0YWluIGEgdGltZS1saW1pdGVkIGV2YWx1YXRpb24gbGljZW5zZSBieSBzdGFydGluZyBhIHRyaWFsIGF0IGh0dHBzOi8vd3d3LnBob3RvZWRpdG9yc2RrLmNvbS91c2Vycy9uZXcgb3IgeW91IGNhbiBwdXJjaGFzZSBhIGxpY2Vuc2UgYnkgcmVxdWVzdGluZyBhIHF1b3RlIGF0IGh0dHBzOi8vd3d3LnBob3RvZWRpdG9yc2RrLmNvbS9wcmljaW5nLgoKQmVjYXVzZSB5b3UgZGlkIG5vdCBzcGVjaWZ5IGEgbGljZW5zZSBmaWxlIHlldCwgdGhlIFNESyB3aWxsIG5vdyBkaXNwbGF5IGEgd2F0ZXJtYXJrIGltYWdlIG9uIHRvcCBvZiBhbnkgcGhvdG9zIHlvdSBkaXNwbGF5IG9yIGV4cG9ydCB3aXRoIGl0LiBGb3IgaW5zdHJ1Y3Rpb25zIGZvciBob3cgdG8gdW5sb2NrIHRoZSBTREssIHBsZWFzZSB2aXNpdCBodHRwczovL2RvY3MucGhvdG9lZGl0b3JzZGsuY29tL2d1aWRlcy9odG1sNS92NC9pbnRyb2R1Y3Rpb24vZ2V0dGluZ19zdGFydGVkLg==")), r._options.image && r.setImage(r._options.image, r._options.exif), r;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), T(t, [{
          key: "_v",
          value: function value() {
            return !!this[E("X29wdGlvbnM=")][E("bGljZW5zZQ==")] || (P.error(E("TGljZW5zaW5n"), E("Tm8gYGxpY2Vuc2VgIG9wdGlvbiBnaXZlbi4=")), P.error(E("TGljZW5zaW5n"), E("SW4gY2FzZSB5b3UgZG9uJ3QgaGF2ZSBhIGxpY2Vuc2UgeWV0LCBwbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tIHRvIG9idGFpbiBhIGxpY2Vuc2Ugb3IgbG9nIGluIHRvIHlvdXIgY3VzdG9tZXIgZGFzaGJvYXJkLg==")), !1);
          }
        }, {
          key: "_ct",
          value: function value() {
            this._l.exp() && (this._l.isExp() ? P.error(E("TGljZW5zaW5n"), E("WW91ciB0cmlhbCBsaWNlbnNlIGhhcyBleHBpcmVkLiBQbGVhc2UgY29udGFjdCB1cyBhdCBzYWxlc0BwaG90b2VkaXRvcnNkay5jb20gdG8gb2J0YWluIGEgbGljZW5zZS4=")) : P.warn(E("TGljZW5zaW5n"), E("WW91ciB0cmlhbCBsaWNlbnNlIHdpbGwgZXhwaXJlIGluICVkIGRheXMu").replace("%d", this._l.dl())));
          }
        }, {
          key: "_cv",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return this._l.c().catch(function (n) {
              e[E("VG04Z1lHRndhVXRsZVdBZ2IzQjBhVzl1SUdkcGRtVnU=")] = !1;
              var i = E("SW52YWxpZCBsaWNlbnNlLg==");
              throw t && (i = "ELICEXP" === n.code ? E("WW91ciB0cmlhbCBsaWNlbnNlIGhhcyBleHBpcmVkLiBQbGVhc2UgY29udGFjdCB1cyBhdCBzYWxlc0BwaG90b2VkaXRvcnNkay5jb20gdG8gb2J0YWluIGEgbGljZW5zZS4=") : "ELICINVHOST" === n.code ? E("VGhpcyBsaWNlbnNlIGlzIG5vdCB2YWxpZCBmb3IgdGhlIGhvc3RuYW1lIA==") + window.location.hostname + "." : "ELICINVPLAT" === n.code ? E("VGhpcyBsaWNlbnNlIGlzIG5vdCB2YWxpZCBmb3IgdGhlIGN1cnJlbnQgcGxhdGZvcm0u") : "ELICINVFMT" === n.code ? E("SW52YWxpZCBsaWNlbnNlIGZvcm1hdC4gUGxlYXNlIG1ha2Ugc3VyZSB5b3UncmUgcGFzc2luZyB5b3VyIGxpY2Vuc2UgYXMgYSBzdHJpbmcsIG5vdCBhcyBgJGZvcm1hdGAu").replace("$format", k(e._options.license)) : "ELICINV" === n.code ? E("SW52YWxpZCBsaWNlbnNlISBQbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc3VwcG9ydEBwaG90b2VkaXRvcnNkay5jb20gdG8gb2J0YWluIGEgbGljZW5zZSBvciBsb2cgaW4gdG8geW91ciBjdXN0b21lciBkYXNoYm9hcmQu") : E("SW4gY2FzZSB5b3UgZG9uJ3QgaGF2ZSBhIGxpY2Vuc2UgeWV0LCBwbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tIHRvIG9idGFpbiBhIGxpY2Vuc2Ugb3IgbG9nIGluIHRvIHlvdXIgY3VzdG9tZXIgZGFzaGJvYXJkLg==")), n.message = i, new Error(n);
            });
          }
        }, {
          key: "_t",
          value: function value() {
            this._l.t();
          }
        }, {
          key: "_fl",
          value: function value() {
            return this[E("Wm5KbFpVeHBZMlZ1YzAxdlpHVT0=")];
          }
        }, {
          key: "_onOperationUpdate",
          value: function value() {
            for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            this.emit.apply(this, [F.OPERATION_UPDATED].concat(t));
          }
        }, {
          key: "_onContextRestored",
          value: function value() {
            P.warn(this.constructor.name, "Trying to re-render after WebGL context has been restored."), this.setAllOperationsToDirty(), this._operationsStack.forEach(function (e) {
              e.disposeRenderTextures();
            }), this.render();
          }
        }, {
          key: "export",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : B.DATAURL,
                t = this,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : N.PNG,
                i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .8;
            return this._cv(!0).then(function () {
              return t.hasChanges() && t._t(), t._operationsStack.forEach(function (e) {
                e.onBeforeExport();
              }), new w.a(t, {
                renderType: e,
                imageFormat: n,
                quality: i
              }).export().then(function (e) {
                return t._operationsStack.forEach(function (e) {
                  e.onAfterExport();
                }), d.a.resolve(e);
              });
            });
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
                t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            if (!this._inputTexture) throw new Error("You need to set an image before calling PhotoEditorSDK#render.");

            var n = this._renderer.getContext();

            n.startFrame && n.startFrame();
            var i = void 0;
            P.canLog("info") && (i = new x.a("⚡⚡⚡", "Frame rendering")), P.info("⚡⚡⚡", "Rendering starts");
            var r = this._operationsStack;
            return r.updateDirtinessForRenderer(this._renderer), this._prepareTexture().then(function (t) {
              "export" === e._renderMode && (t = e._inputTexture), e._currentTexture = t, e._sprite.setTexture(t), e._container.updateTransform();
            }).then(function () {
              return r.validateSettings();
            }).then(function () {
              return !e._fl() && e[E("VG04Z1lHRndhVXRsZVdBZ2IzQjBhVzl1SUdkcGRtVnU=")] || (r.getByIdentifier("license-watermark") ? r.moveToTop("license-watermark") : e.createOperation("license-watermark")), r.render(e, e._currentTexture);
            }).then(function (n) {
              var i = n.outputTexture;

              switch (e._currentTexture = i, e._sprite.setTexture(e._currentTexture), e._renderMode) {
                case "dynamic":
                  var r = e._renderer.getDimensions().clone().divide(2).add(e._offset);

                  e._container.setScale(e._zoom / e.getTextureScale(), e._zoom / e.getTextureScale()), e._container.setPosition(r), e._sprite.setAnchor(.5, .5), e._sprite.setScale(e._spriteScale, e._spriteScale), e._sprite.setRotation(e._rotation);
                  break;

                case "export":
                  e._container.setScale(1, 1), e._container.setPosition(0, 0), e._sprite.setAnchor(0, 0), e._sprite.setPosition(0, 0), e._sprite.setScale(e._spriteScale, e._spriteScale), e._sprite.setRotation(0);
                  break;

                case "adapter":
                  e._container.setScale(1, 1), e._container.setPosition(0, 0), e._sprite.setAnchor(0, 0), e._sprite.setPosition(0, 0), e._sprite.setScale(1, 1), e._sprite.setRotation(0);
              }

              return t && e._renderer.render(e._container), n;
            }).then(function (t) {
              return i && i.stop(), n.endFrame && n.endFrame(), e._disposeTextures(), t;
            });
          }
        }, {
          key: "getTextureScale",
          value: function value() {
            return Math.min(1, this._textureQuality * this._options.pixelRatio);
          }
        }, {
          key: "_prepareTexture",
          value: function value() {
            var e = this;
            return new d.a(function (t, n) {
              var i = e.getTextureScale();
              if (1 === e._textureQuality) return t(e._inputTexture);
              var r = e.getInputDimensions().multiply(i).floor(),
                  o = void 0;
              e._resizedTexture ? e._resizedTexture.getDimensions().equals(r) || (e._resizedTexture.resizeTo(r), o = !0) : (e._resizedTexture = new I.RenderTexture(e._renderer, r.x, r.y), o = !0), o && (e._resizedSprite.setScale(i, i), e._resizedSprite.setTexture(e._inputTexture), e._resizedTexture.render(e._resizedContainer)), t(e._resizedTexture);
            });
          }
        }, {
          key: "_registerOperations",
          value: function value() {
            for (var e in this._operations = {}, _) {
              var t = _[e];
              this._operations[t.identifier] = t;
            }

            this._operations = A.extend(this._operations, this._options.extensions.operations);
          }
        }, {
          key: "registerOperations",
          value: function value(e) {
            var t = this;
            e.forEach(function (e) {
              t._operations[e.identifier] = e;
            });
          }
        }, {
          key: "setAllOperationsToDirty",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];

            this._operationsStack.setAllToDirty(e);
          }
        }, {
          key: "createOperation",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                i = this._operations[e];
            if (!i) throw new Error("No operation with identifier `" + e + "` found.");
            var r = new i(this, t);
            return n && this.addOperation(r), r;
          }
        }, {
          key: "addOperation",
          value: function value(e) {
            this._operationsStack.push(e);
          }
        }, {
          key: "removeOperation",
          value: function value(e) {
            this._operationsStack.remove(e);
          }
        }, {
          key: "getInputDimensions",
          value: function value() {
            var e = this._inputTexture.getFrame();

            return new D(e.width, e.height);
          }
        }, {
          key: "getFinalDimensions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = this.getInputDimensions(),
                n = this._operationsStack;
            return n.forEach(function (e) {
              e.getEnabled() && (t = e.getNewDimensions(t));
            }), e && t.multiply(this._spriteScale), t.floor();
          }
        }, {
          key: "getOutputDimensions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return this.getFinalDimensions(e).clone().multiply(this._zoom).floor();
          }
        }, {
          key: "getOutputTextureDimensions",
          value: function value() {
            var e = this.getTextureScale(),
                t = this.getInputDimensions().multiply(e).floor();
            return this._operationsStack.forEach(function (e) {
              t = e.getNewDimensions(t);
            }), t;
          }
        }, {
          key: "getCrossOrigin",
          value: function value() {
            return A.getCrossOrigin(this._options.crossOrigin || "Anonymous");
          }
        }, {
          key: "_initRenderer",
          value: function value() {
            var e = {
              canvas: this._options.canvas,
              pixelRatio: this._options.pixelRatio,
              debug: this._options.debug,
              transparent: this._options.transparent,
              clearColor: this._options.clearColor
            },
                t = void 0,
                n = void 0;

            if ("export" !== this._renderMode && this._options.canvas) {
              var i = this._options.canvas;
              t = i.width, n = i.height;
            } else if (this._inputTexture) {
              var r = this.getFinalDimensions();
              t = r.x, n = r.y;
            } else t = 1, n = 1;

            switch (this._preferredRenderer) {
              case U.WEBGL:
                this._renderer = I.autoDetectRenderer(t, n, e), this._renderer.on("context-restored", this._onContextRestored);
                break;

              case U.CANVAS:
                this._renderer = new I.CanvasRenderer(t, n, e), this._renderer.on("context-restored", this._onContextRestored);
                break;

              default:
                P.warn("PhotoEditorSDK", "PhotoEditorSDK Error: Renderer `" + this._preferredRenderer + "` not supported. Falling back to automatically detected renderer."), this._renderer = I.autoDetectRenderer(t, n, e);
            }
          }
        }, {
          key: "resizeTo",
          value: function value(e) {
            this._renderer.resizeTo(e, !0);
          }
        }, {
          key: "reset",
          value: function value() {
            this._operationsStack.clear();
          }
        }, {
          key: "parseExif",
          value: function value(e) {
            if (e) {
              var t,
                  n = e.src;

              if (t = n, b.a.isJPEG(n)) {
                var i = null;

                try {
                  i = b.a.fromBase64String(t);
                } catch (e) {}

                if (!i) return;
                return i;
              }
            }
          }
        }, {
          key: "_handleExifOrientation",
          value: function value() {
            var e = this._exif.getTags();

            if (e && e.Orientation) {
              var t = 1 !== e.Orientation && 2 !== e.Orientation,
                  n = -1 !== [2, 4, 5, 7].indexOf(e.Orientation);
              (t || n) && (this._exifOperation || (this._exifOperation = this.createOperation("exif-orientation")), this._exifOperation.setTags(e), this._exif.setOrientation(1));
            }
          }
        }, {
          key: "correctExifOrientation",
          value: function value(e) {
            var t = this.parseExif(e);
            if (!t) return e;
            var n = t.getTags();

            if (n && n.Orientation) {
              var i = 1 !== n.Orientation && 2 !== n.Orientation,
                  r = -1 !== [2, 4, 5, 7].indexOf(n.Orientation);

              if (i || r) {
                var o = this.createOperation("exif-orientation", {}, !1);
                o.setTags(n);
                var a = o.applyTo(e);
                return t.setOrientation(1), n.Orientation = 1, a;
              }
            }

            return e;
          }
        }, {
          key: "hasImage",
          value: function value() {
            return null !== this._image && void 0 !== this._image;
          }
        }, {
          key: "getImage",
          value: function value() {
            return this._image;
          }
        }, {
          key: "disposeTexture",
          value: function value(e) {
            this._texturesToDispose.push(e);
          }
        }, {
          key: "_disposeTextures",
          value: function value() {
            for (var e = 0; e < this._texturesToDispose.length; e++) {
              this._texturesToDispose[e].dispose();
            }

            this._texturesToDispose = [];
          }
        }, {
          key: "setImage",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            this._disposeTextures(), this._exifOperation && (this.removeOperation(this._exifOperation), this._exifOperation = null), this._options.image = e, this._image = e, this._exif = t || this.parseExif(e), this._exif && this._handleExifOrientation();
            var i = new I.BaseTexture(this._image),
                r = new O(0, 0, this._image.naturalWidth || this._image.width, this._image.naturalHeight || this._image.height);
            n && (r.width = n.x, r.height = n.y), this._resizedTexture && this._resizedTexture.dispose(), this._resizedTexture = null, this._inputTexture && this.disposeTexture(this._inputTexture.getBaseTexture()), this._inputTexture = new I.Texture(i, r), this._currentTexture = this._inputTexture, this._sprite.clearTexture(!1), this._sprite.setTexture(this._inputTexture), this.emit("new-image"), this.setAllOperationsToDirty(!0);
          }
        }, {
          key: "setInputTexture",
          value: function value(e) {
            this._inputTexture = e;
          }
        }, {
          key: "getCanvas",
          value: function value() {
            return this._renderer.getCanvas();
          }
        }, {
          key: "setCanvas",
          value: function value(e) {
            this._renderer.setCanvas(e);
          }
        }, {
          key: "getSprite",
          value: function value() {
            return this._sprite;
          }
        }, {
          key: "getContainer",
          value: function value() {
            return this._container;
          }
        }, {
          key: "getOperationsStack",
          value: function value() {
            return this._operationsStack;
          }
        }, {
          key: "setOperationsStack",
          value: function value(e) {
            this._operationsStack && this._operationsStack.off(F.OPERATION_UPDATED, this._onOperationUpdate), this._operationsStack = e, this._operationsStack.on(F.OPERATION_UPDATED, this._onOperationUpdate);
          }
        }, {
          key: "getOperations",
          value: function value() {
            return this._operations;
          }
        }, {
          key: "getRenderer",
          value: function value() {
            return this._renderer;
          }
        }, {
          key: "getOffset",
          value: function value() {
            return this._offset;
          }
        }, {
          key: "setOffset",
          value: function value(e, t) {
            e instanceof D ? this._offset.copy(e) : this._offset.set(e, t);
          }
        }, {
          key: "getRenderMode",
          value: function value() {
            return this._renderMode;
          }
        }, {
          key: "setRenderMode",
          value: function value(e) {
            this._renderMode = e;
          }
        }, {
          key: "getZoom",
          value: function value() {
            return this._zoom;
          }
        }, {
          key: "setZoom",
          value: function value(e) {
            this._zoom = e, this._container.setScale(this._zoom, this._zoom), this._container.updateTransform();
          }
        }, {
          key: "getTextureQuality",
          value: function value() {
            return "export" === this._renderMode ? 1 : this._textureQuality;
          }
        }, {
          key: "setTextureQuality",
          value: function value(e) {
            e !== this._textureQuality && this.setAllOperationsToDirty(!0), this._textureQuality = Math.min(1, e), 1 === this._textureQuality && this._resizedTexture && (this._resizedTexture.dispose(), this._resizedTexture = null);
          }
        }, {
          key: "getSpriteScale",
          value: function value() {
            return this._spriteScale;
          }
        }, {
          key: "setSpriteScale",
          value: function value(e) {
            this._spriteScale = e, this._sprite.setScale(e, e), this._sprite.updateTransform();
          }
        }, {
          key: "getPixelRatio",
          value: function value() {
            return this._options.pixelRatio;
          }
        }, {
          key: "getExif",
          value: function value() {
            return this._exif;
          }
        }, {
          key: "getOptions",
          value: function value() {
            return this._options;
          }
        }, {
          key: "getInputTexture",
          value: function value() {
            return this._inputTexture;
          }
        }, {
          key: "setSmoothDownscaling",
          value: function value(e) {
            this._options.smoothDownscaling = e, this._sprite.setSmoothDownscaling(e), this._resizedSprite.setSmoothDownscaling(e);
          }
        }, {
          key: "setRotation",
          value: function value(e) {
            this._rotation = e;
          }
        }, {
          key: "getRotation",
          value: function value() {
            return this._rotation;
          }
        }, {
          key: "hasChanges",
          value: function value() {
            return this.getOperationsStack().hasChanges();
          }
        }, {
          key: "dispose",
          value: function value() {
            this._operationsStack.dispose(), this._renderer.dispose(), this._exif && this._exif.dispose(), this._resizedTexture && this._resizedTexture.dispose();
          }
        }]), t;
      }(M);

      t.a = j;
    }, function (e, t, n) {
      e.exports = n(34);
    }, function (e, t) {
      e.exports = function (e, t) {
        return {
          value: t,
          done: !!e
        };
      };
    }, function (e, t, n) {
      var i = n(59);

      e.exports = Array.isArray || function (e) {
        return "Array" == i(e);
      };
    }, function (e, t, n) {
      var i = n(137),
          r = n(102).concat("length", "prototype");

      t.f = Object.getOwnPropertyNames || function (e) {
        return i(e, r);
      };
    }, function (e, t, n) {
      var i = n(28);

      e.exports = function (e, t, n, r) {
        try {
          return r ? t(i(n)[0], n[1]) : t(n);
        } catch (t) {
          var o = e.return;
          throw void 0 !== o && i(o.call(e)), t;
        }
      };
    }, function (e, t, n) {
      var i = n(51),
          r = n(17)("iterator"),
          o = Array.prototype;

      e.exports = function (e) {
        return void 0 !== e && (i.Array === e || o[r] === e);
      };
    }, function (e, t, n) {
      var i = n(28),
          r = n(56),
          o = n(17)("species");

      e.exports = function (e, t) {
        var n,
            a = i(e).constructor;
        return void 0 === a || null == (n = i(a)[o]) ? t : r(n);
      };
    }, function (e, t) {
      e.exports = function (e) {
        try {
          return {
            e: !1,
            v: e()
          };
        } catch (e) {
          return {
            e: !0,
            v: e
          };
        }
      };
    }, function (e, t, n) {
      var i = n(28),
          r = n(23),
          o = n(113);

      e.exports = function (e, t) {
        if (i(e), r(t) && t.constructor === e) return t;
        var n = o.f(e);
        return (0, n.resolve)(t), n.promise;
      };
    }, function (e, t, n) {
      var i = n(16),
          r = n(11),
          o = n(22),
          a = n(19),
          s = n(17)("species");

      e.exports = function (e) {
        var t = "function" == typeof r[e] ? r[e] : i[e];
        a && t && !t[s] && o.f(t, s, {
          configurable: !0,
          get: function get() {
            return this;
          }
        });
      };
    }, function (e, t, n) {
      var i = n(17)("iterator"),
          r = !1;

      try {
        var o = [7][i]();
        o.return = function () {
          r = !0;
        }, Array.from(o, function () {
          throw 2;
        });
      } catch (e) {}

      e.exports = function (e, t) {
        if (!t && !r) return !1;
        var n = !1;

        try {
          var o = [7],
              a = o[i]();
          a.next = function () {
            return {
              done: n = !0
            };
          }, o[i] = function () {
            return a;
          }, e(o);
        } catch (e) {}

        return n;
      };
    }, function (e, t) {
      var n,
          i,
          r = e.exports = {};

      function o() {
        throw new Error("setTimeout has not been defined");
      }

      function a() {
        throw new Error("clearTimeout has not been defined");
      }

      function s(e) {
        if (n === setTimeout) return setTimeout(e, 0);
        if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

        try {
          return n(e, 0);
        } catch (t) {
          try {
            return n.call(null, e, 0);
          } catch (t) {
            return n.call(this, e, 0);
          }
        }
      }

      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : o;
        } catch (e) {
          n = o;
        }

        try {
          i = "function" == typeof clearTimeout ? clearTimeout : a;
        } catch (e) {
          i = a;
        }
      }();
      var l,
          u = [],
          c = !1,
          p = -1;

      function f() {
        c && l && (c = !1, l.length ? u = l.concat(u) : p = -1, u.length && h());
      }

      function h() {
        if (!c) {
          var e = s(f);
          c = !0;

          for (var t = u.length; t;) {
            for (l = u, u = []; ++p < t;) {
              l && l[p].run();
            }

            p = -1, t = u.length;
          }

          l = null, c = !1, function (e) {
            if (i === clearTimeout) return clearTimeout(e);
            if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);

            try {
              i(e);
            } catch (t) {
              try {
                return i.call(null, e);
              } catch (t) {
                return i.call(this, e);
              }
            }
          }(e);
        }
      }

      function d(e, t) {
        this.fun = e, this.array = t;
      }

      function g() {}

      r.nextTick = function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }
        u.push(new d(e, t)), 1 !== u.length || c || s(h);
      }, d.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = g, r.addListener = g, r.once = g, r.off = g, r.removeListener = g, r.removeAllListeners = g, r.emit = g, r.prependListener = g, r.prependOnceListener = g, r.listeners = function (e) {
        return [];
      }, r.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, r.cwd = function () {
        return "/";
      }, r.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, r.umask = function () {
        return 0;
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(263),
        __esModule: !0
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(45),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.reset();
        }

        return a(e, [{
          key: "multiply",
          value: function value(e) {
            var t, n, i, r, o, a;
            return t = this.a * e.a + this.b * e.c, n = this.a * e.b + this.b * e.d, i = this.c * e.a + this.d * e.c, r = this.c * e.b + this.d * e.d, o = this.tx * e.a + this.ty * e.c + e.tx, a = this.tx * e.b + this.ty * e.d + e.ty, this.a = t, this.b = n, this.c = i, this.d = r, this.tx = o, this.ty = a, this;
          }
        }, {
          key: "applyToVector",
          value: function value(e) {
            var t = e,
                n = t.x,
                i = t.y;
            return (e = e.clone()).x = this.a * n + this.c * i + this.tx, e.y = this.b * n + this.d * i + this.tx, e;
          }
        }, {
          key: "applyInverseToVector",
          value: function value(e) {
            var t = 1 / (this.a * this.d + this.c * -this.b),
                n = e,
                i = n.x,
                r = n.y;
            return (e = e.clone()).x = this.d * t * i + -this.c * t * r + (this.ty * this.c - this.tx * this.d) * t, e.y = this.a * t * r + -this.b * t * i + (-this.ty * this.a + this.tx * this.b) * t, e;
          }
        }, {
          key: "rectangleToCoordinates",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new o.a(0, 0),
                n = e.width * (1 - t.x),
                i = e.width * -t.x,
                r = e.height * (1 - t.y),
                a = e.height * -t.y,
                s = [];
            return s.push(new o.a(this.a * i + this.c * a + this.tx, this.d * a + this.b * i + this.ty)), s.push(new o.a(this.a * n + this.c * a + this.tx, this.d * a + this.b * n + this.ty)), s.push(new o.a(this.a * n + this.c * r + this.tx, this.d * r + this.b * n + this.ty)), s.push(new o.a(this.a * i + this.c * r + this.tx, this.d * r + this.b * i + this.ty)), s;
          }
        }, {
          key: "reset",
          value: function value() {
            this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0;
          }
        }, {
          key: "toArray",
          value: function value() {
            var e = [this.a, this.b, 0, this.c, this.d, 0, this.tx, this.ty, 1];
            return "undefined" == typeof Float32Array ? e : new Float32Array(e);
          }
        }, {
          key: "toString",
          value: function value() {
            return "Matrix({ a: " + this.a + ", b: " + this.b + ", c: " + this.c + ", d: " + this.d + ", tx: " + this.tx + ", ty: " + this.ty + " })";
          }
        }], [{
          key: "IDENTITY",
          get: function get() {
            return new e();
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(45),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function s(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var l = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
          s(this, e), this.x = t, this.y = n, this.width = i, this.height = r;
        }

        return a(e, [{
          key: "set",
          value: function value(e, t, n, i) {
            return this.x = e, this.y = t, this.width = n, this.height = i, this;
          }
        }, {
          key: "clone",
          value: function value() {
            return new e(this.x, this.y, this.width, this.height);
          }
        }, {
          key: "copy",
          value: function value(e) {
            return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this;
          }
        }, {
          key: "equals",
          value: function value(t, n, i, r) {
            return t instanceof e ? t.x === this.x && t.y === this.y && t.width === this.width && t.height === this.height : t === this.x && n === this.y && i === this.width && r === this.height;
          }
        }, {
          key: "translate",
          value: function value(e, t) {
            return e instanceof o.a && (t = e.y, e = e.x), this.x += e, this.y += t, this;
          }
        }, {
          key: "scale",
          value: function value(e, t) {
            return e instanceof o.a ? (t = e.y, e = e.x) : void 0 === t && (t = e), this.width *= e, this.height *= t, this;
          }
        }, {
          key: "round",
          value: function value() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this.width = Math.round(this.width), this.height = Math.round(this.height), this;
          }
        }, {
          key: "getPosition",
          value: function value() {
            return new o.a(this.x, this.y);
          }
        }, {
          key: "getSize",
          value: function value() {
            return new o.a(this.width, this.height);
          }
        }, {
          key: "insetBy",
          value: function value(e, t) {
            return this.x += e, this.y += t, this.width -= 2 * e, this.height -= 2 * t, this;
          }
        }, {
          key: "intersects",
          value: function value(e) {
            var t = new o.a(this.x, this.y),
                n = new o.a(this.x + this.width, this.y + this.height),
                i = new o.a(e.x, e.y),
                r = new o.a(e.x + e.width, e.y + e.height);
            return !(i.x > n.x || t.x > r.x || r.y < t.y || n.y < i.y);
          }
        }, {
          key: "toString",
          value: function value() {
            return "Rectangle({ x: " + this.x + ", y: " + this.y + ", width: " + this.width + ", height: " + this.height + " })";
          }
        }], [{
          key: "FromDiagonalPoints",
          value: function value(t, n) {
            var i = !1;
            n.x - t.x < 0 && (i = !0);
            var r = i ? n : t,
                o = i ? t : n,
                a = o.x - r.x,
                s = o.y - r.y;
            return new e(r.x, r.y, a, s);
          }
        }]), e;
      }();

      t.a = l;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(24),
          a = n(274);

      function s(e, t, n) {
        return t in e ? r()(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      n.n(a), t.a = {
        checkFramebufferStatus: function checkFramebufferStatus(e, t) {
          var n,
              i = t.checkFramebufferStatus(t.FRAMEBUFFER),
              r = (s(n = {}, t.FRAMEBUFFER_INCOMPLETE_ATTACHMENT, "Incomplete attachment"), s(n, t.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT, "Missing attachment"), s(n, t.FRAMEBUFFER_INCOMPLETE_DIMENSIONS, "Incomplete dimensions"), s(n, t.FRAMEBUFFER_UNSUPPORTED, "Framebuffer unsupported"), n);
          i !== t.FRAMEBUFFER_COMPLETE && o.a.warn(e, "Framebuffer incomplete: " + r[i]);
        },
        determineGPUName: function determineGPUName(e) {
          var t = null,
              n = null;
          e || (e = (n = document.createElement("canvas")).getContext("experimental-webgl") || n.getContext("webgl"));
          var i = e && e.getExtension("WEBGL_debug_renderer_info");
          return i && (t = e.getParameter(i.UNMASKED_RENDERER_WEBGL), n && n.remove()), t;
        },
        isGPUBlacklisted: function isGPUBlacklisted(e) {
          return !1;
        }
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(12),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = "undefined" != typeof window && window.performance && window.performance.now ? window.performance.now.bind(window.performance) : n(87),
          l = function () {
        function e(t) {
          var n = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._context = t, this._tracking = !1;

          var i = this,
              r = function r(e) {
            "function" == typeof t[e] ? n[e] = function () {
              for (var n = arguments.length, r = Array(n), o = 0; o < n; o++) {
                r[o] = arguments[o];
              }

              var a = t[e];
              if (!i._tracking) return a.apply(t, r);
              var l = s(),
                  u = a.apply(t, r),
                  c = s() - l,
                  p = {
                functionName: e,
                arguments: r,
                duration: c
              };
              return i._trackedCalls.push(p), u;
            } : n._makePropertyWrapper(e);
          };

          for (var o in t) {
            r(o);
          }
        }

        return a(e, [{
          key: "_makePropertyWrapper",
          value: function value(e) {
            if (-1 === ["_context", "_trackedCalls", "_tracking"].indexOf(e)) {
              var t = this._context;
              this.__defineGetter__(e, function () {
                return t[e];
              }), this.__defineSetter__(e, function (n) {
                t[e] = n;
              });
            }
          }
        }, {
          key: "startFrame",
          value: function value() {
            this._tracking = !0, this._trackedCalls = [];
          }
        }, {
          key: "endFrame",
          value: function value() {
            var e = "Rendering";
            o.f.log(e, "Frame rendering results:"), o.f.log(e, "Context calls: " + this._trackedCalls.length);
            var t = {};

            this._trackedCalls.forEach(function (e) {
              var n = e.functionName,
                  i = e.duration;
              t[n] = t[n] || {
                totalDuration: 0,
                calls: 0
              }, t[n].totalDuration += i, t[n].calls++;
            });

            var n = [];

            for (var i in t) {
              var r = t[i];
              r.averageDuration = r.totalDuration / r.calls, n.push({
                functionName: i,
                data: r
              });
            }

            n.sort(function (e, t) {
              return t.data.totalDuration - e.data.totalDuration;
            }), (n = n.slice(0, 3)).forEach(function (t) {
              o.f.log(e, t.functionName + ": " + t.data.calls + " calls, " + t.data.totalDuration.toFixed(2) + "ms");
            });
          }
        }]), e;
      }();

      t.a = l;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(12),
          f = n(275),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = function (e) {
        function t(e, n) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          d(this, t);
          var r = g(this, (t.__proto__ || c()(t)).call(this));
          return r._options = f.a.defaults(i, {
            pixelRatio: 1,
            transparent: !1,
            clearColor: p.b.BLACK,
            debug: !1
          }), r.setMaxListeners(0), r._width = e || 800, r._height = n || 600, r._dimensions = new p.k(r._width, r._height), r._maxTextureSize = null, r._pixelRatio = r._options.pixelRatio, r._clearColor = r._options.transparent ? p.b.TRANSPARENT : r._options.clearColor || p.b.BLACK, r;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "setCanvas",
          value: function value(e) {
            var t = this._canvas;
            this._canvas = e, t !== e && (this._createContext(), this._onBeforeContext(), this._setupContext()), this.resizeTo(new p.k(this._width, this._height));
          }
        }, {
          key: "getCanvas",
          value: function value() {
            return this._canvas;
          }
        }, {
          key: "_onBeforeContext",
          value: function value() {}
        }, {
          key: "resizeTo",
          value: function value(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            this._width = e.x * this._pixelRatio, this._height = e.y * this._pixelRatio, t && (this._canvas.width = this._width, this._canvas.height = this._height, this._canvas.style && (this._canvas.style.width = this._width / this._pixelRatio + "px", this._canvas.style.height = this._height / this._pixelRatio + "px")), this._dimensions = e.clone();
          }
        }, {
          key: "_createContext",
          value: function value() {
            p.f.warn(this.constructor.name, "`_createContext` is abstract and not implemented in inherited class");
          }
        }, {
          key: "_setupContext",
          value: function value() {
            p.f.warn(this.constructor.name, "`_setupContext` is abstract and not implemented in inherited class");
          }
        }, {
          key: "render",
          value: function value(e) {
            p.f.warn(this.constructor.name, "`render` is abstract and not implemented in inherited class");
          }
        }, {
          key: "getMaxDimensions",
          value: function value() {
            return null;
          }
        }, {
          key: "getContext",
          value: function value() {
            return this._context;
          }
        }, {
          key: "getWidth",
          value: function value() {
            return this._dimensions.x;
          }
        }, {
          key: "getHeight",
          value: function value() {
            return this._dimensions.y;
          }
        }, {
          key: "getDimensions",
          value: function value() {
            return this._dimensions;
          }
        }, {
          key: "getPixelRatio",
          value: function value() {
            return this._pixelRatio;
          }
        }, {
          key: "setPixelRatio",
          value: function value(e) {
            this._pixelRatio = e, this._defaultRenderTarget && this._defaultRenderTarget.setPixelRatio(e);
          }
        }, {
          key: "getMaxTextureSize",
          value: function value() {
            return this._maxTextureSize;
          }
        }, {
          key: "getFilterManager",
          value: function value() {
            return this._filterManager;
          }
        }, {
          key: "setFilterManager",
          value: function value(e) {
            this._filterManager = e;
          }
        }, {
          key: "isOfType",
          value: function value(e) {
            return this._type === e;
          }
        }, {
          key: "dispose",
          value: function value() {
            p.f.warn(this.constructor.name, "`dispose` is abstract and not implemented in inherited class");
          }
        }], [{
          key: "isSupported",
          value: function value() {
            return !0;
          }
        }]), t;
      }(p.d);

      t.a = m;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._renderer = t, this._onContextChange = this._onContextChange.bind(this), this._renderer.on("context", this._onContextChange);
        }

        return o(e, [{
          key: "_onContextChange",
          value: function value() {}
        }, {
          key: "start",
          value: function value() {}
        }, {
          key: "stop",
          value: function value() {
            this.flush();
          }
        }, {
          key: "flush",
          value: function value() {}
        }, {
          key: "dispose",
          value: function value() {
            this._renderer.off("context", this._onContextChange), this._renderer = null;
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._renderer = t, this._context = this._renderer.getContext(), this._vertices = new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]), this._uvs = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]), this._indices = new Uint16Array([0, 1, 2, 0, 3, 2]), this._colors = new Float32Array([1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]), this._initBuffers(), this._uploadBuffers();
        }

        return o(e, [{
          key: "map",
          value: function value(e, t) {
            var n = t.x,
                i = t.y;
            this._uvs[2] = t.width / e.width, this._uvs[4] = this._uvs[2], this._uvs[5] = t.height / e.height, this._uvs[7] = this._uvs[5], this._vertices[0] = n, this._vertices[1] = i, this._vertices[2] = n + t.width, this._vertices[3] = i, this._vertices[4] = this._vertices[2], this._vertices[5] = i + t.height, this._vertices[6] = n, this._vertices[7] = this._vertices[5], this._uploadBuffers();
          }
        }, {
          key: "_initBuffers",
          value: function value() {
            var e = this._context;
            this._vertexBuffer && (e.deleteBuffer(this._vertexBuffer), this._vertexBuffer = null), this._indexBuffer && (e.deleteBuffer(this._indexBuffer), this._indexBuffer = null), this._vertexBuffer = e.createBuffer(), e.bindBuffer(e.ARRAY_BUFFER, this._vertexBuffer), e.bufferData(e.ARRAY_BUFFER, 128, e.DYNAMIC_DRAW), this._indexBuffer = e.createBuffer(), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this._indexBuffer), e.bufferData(e.ELEMENT_ARRAY_BUFFER, this._indices, e.STATIC_DRAW);
          }
        }, {
          key: "_uploadBuffers",
          value: function value() {
            var e = this._context;
            e.bindBuffer(e.ARRAY_BUFFER, this._vertexBuffer), e.bufferSubData(e.ARRAY_BUFFER, 0, this._vertices), e.bufferSubData(e.ARRAY_BUFFER, 32, this._uvs), e.bufferSubData(e.ARRAY_BUFFER, 64, this._colors);
          }
        }, {
          key: "getVertexBuffer",
          value: function value() {
            return this._vertexBuffer;
          }
        }, {
          key: "getIndexBuffer",
          value: function value() {
            return this._indexBuffer;
          }
        }, {
          key: "dispose",
          value: function value() {
            var e = this._context;
            this._vertexBuffer && (e.deleteBuffer(this._vertexBuffer), this._vertexBuffer = null), this._indexBuffer && (e.deleteBuffer(this._indexBuffer), this._indexBuffer = null);
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t, n, i) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.width = t, this.height = n, this.data = i;
        }

        return o(e, null, [{
          key: "fromNodeCanvasImage",
          value: function value(t) {
            var n = new Canvas(t.width, t.height).getContext("2d");
            n.drawImage(t, 0, 0);
            var i = n.getImageData(0, 0, t.width, t.height);
            return new e(t.width, t.height, i.data);
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(12),
          d = n(118),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = y(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._children = [], o._filters = [], o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "addFilter",
          value: function value(e) {
            this._filters.push(e);
          }
        }, {
          key: "removeFilter",
          value: function value(e) {
            var t = this._filters.indexOf(e);

            return -1 !== t && (this._filters.splice(t, 1), !0);
          }
        }, {
          key: "setFilters",
          value: function value(e) {
            this._filters = e;
          }
        }, {
          key: "addChild",
          value: function value(e) {
            var t = e.getParent();
            null !== t && t.removeChild(e), e.setParent(this), this._children.push(e);
          }
        }, {
          key: "prependChild",
          value: function value(e) {
            var t = e.getParent();
            null !== t && t.removeChild(e), e.setParent(this), this._children.unshift(e);
          }
        }, {
          key: "hasChild",
          value: function value(e) {
            return -1 !== this._children.indexOf(e);
          }
        }, {
          key: "removeChild",
          value: function value(e) {
            var t = this._children.indexOf(e);

            -1 !== t ? (this._children.splice(t, 1), e.setParent(null)) : h.f.info(this.constructor.name, "Tried to remove a child that does not exist");
          }
        }, {
          key: "clearChildren",
          value: function value() {
            this._children = [];
          }
        }, {
          key: "renderWebGL",
          value: function value(e) {
            if (this._visible) {
              var t = e.getFilterManager();
              this._filters && this._filters.length && t.pushFilters(this, this._filters), e.getCurrentObjectRenderer().start(), this._renderWebGL(e), this._children.forEach(function (t) {
                t.renderWebGL(e);
              }), e.getCurrentObjectRenderer().flush(), this._filters && this._filters.length && t.popFilters(), e.getCurrentObjectRenderer().start();
            }
          }
        }, {
          key: "_renderWebGL",
          value: function value(e) {}
        }, {
          key: "renderCanvas",
          value: function value(e) {
            if (this._visible) {
              var t = e.getFilterManager();
              this._filters && this._filters.length && t.pushFilters(this, this._filters), this._renderCanvas(e), this._children.forEach(function (t) {
                t.renderCanvas(e);
              }), this._filters && this._filters.length && t.popFilters();
            }
          }
        }, {
          key: "_renderCanvas",
          value: function value(e) {}
        }, {
          key: "updateTransform",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "updateTransform", this).call(this), this._children.forEach(function (e) {
              e.updateTransform();
            });
          }
        }, {
          key: "getLocalBounds",
          value: function value() {
            return this._localBoundsNeedUpdate && (this._localBoundsNeedUpdate = !1), this._localBounds.clone();
          }
        }, {
          key: "getBounds",
          value: function value() {
            return this._boundsNeedUpdate && (this._boundsNeedUpdate = !1), this._bounds.clone();
          }
        }, {
          key: "getChildren",
          value: function value() {
            return this._children;
          }
        }, {
          key: "getFilters",
          value: function value() {
            return this._filters;
          }
        }, {
          key: "dispose",
          value: function value() {}
        }]), t;
      }(d.a);

      t.a = _;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(12),
          f = n(68),
          h = n(284),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          g = function (e) {
        function t(e, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var i = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this));

          if (!(e instanceof f.a)) throw new Error("`baseTexture` should be an instance of BaseTexture");
          return i._uvs = new h.a(), i._frame = n ? n.clone() : null, i._frameLocked = !!n, i._onBaseTextureLoaded = i._onBaseTextureLoaded.bind(i), i._onBaseTextureUpdated = i._onBaseTextureUpdated.bind(i), i._frame || (i._frame = new p.h(0, 0, 1, 1)), i.setBaseTexture(e), i;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "_onBaseTextureLoaded",
          value: function value() {
            if (!this._frameLocked) {
              var e = this._baseTexture.getFrame().clone();

              this.setFrame(e);
            }

            this._baseTexture.on("update", this._onBaseTextureUpdated);
          }
        }, {
          key: "_onBaseTextureUpdated",
          value: function value() {
            var e = this._baseTexture.getFrame(),
                t = e.width,
                n = e.height;

            this._frame.width = t, this._frame.height = n, this.emit("update");
          }
        }, {
          key: "_updateUVs",
          value: function value() {
            this._uvs.update(this._frame, this._baseTexture.getFrame());
          }
        }, {
          key: "getBaseTexture",
          value: function value() {
            return this._baseTexture;
          }
        }, {
          key: "setBaseTexture",
          value: function value(e) {
            if (this._baseTexture = e, this._baseTexture.isLoaded()) {
              var t = e.getFrame(),
                  n = t.width,
                  i = t.height;
              this._frameLocked || (this._frame = new p.h(0, 0, n, i)), this._onBaseTextureLoaded();
            } else this._baseTexture.once("loaded", this._onBaseTextureLoaded);
          }
        }, {
          key: "getFrame",
          value: function value() {
            return this._frame;
          }
        }, {
          key: "setFrame",
          value: function value(e) {
            this._frame = e, this._updateUVs();
          }
        }, {
          key: "getWidth",
          value: function value() {
            return this._frame.width;
          }
        }, {
          key: "getHeight",
          value: function value() {
            return this._frame.height;
          }
        }, {
          key: "getUVs",
          value: function value() {
            return this._uvs;
          }
        }, {
          key: "getDimensions",
          value: function value() {
            return new p.k(this._frame.width, this._frame.height);
          }
        }, {
          key: "dispose",
          value: function value() {
            var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            e && this._baseTexture.dispose();
          }
        }], [{
          key: "fromImage",
          value: function value(e) {
            return new t(new f.a(e));
          }
        }, {
          key: "fromCanvas",
          value: function value(e) {
            return new t(new f.a(e));
          }
        }]), t;
      }(p.d);

      t.a = g;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(66),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function s(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var l = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
              o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
              a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0,
              l = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1,
              u = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0,
              c = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0,
              p = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0,
              f = arguments.length > 10 && void 0 !== arguments[10] ? arguments[10] : 0,
              h = arguments.length > 11 && void 0 !== arguments[11] ? arguments[11] : 0,
              d = arguments.length > 12 && void 0 !== arguments[12] ? arguments[12] : 1,
              g = arguments.length > 13 && void 0 !== arguments[13] ? arguments[13] : 0,
              m = arguments.length > 14 && void 0 !== arguments[14] ? arguments[14] : 0,
              y = arguments.length > 15 && void 0 !== arguments[15] ? arguments[15] : 0,
              _ = arguments.length > 16 && void 0 !== arguments[16] ? arguments[16] : 0,
              v = arguments.length > 17 && void 0 !== arguments[17] ? arguments[17] : 0,
              b = arguments.length > 18 && void 0 !== arguments[18] ? arguments[18] : 1,
              w = arguments.length > 19 && void 0 !== arguments[19] ? arguments[19] : 0;

          s(this, e), this.set(t, n, i, r, o, a, l, u, c, p, f, h, d, g, m, y, _, v, b, w);
        }

        return a(e, [{
          key: "set",
          value: function value(e, t, n, i, r, o, a, s, l, u, c, p, f, h, d, g, m, y, _, v) {
            this.a = e, this.b = t, this.c = n, this.d = i, this.e = r, this.f = o, this.g = a, this.h = s, this.i = l, this.j = u, this.k = c, this.l = p, this.m = f, this.n = h, this.o = d, this.p = g, this.q = m, this.r = y, this.s = _, this.t = v;
          }
        }, {
          key: "reset",
          value: function value() {
            this.a = 1, this.b = 0, this.c = 0, this.d = 0, this.e = 0, this.f = 0, this.g = 1, this.h = 0, this.i = 0, this.j = 0, this.k = 0, this.l = 0, this.m = 1, this.n = 0, this.o = 0, this.p = 0, this.q = 0, this.r = 0, this.s = 1, this.t = 0;
          }
        }, {
          key: "apply",
          value: function value(e) {
            var t = this.a * e.r + this.b * e.g + this.c * e.b + this.d * e.a + this.e,
                n = this.f * e.r + this.g * e.g + this.h * e.b + this.i * e.a + this.j,
                i = this.k * e.r + this.l * e.g + this.m * e.b + this.n * e.a + this.o,
                r = this.p * e.r + this.q * e.g + this.r * e.b + this.s * e.a + this.t;
            return new o.a(t, n, i, r);
          }
        }, {
          key: "multiply",
          value: function value(e) {
            var t,
                n,
                i,
                r,
                o,
                a,
                s,
                l,
                u,
                c,
                p,
                f,
                h,
                d,
                g,
                m,
                y,
                _,
                v,
                b,
                w = e,
                x = this;

            return t = w.a * x.a + w.b * x.f + w.c * x.k + w.d * x.p, n = w.a * x.b + w.b * x.g + w.c * x.l + w.d * x.q, i = w.a * x.c + w.b * x.h + w.c * x.m + w.d * x.r, r = w.a * x.d + w.b * x.i + w.c * x.n + w.d * x.s, a = w.f * x.a + w.g * x.f + w.h * x.k + w.i * x.p, s = w.f * x.b + w.g * x.g + w.h * x.l + w.i * x.q, l = w.f * x.c + w.g * x.h + w.h * x.m + w.i * x.r, u = w.f * x.d + w.g * x.i + w.h * x.n + w.i * x.s, p = w.k * x.a + w.l * x.f + w.m * x.k + w.n * x.p, f = w.k * x.b + w.l * x.g + w.m * x.l + w.n * x.q, h = w.k * x.c + w.l * x.h + w.m * x.m + w.n * x.r, d = w.k * x.d + w.l * x.i + w.m * x.n + w.n * x.s, m = w.p * x.a + w.q * x.f + w.r * x.k + w.s * x.p, y = w.p * x.b + w.q * x.g + w.r * x.l + w.s * x.q, _ = w.p * x.c + w.q * x.h + w.r * x.m + w.s * x.r, v = w.p * x.d + w.q * x.i + w.r * x.n + w.s * x.s, o = w.a * x.e + w.b * x.j + w.c * x.o + w.d * x.t + w.e, c = w.f * x.e + w.g * x.j + w.h * x.o + w.i * x.t + w.j, g = w.k * x.e + w.l * x.j + w.m * x.o + w.n * x.t + w.o, b = w.p * x.e + w.q * x.j + w.r * x.o + w.s * x.t + w.t, this.a = t, this.b = n, this.c = i, this.d = r, this.e = o, this.f = a, this.g = s, this.h = l, this.i = u, this.j = c, this.k = p, this.l = f, this.m = h, this.n = d, this.o = g, this.p = m, this.q = y, this.r = _, this.s = v, this.t = b, this;
          }
        }, {
          key: "clone",
          value: function value() {
            var t = new e();
            return t.set(this.a, this.b, this.c, this.d, this.e, this.f, this.g, this.h, this.i, this.j, this.k, this.l, this.m, this.n, this.o, this.p, this.q, this.r, this.s, this.t), t;
          }
        }, {
          key: "equals",
          value: function value(e) {
            return this.a === e.a && this.b === e.b && this.c === e.c && this.d === e.d && this.e === e.e && this.f === e.f && this.g === e.g && this.h === e.h && this.i === e.i && this.j === e.j && this.k === e.k && this.l === e.l && this.m === e.m && this.n === e.n && this.o === e.o && this.p === e.p && this.q === e.q && this.r === e.r && this.s === e.s && this.t === e.t;
          }
        }, {
          key: "getOffsets",
          value: function value() {
            return [this.e, this.j, this.o, this.t];
          }
        }, {
          key: "toString",
          value: function value() {
            return "ColorMatrix( " + this.a + ", " + this.b + ", " + this.c + ", " + this.d + ", " + this.e + ",\n      " + this.f + ", " + this.g + ", " + this.h + ", " + this.i + ", " + this.j + ",\n      " + this.k + ", " + this.l + ", " + this.m + ", " + this.n + ", " + this.o + ",\n      " + this.p + ", " + this.q + ", " + this.r + ", " + this.s + ", " + this.t + " )";
          }
        }, {
          key: "toArray",
          value: function value() {
            var e = this;
            return "abcdefghijklmnopqrst".split("").map(function (t) {
              return e[t];
            });
          }
        }], [{
          key: "createBrightnessMatrix",
          value: function value(t) {
            var n = new e();
            return n.e = t, n.j = t, n.o = t, n;
          }
        }, {
          key: "createContrastMatrix",
          value: function value(t) {
            var n = new e(),
                i = (1 - t) / 2;
            return n.a = n.g = n.m = t, n.e = n.j = n.o = i, n;
          }
        }, {
          key: "createSaturationMatrix",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                n = new e(),
                i = 1 - t,
                r = .213 * i,
                o = .715 * i,
                a = .072 * i;
            return n.a = r + t, n.b = o, n.c = a, n.f = r, n.g = o + t, n.h = a, n.k = r, n.l = o, n.m = a + t, n;
          }
        }, {
          key: "createExposureMatrix",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                n = Math.pow(2, t);
            return new e(n, 0, 0, 0, 0, 0, n, 0, 0, 0, 0, 0, n, 0, 0, 0, 0, 0, 1, 0);
          }
        }, {
          key: "createLinearMatrix",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                i = new e();
            return i.a = i.g = i.m = t, i.e = i.j = i.o = n, i;
          }
        }, {
          key: "IDENTITY",
          get: function get() {
            return new e();
          }
        }]), e;
      }();

      t.a = l;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(45),
          r = n(314),
          o = n(315),
          a = n(155),
          s = n(154),
          l = n(164),
          u = n(316);
      n.d(t, "Vector2", function () {
        return i.a;
      }), n.d(t, "Vector3", function () {
        return r.a;
      }), n.d(t, "Range", function () {
        return o.a;
      }), n.d(t, "Rectangle", function () {
        return a.a;
      }), n.d(t, "Matrix", function () {
        return s.a;
      }), n.d(t, "ColorMatrix", function () {
        return l.a;
      }), n.d(t, "CubicBezierCurve", function () {
        return u.a;
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(317);
      n.d(t, "ExifOrientationOperation", function () {
        return i.a;
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(40),
          f = n(46),
          h = n(24),
          d = n(86),
          g = n(70),
          m = n(168),
          y = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = function (e) {
        function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

          _(this, t);

          var i = v(this, (t.__proto__ || c()(t)).call(this, n, {
            enabled: {
              type: p.OptionType.BOOLEAN,
              default: !0,
              serializable: !1
            }
          }));
          return i._sdk = e, i._cacheEnabled = !1, i._dirtiness = {}, i._sprite = new d.a.Sprite(), i._container = new d.a.Container(), i._container.addChild(i._sprite), i;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), y(t, [{
          key: "_onOptionsChange",
          value: function value() {
            this.setDirty(!0);
          }
        }, {
          key: "render",
          value: function value(e) {
            var t = this;
            if (!this.getEnabled()) return h.a.info(this.constructor.name, "Disabled - skipping"), f.a.resolve(e);

            if (!this._renderTexture) {
              var n = e.getDimensions().floor();
              this._renderTexture = new d.a.RenderTexture(this._sdk.getRenderer(), n.x, n.y);
            }

            var i = this._sdk.getRenderer(),
                r = void 0,
                o = void 0;

            if (h.a.canLog("info") && (o = new m.a(this.constructor.name, "Rendering")), this.isDirtyForRenderer(i)) {
              this._sprite.setTexture(e);

              var a = this.getNewDimensions(e.getDimensions()).floor();
              this._renderTexture.resizeTo(a), this._renderTexture.clear(), r = this._render(e).then(function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                return t.setDirtyForRenderer(e, i), t._renderTexture;
              });
            } else h.a.info(this.constructor.name, "Rendering from cache"), r = f.a.resolve(this._renderTexture);

            return r.then(function (e) {
              return o && o.stop(), e;
            });
          }
        }, {
          key: "_render",
          value: function value(e) {
            return (this._sdk.getRenderer().isOfType(p.RendererType.WEBGL) ? this._renderWebGL.bind(this) : this._renderCanvas.bind(this))(e);
          }
        }, {
          key: "_renderWebGL",
          value: function value(e) {
            throw new Error("Operation#_renderWebGL is abstract and not implemented in inherited class.");
          }
        }, {
          key: "_renderCanvas",
          value: function value(e) {
            throw new Error("Operation#_renderCanvas is abstract and not implemented in inherited class.");
          }
        }, {
          key: "getNewDimensions",
          value: function value(e) {
            return e.clone();
          }
        }, {
          key: "onBeforeExport",
          value: function value() {
            this.transform && this._tempTransformChange && this.transform(this._tempTransformChange), this._onBeforeExport();
          }
        }, {
          key: "onAfterExport",
          value: function value() {
            this.transform && this._tempInverseTransformChange && this.transform(this._tempInverseTransformChange), this._onAfterExport();
          }
        }, {
          key: "_onBeforeExport",
          value: function value() {}
        }, {
          key: "_onAfterExport",
          value: function value() {}
        }, {
          key: "setTemporaryTransformChange",
          value: function value(e, t) {
            this._tempTransformChange = e, this._tempInverseTransformChange = t;
          }
        }, {
          key: "reset",
          value: function value() {
            this._dirty = !0, this._glslPrograms = {};
          }
        }, {
          key: "isDirtyForRenderer",
          value: function value(e) {
            var t = this._dirtiness[e.id];
            return void 0 === t || t;
          }
        }, {
          key: "setDirtyForRenderer",
          value: function value(e, t) {
            this._dirtiness[t.id] = e;
          }
        }, {
          key: "setDirty",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

            for (var n in this._dirtiness) {
              this.setDirtyForRenderer(e, {
                id: n
              }, t);
            }
          }
        }, {
          key: "getSDK",
          value: function value() {
            return this._sdk;
          }
        }, {
          key: "getInputDimensions",
          value: function value() {
            var e = this,
                t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                n = this._sdk.getInputDimensions();

            t && n.multiply(this._sdk.getZoom()).floor();
            var i = void 0;
            return this._sdk.getOperationsStack().forEach(function (t) {
              i || (t !== e ? n = t.getNewDimensions(n) : i = !0);
            }), n.floor();
          }
        }, {
          key: "clone",
          value: function value() {
            return new (0, this.constructor)(this._sdk, this.serializeOptions());
          }
        }, {
          key: "disposeRenderTextures",
          value: function value() {
            this._renderTexture && this._renderTexture.dispose(), this._renderTexture = null;
          }
        }, {
          key: "dispose",
          value: function value() {
            this.disposeRenderTextures(), this._sprite.dispose();
          }
        }]), t;
      }(g.a);

      b.identifier = null, t.a = b;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(38),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = "undefined" != typeof window && window.performance && window.performance.now ? window.performance.now.bind(window.performance) : n(87),
          l = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._tag = t, this._name = n, this._start = s();
        }

        return a(e, [{
          key: "stop",
          value: function value() {
            var e = s() - this._start,
                t = Math.round(1e3 / e);

            o.Log.info(this._tag, this._name + " took " + e.toFixed(2) + "ms (" + t + " FPS)");
          }
        }]), e;
      }();

      t.a = l;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(38),
          f = n(46),
          h = n(67),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function g(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function m(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var y = function (e) {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          g(this, t);
          var n = m(this, (t.__proto__ || c()(t)).call(this));
          return n._onOperationUpdate = n._onOperationUpdate.bind(n), n._cacheEnabled = !0, n._stack = e, n._stack.forEach(function (e) {
            e.on("update", n._onOperationUpdate);
          }), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "clear",
          value: function value() {
            var e = this;
            this.forEach(function (t) {
              return e.remove(t);
            }), this._stack = [];
          }
        }, {
          key: "hasChanges",
          value: function value() {
            return this._stack.filter(function (e) {
              return !!e;
            }).some(function (e) {
              return e.hasChanges();
            });
          }
        }, {
          key: "_onOperationUpdate",
          value: function value(e, t) {
            this.emit(p.Events.OPERATION_UPDATED, e, t);
          }
        }, {
          key: "enableCache",
          value: function value() {
            this._cacheEnabled = !0;
          }
        }, {
          key: "disableCache",
          value: function value() {
            this._cacheEnabled = !1;
          }
        }, {
          key: "forEach",
          value: function value(e) {
            return this._stack.filter(function (e) {
              return !!e;
            }).forEach(e);
          }
        }, {
          key: "render",
          value: function value(e, t) {
            var n = this,
                i = t,
                r = this._stack.filter(function (e) {
              return !!e;
            }).filter(function (e) {
              return e.getEnabled();
            });

            r.reverse();
            var o = r.filter(function (t) {
              return !t.isDirtyForRenderer(e.getRenderer());
            })[0],
                a = r.indexOf(o);
            r.reverse();
            var s = 0;
            -1 !== a && (s = r.length - a - 1);

            for (var l = 0; l < s; l++) {
              p.Log.info(this.constructor.name, "Skipping " + r[l].constructor.name);
            }

            for (var u = f.a.resolve(i), c = function c(e) {
              var t = r[e],
                  i = void 0,
                  o = void 0;
              u = u.then(function (e) {
                return t.render(e).then(function (e) {
                  return i && e !== i && !n._cacheEnabled && o.disposeRenderTextures(), i = e, o = t, e;
                });
              });
            }, h = s; h < r.length; h++) {
              c(h);
            }

            return u.then(function (t) {
              return {
                outputTexture: t,
                renderDone: !r.some(function (t) {
                  return t.isDirtyForRenderer(e.getRenderer());
                })
              };
            });
          }
        }, {
          key: "validateSettings",
          value: function value() {
            return f.a.all(this._stack.filter(function (e) {
              return !!e;
            }).map(function (e) {
              return e.validateSettings();
            }));
          }
        }, {
          key: "setAllToDirty",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            this.forEach(function (t) {
              return t.setDirty(!0, e);
            });
          }
        }, {
          key: "updateDirtinessForRenderer",
          value: function value(e) {
            for (var t = !1, n = 0; n < this._stack.length; n++) {
              var i = this._stack[n];
              i && (i.isDirtyForRenderer(e) && (t = !0), t && i.setDirtyForRenderer(!0, e));
            }
          }
        }, {
          key: "push",
          value: function value(e) {
            this._stack.push(e), e.on("update", this._onOperationUpdate);
          }
        }, {
          key: "pop",
          value: function value() {
            var e = this._stack.pop();

            e && (e.off("update", this._onOperationUpdate), e.dispose());
          }
        }, {
          key: "unshift",
          value: function value(e) {
            this._stack.unshift(e), e.on("update", this._onOperationUpdate);
          }
        }, {
          key: "clone",
          value: function value() {
            return new t(this._stack.slice(0));
          }
        }, {
          key: "get",
          value: function value(e) {
            return this._stack[e];
          }
        }, {
          key: "getByIdentifier",
          value: function value(e) {
            return p.Utils.Array.find(this._stack, function (t) {
              return t && t.constructor.identifier === e;
            });
          }
        }, {
          key: "getIndexByIdentifier",
          value: function value(e) {
            return p.Utils.Array.findIndex(this._stack, function (t) {
              return t && t.constructor.identifier === e;
            });
          }
        }, {
          key: "moveToTop",
          value: function value(e) {
            var t = p.Utils.Array.findIndex(this._stack, function (t) {
              return t && t.constructor.identifier === e;
            });

            if (!(t < 0 || t === this._stack.length - 1)) {
              var n = this.getByIdentifier(e);
              this._stack.splice(t, 1), this._stack[this._stack.length] = n;
            }
          }
        }, {
          key: "set",
          value: function value(e, t) {
            this._stack[e] && (this._stack[e].off("update", this._onOperationUpdate), this._stack[e].dispose()), this._stack[e] = t, t.on("update", this._onOperationUpdate);
          }
        }, {
          key: "remove",
          value: function value(e) {
            var t = this._stack.indexOf(e);

            -1 !== t && (this._stack[t] && (this._stack[t].off("update", this._onOperationUpdate), this._stack[t].dispose()), this._stack.splice(t, 1));
          }
        }, {
          key: "removeAt",
          value: function value(e) {
            this._stack[e] && (this._stack[e].off("update", this._onOperationUpdate), this._stack[e].dispose()), delete this._stack[e];
          }
        }, {
          key: "getStack",
          value: function value() {
            return this._stack;
          }
        }, {
          key: "dispose",
          value: function value() {
            this.forEach(function (e) {
              e.dispose();
            });
          }
        }]), t;
      }(h.a);

      t.a = y;
    }, function (e, t) {
      e.exports = {
        name: "photoeditorsdk",
        version: "4.22.3",
        description: "The most comprehensive photo editor SDK for HTML5",
        repository: "http://github.com/imgly/pesdk-html5",
        author: "PhotoEditorSDK (img.ly GmbH) <contact@img.ly>",
        license: "SEE LICENSE IN LICENSE.md",
        bin: {},
        scripts: {
          "build:engine-wrapper": "webpack"
        },
        devDependencies: {
          adonis: "git://github.com/imgly/adonis.git#v1.0.1",
          ajv: "^5.5.1",
          "babel-core": "^6.26.3",
          "babel-loader": "^7.1.2",
          "babel-minify-webpack-plugin": "^0.2.0",
          "babel-plugin-external-helpers": "^6.22.0",
          "babel-plugin-transform-adonis-hash": "^0.4.0",
          "babel-plugin-transform-class-properties": "^6.19.0",
          "babel-plugin-transform-es2015-classes": "^6.6.4",
          "babel-plugin-transform-object-rest-spread": "^6.26.0",
          "babel-plugin-transform-proto-to-assign": "^6.26.0",
          "babel-plugin-transform-runtime": "^6.6.0",
          "babel-preset-env": "^1.7.0",
          "babel-preset-es2015": "^6.6.0",
          "babel-preset-minify": "^0.2.0",
          "babel-preset-react": "^6.5.0",
          "babel-preset-stage-0": "^6.24.1",
          "babel-preset-stage-3": "^6.24.1",
          "babel-register": "^6.26.0",
          "babel-runtime": "^6.26.0",
          chalk: "^2.4.1",
          chromedriver: "^2.37.0",
          "circular-json-es6": "^2.0.2",
          classnames: "^2.1.3",
          "clean-webpack-plugin": "^0.1.16",
          "compass-mixins": "^0.12.8",
          "copy-webpack-plugin": "^4.5.2",
          "css-loader": "^0.28.7",
          del: "^2.0.0",
          djv: "^1.2.0",
          express: "^4.16.2",
          "extract-text-webpack-plugin": "^3.0.2",
          "html-webpack-plugin": "^3.2.0",
          husky: "^1.2.0",
          inquirer: "^0.11.4",
          "inquirer-path": "^1.0.0-beta5",
          "isomorphic-fetch": "^2.2.1",
          "jaguarjs-jsdoc": "git://github.com/imgly/jaguarjs-jsdoc.git#master",
          jsdoc: "^3.6.3",
          "json-loader": "^0.5.7",
          "lodash.defaults": "^4.2.0",
          "lodash.defaultsdeep": "^4.6.1",
          minimist: "^1.2.0",
          mkdirp: "^0.5.1",
          ncp: "^2.0.0",
          "node-sass": "^4.12.0",
          "node-static": "^0.7.10",
          "optimize-css-assets-webpack-plugin": "^3.2.0",
          "performance-now": "^0.2.0",
          pixelmatch: "^4.0.2",
          pngjs: "^3.3.2",
          "preprocess-loader": "^0.3.0",
          "pretty-error": "^2.0.0",
          prompt: "^1.0.0",
          "raw-loader": "^0.5.1",
          rembrandt: "^0.1.3",
          rimraf: "^2.6.2",
          should: "^4.3.0",
          sinon: "^1.17.3",
          "sinon-chai": "^2.14.0",
          standard: "^9.0.2",
          "standard-loader": "^6.0.1",
          "stats.js": "^0.16.0",
          "style-loader": "^0.13.1",
          "styled-components": "^4.2.0",
          "term-img2": "^2.0.1",
          "transform-loader": "^0.2.2",
          "uglifyjs-webpack-plugin": "^1.2.5",
          "vinyl-source-stream": "0.1.1",
          webpack: "^3.12.0",
          "webpack-notifier": "^1.2.1"
        },
        standard: {
          globals: ["describe", "context", "before", "beforeEach", "after", "afterEach", "it", "expect"],
          parser: "babel-eslint"
        },
        dependencies: {
          "can-use-dom": "^0.1.0",
          canvas: "^2.6.0",
          gl: "^4.1.1",
          "lodash.debounce": "^4.0.8",
          "lodash.memoize": "^4.1.2",
          "lodash.throttle": "^4.1.1",
          opn: "^5.3.0",
          request: "^2.88.0",
          "resize-observer-polyfill": "^1.5.1"
        },
        devEngines: {
          node: "8.x || 9.x || 10.x || 11.x || 12.x"
        }
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(73);
      n.d(t, "ImageLoader", function () {
        return i.a;
      });
      var r = n(72);
      n.d(t, "JSONLoader", function () {
        return r.a;
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          h = p.Math.ColorMatrix;

      function d(e, t, n, i, r) {
        return (e - t) * (r - i) / (n - t) + i;
      }

      var g = function g(e) {
        return (Math.max(e.r, e.g, e.b) + Math.min(e.r, e.g, e.b)) / 2;
      },
          m = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var e = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this));

          return e._fragmentSource = n(325), e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = this._options, l = s.colorMatrix, u = s.gamma, c = s.shadows, f = s.highlights, h = s.whites, m = s.blacks, y = 1 !== u, _ = 0 !== c || 0 !== f, v = new p.Color(0, 0, 0, 0), b = 0; b < i.width * i.height; b++) {
              var w = 4 * b;

              if (v.r = a.data[w] / 255, v.g = a.data[w + 1] / 255, v.b = a.data[w + 2] / 255, y && (v.r = Math.pow(v.r, 1 / Math.max(u, 1e-7)), v.g = Math.pow(v.g, 1 / Math.max(u, 1e-7)), v.b = Math.pow(v.b, 1 / Math.max(u, 1e-7))), _) {
                var x = g(v),
                    k = c >= 0 ? p.Utils.clamp(Math.pow(x, 1 / (c + 1)) + -.76 * Math.pow(x, 2 / (c + 1)) - x, 0, Math.max(c, 1)) : -p.Utils.clamp(Math.pow(x, 1 / (1 - c)) + -.76 * Math.pow(x, 2 / (1 - c)) - x, 0, Math.max(-c, 1)),
                    T = k * x * x,
                    S = k - T,
                    C = x + T + (f < 0 ? p.Utils.clamp(1 - Math.pow(1 - x, 1 / (1 - f)) - -.8 * Math.pow(1 - x, 2 / (1 - f)) - x, -1, 0) : -p.Utils.clamp(1 - Math.pow(1 - x, 1 / (1 + f)) - -.8 * Math.pow(1 - x, 2 / (1 + f)) - x, -1, 0));
                v.r = p.Utils.clamp(C * ((v.r + S) / Math.max(x, 1e-7)), 0, 1), v.g = p.Utils.clamp(C * ((v.g + S) / Math.max(x, 1e-7)), 0, 1), v.b = p.Utils.clamp(C * ((v.b + S) / Math.max(x, 1e-7)), 0, 1);
              }

              (v = l.apply(v).clamp(0, 1)).r = d(v.r, 0, 1, m / 2, 1 + h / 2), v.g = d(v.g, 0, 1, m / 2, 1 + h / 2), v.b = d(v.b, 0, 1, m / 2, 1 + h / 2), a.data[w] = 255 * v.r, a.data[w + 1] = 255 * v.g, a.data[w + 2] = 255 * v.b;
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      m.prototype.availableOptions = {
        gamma: {
          type: p.OptionType.NUMBER,
          default: 1,
          uniformType: p.UniformType.FLOAT
        },
        shadows: {
          type: p.OptionType.NUMBER,
          default: 0,
          uniformType: p.UniformType.FLOAT
        },
        highlights: {
          type: p.OptionType.NUMBER,
          default: 1,
          uniformType: p.UniformType.FLOAT
        },
        whites: {
          type: p.OptionType.NUMBER,
          default: 0,
          uniformType: p.UniformType.FLOAT
        },
        blacks: {
          type: p.OptionType.NUMBER,
          default: 0,
          uniformType: p.UniformType.FLOAT
        },
        colorMatrix: {
          type: p.OptionType.COLOR_MATRIX,
          default: new h(),
          uniformType: p.UniformType.MAT4
        },
        colorOffset: {
          type: p.OptionType.ARRAY,
          default: [],
          uniformType: p.UniformType.FLOAT4
        }
      }, t.a = m;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(7)),
          g = n(8),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = _(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));

          return o._stack.push(new g.Brightness({
            brightness: 0
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "render",
          value: function value(e, n, i) {
            return this._stack.isEmpty() && this._stack.push(new g.Brightness({
              brightness: 0
            })), function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "render", this).call(this, e, n, i);
          }
        }]), t;
      }(d.a);

      v.isIdentity = !0, v.identifier = "identity", t.a = v;
    }, function (e, t, n) {
      var i = n(5),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(18)),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function _(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = c()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (l.a ? l()(e, t) : e.__proto__ = t);
      }

      var v = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = y(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(r)));
          return a._fragmentSource = n(355), a;
        }

        return _(t, e), g(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = this._options.lookupTableData, l = 0; l < i.width * i.height; l++) {
              var u = 4 * l,
                  c = a.data[u];
              a.data[u] = s[4 * c];
              var p = a.data[u + 1];
              a.data[u + 1] = s[1 + 4 * p];
              var f = a.data[u + 2];
              a.data[u + 2] = s[2 + 4 * f];
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(h.Engine.Filter);

      v.prototype.availableOptions = {
        lookupTable: {
          type: h.OptionType.NUMBER,
          default: 1,
          uniformType: h.UniformType.INT
        },
        lookupTableData: {
          type: h.OptionType.ARRAY,
          default: []
        }
      };

      var b = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = y(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new v({
            lookupTable: o._options.textureGLUnit
          }), o._textures = {}, o._renderers = {}, o;
        }

        return _(t, e), g(t, [{
          key: "update",
          value: function value(e) {
            var t = e.getRenderer();
            t.isOfType(h.RendererType.WEBGL) ? this._updateWebGLTexture(e) : t.isOfType(h.RendererType.CANVAS) && this._filter.setLookupTableData(this._options.data);
          }
        }, {
          key: "_updateWebGLTexture",
          value: function value(e) {
            if (void 0 === this._options.data) throw new Error("LookupTable: No data specified.");
            var t = new Uint8Array(this._options.data),
                n = e.getRenderer(),
                i = n.id;
            this._renderers[i] = n, this._textures[i] || (this._textures[i] = new h.Engine.BaseTexture());
            var r = this._textures[i],
                o = new h.Engine.PixelArrayImage(256, 1, t);
            r.setSource(o), r.setGLUnit(this._options.textureGLUnit), n.isOfType(h.RendererType.WEBGL) && n.updateTexture(r);
          }
        }, {
          key: "dispose",
          value: function value() {
            for (var e in function e(t, n, i) {
              null === t && (t = Function.prototype);
              var o = r()(t, n);

              if (void 0 === o) {
                var a = f()(t);
                return null === a ? void 0 : e(a, n, i);
              }

              if ("value" in o) return o.value;
              var s = o.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._textures) {
              this._textures[e].dispose(), delete this._textures[e];
            }

            delete this._options.data;
          }
        }]), t;
      }(d.a);

      t.a = b;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(417)),
          g = n(75),
          m = n(176),
          y = n(419),
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          v = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = h.Math.Vector2,
          k = function (e) {
        function t() {
          var e;
          b(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = w(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._persistedPaths = [], o._outputCanvasDirty = !0, o._outputCanvas = h.Utils.createCanvas(), o._outputContext = o._outputCanvas.getContext("2d"), o._persistCanvas = h.Utils.createCanvas(), o._persistContext = o._persistCanvas.getContext("2d"), o._nextCanvas = h.Utils.createCanvas(), o._texture = h.Engine.Texture.fromCanvas(o._outputCanvas), o._sprite.setTexture(o._texture), o._onPathUpdate = o._onPathUpdate.bind(o), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "applyFlip",
          value: function value(e) {
            this._options.paths.forEach(function (t) {
              t.forEachControlPoint(function (t) {
                var n = t.getPosition().clone();

                switch (e) {
                  case "horizontal":
                    n.x = 1 - n.x;
                    break;

                  case "vertical":
                    n.y = 1 - n.y;
                }

                t.setPosition(n);
              }), t.setDirty(!0);
            }), this._reset();
          }
        }, {
          key: "applyRotation",
          value: function value(e) {
            this._options.paths.forEach(function (t) {
              t.forEachControlPoint(function (t) {
                var n = t.getPosition().clone();
                90 === e ? (n.flip(), n.x = 1 - n.x) : -90 === e && (n.flip(), n.y = 1 - n.y), t.setPosition(n);
              }), t.setDirty(!0);
            }), this._reset();
          }
        }, {
          key: "applyTransform",
          value: function value(e) {
            var t = null;
            this._options.paths.forEach(function (n) {
              n.forEachControlPoint(function (t) {
                t.setPosition(e.applyToRelativePoint(t.getPosition()));
              });
              var i = n.getBrush();
              i !== t && (i.setSize(e.applyToRelativeSize(i.getSize())), t = i), n.setDirty(!0);
            }), this._reset();
          }
        }, {
          key: "clearCanvas",
          value: function value() {
            if (this._outputCanvas) {
              this._outputCanvasDirty = !0;
              var e = this._outputCanvas,
                  t = e.width,
                  n = e.height;

              this._outputContext.clearRect(0, 0, t, n);
            }
          }
        }, {
          key: "clearPersistCanvas",
          value: function value() {
            if (this._persistCanvas) {
              var e = this._persistCanvas,
                  t = e.width,
                  n = e.height;

              this._persistContext.clearRect(0, 0, t, n);
            }
          }
        }, {
          key: "serializeOptions",
          value: function value(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                i = v(t.prototype.__proto__ || f()(t.prototype), "serializeOptions", this).call(this, e, n);
            return e || (i.type = "brush"), i;
          }
        }, {
          key: "serializeOption",
          value: function value(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return "paths" === e ? this._options.paths.map(function (e) {
              return e.serializeOptions(void 0, n);
            }) : v(t.prototype.__proto__ || f()(t.prototype), "serializeOption", this).call(this, e, n);
          }
        }, {
          key: "createPath",
          value: function value(e) {
            var t = new d.a(this._operation, {
              brush: e
            }, this._nextCanvas);
            return t.on("update", this._onPathUpdate), this._options.paths.push(t), this.setDirty(!0), t;
          }
        }, {
          key: "_onPathUpdate",
          value: function value() {
            this._operation.setDirty(!0), this.setDirty(!0);
          }
        }, {
          key: "_onPathPersist",
          value: function value(e) {
            e.renderToCanvas(this._persistCanvas), this._nextCanvas = e.getCanvas(), this._nextCanvas.getContext("2d").clearRect(0, 0, this._nextCanvas.width, this._nextCanvas.height), this._persistedPaths.push(e);
          }
        }, {
          key: "_getTexture",
          value: function value() {
            return this._texture;
          }
        }, {
          key: "setDirtyForRenderer",
          value: function value(e, n) {
            var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            v(t.prototype.__proto__ || f()(t.prototype), "setDirtyForRenderer", this).call(this, e, n, i), e && i && (this._persistedPaths = [], this.clearPersistCanvas(), this._options.paths.forEach(function (e) {
              e.setDirty(!0);
            }));
          }
        }, {
          key: "setDirty",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

            for (var n in this._dirtiness) {
              this.setDirtyForRenderer(e, this._renderers[n], t);
            }
          }
        }, {
          key: "render",
          value: function value(e) {
            var t = this,
                n = this._operation.getSDK().getRenderer();

            this.isDirtyForRenderer(n) && (h.Utils.ensureCanvasDimensions(this._outputCanvas, e), h.Utils.ensureCanvasDimensions(this._persistCanvas, e), this._options.paths.forEach(function (n) {
              n.render(e), n.getClosed() && -1 === t._persistedPaths.indexOf(n) && t._onPathPersist(n);
            }), this.clearCanvas(), this._outputContext.drawImage(this._persistCanvas, 0, 0), this._options.paths.forEach(function (e) {
              e.getClosed() || e.renderToCanvas(t._outputCanvas);
            }), this.setDirtyForRenderer(!1, n));
          }
        }, {
          key: "update",
          value: function value(e, n) {
            n && (h.Utils.ensureCanvasDimensions(this._outputCanvas, n), h.Utils.ensureCanvasDimensions(this._persistCanvas, n), this._texture.getBaseTexture().update()), this.render(n);
            var i = e.getRenderer();
            i.isOfType(h.RendererType.WEBGL) && i.updateTexture(this._texture.getBaseTexture()), v(t.prototype.__proto__ || f()(t.prototype), "update", this).call(this, e, n);
          }
        }, {
          key: "_reset",
          value: function value() {
            this._persistedPaths = [], this._operation && this._operation.setDirty(!0), this.setDirty(!0), this.clearCanvas(), this.clearPersistCanvas();
          }
        }, {
          key: "getCanvas",
          value: function value() {
            return this._outputCanvas;
          }
        }, {
          key: "_createRadialBrush",
          value: function value() {
            return new y.a();
          }
        }, {
          key: "_getTempCanvas",
          value: function value() {
            return this._nextCanvas;
          }
        }, {
          key: "dispose",
          value: function value() {
            v(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._texture && this._texture.getBaseTexture().dispose();
          }
        }]), t;
      }(g.a);

      k.prototype.availableOptions = {
        id: {
          type: h.OptionType.STRING,
          default: function _default() {
            return h.Utils.getUUID();
          }
        },
        position: {
          type: h.OptionType.VECTOR2,
          default: new x(0, 0)
        },
        scale: {
          type: h.OptionType.VECTOR2,
          default: new x(1, 1)
        },
        anchor: {
          type: h.OptionType.VECTOR2,
          default: new x(0, 0)
        },
        pivot: {
          type: h.OptionType.VECTOR2,
          default: new x(0, 0)
        },
        rotation: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        paths: {
          type: h.OptionType.ARRAY,
          default: [],
          setter: function setter(e) {
            var t = this;
            return e = e.map(function (e) {
              if (e instanceof d.a) return e;
              var n = e.brush,
                  i = e.closed,
                  r = new d.a(t._operation, {
                brush: n,
                closed: i
              }, t._nextCanvas);
              return e.controlPoints.forEach(function (e) {
                r.addControlPoint(e);
              }), r;
            }), this._reset(), e;
          }
        }
      }, k.type = "brush", k.Brush = m.a, k.Path = d.a, k.Brushes = {
        RadialBrush: y.a
      }, t.a = k;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = p.Math.Vector2,
          m = function (e) {
        function t() {
          var e;
          h(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = d(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._lastOptions = {}, o._lastInputDimensions = new g(0, 0), o._brush = null, o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "getBrushImage",
          value: function value(e) {
            if (this._brush && this.optionsEqual(this._lastOptions) && e.equals(this._lastInputDimensions)) return this._brush;
            var t = this._options,
                n = t.image,
                i = t.size;
            n.width = n.height = Math.ceil(i * e.min());
            var r = p.Utils.createCanvas();
            r.width = n.width, r.height = n.height;
            var o = r.getContext("2d");
            o.drawImage(n, 0, 0, r.width, r.height);

            var a = this._tintImageData(o.getImageData(0, 0, r.width, r.height), r.width, r.height);

            return o.putImageData(a, 0, 0), this._lastOptions = this.serializeOptions(["size", "color"]), this._brush = r, this._lastInputDimensions = e.clone(), r;
          }
        }, {
          key: "_tintImageData",
          value: function value(e) {
            for (var t = this._options.color, n = 0; n < e.data.length; n += 4) {
              e.data[n] += (255 * t.r - e.data[n]) * t.a, e.data[n + 1] += (255 * t.g - e.data[n + 1]) * t.a, e.data[n + 2] += (255 * t.b - e.data[n + 2]) * t.a;
            }

            return e;
          }
        }, {
          key: "clone",
          value: function value() {
            return new (0, this.constructor)(this._options);
          }
        }]), t;
      }(p.Configurable);

      t.a = m, m.prototype.availableOptions = {
        identifier: {
          type: p.OptionType.STRING
        },
        image: {
          type: p.OptionType.IMAGE
        },
        size: {
          type: p.OptionType.NUMBER,
          default: .05
        },
        color: {
          type: p.OptionType.COLOR,
          default: p.Color.RED
        }
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(4),
          a = (n.n(o), n(178)),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = o.Math.Vector2,
          u = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._text = t, this._operation = n, this._textOptions = {}, this.rotation = 0, this._createCanvas(), this._createTexture();
        }

        return s(e, [{
          key: "_createCanvas",
          value: function value() {
            this._canvas = o.Utils.createCanvas(), this._context = this._canvas.getContext("2d"), this._textSplitter = new a.a(this._context), this._finalCanvas = o.Utils.createCanvas(), this._finalContext = this._finalCanvas.getContext("2d");
          }
        }, {
          key: "_createTexture",
          value: function value() {
            this._texture = o.Engine.Texture.fromCanvas(this._canvas), this._finalTexture = o.Engine.Texture.fromCanvas(this._finalCanvas);
          }
        }, {
          key: "_applyTextOptions",
          value: function value(e, t) {
            t.font = this._text.getFontStyle() + " " + this._text.getFontWeight() + " " + e.fontSize + 'px "' + this._text.getFontFamily() + '"', t.textBaseline = "top", t.textAlign = this._text.getAlignment(), t.fillStyle = this._text.getColor().toRGBA(), t.strokeStyle = this._text.getOutlineColor().toRGBA();

            var n = this._text.getOutlineWidth();

            n > 0 && (t.lineWidth = n);
          }
        }, {
          key: "_buildOutputLines",
          value: function value(e) {
            return this._textSplitter.setText(this._text.getText()), this._textSplitter.setMaxWidth(e), this._textSplitter.getLines().map(function (e) {
              return e.replace(/\s+$/i, "");
            });
          }
        }, {
          key: "_renderTextLine",
          value: function value(e, t) {
            var n = this._text.getAlignment(),
                i = new l(0, t);

            switch (n) {
              case "center":
                i.x = this._canvas.width / 2;
                break;

              case "right":
                i.x = this._canvas.width;
            }

            this._context.fillText(e, i.x, i.y), this._text.getOutlineWidth() > 0 && (this._context.miterLimit = 2, this._context.strokeText(e, i.x, i.y));
          }
        }, {
          key: "update",
          value: function value(e, t) {
            var n = this.calculateFontStyles(e, t);

            if (n) {
              var i = this._calculateText(e, n, t),
                  r = i.dimensions,
                  o = i.lines;

              this._renderText(e, r, o, n, t), this._updateFinalTexture();
            }
          }
        }, {
          key: "_updateFinalTexture",
          value: function value() {
            var e = this._canvas,
                t = e.width,
                n = e.height,
                i = this.rotation,
                r = Math.cos(i),
                o = Math.sin(i),
                a = new l(Math.abs(t * r) + Math.abs(n * o), Math.abs(t * o) + Math.abs(n * r));
            this._finalCanvas.width = a.x, this._finalCanvas.height = a.y, this._finalContext.save(), this._finalContext.translate(this._finalCanvas.width / 2, this._finalCanvas.height / 2), this._finalContext.rotate(i), this._finalContext.drawImage(this._canvas, -t / 2, -n / 2), this._finalContext.restore();
          }
        }, {
          key: "_renderText",
          value: function value(e, t, n, i, r) {
            this._canvas.width = t.x, this._canvas.height = t.y, this._text.getMaxHeight() && (this._canvas.height = Math.min(this._text.getMaxHeight() * r.y, this._canvas.height)), this._context = this._canvas.getContext("2d"), this._context.fillStyle = this._text.getBackgroundColor().toRGBA(), this._context.fillRect(0, 0, t.x, t.y), this._applyTextOptions(i, this._context);

            for (var o = 0; o < n.length; o++) {
              var a = n[o];

              this._renderTextLine(a, i.topPadding + i.lineHeight * o);
            }
          }
        }, {
          key: "calculateFontStyles",
          value: function value(e, t) {
            var n = this._text.getFontFamily(),
                i = this._text.getFontSize() * t.y,
                r = this._text.getAbsoluteTextHeight(t),
                o = r * this._text.getLineHeight(),
                a = {
              fontFamily: n,
              fontSize: i,
              lineHeight: o,
              topPadding: r * (this._text.getLineHeight() - 1) / 2
            };

            return this._textOptions.fontFamily === n && this._textOptions.fontSize === i && this._textOptions.lineHeight === o || (this._textOptions = a), a;
          }
        }, {
          key: "_calculateText",
          value: function value(e, t, n) {
            var i = this._text.getMaxWidth() * n.x;

            this._applyTextOptions(t, this._context);

            var r = new l(),
                o = this._text.getText().split("\n");

            if (void 0 !== i) r.x = i, o = this._buildOutputLines(i);else for (var a = 0; a < o.length; a++) {
              var s = o[a];
              r.x = Math.max(r.x, this._context.measureText(s).width);
            }
            var u = t.lineHeight;
            return r.y = o.length * u, {
              dimensions: r,
              lines: o
            };
          }
        }, {
          key: "getTexture",
          value: function value() {
            return this._texture;
          }
        }, {
          key: "getFinalTexture",
          value: function value() {
            return this._finalTexture;
          }
        }, {
          key: "getDimensions",
          value: function value(e, t) {
            var n = this.calculateFontStyles(e, t);
            return this._calculateText(e, n, t).dimensions;
          }
        }, {
          key: "dispose",
          value: function value() {
            this._measurementElement && document.body.removeChild(this._measurementElement), this._texture && (this._texture.dispose(), this._texture = null), this._finalTexture && (this._finalTexture.dispose(), this._finalTexture = null);
          }
        }]), e;
      }();

      t.a = u;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._context = t, this._lastFontStyle = {};
        }

        return o(e, [{
          key: "getLines",
          value: function value() {
            for (var e = this, t = [], n = [], i = this._lines.length, r = 0; r < i; r++) {
              for (var o = this._lines[r], a = this._buildWords(o), s = a.length, l = 0; l < s; l++) {
                var u = a[l],
                    c = n.concat(u).join("").replace(/\s+$/i, "");

                if (this._getWidth(c) > this._maxWidth) {
                  n.length > 0 && (t.push(n.join("")), n = [u]);
                  var p = u.replace(/\s+$/i, "");

                  if (this._getWidth(p) > this._maxWidth) {
                    var f = this._splitWord(u);

                    t = t.concat(f.lines), f.rest && (n = [f.rest]);
                  }
                } else n.push(u);
              }

              t.push(n.join("")), n = [];
            }

            return t.map(function (t) {
              return e._trimLine(t, e._context.textAlign);
            });
          }
        }, {
          key: "_trimLine",
          value: function value(e, t) {
            return e;
          }
        }, {
          key: "_buildWords",
          value: function value(e) {
            for (var t = [], n = "", i = e.length, r = 0; r < i; r++) {
              var o = e[r];
              n += o, " " !== o && "-" !== o && r !== i - 1 || (t.push(n), n = "");
            }

            return t;
          }
        }, {
          key: "_splitWord",
          value: function value(e) {
            for (var t = {
              lines: [],
              rest: null
            }, n = e.length, i = [], r = 0; r < n; r++) {
              var o = e[r];
              this._getWidth(i.concat(o).join("")) > this._maxWidth ? (i.length > 0 && t.lines.push(i.join("")), i = [o]) : i.push(o), r === n - 1 && i.length > 0 && (t.rest = i.join(""));
            }

            return t;
          }
        }, {
          key: "_fontStyleChanged",
          value: function value() {
            return this._context.font !== this._lastFontStyle && (this._lastFontStyle = this._context.font, !0);
          }
        }, {
          key: "_getWidth",
          value: function value(e) {
            return this._context.measureText(e).width;
          }
        }, {
          key: "setText",
          value: function value(e) {
            this._text = e, this._lines = e.split("\n");
          }
        }, {
          key: "setMaxWidth",
          value: function value(e) {
            this._maxWidth = e;
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return S;
      });

      var i = n(6),
          r = n.n(i),
          o = n(15),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(5),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = (n.n(y), n(76)),
          v = n(180),
          b = n(26),
          w = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          x = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function k(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function T(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var S = function (e) {
        function t() {
          return k(this, t), T(this, (t.__proto__ || m()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), x(t, [{
          key: "_layoutRow",
          value: function value(e, t, n, i) {
            return new b.a({
              words: e,
              width: t,
              attributes: n
            });
          }
        }, {
          key: "_layoutRows",
          value: function value(e, n) {
            var i = function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = c()(t, n);

              if (void 0 === r) {
                var o = m()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var a = r.get;
              return void 0 !== a ? a.call(i) : void 0;
            }(t.prototype.__proto__ || m()(t.prototype), "_layoutRows", this).call(this, e, n),
                r = .032 * n,
                o = .08 * n,
                s = new v.a({
              width: n,
              height: r,
              type: v.a.FormType.LongLine,
              shearingAngle: 0
            }).layout(),
                l = new v.a({
              width: n,
              height: o,
              type: v.a.FormType.LongAndShortLine,
              shearingAngle: 0
            }).layout();

            return [s].concat(function (e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = Array(e.length); t < e.length; t++) {
                  n[t] = e[t];
                }

                return n;
              }

              return a()(e);
            }(i), [l]);
          }
        }]), t;
      }(_.a);

      S.defaultFontIdentifiers = ["imgly_font_summer_font_light"], S.identifier = "imgly_text_design_blocks_light", S.prototype.availableOptions = w({}, _.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: y.OptionType.ARRAY,
          default: S.defaultFontIdentifiers
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return k;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(52)),
          g = n(92),
          m = n(33),
          y = n(48),
          _ = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = h.Math.Rectangle,
          k = function (e) {
        function t() {
          var e;
          b(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = w(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o.setSize(new m.a(o.getWidth(), o.getHeight())), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_calculateLayoutElements",
          value: function value() {
            return [new d.a({
              frame: this._getTextFrame()
            })];
          }
        }, {
          key: "render",
          value: function value(e) {
            var n = this._getFrame(),
                i = this.getType(),
                r = this.getAttributes().getTextColor(),
                o = n.height / 3,
                a = new x(n.x, n.y, n.width, o),
                s = new x(n.x, n.y + 2 * o, n.width, o);

            switch (i) {
              case t.FormType.Rect:
                Object(y.d)(e, n, r);
                break;

              case t.FormType.DoubleRect:
                Object(y.d)(e, a, r), Object(y.d)(e, s, r);
                break;

              case t.FormType.DoubleRectFirstPunctuated:
                Object(y.e)(e, a, r), Object(y.d)(e, s, r);
                break;

              case t.FormType.DoubleRectSecondPunctuated:
                Object(y.d)(e, a, r), Object(y.e)(e, s, r);
                break;

              case t.FormType.LongLine:
                var l = n.height / 2,
                    u = new x(n.x, n.y, n.width, l);
                Object(y.c)(e, u, .5 * u.height, r);
                break;

              case t.FormType.LongAndShortLine:
                var c = .2 * n.height,
                    p = .75 * c;
                a = new x(n.x, n.y + c, n.width, c);
                var f = n.x + .25 * n.width,
                    h = n.y + n.height - p;
                s = new x(f, h, .5 * n.width, p), Object(y.c)(e, a, .5 * a.height, r), Object(y.c)(e, s, .5 * s.height, r);
            }
          }
        }]), t;
      }(g.a);

      k.FormType = {
        Rect: "RECT",
        DoubleRect: "DOUBLE_RECT",
        DoubleRectFirstPunctuated: "DOUBLE_RECT_FIRST_PUNCTUATED",
        DoubleRectSecondPunctuated: "DOUBLE_RECT_SECOND_PUNCTUATED",
        LongLine: "LONG_LINE",
        LongAndShortLine: "LONG_AND_SHORT_LINE"
      }, k.prototype.availableOptions = _({}, g.a.prototype.availableOptions, {
        height: {
          type: h.OptionType.NUMBER,
          default: 100
        },
        type: {
          type: h.OptionType.STRING,
          default: k.FormType.Rect,
          available: h.Utils.values(k.FormType)
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return S;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(76)),
          y = n(26),
          _ = n(123),
          v = n(47),
          b = n(125),
          w = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          x = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function k(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function T(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var S = function (e) {
        function t() {
          return k(this, t), T(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), x(t, [{
          key: "_fontForRow",
          value: function value(e, t) {
            var n = this.getFontIdentifiers();
            return n[e % n.length];
          }
        }, {
          key: "_minimumNumberOfLines",
          value: function value(e) {
            return Math.max(Math.floor(.7 * function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = l()(t, n);

              if (void 0 === r) {
                var o = d()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var a = r.get;
              return void 0 !== a ? a.call(i) : void 0;
            }(t.prototype.__proto__ || d()(t.prototype), "_minimumNumberOfLines", this).call(this, e)), 1);
          }
        }, {
          key: "_maximumNumberOfLines",
          value: function value(e) {
            return Math.max(Math.floor(e.countNumberOfCharacters() / 5), 1);
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, n, i, r) {
            return this._createSingleRow(t.RowType.Single, e, i, r);
          }
        }, {
          key: "_createSingleRow",
          value: function value(e, n, i, r) {
            var o = r.getFontIdentifier(),
                a = "imgly_font_amberlight" === o || "imgly_font_handycheera_regular" === o ? new v.a().set(n.getLowerCase()) : n;

            switch (e) {
              case t.RowType.Single:
                return new y.a({
                  words: a,
                  width: i,
                  attributes: r
                });

              case t.RowType.SingleImage:
                return new b.a({
                  words: a,
                  width: i,
                  attributes: r
                });

              default:
                return g.Log.warn("TextDesignCelebrate#_createSingleRow: Invalid row type '" + e + "'"), null;
            }
          }
        }]), t;
      }(m.a);

      S.defaultFontIdentifiers = ["imgly_font_handycheera_regular", "imgly_font_rasa_regular"], S.defaultBanderoles = [_.a.Celebrate1, _.a.Celebrate2], S.identifier = "imgly_text_design_celebrate", S.RowType = {
        Single: "SINGLE",
        SingleImage: "SINGLE_IMAGE"
      }, S.prototype.availableOptions = w({}, m.a.prototype.availableOptions, {
        relativeLineSpacing: {
          type: g.OptionType.NUMBER,
          default: .01875
        },
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: S.defaultFontIdentifiers
        },
        banderoles: {
          type: g.OptionType.ARRAY,
          default: S.defaultBanderoles
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return E;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(77)),
          y = n(26),
          _ = n(21),
          v = n(436),
          b = n(47),
          w = n(20),
          x = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          k = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          T = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function S(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function C(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var E = function (e) {
        function t() {
          var e;
          S(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = C(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          return o._relativeInsets = new _.a(.1, .1, .1, .1), o._alreadyContainsARowWithScriptFont = !1, o._backgroundsRandomizer = new w.a(0), o._seedPool.push(o._backgroundsRandomizer), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), k(t, [{
          key: "getImagePaths",
          value: function value() {
            return g.Utils.Array.flatten(v.a.Backgrounds.map(function (e) {
              return e.getImagePaths();
            }));
          }
        }, {
          key: "_getBackground",
          value: function value() {
            return this._backgroundsRandomizer.pickNext(v.a.Backgrounds);
          }
        }, {
          key: "generateLayoutData",
          value: function value(e, n) {
            return this._alreadyContainsARowWithScriptFont = !1, this._background = this._getBackground(), T(t.prototype.__proto__ || d()(t.prototype), "generateLayoutData", this).call(this, e, n);
          }
        }, {
          key: "_modifiedText",
          value: function value(e) {
            return T(t.prototype.__proto__ || d()(t.prototype), "_modifiedText", this).call(this, e).toUpperCase();
          }
        }, {
          key: "_fontForRow",
          value: function value(e, n) {
            var i = T(t.prototype.__proto__ || d()(t.prototype), "_fontForRow", this).call(this, e, n);
            return "imgly_font_petit_formal_script" === i && (this._alreadyContainsARowWithScriptFont && (i = "imgly_font_bungee_inline"), this._alreadyContainsARowWithScriptFont = !0), i;
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, t, n, i) {
            var r = "imgly_font_petit_formal_script" === i.getFontIdentifier();
            return new y.a({
              words: r ? new b.a().set(e.getLowerCase()) : e,
              width: n,
              attributes: i
            });
          }
        }]), t;
      }(m.a);

      E.identifier = "imgly_text_design_equal_width", E.defaultFontIdentifiers = ["imgly_font_ultra", "imgly_font_bungee_inline", "imgly_font_petit_formal_script"], E.prototype.availableOptions = x({}, m.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: E.defaultFontIdentifiers
        },
        relativeLineSpacing: {
          type: g.OptionType.NUMBER,
          default: .025
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return g;
      });
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "render",
          value: function value(e, t, n, i, r) {
            p.Log.warn("TextDesignBackground#render: Abstract class");
          }
        }]), t;
      }(p.Configurable);

      g.prototype.availableOptions = {};
    }, function (e, t, n) {
      var i = n(23);

      e.exports = function (e, t) {
        if (!i(e) || e._t !== t) throw TypeError("Incompatible receiver, " + t + " required!");
        return e;
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(13),
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            var e = this._getInputWithName("x").logicalShape;

            if (2 !== e.length) throw new Error("UnpackRGBAFilter expects 2D inputs");
            return [1, e[0], e[1], 3];
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      void main ()\n      {\n        //       x, y, z, w\n        // e.g. [0, 4, 3, 2] (which is the blue channel of the pixel at x: 3, y: 4)\n        ivec4 outputCoords = getOutputCoords();\n        \n        int row = outputCoords.y;\n        int col = outputCoords.z;\n        int offset = outputCoords.w;\n\n        int index = row * int(x_sizeRC.y) + col;\n        int logR = index / int(x_sizeRC.y);\n        int logC = index - logR * int(x_sizeRC.y);\n        vec2 uv = (vec2(logC, logR) + halfCR) / x_texRC.yx;\n        vec4 color = texture2D(x, uv);\n\n        float component = 0.0;\n        if (offset == 0) {\n          component = color.r;\n        } else if (offset == 1) {\n          component = color.g;\n        } else if (offset == 2) {\n          component = color.b;\n        }\n        gl_FragColor = vec4(component, 0.0, 0.0, 1.0);\n      }\n    ";
          }
        }, {
          key: "requiresFloatTextures",
          value: function value() {
            return !0;
          }
        }]), t;
      }(p.b);

      t.a = g;
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(13)),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = y(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._uniforms.blendLeftTopRightBottom = {
            type: h.UniformType.FLOAT4,
            value: o.availableOptions.blendLeftTopRightBottom.default
          }, o._uniforms.blendRadius = {
            type: h.UniformType.FLOAT,
            value: o.availableOptions.blendRadius.default
          }, o.prepareUniforms(), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "requiresFloatTextures",
          value: function value() {
            return !1;
          }
        }, {
          key: "_calculateOutputShape",
          value: function value() {
            var e = this._getInputWithName("x"),
                t = this._getInputWithName("y");

            if (e.logicalShape[0] !== t.logicalShape[0] || e.logicalShape[1] !== t.logicalShape[1]) throw new Error("X and Y inputs of " + this.constructor.name + " must have same shape.");
            return e.logicalShape;
          }
        }, {
          key: "_updateAdditionalUniforms",
          value: function value(e) {
            e.setUniform("blendLeftTopRightBottom", this.getBlendLeftTopRightBottom()), e.setUniform("blendRadius", this.getBlendRadius());
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      uniform vec4 blendLeftTopRightBottom;\n      uniform float blendRadius;\n\n      void main() {\n        vec2 coords = vec2(getOutputCoords());\n\n        vec2 blendVertical = vec2(coords.x, x_sizeRC.x - coords.x) / vec2(x_sizeRC.x * blendRadius); // topBlend, bottomBlend\n        vec2 blendHorizontal = vec2(coords.y, x_sizeRC.y - coords.y) / vec2(x_sizeRC.y * blendRadius); // leftBlend, rightBlend\n        vec4 factorLeftTopRightBottom = clamp(vec4(blendHorizontal.x, blendVertical.x, blendHorizontal.y, blendVertical.y), vec4(0.0), vec4(1.0));\n        vec4 maskVector = (vec4(1.0) - blendLeftTopRightBottom) * vec4(2.0); // [0, 1, 1, 1] becomes [2, 0, 0, 0]\n        vec4 maskedFactorLeftTopRightBottom = factorLeftTopRightBottom + maskVector; // [0.25, 0.5, 1.0, 1.0] becomes [2.25, 1.0, 1.0]\n        float factor = min(min(maskedFactorLeftTopRightBottom.x, maskedFactorLeftTopRightBottom.y), min(maskedFactorLeftTopRightBottom.z, maskedFactorLeftTopRightBottom.w)); // Choose the smallest blending factor\n        \n        vec2 uv = UVfrom2D(x_texRC, x_sizeRC, int(x_sizeRC.y), int(coords.x), int(coords.y));\n        vec4 xColor = texture2D(x, uv);\n        vec4 yColor = texture2D(y, uv);\n\n        gl_FragColor = mix(yColor, xColor, factor);\n      }\n    ";
          }
        }]), t;
      }(d.b);

      _.prototype.availableOptions = r()({
        blendLeftTopRightBottom: {
          type: h.OptionType.ARRAY,
          default: [1, 1, 1, 1]
        },
        blendRadius: {
          type: h.OptionType.NUMBER,
          default: .2
        }
      }, d.b.prototype.availableOptions), t.a = _;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(4),
          a = (n.n(o), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          s = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }

        return a(e, null, [{
          key: "determineSupportedConfiguration",
          value: function value(t) {
            var n = !1;
            if (e._cachedConfigs || (e._cachedConfigs = {}, n = !0), e._cachedConfigs[t.id]) return e._cachedConfigs[t.id];

            var i = t.getExtension("OES_texture_float"),
                r = t.FLOAT,
                a = t.getExtension("OES_texture_half_float"),
                s = null !== a ? a.HALF_FLOAT_OES : null,
                l = null !== i,
                u = e._canCreateTexture(t, r, t.LUMINANCE),
                c = null !== a && e._canCreateTexture(t, s, t.RGBA),
                p = e._canCreateTexture(t, s, t.LUMINANCE),
                f = l && (t.getExtension("WEBGL_color_buffer_float") || e._canBindBuffer(t, r, t.RGBA)),
                h = e._canBindBuffer(t, r, t.LUMINANCE),
                d = e._canBindBuffer(t, s, t.LUMINANCE),
                g = t.FLOAT,
                m = t.RGBA,
                y = "?";

            p ? (y = "Float16 Luminance", g = s, m = t.LUMINANCE) : c ? (y = "Float16 RGBA", g = s) : u ? (y = "Float32 Luminance", m = t.LUMINANCE) : y = "Float32 RGBA";
            var _ = r,
                v = t.RGBA,
                b = "?";
            d ? (b = "Float16 Luminance", _ = s, v = t.LUMINANCE) : h ? (b = "Float32 Luminance", _ = r, v = t.LUMINANCE) : b = "Float32 RGBA", n && o.Log.info("\nArt Filter configuration:\nWeight Textures: " + y + "\nRender Textures: " + b);
            var w = {
              environmentSupported: f,
              weightTextureType: g,
              weightTextureFormat: m,
              renderTextureType: _,
              renderTextureFormat: v
            };
            return e._cachedConfigs[t.id] = w, w;
          }
        }, {
          key: "_canCreateTexture",
          value: function value(e, t, n) {
            var i = e.createTexture();
            e.bindTexture(e.TEXTURE_2D, i);
            var r = n === e.RGBA ? 4 : 1,
                o = new Uint16Array(r);
            t === e.FLOAT && (o = new Float32Array(r)), 1 === r && e.pixelStorei(e.UNPACK_ALIGNMENT, 1), e.texImage2D(e.TEXTURE_2D, 0, n, 1, 1, 0, n, t, o), e.pixelStorei(e.UNPACK_ALIGNMENT, 4);
            var a = e.isTexture(i),
                s = e.getError() !== e.NO_ERROR;
            return e.deleteTexture(i), a && !s;
          }
        }, {
          key: "_canBindBuffer",
          value: function value(e, t, n) {
            var i = e.createTexture();
            e.bindTexture(e.TEXTURE_2D, i), e.texImage2D(e.TEXTURE_2D, 0, n, 1, 1, 0, n, t, null);
            var r = e.createFramebuffer();
            e.bindFramebuffer(e.FRAMEBUFFER, r), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, i, 0);
            var o = e.checkFramebufferStatus(e.FRAMEBUFFER);
            return e.deleteTexture(i), e.deleteFramebuffer(r), o === e.FRAMEBUFFER_COMPLETE;
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(13),
          f = n(54),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = function (e) {
        function t() {
          return d(this, t), g(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            if (2 !== this.getInputs().length) throw Error("AddFilter requires two inputs: x and y.");

            var e = this._getInputWithName("x"),
                t = this._getInputWithName("y");

            if (!f.a.isSameShape(e.logicalShape, t.logicalShape)) throw Error("AddFilter inputs must have matching input shapes (" + e.logicalShape + " vs. " + t.logicalShape + ").");
            return e.logicalShape;
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        float xVal = getX(coords.x, coords.y, coords.z, coords.w);\n        float yVal = getY(coords.x, coords.y, coords.z, coords.w);\n        \n        float result = xVal + yVal;\n        setOutput(result);\n      }\n    ";
          }
        }]), t;
      }(p.b);

      t.a = m;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(13),
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            return this._getInputWithName("x").logicalShape;
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        float x = getX(coords.x, coords.y, coords.z, coords.w);\n\n        // WebGL doesn't offer tanh, taken from TFJS\n        float e2x = exp(-2.0 * abs(x));\n        float tanh = sign(x) * (1.0 - e2x) / (1.0 + e2x);\n\n        float rgbValue = (tanh * 150.0) + 127.5;\n        float clamped = clamp(rgbValue, 0.0, 255.0);\n        setOutput(clamped / 255.0);\n      }\n    ";
          }
        }]), t;
      }(p.b);

      t.a = g;
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(29),
          a = n.n(o),
          s = n(25),
          l = n.n(s),
          u = n(0),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = (n.n(y), n(13)),
          v = n(133),
          b = function b(e, t) {
        if (Array.isArray(e)) return e;
        if (a()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var a, s = l()(e); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && s.return && s.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          w = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), c()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function x(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function k(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var T = function (e) {
        function t() {
          return x(this, t), k(this, (t.__proto__ || m()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), w(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            if (2 !== this._options.inputs.length) throw Error("Conv2DFilter requires two inputs: x and w.");

            var e = this._getInputWithName("x"),
                t = this._getInputWithName("w"),
                n = b(e.logicalShape, 4),
                i = n[0],
                r = n[1],
                o = n[2],
                a = (n[3], b(t.logicalShape, 4)),
                s = a[0],
                l = a[1],
                u = a[3],
                c = this._options.stride,
                p = this._options.stride,
                f = v.a.calculatePadding(this._options.padding, r, o, c, p, s, l),
                h = f.padInfo,
                d = f.outHeight,
                g = f.outWidth;

            return this._outChannels = u, this._padInfo = h, [i, d, g, this._outChannels];
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            var e = this._getInputWithName("x").logicalShape[3],
                t = this._padInfo.top,
                n = this._padInfo.left,
                i = 4 * Math.floor(e / 4),
                r = e % 4,
                o = this._options.stride;

            return "\n    const ivec2 strides = ivec2(" + o + ", " + o + ");\n    const ivec2 pads = ivec2(" + t + ", " + n + ");\n\n    const int max_filter_iterations = 9; // Required to achieve fixed size loop\n\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int batch = coords[0];\n      int d2 = coords[3];\n\n      ivec2 xRCCorner = coords.yz * strides - pads;\n      int xRCorner = xRCCorner.x;\n      int xCCorner = xRCCorner.y;\n\n      // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).\n      // ? = to be determined. : = across all values in that axis.\n      float dotProd = 0.0;\n      for (int wR = 0; wR < max_filter_iterations; wR++) {\n        if (wR >= w_shape[0]) { break; }\n        int xR = xRCorner + wR;\n        if (xR < 0 || xR >= x_shape[1]) {\n          continue;\n        }\n\n        for (int wC = 0; wC < max_filter_iterations; wC++) {\n          if (wC >= w_shape[1]) { break; }\n          int xC = xCCorner + wC;\n\n          if (xC < 0 || xC >= x_shape[2]) {\n            continue;\n          }\n\n          for (int d1 = 0; d1 < " + i + "; d1 += 4) {\n            vec4 xValues = vec4(\n              getX(batch, xR, xC, d1),\n              getX(batch, xR, xC, d1 + 1),\n              getX(batch, xR, xC, d1 + 2),\n              getX(batch, xR, xC, d1 + 3)\n            );\n            vec4 wValues = vec4(\n              getW(wR, wC, d1, d2),\n              getW(wR, wC, d1 + 1, d2),\n              getW(wR, wC, d1 + 2, d2),\n              getW(wR, wC, d1 + 3, d2)\n            );\n\n            dotProd += dot(xValues, wValues);\n          }\n\n          if (" + (1 === r) + ") {\n            dotProd +=\n              getX(batch, xR, xC, " + i + ") *\n              getW(wR, wC, " + i + ", d2);\n          } else if (" + (2 === r) + ") {\n            vec2 xValues = vec2(\n              getX(batch, xR, xC, " + i + "),\n              getX(batch, xR, xC, " + i + " + 1)\n            );\n            vec2 wValues = vec2(\n              getW(wR, wC, " + i + ", d2),\n              getW(wR, wC, " + i + " + 1, d2)\n            );\n            dotProd += dot(xValues, wValues);\n          } else if (" + (3 === r) + ") {\n            vec3 xValues = vec3(\n              getX(batch, xR, xC, " + i + "),\n              getX(batch, xR, xC, " + i + " + 1),\n              getX(batch, xR, xC, " + i + " + 2)\n            );\n            vec3 wValues = vec3(\n              getW(wR, wC, " + i + ", d2),\n              getW(wR, wC, " + i + " + 1, d2),\n              getW(wR, wC, " + i + " + 2, d2)\n            );\n            dotProd += dot(xValues, wValues);\n          }\n        }\n      }\n      setOutput(dotProd);\n    }";
          }
        }]), t;
      }(_.b);

      T.prototype.availableOptions = r()({
        stride: {
          type: y.OptionType.NUMBER,
          default: 1
        },
        padding: {
          type: y.OptionType.STRING,
          default: "same"
        }
      }, _.b.prototype.availableOptions), t.a = T;
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(29),
          a = n.n(o),
          s = n(25),
          l = n.n(s),
          u = n(0),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = (n.n(y), n(13)),
          v = n(133),
          b = function b(e, t) {
        if (Array.isArray(e)) return e;
        if (a()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var a, s = l()(e); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && s.return && s.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          w = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), c()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function x(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function k(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var T = function (e) {
        function t() {
          return x(this, t), k(this, (t.__proto__ || m()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), w(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            if (2 !== this.getInputs().length) throw Error("DepthwiseConv2DFilter requires two inputs: x and w.");

            var e = this._getInputWithName("x"),
                t = this._getInputWithName("w"),
                n = b(e.logicalShape, 4),
                i = n[0],
                r = n[1],
                o = n[2],
                a = n[3],
                s = b(t.logicalShape, 4),
                l = s[0],
                u = s[1],
                c = s[3];

            if (l > 9 || u > 9) throw new Error("Filter heights are limited to 9. Change shader source if larger ones are required.");
            var p = this._options.stride,
                f = this._options.stride,
                h = v.a.calculatePadding(this._options.padding, r, o, p, f, l, u),
                d = h.padInfo,
                g = h.outHeight,
                m = h.outWidth;
            return this._outChannels = c * a, this._padInfo = d, [i, g, m, this._outChannels];
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            var e,
                t = this._padInfo.top,
                n = this._padInfo.left,
                i = this._options,
                r = i.stride,
                o = i.padMethod;

            switch (o) {
              case "zero":
                e = "return coords;";
                break;

              case "edge":
                e = "return ivec4(clamp(vec4(coords), vec4(0.0), vec4(x_shape - 1)));";
            }

            return "\n      const ivec2 strides = ivec2(" + r + ", " + r + ");\n      const ivec2 pads = ivec2(" + t + ", " + n + ");\n      const int max_filter_iterations = 9; // Required to achieve fixed size loop\n\n      \n    ivec4 convertCoordinatesForPadding(ivec4 coords) {\n      " + e + "\n    }\n    \n\n      void main() {\n        ivec4 coords = getOutputCoords();\n\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads; // current coordinates in x\n        int d2 = coords.w; // current channel index\n        int outChannels = w_shape[3] * x_shape[3];\n        int d1 = d2; // currently probed channel\n        int q = d2 - d1; // current filter index\n\n        int xRCorner = xRCCorner.x; // row index\n        int xCCorner = xRCCorner.y; // column index\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < max_filter_iterations; wR++) {\n          if (wR >= w_shape[0]) { break; }\n\n          int xR = xRCorner + wR; // x row index = current index + offset * y dilation\n          " + ("zero" === o ? "if (xR < 0 || xR >= x_shape[1]) { continue; }" : "") + "\n\n          for (int wC = 0; wC < max_filter_iterations; wC++) {\n            if (wC >= w_shape[1]) { break; }\n\n            int xC = xCCorner + wC; // x column index = current index + offset * x dilation\n            " + ("zero" === o ? "if (xC < 0 || xC >= x_shape[2]) { continue; }" : "") + "\n\n            float xVal = getX(convertCoordinatesForPadding(ivec4(batch, xR, xC, d1))); // Get value at current [batch, y, x, channel]\n            float wVal = getW(wR, wC, d1, q); // Get kernel value at current \n            dotProd += xVal * wVal;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          }
        }]), t;
      }(_.b);

      T.prototype.availableOptions = r()({
        stride: {
          type: y.OptionType.NUMBER
        },
        padding: {
          type: y.OptionType.STRING,
          default: "same"
        },
        padMethod: {
          type: y.OptionType.STRING,
          default: "zero"
        }
      }, _.b.prototype.availableOptions), t.a = T;
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(29),
          a = n.n(o),
          s = n(25),
          l = n.n(s),
          u = n(0),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = (n.n(y), n(13)),
          v = n(54),
          b = function b(e, t) {
        if (Array.isArray(e)) return e;
        if (a()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var a, s = l()(e); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && s.return && s.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          w = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), c()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function x(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function k(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var T = function (e) {
        function t() {
          return x(this, t), k(this, (t.__proto__ || m()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), w(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            var e = this._getInputWithName("x").logicalShape[0],
                t = this._options,
                n = t.batchSize,
                i = t.windowSize;

            return [Math.ceil(e / i), n];
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            var e = this._options.windowSize,
                t = this._getInputWithName("x").logicalShape[0],
                n = 4 * Math.floor(e / 4),
                i = e % 4,
                r = "";

            return t % e > 0 && (r = "\n      if (inIdx < 0 || inIdx >= x_shape[0]) {\n        return initalizationValue;\n      }\n      "), "\n      const float initializationValue = 0.0;\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        " + r + "\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        // row, col\n        ivec2 coords = getOutputCoords();\n        int batch = coords[1];\n        int outIdx = coords[0];\n        int inOffset = outIdx * " + e + ";\n        float sumValue = 0.0;\n\n        for (int i = 0; i < " + n + "; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            // row, col\n            getValue(inIdx, batch),\n            getValue(inIdx + 1, batch),\n            getValue(inIdx + 2, batch),\n            getValue(inIdx + 3, batch)\n          );\n\n          sumValue += dot(values, ones);\n        }\n\n        int inIdx = inOffset + " + n + ";\n        if (" + (1 === i) + ") {\n          vec4 values = vec4(\n            getValue(inIdx, batch),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          sumValue += dot(values, ones);\n        } else if (" + (2 === i) + ") {\n          vec4 values = vec4(\n            getValue(inIdx, batch),\n            getValue(inIdx + 1, batch),\n            initializationValue,\n            initializationValue\n          );\n\n          sumValue += dot(values, ones);\n        } else if (" + (3 === i) + ") {\n          vec4 values = vec4(\n            getValue(inIdx, batch),\n            getValue(inIdx + 1, batch),\n            getValue(inIdx + 2, batch),\n            initializationValue\n          );\n\n          sumValue += dot(values, ones);\n        }\n        setOutput(sumValue);\n      }\n    ";
          }
        }], [{
          key: "addFiltersForReduceSumOperationToGraph",
          value: function value(e, n) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [1, 2],
                r = e.getLogicalShapeAtIndex(n),
                o = t._computeOutAndReduceShape(r, i),
                a = b(o, 2),
                s = (a[0], a[1]),
                l = v.a.getSizeOfLogicalShape(s),
                u = v.a.getSizeOfLogicalShape(r) / l,
                c = [l, u],
                p = n === e.getLastIndex(),
                f = {
              name: "x",
              logicalShape: c,
              type: p ? _.a.PREVIOUS : _.a.INDEX
            };

            p || (f.data = n);

            var h = t._buildReduceFilter(f);

            e.addFilter(h, !1);

            for (var d = h.outputLogicalShape(); 1 !== d[0];) {
              var g = {
                name: "x",
                type: _.a.PREVIOUS,
                logicalShape: h.outputLogicalShape()
              };
              d = (h = t._buildReduceFilter(g)).outputLogicalShape(), e.addFilter(h);
            }

            return e.getLastIndex();
          }
        }, {
          key: "_buildReduceFilter",
          value: function value(e) {
            var n = b(e.logicalShape, 2),
                i = n[0],
                r = n[1],
                o = t._computeWindowSize(i);

            return new t({
              inputs: [e],
              windowSize: o,
              batchSize: r
            });
          }
        }, {
          key: "_computeWindowSize",
          value: function value(e) {
            if (e <= 30) return e;

            for (var t = Math.floor(Math.sqrt(e)); t < e; ++t) {
              if (e % t == 0) return t;
            }

            return e;
          }
        }, {
          key: "_computeOutAndReduceShape",
          value: function value(e, t) {
            for (var n = [], i = e.length, r = 0; r < i; r++) {
              -1 === t.indexOf(r) && n.push(e[r]);
            }

            return [n, t.map(function (t) {
              return e[t];
            })];
          }
        }]), t;
      }(_.b);

      T.prototype.availableOptions = r()({
        axes: {
          type: y.OptionType.ARRAY,
          default: [1, 2]
        },
        windowSize: {
          type: y.OptionType.NUMBER
        },
        batchSize: {
          type: y.OptionType.NUMBER
        }
      }, _.b.prototype.availableOptions), t.a = T;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(13),
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            return this._getInputWithName("x").logicalShape;
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      void main ()\n      {\n        ivec4 coords = getOutputCoords();\n        float numValuesPerChannel = float(x_shape[1] * x_shape[2]);\n\n        // 'Sum' input consists of a single value which holds the sum of all elements in x\n        float xSum = getSumFlat(coords.w);\n\n        // 'X' is a 4D tensor holding arbitrary float values\n        float x = getX(coords.x, coords.y, coords.z, coords.w);\n\n        // Calculate the mean\n        float mean = xSum / numValuesPerChannel;\n\n        // Calculate a single variance component (x_i - mean)^2\n        float result = pow((x - mean), 2.0);\n        setOutput(result);\n      }\n    ";
          }
        }]), t;
      }(p.b);

      t.a = g;
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(13)),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            var e = this._getInputWithName("x"),
                t = this._getInputWithName("variance"),
                n = this._getInputWithName("sum"),
                i = e.logicalShape[3];

            if (t.logicalShape[1] !== i || n.logicalShape[1] !== i) throw new Error("Variance and sum input depth must match x inputs channels for InstanceNormReluFilter.");
            return e.logicalShape;
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      void main ()\n      {\n        float numValuesPerChannel = float(x_shape[1] * x_shape[2]);\n        ivec4 coords = getOutputCoords();\n        float x = getX(coords.x, coords.y, coords.z, coords.w);\n\n        // 'variance' input consists of a single value per channel which holds the sum of all values in x reduced by it's mean and squared afterwards\n        float nonMeanedVariance = getVarianceFlat(coords.w);\n        float variance = nonMeanedVariance / numValuesPerChannel;\n\n        // 'sum' input consists of a single value per channel which holds the sum of all elements in x\n        float xSum = getSumFlat(coords.w);\n        float mean = xSum / numValuesPerChannel;\n\n        float netmu = x - mean;\n        float sigmaEpsilonSqrt = sqrt(variance + 0.001);\n\n        float normalized = netmu / sigmaEpsilonSqrt;\n        \n        // Calculate the instance normalized value of x\n        float shift = getShiftFlat(coords.w);\n        float scale = getScaleFlat(coords.w);\n        float result = (scale * normalized) + shift;\n\n        // If it's not NaN, calculate relu\n        " + (this.getAddRelu() ? "\n      if (isNaN(result)) {\n        setOutput(result);\n      } else {\n        float relu = (result < 0.0) ? 0.0 : result;\n        setOutput(relu);\n      }\n    " : "setOutput(result);") + "\n      }\n    ";
          }
        }]), t;
      }(d.b);

      _.prototype.availableOptions = r()({
        shift: {
          type: h.OptionType.NUMBER
        },
        scale: {
          type: h.OptionType.NUMBER
        },
        addRelu: {
          type: h.OptionType.BOOLEAN,
          default: !0
        }
      }, d.b.prototype.availableOptions), t.a = _;
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(29),
          a = n.n(o),
          s = n(25),
          l = n.n(s),
          u = n(0),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = (n.n(y), n(13)),
          v = function v(e, t) {
        if (Array.isArray(e)) return e;
        if (a()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var a, s = l()(e); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && s.return && s.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          b = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), c()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function w(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var k = function (e) {
        function t() {
          var e;
          w(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = x(this, (e = t.__proto__ || m()(t)).call.apply(e, [this].concat(i)));
          return o._uniforms.sourceSizeRC = {
            type: y.UniformType.FLOAT2,
            value: [0, 0]
          }, o._uniforms.targetSizeRC = {
            type: y.UniformType.FLOAT2,
            value: [0, 0]
          }, o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), b(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            var e = this._getInputWithName("x"),
                t = v(e.logicalShape, 4),
                n = t[0],
                i = t[3],
                r = v(this._options.size, 2);

            return [n, r[0], r[1], i];
          }
        }, {
          key: "_updateAdditionalUniforms",
          value: function value(e) {
            var t = v(this._getInputWithName("x").logicalShape, 3),
                n = (t[0], t[1]),
                i = t[2],
                r = {
              targetSizeRC: this.getSize(),
              sourceSizeRC: [n, i]
            };
            e.setUniforms(r);
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      uniform vec2 sourceSizeRC;\n      uniform vec2 targetSizeRC;\n\n      void main() {\n        vec2 effectiveInSize = sourceSizeRC - vec2(1.0, 1.0);\n        vec2 effectiveOutSize = targetSizeRC - vec2(1.0, 1.0);\n        vec2 effectiveInputOverOutputRatioRC = effectiveInSize / effectiveOutSize;\n\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices\n        ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n        ivec2 sourceCeilRC = ivec2(min(sourceSizeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        float topLeft = getX(b, sourceFloorRC.x, sourceFloorRC.y, d);\n        float bottomLeft = getX(b, sourceCeilRC.x, sourceFloorRC.y, d);\n        float topRight = getX(b, sourceFloorRC.x, sourceCeilRC.y, d);\n        float bottomRight = getX(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n        float top = topLeft + (topRight - topLeft) * fracRC.y;\n        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n        float newValue = top + (bottom - top) * fracRC.x;\n\n        setOutput(newValue);\n      }\n    ";
          }
        }]), t;
      }(_.b);

      k.prototype.availableOptions = r()({
        size: {
          type: y.OptionType.ARRAY,
          required: !0
        },
        alignCorners: {
          type: y.OptionType.BOOLEAN,
          default: !0
        }
      }, _.b.prototype.availableOptions), t.a = k;
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(13),
          d = n(4),
          g = (n.n(d), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            var e = this._options.paddings;
            if (1 === !this.getInputs().length || 0 === this.getInputs().length) throw new Error("ReflectionPadFilter requires single input.");
            var t = this.getInputs()[0].logicalShape;
            if (e.length !== t.length) throw new Error("Not enough or too many paddings for input shape " + t);
            return e.map(function (e, n) {
              return e[0] + t[n] + e[1];
            });
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            var e = this.getInputs()[0].logicalShape.length,
                t = "vec" + e;
            return "\n      i" + t + " start = i" + t + "(" + this._options.paddings.map(function (e) {
              return e[0];
            }).join(",") + ");\n\n      void main () {\n        i" + t + " outC = getOutputCoords();\n        " + t + " coordsInInput = " + t + "(outC - start);\n        i" + t + " coords = i" + t + "(clamp(coordsInInput, " + t + "(0.0), " + t + "(x_shape - 1)));\n        setOutput(getX(" + ["coords[0]", "coords[1]", "coords[2]", "coords[3]"].slice(0, e).join(",") + "));\n      }\n    ";
          }
        }]), t;
      }(h.b);

      _.prototype.availableOptions = r()({
        paddings: {
          type: d.OptionType.ARRAY,
          required: !0
        }
      }, h.b.prototype.availableOptions), t.a = _;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(13),
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            return this._getInputWithName("x").logicalShape;
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            return "\n      float kernel[9];\n      vec2 offset[9];\n      float factor = 0.1;\n    \n      void main ()\n      {\n        kernel[0] = 0.;\n        kernel[1] = -1. * factor;\n        kernel[2] = 0.;\n        kernel[3] = -1. * factor;\n        kernel[4] = 1. + 4. * factor;\n        kernel[5] = -1. * factor;\n        kernel[6] = 0.;\n        kernel[7] = -1. * factor;\n        kernel[8] = 0.;\n\n        float step_w = 1.0 / float(x_sizeRC.y);\n        float step_h = 1.0 / float(x_sizeRC.x);\n\n        offset[0] = vec2(-step_w, -step_h);\n        offset[1] = vec2(0.0, -step_h);\n        offset[2] = vec2(step_w, -step_h);\n        offset[3] = vec2(-step_w, 0.0);\n        offset[4] = vec2(0.0, 0.0);\n        offset[5] = vec2(step_w, 0.0);\n        offset[6] = vec2(-step_w, step_h);\n        offset[7] = vec2(0.0, step_h);\n        offset[8] = vec2(step_w, step_h);\n\n        vec2 uv = (gl_FragCoord.xy + halfCR) / x_texRC.yx;\n        vec4 sum = vec4(0.0);\n        for (int i = 0; i < 9; i++) {\n          vec4 color = texture2D(x, uv.xy + offset[i]);\n          sum += color * kernel[i];\n        }\n\n        gl_FragColor = sum;\n      }\n    ";
          }
        }, {
          key: "requiresFloatTextures",
          value: function value() {
            return !1;
          }
        }]), t;
      }(p.b);

      t.a = g;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(9),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }

        return a(e, null, [{
          key: "downloadDataURL",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "photoeditorsdk-export",
                n = this.createBlobURLFromDataURL(e),
                i = this.getExtensionFromDataURL(e),
                r = document.createElement("a");
            r.download = t + "." + i, r.href = n, document.body.appendChild(r), r.click(), document.body.removeChild(r);
          }
        }, {
          key: "downloadMSBlob",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "photoeditorsdk-export";
            navigator.msSaveBlob && navigator.msSaveBlob(e, t + ".png");
          }
        }, {
          key: "getExtensionFromDataURL",
          value: function value(e) {
            return e.split(",")[0].split(":")[1].split(";")[0].split("/").pop();
          }
        }, {
          key: "createBlobURLFromDataURL",
          value: function value(e) {
            if (!(window.Blob && window.URL && ArrayBuffer && Uint8Array)) return e;

            for (var t = o.a.decode(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], i = new ArrayBuffer(t.length), r = new Uint8Array(i), a = 0; a < t.length; a++) {
              r[a] = t[a];
            }

            var s = new window.Blob([i], {
              type: n
            });
            return window.URL.createObjectURL(s);
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(31),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = {
        100: "Extra Light",
        200: "Light",
        300: "Book",
        400: "Regular",
        500: "Medium",
        600: "Semibold",
        700: "Bold",
        800: "Black",
        900: "Extra Black",
        bold: "Bold",
        normal: "Regular"
      },
          m = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "getLabel",
          value: function value() {
            var e = g[this._options.fontWeight];

            switch (this._options.fontStyle) {
              case "italic":
                e += " Italic";
            }

            return e;
          }
        }]), t;
      }(p.Configurable);

      t.a = m, m.prototype.availableOptions = {
        identifier: {
          type: p.OptionType.STRING,
          required: !0
        },
        fontFamily: {
          type: p.OptionType.STRING,
          required: !0
        },
        fontWeight: {
          type: p.OptionType.ALL,
          default: 400
        },
        fontStyle: {
          type: p.OptionType.STRING,
          default: "normal"
        },
        textMetrics: {
          type: p.OptionType.OBJECT,
          default: null
        },
        provider: {
          type: p.OptionType.STRING,
          available: ["google", "file"]
        },
        filePath: {
          type: p.OptionType.STRING
        },
        default: {
          type: p.OptionType.BOOLEAN,
          default: !1
        },
        font: {
          type: p.OptionType.OBJECT
        }
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(10),
          a = n.n(o),
          s = n(9),
          l = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          u = 2 * Math.PI,
          c = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t, this._serializeOperations = this._serializeOperations.bind(this);
        }

        return l(e, [{
          key: "serialize",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this._options = s.k.defaults(e, {
              image: !0
            });
            var t = {
              version: this.constructor.version
            };
            return this._serializeInputImage(t).then(this._serializeOperations);
          }
        }, {
          key: "_serializeInputImage",
          value: function value(e) {
            var t = this._editor.getImage(),
                n = t.width,
                i = t.height;

            if (!this._options.image) return e.inputImage = {
              width: n,
              height: i
            }, a.a.resolve(e);
            var r = s.k.createCanvas();
            r.width = t.width, r.height = t.height, r.getContext("2d").drawImage(t, 0, 0);
            var o = r.toDataURL(s.e.PNG);
            return e.inputImage = {
              type: s.e.PNG,
              data: o.replace(/^data:image\/(.*?);base64,/, ""),
              width: n,
              height: i
            }, a.a.resolve(e);
          }
        }, {
          key: "_serializeOperations",
          value: function value(e) {
            var t = this,
                n = [];
            return this._editor.operations.getStack().forEach(function (e) {
              var i = t._serializeOperation(e, n);

              i && n.push(i);
            }), e.operations = n.filter(function (e) {
              return e;
            }), a.a.resolve(e);
          }
        }, {
          key: "_serializeOperation",
          value: function value(e, t) {
            switch (e.constructor.identifier) {
              case "transform":
                return this._serializeTransformOperation(e);

              case "orientation":
                return this._serializeOrientationOperation(e);

              case "filter":
                return this._serializeFilterOperation(e);

              case "adjustments":
                return this._serializeAdjustmentsOperation(e);

              case "sprite":
                return this._serializeSpriteOperation(e, t);

              case "radial-focus":
                return this._serializeRadialFocusOperation(e);

              case "mirrored-focus":
                return this._serializeLinearFocusOperation(e);

              default:
                s.g.warn("Unable to serialize operation of type " + e.constructor.identifier);
            }
          }
        }, {
          key: "_serializeTransformOperation",
          value: function value(e) {
            var t = e.serializeOptions(["start", "end", "rotation"], !0);
            return t.rotation = (t.rotation + u) % u, {
              type: "crop",
              options: t
            };
          }
        }, {
          key: "_serializeOrientationOperation",
          value: function value(e) {
            return {
              type: "orientation",
              options: e.serializeOptions(["flipVertically", "flipHorizontally", "rotation"], !0)
            };
          }
        }, {
          key: "_serializeFilterOperation",
          value: function value(e) {
            return "identity" === e.getIdentifier() ? null : {
              type: "filter",
              options: {
                intensity: e.getIntensity(),
                name: e.getIdentifier()
              }
            };
          }
        }, {
          key: "_serializeAdjustmentsOperation",
          value: function value(e) {
            var t = e.availableOptions,
                n = {};
            return ["brightness", "saturation", "contrast", "exposure", "shadows", "highlights", "clarity"].forEach(function (i) {
              var r = t[i],
                  o = e.getOption(i),
                  a = r.minValue,
                  s = r.midValue,
                  l = r.maxValue;
              n[i] = o <= s ? (o - a) / (s - a) - 1 : (o - s) / (l - s);
            }), {
              type: "adjustments",
              options: n
            };
          }
        }, {
          key: "_serializeSpriteOperation",
          value: function value(e, t) {
            var n = this,
                i = t.filter(function (e) {
              return "sprite" === e.type;
            }),
                r = void 0,
                o = !0;
            if (i.length ? (r = i.pop(), o = !1) : r = {
              type: "sprite",
              options: {
                sprites: []
              }
            }, e.getSprites().forEach(function (t) {
              var i = null;
              t instanceof e.constructor.StickerSprite ? i = n._serializeSticker(e, t) : t instanceof e.constructor.TextSprite ? i = n._serializeText(e, t) : t instanceof e.constructor.BrushSprite ? i = n._serializeBrush(e, t) : t instanceof e.constructor.TextDesignSprite && (i = n._serializeTextDesign && n._serializeTextDesign(e, t)), i && r.options.sprites.push(i);
            }), o) return r;
          }
        }, {
          key: "_serializeSticker",
          value: function value(e, t) {
            var n = t.getAdjustments(),
                i = t.serializeOptions(["identifier", "position", "dimensions", "flipVertically", "flipHorizontally", "rotation"], !0);
            i.name = i.identifier, delete i.identifier, i.rotation = (i.rotation + u) % u;
            var r = n.availableOptions;
            return i.adjustments = {
              brightness: n.getBrightness() - r.brightness.default,
              saturation: n.getSaturation() - r.saturation.default,
              contrast: n.getContrast() - r.contrast.default
            }, {
              type: "sticker",
              options: i
            };
          }
        }, {
          key: "_serializeText",
          value: function value(e, t) {
            var n = t.serializeOptions(["fontSize", "lineHeight", "fontFamily", "fontWeight", "alignment", "color", "backgroundColor", "position", "rotation", "text", "maxWidth"], !0);
            return n.rotation = (n.rotation + u) % u, {
              type: "text",
              options: n
            };
          }
        }, {
          key: "_serializeBrush",
          value: function value(e, t) {
            var n = this;
            return {
              type: "brush",
              options: {
                paths: t.getPaths().map(function (e) {
                  return n._serializePath(e);
                })
              }
            };
          }
        }, {
          key: "_serializePath",
          value: function value(e) {
            var t = e.getBrush().serializeOptions(["color", "size"], !0);
            return t.points = e.getControlPoints().map(function (e) {
              return e.getPosition().toObject();
            }), t;
          }
        }, {
          key: "_serializeRadialFocusOperation",
          value: function value(e) {
            return {
              type: "focus",
              options: {
                type: "radial",
                options: e.serializeOptions(["position", "radius", "gradientRadius", "blurRadius"], !0)
              }
            };
          }
        }, {
          key: "_serializeLinearFocusOperation",
          value: function value(e) {
            return {
              type: "focus",
              options: {
                type: "linear",
                options: e.serializeOptions(["start", "end", "blurRadius", "size", "gradientSize"], !0)
              }
            };
          }
        }, {
          key: "_getInputDimensionsForOperation",
          value: function value(e) {
            var t = !1,
                n = this._editor.getInputDimensions();

            return this._editor.operations.getStack().forEach(function (i) {
              i === e && (t = !0), t || (n = i.getNewDimensions(n));
            }), n;
          }
        }]), e;
      }();

      t.a = c, c.version = "1.0.0";
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(80),
          f = n.n(p),
          h = n(10),
          d = n.n(h),
          g = n(9),
          m = n(202),
          y = n(134),
          _ = n(495),
          v = n(41),
          b = n(135),
          w = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function k(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var T = void 0;
      void 0 !== g.j.Operations.SpriteOperation && (T = g.j.Operations.SpriteOperation.BrushSprite);

      var S = function () {
        function e(t, n) {
          k(this, e), this._editor = t, this._ui = this._editor.getUI(), this._data = n, this._filterManager = new m.a(this._ui, this._getOptions("filter")), this._stickerManager = new y.a(this._ui, this._getOptions("sticker")), this._brushManager = new _.a(this._ui, this._getOptions("brush")), this._fontManager = new v.a(this._ui, this._getOptions("text"));
        }

        var t, n;
        return w(e, [{
          key: "_getOptions",
          value: function value(e) {
            var t = this._editor.controls,
                n = {};
            t && t.get(e) && (n = t.get(e).defaultOptions);

            var i = this._editor.getOptions();

            return g.k.deepDefaults({}, i.editor.controlsOptions[e] || {}, n);
          }
        }, {
          key: "deserialize",
          value: function value() {
            var e = this;
            return this._validateVersion().then(function () {
              return e._deserializeInputImage();
            }).then(function () {
              return e._deserializeOperations();
            });
          }
        }, {
          key: "_validateVersion",
          value: function value() {
            return this._data.version !== this.constructor.version ? d.a.reject(new Error("Invalid version " + this._data.version + ", expected " + this.constructor.version)) : d.a.resolve();
          }
        }, {
          key: "_deserializeInputImage",
          value: function value() {
            var e = this;
            return new d.a(function (t, n) {
              var i = e._data.inputImage,
                  r = i.data,
                  o = i.type;

              if (r && o) {
                var a = new window.Image();
                a.addEventListener("load", function () {
                  e._editor.setImage(a), t();
                }), a.src = "data:" + o + ";base64," + r;
              } else t();
            });
          }
        }, {
          key: "_deserializeOperations",
          value: (t = f.a.mark(function e() {
            var t, n, i, r, o;
            return f.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    t = this._data.operations, n = [], i = 0;

                  case 3:
                    if (!(i < t.length)) {
                      e.next = 12;
                      break;
                    }

                    return r = t[i], e.next = 7, this._deserializeOperation(r);

                  case 7:
                    o = e.sent, n.push(o);

                  case 9:
                    i++, e.next = 3;
                    break;

                  case 12:
                    return e.abrupt("return", n);

                  case 13:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }), n = function n() {
            var e = t.apply(this, arguments);
            return new d.a(function (t, n) {
              return function i(r, o) {
                try {
                  var a = e[r](o),
                      s = a.value;
                } catch (e) {
                  return void n(e);
                }

                if (!a.done) return d.a.resolve(s).then(function (e) {
                  i("next", e);
                }, function (e) {
                  i("throw", e);
                });
                t(s);
              }("next");
            });
          }, function () {
            return n.apply(this, arguments);
          })
        }, {
          key: "_deserializeOperation",
          value: function value(e) {
            switch (e.type) {
              case "crop":
                return this._deserializeCropOperation(e);

              case "orientation":
                return this._deserializeOrientationOperation(e);

              case "filter":
                return this._deserializeFilterOperation(e);

              case "adjustments":
                return this._deserializeAdjustmentsOperation(e);

              case "sprite":
                return this._deserializeSpriteOperation(e);

              case "focus":
                return this._deserializeFocusOperation(e);
            }
          }
        }, {
          key: "_deserializeCropOperation",
          value: function value(e) {
            var t = e.options,
                n = t.rotation,
                i = g.n.fromObject(t.start),
                r = g.n.fromObject(t.end);
            n > Math.PI && (n -= 2 * Math.PI);
            var o = {
              start: i,
              end: r
            };
            void 0 !== n && (o.rotation = n);

            var a = this._editor.operations.getOrCreate("transform");

            return this._editor.broadcastTransform(a, o), a.set(o), d.a.resolve(a);
          }
        }, {
          key: "_deserializeOrientationOperation",
          value: function value(e) {
            var t = e.options,
                n = this._editor.operations.getOrCreate("orientation");

            return n ? (n.set(t), d.a.resolve(n)) : d.a.resolve();
          }
        }, {
          key: "_deserializeFilterOperation",
          value: function value(e) {
            var t = this,
                n = e.options;
            return this._filterManager.getFilterByIdentifier(n.name) ? this._filterManager.instantiateFilterWithIdentifier(n.name).then(function (e) {
              var i = t._editor.operations.getOrCreate("filter");

              return i.set({
                identifier: n.name,
                filter: e,
                intensity: n.intensity
              }), i;
            }) : (g.g.warn("Deserializer", "Unknown filter `" + n.name + "`"), d.a.resolve());
          }
        }, {
          key: "_deserializeAdjustmentsOperation",
          value: function value(e) {
            var t = g.j.Operations.AdjustmentsOperation,
                n = e.options,
                i = {};
            return ["brightness", "saturation", "contrast", "exposure", "shadows", "highlights", "clarity"].forEach(function (e) {
              if (void 0 !== n[e]) {
                var r = t.prototype.availableOptions[e],
                    o = r.minValue,
                    a = r.midValue,
                    s = r.maxValue,
                    l = n[e];
                l = l < 0 ? a + (a - o) * l : a + (s - a) * l, i[e] = l;
              }
            }), d.a.resolve(this._editor.operations.getOrCreate("adjustments", i));
          }
        }, {
          key: "_deserializeSpriteOperation",
          value: function value(e) {
            var t = this,
                n = e.options,
                i = this._editor.operations.getOrCreate("sprite");

            if (!i) return d.a.resolve();
            var r = n.sprites.map(function (e) {
              return t._deserializeSprite(i, e);
            }).filter(function (e) {
              return e;
            });
            return d.a.all(r).then(function (e) {
              return i.setSprites(e.filter(function (e) {
                return e;
              })), i;
            });
          }
        }, {
          key: "_deserializeSprite",
          value: function value(e, t) {
            switch (t.type) {
              case "sticker":
                return this._deserializeSticker(e, t);

              case "text":
                return this._deserializeText(e, t);

              case "brush":
                return this._deserializeBrush(e, t);

              case "textdesign":
                return this._deserializeTextDesign && this._deserializeTextDesign(e, t);
            }
          }
        }, {
          key: "_deserializeSticker",
          value: function value(e, t) {
            var n = this,
                i = g.j.Operations.SpriteOperation,
                r = t.options,
                o = this._stickerManager.getStickerByIdentifier(r.name),
                a = this._stickerManager.getURLForSticker(o);

            return o ? new d.a(function (t, o) {
              var s = new window.Image();
              s.addEventListener("load", function () {
                var n = i.StickerSprite.prototype.availableOptions.adjustments.structure,
                    o = r.rotation,
                    a = r.flipHorizontally,
                    l = r.flipVertically,
                    u = {
                  identifier: r.name,
                  image: s,
                  position: g.n.fromObject(r.position),
                  dimensions: g.n.fromObject(r.dimensions),
                  rotation: o,
                  flipHorizontally: a,
                  flipVertically: l,
                  adjustments: {}
                };
                void 0 !== r.adjustments && ["brightness", "contrast", "saturation"].forEach(function (e) {
                  void 0 !== r.adjustments[e] && (u.adjustments[e] = r.adjustments[e] + n[e].default);
                }), t(e.createSticker(u));
              }), s.crossOrigin = n._editor.getCrossOrigin(), s.src = n._editor.getUI().getAssetPath(a);
            }) : (g.g.warn("Deserializer", "Unknown sticker '" + r.name + "'. Skipping sprite."), d.a.resolve());
          }
        }, {
          key: "_deserializeText",
          value: function value(e, t) {
            var n = t.options,
                i = n.fontSize,
                r = n.lineHeight,
                o = n.fontFamily,
                a = n.fontWeight,
                s = n.alignment,
                l = n.rotation,
                u = n.maxWidth,
                c = n.color,
                p = n.backgroundColor,
                f = new b.a(this._ui),
                h = this._fontManager.getFontByFontFamily(o);

            return h || (h = this._fontManager.getDefaultFont()), f.setFonts([h]), f.load().then(function () {
              var t = e.createText({
                fontSize: i,
                lineHeight: r,
                fontFamily: o,
                fontWeight: a,
                alignment: s,
                rotation: l,
                maxWidth: u,
                text: n.text,
                color: g.b.fromArray(c),
                backgroundColor: g.b.fromArray(p),
                position: g.n.fromObject(n.position)
              });
              return t._edited = !0, t;
            });
          }
        }, {
          key: "_deserializeBrush",
          value: function value(e, t) {
            var n = this,
                i = t.options.paths,
                r = e.createBrush();
            return i.forEach(function (e) {
              n._deserializeBrushPath(r, e);
            }), d.a.resolve(r);
          }
        }, {
          key: "_deserializeBrushPath",
          value: function value(e, t) {
            var n = t.points,
                i = this._createBrushForPath(t),
                r = e.createPath(i);

            r.setClosed(!0), n.forEach(function (e) {
              r.addControlPoint(g.n.fromObject(e));
            });
          }
        }, {
          key: "_createBrushForPath",
          value: function value(e) {
            var t = e.color,
                n = e.size,
                i = {
              color: g.b.fromArray(t),
              size: n
            },
                o = this._brushManager.getFirstBrush();

            if (o.prototype && o.prototype instanceof T) return new o(i);
            var s = g.k.extend({}, o);
            delete s.image;

            var l = function (e) {
              function t() {
                return k(this, t), x(this, (t.__proto__ || c()(t)).apply(this, arguments));
              }

              return function (e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = a()(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), t && (r.a ? r()(e, t) : e.__proto__ = t);
              }(t, e), t;
            }(T);

            return l.identifier = o.identifier, new l(g.k.extend({}, s, i));
          }
        }, {
          key: "_deserializeFocusOperation",
          value: function value(e) {
            var t = e.options.options;

            switch (e.options.type) {
              case "radial":
                var n = t.position,
                    i = t.radius,
                    r = t.gradientRadius,
                    o = t.blurRadius;
                return d.a.resolve(this._editor.operations.getOrCreate("radial-focus", {
                  position: g.n.fromObject(n),
                  radius: i,
                  gradientRadius: r,
                  blurRadius: o
                }));

              case "linear":
                var a = t.start,
                    s = t.end,
                    l = t.size,
                    u = t.gradientSize,
                    c = t.blurRadius;
                return d.a.resolve(this._editor.operations.getOrCreate("mirrored-focus", {
                  start: g.n.fromObject(a),
                  end: g.n.fromObject(s),
                  size: l,
                  gradientSize: u,
                  blurRadius: c
                }));
            }
          }
        }, {
          key: "_getInputDimensionsForOperation",
          value: function value(e) {
            var t = !1,
                n = this._editor.getInputDimensions();

            return this._editor.operations.getStack().forEach(function (i) {
              i === e && (t = !0), t || (n = i.getNewDimensions(n));
            }), n;
          }
        }]), e;
      }();

      t.a = S, S.version = "1.0.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(10),
          a = n.n(o),
          s = n(9),
          l = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function u(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var c = function () {
        function e(t, n) {
          var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          u(this, e), this._ui = t, this._options = n, this._categoriesById = {}, this._filtersByIdentifier = {
            identity: s.j.Operations.FilterOperation.Filters.IdentityFilter
          }, this._categories = s.m.wrapFiltersInCategories(s.l.DEFAULTS.FILTERS.slice(0), e.CATEGORY_ITEMS_PROPERTY), this._customAssetsAllowed = i || t.getEditor().getSDK()._l.areCustomAssetsAllowed(), this._customAssetsAllowed && this._options.categories && (this._options.categories = s.m.wrapFiltersInCategories(this._options.categories, e.CATEGORY_ITEMS_PROPERTY)), this._initCategories();
        }

        return l(e, [{
          key: "instantiateFilterWithIdentifier",
          value: function value(e) {
            var t = this,
                n = {
              value: this._ui._options.crossOrigin,
              cors: !0
            },
                i = this.getFilterByIdentifier(e);
            if (!i) return a.a.reject(new Error("Unknown filter with identifier `" + e + "`!"));
            if (i.prototype instanceof s.j.Operations.FilterOperation.Filter) return a.a.resolve(new i());
            var r = i.lutImage,
                o = i.resolution,
                l = i.horizontalTileCount,
                u = i.verticalTileCount,
                c = i.lightColor,
                p = i.darkColor;
            if (c && p) return c = s.b.fromHex(c), p = s.b.fromHex(p), a.a.resolve(new s.j.Operations.FilterOperation.Filters.DuoToneFilter({
              lightColor: c,
              darkColor: p
            }));
            var f = void 0;
            return this._ui.getPreloader && (f = this._ui.getPreloader().getAsset(r)), (f ? a.a.resolve(f) : s.f.loadImage(this._ui.getAssetPath(r), n)).then(function () {
              return s.f.loadImage(t._ui.getAssetPath(r), n).then(function (e) {
                return new s.j.Operations.FilterOperation.Filters.ThreeDLUTFilter({
                  image: e,
                  resolution: o,
                  horizontalTileCount: l,
                  verticalTileCount: u
                });
              });
            });
          }
        }, {
          key: "_initCategories",
          value: function value() {
            var t = this;

            if (this._customAssetsAllowed && this._options.categories && (this._options.replaceCategories ? this._categories = s.m.wrapFiltersInCategories(this._options.categories, e.CATEGORY_ITEMS_PROPERTY) : this._categories = s.m.mergeCategories(this._categories, this._options.categories, e.CATEGORY_ITEMS_PROPERTY)), this._customAssetsAllowed && this._options.availableFilters) {
              var n = [];
              this._categories.forEach(function (e) {
                var i = e.filters.filter(function (e) {
                  return -1 !== t._options.availableFilters.indexOf(e.identifier);
                });
                i.length > 0 && n.push({
                  identifier: e.identifier,
                  defaultName: e.defaultName,
                  filters: i
                });
              }), this._categories = n;
            }

            var i = {
              identifier: "all",
              defaultName: "All",
              visible: !1,
              filters: this._categories.length <= 0 ? [] : this._categories.map(function (e) {
                return e.filters;
              }).reduce(function (e, t) {
                return e.concat(t);
              })
            };
            this._categories.unshift(i), this._categoriesById.all = i, this._categories.forEach(function (e) {
              t._categoriesById[e.identifier] = e;
            }), i.filters.forEach(function (e) {
              t._filtersByIdentifier[e.identifier] = e;
            });
          }
        }, {
          key: "getFiltersForCategory",
          value: function value(e) {
            if (!this._categoriesById[e]) throw new Error("Unknown filter category '" + e + "'");
            return this._categoriesById[e].filters;
          }
        }, {
          key: "getItemsByCategory",
          value: function value(e) {
            return this.getFiltersForCategory(e);
          }
        }, {
          key: "getFilterByIdentifier",
          value: function value(e) {
            return this._filtersByIdentifier[e];
          }
        }, {
          key: "getCategories",
          value: function value() {
            return this._categories;
          }
        }, {
          key: "getCategoryByIdentifier",
          value: function value(e) {
            return this._categoriesById[e];
          }
        }]), e;
      }();

      c.CATEGORY_ITEMS_PROPERTY = "filters", t.a = c;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(10),
          a = n.n(o),
          s = n(497),
          l = n(31),
          u = (n.n(l), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          c = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._ui = t, this._fonts = [], this._observers = [];
        }

        return u(e, [{
          key: "add",
          value: function value(e) {
            this._fonts.push(e);
          }
        }, {
          key: "load",
          value: function value() {
            var e = this;
            return 0 === this._fonts.length ? a.a.resolve() : (this._observers = [], this._fonts.forEach(function (t) {
              e._observers.push(new s.a(t));
            }), l.Utils.executePromises(this._observers.map(function (e) {
              return e.observe();
            })));
          }
        }, {
          key: "dispose",
          value: function value() {
            this._observers.forEach(function (e) {
              return e.dispose();
            });
          }
        }]), e;
      }();

      t.a = c;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(200),
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = 2 * Math.PI,
          m = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_serializeTransformOperation",
          value: function value(e) {
            var t = e.serializeOptions(["start", "end", "rotation", "textureScale"], !0);
            return t.rotation = (t.rotation + g) % g, 1 !== t.textureScale && (t.dimensions = e.getNewDimensions(e.getInputDimensions(!1))), delete t.textureScale, {
              type: "crop",
              options: t
            };
          }
        }]), t;
      }(p.a);

      t.a = m, m.version = "1.0.1";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(10),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(9),
          m = n(201),
          y = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = function (e) {
        function t() {
          return _(this, t), v(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), y(t, [{
          key: "_deserializeOperation",
          value: function value(e) {
            return "selective-blur" === e.type ? this._deserializeSelectiveBlurOperation(e) : function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = d()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || d()(t.prototype), "_deserializeOperation", this).call(this, e);
          }
        }, {
          key: "_deserializeCropOperation",
          value: function value(e) {
            var t = e.options,
                n = t.rotation,
                i = g.n.fromObject(t.start),
                r = g.n.fromObject(t.end),
                o = t.dimensions ? g.n.fromObject(t.dimensions) : null;
            if (r.x - i.x <= 0 || r.y - i.y <= 0) throw new Error("A crop should not result in negative or zero dimensions - start: " + i + " - end: " + r);
            n > Math.PI && (n -= 2 * Math.PI);
            var a = {
              start: i,
              end: r
            };
            void 0 !== n && (a.rotation = n);

            var s = this._editor.operations.getOrCreate("transform");

            if (!s) return f.a.resolve();

            if (this._editor.broadcastTransform(s, a), s.set(a), o) {
              var l = r.clone().subtract(i),
                  u = s.getInputDimensions(!1).multiply(l);
              s.setTextureScale(o.x / u.x);
            }

            return f.a.resolve(s);
          }
        }]), t;
      }(m.a);

      t.a = b, b.version = "1.0.1";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(204),
          d = n(93),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          m = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = function (e) {
        function t() {
          return y(this, t), _(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_serializeSticker",
          value: function value(e, n) {
            var i = e.getInputDimensions(!1),
                r = m(t.prototype.__proto__ || f()(t.prototype), "_serializeSticker", this).call(this, e, n);
            return "none" !== n.getTintMode() && (r.options.tintColor = n.serializeOption("tintColor", !0)), r.options.dimensions = n.getDimensions().clone().divide(i.min()).toObject(), r.options.identifier = r.options.name, delete r.options.name, r;
          }
        }, {
          key: "_serializePath",
          value: function value(e) {
            var n = m(t.prototype.__proto__ || f()(t.prototype), "_serializePath", this).call(this, e),
                i = e.getBrush();
            return i.hasOption("hardness") && (n.hardness = i.getOption("hardness")), n;
          }
        }, {
          key: "_serializeOperation",
          value: function value(e, n) {
            return "frame" === e.constructor.identifier ? (this._serializeFrameOperation(e, n), null) : "overlay" === e.constructor.identifier ? (this._serializeOverlayOperation(e, n), null) : m(t.prototype.__proto__ || f()(t.prototype), "_serializeOperation", this).call(this, e, n);
          }
        }, {
          key: "_serializeFrameOperation",
          value: function value(e, t) {
            var n = t.filter(function (e) {
              return "sprite" === e.type;
            }),
                i = void 0;
            n.length ? i = n.pop() : (i = {
              type: "sprite",
              options: {
                sprites: []
              }
            }, t.push(i)), i.options.sprites.push({
              type: "frame",
              options: this._getFrameOptions(e)
            });
          }
        }, {
          key: "_serializeOverlayOperation",
          value: function value(e, t) {
            if (e.getIdentifier()) {
              var n = t.filter(function (e) {
                return "sprite" === e.type;
              }),
                  i = void 0;
              n.length ? i = n.pop() : (i = {
                type: "sprite",
                options: {
                  sprites: []
                }
              }, t.push(i)), i.options.sprites.push({
                type: "overlay",
                options: {
                  identifier: e.getIdentifier(),
                  intensity: e.getAlpha(),
                  blendMode: d.a[e.getBlendMode()]
                }
              });
            }
          }
        }, {
          key: "_getFrameOptions",
          value: function value(e) {
            return {
              identifier: e.getFrame().identifier
            };
          }
        }, {
          key: "_serializeOrientationOperation",
          value: function value(e) {
            var n = m(t.prototype.__proto__ || f()(t.prototype), "_serializeOrientationOperation", this).call(this, e);
            return 90 !== n.options.rotation && 270 !== n.options.rotation || (n.options.flipHorizontally = !n.options.flipHorizontally, n.options.flipVertically = !n.options.flipVertically), n;
          }
        }, {
          key: "_serializeTransformOperation",
          value: function value(e) {
            var n = this._editor.operations;

            if (n.exists("orientation")) {
              e = e.clone();
              var i = n.get("orientation");
              e.rotate(-i.getRotation()), i.getFlipVertically() && (e.flip("vertical"), e.setRotation(-1 * e.getRotation())), i.getFlipHorizontally() && (e.flip("horizontal"), e.setRotation(-1 * e.getRotation()));
            }

            var r = m(t.prototype.__proto__ || f()(t.prototype), "_serializeTransformOperation", this).call(this, e);
            return r.type = "transform", r;
          }
        }, {
          key: "_serializeText",
          value: function value(e, n) {
            var i = m(t.prototype.__proto__ || f()(t.prototype), "_serializeText", this).call(this, e, n),
                r = e.getInputDimensions(!1);
            return i.options.fontIdentifier = n.getFontIdentifier(), i.options.maxWidth = i.options.maxWidth * r.x / r.min(), delete i.options.fontFamily, i;
          }
        }, {
          key: "_serializeFilterOperation",
          value: function value(e) {
            var n = m(t.prototype.__proto__ || f()(t.prototype), "_serializeFilterOperation", this).call(this, e);
            return n ? (n.options.identifier = n.options.name, delete n.options.name, n) : null;
          }
        }, {
          key: "_serializeRadialFocusOperation",
          value: function value(e) {
            var n = m(t.prototype.__proto__ || f()(t.prototype), "_serializeRadialFocusOperation", this).call(this, e),
                i = n.options.options;
            return i.start = i.position, delete i.position, i.end = {
              x: i.start.x + i.radius,
              y: i.start.y
            }, delete i.radius, n;
          }
        }]), t;
      }(h.a);

      t.a = v, v.version = "2.0.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(10),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(9),
          m = n(205),
          y = n(502),
          _ = n(503),
          v = n(134),
          b = n(504),
          w = n(135),
          x = n(73),
          k = n(93),
          T = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          S = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function C(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function E(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var O = g.k.flipObject(k.a),
          R = function (e) {
        function t() {
          var e;
          C(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = E(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          o._frameManager = new y.a(o._ui, o._getOptions("frame"));

          var a = o._getOptions("overlay");

          return a && (o._overlayManager = new _.a(o._ui, a)), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), T(t, [{
          key: "_deserializeSprite",
          value: function value(e, n) {
            return "frame" === n.type ? this._deserializeFrame(e, n) : "overlay" === n.type ? this._deserializeOverlay(e, n) : S(t.prototype.__proto__ || d()(t.prototype), "_deserializeSprite", this).call(this, e, n);
          }
        }, {
          key: "_deserializeOperation",
          value: function value(e) {
            return "transform" === e.type ? this._deserializeTransformOperation(e) : S(t.prototype.__proto__ || d()(t.prototype), "_deserializeOperation", this).call(this, e);
          }
        }, {
          key: "_deserializeOrientationOperation",
          value: function value(e) {
            if (this._data.meta && "html5" !== this._data.meta.platform) return S(t.prototype.__proto__ || d()(t.prototype), "_deserializeOrientationOperation", this).call(this, e);
            var n = e.options,
                i = n.rotation,
                r = n.flipHorizontally,
                o = n.flipVertically,
                a = 90 === i && !r && !o;
            return a |= 90 === i && r && o, a |= 270 === i && !r && !o, (a |= 270 === i && r && o) && (e.options.flipHorizontally = !e.options.flipHorizontally, e.options.flipVertically = !e.options.flipVertically), S(t.prototype.__proto__ || d()(t.prototype), "_deserializeOrientationOperation", this).call(this, e);
          }
        }, {
          key: "_deserializeTransformOperation",
          value: function value(e) {
            var n = this;
            return S(t.prototype.__proto__ || d()(t.prototype), "_deserializeCropOperation", this).call(this, e).then(function (e) {
              if (e) {
                var t = g.k.Array.find(n._data.operations, function (e) {
                  return "orientation" === e.type;
                });

                if (t) {
                  var i = t.options,
                      r = i.rotation,
                      o = i.flipHorizontally,
                      a = i.flipVertically;
                  90 !== r && 270 !== r || (!o && a || o && !a) && (o = !o, a = !a), e.rotate(i.rotation), o && (e.flip("horizontal"), e.setRotation(-1 * e.getRotation())), a && (e.flip("vertical"), e.setRotation(-1 * e.getRotation()));
                }

                return e;
              }
            });
          }
        }, {
          key: "_deserializeFrame",
          value: function value(e, t) {
            var n = this,
                i = t.options.identifier,
                r = this._frameManager.getFrameByIdentifier(i);

            if (!r) return g.g.warn("Deserializer", "Unknown frame `" + i + "`. Skipping frame."), f.a.resolve();
            var o = new b.a(this._ui, r);
            return o.load().then(function () {
              n._editor.operations.getOrCreate("frame", {
                frame: o.getFrame()
              });
            });
          }
        }, {
          key: "_deserializeOverlay",
          value: function value(e, t) {
            var n = this,
                i = t.options,
                r = i.blendMode,
                o = i.intensity,
                a = i.identifier,
                s = this._overlayManager.getOverlayByIdentifier(a);

            if (!s) return g.g.warn("Deserializer", "Unknown overlay `" + a + "`. Skipping overlay."), f.a.resolve();

            var l = this._editor.getUI().getAssetPath(s.image);

            return x.a.load(l).then(function (e) {
              n._editor.operations.getOrCreate("overlay", {
                alpha: o,
                identifier: a,
                blendMode: parseInt(O[r || s.blendMode], 10),
                image: e
              });
            });
          }
        }, {
          key: "_createBrushForPath",
          value: function value(e) {
            var n = S(t.prototype.__proto__ || d()(t.prototype), "_createBrushForPath", this).call(this, e);
            return void 0 !== e.hardness && n.hasOption("hardness") && n.setHardness(e.hardness), n;
          }
        }, {
          key: "_deserializeSticker",
          value: function value(e, t) {
            var n = this,
                i = g.j.Operations.SpriteOperation,
                r = t.options,
                o = this._stickerManager.getStickerByIdentifier(r.identifier),
                a = v.a.getURLForSticker(o, "base");

            if (!o) return g.g.warn("Deserializer", "Unknown sticker `" + r.identifier + "`. Skipping sprite."), f.a.resolve();
            var s = e.getInputDimensions(!1);
            return new f.a(function (t, l) {
              var u = new window.Image();
              u.addEventListener("load", function () {
                var n = i.StickerSprite.prototype.availableOptions.adjustments.structure,
                    a = r.rotation,
                    l = r.flipHorizontally,
                    c = r.flipVertically,
                    p = {
                  identifier: r.identifier,
                  image: u,
                  position: g.n.fromObject(r.position),
                  dimensions: g.n.fromObject(r.dimensions).multiply(s.min()),
                  rotation: a,
                  flipHorizontally: l,
                  flipVertically: c,
                  adjustments: {}
                };
                void 0 !== r.adjustments && ["brightness", "contrast", "saturation"].forEach(function (e) {
                  void 0 !== r.adjustments[e] && (p.adjustments[e] = r.adjustments[e] + n[e].default);
                }), void 0 !== r.tintColor && void 0 !== o.tintMode && (p.tintColor = g.b.fromArray(r.tintColor), p.tintMode = o.tintMode), t(e.createSticker(p));
              }), u.crossOrigin = n._editor.getCrossOrigin(), u.src = n._editor.getUI().getAssetPath(a);
            });
          }
        }, {
          key: "_deserializeFilterOperation",
          value: function value(e) {
            var t = this,
                n = e.options;
            return this._filterManager.getFilterByIdentifier(n.identifier) ? this._filterManager.instantiateFilterWithIdentifier(n.identifier).then(function (e) {
              var i = t._editor.operations.getOrCreate("filter");

              if (i) return i.set({
                identifier: n.identifier,
                filter: e,
                intensity: n.intensity
              }), i;
            }) : (g.g.warn("Deserializer", "Unknown filter `" + n.identifier + "`"), f.a.resolve());
          }
        }, {
          key: "_deserializeFocusOperation",
          value: function value(e) {
            var n = e.options,
                i = n.options;
            if ("radial" !== n.type) return S(t.prototype.__proto__ || d()(t.prototype), "_deserializeFocusOperation", this).call(this, e);

            var r = this._editor.getImage(),
                o = r.width / r.height,
                a = i.start,
                s = i.end,
                l = i.gradientRadius,
                u = i.blurRadius,
                c = g.n.fromObject(s).subtract(g.n.fromObject(a)).multiply(o, 1).len();

            return f.a.resolve(this._editor.operations.getOrCreate("radial-focus", {
              position: g.n.fromObject(a),
              radius: c,
              gradientRadius: l,
              blurRadius: u
            }));
          }
        }, {
          key: "_deserializeText",
          value: function value(e, t) {
            var n = t.options,
                i = n.fontSize,
                r = n.lineHeight,
                o = n.fontIdentifier,
                a = n.alignment,
                s = n.rotation,
                l = n.maxWidth,
                u = n.color,
                c = n.backgroundColor,
                p = new w.a(this._ui),
                f = this._fontManager.getVariationByIdentifier(o);

            return f ? p.setFonts([f.getFont()]) : f = this._fontManager.getDefaultFont(), p.load().then(function () {
              var t = e.getInputDimensions(!1),
                  o = l * t.min() / t.x,
                  p = e.createText({
                fontSize: i,
                lineHeight: r,
                fontFamily: f.getFontFamily(),
                fontWeight: f.getFontWeight(),
                fontIdentifier: f.getIdentifier(),
                alignment: a,
                rotation: s,
                maxWidth: o,
                text: n.text,
                color: g.b.fromArray(u),
                backgroundColor: g.b.fromArray(c),
                position: g.n.fromObject(n.position)
              });
              return p._edited = !0, p;
            });
          }
        }]), t;
      }(m.a);

      t.a = R, R.version = "2.0.0";
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(9),
          m = n(206),
          y = n(209),
          _ = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          b = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function w(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var k = function (e) {
        function t() {
          return w(this, t), x(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "serialize",
          value: function value() {
            var e = this,
                n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return b(t.prototype.__proto__ || d()(t.prototype), "serialize", this).call(this, n).then(function (t) {
              return t.meta = {
                platform: "html5",
                version: e._editor.getSDK().version,
                createdAt: g.k.ISODateString(new Date())
              }, t.image = t.inputImage, delete t.inputImage, t;
            });
          }
        }, {
          key: "_serializeSticker",
          value: function value(e, n) {
            var i = b(t.prototype.__proto__ || d()(t.prototype), "_serializeSticker", this).call(this, e, n);
            return i.options.alpha = n.getAlpha(), i.options.tintColor && (i.options.tintColor = {
              rgba: i.options.tintColor
            }), i;
          }
        }, {
          key: "_serializeText",
          value: function value(e, n) {
            var i = b(t.prototype.__proto__ || d()(t.prototype), "_serializeText", this).call(this, e, n);
            return i.options.color = {
              rgba: i.options.color
            }, i.options.backgroundColor = {
              rgba: i.options.backgroundColor
            }, i.options.flipHorizontally = !1, i.options.flipVertically = !1, delete i.options.fontWeight, i;
          }
        }, {
          key: "_serializePath",
          value: function value(e) {
            var n = b(t.prototype.__proto__ || d()(t.prototype), "_serializePath", this).call(this, e);
            delete n.hardness, delete n.size, delete n.color;
            var i = e.getBrush();
            n.brush = i.serializeOptions(["identifier", "size", "color"], !0), void 0 === n.brush.identifier && delete n.brush.identifier, n.brush.color = {
              rgba: n.brush.color
            };
            var r = i.getOption("hardness");
            return "undefined" !== r && (n.brush.hardness = r), n;
          }
        }, {
          key: "_serializeFrameOperation",
          value: function value(e, n) {
            b(t.prototype.__proto__ || d()(t.prototype), "_serializeFrameOperation", this).call(this, e, n);
            var i = n.filter(function (e) {
              return "sprite" === e.type;
            });

            if (i.length) {
              var r = i.pop().options.sprites.filter(function (e) {
                return "frame" === e.type;
              })[0];
              e.getTintColor().equals(new g.b(1, 1, 1, 0)) || (r.options.tintColor = {
                rgba: e.serializeOption("tintColor", !0)
              });
              var o = e.serializeOptions(["scale", "alpha"], !0);
              r.options = g.k.extend(r.options, o), r.options.size = r.options.scale, delete r.options.scale;
            }
          }
        }, {
          key: "_serializeTransformOperation",
          value: function value(e) {
            var n = b(t.prototype.__proto__ || d()(t.prototype), "_serializeTransformOperation", this).call(this, e);

            if (e._ratio) {
              var i = void 0;
              i = e._ratio instanceof y.a ? e._ratio.getIdentifier() : e._ratio.identifier, n.options.meta = {
                identifier: i
              };
            }

            return delete n.options.scale, n;
          }
        }, {
          key: "_serializeAdjustmentsOperation",
          value: function value(e) {
            var n = b(t.prototype.__proto__ || d()(t.prototype), "_serializeAdjustmentsOperation", this).call(this, e),
                i = e.availableOptions,
                r = {};
            return ["gamma", "whites", "blacks", "temperature"].forEach(function (t) {
              var n = i[t],
                  o = e.getOption(t),
                  a = n.minValue,
                  s = n.midValue,
                  l = n.maxValue;
              r[t] = o <= s ? (o - a) / (s - a) - 1 : (o - s) / (l - s);
            }), n.options = _({}, n.options, r), n;
          }
        }, {
          key: "_serializeOperation",
          value: function value(e, n) {
            switch (e.constructor.identifier) {
              case "mirrored-focus":
                return this._serializeMirroredFocusOperation(e);

              case "linear-focus":
                return this._serializeLinearFocusOperation(e);

              case "blur":
                return this._serializeBlurOperation(e);

              default:
                return b(t.prototype.__proto__ || d()(t.prototype), "_serializeOperation", this).call(this, e, n);
            }
          }
        }, {
          key: "_serializeMirroredFocusOperation",
          value: function value(e) {
            return {
              type: "focus",
              options: {
                type: "mirrored",
                options: e.serializeOptions(["start", "end", "blurRadius", "size", "gradientSize"], !0)
              }
            };
          }
        }, {
          key: "_serializeLinearFocusOperation",
          value: function value(e) {
            var t = e.serializeOptions(["controlPoint1", "controlPoint2", "blurRadius"], !0);
            return t.start = t.controlPoint1, delete t.controlPoint1, t.end = t.controlPoint2, delete t.controlPoint2, {
              type: "focus",
              options: {
                type: "linear",
                options: t
              }
            };
          }
        }, {
          key: "_serializeBlurOperation",
          value: function value(e) {
            return {
              type: "focus",
              options: {
                type: "gaussian",
                options: e.serializeOptions(["blurRadius"], !0)
              }
            };
          }
        }]), t;
      }(m.a);

      t.a = k, k.version = "3.0.0";
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(31);

      function c(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function p(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      n.n(u);

      var f = function (e) {
        function t() {
          return c(this, t), p(this, (t.__proto__ || l()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.Configurable);

      t.a = f, f.prototype.availableOptions = {
        identifier: {
          type: u.OptionType.STRING,
          required: !0
        },
        defaultName: {
          type: u.OptionType.STRING,
          required: !0
        },
        ratio: {
          type: u.OptionType.ALL,
          required: !1,
          default: null
        },
        selected: {
          type: u.OptionType.BOOLEAN,
          required: !1
        },
        dimensions: {
          type: u.OptionType.VECTOR2,
          required: !1
        },
        lockDimensions: {
          type: u.OptionType.BOOLEAN,
          required: !1,
          default: null
        },
        forceDimensions: {
          type: u.OptionType.BOOLEAN,
          required: !1,
          default: null
        }
      };
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(10),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(9),
          _ = n(207),
          v = n(134),
          b = n(55),
          w = n(73),
          x = n(41),
          k = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          T = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          S = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = m()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function C(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function E(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function O(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = f()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (c.a ? c()(e, t) : e.__proto__ = t);
      }

      var R = void 0;
      void 0 !== y.j.Operations.SpriteOperation && (R = y.j.Operations.SpriteOperation.BrushSprite.Brush);

      var I = function (e) {
        function t() {
          return C(this, t), E(this, (t.__proto__ || m()(t)).apply(this, arguments));
        }

        return O(t, e), T(t, [{
          key: "_deserializeSticker",
          value: function value(e, t) {
            var n = y.j.Operations.SpriteOperation,
                i = t.options,
                r = this._stickerManager.getStickerByIdentifier(i.identifier);

            if (!r) return y.g.warn("Deserializer", "Unknown sticker `" + i.identifier + "`. Skipping sprite."), d.a.resolve();
            var o = r.images.mediaBase,
                a = v.a.getURLForSticker(r, "base"),
                s = o.rawData ? o.uris[0] : this._editor.getUI().getAssetPath(a),
                l = e.getInputDimensions(!1);
            return w.a.load(s).then(function (t) {
              var o = n.StickerSprite.prototype.availableOptions.adjustments.structure,
                  a = i.rotation,
                  s = i.flipHorizontally,
                  u = i.flipVertically,
                  c = {
                identifier: i.identifier,
                image: t,
                position: y.n.fromObject(i.position),
                dimensions: y.n.fromObject(i.dimensions).multiply(l.min()),
                rotation: a || 0,
                flipHorizontally: s,
                flipVertically: u,
                resizeMode: r.resizeMode || "keepAspect",
                adjustments: {}
              };
              return void 0 !== i.adjustments && ["brightness", "contrast", "saturation"].forEach(function (e) {
                void 0 !== i.adjustments[e] && (c.adjustments[e] = i.adjustments[e] + o[e].default);
              }), void 0 !== i.tintMode && void 0 !== i.tintColor ? (c.tintColor = y.b.fromArray(i.tintColor.rgba), c.tintMode = i.tintMode) : void 0 !== i.tintColor && void 0 !== r.tintMode && (c.tintColor = y.b.fromArray(i.tintColor.rgba), c.tintMode = r.tintMode), void 0 !== i.alpha && (c.alpha = i.alpha), e.createSticker(c);
            });
          }
        }, {
          key: "_deserializeTransformOperation",
          value: function value(e) {
            return S(t.prototype.__proto__ || m()(t.prototype), "_deserializeTransformOperation", this).call(this, e).then(function (e) {
              if (e) return e._ratio = null, e;
            });
          }
        }, {
          key: "_deserializeInputImage",
          value: function value() {
            var e = this,
                t = this._data.image,
                n = t.data,
                i = t.type,
                r = t.uri;
            return n && i && (r = "data:" + i + ";base64," + n), r ? w.a.load(r).then(function (t) {
              e._editor.setImage(t);
            }) : d.a.resolve();
          }
        }, {
          key: "_deserializeAdjustmentsOperation",
          value: function value(e) {
            var n = y.j.Operations.AdjustmentsOperation;
            return S(t.prototype.__proto__ || m()(t.prototype), "_deserializeAdjustmentsOperation", this).call(this, e).then(function (t) {
              if (!t) return null;
              var i = e.options,
                  r = {};
              return ["gamma", "whites", "blacks", "temperature"].forEach(function (e) {
                if (void 0 !== i[e]) {
                  var t = n.prototype.availableOptions[e],
                      o = t.minValue,
                      a = t.midValue,
                      s = t.maxValue,
                      l = i[e];
                  l = l < 0 ? a + (a - o) * l : a + (s - a) * l, r[e] = l;
                }
              }), t.set(r), t;
            });
          }
        }, {
          key: "_deserializeFocusOperation",
          value: function value(e) {
            var n = e.options.options;

            switch (e.options.type) {
              case "radial":
                return S(t.prototype.__proto__ || m()(t.prototype), "_deserializeFocusOperation", this).call(this, e);

              case "linear":
                var i = n.start,
                    r = n.end,
                    o = n.blurRadius;
                return d.a.resolve(this._editor.operations.getOrCreate("linear-focus", {
                  controlPoint1: y.n.fromObject(i),
                  controlPoint2: y.n.fromObject(r),
                  blurRadius: o
                }));

              case "mirrored":
                var a = n.start,
                    s = n.end,
                    l = n.size,
                    u = n.gradientSize,
                    c = n.blurRadius;
                return d.a.resolve(this._editor.operations.getOrCreate("mirrored-focus", {
                  start: y.n.fromObject(a),
                  end: y.n.fromObject(s),
                  size: l,
                  gradientSize: u,
                  blurRadius: c
                }));

              case "gaussian":
                var p = n.blurRadius;
                return d.a.resolve(this._editor.operations.getOrCreate("blur", {
                  blurRadius: p
                }));
            }
          }
        }, {
          key: "_deserializeText",
          value: function value(e, t) {
            var n = t.options,
                i = n.fontSize,
                r = n.lineHeight,
                o = n.fontIdentifier,
                a = n.alignment,
                s = n.rotation,
                l = n.maxWidth,
                u = n.color,
                c = n.backgroundColor,
                p = this._ui.getFontLoader(),
                f = this._fontManager.getVariationByIdentifier(o);

            return f ? p.setFonts([f.getFont()]) : f = this._fontManager.getDefaultVariation(), p.load().then(function () {
              var t = e.getInputDimensions(!1),
                  o = l * t.min() / t.x,
                  p = e.createText({
                fontSize: i,
                lineHeight: r,
                fontFamily: f.getFontFamily(),
                fontWeight: f.getFontWeight(),
                fontIdentifier: f.getIdentifier(),
                textMetrics: f.getTextMetrics(),
                alignment: a,
                rotation: s,
                maxWidth: o,
                text: n.text,
                color: y.b.fromArray(u.rgba),
                backgroundColor: y.b.fromArray(c.rgba),
                position: y.n.fromObject(n.position)
              });
              return p._edited = !0, p;
            });
          }
        }, {
          key: "_createBrushForPath",
          value: function value(e) {
            var t = e.brush,
                n = t.identifier,
                i = t.color,
                r = t.size,
                o = t.hardness,
                a = {
              color: y.b.fromArray(i.rgba),
              size: r
            };
            void 0 !== o && (a.hardness = o);

            var s = this._brushManager.getBrushByIdentifier(n);

            if (s || (s = this._brushManager.getFirstBrush()), s.prototype && s.prototype instanceof R) return new s(a);
            var l = y.k.extend({}, s);
            delete l.image;

            var u = function (e) {
              function t() {
                return C(this, t), E(this, (t.__proto__ || m()(t)).apply(this, arguments));
              }

              return O(t, e), t;
            }(R);

            return u.identifier = s.identifier, new u(y.k.extend({}, l, a));
          }
        }, {
          key: "_deserializeFrame",
          value: function value(e, n) {
            var i = this;
            return S(t.prototype.__proto__ || m()(t.prototype), "_deserializeFrame", this).call(this, e, n).then(function () {
              var e = i._editor.operations.get("frame"),
                  t = n.options,
                  r = t.size,
                  o = t.alpha,
                  a = t.tintColor,
                  s = {};

              void 0 !== r && (s.scale = r), void 0 !== o && (s.alpha = o), void 0 !== a && (s.tintColor = y.b.fromArray(a.rgba)), e.set(s);
            });
          }
        }, {
          key: "_deserializeTextDesign",
          value: function value(e, t) {
            var n = this,
                i = t.options,
                r = i.position,
                o = i.rotation,
                a = i.flipHorizontally,
                s = i.flipVertically,
                l = i.text,
                u = i.color,
                c = i.width,
                p = i.seed,
                f = i.inverted,
                h = i.identifier;
            h === y.j.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignBlocksLight.identifier ? h = y.j.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignBlocksLightV310.identifier : h === y.j.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignSunshine.identifier && (h = y.j.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignSunshineV310.identifier);

            var d = new b.a(this._ui, this._getOptions("textdesign")),
                g = new x.a(this._ui, {
              fonts: y.c.DEFAULTS.TEXT_DESIGN_FONTS,
              replaceFonts: !0
            }),
                m = e.constructor.TextDesignSprite.AssetManager,
                _ = this._ui.getFontLoader(),
                v = new (d.getLayoutByIdentifier(h))();

            return _.setFonts(g.getFonts()), m.setFonts(k({}, m.getFonts(), g.getVariationsByIdentifier())), _.load().then(function () {
              var t = v.getImagePaths().map(function (e) {
                return {
                  path: e,
                  fullPath: n._ui.getAssetPath(e),
                  image: null
                };
              });
              return m.loadImages(t).then(function () {
                return v.onImagesLoaded(), e.createTextDesign({
                  position: r,
                  rotation: o,
                  flipHorizontally: a,
                  flipVertically: s,
                  text: l,
                  color: y.b.fromArray(u.rgba),
                  width: c,
                  seed: p,
                  inverted: f,
                  layout: v
                });
              });
            });
          }
        }]), t;
      }(_.a);

      t.a = I, I.version = "3.0.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = (n(9), n(208)),
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_serializeTextDesign",
          value: function value(e, t) {
            var n = t.serializeOptions(["position", "rotation", "flipHorizontally", "flipVertically", "text", "color", "width", "seed", "inverted"], !0);
            n.color = {
              rgba: n.color
            };
            var i = t.getLayout();
            return i && (n.identifier = i.constructor.identifier), {
              type: "textdesign",
              options: n
            };
          }
        }]), t;
      }(p.a);

      t.a = g, g.version = "3.1.0";
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(9),
          d = n(210),
          g = n(55),
          m = n(41),
          y = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function b(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var w = function (e) {
        function t() {
          return v(this, t), b(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "_deserializeTextDesign",
          value: function value(e, t) {
            var n = this,
                i = t.options,
                r = i.position,
                o = i.rotation,
                a = i.flipHorizontally,
                s = i.flipVertically,
                l = i.text,
                u = i.color,
                c = i.width,
                p = i.seed,
                f = i.inverted,
                d = i.identifier;
            d === h.j.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignBlocksLight.identifier ? d = h.j.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignBlocksLightV310.identifier : d === h.j.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignSunshine.identifier && (d = h.j.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignSunshineV310.identifier);

            var _ = new g.a(this._ui, this._getOptions("textdesign")),
                v = new m.a(this._ui, {
              fonts: h.c.DEFAULTS.TEXT_DESIGN_FONTS,
              replaceFonts: !0
            }),
                b = e.constructor.TextDesignSprite.AssetManager,
                w = this._ui.getFontLoader(),
                x = new (_.getLayoutByIdentifier(d))();

            return w.setFonts(v.getFonts()), b.setFonts(y({}, b.getFonts(), v.getVariationsByIdentifier())), w.load().then(function () {
              var t = x.getImagePaths().map(function (e) {
                return {
                  path: e,
                  fullPath: n._ui.getAssetPath(e),
                  image: null
                };
              });
              return b.loadImages(t).then(function () {
                return x.onImagesLoaded(), e.createTextDesign({
                  position: r,
                  rotation: o,
                  flipHorizontally: a,
                  flipVertically: s,
                  text: l,
                  color: h.b.fromArray(u.rgba),
                  width: c,
                  seed: p,
                  inverted: f,
                  layout: x
                });
              });
            });
          }
        }]), t;
      }(d.a);

      t.a = w, w.version = "3.1.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(211),
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_serializeTextDesign",
          value: function value(e, t) {
            var n = t.serializeOptions(["position", "rotation", "flipHorizontally", "flipVertically", "text", "color", "width", "seed", "inverted", "padding"], !0);
            n.color = {
              rgba: n.color
            };
            var i = t.getLayout();
            return i && (n.identifier = i.constructor.identifier), n.padding *= n.width, {
              type: "textdesign",
              options: n
            };
          }
        }]), t;
      }(p.a);

      t.a = g, g.version = "3.2.0";
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(9),
          d = n(212),
          g = n(55),
          m = n(41),
          y = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function b(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var w = function (e) {
        function t() {
          return v(this, t), b(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "_deserializeTextDesign",
          value: function value(e, t) {
            var n = this,
                i = t.options,
                r = i.position,
                o = i.rotation,
                a = i.flipHorizontally,
                s = i.flipVertically,
                l = i.text,
                u = i.color,
                c = i.width,
                p = i.seed,
                f = i.inverted,
                d = i.identifier;
            d === h.j.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignBlocksLight.identifier ? d = h.j.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignBlocksLightV310.identifier : d === h.j.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignSunshine.identifier && (d = h.j.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignSunshineV310.identifier);

            var _ = "padding" in i ? i.padding / c : -1,
                v = new g.a(this._ui, this._getOptions("textdesign")),
                b = new m.a(this._ui, {
              fonts: h.c.DEFAULTS.TEXT_DESIGN_FONTS,
              replaceFonts: !0
            }),
                w = e.constructor.TextDesignSprite.AssetManager,
                x = this._ui.getFontLoader(),
                k = new (v.getLayoutByIdentifier(d))();

            return x.setFonts(b.getFonts()), w.setFonts(y({}, w.getFonts(), b.getVariationsByIdentifier())), x.load().then(function () {
              var t = k.getImagePaths().map(function (e) {
                return {
                  path: e,
                  fullPath: n._ui.getAssetPath(e),
                  image: null
                };
              });
              return w.loadImages(t).then(function () {
                return k.onImagesLoaded(), e.createTextDesign({
                  position: r,
                  rotation: o,
                  flipHorizontally: a,
                  flipVertically: s,
                  text: l,
                  color: h.b.fromArray(u.rgba),
                  width: c,
                  seed: p,
                  inverted: f,
                  layout: k,
                  padding: _
                });
              });
            });
          }
        }]), t;
      }(d.a);

      t.a = w, w.version = "3.2.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(213),
          d = n(93),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_serializeOperation",
          value: function value(e, n) {
            switch (e.constructor.identifier) {
              case "artfilter":
                return this._serializeStyle(e);

              default:
                return function e(t, n, i) {
                  null === t && (t = Function.prototype);
                  var r = a()(t, n);

                  if (void 0 === r) {
                    var o = f()(t);
                    return null === o ? void 0 : e(o, n, i);
                  }

                  if ("value" in r) return r.value;
                  var s = r.get;
                  return void 0 !== s ? s.call(i) : void 0;
                }(t.prototype.__proto__ || f()(t.prototype), "_serializeOperation", this).call(this, e, n);
            }
          }
        }, {
          key: "_serializeOrientationOperation",
          value: function value(e) {
            return {
              type: "orientation",
              options: e.serializeOptions(["flipVertically", "flipHorizontally", "rotation"], !0)
            };
          }
        }, {
          key: "_serializeStyle",
          value: function value(e) {
            var t = e.getOptions(),
                n = t.identifier,
                i = t.intensity,
                r = t.blendMode,
                o = e.getStyleTransferModel().getOptions(),
                a = o.tileEdgeLength,
                s = o.overlappingFactor;
            return {
              type: "artFilter",
              options: {
                identifier: n,
                intensity: i,
                blendMode: d.a[r],
                tileEdgeLength: a,
                overlappingFactor: s
              }
            };
          }
        }]), t;
      }(h.a);

      t.a = _, _.version = "3.4.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(10),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(9),
          m = n(214),
          y = (n(55), n(41), n(513)),
          _ = n(93),
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = g.k.flipObject(_.a),
          k = g.j.Operations.ArtFilterOperation,
          T = function (e) {
        function t() {
          return b(this, t), w(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_deserializeOperation",
          value: function value(e) {
            return "artFilter" === e.type ? this._deserializeStyle(e) : function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = d()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || d()(t.prototype), "_deserializeOperation", this).call(this, e);
          }
        }, {
          key: "_deserializeOrientationOperation",
          value: function value(e) {
            var t = e.options,
                n = this._editor.operations.getOrCreate("orientation");

            return n ? (n.set(t), f.a.resolve(n)) : f.a.resolve();
          }
        }, {
          key: "_deserializeStyle",
          value: function value(e) {
            var t = this,
                n = e.options,
                i = n.identifier,
                r = n.intensity,
                o = n.blendMode,
                a = n.tileEdgeLength,
                s = n.overlappingFactor;
            return i ? k.isSupported(this._editor.getSDK()) ? new y.a(this._ui, this._getOptions("artfilter")).instantiateStyleTransferModelForArtFilterWithIdentifier(i, {
              tileEdgeLength: a,
              overlappingFactor: s
            }).catch(function (e) {
              g.g.warn("Could not deserialize art filter: " + e);
            }).then(function (e) {
              t._editor.operations.getOrCreate("artfilter", {
                identifier: i,
                styleTransferModel: e,
                intensity: r,
                blendMode: parseInt(x[o || o], 10)
              });
            }) : (g.g.warn("Can't restore Art Filters, as they're not supported on this platform."), f.a.resolve()) : (g.g.warn("Found invalid Art Filter serialization."), f.a.resolve());
          }
        }]), t;
      }(m.a);

      t.a = T, T.version = "3.4.0";
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s);

      function u(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function c(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var p = function (e) {
        function t() {
          return u(this, t), c(this, (t.__proto__ || l()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(n(215).a);

      t.a = p, p.version = "3.5.0";
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(9),
          d = n(216),
          g = n(55),
          m = n(41),
          y = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function b(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var w = function (e) {
        function t() {
          return v(this, t), b(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "_deserializeTextDesign",
          value: function value(e, t) {
            var n = this,
                i = t.options,
                r = i.position,
                o = i.rotation,
                a = i.flipHorizontally,
                s = i.flipVertically,
                l = i.text,
                u = i.color,
                c = i.width,
                p = i.seed,
                f = i.inverted,
                d = i.identifier,
                _ = "padding" in i ? i.padding / c : -1,
                v = new g.a(this._ui, this._getOptions("textdesign")),
                b = new m.a(this._ui, {
              fonts: h.c.DEFAULTS.TEXT_DESIGN_FONTS,
              replaceFonts: !0
            }),
                w = e.constructor.TextDesignSprite.AssetManager,
                x = this._ui.getFontLoader(),
                k = new (v.getLayoutByIdentifier(d))();

            return x.setFonts(b.getFonts()), w.setFonts(y({}, w.getFonts(), b.getVariationsByIdentifier())), x.load().then(function () {
              var t = k.getImagePaths().map(function (e) {
                return {
                  path: e,
                  fullPath: n._ui.getAssetPath(e),
                  image: null
                };
              });
              return w.loadImages(t).then(function () {
                return k.onImagesLoaded(), e.createTextDesign({
                  position: r,
                  rotation: o,
                  flipHorizontally: a,
                  flipVertically: s,
                  text: l,
                  color: h.b.fromArray(u.rgba),
                  width: c,
                  seed: p,
                  inverted: f,
                  layout: k,
                  padding: _
                });
              });
            });
          }
        }]), t;
      }(d.a);

      t.a = w, w.version = "3.5.0";
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(217),
          m = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          y = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = function (e) {
        function t() {
          return _(this, t), v(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), y(t, [{
          key: "_serializeAdjustmentsOperation",
          value: function value(e) {
            var n = function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = l()(t, n);

              if (void 0 === r) {
                var o = d()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var a = r.get;
              return void 0 !== a ? a.call(i) : void 0;
            }(t.prototype.__proto__ || d()(t.prototype), "_serializeAdjustmentsOperation", this).call(this, e),
                i = {},
                r = e.availableOptions.sharpness,
                o = e.getOption("sharpness"),
                a = r.minValue,
                s = r.midValue,
                u = r.maxValue;

            return i.sharpness = o <= s ? (o - a) / (s - a) - 1 : (o - s) / (u - s), n.options = m({}, n.options, i), n;
          }
        }]), t;
      }(g.a);

      t.a = b, b.version = "3.6.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(9),
          d = n(218),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_deserializeAdjustmentsOperation",
          value: function value(e) {
            var n = h.j.Operations.AdjustmentsOperation;
            return function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "_deserializeAdjustmentsOperation", this).call(this, e).then(function (t) {
              if (!t) return null;
              var i = e.options,
                  r = {};

              if (void 0 !== i.sharpness) {
                var o = n.prototype.availableOptions.sharpness,
                    a = o.minValue,
                    s = o.midValue,
                    l = o.maxValue,
                    u = i.sharpness;
                return u = u < 0 ? s + (s - a) * u : s + (l - s) * u, r.sharpness = u, t.set(r), t;
              }
            });
          }
        }]), t;
      }(d.a);

      t.a = _, _.version = "3.6.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(10),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(219),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          y = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = function (e) {
        function t() {
          return _(this, t), v(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "serialize",
          value: function value() {
            var e = this,
                n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return y(t.prototype.__proto__ || d()(t.prototype), "serialize", this).call(this, n).then(function (t) {
              return e._serializeAssetLibrary(t).then(function (e) {
                return e;
              });
            });
          }
        }, {
          key: "_serializeAssetLibrary",
          value: function value(e) {
            if (!this._editor.getDynamicAssetsLibrary) return f.a.resolve(e);

            var t = this._editor.getDynamicAssetsLibrary(),
                n = this._serializeCustomStickerAssets(e, t);

            return 0 === n.length || (e.assetLibrary = {
              assets: {
                stickers: n
              }
            }), f.a.resolve(e);
          }
        }, {
          key: "_serializeCustomStickerAssets",
          value: function value(e, t) {
            var n = t.getAssets("sticker");
            if (0 === n.length) return [];
            var i = e.operations.filter(function (e) {
              return "sprite" === e.type;
            }).flatMap(function (e) {
              return e.options.sprites;
            }).filter(function (e) {
              return "sticker" === e.type;
            }).map(function (e) {
              return e.options.identifier;
            }),
                r = {};
            return i.forEach(function (e) {
              r[e] = !0;
            }), n.filter(function (e) {
              return r[e.identifier];
            }).map(function (e) {
              var t = e.identifier,
                  n = e.defaultName,
                  i = e.images,
                  r = i.mediaBase.uris[0],
                  o = i.mediaBase.isSVG,
                  a = /^data:(image\/(jpeg|png));base64,(.*)$/g.exec(r),
                  s = {
                identifier: t,
                name: n,
                raster: {
                  type: a[1],
                  data: a[3]
                }
              };
              return n && (s.name = n), o && (s.svg = {
                data: i.mediaBase.uris[1].replace(/^data:image\/svg\+xml;base64,/g, "")
              }), s;
            });
          }
        }]), t;
      }(g.a);

      t.a = b, b.version = "3.7.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(10),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(31),
          d = (n.n(h), n(220)),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "deserialize",
          value: function value() {
            var e = this;
            return this._validateVersion().then(function () {
              return e._deserializeAssetLibrary();
            }).then(function () {
              return e._deserializeInputImage();
            }).then(function () {
              return e._deserializeOperations();
            });
          }
        }, {
          key: "_deserializeAssetLibrary",
          value: function value() {
            var e = this;
            return new c.a(function (t, n) {
              var i = e._data;

              if (i.assetLibrary) {
                var r = i.assetLibrary.assets,
                    o = [];

                for (var a in r) {
                  o.push(e._deserializeCustomAssets(a, r[a]));
                }

                return c.a.all(o).then(function () {
                  t();
                }).catch(function (e) {
                  console.error(e), n(e);
                });
              }

              t();
            });
          }
        }, {
          key: "_deserializeCustomAssets",
          value: function value(e, t) {
            switch (e) {
              case "stickers":
                return this._deserializeCustomStickerAssets(t);

              default:
                return c.a.reject(new Error("Unknown asset type: " + e));
            }
          }
        }, {
          key: "_deserializeCustomStickerAssets",
          value: function value(e) {
            var t = this,
                n = "none",
                i = this._editor.getOptions().editor;

            i && i.controlsOptions && i.controlsOptions.sticker && (n = i.controlsOptions.sticker.customStickerTintMode || "none");
            var r = e.map(function (e) {
              return new c.a(function (i, r) {
                var o = e.identifier,
                    a = e.raster,
                    s = void 0 !== e.svg,
                    l = "data:" + a.type + ";base64," + a.data,
                    u = new h.Image();
                u.onload = function () {
                  var r,
                      a = t._editor.getSDK();

                  (u = a.correctExifOrientation(u)).toDataURL && (l = u.toDataURL()), r = t._stickerManager.renderStickerThumbnailFromImage(u);
                  var c = {
                    identifier: o,
                    defaultName: e.name || "",
                    tintMode: n,
                    images: {
                      mediaBase: {
                        uris: [l],
                        rawData: !0,
                        isSVG: s,
                        width: u.width,
                        height: u.height
                      },
                      mediaThumb: {
                        uris: [r.data],
                        rawData: !0,
                        width: r.width,
                        height: r.height
                      }
                    }
                  };

                  if (s) {
                    var p = "data:image/svg+xml;base64," + e.svg.data;
                    c.images.mediaBase.uris.push(p);
                  }

                  i(c);
                }, u.onerror = function () {
                  r(new Error("Invalid base64 data: " + l));
                }, u.src = l;
              });
            });
            return c.a.all(r).then(function (e) {
              t._editor.getDynamicAssetsLibrary().setAssets("sticker", e), t._stickerManager.reload();
            });
          }
        }]), t;
      }(d.a);

      t.a = _, _.version = "3.7.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(221),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function g(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function m(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var y = function (e) {
        function t() {
          return g(this, t), m(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "_serializeSticker",
          value: function value(e, n) {
            var i = function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "_serializeSticker", this).call(this, e, n);

            return i.options.tintMode = n.getTintMode(), i;
          }
        }]), t;
      }(h.a);

      t.a = y, y.version = "3.8.0";
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s);

      function u(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function c(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var p = function (e) {
        function t() {
          return u(this, t), c(this, (t.__proto__ || l()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(n(222).a);

      t.a = p, p.version = "3.8.0";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(226);
      n.d(t, "Constants", function () {
        return i.b;
      }), n.d(t, "Utils", function () {
        return i.f;
      }), n.d(t, "JSONLoader", function () {
        return i.d;
      }), n.d(t, "PhotoEditorSDK", function () {
        return i.e;
      }), n.d(t, "EngineWrapper", function () {
        return i.c;
      }), n.d(t, "Color", function () {
        return i.a;
      });
    }, function (e, t, n) {
      n.d(t, "c", function () {
        return x;
      });
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(9),
          f = n(488),
          h = n(72),
          d = n(135),
          g = n(202),
          m = n(41),
          y = n(55);
      n.d(t, "b", function () {
        return p.c;
      }), n.d(t, "f", function () {
        return p.m;
      }), n.d(t, "d", function () {
        return h.a;
      }), n.d(t, "e", function () {
        return p.j;
      }), n.d(t, "a", function () {
        return p.b;
      });

      var _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function b(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }
      /*!
       * This file is part of PhotoEditorSDK.
       *
       * Copyright (C) 2016-2019 img.ly GmbH <contact@img.ly>
       * All rights reserved.
       *
       * Redistribution and use in source and binary forms, without
       * modification, are permitted provided that the following license agreement
       * is approved and a legal/financial contract was signed by the user.
       * The license agreement can be found under following link:
       *
       * https://www.photoeditorsdk.com/LICENSE.txt
       */


      var w = function w(e) {
        return p.k.byteArrayToString(p.a.decode(e));
      },
          x = function (e) {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          v(this, t);
          var n = b(this, (t.__proto__ || c()(t)).call(this));
          return n._mediator = new p.d(), n._fontLoader = new d.a(n), n._options = e, n._initOptions(), n._initEvents(), n._disposed = !1, n._isReady = !1, n._editor = new f.a(n, n._options, n._mediator), n._options.editor.image && n._editor.setImage(n._options.editor.image), n._mediator.once(p.c.EVENTS.EDITOR_READY, function () {
            n._isReady = !0;
          }), p.g.setLevel(n._options.logLevel), n._v(), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "export",
          value: function value() {
            var e;
            return (e = this._editor).export.apply(e, arguments);
          }
        }, {
          key: "serialize",
          value: function value() {
            var e;
            return (e = this._editor).serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return this._editor.deserialize(e);
          }
        }, {
          key: "getEditor",
          value: function value() {
            return this._editor;
          }
        }, {
          key: "isReady",
          value: function value() {
            return this._isReady;
          }
        }, {
          key: "onReady",
          value: function value(e) {
            this._isReady ? e() : this._mediator.once(p.c.EVENTS.EDITOR_READY, e);
          }
        }, {
          key: "createFilter",
          value: function value(e) {
            return new g.a(this, this._getOptions("filter")).instantiateFilterWithIdentifier(e);
          }
        }, {
          key: "getTextDesignLayoutByID",
          value: function value(e) {
            return new (new y.a(this, this._getOptions("textDesign")).getLayoutByIdentifier(e))();
          }
        }, {
          key: "getTextDesignAssetManager",
          value: function value() {
            return p.j.Operations.SpriteOperation.TextDesignSprite.AssetManager;
          }
        }, {
          key: "getTextDesignFontManager",
          value: function value() {
            return new m.a(this, {
              fonts: p.c.DEFAULTS.TEXT_DESIGN_FONTS,
              replaceFonts: !0
            });
          }
        }, {
          key: "_getOptions",
          value: function value(e) {
            var t = this.getEditor(),
                n = t.controls,
                i = {};
            n && n.get(e) && (i = n.get(e).defaultOptions);
            var r = t.getOptions();
            return p.k.deepDefaults({}, r.editor.controlsOptions[e] || {}, i);
          }
        }, {
          key: "_initOptions",
          value: function value() {
            if (this._options = p.k.defaults(this._options, {
              language: "en",
              logLevel: "warn",
              crossOrigin: "anonymous",
              editor: {},
              assets: {},
              responsive: !1,
              preloader: !0,
              autoRun: !0
            }), this._options.editor = p.k.defaults(this._options.editor || {}, {
              enableZoom: !0,
              enableDrag: !0,
              enableExport: !0,
              enableKeyboardControls: !0,
              enablePositionSnapping: !0,
              enableRotationSnapping: !0,
              enableSave: !1,
              enableLoad: !1,
              pixelRatio: "undefined" != typeof window && window.devicePixelRatio || 1,
              preferredRenderer: "webgl",
              transparent: !0,
              clearColor: [0, 0, 0, 0],
              displayResizeMessage: !0,
              maxMegaPixels: {},
              displayCloseButton: !1,
              undoMode: "global",
              defaultControl: "filter",
              forceCrop: !1,
              snappingOptions: {},
              tools: ["transform", "filter", "adjustments", "focus", "text", "textdesign", "sticker", "brush", "frame", "overlay", "library", "artfilter"],
              controlsOrder: [["library"], ["artfilter", "transform", "filter", "adjustments", "focus"], ["text", "textdesign", "sticker", "brush", "frame", "overlay"]],
              operationsOrder: ["exif-orientation", "artfilter", "orientation", "transform", "filter", "adjustments", "radial-focus", "mirrored-focus", "linear-focus", "blur", "selective-blur", "overlay", "sprite", "frame", "watermark"],
              controlsOptions: {
                focus: {
                  highQualityCanvasBlur: !1
                }
              }
            }), this._options.editor.snappingOptions = p.k.defaults(this._options.editor.snappingOptions, {
              position: {},
              rotation: {}
            }), this._options.editor.snappingOptions.position = p.k.defaults(this._options.editor.snappingOptions.position, {
              padding: {},
              threshold: 20
            }), this._options.editor.snappingOptions.position.padding = p.k.defaults(this._options.editor.snappingOptions.position.padding, {
              left: .1,
              right: .1,
              top: .1,
              bottom: .1
            }), this._options.editor.snappingOptions.rotation = p.k.defaults(this._options.editor.snappingOptions.rotation, {
              angles: [0, 45, 90, 135, 180, 225, 270, 315],
              threshold: 20
            }), this._options.editor.controlsOptions.focus = p.k.defaults(this._options.editor.controlsOptions.focus, {
              highQualityCanvasBlur: !1
            }), this._options.editor.maxMegaPixels = p.k.defaults(this._options.editor.maxMegaPixels, {
              mobile: 5,
              desktop: 10
            }), this._options.editor.export = p.k.defaults(this._options.editor.export || {}, {
              format: "image/png",
              type: p.i.IMAGE,
              download: !0,
              fileBasename: "photoeditorsdk-export",
              quality: .8
            }), this._options.editor.save = p.k.defaults(this._options.editor.save || {}, {
              format: "text/json",
              download: !0,
              fileBasename: "photoeditorsdk-save"
            }), this._options.extensions = p.k.defaults(this._options.extensions || {}, {
              languages: {},
              operations: [],
              controls: []
            }), this._options.assets = p.k.defaults(this._options.assets || {}, {
              baseUrl: "assets",
              resolver: null
            }), !(this._options.editor.image instanceof window.Image)) {
              var e = new window.Image();
              this._options.editor.image && (e.src = this._options.editor.image, this._options.editor.image = e);
            }
          }
        }, {
          key: "_v",
          value: function value() {
            return !!this[w("X29wdGlvbnM=")][w("bGljZW5zZQ==")] || (p.g.error(w("TGljZW5zaW5n"), w("Tm8gYGxpY2Vuc2VgIG9wdGlvbiBnaXZlbg==")), p.g.error(w("TGljZW5zaW5n"), w("SW4gY2FzZSB5b3UgZG9uJ3QgaGF2ZSBhIGxpY2Vuc2UgeWV0LCBwbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tIHRvIG9idGFpbiBhIGxpY2Vuc2Ugb3IgbG9nIGluIHRvIHlvdXIgY3VzdG9tZXIgZGFzaGJvYXJkLg==")), !1);
          }
        }, {
          key: "_initEvents",
          value: function value() {
            this._mediator.pipeEvents(this);
          }
        }, {
          key: "_disposeEvents",
          value: function value() {
            this._mediator.unpipeEvents(this);
          }
        }, {
          key: "setImage",
          value: function value(e) {
            this._editor.setImage(e);
          }
        }, {
          key: "getAssetPath",
          value: function value(e) {
            var t = this._options.assets,
                n = t.baseUrl,
                i = t.resolver,
                r = n + "/" + e;
            i = i || function (e) {
              return e;
            }, e.match(/(ftp|http|https):\/\//) && (r = e);
            var o = e.replace(/assets\//, "").split("/");

            switch (o[0]) {
              case "art-filters":
                return i("art-filter", {
                  identifier: o[1],
                  type: o[2].split(".")[0]
                });

              case "filters":
                return i("filter", {
                  identifier: o[1].replace(/\.png$/g, "")
                });

              case "fonts":
                return i("font", {
                  identifier: o[1].replace(/\.(woff|otf|ttf)$/g, "")
                });

              case "frames":
                return i("frame", {
                  identifier: o[1],
                  filename: o[2]
                });

              case "overlays":
                return i("overlay", {
                  identifier: o[1].replace(/\.(png|jpg|jpeg)$/g, "")
                });

              case "stickers":
                var a = o[3].endsWith(".svg"),
                    s = "thumbs" === o[3];
                return i("sticker", {
                  category: o[1],
                  identifier: (a ? o[3] : o[4]).replace(/\.(png|svg)$/g, ""),
                  variant: a ? "svg" : s ? "thumb" : "base"
                });

              case "text-design":
                return i("text-design", {
                  type: "fonts" === o[1] ? "font" : "image",
                  identifier: o[2].replace(/\.(png|otf|ttf|woff2?)$/g, "")
                });
            }

            return null != i && (r = i(r)), r;
          }
        }, {
          key: "getFontLoader",
          value: function value() {
            return this._fontLoader;
          }
        }, {
          key: "dispose",
          value: function value() {
            if (this._disposed) throw new Error("This instance of PhotoEditorSDK is already disposed.");
            this._disposed = !0, this._disposeEvents();
          }
        }, {
          key: "render",
          value: function value(e) {
            var t = this;
            return this.deserialize(e).then(function () {
              return t.export();
            });
          }
        }]), t;
      }(p.d);

      x.prototype.identifier = "engine-wrapper", x.Constants = p.c, x.Events = p.c.EVENTS, x.Utils = p.m, x.JSONLoader = h.a, x.SDK = p.j;
    }, function (e, t, n) {
      n(228);
      var i = n(11).Object;

      e.exports = function (e, t, n) {
        return i.defineProperty(e, t, n);
      };
    }, function (e, t, n) {
      var i = n(14);
      i(i.S + i.F * !n(19), "Object", {
        defineProperty: n(22).f
      });
    }, function (e, t, n) {
      n(230), e.exports = n(11).Object.setPrototypeOf;
    }, function (e, t, n) {
      var i = n(14);
      i(i.S, "Object", {
        setPrototypeOf: n(231).set
      });
    }, function (e, t, n) {
      var i = n(23),
          r = n(28),
          o = function o(e, t) {
        if (r(e), !i(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
      };

      e.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, t, i) {
          try {
            (i = n(30)(Function.call, n(96).f(Object.prototype, "__proto__").set, 2))(e, []), t = !(e instanceof Array);
          } catch (e) {
            t = !0;
          }

          return function (e, n) {
            return o(e, n), t ? e.__proto__ = n : i(e, n), e;
          };
        }({}, !1) : void 0),
        check: o
      };
    }, function (e, t, n) {
      n(233);
      var i = n(11).Object;

      e.exports = function (e, t) {
        return i.create(e, t);
      };
    }, function (e, t, n) {
      var i = n(14);
      i(i.S, "Object", {
        create: n(82)
      });
    }, function (e, t, n) {
      var i = n(22),
          r = n(28),
          o = n(49);
      e.exports = n(19) ? Object.defineProperties : function (e, t) {
        r(e);

        for (var n, a = o(t), s = a.length, l = 0; s > l;) {
          i.f(e, n = a[l++], t[n]);
        }

        return e;
      };
    }, function (e, t, n) {
      var i = n(35),
          r = n(83),
          o = n(236);

      e.exports = function (e) {
        return function (t, n, a) {
          var s,
              l = i(t),
              u = r(l.length),
              c = o(a, u);

          if (e && n != n) {
            for (; u > c;) {
              if ((s = l[c++]) != s) return !0;
            }
          } else for (; u > c; c++) {
            if ((e || c in l) && l[c] === n) return e || c || 0;
          }

          return !e && -1;
        };
      };
    }, function (e, t, n) {
      var i = n(99),
          r = Math.max,
          o = Math.min;

      e.exports = function (e, t) {
        return (e = i(e)) < 0 ? r(e + t, 0) : o(e, t);
      };
    }, function (e, t, n) {
      n(238), e.exports = n(11).Object.getPrototypeOf;
    }, function (e, t, n) {
      var i = n(44),
          r = n(139);
      n(103)("getPrototypeOf", function () {
        return function (e) {
          return r(i(e));
        };
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(31),
          a = n.n(o),
          s = n(24),
          l = n(480),
          u = n(72),
          c = a.a.Utils,
          p = a.a.Math.Vector2,
          f = {
        getInnerDimensionsForElement: function getInnerDimensionsForElement(e) {
          var t = new p(e.offsetWidth, e.offsetHeight),
              n = window.getComputedStyle(e, null);
          return t.x -= parseInt(n.getPropertyValue("padding-left"), 10), t.x -= parseInt(n.getPropertyValue("padding-right"), 10), t.y -= parseInt(n.getPropertyValue("padding-top"), 10), t.y -= parseInt(n.getPropertyValue("padding-bottom"), 10), t;
        },
        getEventPosition: function getEventPosition(e) {
          var t = e.clientX,
              n = e.clientY;

          if (-1 !== e.type.indexOf("touch")) {
            if (!e.touches.length) return;
            t = e.touches[0].clientX, n = e.touches[0].clientY;
          }

          return new p(t, n);
        },
        createTransparentPatternCanvas: function createTransparentPatternCanvas() {
          var e = document.createElement("canvas"),
              t = e.getContext("2d");
          return e.width = 10, e.height = 10, t.fillStyle = "white", t.fillRect(0, 0, e.width, e.height), t.fillStyle = "#cccccc", t.fillRect(0, 0, e.width / 2, e.height / 2), t.fillRect(e.width / 2, e.height / 2, e.width, e.height), e;
        },
        supportsMSBlob: function supportsMSBlob() {
          return void 0 !== document.createElement("canvas").msToBlob;
        },
        translate: function translate(e, t) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = this.fetch(e, t);

          if (!r) {
            s.a.info("Utils#translate", "Unable to translate `" + t + "`");
            var o = n(481),
                a = o[t];
            return null != a ? (s.a.warn("Utils#translate", "Trying to find localized string for old key: `" + a + "`. Please update your localization to use the new key as soon as possible. Support for the old, deprecated key will be dropped with the next major version update."), this.translate(e, a, i)) : null;
          }

          for (var l in i) {
            r = r.replace("${" + l + "}", i[l]);
          }

          return r;
        },
        fetch: function fetch(e, t, n) {
          for (var i = (t = (t = t.replace(/\[(\w+)]/g, ".$1")).replace(/^\./, "")).split("."), r = 0; r < i.length && (e = e[i[r]]); r++) {
            ;
          }

          return void 0 !== e && e;
        },
        isMobile: function isMobile() {
          var e = navigator.userAgent || navigator.vendor || window.opera;
          return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4));
        },
        select: function select(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          n || (n = function n(e) {
            return e;
          });
          var i = [];
          return t.forEach(function (t) {
            e.forEach(function (e) {
              n(e) === t && i.push(e);
            });
          }), i;
        },
        getJSONP: function getJSONP(e) {
          return new u.a(e).load();
        },
        cloneCategories: function cloneCategories(e, t) {
          return e.map(function (e) {
            return (e = c.clone(e))[t] = e[t].slice(0), e;
          });
        },
        mergeCategories: function mergeCategories(e, t, n) {
          e = this.cloneCategories(e, n);
          var i = null;
          return t.forEach(function (t) {
            e.forEach(function (e) {
              t.identifier === e.identifier && (i = e);
            }), i ? i[n] = i[n].concat(t[n]) : e.push(t);
          }), e;
        },
        wrapFiltersInCategories: function wrapFiltersInCategories(e, t) {
          return e.map(function (e) {
            var n,
                i,
                o,
                a = e;
            return t in a || (n = {
              identifier: "imgly_filters_wrapped-" + e.identifier,
              displayFlat: !0
            }, o = [e], (i = t) in n ? r()(n, i, {
              value: o,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : n[i] = o, a = n), a;
          });
        },
        getStyleObject: function getStyleObject(e) {
          var t = window.getComputedStyle(e),
              n = {};

          for (var i in t) {
            var r = t.getPropertyValue(i),
                o = i.replace(/-([a-z])/g, function (e, t) {
              return t.toUpperCase();
            });
            "" !== r && (n[o] = r);
          }

          return n;
        },
        styleElement: function styleElement(e, t) {
          for (var n in t) {
            e.style[n] = t[n];
          }
        },
        debounce: function debounce(e, t, n) {
          var i;
          return function () {
            var r = this,
                o = arguments,
                a = function a() {
              i = null, n || e.apply(r, o);
            },
                s = n && !i;

            clearTimeout(i), i = setTimeout(a, t), s && e.apply(this, o);
          };
        },
        getScrollbarWidth: function getScrollbarWidth() {
          var e = document.createElement("div");
          e.style.visibility = "hidden", e.style.width = "100px", e.style.msOverflowStyle = "scrollbar", document.body.appendChild(e);
          var t = e.offsetWidth;
          e.style.overflow = "scroll";
          var n = document.createElement("div");
          n.style.width = "100%", e.appendChild(n);
          var i = n.offsetWidth;
          return e.parentNode.removeChild(e), t - i;
        },
        findIntegerFraction: function findIntegerFraction(e) {
          for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100, n = Number.MAX_VALUE, i = 0, r = 0, o = 1, a = 1, s = 0; s < t; s++) {
            var l = o / a - e;
            if (l < 0) o++;else {
              if (!(l > 0)) return new p(o, a);
              a++;
            }
            var u = Math.abs(o / a - e);
            u < n && (n = u, i = o, r = a);
          }

          return new p(i, r);
        },
        toFixed: function toFixed(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
              n = e.toFixed(t);
          return parseFloat(n);
        },
        capitalize: function capitalize(e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        },
        flipObject: function flipObject(e) {
          var t = {};

          for (var n in e) {
            t[e[n]] = n;
          }

          return t;
        },
        Browser: l.a
      };
      t.a = f;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(140),
          r = n(321),
          o = (n.n(r), n(165)),
          a = n(166),
          s = n(86),
          l = n(66),
          u = n(167),
          c = n(67),
          p = n(32),
          f = n(322),
          h = n(169),
          d = n(120),
          g = n(90),
          m = n(46),
          y = n(70),
          _ = n(24),
          v = n(171),
          b = n(40),
          w = n(65);
      /*
       * This file is part of PhotoEditorSDK.
       *
       * Copyright (C) 2016-2019 img.ly GmbH <contact@img.ly>
       * All rights reserved.
       *
       * Redistribution and use in source and binary forms, without
       * modification, are permitted provided that the following license agreement
       * is approved and a legal/financial contract was signed by the user.
       * The license agreement can be found under following link:
       *
       * https://www.photoeditorsdk.com/LICENSE.txt
       * @license
       */


      i.a.version = n(170).version, i.a.Math = o, i.a.Operations = a, i.a.Engine = s.a, i.a.Color = l.a, i.a.Operation = u.a, i.a.EventEmitter = c.a, i.a.Utils = p.a, i.a.Env = f.a, i.a.OperationsStack = h.a, i.a.EXIF = d.a, i.a.Image = g.a, i.a.Promise = m.a, i.a.Configurable = y.a, i.a.Log = _.a, i.a.Loaders = v, i.a.RenderType = b.RenderType, i.a.ImageFormat = b.ImageFormat, i.a.OptionType = b.OptionType, i.a.RendererType = b.RendererType, i.a.UniformType = b.UniformType, i.a.Base64 = w.a, i.a.UI = {}, t.default = i.a;
    }, function (e, t, n) {
      n(50), n(62), e.exports = n(105).f("iterator");
    }, function (e, t, n) {
      var i = n(99),
          r = n(98);

      e.exports = function (e) {
        return function (t, n) {
          var o,
              a,
              s = String(r(t)),
              l = i(n),
              u = s.length;
          return l < 0 || l >= u ? e ? "" : void 0 : (o = s.charCodeAt(l)) < 55296 || o > 56319 || l + 1 === u || (a = s.charCodeAt(l + 1)) < 56320 || a > 57343 ? e ? s.charAt(l) : o : e ? s.slice(l, l + 2) : a - 56320 + (o - 55296 << 10) + 65536;
        };
      };
    }, function (e, t, n) {
      var i = n(82),
          r = n(57),
          o = n(61),
          a = {};
      n(34)(a, n(17)("iterator"), function () {
        return this;
      }), e.exports = function (e, t, n) {
        e.prototype = i(a, {
          next: r(1, n)
        }), o(e, t + " Iterator");
      };
    }, function (e, t, n) {
      var i = n(245),
          r = n(142),
          o = n(51),
          a = n(35);
      e.exports = n(104)(Array, "Array", function (e, t) {
        this._t = a(e), this._i = 0, this._k = t;
      }, function () {
        var e = this._t,
            t = this._k,
            n = this._i++;
        return !e || n >= e.length ? (this._t = void 0, r(1)) : r(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
      }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
    }, function (e, t) {
      e.exports = function () {};
    }, function (e, t, n) {
      n(247), n(109), n(250), n(251), e.exports = n(11).Symbol;
    }, function (e, t, n) {
      var i = n(16),
          r = n(43),
          o = n(19),
          a = n(14),
          s = n(141),
          l = n(106).KEY,
          u = n(42),
          c = n(101),
          p = n(61),
          f = n(84),
          h = n(17),
          d = n(105),
          g = n(107),
          m = n(248),
          y = n(143),
          _ = n(28),
          v = n(23),
          b = n(44),
          w = n(35),
          x = n(95),
          k = n(57),
          T = n(82),
          S = n(249),
          C = n(96),
          E = n(108),
          O = n(22),
          R = n(49),
          I = C.f,
          A = O.f,
          M = S.f,
          _F = i.Symbol,
          D = i.JSON,
          P = D && D.stringify,
          z = h("_hidden"),
          L = h("toPrimitive"),
          B = {}.propertyIsEnumerable,
          N = c("symbol-registry"),
          U = c("symbols"),
          j = c("op-symbols"),
          W = Object.prototype,
          H = "function" == typeof _F && !!E.f,
          G = i.QObject,
          V = !G || !G.prototype || !G.prototype.findChild,
          X = o && u(function () {
        return 7 != T(A({}, "a", {
          get: function get() {
            return A(this, "a", {
              value: 7
            }).a;
          }
        })).a;
      }) ? function (e, t, n) {
        var i = I(W, t);
        i && delete W[t], A(e, t, n), i && e !== W && A(W, t, i);
      } : A,
          Y = function Y(e) {
        var t = U[e] = T(_F.prototype);
        return t._k = e, t;
      },
          q = H && "symbol" == typeof _F.iterator ? function (e) {
        return "symbol" == typeof e;
      } : function (e) {
        return e instanceof _F;
      },
          K = function K(e, t, n) {
        return e === W && K(j, t, n), _(e), t = x(t, !0), _(n), r(U, t) ? (n.enumerable ? (r(e, z) && e[z][t] && (e[z][t] = !1), n = T(n, {
          enumerable: k(0, !1)
        })) : (r(e, z) || A(e, z, k(1, {})), e[z][t] = !0), X(e, t, n)) : A(e, t, n);
      },
          Z = function Z(e, t) {
        _(e);

        for (var n, i = m(t = w(t)), r = 0, o = i.length; o > r;) {
          K(e, n = i[r++], t[n]);
        }

        return e;
      },
          Q = function Q(e) {
        var t = B.call(this, e = x(e, !0));
        return !(this === W && r(U, e) && !r(j, e)) && (!(t || !r(this, e) || !r(U, e) || r(this, z) && this[z][e]) || t);
      },
          J = function J(e, t) {
        if (e = w(e), t = x(t, !0), e !== W || !r(U, t) || r(j, t)) {
          var n = I(e, t);
          return !n || !r(U, t) || r(e, z) && e[z][t] || (n.enumerable = !0), n;
        }
      },
          $ = function $(e) {
        for (var t, n = M(w(e)), i = [], o = 0; n.length > o;) {
          r(U, t = n[o++]) || t == z || t == l || i.push(t);
        }

        return i;
      },
          ee = function ee(e) {
        for (var t, n = e === W, i = M(n ? j : w(e)), o = [], a = 0; i.length > a;) {
          !r(U, t = i[a++]) || n && !r(W, t) || o.push(U[t]);
        }

        return o;
      };

      H || (s((_F = function F() {
        if (this instanceof _F) throw TypeError("Symbol is not a constructor!");

        var e = f(arguments.length > 0 ? arguments[0] : void 0),
            t = function t(n) {
          this === W && t.call(j, n), r(this, z) && r(this[z], e) && (this[z][e] = !1), X(this, e, k(1, n));
        };

        return o && V && X(W, e, {
          configurable: !0,
          set: t
        }), Y(e);
      }).prototype, "toString", function () {
        return this._k;
      }), C.f = J, O.f = K, n(144).f = S.f = $, n(58).f = Q, E.f = ee, o && !n(60) && s(W, "propertyIsEnumerable", Q, !0), d.f = function (e) {
        return Y(h(e));
      }), a(a.G + a.W + a.F * !H, {
        Symbol: _F
      });

      for (var te = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), ne = 0; te.length > ne;) {
        h(te[ne++]);
      }

      for (var ie = R(h.store), re = 0; ie.length > re;) {
        g(ie[re++]);
      }

      a(a.S + a.F * !H, "Symbol", {
        for: function _for(e) {
          return r(N, e += "") ? N[e] : N[e] = _F(e);
        },
        keyFor: function keyFor(e) {
          if (!q(e)) throw TypeError(e + " is not a symbol!");

          for (var t in N) {
            if (N[t] === e) return t;
          }
        },
        useSetter: function useSetter() {
          V = !0;
        },
        useSimple: function useSimple() {
          V = !1;
        }
      }), a(a.S + a.F * !H, "Object", {
        create: function create(e, t) {
          return void 0 === t ? T(e) : Z(T(e), t);
        },
        defineProperty: K,
        defineProperties: Z,
        getOwnPropertyDescriptor: J,
        getOwnPropertyNames: $,
        getOwnPropertySymbols: ee
      });
      var oe = u(function () {
        E.f(1);
      });
      a(a.S + a.F * oe, "Object", {
        getOwnPropertySymbols: function getOwnPropertySymbols(e) {
          return E.f(b(e));
        }
      }), D && a(a.S + a.F * (!H || u(function () {
        var e = _F();

        return "[null]" != P([e]) || "{}" != P({
          a: e
        }) || "{}" != P(Object(e));
      })), "JSON", {
        stringify: function stringify(e) {
          for (var t, n, i = [e], r = 1; arguments.length > r;) {
            i.push(arguments[r++]);
          }

          if (n = t = i[1], (v(t) || void 0 !== e) && !q(e)) return y(t) || (t = function t(e, _t4) {
            if ("function" == typeof n && (_t4 = n.call(this, e, _t4)), !q(_t4)) return _t4;
          }), i[1] = t, P.apply(D, i);
        }
      }), _F.prototype[L] || n(34)(_F.prototype, L, _F.prototype.valueOf), p(_F, "Symbol"), p(Math, "Math", !0), p(i.JSON, "JSON", !0);
    }, function (e, t, n) {
      var i = n(49),
          r = n(108),
          o = n(58);

      e.exports = function (e) {
        var t = i(e),
            n = r.f;
        if (n) for (var a, s = n(e), l = o.f, u = 0; s.length > u;) {
          l.call(e, a = s[u++]) && t.push(a);
        }
        return t;
      };
    }, function (e, t, n) {
      var i = n(35),
          r = n(144).f,
          o = {}.toString,
          a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

      e.exports.f = function (e) {
        return a && "[object Window]" == o.call(e) ? function (e) {
          try {
            return r(e);
          } catch (e) {
            return a.slice();
          }
        }(e) : r(i(e));
      };
    }, function (e, t, n) {
      n(107)("asyncIterator");
    }, function (e, t, n) {
      n(107)("observable");
    }, function (e, t, n) {
      n(109), n(50), n(62), n(253), n(257), n(258), e.exports = n(11).Promise;
    }, function (e, t, n) {
      var i,
          r,
          o,
          a,
          s = n(60),
          l = n(16),
          u = n(30),
          c = n(85),
          p = n(14),
          f = n(23),
          h = n(56),
          d = n(110),
          g = n(63),
          m = n(147),
          y = n(112).set,
          _ = n(255)(),
          v = n(113),
          b = n(148),
          w = n(256),
          x = n(149),
          k = l.TypeError,
          T = l.process,
          S = T && T.versions,
          C = S && S.v8 || "",
          _E = l.Promise,
          O = "process" == c(T),
          R = function R() {},
          I = r = v.f,
          A = !!function () {
        try {
          var e = _E.resolve(1),
              t = (e.constructor = {})[n(17)("species")] = function (e) {
            e(R, R);
          };

          return (O || "function" == typeof PromiseRejectionEvent) && e.then(R) instanceof t && 0 !== C.indexOf("6.6") && -1 === w.indexOf("Chrome/66");
        } catch (e) {}
      }(),
          M = function M(e) {
        var t;
        return !(!f(e) || "function" != typeof (t = e.then)) && t;
      },
          F = function F(e, t) {
        if (!e._n) {
          e._n = !0;
          var n = e._c;

          _(function () {
            for (var i = e._v, r = 1 == e._s, o = 0, a = function a(t) {
              var n,
                  o,
                  a,
                  s = r ? t.ok : t.fail,
                  l = t.resolve,
                  u = t.reject,
                  c = t.domain;

              try {
                s ? (r || (2 == e._h && z(e), e._h = 1), !0 === s ? n = i : (c && c.enter(), n = s(i), c && (c.exit(), a = !0)), n === t.promise ? u(k("Promise-chain cycle")) : (o = M(n)) ? o.call(n, l, u) : l(n)) : u(i);
              } catch (e) {
                c && !a && c.exit(), u(e);
              }
            }; n.length > o;) {
              a(n[o++]);
            }

            e._c = [], e._n = !1, t && !e._h && D(e);
          });
        }
      },
          D = function D(e) {
        y.call(l, function () {
          var t,
              n,
              i,
              r = e._v,
              o = P(e);
          if (o && (t = b(function () {
            O ? T.emit("unhandledRejection", r, e) : (n = l.onunhandledrejection) ? n({
              promise: e,
              reason: r
            }) : (i = l.console) && i.error && i.error("Unhandled promise rejection", r);
          }), e._h = O || P(e) ? 2 : 1), e._a = void 0, o && t.e) throw t.v;
        });
      },
          P = function P(e) {
        return 1 !== e._h && 0 === (e._a || e._c).length;
      },
          z = function z(e) {
        y.call(l, function () {
          var t;
          O ? T.emit("rejectionHandled", e) : (t = l.onrejectionhandled) && t({
            promise: e,
            reason: e._v
          });
        });
      },
          L = function L(e) {
        var t = this;
        t._d || (t._d = !0, (t = t._w || t)._v = e, t._s = 2, t._a || (t._a = t._c.slice()), F(t, !0));
      },
          B = function B(e) {
        var t,
            n = this;

        if (!n._d) {
          n._d = !0, n = n._w || n;

          try {
            if (n === e) throw k("Promise can't be resolved itself");
            (t = M(e)) ? _(function () {
              var i = {
                _w: n,
                _d: !1
              };

              try {
                t.call(e, u(B, i, 1), u(L, i, 1));
              } catch (e) {
                L.call(i, e);
              }
            }) : (n._v = e, n._s = 1, F(n, !1));
          } catch (e) {
            L.call({
              _w: n,
              _d: !1
            }, e);
          }
        }
      };

      A || (_E = function E(e) {
        d(this, _E, "Promise", "_h"), h(e), i.call(this);

        try {
          e(u(B, this, 1), u(L, this, 1));
        } catch (e) {
          L.call(this, e);
        }
      }, (i = function i(e) {
        this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
      }).prototype = n(114)(_E.prototype, {
        then: function then(e, t) {
          var n = I(m(this, _E));
          return n.ok = "function" != typeof e || e, n.fail = "function" == typeof t && t, n.domain = O ? T.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && F(this, !1), n.promise;
        },
        catch: function _catch(e) {
          return this.then(void 0, e);
        }
      }), o = function o() {
        var e = new i();
        this.promise = e, this.resolve = u(B, e, 1), this.reject = u(L, e, 1);
      }, v.f = I = function I(e) {
        return e === _E || e === a ? new o(e) : r(e);
      }), p(p.G + p.W + p.F * !A, {
        Promise: _E
      }), n(61)(_E, "Promise"), n(150)("Promise"), a = n(11).Promise, p(p.S + p.F * !A, "Promise", {
        reject: function reject(e) {
          var t = I(this);
          return (0, t.reject)(e), t.promise;
        }
      }), p(p.S + p.F * (s || !A), "Promise", {
        resolve: function resolve(e) {
          return x(s && this === a ? _E : this, e);
        }
      }), p(p.S + p.F * !(A && n(151)(function (e) {
        _E.all(e).catch(R);
      })), "Promise", {
        all: function all(e) {
          var t = this,
              n = I(t),
              i = n.resolve,
              r = n.reject,
              o = b(function () {
            var n = [],
                o = 0,
                a = 1;
            g(e, !1, function (e) {
              var s = o++,
                  l = !1;
              n.push(void 0), a++, t.resolve(e).then(function (e) {
                l || (l = !0, n[s] = e, --a || i(n));
              }, r);
            }), --a || i(n);
          });
          return o.e && r(o.v), n.promise;
        },
        race: function race(e) {
          var t = this,
              n = I(t),
              i = n.reject,
              r = b(function () {
            g(e, !1, function (e) {
              t.resolve(e).then(n.resolve, i);
            });
          });
          return r.e && i(r.v), n.promise;
        }
      });
    }, function (e, t) {
      e.exports = function (e, t, n) {
        var i = void 0 === n;

        switch (t.length) {
          case 0:
            return i ? e() : e.call(n);

          case 1:
            return i ? e(t[0]) : e.call(n, t[0]);

          case 2:
            return i ? e(t[0], t[1]) : e.call(n, t[0], t[1]);

          case 3:
            return i ? e(t[0], t[1], t[2]) : e.call(n, t[0], t[1], t[2]);

          case 4:
            return i ? e(t[0], t[1], t[2], t[3]) : e.call(n, t[0], t[1], t[2], t[3]);
        }

        return e.apply(n, t);
      };
    }, function (e, t, n) {
      var i = n(16),
          r = n(112).set,
          o = i.MutationObserver || i.WebKitMutationObserver,
          a = i.process,
          s = i.Promise,
          l = "process" == n(59)(a);

      e.exports = function () {
        var e,
            t,
            n,
            u = function u() {
          var i, r;

          for (l && (i = a.domain) && i.exit(); e;) {
            r = e.fn, e = e.next;

            try {
              r();
            } catch (i) {
              throw e ? n() : t = void 0, i;
            }
          }

          t = void 0, i && i.enter();
        };

        if (l) n = function n() {
          a.nextTick(u);
        };else if (!o || i.navigator && i.navigator.standalone) {
          if (s && s.resolve) {
            var c = s.resolve(void 0);

            n = function n() {
              c.then(u);
            };
          } else n = function n() {
            r.call(i, u);
          };
        } else {
          var p = !0,
              f = document.createTextNode("");
          new o(u).observe(f, {
            characterData: !0
          }), n = function n() {
            f.data = p = !p;
          };
        }
        return function (i) {
          var r = {
            fn: i,
            next: void 0
          };
          t && (t.next = r), e || (e = r, n()), t = r;
        };
      };
    }, function (e, t, n) {
      var i = n(16).navigator;
      e.exports = i && i.userAgent || "";
    }, function (e, t, n) {
      var i = n(14),
          r = n(11),
          o = n(16),
          a = n(147),
          s = n(149);
      i(i.P + i.R, "Promise", {
        finally: function _finally(e) {
          var t = a(this, r.Promise || o.Promise),
              n = "function" == typeof e;
          return this.then(n ? function (n) {
            return s(t, e()).then(function () {
              return n;
            });
          } : e, n ? function (n) {
            return s(t, e()).then(function () {
              throw n;
            });
          } : e);
        }
      });
    }, function (e, t, n) {
      var i = n(14),
          r = n(113),
          o = n(148);
      i(i.S, "Promise", {
        try: function _try(e) {
          var t = r.f(this),
              n = o(e);
          return (n.e ? t.reject : t.resolve)(n.v), t.promise;
        }
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(12),
          f = n(157),
          h = n(158),
          d = n(88),
          g = n(115),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = p.c.RendererType,
          b = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = _(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));

          return o._type = v.CANVAS, o.setCanvas(o._options.canvas || o._createCanvas()), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "_createCanvas",
          value: function value() {
            return p.i.createCanvas();
          }
        }, {
          key: "_createContext",
          value: function value() {
            var e = this._canvas.getContext("2d");

            return this._options.debug && (e = new f.a(e)), this.id = e.id = t.contextId++, this._context = e, e.renderer = this, this.emit("context", e), e;
          }
        }, {
          key: "_setupContext",
          value: function value() {
            var e = this._context;
            "imageSmoothingEnabled" in e ? e.imageSmoothingEnabled = !0 : ["moz", "webkit", "ms"].forEach(function (t) {
              e[t] && (e[t] = !0);
            }), this._defaultRenderTarget = new d.a(this._width, this._height, this._pixelRatio, this._canvas, this._context), this.setRenderTarget(this._defaultRenderTarget), this._filterManager = new g.a(this);
          }
        }, {
          key: "render",
          value: function value(e) {
            var t = this._renderTarget.getContext(),
                n = e.getParent();

            e.setParent(this._fakeObject), e.updateTransform(), e.setParent(n), t.setTransform(1, 0, 0, 1, 0, 0), t.globalAlpha = 1;
            var i = this._canvas,
                r = i.width,
                o = i.height;
            t.clearRect(0, 0, r, o), 0 !== this._clearColor.a && (t.save(), t.fillStyle = this._clearColor.toRGBA(), t.fillRect(0, 0, r, o), t.restore()), this.renderDisplayObject(e, this._renderTarget);
          }
        }, {
          key: "renderDisplayObject",
          value: function value(e, t) {
            var n = this._renderTarget;
            this._filterManager.setFilterStack(t.getFilterStack()), this.setRenderTarget(t), e.renderCanvas(this), this.setRenderTarget(n);
          }
        }, {
          key: "getCurrentRenderTarget",
          value: function value() {
            return this._renderTarget;
          }
        }, {
          key: "setRenderTarget",
          value: function value(e) {
            this._renderTarget = e;
          }
        }, {
          key: "getContext",
          value: function value() {
            return this._renderTarget.getContext();
          }
        }, {
          key: "dispose",
          value: function value() {
            this._filterManager.dispose();
          }
        }]), t;
      }(h.a);

      b.contextId = 0, b.type = "Canvas2D", t.a = b;
    }, function (e, t, n) {
      n(50), n(261), e.exports = n(11).Array.from;
    }, function (e, t, n) {
      var i = n(30),
          r = n(14),
          o = n(44),
          a = n(145),
          s = n(146),
          l = n(83),
          u = n(262),
          c = n(111);
      r(r.S + r.F * !n(151)(function (e) {
        Array.from(e);
      }), "Array", {
        from: function from(e) {
          var t,
              n,
              r,
              p,
              f = o(e),
              h = "function" == typeof this ? this : Array,
              d = arguments.length,
              g = d > 1 ? arguments[1] : void 0,
              m = void 0 !== g,
              y = 0,
              _ = c(f);

          if (m && (g = i(g, d > 2 ? arguments[2] : void 0, 2)), null == _ || h == Array && s(_)) for (n = new h(t = l(f.length)); t > y; y++) {
            u(n, y, m ? g(f[y], y) : f[y]);
          } else for (p = _.call(f), n = new h(); !(r = p.next()).done; y++) {
            u(n, y, m ? a(p, g, [r.value, y], !0) : r.value);
          }
          return n.length = y, n;
        }
      });
    }, function (e, t, n) {
      var i = n(22),
          r = n(57);

      e.exports = function (e, t, n) {
        t in e ? i.f(e, t, r(0, n)) : e[t] = n;
      };
    }, function (e, t, n) {
      var i = n(11),
          r = i.JSON || (i.JSON = {
        stringify: JSON.stringify
      });

      e.exports = function (e) {
        return r.stringify.apply(r, arguments);
      };
    }, function (e, t, n) {
      n(265), e.exports = n(11).Object.assign;
    }, function (e, t, n) {
      var i = n(14);
      i(i.S + i.F, "Object", {
        assign: n(266)
      });
    }, function (e, t, n) {
      var i = n(19),
          r = n(49),
          o = n(108),
          a = n(58),
          s = n(44),
          l = n(97),
          u = Object.assign;
      e.exports = !u || n(42)(function () {
        var e = {},
            t = {},
            n = Symbol(),
            i = "abcdefghijklmnopqrst";
        return e[n] = 7, i.split("").forEach(function (e) {
          t[e] = e;
        }), 7 != u({}, e)[n] || Object.keys(u({}, t)).join("") != i;
      }) ? function (e, t) {
        for (var n = s(e), u = arguments.length, c = 1, p = o.f, f = a.f; u > c;) {
          for (var h, d = l(arguments[c++]), g = p ? r(d).concat(p(d)) : r(d), m = g.length, y = 0; m > y;) {
            h = g[y++], i && !f.call(d, h) || (n[h] = d[h]);
          }
        }

        return n;
      } : u;
    }, function (e, t, n) {
      n(268), e.exports = n(11).Object.keys;
    }, function (e, t, n) {
      var i = n(44),
          r = n(49);
      n(103)("keys", function () {
        return function (e) {
          return r(i(e));
        };
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }

        return o(e, null, [{
          key: "head",
          value: function value(e) {
            return e[0];
          }
        }, {
          key: "tail",
          value: function value(e) {
            return e.slice(1);
          }
        }, {
          key: "last",
          value: function value(e) {
            return e[e.length - 1];
          }
        }, {
          key: "init",
          value: function value(e) {
            return e.slice(0, e.length - 1);
          }
        }, {
          key: "remove",
          value: function value(e, t) {
            return e.filter(function (e, n, i) {
              return !t(e, n, i);
            });
          }
        }, {
          key: "findIndex",
          value: function value(e, t) {
            for (var n = 0; n < e.length; n++) {
              if (t(e[n])) return n;
            }

            return -1;
          }
        }, {
          key: "find",
          value: function value(e, t) {
            for (var n = 0; n < e.length; n++) {
              if (t(e[n])) return e[n];
            }
          }
        }, {
          key: "flatten",
          value: function value(t) {
            return t.reduce(function (t, n) {
              return t.concat(Array.isArray(n) ? e.flatten(n) : n);
            }, []);
          }
        }, {
          key: "range",
          value: function value(e, t) {
            var n = [];
            if (t > e) for (var i = e; i < t; i++) {
              n.push(i);
            }
            return n;
          }
        }, {
          key: "repeat",
          value: function value(e, t) {
            for (var n = [], i = 0; i < t; i++) {
              n[i] = e;
            }

            return n;
          }
        }, {
          key: "zip",
          value: function value(e, t) {
            for (var n = Math.min(e.length, t.length), i = [], r = 0; r < n; r++) {
              i[r] = [e[r], t[r]];
            }

            return i;
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      n(62), n(50), e.exports = n(271);
    }, function (e, t, n) {
      var i = n(85),
          r = n(17)("iterator"),
          o = n(51);

      e.exports = n(11).isIterable = function (e) {
        var t = Object(e);
        return void 0 !== t[r] || "@@iterator" in t || o.hasOwnProperty(i(t));
      };
    }, function (e, t, n) {
      n(62), n(50), e.exports = n(273);
    }, function (e, t, n) {
      var i = n(28),
          r = n(111);

      e.exports = n(11).getIterator = function (e) {
        var t = r(e);
        if ("function" != typeof t) throw TypeError(e + " is not iterable!");
        return i(t.call(e));
      };
    }, function (e, t, n) {
      var i;
      /*!
       * UAParser.js v0.7.21
       * Lightweight JavaScript-based User-Agent string parser
       * https://github.com/faisalman/ua-parser-js
       *
       * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
       * Licensed under MIT License
       */

      !function (r, o) {
        var a = "model",
            s = "name",
            l = "type",
            u = "vendor",
            c = "version",
            p = "mobile",
            f = "tablet",
            h = "smarttv",
            d = {
          extend: function extend(e, t) {
            var n = {};

            for (var i in e) {
              t[i] && t[i].length % 2 == 0 ? n[i] = t[i].concat(e[i]) : n[i] = e[i];
            }

            return n;
          },
          has: function has(e, t) {
            return "string" == typeof e && -1 !== t.toLowerCase().indexOf(e.toLowerCase());
          },
          lowerize: function lowerize(e) {
            return e.toLowerCase();
          },
          major: function major(e) {
            return "string" == typeof e ? e.replace(/[^\d\.]/g, "").split(".")[0] : void 0;
          },
          trim: function trim(e) {
            return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
          }
        },
            g = {
          rgx: function rgx(e, t) {
            for (var n, i, r, o, a, s, l = 0; l < t.length && !a;) {
              var u = t[l],
                  c = t[l + 1];

              for (n = i = 0; n < u.length && !a;) {
                if (a = u[n++].exec(e)) for (r = 0; r < c.length; r++) {
                  s = a[++i], "object" == typeof (o = c[r]) && o.length > 0 ? 2 == o.length ? "function" == typeof o[1] ? this[o[0]] = o[1].call(this, s) : this[o[0]] = o[1] : 3 == o.length ? "function" != typeof o[1] || o[1].exec && o[1].test ? this[o[0]] = s ? s.replace(o[1], o[2]) : void 0 : this[o[0]] = s ? o[1].call(this, s, o[2]) : void 0 : 4 == o.length && (this[o[0]] = s ? o[3].call(this, s.replace(o[1], o[2])) : void 0) : this[o] = s || void 0;
                }
              }

              l += 2;
            }
          },
          str: function str(e, t) {
            for (var n in t) {
              if ("object" == typeof t[n] && t[n].length > 0) {
                for (var i = 0; i < t[n].length; i++) {
                  if (d.has(t[n][i], e)) return "?" === n ? void 0 : n;
                }
              } else if (d.has(t[n], e)) return "?" === n ? void 0 : n;
            }

            return e;
          }
        },
            m = {
          browser: {
            oldsafari: {
              version: {
                "1.0": "/8",
                1.2: "/1",
                1.3: "/3",
                "2.0": "/412",
                "2.0.2": "/416",
                "2.0.3": "/417",
                "2.0.4": "/419",
                "?": "/"
              }
            }
          },
          device: {
            amazon: {
              model: {
                "Fire Phone": ["SD", "KF"]
              }
            },
            sprint: {
              model: {
                "Evo Shift 4G": "7373KT"
              },
              vendor: {
                HTC: "APA",
                Sprint: "Sprint"
              }
            }
          },
          os: {
            windows: {
              version: {
                ME: "4.90",
                "NT 3.11": "NT3.51",
                "NT 4.0": "NT4.0",
                2e3: "NT 5.0",
                XP: ["NT 5.1", "NT 5.2"],
                Vista: "NT 6.0",
                7: "NT 6.1",
                8: "NT 6.2",
                8.1: "NT 6.3",
                10: ["NT 6.4", "NT 10.0"],
                RT: "ARM"
              }
            }
          }
        },
            y = {
          browser: [[/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, /(opera).+version\/([\w\.]+)/i, /(opera)[\/\s]+([\w\.]+)/i], [s, c], [/(opios)[\/\s]+([\w\.]+)/i], [[s, "Opera Mini"], c], [/\s(opr)\/([\w\.]+)/i], [[s, "Opera"], c], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i, /(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(rekonq)\/([\w\.]*)/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i], [s, c], [/(konqueror)\/([\w\.]+)/i], [[s, "Konqueror"], c], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i], [[s, "IE"], c], [/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i], [[s, "Edge"], c], [/(yabrowser)\/([\w\.]+)/i], [[s, "Yandex"], c], [/(Avast)\/([\w\.]+)/i], [[s, "Avast Secure Browser"], c], [/(AVG)\/([\w\.]+)/i], [[s, "AVG Secure Browser"], c], [/(puffin)\/([\w\.]+)/i], [[s, "Puffin"], c], [/(focus)\/([\w\.]+)/i], [[s, "Firefox Focus"], c], [/(opt)\/([\w\.]+)/i], [[s, "Opera Touch"], c], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i], [[s, "UCBrowser"], c], [/(comodo_dragon)\/([\w\.]+)/i], [[s, /_/g, " "], c], [/(windowswechat qbcore)\/([\w\.]+)/i], [[s, "WeChat(Win) Desktop"], c], [/(micromessenger)\/([\w\.]+)/i], [[s, "WeChat"], c], [/(brave)\/([\w\.]+)/i], [[s, "Brave"], c], [/(qqbrowserlite)\/([\w\.]+)/i], [s, c], [/(QQ)\/([\d\.]+)/i], [s, c], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i], [s, c], [/(baiduboxapp)[\/\s]?([\w\.]+)/i], [s, c], [/(2345Explorer)[\/\s]?([\w\.]+)/i], [s, c], [/(MetaSr)[\/\s]?([\w\.]+)/i], [s], [/(LBBROWSER)/i], [s], [/xiaomi\/miuibrowser\/([\w\.]+)/i], [c, [s, "MIUI Browser"]], [/;fbav\/([\w\.]+);/i], [c, [s, "Facebook"]], [/safari\s(line)\/([\w\.]+)/i, /android.+(line)\/([\w\.]+)\/iab/i], [s, c], [/headlesschrome(?:\/([\w\.]+)|\s)/i], [c, [s, "Chrome Headless"]], [/\swv\).+(chrome)\/([\w\.]+)/i], [[s, /(.+)/, "$1 WebView"], c], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[s, /(.+(?:g|us))(.+)/, "$1 $2"], c], [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i], [c, [s, "Android Browser"]], [/(sailfishbrowser)\/([\w\.]+)/i], [[s, "Sailfish Browser"], c], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i], [s, c], [/(dolfin)\/([\w\.]+)/i], [[s, "Dolphin"], c], [/(qihu|qhbrowser|qihoobrowser|360browser)/i], [[s, "360 Browser"]], [/((?:android.+)crmo|crios)\/([\w\.]+)/i], [[s, "Chrome"], c], [/(coast)\/([\w\.]+)/i], [[s, "Opera Coast"], c], [/fxios\/([\w\.-]+)/i], [c, [s, "Firefox"]], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i], [c, [s, "Mobile Safari"]], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i], [c, s], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [[s, "GSA"], c], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [s, [c, g.str, m.browser.oldsafari.version]], [/(webkit|khtml)\/([\w\.]+)/i], [s, c], [/(navigator|netscape)\/([\w\.-]+)/i], [[s, "Netscape"], c], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [s, c]],
          cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [["architecture", "amd64"]], [/(ia32(?=;))/i], [["architecture", d.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [["architecture", "ia32"]], [/windows\s(ce|mobile);\sppc;/i], [["architecture", "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [["architecture", /ower/, "", d.lowerize]], [/(sun4\w)[;\)]/i], [["architecture", "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [["architecture", d.lowerize]]],
          device: [[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i], [a, u, [l, f]], [/applecoremedia\/[\w\.]+ \((ipad)/], [a, [u, "Apple"], [l, f]], [/(apple\s{0,1}tv)/i], [[a, "Apple TV"], [u, "Apple"], [l, h]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad)/i, /(hp).+(tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [u, a, [l, f]], [/(kf[A-z]+)\sbuild\/.+silk\//i], [a, [u, "Amazon"], [l, f]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i], [[a, g.str, m.device.amazon.model], [u, "Amazon"], [l, p]], [/android.+aft([bms])\sbuild/i], [a, [u, "Amazon"], [l, h]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [a, u, [l, p]], [/\((ip[honed|\s\w*]+);/i], [a, [u, "Apple"], [l, p]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [u, a, [l, p]], [/\(bb10;\s(\w+)/i], [a, [u, "BlackBerry"], [l, p]], [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i], [a, [u, "Asus"], [l, f]], [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i], [[u, "Sony"], [a, "Xperia Tablet"], [l, f]], [/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [a, [u, "Sony"], [l, p]], [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i], [u, a, [l, "console"]], [/android.+;\s(shield)\sbuild/i], [a, [u, "Nvidia"], [l, "console"]], [/(playstation\s[34portablevi]+)/i], [a, [u, "Sony"], [l, "console"]], [/(sprint\s(\w+))/i], [[u, g.str, m.device.sprint.vendor], [a, g.str, m.device.sprint.model], [l, p]], [/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i], [u, [a, /_/g, " "], [l, p]], [/(nexus\s9)/i], [a, [u, "HTC"], [l, f]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i], [a, [u, "Huawei"], [l, p]], [/android.+(bah2?-a?[lw]\d{2})/i], [a, [u, "Huawei"], [l, f]], [/(microsoft);\s(lumia[\s\w]+)/i], [u, a, [l, p]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i], [a, [u, "Microsoft"], [l, "console"]], [/(kin\.[onetw]{3})/i], [[a, /\./g, " "], [u, "Microsoft"], [l, p]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [a, [u, "Motorola"], [l, p]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [a, [u, "Motorola"], [l, f]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i], [[u, d.trim], [a, d.trim], [l, h]], [/hbbtv.+maple;(\d+)/i], [[a, /^/, "SmartTV"], [u, "Samsung"], [l, h]], [/\(dtv[\);].+(aquos)/i], [a, [u, "Sharp"], [l, h]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[u, "Samsung"], a, [l, f]], [/smart-tv.+(samsung)/i], [u, [l, h], a], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[u, "Samsung"], a, [l, p]], [/sie-(\w*)/i], [a, [u, "Siemens"], [l, p]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]*)/i], [[u, "Nokia"], a, [l, p]], [/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i], [a, [u, "Acer"], [l, f]], [/android.+([vl]k\-?\d{3})\s+build/i], [a, [u, "LG"], [l, f]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i], [[u, "LG"], a, [l, f]], [/(lg) netcast\.tv/i], [u, a, [l, h]], [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [a, [u, "LG"], [l, p]], [/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i], [u, a, [l, f]], [/android.+(ideatab[a-z0-9\-\s]+)/i], [a, [u, "Lenovo"], [l, f]], [/(lenovo)[_\s-]?([\w-]+)/i], [u, a, [l, p]], [/linux;.+((jolla));/i], [u, a, [l, p]], [/((pebble))app\/[\d\.]+\s/i], [u, a, [l, "wearable"]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i], [u, a, [l, p]], [/crkey/i], [[a, "Chromecast"], [u, "Google"], [l, h]], [/android.+;\s(glass)\s\d/i], [a, [u, "Google"], [l, "wearable"]], [/android.+;\s(pixel c)[\s)]/i], [a, [u, "Google"], [l, f]], [/android.+;\s(pixel( [23])?( xl)?)[\s)]/i], [a, [u, "Google"], [l, p]], [/android.+;\s(\w+)\s+build\/hm\1/i, /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i], [[a, /_/g, " "], [u, "Xiaomi"], [l, p]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i], [[a, /_/g, " "], [u, "Xiaomi"], [l, f]], [/android.+;\s(m[1-5]\snote)\sbuild/i], [a, [u, "Meizu"], [l, p]], [/(mz)-([\w-]{2,})/i], [[u, "Meizu"], a, [l, p]], [/android.+a000(1)\s+build/i, /android.+oneplus\s(a\d{4})[\s)]/i], [a, [u, "OnePlus"], [l, p]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i], [a, [u, "RCA"], [l, f]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i], [a, [u, "Dell"], [l, f]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i], [a, [u, "Verizon"], [l, f]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i], [[u, "Barnes & Noble"], a, [l, f]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i], [a, [u, "NuVision"], [l, f]], [/android.+;\s(k88)\sbuild/i], [a, [u, "ZTE"], [l, f]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i], [a, [u, "Swiss"], [l, p]], [/android.+[;\/]\s*(zur\d{3})\s+build/i], [a, [u, "Swiss"], [l, f]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i], [a, [u, "Zeki"], [l, f]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i], [[u, "Dragon Touch"], a, [l, f]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i], [a, [u, "Insignia"], [l, f]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i], [a, [u, "NextBook"], [l, f]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[u, "Voice"], a, [l, p]], [/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i], [[u, "LvTel"], a, [l, p]], [/android.+;\s(PH-1)\s/i], [a, [u, "Essential"], [l, p]], [/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i], [a, [u, "Envizen"], [l, f]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i], [u, a, [l, f]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i], [a, [u, "MachSpeed"], [l, f]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i], [u, a, [l, f]], [/android.+[;\/]\s*TU_(1491)\s+build/i], [a, [u, "Rotor"], [l, f]], [/android.+(KS(.+))\s+build/i], [a, [u, "Amazon"], [l, f]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i], [u, a, [l, f]], [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i], [[l, d.lowerize], u, a], [/[\s\/\(](smart-?tv)[;\)]/i], [[l, h]], [/(android[\w\.\s\-]{0,9});.+build/i], [a, [u, "Generic"]]],
          engine: [[/windows.+\sedge\/([\w\.]+)/i], [c, [s, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [c, [s, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [s, c], [/rv\:([\w\.]{1,9}).+(gecko)/i], [c, s]],
          os: [[/microsoft\s(windows)\s(vista|xp)/i], [s, c], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [s, [c, g.str, m.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[s, "Windows"], [c, g.str, m.os.windows.version]], [/\((bb)(10);/i], [[s, "BlackBerry"], c], [/(blackberry)\w*\/?([\w\.]*)/i, /(tizen|kaios)[\/\s]([\w\.]+)/i, /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i], [s, c], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i], [[s, "Symbian"], c], [/\((series40);/i], [s], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[s, "Firefox OS"], c], [/(nintendo|playstation)\s([wids34portablevu]+)/i, /(mint)[\/\s\(]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i], [s, c], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[s, "Chromium OS"], c], [/(sunos)\s?([\w\.\d]*)/i], [[s, "Solaris"], c], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i], [s, c], [/(haiku)\s(\w+)/i], [s, c], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i], [[c, /_/g, "."], [s, "iOS"]], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i], [[s, "Mac OS"], [c, /_/g, "."]], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, /(unix)\s?([\w\.]*)/i], [s, c]]
        },
            _ = function _(e, t) {
          if ("object" == typeof e && (t = e, e = void 0), !(this instanceof _)) return new _(e, t).getResult();
          var n = e || (r && r.navigator && r.navigator.userAgent ? r.navigator.userAgent : ""),
              i = t ? d.extend(y, t) : y;
          return this.getBrowser = function () {
            var e = {
              name: void 0,
              version: void 0
            };
            return g.rgx.call(e, n, i.browser), e.major = d.major(e.version), e;
          }, this.getCPU = function () {
            var e = {
              architecture: void 0
            };
            return g.rgx.call(e, n, i.cpu), e;
          }, this.getDevice = function () {
            var e = {
              vendor: void 0,
              model: void 0,
              type: void 0
            };
            return g.rgx.call(e, n, i.device), e;
          }, this.getEngine = function () {
            var e = {
              name: void 0,
              version: void 0
            };
            return g.rgx.call(e, n, i.engine), e;
          }, this.getOS = function () {
            var e = {
              name: void 0,
              version: void 0
            };
            return g.rgx.call(e, n, i.os), e;
          }, this.getResult = function () {
            return {
              ua: this.getUA(),
              browser: this.getBrowser(),
              engine: this.getEngine(),
              os: this.getOS(),
              device: this.getDevice(),
              cpu: this.getCPU()
            };
          }, this.getUA = function () {
            return n;
          }, this.setUA = function (e) {
            return n = e, this;
          }, this;
        };

        _.VERSION = "0.7.21", _.BROWSER = {
          NAME: s,
          MAJOR: "major",
          VERSION: c
        }, _.CPU = {
          ARCHITECTURE: "architecture"
        }, _.DEVICE = {
          MODEL: a,
          VENDOR: u,
          TYPE: l,
          CONSOLE: "console",
          MOBILE: p,
          SMARTTV: h,
          TABLET: f,
          WEARABLE: "wearable",
          EMBEDDED: "embedded"
        }, _.ENGINE = {
          NAME: s,
          VERSION: c
        }, _.OS = {
          NAME: s,
          VERSION: c
        }, void 0 !== t ? (void 0 !== e && e.exports && (t = e.exports = _), t.UAParser = _) : void 0 === (i = function () {
          return _;
        }.call(t, n, t, e)) || (e.exports = i);
        var v = r && (r.jQuery || r.Zepto);

        if (v && !v.ua) {
          var b = new _();
          v.ua = b.getResult(), v.ua.get = function () {
            return b.getUA();
          }, v.ua.set = function (e) {
            b.setUA(e);
            var t = b.getResult();

            for (var n in t) {
              v.ua[n] = t[n];
            }
          };
        }
      }("object" == typeof window ? window : this);
    }, function (e, t, n) {
      var i = {
        defaults: function defaults(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
            n[i - 1] = arguments[i];
          }

          var r = {};

          for (var o in e) {
            r[o] = e[o];
          }

          for (var a = 0; a < n.length; a++) {
            var s = n[a];

            for (var l in s) {
              void 0 === r[l] && (r[l] = s[l]);
            }
          }

          return r;
        },
        extend: function extend(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
            n[i - 1] = arguments[i];
          }

          var r = {};

          for (var o in e) {
            r[o] = e[o];
          }

          for (var a = 0; a < n.length; a++) {
            var s = n[a];

            for (var l in s) {
              r[l] = s[l];
            }
          }

          return r;
        }
      };
      t.a = i;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(12),
          d = n(158),
          g = n(89),
          m = n(159),
          y = n(279),
          _ = n(116),
          v = n(118),
          b = n(119),
          w = n(157),
          x = n(282),
          k = n(161),
          T = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          S = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function C(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function E(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var O = h.c.RendererType,
          R = function (e) {
        function t() {
          var e;
          C(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = E(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._type = O.WEBGL, o._fakeObject = new v.a(), o._onContextLost = o._onContextLost.bind(o), o._onContextRestored = o._onContextRestored.bind(o), o.setCanvas(o._options.canvas || h.i.createCanvas()), o._cachedBlitCanvas = h.i.createCanvas(), o.shaders = o._initShaders(), o.renderers = o._initRenderers(), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), T(t, [{
          key: "_onContextLost",
          value: function value(e) {
            e.preventDefault(), h.f.warn(this.constructor.name, "WebGL context has been lost - trying to restore.");
          }
        }, {
          key: "_onContextCreationError",
          value: function value(e) {
            e.preventDefault(), h.f.warn(this.constructor.name, "Failed to create WebGL context: " + (e.statusMessage || "Unknown error"));
          }
        }, {
          key: "_onContextRestored",
          value: function value() {
            h.f.warn(this.constructor.name, "WebGL context has been restored. Clearing all textures."), this._createContext(), this._setupContext(), this.emit("context-restored");
          }
        }, {
          key: "_onBeforeContext",
          value: function value() {
            this._filterManager && this._filterManager.dispose(), this._filterManager = new b.a(this), this._currentObjectRenderer = new m.a(this);
          }
        }, {
          key: "setShader",
          value: function value(e) {
            this._currentShader = e, this._context.useProgram(e.getProgram()), this._setAttributesForShader(e);
          }
        }, {
          key: "setCanvas",
          value: function value(e) {
            this._canvas && this._removeContextEventListeners(), S(t.prototype.__proto__ || f()(t.prototype), "setCanvas", this).call(this, e), this._canvas.addEventListener && this._addContextEventListeners();
          }
        }, {
          key: "_addContextEventListeners",
          value: function value() {
            this._canvas.addEventListener("webglcontextlost", this._onContextLost), this._canvas.addEventListener("webglcontextrestored", this._onContextRestored), this._canvas.addEventListener("webglcontextcreationerror", this._onContextCreationError);
          }
        }, {
          key: "_removeContextEventListeners",
          value: function value() {
            this._canvas.removeEventListener("webglcontextlost", this._onContextLost), this._canvas.removeEventListener("webglcontextrestored", this._onContextRestored), this._canvas.removeEventListener("webglcontextcreationerror", this._onContextCreationError);
          }
        }, {
          key: "_setAttributesForShader",
          value: function value(e) {
            var t = this._context,
                n = e.getAttributes(),
                i = e.getAttributeLocations();
            n.forEach(function (e) {
              var n = i[e];
              t.enableVertexAttribArray(n);
            });
          }
        }, {
          key: "_initShaders",
          value: function value() {
            return {
              default: new _.a(this)
            };
          }
        }, {
          key: "_initRenderers",
          value: function value() {
            return {
              sprite: new y.a(this)
            };
          }
        }, {
          key: "_createContext",
          value: function value() {
            var e = this._canvas,
                n = null,
                i = {
              preserveDrawingBuffer: !0
            };
            return n = e.getContext("webgl", i) || e.getContext("experimental-webgl", i), "undefined" != typeof window && window.WebGLDebugUtils && this._options.debug && (n = window.WebGLDebugUtils.makeDebugContext(n, null, function (e, t) {
              console.error("gl." + e + "(" + window.WebGLDebugUtils.glFunctionArgsToString(e, t) + ")");
            })), this._options.debug && (n = new w.a(n), n = new x.a(n)), this.id = n.id = t.contextId++, this._context = n, n.renderer = this, this._maxTextureSize = n.getParameter(n.MAX_TEXTURE_SIZE), this.emit("context", n), n;
          }
        }, {
          key: "_setupContext",
          value: function value() {
            var e = this._context;
            e.disable(e.DEPTH_TEST), e.disable(e.CULL_FACE), e.enable(e.BLEND), e.blendFunc(e.ONE, e.ONE_MINUS_SRC_ALPHA), this._defaultRenderTarget = new g.a(this, this._width, this._height, this._pixelRatio, !0), this.setRenderTarget(this._defaultRenderTarget), this._getMaxPrecision();
          }
        }, {
          key: "_getMaxPrecision",
          value: function value() {
            var e = this._context,
                t = e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT);
            this._maxFloatPrecision = 0 !== t.precision ? "highp" : "mediump";
            var n = e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_INT);
            this._maxIntPrecision = 0 !== n.rangeMax ? "highp" : "lowp";
          }
        }, {
          key: "resizeTo",
          value: function value(e) {
            var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            S(t.prototype.__proto__ || f()(t.prototype), "resizeTo", this).call(this, e, n), this._currentRenderTarget && this._currentRenderTarget.resizeTo(e);
          }
        }, {
          key: "setRenderTarget",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._defaultRenderTarget;
            this._currentRenderTarget = e, this._currentRenderTarget.activate();
          }
        }, {
          key: "setObjectRenderer",
          value: function value(e) {
            this._currentObjectRenderer.stop(), this._currentObjectRenderer = e, this._currentObjectRenderer.start();
          }
        }, {
          key: "render",
          value: function value(e) {
            this.setRenderTarget(this._defaultRenderTarget), this._defaultRenderTarget.clear(this._clearColor);
            var t = e.getParent();
            e.setParent(this._fakeObject), e.updateTransform(), e.setParent(t), this.renderDisplayObject(e, this._defaultRenderTarget);
          }
        }, {
          key: "renderDisplayObject",
          value: function value(e, t) {
            this.setRenderTarget(t), this._filterManager.setFilterStack(t.getFilterStack()), e.renderWebGL(this), this._currentObjectRenderer.flush();
          }
        }, {
          key: "clear",
          value: function value() {
            var e = this._context;
            e.clearColor.apply(e, this._clearColor.toGLColor()), e.clear(e.COLOR_BUFFER_BIT);
          }
        }, {
          key: "save",
          value: function value() {
            return {
              renderTarget: this._currentRenderTarget,
              objectRenderer: this._currentObjectRenderer,
              filterStack: this._filterManager.getFilterStack()
            };
          }
        }, {
          key: "restore",
          value: function value(e) {
            this.setRenderTarget(e.renderTarget), this._filterManager.setFilterStack(e.filterStack), this._currentObjectRenderer = e.objectRenderer;
          }
        }, {
          key: "getOrCreateGLTexture",
          value: function value(e) {
            var t = this._context,
                n = e.getGLTextureForRenderer(this);
            return n || (n = t.createTexture(), e.setGLTextureForRenderer(n, this)), n;
          }
        }, {
          key: "updateTexture",
          value: function value(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                n = e.getSource(),
                i = !!n,
                r = this._context,
                o = e.getGLUnit(),
                a = this.getOrCreateGLTexture(e);
            if (r.activeTexture(r.TEXTURE0 + o), r.bindTexture(r.TEXTURE_2D, a), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), t && i) if (n instanceof k.a) r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, n.width, n.height, 0, r.RGBA, r.UNSIGNED_BYTE, n.data);else {
              var s = h.i.convertHtmlImageToRGBACanvas(n, this._cachedBlitCanvas);
              r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, r.RGBA, r.UNSIGNED_BYTE, s);
            }
            e.isMipMappingEnabled() ? r.generateMipmap(r.TEXTURE_2D) : (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, e.getGLRepeat(r, "x")), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, e.getGLRepeat(r, "y"))), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, e.getGLFilter(r, "min")), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, e.getGLFilter(r, "mag")), r.activeTexture(r.TEXTURE0);
          }
        }, {
          key: "getMaxDimensions",
          value: function value() {
            var e = this.maxTextureDimensions;

            if (void 0 === e) {
              var t = h.i.createCanvas(),
                  n = t.getContext("webgl") || t.getContext("experimental-webgl");

              if (n) {
                var i = n.getParameter(n.MAX_TEXTURE_SIZE),
                    r = n.getExtension("WEBGL_lose_context");
                r && r.loseContext(), e = i;
              } else e = null;

              this.maxTextureDimensions = e;
            }

            return e;
          }
        }, {
          key: "getCurrentRenderTarget",
          value: function value() {
            return this._currentRenderTarget;
          }
        }, {
          key: "getCurrentObjectRenderer",
          value: function value() {
            return this._currentObjectRenderer;
          }
        }, {
          key: "getMaxFloatPrecision",
          value: function value() {
            return this._maxFloatPrecision;
          }
        }, {
          key: "getMaxIntPrecision",
          value: function value() {
            return this._maxIntPrecision;
          }
        }, {
          key: "dispose",
          value: function value() {
            for (var e in this._filterManager.dispose(), this._currentObjectRenderer.dispose(), this._defaultRenderTarget.dispose(), this.shaders) {
              this.shaders[e].dispose(), delete this.shaders[e];
            }

            this._removeContextEventListeners();

            var t = this._context.getExtension("WEBGL_lose_context");

            t && t.loseContext();
          }
        }], [{
          key: "isSupported",
          value: function value() {
            var e = h.i.createCanvas();
            e.addEventListener("webglcontextcreationerror", this.prototype._onContextCreationError);
            var t = e.getContext("webgl") || e.getContext("experimental-webgl"),
                n = !!t;

            if (n) {
              var i = h.e.determineGPUName(t);
              n &= !h.e.isGPUBlacklisted(i);
            }

            return e.removeEventListener("webglcontextcreationerror", this.prototype._onContextCreationError), n;
          }
        }]), t;
      }(d.a);

      R.contextId = 0, R.type = "WebGL", t.a = R;
    }, function (e, t, n) {
      n(278);
      var i = n(11).Object;

      e.exports = function (e, t) {
        return i.getOwnPropertyDescriptor(e, t);
      };
    }, function (e, t, n) {
      var i = n(35),
          r = n(96).f;
      n(103)("getOwnPropertyDescriptor", function () {
        return function (e, t) {
          return r(i(e), t);
        };
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(12),
          d = n(159),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = y(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          o._maxBatchSize = h.a, o._vertices = new ArrayBuffer(4 * h.a * h.j), o._positions = new Float32Array(o._vertices), o._colors = new Uint32Array(o._vertices), o._indices = new Uint16Array(6 * h.a);

          for (var a = 0, s = 0; a < 6 * h.a; a += 6, s += 4) {
            o._indices[a + 0] = s + 0, o._indices[a + 1] = s + 1, o._indices[a + 2] = s + 2, o._indices[a + 3] = s + 0, o._indices[a + 4] = s + 2, o._indices[a + 5] = s + 3;
          }

          return o._shaders = [], o._sprites = [], o._currentBatchSize = 0, o._onContextChange(), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "render",
          value: function value(e) {
            var t = e.getTexture(),
                n = t.getFrame();
            t.getBaseTexture(), this._currentBatchSize >= this._maxBatchSize && this.flush();
            var i = t.getUVs();

            if (i) {
              var r = this._currentBatchSize * h.j;
              this._addVertexCoordinates(e, r, n), this._addTextureUVs(e, r, i), this._addColors(e, r), this._sprites[this._currentBatchSize] = e, this._currentBatchSize++;
            }
          }
        }, {
          key: "_addColors",
          value: function value(e, t) {
            var n = this._colors,
                i = e.getTint(),
                r = (i >> 16) + (65280 & i) + ((255 & i) << 16) + (255 * e.getWorldAlpha() << 24);
            n[t + 4] = n[t + 9] = n[t + 14] = n[t + 19] = r;
          }
        }, {
          key: "_addTextureUVs",
          value: function value(e, t, n) {
            var i = this._positions,
                r = n.getUVsAt(0);
            i[t + 2] = r.x, i[t + 3] = r.y, r = n.getUVsAt(1), i[t + 7] = r.x, i[t + 8] = r.y, r = n.getUVsAt(2), i[t + 12] = r.x, i[t + 13] = r.y, r = n.getUVsAt(3), i[t + 17] = r.x, i[t + 18] = r.y;
          }
        }, {
          key: "_addVertexCoordinates",
          value: function value(e, t, n) {
            for (var i = this._positions, r = e.getWorldTransform(), o = e.getAnchor(), a = r.rectangleToCoordinates(n, o), s = 0; s < 4; s++) {
              i[t + 5 * s] = a[s].x, i[t + 5 * s + 1] = a[s].y;
            }
          }
        }, {
          key: "_onContextChange",
          value: function value() {
            var e = this._renderer.getContext();

            this._shader = this._renderer.shaders.default, this._vertexBuffer && (this._vertexBuffer = null), this._indexBuffer && (this._indexBuffer = null), this._vertexBuffer = e.createBuffer(), this._indexBuffer = e.createBuffer(), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this._indexBuffer), e.bufferData(e.ELEMENT_ARRAY_BUFFER, this._indices, e.STATIC_DRAW), e.bindBuffer(e.ARRAY_BUFFER, this._vertexBuffer), e.bufferData(e.ARRAY_BUFFER, this._vertices, e.DYNAMIC_DRAW);
          }
        }, {
          key: "start",
          value: function value() {
            this._shader.setupBuffers(this._vertexBuffer, this._indexBuffer);
          }
        }, {
          key: "flush",
          value: function value() {
            var e = this._renderer,
                t = e.getContext();

            if (0 !== this._currentBatchSize) {
              if (this._currentBatchSize > .5 * h.a) t.bufferSubData(t.ARRAY_BUFFER, 0, this._vertices);else {
                var n = this._positions.subarray(0, this._currentBatchSize * h.j);

                t.bufferSubData(t.ARRAY_BUFFER, 0, n);
              }

              for (var i = 0, r = null, o = null, a = null, s = null, l = !1, u = null, c = 0, p = 0, f = this._currentBatchSize; p < f; p++) {
                if (o = (u = this._sprites[p]).getTexture().getBaseTexture(), l = a !== (s = u.getShader() || this._shader), (r !== o || l) && (this._renderBatch(r, i, c), c = p, i = 0, r = o, l)) {
                  a = s, e.setShader(a);
                  var d = e.getCurrentRenderTarget().getProjectionMatrix().toArray();
                  a.setUniform("u_projMatrix", d), a.syncUniforms(), t.activeTexture(t.TEXTURE0);
                }

                i++;
              }

              this._renderBatch(r, i, c), this._currentBatchSize = 0, this._sprites = [];
            }
          }
        }, {
          key: "_renderBatch",
          value: function value(e, t, n) {
            if (0 !== t) {
              var i = this._renderer,
                  r = i.getContext(),
                  o = e.getGLTextureForRenderer(i);
              o || (o = i.getOrCreateGLTexture(e)), e.isDirty() && (i.updateTexture(e), e.setDirty(!1)), r.activeTexture(r.TEXTURE0 + e.getGLUnit()), r.bindTexture(r.TEXTURE_2D, o);
              var a = 6 * t,
                  s = 6 * n * 2;
              r.drawElements(r.TRIANGLES, a, r.UNSIGNED_SHORT, s);
            }
          }
        }, {
          key: "dispose",
          value: function value() {
            var e = this._renderer.getContext();

            for (var n in this._sprites) {
              n.dispose();
            }

            this._vertexBuffer && (e.deleteBuffer(this._vertexBuffer), this._vertexBuffer = null), this._indexBuffer && (e.deleteBuffer(this._indexBuffer), this._indexBuffer = null), this._vertices = null, this._positions = null, this._colors = null, this._indices = null, function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this);
          }
        }]), t;
      }(d.a);

      t.a = _;
    }, function (e, t) {
      e.exports = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nattribute vec4 a_color;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\nuniform mat3 u_projMatrix;\n\nvoid main() {\n  gl_Position = vec4((u_projMatrix * vec3(a_position, 1)).xy, 0, 1);\n  v_texCoord = a_texCoord;\n  v_color = vec4(a_color.rgb * a_color.a, a_color.a);\n}\n";
    }, function (e, t) {
      e.exports = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\n\nvoid main() {\n  gl_FragColor = texture2D(u_image, v_texCoord) * v_color;\n}\n";
    }, function (e, t, n) {
      var i = n(29),
          r = n.n(i),
          o = n(25),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(39),
          c = n.n(u),
          p = n(283),
          f = n.n(p),
          h = function h(e, t) {
        if (Array.isArray(e)) return e;
        if (r()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var s, l = a()(e); !(i = (s = l.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && l.return && l.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          g = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._context = t, this._domAvailable = "undefined" != typeof document, this._hookIntoContext(), this._textures = {}, this._framebuffers = {}, this._programs = {}, this._shaders = {}, this._buffers = {}, this._boundTexture = null, this._id = 0, this._enums = {}, this._setupStats(), this._createEnumMap(), this._updateMemoryStats = this._updateMemoryStats.bind(this), this._updateMemoryStats();
        }

        return d(e, [{
          key: "_createEnumMap",
          value: function value() {
            for (var e in this._context) {
              var t = this._context[e];
              "number" == typeof t && (this._enums[t] = e);
            }
          }
        }, {
          key: "_enumValueToString",
          value: function value(e) {
            var t = this._enums[e];
            return void 0 === t ? e : t;
          }
        }, {
          key: "_setupStats",
          value: function value() {
            this._domAvailable && (this._stats = new f.a(), this._stats.showPanel(3), this._memPanel = this._stats.addPanel(new f.a.Panel("MB [WebGL]", "#43ADEB", "#282828")), this._texPanel = this._stats.addPanel(new f.a.Panel("Textures", "#43ADEB", "#282828")), this._bufPanel = this._stats.addPanel(new f.a.Panel("Buffers", "#43ADEB", "#282828")), this._fboPanel = this._stats.addPanel(new f.a.Panel("FBOs", "#43ADEB", "#282828")), this._prgPanel = this._stats.addPanel(new f.a.Panel("Programs", "#43ADEB", "#282828")), this._shdPanel = this._stats.addPanel(new f.a.Panel("Shaders", "#43ADEB", "#282828")));
          }
        }, {
          key: "_updatePanel",
          value: function value(e) {
            if (this._domAvailable) {
              switch (this._stats.begin(), e) {
                case "tex":
                  this._texPanel.update(this.getTexturesCount(), 50);

                  break;

                case "buf":
                  this._bufPanel.update(this.getBuffersCount(), 50);

                  break;

                case "fbo":
                  this._fboPanel.update(this.getFBOCount(), 50);

                  break;

                case "prg":
                  this._prgPanel.update(this.getProgramCount(), 50);

                  break;

                case "shd":
                  this._shdPanel.update(this.getShaderCount(), 50);

              }

              this._stats.end();
            }
          }
        }, {
          key: "getTexturesCount",
          value: function value() {
            return c()(this._textures).length;
          }
        }, {
          key: "getBuffersCount",
          value: function value() {
            return c()(this._buffers).length;
          }
        }, {
          key: "getFBOCount",
          value: function value() {
            return c()(this._framebuffers).length;
          }
        }, {
          key: "getProgramCount",
          value: function value() {
            return c()(this._programs).length;
          }
        }, {
          key: "getShaderCount",
          value: function value() {
            return c()(this._shaders).length;
          }
        }, {
          key: "_updateMemoryStats",
          value: function value() {
            if (this._domAvailable) {
              var e = this._getMemoryUsage() / 1e3 / 1e3;
              this._memPanel.update(e, 400), setTimeout(this._updateMemoryStats, 1e3);
            }
          }
        }, {
          key: "_getMemoryUsage",
          value: function value() {
            var e = 0;

            for (var t in this._textures) {
              e += this._textures[t].memory;
            }

            for (var n in this._buffers) {
              e += this._buffers[n].memory;
            }

            return e;
          }
        }, {
          key: "_hookIntoContext",
          value: function value() {
            var e = this,
                t = function t(_t5) {
              "function" == typeof e._context[_t5] ? e[_t5] = function () {
                for (var e = this._context[_t5], n = arguments.length, i = Array(n), r = 0; r < n; r++) {
                  i[r] = arguments[r];
                }

                return this._trackGLCall(e, _t5, i);
              } : e._makePropertyWrapper(_t5);
            };

            for (var n in this._context) {
              t(n);
            }
          }
        }, {
          key: "_makePropertyWrapper",
          value: function value(e) {
            if (-1 === ["_context"].indexOf(e)) {
              var t = this._context;
              this.__defineGetter__(e, function () {
                return t[e];
              }), this.__defineSetter__(e, function (n) {
                t[e] = n;
              });
            }
          }
        }, {
          key: "_trackGLCall",
          value: function value(e, t, n) {
            var i = void 0;
            i = -1 !== ["texImage2D", "bindTexture", "createTexture", "deleteTexture", "createBuffer", "bindBuffer", "bufferData", "deleteBuffer", "createFramebuffer", "deleteFramebuffer", "createProgram", "deleteProgram", "createShader", "deleteShader"].indexOf(t) ? this["_" + t](n) : e.apply(this._context, n);

            var r = this._context.getError();

            if (0 !== r) {
              var o = n.join(", ");
              o.length > 100 && (o = o.substr(0, 100) + "..."), console.error(new Error("WebGL Error " + this._enumValueToString(r) + " in " + t + "(" + o + ")"));
            }

            return i;
          }
        }, {
          key: "_createProgram",
          value: function value() {
            var e = this._context.createProgram();

            return e._wmmId = this._id++, this._programs[e._wmmId] = e, this._updatePanel("prg"), e;
          }
        }, {
          key: "_deleteProgram",
          value: function value(e) {
            var t = h(e, 1)[0];
            t && this._programs[t._wmmId] && (delete this._programs[t._wmmId], this._context.deleteProgram(t), this._updatePanel("prg"));
          }
        }, {
          key: "_createShader",
          value: function value(e) {
            var t = h(e, 1)[0],
                n = this._context.createShader(t);

            return n._wmmId = this._id++, this._shaders[n._wmmId] = n, this._updatePanel("shd"), n;
          }
        }, {
          key: "_deleteShader",
          value: function value(e) {
            var t = h(e, 1)[0];
            t && this._shaders[t._wmmId] && (delete this._shaders[t._wmmId], this._context.deleteShader(t), this._updatePanel("shd"));
          }
        }, {
          key: "_createFramebuffer",
          value: function value() {
            var e = this._context.createFramebuffer();

            return e._wmmId = this._id++, this._framebuffers[e._wmmId] = e, this._updatePanel("fbo"), e;
          }
        }, {
          key: "_deleteFramebuffer",
          value: function value(e) {
            var t = h(e, 1)[0];
            t && this._framebuffers[t._wmmId] && (delete this._framebuffers[t._wmmId], this._context.deleteFramebuffer(t), this._updatePanel("fbo"));
          }
        }, {
          key: "_createBuffer",
          value: function value() {
            var e = this._context.createBuffer();

            return e._wmmId = this._id++, this._buffers[e._wmmId] = {
              buffer: e,
              memory: 0
            }, this._updatePanel("buf"), e;
          }
        }, {
          key: "_bindBuffer",
          value: function value(e) {
            var t = h(e, 2),
                n = t[0],
                i = t[1];
            this._context.bindBuffer(n, i), this._boundBuffer = i._wmmId;
          }
        }, {
          key: "_bufferData",
          value: function value(e) {
            var t = h(e, 3),
                n = t[0],
                i = t[1],
                r = t[2];

            this._context.bufferData(n, i, r);

            var o = void 0;
            "number" == typeof i ? o = i : "byteLength" in i ? o = i.byteLength : "length" in i && (o = i.length), this._buffers[this._boundBuffer].memory = o;
          }
        }, {
          key: "_deleteBuffer",
          value: function value(e) {
            var t = h(e, 1)[0];
            t && this._buffers[t._wmmId] && (delete this._buffers[t._wmmId], this._context.deleteBuffer(t), this._updatePanel("buf"));
          }
        }, {
          key: "_createTexture",
          value: function value() {
            var e = this._context.createTexture();

            return e._wmmId = this._id++, this._textures[e._wmmId] = {
              texture: e,
              memory: 0
            }, this._updatePanel("tex"), e;
          }
        }, {
          key: "_deleteTexture",
          value: function value(e) {
            var t = h(e, 1)[0];
            t && this._textures[t._wmmId] && (delete this._textures[t._wmmId], this._context.deleteTexture(t), this._updatePanel("tex"));
          }
        }, {
          key: "_bindTexture",
          value: function value(e) {
            var t = h(e, 2),
                n = t[0],
                i = t[1];
            this._context.bindTexture(n, i), this._boundTexture = i._wmmId;
          }
        }, {
          key: "_texImage2D",
          value: function value(e) {
            var t = h(e, 9),
                n = t[2],
                i = t[3],
                r = t[4],
                o = t[5],
                a = t[8];
            void 0 === a && (a = o), this._context.texImage2D.apply(this._context, e);

            var s = this._calculateByteCountForTexture(n, i, r, a);

            this._textures[this._boundTexture].memory = s;
          }
        }, {
          key: "_calculateByteCountForTexture",
          value: function value(e, t, n, i) {
            if (null !== i) {
              if (!("width" in i)) return i.length;
              t = i.width, n = i.height;
            }

            var r = 1;

            switch (e) {
              case this._context.ALPHA:
                r = 1;
                break;

              case this._context.RGB:
                r = 3;
                break;

              case this._context.RGBA:
                r = 4;
            }

            return t * n * r;
          }
        }]), e;
      }();

      t.a = g;
    }, function (e, t) {
      var n = function n() {
        function e(e) {
          return r.appendChild(e.dom), e;
        }

        function t(e) {
          for (var t = 0; t < r.children.length; t++) {
            r.children[t].style.display = t === e ? "block" : "none";
          }

          i = e;
        }

        var i = 0,
            r = document.createElement("div");
        r.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000", r.addEventListener("click", function (e) {
          e.preventDefault(), t(++i % r.children.length);
        }, !1);
        var o = (performance || Date).now(),
            a = o,
            s = 0,
            l = e(new n.Panel("FPS", "#0ff", "#002")),
            u = e(new n.Panel("MS", "#0f0", "#020"));
        if (self.performance && self.performance.memory) var c = e(new n.Panel("MB", "#f08", "#201"));
        return t(0), {
          REVISION: 16,
          dom: r,
          addPanel: e,
          showPanel: t,
          begin: function begin() {
            o = (performance || Date).now();
          },
          end: function end() {
            s++;
            var e = (performance || Date).now();

            if (u.update(e - o, 200), e > a + 1e3 && (l.update(1e3 * s / (e - a), 100), a = e, s = 0, c)) {
              var t = performance.memory;
              c.update(t.usedJSHeapSize / 1048576, t.jsHeapSizeLimit / 1048576);
            }

            return e;
          },
          update: function update() {
            o = this.end();
          },
          domElement: r,
          setMode: t
        };
      };

      n.Panel = function (e, t, n) {
        var i = 1 / 0,
            r = 0,
            o = Math.round,
            a = o(window.devicePixelRatio || 1),
            s = 80 * a,
            l = 48 * a,
            u = 3 * a,
            c = 2 * a,
            p = 3 * a,
            f = 15 * a,
            h = 74 * a,
            d = 30 * a,
            g = document.createElement("canvas");
        g.width = s, g.height = l, g.style.cssText = "width:80px;height:48px";
        var m = g.getContext("2d");
        return m.font = "bold " + 9 * a + "px Helvetica,Arial,sans-serif", m.textBaseline = "top", m.fillStyle = n, m.fillRect(0, 0, s, l), m.fillStyle = t, m.fillText(e, u, c), m.fillRect(p, f, h, d), m.fillStyle = n, m.globalAlpha = .9, m.fillRect(p, f, h, d), {
          dom: g,
          update: function update(l, y) {
            i = Math.min(i, l), r = Math.max(r, l), m.fillStyle = n, m.globalAlpha = 1, m.fillRect(0, 0, s, f), m.fillStyle = t, m.fillText(o(l) + " " + e + " (" + o(i) + "-" + o(r) + ")", u, c), m.drawImage(g, p + a, f, h - a, d, p, f, h - a, d), m.fillRect(p + h - a, f, a, d), m.fillStyle = n, m.globalAlpha = .9, m.fillRect(p + h - a, f, a, o((1 - l / y) * d));
          }
        };
      }, "object" == typeof e && (e.exports = n);
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(12),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._uvs = [new o.k(0, 0), new o.k(1, 0), new o.k(1, 1), new o.k(0, 1)];
        }

        return a(e, [{
          key: "update",
          value: function value(e, t) {
            var n = this._uvs[0];
            n.x = e.x / t.width, n.y = e.y / t.height, (n = this._uvs[1]).x = (e.x + e.width) / t.width, n.y = e.y / t.height, (n = this._uvs[2]).x = (e.x + e.width) / t.width, n.y = (e.y + e.height) / t.height, (n = this._uvs[3]).x = e.x / t.width, n.y = (e.y + e.height) / t.height;
          }
        }, {
          key: "getUVsAt",
          value: function value(e) {
            return this._uvs[e];
          }
        }, {
          key: "getUVs",
          value: function value() {
            return this._uvs;
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(12),
          d = n(163),
          g = n(68),
          m = n(89),
          y = n(88),
          _ = n(119),
          v = n(115),
          b = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function w(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var k = h.c.RendererType,
          T = function (e) {
        function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 100,
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
          w(this, t);
          var o = x(this, (t.__proto__ || f()(t)).call(this, new g.a(), new h.h(0, 0, n, i)));
          return o._loaded = !0, o._width = n, o._height = i, o._pixelRatio = r, o._renderer = e, o._setupFilterManager(), o._setupBuffer(), o.setBaseTexture(o._renderTarget.getBaseTexture()), o._updateUVs(), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), b(t, [{
          key: "_setupFilterManager",
          value: function value() {
            this._filterManager && this._filterManager.dispose(), this._renderer.isOfType(k.WEBGL) ? this._filterManager = new _.a(this._renderer) : this._renderer.isOfType(k.CANVAS) && (this._filterManager = new v.a(this._renderer)), this._filterManager.resizeTo(new h.k(this._width, this._height));
          }
        }, {
          key: "_setupBuffer",
          value: function value() {
            this._renderer.isOfType(k.WEBGL) ? this._setupWebGLRenderTarget() : this._renderer.isOfType(k.CANVAS) && this._setupCanvasRenderTarget();
          }
        }, {
          key: "_setupWebGLRenderTarget",
          value: function value() {
            this._renderTarget && this._renderTarget.dispose(), this._renderTarget = new m.a(this._renderer, this._width, this._height, this._pixelRatio);
          }
        }, {
          key: "_setupCanvasRenderTarget",
          value: function value() {
            this._renderTarget && this._renderTarget.dispose(), this._renderTarget = new y.a(this._width, this._height, this._pixelRatio);
          }
        }, {
          key: "clear",
          value: function value(e) {
            this._renderTarget.clear(e);
          }
        }, {
          key: "resizeTo",
          value: function value(e) {
            this._width === e.x && this._height === e.y || (this._width = e.x, this._height = e.y, this._frame.width = e.x, this._frame.height = e.y, this._renderTarget.resizeTo(e), this._filterManager.resizeTo(e));
          }
        }, {
          key: "render",
          value: function value(e) {
            if (this._renderer.isOfType(k.WEBGL)) this._renderWebGL(e);else {
              if (!this._renderer.isOfType(k.CANVAS)) throw new Error("RenderTexture does not support rendering via " + this._renderer.constructor.name);

              this._renderCanvas(e);
            }
          }
        }, {
          key: "_renderWebGL",
          value: function value(e) {
            this._renderTarget.activate(), e.getWorldTransform().reset(), e.getChildren().forEach(function (e) {
              e.updateTransform();
            });

            var t = this._renderer.getFilterManager();

            this._renderer.setFilterManager(this._filterManager), this._renderer.renderDisplayObject(e, this._renderTarget), this._renderer.setFilterManager(t);
          }
        }, {
          key: "_renderCanvas",
          value: function value(e) {
            e.getWorldTransform().reset(), e.getChildren().forEach(function (e) {
              e.updateTransform();
            });

            var t = this._renderer.getFilterManager();

            this._renderer.setFilterManager(this._filterManager), this._renderer.renderDisplayObject(e, this._renderTarget), this._renderer.setFilterManager(t);
          }
        }, {
          key: "getRenderTarget",
          value: function value() {
            return this._renderTarget;
          }
        }, {
          key: "dispose",
          value: function value() {
            this._renderTarget.dispose(), this._filterManager.dispose(), function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this);
          }
        }]), t;
      }(d.a);

      t.a = T;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(12),
          f = n(162),
          h = n(287),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          g = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this));

          return n._onTextureUpdate = n._onTextureUpdate.bind(n), n._texture = e, n._shader = null, n._width = 0, n._height = 0, n._anchor = new p.k(0, 0), n._canvasSmoothingEnabled = !0, n.setTexture(e), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "_onTextureUpdate",
          value: function value() {
            this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "_renderWebGL",
          value: function value(e) {
            var t = e.save();
            this._smoothDownscaling && (this._potRenderer || (this._potRenderer = new h.a()), this._potRenderer.render(e, this, this._texture)), e.restore(t), e.setObjectRenderer(e.renderers.sprite), e.renderers.sprite.render(this);
          }
        }, {
          key: "_renderCanvas",
          value: function value(e) {
            var t = this._worldTransform,
                n = this._texture.getFrame(),
                i = n.width,
                r = n.height,
                o = e.getCurrentRenderTarget().getPixelRatio(),
                a = this._anchor.x * -i | 0,
                s = this._anchor.y * -r | 0,
                l = e.getContext();

            l.setTransform(t.a, t.b, t.c, t.d, t.tx * o, t.ty * o), l.globalAlpha = this.getWorldAlpha();

            var u = this._texture.getBaseTexture(),
                c = u.getPixelRatio(),
                p = u.getSource();

            l.imageSmoothingEnabled = this._canvasSmoothingEnabled, e.beforeDraw && e.beforeDraw(l), l.drawImage(p, 0, 0, (p.naturalWidth || i) * c, (p.naturalHeight || r) * c, a * o, s * o, i * o, r * o);
          }
        }, {
          key: "isAtPosition",
          value: function value(e) {
            var t = this._worldTransform.applyInverseToVector(e),
                n = this._texture.getFrame(),
                i = n.width,
                r = n.height,
                o = new p.k(-i, -r);

            o.multiply(this._anchor);
            var a = o.clone().add(i, r);
            return !(t.x < o.x || t.x > a.x || t.y < o.y || t.y > a.y);
          }
        }, {
          key: "getLocalBounds",
          value: function value() {
            if (this._localBoundsNeedUpdate) {
              var e = this._localBounds,
                  t = this._texture.getFrame();

              e.x = -t.width * this._anchor.x, e.y = -t.height * this._anchor.y, e.width = t.width, e.height = t.height, this._localBoundsNeedUpdate = !1;
            }

            return this._localBounds.clone();
          }
        }, {
          key: "getBounds",
          value: function value() {
            if (this._boundsNeedUpdate) {
              var e = this._bounds,
                  t = this._texture.getFrame(),
                  n = this._worldTransform,
                  i = this._anchor,
                  r = n.rectangleToCoordinates(t, i),
                  o = r[0].x,
                  a = r[0].y,
                  s = o,
                  l = a;

              r.forEach(function (e) {
                var t = e.x,
                    n = e.y;
                o = Math.min(o, t), a = Math.min(a, n), s = Math.max(s, t), l = Math.max(l, n);
              }), e.x = o, e.width = Math.abs(s - o), e.y = a, e.height = Math.abs(l - a), this._boundsNeedUpdate = !1;
            }

            return this._bounds.clone();
          }
        }, {
          key: "getTexture",
          value: function value() {
            return this._texture;
          }
        }, {
          key: "clearTexture",
          value: function value() {
            var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            this._texture && (this._texture.off("update", this._onTextureUpdate), e && this._texture.dispose(), this._texture = null, this._potRenderer && (e && this._potRenderer.dispose(), this._potRenderer = null));
          }
        }, {
          key: "setTexture",
          value: function value(e) {
            e && (this._texture && this._texture.off("update", this._onTextureUpdate), this._potRenderer && this._potRenderer.getRenderTexture().getBaseTexture().setDirty(!0), this._texture = e, e.getBaseTexture().isLoaded() && this._onTextureUpdate(), e.on("update", this._onTextureUpdate));
          }
        }, {
          key: "getShader",
          value: function value() {
            return this._shader;
          }
        }, {
          key: "setShader",
          value: function value(e) {
            this._shader = e;
          }
        }, {
          key: "getWidth",
          value: function value() {
            return this._width;
          }
        }, {
          key: "setWidth",
          value: function value(e) {
            this._scale.x = e / this._texture.getFrame().width, this._width = e, this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "getHeight",
          value: function value() {
            return this._height;
          }
        }, {
          key: "setHeight",
          value: function value(e) {
            this._scale.y = e / this._texture.getFrame().height, this._height = e, this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "getDimensions",
          value: function value() {
            return new p.k(this._width, this._height);
          }
        }, {
          key: "getAnchor",
          value: function value() {
            return this._anchor;
          }
        }, {
          key: "setAnchor",
          value: function value(e, t) {
            e instanceof p.k ? this._anchor.copy(e) : this._anchor.set(e, t), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
          }
        }, {
          key: "isSmoothDownscaling",
          value: function value() {
            return this._smoothDownscaling;
          }
        }, {
          key: "setSmoothDownscaling",
          value: function value(e) {
            this._smoothDownscaling = e;
          }
        }, {
          key: "dispose",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            this._texture && this._texture.off("update", this._onTextureUpdate), (e || t) && this._texture.dispose(t), this._potRenderer && this._potRenderer.dispose();
          }
        }]), t;
      }(f.a);

      t.a = g;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(38),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._container = new o.Engine.Container(), this._sprite = new o.Engine.Sprite(), this._container.addChild(this._sprite);
        }

        return a(e, [{
          key: "render",
          value: function value(e, t, n) {
            var i = n.getDimensions(),
                r = this._getNextHighestPOT(i);

            this._renderTexture ? this._renderTexture.resizeTo(r) : this._renderTexture = new o.Engine.RenderTexture(e, r.x, r.y);

            var a = this._renderTexture.getDimensions();

            this._sprite.setTexture(n), this._sprite.updateTransform(), this._renderTexture.clear(), this._renderTexture.render(this._container), this._updateSprite(e, t, i, a);
          }
        }, {
          key: "_updateSprite",
          value: function value(e, t, n, i) {
            t.setTexture(this._renderTexture), this._renderTexture.setFrame(new o.Rectangle(0, 0, n.x, n.y));
          }
        }, {
          key: "_getNextHighestPOT",
          value: function value(e) {
            return new o.Vector2(o.Utils.nextHighestPOT(e.x), o.Utils.nextHighestPOT(e.y));
          }
        }, {
          key: "getRenderTexture",
          value: function value() {
            return this._renderTexture;
          }
        }, {
          key: "dispose",
          value: function value() {
            this._renderTexture && (this._renderTexture.dispose(), this._renderTexture = null);
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(116);
      t.a = {
        TextureShader: i.a
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(290),
        __esModule: !0
      };
    }, function (e, t, n) {
      n(291), e.exports = n(11).setImmediate;
    }, function (e, t, n) {
      var i = n(14),
          r = n(112);
      i(i.G + i.B, {
        setImmediate: r.set,
        clearImmediate: r.clear
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(293);
      n.d(t, "UnpremultiplyFilter", function () {
        return i.a;
      });
      var r = n(295);
      n.d(t, "ColorOverlayFilter", function () {
        return r.a;
      });
      var o = n(297);
      n.d(t, "TintFilter", function () {
        return o.a;
      });
      var a = n(299);
      n.d(t, "OverlayFilter", function () {
        return a.a;
      });
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var e = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || l()(t)).call(this));

          return e._fragmentSource = n(294), e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(n(69).a);

      t.a = u;
    }, function (e, t) {
      e.exports = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(color.a > 0. ? color.rgb / color.a : vec3(0), color.a);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(12),
          f = n(69),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = p.c.OptionType,
          y = p.c.UniformType,
          _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(r)));
          return a._fragmentSource = n(296), a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = this._options.color, s = r.getImageData(0, 0, i.width, i.height), l = o.getImageData(0, 0, i.width, i.height), u = i.width * i.height, c = new p.b(), f = new p.b(), h = 0; h < 4 * u; h += 4) {
              c.set(s.data[h] / 255, s.data[h + 1] / 255, s.data[h + 2] / 255, s.data[h + 3] / 255), f.set(l.data[h] / 255, l.data[h + 1] / 255, l.data[h + 2] / 255, l.data[h + 3] / 255);
              var d = f.r + c.a * (c.r - f.r);
              l.data[h] = 255 * (d + c.a * (a.r - d));
              var g = f.g + c.a * (c.g - f.g);
              l.data[h + 1] = 255 * (g + c.a * (a.g - g));
              var m = f.b + c.a * (c.b - f.b);
              l.data[h + 2] = 255 * (m + c.a * (a.b - m));
            }

            o.putImageData(l, 0, 0);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = {
        color: {
          type: m.COLOR,
          default: p.b.WHITE,
          uniformType: y.FLOAT4
        }
      }, t.a = _;
    }, function (e, t) {
      e.exports = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform vec4 u_color;\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(mix(color.rgb, u_color.rgb, u_color.a), color.a) * color.a;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(12),
          f = n(69),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = p.c.OptionType,
          y = p.c.UniformType,
          _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(r)));
          return a._fragmentSource = n(298), a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, n, i) {
            var r = n.getCanvas(),
                o = n.getContext(),
                a = i.getContext(),
                s = o.getImageData(0, 0, r.width, r.height),
                l = this._options,
                u = l.mode,
                c = l.color,
                f = c.r,
                h = c.g,
                d = c.b,
                g = c.a,
                m = [.2125, .7154, .0721];

            switch (u) {
              case t.MODES.SOLID:
                for (var y = 0; y < r.width * r.height; y++) {
                  var _ = 4 * y;

                  s.data[_] += (255 * f - s.data[_]) * g, s.data[_ + 1] += (255 * h - s.data[_ + 1]) * g, s.data[_ + 2] += (255 * d - s.data[_ + 2]) * g;
                }

                break;

              case t.MODES.COLORIZED:
                for (var v = 0; v < r.width * r.height; v++) {
                  var b = 4 * v,
                      w = s.data[b] / 255 * m[0] + s.data[b + 1] / 255 * m[1] + s.data[b + 2] / 255 * m[2],
                      x = new p.b(w * f, w * h, w * d);
                  s.data[b] += (255 * x.r - s.data[b]) * g, s.data[b + 1] += (255 * x.g - s.data[b + 1]) * g, s.data[b + 2] += (255 * x.b - s.data[b + 2]) * g;
                }

            }

            a.putImageData(s, 0, 0);
          }
        }]), t;
      }(f.a);

      _.MODES = {
        NONE: 0,
        SOLID: 1,
        COLORIZED: 2
      }, _.prototype.availableOptions = {
        color: {
          type: m.COLOR,
          default: p.b.WHITE,
          uniformType: y.FLOAT4
        },
        mode: {
          type: m.NUMBER,
          default: _.MODES.NONE,
          uniformType: y.INT
        }
      }, t.a = _;
    }, function (e, t) {
      e.exports = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform vec4 u_color;\nuniform int u_mode;\n\nvec3 W = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  if (u_mode == 0) {\n    gl_FragColor = color * color.a;\n  } else if (u_mode == 1) {\n    gl_FragColor = vec4(mix(color.rgb, u_color.rgb, u_color.a), color.a) * color.a;\n  } else if (u_mode == 2) {\n    float luminance = dot(color.rgb, W);\n    vec3 colorized = vec3(luminance) * u_color.rgb;\n    gl_FragColor = vec4(mix(color.rgb, colorized, u_color.a), color.a) * color.a;\n  }\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(12),
          f = n(69),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = p.c.OptionType,
          y = p.c.UniformType,
          _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(r)));
          return a._fragmentSource = n(300), a._lastImage = null, a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, n, i) {
            for (var r = this._options.overlayTexture.getRenderTarget().getContext(), o = n.getCanvas(), a = n.getContext(), s = i.getContext(), l = a.getImageData(0, 0, o.width, o.height), u = r.getImageData(0, 0, o.width, o.height), c = this._options, f = c.blendMode, h = c.alpha, d = new p.b(), g = new p.b(), m = new p.b(), y = 0; y < o.width * o.height * 4; y += 4) {
              d.set(l.data[y] / 255, l.data[y + 1] / 255, l.data[y + 2] / 255, l.data[y + 3] / 255), g.set(u.data[y] / 255, u.data[y + 1] / 255, u.data[y + 2] / 255, u.data[y + 3] / 255);

              var _ = void 0,
                  v = void 0,
                  b = void 0,
                  w = void 0,
                  x = void 0,
                  k = void 0,
                  T = void 0,
                  S = void 0,
                  C = void 0;

              switch (f) {
                case t.BLEND_MODES.NORMAL:
                  m.set(d.r + g.a * h * (g.r - d.r), d.g + g.a * h * (g.g - d.g), d.b + g.a * h * (g.b - d.b), d.a);
                  break;

                case t.BLEND_MODES.OVERLAY:
                  _ = 1 - 2 * (1 - d.r) * (1 - g.r), v = 2 * d.r * g.r, b = _ + (d.r < .5 ? 1 : 0) * (v - _), w = 1 - 2 * (1 - d.g) * (1 - g.g), x = 2 * d.g * g.g, k = w + (d.g < .5 ? 1 : 0) * (x - w), T = 1 - 2 * (1 - d.b) * (1 - g.b), S = 2 * d.b * g.b, C = T + (d.b < .5 ? 1 : 0) * (S - T), m.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (k - d.g), d.b + g.a * h * (C - d.b), d.a);
                  break;

                case t.BLEND_MODES.HARD_LIGHT:
                  _ = 1 - 2 * (1 - g.r) * (1 - d.r), v = 2 * g.r * d.r, b = _ + (g.r < .5 ? 1 : 0) * (v - _), w = 1 - 2 * (1 - g.g) * (1 - d.g), x = 2 * g.g * d.g, k = w + (g.g < .5 ? 1 : 0) * (x - w), T = 1 - 2 * (1 - g.b) * (1 - d.b), S = 2 * g.b * d.b, C = T + (g.b < .5 ? 1 : 0) * (S - T), m.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (k - d.g), d.b + g.a * h * (C - d.b), d.a);
                  break;

                case t.BLEND_MODES.SOFT_LIGHT:
                  _ = 2 * d.r * (1 - g.r) + (2 * g.r - 1) * Math.sqrt(d.r), v = 2 * d.r * g.r + d.r * d.r * (1 - 2 * g.r), b = _ + (g.r < .5 ? 1 : 0) * (v - _), w = 2 * d.g * (1 - g.g) + (2 * g.g - 1) * Math.sqrt(d.g), x = 2 * d.g * g.g + d.g * d.g * (1 - 2 * g.g), k = w + (g.g < .5 ? 1 : 0) * (x - w), T = 2 * d.b * (1 - g.b) + (2 * g.b - 1) * Math.sqrt(d.b), S = 2 * d.b * g.b + d.b * d.b * (1 - 2 * g.b), C = T + (g.b < .5 ? 1 : 0) * (S - T), m.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (k - d.g), d.b + g.a * h * (C - d.b), d.a);
                  break;

                case t.BLEND_MODES.MULTIPLY:
                  b = d.r * g.r, k = d.g * g.g, C = d.b * g.b, m.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (k - d.g), d.b + g.a * h * (C - d.b), d.a);
                  break;

                case t.BLEND_MODES.DARKEN:
                  b = Math.min(d.r, g.r), k = Math.min(d.g, g.g), C = Math.min(d.b, g.b), m.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (k - d.g), d.b + g.a * h * (C - d.b), d.a);
                  break;

                case t.BLEND_MODES.LIGHTEN:
                  b = Math.max(d.r, g.r), k = Math.max(d.g, g.g), C = Math.max(d.b, g.b), m.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (k - d.g), d.b + g.a * h * (C - d.b), d.a);
                  break;

                case t.BLEND_MODES.SCREEN:
                  b = 1 - (1 - d.r) * (1 - g.r), k = 1 - (1 - d.g) * (1 - g.g), C = 1 - (1 - d.b) * (1 - g.b), m.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (k - d.g), d.b + g.a * h * (C - d.b), d.a);
                  break;

                case t.BLEND_MODES.COLOR_BURN:
                  b = Math.max(0, Math.min(1, 1 - (1 - d.r) / Math.max(g.r, 1e-6))), k = Math.max(0, Math.min(1, 1 - (1 - d.g) / Math.max(g.g, 1e-6))), C = Math.max(0, Math.min(1, 1 - (1 - d.b) / Math.max(g.b, 1e-6))), m.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (k - d.g), d.b + g.a * h * (C - d.b), d.a);
              }

              l.data[y] = 255 * m.r, l.data[y + 1] = 255 * m.g, l.data[y + 2] = 255 * m.b, l.data[y + 3] = 255 * m.a;
            }

            s.putImageData(l, 0, 0);
          }
        }]), t;
      }(f.a);

      _.BLEND_MODES = {
        NORMAL: 0,
        OVERLAY: 1,
        HARD_LIGHT: 2,
        SOFT_LIGHT: 3,
        MULTIPLY: 4,
        DARKEN: 5,
        LIGHTEN: 6,
        SCREEN: 7,
        COLOR_BURN: 8
      }, _.prototype.availableOptions = {
        blendMode: {
          type: m.NUMBER,
          default: _.BLEND_MODES.NORMAL,
          uniformType: y.INT
        },
        overlayImage: {
          type: m.NUMBER,
          required: !0,
          uniformType: y.SAMPLER2D
        },
        overlayTexture: {
          type: m.OBJECT,
          required: !0
        },
        alpha: {
          type: m.NUMBER,
          default: 1,
          uniformType: y.FLOAT
        }
      }, t.a = _;
    }, function (e, t) {
      e.exports = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform sampler2D u_overlayImage;\nuniform int u_blendMode;\nuniform float u_alpha;\n\nconst float EPSILON = 0.000001;\n\nvec4 overlay(vec4 a, vec4 b) {\n    vec3 result = mix(\n          1.0 - 2.0 * (1.0 - a.rgb) * (1.0 - b.rgb),\n          2.0 * a.rgb * b.rgb,\n          vec3(a.r < 0.5, a.g < 0.5, a.b < 0.5)\n      );\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 hardLight(vec4 b, vec4 a) {\n    vec3 result = mix(\n          1.0 - 2.0 * (1.0 - a.rgb) * (1.0 - b.rgb),\n          2.0 * a.rgb * b.rgb,\n          vec3(a.r < 0.5, a.g < 0.5, a.b < 0.5)\n      );\n    return mix(b, vec4(result, b.a), u_alpha * a.a);\n}\n\nvec4 softLight(vec4 a, vec4 b) {\n    vec3 result = mix(\n          2.0 * a.rgb * (1.0 - b.rgb) + (2.0 * b.rgb - 1.0) * sqrt(a.rgb),\n          2.0 * a.rgb * b.rgb + a.rgb * a.rgb * (1.0 - 2.0 * b.rgb),\n          vec3(b.r < 0.5, b.g < 0.5, b.b < 0.5)\n      );\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 multiply(vec4 a, vec4 b) {\n    vec3 result = a.rgb * b.rgb;\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 darken(vec4 a, vec4 b) {\n    vec3 result = min(a.rgb, b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 lighten(vec4 a, vec4 b) {\n    vec3 result = max(a.rgb, b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 screen(vec4 a, vec4 b) {\n    vec3 result = 1.0 - (1.0 - a.rgb) * (1.0 - b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 colorBurn(vec4 a, vec4 b) {\n    vec3 result = clamp(1.0 - (1.0 - a.rgb) / max(b.rgb, EPSILON), 0.0, 1.0);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 normal(vec4 a, vec4 b) {\n    return mix(a, vec4(b.rgb, a.a), u_alpha * b.a);\n}\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  vec4 overlayColor = texture2D(u_overlayImage, v_texCoord);\n\n  vec4 resultColor;\n  if (u_blendMode == 0) {\n    resultColor = normal(color, overlayColor);\n  } else if (u_blendMode == 1) {\n    resultColor = overlay(color, overlayColor);\n  } else if (u_blendMode == 2) {\n    resultColor = hardLight(color, overlayColor);\n  } else if (u_blendMode == 3) {\n    resultColor = softLight(color, overlayColor);\n  } else if (u_blendMode == 4) {\n    resultColor = multiply(color, overlayColor);\n  } else if (u_blendMode == 5) {\n    resultColor = darken(color, overlayColor);\n  } else if (u_blendMode == 6) {\n    resultColor = lighten(color, overlayColor);\n  } else if (u_blendMode == 7) {\n    resultColor = screen(color, overlayColor);\n  } else if (u_blendMode == 8) {\n    resultColor = colorBurn(color, overlayColor);\n  }\n  gl_FragColor = vec4(resultColor.rgb * resultColor.a, resultColor.a);\n}\n";
    }, function (e, t, n) {
      t.a = [{
        defaultName: "Natasha Wescoat",
        identifier: "imgly_art_filter_june_tree",
        rootPath: "art-filters/imgly_june_tree",
        thumbnail: "art-filters/imgly_june_tree/thumbnail.jpg"
      }, {
        defaultName: "Hive",
        identifier: "imgly_art_filter_hive",
        rootPath: "art-filters/imgly_hive",
        thumbnail: "art-filters/imgly_hive/thumbnail.jpg"
      }, {
        defaultName: "Udnie",
        identifier: "imgly_art_filter_udnie",
        rootPath: "art-filters/imgly_udnie",
        thumbnail: "art-filters/imgly_udnie/thumbnail.jpg"
      }, {
        defaultName: "Vince Low",
        identifier: "imgly_art_filter_vince_low",
        rootPath: "art-filters/imgly_vince_low",
        thumbnail: "art-filters/imgly_vince_low/thumbnail.jpg"
      }, {
        defaultName: "Mosaic",
        identifier: "imgly_art_filter_mosaic",
        rootPath: "art-filters/imgly_mosaic",
        thumbnail: "art-filters/imgly_mosaic/thumbnail.jpg"
      }, {
        defaultName: "Wave",
        identifier: "imgly_art_filter_wave",
        rootPath: "art-filters/imgly_wave",
        thumbnail: "art-filters/imgly_wave/thumbnail.jpg"
      }, {
        defaultName: "Malikova Darya",
        identifier: "imgly_art_filter_watercolor",
        rootPath: "art-filters/imgly_watercolor",
        thumbnail: "art-filters/imgly_watercolor/thumbnail.jpg"
      }];
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return k;
      });

      var i = n(36),
          r = n.n(i),
          o = n(37),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(10),
          c = n.n(u),
          p = n(32),
          f = n(303),
          h = n(304),
          d = n(65),
          g = n(72),
          m = n(312),
          y = "function" == typeof a.a && "symbol" == typeof r.a ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof a.a && e.constructor === a.a && e !== a.a.prototype ? "symbol" : typeof e;
      },
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var b = function b(e) {
        return p.a.byteArrayToString(d.a.decode(e));
      },
          w = "ZXhwaXJlc19hdA==",
          x = function () {
        function e(t) {
          v(this, e), this._version = "2.4", this._l = "string" == typeof t ? t.trim() : t, this._e = this._parseBigInt("65537", 10), this._n = this._parseBigInt("681984042382424091378806337544846672160292647422517223678775230983366046720611873368204040735766698395282492937192783016867164773742859209434481353888637963692711665138989982680829529436715362566735813634679619274059040232728883894511099669775400556584329435375723951309340934658571478665059403241851229195311069345899870108307225910988692123234379186643268583453907260879685992156955936561142314233983397819356937109343127504441076920088455337597736475086676246750168976219763398350254797168313954762459542746440628077261880980924552698138857743609502132632199713575442848784271304503226045319991689413234228439044522583790713890093165912455428688507463773064216328753265963237930998706891042679105987175588970202082466871461192706070321938250462103821558100761330890228135620208935801286878657384108721268761878694436895194628411397454202904351577771506916746612289964053490210990342857409030179406810634136188751670648983222653319056818302012063874664196648868156305696644664362171542503665321455971335955948698828939948786720193132672749776162913092000667953299803216404664087988046584107737900256954976744353601826341965438148646041640662195744770544094748295945844184507459808803114917301124088082458306086473490516969815873631", 10), this._parseLicense();
        }

        return _(e, [{
          key: "v",
          value: function value() {
            return this._sigValid() && !this.isExp();
          }
        }, {
          key: "_jsonValid",
          value: function value() {
            try {
              this._decLic = JSON.parse(this._l);
            } catch (e) {
              return this._decLic = {}, !1;
            }

            return !0;
          }
        }, {
          key: "_hostnameValid",
          value: function value() {
            if ("undefined" == typeof window) return !0;
            if (!this._decLic[b("YXBwX2lkZW50aWZpZXJz")].length) return !0;
            var e = window.location.hostname,
                t = !1;
            return this._decLic[b("YXBwX2lkZW50aWZpZXJz")].forEach(function (n) {
              p.a.wildCardMatch(e, n) && (t = !0);
            }), t;
          }
        }, {
          key: "_platformValid",
          value: function value() {
            return "HTML5" === this._decLic[b("cGxhdGZvcm0=")];
          }
        }, {
          key: "c",
          value: function value() {
            var e = this;
            return new c.a(function (t, n) {
              if ("string" !== y(e._l) || !e._jsonValid()) {
                var i = new Error();
                return i.code = "ELICINVFMT", n(i);
              }

              if (!e._sigValid()) {
                var r = new Error();
                return r.code = "ELICINV", n(r);
              }

              if (!e._hostnameValid()) {
                var o = new Error();
                return o.code = "ELICINVHOST", n(o);
              }

              if (!e._platformValid()) {
                var a = new Error();
                return a.code = "ELICINVPLAT", n(a);
              }

              if (e.isExp()) {
                var s = new Error();
                return s.code = "ELICEXP", n(s);
              }

              t();
            });
          }
        }, {
          key: "isToolAllowed",
          value: function value(e) {
            return this._includesFeature(e);
          }
        }, {
          key: "isWhiteLabel",
          value: function value() {
            return this._includesFeature("whitelabel", new f.a("2.4", !0));
          }
        }, {
          key: "areCustomAssetsAllowed",
          value: function value() {
            return this._includesFeature("customassets", new f.a("2.4", !0));
          }
        }, {
          key: "t",
          value: function value() {
            if (this._decLic.enterprise_license) return c.a.resolve();
            if (this._includesFeature("noexporttracking", new f.a("2.4", !0))) return c.a.resolve();

            var e = this._decLic[b("ZG9tYWlucw==")][0] + b(b("TDNSeVlXTnJQMkZ3YVV0bGVUMD0=")) + this._decLic[b("YXBpX3Rva2Vu")];

            return new g.a(e).load();
          }
        }, {
          key: "isENT",
          value: function value() {
            return !!this._decLic && this._decLic[b("ZW50ZXJwcmlzZV9saWNlbnNl")];
          }
        }, {
          key: "_sigValid",
          value: function value() {
            return this._verify(this._message, this._sig);
          }
        }, {
          key: "exp",
          value: function value() {
            return !!this._decLic[b(w)];
          }
        }, {
          key: "dl",
          value: function value() {
            return Math.ceil((this._expAt() - Date.now()) / 864e5);
          }
        }, {
          key: "isExp",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Date.now();
            return null !== this._decLic[b(w)] && e > this._expAt();
          }
        }, {
          key: "_expAt",
          value: function value() {
            return 1e3 * this._decLic[b(w)];
          }
        }, {
          key: "_verify",
          value: function value(e, t) {
            return this._encodeMessage(e) === this._decodeSignature(t).substr(-64);
          }
        }, {
          key: "_encodeMessage",
          value: function value(e) {
            return Object(m.a)(e);
          }
        }, {
          key: "_decodeSignature",
          value: function value(e) {
            return e = (e = d.a.decode(e)).map(function (e) {
              return ("0" + (255 & e).toString(16)).slice(-2);
            }).join(""), (e = this._parseBigInt(e, 16)).modPowInt(this._e, this._n).toString(16);
          }
        }, {
          key: "_parseBigInt",
          value: function value(e, t) {
            return new h.a(e, t);
          }
        }, {
          key: "_parseLicense",
          value: function value() {
            "string" == typeof this._l && this._jsonValid() && (this._sig = this._decLic[b("c2lnbmF0dXJl")] || "", delete this._decLic[b("c2lnbmF0dXJl")], this._sig = this._sig.replace(/[^A-Za-z0-9+/=]/g, ""), this._message = this._l.replace(new RegExp(',"' + b("c2lnbmF0dXJl") + '":"([^"]*)"'), ""));
          }
        }, {
          key: "_includesFeature",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new f.a("1.0", !0),
                n = new f.a(this._decLic[b("dmVyc2lvbg==")], !0);
            return !!t.isMoreRecentThan(n) || this._decLic[b("ZmVhdHVyZXM=")] && -1 !== this._decLic[b("ZmVhdHVyZXM=")].indexOf(e);
          }
        }]), e;
      }(),
          k = function () {
        function e() {
          v(this, e);
        }

        return _(e, [{
          key: "v",
          value: function value() {
            return !0;
          }
        }, {
          key: "c",
          value: function value() {
            return c.a.resolve();
          }
        }, {
          key: "isToolAllowed",
          value: function value(e) {
            return !0;
          }
        }, {
          key: "isWhiteLabel",
          value: function value() {
            return !1;
          }
        }, {
          key: "areCustomAssetsAllowed",
          value: function value() {
            return !0;
          }
        }, {
          key: "t",
          value: function value() {
            return c.a.resolve();
          }
        }, {
          key: "isENT",
          value: function value() {
            return !1;
          }
        }, {
          key: "exp",
          value: function value() {
            return !1;
          }
        }, {
          key: "dl",
          value: function value() {
            return 0;
          }
        }, {
          key: "isExp",
          value: function value() {
            return !1;
          }
        }]), e;
      }();

      t.b = x;
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return u;
      });

      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function a(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var s = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/g,
          l = /^(0|[1-9]\d*)\.(0|[1-9]\d*)(\.(0|[1-9]\d*))?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/g,
          u = function () {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          a(this, e);
          var i = n ? l : s,
              r = i.exec(t);
          i.lastIndex = 0, this._major = r[1], this._minor = r[2], this._patch = r[3] || 0;
        }

        return o(e, [{
          key: "major",
          get: function get() {
            return this._major;
          }
        }, {
          key: "minor",
          get: function get() {
            return this._minor;
          }
        }, {
          key: "patch",
          get: function get() {
            return this._patch;
          }
        }]), o(e, [{
          key: "equals",
          value: function value(e) {
            return this._major === e._major && this._minor === e._minor && this._patch === e._patch;
          }
        }, {
          key: "isMoreRecentThan",
          value: function value(e) {
            return !(this._major < e.major) && (this._major > e.major || !(this._minor < e.minor) && (this._minor > e.minor || !(this._patch <= e.patch) && (this._patch > e.patch || void 0)));
          }
        }]), e;
      }();
    }, function (e, t, n) {
      /*!
       * Copyright (c) 2003-2005  Tom Wu
       * All Rights Reserved.
       *
       * Permission is hereby granted, free of charge, to any person obtaining
       * a copy of this software and associated documentation files (the
       * "Software"), to deal in the Software without restriction, including
       * without limitation the rights to use, copy, modify, merge, publish,
       * distribute, sublicense, and/or sell copies of the Software, and to
       * permit persons to whom the Software is furnished to do so, subject to
       * the following conditions:
       *
       * The above copyright notice and this permission notice shall be
       * included in all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
       * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
       * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
       *
       * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
       * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
       * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
       * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
       * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
       *
       * In addition, the following condition applies:
       *
       * All redistributions must retain an intact copy of this copyright notice
       * and disclaimer.
       */
      var i,
          r = r || {};

      function o(e, t, n) {
        null != e && ("number" == typeof e ? this.fromNumber(e, t, n) : null == t && "string" != typeof e ? this.fromString(e, 256) : this.fromString(e, t));
      }

      function a() {
        return new o(null);
      }

      "Microsoft Internet Explorer" == r.appName ? (o.prototype.am = function (e, t, n, i, r, o) {
        for (var a = 32767 & t, s = t >> 15; --o >= 0;) {
          var l = 32767 & this[e],
              u = this[e++] >> 15,
              c = s * l + u * a;
          r = ((l = a * l + ((32767 & c) << 15) + n[i] + (1073741823 & r)) >>> 30) + (c >>> 15) + s * u + (r >>> 30), n[i++] = 1073741823 & l;
        }

        return r;
      }, i = 30) : "Netscape" != r.appName ? (o.prototype.am = function (e, t, n, i, r, o) {
        for (; --o >= 0;) {
          var a = t * this[e++] + n[i] + r;
          r = Math.floor(a / 67108864), n[i++] = 67108863 & a;
        }

        return r;
      }, i = 26) : (o.prototype.am = function (e, t, n, i, r, o) {
        for (var a = 16383 & t, s = t >> 14; --o >= 0;) {
          var l = 16383 & this[e],
              u = this[e++] >> 14,
              c = s * l + u * a;
          r = ((l = a * l + ((16383 & c) << 14) + n[i] + r) >> 28) + (c >> 14) + s * u, n[i++] = 268435455 & l;
        }

        return r;
      }, i = 28), o.prototype.DB = i, o.prototype.DM = (1 << i) - 1, o.prototype.DV = 1 << i, o.prototype.FV = Math.pow(2, 52), o.prototype.F1 = 52 - i, o.prototype.F2 = 2 * i - 52;
      var s,
          l,
          u = new Array();

      for (s = "0".charCodeAt(0), l = 0; l <= 9; ++l) {
        u[s++] = l;
      }

      for (s = "a".charCodeAt(0), l = 10; l < 36; ++l) {
        u[s++] = l;
      }

      for (s = "A".charCodeAt(0), l = 10; l < 36; ++l) {
        u[s++] = l;
      }

      function c(e) {
        return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(e);
      }

      function p(e, t) {
        var n = u[e.charCodeAt(t)];
        return null == n ? -1 : n;
      }

      function f(e) {
        var t = a();
        return t.fromInt(e), t;
      }

      function h(e) {
        var t,
            n = 1;
        return 0 != (t = e >>> 16) && (e = t, n += 16), 0 != (t = e >> 8) && (e = t, n += 8), 0 != (t = e >> 4) && (e = t, n += 4), 0 != (t = e >> 2) && (e = t, n += 2), 0 != (t = e >> 1) && (e = t, n += 1), n;
      }

      function d(e) {
        this.m = e;
      }

      function g(e) {
        this.m = e, this.mp = e.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
      }

      function m(e, t) {
        return e & t;
      }

      function y(e, t) {
        return e | t;
      }

      function _(e, t) {
        return e ^ t;
      }

      function v(e, t) {
        return e & ~t;
      }

      function b(e) {
        if (0 == e) return -1;
        var t = 0;
        return 0 == (65535 & e) && (e >>= 16, t += 16), 0 == (255 & e) && (e >>= 8, t += 8), 0 == (15 & e) && (e >>= 4, t += 4), 0 == (3 & e) && (e >>= 2, t += 2), 0 == (1 & e) && ++t, t;
      }

      function w(e) {
        for (var t = 0; 0 != e;) {
          e &= e - 1, ++t;
        }

        return t;
      }

      function x() {}

      function k(e) {
        return e;
      }

      function T(e) {
        this.r2 = a(), this.q3 = a(), o.ONE.dlShiftTo(2 * e.t, this.r2), this.mu = this.r2.divide(e), this.m = e;
      }

      d.prototype.convert = function (e) {
        return e.s < 0 || e.compareTo(this.m) >= 0 ? e.mod(this.m) : e;
      }, d.prototype.revert = function (e) {
        return e;
      }, d.prototype.reduce = function (e) {
        e.divRemTo(this.m, null, e);
      }, d.prototype.mulTo = function (e, t, n) {
        e.multiplyTo(t, n), this.reduce(n);
      }, d.prototype.sqrTo = function (e, t) {
        e.squareTo(t), this.reduce(t);
      }, g.prototype.convert = function (e) {
        var t = a();
        return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(o.ZERO) > 0 && this.m.subTo(t, t), t;
      }, g.prototype.revert = function (e) {
        var t = a();
        return e.copyTo(t), this.reduce(t), t;
      }, g.prototype.reduce = function (e) {
        for (; e.t <= this.mt2;) {
          e[e.t++] = 0;
        }

        for (var t = 0; t < this.m.t; ++t) {
          var n = 32767 & e[t],
              i = n * this.mpl + ((n * this.mph + (e[t] >> 15) * this.mpl & this.um) << 15) & e.DM;

          for (e[n = t + this.m.t] += this.m.am(0, i, e, t, 0, this.m.t); e[n] >= e.DV;) {
            e[n] -= e.DV, e[++n]++;
          }
        }

        e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
      }, g.prototype.mulTo = function (e, t, n) {
        e.multiplyTo(t, n), this.reduce(n);
      }, g.prototype.sqrTo = function (e, t) {
        e.squareTo(t), this.reduce(t);
      }, o.prototype.copyTo = function (e) {
        for (var t = this.t - 1; t >= 0; --t) {
          e[t] = this[t];
        }

        e.t = this.t, e.s = this.s;
      }, o.prototype.fromInt = function (e) {
        this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this[0] = e : e < -1 ? this[0] = e + this.DV : this.t = 0;
      }, o.prototype.fromString = function (e, t) {
        var n;
        if (16 == t) n = 4;else if (8 == t) n = 3;else if (256 == t) n = 8;else if (2 == t) n = 1;else if (32 == t) n = 5;else {
          if (4 != t) return void this.fromRadix(e, t);
          n = 2;
        }
        this.t = 0, this.s = 0;

        for (var i = e.length, r = !1, a = 0; --i >= 0;) {
          var s = 8 == n ? 255 & e[i] : p(e, i);
          s < 0 ? "-" == e.charAt(i) && (r = !0) : (r = !1, 0 == a ? this[this.t++] = s : a + n > this.DB ? (this[this.t - 1] |= (s & (1 << this.DB - a) - 1) << a, this[this.t++] = s >> this.DB - a) : this[this.t - 1] |= s << a, (a += n) >= this.DB && (a -= this.DB));
        }

        8 == n && 0 != (128 & e[0]) && (this.s = -1, a > 0 && (this[this.t - 1] |= (1 << this.DB - a) - 1 << a)), this.clamp(), r && o.ZERO.subTo(this, this);
      }, o.prototype.clamp = function () {
        for (var e = this.s & this.DM; this.t > 0 && this[this.t - 1] == e;) {
          --this.t;
        }
      }, o.prototype.dlShiftTo = function (e, t) {
        var n;

        for (n = this.t - 1; n >= 0; --n) {
          t[n + e] = this[n];
        }

        for (n = e - 1; n >= 0; --n) {
          t[n] = 0;
        }

        t.t = this.t + e, t.s = this.s;
      }, o.prototype.drShiftTo = function (e, t) {
        for (var n = e; n < this.t; ++n) {
          t[n - e] = this[n];
        }

        t.t = Math.max(this.t - e, 0), t.s = this.s;
      }, o.prototype.lShiftTo = function (e, t) {
        var n,
            i = e % this.DB,
            r = this.DB - i,
            o = (1 << r) - 1,
            a = Math.floor(e / this.DB),
            s = this.s << i & this.DM;

        for (n = this.t - 1; n >= 0; --n) {
          t[n + a + 1] = this[n] >> r | s, s = (this[n] & o) << i;
        }

        for (n = a - 1; n >= 0; --n) {
          t[n] = 0;
        }

        t[a] = s, t.t = this.t + a + 1, t.s = this.s, t.clamp();
      }, o.prototype.rShiftTo = function (e, t) {
        t.s = this.s;
        var n = Math.floor(e / this.DB);
        if (n >= this.t) t.t = 0;else {
          var i = e % this.DB,
              r = this.DB - i,
              o = (1 << i) - 1;
          t[0] = this[n] >> i;

          for (var a = n + 1; a < this.t; ++a) {
            t[a - n - 1] |= (this[a] & o) << r, t[a - n] = this[a] >> i;
          }

          i > 0 && (t[this.t - n - 1] |= (this.s & o) << r), t.t = this.t - n, t.clamp();
        }
      }, o.prototype.subTo = function (e, t) {
        for (var n = 0, i = 0, r = Math.min(e.t, this.t); n < r;) {
          i += this[n] - e[n], t[n++] = i & this.DM, i >>= this.DB;
        }

        if (e.t < this.t) {
          for (i -= e.s; n < this.t;) {
            i += this[n], t[n++] = i & this.DM, i >>= this.DB;
          }

          i += this.s;
        } else {
          for (i += this.s; n < e.t;) {
            i -= e[n], t[n++] = i & this.DM, i >>= this.DB;
          }

          i -= e.s;
        }

        t.s = i < 0 ? -1 : 0, i < -1 ? t[n++] = this.DV + i : i > 0 && (t[n++] = i), t.t = n, t.clamp();
      }, o.prototype.multiplyTo = function (e, t) {
        var n = this.abs(),
            i = e.abs(),
            r = n.t;

        for (t.t = r + i.t; --r >= 0;) {
          t[r] = 0;
        }

        for (r = 0; r < i.t; ++r) {
          t[r + n.t] = n.am(0, i[r], t, r, 0, n.t);
        }

        t.s = 0, t.clamp(), this.s != e.s && o.ZERO.subTo(t, t);
      }, o.prototype.squareTo = function (e) {
        for (var t = this.abs(), n = e.t = 2 * t.t; --n >= 0;) {
          e[n] = 0;
        }

        for (n = 0; n < t.t - 1; ++n) {
          var i = t.am(n, t[n], e, 2 * n, 0, 1);
          (e[n + t.t] += t.am(n + 1, 2 * t[n], e, 2 * n + 1, i, t.t - n - 1)) >= t.DV && (e[n + t.t] -= t.DV, e[n + t.t + 1] = 1);
        }

        e.t > 0 && (e[e.t - 1] += t.am(n, t[n], e, 2 * n, 0, 1)), e.s = 0, e.clamp();
      }, o.prototype.divRemTo = function (e, t, n) {
        var i = e.abs();

        if (!(i.t <= 0)) {
          var r = this.abs();
          if (r.t < i.t) return null != t && t.fromInt(0), void (null != n && this.copyTo(n));
          null == n && (n = a());
          var s = a(),
              l = this.s,
              u = e.s,
              c = this.DB - h(i[i.t - 1]);
          c > 0 ? (i.lShiftTo(c, s), r.lShiftTo(c, n)) : (i.copyTo(s), r.copyTo(n));
          var p = s.t,
              f = s[p - 1];

          if (0 != f) {
            var d = f * (1 << this.F1) + (p > 1 ? s[p - 2] >> this.F2 : 0),
                g = this.FV / d,
                m = (1 << this.F1) / d,
                y = 1 << this.F2,
                _ = n.t,
                v = _ - p,
                b = null == t ? a() : t;

            for (s.dlShiftTo(v, b), n.compareTo(b) >= 0 && (n[n.t++] = 1, n.subTo(b, n)), o.ONE.dlShiftTo(p, b), b.subTo(s, s); s.t < p;) {
              s[s.t++] = 0;
            }

            for (; --v >= 0;) {
              var w = n[--_] == f ? this.DM : Math.floor(n[_] * g + (n[_ - 1] + y) * m);
              if ((n[_] += s.am(0, w, n, v, 0, p)) < w) for (s.dlShiftTo(v, b), n.subTo(b, n); n[_] < --w;) {
                n.subTo(b, n);
              }
            }

            null != t && (n.drShiftTo(p, t), l != u && o.ZERO.subTo(t, t)), n.t = p, n.clamp(), c > 0 && n.rShiftTo(c, n), l < 0 && o.ZERO.subTo(n, n);
          }
        }
      }, o.prototype.invDigit = function () {
        if (this.t < 1) return 0;
        var e = this[0];
        if (0 == (1 & e)) return 0;
        var t = 3 & e;
        return (t = (t = (t = (t = t * (2 - (15 & e) * t) & 15) * (2 - (255 & e) * t) & 255) * (2 - ((65535 & e) * t & 65535)) & 65535) * (2 - e * t % this.DV) % this.DV) > 0 ? this.DV - t : -t;
      }, o.prototype.isEven = function () {
        return 0 == (this.t > 0 ? 1 & this[0] : this.s);
      }, o.prototype.exp = function (e, t) {
        if (e > 4294967295 || e < 1) return o.ONE;
        var n = a(),
            i = a(),
            r = t.convert(this),
            s = h(e) - 1;

        for (r.copyTo(n); --s >= 0;) {
          if (t.sqrTo(n, i), (e & 1 << s) > 0) t.mulTo(i, r, n);else {
            var l = n;
            n = i, i = l;
          }
        }

        return t.revert(n);
      }, o.prototype.toString = function (e) {
        if (this.s < 0) return "-" + this.negate().toString(e);
        var t;
        if (16 == e) t = 4;else if (8 == e) t = 3;else if (2 == e) t = 1;else if (32 == e) t = 5;else {
          if (4 != e) return this.toRadix(e);
          t = 2;
        }
        var n,
            i = (1 << t) - 1,
            r = !1,
            o = "",
            a = this.t,
            s = this.DB - a * this.DB % t;
        if (a-- > 0) for (s < this.DB && (n = this[a] >> s) > 0 && (r = !0, o = c(n)); a >= 0;) {
          s < t ? (n = (this[a] & (1 << s) - 1) << t - s, n |= this[--a] >> (s += this.DB - t)) : (n = this[a] >> (s -= t) & i, s <= 0 && (s += this.DB, --a)), n > 0 && (r = !0), r && (o += c(n));
        }
        return r ? o : "0";
      }, o.prototype.negate = function () {
        var e = a();
        return o.ZERO.subTo(this, e), e;
      }, o.prototype.abs = function () {
        return this.s < 0 ? this.negate() : this;
      }, o.prototype.compareTo = function (e) {
        var t = this.s - e.s;
        if (0 != t) return t;
        var n = this.t;
        if (0 != (t = n - e.t)) return this.s < 0 ? -t : t;

        for (; --n >= 0;) {
          if (0 != (t = this[n] - e[n])) return t;
        }

        return 0;
      }, o.prototype.bitLength = function () {
        return this.t <= 0 ? 0 : this.DB * (this.t - 1) + h(this[this.t - 1] ^ this.s & this.DM);
      }, o.prototype.mod = function (e) {
        var t = a();
        return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(o.ZERO) > 0 && e.subTo(t, t), t;
      }, o.prototype.modPowInt = function (e, t) {
        var n;
        return n = e < 256 || t.isEven() ? new d(t) : new g(t), this.exp(e, n);
      }, o.ZERO = f(0), o.ONE = f(1), x.prototype.convert = k, x.prototype.revert = k, x.prototype.mulTo = function (e, t, n) {
        e.multiplyTo(t, n);
      }, x.prototype.sqrTo = function (e, t) {
        e.squareTo(t);
      }, T.prototype.convert = function (e) {
        if (e.s < 0 || e.t > 2 * this.m.t) return e.mod(this.m);
        if (e.compareTo(this.m) < 0) return e;
        var t = a();
        return e.copyTo(t), this.reduce(t), t;
      }, T.prototype.revert = function (e) {
        return e;
      }, T.prototype.reduce = function (e) {
        for (e.drShiftTo(this.m.t - 1, this.r2), e.t > this.m.t + 1 && (e.t = this.m.t + 1, e.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); e.compareTo(this.r2) < 0;) {
          e.dAddOffset(1, this.m.t + 1);
        }

        for (e.subTo(this.r2, e); e.compareTo(this.m) >= 0;) {
          e.subTo(this.m, e);
        }
      }, T.prototype.mulTo = function (e, t, n) {
        e.multiplyTo(t, n), this.reduce(n);
      }, T.prototype.sqrTo = function (e, t) {
        e.squareTo(t), this.reduce(t);
      };
      var S = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997],
          C = (1 << 26) / S[S.length - 1];
      o.prototype.chunkSize = function (e) {
        return Math.floor(Math.LN2 * this.DB / Math.log(e));
      }, o.prototype.toRadix = function (e) {
        if (null == e && (e = 10), 0 == this.signum() || e < 2 || e > 36) return "0";
        var t = this.chunkSize(e),
            n = Math.pow(e, t),
            i = f(n),
            r = a(),
            o = a(),
            s = "";

        for (this.divRemTo(i, r, o); r.signum() > 0;) {
          s = (n + o.intValue()).toString(e).substr(1) + s, r.divRemTo(i, r, o);
        }

        return o.intValue().toString(e) + s;
      }, o.prototype.fromRadix = function (e, t) {
        this.fromInt(0), null == t && (t = 10);

        for (var n = this.chunkSize(t), i = Math.pow(t, n), r = !1, a = 0, s = 0, l = 0; l < e.length; ++l) {
          var u = p(e, l);
          u < 0 ? "-" == e.charAt(l) && 0 == this.signum() && (r = !0) : (s = t * s + u, ++a >= n && (this.dMultiply(i), this.dAddOffset(s, 0), a = 0, s = 0));
        }

        a > 0 && (this.dMultiply(Math.pow(t, a)), this.dAddOffset(s, 0)), r && o.ZERO.subTo(this, this);
      }, o.prototype.fromNumber = function (e, t, n) {
        if ("number" == typeof t) {
          if (e < 2) this.fromInt(1);else for (this.fromNumber(e, n), this.testBit(e - 1) || this.bitwiseTo(o.ONE.shiftLeft(e - 1), y, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(t);) {
            this.dAddOffset(2, 0), this.bitLength() > e && this.subTo(o.ONE.shiftLeft(e - 1), this);
          }
        } else {
          var i = new Array(),
              r = 7 & e;
          i.length = 1 + (e >> 3), t.nextBytes(i), r > 0 ? i[0] &= (1 << r) - 1 : i[0] = 0, this.fromString(i, 256);
        }
      }, o.prototype.bitwiseTo = function (e, t, n) {
        var i,
            r,
            o = Math.min(e.t, this.t);

        for (i = 0; i < o; ++i) {
          n[i] = t(this[i], e[i]);
        }

        if (e.t < this.t) {
          for (r = e.s & this.DM, i = o; i < this.t; ++i) {
            n[i] = t(this[i], r);
          }

          n.t = this.t;
        } else {
          for (r = this.s & this.DM, i = o; i < e.t; ++i) {
            n[i] = t(r, e[i]);
          }

          n.t = e.t;
        }

        n.s = t(this.s, e.s), n.clamp();
      }, o.prototype.changeBit = function (e, t) {
        var n = o.ONE.shiftLeft(e);
        return this.bitwiseTo(n, t, n), n;
      }, o.prototype.addTo = function (e, t) {
        for (var n = 0, i = 0, r = Math.min(e.t, this.t); n < r;) {
          i += this[n] + e[n], t[n++] = i & this.DM, i >>= this.DB;
        }

        if (e.t < this.t) {
          for (i += e.s; n < this.t;) {
            i += this[n], t[n++] = i & this.DM, i >>= this.DB;
          }

          i += this.s;
        } else {
          for (i += this.s; n < e.t;) {
            i += e[n], t[n++] = i & this.DM, i >>= this.DB;
          }

          i += e.s;
        }

        t.s = i < 0 ? -1 : 0, i > 0 ? t[n++] = i : i < -1 && (t[n++] = this.DV + i), t.t = n, t.clamp();
      }, o.prototype.dMultiply = function (e) {
        this[this.t] = this.am(0, e - 1, this, 0, 0, this.t), ++this.t, this.clamp();
      }, o.prototype.dAddOffset = function (e, t) {
        if (0 != e) {
          for (; this.t <= t;) {
            this[this.t++] = 0;
          }

          for (this[t] += e; this[t] >= this.DV;) {
            this[t] -= this.DV, ++t >= this.t && (this[this.t++] = 0), ++this[t];
          }
        }
      }, o.prototype.multiplyLowerTo = function (e, t, n) {
        var i,
            r = Math.min(this.t + e.t, t);

        for (n.s = 0, n.t = r; r > 0;) {
          n[--r] = 0;
        }

        for (i = n.t - this.t; r < i; ++r) {
          n[r + this.t] = this.am(0, e[r], n, r, 0, this.t);
        }

        for (i = Math.min(e.t, t); r < i; ++r) {
          this.am(0, e[r], n, r, 0, t - r);
        }

        n.clamp();
      }, o.prototype.multiplyUpperTo = function (e, t, n) {
        --t;
        var i = n.t = this.t + e.t - t;

        for (n.s = 0; --i >= 0;) {
          n[i] = 0;
        }

        for (i = Math.max(t - this.t, 0); i < e.t; ++i) {
          n[this.t + i - t] = this.am(t - i, e[i], n, 0, 0, this.t + i - t);
        }

        n.clamp(), n.drShiftTo(1, n);
      }, o.prototype.modInt = function (e) {
        if (e <= 0) return 0;
        var t = this.DV % e,
            n = this.s < 0 ? e - 1 : 0;
        if (this.t > 0) if (0 == t) n = this[0] % e;else for (var i = this.t - 1; i >= 0; --i) {
          n = (t * n + this[i]) % e;
        }
        return n;
      }, o.prototype.millerRabin = function (e) {
        var t = this.subtract(o.ONE),
            n = t.getLowestSetBit();
        if (n <= 0) return !1;
        var i = t.shiftRight(n);
        (e = e + 1 >> 1) > S.length && (e = S.length);

        for (var r = a(), s = 0; s < e; ++s) {
          r.fromInt(S[Math.floor(Math.random() * S.length)]);
          var l = r.modPow(i, this);

          if (0 != l.compareTo(o.ONE) && 0 != l.compareTo(t)) {
            for (var u = 1; u++ < n && 0 != l.compareTo(t);) {
              if (0 == (l = l.modPowInt(2, this)).compareTo(o.ONE)) return !1;
            }

            if (0 != l.compareTo(t)) return !1;
          }
        }

        return !0;
      }, o.prototype.clone = function () {
        var e = a();
        return this.copyTo(e), e;
      }, o.prototype.intValue = function () {
        if (this.s < 0) {
          if (1 == this.t) return this[0] - this.DV;
          if (0 == this.t) return -1;
        } else {
          if (1 == this.t) return this[0];
          if (0 == this.t) return 0;
        }

        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
      }, o.prototype.byteValue = function () {
        return 0 == this.t ? this.s : this[0] << 24 >> 24;
      }, o.prototype.shortValue = function () {
        return 0 == this.t ? this.s : this[0] << 16 >> 16;
      }, o.prototype.signum = function () {
        return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
      }, o.prototype.toByteArray = function () {
        var e = this.t,
            t = new Array();
        t[0] = this.s;
        var n,
            i = this.DB - e * this.DB % 8,
            r = 0;
        if (e-- > 0) for (i < this.DB && (n = this[e] >> i) != (this.s & this.DM) >> i && (t[r++] = n | this.s << this.DB - i); e >= 0;) {
          i < 8 ? (n = (this[e] & (1 << i) - 1) << 8 - i, n |= this[--e] >> (i += this.DB - 8)) : (n = this[e] >> (i -= 8) & 255, i <= 0 && (i += this.DB, --e)), 0 != (128 & n) && (n |= -256), 0 == r && (128 & this.s) != (128 & n) && ++r, (r > 0 || n != this.s) && (t[r++] = n);
        }
        return t;
      }, o.prototype.equals = function (e) {
        return 0 == this.compareTo(e);
      }, o.prototype.min = function (e) {
        return this.compareTo(e) < 0 ? this : e;
      }, o.prototype.max = function (e) {
        return this.compareTo(e) > 0 ? this : e;
      }, o.prototype.and = function (e) {
        var t = a();
        return this.bitwiseTo(e, m, t), t;
      }, o.prototype.or = function (e) {
        var t = a();
        return this.bitwiseTo(e, y, t), t;
      }, o.prototype.xor = function (e) {
        var t = a();
        return this.bitwiseTo(e, _, t), t;
      }, o.prototype.andNot = function (e) {
        var t = a();
        return this.bitwiseTo(e, v, t), t;
      }, o.prototype.not = function () {
        for (var e = a(), t = 0; t < this.t; ++t) {
          e[t] = this.DM & ~this[t];
        }

        return e.t = this.t, e.s = ~this.s, e;
      }, o.prototype.shiftLeft = function (e) {
        var t = a();
        return e < 0 ? this.rShiftTo(-e, t) : this.lShiftTo(e, t), t;
      }, o.prototype.shiftRight = function (e) {
        var t = a();
        return e < 0 ? this.lShiftTo(-e, t) : this.rShiftTo(e, t), t;
      }, o.prototype.getLowestSetBit = function () {
        for (var e = 0; e < this.t; ++e) {
          if (0 != this[e]) return e * this.DB + b(this[e]);
        }

        return this.s < 0 ? this.t * this.DB : -1;
      }, o.prototype.bitCount = function () {
        for (var e = 0, t = this.s & this.DM, n = 0; n < this.t; ++n) {
          e += w(this[n] ^ t);
        }

        return e;
      }, o.prototype.testBit = function (e) {
        var t = Math.floor(e / this.DB);
        return t >= this.t ? 0 != this.s : 0 != (this[t] & 1 << e % this.DB);
      }, o.prototype.setBit = function (e) {
        return this.changeBit(e, y);
      }, o.prototype.clearBit = function (e) {
        return this.changeBit(e, v);
      }, o.prototype.flipBit = function (e) {
        return this.changeBit(e, _);
      }, o.prototype.add = function (e) {
        var t = a();
        return this.addTo(e, t), t;
      }, o.prototype.subtract = function (e) {
        var t = a();
        return this.subTo(e, t), t;
      }, o.prototype.multiply = function (e) {
        var t = a();
        return this.multiplyTo(e, t), t;
      }, o.prototype.divide = function (e) {
        var t = a();
        return this.divRemTo(e, t, null), t;
      }, o.prototype.remainder = function (e) {
        var t = a();
        return this.divRemTo(e, null, t), t;
      }, o.prototype.divideAndRemainder = function (e) {
        var t = a(),
            n = a();
        return this.divRemTo(e, t, n), new Array(t, n);
      }, o.prototype.modPow = function (e, t) {
        var n,
            i,
            r = e.bitLength(),
            o = f(1);
        if (r <= 0) return o;
        n = r < 18 ? 1 : r < 48 ? 3 : r < 144 ? 4 : r < 768 ? 5 : 6, i = r < 8 ? new d(t) : t.isEven() ? new T(t) : new g(t);
        var s = new Array(),
            l = 3,
            u = n - 1,
            c = (1 << n) - 1;

        if (s[1] = i.convert(this), n > 1) {
          var p = a();

          for (i.sqrTo(s[1], p); l <= c;) {
            s[l] = a(), i.mulTo(p, s[l - 2], s[l]), l += 2;
          }
        }

        var m,
            y,
            _ = e.t - 1,
            v = !0,
            b = a();

        for (r = h(e[_]) - 1; _ >= 0;) {
          for (r >= u ? m = e[_] >> r - u & c : (m = (e[_] & (1 << r + 1) - 1) << u - r, _ > 0 && (m |= e[_ - 1] >> this.DB + r - u)), l = n; 0 == (1 & m);) {
            m >>= 1, --l;
          }

          if ((r -= l) < 0 && (r += this.DB, --_), v) s[m].copyTo(o), v = !1;else {
            for (; l > 1;) {
              i.sqrTo(o, b), i.sqrTo(b, o), l -= 2;
            }

            l > 0 ? i.sqrTo(o, b) : (y = o, o = b, b = y), i.mulTo(b, s[m], o);
          }

          for (; _ >= 0 && 0 == (e[_] & 1 << r);) {
            i.sqrTo(o, b), y = o, o = b, b = y, --r < 0 && (r = this.DB - 1, --_);
          }
        }

        return i.revert(o);
      }, o.prototype.modInverse = function (e) {
        var t = e.isEven();
        if (this.isEven() && t || 0 == e.signum()) return o.ZERO;

        for (var n = e.clone(), i = this.clone(), r = f(1), a = f(0), s = f(0), l = f(1); 0 != n.signum();) {
          for (; n.isEven();) {
            n.rShiftTo(1, n), t ? (r.isEven() && a.isEven() || (r.addTo(this, r), a.subTo(e, a)), r.rShiftTo(1, r)) : a.isEven() || a.subTo(e, a), a.rShiftTo(1, a);
          }

          for (; i.isEven();) {
            i.rShiftTo(1, i), t ? (s.isEven() && l.isEven() || (s.addTo(this, s), l.subTo(e, l)), s.rShiftTo(1, s)) : l.isEven() || l.subTo(e, l), l.rShiftTo(1, l);
          }

          n.compareTo(i) >= 0 ? (n.subTo(i, n), t && r.subTo(s, r), a.subTo(l, a)) : (i.subTo(n, i), t && s.subTo(r, s), l.subTo(a, l));
        }

        return 0 != i.compareTo(o.ONE) ? o.ZERO : l.compareTo(e) >= 0 ? l.subtract(e) : l.signum() < 0 ? (l.addTo(e, l), l.signum() < 0 ? l.add(e) : l) : l;
      }, o.prototype.pow = function (e) {
        return this.exp(e, new x());
      }, o.prototype.gcd = function (e) {
        var t = this.s < 0 ? this.negate() : this.clone(),
            n = e.s < 0 ? e.negate() : e.clone();

        if (t.compareTo(n) < 0) {
          var i = t;
          t = n, n = i;
        }

        var r = t.getLowestSetBit(),
            o = n.getLowestSetBit();
        if (o < 0) return t;

        for (r < o && (o = r), o > 0 && (t.rShiftTo(o, t), n.rShiftTo(o, n)); t.signum() > 0;) {
          (r = t.getLowestSetBit()) > 0 && t.rShiftTo(r, t), (r = n.getLowestSetBit()) > 0 && n.rShiftTo(r, n), t.compareTo(n) >= 0 ? (t.subTo(n, t), t.rShiftTo(1, t)) : (n.subTo(t, n), n.rShiftTo(1, n));
        }

        return o > 0 && n.lShiftTo(o, n), n;
      }, o.prototype.isProbablePrime = function (e) {
        var t,
            n = this.abs();

        if (1 == n.t && n[0] <= S[S.length - 1]) {
          for (t = 0; t < S.length; ++t) {
            if (n[0] == S[t]) return !0;
          }

          return !1;
        }

        if (n.isEven()) return !1;

        for (t = 1; t < S.length;) {
          for (var i = S[t], r = t + 1; r < S.length && i < C;) {
            i *= S[r++];
          }

          for (i = n.modInt(i); t < r;) {
            if (i % S[t++] == 0) return !1;
          }
        }

        return n.millerRabin(e);
      }, o.prototype.square = function () {
        var e = a();
        return this.squareTo(e), e;
      }, t.a = o;
    }, function (e, t, n) {
      var i = n(306),
          r = n(308);

      function o() {
        this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
      }

      t.parse = v, t.resolve = function (e, t) {
        return v(e, !1, !0).resolve(t);
      }, t.resolveObject = function (e, t) {
        return e ? v(e, !1, !0).resolveObject(t) : t;
      }, t.format = function (e) {
        return r.isString(e) && (e = v(e)), e instanceof o ? e.format() : o.prototype.format.call(e);
      }, t.Url = o;

      var a = /^([a-z0-9.+-]+:)/i,
          s = /:[0-9]*$/,
          l = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
          u = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
          c = ["'"].concat(u),
          p = ["%", "/", "?", ";", "#"].concat(c),
          f = ["/", "?", "#"],
          h = /^[+a-z0-9A-Z_-]{0,63}$/,
          d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
          g = {
        javascript: !0,
        "javascript:": !0
      },
          m = {
        javascript: !0,
        "javascript:": !0
      },
          y = {
        http: !0,
        https: !0,
        ftp: !0,
        gopher: !0,
        file: !0,
        "http:": !0,
        "https:": !0,
        "ftp:": !0,
        "gopher:": !0,
        "file:": !0
      },
          _ = n(309);

      function v(e, t, n) {
        if (e && r.isObject(e) && e instanceof o) return e;
        var i = new o();
        return i.parse(e, t, n), i;
      }

      o.prototype.parse = function (e, t, n) {
        if (!r.isString(e)) throw new TypeError("Parameter 'url' must be a string, not " + typeof e);
        var o = e.indexOf("?"),
            s = -1 !== o && o < e.indexOf("#") ? "?" : "#",
            u = e.split(s);
        u[0] = u[0].replace(/\\/g, "/");
        var v = e = u.join(s);

        if (v = v.trim(), !n && 1 === e.split("#").length) {
          var b = l.exec(v);
          if (b) return this.path = v, this.href = v, this.pathname = b[1], b[2] ? (this.search = b[2], this.query = t ? _.parse(this.search.substr(1)) : this.search.substr(1)) : t && (this.search = "", this.query = {}), this;
        }

        var w = a.exec(v);

        if (w) {
          var x = (w = w[0]).toLowerCase();
          this.protocol = x, v = v.substr(w.length);
        }

        if (n || w || v.match(/^\/\/[^@\/]+@[^@\/]+/)) {
          var k = "//" === v.substr(0, 2);
          !k || w && m[w] || (v = v.substr(2), this.slashes = !0);
        }

        if (!m[w] && (k || w && !y[w])) {
          for (var T, S, C = -1, E = 0; E < f.length; E++) {
            -1 !== (O = v.indexOf(f[E])) && (-1 === C || O < C) && (C = O);
          }

          for (-1 !== (S = -1 === C ? v.lastIndexOf("@") : v.lastIndexOf("@", C)) && (T = v.slice(0, S), v = v.slice(S + 1), this.auth = decodeURIComponent(T)), C = -1, E = 0; E < p.length; E++) {
            var O;
            -1 !== (O = v.indexOf(p[E])) && (-1 === C || O < C) && (C = O);
          }

          -1 === C && (C = v.length), this.host = v.slice(0, C), v = v.slice(C), this.parseHost(), this.hostname = this.hostname || "";
          var R = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
          if (!R) for (var I = this.hostname.split(/\./), A = (E = 0, I.length); E < A; E++) {
            var M = I[E];

            if (M && !M.match(h)) {
              for (var F = "", D = 0, P = M.length; D < P; D++) {
                M.charCodeAt(D) > 127 ? F += "x" : F += M[D];
              }

              if (!F.match(h)) {
                var z = I.slice(0, E),
                    L = I.slice(E + 1),
                    B = M.match(d);
                B && (z.push(B[1]), L.unshift(B[2])), L.length && (v = "/" + L.join(".") + v), this.hostname = z.join(".");
                break;
              }
            }
          }
          this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), R || (this.hostname = i.toASCII(this.hostname));
          var N = this.port ? ":" + this.port : "",
              U = this.hostname || "";
          this.host = U + N, this.href += this.host, R && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== v[0] && (v = "/" + v));
        }

        if (!g[x]) for (E = 0, A = c.length; E < A; E++) {
          var j = c[E];

          if (-1 !== v.indexOf(j)) {
            var W = encodeURIComponent(j);
            W === j && (W = escape(j)), v = v.split(j).join(W);
          }
        }
        var H = v.indexOf("#");
        -1 !== H && (this.hash = v.substr(H), v = v.slice(0, H));
        var G = v.indexOf("?");

        if (-1 !== G ? (this.search = v.substr(G), this.query = v.substr(G + 1), t && (this.query = _.parse(this.query)), v = v.slice(0, G)) : t && (this.search = "", this.query = {}), v && (this.pathname = v), y[x] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
          N = this.pathname || "";
          var V = this.search || "";
          this.path = N + V;
        }

        return this.href = this.format(), this;
      }, o.prototype.format = function () {
        var e = this.auth || "";
        e && (e = (e = encodeURIComponent(e)).replace(/%3A/i, ":"), e += "@");
        var t = this.protocol || "",
            n = this.pathname || "",
            i = this.hash || "",
            o = !1,
            a = "";
        this.host ? o = e + this.host : this.hostname && (o = e + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (o += ":" + this.port)), this.query && r.isObject(this.query) && Object.keys(this.query).length && (a = _.stringify(this.query));
        var s = this.search || a && "?" + a || "";
        return t && ":" !== t.substr(-1) && (t += ":"), this.slashes || (!t || y[t]) && !1 !== o ? (o = "//" + (o || ""), n && "/" !== n.charAt(0) && (n = "/" + n)) : o || (o = ""), i && "#" !== i.charAt(0) && (i = "#" + i), s && "?" !== s.charAt(0) && (s = "?" + s), t + o + (n = n.replace(/[?#]/g, function (e) {
          return encodeURIComponent(e);
        })) + (s = s.replace("#", "%23")) + i;
      }, o.prototype.resolve = function (e) {
        return this.resolveObject(v(e, !1, !0)).format();
      }, o.prototype.resolveObject = function (e) {
        if (r.isString(e)) {
          var t = new o();
          t.parse(e, !1, !0), e = t;
        }

        for (var n = new o(), i = Object.keys(this), a = 0; a < i.length; a++) {
          var s = i[a];
          n[s] = this[s];
        }

        if (n.hash = e.hash, "" === e.href) return n.href = n.format(), n;

        if (e.slashes && !e.protocol) {
          for (var l = Object.keys(e), u = 0; u < l.length; u++) {
            var c = l[u];
            "protocol" !== c && (n[c] = e[c]);
          }

          return y[n.protocol] && n.hostname && !n.pathname && (n.path = n.pathname = "/"), n.href = n.format(), n;
        }

        if (e.protocol && e.protocol !== n.protocol) {
          if (!y[e.protocol]) {
            for (var p = Object.keys(e), f = 0; f < p.length; f++) {
              var h = p[f];
              n[h] = e[h];
            }

            return n.href = n.format(), n;
          }

          if (n.protocol = e.protocol, e.host || m[e.protocol]) n.pathname = e.pathname;else {
            for (var d = (e.pathname || "").split("/"); d.length && !(e.host = d.shift());) {
              ;
            }

            e.host || (e.host = ""), e.hostname || (e.hostname = ""), "" !== d[0] && d.unshift(""), d.length < 2 && d.unshift(""), n.pathname = d.join("/");
          }

          if (n.search = e.search, n.query = e.query, n.host = e.host || "", n.auth = e.auth, n.hostname = e.hostname || e.host, n.port = e.port, n.pathname || n.search) {
            var g = n.pathname || "",
                _ = n.search || "";

            n.path = g + _;
          }

          return n.slashes = n.slashes || e.slashes, n.href = n.format(), n;
        }

        var v = n.pathname && "/" === n.pathname.charAt(0),
            b = e.host || e.pathname && "/" === e.pathname.charAt(0),
            w = b || v || n.host && e.pathname,
            x = w,
            k = n.pathname && n.pathname.split("/") || [],
            T = (d = e.pathname && e.pathname.split("/") || [], n.protocol && !y[n.protocol]);
        if (T && (n.hostname = "", n.port = null, n.host && ("" === k[0] ? k[0] = n.host : k.unshift(n.host)), n.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && ("" === d[0] ? d[0] = e.host : d.unshift(e.host)), e.host = null), w = w && ("" === d[0] || "" === k[0])), b) n.host = e.host || "" === e.host ? e.host : n.host, n.hostname = e.hostname || "" === e.hostname ? e.hostname : n.hostname, n.search = e.search, n.query = e.query, k = d;else if (d.length) k || (k = []), k.pop(), k = k.concat(d), n.search = e.search, n.query = e.query;else if (!r.isNullOrUndefined(e.search)) return T && (n.hostname = n.host = k.shift(), (R = !!(n.host && n.host.indexOf("@") > 0) && n.host.split("@")) && (n.auth = R.shift(), n.host = n.hostname = R.shift())), n.search = e.search, n.query = e.query, r.isNull(n.pathname) && r.isNull(n.search) || (n.path = (n.pathname ? n.pathname : "") + (n.search ? n.search : "")), n.href = n.format(), n;
        if (!k.length) return n.pathname = null, n.search ? n.path = "/" + n.search : n.path = null, n.href = n.format(), n;

        for (var S = k.slice(-1)[0], C = (n.host || e.host || k.length > 1) && ("." === S || ".." === S) || "" === S, E = 0, O = k.length; O >= 0; O--) {
          "." === (S = k[O]) ? k.splice(O, 1) : ".." === S ? (k.splice(O, 1), E++) : E && (k.splice(O, 1), E--);
        }

        if (!w && !x) for (; E--; E) {
          k.unshift("..");
        }
        !w || "" === k[0] || k[0] && "/" === k[0].charAt(0) || k.unshift(""), C && "/" !== k.join("/").substr(-1) && k.push("");
        var R,
            I = "" === k[0] || k[0] && "/" === k[0].charAt(0);
        return T && (n.hostname = n.host = I ? "" : k.length ? k.shift() : "", (R = !!(n.host && n.host.indexOf("@") > 0) && n.host.split("@")) && (n.auth = R.shift(), n.host = n.hostname = R.shift())), (w = w || n.host && k.length) && !I && k.unshift(""), k.length ? n.pathname = k.join("/") : (n.pathname = null, n.path = null), r.isNull(n.pathname) && r.isNull(n.search) || (n.path = (n.pathname ? n.pathname : "") + (n.search ? n.search : "")), n.auth = e.auth || n.auth, n.slashes = n.slashes || e.slashes, n.href = n.format(), n;
      }, o.prototype.parseHost = function () {
        var e = this.host,
            t = s.exec(e);
        t && (":" !== (t = t[0]) && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
      };
    }, function (e, t, n) {
      (function (e, i) {
        var r;
        /*! https://mths.be/punycode v1.4.1 by @mathias */

        !function (o) {
          "object" == typeof t && t && t.nodeType, "object" == typeof e && e && e.nodeType;
          var a = "object" == typeof i && i;
          a.global === a || a.window === a || a.self;
          var s,
              l = 2147483647,
              u = /^xn--/,
              c = /[^\x20-\x7E]/,
              p = /[\x2E\u3002\uFF0E\uFF61]/g,
              f = {
            overflow: "Overflow: input needs wider integers to process",
            "not-basic": "Illegal input >= 0x80 (not a basic code point)",
            "invalid-input": "Invalid input"
          },
              h = Math.floor,
              d = String.fromCharCode;

          function g(e) {
            throw new RangeError(f[e]);
          }

          function m(e, t) {
            for (var n = e.length, i = []; n--;) {
              i[n] = t(e[n]);
            }

            return i;
          }

          function y(e, t) {
            var n = e.split("@"),
                i = "";
            return n.length > 1 && (i = n[0] + "@", e = n[1]), i + m((e = e.replace(p, ".")).split("."), t).join(".");
          }

          function _(e) {
            for (var t, n, i = [], r = 0, o = e.length; r < o;) {
              (t = e.charCodeAt(r++)) >= 55296 && t <= 56319 && r < o ? 56320 == (64512 & (n = e.charCodeAt(r++))) ? i.push(((1023 & t) << 10) + (1023 & n) + 65536) : (i.push(t), r--) : i.push(t);
            }

            return i;
          }

          function v(e) {
            return m(e, function (e) {
              var t = "";
              return e > 65535 && (t += d((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += d(e);
            }).join("");
          }

          function b(e, t) {
            return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
          }

          function w(e, t, n) {
            var i = 0;

            for (e = n ? h(e / 700) : e >> 1, e += h(e / t); e > 455; i += 36) {
              e = h(e / 35);
            }

            return h(i + 36 * e / (e + 38));
          }

          function x(e) {
            var t,
                n,
                i,
                r,
                o,
                a,
                s,
                u,
                c,
                p,
                f,
                d = [],
                m = e.length,
                y = 0,
                _ = 128,
                b = 72;

            for ((n = e.lastIndexOf("-")) < 0 && (n = 0), i = 0; i < n; ++i) {
              e.charCodeAt(i) >= 128 && g("not-basic"), d.push(e.charCodeAt(i));
            }

            for (r = n > 0 ? n + 1 : 0; r < m;) {
              for (o = y, a = 1, s = 36; r >= m && g("invalid-input"), ((u = (f = e.charCodeAt(r++)) - 48 < 10 ? f - 22 : f - 65 < 26 ? f - 65 : f - 97 < 26 ? f - 97 : 36) >= 36 || u > h((l - y) / a)) && g("overflow"), y += u * a, !(u < (c = s <= b ? 1 : s >= b + 26 ? 26 : s - b)); s += 36) {
                a > h(l / (p = 36 - c)) && g("overflow"), a *= p;
              }

              b = w(y - o, t = d.length + 1, 0 == o), h(y / t) > l - _ && g("overflow"), _ += h(y / t), y %= t, d.splice(y++, 0, _);
            }

            return v(d);
          }

          function k(e) {
            var t,
                n,
                i,
                r,
                o,
                a,
                s,
                u,
                c,
                p,
                f,
                m,
                y,
                v,
                x,
                k = [];

            for (m = (e = _(e)).length, t = 128, n = 0, o = 72, a = 0; a < m; ++a) {
              (f = e[a]) < 128 && k.push(d(f));
            }

            for (i = r = k.length, r && k.push("-"); i < m;) {
              for (s = l, a = 0; a < m; ++a) {
                (f = e[a]) >= t && f < s && (s = f);
              }

              for (s - t > h((l - n) / (y = i + 1)) && g("overflow"), n += (s - t) * y, t = s, a = 0; a < m; ++a) {
                if ((f = e[a]) < t && ++n > l && g("overflow"), f == t) {
                  for (u = n, c = 36; !(u < (p = c <= o ? 1 : c >= o + 26 ? 26 : c - o)); c += 36) {
                    x = u - p, v = 36 - p, k.push(d(b(p + x % v, 0))), u = h(x / v);
                  }

                  k.push(d(b(u, 0))), o = w(n, y, i == r), n = 0, ++i;
                }
              }

              ++n, ++t;
            }

            return k.join("");
          }

          s = {
            version: "1.4.1",
            ucs2: {
              decode: _,
              encode: v
            },
            decode: x,
            encode: k,
            toASCII: function toASCII(e) {
              return y(e, function (e) {
                return c.test(e) ? "xn--" + k(e) : e;
              });
            },
            toUnicode: function toUnicode(e) {
              return y(e, function (e) {
                return u.test(e) ? x(e.slice(4).toLowerCase()) : e;
              });
            }
          }, void 0 === (r = function () {
            return s;
          }.call(t, n, t, e)) || (e.exports = r);
        }();
      }).call(t, n(307)(e), n(64));
    }, function (e, t) {
      e.exports = function (e) {
        return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function get() {
            return e.l;
          }
        }), Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function get() {
            return e.i;
          }
        }), e.webpackPolyfill = 1), e;
      };
    }, function (e, t, n) {
      e.exports = {
        isString: function isString(e) {
          return "string" == typeof e;
        },
        isObject: function isObject(e) {
          return "object" == typeof e && null !== e;
        },
        isNull: function isNull(e) {
          return null === e;
        },
        isNullOrUndefined: function isNullOrUndefined(e) {
          return null == e;
        }
      };
    }, function (e, t, n) {
      t.decode = t.parse = n(310), t.encode = t.stringify = n(311);
    }, function (e, t, n) {
      function i(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      e.exports = function (e, t, n, o) {
        t = t || "&", n = n || "=";
        var a = {};
        if ("string" != typeof e || 0 === e.length) return a;
        var s = /\+/g;
        e = e.split(t);
        var l = 1e3;
        o && "number" == typeof o.maxKeys && (l = o.maxKeys);
        var u = e.length;
        l > 0 && u > l && (u = l);

        for (var c = 0; c < u; ++c) {
          var p,
              f,
              h,
              d,
              g = e[c].replace(s, "%20"),
              m = g.indexOf(n);
          m >= 0 ? (p = g.substr(0, m), f = g.substr(m + 1)) : (p = g, f = ""), h = decodeURIComponent(p), d = decodeURIComponent(f), i(a, h) ? r(a[h]) ? a[h].push(d) : a[h] = [a[h], d] : a[h] = d;
        }

        return a;
      };

      var r = Array.isArray || function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      };
    }, function (e, t, n) {
      var i = function i(e) {
        switch (typeof e) {
          case "string":
            return e;

          case "boolean":
            return e ? "true" : "false";

          case "number":
            return isFinite(e) ? e : "";

          default:
            return "";
        }
      };

      e.exports = function (e, t, n, s) {
        return t = t || "&", n = n || "=", null === e && (e = void 0), "object" == typeof e ? o(a(e), function (a) {
          var s = encodeURIComponent(i(a)) + n;
          return r(e[a]) ? o(e[a], function (e) {
            return s + encodeURIComponent(i(e));
          }).join(t) : s + encodeURIComponent(i(e[a]));
        }).join(t) : s ? encodeURIComponent(i(s)) + n + encodeURIComponent(i(e)) : "";
      };

      var r = Array.isArray || function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      };

      function o(e, t) {
        if (e.map) return e.map(t);

        for (var n = [], i = 0; i < e.length; i++) {
          n.push(t(e[i], i));
        }

        return n;
      }

      var a = Object.keys || function (e) {
        var t = [];

        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
        }

        return t;
      };
    }, function (e, t, n) {
      /*!
       *  Secure Hash Algorithm (SHA256)
       *  http://www.webtoolkit.info/
       *
       *  Original code by Angel Marin, Paul Johnston.
       */
      function i(e) {
        function t(e, t) {
          var n = (65535 & e) + (65535 & t);
          return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
        }

        function n(e, t) {
          return e >>> t | e << 32 - t;
        }

        function i(e, t) {
          return e >>> t;
        }

        function r(e, t, n) {
          return e & t ^ ~e & n;
        }

        function o(e, t, n) {
          return e & t ^ e & n ^ t & n;
        }

        function a(e) {
          return n(e, 2) ^ n(e, 13) ^ n(e, 22);
        }

        function s(e) {
          return n(e, 6) ^ n(e, 11) ^ n(e, 25);
        }

        function l(e) {
          return n(e, 7) ^ n(e, 18) ^ i(e, 3);
        }

        return function (e) {
          for (var t = "", n = 0; n < 4 * e.length; n++) {
            t += "0123456789abcdef".charAt(e[n >> 2] >> 8 * (3 - n % 4) + 4 & 15) + "0123456789abcdef".charAt(e[n >> 2] >> 8 * (3 - n % 4) & 15);
          }

          return t;
        }(function (e, u) {
          var c,
              p,
              f,
              h,
              d,
              g,
              m,
              y,
              _,
              v,
              b,
              w = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298),
              x = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225),
              k = new Array(64);

          e[u >> 5] |= 128 << 24 - u % 32, e[15 + (u + 64 >> 9 << 4)] = u;

          for (var T = 0; T < e.length; T += 16) {
            c = x[0], p = x[1], f = x[2], h = x[3], d = x[4], g = x[5], m = x[6], y = x[7];

            for (var S = 0; S < 64; S++) {
              k[S] = S < 16 ? e[S + T] : t(t(t(n(b = k[S - 2], 17) ^ n(b, 19) ^ i(b, 10), k[S - 7]), l(k[S - 15])), k[S - 16]), _ = t(t(t(t(y, s(d)), r(d, g, m)), w[S]), k[S]), v = t(a(c), o(c, p, f)), y = m, m = g, g = d, d = t(h, _), h = f, f = p, p = c, c = t(_, v);
            }

            x[0] = t(c, x[0]), x[1] = t(p, x[1]), x[2] = t(f, x[2]), x[3] = t(h, x[3]), x[4] = t(d, x[4]), x[5] = t(g, x[5]), x[6] = t(m, x[6]), x[7] = t(y, x[7]);
          }

          return x;
        }(function (e) {
          for (var t = Array(), n = 0; n < 8 * e.length; n += 8) {
            t[n >> 5] |= (255 & e.charCodeAt(n / 8)) << 24 - n % 32;
          }

          return t;
        }(e = function (e) {
          e = e.replace(/\r\n/g, "\n");

          for (var t = "", n = 0; n < e.length; n++) {
            var i = e.charCodeAt(n);
            i < 128 ? t += String.fromCharCode(i) : i > 127 && i < 2048 ? (t += String.fromCharCode(i >> 6 | 192), t += String.fromCharCode(63 & i | 128)) : (t += String.fromCharCode(i >> 12 | 224), t += String.fromCharCode(i >> 6 & 63 | 128), t += String.fromCharCode(63 & i | 128));
          }

          return t;
        }(e)), 8 * e.length));
      }

      n.d(t, "a", function () {
        return i;
      });
    }, function (e, t, n) {
      (function (e) {
        n.d(t, "b", function () {
          return r;
        }), n.d(t, "a", function () {
          return o;
        });

        for (
        /*
         * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
         * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
         * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
         * MIT license
         * @license
         */
        var i = "undefined" == typeof window ? e : window, r = i.requestAnimationFrame, o = i.cancelAnimationFrame, a = 0, s = ["ms", "moz", "webkit", "o"], l = 0; l < s.length && !r; ++l) {
          r = i[s[l] + "RequestAnimationFrame"], o = i[s[l] + "CancelAnimationFrame"] || i[s[l] + "CancelRequestAnimationFrame"];
        }

        r && (r = r.bind(i)), o && (o = o.bind(i)), r || (r = function r(e, t) {
          var n = new Date().getTime(),
              i = Math.max(0, 16 - (n - a)),
              r = setTimeout(function () {
            e(n + i);
          }, i);
          return a = n + i, r;
        }), o || (o = function o(e) {
          clearTimeout(e);
        });
      }).call(t, n(64));
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t, n, i) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.x = t, this.y = n, this.z = i, void 0 === this.x && (this.x = 0), void 0 === this.y && (this.y = 0), void 0 === this.z && (this.z = 0);
        }

        return o(e, [{
          key: "set",
          value: function value(e, t, n) {
            return this.x = e, this.y = t, this.z = n, this;
          }
        }, {
          key: "clone",
          value: function value() {
            return new e(this.x, this.y, this.z);
          }
        }, {
          key: "copy",
          value: function value(e) {
            return this.x = e.x, this.y = e.y, this.z = e.z, this;
          }
        }, {
          key: "clamp",
          value: function value(t, n) {
            var i = null != t,
                r = null != n;
            return t instanceof e || !i || (t = new e(t, t, t)), n instanceof e || !r || (n = new e(n, n, n)), i && (this.x = Math.max(t.x, this.x), this.y = Math.max(t.y, this.y), this.z = Math.max(t.z, this.z)), r && (this.x = Math.min(n.x, this.x), this.y = Math.min(n.y, this.y), this.z = Math.min(n.z, this.z)), this;
          }
        }, {
          key: "divide",
          value: function value(t) {
            return t instanceof e ? (this.x /= t.x, this.y /= t.y, this.z /= t.z) : (this.x /= t, this.y /= t, this.z /= t), this;
          }
        }, {
          key: "subtract",
          value: function value(t) {
            return t instanceof e ? (this.x -= t.x, this.y -= t.y, this.z -= t.z) : (this.x -= t, this.y -= t, this.z -= t), this;
          }
        }, {
          key: "multiply",
          value: function value(t) {
            return t instanceof e ? (this.x *= t.x, this.y *= t.y, this.z *= t.z) : (this.x *= t, this.y *= t, this.z *= t), this;
          }
        }, {
          key: "add",
          value: function value(t) {
            return t instanceof e ? (this.x += t.x, this.y += t.y, this.z += t.z) : (this.x += t, this.y += t, this.z += t), this;
          }
        }, {
          key: "equals",
          value: function value(t) {
            return t instanceof e ? t.x === this.x && t.y === this.y && t.z === this.z : t === this.x && t === this.y && t === this.z;
          }
        }, {
          key: "round",
          value: function value() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
          }
        }, {
          key: "ceil",
          value: function value() {
            return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
          }
        }, {
          key: "floor",
          value: function value() {
            return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
          }
        }, {
          key: "fract",
          value: function value() {
            return this.x = this.x % 1, this.y = this.y % 1, this.z = this.z % 1, this;
          }
        }, {
          key: "toInt",
          value: function value() {
            return this.x = 0 | this.x, this.y = 0 | this.y, this.z = 0 | this.z, this;
          }
        }, {
          key: "abs",
          value: function value() {
            return this.x = Math.abs(this.x), this.y = Math.abs(this.y), this.z = Math.abs(this.z), this;
          }
        }, {
          key: "len",
          value: function value() {
            return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
          }
        }, {
          key: "min",
          value: function value() {
            return Math.min(Math.min(this.x, this.y), this.z);
          }
        }, {
          key: "max",
          value: function value() {
            return Math.max(Math.max(this.x, this.y), this.z);
          }
        }, {
          key: "toObject",
          value: function value() {
            return {
              x: this.x,
              y: this.y,
              z: this.z
            };
          }
        }, {
          key: "toString",
          value: function value() {
            return "Vector3({ x: " + this.x + ", y: " + this.y + ", z: " + this.z + " })";
          }
        }, {
          key: "roundDecimal",
          value: function value(e) {
            return this.x = parseFloat(this.x.toFixed(e)), this.y = parseFloat(this.y.toFixed(e)), this.z = parseFloat(this.z.toFixed(e)), this;
          }
        }], [{
          key: "fromObject",
          value: function value(t) {
            return new e(t.x, t.y, t.z);
          }
        }, {
          key: "NULL",
          get: function get() {
            return new e(0, 0, 0);
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.min = t, this.max = n;
        }

        return o(e, [{
          key: "getMin",
          value: function value() {
            return this.min;
          }
        }, {
          key: "getMax",
          value: function value() {
            return this.max;
          }
        }, {
          key: "getLength",
          value: function value() {
            return this.max - this.min;
          }
        }, {
          key: "contains",
          value: function value(e) {
            return this.min <= e && e <= this.max;
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(45),
          a = n(24),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function l(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var u = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new o.a(0, 0),
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new o.a(1, 1),
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new o.a(2, -1),
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : new o.a(2, 0);
          l(this, e), this._p0 = t.clone(), this._p1 = n.clone(), this._p2 = i.clone(), this._p3 = r.clone(), this._segments = [], this._length = -1, this._sample = [];
        }

        return s(e, [{
          key: "set",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new o.a(0, 0),
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new o.a(1, 1),
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new o.a(2, 1),
                i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : new o.a(2, 0);
            this._p0 = e.clone(), this._p1 = t.clone(), this._p2 = n.clone(), this._p3 = i.clone();
          }
        }, {
          key: "getLength",
          value: function value() {
            return this._length;
          }
        }, {
          key: "calculateSegments",
          value: function value() {
            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 100, t = 0, n = 0, i = [], r = 1 / e, o = this._p0.clone(), a = 1; a <= e; a++) {
              var s = [];
              s.push({
                t: t,
                s: n,
                point: o
              }), t += r, t = Math.min(t, 1);
              var l = this.evalAt(t),
                  u = l.clone().subtract(o);
              n += u.len(), s.push({
                t: t,
                s: n,
                point: l
              }), i.push(s), o = l;
            }

            return this._segments = i, this._length = n, n;
          }
        }, {
          key: "evalAt",
          value: function value(e) {
            e = this.normalizeParameter(e);

            var t = this._p0.clone().multiply(Math.pow(1 - e, 3)),
                n = this._p1.clone().multiply(3 * (1 - e) * (1 - e) * e),
                i = this._p2.clone().multiply(3 * (1 - e) * e * e),
                r = this._p3.clone().multiply(e * e * e);

            return t.add(n).add(i).add(r);
          }
        }, {
          key: "isInSegment",
          value: function value(e, t) {
            return (e = this.normalizeArcLength(e)) >= t[0].s && e <= t[1].s;
          }
        }, {
          key: "getArcLengthSegment",
          value: function value(e) {
            e = this.normalizeArcLength(e);

            for (var t = 0; t < this._segments.length; t++) {
              var n = this._segments[t];
              if (this.isInSegment(e, n)) return n;
            }

            return null;
          }
        }, {
          key: "normalizeArcLength",
          value: function value(e) {
            return Math.max(Math.min(this._length, e), 0);
          }
        }, {
          key: "normalizeParameter",
          value: function value(e) {
            return Math.max(Math.min(1, e), 0);
          }
        }, {
          key: "getParameterForArcLength",
          value: function value(e) {
            var t = this.normalizeArcLength(e),
                n = this.getArcLengthSegment(t);
            if (!n) return a.a.warn("CubicBezierCurve#getParameterForArcLength", "Segment not found."), -1;
            var i = (t - n[1].s) / (n[0].s - n[1].s);
            return i * n[0].t + (1 - i) * n[1].t;
          }
        }, {
          key: "evalAtArcLength",
          value: function value(e) {
            return this.evalAt(this.getParameterForArcLength(e));
          }
        }, {
          key: "approximateAtArcLength",
          value: function value(e) {
            var t = this.normalizeArcLength(e),
                n = this.getArcLengthSegment(t);
            if (!n) return -1;
            var i = (t - n[1].s) / (n[0].s - n[1].s);
            return n[0].point.clone().multiply(i).add(n[1].point.clone().multiply(1 - i));
          }
        }, {
          key: "parameterSample",
          value: function value() {
            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 100, t = 1 / e, n = [], i = 0, r = 0; r <= e + 1; r++) {
              n.push(this.evalAt(i)), i += t;
            }

            return this._sample = n, [].concat(n);
          }
        }, {
          key: "arcLengthApproxSample",
          value: function value() {
            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 100, t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = this._length / e, r = [], o = 0, a = t ? 1 : 0; a < e + 1; a++) {
              r.push(this.approximateAtArcLength(o)), o += i;
            }

            return n && r.pop(), this._sample = r, [].concat(r);
          }
        }]), e;
      }();

      t.a = u;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(38),
          f = n(46),
          h = n(45),
          d = n(167),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = p.Constants.OptionType,
          v = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "getRotation",
          value: function value() {
            var e = 0;

            switch (this.getTags().Orientation) {
              case 7:
              case 8:
                e = -90;
                break;

              case 3:
              case 4:
                e = -180;
                break;

              case 5:
              case 6:
                e = 90;
            }

            return e;
          }
        }, {
          key: "_getFlipVertically",
          value: function value() {
            var e = this.getTags().Orientation;
            return -1 !== [5, 7].indexOf(e);
          }
        }, {
          key: "_getFlipHorizontally",
          value: function value() {
            var e = this.getTags().Orientation;
            return -1 !== [2, 4].indexOf(e);
          }
        }, {
          key: "_getFinalOptions",
          value: function value() {
            return {
              rotation: this.getRotation(),
              flipVertically: this._getFlipVertically(),
              flipHorizontally: this._getFlipHorizontally()
            };
          }
        }, {
          key: "_render",
          value: function value(e) {
            var t = this._getFinalOptions(),
                n = t.rotation % 360 * (Math.PI / 180);

            this._sprite.setScale(t.flipHorizontally ? -1 : 1, t.flipVertically ? -1 : 1), this._sprite.setRotation(n), this._sprite.setAnchor(.5, .5), this._sprite.updateTransform();

            var i = this._sprite.getBounds();

            return this._renderTexture.resizeTo(new h.a(i.width, i.height)), this._sprite.setPosition(this._renderTexture.getDimensions().divide(2)), this._renderTexture.render(this._container), f.a.resolve();
          }
        }, {
          key: "getNewDimensions",
          value: function value(e) {
            var t = this._getFinalOptions();

            return e = e.clone(), t.rotation % 180 && e.flip(), e;
          }
        }, {
          key: "applyTo",
          value: function value(e) {
            var t = this._getFinalOptions(),
                n = p.Utils.createCanvas();

            90 === Math.abs(t.rotation % 180) ? (n.width = e.height, n.height = e.width) : (n.width = e.width, n.height = e.height);
            var i = n.getContext("2d"),
                r = t.rotation * Math.PI / 180,
                o = .5 * (n.width - e.width),
                a = .5 * (n.height - e.height);
            return i.translate(o, a), i.translate(.5 * e.width, .5 * e.height), i.rotate(r), i.translate(-.5 * e.width, -.5 * e.height), t.flipVertically && (i.translate(0, e.height), i.scale(1, -1)), t.flipHorizontally && (i.translate(e.width, 0), i.scale(-1, 1)), i.drawImage(e, 0, 0), n;
          }
        }]), t;
      }(d.a);

      v.identifier = "exif-orientation", v.prototype.availableOptions = {
        tags: {
          type: _.OBJECT,
          default: {}
        }
      }, t.a = v;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(121),
          a = n(122),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = a.a.MARKERS,
          u = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._buf = t, this._stream = new o.a(this._buf), this._stream.setHead(0);
        }

        return s(e, [{
          key: "isValid",
          value: function value() {
            if (this._stream.setHead(0), this._stream.readInt16() !== l.APP0) return !1;
            if (!(this._stream.readInt16() >= 16)) return !1;

            var e = this._stream.readString(4),
                t = this._stream.readInt8();

            return "JFIF" === e && 0 === t;
          }
        }, {
          key: "setUnitDensity",
          value: function value(e) {
            this._stream.setHead(11), this._stream.writeInt8(e);
          }
        }, {
          key: "setDensityX",
          value: function value(e) {
            this._stream.setHead(12), this._stream.writeInt16(e);
          }
        }, {
          key: "setDensityY",
          value: function value(e) {
            this._stream.setHead(14), this._stream.writeInt16(e);
          }
        }, {
          key: "getUnitDensity",
          value: function value() {
            return this._stream.setHead(11), this._stream.readInt8();
          }
        }, {
          key: "getDensityX",
          value: function value() {
            return this._stream.setHead(12), this._stream.readInt16();
          }
        }, {
          key: "getDensityY",
          value: function value() {
            return this._stream.setHead(14), this._stream.readInt16();
          }
        }, {
          key: "getBuffer",
          value: function value() {
            return this._buf;
          }
        }]), e;
      }();

      t.a = u;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(121),
          a = n(122),
          s = n(32),
          l = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          u = s.a.invariant,
          c = a.a.MARKERS,
          p = a.a.EXIF_TAGS,
          f = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._buf = t, this._stream = new o.a(this._buf), this._stream.setHead(0), this._parse();
        }

        return l(e, [{
          key: "isValid",
          value: function value() {
            return this._stream.setHead(0), this._stream.readInt16() === c.EXIF && this._stream.readInt16() > 0 && "Exif" === this._stream.readString(4);
          }
        }, {
          key: "_parse",
          value: function value() {
            if (this.isValid()) {
              this._stream.setHead(10);

              var e = this._stream.getHead(),
                  t = !1,
                  n = this._stream.readInt16();

              18761 === n ? t = !1 : 19789 === n ? t = !0 : u(!1, "Invalid TIFF data: No endian type found"), u(42 === this._stream.readInt16(!t), "Invalid TIFF data: No 0x002A");

              var i = this._stream.readInt32(!t);

              u(i >= 8, "Invalid TIFF data: First IFD offset < 8");

              var r = e + i,
                  o = this._readTags(this._stream, e, r, t);

              this._tags = o.tags, this._tagData = o.tagData;
            }
          }
        }, {
          key: "getTags",
          value: function value() {
            return this._tags;
          }
        }, {
          key: "getTagData",
          value: function value() {
            return this._tagData;
          }
        }, {
          key: "setOrientation",
          value: function value(e) {
            if (this._tagData.Orientation) {
              var t = this._tagData.Orientation.entryOffset;
              this._stream.setHead(t + 8), this._stream.writeInt16(e);
            }
          }
        }, {
          key: "_readTags",
          value: function value(e, t, n, i) {
            e.setHead(n);

            for (var r = e.readInt16(!i), o = {}, a = [], s = 0; s < r; s++) {
              var l = n + 12 * s + 2;
              e.setHead(l);
              var u = e.readInt16(!i),
                  c = void 0,
                  f = void 0,
                  h = void 0;

              if (p[u]) {
                u = p[u], c = e.readInt16(!i), f = e.readInt32(!i), h = e.readInt32(!i) + t;
                var d = null;

                switch (c) {
                  case 1:
                  case 7:
                    if (1 === f) d = e.readInt8(!i);else {
                      d = [];

                      for (var g = 0; g < f; g++) {
                        d.push(e.readInt8(!i));
                      }
                    }
                    break;

                  case 2:
                    e.setHead(f > 4 ? h : l + 8), d = e.readString(f);
                    break;

                  case 3:
                    if (e.setHead(f > 2 ? h : l + 8), 1 === f) d = e.readInt16(!i);else {
                      d = [];

                      for (var m = 0; m < f; m++) {
                        d.push(e.readInt16(!i));
                      }
                    }
                    break;

                  case 4:
                  case 9:
                    if (e.setHead(f > 1 ? h : l + 8), 1 === f) d = e.readInt32(!i);else {
                      d = [];

                      for (var y = 0; y < f; y++) {
                        d.push(e.readInt32(!i));
                      }
                    }
                    break;

                  case 5:
                  case 10:
                    if (e.setHead(h), 1 === f) d = e.readInt32(!i) / e.readInt32(!i);else {
                      d = [];

                      for (var _ = 0; _ < f; _++) {
                        var v = e.readInt32(!i) / e.readInt32(!i);
                        d.push(v);
                      }
                    }
                }

                o[u] = d, a[u] = {
                  value: d,
                  numValues: f,
                  entryOffset: l,
                  valueOffset: h,
                  type: c
                };
              }
            }

            return {
              tags: o,
              tagData: a
            };
          }
        }, {
          key: "getBuffer",
          value: function value() {
            return this._buf;
          }
        }]), e;
      }();

      t.a = f;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(10),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(40),
          d = n(86),
          g = n(32),
          m = n(90),
          y = (n(120), n(70)),
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function b(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var w = function (e) {
        function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          v(this, t);
          var i = b(this, (t.__proto__ || f()(t)).call(this, n));
          return i._sdk = e, i;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "export",
          value: function value() {
            var e = this,
                t = this._options.imageFormat;
            return this.validateSettings().then(function () {
              return e._prepareSDK().then(function (t) {
                return function t(n) {
                  return n.renderDone ? n : e._sdk.render().then(function (e) {
                    return t(e);
                  });
                }(t);
              });
            }).then(function (t) {
              var n = t.outputTexture,
                  i = (t.renderDone, e._sdk.getRenderer()),
                  r = i.getCanvas();
              return i.isOfType(h.RendererType.WEBGL) && (r = e._createCanvasFromTexture(n)), e._encodeImageFormat(r);
            }).then(function (n) {
              return e._restoreExifMetadata(n, t);
            }).then(function (t) {
              return e._restoreSDK().then(function () {
                return t;
              });
            });
          }
        }, {
          key: "_restoreExifMetadata",
          value: function value(e, t, n) {
            if (t === h.ImageFormat.JPEG) {
              var i = this._sdk.getExif();

              i && ("string" == typeof e ? e = i.restoreSegments(e) : this._options.renderType);
            }

            return c.a.resolve(e);
          }
        }, {
          key: "_encodeAsDataURL",
          value: function value(e, t, n) {
            return g.a.isBrowser ? c.a.resolve(e.toDataURL(t, n)) : new c.a(function (i, r) {
              e.toDataURL(t, n, function (e, t) {
                e ? r(e) : i(t);
              });
            });
          }
        }, {
          key: "_encodeAsHTMLImage",
          value: function value(e, t, n) {
            return this._encodeAsDataURL(e, t, n).then(function (e) {
              var t = new m.a();
              return t.src = e, c.a.resolve(t);
            });
          }
        }, {
          key: "_encodeAsBuffer",
          value: function value(e, t, n) {
            return c.a.reject(new Error("Unsupported platform for RenderType"));
          }
        }, {
          key: "_encodeAsMSBlob",
          value: function value(e, t, n) {
            return c.a.resolve(e.msToBlob());
          }
        }, {
          key: "_encodeAsBLOB",
          value: function value(e, t, n) {
            return new c.a(function (i, r) {
              e.toBlob(function (e) {
                i(e);
              }, t, n);
            });
          }
        }, {
          key: "_encodeImageFormat",
          value: function value(e) {
            var t = this._options,
                n = t.imageFormat,
                i = t.quality,
                r = this._options.renderType;

            switch (r === h.RenderType.BLOB && e.msToBlob && !e.toBlob && (r = h.RenderType.MSBLOB), r) {
              case h.RenderType.IMAGE:
                return this._encodeAsHTMLImage(e, n, i);

              case h.RenderType.DATAURL:
                return this._encodeAsDataURL(e, n, i);

              case h.RenderType.BUFFER:
                return this._encodeAsBuffer(e, n, i);

              case h.RenderType.MSBLOB:
                return this._encodeAsMSBlob(e, n, i);

              case h.RenderType.BLOB:
                return this._encodeAsBLOB(e, n, i);
            }

            return c.a.reject(new Error("Unsupported RenderType: " + r + "!"));
          }
        }, {
          key: "_prepareSDK",
          value: function value() {
            var e = this._sdk.getRenderer();

            this._sdkSettings = {
              dimensions: e.getDimensions().clone(),
              textureQuality: this._sdk.getTextureQuality(),
              pixelRatio: this._sdk.getPixelRatio(),
              renderMode: this._sdk.getRenderMode()
            }, this._sdk.setRenderMode("export"), this._sdk.setTextureQuality(1);
            var t = e.isOfType(h.RendererType.CANVAS);
            e.setPixelRatio(1), e.resizeTo(this._sdk.getFinalDimensions(), t), this._sdk.setAllOperationsToDirty(!0);

            var n = this._sdk.getOperationsStack();

            return n.forEach(function (e) {
              e.disposeRenderTextures();
            }), n.disableCache(), this._sdk.render();
          }
        }, {
          key: "_restoreSDK",
          value: function value() {
            this._sdk.getOperationsStack().enableCache(), this._sdk.setRenderMode(this._sdkSettings.renderMode);

            var e = this._sdk.getRenderer(),
                t = e.isOfType(h.RendererType.CANVAS);

            return e.setPixelRatio(this._sdkSettings.pixelRatio), e.resizeTo(this._sdkSettings.dimensions, t), this._sdk.setTextureQuality(this._sdkSettings.textureQuality), this._sdk.setAllOperationsToDirty(!0), this._sdk.render();
          }
        }, {
          key: "_createCanvasFromTexture",
          value: function value(e) {
            var t = this._sdk.getRenderer(),
                n = this._sdk.getFinalDimensions(),
                i = this._sdk.getRenderer().getContext(),
                r = i.createFramebuffer();

            i.bindFramebuffer(i.FRAMEBUFFER, r);
            var o = e.getBaseTexture().getGLTextureForRenderer(t);
            i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, o, 0);
            var a = new Uint8Array(n.x * n.y * 4);
            i.readPixels(0, 0, n.x, n.y, i.RGBA, i.UNSIGNED_BYTE, a);
            var s = void 0;

            if (this._checkPixelsForTransparency(a)) {
              var l = new d.a.Sprite(e);
              l.setFilters([new d.a.Filters.UnpremultiplyFilter()]);
              var u = new d.a.Container();
              u.addChild(l), (s = new d.a.RenderTexture(t, n.x, n.y)).render(u);
              var c = s.getBaseTexture().getGLTextureForRenderer(t);
              i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, c, 0), i.readPixels(0, 0, n.x, n.y, i.RGBA, i.UNSIGNED_BYTE, a), t.setRenderTarget(), s.dispose();
            }

            var p = g.a.createCanvas();
            p.width = n.x, p.height = n.y;
            var f = p.getContext("2d"),
                h = f.createImageData(n.x, n.y);
            return h.data.set(a), f.putImageData(h, 0, 0), i.deleteFramebuffer(r), p;
          }
        }, {
          key: "_checkPixelsForTransparency",
          value: function value(e) {
            for (var t = this._sdk.getFinalDimensions(), n = t.x * t.y * 4, i = 3; i < n; i += 4) {
              if (255 !== e[i]) return !0;
            }

            return !1;
          }
        }]), t;
      }(y.a);

      w.prototype.availableOptions = {
        renderType: {
          type: h.OptionType.STRING,
          available: g.a.values(h.RenderType),
          default: h.RenderType.IMAGE
        },
        imageFormat: {
          type: h.OptionType.STRING,
          available: g.a.values(h.ImageFormat),
          default: h.ImageFormat.PNG
        },
        quality: {
          type: h.OptionType.NUMBER,
          default: .8
        }
      }, t.a = w;
    }, function (e, t) {
      /*
       * This file is part of PhotoEditorSDK.
       *
       * Copyright (C) 2016-2019 img.ly GmbH <contact@img.ly>
       * All rights reserved.
       *
       * Redistribution and use in source and binary forms, without
       * modification, are permitted provided that the following license agreement
       * is approved and a legal/financial contract was signed by the user.
       * The license agreement can be found under following link:
       *
       * https://www.photoeditorsdk.com/LICENSE.txt
       * @license
       */
      Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
        value: function value(e) {
          if (null == this) throw new TypeError('"this" is null or not defined');
          var t = Object(this),
              n = t.length >>> 0;
          if ("function" != typeof e) throw new TypeError("predicate must be a function");

          for (var i = arguments[1], r = 0; r < n;) {
            var o = t[r];
            if (e.call(i, o, r, t)) return r;
            r++;
          }

          return -1;
        },
        configurable: !0,
        writable: !0
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }

        return o(e, null, [{
          key: "current",
          value: function value() {
            return "development";
          }
        }, {
          key: "isTest",
          value: function value() {
            return !1;
          }
        }, {
          key: "isDevelopment",
          value: function value() {
            return !0;
          }
        }, {
          key: "isProduction",
          value: function value() {
            return !this.isTest() && !this.isDevelopment();
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(4),
          r = n.n(i),
          o = n(324),
          a = n(332),
          s = n(334),
          l = n(400),
          u = n(401),
          c = n(405),
          p = n(408),
          f = n(411),
          h = n(412),
          d = n(413),
          g = n(416),
          m = n(422),
          y = n(451),
          _ = n(453),
          v = n(454),
          b = n(478),
          w = n(479),
          x = [o.a, a.a, s.a, l.a, u.a, c.a, p.a, f.a, h.a, d.a, g.a, m.a, y.a, _.a, v.a, b.a, w.a];

      r.a.AllOperations = x, t.default = x;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = n.n(h),
          g = n(172),
          m = n(326),
          y = n(328),
          _ = n(330),
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = h.Math.ColorMatrix,
          k = function (e) {
        function t() {
          var e;
          b(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = w(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._clarityFilter = new m.a(), o._temperatureFilter = new y.a(), o._sharpnessFilter = new _.a(), o._filter = new g.a(), o._sprite.setFilters([o._clarityFilter, o._temperatureFilter, o._filter]), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_render",
          value: function value(e) {
            var t = e.getDimensions();
            t.x = 1 / t.x, t.y = 1 / t.y;
            var n = new x();
            n.multiply(x.createSaturationMatrix(-.3 * this._options.clarity + 1)), n.multiply(x.createContrastMatrix(.1 * this._options.clarity + 1)), this._clarityFilter.set({
              clarity: this._options.clarity,
              pixelDimension: t,
              colorMatrix: n,
              colorOffset: n.getOffsets()
            }), this._temperatureFilter.set({
              temperature: this._options.temperature
            }), this._sharpnessFilter.set({
              sharpness: this._options.sharpness,
              pixelDimension: t
            });
            var i = new x();
            i.multiply(x.createExposureMatrix(this._options.exposure)), i.multiply(x.createSaturationMatrix(this._options.saturation + 1)), i.multiply(x.createContrastMatrix((this._options.contrast > 0 ? 2 * this._options.contrast : this._options.contrast) + 1)), i.multiply(x.createBrightnessMatrix(this._options.brightness)), this._filter.set({
              gamma: this._options.gamma,
              shadows: this._options.shadows,
              highlights: this._options.highlights,
              whites: this._options.whites,
              blacks: this._options.blacks,
              colorMatrix: i,
              colorOffset: i.getOffsets()
            });
            var r = [];
            return 0 !== this._options.clarity && r.push(this._clarityFilter), 0 !== this._options.sharpness && r.push(this._sharpnessFilter), 0 !== this._options.temperature && r.push(this._temperatureFilter), r.push(this._filter), this._sprite.setFilters(r), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._filter.dispose(), this._clarityFilter.dispose(), this._temperatureFilter.dispose(), this._sharpnessFilter.dispose();
          }
        }]), t;
      }(h.Operation);

      k.identifier = "adjustments", k.prototype.availableOptions = {
        brightness: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        saturation: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        contrast: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        gamma: {
          type: h.OptionType.NUMBER,
          default: 1,
          minValue: .5,
          midValue: 1,
          maxValue: 2
        },
        exposure: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        shadows: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -2,
          midValue: 0,
          maxValue: 2
        },
        highlights: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        clarity: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        whites: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        blacks: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        temperature: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        },
        sharpness: {
          type: h.OptionType.NUMBER,
          default: 0,
          minValue: -1,
          midValue: 0,
          maxValue: 1
        }
      }, d.a.Operations.AdjustmentsOperation = k, t.a = k;
    }, function (e, t) {
      e.exports = "precision highp float;\n\nvarying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nuniform float u_gamma;\nuniform float u_shadows;\nuniform float u_highlights;\nuniform float u_whites;\nuniform float u_blacks;\n\nuniform mat4 u_colorMatrix;\nuniform vec4 u_colorOffset;\n\nconst float EPSILON = 0.0000001;\n\nfloat calculateLuminance(vec3 rgb) {\n    // This is the luminance calculation part of the RGB to HSL formular.\n    vec4 p = mix(\n        vec4(rgb.gb, 0.0, -1.0 / 3.0),\n        vec4(rgb.bg, -1.0, 2.0 / 3.0),\n        vec4(rgb.g < rgb.b)\n    );\n\n    vec4 q = mix(\n        vec4(rgb.r, p.yzx),\n        vec4(p.xyw, rgb.r),\n        vec4(rgb.r < p.x)\n    );\n\n    float croma = q.x - min(q.w, q.y);\n    float luminance = q.x - croma * 0.5;\n    return luminance;\n}\n\nvec3 map(vec3 x, float in_min, float in_max, float out_min, float out_max){\n  return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;\n}\n\nvoid main() {\n\n  vec4 color = clamp(texture2D(u_image, v_texCoord), 0.0, 1.0);\n  color.rgb /= max(color.a, EPSILON); // Revert premultiplied alpha\n\n  // Apply gamma\n  if (u_gamma != 1.0) {\n    color.rgb = pow(color.rgb, vec3(1.0 / max(u_gamma, EPSILON)));\n  }\n\n  // Apply shadows and highlights\n  float luminance = calculateLuminance(color.rgb);\n\n  float shadow = u_shadows >= 0.0\n    ? clamp(\n          pow(luminance, 1.0 / (u_shadows + 1.0))\n          + pow(luminance, 2.0 / (u_shadows + 1.0)) * -0.76\n          - luminance\n    , 0.0, max(u_shadows, 1.0))\n    : -clamp(\n          pow(luminance, 1.0 / (-u_shadows + 1.0))\n          + pow(luminance, 2.0 / (-u_shadows + 1.0)) * -0.76\n          - luminance\n    , 0.0, max(-u_shadows, 1.0));\n\n  float highlight = u_highlights < 0.0\n    ? clamp(\n          1.0\n          - pow(1.0 - luminance, 1.0 / (1.0 - u_highlights))\n          - pow(1.0 - luminance, 2.0 / (1.0 - u_highlights)) * -0.8\n          - luminance\n     , -1.0, 0.0)\n    : -clamp(\n          1.0\n          - pow(1.0 - luminance, 1.0 / (1.0 + u_highlights))\n          - pow(1.0 - luminance, 2.0 / (1.0 + u_highlights)) * -0.8\n          - luminance\n     , -1.0, 0.0);\n\n  // Bright color need more contrast and dark color need more brightness.\n  // This is to keep saturatation because the color information of a dark colors is lost.\n  float shadowContrast   = shadow * luminance * luminance;\n  float shadowBrightness = shadow - shadowContrast;\n\n  float offset = luminance + shadowContrast + highlight;\n  color.rgb = clamp(offset * ((color.rgb + shadowBrightness) / max(luminance, EPSILON)), 0.0, 1.0);\n  \n  // Apply Color Matrix\n  color.rgb = clamp(color * u_colorMatrix + u_colorOffset, 0.0, 1.0).rgb;\n  color.rgb = map(color.rgb, 0.0, 1.0, u_blacks / 2.0, 1.0 + u_whites / 2.0);\n  color = clamp(color, 0.0, 1.0);\n  color.rgb *= color.a; // Reset premultiplied alpha\n\n  gl_FragColor = color;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          h = p.Math.Vector2,
          d = p.Math.ColorMatrix,
          g = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var e = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this));

          return e._fragmentSource = n(327), e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = n.getContext(),
                r = t.getCanvas(),
                o = t.getContext(),
                a = this._options.clarity,
                s = this._options.colorMatrix,
                l = new p.Color(this._options.colorOffset[0], this._options.colorOffset[1], this._options.colorOffset[2], this._options.colorOffset[3]),
                u = r.width,
                c = r.height,
                f = o.getImageData(0, 0, u, c),
                h = i.createImageData(u, c);
            this.canvasShader(f, h, a, s, l), i.putImageData(h, 0, 0);
          }
        }, {
          key: "canvasShader",
          value: function value(e, t, n, i, r) {
            for (var o = function o(e, t, n) {
              return Math.min(Math.max(e, t), n);
            }, a = function a(e, t, n) {
              var i = o((n - e) / (t - e), 0, 1);
              return i * i * (3 - 2 * i);
            }, s = 4 * e.width, l = e.data.length, u = l - 1, c = e.data, f = t.data, h = new p.Color(), d = function d(e) {
              return c[e = (e = e < 0 ? 0 : e) > u ? u : e];
            }, g = 0; g < l; g += 4) {
              var m = d(g + 0),
                  y = d(g + 1),
                  _ = d(g + 2),
                  v = d(g + 3),
                  b = (m + d(g - 4 - s + 0) + d(g - 4 + 0) + d(g - 4 + s + 0) + d(g - s + 0) + d(g + s + 0) + d(g + 4 - s + 0) + d(g + 4 + 0) + d(g + 4 + s)) / 2295,
                  w = (y + d(g - 4 - s + 1) + d(g - 4 + 1) + d(g - 4 + s + 1) + d(g - s + 1) + d(g + s + 1) + d(g + 4 - s + 1) + d(g + 4 + 1) + d(g + 4 + s + 1)) / 2295,
                  x = (_ + d(g - 4 - s + 2) + d(g - 4 + 2) + d(g - 4 + s + 2) + d(g - s + 2) + d(g + s + 2) + d(g + 4 - s + 2) + d(g + 4 + 2) + d(g + 4 + s + 2)) / 2295,
                  k = (v + d(g - 4 - s + 3) + d(g - 4 + 3) + d(g - 4 + s + 3) + d(g - s + 3) + d(g + s + 3) + d(g + 4 - s + 3) + d(g + 4 + 3) + d(g + 4 + s + 3)) / 2295;

              v /= 255;
              var T = o(.3 * (m /= 255) + .59 * (y /= 255) + .1 * (_ /= 255), .111111, .999999),
                  S = Math.min(a(1 - T, 0, .11), a(T, 0, .11)),
                  C = 3.7 * n * S,
                  E = Math.pow(2, .27 * n * S),
                  O = o(m + o((m - b) * C, 0, 10), 0, 1) * E,
                  R = o(y + o((y - w) * C, 0, 10), 0, 1) * E,
                  I = o(_ + o((_ - x) * C, 0, 10), 0, 1) * E,
                  A = o(v + o((v - k) * C, 0, 10), 0, 1);
              h.set(O, R, I, A);
              var M = i.apply(h).clamp(0, 1);
              f[g + 0] = 255 * M.r, f[g + 1] = 255 * M.g, f[g + 2] = 255 * M.b, f[g + 3] = 255 * M.a;
            }
          }
        }]), t;
      }(p.Engine.Filter);

      g.prototype.availableOptions = {
        clarity: {
          type: p.OptionType.NUMBER,
          default: 0,
          uniformType: p.UniformType.FLOAT
        },
        pixelDimension: {
          type: p.OptionType.VECTOR2,
          default: new h(100, 100),
          uniformType: p.UniformType.FLOAT2
        },
        colorMatrix: {
          type: p.OptionType.COLOR_MATRIX,
          default: new d(),
          uniformType: p.UniformType.MAT4
        },
        colorOffset: {
          type: p.OptionType.ARRAY,
          default: [],
          uniformType: p.UniformType.FLOAT4
        }
      }, t.a = g;
    }, function (e, t) {
      e.exports = "precision mediump float;\n\n// Input Image with config WRAP_S and WRAP_T: CLAMP_TO_EDGE\nuniform sampler2D u_image;\n\n// Size of one pixel == vec2(1.0 / u_image.width, 1.0 / u_image.height)\nuniform vec2 u_pixelDimension;\n\n// Range (-1.0 - 1.0)\nuniform float u_clarity;\n\nvarying vec2 v_texCoord;\n\nuniform mat4 u_colorMatrix;\nuniform vec4 u_colorOffset;\n\nconst float EPSILON = 0.000001;\n\nvec4 unpremultiply(vec4 col) {\n    col.rgb /= max(col.a, EPSILON);\n    return col;\n}\n\nvoid main() {\n    vec4 color = texture2D(u_image, v_texCoord);\n    color = unpremultiply(color);\n\n    // L = Left, R = Right, C = Center, T = Top, B = Bottom\n    vec4 colLB = texture2D(u_image, v_texCoord + vec2(-u_pixelDimension.x, -u_pixelDimension.y));\n    vec4 colLC = texture2D(u_image, v_texCoord + vec2(-u_pixelDimension.x,                 0.0));\n    vec4 colLT = texture2D(u_image, v_texCoord + vec2(-u_pixelDimension.x,  u_pixelDimension.y));\n\n    vec4 colCL = texture2D(u_image, v_texCoord + vec2(                0.0, -u_pixelDimension.y));\n    vec4 colCR = texture2D(u_image, v_texCoord + vec2(                0.0,  u_pixelDimension.y));\n    \n    vec4 colRB = texture2D(u_image, v_texCoord + vec2( u_pixelDimension.x, -u_pixelDimension.y));\n    vec4 colRC = texture2D(u_image, v_texCoord + vec2( u_pixelDimension.x,                 0.0));\n    vec4 colRT = texture2D(u_image, v_texCoord + vec2( u_pixelDimension.x,  u_pixelDimension.y));\n\n    vec4 mergedColor = color;\n    mergedColor.rgb += unpremultiply(colLB).rgb + unpremultiply(colLC).rgb + unpremultiply(colLT).rgb;\n    mergedColor.rgb += unpremultiply(colCL).rgb + unpremultiply(colCR).rgb;\n    mergedColor.rgb += unpremultiply(colRB).rgb + unpremultiply(colRC).rgb + unpremultiply(colRT).rgb;\n\n    mergedColor /= 9.0;\n\n    float grayValue = clamp(color.r * 0.3 + color.g * 0.59 + color.b * 0.1, 0.111111, 0.999999);\n    // 1.0 and 0.0 result in white not black, therefore we clamp\n\n    // Here we create a function that will map values below 0.1 to 0. Values above 0.2 will be mapped to 1,\n    // and for values between 0.1 and 0.2 it will produce a gradient.\n    // The funtion is mirror at 0.5, meaning values between 0.8 and 0.9 will result in a decending gradient.\n    // And values above 0.9 will be mapped to 0.\n    float frequenceFactor = min(smoothstep(1.0 - grayValue, 0.0, 0.11), smoothstep(grayValue, 0.0, 0.11));\n\n    // here we apply the high pass filter. Its strength is determined by the uniform ,\n    // and the frequence factor. That means the only the mid tones are affected by this filter.\n    // Clarity input is ranging from -1 to 1. But we want to strengthen the effect.\n    // Therefore we see this little magic number '3.7'.\n    color.rgb = clamp(color + clamp((color - mergedColor) * u_clarity * 3.7 * frequenceFactor, 0.0, 10.0), 0.0, 1.0).rgb;\n\n    // apply exposure but only to the mid tones.\n    color.rgb = color.rgb * pow(2.0, u_clarity * 0.27 * frequenceFactor);\n\n    // apply contrast and desaturation matrix\n    color.rgb = clamp(color * u_colorMatrix + u_colorOffset, 0.0, 1.0).rgb;\n\n    color.rgb *= color.a; // Premultiply alpha\n\n    gl_FragColor = clamp(color, 0.0, 1.0);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());
      p.Math.Vector3;

      var h = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var e = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this));

          return e._fragmentSource = n(329), e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = n.getContext(),
                r = t.getCanvas(),
                o = t.getContext(),
                a = this._options.temperature,
                s = r.width,
                l = r.height,
                u = o.getImageData(0, 0, s, l),
                c = i.createImageData(s, l);
            this.canvasShader(u, c, a), i.putImageData(c, 0, 0);
          }
        }, {
          key: "canvasShader",
          value: function value(e, t, n) {
            for (var i, r, o, a = function a(e, t, n) {
              return e * (1 - n) + t * n;
            }, s = function s(e, t) {
              return [e[0] * t[0] + e[3] * t[1] + e[6] * t[2], e[1] * t[0] + e[4] * t[1] + e[7] * t[2], e[2] * t[0] + e[5] * t[1] + e[8] * t[2]];
            }, l = e.data.length, u = l - 1, c = e.data, p = t.data, f = function f(e) {
              return c[e = (e = e < 0 ? 0 : e) > u ? u : e];
            }, h = [.93, .54, 0], d = [.299, .587, .114, .596, -.274, -.322, .212, -.523, .311], g = [1, .956, .621, 1, -.272, -.647, 1, -1.105, 1.702], m = 0; m < l; m += 4) {
              var y = f(m + 0) / 255,
                  _ = f(m + 1) / 255,
                  v = f(m + 2) / 255,
                  b = f(m + 3) / 255,
                  w = s(d, [y, _, v]);

              w.z = (i = w.z + 0, r = -.5226, o = .5226, Math.min(Math.max(i, r), o));
              var x = s(g, w),
                  k = [x[0] < .5 ? 2 * x[0] * h[0] : 1 - 2 * (1 - x[0]) * (1 - h[0]), x[1] < .5 ? 2 * x[1] * h[1] : 1 - 2 * (1 - x[1]) * (1 - h[1]), x[2] < .5 ? 2 * x[2] * h[2] : 1 - 2 * (1 - x[2]) * (1 - h[2])];
              p[m + 0] = 255 * a(x[0], k[0], n), p[m + 1] = 255 * a(x[1], k[1], n), p[m + 2] = 255 * a(x[2], k[2], n), p[m + 3] = 255 * b;
            }
          }
        }]), t;
      }(p.Engine.Filter);

      h.prototype.availableOptions = {
        temperature: {
          type: p.OptionType.NUMBER,
          default: 0,
          uniformType: p.UniformType.FLOAT
        }
      }, t.a = h;
    }, function (e, t) {
      e.exports = "precision mediump float;\n\n// Input Image with config WRAP_S and WRAP_T: CLAMP_TO_EDGE\nuniform sampler2D u_image;\n\n// Range (-1.0 - 1.0)\nuniform float u_temperature;\n\nconst lowp vec3 warmFilter = vec3(0.93, 0.54, 0.0);\n\nconst mediump mat3 RGBtoYIQ = mat3(0.299, 0.587, 0.114, 0.596, -0.274, -0.322, 0.212, -0.523, 0.311);\nconst mediump mat3 YIQtoRGB = mat3(1.0, 0.956, 0.621, 1.0, -0.272, -0.647, 1.0, -1.105, 1.702);\n\nconst float EPSILON = 0.0000001;\n\nvarying vec2 v_texCoord;\nvoid main() {\n  float temperature = u_temperature;\n  const float tint = 0.0;\n  vec4 source = texture2D(u_image, v_texCoord);\n\n  source.rgb /= max(source.a, EPSILON);   // Revert premultiplied alpha\n\n  vec3 yiq = RGBtoYIQ * source.rgb;\n  yiq.b = clamp(yiq.b + tint*0.5226*0.1, -0.5226, 0.5226);\n  vec3 rgb = YIQtoRGB * yiq;\n\n  vec3 processed = mix(\n    (1.0 - 2.0 * (1.0 - rgb) * (1.0 - warmFilter)),\n    (2.0 * rgb * warmFilter),\n    vec3(rgb.r < 0.5, rgb.g < 0.5, rgb.b < 0.5)\n  );\n\n  vec4 color = vec4(mix(rgb, processed, temperature), source.a);\n\n  color.rgb *= color.a;   // Premultiply alpha again\n\n  gl_FragColor = color;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          h = p.Math.Vector2,
          d = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var e = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this));

          return e._fragmentSource = n(331), e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = n.getContext(),
                r = t.getCanvas(),
                o = t.getContext(),
                a = this._options.sharpness,
                s = r.width,
                l = r.height,
                u = o.getImageData(0, 0, s, l),
                c = i.createImageData(s, l);
            this.canvasShader(u, c, a), i.putImageData(c, 0, 0);
          }
        }, {
          key: "canvasShader",
          value: function value(e, t, n) {
            for (var i = function i(e, t, n) {
              return Math.min(Math.max(e, t), n);
            }, r = e.width, o = e.height, a = e.data, s = t.data, l = function l(e, t, n) {
              return e * (1 - n) + t * n;
            }, u = function u(e) {
              return i(a[e] / 255, 0, 1);
            }, c = function c(e, t) {
              var n = i(e, 0, r - 1),
                  a = i(t, 0, o - 1);
              return 4 * (n + r * a);
            }, p = [], f = [], h = [-1, 0, 0, 1], d = [0, -1, 1, 0], g = n > 0 ? -1 : .2, m = n > 0 ? 5 : .2, y = Math.abs(n), _ = 0; _ < r; _++) {
              for (var v = 0; v < o; v++) {
                var b = c(_, v);
                p[0] = u(b + 0), p[1] = u(b + 1), p[2] = u(b + 2), p[3] = u(b + 3), f[0] = m * p[0] * p[3], f[1] = m * p[1] * p[3], f[2] = m * p[2] * p[3], f[3] = m * p[3];

                for (var w = 0; w < 4; w++) {
                  var x = c(_ + h[w], v + d[w]),
                      k = u(x + 3);
                  f[3] += g * k;

                  for (var T = 0; T < 3; T++) {
                    f[T] += g * u(x + T) * k;
                  }
                }

                for (var S = 0; S < 3; S++) {
                  f[S] /= Math.max(f[3], 1e-6), f[S] = i(f[S], 0, 1);
                }

                f[3] = i(f[3], 0, 1);

                for (var C = 0; C < 4; C++) {
                  p[C] = i(l(p[C], f[C], y), 0, 1), s[b + C] = 255 * p[C];
                }
              }
            }
          }
        }]), t;
      }(p.Engine.Filter);

      d.prototype.availableOptions = {
        sharpness: {
          type: p.OptionType.NUMBER,
          default: 0,
          uniformType: p.UniformType.FLOAT
        },
        pixelDimension: {
          type: p.OptionType.VECTOR2,
          default: new h(100, 100),
          uniformType: p.UniformType.FLOAT2
        }
      }, t.a = d;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform vec2 u_pixelDimension;\nuniform float u_sharpness;\n \nconst float EPSILON = 0.000001;\n \nvoid main() {\n    vec4 color = clamp(texture2D(u_image, v_texCoord), 0.0, 1.0);\n\n    float factor        = mix(0.2, -1.0, float(u_sharpness > 0.0));\n    vec4 sharpenedColor = mix(0.2,  5.0, float(u_sharpness > 0.0)) * color;\n \n    sharpenedColor += factor * clamp(texture2D(u_image, v_texCoord + u_pixelDimension * vec2(-1.0,  0.0)), 0.0, 1.0);\n    sharpenedColor += factor * clamp(texture2D(u_image, v_texCoord + u_pixelDimension * vec2( 0.0, -1.0)), 0.0, 1.0);\n    sharpenedColor += factor * clamp(texture2D(u_image, v_texCoord + u_pixelDimension * vec2( 0.0,  1.0)), 0.0, 1.0);\n    sharpenedColor += factor * clamp(texture2D(u_image, v_texCoord + u_pixelDimension * vec2( 1.0,  0.0)), 0.0, 1.0);\n \n    color.rgb /= max(color.a, EPSILON); // unpremultiply\n    sharpenedColor.rgb /= max(sharpenedColor.a, EPSILON); // unpremultiply\n \n    sharpenedColor = clamp(sharpenedColor, 0.0, 1.0);\n \n    color = clamp(mix(color, sharpenedColor, abs(u_sharpness)), 0.0, 1.0);\n      \n    gl_FragColor = vec4(color.rgb * color.a, color.a); // premultiply\n}";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = n.n(h),
          g = n(74),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = h.Math.Vector2,
          b = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = _(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));

          o._lastBlurRadius = o._options.blurRadius;
          var a = {
            blurQuality: {
              type: h.OptionType.STRING
            }
          };
          return o._horizontalFilter = new g.a({}, a), o._verticalFilter = new g.a({}, a), o._sprite.setFilters([o._horizontalFilter, o._verticalFilter]), o._horizontalFilter.setDelta(new v(.5, .5)), o._verticalFilter.setDelta(new v(-.5, .5)), o._filter = new g.a({}, a), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "_renderWebGL",
          value: function value(e) {
            return this._renderBlur(e);
          }
        }, {
          key: "_renderCanvas",
          value: function value(e) {
            return this._options.highQualityCanvasBlur ? this._renderBlur(e) : this._renderLQCanvasBlur(e);
          }
        }, {
          key: "_renderBlur",
          value: function value(e) {
            var t = e.getDimensions(),
                n = t.min(),
                i = {
              blurRadius: this._options.blurRadius * n,
              texSize: t,
              blurQuality: "high"
            };
            return this._horizontalFilter.set(i), this._verticalFilter.set(i), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "_renderLQCanvasBlur",
          value: function value(e) {
            var t = this._options.blurRadius,
                n = e.getDimensions();
            return this._filter.set({
              blurRadius: t,
              texSize: n,
              blurQuality: "low"
            }), this._sprite.setFilters([this._filter]), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "transform",
          value: function value(e) {
            var t = this.getBlurRadius(),
                n = e.applyToRelativeSize(t);
            this.set({
              blurRadius: n
            }, !1);
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._filter.dispose(), this._verticalFilter.dispose(), this._horizontalFilter.dispose();
          }
        }, {
          key: "hasChanges",
          value: function value() {
            return !0;
          }
        }]), t;
      }(h.Operation);

      b.identifier = "blur", b.prototype.availableOptions = {
        blurRadius: {
          type: h.OptionType.NUMBER,
          default: .025
        },
        highQualityCanvasBlur: {
          type: h.OptionType.BOOLEAN,
          default: !1
        }
      }, d.a.Operations.BlurOperation = b, t.a = b;
    }, function (e, t) {
      e.exports = "/*\n * Based on evanw's glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n    float radius = u_blurRadius;\n\n    const float steps = 30.0;\n\n    for (float t = -steps; t <= steps; t++) {\n        float percent = (t + offset - 0.5) / steps;\n        float weight = 1.0 - abs(percent);\n\n        // Somehow `sample` is a keyword in headless-gl\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / total;\n}\n";
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = n.n(g),
          y = n(173),
          _ = n(8),
          v = n(367),
          b = n(7),
          w = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          x = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          k = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function T(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function S(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var C = function (e) {
        function t() {
          return T(this, t), S(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), x(t, [{
          key: "_render",
          value: function value(e) {
            return this._selectedFilter.render(this._sdk, e, this._renderTexture);
          }
        }, {
          key: "render",
          value: function value(e) {
            return this._selectedFilter.getDirty() && this.setDirty(!0), this.getEnabled() ? k(t.prototype.__proto__ || d()(t.prototype), "render", this).call(this, e) : (this.setDirtyForRenderer(!1, this._sdk.getRenderer()), g.Promise.resolve(e));
          }
        }, {
          key: "setDirtyForRenderer",
          value: function value(e, n) {
            k(t.prototype.__proto__ || d()(t.prototype), "setDirtyForRenderer", this).call(this, e, n), this._selectedFilter.setDirtyForRenderer(e, n);
          }
        }, {
          key: "disposeRenderTextures",
          value: function value() {
            k(t.prototype.__proto__ || d()(t.prototype), "disposeRenderTextures", this).call(this), this._selectedFilter && this._selectedFilter.disposeRenderTextures();
          }
        }, {
          key: "dispose",
          value: function value() {
            k(t.prototype.__proto__ || d()(t.prototype), "dispose", this).call(this), this._selectedFilter && this._selectedFilter.dispose();
          }
        }, {
          key: "restoreSnapshot",
          value: function value(e) {
            var t = w({}, e);

            if (delete t.filter, e.filter) {
              var n = e.filter.constructor;
              "3d-lut" === n.identifier ? this.setFilter(new n({
                image: e.filter.getImage(),
                resolution: e.filter.getResolution(),
                horizontalTileCount: e.filter.getHorizontalTileCount(),
                verticalTileCount: e.filter.getVerticalTileCount()
              })) : "duotone" === n.identifier ? this.setFilter(new n({
                lightColor: e.filter.getLightColor(),
                darkColor: e.filter.getDarkColor(),
                intensity: e.filter.getIntensity()
              })) : this.setFilter(new n());
            }

            this.set(t);
          }
        }, {
          key: "resetToDefaultFilterIntensity",
          value: function value() {
            var e = this._selectedFilter && this._selectedFilter.availableOptions,
                t = e && e.intensity.default;
            this.setIntensity(t || 1);
          }
        }]), t;
      }(g.Operation);

      C.identifier = "filter", C.prototype.availableOptions = {
        identifier: {
          type: g.OptionType.STRING,
          default: "identity"
        },
        intensity: {
          type: g.OptionType.NUMBER,
          default: 1,
          setter: function setter(e) {
            return this._selectedFilter && this._selectedFilter.setIntensity(e), e;
          }
        },
        filter: {
          type: g.OptionType.OBJECT,
          default: new y.a(),
          setter: function setter(e) {
            return this._selectedFilter && (this._selectedFilter.dispose(), this._selectedFilter = null), this._selectedFilter = e, void 0 !== this._options.intensity && this._selectedFilter.set({
              intensity: this._options.intensity
            }), e;
          }
        }
      }, C.FilterPrimitives = _, C.Filters = v, C.Filter = b.a, m.a.Operations.FilterOperation = C, t.a = C;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var d = function (e) {
        function t() {
          h(this, t);

          var e = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this));

          return e._fragmentSource = n(336), e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = t.getCanvas(),
                r = n.getContext(),
                o = this._options.filteredCanvas;
            r.save(), r.globalAlpha = 1 - this._options.intensity, r.drawImage(i, 0, 0), r.globalAlpha = this._options.intensity, r.drawImage(o, 0, 0), r.restore();
          }
        }]), t;
      }(p.Engine.Filter);

      d.prototype.availableOptions = {
        filteredImage: {
          type: p.OptionType.NUMBER,
          default: 1,
          uniformType: p.UniformType.INT
        },
        filteredCanvas: {
          type: p.OptionType.OBJECT,
          default: null
        },
        intensity: {
          type: p.OptionType.NUMBER,
          default: 1,
          uniformType: p.UniformType.FLOAT
        }
      };

      var g = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
          h(this, e), this._intensity = t, this._stack = [], this._dirtiness = {}, this._renderTextures = {}, this._container = new p.Engine.Container(), this._sprite = new p.Engine.Sprite(), this._container.addChild(this._sprite), this._blendFilter = new d();
        }

        return f(e, [{
          key: "push",
          value: function value(e) {
            this._stack.push(e);
          }
        }, {
          key: "clear",
          value: function value() {
            this._stack = [];
          }
        }, {
          key: "render",
          value: function value(e, t, n) {
            if (this.isEmpty()) return p.Promise.resolve();
            var i = e.getRenderer();

            this._sprite.setTexture(t);

            var r = this._renderTextures[i.id];

            if (!r) {
              var o = e.getSprite().getTexture().getFrame();
              r = new p.Engine.RenderTexture(e.getRenderer(), o.width, o.height), this._renderTextures[i.id] = r;
            }

            var a = n.getDimensions();
            r.resizeTo(a);
            var s = this.isDirtyForRenderer(i);

            if (s) {
              this._stack.forEach(function (t) {
                t.update(e);
              });

              var l = this._stack.map(function (e) {
                return e.getFilter();
              });

              this._sprite.setFilters(l), r.render(this._container), this.setDirtyForRenderer(!1, i);
            }

            if (this._blendFilter.setIntensity(this._intensity), i.isOfType(p.RendererType.CANVAS)) this._blendFilter.setFilteredCanvas(r.getRenderTarget().getCanvas());else if (i.isOfType(p.RendererType.WEBGL)) {
              var u = r.getBaseTexture();
              u.setGLUnit(this._blendFilter.getFilteredImage()), i.updateTexture(u, !1);
            }
            return this._sprite.setFilters([this._blendFilter]), n.clear(p.Color.TRANSPARENT), n.render(this._container), s && this.disposeRenderTextures(), p.Promise.resolve();
          }
        }, {
          key: "setIntensity",
          value: function value(e) {
            this._intensity = e;
          }
        }, {
          key: "isEmpty",
          value: function value() {
            return 0 === this._stack.length;
          }
        }, {
          key: "isDirtyForRenderer",
          value: function value(e) {
            return e.id in this._dirtiness || (this._dirtiness[e.id] = !0), this._dirtiness[e.id];
          }
        }, {
          key: "setDirtyForRenderer",
          value: function value(e, t) {
            this._dirtiness[t.id] = e;
          }
        }, {
          key: "setDirty",
          value: function value(e) {
            for (var t in this._dirtiness) {
              this._dirtiness[t] = e;
            }
          }
        }, {
          key: "disposeRenderTextures",
          value: function value() {
            for (var e in this._renderTextures) {
              this._renderTextures[e].dispose(), delete this._renderTextures[e];
            }
          }
        }, {
          key: "dispose",
          value: function value() {
            this.disposeRenderTextures(), this._stack.forEach(function (e) {
              return e.dispose();
            }), this._stack = [], this._blendFilter.dispose(), this._sprite.dispose();
          }
        }]), e;
      }();

      t.a = g;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_filteredImage;\nuniform float u_intensity;\n\nvoid main() {\n  vec4 color0 = texture2D(u_image, v_texCoord);\n  vec4 color1 = texture2D(u_filteredImage, v_texCoord);\n  gl_FragColor = mix(color0, color1, u_intensity);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(338), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = t.getCanvas(),
                r = t.getContext(),
                o = n.getContext(),
                a = r.getImageData(0, 0, i.width, i.height),
                s = this._options.brightness;

            if (0 !== s) {
              s *= 255;

              for (var l = 0; l < i.width * i.height; l++) {
                var u = 4 * l;
                a.data[u] += s, a.data[u + 1] += s, a.data[u + 2] += s;
              }

              o.putImageData(a, 0, 0);
            } else o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        brightness: {
          type: p.OptionType.NUMBER,
          default: 0,
          uniformType: p.UniformType.FLOAT
        }
      };

      var _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setBrightness(this._options.brightness);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = y.prototype.availableOptions, t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_brightness;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4((texColor.rgb + vec3(u_brightness) * texColor.a), texColor.a);;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(340), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = t.getCanvas(),
                r = t.getContext(),
                o = n.getContext(),
                a = r.getImageData(0, 0, i.width, i.height),
                s = this._options.contrast;

            if (1 !== s) {
              for (var l = 0; l < i.width * i.height; l++) {
                var u = 4 * l;
                a.data[u] = (a.data[u] - 127) * s + 127, a.data[u + 1] = (a.data[u + 1] - 127) * s + 127, a.data[u + 2] = (a.data[u + 2] - 127) * s + 127;
              }

              o.putImageData(a, 0, 0);
            }
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        contrast: {
          type: p.OptionType.NUMBER,
          default: 1,
          uniformType: p.UniformType.FLOAT
        }
      };

      var _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setContrast(this._options.contrast);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = y.prototype.availableOptions, t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_contrast;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(((texColor.rgb - vec3(0.5)) * u_contrast + vec3(0.5) * texColor.a), texColor.a);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = p.Math.ColorMatrix,
          _ = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(342), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = this._options.colorMatrix, l = new p.Color(0, 0, 0, 0), u = 0; u < i.width * i.height; u++) {
              var c = 4 * u;
              l.r = a.data[c] / 255, l.g = a.data[c + 1] / 255, l.b = a.data[c + 2] / 255, l = s.apply(l), a.data[c] = 255 * l.r, a.data[c + 1] = 255 * l.g, a.data[c + 2] = 255 * l.b;
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      _.prototype.availableOptions = {
        colorMatrix: {
          type: p.OptionType.COLOR_MATRIX,
          default: new y(),
          uniformType: p.UniformType.MAT4
        },
        colorMatrixOffset: {
          type: p.OptionType.ARRAY,
          default: [],
          uniformType: p.UniformType.FLOAT4
        }
      };

      var v = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new _(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setColorMatrix(this._options.colorMatrix);
          }
        }]), t;
      }(f.a);

      v.prototype.availableOptions = _.prototype.availableOptions, t.a = v;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform mat4 u_colorMatrix;\nuniform vec4 u_colorMatrixOffset;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = texColor * u_colorMatrix + u_colorMatrixOffset;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(344), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = [.3, .59, .11], l = this._options.desaturation, u = 0; u < i.width * i.height; u++) {
              var c = 4 * u,
                  p = s[0] * a.data[c] / 255 + s[1] * a.data[c + 1] / 255 + s[2] * a.data[c + 2] / 255;
              a.data[c] += (255 * p - a.data[c]) * l, a.data[c + 1] += (255 * p - a.data[c + 1]) * l, a.data[c + 2] += (255 * p - a.data[c + 2]) * l;
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        desaturation: {
          type: p.OptionType.NUMBER,
          default: 1,
          uniformType: p.UniformType.FLOAT
        }
      };

      var _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setDesaturation(this._options.desaturation);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = y.prototype.availableOptions, t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_desaturation;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec3 grayXfer = vec3(0.3, 0.59, 0.11);\n  vec3 gray = vec3(dot(grayXfer, texColor.xyz));\n  gl_FragColor = vec4(mix(texColor.xyz, gray, u_desaturation) * texColor.a, texColor.a);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(346), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = this._options, l = s.lightColor, u = s.darkColor, c = s.intensity, f = 0; f < i.width * i.height; f++) {
              var h = 4 * f,
                  d = a.data[h] / 255,
                  g = a.data[h + 1] / 255,
                  m = a.data[h + 2] / 255,
                  y = a.data[h + 3] / 255,
                  _ = new p.Color(d, g, m, y),
                  v = this._duoToneKernel(_, l, u, c);

              a.data[h] = 255 * v.r, a.data[h + 1] = 255 * v.g, a.data[h + 2] = 255 * v.b, a.data[h + 3] = 255 * v.a;
            }

            o.putImageData(a, 0, 0);
          }
        }, {
          key: "_duoToneKernel",
          value: function value(e, t, n, i) {
            if (e.clone().clamp(0, 1), i > 0) {
              var r = Math.max(i + 1, 1e-7);
              e.r = 1 - Math.pow(1 - e.r, r), e.g = 1 - Math.pow(1 - e.g, r), e.b = 1 - Math.pow(1 - e.b, r);
            } else {
              var o = Math.max(1 - i, 1e-7);
              e.r = Math.pow(e.r, o), e.g = Math.pow(e.g, o), e.b = Math.pow(e.b, o);
            }

            var a = .2126 * e.r + .7152 * e.g + .0722 * e.b,
                s = Math.min(Math.max(a, 0), 1),
                l = n.clone().mix(t, s);
            return l.a *= e.a, l;
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        lightColor: {
          type: p.OptionType.COLOR,
          default: p.Color.RED,
          uniformType: p.UniformType.FLOAT4
        },
        darkColor: {
          type: p.OptionType.COLOR,
          default: p.Color.BLACK,
          uniformType: p.UniformType.FLOAT4
        },
        intensity: {
          type: p.OptionType.NUMBER,
          default: .5,
          uniformType: p.UniformType.FLOAT
        }
      };

      var _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setLightColor(this._options.lightColor), this._filter.setDarkColor(this._options.darkColor);
            var e = 2 * this._options.intensity - 1;

            this._filter.setIntensity(e);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = y.prototype.availableOptions, t.a = _;
    }, function (e, t) {
      e.exports = 'precision highp float;\n\nuniform sampler2D u_image;\nuniform vec4 u_lightColor;\nuniform vec4 u_darkColor;\nuniform float u_intensity;\nvarying vec2 v_texCoord;\n\nconst float EPSILON = 0.0000001;\nconst vec3 GRAYSCALE_WEIGHTS = vec3(0.2126, 0.7152, 0.0722);\n\nvec4 duotoneKernel(vec4 sampledCol, vec4 light, vec4 dark, float intensity) {\n  vec4 color = clamp(sampledCol, 0.0, 1.0);\n  color.rgb /= max(color.a, EPSILON);\n  color = clamp(color, 0.0, 1.0); // necessary to get rid of all extended sRGB issues with OpenGL ES\n \n  // Apply intensity as "symmetric gamma"\n  if (intensity > 0.0) {\n    color.rgb = 1.0 - pow(1.0 - color.rgb, vec3(max(intensity + 1.0, EPSILON)));\n  } else {\n    color.rgb = pow(color.rgb, vec3(max(-intensity + 1.0, EPSILON)));\n  }\n \n  // Colorimetric (perceptual luminance-preserving) RGB to grayscale conversion\n  // https://en.wikipedia.org/wiki/Grayscale#Colorimetric_(perceptual_luminance-preserving)_conversion_to_grayscale\n  float luminance = dot(GRAYSCALE_WEIGHTS, color.rgb);\n \n  // Apply DuoTone\n  vec4 duotone = mix(dark, light, clamp(luminance, 0.0, 1.0));\n  duotone.a *= color.a;\n  \n  duotone.rgb *= duotone.a;\n\n  return duotone;\n}\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = duotoneKernel(texColor, u_lightColor, u_darkColor, u_intensity);\n}';
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(348), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = this._options.gamma, l = new Float32Array(256), u = 0; u < 256; u++) {
              l[u] = 255 * Math.pow(u / 255, s.r);
            }

            for (var c = new Float32Array(256), p = 0; p < 256; p++) {
              c[p] = 255 * Math.pow(p / 255, s.g);
            }

            for (var f = new Float32Array(256), h = 0; h < 256; h++) {
              f[h] = 255 * Math.pow(h / 255, s.b);
            }

            for (var d = 0; d < i.width * i.height; d++) {
              var g = 4 * d;
              a.data[g] = l[a.data[g]], a.data[g + 1] = c[a.data[g + 1]], a.data[g + 2] = f[a.data[g + 2]];
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        gamma: {
          type: p.OptionType.COLOR,
          default: p.Color.WHITE,
          uniformType: p.UniformType.FLOAT3
        }
      };

      var _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setGamma(this._options.gamma);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = y.prototype.availableOptions, t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform vec3 u_gamma;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec3 rgb = vec3(texColor.r, texColor.g, texColor.b);\n  rgb = pow(rgb, u_gamma);\n  gl_FragColor = vec4(rgb * texColor.a, texColor.a);;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(350), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i, r = t.getCanvas(), o = t.getContext(), a = n.getContext(), s = o.getImageData(0, 0, r.width, r.height), l = this._options.color, u = 0; u < r.width; u++) {
              for (var c = 0; c < r.height; c++) {
                var p = 4 * (r.width * c + u),
                    f = (u / r.width - .5) / .75,
                    h = (c / r.height - .5) / .75;
                i = 1 - (f * f + h * h), i = Math.min(Math.max(i, .1), 1), s.data[p] = s.data[p] * (i * l.r), s.data[p + 1] = s.data[p + 1] * (i * l.g), s.data[p + 2] = s.data[p + 2] * (i * l.b), s.data[p + 3] = 255;
              }
            }

            a.putImageData(s, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        color: {
          type: p.OptionType.COLOR,
          default: p.Color.WHITE,
          uniformType: p.UniformType.FLOAT3
        }
      };

      var _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setColor(this._options.color);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = y.prototype.availableOptions, t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nuniform vec3 u_color;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n\n  vec2 textureCoord = v_texCoord - vec2(0.5, 0.5);\n  textureCoord /= 0.75;\n\n  float d = 1.0 - dot(textureCoord, textureCoord);\n  d = clamp(d, 0.2, 1.0);\n  vec3 newColor = texColor.rgb * d * u_color.rgb;\n  gl_FragColor = vec4(vec3(newColor) * texColor.a, texColor.a);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(352), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = 0; s < i.width; s++) {
              for (var l = 0; l < i.height; l++) {
                var u = 4 * (i.width * l + s);
                a.data[u + 2] = .33 * a.data[u + 1], a.data[u] = .6 * a.data[u], a.data[u + 2] += .33 * a.data[u], a.data[u + 1] = .7 * a.data[u + 1], a.data[u + 3] = 255;
              }
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter),
          _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), t;
      }(f.a);

      t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  texColor.b = texColor.g * 0.33;\n  texColor.r = texColor.r * 0.6;\n  texColor.b += texColor.r * 0.33;\n  texColor.g = texColor.g * 0.7;\n  gl_FragColor = texColor;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(354), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = 0; s < i.width; s++) {
              for (var l = 0; l < i.height; l++) {
                var u = 4 * (i.width * l + s),
                    c = .2125 * a.data[u] + .7154 * a.data[u + 1] + .0721 * a.data[u + 2];
                a.data[u] = c, a.data[u + 1] = c, a.data[u + 2] = c;
              }
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter),
          _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), t;
      }(f.a);

      t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nvec3 W = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float luminance = dot(texColor.rgb, W);\n  gl_FragColor = vec4(vec3(luminance) * texColor.a, texColor.a);\n}\n";
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_lookupTable;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float r = texture2D(u_lookupTable, vec2(texColor.r, 0.0)).r;\n  float g = texture2D(u_lookupTable, vec2(texColor.g, 0.0)).g;\n  float b = texture2D(u_lookupTable, vec2(texColor.b, 0.0)).b;\n\n  gl_FragColor = vec4(vec3(r, g, b) * texColor.a, texColor.a);\n}\n";
    }, function (e, t, n) {
      var i = n(5),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(18)),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function _(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = c()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (l.a ? l()(e, t) : e.__proto__ = t);
      }

      var v = h.Math.Vector2,
          b = function (e) {
        function t() {
          m(this, t);
          var e = y(this, (t.__proto__ || f()(t)).call(this));
          return e._precomputeQuads(), e._fragmentSource = n(357), e;
        }

        return _(t, e), g(t, [{
          key: "_precomputeQuads",
          value: function value() {
            this._quads = [];

            for (var e = 0; e < 256; e++) {
              var t = e / 255 * 63,
                  n = new v();
              n.y = .125 * (0 | t) | 0, n.x = (0 | t) - 8 * n.y, this._quads.push(n);
            }
          }
        }, {
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = this._options.lookupTableImage, s = this._createImageCanvas(a).getContext("2d"), l = r.getImageData(0, 0, i.width, i.height), u = s.getImageData(0, 0, a.width, a.height), c = new v(), p = 0; p < i.width * i.height * 4; p += 4) {
              var f = l.data[p],
                  h = l.data[p + 1],
                  d = l.data[p + 2],
                  g = l.data[p + 3] / 255,
                  m = this._quads[d];
              c.x = 64 * m.x, c.y = 64 * m.y, c.x += Math.floor(f / 4), c.y += Math.floor(h / 4);
              var y = 4 * (a.width * c.y + c.x) | 0,
                  _ = u.data[y];
              _ = f * (1 - g) + _ * g;
              var b = u.data[y + 1];
              b = h * (1 - g) + b * g;
              var w = u.data[y + 2];
              w = d * (1 - g) + w * g, l.data[p] = _, l.data[p + 1] = b, l.data[p + 2] = w;
            }

            o.putImageData(l, 0, 0);
          }
        }, {
          key: "_createImageCanvas",
          value: function value(e) {
            var t = h.Utils.createCanvas();
            return t.width = e.width, t.height = e.height, t.getContext("2d").drawImage(e, 0, 0), t;
          }
        }]), t;
      }(h.Engine.Filter);

      b.prototype.availableOptions = {
        lookupTable: {
          type: h.OptionType.NUMBER,
          default: 3,
          uniformType: h.UniformType.INT
        },
        lookupTableImage: {
          type: h.OptionType.IMAGE,
          uniformType: null
        }
      };

      var w = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = y(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new b(), o._textures = {}, o;
        }

        return _(t, e), g(t, [{
          key: "update",
          value: function value(e) {
            var t = e.getRenderer();
            t.isOfType(h.RendererType.WEBGL) ? this._updateWebGLTexture(e) : t.isOfType(h.RendererType.CANVAS) && this._filter.setLookupTableImage(this._options.image);
          }
        }, {
          key: "_updateWebGLTexture",
          value: function value(e) {
            var t = e.getRenderer(),
                n = t.id;
            this._textures[n] || (this._textures[n] = new h.Engine.BaseTexture());
            var i = this._textures[n];
            i.setSource(this._options.image), i.setGLUnit(3), t.updateTexture(i);
          }
        }, {
          key: "dispose",
          value: function value() {
            for (var e in function e(t, n, i) {
              null === t && (t = Function.prototype);
              var o = r()(t, n);

              if (void 0 === o) {
                var a = f()(t);
                return null === a ? void 0 : e(a, n, i);
              }

              if ("value" in o) return o.value;
              var s = o.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._textures) {
              delete this._textures[e];
            }
          }
        }]), t;
      }(d.a);

      w.prototype.availableOptions = {
        image: {
          type: h.OptionType.IMAGE
        }
      }, t.a = w;
    }, function (e, t) {
      e.exports = "/**\n * Based off of GPUImage's LookupFilter:\n * https://github.com/BradLarson/GPUImage/blob/master/framework/Source/GPUImageLookupFilter.m\n */\n\nvarying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_lookupTable;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float blueColor = texColor.b * 63.0;\n\n  vec2 quad1;\n  quad1.y = floor(floor(blueColor) / 8.0);\n  quad1.x = floor(blueColor) - (quad1.y * 8.0);\n\n  vec2 quad2;\n  quad2.y = floor(ceil(blueColor) / 8.0);\n  quad2.x = ceil(blueColor) - (quad2.y * 8.0);\n\n  vec2 texCoord1;\n  texCoord1.x = (quad1.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.r);\n  texCoord1.y = (quad1.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.g);\n\n  vec2 texCoord2;\n  texCoord2.x = (quad2.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.r);\n  texCoord2.y = (quad2.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.g);\n\n  vec4 newColor1 = texture2D(u_lookupTable, texCoord1);\n  vec4 newColor2 = texture2D(u_lookupTable, texCoord2);\n\n  vec4 newColor = mix(newColor1, newColor2, fract(blueColor));\n  gl_FragColor = mix(texColor, vec4(newColor.rgb, texColor.w), texColor.a);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(359), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = this._options.saturation, l = 0; l < i.width; l++) {
              for (var u = 0; u < i.height; u++) {
                var c = 4 * (i.width * u + l),
                    p = .2125 * a.data[c] + .7154 * a.data[c + 1] + .0721 * a.data[c + 2];
                a.data[c] = p * (1 - s) + a.data[c] * s, a.data[c + 1] = p * (1 - s) + a.data[c + 1] * s, a.data[c + 2] = p * (1 - s) + a.data[c + 2] * s;
              }
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        saturation: {
          type: p.OptionType.NUMBER,
          default: 0,
          uniformType: p.UniformType.FLOAT
        }
      };

      var _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setSaturation(this._options.saturation);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = y.prototype.availableOptions, t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_saturation;\n\nconst vec3 luminanceWeighting = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float luminance = dot(texColor.rgb, luminanceWeighting);\n\n  vec3 greyScaleColor = vec3(luminance);\n\n  gl_FragColor = vec4(mix(greyScaleColor, texColor.rgb, u_saturation) * texColor.a, texColor.a);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(361), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = 0; s < i.width; s++) {
              for (var l = 0; l < i.height; l++) {
                var u = 4 * (i.width * l + s);
                a.data[u] = Math.max(255 * this._options.color.r, a.data[u]), a.data[u + 1] = Math.max(255 * this._options.color.g, a.data[u + 1]), a.data[u + 2] = Math.max(255 * this._options.color.b, a.data[u + 2]);
              }
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      y.prototype.availableOptions = {
        color: {
          type: p.OptionType.COLOR,
          default: p.Color.WHITE,
          uniformType: p.UniformType.FLOAT3
        }
      };

      var _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), h(t, [{
          key: "update",
          value: function value() {
            this._filter.setColor(this._options.color);
          }
        }]), t;
      }(f.a);

      _.prototype.availableOptions = y.prototype.availableOptions, t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform vec3 u_color;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec4 overlayVec4 = vec4(u_color, texColor.a);\n  gl_FragColor = max(overlayVec4 * texColor.a, texColor);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(174)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._options.rgbControlPoints || (o._options.rgbControlPoints = {
            red: o._options.controlPoints,
            green: o._options.controlPoints,
            blue: o._options.controlPoints
          }), o._updateLookupTable(), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_updateLookupTable",
          value: function value() {
            var e = this._calculateSplineCurve(this._options.rgbControlPoints.red),
                t = this._calculateSplineCurve(this._options.rgbControlPoints.green),
                n = this._calculateSplineCurve(this._options.rgbControlPoints.blue);

            this._options.data = this._buildLookupTable(e, t, n);
          }
        }, {
          key: "_buildLookupTable",
          value: function value(e, t, n) {
            for (var i = [], r = 0; r < 256; r++) {
              i.push(Math.min(Math.max(r + e[r], 0), 255)), i.push(Math.min(Math.max(r + t[r], 0), 255)), i.push(Math.min(Math.max(r + n[r], 0), 255)), i.push(255);
            }

            return i;
          }
        }, {
          key: "_calculateSplineCurve",
          value: function value(e) {
            e = e.sort(function (e, t) {
              return e[0] > t[0];
            });

            var t,
                n = this._getSplineCurve(e),
                i = n[0];

            if (i[0] > 0) for (t = 0; t < i[0]; t++) {
              n.unshift([0, 0]);
            }
            var r = [];

            for (t = 0; t < n.length; t++) {
              var o = n[t],
                  a = [o[0], o[0]],
                  s = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2));
              a[1] > o[1] && (s = -s), r.push(s);
            }

            return r;
          }
        }, {
          key: "_getSplineCurve",
          value: function value(e) {
            var t,
                n = this._secondDerivative(e),
                i = n.length,
                r = [];

            for (t = 0; t < i; t++) {
              r[t] = n[t];
            }

            var o = [];

            for (t = 0; t < i - 1; t++) {
              for (var a = e[t], s = e[t + 1], l = a[0]; l < s[0]; l++) {
                var u = (l - a[0]) / (s[0] - a[0]),
                    c = 1 - u,
                    p = u,
                    f = s[0] - a[0],
                    h = c * a[1] + p * s[1] + f * f / 6 * ((c * c * c - c) * r[t] + (p * p * p - p) * r[t + 1]);
                h > 255 ? h = 255 : h < 0 && (h = 0), o.push([l, h]);
              }
            }

            return 255 === o.length && o.push(e[e.length - 1]), o;
          }
        }, {
          key: "_secondDerivative",
          value: function value(e) {
            var t = e.length;
            if (t <= 0 || 1 === t) return null;
            var n,
                i,
                r = [],
                o = [];

            for (r[0] = [0, 1, 0], n = 1; n < t - 1; n++) {
              var a = e[n - 1],
                  s = e[n],
                  l = e[n + 1];
              r[n] = r[n] || [], r[n][0] = (s[0] - a[0]) / 6, r[n][1] = (l[0] - a[0]) / 3, r[n][2] = (l[0] - s[0]) / 6, o[n] = (l[1] - s[1]) / (l[0] - s[0]) - (s[1] - a[1]) / (s[0] - a[0]);
            }

            for (o[0] = 0, o[t - 1] = 0, r[t - 1] = [0, 1, 0], n = 1; n < t; n++) {
              i = r[1][0] / r[n - 1][1], r[n][1] -= i * r[n - 1][2], r[n][0] = 0, o[n] -= i * o[n - 1];
            }

            for (n = t - 2; n > 0; n--) {
              i = r[n][2] / r[n + 1][1], r[n][1] -= i * r[n + 1][0], r[n][2] = 0, o[n] -= i * o[n + 1];
            }

            var u = [];

            for (n = 0; n < t; n++) {
              u[n] = o[n] / r[n][1];
            }

            return u;
          }
        }]), t;
      }(f.a);

      m.prototype.availableOptions = {
        rgbControlPoints: {
          type: p.OptionType.OBJECT
        },
        controlPoints: {
          type: p.OptionType.ARRAY,
          default: []
        },
        textureGLUnit: {
          type: p.OptionType.NUMBER,
          default: 1
        }
      }, t.a = m;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(18)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function m(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = l()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (a.a ? a()(e, t) : e.__proto__ = t);
      }

      var y = function (e) {
        function t() {
          d(this, t);
          var e = g(this, (t.__proto__ || c()(t)).call(this));
          return e._fragmentSource = n(364), e;
        }

        return m(t, e), h(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = r.getImageData(0, 0, i.width, i.height), s = 0; s < i.width; s++) {
              for (var l = 0; l < i.height; l++) {
                var u = 4 * (i.width * l + s),
                    c = a.data[u] / 255 * .3 + a.data[u + 1] / 255 * .3 + a.data[u + 2] / 255 * .3;
                c -= .2, c = Math.max(0, Math.min(1, c)), c += .15, c *= 1.4, c *= 255, a.data[u] = c, a.data[u + 1] = c, a.data[u + 2] = c;
              }
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter),
          _ = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new y(), o;
        }

        return m(t, e), t;
      }(f.a);

      t.a = _;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float gray = texColor.r * 0.3 + texColor.g * 0.3 + texColor.b * 0.3;\n  gray -= 0.2;\n  gray = clamp(gray, 0.0, 1.0);\n  gray += 0.15;\n  gray *= 1.4;\n  gl_FragColor = vec4(vec3(gray) * texColor.a, texColor.a);\n}\n";
    }, function (e, t, n) {
      var i = n(5),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(18)),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function _(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = c()(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (l.a ? l()(e, t) : e.__proto__ = t);
      }

      var v = h.Math.Vector2,
          b = h.Math.Vector3,
          w = function (e) {
        function t() {
          m(this, t);
          var e = y(this, (t.__proto__ || f()(t)).call(this));
          return e._precomputeQuads(), e._fragmentSource = n(366), e;
        }

        return _(t, e), g(t, [{
          key: "_precomputeQuads",
          value: function value() {
            this._quads = [];

            for (var e = 0; e < 256; e++) {
              var t = e / 255 * 63,
                  n = new v();
              n.y = .125 * (0 | t) | 0, n.x = (0 | t) - 8 * n.y, this._quads.push(n);
            }
          }
        }, {
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = this._options, r = i.resolution, o = i.horizontalTileCount, a = i.verticalTileCount, s = t.getCanvas(), l = t.getContext(), u = n.getContext(), c = this._options.lookupTableImage, p = this._createImageCanvas(c).getContext("2d"), f = l.getImageData(0, 0, s.width, s.height), d = p.getImageData(0, 0, c.width, c.height), g = new b(r / o - 1 | 0, r / a - 1 | 0, o * a - 1 | 0), m = new h.Color(), y = new h.Color(), _ = new h.Color(), w = new h.Color(), x = new h.Color(), k = new h.Color(), T = new h.Color(), S = new h.Color(), C = new v(), E = new v(), O = function O(e, t, n, i) {
              e.r = t.r * (1 - i) + n.r * i, e.g = t.g * (1 - i) + n.g * i, e.b = t.b * (1 - i) + n.b * i;
            }, R = function R(e, t, n) {
              var i = 4 * ((n = .5 + n | 0) * r + (t = .5 + t | 0));
              e.r = d.data[i] / 255, e.g = d.data[i + 1] / 255, e.b = d.data[i + 2] / 255, e.a = d.data[i + 3] / 255;
            }, I = new h.Color(), A = new h.Color(), M = function M(e, t, n, i, r, o, a) {
              O(I, t, i, o), O(A, n, r, o), O(e, I, A, a);
            }, F = new v(r, r).divide(o, a).floor(), D = 0; D < s.width * s.height * 4; D += 4) {
              m.set(f.data[D] / 255, f.data[D + 1] / 255, f.data[D + 2] / 255, f.data[D + 3] / 255);
              var P = new b(m.r * g.x, m.g * g.y, m.b * g.z),
                  z = P.clone().floor().toInt(),
                  L = P.clone().ceil().toInt(),
                  B = P.clone().fract();
              C.y = z.z / o | 0, C.x = z.z - C.y * o | 0, E.y = L.z / o | 0, E.x = L.z - E.y * o | 0, C.multiply(F), E.multiply(F), R(x, C.x + z.x, C.y + z.y), R(k, C.x + z.x, C.y + L.y), R(T, C.x + L.x, C.y + z.y), R(S, C.x + L.x, C.y + L.y), M(_, x, k, T, S, B.x, B.y), R(x, E.x + z.x, E.y + z.y), R(k, E.x + z.x, E.y + L.y), R(T, E.x + L.x, E.y + z.y), R(S, E.x + L.x, E.y + L.y), M(w, x, k, T, S, B.x, B.y), O(y, _, w, B.z), f.data[D] = Math.ceil(255 * y.r), f.data[D + 1] = Math.ceil(255 * y.g), f.data[D + 2] = Math.ceil(255 * y.b);
            }

            u.putImageData(f, 0, 0);
          }
        }, {
          key: "_createImageCanvas",
          value: function value(e) {
            var t = h.Utils.createCanvas();
            return t.width = e.width, t.height = e.height, t.getContext("2d").drawImage(e, 0, 0), t;
          }
        }]), t;
      }(h.Engine.Filter);

      w.prototype.availableOptions = {
        lookupTable: {
          type: h.OptionType.NUMBER,
          default: 3,
          uniformType: h.UniformType.INT
        },
        lookupTableImage: {
          type: h.OptionType.IMAGE,
          uniformType: null
        },
        resolution: {
          type: h.OptionType.NUMBER,
          default: 128,
          uniformType: h.UniformType.FLOAT
        },
        horizontalTileCount: {
          type: h.OptionType.NUMBER,
          default: 5,
          uniformType: h.UniformType.FLOAT
        },
        verticalTileCount: {
          type: h.OptionType.NUMBER,
          default: 5,
          uniformType: h.UniformType.FLOAT
        }
      };

      var x = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = y(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._filter = new w(), o._textures = {}, o;
        }

        return _(t, e), g(t, [{
          key: "update",
          value: function value(e) {
            var t = e.getRenderer();
            t.isOfType(h.RendererType.WEBGL) ? this._updateWebGLTexture(e) : t.isOfType(h.RendererType.CANVAS) && this._filter.setLookupTableImage(this._options.image);
            var n = this._options,
                i = n.resolution,
                r = n.verticalTileCount,
                o = n.horizontalTileCount;

            this._filter.set({
              resolution: i,
              verticalTileCount: r,
              horizontalTileCount: o
            });
          }
        }, {
          key: "_updateWebGLTexture",
          value: function value(e) {
            var t = e.getRenderer(),
                n = t.id;
            this._textures[n] || (this._textures[n] = new h.Engine.BaseTexture());
            var i = this._textures[n];
            i.setSource(this._options.image), i.setGLUnit(3), i.setMinFilter(h.Engine.BaseTexture.NearestFilter), t.updateTexture(i);
          }
        }, {
          key: "dispose",
          value: function value() {
            for (var e in function e(t, n, i) {
              null === t && (t = Function.prototype);
              var o = r()(t, n);

              if (void 0 === o) {
                var a = f()(t);
                return null === a ? void 0 : e(a, n, i);
              }

              if ("value" in o) return o.value;
              var s = o.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._textures) {
              delete this._textures[e];
            }
          }
        }]), t;
      }(d.a);

      x.prototype.availableOptions = {
        image: {
          type: h.OptionType.IMAGE
        },
        resolution: {
          type: h.OptionType.NUMBER,
          default: 128
        },
        horizontalTileCount: {
          type: h.OptionType.NUMBER,
          default: 5
        },
        verticalTileCount: {
          type: h.OptionType.NUMBER,
          default: 5
        }
      }, t.a = x;
    }, function (e, t) {
      e.exports = "precision highp float;\n\nuniform sampler2D u_image;\n\nuniform sampler2D u_lookupTable;\n\nuniform float u_resolution;     // Texture-Resolution, must be power of 2: 64, 128, 256, 512, 1024, 2048, 4096\nuniform float u_horizontalTileCount; // Horizontal Blue Tiles\nuniform float u_verticalTileCount; // Vertical Blue Tiles\n\nvarying vec2 v_texCoord;\n\nconst float EPSILON = 0.000001;\n\n// Try to get the exact pixel of the lut map image\nvec3 lutColor(int texPosX, int texPosY) {\n    return texture2D(u_lookupTable, (0.5 / u_resolution) + vec2(float(texPosX), float(texPosY)) / u_resolution).rgb;\n}\n\nvec3 bilinearInterpolate(vec3 cRfGf, vec3 cRfGc, vec3 cRcGf, vec3 cRcGc, float redFract, float greenFract) {\n    return mix(mix(cRfGf, cRcGf, redFract), mix(cRfGc, cRcGc, redFract), greenFract);\n}\n\nvoid main() {\n    vec4 inputColor = clamp(texture2D(u_image, v_texCoord.xy), 0.0, 1.0);\n\n    vec3 sourceColor = vec3(inputColor.rgb / max(inputColor.a, EPSILON)); \n\n    vec3 ranges = vec3(\n        floor(u_resolution / u_horizontalTileCount - 1.0),\n        floor(u_resolution / u_verticalTileCount - 1.0),\n        floor(u_horizontalTileCount * u_horizontalTileCount - 1.0)\n    );\n    \n    vec3 tmp = sourceColor * ranges;\n    ivec3 floors = ivec3(tmp);\n    ivec3 ceils = ivec3(ceil(tmp));\n    vec3 fracts = fract(tmp);\n\n    // Map tile index to tile pixel pos.\n    ivec2 pixelsPerTile = ivec2(\n        u_resolution / u_horizontalTileCount, \n        u_resolution / u_verticalTileCount\n      );\n\n    ivec2 tileFloor; // Blue tile index\n    tileFloor.y = floors.z / int(u_horizontalTileCount);\n    tileFloor.x = (floors.z - (tileFloor.y * int(u_horizontalTileCount)));\n\n    ivec2 tileCeil; // Blue tile index\n    tileCeil.y = ceils.z / int(u_horizontalTileCount);\n    tileCeil.x = (ceils.z - (tileCeil.y * int(u_horizontalTileCount)));\n    \n    tileFloor *= pixelsPerTile;\n    tileCeil *= pixelsPerTile; \n    \n    \n    // Interpolate between red and green\n    vec3 lutColorFB = bilinearInterpolate(\n        lutColor(tileFloor.x + floors.x, tileFloor.y + floors.y),\n        lutColor(tileFloor.x + floors.x, tileFloor.y + ceils.y),\n        lutColor(tileFloor.x + ceils.x,  tileFloor.y + floors.y),\n        lutColor(tileFloor.x + ceils.x,  tileFloor.y + ceils.y),\n        fracts.x, fracts.y\n    );\n    vec3 lutColorCB = bilinearInterpolate(\n        lutColor(tileCeil.x + floors.x, tileCeil.y + floors.y),\n        lutColor(tileCeil.x + floors.x, tileCeil.y + ceils.y),\n        lutColor(tileCeil.x + ceils.x,  tileCeil.y + floors.y),\n        lutColor(tileCeil.x + ceils.x,  tileCeil.y + ceils.y),\n        fracts.x, fracts.y\n    );\n\n    // Interpolate between the blue values\n    vec3 interpolation = mix(lutColorFB, lutColorCB, fracts.z);\n\n    // Round Color Values to prevent that for ex. 254.999999 is cutting to 254 instead of 255;\n    interpolation = clamp(floor(interpolation * 255. + .5) / 255., 0.0, 1.0);\n\n    gl_FragColor = vec4(interpolation.rgb * inputColor.a, inputColor.a);\n}\n";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(173);
      n.d(t, "IdentityFilter", function () {
        return i.a;
      });
      var r = n(368);
      n.d(t, "A15Filter", function () {
        return r.a;
      });
      var o = n(369);
      n.d(t, "BreezeFilter", function () {
        return o.a;
      });
      var a = n(370);
      n.d(t, "BWFilter", function () {
        return a.a;
      });
      var s = n(371);
      n.d(t, "BWHardFilter", function () {
        return s.a;
      });
      var l = n(372);
      n.d(t, "CelsiusFilter", function () {
        return l.a;
      });
      var u = n(373);
      n.d(t, "ChestFilter", function () {
        return u.a;
      });
      var c = n(374);
      n.d(t, "DuoToneFilter", function () {
        return c.a;
      });
      var p = n(375);
      n.d(t, "FixieFilter", function () {
        return p.a;
      });
      var f = n(376);
      n.d(t, "FoodFilter", function () {
        return f.a;
      });
      var h = n(377);
      n.d(t, "FridgeFilter", function () {
        return h.a;
      });
      var d = n(378);
      n.d(t, "FrontFilter", function () {
        return d.a;
      });
      var g = n(379);
      n.d(t, "GlamFilter", function () {
        return g.a;
      });
      var m = n(380);
      n.d(t, "GobblinFilter", function () {
        return m.a;
      });
      var y = n(381);
      n.d(t, "K1Filter", function () {
        return y.a;
      });

      var _ = n(382);

      n.d(t, "K2Filter", function () {
        return _.a;
      });
      var v = n(383);
      n.d(t, "K6Filter", function () {
        return v.a;
      });
      var b = n(384);
      n.d(t, "KDynamicFilter", function () {
        return b.a;
      });
      var w = n(385);
      n.d(t, "LeninFilter", function () {
        return w.a;
      });
      var x = n(386);
      n.d(t, "LomoFilter", function () {
        return x.a;
      });
      var k = n(387);
      n.d(t, "MellowFilter", function () {
        return k.a;
      });
      var T = n(388);
      n.d(t, "MetalFilter", function () {
        return T.a;
      });
      var S = n(389);
      n.d(t, "MorningFilter", function () {
        return S.a;
      });
      var C = n(390);
      n.d(t, "OrchidFilter", function () {
        return C.a;
      });
      var E = n(391);
      n.d(t, "PolaFilter", function () {
        return E.a;
      });
      var O = n(392);
      n.d(t, "Pola669Filter", function () {
        return O.a;
      });
      var R = n(393);
      n.d(t, "QuoziFilter", function () {
        return R.a;
      });
      var I = n(394);
      n.d(t, "SemiredFilter", function () {
        return I.a;
      });
      var A = n(395);
      n.d(t, "SunnyFilter", function () {
        return A.a;
      });
      var M = n(396);
      n.d(t, "TexasFilter", function () {
        return M.a;
      });
      var F = n(397);
      n.d(t, "X400Filter", function () {
        return F.a;
      });
      var D = n(398);
      n.d(t, "LUTFilter", function () {
        return D.a;
      });
      var P = n(399);
      n.d(t, "ThreeDLUTFilter", function () {
        return P.a;
      });
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Contrast({
            contrast: .63
          })), o._stack.push(new c.Brightness({
            brightness: .12
          })), o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 38], [94, 94], [148, 142], [175, 187], [255, 255]],
              green: [[0, 0], [77, 53], [171, 190], [255, 255]],
              blue: [[0, 10], [48, 85], [174, 228], [255, 255]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "a15", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Desaturation({
            desaturation: .5
          })), o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [170, 170], [212, 219], [234, 242], [255, 255]],
              green: [[0, 0], [170, 168], [234, 231], [255, 255]],
              blue: [[0, 0], [170, 170], [212, 208], [255, 255]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "breeze", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Grayscale()), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "bw", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Grayscale()), o._stack.push(new c.Contrast({
            contrast: 1.5
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "bwhard", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 69], [55, 110], [202, 230], [255, 255]],
              green: [[0, 44], [89, 93], [185, 141], [255, 189]],
              blue: [[0, 76], [39, 82], [218, 138], [255, 171]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "celsius", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [44, 44], [124, 143], [221, 204], [255, 255]],
              green: [[0, 0], [130, 127], [213, 199], [255, 255]],
              blue: [[0, 0], [51, 52], [219, 204], [255, 255]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "chest", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(4),
          c = (n.n(u), n(7)),
          p = n(8);

      function f(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function h(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var d = function (e) {
        function t() {
          var e;
          f(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = h(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i, [{
            intensity: {
              type: u.OptionType.NUMBER,
              default: .5,
              required: !0,
              setter: function setter(e) {
                return this._filterPrimitive && (this._filterPrimitive.setIntensity(e), this._stack.setIntensity(1)), this._dirty = !0, e;
              }
            }
          }])));
          return o._filterPrimitive = new p.DuoTone({
            lightColor: o._options.lightColor || u.Color.WHITE,
            darkColor: o._options.darkColor || u.Color.BLACK,
            intensity: o._options.intensity || .5
          }), o._stack.push(o._filterPrimitive), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(c.a);

      d.prototype.availableOptions = {
        lightColor: {
          type: u.OptionType.COLOR,
          default: u.Color.WHITE,
          required: !0,
          setter: function setter(e) {
            return this._filterPrimitive && this._filterPrimitive.setLightColor(e), this.setDirty && this.setDirty(!0), e;
          }
        },
        darkColor: {
          type: u.OptionType.COLOR,
          default: u.Color.BLACK,
          required: !0,
          setter: function setter(e) {
            return this._filterPrimitive && this._filterPrimitive.setDarkColor(e), this.setDirty && this.setDirty(!0), e;
          }
        },
        intensity: {
          type: u.OptionType.NUMBER,
          default: .5,
          required: !0
        }
      }, d.identifier = "duotone", t.a = d;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [44, 28], [63, 48], [128, 132], [235, 248], [255, 255]],
              green: [[0, 0], [20, 10], [60, 45], [190, 209], [211, 231], [255, 255]],
              blue: [[0, 31], [41, 62], [150, 142], [234, 212], [255, 224]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "fixie", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Saturation({
            saturation: 1.35
          })), o._stack.push(new c.Contrast({
            contrast: 1.1
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "food", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 9], [21, 11], [45, 24], [255, 220]],
              green: [[0, 12], [21, 21], [42, 42], [150, 150], [170, 173], [255, 210]],
              blue: [[0, 28], [43, 72], [128, 185], [255, 220]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "fridge", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 65], [28, 67], [67, 113], [125, 183], [187, 217], [255, 229]],
              green: [[0, 52], [42, 59], [104, 134], [169, 209], [255, 240]],
              blue: [[0, 52], [65, 68], [93, 104], [150, 153], [255, 198]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "front", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Contrast({
            contrast: 1.1
          })), o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [94, 74], [181, 205], [255, 255]],
              green: [[0, 0], [127, 127], [255, 255]],
              blue: [[0, 0], [102, 73], [227, 213], [255, 255]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "glam", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Gobblin()), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "gobblin", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            controlPoints: [[0, 0], [53, 32], [91, 80], [176, 205], [255, 255]]
          })), o._stack.push(new c.Saturation({
            saturation: .9
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "k1", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(4),
          c = (n.n(u), n(7)),
          p = n(8);

      function f(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function h(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var d = function (e) {
        function t() {
          var e;
          f(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = h(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new p.ToneCurve({
            controlPoints: [[0, 0], [54, 33], [77, 82], [94, 103], [122, 126], [177, 193], [229, 232], [255, 255]]
          })), o._stack.push(new p.SoftColorOverlay({
            color: new u.Color(40 / 255, 40 / 255, 40 / 255)
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(c.a);

      d.identifier = "k2", t.a = d;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Saturation({
            saturation: .5
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "k6", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            controlPoints: [[0, 0], [17, 27], [46, 69], [90, 112], [156, 200], [203, 243], [255, 255]]
          })), o._stack.push(new c.Saturation({
            saturation: .7
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "kdynamic", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Desaturation({
            desaturation: .4
          })), o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 20], [40, 20], [106, 111], [129, 153], [190, 223], [255, 255]],
              green: [[0, 20], [40, 20], [62, 41], [106, 108], [132, 159], [203, 237], [255, 255]],
              blue: [[0, 40], [40, 40], [73, 60], [133, 160], [191, 297], [203, 237], [237, 239], [255, 255]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "lenin", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            controlPoints: [[0, 0], [87, 20], [131, 156], [183, 205], [255, 200]]
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "lomo", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [41, 84], [87, 134], [255, 255]],
              green: [[0, 0], [255, 216]],
              blue: [[0, 0], [255, 131]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "mellow", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(4),
          c = (n.n(u), n(7)),
          p = n(8);

      function f(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function h(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var d = u.Math.ColorMatrix,
          g = function (e) {
        function t() {
          var e;
          f(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = h(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i))),
              a = new d(.8158218291630716, 0, 0, 0, -.01779810181190647, 0, .8098360655737704, 0, 0, .0916393442622953, 0, 0, .4596336773932402, 0, .12760574782432707, 0, 0, 0, 1, 0);

          o._stack.push(new p.ColorMatrixPrimitive({
            colorMatrix: a
          }));

          var s = new u.Color(.8, .6, .9);
          return o._stack.push(new p.Gamma({
            gamma: s
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(c.a);

      g.identifier = "metal", t.a = g;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 40], [255, 230]],
              green: [[0, 10], [255, 225]],
              blue: [[0, 20], [255, 181]]
            }
          })), o._stack.push(new c.Glow()), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "morning", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [115, 130], [195, 215], [255, 255]],
              green: [[0, 0], [148, 153], [172, 215], [255, 255]],
              blue: [[0, 46], [58, 75], [178, 205], [255, 255]]
            },
            textureGLUnit: 2
          })), o._stack.push(new c.ToneCurve({
            controlPoints: [[0, 0], [117, 151], [189, 217], [255, 255]],
            textureGLUnit: 3
          })), o._stack.push(new c.Desaturation({
            desaturation: .65
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "orchid", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [94, 74], [181, 205], [255, 255]],
              green: [[0, 0], [34, 34], [99, 76], [176, 190], [255, 255]],
              blue: [[0, 0], [102, 73], [227, 213], [255, 255]]
            }
          })), o._stack.push(new c.Saturation({
            saturation: .8
          })), o._stack.push(new c.Contrast({
            contrast: 1.5
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "pola", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [56, 18], [196, 209], [255, 255]],
              green: [[0, 38], [71, 84], [255, 255]],
              blue: [[0, 0], [131, 133], [204, 211], [255, 255]]
            }
          })), o._stack.push(new c.Saturation({
            saturation: .8
          })), o._stack.push(new c.Contrast({
            contrast: 1.5
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "pola669", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.Desaturation({
            desaturation: .65
          })), o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 50], [40, 78], [118, 170], [181, 211], [255, 255]],
              green: [[0, 27], [28, 45], [109, 157], [157, 195], [179, 208], [206, 212], [255, 240]],
              blue: [[0, 50], [12, 55], [46, 103], [103, 162], [194, 182], [241, 201], [255, 219]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "quozi", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 129], [75, 153], [181, 227], [255, 255]],
              green: [[0, 8], [111, 85], [212, 158], [255, 226]],
              blue: [[0, 5], [75, 22], [193, 90], [255, 229]]
            }
          })), o._stack.push(new c.Glow()), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "semired", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 0], [62, 82], [141, 154], [255, 255]],
              green: [[0, 39], [56, 96], [192, 176], [255, 255]],
              blue: [[0, 0], [174, 99], [255, 235]]
            },
            textureGLUnit: 2
          })), o._stack.push(new c.ToneCurve({
            controlPoints: [[0, 0], [55, 20], [158, 191], [255, 255]],
            textureGLUnit: 3
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "sunny", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.ToneCurve({
            rgbControlPoints: {
              red: [[0, 72], [89, 99], [176, 212], [255, 237]],
              green: [[0, 49], [255, 192]],
              blue: [[0, 72], [255, 151]]
            }
          })), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "texas", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(7),
          c = n(8);

      function p(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function f(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var h = function (e) {
        function t() {
          var e;
          p(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = f(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._stack.push(new c.X400()), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.a);

      h.identifier = "x400", t.a = h;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(4),
          c = (n.n(u), n(7)),
          p = n(8);

      function f(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function h(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var d = function (e) {
        function t() {
          var e;
          f(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = h(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i)));
          return o._lutPrimitive = new p.LookupTableImage({
            image: o._options.image
          }), o._stack.push(o._lutPrimitive), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(c.a);

      d.prototype.availableOptions = {
        image: {
          type: u.OptionType.IMAGE,
          required: !0,
          setter: function setter(e) {
            return this._lutPrimitive && this._lutPrimitive.setImage(e), this.setDirty(!0), e;
          }
        }
      }, d.identifier = "lut", t.a = d;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(4),
          c = (n.n(u), n(7)),
          p = n(8);

      function f(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function h(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var d = function (e) {
        function t() {
          var e;
          f(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = h(this, (e = t.__proto__ || l()(t)).call.apply(e, [this].concat(i))),
              a = o._options,
              s = a.image,
              u = a.resolution,
              c = a.verticalTileCount,
              d = a.horizontalTileCount;
          return o._lutPrimitive = new p.ThreeDLookupTableImage({
            image: s,
            resolution: u,
            verticalTileCount: c,
            horizontalTileCount: d
          }), o._stack.push(o._lutPrimitive), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(c.a);

      d.prototype.availableOptions = {
        image: {
          type: u.OptionType.IMAGE,
          required: !0,
          setter: function setter(e) {
            return this._lutPrimitive && this._lutPrimitive.setImage(e), this.setDirty(!0), e;
          }
        },
        resolution: {
          type: u.OptionType.NUMBER,
          default: 128
        },
        horizontalTileCount: {
          type: u.OptionType.NUMBER,
          default: 5
        },
        verticalTileCount: {
          type: u.OptionType.NUMBER,
          default: 5
        }
      }, d.identifier = "3d-lut", t.a = d;
    }, function (e, t, n) {
      var i = n(36),
          r = n.n(i),
          o = n(37),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(5),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = n.n(y),
          v = "function" == typeof a.a && "symbol" == typeof r.a ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof a.a && e.constructor === a.a && e !== a.a.prototype ? "symbol" : typeof e;
      },
          b = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function w(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var k = y.Math.Vector2,
          T = function (e) {
        function t() {
          var e;
          w(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = x(this, (e = t.__proto__ || m()(t)).call.apply(e, [this].concat(i)));
          return o._colorOverlayFilter = new y.Engine.Filters.ColorOverlayFilter({
            color: o.getTintColor()
          }), o._frameContainer = new y.Engine.Container(), o._resetSprites(), o._options.frame && o._createSpritesForFrame(o._options.frame), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), b(t, [{
          key: "_resetSprites",
          value: function value() {
            this._spriteGroups = {
              top: {},
              left: {},
              right: {},
              bottom: {}
            }, this._sprites = [], this._repeatSprites = {
              top: [],
              left: [],
              right: [],
              bottom: []
            };
          }
        }, {
          key: "_createSpritesForFrame",
          value: function value(e) {
            var t = this;
            if (!e) return this._disposeSprites();
            var n = e.imageGroups,
                i = e.layoutMode;
            this._layoutMode = i || "horizontal-inside", this._disposeSprites(), ["top", "left", "right", "bottom"].forEach(function (e) {
              void 0 !== n[e] && ["start", "mid", "end"].forEach(function (i) {
                if (void 0 !== n[e][i]) {
                  var r = n[e][i];
                  "image" in r && (r = r.image);
                  var o = y.Engine.Texture.fromImage(r),
                      a = new y.Engine.Sprite(o);
                  t._spriteGroups[e][i] = a, t._sprites.push(a), t._frameContainer.addChild(a);
                }
              });
            });
          }
        }, {
          key: "_render",
          value: function value(e) {
            var t = this._renderTexture.getDimensions();

            return this._options.frame && (this._colorOverlayFilter.setColor(this.getTintColor()), this._updateSprites(e)), this._frameRenderTexture ? this._frameRenderTexture.resizeTo(t) : (this._frameRenderTexture = new y.Engine.RenderTexture(this._sdk.getRenderer(), t.x, t.y), this._frameSprite = new y.Engine.Sprite(this._frameRenderTexture), this._container.addChild(this._frameSprite)), this._frameSprite.setAlpha(this._options.alpha), this._options.frame && this._options.frame.tintable ? this._frameSprite.setFilters([this._colorOverlayFilter]) : this._frameSprite.setFilters([]), this._frameRenderTexture.clear(), this._frameRenderTexture.render(this._frameContainer), this._renderTexture.render(this._container), y.Promise.resolve();
          }
        }, {
          key: "_updateSprites",
          value: function value(e) {
            var t = e.getDimensions();
            this._frameWidth = Math.ceil(e.getDimensions().min() * this._options.scale), this._updateHorizontalSpriteGroup(e, "top", 0), this._updateHorizontalSpriteGroup(e, "bottom", t.y - this._frameWidth), this._updateVerticalSpriteGroup(e, "left", 0), this._updateVerticalSpriteGroup(e, "right", t.x - this._frameWidth);
          }
        }, {
          key: "_updateHorizontalSpriteGroup",
          value: function value(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                i = e.getDimensions(),
                r = "vertical-inside" === this._layoutMode,
                o = this._spriteGroups[t].start,
                a = this._spriteGroups[t].mid,
                s = this._spriteGroups[t].end,
                l = 0,
                u = 0,
                c = void 0,
                p = void 0;

            if (o) {
              p = (c = o.getTexture().getDimensions()).y / c.x, l = Math.floor(this._frameWidth / p);
              var f = new k(0, n);
              f.x = r ? this._frameWidth : 0, o.setPosition(f), o.setHeight(this._frameWidth), o.setWidth(l);
            }

            if (s) {
              p = (c = s.getTexture().getDimensions()).y / c.x, u = Math.floor(this._frameWidth * p);
              var h = new k(i.x - u, n);
              h.x -= r ? this._frameWidth : 0, s.setPosition(h), s.setHeight(this._frameWidth), s.setWidth(u);
            }

            if (a) {
              p = (c = a.getTexture().getDimensions()).y / c.x;
              var d = new k(l, n),
                  g = i.x - l - u;

              if (r && (d.x += this._frameWidth, g -= 2 * this._frameWidth), a.setPosition(d), a.setWidth(g), a.setHeight(this._frameWidth), "repeat" === this._options.frame.imageGroups[t].mid.mode) {
                var m = this._frameWidth / p,
                    y = Math.ceil(g / m),
                    _ = 0;

                if (-1 !== y) {
                  var v = Math.round(g / y);
                  a.setWidth(v), _ += v, this._ensureRepeatSpritesExist(y - 1, t, a);

                  for (var b = 0; b < y - 1; b++) {
                    v = Math.round((g - _) / (y - b - 1));
                    var w = this._repeatSprites[t][b],
                        x = d.clone().add(_, 0).floor();
                    w.setPosition(x), w.setWidth(v), w.setHeight(this._frameWidth), _ += v;
                  }
                }
              }
            }
          }
        }, {
          key: "_ensureRepeatSpritesExist",
          value: function value(e, t, n) {
            var i = this;
            n.getTexture().setMaxListeners(e + 1);
            var r = this._repeatSprites[t].length;
            if (e > r) for (var o = e - r, a = 0; a < o; a++) {
              var s = new y.Engine.Sprite(n.getTexture());
              this._repeatSprites[t].push(s), this._frameContainer.addChild(s), this._sprites.push(s);
            } else e < r && this._repeatSprites[t].splice(e).forEach(function (e) {
              var t = i._sprites.indexOf(e);

              -1 !== t && (i._sprites.splice(t, 1), i._frameContainer.removeChild(e), e.dispose());
            });
          }
        }, {
          key: "_updateVerticalSpriteGroup",
          value: function value(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                i = e.getDimensions(),
                r = "horizontal-inside" === this._layoutMode,
                o = this._spriteGroups[t].start,
                a = this._spriteGroups[t].mid,
                s = this._spriteGroups[t].end,
                l = 0,
                u = 0,
                c = void 0,
                p = void 0;

            if (o) {
              p = (c = o.getTexture().getDimensions()).y / c.x, l = Math.floor(this._frameWidth * p);
              var f = new k(n, 0);
              f.y = r ? this._frameWidth : 0, o.setPosition(f), o.setWidth(this._frameWidth), o.setHeight(l);
            }

            if (s) {
              p = (c = s.getTexture().getDimensions()).y / c.x, u = Math.floor(this._frameWidth * p);
              var h = new k(n, i.y - u);
              h.y -= r ? this._frameWidth : 0, s.setPosition(h), s.setWidth(this._frameWidth), s.setHeight(u);
            }

            if (a) {
              p = (c = a.getTexture().getDimensions()).y / c.x;
              var d = new k(n, l),
                  g = i.y - l - u;

              if (r && (d.y += this._frameWidth, g -= 2 * this._frameWidth), a.setPosition(d), a.setHeight(g), a.setWidth(this._frameWidth), "repeat" === this._options.frame.imageGroups[t].mid.mode) {
                var m = this._frameWidth * p,
                    y = Math.ceil(g / m),
                    _ = 0;

                if (-1 !== y) {
                  var v = Math.round(g / y);
                  a.setHeight(v), _ += v, this._ensureRepeatSpritesExist(y - 1, t, a);

                  for (var b = 0; b < y - 1; b++) {
                    v = Math.round((g - _) / (y - b - 1));
                    var w = this._repeatSprites[t][b],
                        x = d.clone().add(0, _).floor();
                    w.setPosition(x), w.setHeight(v), w.setWidth(this._frameWidth), _ += v;
                  }
                }
              }
            }
          }
        }, {
          key: "_disposeSprites",
          value: function value() {
            var e = this;
            this._sprites.forEach(function (t) {
              e._frameContainer.removeChild(t), t.getTexture().dispose(), t.dispose();
            }), this._resetSprites();
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = c()(t, n);

              if (void 0 === r) {
                var o = m()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var a = r.get;
              return void 0 !== a ? a.call(i) : void 0;
            })(t.prototype.__proto__ || m()(t.prototype), "dispose", this).call(this), this._disposeSprites(), this._colorOverlayFilter && this._colorOverlayFilter.dispose(), this._frameRenderTexture && this._frameRenderTexture.dispose();
          }
        }], [{
          key: "validateFrame",
          value: function value(e) {
            if (e) {
              var t = e.imageGroups,
                  n = e.layoutMode;
              if ("string" != typeof e.identifier) throw new Error("Frame needs a property `identifier` of type String.");
              if ("object" !== v(e.imageGroups)) throw new Error("Frame needs a property `imageGroups` of type Object.");

              var i = function i(e) {
                var n = t[e],
                    i = n.start,
                    r = n.end,
                    o = n.mid;

                if (void 0 !== t[e]) {
                  if ("object" !== v(t[e])) throw new Error("Frame: `imageGroups." + e + "` needs to be of type Object.");
                  if (void 0 !== i && !(i instanceof y.Image || "undefined" != typeof HTMLImageElement && i instanceof HTMLImageElement)) throw new Error("Frame: `imageGroups." + e + ".start` needs to be of type Image.");
                  if (void 0 !== o && !(i instanceof y.Image || "undefined" != typeof HTMLImageElement && i instanceof HTMLImageElement) && "object" !== (void 0 === o ? "undefined" : v(o))) throw new Error("Frame: `imageGroups." + e + ".mid` needs to be of type Image or Object.");
                  if (void 0 !== r && !(r instanceof y.Image || "undefined" != typeof HTMLImageElement && r instanceof HTMLImageElement)) throw new Error("Frame: `imageGroups." + e + ".end` needs to be of type Image.");
                }
              };

              if (void 0 !== n && -1 === ["vertical-inside", "horizontal-inside"].indexOf(n)) throw new Error("Frame: `layoutMode` must be one of vertical-inside, horizontal-inside");
              if ("undefined" != typeof tintable && "boolean" != typeof tintable) throw new Error("Frame: `tintable` needs to be of type Boolean.");
              i("top"), i("left"), i("right"), i("bottom");
            }
          }
        }]), t;
      }(y.Operation);

      T.identifier = "frame", T.prototype.availableOptions = {
        frame: {
          type: y.OptionType.OBJECT,
          validation: T.validateFrame,
          setter: function setter(e, t) {
            return t || this._createSpritesForFrame(e), e;
          },
          default: null
        },
        alpha: {
          type: y.OptionType.NUMBER,
          default: 1
        },
        tintColor: {
          type: y.OptionType.COLOR,
          default: new y.Color(1, 1, 1, 0)
        },
        scale: {
          type: y.OptionType.NUMBER,
          default: .1
        }
      }, _.a.Operations.FrameOperation = T, t.a = T;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = n.n(h),
          g = n(402),
          m = n(404),
          y = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = function (e) {
        function t() {
          var e;

          _(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = v(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._applyWatermarkFilter = function () {
            return o._watermarkFilter || (o._watermarkFilter = new g.a({
              watermarkImage: o._watermarkImage
            })), o._sprite.setFilters([o._watermarkFilter]), o._renderTexture.render(o._container), h.Promise.resolve();
          }, o._loadWatermarkImage = function () {
            return o._watermarkImage ? h.Promise.resolve() : new h.Promise(function (e, t) {
              o._watermarkImage = new h.Image(), o._watermarkImage.onload = e, o._watermarkImage.src = m.a;
            });
          }, o._watermarkFilter = null, o._watermarkImage = null, o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), y(t, [{
          key: "_render",
          value: function value(e) {
            return this._loadWatermarkImage().then(this._applyWatermarkFilter);
          }
        }, {
          key: "dispose",
          value: function value() {
            this._watermarkFilter && this._watermarkFilter.dispose(), function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this);
          }
        }]), t;
      }(h.Operation);

      b.identifier = "license-watermark", b.prototype.availableOptions = {}, d.a.Operations.LicenseWatermarkOperation = b, t.a = b;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          var e;
          h(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = d(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(r)));
          return a._fragmentSource = n(403), a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_applyWebGL",
          value: function value(e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                r = e.getContext(),
                o = (r.canvas, this.getShaderForRenderer(e)),
                a = t.getFrame(),
                s = this._watermarkCanvas;
            s && a.width === s.width && a.height === s.height || this._createWatermarkCanvas(a.width, a.height);
            var l = p.Engine.Texture.fromCanvas(this._watermarkCanvas),
                u = l.getBaseTexture();
            e.updateTexture(u), u.setGLUnit(1), e.setRenderTarget(n), i && n.clear(), e.setShader(o);
            var c = e.getCurrentRenderTarget().getProjectionMatrix().toArray();
            o.setUniform("u_projMatrix", c), o.syncUniforms(), r.uniform1i(r.getUniformLocation(o.getProgram(), "u_watermarkTex"), 1), r.activeTexture(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, t.getTexture()), r.activeTexture(r.TEXTURE1), r.bindTexture(r.TEXTURE_2D, u.getGLTextureForRenderer(e)), r.drawElements(r.TRIANGLES, 6, r.UNSIGNED_SHORT, 0), l.dispose();
          }
        }, {
          key: "_createWatermarkCanvas",
          value: function value(e, t) {
            var n = this._options.watermarkImage,
                i = p.Utils.createCanvas();
            i.width = e, i.height = t;
            var r = i.getContext("2d"),
                o = void 0,
                a = void 0,
                s = void 0;
            e > t ? (o = e / n.width, s = (t - n.height * o) / 2, a = 0) : (o = t / n.height, s = 0, a = (e - n.width * o) / 2), r.drawImage(n, 0, 0, n.width, n.height, a, s, n.width * o, n.height * o), this._watermarkCanvas = i, this._watermarkContext = r;
          }
        }, {
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = t.getCanvas(),
                r = t.getContext(),
                o = n.getContext();
            this._options.watermarkImage, this._createWatermarkCanvas(i.width, i.height);

            for (var a = r.getImageData(0, 0, i.width, i.height), s = this._watermarkContext.getImageData(0, 0, i.width, i.height), l = new p.Color(), u = new p.Color(), c = new p.Color(), f = 0; f < i.width * i.height * 4; f += 4) {
              l.set(a.data[f] / 255, a.data[f + 1] / 255, a.data[f + 2] / 255, a.data[f + 3] / 255), u.set(s.data[f] / 255, s.data[f + 1] / 255, s.data[f + 2] / 255, s.data[f + 3] / 255), u.r > .8 ? c.copy(l.clone().mix(u, .3)) : c.copy(l), a.data[f] = 255 * c.r, a.data[f + 1] = 255 * c.g, a.data[f + 2] = 255 * c.b, a.data[f + 3] = 255 * c.a;
            }

            o.putImageData(a, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      g.prototype.availableOptions = {
        watermarkImage: {
          type: p.OptionType.OBJECT,
          required: !0
        }
      }, t.a = g;
    }, function (e, t) {
      e.exports = "uniform sampler2D u_image;\nuniform sampler2D u_watermarkTex;\n\nvarying vec2 v_texCoord;\n\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  vec4 watermarkColor = texture2D(u_watermarkTex, v_texCoord);\n\n  if (watermarkColor.r > 0.8) {\n    gl_FragColor = mix(color, watermarkColor, 0.3);\n  } else {\n    gl_FragColor = color;\n  }\n}\n";
    }, function (e, t, n) {
      t.a = "data:image/png;base64,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";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = n.n(h),
          g = n(406),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = h.Math.Vector2,
          b = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = _(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));

          o._lastBlurRadius = o._options.blurRadius, o._lastControlPoint1 = o._options.controlPoint1.clone(), o._lastControlPoint2 = o._options.controlPoint2.clone();
          var a = {
            blurQuality: {
              type: h.OptionType.STRING
            }
          };
          return o._horizontalFilter = new g.a({}, a), o._verticalFilter = new g.a({}, a), o._sprite.setFilters([o._horizontalFilter, o._verticalFilter]), o._horizontalFilter.setDelta(new v(.5, .5)), o._verticalFilter.setDelta(new v(-.5, .5)), o._filter = new g.a({}, a), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "rotate",
          value: function value(e) {
            var t = this._options.controlPoint1,
                n = this._options.controlPoint2;
            90 === e ? (t.flip(), t.x = 1 - t.x, n.flip(), n.x = 1 - n.x) : -90 === e && (t.flip(), t.y = 1 - t.y, n.flip(), n.y = 1 - n.y), this.set({
              controlPoint1: t,
              controlPoint2: n
            });
          }
        }, {
          key: "flip",
          value: function value(e) {
            var t = this._options.controlPoint1,
                n = this._options.controlPoint2;

            switch (e) {
              case "horizontal":
                t.x = 1 - t.x, n.x = 1 - n.x;
                break;

              case "vertical":
                t.y = 1 - t.y, n.y = 1 - n.y;
            }

            this.set({
              controlPoint1: t,
              controlPoint2: n
            });
          }
        }, {
          key: "transform",
          value: function value(e) {
            var t = this,
                n = {};
            ["controlPoint1", "controlPoint2"].forEach(function (i) {
              var r = t.getOption(i);
              n[i] = e.applyToRelativePoint(r);
            }), ["blurRadius"].forEach(function (i) {
              var r = t.getOption(i);
              n[i] = e.applyToRelativeSize(r);
            }), this.set(n, !1);
          }
        }, {
          key: "_renderWebGL",
          value: function value(e) {
            return this._renderBlur(e);
          }
        }, {
          key: "_renderCanvas",
          value: function value(e) {
            return this._options.highQualityCanvasBlur ? this._renderBlur(e) : this._renderLQCanvasBlur(e);
          }
        }, {
          key: "_renderBlur",
          value: function value(e) {
            var t = e.getDimensions(),
                n = t.min(),
                i = this._options,
                r = i.blurRadius,
                o = i.controlPoint1,
                a = i.controlPoint2,
                s = {
              blurRadius: r * n,
              controlPoint1: o.clone(),
              controlPoint2: a.clone(),
              texSize: t,
              blurQuality: "high"
            };
            return this._horizontalFilter.set(s), this._verticalFilter.set(s), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "_renderLQCanvasBlur",
          value: function value(e) {
            var t = e.getDimensions(),
                n = this._options,
                i = n.blurRadius,
                r = n.controlPoint1,
                o = n.controlPoint2;
            return this._filter.set({
              blurRadius: i,
              controlPoint1: r.clone(),
              controlPoint2: o.clone(),
              texSize: t,
              blurQuality: "low"
            }), this._sprite.setFilters([this._filter]), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._filter.dispose(), this._verticalFilter.dispose(), this._horizontalFilter.dispose();
          }
        }, {
          key: "hasChanges",
          value: function value() {
            return !0;
          }
        }]), t;
      }(h.Operation);

      b.identifier = "linear-focus", b.prototype.availableOptions = {
        controlPoint1: {
          type: h.OptionType.VECTOR2,
          default: new v(0, .5)
        },
        controlPoint2: {
          type: h.OptionType.VECTOR2,
          default: new v(1, .5)
        },
        blurRadius: {
          type: h.OptionType.NUMBER,
          default: .025
        },
        highQualityCanvasBlur: {
          type: h.OptionType.BOOLEAN,
          default: !1
        }
      }, d.a.Operations.LinearFocusOperation = b, t.a = b;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(71)),
          g = (n.n(d), n(74)),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = h.Math.Vector2,
          b = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = _(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(r)));

          return a._fragmentSource = n(407), a._lastBlurRadius = null, a._lastControlPoint1 = new v(), a._lastControlPoint2 = new v(), a._blurFilter = new g.a(), a._blurredRenderTarget = new h.Engine.CanvasRenderTarget(100, 100, 1), a._maskRenderTarget = new h.Engine.CanvasRenderTarget(100, 100, 1), a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = this,
                r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];

            if ("low" !== this._options.blurQuality) {
              var o = t.getDimensions(),
                  a = !n.getDimensions().equals(o),
                  s = t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || a;

              if (s) {
                var l = new v(this._options.delta.x, this._options.delta.y);

                this._blurFilter.setDelta(l);

                var u = {
                  blurRadius: this._options.blurRadius,
                  texSize: o
                },
                    c = function c(e, t, n) {
                  return Math.min(Math.max(e, t), n);
                },
                    p = function p(e, t, n) {
                  var i = c((n - e) / (t - e), 0, 1);
                  return i * i * (3 - 2 * i);
                },
                    f = this._options.controlPoint2.clone().subtract(this._options.controlPoint1.clone()),
                    h = this._options.blurRadius,
                    d = function d(e, t) {
                  return p(0, 1, Math.abs(c(new v(e, t).subtract(i._options.controlPoint1).dot(f) / f.dot(f), 0, 1))) * h;
                };

                this._blurFilter.set(u), this._blurFilter._applyCanvas(e, t, n, r, d), this._lastBlurRadius = this._options.blurRadius;
              }
            } else this._renderLQBlur(e, t, n, r);
          }
        }, {
          key: "_renderLQBlur",
          value: function value(e, t, n) {
            var i = t.getDimensions(),
                r = !this._blurredRenderTarget.getDimensions().equals(i);
            this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()), this._blurredRenderTarget.resizeTo(t.getDimensions()), this._maskRenderTarget.setPixelRatio(t.getPixelRatio()), this._maskRenderTarget.resizeTo(t.getDimensions());
            var o = !this._lastControlPoint1.equals(this._options.controlPoint1) || !this._lastControlPoint2.equals(this._options.controlPoint2) || r,
                a = t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || r;
            o && (this._renderMask(), this._lastControlPoint1 = this._options.controlPoint1.clone(), this._lastControlPoint2 = this._options.controlPoint2.clone()), a && (this._blurImage(t, this._blurredRenderTarget, this._options.blurRadius), this._lastBlurRadius = this._options.blurRadius), this._applyMask(t, n);
          }
        }, {
          key: "_renderMask",
          value: function value() {
            var e = this._maskRenderTarget.getCanvas(),
                t = this._maskRenderTarget.getContext(),
                n = new v(e.width, e.height),
                i = this._options.controlPoint1.clone().multiply(n),
                r = this._options.controlPoint2.clone().multiply(n),
                o = t.createLinearGradient(i.x, i.y, r.x, r.y);

            o.addColorStop(0, "#FFFFFF"), o.addColorStop(1, "#000000"), t.fillStyle = o, t.fillRect(0, 0, e.width, e.height);
          }
        }, {
          key: "_applyMask",
          value: function value(e, t) {
            for (var n = t.getContext(), i = e.getCanvas(), r = e.getContext(), o = this._blurredRenderTarget.getContext(), a = this._maskRenderTarget.getContext(), s = r.getImageData(0, 0, i.width, i.height), l = s.data, u = o.getImageData(0, 0, i.width, i.height).data, c = a.getImageData(0, 0, i.width, i.height).data, p = void 0, f = 0; f < i.width * i.height * 4; f += 4) {
              p = c[f] / 255, l[f] = p * l[f] + (1 - p) * u[f], l[f + 1] = p * l[f + 1] + (1 - p) * u[f + 1], l[f + 2] = p * l[f + 2] + (1 - p) * u[f + 2];
            }

            n.putImageData(s, 0, 0);
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._blurFilter.dispose(), this._blurredRenderTarget.dispose(), this._maskRenderTarget.dispose();
          }
        }]), t;
      }(h.Engine.Filter);

      b.prototype.availableOptions = {
        blurRadius: {
          type: h.OptionType.NUMBER,
          default: 30,
          uniformType: h.UniformType.FLOAT
        },
        controlPoint1: {
          type: h.OptionType.VECTOR2,
          default: new v(0, .5),
          uniformType: h.UniformType.FLOAT2
        },
        controlPoint2: {
          type: h.OptionType.VECTOR2,
          default: new v(1, .5),
          uniformType: h.UniformType.FLOAT2
        },
        delta: {
          type: h.OptionType.VECTOR2,
          default: new v(1, 1),
          uniformType: h.UniformType.FLOAT2
        },
        texSize: {
          type: h.OptionType.VECTOR2,
          default: new v(100, 100),
          uniformType: h.UniformType.FLOAT2
        }
      }, t.a = b;
    }, function (e, t) {
      e.exports = "/*!\n * Based on evanw's glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform vec2 u_controlPoint1;\nuniform vec2 u_controlPoint2;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    vec2 vector = u_controlPoint2 - u_controlPoint1;\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n\n    float radius = smoothstep(0.0, 1.0,\n      abs(\n        clamp(dot(v_texCoord - u_controlPoint1, vector) / dot(vector, vector), 0.0, 1.0)\n      )\n    ) * u_blurRadius;\n\n    for (float t = -30.0; t <= 30.0; t++) {\n      float percent = (t + offset - 0.5) / 30.0;\n      float weight = 1.0 - abs(percent);\n      vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n      color += _sample * weight;\n      total += weight;\n    }\n\n    gl_FragColor = color / total;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = n.n(h),
          g = n(409),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = h.Math.Vector2,
          b = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = _(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));

          o._lastBlurRadius = o._options.blurRadius, o._lastSize = o._options.size, o._lastGradientSize = o._options.gradientSize;
          var a = {
            blurQuality: {
              type: h.OptionType.STRING
            }
          };
          return o._horizontalFilter = new g.a({}, a), o._verticalFilter = new g.a({}, a), o._sprite.setFilters([o._horizontalFilter, o._verticalFilter]), o._horizontalFilter.setDelta(new v(.5, .5)), o._verticalFilter.setDelta(new v(-.5, .5)), o._filter = new g.a({}, a), o._renderBlur.bind(o), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "rotate",
          value: function value(e) {
            var t = this._options.start,
                n = this._options.end;
            90 === e ? (t.flip(), t.x = 1 - t.x, n.flip(), n.x = 1 - n.x) : -90 === e && (t.flip(), t.y = 1 - t.y, n.flip(), n.y = 1 - n.y), this.set({
              start: t,
              end: n
            });
          }
        }, {
          key: "flip",
          value: function value(e) {
            var t = this._options.start,
                n = this._options.end;

            switch (e) {
              case "horizontal":
                t.x = 1 - t.x, n.x = 1 - n.x;
                break;

              case "vertical":
                t.y = 1 - t.y, n.y = 1 - n.y;
            }

            this.set({
              start: t,
              end: n
            });
          }
        }, {
          key: "transform",
          value: function value(e) {
            var t = this,
                n = {};
            ["start", "end"].forEach(function (i) {
              var r = t.getOption(i);
              n[i] = e.applyToRelativePoint(r);
            }), ["blurRadius", "size", "gradientSize"].forEach(function (i) {
              var r = t.getOption(i);
              n[i] = e.applyToRelativeSize(r);
            }), this.set(n, !1);
          }
        }, {
          key: "_renderWebGL",
          value: function value(e) {
            return this._renderBlur(e);
          }
        }, {
          key: "_renderCanvas",
          value: function value(e) {
            return this._options.highQualityCanvasBlur ? this._renderBlur(e) : this._renderLQCanvasBlur(e);
          }
        }, {
          key: "_renderBlur",
          value: function value(e) {
            var t = e.getDimensions(),
                n = t.min(),
                i = this._options.start.clone(),
                r = this._options.end.clone(),
                o = this._options,
                a = {
              blurRadius: o.blurRadius * n,
              size: o.size * n,
              gradientSize: o.gradientSize * n,
              start: i.clone().multiply(t),
              end: r.clone().multiply(t),
              texSize: t,
              blurQuality: "high"
            };

            return this._horizontalFilter.set(a), this._verticalFilter.set(a), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "_renderLQCanvasBlur",
          value: function value(e) {
            var t = e.getDimensions(),
                n = this._options,
                i = n.blurRadius,
                r = n.size,
                o = n.gradientSize,
                a = n.start,
                s = n.end;
            return this._filter.set({
              blurRadius: i,
              gradientSize: o,
              size: r,
              start: a.clone(),
              end: s.clone(),
              texSize: t,
              blurQuality: "low"
            }), this._sprite.setFilters([this._filter]), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._filter.dispose(), this._verticalFilter.dispose(), this._horizontalFilter.dispose();
          }
        }, {
          key: "hasChanges",
          value: function value() {
            return !0;
          }
        }]), t;
      }(h.Operation);

      b.identifier = "mirrored-focus", b.prototype.availableOptions = {
        start: {
          type: h.OptionType.VECTOR2,
          default: new v(0, .5)
        },
        end: {
          type: h.OptionType.VECTOR2,
          default: new v(1, .5)
        },
        blurRadius: {
          type: h.OptionType.NUMBER,
          default: .025
        },
        size: {
          type: h.OptionType.NUMBER,
          default: .1
        },
        gradientSize: {
          type: h.OptionType.NUMBER,
          default: .1
        },
        highQualityCanvasBlur: {
          type: h.OptionType.BOOLEAN,
          default: !1
        }
      }, d.a.Operations.MirroredFocusOperation = b, t.a = b;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(71)),
          g = (n.n(d), n(74)),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = h.Math.Vector2,
          b = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = _(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(r)));

          return a._fragmentSource = n(410), a._lastBlurRadius = null, a._lastGradientRadius = null, a._lastStart = new v(), a._lastEnd = new v(), a._blurFilter = new g.a(), a._blurredRenderTarget = new h.Engine.CanvasRenderTarget(100, 100, 1), a._maskRenderTarget = new h.Engine.CanvasRenderTarget(100, 100, 1), a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];

            if ("low" !== this._options.blurQuality) {
              var r = t.getDimensions(),
                  o = !n.getDimensions().equals(r),
                  a = t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || o;

              if (a) {
                var s = new v(this._options.delta.x, this._options.delta.y);

                this._blurFilter.setDelta(s);

                var l = {
                  blurRadius: this._options.blurRadius,
                  texSize: r
                },
                    u = function u(e, t, n) {
                  return Math.min(Math.max(e, t), n);
                },
                    c = function c(e, t, n) {
                  var i = u((n - e) / (t - e), 0, 1);
                  return i * i * (3 - 2 * i);
                },
                    p = this._options,
                    f = p.blurRadius,
                    h = p.gradientSize,
                    d = p.size,
                    g = p.start,
                    m = p.end,
                    y = p.texSize,
                    _ = new v(g.y - m.y, m.x - g.x);

                _.divide(_.len());

                var b = function b(e, t) {
                  return c(0, 1, (Math.abs(y.clone().multiply(e, t).subtract(g).dot(_)) - d) / h) * f;
                };

                this._blurFilter.set(l), this._blurFilter._applyCanvas(e, t, n, i, b), this._lastBlurRadius = this._options.blurRadius;
              }
            } else this._renderLQBlur(e, t, n, i);
          }
        }, {
          key: "_renderLQBlur",
          value: function value(e, t, n) {
            var i = t.getDimensions(),
                r = !this._blurredRenderTarget.getDimensions().equals(i);
            this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()), this._blurredRenderTarget.resizeTo(t.getDimensions()), this._maskRenderTarget.setPixelRatio(t.getPixelRatio()), this._maskRenderTarget.resizeTo(t.getDimensions());
            var o = !this._lastStart.equals(this._options.start) || !this._lastEnd.equals(this._options.end) || this._lastGradientRadius !== this._options.size || r,
                a = t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || r;
            o && (this._renderMask(), this._lastStart = this._options.start.clone(), this._lastEnd = this._options.end.clone(), this._lastGradientRadius = this._options.size), a && (this._blurImage(t, this._blurredRenderTarget, this._options.blurRadius), this._lastBlurRadius = this._options.blurRadius), this._applyMask(t, n);
          }
        }, {
          key: "_renderMask",
          value: function value() {
            var e = this._maskRenderTarget.getCanvas(),
                t = this._maskRenderTarget.getContext(),
                n = this._maskRenderTarget.getPixelRatio(),
                i = new v(e.width, e.height),
                r = this._options.size * i.min() * n,
                o = this._options.gradientSize * i.min() * n,
                a = this._options.start.clone().multiply(i),
                s = this._options.end.clone().multiply(i).clone().subtract(a),
                l = a.clone().add(s.clone().divide(2)),
                u = s.len(),
                c = s.clone().divide(u),
                p = l.clone().add((r + o) * c.y, -(r + o) * c.x),
                f = l.clone().add(-(r + o) * c.y, (r + o) * c.x),
                h = t.createLinearGradient(p.x, p.y, f.x, f.y),
                d = f.clone().subtract(p).len();

            h.addColorStop(0, "#000000"), h.addColorStop(o / 2 / d, "#FFFFFF"), h.addColorStop(1 - o / 2 / d, "#FFFFFF"), h.addColorStop(1, "#000000"), t.fillStyle = h, t.fillRect(0, 0, e.width, e.height);
          }
        }, {
          key: "_applyMask",
          value: function value(e, t) {
            for (var n = t.getContext(), i = e.getCanvas(), r = e.getContext(), o = this._blurredRenderTarget.getContext(), a = this._maskRenderTarget.getContext(), s = r.getImageData(0, 0, i.width, i.height), l = s.data, u = o.getImageData(0, 0, i.width, i.height).data, c = a.getImageData(0, 0, i.width, i.height).data, p = void 0, f = 0; f < i.width * i.height * 4; f += 4) {
              p = c[f] / 255, l[f] = p * l[f] + (1 - p) * u[f], l[f + 1] = p * l[f + 1] + (1 - p) * u[f + 1], l[f + 2] = p * l[f + 2] + (1 - p) * u[f + 2];
            }

            n.putImageData(s, 0, 0);
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._blurFilter.dispose();
          }
        }]), t;
      }(h.Engine.Filter);

      b.prototype.availableOptions = {
        blurRadius: {
          type: h.OptionType.NUMBER,
          default: 30,
          uniformType: h.UniformType.FLOAT
        },
        size: {
          type: h.OptionType.NUMBER,
          default: 50,
          uniformType: h.UniformType.FLOAT
        },
        gradientSize: {
          type: h.OptionType.NUMBER,
          default: 50,
          uniformType: h.UniformType.FLOAT
        },
        start: {
          type: h.OptionType.VECTOR2,
          default: new v(0, .5),
          uniformType: h.UniformType.FLOAT2
        },
        end: {
          type: h.OptionType.VECTOR2,
          default: new v(1, .5),
          uniformType: h.UniformType.FLOAT2
        },
        delta: {
          type: h.OptionType.VECTOR2,
          default: new v(1, 1),
          uniformType: h.UniformType.FLOAT2
        },
        texSize: {
          type: h.OptionType.VECTOR2,
          default: new v(100, 100),
          uniformType: h.UniformType.FLOAT2
        }
      }, t.a = b;
    }, function (e, t) {
      e.exports = "/*\n * Based on evanw's glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform float u_gradientSize;\nuniform float u_size;\nuniform vec2 u_start;\nuniform vec2 u_end;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n\n    vec2 normal = normalize(vec2(u_start.y - u_end.y, u_end.x - u_start.x));\n    float radius = smoothstep(0.0, 1.0,\n      (abs(\n        dot(v_texCoord * u_texSize - u_start, normal)\n      ) - u_size) / u_gradientSize\n    ) * u_blurRadius;\n\n    for (float t = -30.0; t <= 30.0; t++) {\n        float percent = (t + offset - 0.5) / 30.0;\n        float weight = 1.0 - abs(percent);\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / total;\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = n.n(p),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = p.Math.Vector2,
          y = function (e) {
        function t() {
          return d(this, t), g(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_render",
          value: function value(e) {
            var t = this._options.rotation % 360,
                n = t * (Math.PI / 180),
                i = 90 === t || 270 === t,
                r = this._options.flipHorizontally !== this._options.flipVertically,
                o = i && r ? !this._options.flipVertically : this._options.flipVertically,
                a = i && r ? !this._options.flipHorizontally : this._options.flipHorizontally;
            this._sprite.setScale(a ? -1 : 1, o ? -1 : 1), this._sprite.setRotation(n), this._sprite.setAnchor(.5, .5), this._sprite.updateTransform();

            var s = this._sprite.getBounds();

            return this._renderTexture.resizeTo(new m(s.width, s.height)), this._sprite.setPosition(this._renderTexture.getDimensions().divide(2).round()), this._renderTexture.render(this._container), p.Promise.resolve();
          }
        }, {
          key: "getNewDimensions",
          value: function value(e) {
            return e = e.clone(), this._options.rotation % 180 && e.flip(), e;
          }
        }, {
          key: "flip",
          value: function value(e) {
            var t = this._options.rotation;

            switch (90 !== t && 270 !== t || (e = "vertical" === e ? "horizontal" : "vertical"), e) {
              case "vertical":
                this.setFlipVertically(!this.getFlipVertically());
                break;

              case "horizontal":
                this.setFlipHorizontally(!this.getFlipHorizontally());
            }
          }
        }]), t;
      }(p.Operation);

      y.identifier = "orientation", y.prototype.availableOptions = {
        rotation: {
          type: p.OptionType.NUMBER,
          default: 0,
          validation: function validation(e) {
            if (e % 90 != 0) throw new Error("OrientationOperation: `rotation` has to be a multiple of 90.");
          },
          setter: function setter(e) {
            return (e + 360) % 360;
          }
        },
        flipVertically: {
          type: p.OptionType.BOOLEAN,
          default: !1
        },
        flipHorizontally: {
          type: p.OptionType.BOOLEAN,
          default: !1
        }
      }, f.a.Operations.OrientationOperation = y, t.a = y;
    }, function (e, t, n) {
      var i = n(39),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = n.n(g),
          y = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          _ = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function b(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var w = g.Engine.Filters.OverlayFilter,
          x = g.Math.Vector2,
          k = function (e) {
        function t() {
          var e;
          v(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = b(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          return o._overlayTexture = g.Engine.Texture.fromImage(o._options.image), o._overlayContainer = new g.Engine.Container(), o._overlaySprite = new g.Engine.Sprite(), o._overlaySprite.setTexture(o._overlayTexture), o._overlaySprite.setAnchor(0, 0), o._overlayContainer.addChild(o._overlaySprite), o._overlayFilter = new g.Engine.Filters.OverlayFilter({
            overlayImage: o._overlayTexture.getBaseTexture().getGLUnit(),
            overlayTexture: o._overlayTexture
          }), o._sprite.setFilters([o._overlayFilter]), o._renderedOverlaySprite = new g.Engine.Sprite(), o._renderedOverlayContainer = new g.Engine.Container(), o._renderedOverlayContainer.addChild(o._renderedOverlaySprite), o._overlayRendered = !1, o._lastInputDimensions = new x(0, 0), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), y(t, [{
          key: "setOption",
          value: function value(e, n) {
            if (_(t.prototype.__proto__ || d()(t.prototype), "setOption", this).call(this, e, n), "image" === e && n && this._sdk) {
              var i = this._sdk.getRenderer(),
                  r = this._overlayTexture.getBaseTexture();

              r.setSource(n), i.isOfType(g.RendererType.WEBGL) && i.updateTexture(r), this._overlayRendered = !1;
            }
          }
        }, {
          key: "_render",
          value: function value(e) {
            var t = e.getDimensions(),
                n = this._options,
                i = n.image,
                r = n.alpha,
                o = n.blendMode;
            return i ? (this._overlayRendered && this._lastInputDimensions.equals(t) || (this._renderOverlayToRenderTexture(e), this._overlayRendered = !0, this._lastInputDimensions.copy(t)), this._overlayFilter.set({
              blendMode: o,
              overlayImage: this._overlayRenderTexture.getBaseTexture().getGLUnit(),
              overlayTexture: this._overlayRenderTexture,
              alpha: r
            }), this._sprite.setFilters([this._overlayFilter]), this._renderTexture.render(this._container), g.Promise.resolve()) : (this._sprite.setFilters([]), this._renderTexture.render(this._container), g.Promise.resolve());
          }
        }, {
          key: "_renderOverlayToRenderTexture",
          value: function value(e) {
            var t = this._sdk.getRenderer(),
                n = e.getDimensions();

            this._overlayRenderTexture || (this._overlayRenderTexture = new g.Engine.RenderTexture(t, n.x, n.y), this._renderedOverlaySprite.setTexture(this._overlayRenderTexture));
            var i = this._options.image,
                r = i.width,
                o = i.height,
                a = g.Utils.resizeVectorToFill(new x(r, o), n),
                s = this._options,
                l = s.flipHorizontally ? -1 : 1,
                u = s.flipVertically ? -1 : 1;
            this._overlaySprite.setWidth(a.x * l), this._overlaySprite.setHeight(a.y * u), this._overlaySprite.setPosition(n.x * (1 - l) * .5, n.y * (1 - u) * .5);

            var c = this._overlayRenderTexture.getBaseTexture();

            this._overlayRenderTexture.resizeTo(n), t.isOfType(g.RendererType.WEBGL) && (c.setGLUnit(4), t.updateTexture(c, !1)), this._overlayRenderTexture.render(this._overlayContainer);
          }
        }, {
          key: "dispose",
          value: function value() {
            _(t.prototype.__proto__ || d()(t.prototype), "dispose", this).call(this), this._overlaySprite && this._overlaySprite.dispose(), this._overlayRenderTexture && this._renderedOverlaySprite.dispose(), this._overlayFilter && this._overlayFilter.dispose(), this._overlayTexture && this._overlayTexture.dispose(), this._overlayRenderTexture && this._overlayRenderTexture.dispose(), this._renderedOverlaySprite && this._renderedOverlaySprite.dispose();
          }
        }]), t;
      }(g.Operation);

      k.identifier = "overlay", k.BLEND_MODES = w.BLEND_MODES, k.prototype.availableOptions = {
        identifier: {
          type: g.OptionType.STRING
        },
        image: {
          type: g.OptionType.IMAGE
        },
        blendMode: {
          type: g.OptionType.NUMBER,
          default: w.BLEND_MODES.MULTIPLY,
          available: r()(w.BLEND_MODES).map(function (e) {
            return w.BLEND_MODES[e];
          })
        },
        alpha: {
          type: g.OptionType.NUMBER,
          default: 1
        },
        flipHorizontally: {
          type: g.OptionType.BOOLEAN,
          default: !1
        },
        flipVertically: {
          type: g.OptionType.BOOLEAN,
          default: !1
        }
      }, m.a.Operations.OverlayOperation = k, t.a = k;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = n.n(h),
          g = n(414),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = h.Math.Vector2,
          b = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = _(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));

          o._lastBlurRadius = o._options.blurRadius, o._lastGradientRadius = o._options.gradientRadius;
          var a = {
            blurQuality: {
              type: h.OptionType.STRING
            }
          };
          return o._horizontalFilter = new g.a({}, a), o._verticalFilter = new g.a({}, a), o._sprite.setFilters([o._horizontalFilter, o._verticalFilter]), o._horizontalFilter.setDelta(new v(.5, .5)), o._verticalFilter.setDelta(new v(-.5, .5)), o._filter = new g.a({}, a), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "rotate",
          value: function value(e) {
            var t = this._options.position;
            90 === e ? (t.flip(), t.x = 1 - t.x) : -90 === e && (t.flip(), t.y = 1 - t.y), this.set({
              position: t
            });
          }
        }, {
          key: "flip",
          value: function value(e) {
            var t = this._options.position;

            switch (e) {
              case "horizontal":
                t.x = 1 - t.x;
                break;

              case "vertical":
                t.y = 1 - t.y;
            }

            this.set({
              position: t
            });
          }
        }, {
          key: "transform",
          value: function value(e) {
            var t = this,
                n = {},
                i = this.getPosition();
            n.position = e.applyToRelativePoint(i), ["radius", "blurRadius", "gradientRadius"].forEach(function (i) {
              var r = t.getOption(i);
              n[i] = e.applyToRelativeSize(r);
            }), this.set(n, !1);
          }
        }, {
          key: "_renderWebGL",
          value: function value(e) {
            return this._renderBlur(e);
          }
        }, {
          key: "_renderCanvas",
          value: function value(e) {
            return this._options.highQualityCanvasBlur ? this._renderBlur(e) : this._renderLQCanvasBlur(e);
          }
        }, {
          key: "_renderBlur",
          value: function value(e) {
            var t = e.getDimensions(),
                n = t.min(),
                i = this._options,
                r = i.position,
                o = {
              blurRadius: i.blurRadius * n,
              radius: i.radius * n,
              gradientRadius: i.gradientRadius * n,
              position: r.clone().multiply(t),
              texSize: t,
              blurQuality: "high"
            };
            return this._horizontalFilter.set(o), this._verticalFilter.set(o), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "_renderLQCanvasBlur",
          value: function value(e) {
            var t = this._options,
                n = t.blurRadius,
                i = t.radius,
                r = t.gradientRadius,
                o = t.position,
                a = e.getDimensions();
            return this._filter.set({
              blurRadius: n,
              radius: i,
              gradientRadius: r,
              position: o,
              texSize: a,
              blurQuality: "low"
            }), this._sprite.setFilters([this._filter]), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._filter.dispose(), this._verticalFilter.dispose(), this._horizontalFilter.dispose();
          }
        }, {
          key: "hasChanges",
          value: function value() {
            return !0;
          }
        }]), t;
      }(h.Operation);

      b.identifier = "radial-focus", b.prototype.availableOptions = {
        position: {
          type: h.OptionType.VECTOR2,
          default: new v(.5, .5)
        },
        radius: {
          type: h.OptionType.NUMBER,
          default: .25
        },
        gradientRadius: {
          type: h.OptionType.NUMBER,
          default: .125
        },
        blurRadius: {
          type: h.OptionType.NUMBER,
          default: .025
        },
        highQualityCanvasBlur: {
          type: h.OptionType.BOOLEAN,
          default: !1
        }
      }, d.a.Operations.RadialFocusOperation = b, t.a = b;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(71)),
          g = (n.n(d), n(74)),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function y(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function _(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var v = h.Math.Vector2,
          b = function (e) {
        function t() {
          var e;
          y(this, t);

          for (var i = arguments.length, r = Array(i), o = 0; o < i; o++) {
            r[o] = arguments[o];
          }

          var a = _(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(r)));

          return a._fragmentSource = n(415), a._lastBlurRadius = null, a._lastGradientRadius = null, a._lastPosition = new v(), a._blurFilter = new g.a(), a._blurredRenderTarget = new h.Engine.CanvasRenderTarget(100, 100, 1), a._maskRenderTarget = new h.Engine.CanvasRenderTarget(100, 100, 1), a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            var i = this,
                r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];

            if ("low" !== this._options.blurQuality) {
              var o = t.getDimensions(),
                  a = !n.getDimensions().equals(o),
                  s = this._options,
                  l = s.blurRadius,
                  u = s.position,
                  c = s.texSize,
                  p = s.gradientRadius,
                  f = t.getBaseTexture().isDirty() || this._lastBlurRadius !== l || a;

              if (f) {
                var h = new v(this._options.delta.x, this._options.delta.y);

                this._blurFilter.setDelta(h);

                var d = {
                  blurRadius: l,
                  texSize: o
                },
                    g = function g(e, t, n) {
                  return Math.min(Math.max(e, t), n);
                },
                    m = function m(e, t, n) {
                  var i = g((n - e) / (t - e), 0, 1);
                  return i * i * (3 - 2 * i);
                },
                    y = function y(e, t) {
                  return m(0, 1, (Math.abs(c.clone().multiply(e, t).subtract(u).len()) - i._options.radius) / (2 * p)) * l;
                };

                this._blurFilter.set(d), this._blurFilter._applyCanvas(e, t, n, r, y), this._lastBlurRadius = l;
              }
            } else this._renderLQBlur(e, t, n, r);
          }
        }, {
          key: "_renderLQBlur",
          value: function value(e, t, n) {
            var i = t.getDimensions(),
                r = !this._blurredRenderTarget.getDimensions().equals(i);
            this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()), this._blurredRenderTarget.resizeTo(t.getDimensions()), this._maskRenderTarget.setPixelRatio(t.getPixelRatio()), this._maskRenderTarget.resizeTo(t.getDimensions());
            var o = !this._lastPosition.equals(this._options.position) || this._lastGradientRadius !== this._options.gradientRadius || r,
                a = t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || r;
            o && (this._renderMask(), this._lastPosition = this._options.position.clone(), this._lastGradientRadius = this._options.gradientRadius), a && (this._blurImage(t, this._blurredRenderTarget, this._options.blurRadius), this._lastBlurRadius = this._options.blurRadius), this._applyMask(t, n);
          }
        }, {
          key: "_renderMask",
          value: function value() {
            var e = this._maskRenderTarget.getCanvas(),
                t = this._maskRenderTarget.getContext(),
                n = new v(e.width, e.height),
                i = this._maskRenderTarget.getPixelRatio(),
                r = this._options.position.clone().multiply(n),
                o = this._options,
                a = o.radius,
                s = o.gradientRadius;

            a *= e.height, s *= e.height;
            var l = t.createRadialGradient(r.x, r.y, 0, r.x, r.y, (a + s) * i);
            l.addColorStop(0, "#FFFFFF"), l.addColorStop(a / (a + s), "#FFFFFF"), l.addColorStop(1, "#000000"), t.fillStyle = l, t.fillRect(0, 0, n.x, n.y);
          }
        }, {
          key: "_applyMask",
          value: function value(e, t) {
            for (var n = t.getContext(), i = e.getCanvas(), r = e.getContext(), o = this._blurredRenderTarget.getContext(), a = this._maskRenderTarget.getContext(), s = r.getImageData(0, 0, i.width, i.height), l = s.data, u = o.getImageData(0, 0, i.width, i.height).data, c = a.getImageData(0, 0, i.width, i.height).data, p = void 0, f = 0; f < i.width * i.height * 4; f += 4) {
              p = c[f] / 255, l[f] = p * l[f] + (1 - p) * u[f], l[f + 1] = p * l[f + 1] + (1 - p) * u[f + 1], l[f + 2] = p * l[f + 2] + (1 - p) * u[f + 2];
            }

            n.putImageData(s, 0, 0);
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._blurFilter.dispose(), this._blurredRenderTarget.dispose(), this._maskRenderTarget.dispose();
          }
        }]), t;
      }(h.Engine.Filter);

      b.prototype.availableOptions = {
        blurRadius: {
          type: h.OptionType.NUMBER,
          default: 30,
          uniformType: h.UniformType.FLOAT
        },
        radius: {
          type: h.OptionType.NUMBER,
          default: 50,
          uniformType: h.UniformType.FLOAT
        },
        gradientRadius: {
          type: h.OptionType.NUMBER,
          default: 25,
          uniformType: h.UniformType.FLOAT
        },
        position: {
          type: h.OptionType.VECTOR2,
          default: new v(.5, .5),
          uniformType: h.UniformType.FLOAT2
        },
        delta: {
          type: h.OptionType.VECTOR2,
          default: new v(1, 1),
          uniformType: h.UniformType.FLOAT2
        },
        texSize: {
          type: h.OptionType.VECTOR2,
          default: new v(100, 100),
          uniformType: h.UniformType.FLOAT2
        }
      }, t.a = b;
    }, function (e, t) {
      e.exports = "/*\n * Based on evanw's glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_radius;\nuniform float u_blurRadius;\nuniform float u_gradientRadius;\nuniform vec2 u_position;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nconst float blurSteps = 30.0;\nconst float EPSILON = 0.000000001;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    vec2 coord = v_texCoord * u_texSize;\n    vec2 diff = coord - u_position;\n    float dist = sqrt(diff.x * diff.x + diff.y * diff.y);\n\n    float blurPercentage = smoothstep( \n      0.0, 1.0,\n      (abs(dist) - u_radius) / u_gradientRadius\n    );\n\n    float radius = blurPercentage * u_blurRadius;\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n\n    for (float t = -blurSteps; t <= blurSteps; t++) {\n        float percent = (t + offset - 0.5) / blurSteps;\n        float weight = 1.0 - abs(percent);\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / max(total, EPSILON);\n}\n";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = n.n(h),
          g = n(175),
          m = n(74),
          y = n(420),
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          v = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = h.Math.Vector2,
          k = function (e) {
        function t() {
          var e;
          b(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = w(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i))),
              a = o._sdk.getRenderer();

          o._lastBlurRadius = null, o._blurredRenderTexture = new h.Engine.RenderTexture(a, 100, 100, 1), o._maskRenderTexture = new h.Engine.RenderTexture(a, 100, 100, 1), o._brushSprite = new g.a(o), o._brushSpriteContainer = new h.Engine.Container();

          var s = o._brushSprite.getDisplayObject();

          if (o._brushSpriteContainer.addChild(s), o._outputSprite = new h.Engine.Sprite(), o._outputContainer = new h.Engine.Container(), o._outputContainer.addChild(o._outputSprite), o._maskFilter = new y.a(), a.isOfType(h.RendererType.WEBGL)) {
            o._horizontalFilter = new m.a(), o._verticalFilter = new m.a(), o._sprite.setFilters([o._horizontalFilter, o._verticalFilter]), o._horizontalFilter.setDelta(new x(1, 1)), o._verticalFilter.setDelta(new x(-1, 1));

            var l = o._maskRenderTexture.getBaseTexture();

            l.setGLUnit(o._maskFilter.getMaskImage()), a.updateTexture(l, !1), (l = o._blurredRenderTexture.getBaseTexture()).setGLUnit(o._maskFilter.getFilterImage()), a.updateTexture(l, !1);
          } else a.isOfType(h.RendererType.CANVAS) && (o._blurFilter = new m.a(), o._sprite.setFilters([o._blurFilter]), o._maskFilter.setMaskCanvas(o._maskRenderTexture.getRenderTarget().getCanvas()), o._maskFilter.setFilterCanvas(o._blurredRenderTexture.getRenderTarget().getCanvas()));

          return o._outputSprite.setFilters([o._maskFilter]), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "flip",
          value: function value(e) {
            this._brushSprite.applyFlip(e), this.setDirty(!0, !0), this._lastBlurRadius = null;
          }
        }, {
          key: "rotate",
          value: function value(e) {
            this._brushSprite.applyRotation(e), this.setDirty(!0, !0), this._lastBlurRadius = null;
          }
        }, {
          key: "transform",
          value: function value(e, t) {
            this._brushSprite.applyTransform(e, t), this.setDirty(!0, !0), this._lastBlurRadius = null;
          }
        }, {
          key: "_render",
          value: function value(e) {
            return this._renderBlur(e), this._renderMask(e), this._outputSprite.setTexture(e), this._renderTexture.render(this._outputContainer), h.Promise.resolve();
          }
        }, {
          key: "_renderMask",
          value: function value(e) {
            var t = e.getDimensions();
            this._maskRenderTexture.getDimensions().equals(t) || this._maskRenderTexture.resizeTo(t), this._brushSprite.update(this._sdk, t), this._maskRenderTexture.clear(h.Color.BLACK), this._maskRenderTexture.render(this._brushSpriteContainer);

            var n = this._sdk.getRenderer();

            n.isOfType(h.RendererType.WEBGL) && n.updateTexture(this._maskRenderTexture.getBaseTexture(), !1);
          }
        }, {
          key: "_renderBlur",
          value: function value(e) {
            var t = e.getDimensions(),
                n = this._blurredRenderTexture.getDimensions();

            n.equals(t) || this._blurredRenderTexture.resizeTo(t);
            var i = this._options.blurRadius;

            if (this._lastBlurRadius !== i || !n.equals(t)) {
              var r = this._sdk.getRenderer(),
                  o = void 0;

              r.isOfType(h.RendererType.WEBGL) ? (o = {
                blurRadius: i * t.min(),
                texSize: t
              }, this._horizontalFilter.set(o), this._verticalFilter.set(o)) : r.isOfType(h.RendererType.CANVAS) && (o = {
                blurRadius: i
              }, this._blurFilter.set(o)), this._blurredRenderTexture.render(this._container), this._lastBlurRadius = i;
            }

            var a = this._sdk.getRenderer();

            a.isOfType(h.RendererType.WEBGL) && a.updateTexture(this._blurredRenderTexture.getBaseTexture(), !1);
          }
        }, {
          key: "getBrush",
          value: function value() {
            return this._brushSprite;
          }
        }, {
          key: "createPath",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                n = new g.a.Brushes.RadialBrush({
              size: e,
              hardness: t,
              color: h.Color.WHITE
            }),
                i = this._brushSprite.createPath(n);

            return this._options.paths.push(i), this.setDirty(!0), i;
          }
        }, {
          key: "setDirtyForRenderer",
          value: function value(e, n, i) {
            v(t.prototype.__proto__ || f()(t.prototype), "setDirtyForRenderer", this).call(this, e, n, i), this._brushSprite.setDirtyForRenderer(e, n, i);
          }
        }, {
          key: "dispose",
          value: function value() {
            v(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._sdk.getRenderer().isOfType(h.RendererType.WEBGL) ? (this._verticalFilter.dispose(), this._horizontalFilter.dispose()) : this._blurFilter.dispose(), this._brushSprite.dispose(), this._maskFilter.dispose(), this._blurredRenderTexture.dispose(), this._maskRenderTexture.dispose();
          }
        }, {
          key: "hasChanges",
          value: function value() {
            return !0;
          }
        }]), t;
      }(h.Operation);

      k.identifier = "selective-blur", k.prototype.availableOptions = {
        blurRadius: {
          type: h.OptionType.NUMBER,
          default: .05
        },
        paths: {
          type: h.OptionType.ARRAY,
          default: [],
          setter: function setter(e) {
            return this._brushSprite && this._brushSprite.setPaths(e), e;
          }
        }
      }, d.a.Operations.SelectiveBlurOperation = k, t.a = k;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(418)),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          m = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      },
          y = function (e) {
        function t(e, n, i) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var r = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || f()(t)).call(this, n));

          return r._operation = e, r._canvas = i || h.Utils.createCanvas(), r._context = r._canvas.getContext("2d"), r;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "serializeOption",
          value: function value(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return "controlPoints" === e ? this._options.controlPoints.map(function (e) {
              var t = e.getPosition();
              return n ? t.toObject() : t.clone();
            }) : m(t.prototype.__proto__ || f()(t.prototype), "serializeOption", this).call(this, e, n);
          }
        }, {
          key: "_optionEquals",
          value: function value(e, n) {
            if ("controlPoints" === e) {
              for (var i = this._options.controlPoints, r = 0, o = i.length; r < o; r++) {
                if (!i[r].getPosition().equals(n[r])) return !1;
              }

              return !0;
            }

            return m(t.prototype.__proto__ || f()(t.prototype), "_optionEquals", this).call(this, e, n);
          }
        }, {
          key: "render",
          value: function value(e) {
            var t = this._options,
                n = t.controlPoints,
                i = t.size;

            if (!(n.length < 2)) {
              var r = this.getBrush(),
                  o = r && r.getHardness ? r.getHardness() : 1;
              h.Utils.ensureCanvasDimensions(this._canvas, e), this._brush && this._lastBrushSize === i && e.equals(this._brushInputDimensions) || (this._brushInputDimensions = e.clone(), this._lastBrushSize = i);

              for (var a = void 0, s = void 0, l = void 0, u = void 0, c = 0; c < n.length; c++) {
                a = n[c - 2], s = n[c - 1], l = n[c], u = n[c + 1], l.renderToCanvas(this._options.brush.getBrushImage(e), this._canvas, a, s, u, o);
              }
            }
          }
        }, {
          key: "_createBrush",
          value: function value(e) {
            var t = this._options,
                n = t.size,
                i = t.hardness,
                r = t.color,
                o = h.Utils.createCanvas();
            o.width = o.height = Math.ceil(n * e.min());
            var a = o.getContext("2d");
            if ((r = r.clone()).a = 1, 1 === o.width) a.fillStyle = r.toRGBA(), a.fillRect(0, 0, 1, 1);else {
              var s = a.createRadialGradient(o.width / 2, o.height / 2, Math.min(o.width / 2 - 1, o.width / 2 * i), o.width / 2, o.height / 2, o.width / 2);
              s.addColorStop(0, r.toRGBA());
              var l = r.clone();
              l.a = 0, s.addColorStop(1, l.toRGBA()), a.fillStyle = s, a.fillRect(0, 0, o.width, o.height);
            }
            return o;
          }
        }, {
          key: "addControlPoint",
          value: function value(e) {
            var t = new d.a(this, e);
            this._options.controlPoints.push(t), this.emit("update", this);
          }
        }, {
          key: "getCanvas",
          value: function value() {
            return this._canvas;
          }
        }, {
          key: "setCanvas",
          value: function value(e) {
            this._canvas = e, this._context = e.getContext("2d");
          }
        }, {
          key: "setDirty",
          value: function value() {
            this._context.clearRect(0, 0, this._canvas.width, this._canvas.height), this._options.controlPoints.forEach(function (e) {
              e.setDirty();
            });
          }
        }, {
          key: "forEachControlPoint",
          value: function value(e) {
            this._options.controlPoints.forEach(e);
          }
        }, {
          key: "renderToCanvas",
          value: function value(e) {
            var t = e.getContext("2d");
            t.save(), t.globalAlpha = this._options.brush.getColor().a, t.drawImage(this._canvas, 0, 0), t.restore();
          }
        }, {
          key: "getCanvasDimensions",
          value: function value() {
            return this._canvasDimensions;
          }
        }]), t;
      }(h.Configurable);

      y.prototype.availableOptions = {
        id: {
          type: h.OptionType.STRING,
          default: function _default() {
            return h.Utils.getUUID();
          }
        },
        brush: {
          type: h.OptionType.OBJECT,
          required: !0
        },
        controlPoints: {
          type: h.OptionType.ARRAY,
          default: []
        },
        closed: {
          type: h.OptionType.BOOLEAN,
          default: !1
        }
      }, t.a = y;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(4),
          a = (n.n(o), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function s(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var l = o.Math.Vector2,
          u = o.Math.CubicBezierCurve,
          c = function () {
        function e(t, n) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 3;
          s(this, e), this._path = t, this._drawnCanvases = [], this._position = n, this._smooth = i;
        }

        return a(e, [{
          key: "getBezierCurve",
          value: function value(e, t, n, i) {
            if (!t) return null;
            var r = void 0,
                o = void 0;
            i ? (r = (i.x - t.x) / this._smooth, o = (i.y - t.y) / this._smooth) : (r = (n.x - t.x) / this._smooth, o = (n.y - t.y) / this._smooth);
            var a = void 0,
                s = void 0;
            e ? (a = (n.x - e.x) / this._smooth, s = (n.y - e.y) / this._smooth) : (a = (n.x - t.x) / this._smooth, s = (n.y - t.y) / this._smooth);
            var l = t.clone().add(a, s),
                c = n.clone().subtract(r, o);
            return new u(t, l, c, n);
          }
        }, {
          key: "renderToCanvas",
          value: function value(e, t, n, i, r) {
            var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1;

            if (-1 === this._drawnCanvases.indexOf(t)) {
              var a = new l(t.width, t.height),
                  s = t.getContext("2d"),
                  u = this._position.clone().multiply(a),
                  c = i ? i.getPosition().clone().multiply(a) : null,
                  p = n ? n.getPosition().clone().multiply(a) : null,
                  f = r ? r.getPosition().clone().multiply(a) : null,
                  h = (u.clone().subtract(c).len(), e.width / 10),
                  d = this.getBezierCurve(p, c, u, f),
                  g = void 0;

              if (d) {
                d.calculateSegments(20);
                var m = d.getLength();
                g = d.arcLengthApproxSample(Math.ceil(m / h));
              } else g = [u];

              for (var y = 0; y < g.length; y++) {
                var _ = g[y],
                    v = .5 * e.width / (2 * h);
                v = 1 / (1 + (v *= 1 - o)), s.globalAlpha = v, s.drawImage(e, _.x - e.width / 2, _.y - e.height / 2, e.width, e.height);
              }

              s.globalAlpha = 1, this._drawnCanvases.push(t);
            }
          }
        }, {
          key: "setPosition",
          value: function value(e) {
            this._position = e;
          }
        }, {
          key: "getPosition",
          value: function value() {
            return this._position.clone();
          }
        }, {
          key: "setDirty",
          value: function value() {
            this._drawnCanvases = [];
          }
        }]), e;
      }();

      t.a = c;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(176)),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = function (e) {
        function t() {
          return d(this, t), g(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "getBrushImage",
          value: function value(e) {
            if (this._brush && this.optionsEqual(this._lastOptions) && e.equals(this._lastInputDimensions)) return this._brush;
            var t = this._options,
                n = t.size,
                i = t.hardness,
                r = t.color,
                o = p.Utils.createCanvas();
            o.width = o.height = Math.ceil(n * e.min());
            var a = o.getContext("2d");
            if ((r = r.clone()).a = 1, 1 === o.width) a.fillStyle = r.toRGBA(), a.fillRect(0, 0, 1, 1);else {
              var s = a.createRadialGradient(o.width / 2, o.height / 2, Math.min(o.width / 2 - 1, o.width / 2 * i), o.width / 2, o.height / 2, o.width / 2);
              s.addColorStop(0, r.toRGBA());
              var l = r.clone();
              l.a = 0, s.addColorStop(1, l.toRGBA()), a.fillStyle = s, a.fillRect(0, 0, o.width, o.height);
            }
            return this._lastOptions = this.serializeOptions(["size", "color", "hardness"]), this._brush = o, this._lastInputDimensions = e.clone(), o;
          }
        }]), t;
      }(f.a);

      t.a = m, m.identifier = "imgly_brush_radial", m.prototype.availableOptions = p.Utils.extend(f.a.prototype.availableOptions, {
        hardness: {
          type: p.OptionType.NUMBER,
          default: 1
        }
      });
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          h = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var e = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || c()(t)).call(this));

          return e._fragmentSource = n(421), e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_applyCanvas",
          value: function value(e, t, n) {
            for (var i = t.getCanvas(), r = t.getContext(), o = n.getContext(), a = this._options, s = a.maskCanvas, l = a.filterCanvas, u = s.getContext("2d"), c = l.getContext("2d"), p = u.getImageData(0, 0, i.width, i.height).data, f = r.getImageData(0, 0, i.width, i.height), h = f.data, d = c.getImageData(0, 0, i.width, i.height).data, g = void 0, m = 0; m < i.width * i.height * 4; m += 4) {
              g = p[m] / 255, h[m] = g * d[m] + (1 - g) * h[m], h[m + 1] = g * d[m + 1] + (1 - g) * h[m + 1], h[m + 2] = g * d[m + 2] + (1 - g) * h[m + 2];
            }

            o.putImageData(f, 0, 0);
          }
        }]), t;
      }(p.Engine.Filter);

      h.prototype.availableOptions = {
        maskImage: {
          type: p.OptionType.NUMBER,
          default: 1,
          uniformType: p.UniformType.INT
        },
        maskCanvas: {
          type: p.OptionType.OBJECT,
          default: null
        },
        filterImage: {
          type: p.OptionType.NUMBER,
          default: 2,
          uniformType: p.UniformType.INT
        },
        filterCanvas: {
          type: p.OptionType.OBJECT,
          default: null
        }
      }, t.a = h;
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_filterImage;\nuniform sampler2D u_maskImage;\n\nvoid main() {\n  vec4 color0 = texture2D(u_image, v_texCoord);\n  vec4 color1 = texture2D(u_filterImage, v_texCoord);\n  vec4 mask = texture2D(u_maskImage, v_texCoord);\n  gl_FragColor = mix(color0, color1, mask);\n}\n";
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = n.n(g),
          y = n(75),
          _ = n(423),
          v = n(424),
          b = n(175),
          w = n(425),
          x = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          k = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          T = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function S(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function C(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var E = g.Math.Vector2,
          O = function (e) {
        function t() {
          var e;
          S(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = C(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          o.setSmoothDownscaling(o._sdk.getOptions().smoothDownscaling), o._onSpriteUpdate = o._onSpriteUpdate.bind(o), o._maskCanvas = g.Utils.createCanvas();

          var a = o._options.sprites.slice();

          return a.forEach(function (e) {
            o.removeSprite(e), o.addSprite(e);
          }), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), k(t, [{
          key: "getSpritesOfType",
          value: function value(e) {
            return this._options.sprites.filter(function (t) {
              return t instanceof e;
            });
          }
        }, {
          key: "rotate",
          value: function value(e) {
            this._options.sprites.forEach(function (t) {
              t.applyRotation(e);
            });
          }
        }, {
          key: "flip",
          value: function value(e) {
            this._options.sprites.forEach(function (t) {
              t.applyFlip(e);
            });
          }
        }, {
          key: "_onSpriteUpdate",
          value: function value(e, t) {
            this.emit("update", this), this.setDirty(!0);
          }
        }, {
          key: "_applyRotation",
          value: function value(e, t) {
            this._options.sprites.forEach(function (n) {
              return n.applyRotation(e, t);
            });
          }
        }, {
          key: "transform",
          value: function value(e) {
            this._options.sprites.forEach(function (t) {
              return t.applyTransform(e);
            });
          }
        }, {
          key: "scale",
          value: function value(e) {
            this._options.sprites.forEach(function (t) {
              return t.applyScale(e);
            });
          }
        }, {
          key: "serializeOption",
          value: function value(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return "sprites" === e ? this._options.sprites.map(function (e) {
              return e.serializeOptions(void 0, n);
            }) : T(t.prototype.__proto__ || d()(t.prototype), "serializeOption", this).call(this, e, n);
          }
        }, {
          key: "createSticker",
          value: function value(e) {
            return new _.a(this, e);
          }
        }, {
          key: "createText",
          value: function value(e) {
            return new v.a(this, e);
          }
        }, {
          key: "createBrush",
          value: function value(e) {
            return new b.a(this, e);
          }
        }, {
          key: "createTextDesign",
          value: function value(e) {
            return new w.a(this, e);
          }
        }, {
          key: "addSprite",
          value: function value(e) {
            this._options.sprites.push(e);

            var t = this.getSmoothDownscaling();
            e.setSmoothDownscaling && e.setSmoothDownscaling(t), this._container.addChild(e.getDisplayObject()), this.setDirty(!0), e.on("update", this._onSpriteUpdate), this.emit("update", this, this._options.sprites);
          }
        }, {
          key: "removeSprite",
          value: function value(e) {
            var t = this._options.sprites,
                n = t.indexOf(e);
            return -1 !== n && (e.off("update", this._onSpriteUpdate), this._container.removeChild(e.getDisplayObject()), t.splice(n, 1), this.setDirty(!0), !0);
          }
        }, {
          key: "_getOrientatedStageSize",
          value: function value() {
            var e = this._sdk.getSprite().getTexture().getFrame(),
                t = this._sdk.getOperationsStack().getByIdentifier("orientation");

            if (t) {
              var n = t ? t.getRotation() : 0;
              return 270 === n || 90 === n ? new E(e.height, e.width) : new E(e.width, e.height);
            }

            var i = this._sdk.getOperationsStack().getByIdentifier("output");

            return i ? i.getOutputResolution() : new E(e.width, e.height);
          }
        }, {
          key: "_render",
          value: function value(e) {
            var t = this,
                n = this._container,
                i = this._options.sprites,
                r = e.getDimensions().clone().floor(),
                o = new g.Engine.Container();
            return o.addChild(this._sprite), g.Promise.all(i.map(function (e) {
              return e.validateSettings();
            })).then(function () {
              i.forEach(function (e) {
                return e.update(t._sdk, r);
              });
            }).then(function () {
              t._renderTexture.clear(), i.forEach(function (e) {
                e.getInverted && e.getInverted() ? (t._renderTexture.render(o), t._renderTexture.render(t._renderMaskedSprite(e.getDisplayObject(), e.getColor ? e.getColor() : g.Color.WHITE, e.getPadding ? e.getPadding() : -1)), o = new g.Engine.Container()) : o.addChild(e.getDisplayObject());
              }), t._renderTexture.render(o), n.addChild(t._sprite), i.forEach(function (e) {
                return n.addChild(e.getDisplayObject());
              });
            });
          }
        }, {
          key: "_renderMaskedSprite",
          value: function value(e, t, n) {
            var i = this._maskCanvas,
                r = e.getWorldTransform(),
                o = this._getOrientatedStageSize();

            g.Utils.ensureCanvasDimensions(i, o);
            var a = i.getContext("2d");
            if (a.clearRect(0, 0, i.width, i.height), a.save(), a.fillStyle = t.toRGBA(), n < 0) a.fillRect(0, 0, o.x, o.y);else {
              var s = Math.abs(e.getWidth() / e.getScale().x),
                  l = Math.abs(e.getHeight() / e.getScale().y),
                  u = s * n;
              a.transform(r.a, r.b, r.c, r.d, r.tx, r.ty), a.fillRect(-u, -u, s + 2 * u, l + 2 * u);
            }
            a.restore(), a.save(), a.globalCompositeOperation = "destination-out", e._renderCanvas({
              getCurrentRenderTarget: function getCurrentRenderTarget() {
                return {
                  getPixelRatio: function getPixelRatio() {
                    return 1;
                  }
                };
              },
              beforeDraw: function beforeDraw(t) {
                var n = e.getWidth(),
                    i = e.getHeight(),
                    r = e.getScale(),
                    o = r.x < 0,
                    a = r.y < 0;
                t.translate(n, i), t.scale(o ? -1 : 1, a ? -1 : 1), t.translate(-n, -i);
              },
              getContext: function getContext() {
                return a;
              }
            }), a.restore();
            var c = new g.Engine.Container(),
                p = new g.Engine.Sprite(g.Engine.Texture.fromCanvas(i));
            return c.addChild(p), c;
          }
        }, {
          key: "takeSpriteToFront",
          value: function value(e) {
            var t = this._options.sprites,
                n = t.indexOf(e);

            if (-1 !== n) {
              g.Utils.moveArrayItem(t, n, t.length - 1);
              var i = e.getDisplayObject();
              this._container.removeChild(i), this._container.addChild(i), this.setDirty(!0);
            }
          }
        }, {
          key: "getSpritesAtPosition",
          value: function value(e, t) {
            var n = this,
                i = [];

            this._options.sprites.forEach(function (e) {
              return e.update(n._sdk, t);
            });

            var r = this._sdk.getSprite(),
                o = r.getWorldTransform().applyInverseToVector(e),
                a = r.getTexture().getFrame(),
                s = a.width,
                l = a.height,
                u = r.getAnchor().clone().multiply(-s, -l);

            o.subtract(u);

            for (var c = this._options.sprites.slice(0).reverse(), p = 0, f = c.length; p < f; p++) {
              var h = c[p];
              h.getHitTestDisplayObject().isAtPosition(o) && i.push(h);
            }

            return i;
          }
        }, {
          key: "setDirtyForRenderer",
          value: function value(e, n, i) {
            T(t.prototype.__proto__ || d()(t.prototype), "setDirtyForRenderer", this).call(this, e, n, i), this._options.sprites.forEach(function (t) {
              t.setDirtyForRenderer(e, n, i);
            });
          }
        }, {
          key: "dispose",
          value: function value() {
            T(t.prototype.__proto__ || d()(t.prototype), "dispose", this).call(this), this._options.sprites.forEach(function (e) {
              e.dispose();
            });
          }
        }]), t;
      }(g.Operation);

      O.StickerSprite = _.a, O.TextSprite = v.a, O.BrushSprite = b.a, O.TextDesignSprite = w.a, O.identifier = "sprite", O.prototype.availableOptions = {
        sprites: {
          type: g.OptionType.ARRAY,
          default: [],
          setter: function setter(e, t) {
            var n = this;
            return e = e.map(function (e, t) {
              if (e instanceof y.a) return e;
              var i = x({}, e);

              switch (delete i.type, e.type) {
                case "text":
                  return new v.a(n, i);

                case "sticker":
                  return new _.a(n, i);

                case "brush":
                  return new b.a(n, i);

                case "textdesign":
                  return new w.a(n, i);

                default:
                  g.Log.error(n.constructor.name, "Invalid sprite type: " + e.type);
              }
            }), t || (this._options.sprites && this._options.sprites.slice().forEach(function (e) {
              e.dispose(), n.removeSprite(e);
            }), e.forEach(function (e) {
              n.addSprite(e);
            })), e;
          }
        },
        smoothDownscaling: {
          type: g.OptionType.BOOLEAN,
          default: !1
        }
      }, m.a.Operations.SpriteOperation = O, t.a = O;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(75)),
          g = n(172),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          y = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = h.Math.Vector2,
          w = h.Math.ColorMatrix,
          x = function (e) {
        function t() {
          var e;

          _(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = v(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i))),
              a = o._options.image,
              s = a.src || a.filePath || a.toDataUrl && a.toDataURL();
          return o._isSVG = s && !!s.match(/\w+\.svg(?=\?|$)/i), o._isSVG && (o._canvas = h.Utils.createCanvas(), o._context = o._canvas.getContext("2d"), o._options.smoothDownscaling = !1), a && o._onImageUpdate(), o._tintFilter = new h.Engine.Filters.TintFilter(), o._adjustmentsFilter = new g.a(), o._lastRenderedDimensions = b.NULL, o._lastRenderedInputDimensions = b.NULL, o._onOptionsChange = o._onOptionsChange.bind(o), o._options.adjustments.on("update", o._onOptionsChange), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "applyScale",
          value: function value(e) {
            this.setDimensions(this.getDimensions().multiply(e));
          }
        }, {
          key: "serializeOptions",
          value: function value(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                i = y(t.prototype.__proto__ || f()(t.prototype), "serializeOptions", this).call(this, e, n);
            return e || (i.type = "sticker"), i;
          }
        }, {
          key: "_rendersToRenderTexture",
          value: function value(e) {
            return this._options.smoothDownscaling && !this._isSVG && e.getRenderer().isOfType(h.RendererType.WEBGL) || this._hasAdjustments() || "none" !== this._options.tintMode;
          }
        }, {
          key: "_getTexture",
          value: function value() {
            return this._inputTexture;
          }
        }, {
          key: "update",
          value: function value(e, t) {
            var n = this._options,
                i = n.dimensions,
                r = n.image;

            if (i.equals(b.NULL) && i.set(r.width, r.height), this._sprite.setSmoothDownscaling(!this._isSVG && this.getSmoothDownscaling()), (!this._lastRenderedInputDimensions.equals(t) || !this._lastRenderedDimensions.equals(i) || this._lastRenderedImage !== r) && this._isSVG && e.getRenderer().isOfType(h.RendererType.WEBGL)) {
              r.width = Math.round(i.x), r.height = Math.round(i.y);
              var o = r.width / r.height;
              r.width > 4096 && (r.width = 4096, r.height = Math.round(r.width / o)), r.height > 4096 && (r.height = 4096, r.width = Math.round(r.height * o)), this._canvas.width = r.width, this._canvas.height = r.height, this._context.clearRect(0, 0, r.width, r.height), this._context.drawImage(r, 0, 0, r.width, r.height), this._inputTexture.getBaseTexture().update();
            }

            this._rendersToRenderTexture(e) && this._prepareRenderTexture(e);
            var a = [];

            if (this._rendersToRenderTexture(e)) {
              if (this._hasAdjustments()) {
                a.push(this._adjustmentsFilter);
                var s = this._options.adjustments,
                    l = new w();
                l.multiply(w.createBrightnessMatrix(s.getBrightness())), l.multiply(w.createSaturationMatrix(s.getSaturation())), l.multiply(w.createContrastMatrix(s.getContrast())), this._adjustmentsFilter.set({
                  colorMatrix: l
                });
              }

              this._options.tintMode && "none" !== this._options.tintMode && (a.push(this._tintFilter), this._tintFilter.set({
                mode: h.Engine.Filters.TintFilter.MODES[this._options.tintMode.toUpperCase()],
                color: this._options.tintColor
              })), this._renderTextureSprite.setFilters(a);
            }

            this._rendersToRenderTexture(e) ? this._renderToRenderTexture(e) : this._sprite.setTexture(this._inputTexture), this._updateSprite(t), this._applyFlip(), this._lastRenderedDimensions.copy(i), this._lastRenderedInputDimensions.copy(t), this._lastRenderedImage = r;
          }
        }, {
          key: "_applyFlip",
          value: function value() {
            var e = this._sprite.getScale(),
                t = this._options,
                n = t.flipHorizontally,
                i = t.flipVertically;

            (n && e.x > 0 || !n && e.x < 0) && (e.x *= -1), (i && e.y > 0 || !i && e.y < 0) && (e.y *= -1), this._sprite.setScale(e);
          }
        }, {
          key: "applyFlip",
          value: function value(e) {
            y(t.prototype.__proto__ || f()(t.prototype), "applyFlip", this).call(this, e);
            var n = {
              rotation: this._options.rotation
            },
                i = n.rotation / Math.PI * 180 * -1;

            switch (n.rotation = i * Math.PI / 180, e) {
              case "horizontal":
                n.flipHorizontally = !this._options.flipHorizontally, this.set(n);
                break;

              case "vertical":
                n.flipVertically = !this._options.flipVertically, this.set(n);
            }
          }
        }, {
          key: "_hasAdjustments",
          value: function value() {
            var e = this._options.adjustments;
            return 0 !== e.getBrightness() || 1 !== e.getSaturation() || 1 !== e.getContrast();
          }
        }, {
          key: "_onImageUpdate",
          value: function value() {
            var e = this._options.image,
                t = this._operation.getSDK().getRenderer();

            this._isSVG && t.isOfType(h.RendererType.WEBGL) && (e = this._canvas), this._inputTexture && (this._inputTexture.dispose(), this._inputTexture = null), this._inputTexture = h.Engine.Texture.fromImage(e), this._identitySprite.setTexture(this._inputTexture), this._sprite.setTexture(this._inputTexture), this._renderTexture && (this._renderTextureSprite.setTexture(this._inputTexture), this._renderTexture.resizeTo(this._inputTexture.getDimensions())), this.setDirty(!0);
          }
        }, {
          key: "scalesUniformly",
          value: function value() {
            return "keepAspect" === this._options.resizeMode;
          }
        }, {
          key: "setOption",
          value: function value(e, n) {
            var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
            y(t.prototype.__proto__ || f()(t.prototype), "setOption", this).call(this, e, n, i), "image" === e && this._identitySprite && this._onImageUpdate();
          }
        }, {
          key: "_onOptionsChange",
          value: function value() {
            var e = this._dirtiness;

            for (var t in e) {
              e[t] = !0;
            }
          }
        }, {
          key: "dispose",
          value: function value() {
            y(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._inputTexture && (this._inputTexture.dispose(), this._inputTexture = null), this._tintFilter.dispose(), this._adjustmentsFilter.dispose(), this._options.adjustments.off("updated", this._onOptionsChange);
          }
        }]), t;
      }(d.a);

      x.prototype.availableOptions = {
        id: {
          type: h.OptionType.STRING,
          default: function _default() {
            return h.Utils.getUUID();
          }
        },
        identifier: {
          type: h.OptionType.STRING,
          default: ""
        },
        image: {
          type: h.OptionType.IMAGE,
          required: !0
        },
        position: {
          type: h.OptionType.VECTOR2,
          default: b.NULL
        },
        dimensions: {
          type: h.OptionType.VECTOR2,
          default: b.NULL
        },
        anchor: {
          type: h.OptionType.VECTOR2,
          default: new b(0, 0)
        },
        pivot: {
          type: h.OptionType.VECTOR2,
          default: new b(.5, .5)
        },
        rotation: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        flipHorizontally: {
          type: h.OptionType.BOOLEAN,
          default: !1
        },
        flipVertically: {
          type: h.OptionType.BOOLEAN,
          default: !1
        },
        smoothDownscaling: {
          type: h.OptionType.BOOLEAN,
          default: !1
        },
        tintColor: {
          type: h.OptionType.COLOR,
          default: h.Color.WHITE
        },
        tintMode: {
          type: h.OptionType.STRING,
          default: "none",
          available: ["none", "solid", "colorized"]
        },
        resizeMode: {
          type: h.OptionType.STRING,
          default: "keepAspect",
          available: ["keepAspect", "unrestricted"]
        },
        alpha: {
          type: h.OptionType.NUMBER,
          default: 1
        },
        adjustments: {
          type: h.OptionType.CONFIGURABLE,
          structure: {
            brightness: {
              type: h.OptionType.NUMBER,
              default: 0
            },
            saturation: {
              type: h.OptionType.NUMBER,
              default: 1
            },
            contrast: {
              type: h.OptionType.NUMBER,
              default: 1
            }
          }
        }
      }, x.type = "sticker", t.a = x;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(75)),
          g = n(177),
          m = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          y = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      };

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = h.Math.Vector2,
          w = function (e) {
        function t() {
          var e;

          _(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = v(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._textRenderer = new g.a(o, o._operation), o._textRenderer.rotation = o.getRotation(), o._sprite.setTexture(o._textRenderer.getFinalTexture()), o._hitTestSprite.setTexture(o._textRenderer.getTexture()), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), m(t, [{
          key: "serializeOptions",
          value: function value(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                i = y(t.prototype.__proto__ || f()(t.prototype), "serializeOptions", this).call(this, e, n);
            return e || (i.type = "text"), i;
          }
        }, {
          key: "getDOMStyle",
          value: function value(e, t) {
            var n = this.getFontSize() * t.y;
            return {
              fontWeight: this._options.fontWeight,
              fontSize: n + "px",
              fontStyle: this._options.fontStyle,
              fontFamily: this._options.fontFamily,
              lineHeight: this.getAbsoluteTextHeight(t) * this.getLineHeight() + "px",
              color: this._options.color.toRGBA(),
              backgroundColor: this._options.backgroundColor.toRGBA(),
              textAlign: this._options.alignment
            };
          }
        }, {
          key: "getAbsoluteTextHeight",
          value: function value(e) {
            var t = this.getFontSize() * e.y,
                n = this.getTextMetrics();

            if (n) {
              var i = 1 / n.unitsPerEm * t,
                  r = n.ascender * i,
                  o = n.descender * i;
              return r + Math.abs(o);
            }

            return t * this.getLineHeight() * 1.1;
          }
        }, {
          key: "getDimensions",
          value: function value(e, t) {
            return this._textRenderer.getDimensions(e, t);
          }
        }, {
          key: "applyFlip",
          value: function value(e) {
            y(t.prototype.__proto__ || f()(t.prototype), "applyFlip", this).call(this, e);
            var n = this._options.rotation;

            switch (e) {
              case "horizontal":
                n += 2 * (Math.PI - n), this.setRotation(n);
                break;

              case "vertical":
                n += 2 * (Math.PI / 2 - n), this.setRotation(n);
            }
          }
        }, {
          key: "applyTransform",
          value: function value(e) {
            y(t.prototype.__proto__ || f()(t.prototype), "applyTransform", this).call(this, e), this.set({
              fontSize: e.scaleSize(this.getFontSize(), "y"),
              maxWidth: e.scaleSize(this.getMaxWidth(), "x")
            }, !1);
          }
        }, {
          key: "applyRotation",
          value: function value(e) {
            y(t.prototype.__proto__ || f()(t.prototype), "applyRotation", this).call(this, e);

            var n = (e + 360) % 360,
                i = this._operation.getInputDimensions();

            90 !== n && 270 !== n || (this.setMaxWidth(this.getMaxWidth() / i.x * i.y), this.setFontSize(this.getFontSize() / i.y * i.x));
          }
        }, {
          key: "setOption",
          value: function value(e, n) {
            var i = this._options,
                r = i.flipHorizontally,
                o = i.flipVertically;

            if ("rotation" === e) {
              var a = n;
              return r && (a = 2 * Math.PI - a), o && (a = 2 * Math.PI - a), this._options.rotation = a, this._textRenderer && (this._textRenderer.rotation = a), this._rotation = a, void this.emit("update");
            }

            y(t.prototype.__proto__ || f()(t.prototype), "setOption", this).call(this, e, n);
          }
        }, {
          key: "getOption",
          value: function value(e) {
            return "rotation" === e ? this._rotation : y(t.prototype.__proto__ || f()(t.prototype), "getOption", this).call(this, e);
          }
        }, {
          key: "getHitTestDisplayObject",
          value: function value() {
            return this._hitTestSprite;
          }
        }, {
          key: "update",
          value: function value(e, n) {
            if (this._sprite.setVisible(this._options.visible), this._options.visible) {
              this._textRenderer.update(e, n);

              var i = this._textRenderer.getFinalTexture();

              i.getBaseTexture().update();
              var r = e.getRenderer();
              r.isOfType(h.RendererType.WEBGL) && r.updateTexture(i.getBaseTexture()), y(t.prototype.__proto__ || f()(t.prototype), "update", this).call(this, e, n), this._sprite.setRotation(0), this._textRenderer.getTexture().getBaseTexture().update(), this._hitTestSprite.setRotation(this._rotation), this._hitTestSprite.updateTransform(), this._applyFlip();
            }
          }
        }, {
          key: "_applyFlip",
          value: function value() {
            var e = this._sprite.getScale(),
                t = this._options,
                n = t.flipHorizontally,
                i = t.flipVertically;

            (n && e.x > 0 || !n && e.x < 0) && (e.x *= -1, this.setRotation(this._rotation)), (i && e.y > 0 || !i && e.y < 0) && (e.y *= -1, this.setRotation(this._rotation)), this._sprite.setScale(e);
          }
        }, {
          key: "_getTexture",
          value: function value() {
            return this._textRenderer.getFinalTexture();
          }
        }, {
          key: "dispose",
          value: function value() {
            y(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._textRenderer.dispose(), this._hitTestSprite.dispose(), this._sprite.dispose();
          }
        }, {
          key: "canBeFlippedHorizontally",
          value: function value() {
            return !1;
          }
        }, {
          key: "canAdjustPadding",
          value: function value() {
            return !1;
          }
        }]), t;
      }(d.a);

      w.prototype.availableOptions = {
        id: {
          type: h.OptionType.STRING,
          default: function _default() {
            return h.Utils.getUUID();
          }
        },
        fontSize: {
          type: h.OptionType.NUMBER,
          default: .1
        },
        characterSpacing: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        lineHeight: {
          type: h.OptionType.NUMBER,
          default: 1.1
        },
        fontIdentifier: {
          type: h.OptionType.STRING
        },
        fontFamily: {
          type: h.OptionType.STRING,
          default: "Times New Roman"
        },
        fontWeight: {
          type: h.OptionType.ALL,
          default: "normal"
        },
        fontStyle: {
          type: h.OptionType.STRING,
          default: "normal"
        },
        textMetrics: {
          type: h.OptionType.OBJECT,
          default: null
        },
        outlineWidth: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        outlineColor: {
          type: h.OptionType.COLOR,
          default: h.Color.BLACK
        },
        alignment: {
          type: h.OptionType.STRING,
          default: "left",
          available: ["left", "center", "right"]
        },
        verticalAlignment: {
          type: h.OptionType.STRING,
          default: "top",
          available: ["top", "center", "bottom"]
        },
        color: {
          type: h.OptionType.COLOR,
          default: new h.Color(1, 0, 0, 1)
        },
        backgroundColor: {
          type: h.OptionType.COLOR,
          default: h.Color.TRANSPARENT
        },
        position: {
          type: h.OptionType.VECTOR2,
          default: new b(.5, .5)
        },
        anchor: {
          type: h.OptionType.VECTOR2,
          default: new b(0, 0)
        },
        pivot: {
          type: h.OptionType.VECTOR2,
          default: new b(.5, .5)
        },
        rotation: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        text: {
          type: h.OptionType.STRING,
          required: !0
        },
        maxWidth: {
          type: h.OptionType.NUMBER,
          default: .5
        },
        maxHeight: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        visible: {
          type: h.OptionType.BOOLEAN,
          default: !0
        },
        flipHorizontally: {
          type: h.OptionType.BOOLEAN,
          default: !1
        },
        flipVertically: {
          type: h.OptionType.BOOLEAN,
          default: !1
        }
      }, w.type = "text", t.a = w;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(75)),
          g = n(20),
          m = n(76),
          y = n(433),
          _ = n(179),
          v = n(434),
          b = n(181),
          w = n(435),
          x = n(182),
          k = n(437),
          T = n(53),
          S = n(439),
          C = n(128),
          E = n(440),
          O = n(441),
          R = n(442),
          I = n(129),
          A = n(443),
          M = n(444),
          F = n(449),
          D = n(27),
          P = n(450),
          z = n(33),
          L = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          B = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = f()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      },
          N = h.Math.Vector2,
          U = function (e) {
        function t(e, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var i = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || f()(t)).call(this, e, n));

          return i._isDisposed = !1, i._renderer = new P.a(), i._canvas = h.Utils.createCanvas(), i._context = i._canvas.getContext("2d"), i._texture = h.Engine.Texture.fromCanvas(i._canvas), i._sprite.setTexture(i._texture), i._aspect = 1, i._isLayoutDirty = !0, i.getSeed() < 0 && i.setSeed(g.a.TimeSeed()), i;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), L(t, [{
          key: "seed",
          value: function value(e) {
            this.setSeed(e || g.a.TimeSeed()), this._isLayoutDirty = !0;
          }
        }, {
          key: "_updateLayout",
          value: function value() {
            var e = this.getLayout();
            return e ? (this._renderer.createLayout(e, this.getText(), this.getSeed()), this._aspect = this._renderer.calculateAspect(), this._isLayoutDirty = !1, !0) : null;
          }
        }, {
          key: "applyTransform",
          value: function value(e) {
            B(t.prototype.__proto__ || f()(t.prototype), "applyTransform", this).call(this, e);
            var n = {};
            this._options.dimensions && (n.width = e.applyToRelativeSize(this.getWidth())), this.set(n, !1);
          }
        }, {
          key: "applyFlip",
          value: function value(e) {
            B(t.prototype.__proto__ || f()(t.prototype), "applyFlip", this).call(this, e);
            var n = this._options.rotation;

            switch (e) {
              case "horizontal":
                n += 2 * (Math.PI - n), this.setRotation(n);
                break;

              case "vertical":
                n += 2 * (Math.PI / 2 - n), this.setRotation(n);
            }
          }
        }, {
          key: "update",
          value: function value(e, n) {
            var i = this._isLayoutDirty;

            if (!(this._isDisposed || i && !this._updateLayout())) {
              var r = this.getWidth() * n.min() / e.getTextureScale(),
                  o = r / this._aspect,
                  a = new N(r, o),
                  s = new N(Math.round(2 * r), Math.round(2 * o)).clamp(new N(1, 1), new N(1 / 0, 1 / 0)),
                  l = e.getRenderer(),
                  u = l.getMaxDimensions() || 1 / 0;
              s.x > u && (s.x = u, s.y = Math.round(s.x / this._aspect)), s.y > u && (s.y = u, s.x = Math.round(s.y * this._aspect));
              var c = h.Utils.ensureCanvasDimensions(this._canvas, s);
              (i || c) && (this._context.clearRect(0, 0, this._canvas.width, this._canvas.height), this._renderer.draw(this._context, new z.a(s.x, s.y), this.getColor(), this.getInverted()), this.setDimensions(a), this._texture.getBaseTexture().update(), l.isOfType(h.RendererType.WEBGL) && l.updateTexture(this._texture.getBaseTexture())), B(t.prototype.__proto__ || f()(t.prototype), "update", this).call(this, e, n), this._applyFlip();
            }
          }
        }, {
          key: "_applyFlip",
          value: function value() {
            var e = this._sprite.getScale(),
                t = this._options,
                n = t.flipHorizontally,
                i = t.flipVertically;

            (n && e.x > 0 || !n && e.x < 0) && (e.x *= -1), (i && e.y > 0 || !i && e.y < 0) && (e.y *= -1), this._sprite.setScale(e);
          }
        }, {
          key: "_optionEquals",
          value: function value(e, n) {
            if ("layout" === e) {
              var i = this._options.layout;
              return !(!i && n || !n && i || !n.constructor || !i.constructor || i.constructor.identifier !== n.constructor.identifier);
            }

            return B(t.prototype.__proto__ || f()(t.prototype), "_optionEquals", this).call(this, e, n);
          }
        }, {
          key: "serializeOptions",
          value: function value(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

            if (e && this.getPadding() < 0) {
              var i = e.indexOf("padding");
              i > -1 && e.splice(i, 1);
            }

            var r = B(t.prototype.__proto__ || f()(t.prototype), "serializeOptions", this).call(this, e, n);
            return e || (r.type = "textdesign"), r;
          }
        }, {
          key: "_getTexture",
          value: function value() {
            return this._texture;
          }
        }, {
          key: "canBeFlippedHorizontally",
          value: function value() {
            return !1;
          }
        }, {
          key: "canBeDuplicated",
          value: function value() {
            return !0;
          }
        }, {
          key: "canMaskCanvas",
          value: function value() {
            return !0;
          }
        }, {
          key: "canAdjustPadding",
          value: function value() {
            return !0;
          }
        }, {
          key: "dispose",
          value: function value() {
            this._isDisposed = !0, this._texture.dispose(), this._sprite.dispose();
          }
        }]), t;
      }(d.a);

      U.Layouts = {
        TextDesignBlocks: m.a,
        TextDesignBlocksCondensed: y.a,
        TextDesignBlocksLight: _.a,
        TextDesignCelebrate: b.a,
        TextDesignCelebrateSimple: w.a,
        TextDesignEqualWidth: x.a,
        TextDesignEqualWidthFat: k.a,
        TextDesignMasked: T.a,
        TextDesignMaskedBadge: S.a,
        TextDesignMaskedSpeechBubble: C.a,
        TextDesignMaskedSpeechBubbleComic: E.a,
        TextDesignMultiline: O.a,
        TextDesignWatercolor: R.a,
        TextDesignSunshine: I.a,
        TextDesignParticles: M.a,
        TextDesignRotated: F.a
      }, U.LegacyLayouts = {
        TextDesignBlocksLightV310: v.a,
        TextDesignSunshineV310: A.a
      }, U.AssetManager = D.a, U.prototype.availableOptions = {
        id: {
          type: h.OptionType.STRING,
          default: function _default() {
            return h.Utils.getUUID();
          }
        },
        position: {
          type: h.OptionType.VECTOR2,
          default: new N(.5, .5)
        },
        dimensions: {
          type: h.OptionType.VECTOR2,
          default: N.NULL
        },
        anchor: {
          type: h.OptionType.VECTOR2,
          default: new N(0, 0)
        },
        pivot: {
          type: h.OptionType.VECTOR2,
          default: new N(.5, .5)
        },
        rotation: {
          type: h.OptionType.NUMBER,
          default: 0
        },
        flipHorizontally: {
          type: h.OptionType.BOOLEAN,
          default: !1
        },
        flipVertically: {
          type: h.OptionType.BOOLEAN,
          default: !1
        },
        layout: {
          type: h.OptionType.OBJECT,
          default: null,
          setter: function setter(e) {
            return this._isLayoutDirty = !0, e;
          }
        },
        text: {
          type: h.OptionType.STRING,
          default: "",
          setter: function setter(e) {
            return this._isLayoutDirty = !0, e;
          }
        },
        color: {
          type: h.OptionType.COLOR,
          default: h.Color.BLACK,
          setter: function setter(e) {
            return this._isLayoutDirty = !0, e;
          }
        },
        padding: {
          type: h.OptionType.NUMBER,
          default: .01,
          minValue: .01
        },
        width: {
          type: h.OptionType.NUMBER,
          default: .8
        },
        inverted: {
          type: h.OptionType.BOOLEAN,
          default: !1,
          setter: function setter(e) {
            return this._isLayoutDirty = !0, e;
          }
        },
        seed: {
          type: h.OptionType.NUMBER,
          default: -1
        }
      }, t.a = U;
    }, function (e, t, n) {
      e.exports = {
        default: n(427),
        __esModule: !0
      };
    }, function (e, t, n) {
      n(428), e.exports = 9007199254740991;
    }, function (e, t, n) {
      var i = n(14);
      i(i.S, "Number", {
        MAX_SAFE_INTEGER: 9007199254740991
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return y;
      });

      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(21)),
          h = n(33),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function g(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function m(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var y = function (e) {
        function t() {
          return g(this, t), m(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "getSize",
          value: function value() {
            var e = this.getRows(),
                t = this.getWidth(),
                n = e.length - 1,
                i = e.reduce(function (e, t) {
              return e + t.getSize().height;
            }, 0);
            i += (n + 1) * this.getRelativeLineSpacing() * t;
            var r = this.getRelativeInsets().clone().scale(t);
            return i += r.top + r.bottom, new h.a(t, i);
          }
        }]), t;
      }(p.Configurable);

      y.prototype.availableOptions = {
        text: {
          type: p.OptionType.STRING,
          default: ""
        },
        lines: {
          type: p.OptionType.ARRAY,
          default: []
        },
        relativeInsets: {
          type: p.OptionType.OBJECT,
          default: new f.a()
        },
        relativeLineSpacing: {
          type: p.OptionType.NUMBER,
          default: 0
        },
        rows: {
          type: p.OptionType.OBJECT,
          default: []
        },
        background: {
          type: p.OptionType.OBJECT,
          default: null
        },
        width: {
          type: p.OptionType.NUMBER,
          default: 0
        }
      };
    }, function (e, t, n) {
      var i = function () {
        return this;
      }() || Function("return this")(),
          r = i.regeneratorRuntime && Object.getOwnPropertyNames(i).indexOf("regeneratorRuntime") >= 0,
          o = r && i.regeneratorRuntime;

      if (i.regeneratorRuntime = void 0, e.exports = n(431), r) i.regeneratorRuntime = o;else try {
        delete i.regeneratorRuntime;
      } catch (e) {
        i.regeneratorRuntime = void 0;
      }
    }, function (e, t) {
      !function (t) {
        var n = Object.prototype,
            i = n.hasOwnProperty,
            r = "function" == typeof Symbol ? Symbol : {},
            o = r.iterator || "@@iterator",
            a = r.asyncIterator || "@@asyncIterator",
            s = r.toStringTag || "@@toStringTag",
            l = "object" == typeof e,
            u = t.regeneratorRuntime;
        if (u) l && (e.exports = u);else {
          (u = t.regeneratorRuntime = l ? e.exports : {}).wrap = g;
          var c = {},
              p = {};

          p[o] = function () {
            return this;
          };

          var f = Object.getPrototypeOf,
              h = f && f(f(C([])));
          h && h !== n && i.call(h, o) && (p = h);
          var d = v.prototype = y.prototype = Object.create(p);
          _.prototype = d.constructor = v, v.constructor = _, v[s] = _.displayName = "GeneratorFunction", u.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return !!t && (t === _ || "GeneratorFunction" === (t.displayName || t.name));
          }, u.mark = function (e) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, s in e || (e[s] = "GeneratorFunction")), e.prototype = Object.create(d), e;
          }, u.awrap = function (e) {
            return {
              __await: e
            };
          }, b(w.prototype), w.prototype[a] = function () {
            return this;
          }, u.AsyncIterator = w, u.async = function (e, t, n, i) {
            var r = new w(g(e, t, n, i));
            return u.isGeneratorFunction(t) ? r : r.next().then(function (e) {
              return e.done ? e.value : r.next();
            });
          }, b(d), d[s] = "Generator", d[o] = function () {
            return this;
          }, d.toString = function () {
            return "[object Generator]";
          }, u.keys = function (e) {
            var t = [];

            for (var n in e) {
              t.push(n);
            }

            return t.reverse(), function n() {
              for (; t.length;) {
                var i = t.pop();
                if (i in e) return n.value = i, n.done = !1, n;
              }

              return n.done = !0, n;
            };
          }, u.values = C, S.prototype = {
            constructor: S,
            reset: function reset(e) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(T), !e) for (var t in this) {
                "t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
              }
            },
            stop: function stop() {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function dispatchException(e) {
              if (this.done) throw e;
              var t = this;

              function n(n, i) {
                return a.type = "throw", a.arg = e, t.next = n, i && (t.method = "next", t.arg = void 0), !!i;
              }

              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var o = this.tryEntries[r],
                    a = o.completion;
                if ("root" === o.tryLoc) return n("end");

                if (o.tryLoc <= this.prev) {
                  var s = i.call(o, "catchLoc"),
                      l = i.call(o, "finallyLoc");

                  if (s && l) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function abrupt(e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];

                if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                  var o = r;
                  break;
                }
              }

              o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, c) : this.complete(a);
            },
            complete: function complete(e, t) {
              if ("throw" === e.type) throw e.arg;
              return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), c;
            },
            finish: function finish(e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), T(n), c;
              }
            },
            catch: function _catch(e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];

                if (n.tryLoc === e) {
                  var i = n.completion;

                  if ("throw" === i.type) {
                    var r = i.arg;
                    T(n);
                  }

                  return r;
                }
              }

              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(e, t, n) {
              return this.delegate = {
                iterator: C(e),
                resultName: t,
                nextLoc: n
              }, "next" === this.method && (this.arg = void 0), c;
            }
          };
        }

        function g(e, t, n, i) {
          var r = t && t.prototype instanceof y ? t : y,
              o = Object.create(r.prototype),
              a = new S(i || []);
          return o._invoke = function (e, t, n) {
            var i = "suspendedStart";
            return function (r, o) {
              if ("executing" === i) throw new Error("Generator is already running");

              if ("completed" === i) {
                if ("throw" === r) throw o;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (n.method = r, n.arg = o;;) {
                var a = n.delegate;

                if (a) {
                  var s = x(a, n);

                  if (s) {
                    if (s === c) continue;
                    return s;
                  }
                }

                if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                  if ("suspendedStart" === i) throw i = "completed", n.arg;
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                i = "executing";
                var l = m(e, t, n);

                if ("normal" === l.type) {
                  if (i = n.done ? "completed" : "suspendedYield", l.arg === c) continue;
                  return {
                    value: l.arg,
                    done: n.done
                  };
                }

                "throw" === l.type && (i = "completed", n.method = "throw", n.arg = l.arg);
              }
            };
          }(e, n, a), o;
        }

        function m(e, t, n) {
          try {
            return {
              type: "normal",
              arg: e.call(t, n)
            };
          } catch (e) {
            return {
              type: "throw",
              arg: e
            };
          }
        }

        function y() {}

        function _() {}

        function v() {}

        function b(e) {
          ["next", "throw", "return"].forEach(function (t) {
            e[t] = function (e) {
              return this._invoke(t, e);
            };
          });
        }

        function w(e) {
          var t;

          this._invoke = function (n, r) {
            function o() {
              return new Promise(function (t, o) {
                !function t(n, r, o, a) {
                  var s = m(e[n], e, r);

                  if ("throw" !== s.type) {
                    var l = s.arg,
                        u = l.value;
                    return u && "object" == typeof u && i.call(u, "__await") ? Promise.resolve(u.__await).then(function (e) {
                      t("next", e, o, a);
                    }, function (e) {
                      t("throw", e, o, a);
                    }) : Promise.resolve(u).then(function (e) {
                      l.value = e, o(l);
                    }, a);
                  }

                  a(s.arg);
                }(n, r, t, o);
              });
            }

            return t = t ? t.then(o, o) : o();
          };
        }

        function x(e, t) {
          var n = e.iterator[t.method];

          if (void 0 === n) {
            if (t.delegate = null, "throw" === t.method) {
              if (e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method)) return c;
              t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return c;
          }

          var i = m(n, e.iterator, t.arg);
          if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, c;
          var r = i.arg;
          return r ? r.done ? (t[e.resultName] = r.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, c) : r : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, c);
        }

        function k(e) {
          var t = {
            tryLoc: e[0]
          };
          1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
        }

        function T(e) {
          var t = e.completion || {};
          t.type = "normal", delete t.arg, e.completion = t;
        }

        function S(e) {
          this.tryEntries = [{
            tryLoc: "root"
          }], e.forEach(k, this), this.reset(!0);
        }

        function C(e) {
          if (e) {
            var t = e[o];
            if (t) return t.call(e);
            if ("function" == typeof e.next) return e;

            if (!isNaN(e.length)) {
              var n = -1,
                  r = function t() {
                for (; ++n < e.length;) {
                  if (i.call(e, n)) return t.value = e[n], t.done = !1, t;
                }

                return t.value = void 0, t.done = !0, t;
              };

              return r.next = r;
            }
          }

          return {
            next: E
          };
        }

        function E() {
          return {
            value: void 0,
            done: !0
          };
        }
      }(function () {
        return this;
      }() || Function("return this")());
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return x;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(92)),
          g = n(79),
          m = n(52),
          y = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function b(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var w = h.Math.Rectangle,
          x = function (e) {
        function t() {
          return v(this, t), b(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "_calculateLayoutElements",
          value: function value() {
            if (this.getWords().size() <= 0) return [];
            var e = this.serializeOptions(),
                n = e.orientation,
                i = e.width,
                r = e.size,
                o = e.relativeRowOffset,
                a = e.attributes.fontIdentifier,
                s = this.getWords().joined(3),
                l = n === t.Orientations.Left ? [s[0], s[1], s[2]] : [s[1], s[2], s[0]],
                u = h.Utils.Array.range(0, 2).map(function (e) {
              return new g.a({
                text: l[e],
                fontIdentifier: a,
                fontSize: 60
              });
            }),
                c = u.map(function (e) {
              return e.getSizeValue();
            }),
                p = c[0].width > c[1].width ? 0 : 1,
                f = (p + 1) % 2;
            u[f].fitWidth(c[p].width), c[f] = u[f].getSizeValue();
            var d = (c[f].height + c[p].height) / (1 - o),
                y = new g.a({
              text: l[2],
              fontIdentifier: a
            });
            y.fitHeight(d);
            var _ = y.getSizeValue().width,
                v = c[p].width,
                b = i / (_ + v),
                x = b * _,
                k = b * v,
                T = b * d,
                S = o * T;
            r.set(i, T);
            var C = h.Utils.Array.range(0, 3).map(function (e) {
              return new g.a({
                text: l[e],
                fontIdentifier: a
              });
            });
            C[0].fitWidth(k), C[1].fitWidth(k), C[2].fitWidth(x);
            var E = n === t.Orientations.Left ? 0 : x,
                O = [E, E, n === t.Orientations.Left ? k : 0],
                R = [0, C[0].getSizeValue().height + S, 0],
                I = C.map(function (e, t) {
              return new w(O[t], R[t], e.getSizeValue().width, e.getSizeValue().height);
            });
            return C.map(function (e, t) {
              return new m.a({
                text: l[t],
                font: C[t],
                frame: I[t]
              });
            });
          }
        }]), t;
      }(d.a);

      x.Orientations = {
        Right: "RIGHT",
        Left: "LEFT"
      }, x.prototype.availableOptions = y({}, d.a.prototype.availableOptions, {
        orientation: {
          type: h.OptionType.STRING,
          default: x.Orientations.Left,
          available: [x.Orientations.Right, x.Orientations.Left]
        },
        relativeRowOffset: {
          type: h.OptionType.NUMBER,
          default: .05
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return k;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(76)),
          y = n(26),
          _ = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          b = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function w(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var k = function (e) {
        function t() {
          var e;
          w(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = x(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          return o._exclusiveFont = null, o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "generateLayoutData",
          value: function value(e, n) {
            return this._exclusiveFont = this._fontRandomizer.pickNext(this.getFontIdentifiers()), b(t.prototype.__proto__ || d()(t.prototype), "generateLayoutData", this).call(this, e, n);
          }
        }, {
          key: "_fontForRow",
          value: function value(e, n) {
            return this._exclusiveFont || b(t.prototype.__proto__ || d()(t.prototype), "_fontForRow", this).call(this, e, n);
          }
        }, {
          key: "_layoutRow",
          value: function value(e, t, n, i) {
            return new y.a({
              words: e,
              width: t,
              attributes: n
            });
          }
        }]), t;
      }(m.a);

      k.defaultFontIdentifiers = ["imgly_font_ostrich_sans_heavy", "imgly_font_ostrich_sans_bold", "imgly_font_ostrich_sans_black"], k.identifier = "imgly_text_design_blocks_condensed", k.prototype.availableOptions = _({}, m.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: k.defaultFontIdentifiers
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return w;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(179)),
          g = n(78),
          m = n(26),
          y = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          _ = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function v(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function b(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var w = function (e) {
        function t() {
          return v(this, t), b(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), _(t, [{
          key: "_layoutRows",
          value: function value(e, t) {
            var n = this;
            return e.map(function (e, i) {
              return n._randomLayoutRow(e, i, t, new g.a({
                fontIdentifier: n._fontForRow(i, e)
              })).layout();
            });
          }
        }, {
          key: "_layoutRow",
          value: function value(e, t, n, i) {
            return new m.a({
              words: e,
              width: t,
              attributes: n
            });
          }
        }]), t;
      }(d.a);

      w.defaultFontIdentifiers = ["imgly_font_summer_font_light"], w.identifier = "imgly_text_design_blocks_light-v3_1_0", w.prototype.availableOptions = y({}, d.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: h.OptionType.ARRAY,
          default: w.defaultFontIdentifiers
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return O;
      });

      var i = n(6),
          r = n.n(i),
          o = n(15),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(5),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = (n.n(y), n(76), n(26), n(123), n(47), n(125), n(181)),
          v = n(126),
          b = n(27),
          w = n(20),
          x = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          k = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          T = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = c()(t, n);

        if (void 0 === r) {
          var o = m()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function S(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return a()(e);
      }

      function C(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function E(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var O = function (e) {
        function t() {
          var e;
          C(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = E(this, (e = t.__proto__ || m()(t)).call.apply(e, [this].concat(i)));
          return o.getImagePaths = function () {
            var e = o.getBanderoles();
            return [].concat(S(e && e.map(function (e) {
              return e.getImagePath();
            }) || []), S(o._celebrateTypes));
          }, o.onImagesLoaded = function () {
            var e = o.getBanderoles();
            e && e.forEach(function (e) {
              var t = b.a.getImage(e.getImagePath());
              t ? e.setImage(t) : y.Log.warn("TextDesignBlocks#onImagesLoaded: Image not found '" + e.getImagePath() + "'");
            });
          }, o._celebrateTypes = [v.a.RowImages.celebrate1, v.a.RowImages.celebrate2, v.a.RowImages.celebrate3], o._exclusiveFont = null, o._typeRandomizer = new w.a(0), o._useMaskedRandomizer = new w.a(0), o._seedPool.push(o._typeRandomizer), o._seedPool.push(o._useMaskedRandomizer), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), k(t, [{
          key: "_fontForRow",
          value: function value(e, t) {
            var n = this.getFontIdentifiers();
            return n[e % (n.length - 1)];
          }
        }, {
          key: "_layoutRows",
          value: function value(e, n) {
            var i = this._typeRandomizer.pickNext(this._celebrateTypes),
                r = b.a.getImage(i);

            r || y.Log.warn("TextDesignCelebrateSimple#_layoutRows: Image not fount '" + i + "'");
            var o = new v.a({
              width: n,
              height: .5 * n,
              drawingModeAspectFit: !0,
              image: r
            }).layout(),
                a = T(t.prototype.__proto__ || m()(t.prototype), "_layoutRows", this).call(this, e, n);
            return [o].concat(S(a));
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, n, i, r) {
            var o = e.countNumberOfCharacters();
            o < 4 && r.setFontIdentifier("imgly_font_rasa_regular");

            var a = this._useMaskedRandomizer.nextBool(2, 1);

            return o < 13 && a && !this.getHasMaskedText() ? this._layoutRow(e, i, r, !0) : T(t.prototype.__proto__ || m()(t.prototype), "_randomLayoutRow", this).call(this, e, n, i, r);
          }
        }]), t;
      }(_.a);

      O.identifier = "imgly_text_design_celebrate_simple", O.defaultFontIdentifiers = ["imgly_font_amberlight", "imgly_font_rasa_regular", "imgly_font_rasa_500"], O.prototype.availableOptions = x({}, _.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: y.OptionType.ARRAY,
          default: O.defaultFontIdentifiers
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return v;
      });

      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(183)),
          h = n(27),
          d = n(48),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = p.Math.Rectangle,
          v = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "getImagePaths",
          value: function value() {
            var e = this._options;
            return [e.topImagePath, e.bottomImagePath, e.leftImagePath, e.rightImagePath].filter(function (e) {
              return "" !== e;
            });
          }
        }, {
          key: "render",
          value: function value(e, t, n, i, r) {
            var o = n.clone().scale(t.width),
                a = t.rectangle(0, 0),
                s = h.a.getImage(this.getTopImagePath()),
                l = h.a.getImage(this.getLeftImagePath()),
                u = h.a.getImage(this.getRightImagePath()),
                c = h.a.getImage(this.getBottomImagePath());

            if (s) {
              var p = s.width / s.height,
                  f = o.top * this.getTopImageFillRate(),
                  g = f * p,
                  m = a.width / 2,
                  y = new _(m - g / 2, 0, g, f);
              Object(d.a)(e, s, y, i);
            }

            if (c) {
              var v = c.width / c.height,
                  b = o.bottom * this.getBottomImageFillRate(),
                  w = b * v,
                  x = a.width / 2,
                  k = new _(x - w / 2, a.height - b, w, b);
              Object(d.a)(e, c, k, i);
            }

            if (l) {
              var T = l.width / l.height,
                  S = o.left * this.getLeftImageFillRate(),
                  C = S / T,
                  E = a.height / 2,
                  O = new _(0, E - C / 2, S, C);
              Object(d.a)(e, l, O, i);
            }

            if (u) {
              var R = u.width / u.height,
                  I = o.right * this.getRightImageFillRate(),
                  A = I / R,
                  M = a.height / 2 - A / 2,
                  F = new _(a.width - I, M, I, A);
              Object(d.a)(e, u, F, i);
            }
          }
        }]), t;
      }(f.a);

      v.prototype.availableOptions = {
        topImagePath: {
          type: p.OptionType.STRING,
          default: ""
        },
        leftImagePath: {
          type: p.OptionType.STRING,
          default: ""
        },
        bottomImagePath: {
          type: p.OptionType.STRING,
          default: ""
        },
        rightImagePath: {
          type: p.OptionType.STRING,
          default: ""
        },
        topImageFillRate: {
          type: p.OptionType.NUMBER,
          default: 1
        },
        leftImageFillRate: {
          type: p.OptionType.NUMBER,
          default: 1
        },
        bottomImageFillRate: {
          type: p.OptionType.NUMBER,
          default: 1
        },
        rightImageFillRate: {
          type: p.OptionType.NUMBER,
          default: 1
        }
      }, v.Backgrounds = [new v({
        topImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background1_1.png",
        leftImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background1_2.png",
        rightImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background1_2.png",
        bottomImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background1_3.png",
        topImageFillRate: .8,
        leftImageFillRate: .6,
        rightImageFillRate: .6,
        bottomImageFillRate: .8
      }), new v({
        leftImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background2_1.png",
        rightImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background2_1.png",
        bottomImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background2_2.png",
        leftImageFillRate: .6,
        rightImageFillRate: .6,
        bottomImageFillRate: .6
      }), new v({
        topImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background3_1.png",
        bottomImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background3_2.png",
        topImageFillRate: .6,
        bottomImageFillRate: .6
      }), new v({
        topImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background4_1.png",
        leftImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background4_3.png",
        rightImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background4_3.png",
        bottomImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background4_2.png",
        topImageFillRate: .1,
        leftImageFillRate: .6,
        rightImageFillRate: .6,
        bottomImageFillRate: .6
      })];
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return b;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(182)),
          g = n(21),
          m = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          y = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = function (e) {
        function t() {
          var e;

          _(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = v(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._relativeInsets = new g.a(), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), y(t, [{
          key: "_getBackground",
          value: function value() {
            return null;
          }
        }]), t;
      }(d.a);

      b.defaultFontIdentifiers = ["imgly_font_ultra"], b.identifier = "imgly_text_design_equal_width_fat", b.prototype.availableOptions = m({}, d.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: h.OptionType.ARRAY,
          default: b.defaultFontIdentifiers
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return k;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(27)),
          y = n(178),
          _ = n(33),
          v = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          b = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          w = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = l()(t, n);

        if (void 0 === r) {
          var o = d()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      },
          x = g.Math.Vector2,
          k = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || d()(t)).call(this, e));

          return n._textOptions = {}, n._createCanvas(), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), b(t, [{
          key: "_createCanvas",
          value: function value() {
            this._canvas = g.Utils.createCanvas(), this._context = this._canvas.getContext("2d"), this._textSplitter = new y.a(this._context), this._finalCanvas = g.Utils.createCanvas(), this._finalContext = this._finalCanvas.getContext("2d"), this.updateFontVariation();
          }
        }, {
          key: "setOption",
          value: function value(e, n) {
            var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            w(t.prototype.__proto__ || d()(t.prototype), "setOption", this).call(this, e, n, i, r), "fontIdentifier" !== e || r || this.updateFontVariation();
          }
        }, {
          key: "updateFontVariation",
          value: function value() {
            var e = m.a.getVariation(this.getFontIdentifier());
            return e || g.Log.warn("TextDesignFont: Unable to find font '" + this._fontIdentifier + "'"), this.setFontVariation(e), e;
          }
        }, {
          key: "_applyTextOptions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._context,
                n = v({}, this._options, e),
                i = n.fontSize,
                r = n.fontVariation,
                o = (n.lineHeight, n.textColor),
                a = n.alignment,
                s = r.serializeOptions(),
                l = s.fontStyle,
                u = s.fontWeight,
                c = s.fontFamily;
            t.font = l + " " + u + " " + i + 'px "' + c + '"', t.fillStyle = o, t.textBaseline = "top", t.textAlign = a || "left";
          }
        }, {
          key: "_buildOutputLines",
          value: function value(e) {
            return this._textSplitter.setText(this.getText()), this._textSplitter.setMaxWidth(e), this._textSplitter.getLines();
          }
        }, {
          key: "_renderTextLine",
          value: function value(e, t) {
            var n = this.getAlignment(),
                i = new x(0, t);

            switch (n) {
              case "center":
                i.x = this._canvas.width / 2;
                break;

              case "right":
                i.x = this._canvas.width;
            }

            this._context.fillText(e, i.x, i.y);
          }
        }, {
          key: "update",
          value: function value() {
            var e = this.calculateFontStyles();

            if (e) {
              var t = this._calculateText(e),
                  n = t.dimensions,
                  i = t.lines;

              this._dimensions = n, this._renderText(n, i, e);
            }
          }
        }, {
          key: "draw",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
            this.update(), e.drawImage(this._canvas, t, n, this._dimensions.x, this._dimensions.y);
          }
        }, {
          key: "_renderText",
          value: function value(e, t, n) {
            this._canvas.width = e.x, this._canvas.height = e.y, this._context = this._canvas.getContext("2d"), this._applyTextOptions(n, this._context);

            for (var i = 0; i < t.length; i++) {
              var r = t[i];

              this._renderTextLine(r, n.topPadding + n.lineHeight * i);
            }
          }
        }, {
          key: "getFontFamily",
          value: function value() {
            return this.getFontVariation().getFontFamily();
          }
        }, {
          key: "calculateFontStyles",
          value: function value() {
            var e = this.getFontFamily(),
                t = this.getFontSize(),
                n = this.getAbsoluteTextHeight(),
                i = {
              fontFamily: e,
              fontSize: t,
              textHeight: n,
              lineHeight: n * this.getLineHeight(),
              topPadding: n * (this.getLineHeight() - 1) / 2
            };
            return this._textOptions = v({}, i), i;
          }
        }, {
          key: "getTextMetrics",
          value: function value() {
            return this.getFontVariation().getTextMetrics();
          }
        }, {
          key: "getAbsoluteTextHeight",
          value: function value() {
            var e = this.getFontSize(),
                t = this.getTextMetrics();

            if (t) {
              var n = 1 / t.unitsPerEm * e,
                  i = t.ascender * n,
                  r = t.descender * n;
              return i + Math.abs(r);
            }

            return e * this.getLineHeight() * 1.1;
          }
        }, {
          key: "_calculateText",
          value: function value(e) {
            this._applyTextOptions(e, this._context);

            for (var t = new x(), n = this.getText().split("\n"), i = 0; i < n.length; i++) {
              var r = n[i];
              t.x = Math.max(t.x, this._context.measureText(r).width);
            }

            var o = e.lineHeight;
            return t.y = n.length * o, {
              dimensions: t,
              lines: n
            };
          }
        }, {
          key: "getDimensions",
          value: function value() {
            var e = this.calculateFontStyles();
            return this._calculateText(e).dimensions;
          }
        }, {
          key: "fitMaxHeight",
          value: function value() {
            this.update();
            var e = this.getDimensions();
            this.getText().split("\n"), this.getMaxHeight(), e.y;
          }
        }, {
          key: "fitMaxWidth",
          value: function value() {
            var e = this.getDimensions().x,
                t = this.getMaxWidth() / e;
            this.setFontSize(this.getFontSize() * t), this._textOptions.fontSize = this.getFontSize();
          }
        }, {
          key: "fitInFrame",
          value: function value(e) {
            this.setMaxWidth(e.width), this.setMaxHeight(e.height), this.fitMaxWidth(), this.fitMaxHeight();
          }
        }, {
          key: "getSize",
          value: function value() {
            var e = this.getDimensions();
            return new _.a(e.x, e.y);
          }
        }]), t;
      }(g.Configurable);

      k.prototype.availableOptions = {
        text: {
          type: g.OptionType.STRING,
          default: ""
        },
        fontIdentifier: {
          type: g.OptionType.STRING,
          default: "imgly_font_open_sans_bold"
        },
        fontVariation: {
          type: g.OptionType.OBJECT,
          default: null
        },
        lineHeight: {
          type: g.OptionType.NUMBER,
          default: 1
        },
        fontSize: {
          type: g.OptionType.NUMBER,
          default: 22
        },
        textColor: {
          type: g.OptionType.STRING,
          default: "black"
        },
        strokeStyle: {
          type: g.OptionType.STRING,
          default: "black"
        },
        outlineWidth: {
          type: g.OptionType.NUMBER,
          default: 0
        },
        textBaseline: {
          type: g.OptionType.STRING,
          default: "alphabetic"
        },
        excludeAccents: {
          type: g.OptionType.BOOLEAN,
          default: !0
        },
        maxWidth: {
          type: g.OptionType.NUMBER,
          default: 100
        },
        maxHeight: {
          type: g.OptionType.NUMBER,
          default: 0
        },
        alignment: {
          type: g.OptionType.STRING,
          default: "left",
          available: ["left", "center", "right"]
        }
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return k;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(81)),
          y = n(53),
          _ = n(20),
          v = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          b = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function w(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function x(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var k = function (e) {
        function t() {
          var e;
          w(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = x(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          return o._possibleRowTypes = [m.a.Badge1, m.a.Badge2, m.a.Badge3, m.a.Badge4], o._rowTypesRandomizer = new _.a(0), o._isMaskedRandomizer = new _.a(0), o._seedPool.push(o._rowTypesRandomizer), o._seedPool.push(o._isMaskedRandomizer), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), b(t, [{
          key: "getImagePaths",
          value: function value() {
            return this._possibleRowTypes.map(function (e) {
              return e.getImagePath();
            });
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, n, i, r) {
            this._rowType = this._rowTypesRandomizer.pickNext(this._possibleRowTypes), r.setLineSpacing(.9);

            var o = function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = l()(t, n);

              if (void 0 === r) {
                var o = d()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var a = r.get;
              return void 0 !== a ? a.call(i) : void 0;
            }(t.prototype.__proto__ || d()(t.prototype), "_randomLayoutRow", this).call(this, e, n, i, r);

            return o.set({
              textScaleFactor: .9
            }), o;
          }
        }]), t;
      }(y.a);

      k.defaultFontIdentifiers = ["imgly_font_campton_bold"], k.identifier = "imgly_text_design_masked_badge", k.ValidAlignments = [y.a.Alignment.Center], k.prototype.availableOptions = v({}, y.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: k.defaultFontIdentifiers
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return b;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(81)),
          g = (n(53), n(128)),
          m = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          y = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function v(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var b = function (e) {
        function t() {
          var e;

          _(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = v(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._possibleRowTypes = [d.a.SpeechBubble2, d.a.SpeechBubble4, d.a.SpeechBubble2, d.a.SpeechBubble4, d.a.SpeechBubble5], o._possibleRowTypesForMin15 = o._possibleRowTypes.slice(0, 2), o._possibleRowTypesForMax14 = o._possibleRowTypes.slice(2), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), y(t, [{
          key: "_rowTypes",
          value: function value(e) {
            return e.countNumberOfCharacters() < 15 ? this._possibleRowTypesForMax14 : this._possibleRowTypesForMin15;
          }
        }]), t;
      }(g.a);

      b.defaultFontIdentifiers = ["imgly_font_gagalin_regular"], b.identifier = "imgly_text_design_masked_speech_bubble_comic", b.prototype.availableOptions = m({}, g.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: h.OptionType.ARRAY,
          default: b.defaultFontIdentifiers
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return x;
      });

      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(53)),
          y = n(127),
          _ = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = function (e) {
        function t() {
          return b(this, t), w(this, (t.__proto__ || d()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_modifiedText",
          value: function value(e) {
            return function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = l()(t, n);

              if (void 0 === r) {
                var o = d()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var a = r.get;
              return void 0 !== a ? a.call(i) : void 0;
            }(t.prototype.__proto__ || d()(t.prototype), "_modifiedText", this).call(this, e).toUpperCase();
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, t, n, i) {
            var r = this._alignmentRandomizer.pickNext(m.a.ValidAlignments);

            return i.setAlignment(r), new y.a({
              words: e,
              width: n,
              attributes: i,
              image: null,
              backgroundColor: g.Color.WHITE,
              centerOffset: 0,
              sizeToFitContent: !0,
              isMasked: !1,
              autoAdjustTextColor: !1
            });
          }
        }]), t;
      }(m.a);

      x.defaultFontIdentifiers = ["imgly_font_abril_fatface_regular"], x.identifier = "imgly_text_design_multiline", x.prototype.availableOptions = _({}, m.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: x.defaultFontIdentifiers
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return _;
      });

      var i = n(6),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), n(81)),
          h = n(53),
          d = n(128),
          g = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      };

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = y(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._possibleRowTypes = [f.a.Watercolor1, f.a.Watercolor2, f.a.Watercolor3], o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(d.a);

      _.defaultFontIdentifiers = ["imgly_font_permanent_marker", "imgly_font_wolesbro", "imgly_font_wolesbro"], _.identifier = "imgly_text_design_watercolor", _.prototype.availableOptions = g({}, d.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: p.OptionType.ARRAY,
          default: _.defaultFontIdentifiers
        },
        alignment: {
          type: p.OptionType.STRING,
          default: h.a.Alignment.Center,
          available: h.a.ValidAlignments
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return x;
      });

      var i = n(15),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(5),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(129),
          m = n(27),
          y = n(21),
          _ = n(126),
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = function (e) {
        function t() {
          var e;
          b(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = w(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          return o._relativeInsets = new y.a(0, .3, 0, .3), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_layoutRows",
          value: function value(e, n) {
            var i = function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = l()(t, n);

              if (void 0 === r) {
                var o = d()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var a = r.get;
              return void 0 !== a ? a.call(i) : void 0;
            }(t.prototype.__proto__ || d()(t.prototype), "_layoutRows", this).call(this, e, n);

            if (!this.getDecorationsVisible()) return i;
            var o = new _.a({
              width: n,
              height: 25,
              image: m.a.getImage(this._rowTypeRandomizer.pickNext(g.a.RowImages))
            }).layout(),
                a = new _.a({
              width: n,
              height: 25,
              image: m.a.getImage(this._rowTypeRandomizer.pickNext(g.a.RowImages))
            }).layout();
            return [o].concat(function (e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = Array(e.length); t < e.length; t++) {
                  n[t] = e[t];
                }

                return n;
              }

              return r()(e);
            }(i), [a]);
          }
        }]), t;
      }(g.a);

      x.identifier = "imgly_text_design_sunshine-v3_1_0";
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return O;
      });

      var i = n(6),
          r = n.n(i),
          o = n(15),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(1),
          d = n.n(h),
          g = n(4),
          m = (n.n(g), n(27)),
          y = n(21),
          _ = n(129),
          v = n(445),
          b = n(447),
          w = n(448),
          x = n(20),
          k = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          T = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function S(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return a()(e);
      }

      function C(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function E(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var O = function (e) {
        function t() {
          var e;
          C(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = E(this, (e = t.__proto__ || d()(t)).call.apply(e, [this].concat(i)));
          return o._relativeInsets = new y.a(.3, .3, .3, .3), o._backgroundRandomizer = new x.a(0), o._decoTypeRandomizer = new x.a(0), o._seedPool.push(o._backgroundRandomizer), o._seedPool.push(o._decoTypeRandomizer), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), T(t, [{
          key: "getImagePaths",
          value: function value() {
            return [].concat(S(_.a.RowImages), S(g.Utils.Array.flatten(t.Backgrounds.map(function (e) {
              return e.getImagePaths();
            }))), S(t.DecoratorImages));
          }
        }, {
          key: "_getBackground",
          value: function value() {
            return this._backgroundRandomizer.pickNext(t.Backgrounds);
          }
        }, {
          key: "_randomDecoratorImages",
          value: function value() {
            switch (this._decoTypeRandomizer.nextInRange(0, 2)) {
              case 0:
                return t.DecoratorImages.slice(0, 2).map(function (e) {
                  return m.a.getImage(e);
                });

              case 1:
              case 2:
                return t.DecoratorImages.slice(2).map(function (e) {
                  return m.a.getImage(e);
                });

              default:
                return g.Log.warn("TextDesignParticles#_randomDecoratorImages: Number generated not in valid range."), t.DecoratorImages.slice(2).map(function (e) {
                  return m.a.getImage(e);
                });
            }
          }
        }]), t;
      }(_.a);

      O.defaultFontIdentifiers = ["imgly_font_permanent_marker", "imgly_font_wolesbro", "imgly_font_wolesbro", "imgly_font_montserrat_light"], O.identifier = "imgly_text_design_particles", O.Backgrounds = [new v.a(), new b.a(), new w.a()], O.DecoratorImages = ["text-design/images/imgly_text_design_particle_holder_01.png", "text-design/images/imgly_text_design_particle_holder_02.png", "text-design/images/imgly_text_design_particle_holder_03.png", "text-design/images/imgly_text_design_particle_holder_04.png"], O.prototype.availableOptions = k({}, _.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: g.OptionType.ARRAY,
          default: O.defaultFontIdentifiers
        },
        decorationsVisible: {
          type: g.OptionType.BOOLEAN,
          default: !1
        },
        decorativeRowsInTheMiddleOnly: {
          type: g.OptionType.BOOLEAN,
          default: !0
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return _;
      });

      var i = n(15),
          r = n.n(i),
          o = n(6),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(130)),
          g = a.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      };

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(d.a);

      _.Images = ["text-design/images/imgly_text_design_particle_brush_01.png", "text-design/images/imgly_text_design_particle_brush_02.png", "text-design/images/imgly_text_design_particle_brush_03.png", "text-design/images/imgly_text_design_particle_brush_04.png", "text-design/images/imgly_text_design_particle_brush_05.png", "text-design/images/imgly_text_design_particle_brush_06.png", "text-design/images/imgly_text_design_particle_brush_07.png", "text-design/images/imgly_text_design_particle_brush_08.png", "text-design/images/imgly_text_design_particle_brush_09.png", "text-design/images/imgly_text_design_particle_brush_10.png"], _.prototype.availableOptions = g({}, d.a.prototype.availableOptions, {
        imagePaths: {
          type: h.OptionType.ARRAY,
          default: [].concat(function (e) {
            if (Array.isArray(e)) {
              for (var t = 0, n = Array(e.length); t < e.length; t++) {
                n[t] = e[t];
              }

              return n;
            }

            return r()(e);
          }(_.Images))
        },
        relativeParticleSize: {
          type: h.OptionType.NUMBER,
          default: .12
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return m;
      });
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = (n.n(p), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = p.Math.Rectangle,
          m = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "getContentFrame",
          value: function value() {
            var e = this.getFrame().clone(),
                t = .1 * e.width;
            return e.insetBy(t, t);
          }
        }, {
          key: "intersects",
          value: function value(e) {
            return this.getFrame().intersects(e.getFrame());
          }
        }]), t;
      }(p.Configurable);

      m.prototype.availableOptions = {
        frame: {
          type: p.OptionType.OBJECT,
          default: new g()
        }
      };
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return _;
      });

      var i = n(15),
          r = n.n(i),
          o = n(6),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(130)),
          g = a.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      };

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(d.a);

      _.Images = ["text-design/images/imgly_text_design_particle_circle_01.png", "text-design/images/imgly_text_design_particle_circle_02.png", "text-design/images/imgly_text_design_particle_circle_03.png", "text-design/images/imgly_text_design_particle_circle_04.png", "text-design/images/imgly_text_design_particle_circle_05.png", "text-design/images/imgly_text_design_particle_circle_06.png", "text-design/images/imgly_text_design_particle_circle_07.png", "text-design/images/imgly_text_design_particle_circle_08.png", "text-design/images/imgly_text_design_particle_circle_09.png", "text-design/images/imgly_text_design_particle_circle_10.png"], _.prototype.availableOptions = g({}, d.a.prototype.availableOptions, {
        imagePaths: {
          type: h.OptionType.ARRAY,
          default: [].concat(function (e) {
            if (Array.isArray(e)) {
              for (var t = 0, n = Array(e.length); t < e.length; t++) {
                n[t] = e[t];
              }

              return n;
            }

            return r()(e);
          }(_.Images))
        },
        relativeParticleSize: {
          type: h.OptionType.NUMBER,
          default: .12
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return _;
      });

      var i = n(15),
          r = n.n(i),
          o = n(6),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = (n.n(h), n(130)),
          g = a.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      };

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(d.a);

      _.Images = ["text-design/images/imgly_text_design_particle_triangle_01.png", "text-design/images/imgly_text_design_particle_triangle_02.png", "text-design/images/imgly_text_design_particle_triangle_03.png", "text-design/images/imgly_text_design_particle_triangle_04.png", "text-design/images/imgly_text_design_particle_triangle_05.png", "text-design/images/imgly_text_design_particle_triangle_06.png", "text-design/images/imgly_text_design_particle_triangle_07.png", "text-design/images/imgly_text_design_particle_triangle_08.png", "text-design/images/imgly_text_design_particle_triangle_09.png", "text-design/images/imgly_text_design_particle_triangle_10.png"], _.prototype.availableOptions = g({}, d.a.prototype.availableOptions, {
        imagePaths: {
          type: h.OptionType.ARRAY,
          default: [].concat(function (e) {
            if (Array.isArray(e)) {
              for (var t = 0, n = Array(e.length); t < e.length; t++) {
                n[t] = e[t];
              }

              return n;
            }

            return r()(e);
          }(_.Images))
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return E;
      });

      var i = n(6),
          r = n.n(i),
          o = n(15),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(5),
          c = n.n(u),
          p = n(2),
          f = n.n(p),
          h = n(3),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = (n.n(y), n(77)),
          v = n(21),
          b = n(180),
          w = n(20),
          x = r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      },
          k = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          T = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = c()(t, n);

        if (void 0 === r) {
          var o = m()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var a = r.get;
        return void 0 !== a ? a.call(i) : void 0;
      };

      function S(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function C(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var E = function (e) {
        function t() {
          var e;
          S(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = C(this, (e = t.__proto__ || m()(t)).call.apply(e, [this].concat(i)));
          return o._relativeInsets = new v.a(.1, 0, 0, 0), o._rowTypeRandomizer = new w.a(0), o._seedPool.push(o._rowTypeRandomizer), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = d()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (f.a ? f()(e, t) : e.__proto__ = t);
        }(t, e), k(t, [{
          key: "_modifiedText",
          value: function value(e) {
            return T(t.prototype.__proto__ || m()(t.prototype), "_modifiedText", this).call(this, e).toUpperCase();
          }
        }, {
          key: "_randomLayoutRow",
          value: function value(e, n, i, r) {
            var o = T(t.prototype.__proto__ || m()(t.prototype), "_randomLayoutRow", this).call(this, e, n, i, r);
            return o.setShearingAngle(this.getShearingAngle()), o;
          }
        }, {
          key: "_layoutRows",
          value: function value(e, n) {
            var i = T(t.prototype.__proto__ || m()(t.prototype), "_layoutRows", this).call(this, e, n),
                r = y.Utils.values(b.a.FormType),
                o = new b.a({
              width: n,
              height: 30,
              type: this._rowTypeRandomizer.pickNext(r),
              shearingAngle: this.getShearingAngle()
            }).layout(),
                s = new b.a({
              width: n,
              height: 30,
              type: this._rowTypeRandomizer.pickNext(r),
              shearingAngle: this.getShearingAngle()
            }).layout();
            return [o].concat(function (e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = Array(e.length); t < e.length; t++) {
                  n[t] = e[t];
                }

                return n;
              }

              return a()(e);
            }(i), [s]);
          }
        }]), t;
      }(_.a);

      E.defaultFontIdentifiers = ["imgly_font_campton_bold"], E.identifier = "imgly_text_design_rotated", E.prototype.availableOptions = x({}, _.a.prototype.availableOptions, {
        fontIdentifiers: {
          type: y.OptionType.ARRAY,
          default: E.defaultFontIdentifiers
        },
        relativeLineSpacing: {
          type: y.OptionType.NUMBER,
          default: .025 / 3
        },
        shearingAngle: {
          type: y.OptionType.NUMBER,
          default: -.1
        }
      });
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return h;
      });

      var i = n(0),
          r = n.n(i),
          o = n(4),
          a = (n.n(o), n(33)),
          s = n(124),
          l = n(48),
          u = n(20),
          c = n(127),
          p = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          f = o.Math.Rectangle,
          h = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._layoutData = null, this._layout = null, this._text = "", this._seed = 0, this._debugMode = !1, this.randomizer = new u.a();
        }

        return p(e, [{
          key: "createLayout",
          value: function value(e, t, n) {
            this._layout = e, this._text = t, this._seed = n, e.seed(n), this._layoutData = e.generateLayoutData(t, 1e3);
          }
        }, {
          key: "calculateAspect",
          value: function value() {
            return this._layoutData ? this._layoutData.getSize().aspect() : (o.Log.warn("TextDesignRenderer#calculateAspect: No layout data"), 1);
          }
        }, {
          key: "draw",
          value: function value(e, t, n, i) {
            var r = this,
                u = this._layoutData;

            if (this._layoutData) {
              var p = new a.a(1e3, 1e3 / t.aspect()),
                  h = t.width / 1e3,
                  d = u.getRelativeInsets().clone().scale(p.width),
                  g = u.getRelativeLineSpacing() * p.width,
                  m = d.top;
              e.save(), this.randomizer.seed(this._seed);
              var y = u.getBackground();
              y && y.render(e, t, u.getRelativeInsets(), i ? o.Color.WHITE : n, this.randomizer), e.scale(h, h), u.getRows().forEach(function (t) {
                e.save();
                var a = t.getAttributes();

                if (e.transform(1, t.getShearingAngle(), 0, 1, d.left, m), a.setTextColor(i ? o.Color.WHITE : n.clone()), a.setTintColor(i ? o.Color.WHITE : n.clone()), (t instanceof s.a || t instanceof c.a) && (t.setBackgroundColor(i ? o.Color.WHITE : n.clone()), t.setIsUsedInInvertedLayout(i)), r._debugMode && (t._debugMode = !0), t.willRender(e), t.render(e), t.didRender(e), r._debugMode) {
                  var u = t._getFrame(),
                      p = t._getTextFrame();

                  Object(l.f)(e, u, o.Color.GREEN), Object(l.f)(e, p, o.Color.BLUE), t._getLayoutElements().forEach(function (n) {
                    var i = n.getFrame(),
                        r = t._getTextFrameForElement(n);

                    Object(l.f)(e, i, new o.Color(1, 1, 0)), Object(l.f)(e, r, new o.Color(0, 1, 1));
                  });
                }

                m += t.getSize().height + g, e.restore();
              }), this._debugMode && Object(l.f)(e, new f(0, 0, p.width, p.height), o.Color.RED), e.restore();
            }
          }
        }]), e;
      }();
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = n.n(p),
          h = n(452),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function g(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function m(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var y = p.Math.Vector2,
          _ = function (e) {
        function t() {
          return g(this, t), m(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "_render",
          value: function value(e) {
            this._sprite.setRotation(0);

            var t = e.getDimensions(),
                n = this._options,
                i = n.start,
                r = n.end,
                o = n.rotation,
                a = n.textureScale,
                s = r.clone().subtract(i).clone().divide(2),
                l = i.clone().add(s),
                u = this.calculateScale() * a,
                c = t.clone().multiply(u).multiply(s);
            return this._sprite.setAnchor(l), this._sprite.setRotation(o), this._sprite.setScale(u, u), this._sprite.setPosition(c), this._renderTexture.render(this._container), p.Promise.resolve();
          }
        }, {
          key: "calculateScale",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._options.rotation,
                t = this.getInputDimensions(!1),
                n = new y(Math.abs(t.x * Math.cos(e)) + Math.abs(t.y * Math.sin(e)), Math.abs(t.x * Math.sin(e)) + Math.abs(t.y * Math.cos(e))),
                i = t.clone().subtract(n.clone()).divide(2).abs();
            return i.y > i.x ? 2 * i.y / t.y + 1 : 2 * i.x / t.x + 1;
          }
        }, {
          key: "getNewDimensions",
          value: function value(e) {
            var t = this._options,
                n = t.start,
                i = t.end,
                r = t.textureScale,
                o = this.calculateScale();
            return e.clone().multiply(r * o).multiply(i.clone().subtract(n)).round();
          }
        }, {
          key: "flip",
          value: function value(e) {
            var t = this._options,
                n = t.start,
                i = t.end,
                r = n.clone();
            "horizontal" === e ? (n.set(1 - i.x, n.y), i.set(1 - r.x, i.y)) : "vertical" === e && (n.set(n.x, 1 - i.y), i.set(i.x, 1 - r.y));
          }
        }, {
          key: "rotate",
          value: function value(e) {
            for (var t = this._options, n = t.start, i = t.end, r = (e + 360) % 360, o = Math.floor(r / 90), a = 0; a < o; a++) {
              var s = n.clone();
              n.set(1 - i.y, s.x), i.set(1 - s.y, i.x);
            }
          }
        }, {
          key: "_onBeforeExport",
          value: function value() {
            this._wasEnabledBeforeExport = this.getEnabled(), this.setEnabled(!0);
          }
        }, {
          key: "_onAfterExport",
          value: function value() {
            this.setEnabled(this._wasEnabledBeforeExport, !0);
          }
        }]), t;
      }(p.Operation);

      _.identifier = "transform", _.prototype.availableOptions = {
        start: {
          type: p.OptionType.VECTOR2,
          default: new y(0, 0)
        },
        end: {
          type: p.OptionType.VECTOR2,
          default: new y(1, 1)
        },
        textureScale: {
          type: p.OptionType.NUMBER,
          default: 1
        },
        rotation: {
          type: p.OptionType.NUMBER,
          default: 0
        }
      }, _.TransformChange = h.a, f.a.Operations.TransformOperation = _, t.a = _;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(4),
          a = (n.n(o), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          s = o.Math.Vector2,
          l = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._options = n, this._oldOptions = {
            start: t.getStart().clone(),
            end: t.getEnd().clone(),
            rotation: t.getRotation(),
            textureScale: t.getTextureScale()
          }, this._inputDimensions = t.getInputDimensions(!1), this._rotationDelta = n.rotation - t.getRotation(), this._deltaCos = Math.cos(this._rotationDelta), this._deltaSin = Math.sin(this._rotationDelta), this._oldAbsoluteSize = this._oldOptions.end.clone().subtract(this._oldOptions.start).multiply(this._inputDimensions), this._newAbsoluteSize = n.end.clone().subtract(n.start).multiply(this._inputDimensions), this._absoluteStartDiff = this._oldOptions.start.clone().subtract(n.start).multiply(this._inputDimensions), this._scaleRatio = t.calculateScale(n.rotation) / t.calculateScale(), this._sizeFactor = this._newAbsoluteSize.clone().divide(this._oldAbsoluteSize), this._textureScaleFactor = this._options.textureScale / t.getTextureScale();
        }

        return a(e, [{
          key: "applyToRelativePoint",
          value: function value(e) {
            var t = this._oldOptions.start,
                n = this._oldOptions.end,
                i = t.clone().add(n.clone().subtract(t).divide(2)).multiply(this._inputDimensions),
                r = e.clone().multiply(this._oldAbsoluteSize).subtract(this._oldAbsoluteSize.clone().divide(2)),
                o = i.clone().add(r).clone().subtract(this._inputDimensions.clone().divide(2)),
                a = new s(o.x * this._deltaCos - o.y * this._deltaSin, o.x * this._deltaSin + o.y * this._deltaCos),
                l = this._inputDimensions.clone().divide(2).add(a),
                u = this._options.start.clone().multiply(this._inputDimensions);

            return l.clone().subtract(u).divide(this._newAbsoluteSize);
          }
        }, {
          key: "applyToRelativeSize",
          value: function value(e) {
            return e * this._oldAbsoluteSize.min() / this._newAbsoluteSize.min();
          }
        }, {
          key: "applyToDimensions",
          value: function value(e) {
            return e = e.clone().multiply(this._scaleRatio), this._options.textureScale && e.multiply(this._textureScaleFactor), e;
          }
        }, {
          key: "scaleSize",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "y";
            return e / this._sizeFactor[t];
          }
        }, {
          key: "applyToRotation",
          value: function value(e) {
            return (e + this._rotationDelta) % (2 * Math.PI);
          }
        }, {
          key: "invert",
          value: function value() {
            var e = this._options.start.clone(),
                t = this._options.end.clone(),
                n = this._inputDimensions,
                i = -this._rotationDelta,
                r = Math.cos(i),
                o = Math.sin(i),
                a = this._oldAbsoluteSize,
                l = this._newAbsoluteSize,
                u = e.clone().subtract(t).multiply(n),
                c = 1 / this._scaleRatio,
                p = new s(1 / this._sizeFactor.x, 1 / this._sizeFactor.y),
                f = 1 / this._textureScaleFactor,
                h = this._oldOptions;

            return this._oldOptions = this._options, this._options = h, this._inputDimensions = n, this._rotationDelta = i, this._deltaCos = r, this._deltaSin = o, this._oldAbsoluteSize = l, this._newAbsoluteSize = a, this._absoluteStartDiff = u, this._scaleRatio = c, this._sizeFactor = p, this._textureScaleFactor = f, this;
          }
        }]), e;
      }();

      t.a = l;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(4),
          d = n.n(h),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = h.Math.Vector2,
          v = function (e) {
        function t() {
          var e;
          m(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = y(this, (e = t.__proto__ || f()(t)).call.apply(e, [this].concat(i)));
          return o._watermarkSprite = new h.Engine.Sprite(), o._watermarkSprite.setAnchor(.5, .5), o._container.addChild(o._watermarkSprite), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_render",
          value: function value(e) {
            this._watermarkTexture || (this._watermarkTexture = h.Engine.Texture.fromImage(this._options.image), this._watermarkSprite.setTexture(this._watermarkTexture));
            var t = e.getDimensions(),
                n = this._options.image,
                i = n.width,
                r = n.height,
                o = h.Utils.resizeVectorToFit(new _(i, r), t);
            return this._watermarkSprite.setPosition(t.clone().divide(2)), this._watermarkSprite.setWidth(o.x), this._watermarkSprite.setHeight(o.y), this._renderTexture.render(this._container), h.Promise.resolve();
          }
        }, {
          key: "dispose",
          value: function value() {
            (function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            })(t.prototype.__proto__ || f()(t.prototype), "dispose", this).call(this), this._watermarkSprite.dispose();
          }
        }]), t;
      }(h.Operation);

      v.identifier = "watermark", v.prototype.availableOptions = {
        image: {
          type: h.OptionType.OBJECT,
          required: !0
        }
      }, d.a.Operations.WatermarkOperation = v, t.a = v;
    }, function (e, t, n) {
      var i = n(39),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(80),
          d = n.n(h),
          g = n(1),
          m = n.n(g),
          y = n(4),
          _ = n.n(y),
          v = n(455),
          b = n(40),
          w = n(187),
          x = n(475),
          k = function e(t, n, i) {
        null === t && (t = Function.prototype);
        var r = a()(t, n);

        if (void 0 === r) {
          var o = m()(t);
          return null === o ? void 0 : e(o, n, i);
        }

        if ("value" in r) return r.value;
        var s = r.get;
        return void 0 !== s ? s.call(i) : void 0;
      },
          T = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function S(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function C(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var E = y.Engine.Filters.OverlayFilter,
          O = function (e) {
        function t() {
          var e;
          S(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = C(this, (e = t.__proto__ || m()(t)).call.apply(e, [this].concat(i)));
          return o._renderStart = null, o._renderedOverlaySprite = new y.Engine.Sprite(), o._renderedOverlayContainer = new y.Engine.Container(), o._renderedOverlayContainer.addChild(o._renderedOverlaySprite), o._overlayFilter = new E(), o._overlayFilter.getShaderForRenderer(o._sdk.getRenderer()), o._sdk.on("new-image", o._onNewImage.bind(o)), o._prepareRenderTargets(), o;
        }

        var n, i;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), T(t, null, [{
          key: "isSupported",
          value: function value(e) {
            if (e.getRenderer().isOfType(b.RendererType.WEBGL)) {
              var t = e.getRenderer().getContext(),
                  n = w.a.determineSupportedConfiguration(t).environmentSupported,
                  i = !y.Utils.isMobile();
              return n && i;
            }

            return !1;
          }
        }]), T(t, [{
          key: "setOption",
          value: function value(e, n) {
            var i = this;

            if ("styleTransferModel" === e) {
              var r = this._options.styleTransferModel;
              r && r !== n && this._renderInputImageIntoOverlayTarget();
            }

            if (k(t.prototype.__proto__ || m()(t.prototype), "setOption", this).call(this, e, n), "identifier" === e || "styleTransferModel" === e) {
              var o = this._options.styleTransferModel;
              o && o.onWeightsUpdated(function () {
                i._renderInputImageIntoOverlayTarget();
              });
            }
          }
        }, {
          key: "_onNewImage",
          value: function value() {
            this.dispose(), this._prepareRenderTargets();
            var e = this.getStyleTransferModel();
            e && e.updateInputDimensions(this._exifAdjustedInputDimensions);
          }
        }, {
          key: "_prepareRenderTargets",
          value: function value() {
            var e = this._sdk.getRenderer(),
                t = e.getContext(),
                n = this._sdk.getInputTexture(),
                i = n.getDimensions(),
                r = this._sdk.getOperationsStack().getByIdentifier("exif-orientation");

            if (r) {
              i = r.getNewDimensions(i);
              var o = new y.Engine.WebGLRenderTarget(e, i.x, i.y, 1);
              o.setFrame(new y.Math.Rectangle(0, 0, i.x, i.y));
              var a = e.getOrCreateGLTexture(o.getBaseTexture()),
                  s = r.applyTo(this._sdk.getImage());
              t.bindTexture(t.TEXTURE_2D, a), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, s), this._modelInputTarget = o;
            } else {
              var l = new y.Engine.WebGLRenderTarget(e, i.x, i.y, 1);
              l.setFrame(new y.Math.Rectangle(0, 0, i.x, i.y)), l._baseTexture = n.getBaseTexture();

              var u = l._baseTexture.getGLTextureForRenderer(e);

              u || (u = t.createTexture(), l._baseTexture.setGLTextureForRenderer(u, e)), l._texture = u, t.bindTexture(t.TEXTURE_2D, u), t.bindFramebuffer(t.FRAMEBUFFER, l._framebuffer), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, u, 0), this._modelInputTarget = l;
            }

            this._overlayRenderTexture = new y.Engine.RenderTexture(e, i.x, i.y);

            var c = this._overlayRenderTexture.getBaseTexture();

            c.setGLUnit(5), this._sdk.getRenderer().updateTexture(c, !1), this._overlayRenderTarget = this._overlayRenderTexture.getRenderTarget(), this._renderedOverlaySprite.setTexture(this._overlayRenderTexture), this._exifAdjustedInputDimensions = i, this._renderInputImageIntoOverlayTarget();
          }
        }, {
          key: "_renderInputImageIntoOverlayTarget",
          value: function value() {
            var e = this._sdk.getRenderer().getContext(),
                t = this._modelInputTarget.getFrame().getSize();

            this._modelInputTarget.activate(), e.bindTexture(e.TEXTURE_2D, this._overlayRenderTarget.getTexture()), e.copyTexImage2D(e.TEXTURE_2D, 0, e.RGBA, 0, 0, t.x, t.y, 0);
          }
        }, {
          key: "_render",
          value: (n = d.a.mark(function e(t) {
            var n, i, r, o;
            return d.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (n = this._options, i = n.intensity, r = n.blendMode, o = this.getStyleTransferModel()) {
                      e.next = 6;
                      break;
                    }

                    return this._sprite.setFilters([]), this._renderTexture.render(this._container), e.abrupt("return", y.Promise.resolve());

                  case 6:
                    if (!o.isDisposed()) {
                      e.next = 9;
                      break;
                    }

                    return e.next = 9, o.initGraph(this._sdk.getRenderer());

                  case 9:
                    if (!o.isDirty()) {
                      e.next = 12;
                      break;
                    }

                    return e.next = 12, o.execute(this._sdk.getRenderer(), this._modelInputTarget, this._overlayRenderTarget);

                  case 12:
                    return this._overlayFilter.set({
                      blendMode: r,
                      overlayImage: this._overlayRenderTarget.getBaseTexture().getGLUnit(),
                      overlayTexture: this._overlayRenderTexture,
                      alpha: i
                    }), this._sprite.setFilters([this._overlayFilter]), this._renderTexture.render(this._container), e.abrupt("return", y.Promise.resolve(o.isDirty()));

                  case 16:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }), i = function i() {
            var e = n.apply(this, arguments);
            return new y.Promise(function (t, n) {
              return function i(r, o) {
                try {
                  var a = e[r](o),
                      s = a.value;
                } catch (e) {
                  return void n(e);
                }

                if (!a.done) return y.Promise.resolve(s).then(function (e) {
                  i("next", e);
                }, function (e) {
                  i("throw", e);
                });
                t(s);
              }("next");
            });
          }, function (e) {
            return i.apply(this, arguments);
          })
        }, {
          key: "dispose",
          value: function value() {
            if (k(t.prototype.__proto__ || m()(t.prototype), "dispose", this).call(this), this._renderedOverlaySprite.dispose(), this._overlayFilter.dispose(), this._overlayRenderTarget.dispose(), this._modelInputTarget) {
              var e = this._modelInputTarget._framebuffer;
              this._sdk.getRenderer().getContext().deleteFramebuffer(e), this._modelInputTarget = null;
            }

            var n = this._options.styleTransferModel;
            n && n.dispose();
          }
        }]), t;
      }(y.Operation);

      O.identifier = "artfilter", O.prototype.availableOptions = {
        identifier: {
          type: y.OptionType.STRING,
          default: ""
        },
        styleTransferModel: {
          type: y.OptionType.OBJECT,
          default: null
        },
        intensity: {
          type: y.OptionType.NUMBER,
          default: 1
        },
        blendMode: {
          type: y.OptionType.NUMBER,
          default: E.BLEND_MODES.NORMAL,
          available: r()(E.BLEND_MODES).map(function (e) {
            return E.BLEND_MODES[e];
          })
        }
      }, O.StyleTransferModel = v.a, O.TensorFilters = x.a, _.a.Operations.ArtFilterOperation = O, t.a = O;
    }, function (e, t, n) {
      var i = n(29),
          r = n.n(i),
          o = n(25),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(2),
          c = n.n(u),
          p = n(3),
          f = n.n(p),
          h = n(80),
          d = n.n(h),
          g = n(10),
          m = n.n(g),
          y = n(1),
          _ = n.n(y),
          v = n(4),
          b = (n.n(v), n(456)),
          w = n(474),
          x = n(188),
          k = n(189),
          T = n(190),
          S = n(191),
          C = n(192),
          E = n(193),
          O = n(194),
          R = n(195),
          I = n(13),
          A = n(38),
          M = n(171),
          F = n(54),
          D = n(133),
          P = n(196),
          z = n(197),
          L = n(132),
          B = function B(e, t) {
        if (Array.isArray(e)) return e;
        if (r()(Object(e))) return function (e, t) {
          var n = [],
              i = !0,
              r = !1,
              o = void 0;

          try {
            for (var s, l = a()(e); !(i = (s = l.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            r = !0, o = e;
          } finally {
            try {
              !i && l.return && l.return();
            } finally {
              if (r) throw o;
            }
          }

          return n;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          N = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function U(e) {
        return function () {
          var t = e.apply(this, arguments);
          return new m.a(function (e, n) {
            return function i(r, o) {
              try {
                var a = t[r](o),
                    s = a.value;
              } catch (e) {
                return void n(e);
              }

              if (!a.done) return m.a.resolve(s).then(function (e) {
                i("next", e);
              }, function (e) {
                i("throw", e);
              });
              e(s);
            }("next");
          });
        };
      }

      function j(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function W(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var H = function (e) {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments[1];
          j(this, t);
          var i = W(this, (t.__proto__ || _()(t)).call(this, e));
          return i._onWeightsUpdatedCallback = null, i._finalConvIndex = -1, i._tilingController = n, i._disposed = !1, i;
        }

        var n, i;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = f()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (c.a ? c()(e, t) : e.__proto__ = t);
        }(t, e), N(t, [{
          key: "isDirty",
          value: function value() {
            return !this._tilingController || !this._tilingController.hasRenderedAllTiles();
          }
        }, {
          key: "isDisposed",
          value: function value() {
            return null === this._graph;
          }
        }, {
          key: "isReady",
          value: function value() {
            return !this.isDisposed() && this._graph.isFinished();
          }
        }, {
          key: "getTilingController",
          value: function value() {
            return this._tilingController;
          }
        }, {
          key: "onWeightsUpdated",
          value: function value(e) {
            this._onWeightsUpdatedCallback = e;
          }
        }], [{
          key: "createWithOptions",
          value: function value(e, n, i) {
            var r = e.tileEdgeLength || t.prototype.availableOptions.tileEdgeLength.default,
                o = e.overlappingFactor || t.prototype.availableOptions.overlappingFactor.default,
                a = new t(e, new w.a(n, r, o));
            return a.initGraph(i).then(function () {
              return a;
            });
          }
        }]), N(t, [{
          key: "updateInputDimensions",
          value: function value(e) {
            var n = this._options.tileEdgeLength || t.prototype.availableOptions.tileEdgeLength.default,
                i = this._options.overlappingFactor || t.prototype.availableOptions.overlappingFactor.default;
            this._tilingController = new w.a(e, n, i);
          }
        }, {
          key: "updateWithWeightsFromURL",
          value: (i = U(d.a.mark(function e(t) {
            var n, i, r, o, a, s, l, u;
            return d.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n = new M.JSONLoader(t), e.next = 3, n.load();

                  case 3:
                    if (i = e.sent) {
                      e.next = 6;
                      break;
                    }

                    return e.abrupt("return", m.a.reject(new Error("Could not load weight map from " + t)));

                  case 6:
                    for (r = 0; i["transform/residual/res_" + (r + 1) + "/conv1/depthwise_weights"];) {
                      r++;
                    }

                    if (o = i["transform/expand/final_conv/depthwise_weights"].logicalShape, a = this._graph._filterStack[this._finalConvIndex]._getInputWithName("w").logicalShape, s = F.a.isSameShape(a, o), l = this._residualBlockCount === r, u = this, !s || !l) {
                      e.next = 17;
                      break;
                    }

                    return e.abrupt("return", this._graph.updateWeights(i).then(function () {
                      u._onWeightsUpdatedCallback && u._onWeightsUpdatedCallback(), u.getTilingController().reset();
                    }));

                  case 17:
                    return e.abrupt("return", m.a.reject(new Error("Model architectures differ.")));

                  case 18:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (e) {
            return i.apply(this, arguments);
          })
        }, {
          key: "execute",
          value: function value(e, t, n) {
            var i = this._tilingController,
                r = this._graph,
                o = i.getNextTileIndex();
            if (!r.isFinished()) throw new Error("Can't execute an unfinished graph.");

            var a = this._tilingController.getOriginalInputCoordinatesForTileAtIndex(o),
                s = a.x,
                l = a.y,
                u = a.height,
                c = a.width,
                p = new A.Rectangle(s, l, c, u),
                f = this._tilingController.getBlendLeftTopRightBottomForTile(o),
                h = this._tilingController.getTilingConfiguration().overlappingFactor;

            return r.render(e, t, n, p, f, h).then(function () {
              i.markTileAsRendered(o);
            });
          }
        }, {
          key: "initGraph",
          value: (n = U(d.a.mark(function e(t) {
            var n,
                i,
                r,
                o,
                a,
                s,
                l,
                u,
                c,
                p = this;
            return d.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n = this._options, i = n.weightURL, r = n.tileEdgeLength, o = this.getTilingController(), a = o.calculateMaximumTileDimensions(), s = o.getOriginalInputCoordinatesForTileAtIndex(0).getSize(), l = new M.JSONLoader(i), e.next = 7, l.load();

                  case 7:
                    for (u = e.sent, c = 0; u["transform/residual/res_" + (c + 1) + "/conv1/depthwise_weights"];) {
                      c++;
                    }

                    return this._residualBlockCount = c, this._graph = new b.a(t, u, a, r), this._graph.addFilter(new R.a({
                      inputs: [{
                        name: "x",
                        type: I.a.PREVIOUS
                      }],
                      size: [r, r]
                    })), this._addStyleTransferOperationsToGraph(this._graph, u, s), e.abrupt("return", this._graph.load(t).then(function () {
                      p._tilingController.reset();
                    }));

                  case 15:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (e) {
            return n.apply(this, arguments);
          })
        }, {
          key: "_addStyleTransferOperationsToGraph",
          value: function value(e, t, n) {
            this._weightMap = t;

            for (var i = this._addDepthwiseSeparableConvolution("transform/contract/conv1", e, 1, 1, "same"), r = this._addDepthwiseSeparableConvolution("transform/contract/conv2", e, i, 2, "same"), o = this._addDepthwiseSeparableConvolution("transform/contract/conv3", e, r, 2, "same"), a = 1; a <= this._residualBlockCount; a++) {
              var s = "transform/residual/res_" + a;
              o = this._addResidualBlock(s, e, o);
            }

            var l = this._addUpsampling("transform/expand/up_1", e, o),
                u = this._addUpsampling("transform/expand/up_2", e, l);

            this._addDepthwiseSeparableConvolution("transform/expand/final_conv", e, u, 1, "same", !1), e.addFilter(new k.a({
              inputs: [{
                name: "x",
                type: I.a.PREVIOUS
              }]
            }));

            var c = e.addFilter(new R.a({
              inputs: [{
                name: "x",
                type: I.a.PREVIOUS
              }],
              size: [n.y, n.x]
            })),
                p = this._addEdgePadding(e, c, 3, 1),
                f = this._addPackFilterToStack(e, p);

            this._addSharpening(e, f), this._weightMap = null;
          }
        }, {
          key: "_addDepthwiseSeparableConvolution",
          value: function value(e, t, n, i, r) {
            var o = !(arguments.length > 5 && void 0 !== arguments[5]) || arguments[5],
                a = e + "/depthwise_weights",
                s = e + "/pointwise_weights",
                l = t.getLastIndex() === n,
                u = t.addFilter(new S.a({
              inputs: [{
                name: "x",
                type: l ? I.a.PREVIOUS : I.a.DATA,
                data: n
              }, {
                name: "w",
                type: I.a.DATA,
                data: a
              }],
              stride: i,
              padding: "same",
              padMethod: "edge"
            }));
            a.indexOf("final_conv") >= 0 && (this._finalConvIndex = u);
            var c = t.addFilter(new T.a({
              inputs: [{
                name: "x",
                type: I.a.PREVIOUS
              }, {
                name: "w",
                type: I.a.DATA,
                data: s
              }],
              stride: 1,
              padding: "valid"
            })),
                p = C.a.addFiltersForReduceSumOperationToGraph(t, c, [1, 2]),
                f = t.addFilter(new E.a({
              inputs: [{
                name: "sum",
                type: I.a.PREVIOUS
              }, {
                name: "x",
                type: I.a.INDEX,
                data: c
              }]
            }));
            C.a.addFiltersForReduceSumOperationToGraph(t, f, [1, 2]);
            var h = e + "/instance_norm/shift",
                d = e + "/instance_norm/scale";
            return t.addFilter(new O.a({
              inputs: [{
                name: "variance",
                type: I.a.PREVIOUS
              }, {
                name: "sum",
                type: I.a.INDEX,
                data: p
              }, {
                name: "x",
                type: I.a.INDEX,
                data: c
              }, {
                name: "shift",
                type: I.a.DATA,
                data: h
              }, {
                name: "scale",
                type: I.a.DATA,
                data: d
              }],
              addRelu: o
            })), t.getLastIndex();
          }
        }, {
          key: "_addResidualBlock",
          value: function value(e, t, n) {
            var i = this._addDepthwiseSeparableConvolution(e + "/conv1", t, n, 1, "same"),
                r = this._addDepthwiseSeparableConvolution(e + "/conv2", t, i, 1, "same", !1),
                o = t.getLastIndex() === r;

            return t.addFilter(new x.a({
              inputs: [{
                name: "x",
                type: I.a.INDEX,
                data: n
              }, {
                name: "y",
                type: o ? I.a.PREVIOUS : I.a.INDEX,
                data: r
              }]
            })), t.getLastIndex();
          }
        }, {
          key: "_addUpsampling",
          value: function value(e, t, n) {
            var i = t.getLogicalShapeAtIndex(n),
                r = B(i, 3),
                o = (r[0], r[1]),
                a = r[2],
                s = t.getLastIndex() === n,
                l = t.addFilter(new R.a({
              inputs: [{
                name: "x",
                type: s ? I.a.PREVIOUS : I.a.INDEX,
                data: n
              }],
              size: [2 * o, 2 * a]
            }));
            return this._addDepthwiseSeparableConvolution(e + "/conv", t, l, 1, "same");
          }
        }, {
          key: "_addEdgePadding",
          value: function value(e, t, n, i) {
            var r = e.getLogicalShapeAtIndex(t),
                o = B(r, 4),
                a = o[1],
                s = o[2],
                l = (o[3], e.getLastIndex() === t),
                u = D.a.calculatePadding("same", a, s, i, i, n, n).padInfo,
                c = [[0, 0], [u.top, u.bottom], [u.left, u.right], [0, 0]];
            return e.addFilter(new P.a({
              inputs: [{
                name: "x",
                type: l ? I.a.PREVIOUS : I.a.INDEX,
                data: t
              }],
              paddings: c
            }));
          }
        }, {
          key: "_addPackFilterToStack",
          value: function value(e, t) {
            var n = e.getLogicalShapeAtIndex(t),
                i = e.getLastIndex() === t,
                r = new L.a({
              inputs: [{
                name: "x",
                type: i ? I.a.PREVIOUS : I.a.INDEX,
                data: t
              }],
              outputSize: n.slice(1, 3)
            });
            if (3 === n[3]) return e.addFilter(r);
            throw new Error("Couldn't add pack filter due to channel count mismatch (expected RGB output).");
          }
        }, {
          key: "_addSharpening",
          value: function value(e, t) {
            var n = e.getLastIndex() === t;
            e.addFilter(new z.a({
              inputs: [{
                name: "x",
                type: n ? I.a.PREVIOUS : I.a.INDEX,
                data: t
              }]
            }));
          }
        }, {
          key: "dispose",
          value: function value() {
            this._graph && this._graph.dispose(), this._graph = null;
          }
        }]), t;
      }(v.Configurable);

      H.prototype.availableOptions = {
        weightURL: {
          type: v.OptionType.STRING,
          required: !0
        },
        tileEdgeLength: {
          type: v.OptionType.NUMBER,
          default: 256
        },
        overlappingFactor: {
          type: v.OptionType.NUMBER,
          default: .4
        }
      }, t.a = H;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(80),
          a = n.n(o),
          s = n(39),
          l = n.n(s),
          u = n(10),
          c = n.n(u),
          p = n(131),
          f = n.n(p),
          h = n(38),
          d = n(13),
          g = n(185),
          m = n(54),
          y = n(4),
          _ = (n.n(y), n(132), n(12)),
          v = n(160),
          b = n(186),
          w = n(472),
          x = n(473),
          k = n(187),
          T = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          S = function () {
        function e(t, n, i, r) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._measurePerformance = !1, this._filterStack = [], this._intermediateReadDependencies = [], this._intermediateWriteDependencies = [], this._finished = !1, this._renderer = t, this._gl = t.getContext();
          var o = k.a.determineSupportedConfiguration(this._gl);
          this._renderTargetManager = new w.b(t, o), this._textureManager = new x.a(t, o), this._weightMap = n, this._shaderCache = new f.a(), this._inputTileDimensions = i, this._inferenceEdgeLength = r, this._featheredMaskFilter = new b.a({
            inputs: [{
              name: "x",
              type: d.a.PREVIOUS,
              logicalShape: [i.y, i.x]
            }, {
              name: "y",
              type: d.a.INDEX,
              logicalShape: [i.y, i.x]
            }]
          }), this._setupRGBAUnpackFilter();
        }

        var t, n;
        return T(e, [{
          key: "addFilter",
          value: function value(e) {
            var t = this,
                n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            if (this._finished) throw new Error("Can't add filters to an already finished graph.");
            var i = this._filterStack.length,
                r = i - 1,
                o = this._filterStack[r];
            return this._filterStack.push(e), this._intermediateReadDependencies.push([]), this._intermediateWriteDependencies.push([]), e.getInputs().forEach(function (a, s, l) {
              switch (a.type) {
                case d.a.PREVIOUS:
                  n && (a.logicalShape = o.outputLogicalShape());
                  break;

                case d.a.INDEX:
                  if (a.data === r) throw new Error("Accessing the previous filter through indexing is not supported. Use InputType.PREVIOUS instead.");
                  var u = t._filterStack[a.data];
                  if (!u) throw new Error("Indexed input does not exist: " + a.data + " for input " + a.name + " in " + e.constructor.name + " at " + i + ".");
                  n && (a.logicalShape = u.outputLogicalShape()), t._intermediateReadDependencies[i].push(a), t._intermediateWriteDependencies[a.data].push(i);
                  break;

                case d.a.DATA:
                  var c = a.data,
                      p = t._weightMap[c];
                  l[s].logicalShape = p.logicalShape, l[s].data = new Float32Array(p.data), l[s].key = c, delete t._weightMap[c];
              }
            }, this), e.prepareUniforms(), i;
          }
        }, {
          key: "load",
          value: function value(e) {
            var t = this,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._measurePerformance;
            this._renderer = e, this._gl = e.getContext();
            var i = this._gl,
                r = i.getParameter(i.MAX_TEXTURE_IMAGE_UNITS);
            this._maxRequiredTextureDimensions = this._calculateMaximumIntermediateTextureDimensions();
            var o = this;
            return c.a.resolve().then(function () {
              return o._loadTextures(n);
            }).then(function () {
              return o._compileShaders(e, r, n);
            }).then(function () {
              return o._prepareRenderTargets(n);
            }).then(function () {
              return o._intermediateResults = o._filterStack.map(function () {
                return null;
              }), o._quad = new v.a(e), t._weightMap = null, o._finished = !0, o;
            }).then(function () {
              n && (performance.measure("texture_loading", "begin_texture_loading", "finish_texture_loading"), performance.measure("shader_compilation", "begin_shader_compilation", "finish_shader_compilation"), performance.measure("target_preparation", "begin_target_preparation", "finish_target_preparation"), performance.getEntriesByType("measure").forEach(function (e) {
                console.log(e.name + ": " + e.duration + "ms"), performance.clearMarks(), performance.clearMeasures();
              }));
            });
          }
        }, {
          key: "dispose",
          value: function value() {
            this._disposed || (this._textureManager.dispose(), this._renderTargetManager.dispose(), this._shaderCache.forEach(function (e) {
              e.dispose();
            }), this._textureManager = null, this._renderTargetManager = null, this._shaderCache = null, this._intermediateReadDependencies = null, this._intermediateWriteDependencies = null, this._filterStack = null, this._disposed = !0);
          }
        }, {
          key: "_loadTextures",
          value: function value(e) {
            var t = this;
            e && performance.mark("begin_texture_loading");
            var n = [];
            return this._filterStack.forEach(function (e, i) {
              n.push(t._textureManager.createAndLoadTexturesForFilter(e, i));
            }, this), c.a.all(n).then(function () {
              e && performance.mark("finish_texture_loading");
            });
          }
        }, {
          key: "_compileShaders",
          value: function value(e, t, n) {
            var i = this;
            n && performance.mark("begin_shader_compilation");
            var r = [];
            return this._filterStack.concat([this._featheredMaskFilter]).forEach(function (n, o) {
              if (o < i._filterStack.length) {
                var a = 1 + n.getInputs().filter(function (e) {
                  return e.type === d.a.DATA;
                }).length + i._intermediateReadDependencies[o].length;

                if (a > t) throw new Error("This environment does only offer support for " + t + ", but filter " + n.constructor.name + " requires " + a + ".");
              }

              var s = n.getShaderIdentifier(),
                  l = i;
              i._shaderCache.has(s) || r.push(new c.a(function (t) {
                var i = n.getShaderForRenderer(e);
                if (!i) throw new Error("Could not compile filter: " + n.constructor.name + "!");
                l._shaderCache.set(s, i), e.getContext().finish(), t(i);
              }));
            }), c.a.all(r).then(function () {
              n && performance.mark("finish_shader_compilation");
            });
          }
        }, {
          key: "_prepareRenderTargets",
          value: function value(e) {
            var t = this;
            e && performance.mark("begin_target_preparation");
            var n = this._maxRequiredTextureDimensions,
                i = this._inputTileDimensions;
            return c.a.resolve().then(function (e) {
              return t._renderTargetManager.prebuildRenderTargets(5, n, w.a.FLOAT);
            }).then(function (e) {
              return t._renderTargetManager.prebuildRenderTargets(3, i, w.a.INT);
            }).then(function (t) {
              e && performance.mark("finish_target_preparation");
            });
          }
        }, {
          key: "isFinished",
          value: function value() {
            return this._finished;
          }
        }, {
          key: "updateWeights",
          value: function value(e) {
            var t = this;
            return this._finished ? (this._filterStack.forEach(function (n, i, r) {
              var o = !1;
              n.getInputs().forEach(function (t, n) {
                if (t.type === d.a.DATA && t.key) {
                  var a = e[t.key];
                  if (!a) return;
                  r[i].getInputs()[n].data = new Float32Array(a.data), o = !0, delete e[t.key];
                }
              }), o && t._textureManager.updateTexturesForFilter(n, i);
            }), 0 === !l()(e).length && c.a.reject(new Error("Not all weights in the given weight map were in use.")), c.a.resolve()) : c.a.reject(new Error("Graph hasn't been loaded. Unable to update weights."));
          }
        }, {
          key: "render",
          value: (t = a.a.mark(function e(t, n, i, r, o, s) {
            var l,
                u,
                p,
                f,
                g,
                y,
                v,
                b,
                x,
                k,
                T,
                S,
                C,
                E = this,
                O = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : this._measurePerformance;
            return a.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!this._disposed) {
                      e.next = 2;
                      break;
                    }

                    return e.abrupt("return", c.a.resolve(i));

                  case 2:
                    if (O && performance.mark("begin_render"), l = this._gl, O && performance.mark("begin_preparation"), this._featheredMaskFilter.setBlendLeftTopRightBottom(o), this._featheredMaskFilter.setBlendRadius(.5 * s), u = this._maxRequiredTextureDimensions, p = this._renderTargetManager.popRenderTarget(this._inputTileDimensions, w.a.INT), f = this._renderTargetManager.popRenderTarget(u, w.a.FLOAT), g = this._renderTargetManager.popRenderTarget(this._inputTileDimensions, w.a.INT), this._copyTextureContents(n, p, r, h.Vector2.NULL), this._copyTextureContents(i, g, r, h.Vector2.NULL), y = this._filterStack[0], v = y.getInputs()[0].name, b = r.height, x = r.width, k = [b, x], y.setTextureSizeForInputWithName(this._inputTileDimensions.asArray(!0), v), y.setLogicalSizeForInputWithName(k, v), O && performance.mark("finish_preparation"), T = new _.h(), S = new _.h(), this._filterStack.forEach(function (e, n) {
                      var i = 1;
                      O && performance.mark("begin_conversion_" + n);

                      var r = e.requiresFloatTextures() ? w.a.FLOAT : w.a.INT,
                          o = n === E.getLastIndex() ? E._inputTileDimensions : E._maxRequiredTextureDimensions,
                          a = E._renderTargetManager.getFormatOfRenderTarget(f);

                      null === f ? f = E._renderTargetManager.popRenderTarget(o, r) : a !== r && (E._renderTargetManager.pushRenderTarget(f), f = E._renderTargetManager.popRenderTarget(o, r)), O && performance.mark("finish_conversion_" + n);
                      var s = p.getFrame().getSize().asArray(!0),
                          u = f.getFrame().getSize().asArray(!0),
                          c = h.Utils.Array.find(e.getInputs(), function (e) {
                        return e.type === d.a.PREVIOUS;
                      });
                      void 0 !== c && (e.setTextureSizeForInputWithName(s, c.name), e.setLogicalSizeForInputWithName(k, c.name)), O && performance.mark("begin_suppl_" + n + "_prep"), i += E._textureManager.bindTexturesForFilter(e, n, i), O && performance.mark("finish_suppl_" + n + "_prep"), O && performance.mark("begin_intermediate_" + n + "_prep");
                      var g = E._intermediateReadDependencies[n];
                      E._bindIntermediateReadDependencies(e, g, i), O && performance.mark("finish_intermediate_" + n + "_prep");

                      var y = p.getFrame(),
                          _ = f.getFrame();

                      y.equals(T) && _.equals(S) || (E._quad.map(y, _), E._configureVertexAttributesForShader(e.getShaderForRenderer(t)), T = y, S = _), t.setRenderTarget(f);
                      var v = m.a.getTextureDimensionsForLogicalShape(e.outputLogicalShape());
                      e.setTargetTextureSize(u), e.setTargetLogicalSize(v), l.viewport(0, 0, v[1], v[0]), O && performance.mark("begin_filter_" + n);

                      var b = E._shaderCache.get(e.getShaderIdentifier());

                      l.useProgram(b.getProgram()), e._applyWebGL(t, p, f, !0, b), O && performance.mark("finish_filter_" + n), O && performance.mark("begin_postprocess_" + n), E._storeIntermediateResultsIfNeeded(p, n, k, s) && (p = null), g.forEach(function (e) {
                        var t = E._intermediateResults[e.data];
                        t && 0 === t.pendingReads && (E._renderTargetManager.pushRenderTarget(t.target), E._intermediateResults.slice(e.data, 1));
                      }, E);
                      var x = f;
                      f = p, p = x, k = v, O && performance.mark("finish_postprocess_" + n);
                    }, this), O && performance.mark("begin_masking"), this._renderTargetManager.pushRenderTarget(f), f = this._renderTargetManager.popRenderTarget(this._inputTileDimensions, w.a.INT), this._applyFeatheredMasking(t, p, g, f, [b, x], o), O && performance.mark("finish_masking"), O && performance.mark("begin_out_copy"), this._copyTextureContents(f, i, new _.h(0, 0, x, b), r.getPosition()), O && performance.mark("finish_out_copy"), this._renderTargetManager.pushRenderTarget(p), this._renderTargetManager.pushRenderTarget(f), this._renderTargetManager.pushRenderTarget(g), O && performance.mark("finish_render"), O) {
                      for (performance.measure("total", "begin_render", "finish_render"), performance.measure("preparation", "begin_preparation", "finish_preparation"), performance.measure("masking", "begin_masking", "finish_masking"), performance.measure("out_copy", "begin_out_copy", "finish_out_copy"), C = 0; C < this._filterStack.length; C++) {
                        performance.measure("conversion_" + C, "begin_conversion_" + C, "finish_conversion_" + C), performance.measure("suppl_" + C + "_prep", "begin_suppl_" + C + "_prep", "finish_suppl_" + C + "_prep"), performance.measure("intermediate_" + C + "_prep", "begin_intermediate_" + C + "_prep", "finish_intermediate_" + C + "_prep"), performance.measure("filter_" + C + "_" + this._filterStack[C].constructor.name, "begin_filter_" + C, "finish_filter_" + C), performance.measure("postprocess_" + C, "begin_postprocess_" + C, "finish_postprocess_" + C);
                      }

                      performance.getEntriesByType("measure").forEach(function (e) {
                        e.duration > 50 && console.log(e.name + ": " + e.duration + "ms");
                      }), performance.clearMarks(), performance.clearMeasures();
                    }

                    return e.abrupt("return", c.a.resolve(i));

                  case 37:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }), n = function n() {
            var e = t.apply(this, arguments);
            return new c.a(function (t, n) {
              return function i(r, o) {
                try {
                  var a = e[r](o),
                      s = a.value;
                } catch (e) {
                  return void n(e);
                }

                if (!a.done) return c.a.resolve(s).then(function (e) {
                  i("next", e);
                }, function (e) {
                  i("throw", e);
                });
                t(s);
              }("next");
            });
          }, function (e, t, i, r, o, a) {
            return n.apply(this, arguments);
          })
        }, {
          key: "_applyFeatheredMasking",
          value: function value(e, t, n, i, r) {
            var o = this._gl;
            o.activeTexture(o.TEXTURE0 + 1), o.bindTexture(o.TEXTURE_2D, n.getTexture()), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.NEAREST), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.NEAREST), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE);
            var a = i.getFrame().getSize().asArray(!0);
            this._featheredMaskFilter.setTargetTextureSize(a), this._featheredMaskFilter.setTargetLogicalSize(r), this._featheredMaskFilter.setTextureSizeForInputWithName(a, "x"), this._featheredMaskFilter.setLogicalSizeForInputWithName(r, "x"), this._featheredMaskFilter.setTextureSizeForInputWithName(a, "y"), this._featheredMaskFilter.setLogicalSizeForInputWithName(r, "y");

            var s = this._featheredMaskFilter.getShaderIdentifier(),
                l = this._shaderCache.get(s);

            o.useProgram(l.getProgram()), this._featheredMaskFilter._applyWebGL(e, t, i, !0, l);
          }
        }, {
          key: "_copyTextureContents",
          value: function value(e, t, n, i) {
            var r = this._gl;
            e.activate(), r.bindTexture(r.TEXTURE_2D, t.getTexture()), r.copyTexSubImage2D(r.TEXTURE_2D, 0, i.x, i.y, n.x, n.y, n.width, n.height);
          }
        }, {
          key: "_bindIntermediateReadDependencies",
          value: function value(e, t, n) {
            var i = this,
                r = this._gl,
                o = n;
            t.forEach(function (t) {
              var n = i._intermediateResults[t.data];
              r.activeTexture(r.TEXTURE0 + o), r.bindTexture(r.TEXTURE_2D, n.target.getTexture()), e.setTextureSizeForInputWithName(n.textureSize, t.name), e.setLogicalSizeForInputWithName(n.logicalSize, t.name), n.pendingReads--, o++;
            });
          }
        }, {
          key: "_configureVertexAttributesForShader",
          value: function value(e) {
            var t = this._gl,
                n = this._quad.getVertexBuffer(),
                i = this._quad.getIndexBuffer();

            t.bindBuffer(t.ARRAY_BUFFER, n), t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, i);
            var r = e.getAttributeLocations();
            t.vertexAttribPointer(r.a_position, 2, t.FLOAT, !1, 0, 0), t.vertexAttribPointer(r.a_texCoord, 2, t.FLOAT, !1, 0, 32), t.vertexAttribPointer(r.a_color, 4, t.FLOAT, !1, 0, 64);
          }
        }, {
          key: "_storeIntermediateResultsIfNeeded",
          value: function value(e, t, n, i) {
            var r = t - 1;
            return r >= 0 && this._intermediateWriteDependencies[r].length > 0 && (this._intermediateResults[r] = {
              target: e,
              pendingReads: this._intermediateWriteDependencies[r].length,
              textureSize: i,
              logicalSize: n
            }, !0);
          }
        }, {
          key: "getInitialInputLogicalShape",
          value: function value() {
            return this._filterStack[0].outputLogicalShape();
          }
        }, {
          key: "getLastFilterLogicalShape",
          value: function value() {
            return this.getLogicalShapeAtIndex(this._filterStack.length - 1);
          }
        }, {
          key: "getFilterCount",
          value: function value() {
            return this._filterStack.length;
          }
        }, {
          key: "getLastIndex",
          value: function value() {
            return this._filterStack.length - 1;
          }
        }, {
          key: "getLogicalShapeAtIndex",
          value: function value(e) {
            return this._filterStack[e].outputLogicalShape();
          }
        }, {
          key: "getDebugDescription",
          value: function value() {
            var e = this,
                t = "",
                n = 0,
                i = 0;
            return this._filterStack.forEach(function (r, o) {
              var a = r.constructor.name,
                  s = r._options.inputs.map(function (e) {
                return e.name + ": [" + e.logicalShape + "]";
              }).join(", "),
                  l = "Out: [" + r.outputLogicalShape() + "]",
                  u = "[" + e._supplementaryTextures[o].map(function (e) {
                return e.loadedTexture.getGLUnit() + ": " + e.loadedTexture.id;
              }).join(", ") + "]",
                  c = "R: [" + e._intermediateReadDependencies[o].map(function (e) {
                return e.data;
              }).join(", ") + "] | W: [" + e._intermediateWriteDependencies[o].join(", ") + "]";

              t += "[" + o + "] - " + a + " | " + s + " | " + l + " | " + u + " | " + c + "\n", n += e._intermediateReadDependencies[o].length, i += e._supplementaryTextures[o].length;
            }), t += "Max intermediate texture size: " + this._maxRequiredTextureDimensions + "\n", t += "Required render targets: " + (n + 2) + "\n", t += "Required weight textures: " + i;
          }
        }, {
          key: "_setupRGBAUnpackFilter",
          value: function value() {
            var e = this._inputTileDimensions,
                t = [e.y, e.x],
                n = new g.a({
              inputs: [{
                name: "x",
                logicalShape: t,
                type: d.a.PREVIOUS
              }]
            });
            this.addFilter(n, !1);
          }
        }, {
          key: "_removeLastFilter",
          value: function value() {
            this._filterStack.pop(), this._supplementaryTextures.pop(), this._intermediateReadDependencies.pop(), this._intermediateWriteDependencies.pop();
          }
        }, {
          key: "_calculateMaximumIntermediateTextureDimensions",
          value: function value() {
            var e = new h.Vector2(this._inputTileDimensions.x, this._inputTileDimensions.y);
            return this._filterStack.forEach(function (t) {
              var n = m.a.getTextureDimensionsForLogicalShape(t.outputLogicalShape());
              n[1] > e.x && (e.x = n[1]), n[0] > e.y && (e.y = n[0]);
            }), e;
          }
        }]), e;
      }();

      t.a = S;
    }, function (e, t, n) {
      n(109), n(50), n(62), n(458), n(464), n(467), n(469), e.exports = n(11).Map;
    }, function (e, t, n) {
      var i = n(459),
          r = n(184);
      e.exports = n(460)("Map", function (e) {
        return function () {
          return e(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      }, {
        get: function get(e) {
          var t = i.getEntry(r(this, "Map"), e);
          return t && t.v;
        },
        set: function set(e, t) {
          return i.def(r(this, "Map"), 0 === e ? 0 : e, t);
        }
      }, i, !0);
    }, function (e, t, n) {
      var i = n(22).f,
          r = n(82),
          o = n(114),
          a = n(30),
          s = n(110),
          l = n(63),
          u = n(104),
          c = n(142),
          p = n(150),
          f = n(19),
          h = n(106).fastKey,
          d = n(184),
          g = f ? "_s" : "size",
          m = function m(e, t) {
        var n,
            i = h(t);
        if ("F" !== i) return e._i[i];

        for (n = e._f; n; n = n.n) {
          if (n.k == t) return n;
        }
      };

      e.exports = {
        getConstructor: function getConstructor(e, t, n, u) {
          var c = e(function (e, i) {
            s(e, c, t, "_i"), e._t = t, e._i = r(null), e._f = void 0, e._l = void 0, e[g] = 0, null != i && l(i, n, e[u], e);
          });
          return o(c.prototype, {
            clear: function clear() {
              for (var e = d(this, t), n = e._i, i = e._f; i; i = i.n) {
                i.r = !0, i.p && (i.p = i.p.n = void 0), delete n[i.i];
              }

              e._f = e._l = void 0, e[g] = 0;
            },
            delete: function _delete(e) {
              var n = d(this, t),
                  i = m(n, e);

              if (i) {
                var r = i.n,
                    o = i.p;
                delete n._i[i.i], i.r = !0, o && (o.n = r), r && (r.p = o), n._f == i && (n._f = r), n._l == i && (n._l = o), n[g]--;
              }

              return !!i;
            },
            forEach: function forEach(e) {
              d(this, t);

              for (var n, i = a(e, arguments.length > 1 ? arguments[1] : void 0, 3); n = n ? n.n : this._f;) {
                for (i(n.v, n.k, this); n && n.r;) {
                  n = n.p;
                }
              }
            },
            has: function has(e) {
              return !!m(d(this, t), e);
            }
          }), f && i(c.prototype, "size", {
            get: function get() {
              return d(this, t)[g];
            }
          }), c;
        },
        def: function def(e, t, n) {
          var i,
              r,
              o = m(e, t);
          return o ? o.v = n : (e._l = o = {
            i: r = h(t, !0),
            k: t,
            v: n,
            p: i = e._l,
            n: void 0,
            r: !1
          }, e._f || (e._f = o), i && (i.n = o), e[g]++, "F" !== r && (e._i[r] = o)), e;
        },
        getEntry: m,
        setStrong: function setStrong(e, t, n) {
          u(e, t, function (e, n) {
            this._t = d(e, t), this._k = n, this._l = void 0;
          }, function () {
            for (var e = this._k, t = this._l; t && t.r;) {
              t = t.p;
            }

            return this._t && (this._l = t = t ? t.n : this._t._f) ? c(0, "keys" == e ? t.k : "values" == e ? t.v : [t.k, t.v]) : (this._t = void 0, c(1));
          }, n ? "entries" : "values", !n, !0), p(t);
        }
      };
    }, function (e, t, n) {
      var i = n(16),
          r = n(14),
          o = n(106),
          a = n(42),
          s = n(34),
          l = n(114),
          u = n(63),
          c = n(110),
          p = n(23),
          f = n(61),
          h = n(22).f,
          d = n(461)(0),
          g = n(19);

      e.exports = function (e, t, n, m, y, _) {
        var v = i[e],
            b = v,
            w = y ? "set" : "add",
            x = b && b.prototype,
            k = {};
        return g && "function" == typeof b && (_ || x.forEach && !a(function () {
          new b().entries().next();
        })) ? (b = t(function (t, n) {
          c(t, b, e, "_c"), t._c = new v(), null != n && u(n, y, t[w], t);
        }), d("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","), function (e) {
          var t = "add" == e || "set" == e;
          !(e in x) || _ && "clear" == e || s(b.prototype, e, function (n, i) {
            if (c(this, b, e), !t && _ && !p(n)) return "get" == e && void 0;

            var r = this._c[e](0 === n ? 0 : n, i);

            return t ? this : r;
          });
        }), _ || h(b.prototype, "size", {
          get: function get() {
            return this._c.size;
          }
        })) : (b = m.getConstructor(t, e, y, w), l(b.prototype, n), o.NEED = !0), f(b, e), k[e] = b, r(r.G + r.W + r.F, k), _ || m.setStrong(b, e, y), b;
      };
    }, function (e, t, n) {
      var i = n(30),
          r = n(97),
          o = n(44),
          a = n(83),
          s = n(462);

      e.exports = function (e, t) {
        var n = 1 == e,
            l = 2 == e,
            u = 3 == e,
            c = 4 == e,
            p = 6 == e,
            f = 5 == e || p,
            h = t || s;
        return function (t, s, d) {
          for (var g, m, y = o(t), _ = r(y), v = i(s, d, 3), b = a(_.length), w = 0, x = n ? h(t, b) : l ? h(t, 0) : void 0; b > w; w++) {
            if ((f || w in _) && (m = v(g = _[w], w, y), e)) if (n) x[w] = m;else if (m) switch (e) {
              case 3:
                return !0;

              case 5:
                return g;

              case 6:
                return w;

              case 2:
                x.push(g);
            } else if (c) return !1;
          }

          return p ? -1 : u || c ? c : x;
        };
      };
    }, function (e, t, n) {
      var i = n(463);

      e.exports = function (e, t) {
        return new (i(e))(t);
      };
    }, function (e, t, n) {
      var i = n(23),
          r = n(143),
          o = n(17)("species");

      e.exports = function (e) {
        var t;
        return r(e) && ("function" != typeof (t = e.constructor) || t !== Array && !r(t.prototype) || (t = void 0), i(t) && null === (t = t[o]) && (t = void 0)), void 0 === t ? Array : t;
      };
    }, function (e, t, n) {
      var i = n(14);
      i(i.P + i.R, "Map", {
        toJSON: n(465)("Map")
      });
    }, function (e, t, n) {
      var i = n(85),
          r = n(466);

      e.exports = function (e) {
        return function () {
          if (i(this) != e) throw TypeError(e + "#toJSON isn't generic");
          return r(this);
        };
      };
    }, function (e, t, n) {
      var i = n(63);

      e.exports = function (e, t) {
        var n = [];
        return i(e, !1, n.push, n, t), n;
      };
    }, function (e, t, n) {
      n(468)("Map");
    }, function (e, t, n) {
      var i = n(14);

      e.exports = function (e) {
        i(i.S, e, {
          of: function of() {
            for (var e = arguments.length, t = new Array(e); e--;) {
              t[e] = arguments[e];
            }

            return new this(t);
          }
        });
      };
    }, function (e, t, n) {
      n(470)("Map");
    }, function (e, t, n) {
      var i = n(14),
          r = n(56),
          o = n(30),
          a = n(63);

      e.exports = function (e) {
        i(i.S, e, {
          from: function from(e) {
            var t,
                n,
                i,
                s,
                l = arguments[1];
            return r(this), (t = void 0 !== l) && r(l), null == e ? new this() : (n = [], t ? (i = 0, s = o(l, arguments[2], 2), a(e, !1, function (e) {
              n.push(s(e, i++));
            })) : a(e, !1, n.push, n), new this(n));
          }
        });
      };
    }, function (e, t) {
      e.exports = "varying vec2 v_texCoord;\n\n// Added to the calculated (x,y) texture coordinates, to actually sample the 'center' of a pixel\nconst vec2 halfCR = vec2(0.5, 0.5);\n\n// A uniform holding the dimensions (height/rows, width/cols) of the texture we're rendering to\nuniform vec2 output_texRC;\n\n// A uniform holding the virtual output dimensions when rendering to larger textures. This allows\n// making use of the viewport and only two very large textures to perform all tensor rendering.\nuniform vec2 output_sizeRC;\n\nbool isNaN(float val) {\n    return (val < 0.0 || 0.0 < val || val == 0.0) ? false : true;\n}\n\nbool hasNaN(vec4 values) {\n    vec4 v1 = values * values;\n    vec4 v2 = values * values;\n    return any(notEqual(v1, v2));\n}\n\nfloat getNaN(vec4 values) {\n    return dot(vec4(1), values);\n}\n\nint round(float value) {\n    return int(floor(value + 0.5));\n}\n\nint imod(int x, int y) {\n    return x - y * (x / y);\n}\n\n//Based on the work of Dave Hoskins\n//https://www.shadertoy.com/view/4djSRW\n#define HASHSCALE1 443.8975\nfloat random(float seed){\n    vec2 p = v_texCoord * seed;\n    vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);\n    p3 += dot(p3, p3.yzx + 19.19);\n    return fract((p3.x + p3.y) * p3.z);\n}\n\nvec2 UVfrom1D(vec2 texNumRC, vec2 sizeRC, int index) {\n    int logR = index / int(sizeRC.y);\n    int logC = index - logR * int(sizeRC.y);\n    return (vec2(logC, logR) + halfCR) / texNumRC.yx;\n}\n\nvec2 UVfrom2D(vec2 texNumRC, vec2 sizeRC, int numC, int row, int col) {\n  // Calculate x & y in logical size\n  int index = row * numC + col;\n  int logR = index / int(sizeRC.y);\n  int logC = index - logR * int(sizeRC.y);\n\n  // Return relative positions of row & col in texture size\n  return (vec2(logC, logR) + halfCR) / texNumRC.yx;\n}\n\nvec2 UVfrom4D(vec2 texNumRC, vec2 sizeRC, int stride0,\n    int stride1, int stride2, int row, int col, int depth,\n    int depth2) {\n    // Explicitly use integer operations as dot() only works on floats.\n    int index = row * stride0 + col * stride1 + depth * stride2 + depth2;\n    int logR = index / int(sizeRC.y);\n    int logC = index - logR * int(sizeRC.y);\n\n    return (vec2(logC, logR) + halfCR) / texNumRC.yx;\n}\n\nfloat sampleTexture(sampler2D textureSampler, vec2 uv) {\n    return texture2D(textureSampler, uv).r;\n}\n";
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return h;
      });

      var i = n(0),
          r = n.n(i),
          o = n(10),
          a = n.n(o),
          s = n(131),
          l = n.n(s),
          u = n(4),
          c = (n.n(u), n(38)),
          p = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          f = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._targetTextureFormatMap = new l.a(), this._floatTargetPool = [], this._intTargetPool = [], this._renderer = t, this._internalFloatType = n.renderTextureType, this._internalFloatTextureFormat = n.renderTextureFormat;
        }

        return p(e, [{
          key: "prebuildRenderTargets",
          value: function value(e, t, n) {
            for (var i = this, r = [], o = 0; o < e; o++) {
              r.push(new a.a(function (e) {
                var r = i._createRenderTarget(t, n),
                    o = i._uniqueIDForTarget(r);

                i._targetTextureFormatMap.set(o, n), i.pushRenderTarget(r), e();
              }));
            }

            return a.a.all(r);
          }
        }, {
          key: "pushRenderTarget",
          value: function value(e) {
            var t = this._uniqueIDForTarget(e),
                n = this._targetTextureFormatMap.get(t);

            if (n) switch (n) {
              case h.FLOAT:
                this._floatTargetPool.push(e);

                break;

              case h.INT:
                this._intTargetPool.push(e);

            }
          }
        }, {
          key: "popRenderTarget",
          value: function value(e, t) {
            var n = null;
            t === h.FLOAT ? n = this._extractTargetFromPool(this._floatTargetPool, e) : t === h.INT && (n = this._extractTargetFromPool(this._intTargetPool, e)), n || (n = this._createRenderTarget(e, t));

            var i = this._uniqueIDForTarget(n);

            return this._targetTextureFormatMap.set(i, t), n;
          }
        }, {
          key: "getFormatOfRenderTarget",
          value: function value(e) {
            return null === e ? null : this._targetTextureFormatMap.get(e._baseTexture.id);
          }
        }, {
          key: "dispose",
          value: function value() {
            this._targetTextureFormatMap.clear(), this._floatTargetPool.forEach(function (e) {
              e.dispose();
            }), this._floatTargetPool = null, this._intTargetPool.forEach(function (e) {
              e.dispose();
            }), this._intTargetPool = null;
          }
        }, {
          key: "_uniqueIDForTarget",
          value: function value(e) {
            return null === e ? null : null !== e.getBaseTexture() ? e.getBaseTexture().id : null;
          }
        }, {
          key: "_extractTargetFromPool",
          value: function value(e, t) {
            var n = e.filter(function (e) {
              var n = e.getFrame().getSize();
              return n.x === t.x && n.y && t.y;
            }).shift();

            if (n) {
              var i = e.indexOf(n);
              e.splice(i, 1);
            }

            return n;
          }
        }, {
          key: "_createRenderTarget",
          value: function value(e, t) {
            var n = new u.Engine.WebGLRenderTarget(this._renderer, e.x, e.y, 1);
            n.getBaseTexture().setMinFilter(u.Engine.BaseTexture.NearestFilter), n.getBaseTexture().setMagFilter(u.Engine.BaseTexture.NearestFilter), n.getBaseTexture().setMipMappingEnabled(!1), n.setFrame(new c.Rectangle(0, 0, e.x, e.y));

            var i = this._renderer.getContext();

            i.bindTexture(i.TEXTURE_2D, n.getBaseTexture().getGLTextureForRenderer(this._renderer));
            var r = t === h.FLOAT ? this._internalFloatType : i.UNSIGNED_BYTE,
                o = t === h.FLOAT ? this._internalFloatTextureFormat : i.RGBA;
            return i.texImage2D(i.TEXTURE_2D, 0, o, e.x, e.y, 0, o, r, null), n;
          }
        }]), e;
      }(),
          h = {
        FLOAT: "float",
        INT: "int"
      };

      t.b = f;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(10),
          a = n.n(o),
          s = n(131),
          l = n.n(s),
          u = n(13),
          c = n(54),
          p = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          f = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._filterInputToTextureMap = new l.a(), this._renderer = t;

          var i = this._renderer.getContext();

          this._internalFloatType = n.weightTextureType, this._internalFloatTextureFormat = n.weightTextureFormat, this._numChannels = n.weightTextureFormat === i.RGBA ? 4 : 1, this._internalFloatType !== i.FLOAT && this._prepareFloatConversionTables();
        }

        return p(e, [{
          key: "createAndLoadTexturesForFilter",
          value: function value(e, t) {
            var n = this;
            return new a.a(function (i) {
              e.getInputs().forEach(function (i, r) {
                if (i.type === u.a.DATA) {
                  var o = i.data,
                      a = i.logicalShape,
                      s = n._createTexture(),
                      l = n._uploadDataToTexture(s, o, a, n._numChannels),
                      c = t + "_" + i.name;

                  n._filterInputToTextureMap.set(c, l), n._renderer.getContext().flush(), e.getInputs()[r].data = null;
                }
              }), i();
            });
          }
        }, {
          key: "bindTexturesForFilter",
          value: function value(e, t, n) {
            var i = this,
                r = this._renderer.getContext(),
                o = 0;

            return e.getInputs().forEach(function (a, s) {
              if (a.type === u.a.DATA) {
                var l = i._filterInputToTextureMap.get(t + "_" + a.name),
                    c = l.texture,
                    p = l.size;

                if (!c) throw new Error("Missing texture for filter " + s + ".");
                r.activeTexture(r.TEXTURE0 + n + o), r.bindTexture(r.TEXTURE_2D, c), e.setTextureSizeForInputWithName(p, a.name), e.setLogicalSizeForInputWithName(p, a.name), o++;
              }
            }), o;
          }
        }, {
          key: "updateTexturesForFilter",
          value: function value(e, t) {
            var n = this;
            e.getInputs().forEach(function (e) {
              if (e.type === u.a.DATA && null !== e.data) {
                var i = n._filterInputToTextureMap.get(t + "_" + e.name).texture;

                n._uploadDataToTexture(i, e.data, e.logicalShape, n._numChannels);
              }
            }, this);
          }
        }, {
          key: "dispose",
          value: function value() {
            var e = this._renderer.getContext();

            this._filterInputToTextureMap.forEach(function (t) {
              "undefined" !== t && e.deleteTexture(t.texture);
            }), this._filterInputToTextureMap.clear();
          }
        }, {
          key: "_createTexture",
          value: function value() {
            var e = this._renderer.getContext(),
                t = e.createTexture();

            return e.activeTexture(e.TEXTURE0), e.bindTexture(e.TEXTURE_2D, t), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), t;
          }
        }, {
          key: "_uploadDataToTexture",
          value: function value(e, t, n, i) {
            var r = c.a.getTextureDimensionsForLogicalShape(n),
                o = c.a.getSizeOfLogicalShape(n);
            if (t.length !== o) throw new Error("Not enough or too many values (" + t.length + ") for shape " + n + ".");

            var a = this._renderer.getContext(),
                s = this._internalFloatType !== a.FLOAT,
                l = this._createArrayBufferForUpload(t, r, i, s);

            return a.bindTexture(a.TEXTURE_2D, e), a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), 1 === i && a.pixelStorei(a.UNPACK_ALIGNMENT, 1), a.texImage2D(a.TEXTURE_2D, 0, this._internalFloatTextureFormat, r[1], r[0], 0, this._internalFloatTextureFormat, this._internalFloatType, l), a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), a.pixelStorei(a.UNPACK_ALIGNMENT, 4), {
              texture: e,
              size: r
            };
          }
        }, {
          key: "_createArrayBufferForUpload",
          value: function value(e, t, n, i) {
            if (1 === n && !1 === i) return e;

            for (var r = t[0] * t[1] * n, o = i ? new Uint16Array(r) : new Float32Array(r), a = 4 === n, s = 0, l = 0; l < e.length; l++) {
              o[s] = i ? this._toHalfFloat(e[l]) : e[l], a && (o[s + 3] = 1), s += n;
            }

            return o;
          }
        }, {
          key: "_prepareFloatConversionTables",
          value: function value() {
            var e = new ArrayBuffer(4);
            this._floatView = new Float32Array(e), this._uint32View = new Uint32Array(e);

            for (var t = new Uint32Array(512), n = new Uint32Array(512), i = 0; i < 256; ++i) {
              var r = i - 127;
              r < -27 ? (t[0 | i] = 0, t[256 | i] = 32768, n[0 | i] = 24, n[256 | i] = 24) : r < -14 ? (t[0 | i] = 1024 >> -r - 14, t[256 | i] = 1024 >> -r - 14 | 32768, n[0 | i] = -r - 1, n[256 | i] = -r - 1) : r <= 15 ? (t[0 | i] = r + 15 << 10, t[256 | i] = r + 15 << 10 | 32768, n[0 | i] = 13, n[256 | i] = 13) : r < 128 ? (t[0 | i] = 31744, t[256 | i] = 64512, n[0 | i] = 24, n[256 | i] = 24) : (t[0 | i] = 31744, t[256 | i] = 64512, n[0 | i] = 13, n[256 | i] = 13);
            }

            this._baseTable = t, this._shiftTable = n;
          }
        }, {
          key: "_toHalfFloat",
          value: function value(e) {
            this._floatView[0] = e;
            var t = this._uint32View[0],
                n = t >> 23 & 511;
            return this._baseTable[n] + ((8388607 & t) >> this._shiftTable[n]);
          }
        }]), e;
      }();

      t.a = f;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(4),
          a = (n.n(o), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function s(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      var l = o.Math.Vector2,
          u = function () {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 256,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .4;
          s(this, e), this._renderedTileIndices = [], this._unrenderedTileIndices = [], this._originalInputDimensions = t, this._tilingConfiguration = this._calculateTilingConfiguration(t, n, i), this._unrenderedTileIndices = this._generateSpiralingTileIndices(this._tilingConfiguration), this._maskCache = {};
        }

        return a(e, [{
          key: "_generateRandomTileIndices",
          value: function value(e) {
            for (var t = this, n = e.totalTileCount, i = function i() {
              return Math.floor(Math.random() * t._tilingConfiguration.totalTileCount);
            }, r = []; r.length < n;) {
              for (var o = i(); r.indexOf(o) > -1;) {
                o = i();
              }

              r.push(o);
            }

            return r;
          }
        }, {
          key: "_generateSpiralingTileIndices",
          value: function value(e) {
            var t = e.numHorizontalTiles,
                n = e.numVerticalTiles;
            return this._generateSpiralingIndicies(t, n);
          }
        }, {
          key: "_generateSpiralingIndicies",
          value: function value(e, t) {
            for (var n = [], i = 0, r = 0, o = [0, -1], a = e % 2 == 0, s = t % 2 == 0, l = Math.floor(e / 2) - a, u = Math.floor(t / 2) - s, c = Math.pow(Math.max(e, t), 2); c > 0; c--) {
              -e / 2 < i && i <= e / 2 && -t / 2 < r && r <= t / 2 && n.push((u + r) * e + (l + i)), (i === r || i < 0 && i === -r || i > 0 && i === 1 - r) && (o = [-o[1], o[0]]), i += o[0], r += o[1];
            }

            return n.reverse();
          }
        }, {
          key: "calculateMaximumTileDimensions",
          value: function value() {
            for (var e = this._tilingConfiguration.totalTileCount, t = new l(0, 0), n = 0; n < e; n++) {
              var i = this.getOriginalInputCoordinatesForTileAtIndex(n).getSize();
              t.x = Math.max(i.x, t.x), t.y = Math.max(i.y, t.y);
            }

            return t;
          }
        }, {
          key: "reset",
          value: function value() {
            var e = this._tilingConfiguration,
                t = e.tileEdgeLength,
                n = e.overlappingFactor;
            this._tilingConfiguration = this._calculateTilingConfiguration(this._originalInputDimensions, t, n), this._unrenderedTileIndices = this._generateSpiralingTileIndices(this._tilingConfiguration), this._renderedTileIndices = [], this._nextTileIndex = null;
          }
        }, {
          key: "getOriginalInputDimensions",
          value: function value() {
            return this._originalInputDimensions;
          }
        }, {
          key: "getNextTileIndex",
          value: function value() {
            return this.hasRenderedAllTiles() ? -1 : (this._nextTileIndex || (this._nextTileIndex = this._unrenderedTileIndices.pop()), this._nextTileIndex);
          }
        }, {
          key: "getTilingConfiguration",
          value: function value() {
            return this._tilingConfiguration;
          }
        }, {
          key: "getRenderedTileCount",
          value: function value() {
            return this._renderedTileIndices.length;
          }
        }, {
          key: "getRenderingProgress",
          value: function value() {
            return this.getRenderedTileCount() / this._tilingConfiguration.totalTileCount;
          }
        }, {
          key: "getTileCoordinates",
          value: function value(e) {
            return {
              rowIndex: Math.floor(e / this._tilingConfiguration.numHorizontalTiles),
              columnIndex: Math.floor(e % this._tilingConfiguration.numHorizontalTiles)
            };
          }
        }, {
          key: "getOriginalInputCoordinatesForTileAtIndex",
          value: function value(e) {
            var t = this._tilingConfiguration,
                n = t.tileEdgeLength,
                i = t.overlappingFactor,
                r = t.fittedInputDimensions,
                a = t.numHorizontalTiles,
                s = t.numVerticalTiles,
                l = this.getTileCoordinates(e),
                u = l.rowIndex,
                c = l.columnIndex,
                p = Math.ceil(u * (n * (1 - i))),
                f = Math.ceil(c * (n * (1 - i))),
                h = this._originalInputDimensions.x / r.x,
                d = this._originalInputDimensions.y / r.y,
                g = Math.ceil(p * d),
                m = Math.ceil(f * h),
                y = Math.ceil(n * d),
                _ = Math.ceil(n * h);

            return u === s - 1 && g + y < this._originalInputDimensions.y && (g += this._originalInputDimensions.y - (g + y)), c === a - 1 && m + _ < this._originalInputDimensions.x && (m += this._originalInputDimensions.x - (m + _)), new o.Math.Rectangle(m, g, _, y);
          }
        }, {
          key: "hasRenderedAllTiles",
          value: function value() {
            return !(!this._tilingConfiguration || !this._renderedTileIndices) && this._tilingConfiguration.totalTileCount - this._renderedTileIndices.length == 0;
          }
        }, {
          key: "markTileAsRendered",
          value: function value() {
            null !== this._nextTileIndex && (!this._renderedTileIndices.indexOf(this._nextTileIndex) > -1 && this._renderedTileIndices.push(this._nextTileIndex), this._nextTileIndex = null);
          }
        }, {
          key: "_calculateTilingConfiguration",
          value: function value(e, t, n) {
            var i = Math.ceil((1 - n) * t),
                r = Math.ceil((e.x - t) / i) * i,
                a = t + r,
                s = Math.ceil((e.y - t) / i) * i,
                l = t + s,
                u = new o.Math.Vector2(a, l),
                c = Math.max(1, 1 + Math.round(s / i)),
                p = Math.max(1, 1 + Math.round(r / i));
            return {
              tileEdgeLength: t,
              overlappingFactor: n,
              fittedInputDimensions: u,
              numVerticalTiles: c,
              numHorizontalTiles: p,
              totalTileCount: c * p
            };
          }
        }, {
          key: "getBlendLeftTopRightBottomForTile",
          value: function value(e) {
            var t = this.getTileCoordinates(e),
                n = t.rowIndex,
                i = t.columnIndex,
                r = this._tilingConfiguration,
                o = r.numVerticalTiles;
            return [0 !== i ? 1 : 0, 0 !== n ? 1 : 0, i !== r.numHorizontalTiles - 1 ? 1 : 0, n !== o - 1 ? 1 : 0];
          }
        }]), e;
      }();

      t.a = u;
    }, function (e, t, n) {
      var i = n(188),
          r = n(191),
          o = n(190),
          a = n(196),
          s = n(476),
          l = n(186),
          u = n(189),
          c = n(194),
          p = n(132),
          f = n(192),
          h = n(477),
          d = n(195),
          g = n(197),
          m = n(13),
          y = n(185),
          _ = n(193),
          v = {
        AddFilter: i.a,
        Conv2DDepthwiseFilter: r.a,
        Conv2DFilter: o.a,
        EdgePadFilter: a.a,
        EncodeFloatFilter: s.a,
        FeatheredMaskingFilter: l.a,
        FinalizeStyleFilter: u.a,
        InstanceNormReluFilter: c.a,
        PackRGBAFilter: p.a,
        ReduceSumFilter: f.a,
        ReflectionPadFilter: h.a,
        ResizeBilinearFilter: d.a,
        SharpenFilter: g.a,
        TensorFilter: m.b,
        UnpackRGBAFilter: y.a,
        VariancePreparationFilter: _.a
      };

      t.a = v;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(13),
          f = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function d(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var g = function (e) {
        function t() {
          return h(this, t), d(this, (t.__proto__ || c()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), f(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            return this._options.inputs[0].logicalShape;
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            var e = "\nconst float FLOAT_MAX = 1.70141184e38;\nconst float FLOAT_MIN = 1.17549435e-38;\n\nlowp vec4 encode_float(highp float v) {\n  if (isNaN(v)) {\n    return vec4(255, 255, 255, 255);\n  }\n\n  highp float av = abs(v);\n\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n  }\n\n  highp vec4 c = vec4(0,0,0,0);\n\n  highp float e = floor(log2(av));\n  highp float m = exp2(fract(log2(av))) - 1.0;\n\n  c[2] = floor(128.0 * m);\n  m -= c[2] / 128.0;\n  c[1] = floor(32768.0 * m);\n  m -= c[1] / 32768.0;\n  c[0] = floor(8388608.0 * m);\n\n  highp float ebias = e + 127.0;\n  c[3] = floor(ebias / 2.0);\n  ebias -= c[3] * 2.0;\n  c[2] += floor(ebias) * 128.0;\n\n  c[3] += 128.0 * step(0.0, -v);\n\n  return c / 255.0;\n}\n    ";
            return 4 === this._options.inputs[0].logicalShape.length ? e += "\nvoid main ()\n{\n  ivec4 coords = getOutputCoords();\n  float xVal = getX(coords.x, coords.y, coords.z, coords.w);\n  gl_FragColor = encode_float(xVal);\n}\n    " : e += "\nvoid main ()\n{\n  ivec2 coords = getOutputCoords();\n  float xVal = getX(coords.x, coords.y);\n  gl_FragColor = encode_float(xVal);\n}\n    ", e;
          }
        }]), t;
      }(p.b);

      t.a = g;
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(13),
          d = n(4),
          g = (n.n(d), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }());

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_calculateOutputShape",
          value: function value() {
            var e = this._options.paddings;
            if (1 === !this.getInputs().length || 0 === this.getInputs().length) throw new Error("ReflectionPadFilter requires single input.");
            var t = this.getInputs()[0].logicalShape;
            if (e.length !== t.length) throw new Error("Not enough or too many paddings for input shape " + t);
            return e.map(function (e, n) {
              return e[0] + t[n] + e[1];
            });
          }
        }, {
          key: "_getTensorOperationSource",
          value: function value() {
            var e = this.getInputs()[0].logicalShape.length,
                t = this._options.paddings.map(function (e) {
              return e[0];
            }).join(","),
                n = this._options.paddings.map(function (e) {
              return e[1];
            }).join(","),
                i = "\n      int reflectedIndexInInputForPadBefore(int coord, int start) {\n        return int(abs(float(start - coord)));\n      }\n\n      int reflectedIndexInInputForPadAfter(int coord, int start,\n        int length, int afterPad) {\n        int indexInPad = coord - start - length;\n        int index = length - indexInPad - 2;\n        return index;\n      }\n    ",
                r = "\n      ivec2 get2DCoordinates(\n        ivec2 outC,\n        ivec2 coords,\n        ivec2 start,\n        ivec2 end,\n        ivec2 afterPad,\n        int height,\n        int width) {\n\n        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {\n          // Select non-padding rows\n          if (outC.x >= start.x && outC.x < start.x + height) {\n            // Select before pad columns\n            if (outC.y < start.y) {\n              int yIndex =\n                reflectedIndexInInputForPadBefore(outC.y, start.y);\n              return ivec2(coords.x, yIndex);\n            // Select after pad columns\n            } else if (outC.y >= start.y + width) {\n              int yIndex =\n                reflectedIndexInInputForPadAfter(outC.y, start.y,\n                  width, afterPad.y);\n              return ivec2(coords.x, yIndex);\n            }\n\n          // Select top and bottom rows, but only non-padding columns\n          } else if (outC.y >= start.y && outC.y < start.y + height) {\n            // Select top padding rows\n            if (outC.x < start.x) {\n              int xIndex =\n                reflectedIndexInInputForPadBefore(outC.x, start.x);\n              return ivec2(xIndex, coords.y);\n            // Select bottom padding rows\n            } else {\n              int xIndex =\n                reflectedIndexInInputForPadAfter(outC.x, start.x, height,\n                  afterPad.x);\n              return ivec2(xIndex, coords.y);\n            }\n\n          // Handle diagonal corner cases\n          } else if (outC.x < start.x && outC.y < end.y) { // Top Left\n            ivec2 index = outC - start;\n            vec2 absIndex = vec2(abs(float(index.x)), abs(float(index.y)));\n            return ivec2(int(absIndex.x), int(absIndex.y));\n          } else if (outC.x < start.x && outC.y >= end.y) { // Top Right\n            int targetCol =\n              reflectedIndexInInputForPadAfter(outC.y, start.y, width,\n                afterPad.y);\n            int targetRow =\n              reflectedIndexInInputForPadBefore(outC.x, start.x);\n            return ivec2(targetRow, targetCol);\n          } else if (outC.x >= end.x && outC.y < end.y) { // Bottom Left\n            int targetRow =\n              reflectedIndexInInputForPadAfter(outC.x, start.x, height,\n                afterPad.x);\n            int targetCol =\n              reflectedIndexInInputForPadBefore(outC.y, start.y);\n            return ivec2(targetRow, targetCol);\n          } else if (outC.x >= end.x && outC.y >= end.y) { // Bottom Right\n            int targetRow =\n              reflectedIndexInInputForPadAfter(outC.x, start.x, height,\n                afterPad.x);\n            int targetCol =\n              reflectedIndexInInputForPadAfter(outC.y, start.y, width,\n                afterPad.y);\n            return ivec2(targetRow, targetCol);\n          }\n        } else {\n          return coords;\n        }\n      }\n    ";

            return 1 === e ? "\n        int start = " + t + ";\n        int end = start + x_shape;\n        int width = x_shape[0];\n        int afterPad = " + n + ";\n\n        " + i + "\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start) {\n            int index = reflectedIndexInInputForPadBefore(outC, start);\n            setOutput(getX(index));\n          } else if (outC >= end) {\n            int index =\n            reflectedIndexInInputForPadAfter(outC, start, width, afterPad);\n            setOutput(getX(index));\n          } else {\n            setOutput(getX(outC - start));\n          }\n        }\n      " : 2 === e ? "\n        ivec2 start = ivec2(" + t + ");\n        ivec2 end = start + x_shape;\n        ivec2 afterPad = ivec2(" + n + ");\n        int height = x_shape[0];\n        int width = x_shape[1];\n\n        " + i + "\n        " + r + "\n\n        void main() {\n          ivec2 outC = getOutputCoords();\n          ivec2 coords = outC - start;\n          ivec2 coordsInSrcVec = get2DCoordinates(\n            outC,\n            coords,\n            start,\n            end,\n            afterPad,\n            height,\n            width\n          );\n          setOutput(getX(coordsInSrcVec.x, coordsInSrcVec.y));\n        }\n      " : 4 === e ? "\n        ivec4 start = ivec4(" + t + ");\n        ivec4 end = start + x_shape;\n        ivec4 afterPad = ivec4(" + n + ");\n        int length = x_shape[0];\n\n        " + i + "\n        " + r + "\n        \n      ivec3 get3DCoordinates(\n        ivec3 outC,\n        ivec3 coords,\n        ivec3 start,\n        ivec3 end,\n        ivec3 afterPad,\n        int length,\n        int height,\n        int width) {\n        if (any(lessThan(outC, start))\n          || any(greaterThanEqual(outC, end))) {\n\n          // Calculate the current positions inner indices in the original\n          // input tensor\n          ivec2 innerIndices = get2DCoordinates(\n            ivec2(outC.y, outC.z),\n            ivec2(coords.y, coords.z),\n            ivec2(start.y, start.z),\n            ivec2(end.y, end.z),\n            ivec2(afterPad.y, afterPad.z),\n            height,\n            width\n          );\n\n          if (outC.x < start.x) {\n            int outerIndex =\n              reflectedIndexInInputForPadBefore(outC.x, start.x);\n            return ivec3(outerIndex, innerIndices.x, innerIndices.y);\n          } else if (outC.x >= end.x) {\n            int outerIndex = reflectedIndexInInputForPadAfter(\n              outC.x, start.x, length, afterPad.x);\n            return ivec3(outerIndex, innerIndices.x, innerIndices.y);\n          } else {\n            return ivec3(coords.x, innerIndices.x, innerIndices.y);\n          }\n        } else {\n          return coords;\n        }\n      }\n    \n\n        void main() {\n          ivec4 outC = getOutputCoords();\n          ivec4 coords = outC - start; // Coords in input\n\n          if (any(lessThan(outC, start))\n              || any(greaterThanEqual(outC, end))) {\n\n            ivec3 innerIndices = get3DCoordinates(\n              ivec3(outC.y, outC.z, outC.w),\n              ivec3(coords.y, coords.z, coords.w),\n              ivec3(start.y, start.z, start.w),\n              ivec3(end.y, end.z, end.w),\n              ivec3(afterPad.y, afterPad.z, afterPad.w),\n              x_shape[1],\n              x_shape[2],\n              x_shape[3]\n            );\n\n            if (outC.x < start.x) {\n              int outerIndex =\n                reflectedIndexInInputForPadBefore(outC.x, start.x);\n              setOutput(getX(\n                  outerIndex,\n                  innerIndices.x,\n                  innerIndices.y,\n                  innerIndices.z\n                ));\n            } else if (outC.x >= end.x) {\n              int outerIndex = reflectedIndexInInputForPadAfter(\n                outC.x, start.x, length, afterPad.x);\n              setOutput(getX(\n                outerIndex,\n                innerIndices.x,\n                innerIndices.y,\n                innerIndices.z\n              ));\n            } else {\n              setOutput(getX(\n                coords.x,\n                innerIndices.x,\n                innerIndices.y,\n                innerIndices.z));\n            }\n          } else {\n            setOutput(getX(coords.x, coords.y, coords.z, coords.w));\n          }\n        }\n      " : void 0;
          }
        }]), t;
      }(h.b);

      _.prototype.availableOptions = r()({
        paddings: {
          type: d.OptionType.ARRAY,
          required: !0
        }
      }, h.b.prototype.availableOptions), t.a = _;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = n.n(p),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var m = p.Math.Vector2,
          y = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._flipContainer = new p.Engine.Container(), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_render",
          value: function value(e) {
            var t = this._options,
                n = t.position,
                i = t.rotation,
                r = t.scale,
                o = t.pivot,
                a = t.outputResolution,
                s = this._sdk.getTextureScale(),
                l = a.clone().multiply(s).ceil();

            return this._renderTexture.resizeTo(l), this._sprite.setRotation(i), this._sprite.setPosition(n), this._sprite.setPivot(o), this._sprite.setScale(r), this._renderTexture.render(this._container), p.Promise.resolve();
          }
        }, {
          key: "getNewDimensions",
          value: function value(e) {
            var t = this._sdk.getTextureScale();

            return this._options.outputResolution.clone().multiply(t).ceil();
          }
        }]), t;
      }(p.Operation);

      y.identifier = "output", y.prototype.availableOptions = {
        position: {
          type: p.OptionType.VECTOR2,
          default: new m(0, 0)
        },
        rotation: {
          type: p.OptionType.NUMBER,
          default: 0
        },
        scale: {
          type: p.OptionType.VECTOR2,
          default: new m(1, 1)
        },
        pivot: {
          type: p.OptionType.VECTOR2,
          default: new m(0, 0)
        },
        outputResolution: {
          type: p.OptionType.VECTOR2,
          default: new m(100, 100)
        }
      }, f.a.Operations.OutputOperation = y, t.a = y;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(1),
          c = n.n(u),
          p = n(4),
          f = n.n(p),
          h = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function d(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function g(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      p.Math.Vector2;

      var m = function (e) {
        function t() {
          var e;
          d(this, t);

          for (var n = arguments.length, i = Array(n), r = 0; r < n; r++) {
            i[r] = arguments[r];
          }

          var o = g(this, (e = t.__proto__ || c()(t)).call.apply(e, [this].concat(i)));
          return o._flipContainer = new p.Engine.Container(), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), h(t, [{
          key: "_render",
          value: function value(e) {
            var t = this._options,
                n = (t.outputResolution, t.flipHorizontally),
                i = t.flipVertically;

            if (n || i) {
              var r = e.getDimensions();
              this._flipRenderTexture ? this._flipRenderTexture.resizeTo(r) : (this._flipRenderTexture = new p.Engine.RenderTexture(this._sdk.getRenderer(), r.x, r.y), this._flipSprite = new p.Engine.Sprite(this._flipRenderTexture), this._flipContainer.addChild(this._flipSprite));
              var o = n ? -1 : 1,
                  a = i ? -1 : 1;
              this._flipSprite.setScale(o, a), this._flipSprite.setPivot(0, 0), this._flipSprite.setPosition(r.x * (1 - o) * .5, r.y * (1 - a) * .5), this._flipRenderTexture.clear(), this._flipRenderTexture.render(this._container), this._renderTexture.render(this._flipContainer);
            } else this._renderTexture.render(this._container);

            return p.Promise.resolve();
          }
        }]), t;
      }(p.Operation);

      m.identifier = "flip", m.prototype.availableOptions = {
        flipHorizontally: {
          type: p.OptionType.BOOLEAN,
          default: !1
        },
        flipVertically: {
          type: p.OptionType.BOOLEAN,
          default: !1
        }
      }, f.a.Operations.FlipOperation = m, t.a = m;
    }, function (e, t, n) {
      t.a = {
        getIEVersion: function getIEVersion() {
          var e = navigator,
              t = e.userAgent,
              n = e.appVersion;
          return -1 !== n.indexOf("MSIE") ? n.match(/MSIE\s+?([0-9]+)/i)[1] : -1 !== t.indexOf("Trident") && t.match(/rv:([0-9]+)/i)[1];
        },
        isIE10: function isIE10() {
          var e = this.getIEVersion();
          return !1 !== e && 10 === e;
        },
        isIE11: function isIE11() {
          var e = this.getIEVersion();
          return !1 !== e && 11 === e;
        },
        isIElte: function isIElte(e) {
          var t = this.getIEVersion();
          return !1 !== t && t <= e;
        }
      };
    }, function (e, t) {
      e.exports = {
        "pesdk.adjustments.button.reset": "editor.controls.adjustments.reset",
        "pesdk.adjustments.text.brightness": "editor.controls.adjustments.items.brightness",
        "pesdk.adjustments.text.clarity": "editor.controls.adjustments.items.clarity",
        "pesdk.adjustments.text.contrast": "editor.controls.adjustments.items.contrast",
        "pesdk.adjustments.text.exposure": "editor.controls.adjustments.items.exposure",
        "pesdk.adjustments.text.gamma": "editor.controls.adjustments.items.gamma",
        "pesdk.adjustments.text.highlights": "editor.controls.adjustments.items.highlights",
        "pesdk.adjustments.text.saturation": "editor.controls.adjustments.items.saturation",
        "pesdk.adjustments.text.shadows": "editor.controls.adjustments.items.shadows",
        "pesdk.adjustments.title.basics": "editor.controls.adjustments.sections.basics",
        "pesdk.adjustments.title.name": "editor.controls.adjustments.title",
        "pesdk.adjustments.title.refinements": "editor.controls.adjustments.sections.refinements",
        "pesdk.brush.title.hardness": "editor.controls.brush.hardness",
        "pesdk.brush.title.name": "editor.controls.brush.title",
        "pesdk.brush.title.settings": "editor.controls.brush.settings",
        "pesdk.brush.title.width": "editor.controls.brush.width",
        "pesdk.common.button.cancel": "editor.cancel",
        "pesdk.common.text.loading": "loading.loading",
        "pesdk.common.title.error": "errors.title",
        "pesdk.editor.button.discardChangesWarningDiscard": "warnings.discardChanges.buttons.discard",
        "pesdk.editor.button.discardChangesWarningKeep": "warnings.discardChanges.buttons.keep",
        "pesdk.editor.button.export": "editor.export",
        "pesdk.editor.button.newImageChangesLostWarningNo": "warnings.newImage_changesLost.buttons.no",
        "pesdk.editor.button.newImageChangesLostWarningYes": "warnings.newImage_changesLost.buttons.yes",
        "pesdk.editor.text.discardChangesWarning": "warnings.discardChanges.text",
        "pesdk.editor.text.fontLoadingError": "errors.fontLoadingError.text",
        "pesdk.editor.text.imageLoadingError": "errors.imageLoadingError.text",
        "pesdk.editor.text.imageResizedWarning_maxDimensions": "warnings.imageResized_maxDimensions.text",
        "pesdk.editor.text.imageResizedWarning_maxMegaPixels": "warnings.imageResized_maxMegaPixels.text",
        "pesdk.editor.text.invalidFileTypeError": "errors.invalidFileType.text",
        "pesdk.editor.text.loadingFonts": "loading.fonts",
        "pesdk.editor.text.newImageChangesLostWarning": "warnings.newImage_changesLost.text",
        "pesdk.editor.text.renderingError": "errors.renderingError.text",
        "pesdk.editor.text.resizing": "loading.resizing",
        "pesdk.editor.text.webcamUnavailableError": "errors.webcamUnavailable.text",
        "pesdk.editor.title.discardChangesWarning": "warnings.discardChanges.title",
        "pesdk.editor.title.fontLoadingError": "errors.fontLoadingError.title",
        "pesdk.editor.title.imageResizedWarning_maxDimensions": "warnings.imageResized_maxDimensions.title",
        "pesdk.editor.title.imageResizedWarning_maxMegaPixels": "warnings.imageResized_maxMegaPixels.title",
        "pesdk.editor.title.newImageChangesLostWarning": "warnings.newImage_changesLost.title",
        "pesdk.filter.asset.identity": "editor.controls.filter.filters.identity",
        "pesdk.filter.asset.imgly_lut_ad1920": "editor.controls.filter.filters.imgly_lut_ad1920",
        "pesdk.filter.asset.imgly_lut_ancient": "editor.controls.filter.filters.imgly_lut_ancient",
        "pesdk.filter.asset.imgly_lut_bleached": "editor.controls.filter.filters.imgly_lut_bleached",
        "pesdk.filter.asset.imgly_lut_bleachedblue": "editor.controls.filter.filters.imgly_lut_bleachedblue",
        "pesdk.filter.asset.imgly_lut_blues": "editor.controls.filter.filters.imgly_lut_blues",
        "pesdk.filter.asset.imgly_lut_blueshadows": "editor.controls.filter.filters.imgly_lut_blueshadows",
        "pesdk.filter.asset.imgly_lut_breeze": "editor.controls.filter.filters.imgly_lut_breeze",
        "pesdk.filter.asset.imgly_lut_bw": "editor.controls.filter.filters.imgly_lut_bw",
        "pesdk.filter.asset.imgly_lut_celsius": "editor.controls.filter.filters.imgly_lut_celsius",
        "pesdk.filter.asset.imgly_lut_chest": "editor.controls.filter.filters.imgly_lut_chest",
        "pesdk.filter.asset.imgly_lut_classic": "editor.controls.filter.filters.imgly_lut_classic",
        "pesdk.filter.asset.imgly_lut_colorful": "editor.controls.filter.filters.imgly_lut_colorful",
        "pesdk.filter.asset.imgly_lut_cool": "editor.controls.filter.filters.imgly_lut_cool",
        "pesdk.filter.asset.imgly_lut_cottoncandy": "editor.controls.filter.filters.imgly_lut_cottoncandy",
        "pesdk.filter.asset.imgly_lut_creamy": "editor.controls.filter.filters.imgly_lut_creamy",
        "pesdk.filter.asset.imgly_lut_eighties": "editor.controls.filter.filters.imgly_lut_eighties",
        "pesdk.filter.asset.imgly_lut_elder": "editor.controls.filter.filters.imgly_lut_elder",
        "pesdk.filter.asset.imgly_lut_evening": "editor.controls.filter.filters.imgly_lut_evening",
        "pesdk.filter.asset.imgly_lut_fall": "editor.controls.filter.filters.imgly_lut_fall",
        "pesdk.filter.asset.imgly_lut_fixie": "editor.controls.filter.filters.imgly_lut_fixie",
        "pesdk.filter.asset.imgly_lut_food": "editor.controls.filter.filters.imgly_lut_food",
        "pesdk.filter.asset.imgly_lut_fridge": "editor.controls.filter.filters.imgly_lut_fridge",
        "pesdk.filter.asset.imgly_lut_front": "editor.controls.filter.filters.imgly_lut_front",
        "pesdk.filter.asset.imgly_lut_glam": "editor.controls.filter.filters.imgly_lut_glam",
        "pesdk.filter.asset.imgly_lut_gobblin": "editor.controls.filter.filters.imgly_lut_gobblin",
        "pesdk.filter.asset.imgly_lut_highcarb": "editor.controls.filter.filters.imgly_lut_highcarb",
        "pesdk.filter.asset.imgly_lut_highcontrast": "editor.controls.filter.filters.imgly_lut_highcontrast",
        "pesdk.filter.asset.imgly_lut_k1": "editor.controls.filter.filters.imgly_lut_k1",
        "pesdk.filter.asset.imgly_lut_k2": "editor.controls.filter.filters.imgly_lut_k2",
        "pesdk.filter.asset.imgly_lut_k6": "editor.controls.filter.filters.imgly_lut_k6",
        "pesdk.filter.asset.imgly_lut_kdynamic": "editor.controls.filter.filters.imgly_lut_kdynamic",
        "pesdk.filter.asset.imgly_lut_keen": "editor.controls.filter.filters.imgly_lut_keen",
        "pesdk.filter.asset.imgly_lut_lenin": "editor.controls.filter.filters.imgly_lut_lenin",
        "pesdk.filter.asset.imgly_lut_litho": "editor.controls.filter.filters.imgly_lut_litho",
        "pesdk.filter.asset.imgly_lut_lomo100": "editor.controls.filter.filters.imgly_lut_lomo100",
        "pesdk.filter.asset.imgly_lut_lucid": "editor.controls.filter.filters.imgly_lut_lucid",
        "pesdk.filter.asset.imgly_lut_mellow": "editor.controls.filter.filters.imgly_lut_mellow",
        "pesdk.filter.asset.imgly_lut_neat": "editor.controls.filter.filters.imgly_lut_neat",
        "pesdk.filter.asset.imgly_lut_nogreen": "editor.controls.filter.filters.imgly_lut_nogreen",
        "pesdk.filter.asset.imgly_lut_orchid": "editor.controls.filter.filters.imgly_lut_orchid",
        "pesdk.filter.asset.imgly_lut_pale": "editor.controls.filter.filters.imgly_lut_pale",
        "pesdk.filter.asset.imgly_lut_pitched": "editor.controls.filter.filters.imgly_lut_pitched",
        "pesdk.filter.asset.imgly_lut_plate": "editor.controls.filter.filters.imgly_lut_plate",
        "pesdk.filter.asset.imgly_lut_pola669": "editor.controls.filter.filters.imgly_lut_pola669",
        "pesdk.filter.asset.imgly_lut_polasx": "editor.controls.filter.filters.imgly_lut_polasx",
        "pesdk.filter.asset.imgly_lut_pro400": "editor.controls.filter.filters.imgly_lut_pro400",
        "pesdk.filter.asset.imgly_lut_quozi": "editor.controls.filter.filters.imgly_lut_quozi",
        "pesdk.filter.asset.imgly_lut_sepiahigh": "editor.controls.filter.filters.imgly_lut_sepiahigh",
        "pesdk.filter.asset.imgly_lut_settled": "editor.controls.filter.filters.imgly_lut_settled",
        "pesdk.filter.asset.imgly_lut_seventies": "editor.controls.filter.filters.imgly_lut_seventies",
        "pesdk.filter.asset.imgly_lut_sin": "editor.controls.filter.filters.imgly_lut_sin",
        "pesdk.filter.asset.imgly_lut_soft": "editor.controls.filter.filters.imgly_lut_soft",
        "pesdk.filter.asset.imgly_lut_steel": "editor.controls.filter.filters.imgly_lut_steel",
        "pesdk.filter.asset.imgly_lut_summer": "editor.controls.filter.filters.imgly_lut_summer",
        "pesdk.filter.asset.imgly_lut_sunset": "editor.controls.filter.filters.imgly_lut_sunset",
        "pesdk.filter.asset.imgly_lut_tender": "editor.controls.filter.filters.imgly_lut_tender",
        "pesdk.filter.asset.imgly_lut_texas": "editor.controls.filter.filters.imgly_lut_texas",
        "pesdk.filter.asset.imgly_lut_twilight": "editor.controls.filter.filters.imgly_lut_twilight",
        "pesdk.filter.asset.imgly_lut_winter": "editor.controls.filter.filters.imgly_lut_winter",
        "pesdk.filter.asset.imgly_lut_x400": "editor.controls.filter.filters.imgly_lut_x400",
        "pesdk.filter.title.name": "editor.controls.filter.title",
        "pesdk.focus.button.gaussian": "editor.controls.focus.items.gaussian",
        "pesdk.focus.button.linear": "editor.controls.focus.items.linear",
        "pesdk.focus.button.mirrored": "editor.controls.focus.items.mirrored",
        "pesdk.focus.button.none": "editor.controls.focus.items.none",
        "pesdk.focus.button.radial": "editor.controls.focus.items.radial",
        "pesdk.focus.title.name": "editor.controls.focus.title",
        "pesdk.frame.asset.imgly_frame_art_decor": "editor.controls.frame.frames.imgly_frame_art_decor",
        "pesdk.frame.asset.imgly_frame_black_passepartout": "editor.controls.frame.frames.imgly_frame_black_passepartout",
        "pesdk.frame.asset.imgly_frame_dia": "editor.controls.frame.frames.imgly_frame_dia",
        "pesdk.frame.asset.imgly_frame_lowpoly_shadow": "editor.controls.frame.frames.imgly_frame_lowpoly_shadow",
        "pesdk.frame.asset.imgly_frame_wood_passepartout": "editor.controls.frame.frames.imgly_frame_wood_passepartout",
        "pesdk.frame.button.fill": "editor.controls.frame.fill",
        "pesdk.frame.button.replace": "editor.controls.frame.replace",
        "pesdk.frame.title.name": "editor.controls.frame.title",
        "pesdk.frame.title.opacity": "editor.controls.frame.opacity",
        "pesdk.frame.title.width": "editor.controls.frame.width",
        "pesdk.library.button.fileDropZone": "editor.controls.library.fileDropZone",
        "pesdk.library.button.fileDropZoneHovered": "editor.controls.library.fileDropZoneHovered",
        "pesdk.library.placeholder.search": "editor.controls.library.search",
        "pesdk.library.text.noResults": "editor.controls.library.noResults",
        "pesdk.library.title.name": "editor.controls.library.title",
        "pesdk.overlay.asset.imgly_overlay_bokeh": "editor.controls.overlay.overlays.imgly_overlay_bokeh",
        "pesdk.overlay.asset.imgly_overlay_chop": "editor.controls.overlay.overlays.imgly_overlay_chop",
        "pesdk.overlay.asset.imgly_overlay_clouds": "editor.controls.overlay.overlays.imgly_overlay_clouds",
        "pesdk.overlay.asset.imgly_overlay_golden": "editor.controls.overlay.overlays.imgly_overlay_golden",
        "pesdk.overlay.asset.imgly_overlay_grain": "editor.controls.overlay.overlays.imgly_overlay_grain",
        "pesdk.overlay.asset.imgly_overlay_hearts": "editor.controls.overlay.overlays.imgly_overlay_hearts",
        "pesdk.overlay.asset.imgly_overlay_lightleak1": "editor.controls.overlay.overlays.imgly_overlay_lightleak1",
        "pesdk.overlay.asset.imgly_overlay_lightleak2": "editor.controls.overlay.overlays.imgly_overlay_lightleak2",
        "pesdk.overlay.asset.imgly_overlay_metal": "editor.controls.overlay.overlays.imgly_overlay_metal",
        "pesdk.overlay.asset.imgly_overlay_mosaic": "editor.controls.overlay.overlays.imgly_overlay_mosaic",
        "pesdk.overlay.asset.imgly_overlay_painting": "editor.controls.overlay.overlays.imgly_overlay_painting",
        "pesdk.overlay.asset.imgly_overlay_paper": "editor.controls.overlay.overlays.imgly_overlay_paper",
        "pesdk.overlay.asset.imgly_overlay_rain": "editor.controls.overlay.overlays.imgly_overlay_rain",
        "pesdk.overlay.asset.imgly_overlay_vintage": "editor.controls.overlay.overlays.imgly_overlay_vintage",
        "pesdk.overlay.asset.imgly_overlay_wall1": "editor.controls.overlay.overlays.imgly_overlay_wall1",
        "pesdk.overlay.asset.imgly_overlay_wall2": "editor.controls.overlay.overlays.imgly_overlay_wall2",
        "pesdk.overlay.asset.imgly_overlay_wood": "editor.controls.overlay.overlays.imgly_overlay_wood",
        "pesdk.overlay.button.none": "editor.controls.overlay.overlays.none",
        "pesdk.overlay.title.blending": "editor.controls.overlay.blendModes.blending",
        "pesdk.overlay.title.colorBurn": "editor.controls.overlay.blendModes.colorBurn",
        "pesdk.overlay.title.darken": "editor.controls.overlay.blendModes.darken",
        "pesdk.overlay.title.hardLight": "editor.controls.overlay.blendModes.hardLight",
        "pesdk.overlay.title.lighten": "editor.controls.overlay.blendModes.lighten",
        "pesdk.overlay.title.multiply": "editor.controls.overlay.blendModes.multiply",
        "pesdk.overlay.title.name": "editor.controls.overlay.title",
        "pesdk.overlay.title.none": "editor.controls.overlay.blendModes.none",
        "pesdk.overlay.title.normal": "editor.controls.overlay.blendModes.normal",
        "pesdk.overlay.title.overlay": "editor.controls.overlay.blendModes.overlay",
        "pesdk.overlay.title.screen": "editor.controls.overlay.blendModes.screen",
        "pesdk.overlay.title.softLight": "editor.controls.overlay.blendModes.softLight",
        "pesdk.sticker.asset.imgly_sticker_emoticons": "editor.controls.sticker.stickerCategories.imgly_sticker_emoticons",
        "pesdk.sticker.asset.imgly_sticker_emoticons_alien": "editor.controls.sticker.stickers.imgly_sticker_emoticons_alien",
        "pesdk.sticker.asset.imgly_sticker_emoticons_angel": "editor.controls.sticker.stickers.imgly_sticker_emoticons_angel",
        "pesdk.sticker.asset.imgly_sticker_emoticons_angry": "editor.controls.sticker.stickers.imgly_sticker_emoticons_angry",
        "pesdk.sticker.asset.imgly_sticker_emoticons_anxious": "editor.controls.sticker.stickers.imgly_sticker_emoticons_anxious",
        "pesdk.sticker.asset.imgly_sticker_emoticons_asleep": "editor.controls.sticker.stickers.imgly_sticker_emoticons_asleep",
        "pesdk.sticker.asset.imgly_sticker_emoticons_attention": "editor.controls.sticker.stickers.imgly_sticker_emoticons_attention",
        "pesdk.sticker.asset.imgly_sticker_emoticons_baby_chicken": "editor.controls.sticker.stickers.imgly_sticker_emoticons_baby_chicken",
        "pesdk.sticker.asset.imgly_sticker_emoticons_batman": "editor.controls.sticker.stickers.imgly_sticker_emoticons_batman",
        "pesdk.sticker.asset.imgly_sticker_emoticons_beer": "editor.controls.sticker.stickers.imgly_sticker_emoticons_beer",
        "pesdk.sticker.asset.imgly_sticker_emoticons_black": "editor.controls.sticker.stickers.imgly_sticker_emoticons_black",
        "pesdk.sticker.asset.imgly_sticker_emoticons_blue": "editor.controls.sticker.stickers.imgly_sticker_emoticons_blue",
        "pesdk.sticker.asset.imgly_sticker_emoticons_blush": "editor.controls.sticker.stickers.imgly_sticker_emoticons_blush",
        "pesdk.sticker.asset.imgly_sticker_emoticons_boxer": "editor.controls.sticker.stickers.imgly_sticker_emoticons_boxer",
        "pesdk.sticker.asset.imgly_sticker_emoticons_business": "editor.controls.sticker.stickers.imgly_sticker_emoticons_business",
        "pesdk.sticker.asset.imgly_sticker_emoticons_chicken": "editor.controls.sticker.stickers.imgly_sticker_emoticons_chicken",
        "pesdk.sticker.asset.imgly_sticker_emoticons_cool": "editor.controls.sticker.stickers.imgly_sticker_emoticons_cool",
        "pesdk.sticker.asset.imgly_sticker_emoticons_cry": "editor.controls.sticker.stickers.imgly_sticker_emoticons_cry",
        "pesdk.sticker.asset.imgly_sticker_emoticons_deceased": "editor.controls.sticker.stickers.imgly_sticker_emoticons_deceased",
        "pesdk.sticker.asset.imgly_sticker_emoticons_devil": "editor.controls.sticker.stickers.imgly_sticker_emoticons_devil",
        "pesdk.sticker.asset.imgly_sticker_emoticons_duckface": "editor.controls.sticker.stickers.imgly_sticker_emoticons_duckface",
        "pesdk.sticker.asset.imgly_sticker_emoticons_furious": "editor.controls.sticker.stickers.imgly_sticker_emoticons_furious",
        "pesdk.sticker.asset.imgly_sticker_emoticons_grin": "editor.controls.sticker.stickers.imgly_sticker_emoticons_grin",
        "pesdk.sticker.asset.imgly_sticker_emoticons_guitar": "editor.controls.sticker.stickers.imgly_sticker_emoticons_guitar",
        "pesdk.sticker.asset.imgly_sticker_emoticons_harry_potter": "editor.controls.sticker.stickers.imgly_sticker_emoticons_harry_potter",
        "pesdk.sticker.asset.imgly_sticker_emoticons_hippie": "editor.controls.sticker.stickers.imgly_sticker_emoticons_hippie",
        "pesdk.sticker.asset.imgly_sticker_emoticons_hitman": "editor.controls.sticker.stickers.imgly_sticker_emoticons_hitman",
        "pesdk.sticker.asset.imgly_sticker_emoticons_humourous": "editor.controls.sticker.stickers.imgly_sticker_emoticons_humourous",
        "pesdk.sticker.asset.imgly_sticker_emoticons_idea": "editor.controls.sticker.stickers.imgly_sticker_emoticons_idea",
        "pesdk.sticker.asset.imgly_sticker_emoticons_impatient": "editor.controls.sticker.stickers.imgly_sticker_emoticons_impatient",
        "pesdk.sticker.asset.imgly_sticker_emoticons_kiss": "editor.controls.sticker.stickers.imgly_sticker_emoticons_kiss",
        "pesdk.sticker.asset.imgly_sticker_emoticons_kisses": "editor.controls.sticker.stickers.imgly_sticker_emoticons_kisses",
        "pesdk.sticker.asset.imgly_sticker_emoticons_laugh": "editor.controls.sticker.stickers.imgly_sticker_emoticons_laugh",
        "pesdk.sticker.asset.imgly_sticker_emoticons_loud_cry": "editor.controls.sticker.stickers.imgly_sticker_emoticons_loud_cry",
        "pesdk.sticker.asset.imgly_sticker_emoticons_loving": "editor.controls.sticker.stickers.imgly_sticker_emoticons_loving",
        "pesdk.sticker.asset.imgly_sticker_emoticons_masked": "editor.controls.sticker.stickers.imgly_sticker_emoticons_masked",
        "pesdk.sticker.asset.imgly_sticker_emoticons_music": "editor.controls.sticker.stickers.imgly_sticker_emoticons_music",
        "pesdk.sticker.asset.imgly_sticker_emoticons_nerd": "editor.controls.sticker.stickers.imgly_sticker_emoticons_nerd",
        "pesdk.sticker.asset.imgly_sticker_emoticons_ninja": "editor.controls.sticker.stickers.imgly_sticker_emoticons_ninja",
        "pesdk.sticker.asset.imgly_sticker_emoticons_not_speaking_to_you": "editor.controls.sticker.stickers.imgly_sticker_emoticons_not_speaking_to_you",
        "pesdk.sticker.asset.imgly_sticker_emoticons_pig": "editor.controls.sticker.stickers.imgly_sticker_emoticons_pig",
        "pesdk.sticker.asset.imgly_sticker_emoticons_pumpkin": "editor.controls.sticker.stickers.imgly_sticker_emoticons_pumpkin",
        "pesdk.sticker.asset.imgly_sticker_emoticons_question": "editor.controls.sticker.stickers.imgly_sticker_emoticons_question",
        "pesdk.sticker.asset.imgly_sticker_emoticons_rabbit": "editor.controls.sticker.stickers.imgly_sticker_emoticons_rabbit",
        "pesdk.sticker.asset.imgly_sticker_emoticons_sad": "editor.controls.sticker.stickers.imgly_sticker_emoticons_sad",
        "pesdk.sticker.asset.imgly_sticker_emoticons_sick": "editor.controls.sticker.stickers.imgly_sticker_emoticons_sick",
        "pesdk.sticker.asset.imgly_sticker_emoticons_skateboard": "editor.controls.sticker.stickers.imgly_sticker_emoticons_skateboard",
        "pesdk.sticker.asset.imgly_sticker_emoticons_skull": "editor.controls.sticker.stickers.imgly_sticker_emoticons_skull",
        "pesdk.sticker.asset.imgly_sticker_emoticons_sleepy": "editor.controls.sticker.stickers.imgly_sticker_emoticons_sleepy",
        "pesdk.sticker.asset.imgly_sticker_emoticons_smile": "editor.controls.sticker.stickers.imgly_sticker_emoticons_smile",
        "pesdk.sticker.asset.imgly_sticker_emoticons_smoking": "editor.controls.sticker.stickers.imgly_sticker_emoticons_smoking",
        "pesdk.sticker.asset.imgly_sticker_emoticons_sobbing": "editor.controls.sticker.stickers.imgly_sticker_emoticons_sobbing",
        "pesdk.sticker.asset.imgly_sticker_emoticons_star": "editor.controls.sticker.stickers.imgly_sticker_emoticons_star",
        "pesdk.sticker.asset.imgly_sticker_emoticons_steaming_furious": "editor.controls.sticker.stickers.imgly_sticker_emoticons_steaming_furious",
        "pesdk.sticker.asset.imgly_sticker_emoticons_sunbathing": "editor.controls.sticker.stickers.imgly_sticker_emoticons_sunbathing",
        "pesdk.sticker.asset.imgly_sticker_emoticons_tired": "editor.controls.sticker.stickers.imgly_sticker_emoticons_tired",
        "pesdk.sticker.asset.imgly_sticker_emoticons_tongue_out_wink": "editor.controls.sticker.stickers.imgly_sticker_emoticons_tongue_out_wink",
        "pesdk.sticker.asset.imgly_sticker_emoticons_wave": "editor.controls.sticker.stickers.imgly_sticker_emoticons_wave",
        "pesdk.sticker.asset.imgly_sticker_emoticons_wide_grin": "editor.controls.sticker.stickers.imgly_sticker_emoticons_wide_grin",
        "pesdk.sticker.asset.imgly_sticker_emoticons_wink": "editor.controls.sticker.stickers.imgly_sticker_emoticons_wink",
        "pesdk.sticker.asset.imgly_sticker_emoticons_wrestler": "editor.controls.sticker.stickers.imgly_sticker_emoticons_wrestler",
        "pesdk.sticker.asset.imgly_sticker_shapes": "editor.controls.sticker.stickerCategories.imgly_sticker_shapes",
        "pesdk.sticker.asset.imgly_sticker_shapes_arrow_02": "editor.controls.sticker.stickers.imgly_sticker_shapes_arrow_02",
        "pesdk.sticker.asset.imgly_sticker_shapes_arrow_03": "editor.controls.sticker.stickers.imgly_sticker_shapes_arrow_03",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_01": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_01",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_04": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_04",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_06": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_06",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_08": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_08",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_11": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_11",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_12": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_12",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_13": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_13",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_15": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_15",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_18": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_18",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_19": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_19",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_20": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_20",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_28": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_28",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_32": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_32",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_35": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_35",
        "pesdk.sticker.asset.imgly_sticker_shapes_badge_36": "editor.controls.sticker.stickers.imgly_sticker_shapes_badge_36",
        "pesdk.sticker.asset.imgly_sticker_shapes_spray_01": "editor.controls.sticker.stickers.imgly_sticker_shapes_spray_01",
        "pesdk.sticker.asset.imgly_sticker_shapes_spray_03": "editor.controls.sticker.stickers.imgly_sticker_shapes_spray_03",
        "pesdk.sticker.asset.imgly_sticker_shapes_spray_04": "editor.controls.sticker.stickers.imgly_sticker_shapes_spray_04",
        "pesdk.sticker.button.fill": "editor.controls.sticker.fill",
        "pesdk.sticker.button.new": "editor.controls.sticker.new",
        "pesdk.sticker.button.replace": "editor.controls.sticker.replace",
        "pesdk.sticker.text.stickerLoadingError": "errors.stickerLoadingError.text",
        "pesdk.sticker.title.name": "editor.controls.sticker.title",
        "pesdk.sticker.title.opacity": "editor.controls.sticker.opacity",
        "pesdk.text.button.new": "editor.controls.text.new",
        "pesdk.text.placeholder.defaultText": "editor.controls.text.defaultText",
        "pesdk.text.title.background": "editor.controls.text.background",
        "pesdk.text.title.font": "editor.controls.text.font",
        "pesdk.text.title.line": "editor.controls.text.line",
        "pesdk.text.title.name": "editor.controls.text.title",
        "pesdk.text.title.size": "editor.controls.text.size",
        "pesdk.text.title.spacing": "editor.controls.text.spacing",
        "pesdk.textdesign.title.name": "editor.controls.textdesign.title",
        "pesdk.transform.asset.imgly_transforms_common.imgly_transform_common_16-9": "editor.controls.transform.ratios.imgly_transforms_common.imgly_transform_common_16-9",
        "pesdk.transform.asset.imgly_transforms_common.imgly_transform_common_4-3": "editor.controls.transform.ratios.imgly_transforms_common.imgly_transform_common_4-3",
        "pesdk.transform.asset.imgly_transforms_common.imgly_transform_common_custom": "editor.controls.transform.ratios.imgly_transforms_common.imgly_transform_common_custom",
        "pesdk.transform.asset.imgly_transforms_common.imgly_transform_common_square": "editor.controls.transform.ratios.imgly_transforms_common.imgly_transform_common_square",
        "pesdk.transform.asset.imgly_transforms_common.name": "editor.controls.transform.ratios.imgly_transforms_common.name",
        "pesdk.transform.asset.imgly_transforms_facebook.imgly_transform_facebook_ad": "editor.controls.transforms.ratios.imgly_transforms_facebook.imgly_transform_facebook_ad",
        "pesdk.transform.asset.imgly_transforms_facebook.imgly_transform_facebook_cover": "editor.controls.transforms.ratios.imgly_transforms_facebook.imgly_transform_facebook_cover",
        "pesdk.transform.asset.imgly_transforms_facebook.imgly_transform_facebook_post": "editor.controls.transforms.ratios.imgly_transforms_facebook.imgly_transform_facebook_post",
        "pesdk.transform.asset.imgly_transforms_facebook.imgly_transform_facebook_profile": "editor.controls.transforms.ratios.imgly_transforms_facebook.imgly_transform_facebook_profile",
        "pesdk.transform.asset.imgly_transforms_facebook.name": "editor.controls.transform.ratios.imgly_transforms_facebook.name",
        "pesdk.transform.button.reset": "editor.controls.transform.reset",
        "pesdk.transform.placeholder.height": "editor.controls.transform.dimensions.height",
        "pesdk.transform.placeholder.width": "editor.controls.transform.dimensions.width",
        "pesdk.transform.title.name": "editor.controls.transform.title"
      };
    }, function (e, t, n) {
      var i = n(483),
          r = n(484);
      t.a = {
        EVENTS: i.a,
        DEFAULTS: r.a
      };
    }, function (e, t, n) {
      var i = n(6),
          r = n.n(i),
          o = n(91),
          a = (r.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
        }

        return e;
      })({}, o.a, {
        LOAD: "load",
        SAVE: "save",
        EDITOR_RESIZE: "editor:resize",
        ZOOM: "editor:zoom",
        ZOOM_CHANGED: "editor:zoom_changed",
        HISTORY_REDO: "history:redo",
        HISTORY_BEFORE_REDO: "history:before-redo",
        TEXT_SCALED: "editor:text:scaled",
        TRANSFORM_RESIZE: "transform:resize",
        TRANSFORM_AFTER_EDIT: "transform:after-edit",
        ADDED_STICKER: "sticker:added-sticker",
        SPRITES_DESELECTED: "editor:sprite:deselected-all",
        CANVAS_FOCUS: "canvas:focus"
      });

      t.a = a;
    }, function (e, t, n) {
      var i = n(31),
          r = n.n(i),
          o = n(485),
          a = n(486),
          s = n(487),
          l = [];
      void 0 !== r.a.Operations.SpriteOperation && l.push(r.a.Operations.SpriteOperation.BrushSprite.Brushes.RadialBrush), t.a = {
        TRANSFORM_RATIO_CATEGORIES: s.a,
        FONTS: o.a,
        TEXT_DESIGN_FONTS: a.a,
        BRUSHES: l
      };
    }, function (e, t, n) {
      t.a = [{
        fontFamily: "Aleo",
        variations: [{
          identifier: "imgly_font_aleo_bold",
          fontWeight: "bold",
          provider: "file",
          filePath: "fonts/imgly_font_aleo_bold.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1919,
            descender: -409
          }
        }]
      }, {
        fontFamily: "Amatic SC",
        variations: [{
          identifier: "imgly_font_amaticsc",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_amaticsc.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2332,
            descender: -583
          }
        }]
      }, {
        fontFamily: "Bernier",
        variations: [{
          identifier: "imgly_font_bernier_regular",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_bernier_regular.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2007,
            descender: -552
          }
        }]
      }, {
        fontFamily: "Cheque",
        variations: [{
          identifier: "imgly_font_cheque_regular",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_cheque_regular.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1853,
            descender: -495
          }
        }]
      }, {
        fontFamily: "Open Sans",
        variations: [{
          identifier: "imgly_font_open_sans_bold",
          fontWeight: "bold",
          provider: "file",
          filePath: "fonts/imgly_font_open_sans_bold.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2189,
            descender: -640
          }
        }]
      }, {
        fontFamily: "Gagalin",
        variations: [{
          identifier: "imgly_font_gagalin_regular",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_gagalin_regular.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1987,
            descender: -628
          }
        }]
      }, {
        fontFamily: "Hagin",
        variations: [{
          identifier: "imgly_font_hagin_caps_thin",
          fontWeight: 200,
          provider: "file",
          filePath: "fonts/imgly_font_hagin_caps_thin.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1964,
            descender: -482
          }
        }]
      }, {
        fontFamily: "Intro",
        variations: [{
          identifier: "imgly_font_intro_inline",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_intro_inline.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1944,
            descender: -548
          }
        }]
      }, {
        fontFamily: "Lobster",
        variations: [{
          identifier: "imgly_font_lobster",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_lobster.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2048,
            descender: -552
          }
        }]
      }, {
        fontFamily: "Nexa",
        variations: [{
          identifier: "imgly_font_nexa_script",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_nexa_script.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1835,
            descender: -663
          }
        }]
      }, {
        fontFamily: "Ostrich",
        variations: [{
          identifier: "imgly_font_ostrich_sans_black",
          fontWeight: 800,
          provider: "file",
          filePath: "fonts/imgly_font_ostrich_sans_black.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1513,
            descender: -235
          }
        }, {
          identifier: "imgly_font_ostrich_sans_bold",
          fontWeight: "bold",
          provider: "file",
          filePath: "fonts/imgly_font_ostrich_sans_bold.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1513,
            descender: -235
          }
        }]
      }, {
        fontFamily: "Panton",
        variations: [{
          identifier: "imgly_font_panton_black_italic_caps",
          fontWeight: 800,
          fontStyle: "italic",
          provider: "file",
          filePath: "fonts/imgly_font_panton_blackitalic_caps.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2033,
            descender: -572
          }
        }, {
          identifier: "imgly_font_panton_light_italic_caps",
          fontWeight: 200,
          fontStyle: "italic",
          provider: "file",
          filePath: "fonts/imgly_font_panton_lightitalic_caps.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1961,
            descender: -556
          }
        }]
      }, {
        fontFamily: "Perfograma",
        variations: [{
          identifier: "imgly_font_perfograma",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_perfograma.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1982,
            descender: -842
          }
        }]
      }, {
        fontFamily: "Trashhand",
        variations: [{
          identifier: "imgly_font_trash_hand",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_trash_hand.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1554,
            descender: -663
          }
        }]
      }];
    }, function (e, t, n) {
      t.a = [{
        fontFamily: "Open Sans",
        variations: [{
          identifier: "imgly_font_open_sans_bold",
          fontWeight: "bold",
          provider: "file",
          filePath: "fonts/imgly_font_open_sans_bold.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2189,
            descender: -640
          }
        }]
      }, {
        fontFamily: "Gagalin",
        variations: [{
          identifier: "imgly_font_gagalin_regular",
          fontWeight: "normal",
          provider: "file",
          filePath: "fonts/imgly_font_gagalin_regular.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1987,
            descender: -628
          }
        }]
      }, {
        fontFamily: "Abril Fatface",
        variations: [{
          identifier: "imgly_font_abril_fatface_regular",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_abril_fatface_regular.woff",
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 1058,
            descender: -291
          }
        }]
      }, {
        fontFamily: "Montserrat Light",
        variations: [{
          identifier: "imgly_font_montserrat_light",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_montserrat_light.woff",
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 968,
            descender: -251
          }
        }]
      }, {
        fontFamily: "Wolesbro",
        variations: [{
          identifier: "imgly_font_wolesbro",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_wolesbro.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1849,
            descender: -1123
          }
        }]
      }, {
        fontFamily: "Permanent Marker",
        variations: [{
          identifier: "imgly_font_permanent_marker",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_permanent_marker.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2272,
            descender: -686
          }
        }]
      }, {
        fontFamily: "Panton Caps",
        variations: [{
          identifier: "imgly_font_panton_light_italic_caps",
          fontWeight: "lighter",
          fontStyle: "italic",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_panton_light_italic_caps.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 940,
            descender: -260
          }
        }, {
          identifier: "imgly_font_panton_black_italic_caps",
          fontWeight: 800,
          fontStyle: "italic",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_panton_black_italic_caps.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 940,
            descender: -260
          }
        }, {
          identifier: "imgly_font_panton_light_caps",
          fontWeight: "lighter",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_panton_light_caps.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 940,
            descender: -260
          }
        }, {
          identifier: "imgly_font_panton_black_caps",
          fontWeight: 800,
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_panton_black_caps.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 940,
            descender: -260
          }
        }]
      }, {
        fontFamily: "Amberlight",
        variations: [{
          identifier: "imgly_font_amberlight",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_amberlight.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 750,
            descender: -250
          }
        }]
      }, {
        fontFamily: "Ultra",
        variations: [{
          identifier: "imgly_font_ultra",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_ultra.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2066,
            descender: -561
          }
        }]
      }, {
        fontFamily: "Galano Grotesque",
        variations: [{
          identifier: "imgly_font_galano_grotesque_bold",
          fontWeight: "bold",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_galano_grotesque_bold.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 800,
            descender: -200
          }
        }]
      }, {
        fontFamily: "Bungee Inline",
        variations: [{
          identifier: "imgly_font_bungee_inline",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_bungee_inline.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 860,
            descender: -140
          }
        }]
      }, {
        fontFamily: "Petit Formal Script",
        variations: [{
          identifier: "imgly_font_petit_formal_script",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_petit_formal_script.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2033,
            descender: -527
          }
        }]
      }, {
        fontFamily: "Summer Font",
        variations: [{
          identifier: "imgly_font_summer_font_light",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_summer_font_light.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2189,
            descender: -600
          }
        }]
      }, {
        fontFamily: "Handycheera",
        variations: [{
          identifier: "imgly_font_handycheera_regular",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_handycheera_regular.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 2199,
            descender: -808
          }
        }]
      }, {
        fontFamily: "Rasa",
        variations: [{
          identifier: "imgly_font_rasa_regular",
          fontWeight: "normal",
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_rasa_regular.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 2750,
            ascender: 2300,
            descender: -1050
          }
        }, {
          identifier: "imgly_font_rasa_500",
          fontWeight: 500,
          fontStyle: "normal",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_rasa_500.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 2750,
            ascender: 2300,
            descender: -1050
          }
        }]
      }, {
        fontFamily: "Campton Book",
        variations: [{
          identifier: "imgly_font_campton_bold",
          fontWeight: "bold",
          provider: "file",
          filePath: "text-design/fonts/imgly_font_campton_bold.woff",
          default: !0,
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 770,
            descender: -294
          }
        }]
      }, {
        fontFamily: "Ostrich",
        variations: [{
          identifier: "imgly_font_ostrich_sans_black",
          fontWeight: 800,
          provider: "file",
          filePath: "fonts/imgly_font_ostrich_sans_black.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1513,
            descender: -235
          }
        }, {
          identifier: "imgly_font_ostrich_sans_bold",
          fontWeight: "bold",
          provider: "file",
          filePath: "fonts/imgly_font_ostrich_sans_bold.woff",
          textMetrics: {
            unitsPerEm: 2048,
            ascender: 1513,
            descender: -235
          }
        }, {
          identifier: "imgly_font_ostrich_sans_heavy",
          fontWeight: 900,
          provider: "file",
          filePath: "text-design/fonts/imgly_font_ostrich_sans_heavy.woff",
          textMetrics: {
            unitsPerEm: 1e3,
            ascender: 674,
            descender: 0
          }
        }]
      }];
    }, function (e, t, n) {
      t.a = [{
        identifier: "imgly_transforms_common",
        defaultName: "Common Ratios",
        ratios: [{
          identifier: "imgly_transform_common_custom",
          defaultName: "Custom",
          ratio: "*",
          selected: !0
        }, {
          identifier: "imgly_transform_common_square",
          defaultName: "Square",
          ratio: 1
        }, {
          identifier: "imgly_transform_common_4-3",
          defaultName: "4:3",
          ratio: 4 / 3
        }, {
          identifier: "imgly_transform_common_16-9",
          defaultName: "16:9",
          ratio: 16 / 9
        }]
      }, {
        identifier: "imgly_transforms_facebook",
        defaultName: "Facebook",
        ratios: [{
          identifier: "imgly_transform_facebook_profile",
          defaultName: "Profile Pic",
          dimensions: {
            x: 300,
            y: 300
          },
          forceDimensions: !1,
          lockDimensions: !0
        }, {
          identifier: "imgly_transform_facebook_ad",
          defaultName: "Ad",
          dimensions: {
            x: 1200,
            y: 627
          }
        }, {
          identifier: "imgly_transform_facebook_post",
          defaultName: "Post",
          dimensions: {
            x: 940,
            y: 788
          }
        }, {
          identifier: "imgly_transform_facebook_cover",
          defaultName: "Cover",
          dimensions: {
            x: 851,
            y: 315
          }
        }]
      }];
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(153),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(9),
          d = n(489),
          g = n(41),
          m = n(491),
          y = n(198),
          _ = n(492),
          v = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function b(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function w(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var x = function (e) {
        function t(e, n, i) {
          var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          b(this, t);
          var o = w(this, (t.__proto__ || f()(t)).call(this));
          return o._ui = e, o._options = n, o._mediator = i, o._shallow = r, r || (o._initSDK(), o.operations = new _.a(o, o._sdk, o._mediator)), o;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), v(t, [{
          key: "_initFonts",
          value: function value() {
            var e = h.k.defaults(this._options.editor.controlsOptions.text, {
              additionalFonts: [],
              replaceFonts: !1,
              availableVariations: null
            });
            this._fontManager = new g.a(this._ui, e);

            var t = this._fontManager.getFonts(),
                n = this._ui.getFontLoader();

            n.setFonts(t), n.load();
          }
        }, {
          key: "setImage",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._options.editor.image,
                t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            t && this.reset();
            var n = null;
            n = this._sdk.parseExif(e), this._setImage(e, n), this._initWatermark();
          }
        }, {
          key: "_initWatermark",
          value: function value() {
            this._options.editor.watermarkImage && (this._watermarkOperation = this.operations.getOrCreate("watermark", {
              image: this._options.editor.watermarkImage
            }));
          }
        }, {
          key: "_initSDK",
          value: function value() {
            var e = this._options,
                t = e.logLevel,
                n = e.displayWelcomeMessage,
                i = e.debug,
                r = e.license,
                o = e.crossOrigin,
                a = this._options.editor,
                s = a.smoothDownscaling,
                l = a.smoothUpscaling,
                u = a.preferredRenderer,
                c = a.pixelRatio,
                p = a.transparent,
                f = a.clearColor,
                d = void 0;
            Array.isArray(f) ? d = h.b.fromArray(f) : "string" == typeof f ? d = h.b.fromHex(f) : f instanceof h.b && (d = f.clone());
            var g = {
              logLevel: t,
              debug: i,
              displayWelcomeMessage: n,
              pixelRatio: c,
              smoothDownscaling: s,
              smoothUpscaling: l,
              transparent: p,
              crossOrigin: o,
              clearColor: d,
              license: r
            };
            this._sdk = new h.j(u, g);
          }
        }, {
          key: "getMaxMegapixels",
          value: function value() {
            return this._options.editor.maxMegaPixels;
          }
        }, {
          key: "getCrossOrigin",
          value: function value() {
            return h.k.getCrossOriginValue(this._options.crossOrigin || "anonymous");
          }
        }, {
          key: "getOutputDimensions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return this._sdk.getOutputDimensions(e);
          }
        }, {
          key: "getOutputTextureDimensions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return this._sdk.getOutputTextureDimensions(e);
          }
        }, {
          key: "getFinalDimensions",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return this._sdk.getFinalDimensions(e);
          }
        }, {
          key: "_setImage",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._options.editor.image,
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            this._sdk.setAllOperationsToDirty(), this._options.editor.image = e, this._sdk.setImage(e, t);
          }
        }, {
          key: "_ensureImageIsResized",
          value: function value() {
            var e = this,
                t = this._sdk.getImage(),
                n = this._sdk.getRenderer(),
                i = this.getMaxMegapixels(),
                r = i ? 1e6 * i : null,
                o = n.getMaxDimensions(),
                a = new m.a(t, r, o);

            return !this._resizedImage && a.needsResize() ? a.resize().then(function (t) {
              var n = t.canvas;
              return t.dimensions, t.reason, e._resizedImage = n, e._sdk.setImage(n), n;
            }) : h.h.resolve(t);
          }
        }, {
          key: "export",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return this._watermarkOperation && this._watermarkOperation.setEnabled(!1), this._sdk.setAllOperationsToDirty(), this._ensureImageIsResized().then(function (n) {
              var i = e._options.editor.export;
              return new d.a(e._sdk, i, t).export().then(function (t) {
                return e.emit("export", t), e._mediator.emit(h.c.EVENTS.EXPORT, t, e), e._watermarkOperation && (e._watermarkOperation.setEnabled(!0), e._sdk.render()), e._sdk.setAllOperationsToDirty(), t;
              });
            });
          }
        }, {
          key: "broadcastTransform",
          value: function value(e, t) {
            var n = this,
                i = new h.j.Operations.TransformOperation.TransformChange(e, t);
            ["sprite", "selective-blur", "radial-focus", "mirrored-focus", "linear-focus", "blur"].forEach(function (e) {
              var t = n.operations.get(e);
              t && t.transform(i);
            });
          }
        }, {
          key: "broadcastFlip",
          value: function value(e) {
            var t = this;
            ["mirrored-focus", "radial-focus", "linear-focus", "sprite", "selective-blur"].forEach(function (n) {
              var i = t.operations.get(n);
              i && i.flip(e);
            });
          }
        }, {
          key: "broadcastRotate",
          value: function value(e) {
            var t = this;
            ["transform", "mirrored-focus", "linear-focus", "radial-focus", "sprite", "selective-blur"].forEach(function (n) {
              var i = t.operations.get(n);
              i && i.rotate(e);
            });
          }
        }, {
          key: "_initSerializers",
          value: function value() {
            this._serializers = {
              "1.0.0": n(493).default,
              "1.0.1": n(500).default,
              "2.0.0": n(501).default,
              "3.0.0": n(505).default,
              "3.1.0": n(510).default,
              "3.2.0": n(511).default,
              "3.4.0": n(512).default,
              "3.5.0": n(514).default,
              "3.6.0": n(515).default,
              "3.7.0": n(516).default,
              "3.8.0": n(517).default,
              "3.9.0": n(518).default
            };
          }
        }, {
          key: "serialize",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "3.9.0",
                n = this._serializers[t];
            if (!n) return h.h.reject(new Error("No serializer for version " + t + " found."));
            var i = new n(this);
            return i.serialize(e);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            var t = this._serializers[e.version];
            return t ? new t(this).deserialize(e) : h.h.reject(new Error("No serializer for version " + e.version + " found."));
          }
        }, {
          key: "save",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = this._options.editor.save;
            return this.serialize({
              image: t
            }).then(function (t) {
              var i = c()(t, null, 2);

              if (e) {
                var r = "data:text/json;charset=utf-8;base64," + window.encodeURI(window.btoa(i));
                y.a.downloadDataURL(r, n.fileBasename);
              }

              return i;
            });
          }
        }, {
          key: "reset",
          value: function value() {
            this._sdk.reset(), this.operations.reset();
          }
        }, {
          key: "dispose",
          value: function value() {
            this.stop(), this._sdk.dispose();
          }
        }, {
          key: "getRenderer",
          value: function value() {
            return this._sdk.getRenderer();
          }
        }, {
          key: "getSDK",
          value: function value() {
            return this._sdk;
          }
        }, {
          key: "getInputDimensions",
          value: function value() {
            return this._sdk.getInputDimensions();
          }
        }, {
          key: "getImage",
          value: function value() {
            return this._sdk.getImage();
          }
        }, {
          key: "getOptions",
          value: function value() {
            return this._options;
          }
        }, {
          key: "getUI",
          value: function value() {
            return this._ui;
          }
        }, {
          key: "getMediator",
          value: function value() {
            return this._mediator;
          }
        }]), t;
      }(h.d);

      t.a = x;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(9),
          a = n(198),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t, n, i) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._sdk = t, this._options = n, this._download = i;
        }

        return s(e, [{
          key: "export",
          value: function value() {
            var e = this,
                t = this._getRenderType();

            return this._sdk.export(t, this._options.format, this._options.quality).then(function (n) {
              return e._download && e._downloadData(t, n), n;
            });
          }
        }, {
          key: "_downloadData",
          value: function value(e, t) {
            switch (e) {
              case o.i.DATAURL:
                a.a.downloadDataURL(t, this._options.fileBasename);
                break;

              case o.i.MSBLOB:
                a.a.downloadMSBlob(t, this._options.fileBasename);
            }
          }
        }, {
          key: "_getRenderType",
          value: function value() {
            var e = this._options;
            return e.type === o.i.IMAGE && this._download ? o.m.supportsMSBlob() ? o.i.MSBLOB : o.i.DATAURL : e.type;
          }
        }]), e;
      }();

      t.a = l;
    }, function (e, t, n) {
      var i = n(2),
          r = n.n(i),
          o = n(3),
          a = n.n(o),
          s = n(1),
          l = n.n(s),
          u = n(31);

      function c(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function p(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      n.n(u);

      var f = function (e) {
        function t() {
          return c(this, t), p(this, (t.__proto__ || l()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = a()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (r.a ? r()(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(u.Configurable);

      t.a = f, f.prototype.availableOptions = {
        fontFamily: {
          type: u.OptionType.STRING,
          required: !0
        },
        variations: {
          type: u.OptionType.ARRAY,
          required: !0
        }
      };
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(9),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e(t, n, i) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._image = t, this._maxPixels = n, this._maxDimensions = i;
        }

        return a(e, [{
          key: "needsResize",
          value: function value() {
            var e = new o.n(this._image.width, this._image.height),
                t = e.x * e.y > this._maxPixels,
                n = null !== this._maxDimensions && (e.x > this._maxDimensions || e.y > this._maxDimensions);
            return t || n;
          }
        }, {
          key: "resize",
          value: function value() {
            var e = this,
                t = null,
                n = null,
                i = this._maxDimensions;
            return new o.h(function (r, a) {
              window.setTimeout(function () {
                var a = new o.n(e._image.width, e._image.height).clone();

                if (a.x * a.y > e._maxPixels && (a.copy(e._getDimensionsByMaxPixels()), t = "maxMegaPixels"), null !== i && (a.x > i || a.y > i)) {
                  var s = Math.min(i / a.x, i / a.y);
                  a.multiply(s), t = "maxDimensions";
                }

                a.floor(), n = e._createResizedImageCanvas(a), r({
                  canvas: n,
                  dimensions: a,
                  reason: t
                });
              }, 1e3);
            });
          }
        }, {
          key: "_createResizedImageCanvas",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e,
                n = this._image,
                i = document.createElement("canvas");
            i.width = e.x, i.height = e.y;
            var r = e.clone().subtract(t).divide(2),
                o = i.getContext("2d");
            return o.drawImage(n, 0, 0, n.width, n.height, r.x, r.y, t.x, t.y), i;
          }
        }, {
          key: "_getDimensionsByMaxPixels",
          value: function value() {
            var e = this._image,
                t = this._maxPixels,
                n = e.width / e.height,
                i = e.height / e.width;
            return new o.n(Math.sqrt(t * n), Math.sqrt(t * i)).floor();
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(36),
          r = n.n(i),
          o = n(37),
          a = n.n(o),
          s = n(0),
          l = n.n(s),
          u = n(9),
          c = "function" == typeof a.a && "symbol" == typeof r.a ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof a.a && e.constructor === a.a && e !== a.a.prototype ? "symbol" : typeof e;
      },
          p = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), l()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          f = function () {
        function e(t, n, i) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t, this._sdk = n, this._mediator = i, this._available = this._sdk.getOperations(), this._map = {}, this._stack = this._sdk.getOperationsStack(), this._preferredOrder = this._editor.getOptions().editor.operationsOrder, this._fixStack();
        }

        return p(e, [{
          key: "exists",
          value: function value(e) {
            return !!this._map[e];
          }
        }, {
          key: "add",
          value: function value(e) {
            var t = this,
                n = e.constructor.identifier;
            e.on("update", function () {
              t._mediator.emit(u.c.EVENTS.OPERATION_UPDATED, e);
            });

            var i = this._preferredOrder.indexOf(n);

            if (-1 === i) throw new Error("EditorOperations#add: `" + n + "` does not appear in `operationsOrder`");
            this._stack.set(i, e), this._map[n] = e, this._mediator.emit(u.c.EVENTS.OPERATION_CREATED, e);
          }
        }, {
          key: "remove",
          value: function value(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                n = "object" === (void 0 === e ? "undefined" : c(e)) ? e.constructor.identifier : e,
                i = this._stack.getStack();

            e = this.get(n), delete this._map[n];
            var r = i.map(function (e) {
              return e.constructor.identifier;
            }).indexOf(n);

            if (-1 !== r) {
              this._stack.removeAt(r);

              for (var o = r + 1; o < i.length; o++) {
                var a = i[o];
                a && a.setDirty(!0);
              }

              t && this._mediator.emit(u.c.EVENTS.OPERATION_REMOVED, e);
            }
          }
        }, {
          key: "get",
          value: function value(e) {
            return this._map[e];
          }
        }, {
          key: "getOrCreate",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

            if (this._map[e]) {
              var n = this._map[e];
              return n.set(t, !1), n;
            }

            var i = this._available[e],
                r = new i(this._sdk, t);
            return this.add(r), r;
          }
        }, {
          key: "getStack",
          value: function value() {
            return this._stack;
          }
        }, {
          key: "reset",
          value: function value() {
            this._map = {};
          }
        }, {
          key: "_fixStack",
          value: function value() {
            var e = this,
                t = this._stack.getStack().slice();

            this._stack.clear(), t.forEach(function (t) {
              e.add(t);
            });
          }
        }]), e;
      }();

      t.a = f;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(200),
          a = n(201),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "1.0.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          a = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._assetsByGroupId = {};
        }

        return o(e, [{
          key: "addAsset",
          value: function value(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            this._assetsByGroupId[e] ? n ? this._assetsByGroupId[e].unshift(t) : this._assetsByGroupId[e].push(t) : this._assetsByGroupId[e] = [t];
          }
        }, {
          key: "setAssets",
          value: function value(e, t) {
            this._assetsByGroupId[e] = t;
          }
        }, {
          key: "getAssets",
          value: function value(e) {
            return this._assetsByGroupId[e] = this._assetsByGroupId[e] || [], this._assetsByGroupId[e];
          }
        }]), e;
      }();

      t.a = a;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(9),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._ui = t, this._options = n, this._brushes = [], this._brushesById = {}, this._addBrushes(o.c.DEFAULTS.BRUSHES);
          var i = this._options,
              r = i.brushes,
              a = i.replaceBrushes,
              s = i.availableBrushes;
          this._options.brushes && this._addBrushes(r, a), s && (this._brushes = this._brushes.filter(function (e) {
            return -1 !== s.indexOf(e.identifier);
          }));
        }

        return a(e, [{
          key: "_addBrushes",
          value: function value(e, t) {
            var n = this;
            t && (this._brushes = [], this._brushesById = {}), e.forEach(function (e) {
              n._brushes.push(e), n._brushesById[e.identifier] = e;
            });
          }
        }, {
          key: "getBrushByIdentifier",
          value: function value(e) {
            return this._brushesById[e];
          }
        }, {
          key: "getBrushes",
          value: function value() {
            return this._brushes;
          }
        }, {
          key: "getFirstBrush",
          value: function value() {
            return this._brushes[0];
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(203),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function g(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function m(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var y = {
        italic: "i"
      },
          _ = function (e) {
        function t() {
          return g(this, t), m(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "load",
          value: function value() {
            return this._fonts.length && this._addStylesheetTag(), function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "load", this).call(this);
          }
        }, {
          key: "_addStylesheetTag",
          value: function value() {
            var e = this._getFamiliesString(),
                t = document.createElement("link");

            t.rel = "stylesheet", t.href = "https://fonts.googleapis.com/css?family=" + e, document.getElementsByTagName("head")[0].appendChild(t);
          }
        }, {
          key: "_getFamiliesString",
          value: function value() {
            var e = {};

            this._fonts.forEach(function (t) {
              var n = t.getFontFamily(),
                  i = t.getFontStyle(),
                  r = t.getFontWeight();
              e[n] = e[n] || [], void 0 !== r ? e[n].push("" + r + (y[i] || "")) : e[n].push(400);
            });

            var t = [];

            for (var n in e) {
              var i = e[n],
                  r = i.length ? ":" + i.join(",") : "",
                  o = n.replace(" ", "+") + r;
              t.push(o);
            }

            return t.join("|");
          }
        }]), t;
      }(h.a);

      t.a = _;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(10),
          a = n.n(o),
          s = n(498),
          l = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          u = "undefined" != typeof window && window.performance && window.performance.now ? window.performance.now.bind(window.performance) : n(87),
          c = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._fontVariation = t, this._defaultFontRuler = new s.a(), this._customFontRuler = new s.a(this._fontVariation);
        }

        return l(e, [{
          key: "observe",
          value: function value() {
            var e = this,
                t = u();
            return new a.a(function (n, i) {
              var r = window.setInterval(function () {
                if (e._defaultFontRuler.getWidth() !== e._customFontRuler.getWidth()) return window.clearInterval(r), n();

                if (u() - t >= 5e3) {
                  var o = new Error("Failed to load font " + e._fontVariation.getFontFamily() + ".");
                  return o.font = e._fontVariation, i(o);
                }
              }, 50);
            });
          }
        }, {
          key: "dispose",
          value: function value() {
            this._defaultFontRuler.dispose(), this._customFontRuler.dispose();
          }
        }]), e;
      }();

      t.a = c;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(199),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._fontVariation = t || new o.a({
            fontFamily: "Times New Roman",
            fontWeight: "normal",
            fontStyle: "normal"
          }), this._createRuler();
        }

        return a(e, [{
          key: "_createRuler",
          value: function value() {
            this._ruler = document.createElement("div"), this._ruler.innerText = "abcdefghijklmnopqrstuvwxzy", document.body.appendChild(this._ruler), this._setRulerStyle();
          }
        }, {
          key: "_setRulerStyle",
          value: function value() {
            this._ruler.style.cssText = "\n      position: absolute;\n      top: -9999px;\n      left: -9999px;\n      opacity: 0;\n      display: inline-block;\n      font: " + this._fontVariation.getFontStyle() + " " + this._fontVariation.getFontWeight() + " 30px " + this._fontVariation.getFontFamily() + ";\n    ";
          }
        }, {
          key: "setFontVariation",
          value: function value(e) {
            this._fontVariation = e, this._setRulerStyle();
          }
        }, {
          key: "getWidth",
          value: function value() {
            return this._ruler ? this._ruler.offsetWidth : -1;
          }
        }, {
          key: "dispose",
          value: function value() {
            this._ruler && (this._ruler.parentNode.removeChild(this._ruler), this._ruler = null);
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(10),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(203),
          d = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function g(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function m(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var y = function (e) {
        function t() {
          return g(this, t), m(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), d(t, [{
          key: "load",
          value: function value() {
            return c.a.resolve();
          }
        }]), t;
      }(h.a);

      t.a = y;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(204),
          a = n(205),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "1.0.1";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(206),
          a = n(207),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "2.0.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(9),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._ui = t, this._options = n, this._categoriesById = {}, this._categories = [], this._framesById = {}, this._addCategories(o.l.DEFAULTS.FRAME_CATEGORIES), this._customAssetsAllowed = t.getEditor().getSDK()._l.areCustomAssetsAllowed();
          var i = this._options,
              r = i.categories,
              a = i.replaceCategories;
          this._customAssetsAllowed && this._options.categories ? this._addCategories(r, a) : this._updateAllCategory();
        }

        return a(e, [{
          key: "_addCategories",
          value: function value(e) {
            var t = this,
                n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            this._categories = n ? e.slice(0) : o.m.mergeCategories(this._categories, e, "frames"), this._categoriesById = {}, this._categories.forEach(function (e) {
              t._categoriesById[e.identifier] = e;
            });
            var i = this._options.availableFrames;
            this._customAssetsAllowed && i && this._categories.forEach(function (e) {
              e.frames = e.frames.filter(function (e) {
                return -1 !== i.indexOf(e.identifier);
              });
            }), this._categories.forEach(function (e) {
              e.frames.forEach(function (e) {
                t._framesById[e.identifier] = e;
              });
            }), this._updateAllCategory();
          }
        }, {
          key: "_updateAllCategory",
          value: function value() {
            this._allCategory = {
              identifier: "all",
              defaultName: "All",
              frames: this._categories.map(function (e) {
                return e.frames;
              }).reduce(function (e, t) {
                return e.concat(t);
              }, [])
            }, this._categoriesById.all = this._allCategory;
          }
        }, {
          key: "getFramesForCategory",
          value: function value(e) {
            if (!this._categoriesById[e]) throw new Error("Unknown frame category '" + e + "'");
            return this._categoriesById[e].frames;
          }
        }, {
          key: "getFrameByIdentifier",
          value: function value(e) {
            return this._framesById[e];
          }
        }, {
          key: "getCategories",
          value: function value() {
            return this._categories;
          }
        }, {
          key: "getCategory",
          value: function value(e) {
            return this._categoriesById[e];
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(9),
          a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          s = function () {
        function e(t, n) {
          var i = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._ui = t, this._options = n, this._overlays = o.l.DEFAULTS.OVERLAYS.slice(0), this._overlaysByIdentifier = {};

          var r = t.getEditor().getSDK()._l.areCustomAssetsAllowed();

          r && n.overlays && (n.replaceOverlays ? this._overlays = n.overlays : this._overlays = this._overlays.concat(n.overlays)), r && n.availableOverlays && (this._overlays = this._overlays.filter(function (e) {
            return -1 !== n.availableOverlays.indexOf(e.identifier);
          })), this._overlays.forEach(function (e) {
            i._overlaysByIdentifier[e.identifier] = e;
          });
        }

        return a(e, [{
          key: "getOverlays",
          value: function value() {
            return this._overlays;
          }
        }, {
          key: "getOverlayByIdentifier",
          value: function value(e) {
            return this._overlaysByIdentifier[e];
          }
        }]), e;
      }();

      t.a = s;
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(2),
          a = n.n(o),
          s = n(3),
          l = n.n(s),
          u = n(10),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(9),
          d = n(73),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = h.j.OptionType,
          v = function (e) {
        function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          m(this, t);
          var i = y(this, (t.__proto__ || f()(t)).call(this, n));
          return i._loaded = !1, i._loading = !1, i._ui = e, i._frame = h.j.Utils.deepClone(i._options), i;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = l()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (a.a ? a()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "load",
          value: function value() {
            var e = this;
            if (this._loaded) return c.a.resolve();
            if (this._loading) return c.a.reject(new Error("Called Frame#load while it's already loading"));
            this._loading = !0;
            var t = this._frame.imageGroups,
                n = [];
            return ["top", "left", "right", "bottom"].forEach(function (i) {
              if (i in t) {
                var r = t[i];
                ["start", "mid", "end"].forEach(function (t) {
                  t in r && n.push(e._loadPart(i, t));
                });
              }
            }), c.a.all(n).then(function () {
              e._loaded = !0, e._loading = !1;
            }).catch(function (t) {
              e._loaded = !1, e._loading = !1;
            });
          }
        }, {
          key: "_loadPart",
          value: function value(e, t) {
            var n = this,
                i = this._frame.imageGroups[e][t],
                r = i;
            return "string" != typeof i && "image" in i && (r = i.image), d.a.load(this._ui.getAssetPath(r)).then(function (r) {
              return "string" != typeof i ? n._frame.imageGroups[e][t].image = r : n._frame.imageGroups[e][t] = r, r;
            });
          }
        }, {
          key: "getFrame",
          value: function value() {
            return this._frame;
          }
        }]), t;
      }(h.j.Configurable);

      t.a = v, v.prototype.availableOptions = {
        identifier: {
          type: _.STRING,
          required: !0
        },
        defaultName: {
          type: _.STRING
        },
        thumbnail: {
          type: _.STRING
        },
        tintable: {
          type: _.BOOLEAN,
          default: !1
        },
        layoutMode: {
          type: _.STRING,
          default: "horizontal-inside",
          available: ["horizontal-inside", "vertical-inside"]
        },
        imageGroups: {
          type: _.OBJECT,
          required: !0
        }
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(208),
          a = n(210),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.0.0";
    }, function (e, t, n) {
      e.exports = {
        default: n(507),
        __esModule: !0
      };
    }, function (e, t, n) {
      n(508), e.exports = n(11).Object.values;
    }, function (e, t, n) {
      var i = n(14),
          r = n(509)(!1);
      i(i.S, "Object", {
        values: function values(e) {
          return r(e);
        }
      });
    }, function (e, t, n) {
      var i = n(19),
          r = n(49),
          o = n(35),
          a = n(58).f;

      e.exports = function (e) {
        return function (t) {
          for (var n, s = o(t), l = r(s), u = l.length, c = 0, p = []; u > c;) {
            n = l[c++], i && !a.call(s, n) || p.push(e ? [n, s[n]] : s[n]);
          }

          return p;
        };
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(211),
          a = n(212),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.1.0";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(213),
          a = n(214),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.2.0";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(215),
          a = n(216),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.4.0";
    }, function (e, t, n) {
      var i = n(15),
          r = n.n(i),
          o = n(0),
          a = n.n(o),
          s = n(10),
          l = n.n(s),
          u = n(9),
          c = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), a()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          p = function () {
        function e(t, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._ui = t, this._options = n, this._categoriesByIdentifier = {}, this._categories = [], this._artFiltersByIdentifier = {}, this._initCategories();
        }

        return c(e, [{
          key: "_initCategories",
          value: function value() {
            var e = this,
                t = {
              identifier: "standard",
              defaultName: "Standard",
              artFilters: u.l.DEFAULTS.ART_FILTERS || []
            };

            if (this._categories = [t], this._options.categories && (this._options.replaceCategories ? this._categories = this._options.categories : this._categories = u.m.mergeCategories(this._categories, this._options.categories, "artFilters")), this._options.availableArtFilters) {
              var n = [];
              this._categories.forEach(function (t) {
                var i = t.artFilters.filter(function (t) {
                  return -1 !== e._options.availableArtFilters.indexOf(t.identifier);
                });
                i.length > 0 && n.push({
                  identifier: t.identifier,
                  defaultName: t.defaultName,
                  artFilters: i
                });
              }), this._categories = n;
            }

            var i = {
              identifier: "all",
              defaultName: "All",
              artFilters: this._categories.length <= 0 ? [] : this._categories.map(function (e) {
                return e.artFilters;
              }).reduce(function (e, t) {
                return e.concat(t);
              })
            };
            this._categories.unshift(i), this._categoriesByIdentifier.all = i, this._categories.forEach(function (t) {
              e._categoriesByIdentifier[t.identifier] = t;
            }), i.artFilters.forEach(function (t) {
              e._artFiltersByIdentifier[t.identifier] = t;
            });
          }
        }, {
          key: "instantiateStyleTransferModelForArtFilterWithIdentifier",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = this.getArtFilterByIdentifier(e);
            if (!n) return l.a.reject(new Error("Unknown style with identifier `" + e + "`!"));

            var i = n.rootPath,
                r = this._ui.getEditor().getSDK(),
                o = r.getRenderer();

            t.weightURL = this._ui.getAssetPath(i + "/weights.json");
            var a = r.getInputTexture().getDimensions(),
                s = r.getOperationsStack().getByIdentifier("exif-orientation");
            return s && (a = s.getNewDimensions(a)), u.j.Operations.ArtFilterOperation.StyleTransferModel.createWithOptions(t, a, o);
          }
        }, {
          key: "updateLoadedModelWithWeightsForIdentifier",
          value: function value(e, t) {
            var n = this.getArtFilterByIdentifier(t);
            if (!n) return l.a.reject(new Error("Unknown style with identifier `" + t + "`!"));

            var i = n.rootPath,
                r = this._ui.getAssetPath(i + "/weights.json");

            return e.updateWithWeightsFromURL(r);
          }
        }, {
          key: "getArtFiltersForCategory",
          value: function value(e) {
            if (!this._categoriesByIdentifier[e]) throw new Error("Unknown art filter category '" + e + "'");
            return this._categoriesByIdentifier[e].artFilters;
          }
        }, {
          key: "getArtFilterByIdentifier",
          value: function value(e) {
            return this._artFiltersByIdentifier[e];
          }
        }, {
          key: "getCategories",
          value: function value() {
            return this._categories;
          }
        }, {
          key: "getArtFilters",
          value: function value() {
            var e = this,
                t = [];
            return this._categories.map(function (n) {
              t.push.apply(t, function (e) {
                if (Array.isArray(e)) {
                  for (var t = 0, n = Array(e.length); t < e.length; t++) {
                    n[t] = e[t];
                  }

                  return n;
                }

                return r()(e);
              }(e.getArtFiltersForCategory(n.identifier)));
            }), t;
          }
        }, {
          key: "getCategoryByIdentifier",
          value: function value(e) {
            return this._categoriesByIdentifier[e];
          }
        }]), e;
      }();

      t.a = p;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(217),
          a = n(218),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.5.0";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(219),
          a = n(220),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.6.0";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(221),
          a = n(222),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.7.0";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(223),
          a = n(224),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.8.0";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = n.n(i),
          o = n(519),
          a = n(520),
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }(),
          l = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._editor = t;
        }

        return s(e, [{
          key: "serialize",
          value: function value() {
            var e = new o.a(this._editor);
            return e.serialize.apply(e, arguments);
          }
        }, {
          key: "deserialize",
          value: function value(e) {
            return new a.a(this._editor, e).deserialize();
          }
        }]), e;
      }();

      t.default = l, l.version = "3.9.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(223),
          d = n(209),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = 2 * Math.PI,
          v = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_serializeTransformOperation",
          value: function value(e) {
            var t = this._editor.operations;

            if (t.exists("orientation")) {
              e = e.clone();
              var n = t.get("orientation");
              n.getFlipVertically() && (e.flip("vertical"), e.setRotation(-1 * e.getRotation())), n.getFlipHorizontally() && (e.flip("horizontal"), e.setRotation(-1 * e.getRotation())), e.rotate(-n.getRotation());
            }

            var i = e.serializeOptions(["start", "end", "rotation", "textureScale"], !0);
            i.rotation = (i.rotation + _) % _, 1 !== i.textureScale && (i.dimensions = e.getNewDimensions(e.getInputDimensions(!1))), delete i.textureScale;
            var r = {
              type: "transform",
              options: i
            };

            if (e._ratio) {
              var o = void 0;
              o = e._ratio instanceof d.a ? e._ratio.getIdentifier() : e._ratio.identifier, r.options.meta = {
                identifier: o
              };
            }

            return delete r.options.scale, r;
          }
        }, {
          key: "_serializeText",
          value: function value(e, n) {
            var i = e.getInputDimensions(!1),
                r = function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "_serializeText", this).call(this, e, n);

            return r.options.fontSize = r.options.fontSize * i.y / i.min(), r;
          }
        }]), t;
      }(h.a);

      t.a = v, v.version = "3.9.0";
    }, function (e, t, n) {
      var i = n(0),
          r = n.n(i),
          o = n(5),
          a = n.n(o),
          s = n(2),
          l = n.n(s),
          u = n(3),
          c = n.n(u),
          p = n(1),
          f = n.n(p),
          h = n(9),
          d = n(224),
          g = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), r()(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }();

      function m(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function y(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      var _ = function (e) {
        function t() {
          return m(this, t), y(this, (t.__proto__ || f()(t)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = c()(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (l.a ? l()(e, t) : e.__proto__ = t);
        }(t, e), g(t, [{
          key: "_deserializeTransformOperation",
          value: function value(e) {
            var n = this;
            return function e(t, n, i) {
              null === t && (t = Function.prototype);
              var r = a()(t, n);

              if (void 0 === r) {
                var o = f()(t);
                return null === o ? void 0 : e(o, n, i);
              }

              if ("value" in r) return r.value;
              var s = r.get;
              return void 0 !== s ? s.call(i) : void 0;
            }(t.prototype.__proto__ || f()(t.prototype), "_deserializeCropOperation", this).call(this, e).then(function (e) {
              if (e) {
                var t = h.k.Array.find(n._data.operations, function (e) {
                  return "orientation" === e.type;
                });

                if (t) {
                  var i = t.options;
                  e.rotate(i.rotation), i.flipHorizontally && (e.flip("horizontal"), e.setRotation(-1 * e.getRotation())), i.flipVertically && (e.flip("vertical"), e.setRotation(-1 * e.getRotation()));
                }

                return e._ratio = null, e;
              }
            });
          }
        }, {
          key: "_deserializeText",
          value: function value(e, t) {
            var n = t.options,
                i = n.fontSize,
                r = n.lineHeight,
                o = n.fontIdentifier,
                a = n.alignment,
                s = n.rotation,
                l = n.maxWidth,
                u = n.color,
                c = n.backgroundColor,
                p = this._ui.getFontLoader(),
                f = this._fontManager.getVariationByIdentifier(o);

            return f ? p.setFonts([f.getFont()]) : f = this._fontManager.getDefaultVariation(), p.load().then(function () {
              var t = e.getInputDimensions(!1),
                  o = t.min(),
                  p = t.x,
                  d = t.y,
                  g = l * o / p,
                  m = i * o / d,
                  y = e.createText({
                fontSize: m,
                lineHeight: r,
                fontFamily: f.getFontFamily(),
                fontWeight: f.getFontWeight(),
                fontIdentifier: f.getIdentifier(),
                textMetrics: f.getTextMetrics(),
                alignment: a,
                rotation: s,
                maxWidth: g,
                text: n.text,
                color: h.b.fromArray(u.rgba),
                backgroundColor: h.b.fromArray(c.rgba),
                position: h.n.fromObject(n.position)
              });
              return y._edited = !0, y;
            });
          }
        }]), t;
      }(d.a);

      t.a = _, _.version = "3.9.0";
    }]);
  }, e.exports = n();
}));

function tt(e) {
  return void 0 !== e.x;
}

function nt(e) {
  return A.fromTRS(e.position.x, e.position.y, e.rotation, e.scale.x, e.scale.y);
}

function it(e) {
  var t = e.getParent(),
      n = function (e) {
    return e.getBaseLocalToParentMatrix ? e.getBaseLocalToParentMatrix() : nt(e.getTransform());
  }(e);

  if (void 0 === t) return n;
  var i = it(t);
  return A.multiply(i, n);
}

function rt(e) {
  var t = e.getParent(),
      n = function (e) {
    return e.getLocalToParentMatrix ? e.getLocalToParentMatrix() : nt(e.getTransform());
  }(e);

  if (void 0 === t) return n;
  var i = rt(t);
  return A.multiply(i, n);
}

function ot(e, t, n, i) {
  void 0 === i && (i = !1);
  var r = "output" === t.type && i ? it(t) : rt(t),
      o = "output" === n.type && i ? it(n) : rt(n),
      a = A.getInverted(o);
  return A.transformPoint(a, A.transformPoint(r, e));
}

function at(e, t, n) {
  var i = new R(e, 0),
      r = new R(ot(i, t, n)),
      o = new R(ot(R.ZERO, t, n));
  return R.distance(o, r);
}

function st(e, t) {
  var n = rt(t);
  return A.transformPoint(n, e);
}

function lt(e) {
  var t = rt(e),
      n = e.getBounds(),
      i = {
    x: n.width,
    y: 0
  },
      r = {
    x: 0,
    y: n.height
  },
      o = new R(A.transformPoint(t, R.ZERO)),
      a = new R(A.transformPoint(t, i)),
      s = new R(A.transformPoint(t, r));
  return {
    width: R.distance(o, a),
    height: R.distance(o, s)
  };
}

function ut(e, t, n) {
  void 0 === n && (n = !0);
  var i = t.getBounds();
  return {
    x: e.x * i.width + (n ? 0 : i.minX),
    y: e.y * i.height + (n ? 0 : i.minY)
  };
}

function ct(e, t, n) {
  void 0 === n && (n = !0);
  var i = t.getBounds();
  return {
    x: (e.x - (n ? 0 : i.minX)) / i.width,
    y: (e.y - (n ? 0 : i.minY)) / i.height
  };
}

function pt(e, t) {
  var n = ot({
    x: 1,
    y: 0
  }, e, t, !0),
      i = ot(R.ZERO, e, t, !0);
  return Math.atan2(n.y - i.y, n.x - i.x);
}

function ft(e) {
  return "string" != typeof e && !Array.isArray(e) && void 0 === e.a;
}

function ht(e) {
  return "string" != typeof e && Array.isArray(e) && 3 === e.length;
}

function dt(e) {
  return "string" != typeof e && !Array.isArray(e) && void 0 !== e.a;
}

function gt(e) {
  return "string" != typeof e && Array.isArray(e) && 4 === e.length;
}

!function (e) {
  e.BEGAN_IMAGE_DOWNSCALING = "beganImageDownscaling", e.IMAGE_DOWNSCALED = "imageDownscaled";
}(De || (De = {}));

var mt = function () {
  function e(e, t) {
    this.engine = t, this.transform = O.IDENTITY, this.canvasPivot = {
      x: 0,
      y: 0
    }, this.previewQuality = 1, this.canvas = e;
  }

  return Object.defineProperty(e.prototype, "quality", {
    get: function get() {
      return this.previewQuality;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setQuality = function (e) {
    this.previewQuality = Math.min(Math.max(e, .01), 1);
  }, e.prototype.getTransform = function () {
    return this.transform;
  }, e.prototype.setTransform = function (e) {
    this.transform = e;
  }, e.prototype.getPosition = function () {
    return this.transform.position;
  }, e.prototype.setPosition = function (e, t) {
    var n;
    n = "number" == typeof e ? {
      x: e,
      y: void 0 === t ? e : t
    } : e;
    var i = this.transform.scale,
        r = this.transform.rotation;
    this.setTransform(new O(n, i, r));
  }, e.prototype.getScale = function () {
    return this.transform.scale;
  }, e.prototype.setScale = function (e, t) {
    var n;
    n = "number" != typeof e ? e : {
      x: e,
      y: void 0 === t ? e : t
    };
    var i = this.transform.position,
        r = this.transform.rotation;
    this.setTransform(new O(i, n, r));
  }, e.prototype.getRotation = function () {
    return this.transform.rotation;
  }, e.prototype.setRotation = function (e) {
    var t = this.transform.position,
        n = this.transform.scale;
    this.setTransform(new O(t, n, e));
  }, e.prototype.getCanvasPivot = function () {
    return this.canvasPivot;
  }, e.prototype.setCanvasPivot = function (e, t) {
    this.canvasPivot = "number" == typeof e ? {
      x: e,
      y: void 0 === typeof t ? e : t
    } : e;
  }, e.prototype.getCanvasBounds = function () {
    var e = this.canvasPivot,
        t = this.canvas,
        n = t.width,
        i = t.height;
    return new I(-e.x * n, -e.y * i, n, i);
  }, e;
}();

function yt(e) {
  return void 0 !== e.getTransform;
}

var _t = function (e) {
  function t(t) {
    var n = e.call(this) || this;
    return n.config = t, n;
  }

  return _(t, e), t.prototype.getOutputDimensions = function () {
    var e = this.getOutputContainer();
    return e ? e.getResolution() : {
      width: 0,
      height: 0
    };
  }, t.prototype.convertPointFromPreviewIntoOutputSpace = function (e, t) {
    var n = A.getInverted(nt(t));
    return A.transformPoint(n, e);
  }, t.prototype.convertPointFromPreviewIntoWorldSpace = function (e, t, n) {
    var i = A.getInverted(nt(t)),
        r = n ? this.getOutputContainer().getBaseLocalToParentMatrix() : this.getOutputContainer().getLocalToParentMatrix(),
        o = A.multiply(r, i);
    return A.transformPoint(o, e);
  }, t.prototype.convertPointFromPreviewIntoFlippedPreviewSpace = function (e) {
    var t = this.getOutputContainer().getFlipTransformMatrix();
    return A.transformPoint(t, e);
  }, t.prototype.convertPointFromWorldIntoPreviewSpace = function (e, t) {
    var n = nt(t),
        i = A.getInverted(this.getOutputContainer().getLocalToParentMatrix()),
        r = A.multiply(n, i);
    return A.transformPoint(r, e);
  }, t.prototype.convertPointFromOutputIntoPreviewSpace = function (e, t) {
    var n = nt(t);
    return A.transformPoint(n, e);
  }, t.prototype.getContainersAtPreviewPoint = function (e, t) {
    var n,
        i,
        r = new Array(),
        o = this.convertPointFromPreviewIntoWorldSpace(e, t),
        a = this.getRootContainers();

    try {
      for (var s = T(a), l = s.next(); !l.done; l = s.next()) {
        var u = l.value;
        this.accumulateContainersAtWorldPointInHierarchy(o, u, r);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        l && !l.done && (i = s.return) && i.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return r;
  }, t.prototype.isPreviewPointInContainer = function (e, t, n) {
    var i = this.convertPointFromPreviewIntoWorldSpace(e, n);
    return this.isWorldPointInContainer(i, t);
  }, t.prototype.isWorldPointInContainer = function (e, t) {
    var n = rt(t),
        i = A.getInverted(n),
        r = A.transformPoint(i, e);
    return I.contains(t.getBounds(), r);
  }, t.prototype.accumulateContainersAtWorldPointInHierarchy = function (e, t, n) {
    var i, r;
    this.isWorldPointInContainer(e, t) && n.push(t);
    var o = t.getChildren();

    try {
      for (var a = T(o), s = a.next(); !s.done; s = a.next()) {
        var l = s.value;
        yt(l) && this.accumulateContainersAtWorldPointInHierarchy(e, l, n);
      }
    } catch (e) {
      i = {
        error: e
      };
    } finally {
      try {
        s && !s.done && (r = a.return) && r.call(a);
      } finally {
        if (i) throw i.error;
      }
    }
  }, t;
}(Te),
    vt = function () {
  function e(e) {
    this.engine = e, this.id = F();
  }

  return e.prototype.getID = function () {
    return this.id;
  }, e.prototype.getContainer = function () {
    return this.engine.getRootContainers()[0];
  }, e.prototype.getIndexInParent = function () {
    for (var e = this.engine.rootOperations, t = 0; t < e.length; t += 1) {
      if (e[t].getID() === this.id) return t;
    }

    return -1;
  }, e.prototype.setIndexInParent = function (e) {
    this.engine.moveIndex(this, e);
  }, e.prototype.isValid = function () {
    return -1 !== this.getIndexInParent();
  }, e;
}(),
    bt = function (e) {
  function t(t, n, i) {
    var r = e.call(this, n) || this;
    return r.operation = i, r.type = "adjustments", r.setProperties(t), r;
  }

  return _(t, e), t.prototype.getProperties = function () {
    var e = this.operation.getOptions(),
        t = e.gamma - 1;
    return {
      brightness: e.brightness || 0,
      saturation: e.saturation || 0,
      contrast: e.contrast || 0,
      gamma: (t < 0 ? 2 * t : t) || 0,
      clarity: e.clarity || 0,
      exposure: e.exposure || 0,
      shadows: .5 * e.shadows || 0,
      highlights: e.highlights || 0,
      whites: e.whites || 0,
      blacks: e.blacks || 0,
      temperature: e.temperature || 0,
      sharpness: e.sharpness || 0
    };
  }, t.prototype.setProperties = function (e) {
    void 0 !== e.gamma && (e.gamma = 1 + (e.gamma < 0 ? .5 * e.gamma : e.gamma)), e.shadows && (e.shadows = 2 * e.shadows), this.operation.set(e);
  }, t.prototype.getOperation = function () {
    return this.operation;
  }, t.prototype.getTypeIdentifier = function () {
    return "adjustments";
  }, t;
}(vt),
    wt = function wt(e) {
  if (dt(e)) return new et.PhotoEditorSDK.Color(e.r, e.g, e.b, e.a);
  if (gt(e)) return new et.PhotoEditorSDK.Color(e[0], e[1], e[2], e[3]);
  if (ft(e)) return new et.PhotoEditorSDK.Color(e.r, e.g, e.b, 1);
  if (ht(e)) return new et.PhotoEditorSDK.Color(e[0], e[1], e[2], 1);

  if (function (e) {
    return "string" == typeof e;
  }(e)) {
    var t = S(e.match(/[0-9A-fa-f]{1,2}/g), 3),
        n = t[0],
        i = t[1],
        r = t[2];
    return new et.PhotoEditorSDK.Color(parseInt(n, 16) / 255, parseInt(i, 16) / 255, parseInt(r, 16) / 255, 1);
  }

  throw new Error("Invalid color type");
},
    xt = function () {
  function e(e, t) {
    void 0 === e && (e = 0), void 0 === t && (t = 0), this._x = e, this._y = t;
  }

  return Object.defineProperty(e.prototype, "x", {
    get: function get() {
      return this._x;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "y", {
    get: function get() {
      return this._y;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.set = function (e, t) {
    return this._x = e, this._y = t, this;
  }, e.prototype.clone = function () {
    return new e(this._x, this._y);
  }, e.prototype.copy = function (e) {
    return this._x = e.x, this._y = e.y, this;
  }, e.prototype.clamped = function (e, t) {
    void 0 === e && (e = this), void 0 === t && (t = this);
    var n = "number" == typeof e ? {
      x: e,
      y: e
    } : e,
        i = "number" == typeof t ? {
      x: t,
      y: t
    } : t;
    return this._x = Math.max(n.x, this._x), this._y = Math.max(n.y, this._y), this._x = Math.min(i.x, this._x), this._y = Math.min(i.y, this._y), this;
  }, e.prototype.divide = function (e, t) {
    return "number" == typeof e || null === e ? (this._x /= e, this._y /= void 0 === t ? e : t) : (this._x /= e.x, this._y /= e.y), this;
  }, e.prototype.subtract = function (e, t) {
    return "number" == typeof e || null === e ? (this._x -= e, this._y -= void 0 === t ? e : t) : (this._x -= e.x, this._y -= e.y), this;
  }, e.prototype.multiply = function (e, t) {
    return "number" == typeof e || null === e ? (this._x *= e, this._y *= void 0 === t ? e : t) : (this._x *= e.x, this._y *= e.y), this;
  }, e.prototype.add = function (e, t) {
    return "number" == typeof e || null === e ? (this._x += e, this._y += void 0 === t ? e : t) : (this._x += e.x, this._y += e.y), this;
  }, e.prototype.dot = function (e, t) {
    return "number" == typeof e || null === e ? this._x * e + this._y * (void 0 === t ? e : t) : this._x * e.x + this._y * e.y;
  }, e.prototype.equals = function (e, t) {
    return "number" == typeof e || null === e ? e === this._x && t === this._y : e.x === this._x && e.y === this._y;
  }, e.prototype.flip = function () {
    var e = this._x;
    return this._x = this._y, this._y = e, this;
  }, e.prototype.round = function () {
    return this._x = Math.round(this._x), this._y = Math.round(this._y), this;
  }, e.prototype.ceil = function () {
    return this._x = Math.ceil(this._x), this._y = Math.ceil(this._y), this;
  }, e.prototype.floor = function () {
    return this._x = 0 | this._x, this._y = 0 | this._y, this;
  }, e.prototype.abs = function () {
    return this._x = Math.abs(this._x), this._y = Math.abs(this._y), this;
  }, e.prototype.len = function () {
    return Math.sqrt(this._x * this._x + this._y * this._y);
  }, e.prototype.min = function () {
    return Math.min(this._x, this._y);
  }, e.prototype.max = function () {
    return Math.max(this._x, this._y);
  }, e.prototype.toObject = function () {
    return {
      x: this._x,
      y: this._y
    };
  }, e.prototype.toString = function () {
    return "Vector2({ x: " + this._x + ", y: " + this._y + " })";
  }, e.prototype.roundDecimal = function (e) {
    return this._x = parseFloat(this._x.toFixed(e)), this._y = parseFloat(this._y.toFixed(e)), this;
  }, e.prototype.asArray = function (e) {
    return void 0 === e && (e = !1), e ? [this._y, this._x] : [this._x, this._y];
  }, e.fromObject = function (t) {
    return new e(t.x, t.y);
  }, e.fromSize = function (t) {
    return new e(t.width, t.height);
  }, Object.defineProperty(e, "NULL", {
    get: function get() {
      return new e(0, 0);
    },
    enumerable: !0,
    configurable: !0
  }), e;
}(),
    kt = function () {
  function e(e) {
    this.engine = e, this.id = F(), this.transform = O.IDENTITY, this.bounds = I.ZERO;
  }

  return e.prototype.getID = function () {
    return this.id;
  }, e.prototype.getParent = function () {
    var e = this.engine.getRootContainers();
    if (0 !== e.length && this.id !== e[0].id) return e[0];
  }, e.prototype.getIndexInParent = function () {
    for (var e = this.engine.rootOperations, t = 0; t < e.length; t += 1) {
      if (e[t].getID() === this.id) return t;
    }

    return -1;
  }, e.prototype.setIndexInParent = function (e) {
    this.engine.moveIndex(this, e);
  }, e.prototype.getChildren = function () {
    var e = this.engine.getRootContainers();
    return e.length > 0 && (this.id === e[0].id || this.id === this.engine.getOutputContainer().id) ? this.engine.rootOperations : [];
  }, e.prototype.getBounds = function () {
    return this.bounds;
  }, e.prototype.setPivotOnSelfAndSprite = function (e, t, n) {
    "number" == typeof t ? (this.setPivotInternal(t, n), e.setPivot(new xt(t, n))) : (this.setPivotInternal(t), e.setPivot(xt.fromObject(t)));
  }, e.prototype.setPivot = function (e, t) {
    this.setPivotInternal(e, t);
  }, e.prototype.getPivot = function () {
    var e = this.getBounds();
    return {
      x: -e.minX / e.width,
      y: -e.minY / e.height
    };
  }, e.prototype.getTransform = function () {
    return this.transform;
  }, e.prototype.setTransform = function (e) {
    this.transform = e;
  }, e.prototype.updateTransform = function () {
    this.setTransform(this.transform);
  }, e.prototype.getPosition = function () {
    return this.transform.position;
  }, e.prototype.setPosition = function (e, t) {
    var n;
    n = "number" == typeof e ? {
      x: e,
      y: void 0 === t ? e : t
    } : e;
    var i = this.transform.scale,
        r = this.transform.rotation;
    this.setTransform(new O(n, i, r));
  }, e.prototype.getScale = function () {
    return this.transform.scale;
  }, e.prototype.setScale = function (e, t) {
    var n;
    n = "number" != typeof e ? e : {
      x: e,
      y: void 0 === t ? e : t
    };
    var i = this.transform,
        r = i.position,
        o = i.rotation;
    this.setTransform(new O(r, n, o));
  }, e.prototype.getRotation = function () {
    return this.transform.rotation;
  }, e.prototype.setRotation = function (e) {
    var t = this.transform,
        n = t.position,
        i = t.scale;
    this.setTransform(new O(n, i, e));
  }, e.prototype.getSizeInWorldSpace = function () {
    return lt(this);
  }, e.prototype.getSizeInOutputSpace = function () {
    return e = this, t = this.engine.getOutputContainer(), n = lt(e), i = t.getTransform().scale, r = 1 / i.x, o = 1 / i.y, {
      width: n.width * r,
      height: n.height * o
    };
    var e, t, n, i, r, o;
  }, e.prototype.setSizeInWorldSpace = function (e) {
    var t = this.getBounds();
    this.setScale(e.width / t.width, e.height / t.height);
  }, e.prototype.setSizeInOutputSpace = function (e) {
    var t = this.engine.getOutputContainer().getScale();
    this.setSizeInWorldSpace({
      width: e.width / t.x,
      height: e.height / t.y
    });
  }, e.prototype.isValid = function () {
    return -1 !== this.getIndexInParent();
  }, e.prototype.setPivotInternal = function (e, t) {
    var n = this.getBounds();
    "number" == typeof e ? this.setBoundsFromSize(n.width, n.height, {
      x: e,
      y: t
    }) : this.setBoundsFromSize(n.width, n.height, e);
  }, e.prototype.setBoundsFromSize = function (e, t, n) {
    void 0 === n && (n = this.getPivot()), this.bounds = new I(-n.x * e, -n.y * t, e, t);
  }, e;
}(),
    Tt = function (e) {
  function t(t, n) {
    var i = e.call(this, n) || this;
    i.type = "drawing", i.drawing = t, i.operation = n.createSpriteOperation(), i.sprite = i.operation.createBrush({}), i.operation.addSprite(i.sprite), i.radialBrush = i.sprite._createRadialBrush();
    var r = n.getRootContainers()[0].getBounds();
    return i.bounds = new I(0, 0, r.width, r.height), i.setTransform(O.IDENTITY), i.operation.setDirty(!0), i.setData(t), i;
  }

  return _(t, e), t.prototype.beginStroke = function (e) {
    if (this.currentStroke) throw new Error("A brush stroke has already been started but not finished.");
    if ("imgly_brush_radial" !== e.id) throw new Error("This adapter does not support any brush faces other than the radial img.ly brush.");
    this.currentBrush = e, this.currentStroke = {
      brush: e,
      path: {
        controlPoints: []
      }
    };
    var t = this.engine.getOutputContainer().getBounds(),
        n = Math.min(t.width, t.height);
    this.radialBrush.setColor(wt(e.color)), this.radialBrush.setHardness(e.hardness), this.radialBrush.setSize(e.size / n), this.currentPath = this.sprite.createPath(this.radialBrush.clone());
  }, t.prototype.addPointToCurrentStroke = function (e, t) {
    if (void 0 === t && (t = !0), !this.currentStroke || !this.currentBrush || !this.currentPath) throw new Error('A brush stroke has to first be started with a call to "beginStroke(brush:Brush)"');

    if (this.currentStroke.path.controlPoints.length) {
      var n = this.currentStroke.path.controlPoints,
          i = n[n.length - 1],
          r = this.currentBrush.size / 10;
      if (Math.sqrt(e.x - Math.pow(i.x, 2) + (e.y - Math.pow(i.y, 2))) < r) return;
    }

    var o = this.engine.getOutputContainer(),
        a = ct(ot(e, this.engine.getRootContainers()[0], o, !0), o, !1),
        s = o.getBounds();
    this.currentPath.addControlPoint(xt.fromObject(a)), this.currentStroke.path.controlPoints.push(e), t && this.sprite.render(xt.fromObject({
      x: s.width,
      y: s.height
    }));
  }, t.prototype.endStroke = function () {
    if (this.currentStroke && this.currentPath && this.currentBrush) {
      this.currentStroke.path.controlPoints.length && this.drawing.strokes.push(this.currentStroke), this.currentStroke = void 0, this.currentBrush = void 0, this.currentPath.setClosed(!0);
      var e = this.engine.getOutputContainer().getBounds();
      this.sprite.render(xt.fromObject({
        x: e.width,
        y: e.height
      })), this.currentPath = void 0;
    }
  }, t.prototype.setData = function (e) {
    this.drawing = _v2(_v2({}, this.drawing), e), this.drawing.strokes && (this.drawing.strokes = []), this.sprite.clearPersistCanvas(), this.sprite.clearCanvas(), this.sprite.setPaths([]), this.drawStrokes(e.strokes);
  }, t.prototype.getData = function () {
    return this.drawing;
  }, t.prototype.updateData = function () {
    this.setData(this.getData());
  }, t.prototype.getOperation = function () {
    return this.operation;
  }, t.prototype.drawStrokes = function (e) {
    var t = this;
    e.forEach(function (e) {
      t.beginStroke(e.brush), e.path.controlPoints.forEach(function (e) {
        t.addPointToCurrentStroke(e, !0);
      }), t.endStroke();
    });
  }, t;
}(kt),
    St = function (e) {
  function t(t, n, i, r) {
    var o = e.call(this, r) || this;
    return o.filterOperation = n, o.type = "duotone-filter", n.set({
      intensity: i.colorIntensity
    }), n.set({
      filter: t
    }), r.pesdk.setAllOperationsToDirty(), o;
  }

  return _(t, e), t.prototype.getProperties = function () {
    return {
      colorIntensity: this.filterOperation.getOptions().intensity
    };
  }, t.prototype.setProperties = function (e) {
    var t = this.filterOperation.getOptions().intensity;
    void 0 !== e.colorIntensity && (t = Math.min(Math.max(e.colorIntensity, 0), 1)), this.filterOperation.set({
      intensity: t
    });
  }, t.prototype.getOperation = function () {
    return this.filterOperation;
  }, t.prototype.getTypeIdentifier = function () {
    return "filter";
  }, t;
}(vt),
    Ct = function () {
  function e(e, t) {
    this.engine = t, this.loaded = !1, this.loading = !1, this.asset = _v2({}, e);
  }

  return e.prototype.load = function () {
    return x(this, void 0, void 0, function () {
      var e,
          t,
          n = this;
      return k(this, function (i) {
        return this.loaded ? [2, Promise.resolve()] : this.loading ? [2, Promise.reject(new Error("Called Frame#load while it's already loading"))] : (this.loading = !0, e = this.asset.imageGroups, t = [], ["top", "left", "right", "bottom"].forEach(function (i) {
          if (e[i]) {
            var r = e[i];
            ["start", "mid", "end"].forEach(function (e) {
              e in r && t.push(n.loadPart(i, e));
            });
          }
        }), [2, Promise.all(t).then(function () {
          n.loaded = !0, n.loading = !1;
        }).catch(function () {
          n.loaded = !1, n.loading = !1;
        })]);
      });
    });
  }, e.prototype.getFrame = function () {
    return _v2(_v2({}, this.asset), {
      defaultName: this.asset.name,
      thumbnail: this.asset.thumbnailURI
    });
  }, e.prototype.getIdentifier = function () {
    return this.asset.identifier;
  }, e.prototype.getDefaultName = function () {
    return this.asset.name;
  }, e.prototype.getThumbnail = function () {
    return this.asset.thumbnailURI;
  }, e.prototype.getTintable = function () {
    return this.asset.tintable || !1;
  }, e.prototype.getLayoutMode = function () {
    return this.asset.layoutMode;
  }, e.prototype.getImageGroups = function () {
    return this.asset.imageGroups;
  }, e.prototype.loadPart = function (e, t) {
    return x(this, void 0, void 0, function () {
      var n = this;
      return k(this, function (i) {
        return [2, new Promise(function (i, r) {
          var o = n.asset.imageGroups[e][t],
              a = o;
          "string" != typeof o && "image" in o && (a = o.image);
          var s = new Image();
          s.addEventListener("load", function () {
            "string" != typeof o ? n.asset.imageGroups[e][t].image = s : n.asset.imageGroups[e][t] = s, i(s);
          }), s.addEventListener("error", function () {
            r(new Error("Failed to load image at " + s.src));
          }), s.crossOrigin = n.engine.configuration.crossOrigin || "anonymus", s.src = n.engine.assetProvider.getAssetSource("frame", a);
        })];
      });
    });
  }, e;
}(),
    Et = function (e) {
  function t(t, n, i) {
    var r = e.call(this, i) || this;
    return r.frameOperation = t, r.type = "frame", r.setProperties(n), i.pesdk.setAllOperationsToDirty(), r;
  }

  return _(t, e), t.prototype.setProperties = function (e) {
    if (this.props = _v2(_v2({}, this.props), e), "number" == typeof e.opacity && this.frameOperation.set({
      alpha: e.opacity
    }), e.tintColor && this.frameOperation.set({
      tintColor: wt(e.tintColor)
    }), e.width) {
      var t = this.engine.getOutputContainer().getBounds(),
          n = Math.min(t.width, t.height),
          i = e.width / n;
      this.frameOperation.set({
        scale: i
      });
    }

    this.frameOperation.setDirty(!0);
  }, t.prototype.getProperties = function () {
    return this.props;
  }, t.prototype.getOperation = function () {
    return this.frameOperation;
  }, t.prototype.getTypeIdentifier = function () {
    return "frame";
  }, t;
}(vt),
    Ot = function (e) {
  function t(t, n, i) {
    var r = e.call(this, n) || this;
    return r.blurOperation = i, r.type = "gaussian-blur", r.setProperties(t), r;
  }

  return _(t, e), t.prototype.getProperties = function () {
    var e = this.engine.getOutputContainer(),
        t = e.getBounds(),
        n = Math.min(t.size.width, t.size.height);
    return {
      blurRadius: at(this.blurOperation.getOptions().blurRadius * n, e, this.getContainer())
    };
  }, t.prototype.setProperties = function (e) {
    if (void 0 !== e.blurRadius) {
      var t = this.engine.pesdk.getOutputDimensions(),
          n = Math.min(t.x, t.y),
          i = this.getContainer(),
          r = this.engine.getOutputContainer(),
          o = at(e.blurRadius, i, r) / n;
      this.blurOperation.set({
        blurRadius: o
      });
    }
  }, t.prototype.getOperation = function () {
    return this.blurOperation;
  }, t.prototype.getTypeIdentifier = function () {
    return "blur";
  }, t;
}(vt),
    Rt = function (e) {
  function t(t, n) {
    var i = e.call(this, n) || this;
    i.data = t, i.type = "image";
    var r = n.configuration.downscaleOptions;

    if (r) {
      var o = r.maxDimensions;
      i.downscaleOptions = {
        maxMegaPixels: r.maxMegaPixels,
        maxDimensions: {
          width: Math.min(n.maxTextureDimension, o ? o.width : Number.MAX_VALUE),
          height: Math.min(n.maxTextureDimension, o ? o.height : Number.MAX_VALUE)
        }
      };
    } else i.downscaleOptions = {
      maxDimensions: {
        width: n.maxTextureDimension,
        height: n.maxTextureDimension
      }
    };

    i.setData(t);
    var a = i.data.image;
    return i.bounds = new I(R.ZERO, {
      width: a.width,
      height: a.height
    }), i;
  }

  return _(t, e), t.prototype.setData = function (e) {
    var t = this;

    if (this.data = _v2(_v2({}, this.data), e), e.image) {
      var n = e.image,
          i = void 0;

      if (n instanceof HTMLImageElement && (i = this.engine.pesdk.parseExif(n))) {
        var r = i.getTags();

        if (r && r.Orientation) {
          var o = 1 !== r.Orientation && 2 !== r.Orientation,
              a = -1 !== [2, 4, 5, 7].indexOf(r.Orientation);

          if (o || a) {
            if (!CSS.supports("image-orientation", "from-image")) {
              var s = this.engine.pesdk.createOperation("exif-orientation", {}, !1);
              s.setTags(r), n = s.applyTo(n);
            }

            i.setOrientation(1), r.Orientation = 1;
          }
        }
      }

      var l = new Se(n, this.downscaleOptions);
      l.on(ke.IMAGE_DOWNSCALED, function () {
        t.engine.emit(De.IMAGE_DOWNSCALED);
      }), l.on(ke.BEGAN_IMAGE_DOWNSCALING, function () {
        t.engine.emit(De.BEGAN_IMAGE_DOWNSCALING);
      }), n = l.downscaleIfNecessary(), this.data.image = n, this.engine.pesdk.setImage(n, i), this.setBoundsFromSize(n.width, n.height);
    }
  }, t.prototype.getData = function () {
    return this.data;
  }, t.prototype.setPivot = function (e, t) {
    throw new Error("This container does not support modifying the pivot");
  }, t.prototype.getOperation = function () {
    throw new Error("This container has no associated operation");
  }, t;
}(kt),
    It = function (e) {
  function t(t, n, i) {
    var r = e.call(this, n) || this;
    return r.props = t, r.blurOperation = i, r.type = "linear-blur", r.setProperties(t), r;
  }

  return _(t, e), t.prototype.getProperties = function () {
    return this.props;
  }, t.prototype.setProperties = function (e) {
    this.props = _v2(_v2({}, this.props), e);
    var t = this.blurOperation.getOptions(),
        n = this.engine.getOutputContainer(),
        i = n.getBounds(),
        r = this.getContainer(),
        o = n.getBaseLocalToParentMatrix(),
        a = it(r),
        s = A.multiply(A.getInverted(o), a),
        l = Math.min(i.size.width, i.size.height);

    if (void 0 !== e.blurRadius) {
      var u = at(e.blurRadius, r, n);
      t.blurRadius = u / l;
    }

    if (void 0 !== e.start) {
      var c = ct(A.transformPoint(s, e.start), n, !1);
      t.controlPoint1 = c;
    }

    if (void 0 !== e.end) {
      var p = ct(A.transformPoint(s, e.end), n, !1);
      t.controlPoint2 = p;
    }

    this.blurOperation.set(t);
  }, t.prototype.updateProperties = function () {
    var e = this.getProperties();
    this.setProperties(e);
  }, t.prototype.getOperation = function () {
    return this.blurOperation;
  }, t.prototype.getTypeIdentifier = function () {
    return "linear-focus";
  }, t;
}(vt),
    At = function (e) {
  function t(t, n, i, r) {
    var o = e.call(this, r) || this;
    return o.filter = t, o.filterOperation = n, o.props = i, o.type = "lut-filter", n.set({
      intensity: i.intensity
    }), n.set({
      filter: t
    }), r.pesdk.setAllOperationsToDirty(), o;
  }

  return _(t, e), t.prototype.getProperties = function () {
    return {
      intensity: this.filterOperation.getOptions().intensity,
      lutImage: this.props.lutImage,
      horizontalTileCount: this.props.horizontalTileCount,
      verticalTileCount: this.props.verticalTileCount
    };
  }, t.prototype.setProperties = function (e) {
    var t = this.filterOperation.getOptions(),
        n = "number" == typeof e.intensity ? e.intensity : t.intensity;
    this.filterOperation.set({
      intensity: n
    });
  }, t.prototype.getOperation = function () {
    return this.filterOperation;
  }, t.prototype.getTypeIdentifier = function () {
    return "filter";
  }, t;
}(vt),
    Mt = function (e) {
  function t(t, n, i) {
    var r = e.call(this, n) || this;
    return r.props = t, r.blurOperation = i, r.type = "mirrored-blur", r.setProperties(t), r;
  }

  return _(t, e), t.prototype.getProperties = function () {
    return this.props;
  }, t.prototype.setProperties = function (e) {
    this.props = _v2(_v2({}, this.props), e);
    var t = this.blurOperation.getOptions(),
        n = this.engine.getOutputContainer(),
        i = n.getBounds(),
        r = this.getContainer(),
        o = n.getBaseLocalToParentMatrix(),
        a = it(r),
        s = A.multiply(A.getInverted(o), a),
        l = Math.min(i.size.width, i.size.height);

    if (void 0 !== e.blurRadius) {
      var u = at(e.blurRadius, r, n);
      t.blurRadius = u / l;
    }

    if (void 0 !== e.gradientSize) {
      var c = at(e.gradientSize, r, n) / l;
      t.gradientSize = c;
    }

    if (void 0 !== e.clearAreaWidth) {
      var p = at(e.clearAreaWidth, r, n) / l;
      t.size = .5 * p;
    }

    if (void 0 !== e.mirrorAxisOrigin) {
      var f = ct(A.transformPoint(s, e.mirrorAxisOrigin), n, !1);
      t.start = f;
    }

    if (void 0 !== e.mirrorAxisDirection) {
      var h = ct(A.transformPoint(s, e.mirrorAxisDirection), n, !1);
      t.end = h;
    }

    this.blurOperation.set(t);
  }, t.prototype.updateProperties = function () {
    var e = this.getProperties();
    this.setProperties(e);
  }, t.prototype.getOperation = function () {
    return this.blurOperation;
  }, t.prototype.getTypeIdentifier = function () {
    return "mirrored-focus";
  }, t;
}(vt),
    Ft = function (e) {
  function t(t, n, i, r) {
    var o = e.call(this, r) || this;
    return o.settings = t, o.operation = n, o.flipOperation = i, o.type = "output", o.flipTransform = A.IDENTITY, o.blockTransformUpdate = !1, o.transformUpdateWhileBlock = !1, o.bounds = new I({
      x: 0,
      y: 0
    }, o.settings.resolution), o.setData(t), o;
  }

  return _(t, e), t.prototype.pauseChildrenUpdates = function () {
    this.transformUpdateWhileBlock = !1, this.blockTransformUpdate = !0;
  }, t.prototype.resumeChildrenUpdates = function () {
    this.blockTransformUpdate = !1, this.transformUpdateWhileBlock && this.updateChildrenContainers();
  }, t.prototype.setData = function (e) {
    if (this.settings = _v2(_v2({}, this.settings), e), e.resolution && (this.setBoundsFromSize(e.resolution.width, e.resolution.height), this.setTransform(this.transform), this.operation.set({
      outputResolution: new xt(e.resolution.width, e.resolution.height)
    })), void 0 !== e.flipHorizontally) {
      var t = e.flipHorizontally;
      this.updateFlipTransform(), this.flipOperation.set({
        flipHorizontally: t
      });
    }

    if (void 0 !== e.flipVertically) {
      t = e.flipVertically;
      this.updateFlipTransform(), this.flipOperation.set({
        flipVertically: t
      });
    }

    this.operation.setDirty(!0), this.flipOperation.setDirty(!0);
  }, t.prototype.getData = function () {
    return this.settings;
  }, t.prototype.setResolution = function (e) {
    this.setData({
      resolution: e
    });
  }, t.prototype.getResolution = function () {
    return this.getData().resolution;
  }, t.prototype.setTransform = function (e) {
    if (this.transform.rotation !== e.rotation || this.transform.position !== e.position || this.transform.scale !== e.scale) {
      this.transform = e;
      var t = this.flipTransform;
      this.flipTransform = A.IDENTITY;
      var n = ot({
        x: 0,
        y: 0
      }, this.engine.getRootContainers()[0], this),
          i = -e.rotation,
          r = xt.fromObject(n).clone().subtract(xt.fromObject(this.getBounds().origin));
      this.operation.set({
        pivot: new xt(0, 0),
        position: r,
        scale: new xt(1 / e.scale.x, 1 / e.scale.y),
        rotation: i
      }), this.flipTransform = t, this.operation.setDirty(!0), this.updateChildrenContainers();
    }
  }, t.prototype.rotate90 = function (e) {
    void 0 === e && (e = !1);
    var t = e ? .5 * -Math.PI : .5 * Math.PI,
        n = this.getResolution(),
        i = this.getPivot(),
        r = this.getBounds(),
        o = st({
      x: r.midX,
      y: r.midY
    }, this);
    this.setPivot(.5, .5), this.setPosition(o), this.setRotation(this.getRotation() - t);
    var a = {
      width: n.height,
      height: n.width
    };
    this.setResolution(a);
    var s = st({
      x: -a.width * (.5 - i.x),
      y: -a.height * (.5 - i.y)
    }, this);
    this.setPivot(i), this.setPosition(s), this.updateChildrenContainers();
  }, t.prototype.setPivot = function (t, n) {
    e.prototype.setPivotInternal.call(this, t, n), this.setTransform(this.transform);
  }, t.prototype.getTransform = function () {
    return this.transform;
  }, t.prototype.getBaseLocalToParentMatrix = function () {
    return nt(this.getTransform());
  }, t.prototype.getLocalToParentMatrix = function () {
    var e = nt(this.getTransform());
    return A.multiply(e, this.flipTransform);
  }, t.prototype.getFlipTransformMatrix = function () {
    return this.flipTransform;
  }, t.prototype.isValid = function () {
    return !0;
  }, t.prototype.getOperation = function () {
    return this.operation;
  }, t.prototype.updateFlipTransform = function () {
    var e = this.settings,
        t = e.flipHorizontally,
        n = e.flipVertically;

    if (t || n) {
      var i = this.getPivot(),
          r = this.getBounds(),
          o = t ? -1 : 1,
          a = t ? -2 * (i.x - .5) * r.width : 0,
          s = n ? -1 : 1,
          l = n ? -2 * (i.y - .5) * r.height : 0;
      this.flipTransform = new A(o, 0, 0, s, a, l);
    } else this.flipTransform = A.IDENTITY;
  }, t.prototype.updateChildrenContainers = function () {
    this.blockTransformUpdate ? this.transformUpdateWhileBlock = !0 : this.engine.rootOperations.forEach(function (e) {
      yt(e) ? (e.updateTransform(), "updateData" in e && e.updateData()) : "updateProperties" in e && e.updateProperties();
    });
  }, t;
}(kt),
    Dt = function (e) {
  function t(t, n, i) {
    var r = e.call(this, i) || this;
    r.overlayOperation = t, r.type = "overlay";
    var o = n.blendMode || i.mapBlendMode(t.getBlendMode());
    return t.set({
      blendMode: i.reverseMapBlendMode(o)
    }), t.set({
      image: n.image
    }), i.pesdk.setAllOperationsToDirty(), r;
  }

  return _(t, e), t.prototype.getProperties = function () {
    var e = this.overlayOperation.getOptions();
    return {
      image: e.image,
      blendMode: this.engine.mapBlendMode(e.blendMode),
      opacity: e.alpha
    };
  }, t.prototype.setProperties = function (e) {
    var t = this.overlayOperation.getOptions();
    "number" == typeof e.opacity && (t.alpha = e.opacity), void 0 !== e.blendMode && (t.blendMode = this.engine.reverseMapBlendMode(e.blendMode)), this.overlayOperation.set(t), this.overlayOperation.setDirty(!0);
  }, t.prototype.getOperation = function () {
    return this.overlayOperation;
  }, t.prototype.getTypeIdentifier = function () {
    return "overlay";
  }, t.prototype.setFlipHorizontally = function (e) {
    this.overlayOperation.setFlipHorizontally(e);
  }, t.prototype.setFlipVertically = function (e) {
    this.overlayOperation.setFlipVertically(e);
  }, t.prototype.getFlipHorizontally = function () {
    return this.overlayOperation.getFlipHorizontally();
  }, t.prototype.getFlipVertically = function () {
    return this.overlayOperation.getFlipVertically();
  }, t;
}(vt),
    Pt = function (e) {
  function t(t, n, i) {
    var r = e.call(this, n) || this;
    return r.props = t, r.blurOperation = i, r.type = "radial-blur", r.setProperties(t), r;
  }

  return _(t, e), t.prototype.getProperties = function () {
    return this.props;
  }, t.prototype.setProperties = function (e) {
    this.props = _v2(_v2({}, this.props), e);
    var t = this.blurOperation.getOptions(),
        n = this.engine.getOutputContainer(),
        i = n.getBounds(),
        r = this.getContainer(),
        o = n.getBaseLocalToParentMatrix(),
        a = it(r),
        s = A.multiply(A.getInverted(o), a),
        l = Math.min(i.size.width, i.size.height);

    if (void 0 !== e.blurRadius) {
      var u = at(e.blurRadius, r, n);
      t.blurRadius = u / l;
    }

    if (void 0 !== e.center) {
      var c = ct(A.transformPoint(s, e.center), n, !1);
      t.position = c;
    }

    if (void 0 !== e.radius) {
      var p = at(e.radius, r, n) / l;
      t.radius = p;
    }

    if (void 0 !== e.gradientSize) {
      var f = at(e.gradientSize, r, n) / l;
      t.gradientRadius = f;
    }

    this.blurOperation.set(t);
  }, t.prototype.updateProperties = function () {
    var e = this.getProperties();
    this.setProperties(e);
  }, t.prototype.getOperation = function () {
    return this.blurOperation;
  }, t.prototype.getTypeIdentifier = function () {
    return "radial-focus";
  }, t;
}(vt),
    zt = function (e) {
  function t(t, n) {
    var i = e.call(this, n) || this;
    i.data = t, i.type = "sticker";
    var r = t.image,
        o = i.engine.pesdk.parseExif(t.image);

    if (o) {
      var a = o.getTags();

      if (a && a.Orientation) {
        var s = 1 !== a.Orientation && 2 !== a.Orientation,
            l = -1 !== [2, 4, 5, 7].indexOf(a.Orientation);

        if (s || l) {
          var u = i.engine.pesdk.createOperation("exif-orientation", {}, !1);
          u.setTags(a), r = u.applyTo(t.image), o.setOrientation(1), a.Orientation = 1;
        }
      }
    }

    return r = new Se(r, {
      maxMegaPixels: {
        desktop: 10,
        mobile: 5
      }
    }).downscaleImageIfNecessary(), i.operation = n.createSpriteOperation(), i.sprite = i.operation.createSticker({
      identifier: "",
      image: r,
      position: new xt(0, 0),
      dimensions: new xt(1, 1),
      rotation: 0,
      smoothDownscaling: !1
    }), i.operation.addSprite(i.sprite), i.bounds = new I({
      x: 0,
      y: 0
    }, {
      width: r.width,
      height: r.height
    }), i.setTransform(O.IDENTITY), i.sprite.setPivot(new xt(0, 0)), i.operation.setDirty(!0), i.setData(t), i;
  }

  return _(t, e), t.prototype.setData = function (e) {
    this.data = _v2(_v2({}, this.data), e), e.id && (this.id = e.id), e.opacity && this.sprite.setAlpha(e.opacity), e.tintColor && this.sprite.setTintColor(wt(e.tintColor)), e.tintMode && this.sprite.setTintMode(e.tintMode), this.operation.setDirty(!0);
  }, t.prototype.getData = function () {
    return this.data;
  }, t.prototype.updateData = function () {
    this.setData(this.getData());
  }, t.prototype.setTransform = function (t) {
    e.prototype.setTransform.call(this, t);

    var n = this.engine.getOutputContainer(),
        i = this.getParent(),
        r = function (e, t, n) {
      var i = tt(e) ? e.x : e.width,
          r = tt(e) ? e.y : e.height;
      return {
        width: at(i, t, n),
        height: at(r, t, n)
      };
    }({
      width: this.bounds.width * t.scale.x,
      height: this.bounds.height * t.scale.y
    }, i, n);

    this.sprite.setDimensions(xt.fromSize(r));
    var o = ct(ot(t.position, i, n, !0), n, !1);
    this.sprite.setPosition(new xt(o.x, o.y));
    var a = pt(i, n),
        s = t.rotation + a;
    this.sprite.setRotation(s), this.operation.setDirty(!0);
  }, t.prototype.setPivot = function (e, t) {
    this.setPivotOnSelfAndSprite(this.sprite, e, t);
  }, t.prototype.getOperation = function () {
    return this.operation;
  }, t.prototype.setFlipHorizontally = function (e) {
    this.sprite.setFlipHorizontally(e);
  }, t.prototype.setFlipVertically = function (e) {
    this.sprite.setFlipVertically(e);
  }, t.prototype.getFlipHorizontally = function () {
    return this.sprite.getFlipHorizontally();
  }, t.prototype.getFlipVertically = function () {
    return this.sprite.getFlipVertically();
  }, t;
}(kt);

var Lt = function () {
  function e(e) {
    this.context = e, this.sourceLines = [], this.maxWidth = 100;
  }

  return e.buildWords = function (e) {
    for (var t = [], n = "", i = e.length, r = 0; r < i; r += 1) {
      var o = e[r];
      n += o, " " !== o && "-" !== o && r !== i - 1 || (t.push(n), n = "");
    }

    return t;
  }, e.prototype.getLines = function () {
    for (var t = [], n = [], i = this.sourceLines.length, r = 0; r < i; r += 1) {
      for (var o = this.sourceLines[r], a = e.buildWords(o), s = a.length, l = 0; l < s; l += 1) {
        var u = a[l],
            c = n.concat(u).join("").replace(/\s+$/i, "");

        if (this.getWidth(c) > this.maxWidth) {
          n.length > 0 && (t.push(n.join("")), n = [u]);
          var p = u.replace(/\s+$/i, "");

          if (this.getWidth(p) > this.maxWidth) {
            var f = this.splitWord(u);
            t = t.concat(f.lines), f.rest && (n = [f.rest]);
          }
        } else n.push(u);
      }

      t.push(n.join("")), n = [];
    }

    return t;
  }, e.prototype.splitWord = function (e) {
    for (var t = {
      lines: [],
      rest: null
    }, n = e.length, i = [], r = 0; r < n; r += 1) {
      var o = e[r];
      this.getWidth(i.concat(o).join("")) > this.maxWidth ? (i.length > 0 && t.lines.push(i.join("")), i = [o]) : i.push(o), r === n - 1 && i.length > 0 && (t.rest = i.join(""));
    }

    return t;
  }, e.prototype.getWidth = function (e) {
    return this.context.measureText(e).width;
  }, e.prototype.setText = function (e) {
    this.sourceLines = e.split("\n");
  }, e.prototype.setMaxWidth = function (e) {
    this.maxWidth = e;
  }, e;
}();

function Bt(e, t, n, i, r, o, a) {
  e.font = (n.fontStyle || "normal") + " " + (n.fontWeight || "normal") + " " + i + 'px "' + n.fontFamily + '"';
  var s = new Lt(e);
  s.setText(t), s.setMaxWidth(o);

  var l = s.getLines().map(function (e) {
    return e.replace(/\s+$/i, "");
  }),
      u = function (e, t) {
    var n = 1 / t.unitsPerEm * e,
        i = t.ascender * n,
        r = t.descender * n;
    return i + Math.abs(r);
  }(i, a) * r;

  return {
    width: o,
    height: l.length * u
  };
}

var Nt,
    Ut,
    jt = function jt(e) {
  return 2 * Math.PI - e;
},
    Wt = function Wt(e) {
  var t = e.rotation,
      n = e.flipHorizontally,
      i = e.flipVertically,
      r = t;
  return n && (r = jt(r)), i && (r = function (e) {
    return -e;
  }(r)), r;
},
    Ht = function (e) {
  function t(n, i) {
    var r = e.call(this, i) || this;

    if (r.text = n, r.type = "text", !t.measureContext) {
      var o = document.createElement("canvas");
      t.measureContext = o.getContext("2d");
    }

    r.operation = i.createSpriteOperation();
    var a = r.engine.getOutputContainer(),
        s = r.getParent(),
        l = a.getBounds();
    r.sprite = r.operation.createText({
      text: n.text,
      position: new xt(0, 0),
      rotation: 0,
      fontSize: at(n.fontSize / l.height, s, a),
      lineHeight: n.lineHeight,
      fontIdentifier: n.fontIdentifier,
      alignment: n.alignment,
      color: wt(n.textColor),
      backgroundColor: wt(n.backgroundColor),
      maxWidth: at(n.width / l.width, s, a)
    });
    var u = i.assetProvider.getFontManager().getFontWithId(n.fontIdentifier);
    r.sprite.setFontFamily(u.fontFamily), r.sprite.setFontWeight(u.fontWeight || "normal"), r.sprite.setFontStyle(u.fontStyle || "normal"), r.sprite.setFontIdentifier(u.identifier), r.sprite.setTextMetrics(u.textMetrics), r.sprite.setPivot(new xt(0, 0)), r.operation.addSprite(r.sprite);
    var c = Bt(t.measureContext, n.text, u, n.fontSize, n.lineHeight, n.width, u.textMetrics);
    return r.bounds = new I(0, 0, c.width, c.height), r.setTransform(O.IDENTITY), r.operation.setDirty(!0), r;
  }

  return _(t, e), t.prototype.setData = function (e) {
    this.text = _v2(_v2({}, this.text), e);
    var n = this.engine.assetProvider.getFontManager().getFontWithId(e.fontIdentifier || this.text.fontIdentifier);

    if (e.fontIdentifier && (this.sprite.setFontFamily(n.fontFamily), this.sprite.setFontWeight(n.fontWeight || "normal"), this.sprite.setFontStyle(n.fontStyle || "normal"), this.sprite.setFontIdentifier(n.identifier), this.sprite.setTextMetrics(n.textMetrics)), e.id && (this.id = e.id), e.text && this.sprite.setText(e.text), e.fontSize) {
      var i = this.engine.getOutputContainer(),
          r = this.getParent(),
          o = at(e.fontSize, r, i),
          a = i.getBounds();
      this.sprite.setFontSize(o / a.height);
    }

    if (e.alignment && this.sprite.setAlignment(e.alignment), e.lineHeight && this.sprite.setLineHeight(e.lineHeight), e.textColor && this.sprite.setColor(wt(e.textColor)), e.backgroundColor && this.sprite.setBackgroundColor(wt(e.backgroundColor)), e.width) {
      i = this.engine.getOutputContainer(), r = this.getParent();
      var s = at(e.width, r, i);
      a = i.getBounds();
      this.sprite.setMaxWidth(s / a.width);
    }

    var l = Bt(t.measureContext, this.text.text, n, this.text.fontSize, this.text.lineHeight, this.text.width, n.textMetrics);
    this.setBoundsFromSize(l.width, l.height), this.operation.setDirty(!0);
  }, t.prototype.getData = function () {
    return this.text;
  }, t.prototype.updateData = function () {
    this.setData(this.getData());
  }, t.prototype.setTransform = function (t) {
    e.prototype.setTransform.call(this, t);
    var n = this.engine.getOutputContainer(),
        i = this.getParent(),
        r = ct(ot(t.position, i, n, !0), n, !1);
    this.sprite.setPosition(new xt(r.x, r.y));
    var o = pt(i, n);
    this.sprite.setRotation(t.rotation + o), this.operation.setDirty(!0);
  }, t.prototype.setPivot = function (e, t) {
    this.setPivotOnSelfAndSprite(this.sprite, e, t);
  }, t.prototype.getOperation = function () {
    return this.operation;
  }, t.prototype.setFlipHorizontally = function (e) {
    this.sprite.setRotation(this.getFlippedRotation({
      flipHorizontally: e
    })), this.sprite.setFlipHorizontally(e);
  }, t.prototype.setFlipVertically = function (e) {
    this.sprite.setRotation(this.getFlippedRotation({
      flipVertically: e
    })), this.sprite.setFlipVertically(e);
  }, t.prototype.getFlipHorizontally = function () {
    return this.sprite.getFlipHorizontally();
  }, t.prototype.getFlipVertically = function () {
    return this.sprite.getFlipVertically();
  }, t.prototype.getFlippedRotation = function (e) {
    var t = e.flipVertically,
        n = e.flipHorizontally,
        i = t || this.getFlipVertically(),
        r = n || this.getFlipHorizontally(),
        o = this.getRotation();
    return (i || r) && (o = jt(o)), o;
  }, t;
}(kt),
    Gt = function (e) {
  function t(t, n, i) {
    var r = e.call(this, i) || this;
    r.textDesign = t, r.layout = n, r.type = "text-design", r.currentLayoutSize = void 0, r.layoutID = n.identifier, r.operation = i.createSpriteOperation();
    var o = r.engine.getOutputContainer(),
        a = r.getParent(),
        s = o.getBounds(),
        l = Math.min(s.width, s.height);
    n.seed(t.seed), r.bounds = r.calculateBounds(r.textDesign, r.layout);
    var u = t.width;
    return r.sprite = r.operation.createTextDesign({
      text: t.text,
      layout: n,
      inverted: t.inverted,
      color: wt(t.color),
      width: at(t.width / l, a, o),
      padding: t.padding / u,
      seed: t.seed
    }), r.updatePivot(), r.operation.addSprite(r.sprite), r.setTransform(O.IDENTITY), r.operation.setDirty(!0), r;
  }

  return _(t, e), t.stringify = function (e) {
    return JSON.stringify(e, t.serializer());
  }, t.serializer = function () {
    var e = [],
        t = [],
        n = function n(_n2, i) {
      return e[0] === i ? "[Circular ~]" : "[Circular ~." + t.slice(0, e.indexOf(i)).join(".") + "]";
    };

    return function (i, r) {
      if (e.length > 0) {
        var o = e.indexOf(this);
        ~o ? (e.splice(o + 1), t.splice(o, 1 / 0, i)) : (e.push(this), t.push(i)), ~e.indexOf(r) && (r = n.call(this, i, r));
      } else e.push(r);

      return r;
    };
  }, t.prototype.calculateBounds = function (e, t, n) {
    void 0 === n && (n = !0);
    var i = e.inverted && n ? Math.max(0, 2 * e.padding) : 0,
        r = e.width / 1e3;

    if (void 0 === this.currentLayoutSize) {
      t.seed(e.seed);
      var o = t.generateLayoutData(e.text, 1e3);
      this.currentLayoutData = o, this.currentLayoutSize = o.getSize();
    }

    return new I(0, 0, this.currentLayoutSize.width * r + i, this.currentLayoutSize.height * r + i);
  }, t.prototype.findNextUniqueSeed = function (e, n, i) {
    for (var r, o = i, a = this.currentLayoutData ? t.stringify(this.currentLayoutData.getRows()) : "", s = 0; s < 20 && (n.seed(o), r = n.generateLayoutData(e.text, 1e3), a === t.stringify(r.getRows())); s += 1) {
      o += 1;
    }

    return n.seed(o), this.currentLayoutData = r, o;
  }, t.prototype.setData = function (e) {
    if (this.textDesign = _v2(_v2({}, this.textDesign), e), e.id && (this.id = e.id), void 0 !== e.padding) {
      var t = this.textDesign.width;
      this.sprite.setPadding(e.padding / t);
    } else e.width && (this.textDesign.padding = this.sprite.getPadding() * this.textDesign.width);

    if (void 0 !== e.seed && (e.seed < 0 && (e.seed = this.findNextUniqueSeed(this.textDesign, this.layout, Date.now()), this.textDesign.seed = e.seed), this.currentLayoutSize = void 0, this.layout.seed(e.seed), this.sprite.setSeed(e.seed), this.sprite.setLayout(this.layout)), e.color && this.sprite.setColor(wt(e.color)), void 0 !== e.inverted && this.sprite.setInverted(e.inverted), e.text && (this.currentLayoutSize = void 0, this.sprite.setText(e.text)), e.width) {
      var n = this.engine.getOutputContainer(),
          i = this.getParent(),
          r = n.getBounds(),
          o = Math.min(r.width, r.height),
          a = at(e.width / o, i, n);
      this.sprite.setWidth(a);
    }

    if (void 0 !== e.padding || void 0 !== e.seed || void 0 !== e.inverted || e.text || e.width) {
      var s = this.calculateBounds(this.textDesign, this.layout);
      this.setBoundsFromSize(s.width, s.height), this.updatePivot();
    }

    this.operation.setDirty(!0);
  }, t.prototype.getData = function () {
    return this.textDesign;
  }, t.prototype.updateData = function () {
    this.setData(this.getData());
  }, t.prototype.setTransform = function (t) {
    e.prototype.setTransform.call(this, t);
    var n = this.engine.getOutputContainer(),
        i = this.getParent();
    if (1 !== t.scale.x || 1 !== t.scale.y) throw new Error("This engine doesn't support scaling TextDesign containers! You can change the bounds using the width property of the TextDesign data.");
    var r = ct(ot(t.position, i, n, !0), n, !1);
    this.sprite.setPosition(new xt(r.x, r.y));
    var o = pt(i, n);
    this.sprite.setRotation(t.rotation + o), this.operation.setDirty(!0);
  }, t.prototype.setPivot = function (t, n) {
    "number" == typeof t ? e.prototype.setPivot.call(this, t, n) : e.prototype.setPivot.call(this, t), this.updatePivot();
  }, t.prototype.getOperation = function () {
    return this.operation;
  }, t.prototype.getLayoutID = function () {
    return this.layoutID;
  }, t.prototype.setFlipHorizontally = function (e) {
    this.sprite.setFlipHorizontally(e);
  }, t.prototype.setFlipVertically = function (e) {
    this.sprite.setFlipVertically(e);
  }, t.prototype.getFlipHorizontally = function () {
    return this.sprite.getFlipHorizontally();
  }, t.prototype.getFlipVertically = function () {
    return this.sprite.getFlipVertically();
  }, t.prototype.updatePivot = function () {
    var e = this.textDesign.inverted ? Math.max(0, this.textDesign.padding) : 0,
        t = new R(this.bounds.width - 2 * e, this.bounds.height - 2 * e),
        n = this.getPivot(),
        i = new R(n.x * this.bounds.width, n.y * this.bounds.height),
        r = new R(e, e),
        o = i.subtract(r).divide(t);
    this.sprite.setPivot(new xt(o.x, o.y));
  }, t;
}(kt),
    Vt = et.PhotoEditorSDK.Operations.FilterOperation.Filters.DuoToneFilter,
    Xt = et.PhotoEditorSDK.Operations.FilterOperation.Filters.ThreeDLUTFilter,
    Yt = "imgly_font_open_sans_bold",
    qt = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    n.previews = Array(), n.rootOperationStack = [], n.deferredRenderQueue = [], n.operationStackOffset = 1, n.enforceOperationOrder = function () {
      n.refreshFlipIndex(), n.refreshFrameIndex();
    }, n.assetProvider = t.assetProvider || new $e(), n.wrapper = new et.EngineWrapper({
      license: t.license,
      crossOrigin: t.crossOrigin,
      assets: {
        resolver: function resolver(e, t) {
          return n.resolveAssetForSDK(e, t);
        }
      },
      editor: {
        preferredRenderer: "webgl",
        pixelRatio: 1
      }
    }), n.editor = n.wrapper.getEditor(), n.sdk = n.editor.getSDK(), n.sdk.setRenderMode("adapter"), n.tempCanvas = document.createElement("canvas"), n.sdk.setCanvas(n.tempCanvas);
    var i = document.createElement("canvas"),
        r = i.getContext("webgl") || i.getContext("experimental-webgl");
    return n.maxTextureDimension = r.getParameter(r.MAX_TEXTURE_SIZE), n;
  }

  return _(t, e), Object.defineProperty(t.prototype, "configuration", {
    get: function get() {
      return this.config;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "pesdk", {
    get: function get() {
      return this.sdk;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "rootOperations", {
    get: function get() {
      return this.rootOperationStack;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.dispose = function () {
    this.pesdk.dispose(), this.wrapper.dispose();
  }, t.prototype.render = function (e) {
    var t = this;
    return new Promise(function (n) {
      var i = function i() {
        return new Promise(function (i) {
          var r = e.canvas,
              o = e.getTransform(),
              a = t.outputContainer.getPivot(),
              s = e.getCanvasBounds(),
              l = e.quality,
              u = t.tempCanvas;
          t.sdk.setTextureQuality(l);
          var c = t.sdk.getOutputDimensions();
          return u.width = c.x, u.height = c.y, t.sdk.getRenderer().resizeTo(new xt(u.width, u.height)), t.sdk.render(!0).then(function () {
            var l = r.getContext("2d");
            l.clearRect(0, 0, r.width, r.height), l.save(), l.translate(-s.minX, -s.minY), l.translate(o.position.x, o.position.y), l.rotate(o.rotation), l.scale(o.scale.x, o.scale.y), l.translate(-a.x * u.width, -a.y * u.height), l.scale(1 / e.quality, 1 / e.quality), l.drawImage(u, 0, 0), l.restore(), n(), t.deferredRenderQueue.shift(), t.deferredRenderQueue.length ? (t.sdk.setAllOperationsToDirty(), Promise.resolve(t.deferredRenderQueue[0]().then(i))) : i();
          });
        });
      };

      t.deferredRenderQueue.push(i), 1 === t.deferredRenderQueue.length && i();
    });
  }, t.prototype.createPreview = function (e) {
    var t = new mt(e, this);
    return this.previews.push(t), t;
  }, t.prototype.export = function (e, t, n) {
    return void 0 === e && (e = Y.IMAGE), void 0 === t && (t = q.PNG), void 0 === n && (n = 1), x(this, void 0, void 0, function () {
      var i = this;
      return k(this, function (r) {
        return [2, new Promise(function (r) {
          var o = function o() {
            return new Promise(function (o) {
              return i.sdk.export(i.mapToRenderType(e), i.mapToImageFormat(t), n).then(function (e) {
                r(e), i.deferredRenderQueue.shift(), i.deferredRenderQueue.length ? Promise.resolve(i.deferredRenderQueue[0]().then(o)) : o();
              });
            });
          };

          i.deferredRenderQueue.push(o), 1 === i.deferredRenderQueue.length && o();
        })];
      });
    });
  }, t.prototype.getRootContainers = function () {
    return [this.rootContainer];
  }, t.prototype.getOutputContainer = function () {
    return this.outputContainer;
  }, t.prototype.findContainerByID = function (e) {
    return e === this.rootContainer.getID() ? this.rootContainer : this.rootOperationStack.find(function (t) {
      return t.getID() === e;
    });
  }, t.prototype.findEffectByID = function (e) {
    return this.rootOperationStack.find(function (t) {
      return t.getID() === e;
    });
  }, t.prototype.addImage = function (e, t, n) {
    if (this.rootContainer) throw new Error("A background image already exists - did you mean to use addSticker?");
    var i = new Rt(e, this);

    if (this.rootContainer = i, !this.outputContainer) {
      var r = i.getBounds(),
          o = {
        resolution: {
          width: r.width,
          height: r.height
        },
        flipHorizontally: !1,
        flipVertically: !1
      },
          a = this.sdk.createOperation("output", {}, !1),
          s = this.sdk.createOperation("flip", {}, !1);
      this.insertIntoOperationsStack(a, this.operationStackOffset - 1), this.insertIntoOperationsStack(s, this.operationStackOffset), this.outputContainer = new Ft(o, a, s, this);
    }

    return i;
  }, t.prototype.addSticker = function (e, t, n) {
    if (!t) throw new Error("This engine does not support adding stickers as root elements.");
    this.ensureContainerIsRoot(t);
    var i = new zt(e, this);
    return this.addToStackAtIndex(i, n), i;
  }, t.prototype.addStickerFromAssets = function (e, t, n) {
    var i = this;
    if (!t) throw new Error("This engine does not support adding stickers as root elements.");
    return this.ensureContainerIsRoot(t), new Promise(function (t, r) {
      var o = new Image();
      o.onload = function () {
        var e = new zt({
          image: o,
          opacity: 1
        }, i);
        i.addToStackAtIndex(e, n), t(e);
      }, o.onerror = function (e) {
        r(e);
      }, o.crossOrigin = i.config.crossOrigin || null, o.src = i.assetProvider.getAssetSource("sticker", e);
    });
  }, t.prototype.addText = function (e, t, n) {
    if (!t) throw new Error("This engine does not support adding text as root elements.");
    if (!this.assetProvider.getFontManager().isFontLoaded(e.fontIdentifier || Yt)) throw new Error("Adding text synchronously only works if the required font is already loded! Consider using the asynchronous addTextWithFontLoading function instead!");
    this.ensureContainerIsRoot(t);

    var i = _v2({
      text: "",
      fontIdentifier: Yt,
      fontSize: 20,
      lineHeight: 1,
      alignment: "center",
      textColor: [1, 1, 1],
      backgroundColor: [0, 0, 0, 0],
      width: 100
    }, e),
        r = new Ht(i, this);

    return this.addToStackAtIndex(r, n), r;
  }, t.prototype.addTextWithFontLoading = function (e, t, n) {
    var i = this;
    if (!t) throw new Error("This engine does not support adding text as root elements.");
    var r = this.assetProvider.getFontManager(),
        o = e.fontIdentifier || Yt;
    return new Promise(function (a, s) {
      r.loadFontWithIdentifier(o).then(function () {
        i.ensureContainerIsRoot(t);

        var r = _v2({
          text: "",
          fontIdentifier: Yt,
          fontSize: 20,
          lineHeight: 1,
          alignment: "center",
          textColor: [1, 1, 1],
          backgroundColor: [0, 0, 0, 0],
          width: 100
        }, e),
            o = new Ht(r, i);

        i.addToStackAtIndex(o, n), a(o);
      }).catch(s);
    });
  }, t.prototype.addTextDesignAsync = function (e, t, n, i) {
    return void 0 === e && (e = "imgly_text_design_blocks"), x(this, void 0, void 0, function () {
      var r,
          o,
          a,
          s,
          l,
          u,
          c,
          p = this;
      return k(this, function (f) {
        switch (f.label) {
          case 0:
            if (!n) throw new Error("This engine does not support adding TextDesign as a root element.");
            if (r = _v2({
              seed: Date.now(),
              padding: 0,
              text: "",
              color: [0, 0, 0],
              inverted: !1,
              width: 100
            }, t), !(o = this.wrapper.getTextDesignLayoutByID(e))) throw new Error("The layout could not be loaded for the given id: " + e);
            return a = o.getImagePaths().map(function (e) {
              var t = e.split("/").pop() || "";
              return {
                path: e,
                fullPath: p.assetProvider.getAssetSource("textdesign", t)
              };
            }), s = this.wrapper.getTextDesignAssetManager(), l = this.wrapper.getTextDesignFontManager(), u = l.getVariationsByIdentifier(), s.setFonts(u), [4, s.loadImages(a)];

          case 1:
            return f.sent(), o.onImagesLoaded(), c = [], Object.keys(u).forEach(function (e) {
              Object.prototype.hasOwnProperty.call(u, e) && c.push(e);
            }), [2, this.assetProvider.getFontManager().loadFontsWithIdentifiers(c).then(function () {
              p.ensureContainerIsRoot(n);
              var e = new Gt(r, o, p);
              return p.addToStackAtIndex(e, i), Promise.resolve(e);
            })];
        }
      });
    });
  }, t.prototype.addDrawing = function (e, t, n) {
    if (!t) throw new Error("This engine does not support DrawingContainers as root elements.");
    this.ensureContainerIsRoot(t);
    var i = new Tt(e, this);
    return this.addToStackAtIndex(i, n), i;
  }, t.prototype.addGaussianBlur = function (e, t, n) {
    this.ensureContainerIsRoot(t);
    var i = new Ot(e, this, this.sdk.createOperation("blur", {}, !1));
    return this.addToStackAtIndex(i, n), i;
  }, t.prototype.addRadialBlur = function (e, t, n) {
    this.ensureContainerIsRoot(t);
    var i = new Pt(e, this, this.sdk.createOperation("radial-focus", {}, !1));
    return this.addToStackAtIndex(i, n), i;
  }, t.prototype.addMirroredBlur = function (e, t, n) {
    this.ensureContainerIsRoot(t);
    var i = new Mt(e, this, this.sdk.createOperation("mirrored-focus", {}, !1));
    return this.addToStackAtIndex(i, n), i;
  }, t.prototype.addLinearBlur = function (e, t, n) {
    this.ensureContainerIsRoot(t);
    var i = new It(e, this, this.sdk.createOperation("linear-focus", {}, !1));
    return this.addToStackAtIndex(i, n), i;
  }, t.prototype.addDuoToneFilter = function (e, t, n) {
    throw new Error("Not supported! Use addDuoToneFilterFromAssets instead");
  }, t.prototype.addDuoToneFilterFromAssets = function (e, t, n) {
    var i = this;
    this.ensureContainerIsRoot(t);
    var r = this.sdk.getOperationsStack().getByIdentifier("filter");
    if (r && r.getIdentifier() !== e) throw new Error("This engine doesn't support multiple types of filter operations at once!");
    var o = r || this.sdk.createOperation("filter", {}, !1);
    return new Promise(function (t, r) {
      try {
        var a = i.assetProvider.getDuotoneFilterAsset(e),
            s = {
          colorIntensity: a.defaultIntensity || 0
        },
            l = new Vt({
          intensity: s.colorIntensity,
          lightColor: et.PhotoEditorSDK.Color.fromHex(a.lightColor),
          darkColor: et.PhotoEditorSDK.Color.fromHex(a.darkColor)
        }),
            u = new St(l, o, s, i);
        i.addToStackAtIndex(u, n), t(u);
      } catch (e) {
        e && r(e);
      }
    });
  }, t.prototype.addLUTFilter = function (e, t, n) {
    throw new Error("Not supported! Use addLUTFilterFromAssets instead");
  }, t.prototype.addLUTFilterFromAssets = function (e, t, n) {
    var i = this;
    this.ensureContainerIsRoot(t);
    var r = this.sdk.getOperationsStack().getByIdentifier("filter");
    if (r && r.getIdentifier() !== e) throw new Error("This engine doesn't support multiple types filter operations at once!");
    var o = r || this.sdk.createOperation("filter", {}, !1);
    return new Promise(function (t, r) {
      var a = new Image();
      a.addEventListener("load", function () {
        var r = i.assetProvider.getLUTFilterAsset(e),
            s = {
          horizontalTileCount: r.horizontalTileCount || 5,
          verticalTileCount: r.verticalTileCount || 5,
          intensity: r.defaultIntensity || 1
        },
            l = new Xt(_v2(_v2({}, s), {
          image: a
        })),
            u = _v2(_v2({}, s), {
          lutImage: new Image()
        }),
            c = new At(l, o, u, i);

        i.addToStackAtIndex(c, n), t(c);
      }), a.addEventListener("error", function (e) {
        r(e);
      }), a.crossOrigin = i.config.crossOrigin || null, a.src = i.assetProvider.getAssetSource("filter", e);
    });
  }, t.prototype.addAdjustments = function (e, t, n) {
    this.ensureContainerIsRoot(t);
    var i = new bt(e, this, this.sdk.createOperation("adjustments", {}, !1));
    return this.addToStackAtIndex(i, n), i;
  }, t.prototype.addOverlay = function (e, t, n) {
    this.ensureContainerIsRoot(t);
    var i = new Dt(this.sdk.createOperation("overlay", {}, !1), e, this);
    return this.addToStackAtIndex(i, n), i;
  }, t.prototype.addOverlayFromAssets = function (e, t, n) {
    var i = this;
    return this.ensureContainerIsRoot(t), new Promise(function (t, r) {
      var o = i.sdk.getOperationsStack(),
          a = o.getByIdentifier("overlay");
      a && a.getIdentifier() !== e && o.remove(a);
      var s = a || i.sdk.createOperation("overlay", {}, !1),
          l = new Image();
      l.onload = function () {
        var e = {
          image: l,
          opacity: 1,
          blendMode: re.NORMAL
        },
            r = new Dt(s, e, i);
        i.addToStackAtIndex(r, n), t(r);
      }, l.onerror = function (e) {
        r(e);
      }, l.crossOrigin = i.config.crossOrigin || null, l.src = i.assetProvider.getAssetSource("overlay", e);
    });
  }, t.prototype.addFrame = function (e, t, n) {
    throw new Error("Not supported!");
  }, t.prototype.addFrameFromAssets = function (e, t, n) {
    return x(this, void 0, void 0, function () {
      var i, r, o, a, s, l, u;
      return k(this, function (c) {
        switch (c.label) {
          case 0:
            if (this.ensureContainerIsRoot(t), !(i = this.assetProvider.getFrameAsset(e))) throw new Error("The requested asset does not exist! " + e);
            return [4, (r = new Ct(i, this)).load()];

          case 1:
            return c.sent(), o = this.getOutputContainer().getBounds(), a = Math.min(o.width, o.height), (s = this.sdk.createOperation("frame", {}, !1)).setFrame(r.getFrame()), l = {
              opacity: 1,
              tintColor: [1, 1, 1],
              tintable: !1,
              width: Math.max(1, .1 * a),
              imageGroups: r.getFrame().imageGroups
            }, u = new Et(s, l, this), this.addToStackAtIndex(u, n), [2, Promise.resolve(u)];
        }
      });
    });
  }, t.prototype.removeEffect = function (e) {
    if (e.isValid()) {
      var t = e.getOperation();
      this.sdk.removeOperation(t), this.sdk.setAllOperationsToDirty(), this.rootOperationStack.splice(e.getIndexInParent(), 1);
    }
  }, t.prototype.removeContainer = function (e) {
    if (e.isValid() && "output" !== e.type) {
      var t = e.getOperation();
      this.sdk.removeOperation(t), this.sdk.setAllOperationsToDirty(), this.rootOperationStack.splice(e.getIndexInParent(), 1);
    }
  }, t.prototype.refreshOutputIndex = function () {
    var e = this.sdk.getOperationsStack().getIndexByIdentifier("output");
    this.moveInOperationsStack(e, this.operationStackOffset - 1);
  }, t.prototype.refreshFlipIndex = function () {
    var e = this.sdk.getOperationsStack().getIndexByIdentifier("flip"),
        t = this.sdk.getOperationsStack().getStack().length - 1;
    e !== t && this.moveInOperationsStack(e, t);
  }, t.prototype.refreshFrameIndex = function () {
    var e = this.sdk.getOperationsStack().getIndexByIdentifier("frame"),
        t = this.sdk.getOperationsStack().getStack().length - 1;
    -1 !== e && e !== t && this.moveInOperationsStack(e, t);
  }, t.prototype.mapToRenderType = function (e) {
    switch (e) {
      case Y.IMAGE:
        return "image";

      case Y.DATA_URL:
        return "data-url";

      case Y.BLOB:
        return "blob";

      case Y.MSBLOB:
        return "ms-blob";

      default:
        return "image";
    }
  }, t.prototype.mapToImageFormat = function (e) {
    switch (e) {
      case q.PNG:
        return "image/png";

      case q.JPEG:
        return "image/jpeg";

      default:
        return null;
    }
  }, t.prototype.mapBlendMode = function (e) {
    switch (e) {
      case 0:
        return re.NORMAL;

      case 1:
        return re.OVERLAY;

      case 2:
        return re.HARD_LIGHT;

      case 3:
        return re.SOFT_LIGHT;

      case 4:
        return re.MULTIPLY;

      case 5:
        return re.DARKEN;

      case 6:
        return re.LIGHTEN;

      case 7:
        return re.SCREEN;

      case 8:
        return re.COLOR_BURN;

      default:
        return re.NORMAL;
    }
  }, t.prototype.reverseMapBlendMode = function (e) {
    switch (e) {
      case re.NORMAL:
        return 0;

      case re.OVERLAY:
        return 1;

      case re.HARD_LIGHT:
        return 2;

      case re.SOFT_LIGHT:
        return 3;

      case re.MULTIPLY:
        return 4;

      case re.DARKEN:
        return 5;

      case re.LIGHTEN:
        return 6;

      case re.SCREEN:
        return 7;

      case re.COLOR_BURN:
        return 8;

      default:
        return 0;
    }
  }, t.prototype.createSpriteOperation = function () {
    return this.sdk.createOperation("sprite", {}, !1);
  }, t.prototype.moveIndex = function (e, t) {
    var n = this.getSiblingIndex(e);
    if (-1 === n) throw new Error("The item to be moved is not part of any stack.");
    this.moveInStack(this.rootOperationStack, n, t);
    var i = this.operationStackOffset;
    this.moveInOperationsStack(n + i, t + i), this.enforceOperationOrder();
  }, t.prototype.ensureContainerIsRoot = function (e) {
    if (e.getID() !== this.rootContainer.getID()) throw new Error("This engine doesn't support adding this effect/container to anything other than the root image container");
  }, t.prototype.addToStackAtIndex = function (e, t) {
    if (t && t < 0) throw new Error("The given index may not be negative: " + t);
    void 0 === t ? this.rootOperationStack.push(e) : this.rootOperationStack.splice(t, 0, e);
    var n = this.rootOperationStack.length - 1,
        i = void 0 !== t ? t : n;
    i += this.operationStackOffset, e.getContainer, this.insertIntoOperationsStack(e.getOperation(), i), this.sdk.setAllOperationsToDirty();
  }, t.prototype.insertIntoOperationsStack = function (e, t) {
    for (var n = this.sdk.getOperationsStack().getStack(), i = n.length, r = Math.max(Math.min(t, i), 0), o = i - 1; o >= r; o -= 1) {
      var a = n[o];
      n[o + 1] = a;
    }

    n[r] = e, this.sdk.setAllOperationsToDirty(), this.enforceOperationOrder();
  }, t.prototype.moveInStack = function (e, t, n) {
    var i = e.length,
        r = Math.max(Math.min(t, i - 1), 0),
        o = Math.max(Math.min(n, i - 1), 0);

    if (r !== o) {
      var a = e[r];
      if (r < o) for (var s = r + 1; s <= o; s += 1) {
        e[s - 1] = e[s];
      } else for (s = r - 1; s >= o; s -= 1) {
        e[s + 1] = e[s];
      }
      e[o] = a;
    }
  }, t.prototype.moveInOperationsStack = function (e, t) {
    var n = this.sdk.getOperationsStack().getStack(),
        i = n.length,
        r = Math.min(Math.max(0, e), i - 1),
        o = Math.min(Math.max(0, t), i - 1);

    if (r !== o) {
      var a = n[r];
      if (r < o) for (var s = r + 1; s <= o; s += 1) {
        n[s - 1] = n[s];
      } else for (s = r - 1; s >= o; s -= 1) {
        n[s + 1] = n[s];
      }
      n[o] = a, this.sdk.getOperationsStack().setAllToDirty();
    }
  }, t.prototype.getSiblingIndex = function (e) {
    return e.getIndexInParent();
  }, t.prototype.resolveAssetForSDK = function (e, t) {
    switch (t = t, e) {
      case "filter":
        return this.assetProvider.getAssetSource("filter", t.identifier);

      case "overlay":
        return this.assetProvider.getAssetSource("overlay", t.identifier);

      case "font":
        return this.assetProvider.getAssetSource("font", t.identifier);
    }

    return "";
  }, t;
}(_t),
    Kt = function Kt(e) {
  var t = Number(e).toString(16);
  return t.length < 2 && (t = "0" + t), t;
},
    Zt = function Zt(e, t, n) {
  return "#" + Kt(255 * e) + Kt(255 * t) + Kt(255 * n);
},
    Qt = function Qt(e) {
  if (gt(e)) {
    var t = S(e, 4);
    return "rgba(" + 255 * (i = t[0]) + ", " + 255 * (r = t[1]) + ", " + 255 * (o = t[2]) + ", " + t[3] + ")";
  }

  if (dt(e)) return "rgba(" + 255 * (i = e.r) + ", " + 255 * (r = e.g) + ", " + 255 * (o = e.b) + ", " + e.a + ")";

  if (ht(e)) {
    var n = S(e, 3),
        i = n[0],
        r = n[1],
        o = n[2];
    return Zt(i, r, o);
  }

  if (ft(e)) {
    i = e.r, r = e.g, o = e.b;
    return Zt(i, r, o);
  }

  return e;
},
    Jt = {
  black: [0, 0, 0, 1],
  white: [1, 1, 1, 1],
  gray: [191 / 255, 191 / 255, 191 / 255, 1],
  blue: [.4, 134 / 255, 1, 1],
  skyBlue: [.4, .8, 1, 1],
  red: [231 / 255, 80 / 255, 80 / 255, 1],
  orange: [242 / 255, 136 / 255, 85 / 255, 1],
  yellow: [1, 247 / 255, 99 / 255, 1]
},
    $t = {
  transparent: [0, 0, 0, 0],
  black: [0, 0, 0, 1],
  white: [1, 1, 1, 1],
  blue: [.4, 134 / 255, 1, 1],
  skyBlue: [.4, .8, 1, 1],
  red: [231 / 255, 80 / 255, 80 / 255, 1],
  orange: [242 / 255, 136 / 255, 85 / 255, 1],
  yellow: [1, 247 / 255, 99 / 255, 1]
},
    en = [P.LIBRARY, [P.TRANSFORM, P.FILTER, P.ADJUSTMENT], [P.FOCUS, P.FRAME, P.OVERLAY], [P.TEXT, P.TEXT_DESIGN, P.STICKER, P.BRUSH]],
    tn = {
  license: "",
  order: "default",
  language: "en",
  theme: "dark",
  layout: "advanced",
  mainCanvasActions: [D.UNDO, D.REDO, D.EXPORT, D.CLOSE],
  displayResizeWarning: !0,
  displayCloseWarning: !0,
  displayToolControlBarTitle: !0,
  engine: {
    crossOrigin: "anonymous",
    downscaleOptions: {
      maxMegaPixels: {
        desktop: 10,
        mobile: 5
      }
    }
  },
  enableZoom: !0,
  forceCrop: !1,
  assetBaseUrl: "assets/",
  defaultTool: P.FILTER,
  tools: en,
  snapping: new X(),
  filter: new $(),
  focus: new ie(),
  adjustment: new J(),
  library: new le(),
  overlay: new pe(),
  sticker: new fe(),
  text: new ge(),
  textdesign: new we(),
  frame: new oe(),
  brush: new be(),
  transform: new xe(),
  export: {
    image: {
      exportType: Y.IMAGE,
      format: q.PNG,
      quality: .9,
      enableDownload: !0
    },
    filename: "photoeditorsdk-export"
  },
  custom: {}
};

!function (e) {
  e.ERROR = "error", e.WARNING = "warning", e.INFO = "info", e.TEXT_EDIT = "textEdit";
}(Nt || (Nt = {}));

var nn = ((Ut = {})[Z.BRIGHTNESS] = 0, Ut[Z.SATURATION] = 0, Ut[Z.CONTRAST] = 0, Ut[Z.GAMMA] = 0, Ut[Z.CLARITY] = 0, Ut[Z.EXPOSURE] = 0, Ut[Z.SHADOWS] = 0, Ut[Z.HIGHLIGHTS] = 0, Ut[Z.WHITES] = 0, Ut[Z.BLACKS] = 0, Ut[Z.TEMPERATURE] = 0, Ut[Z.SHARPNESS] = 0, Ut),
    _rn = function rn(e, t) {
  return (_rn = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) {
      t.hasOwnProperty(n) && (e[n] = t[n]);
    }
  })(e, t);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function on(e, t) {
  function n() {
    this.constructor = e;
  }

  _rn(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}

var _an = function an() {
  return (_an = Object.assign || function (e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function sn(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var i,
      r,
      o = n.call(e),
      a = [];

  try {
    for (; (void 0 === t || t-- > 0) && !(i = o.next()).done;) {
      a.push(i.value);
    }
  } catch (e) {
    r = {
      error: e
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (r) throw r.error;
    }
  }

  return a;
}

function ln() {
  for (var e = [], t = 0; t < arguments.length; t++) {
    e = e.concat(sn(arguments[t]));
  }

  return e;
}

var un = [];
Object.freeze(un);
var cn = {};
Object.freeze(cn);
var pn = {};

function fn() {
  return "undefined" != typeof window ? window : "undefined" != typeof global ? global : pn;
}

function hn() {
  return ++Bi.mobxGuid;
}

function dn(e) {
  throw gn(!1, e), "X";
}

function gn(e, t) {
  if (!e) throw new Error("[mobx] " + (t || "An invariant failed, however the error is obfuscated because this is an production build."));
}

var mn = [];

function yn(e, t) {
  return "production" !== process.env.NODE_ENV && (t ? yn("'" + e + "', use '" + t + "' instead.") : -1 === mn.indexOf(e) && (mn.push(e), console.error("[mobx] Deprecated: " + e), !0));
}

function _n(e) {
  var t = !1;
  return function () {
    if (!t) return t = !0, e.apply(this, arguments);
  };
}

var vn = function vn() {};

function bn(e) {
  return null !== e && "object" == typeof e;
}

function wn(e) {
  if (null === e || "object" != typeof e) return !1;
  var t = Object.getPrototypeOf(e);
  return t === Object.prototype || null === t;
}

function xn(e, t, n) {
  Object.defineProperty(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}

function kn(e, t, n) {
  Object.defineProperty(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}

function Tn(e, t) {
  "production" === process.env.NODE_ENV || function (e, t) {
    var n = Object.getOwnPropertyDescriptor(e, t);
    return !n || !1 !== n.configurable && !1 !== n.writable;
  }(e, t) || dn("Cannot make property '" + t + "' observable, it is not configurable and writable in the target object");
}

function Sn(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function (e) {
    return bn(e) && !0 === e[n];
  };
}

function Cn(e) {
  return void 0 !== fn().Map && e instanceof fn().Map;
}

function En(e) {
  return e instanceof Set;
}

function On(e) {
  for (var t = [];;) {
    var n = e.next();
    if (n.done) break;
    t.push(n.value);
  }

  return t;
}

function Rn() {
  return "function" == typeof Symbol && Symbol.toPrimitive || "@@toPrimitive";
}

function In(e) {
  return null === e ? null : "object" == typeof e ? "" + e : e;
}

function An() {
  return "function" == typeof Symbol && Symbol.iterator || "@@iterator";
}

function Mn(e, t) {
  kn(e, An(), t);
}

function Fn(e) {
  return e[An()] = Pn, e;
}

function Dn() {
  return "function" == typeof Symbol && Symbol.toStringTag || "@@toStringTag";
}

function Pn() {
  return this;
}

var zn = function () {
  function e(e) {
    void 0 === e && (e = "Atom@" + hn()), this.name = e, this.isPendingUnobservation = !1, this.isBeingObserved = !1, this.observers = [], this.observersIndexes = {}, this.diffValue = 0, this.lastAccessedBy = 0, this.lowestObserverState = li.NOT_TRACKING;
  }

  return e.prototype.onBecomeUnobserved = function () {}, e.prototype.onBecomeObserved = function () {}, e.prototype.reportObserved = function () {
    return Gi(this);
  }, e.prototype.reportChanged = function () {
    Wi(), function (e) {
      if (e.lowestObserverState === li.STALE) return;
      e.lowestObserverState = li.STALE;
      var t = e.observers,
          n = t.length;

      for (; n--;) {
        var i = t[n];
        i.dependenciesState === li.UP_TO_DATE && (i.isTracing !== ui.NONE && Vi(i, e), i.onBecomeStale()), i.dependenciesState = li.STALE;
      }
    }(this), Hi();
  }, e.prototype.toString = function () {
    return this.name;
  }, e;
}(),
    Ln = Sn("Atom", zn);

function Bn(e, t, n) {
  void 0 === t && (t = vn), void 0 === n && (n = vn);
  var i,
      r = new zn(e);
  return fr("onBecomeObserved", r, t, i), pr(r, n), r;
}

function Nn(e, t) {
  return e === t;
}

var Un = {
  identity: Nn,
  structural: function structural(e, t) {
    return uo(e, t);
  },
  default: function _default(e, t) {
    return function (e, t) {
      return "number" == typeof e && "number" == typeof t && isNaN(e) && isNaN(t);
    }(e, t) || Nn(e, t);
  },
  shallow: function shallow(e, t) {
    return uo(e, t, 1);
  }
},
    jn = {},
    Wn = {};

function Hn(e, t) {
  var n = t ? jn : Wn;
  return n[e] || (n[e] = {
    configurable: !0,
    enumerable: t,
    get: function get() {
      return Gn(this), this[e];
    },
    set: function set(t) {
      Gn(this), this[e] = t;
    }
  });
}

function Gn(e) {
  if (!0 !== e.__mobxDidRunLazyInitializers) {
    var t = e.__mobxDecorators;
    if (t) for (var n in xn(e, "__mobxDidRunLazyInitializers", !0), t) {
      var i = t[n];
      i.propertyCreator(e, i.prop, i.descriptor, i.decoratorTarget, i.decoratorArguments);
    }
  }
}

function Vn(e, t) {
  return function () {
    var n,
        i = function i(_i2, r, o, a) {
      if (!0 === a) return t(_i2, r, o, _i2, n), null;

      if ("production" === process.env.NODE_ENV || Xn(arguments) || dn("This function is a decorator, but it wasn't invoked like a decorator"), !Object.prototype.hasOwnProperty.call(_i2, "__mobxDecorators")) {
        var s = _i2.__mobxDecorators;
        xn(_i2, "__mobxDecorators", _an({}, s));
      }

      return _i2.__mobxDecorators[r] = {
        prop: r,
        propertyCreator: t,
        descriptor: o,
        decoratorTarget: _i2,
        decoratorArguments: n
      }, Hn(r, e);
    };

    return Xn(arguments) ? (n = un, i.apply(null, arguments)) : (n = Array.prototype.slice.call(arguments), i);
  };
}

function Xn(e) {
  return (2 === e.length || 3 === e.length) && "string" == typeof e[1] || 4 === e.length && !0 === e[3];
}

function Yn(e, t, n) {
  return _r(e) ? e : Array.isArray(e) ? ai.array(e, {
    name: n
  }) : wn(e) ? ai.object(e, void 0, {
    name: n
  }) : Cn(e) ? ai.map(e, {
    name: n
  }) : En(e) ? ai.set(e, {
    name: n
  }) : e;
}

function qn(e) {
  return e;
}

function Kn(e) {
  var t = Vn(!0, function (t, n, i, r, o) {
    "production" !== process.env.NODE_ENV && gn(!i || !i.get, '@observable cannot be used on getter (property "' + n + '"), use @computed instead.'), function (e, t, n, i) {
      var r = eo(e);

      if (Tn(e, t), Sr(r)) {
        var o = Er(r, {
          object: e,
          name: t,
          type: "add",
          newValue: n
        });
        if (!o) return;
        n = o.newValue;
      }

      var a = r.values[t] = new Ai(n, i, r.name + "." + t, !1);
      n = a.value, Object.defineProperty(e, t, function (e) {
        return to[e] || (to[e] = {
          configurable: !0,
          enumerable: !0,
          get: function get() {
            return this.$mobx.read(this, e);
          },
          set: function set(t) {
            this.$mobx.write(this, e, t);
          }
        });
      }(t)), r.keys && r.keys.push(t);
      !function (e, t, n, i) {
        var r = Or(e),
            o = Ji(),
            a = r || o ? {
          type: "add",
          object: t,
          name: n,
          newValue: i
        } : null;
        o && er(_an({}, a, {
          name: e.name,
          key: n
        }));
        r && Ir(e, a);
        o && nr();
      }(r, e, t, n);
    }(t, n, i ? i.initializer ? i.initializer.call(t) : i.value : void 0, e);
  }),
      n = "undefined" != typeof process && process.env && "production" !== process.env.NODE_ENV ? function () {
    return arguments.length < 2 ? dn("Incorrect decorator invocation. @observable decorator doesn't expect any arguments") : t.apply(null, arguments);
  } : t;
  return n.enhancer = e, n;
}

var Zn = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0
},
    Qn = {
  deep: !1,
  name: void 0,
  defaultDecorator: void 0
};

function Jn(e) {
  /^(deep|name|equals|defaultDecorator)$/.test(e) || dn("invalid option for (extend)observable: " + e);
}

function $n(e) {
  if (null == e) return Zn;
  if ("string" == typeof e) return {
    name: e,
    deep: !0
  };

  if ("production" !== process.env.NODE_ENV) {
    if ("object" != typeof e) return dn("expected options object");
    Object.keys(e).forEach(Jn);
  }

  return e;
}

function ei(e) {
  return e.defaultDecorator ? e.defaultDecorator.enhancer : !1 === e.deep ? qn : Yn;
}

Object.freeze(Zn), Object.freeze(Qn);
var ti = Kn(Yn),
    ni = Kn(function (e, t, n) {
  return null == e || oo(e) || Vr(e) || Kr(e) || Jr(e) ? e : Array.isArray(e) ? ai.array(e, {
    name: n,
    deep: !1
  }) : wn(e) ? ai.object(e, void 0, {
    name: n,
    deep: !1
  }) : Cn(e) ? ai.map(e, {
    name: n,
    deep: !1
  }) : En(e) ? ai.set(e, {
    name: n,
    deep: !1
  }) : dn("production" !== process.env.NODE_ENV && "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}),
    ii = Kn(qn),
    ri = Kn(function (e, t, n) {
  if ("production" !== process.env.NODE_ENV && _r(e)) throw "observable.struct should not be used with observable values";
  return uo(e, t) ? t : e;
});

var oi = {
  box: function box(e, t) {
    arguments.length > 2 && si("box");
    var n = $n(t);
    return new Ai(e, ei(n), n.name, !0, n.equals);
  },
  shallowBox: function shallowBox(e, t) {
    return arguments.length > 2 && si("shallowBox"), yn("observable.shallowBox", "observable.box(value, { deep: false })"), ai.box(e, {
      name: t,
      deep: !1
    });
  },
  array: function array(e, t) {
    arguments.length > 2 && si("array");
    var n = $n(t);
    return new Nr(e, ei(n), n.name);
  },
  shallowArray: function shallowArray(e, t) {
    return arguments.length > 2 && si("shallowArray"), yn("observable.shallowArray", "observable.array(values, { deep: false })"), ai.array(e, {
      name: t,
      deep: !1
    });
  },
  map: function map(e, t) {
    arguments.length > 2 && si("map");
    var n = $n(t);
    return new Yr(e, ei(n), n.name);
  },
  shallowMap: function shallowMap(e, t) {
    return arguments.length > 2 && si("shallowMap"), yn("observable.shallowMap", "observable.map(values, { deep: false })"), ai.map(e, {
      name: t,
      deep: !1
    });
  },
  set: function set(e, t) {
    arguments.length > 2 && si("set");
    var n = $n(t);
    return new Qr(e, ei(n), n.name);
  },
  object: function object(e, t, n) {
    "string" == typeof arguments[1] && si("object");
    var i = $n(n);
    return hr({}, e, t, i);
  },
  shallowObject: function shallowObject(e, t) {
    return "string" == typeof arguments[1] && si("shallowObject"), yn("observable.shallowObject", "observable.object(values, {}, { deep: false })"), ai.object(e, {}, {
      name: t,
      deep: !1
    });
  },
  ref: ii,
  shallow: ni,
  deep: ti,
  struct: ri
},
    ai = function ai(e, t, n) {
  if ("string" == typeof arguments[1]) return ti.apply(null, arguments);
  if (_r(e)) return e;
  var i = wn(e) ? ai.object(e, t, n) : Array.isArray(e) ? ai.array(e, t) : Cn(e) ? ai.map(e, t) : En(e) ? ai.set(e, t) : e;
  if (i !== e) return i;
  dn("production" !== process.env.NODE_ENV && "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
};

function si(e) {
  dn("Expected one or two arguments to observable." + e + ". Did you accidentally try to use observable." + e + " as decorator?");
}

Object.keys(oi).forEach(function (e) {
  return ai[e] = oi[e];
});

var li,
    ui,
    ci = Vn(!1, function (e, t, n, i, r) {
  var o = n.get,
      a = n.set,
      s = r[0] || {};
  !function (e, t, n) {
    var i = eo(e);
    n.name = i.name + "." + t, n.context = e, i.values[t] = new Fi(n), Object.defineProperty(e, t, function (e) {
      return no[e] || (no[e] = {
        configurable: Bi.computedConfigurable,
        enumerable: !1,
        get: function get() {
          return io(this).read(this, e);
        },
        set: function set(t) {
          io(this).write(this, e, t);
        }
      });
    }(t));
  }(e, t, _an({
    get: o,
    set: a
  }, s));
}),
    pi = ci({
  equals: Un.structural
}),
    fi = function fi(e, t, n) {
  if ("string" == typeof t) return ci.apply(null, arguments);
  if (null !== e && "object" == typeof e && 1 === arguments.length) return ci.apply(null, arguments);
  "production" !== process.env.NODE_ENV && (gn("function" == typeof e, "First argument to `computed` should be an expression."), gn(arguments.length < 3, "Computed takes one or two arguments if used as function"));
  var i = "object" == typeof t ? t : {};
  return i.get = e, i.set = "function" == typeof t ? t : i.set, i.name = i.name || e.name || "", new Fi(i);
};

fi.struct = pi, function (e) {
  e[e.NOT_TRACKING = -1] = "NOT_TRACKING", e[e.UP_TO_DATE = 0] = "UP_TO_DATE", e[e.POSSIBLY_STALE = 1] = "POSSIBLY_STALE", e[e.STALE = 2] = "STALE";
}(li || (li = {})), function (e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
}(ui || (ui = {}));

var hi = function hi(e) {
  this.cause = e;
};

function di(e) {
  return e instanceof hi;
}

function gi(e) {
  switch (e.dependenciesState) {
    case li.UP_TO_DATE:
      return !1;

    case li.NOT_TRACKING:
    case li.STALE:
      return !0;

    case li.POSSIBLY_STALE:
      for (var t = bi(), n = e.observing, i = n.length, r = 0; r < i; r++) {
        var o = n[r];

        if (Di(o)) {
          if (Bi.disableErrorBoundaries) o.get();else try {
            o.get();
          } catch (e) {
            return wi(t), !0;
          }
          if (e.dependenciesState === li.STALE) return wi(t), !0;
        }
      }

      return Ti(e), wi(t), !1;
  }
}

function mi(e) {
  var t = e.observers.length > 0;
  Bi.computationDepth > 0 && t && dn("production" !== process.env.NODE_ENV && "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + e.name), Bi.allowStateChanges || !t && "strict" !== Bi.enforceActions || dn("production" !== process.env.NODE_ENV && (Bi.enforceActions ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") + e.name);
}

function yi(e, t, n) {
  var i = xi(!0);
  Ti(e), e.newObserving = new Array(e.observing.length + 100), e.unboundDepsCount = 0, e.runId = ++Bi.runId;
  var r,
      o = Bi.trackingDerivation;
  if (Bi.trackingDerivation = e, !0 === Bi.disableErrorBoundaries) r = t.call(n);else try {
    r = t.call(n);
  } catch (e) {
    r = new hi(e);
  }
  return Bi.trackingDerivation = o, function (e) {
    for (var t = e.observing, n = e.observing = e.newObserving, i = li.UP_TO_DATE, r = 0, o = e.unboundDepsCount, a = 0; a < o; a++) {
      0 === (s = n[a]).diffValue && (s.diffValue = 1, r !== a && (n[r] = s), r++), s.dependenciesState > i && (i = s.dependenciesState);
    }

    n.length = r, e.newObserving = null, o = t.length;

    for (; o--;) {
      0 === (s = t[o]).diffValue && Ui(s, e), s.diffValue = 0;
    }

    for (; r--;) {
      var s;
      1 === (s = n[r]).diffValue && (s.diffValue = 0, Ni(s, e));
    }

    i !== li.UP_TO_DATE && (e.dependenciesState = i, e.onBecomeStale());
  }(e), 0 === e.observing.length && function (e) {
    if ("production" === process.env.NODE_ENV) return;
    (Bi.reactionRequiresObservable || e.requiresObservable) && console.warn("[mobx] Derivation " + e.name + " is created/updated without reading any observable value");
  }(e), ki(i), r;
}

function _i(e) {
  var t = e.observing;
  e.observing = [];

  for (var n = t.length; n--;) {
    Ui(t[n], e);
  }

  e.dependenciesState = li.NOT_TRACKING;
}

function vi(e) {
  var t = bi(),
      n = e();
  return wi(t), n;
}

function bi() {
  var e = Bi.trackingDerivation;
  return Bi.trackingDerivation = null, e;
}

function wi(e) {
  Bi.trackingDerivation = e;
}

function xi(e) {
  var t = Bi.allowStateReads;
  return Bi.allowStateReads = e, t;
}

function ki(e) {
  Bi.allowStateReads = e;
}

function Ti(e) {
  if (e.dependenciesState !== li.UP_TO_DATE) {
    e.dependenciesState = li.UP_TO_DATE;

    for (var t = e.observing, n = t.length; n--;) {
      t[n].lowestObserverState = li.UP_TO_DATE;
    }
  }
}

var Si = 0,
    Ci = 1;

function Ei(e, t) {
  "production" !== process.env.NODE_ENV && (gn("function" == typeof t, "`action` can only be invoked on functions"), "string" == typeof e && e || dn("actions should have valid names, got: '" + e + "'"));

  var n = function n() {
    return Oi(e, t, this, arguments);
  };

  return n.isMobxAction = !0, n;
}

function Oi(e, t, n, i) {
  var r = function (e, t, n) {
    var i = Ji() && !!e,
        r = 0;

    if (i) {
      r = Date.now();
      var o = n && n.length || 0,
          a = new Array(o);
      if (o > 0) for (var s = 0; s < o; s++) {
        a[s] = n[s];
      }
      er({
        type: "action",
        name: e,
        object: t,
        arguments: a
      });
    }

    var l = bi();
    Wi();
    var u = Ri(!0),
        c = xi(!0),
        p = {
      prevDerivation: l,
      prevAllowStateChanges: u,
      prevAllowStateReads: c,
      notifySpy: i,
      startTime: r,
      actionId: Ci++,
      parentActionId: Si
    };
    return Si = p.actionId, p;
  }(e, n, i);

  try {
    return t.apply(n, i);
  } catch (e) {
    throw r.error = e, e;
  } finally {
    !function (e) {
      Si !== e.actionId && dn("invalid action stack. did you forget to finish an action?");
      Si = e.parentActionId, void 0 !== e.error && (Bi.suppressReactionErrors = !0);
      Ii(e.prevAllowStateChanges), ki(e.prevAllowStateReads), Hi(), wi(e.prevDerivation), e.notifySpy && nr({
        time: Date.now() - e.startTime
      });
      Bi.suppressReactionErrors = !1;
    }(r);
  }
}

function Ri(e) {
  var t = Bi.allowStateChanges;
  return Bi.allowStateChanges = e, t;
}

function Ii(e) {
  Bi.allowStateChanges = e;
}

var Ai = function (e) {
  function t(t, n, i, r, o) {
    void 0 === i && (i = "ObservableValue@" + hn()), void 0 === r && (r = !0), void 0 === o && (o = Un.default);
    var a = e.call(this, i) || this;
    return a.enhancer = n, a.name = i, a.equals = o, a.hasUnreportedChange = !1, a.value = n(t, void 0, i), r && Ji() && $i({
      type: "create",
      name: a.name,
      newValue: "" + a.value
    }), a;
  }

  return on(t, e), t.prototype.dehanceValue = function (e) {
    return void 0 !== this.dehancer ? this.dehancer(e) : e;
  }, t.prototype.set = function (e) {
    var t = this.value;

    if ((e = this.prepareNewValue(e)) !== Bi.UNCHANGED) {
      var n = Ji();
      n && er({
        type: "update",
        name: this.name,
        newValue: e,
        oldValue: t
      }), this.setNewValue(e), n && nr();
    }
  }, t.prototype.prepareNewValue = function (e) {
    if (mi(this), Sr(this)) {
      var t = Er(this, {
        object: this,
        type: "update",
        newValue: e
      });
      if (!t) return Bi.UNCHANGED;
      e = t.newValue;
    }

    return e = this.enhancer(e, this.value, this.name), this.equals(this.value, e) ? Bi.UNCHANGED : e;
  }, t.prototype.setNewValue = function (e) {
    var t = this.value;
    this.value = e, this.reportChanged(), Or(this) && Ir(this, {
      type: "update",
      object: this,
      newValue: e,
      oldValue: t
    });
  }, t.prototype.get = function () {
    return this.reportObserved(), this.dehanceValue(this.value);
  }, t.prototype.intercept = function (e) {
    return Cr(this, e);
  }, t.prototype.observe = function (e, t) {
    return t && e({
      object: this,
      type: "update",
      newValue: this.value,
      oldValue: void 0
    }), Rr(this, e);
  }, t.prototype.toJSON = function () {
    return this.get();
  }, t.prototype.toString = function () {
    return this.name + "[" + this.value + "]";
  }, t.prototype.valueOf = function () {
    return In(this.get());
  }, t;
}(zn);

Ai.prototype[Rn()] = Ai.prototype.valueOf;

var Mi = Sn("ObservableValue", Ai),
    Fi = function () {
  function e(e) {
    if (this.dependenciesState = li.NOT_TRACKING, this.observing = [], this.newObserving = null, this.isBeingObserved = !1, this.isPendingUnobservation = !1, this.observers = [], this.observersIndexes = {}, this.diffValue = 0, this.runId = 0, this.lastAccessedBy = 0, this.lowestObserverState = li.UP_TO_DATE, this.unboundDepsCount = 0, this.__mapid = "#" + hn(), this.value = new hi(null), this.isComputing = !1, this.isRunningSetter = !1, this.isTracing = ui.NONE, "production" !== process.env.NODE_ENV && !e.get) return dn("missing option for computed: get");
    this.derivation = e.get, this.name = e.name || "ComputedValue@" + hn(), e.set && (this.setter = Ei(this.name + "-setter", e.set)), this.equals = e.equals || (e.compareStructural || e.struct ? Un.structural : Un.default), this.scope = e.context, this.requiresReaction = !!e.requiresReaction, this.keepAlive = !!e.keepAlive;
  }

  return e.prototype.onBecomeStale = function () {
    !function (e) {
      if (e.lowestObserverState !== li.UP_TO_DATE) return;
      e.lowestObserverState = li.POSSIBLY_STALE;
      var t = e.observers,
          n = t.length;

      for (; n--;) {
        var i = t[n];
        i.dependenciesState === li.UP_TO_DATE && (i.dependenciesState = li.POSSIBLY_STALE, i.isTracing !== ui.NONE && Vi(i, e), i.onBecomeStale());
      }
    }(this);
  }, e.prototype.onBecomeUnobserved = function () {}, e.prototype.onBecomeObserved = function () {}, e.prototype.get = function () {
    this.isComputing && dn("Cycle detected in computation " + this.name + ": " + this.derivation), 0 !== Bi.inBatch || 0 !== this.observers.length || this.keepAlive ? (Gi(this), gi(this) && this.trackAndCompute() && function (e) {
      if (e.lowestObserverState === li.STALE) return;
      e.lowestObserverState = li.STALE;
      var t = e.observers,
          n = t.length;

      for (; n--;) {
        var i = t[n];
        i.dependenciesState === li.POSSIBLY_STALE ? i.dependenciesState = li.STALE : i.dependenciesState === li.UP_TO_DATE && (e.lowestObserverState = li.UP_TO_DATE);
      }
    }(this)) : gi(this) && (this.warnAboutUntrackedRead(), Wi(), this.value = this.computeValue(!1), Hi());
    var e = this.value;
    if (di(e)) throw e.cause;
    return e;
  }, e.prototype.peek = function () {
    var e = this.computeValue(!1);
    if (di(e)) throw e.cause;
    return e;
  }, e.prototype.set = function (e) {
    if (this.setter) {
      gn(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?"), this.isRunningSetter = !0;

      try {
        this.setter.call(this.scope, e);
      } finally {
        this.isRunningSetter = !1;
      }
    } else gn(!1, "production" !== process.env.NODE_ENV && "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
  }, e.prototype.trackAndCompute = function () {
    Ji() && $i({
      object: this.scope,
      type: "compute",
      name: this.name
    });
    var e = this.value,
        t = this.dependenciesState === li.NOT_TRACKING,
        n = this.computeValue(!0),
        i = t || di(e) || di(n) || !this.equals(e, n);
    return i && (this.value = n), i;
  }, e.prototype.computeValue = function (e) {
    var t;
    if (this.isComputing = !0, Bi.computationDepth++, e) t = yi(this, this.derivation, this.scope);else if (!0 === Bi.disableErrorBoundaries) t = this.derivation.call(this.scope);else try {
      t = this.derivation.call(this.scope);
    } catch (e) {
      t = new hi(e);
    }
    return Bi.computationDepth--, this.isComputing = !1, t;
  }, e.prototype.suspend = function () {
    this.keepAlive || (_i(this), this.value = void 0);
  }, e.prototype.observe = function (e, t) {
    var n = this,
        i = !0,
        r = void 0;
    return function (e, t) {
      void 0 === t && (t = cn);
      "production" !== process.env.NODE_ENV && (gn("function" == typeof e, "Autorun expects a function as first argument"), gn(!1 == ("function" == typeof (n = e) && !0 === n.isMobxAction), "Autorun does not accept actions since actions are untrackable"));
      var n;
      var i,
          r = t && t.name || e.name || "Autorun@" + hn();

      if (t.scheduler || t.delay) {
        var o = function (e) {
          return e.scheduler ? e.scheduler : e.delay ? function (t) {
            return setTimeout(t, e.delay);
          } : cr;
        }(t),
            a = !1;

        i = new Xi(r, function () {
          a || (a = !0, o(function () {
            a = !1, i.isDisposed || i.track(s);
          }));
        }, t.onError, t.requiresObservable);
      } else i = new Xi(r, function () {
        this.track(s);
      }, t.onError, t.requiresObservable);

      function s() {
        e(i);
      }

      return i.schedule(), i.getDisposer();
    }(function () {
      var o = n.get();

      if (!i || t) {
        var a = bi();
        e({
          type: "update",
          object: n,
          newValue: o,
          oldValue: r
        }), wi(a);
      }

      i = !1, r = o;
    });
  }, e.prototype.warnAboutUntrackedRead = function () {
    "production" !== process.env.NODE_ENV && (!0 === this.requiresReaction && dn("[mobx] Computed value " + this.name + " is read outside a reactive context"), this.isTracing !== ui.NONE && console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute"), Bi.computedRequiresReaction && console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute"));
  }, e.prototype.toJSON = function () {
    return this.get();
  }, e.prototype.toString = function () {
    return this.name + "[" + this.derivation.toString() + "]";
  }, e.prototype.valueOf = function () {
    return In(this.get());
  }, e;
}();

Fi.prototype[Rn()] = Fi.prototype.valueOf;

var Di = Sn("ComputedValue", Fi),
    Pi = function Pi() {
  this.version = 5, this.UNCHANGED = {}, this.trackingDerivation = null, this.computationDepth = 0, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !0, this.allowStateReads = !0, this.enforceActions = !1, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.computedConfigurable = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1;
},
    zi = !0,
    Li = !1,
    Bi = function () {
  var e = fn();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (zi = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new Pi().version && (zi = !1), zi ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = new Pi()) : (setTimeout(function () {
    Li || dn("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
  }, 1), new Pi());
}();

function Ni(e, t) {
  var n = e.observers.length;
  n && (e.observersIndexes[t.__mapid] = n), e.observers[n] = t, e.lowestObserverState > t.dependenciesState && (e.lowestObserverState = t.dependenciesState);
}

function Ui(e, t) {
  if (1 === e.observers.length) e.observers.length = 0, ji(e);else {
    var n = e.observers,
        i = e.observersIndexes,
        r = n.pop();

    if (r !== t) {
      var o = i[t.__mapid] || 0;
      o ? i[r.__mapid] = o : delete i[r.__mapid], n[o] = r;
    }

    delete i[t.__mapid];
  }
}

function ji(e) {
  !1 === e.isPendingUnobservation && (e.isPendingUnobservation = !0, Bi.pendingUnobservations.push(e));
}

function Wi() {
  Bi.inBatch++;
}

function Hi() {
  if (0 == --Bi.inBatch) {
    qi();

    for (var e = Bi.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation = !1, 0 === n.observers.length && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBecomeUnobserved()), n instanceof Fi && n.suspend());
    }

    Bi.pendingUnobservations = [];
  }
}

function Gi(e) {
  !function (e) {
    "production" !== process.env.NODE_ENV && !Bi.allowStateReads && Bi.observableRequiresReaction && console.warn("[mobx] Observable " + e.name + " being read outside a reactive context");
  }(e);
  var t = Bi.trackingDerivation;
  return null !== t ? (t.runId !== e.lastAccessedBy && (e.lastAccessedBy = t.runId, t.newObserving[t.unboundDepsCount++] = e, e.isBeingObserved || (e.isBeingObserved = !0, e.onBecomeObserved())), !0) : (0 === e.observers.length && Bi.inBatch > 0 && ji(e), !1);
}

function Vi(e, t) {
  if (console.log("[mobx.trace] '" + e.name + "' is invalidated due to a change in: '" + t.name + "'"), e.isTracing === ui.BREAK) {
    var n = [];
    !function e(t, n, i) {
      if (n.length >= 1e3) return void n.push("(and many more)");
      n.push("" + new Array(i).join("\t") + t.name), t.dependencies && t.dependencies.forEach(function (t) {
        return e(t, n, i + 1);
      });
    }((i = e, dr(ao(i, r))), n, 1), new Function("debugger;\n/*\nTracing '" + e.name + "'\n\nYou are entering this break point because derivation '" + e.name + "' is being traced and '" + t.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (e instanceof Fi ? e.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + n.join("\n") + "\n*/\n    ")();
  }

  var i, r;
}

var Xi = function () {
  function e(e, t, n, i) {
    void 0 === e && (e = "Reaction@" + hn()), void 0 === i && (i = !1), this.name = e, this.onInvalidate = t, this.errorHandler = n, this.requiresObservable = i, this.observing = [], this.newObserving = [], this.dependenciesState = li.NOT_TRACKING, this.diffValue = 0, this.runId = 0, this.unboundDepsCount = 0, this.__mapid = "#" + hn(), this.isDisposed = !1, this._isScheduled = !1, this._isTrackPending = !1, this._isRunning = !1, this.isTracing = ui.NONE;
  }

  return e.prototype.onBecomeStale = function () {
    this.schedule();
  }, e.prototype.schedule = function () {
    this._isScheduled || (this._isScheduled = !0, Bi.pendingReactions.push(this), qi());
  }, e.prototype.isScheduled = function () {
    return this._isScheduled;
  }, e.prototype.runReaction = function () {
    if (!this.isDisposed) {
      if (Wi(), this._isScheduled = !1, gi(this)) {
        this._isTrackPending = !0;

        try {
          this.onInvalidate(), this._isTrackPending && Ji() && $i({
            name: this.name,
            type: "scheduled-reaction"
          });
        } catch (e) {
          this.reportExceptionInDerivation(e);
        }
      }

      Hi();
    }
  }, e.prototype.track = function (e) {
    Wi();
    var t,
        n = Ji();
    n && (t = Date.now(), er({
      name: this.name,
      type: "reaction"
    })), this._isRunning = !0;
    var i = yi(this, e, void 0);
    this._isRunning = !1, this._isTrackPending = !1, this.isDisposed && _i(this), di(i) && this.reportExceptionInDerivation(i.cause), n && nr({
      time: Date.now() - t
    }), Hi();
  }, e.prototype.reportExceptionInDerivation = function (e) {
    var t = this;
    if (this.errorHandler) this.errorHandler(e, this);else {
      if (Bi.disableErrorBoundaries) throw e;
      var n = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
      Bi.suppressReactionErrors ? console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)") : console.error(n, e), Ji() && $i({
        type: "error",
        name: this.name,
        message: n,
        error: "" + e
      }), Bi.globalReactionErrorHandlers.forEach(function (n) {
        return n(e, t);
      });
    }
  }, e.prototype.dispose = function () {
    this.isDisposed || (this.isDisposed = !0, this._isRunning || (Wi(), _i(this), Hi()));
  }, e.prototype.getDisposer = function () {
    var e = this.dispose.bind(this);
    return e.$mobx = this, e;
  }, e.prototype.toString = function () {
    return "Reaction[" + this.name + "]";
  }, e.prototype.trace = function (e) {
    void 0 === e && (e = !1), function () {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }

      var n = !1;
      "boolean" == typeof e[e.length - 1] && (n = e.pop());
      var i = kr(e);
      if (!i) return dn("production" !== process.env.NODE_ENV && "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
      i.isTracing === ui.NONE && console.log("[mobx.trace] '" + i.name + "' tracing enabled");
      i.isTracing = n ? ui.BREAK : ui.LOG;
    }(this, e);
  }, e;
}(),
    Yi = function Yi(e) {
  return e();
};

function qi() {
  Bi.inBatch > 0 || Bi.isRunningReactions || Yi(Ki);
}

function Ki() {
  Bi.isRunningReactions = !0;

  for (var e = Bi.pendingReactions, t = 0; e.length > 0;) {
    100 == ++t && (console.error("Reaction doesn't converge to a stable state after 100 iterations. Probably there is a cycle in the reactive function: " + e[0]), e.splice(0));

    for (var n = e.splice(0), i = 0, r = n.length; i < r; i++) {
      n[i].runReaction();
    }
  }

  Bi.isRunningReactions = !1;
}

var Zi = Sn("Reaction", Xi);

function Qi(e) {
  var t = Yi;

  Yi = function Yi(n) {
    return e(function () {
      return t(n);
    });
  };
}

function Ji() {
  return !!Bi.spyListeners.length;
}

function $i(e) {
  if (Bi.spyListeners.length) for (var t = Bi.spyListeners, n = 0, i = t.length; n < i; n++) {
    t[n](e);
  }
}

function er(e) {
  $i(_an({}, e, {
    spyReportStart: !0
  }));
}

var tr = {
  spyReportEnd: !0
};

function nr(e) {
  $i(e ? _an({}, e, {
    spyReportEnd: !0
  }) : tr);
}

function ir(e) {
  return Bi.spyListeners.push(e), _n(function () {
    Bi.spyListeners = Bi.spyListeners.filter(function (t) {
      return t !== e;
    });
  });
}

function rr() {
  dn("production" !== process.env.NODE_ENV && "@action fields are not reassignable");
}

function or(e) {
  return function (t, n, i) {
    if (i) {
      if ("production" !== process.env.NODE_ENV && void 0 !== i.get) return dn("@action cannot be used with getters");
      if (i.value) return {
        value: Ei(e, i.value),
        enumerable: !1,
        configurable: !0,
        writable: !0
      };
      var r = i.initializer;
      return {
        enumerable: !1,
        configurable: !0,
        writable: !0,
        initializer: function initializer() {
          return Ei(e, r.call(this));
        }
      };
    }

    return ar(e).apply(this, arguments);
  };
}

function ar(e) {
  return function (t, n, i) {
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      get: function get() {},
      set: function set(t) {
        xn(this, n, sr(e, t));
      }
    });
  };
}

var sr = function sr(e, t, n, i) {
  return 1 === arguments.length && "function" == typeof e ? Ei(e.name || "<unnamed action>", e) : 2 === arguments.length && "function" == typeof t ? Ei(e, t) : 1 === arguments.length && "string" == typeof e ? or(e) : !0 !== i ? or(t).apply(null, arguments) : void (e[t] = Ei(e.name || t, n.value));
};

function lr(e, t) {
  var n = "string" == typeof e ? e : e.name || "<unnamed action>",
      i = "function" == typeof e ? e : t;
  return "production" !== process.env.NODE_ENV && (gn("function" == typeof i && 0 === i.length, "`runInAction` expects a function without arguments"), "string" == typeof n && n || dn("actions should have valid names, got: '" + n + "'")), Oi(n, i, this, void 0);
}

function ur(e, t, n) {
  xn(e, t, Ei(t, n.bind(e)));
}

sr.bound = function (e, t, n, i) {
  return !0 === i ? (ur(e, t, n.value), null) : n ? {
    configurable: !0,
    enumerable: !1,
    get: function get() {
      return ur(this, t, n.value || n.initializer.call(this)), this[t];
    },
    set: rr
  } : {
    enumerable: !1,
    configurable: !0,
    set: function set(e) {
      ur(this, t, e);
    },
    get: function get() {}
  };
};

var cr = function cr(e) {
  return e();
};

function pr(e, t, n) {
  return fr("onBecomeUnobserved", e, t, n);
}

function fr(e, t, n, i) {
  var r = "function" == typeof i ? ao(t, n) : ao(t),
      o = "function" == typeof i ? i : n,
      a = r[e];
  return "function" != typeof a ? dn("production" !== process.env.NODE_ENV && "Not an atom that can be (un)observed") : (r[e] = function () {
    a.call(this), o.call(this);
  }, function () {
    r[e] = a;
  });
}

function hr(e, t, n, i) {
  if ("production" !== process.env.NODE_ENV && (gn(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments"), gn("object" == typeof e, "'extendObservable' expects an object as first argument"), gn(!Kr(e), "'extendObservable' should not be used on maps, use map.merge instead"), gn(!_r(t), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540"), n)) for (var r in n) {
    r in t || dn("Trying to declare a decorator for unspecified property '" + r + "'");
  }
  var o = (i = $n(i)).defaultDecorator || (!1 === i.deep ? ii : ti);
  Gn(e), eo(e, i.name, o.enhancer), Wi();

  try {
    for (var r in t) {
      var a = Object.getOwnPropertyDescriptor(t, r);
      "production" !== process.env.NODE_ENV && (Object.getOwnPropertyDescriptor(e, r) && dn("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + r + "' already exists on '" + e + "'"), mr(a.value) && dn("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead"));
      var s = n && r in n ? n[r] : a.get ? ci : o;
      if ("production" !== process.env.NODE_ENV && "function" != typeof s) return dn("Not a valid decorator for '" + r + "', got: " + s);
      var l = s(e, r, a, !0);
      l && Object.defineProperty(e, r, l);
    }
  } finally {
    Hi();
  }

  return e;
}

function dr(e) {
  var t,
      n,
      i = {
    name: e.name
  };
  return e.observing && e.observing.length > 0 && (i.dependencies = (t = e.observing, n = [], t.forEach(function (e) {
    -1 === n.indexOf(e) && n.push(e);
  }), n).map(dr)), i;
}

function gr(e, t) {
  if (null == e) return !1;

  if (void 0 !== t) {
    if (!1 === oo(e)) return !1;
    if (!e.$mobx.values[t]) return !1;
    var n = ao(e, t);
    return Di(n);
  }

  return Di(e);
}

function mr(e) {
  return arguments.length > 1 ? dn("production" !== process.env.NODE_ENV && "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property") : gr(e);
}

function yr(e, t) {
  if (null == e) return !1;

  if (void 0 !== t) {
    if ("production" !== process.env.NODE_ENV && (Kr(e) || Vr(e))) return dn("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");

    if (oo(e)) {
      var n = e.$mobx;
      return n.values && !!n.values[t];
    }

    return !1;
  }

  return oo(e) || !!e.$mobx || Ln(e) || Zi(e) || Di(e);
}

function _r(e) {
  return 1 !== arguments.length && dn("production" !== process.env.NODE_ENV && "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), yr(e);
}

var vr = {
  detectCycles: !0,
  exportMapsAsObjects: !0,
  recurseEverything: !1
};

function br(e, t, n, i) {
  return i.detectCycles && e.set(t, n), n;
}

function wr(e, t, n) {
  if (!t.recurseEverything && !_r(e)) return e;
  if ("object" != typeof e) return e;
  if (null === e) return null;
  if (e instanceof Date) return e;
  if (Mi(e)) return wr(e.get(), t, n);
  var i;
  if (_r(e) && (oo(i = e) ? i.$mobx.getKeys() : Kr(i) ? i._keys.slice() : Jr(i) ? On(i.keys()) : Vr(i) ? i.map(function (e, t) {
    return t;
  }) : dn("production" !== process.env.NODE_ENV && "'keys()' can only be used on observable objects, arrays, sets and maps")), !0 === t.detectCycles && null !== e && n.has(e)) return n.get(e);

  if (Vr(e) || Array.isArray(e)) {
    var r = br(n, e, [], t),
        o = e.map(function (e) {
      return wr(e, t, n);
    });
    r.length = o.length;

    for (var a = 0, s = o.length; a < s; a++) {
      r[a] = o[a];
    }

    return r;
  }

  if (Jr(e) || Object.getPrototypeOf(e) === Set.prototype) {
    if (!1 === t.exportMapsAsObjects) {
      var l = br(n, e, new Set(), t);
      return e.forEach(function (e) {
        l.add(wr(e, t, n));
      }), l;
    }

    var u = br(n, e, [], t);
    return e.forEach(function (e) {
      u.push(wr(e, t, n));
    }), u;
  }

  if (Kr(e) || Object.getPrototypeOf(e) === Map.prototype) {
    if (!1 === t.exportMapsAsObjects) {
      var c = br(n, e, new Map(), t);
      return e.forEach(function (e, i) {
        c.set(i, wr(e, t, n));
      }), c;
    }

    var p = br(n, e, {}, t);
    return e.forEach(function (e, i) {
      p[i] = wr(e, t, n);
    }), p;
  }

  var f = br(n, e, {}, t);

  for (var h in e) {
    f[h] = wr(e[h], t, n);
  }

  return f;
}

function xr(e, t) {
  var n;
  return "boolean" == typeof t && (t = {
    detectCycles: t
  }), t || (t = vr), t.detectCycles = void 0 === t.detectCycles ? !0 === t.recurseEverything : !0 === t.detectCycles, t.detectCycles && (n = new Map()), wr(e, t, n);
}

function kr(e) {
  switch (e.length) {
    case 0:
      return Bi.trackingDerivation;

    case 1:
      return ao(e[0]);

    case 2:
      return ao(e[0], e[1]);
  }
}

function Tr(e, t) {
  void 0 === t && (t = void 0), Wi();

  try {
    return e.apply(t);
  } finally {
    Hi();
  }
}

function Sr(e) {
  return void 0 !== e.interceptors && e.interceptors.length > 0;
}

function Cr(e, t) {
  var n = e.interceptors || (e.interceptors = []);
  return n.push(t), _n(function () {
    var e = n.indexOf(t);
    -1 !== e && n.splice(e, 1);
  });
}

function Er(e, t) {
  var n = bi();

  try {
    var i = e.interceptors;
    if (i) for (var r = 0, o = i.length; r < o && (gn(!(t = i[r](t)) || t.type, "Intercept handlers should return nothing or a change object"), t); r++) {
      ;
    }
    return t;
  } finally {
    wi(n);
  }
}

function Or(e) {
  return void 0 !== e.changeListeners && e.changeListeners.length > 0;
}

function Rr(e, t) {
  var n = e.changeListeners || (e.changeListeners = []);
  return n.push(t), _n(function () {
    var e = n.indexOf(t);
    -1 !== e && n.splice(e, 1);
  });
}

function Ir(e, t) {
  var n = bi(),
      i = e.changeListeners;

  if (i) {
    for (var r = 0, o = (i = i.slice()).length; r < o; r++) {
      i[r](t);
    }

    wi(n);
  }
}

var Ar,
    Mr,
    Fr,
    Dr,
    Pr = (Ar = !1, Mr = {}, Object.defineProperty(Mr, "0", {
  set: function set() {
    Ar = !0;
  }
}), Object.create(Mr)[0] = 1, !1 === Ar),
    zr = 0,
    Lr = function Lr() {};

Fr = Lr, Dr = Array.prototype, void 0 !== Object.setPrototypeOf ? Object.setPrototypeOf(Fr.prototype, Dr) : void 0 !== Fr.prototype.__proto__ ? Fr.prototype.__proto__ = Dr : Fr.prototype = Dr, Object.isFrozen(Array) && ["constructor", "push", "shift", "concat", "pop", "unshift", "replace", "find", "findIndex", "splice", "reverse", "sort"].forEach(function (e) {
  Object.defineProperty(Lr.prototype, e, {
    configurable: !0,
    writable: !0,
    value: Array.prototype[e]
  });
});

var Br = function () {
  function e(e, t, n, i) {
    this.array = n, this.owned = i, this.values = [], this.lastKnownLength = 0, this.atom = new zn(e || "ObservableArray@" + hn()), this.enhancer = function (n, i) {
      return t(n, i, e + "[..]");
    };
  }

  return e.prototype.dehanceValue = function (e) {
    return void 0 !== this.dehancer ? this.dehancer(e) : e;
  }, e.prototype.dehanceValues = function (e) {
    return void 0 !== this.dehancer && e.length > 0 ? e.map(this.dehancer) : e;
  }, e.prototype.intercept = function (e) {
    return Cr(this, e);
  }, e.prototype.observe = function (e, t) {
    return void 0 === t && (t = !1), t && e({
      object: this.array,
      type: "splice",
      index: 0,
      added: this.values.slice(),
      addedCount: this.values.length,
      removed: [],
      removedCount: 0
    }), Rr(this, e);
  }, e.prototype.getArrayLength = function () {
    return this.atom.reportObserved(), this.values.length;
  }, e.prototype.setArrayLength = function (e) {
    if ("number" != typeof e || e < 0) throw new Error("[mobx.array] Out of range: " + e);
    var t = this.values.length;
    if (e !== t) if (e > t) {
      for (var n = new Array(e - t), i = 0; i < e - t; i++) {
        n[i] = void 0;
      }

      this.spliceWithArray(t, 0, n);
    } else this.spliceWithArray(e, t - e);
  }, e.prototype.updateArrayLength = function (e, t) {
    if (e !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
    this.lastKnownLength += t, t > 0 && e + t + 1 > zr && Hr(e + t + 1);
  }, e.prototype.spliceWithArray = function (e, t, n) {
    var i = this;
    mi(this.atom);
    var r = this.values.length;

    if (void 0 === e ? e = 0 : e > r ? e = r : e < 0 && (e = Math.max(0, r + e)), t = 1 === arguments.length ? r - e : null == t ? 0 : Math.max(0, Math.min(t, r - e)), void 0 === n && (n = un), Sr(this)) {
      var o = Er(this, {
        object: this.array,
        type: "splice",
        index: e,
        removedCount: t,
        added: n
      });
      if (!o) return un;
      t = o.removedCount, n = o.added;
    }

    var a = (n = 0 === n.length ? n : n.map(function (e) {
      return i.enhancer(e, void 0);
    })).length - t;
    this.updateArrayLength(r, a);
    var s = this.spliceItemsIntoValues(e, t, n);
    return 0 === t && 0 === n.length || this.notifyArraySplice(e, n, s), this.dehanceValues(s);
  }, e.prototype.spliceItemsIntoValues = function (e, t, n) {
    var i;
    if (n.length < 1e4) return (i = this.values).splice.apply(i, ln([e, t], n));
    var r = this.values.slice(e, e + t);
    return this.values = this.values.slice(0, e).concat(n, this.values.slice(e + t)), r;
  }, e.prototype.notifyArrayChildUpdate = function (e, t, n) {
    var i = !this.owned && Ji(),
        r = Or(this),
        o = r || i ? {
      object: this.array,
      type: "update",
      index: e,
      newValue: t,
      oldValue: n
    } : null;
    i && er(_an({}, o, {
      name: this.atom.name
    })), this.atom.reportChanged(), r && Ir(this, o), i && nr();
  }, e.prototype.notifyArraySplice = function (e, t, n) {
    var i = !this.owned && Ji(),
        r = Or(this),
        o = r || i ? {
      object: this.array,
      type: "splice",
      index: e,
      removed: n,
      added: t,
      removedCount: n.length,
      addedCount: t.length
    } : null;
    i && er(_an({}, o, {
      name: this.atom.name
    })), this.atom.reportChanged(), r && Ir(this, o), i && nr();
  }, e;
}(),
    Nr = function (e) {
  function t(t, n, i, r) {
    void 0 === i && (i = "ObservableArray@" + hn()), void 0 === r && (r = !1);
    var o = e.call(this) || this,
        a = new Br(i, n, o, r);

    if (kn(o, "$mobx", a), t && t.length) {
      var s = Ri(!0);
      o.spliceWithArray(0, 0, t), Ii(s);
    }

    return Pr && Object.defineProperty(a.array, "0", Ur), o;
  }

  return on(t, e), t.prototype.intercept = function (e) {
    return this.$mobx.intercept(e);
  }, t.prototype.observe = function (e, t) {
    return void 0 === t && (t = !1), this.$mobx.observe(e, t);
  }, t.prototype.clear = function () {
    return this.splice(0);
  }, t.prototype.concat = function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    return this.$mobx.atom.reportObserved(), Array.prototype.concat.apply(this.peek(), e.map(function (e) {
      return Vr(e) ? e.peek() : e;
    }));
  }, t.prototype.replace = function (e) {
    return this.$mobx.spliceWithArray(0, this.$mobx.values.length, e);
  }, t.prototype.toJS = function () {
    return this.slice();
  }, t.prototype.toJSON = function () {
    return this.toJS();
  }, t.prototype.peek = function () {
    return this.$mobx.atom.reportObserved(), this.$mobx.dehanceValues(this.$mobx.values);
  }, t.prototype.find = function (e, t, n) {
    void 0 === n && (n = 0), 3 === arguments.length && yn("The array.find fromIndex argument to find will not be supported anymore in the next major");
    var i = this.findIndex.apply(this, arguments);
    return -1 === i ? void 0 : this.get(i);
  }, t.prototype.findIndex = function (e, t, n) {
    void 0 === n && (n = 0), 3 === arguments.length && yn("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");

    for (var i = this.peek(), r = i.length, o = n; o < r; o++) {
      if (e.call(t, i[o], o, this)) return o;
    }

    return -1;
  }, t.prototype.splice = function (e, t) {
    for (var n = [], i = 2; i < arguments.length; i++) {
      n[i - 2] = arguments[i];
    }

    switch (arguments.length) {
      case 0:
        return [];

      case 1:
        return this.$mobx.spliceWithArray(e);

      case 2:
        return this.$mobx.spliceWithArray(e, t);
    }

    return this.$mobx.spliceWithArray(e, t, n);
  }, t.prototype.spliceWithArray = function (e, t, n) {
    return this.$mobx.spliceWithArray(e, t, n);
  }, t.prototype.push = function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    var n = this.$mobx;
    return n.spliceWithArray(n.values.length, 0, e), n.values.length;
  }, t.prototype.pop = function () {
    return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
  }, t.prototype.shift = function () {
    return this.splice(0, 1)[0];
  }, t.prototype.unshift = function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    var n = this.$mobx;
    return n.spliceWithArray(0, 0, e), n.values.length;
  }, t.prototype.reverse = function () {
    var e = this.slice();
    return e.reverse.apply(e, arguments);
  }, t.prototype.sort = function (e) {
    var t = this.slice();
    return t.sort.apply(t, arguments);
  }, t.prototype.remove = function (e) {
    var t = this.$mobx.dehanceValues(this.$mobx.values).indexOf(e);
    return t > -1 && (this.splice(t, 1), !0);
  }, t.prototype.move = function (e, t) {
    function n(e) {
      if (e < 0) throw new Error("[mobx.array] Index out of bounds: " + e + " is negative");
      var t = this.$mobx.values.length;
      if (e >= t) throw new Error("[mobx.array] Index out of bounds: " + e + " is not smaller than " + t);
    }

    if (yn("observableArray.move is deprecated, use .slice() & .replace() instead"), n.call(this, e), n.call(this, t), e !== t) {
      var i,
          r = this.$mobx.values;
      i = e < t ? ln(r.slice(0, e), r.slice(e + 1, t + 1), [r[e]], r.slice(t + 1)) : ln(r.slice(0, t), [r[e]], r.slice(t, e), r.slice(e + 1)), this.replace(i);
    }
  }, t.prototype.get = function (e) {
    var t = this.$mobx;

    if (t) {
      if (e < t.values.length) return t.atom.reportObserved(), t.dehanceValue(t.values[e]);
      console.warn("[mobx.array] Attempt to read an array index (" + e + ") that is out of bounds (" + t.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
    }
  }, t.prototype.set = function (e, t) {
    var n = this.$mobx,
        i = n.values;

    if (e < i.length) {
      mi(n.atom);
      var r = i[e];

      if (Sr(n)) {
        var o = Er(n, {
          type: "update",
          object: this,
          index: e,
          newValue: t
        });
        if (!o) return;
        t = o.newValue;
      }

      (t = n.enhancer(t, r)) !== r && (i[e] = t, n.notifyArrayChildUpdate(e, t, r));
    } else {
      if (e !== i.length) throw new Error("[mobx.array] Index out of bounds, " + e + " is larger than " + i.length);
      n.spliceWithArray(e, 0, [t]);
    }
  }, t;
}(Lr);

Mn(Nr.prototype, function () {
  this.$mobx.atom.reportObserved();
  var e = this,
      t = 0;
  return Fn({
    next: function next() {
      return t < e.length ? {
        value: e[t++],
        done: !1
      } : {
        done: !0,
        value: void 0
      };
    }
  });
}), Object.defineProperty(Nr.prototype, "length", {
  enumerable: !1,
  configurable: !0,
  get: function get() {
    return this.$mobx.getArrayLength();
  },
  set: function set(e) {
    this.$mobx.setArrayLength(e);
  }
}), xn(Nr.prototype, Dn(), "Array"), ["every", "filter", "forEach", "indexOf", "join", "lastIndexOf", "map", "reduce", "reduceRight", "slice", "some", "toString", "toLocaleString"].forEach(function (e) {
  var t = Array.prototype[e];
  gn("function" == typeof t, "Base function not defined on Array prototype: '" + e + "'"), xn(Nr.prototype, e, function () {
    return t.apply(this.peek(), arguments);
  });
}), function (e, t) {
  for (var n = 0; n < t.length; n++) {
    xn(e, t[n], e[t[n]]);
  }
}(Nr.prototype, ["constructor", "intercept", "observe", "clear", "concat", "get", "replace", "toJS", "toJSON", "peek", "find", "findIndex", "splice", "spliceWithArray", "push", "pop", "set", "shift", "unshift", "reverse", "sort", "remove", "move", "toString", "toLocaleString"]);
var Ur = jr(0);

function jr(e) {
  return {
    enumerable: !1,
    configurable: !1,
    get: function get() {
      return this.get(e);
    },
    set: function set(t) {
      this.set(e, t);
    }
  };
}

function Wr(e) {
  Object.defineProperty(Nr.prototype, "" + e, jr(e));
}

function Hr(e) {
  for (var t = zr; t < e; t++) {
    Wr(t);
  }

  zr = e;
}

Hr(1e3);
var Gr = Sn("ObservableArrayAdministration", Br);

function Vr(e) {
  return bn(e) && Gr(e.$mobx);
}

var Xr = {},
    Yr = function () {
  function e(e, t, n) {
    if (void 0 === t && (t = Yn), void 0 === n && (n = "ObservableMap@" + hn()), this.enhancer = t, this.name = n, this.$mobx = Xr, this._keys = new Nr(void 0, qn, this.name + ".keys()", !0), "function" != typeof Map) throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
    this._data = new Map(), this._hasMap = new Map(), this.merge(e);
  }

  return e.prototype._has = function (e) {
    return this._data.has(e);
  }, e.prototype.has = function (e) {
    var t = this;
    if (!Bi.trackingDerivation) return this._has(e);

    var n = this._hasMap.get(e);

    if (!n) {
      var i = n = new Ai(this._has(e), qn, this.name + "." + qr(e) + "?", !1);
      this._hasMap.set(e, i), pr(i, function () {
        return t._hasMap.delete(e);
      });
    }

    return n.get();
  }, e.prototype.set = function (e, t) {
    var n = this._has(e);

    if (Sr(this)) {
      var i = Er(this, {
        type: n ? "update" : "add",
        object: this,
        newValue: t,
        name: e
      });
      if (!i) return this;
      t = i.newValue;
    }

    return n ? this._updateValue(e, t) : this._addValue(e, t), this;
  }, e.prototype.delete = function (e) {
    var t = this;
    if (Sr(this) && !(r = Er(this, {
      type: "delete",
      object: this,
      name: e
    }))) return !1;

    if (this._has(e)) {
      var n = Ji(),
          i = Or(this),
          r = i || n ? {
        type: "delete",
        object: this,
        oldValue: this._data.get(e).value,
        name: e
      } : null;
      return n && er(_an({}, r, {
        name: this.name,
        key: e
      })), Tr(function () {
        t._keys.remove(e), t._updateHasMapEntry(e, !1), t._data.get(e).setNewValue(void 0), t._data.delete(e);
      }), i && Ir(this, r), n && nr(), !0;
    }

    return !1;
  }, e.prototype._updateHasMapEntry = function (e, t) {
    var n = this._hasMap.get(e);

    n && n.setNewValue(t);
  }, e.prototype._updateValue = function (e, t) {
    var n = this._data.get(e);

    if ((t = n.prepareNewValue(t)) !== Bi.UNCHANGED) {
      var i = Ji(),
          r = Or(this),
          o = r || i ? {
        type: "update",
        object: this,
        oldValue: n.value,
        name: e,
        newValue: t
      } : null;
      i && er(_an({}, o, {
        name: this.name,
        key: e
      })), n.setNewValue(t), r && Ir(this, o), i && nr();
    }
  }, e.prototype._addValue = function (e, t) {
    var n = this;
    Tr(function () {
      var i = new Ai(t, n.enhancer, n.name + "." + qr(e), !1);
      n._data.set(e, i), t = i.value, n._updateHasMapEntry(e, !0), n._keys.push(e);
    });
    var i = Ji(),
        r = Or(this),
        o = r || i ? {
      type: "add",
      object: this,
      name: e,
      newValue: t
    } : null;
    i && er(_an({}, o, {
      name: this.name,
      key: e
    })), r && Ir(this, o), i && nr();
  }, e.prototype.get = function (e) {
    return this.has(e) ? this.dehanceValue(this._data.get(e).get()) : this.dehanceValue(void 0);
  }, e.prototype.dehanceValue = function (e) {
    return void 0 !== this.dehancer ? this.dehancer(e) : e;
  }, e.prototype.keys = function () {
    return this._keys[An()]();
  }, e.prototype.values = function () {
    var e = this,
        t = 0;
    return Fn({
      next: function next() {
        return t < e._keys.length ? {
          value: e.get(e._keys[t++]),
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, e.prototype.entries = function () {
    var e = this,
        t = 0;
    return Fn({
      next: function next() {
        if (t < e._keys.length) {
          var n = e._keys[t++];
          return {
            value: [n, e.get(n)],
            done: !1
          };
        }

        return {
          done: !0
        };
      }
    });
  }, e.prototype.forEach = function (e, t) {
    var n = this;

    this._keys.forEach(function (i) {
      return e.call(t, n.get(i), i, n);
    });
  }, e.prototype.merge = function (e) {
    var t = this;
    return Kr(e) && (e = e.toJS()), Tr(function () {
      wn(e) ? Object.keys(e).forEach(function (n) {
        return t.set(n, e[n]);
      }) : Array.isArray(e) ? e.forEach(function (e) {
        var n = sn(e, 2),
            i = n[0],
            r = n[1];
        return t.set(i, r);
      }) : Cn(e) ? e.constructor !== Map ? dn("Cannot initialize from classes that inherit from Map: " + e.constructor.name) : e.forEach(function (e, n) {
        return t.set(n, e);
      }) : null != e && dn("Cannot initialize map from " + e);
    }), this;
  }, e.prototype.clear = function () {
    var e = this;
    Tr(function () {
      vi(function () {
        e._keys.slice().forEach(function (t) {
          return e.delete(t);
        });
      });
    });
  }, e.prototype.replace = function (e) {
    var t = this;
    return Tr(function () {
      for (var n, i = Cn(n = e) || Kr(n) ? n : Array.isArray(n) ? new Map(n) : wn(n) ? new Map(Object.entries(n)) : dn("Cannot convert to map from '" + n + "'"), r = t._keys, o = Array.from(i.keys()), a = !1, s = 0; s < r.length; s++) {
        var l = r[s];
        r.length === o.length && l !== o[s] && (a = !0), i.has(l) || (a = !0, t.delete(l));
      }

      i.forEach(function (e, n) {
        t._data.has(n) || (a = !0), t.set(n, e);
      }), a && t._keys.replace(o);
    }), this;
  }, Object.defineProperty(e.prototype, "size", {
    get: function get() {
      return this._keys.length;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.toPOJO = function () {
    var e = this,
        t = {};
    return this._keys.forEach(function (n) {
      return t["symbol" == typeof n ? n : qr(n)] = e.get(n);
    }), t;
  }, e.prototype.toJS = function () {
    var e = this,
        t = new Map();
    return this._keys.forEach(function (n) {
      return t.set(n, e.get(n));
    }), t;
  }, e.prototype.toJSON = function () {
    return this.toPOJO();
  }, e.prototype.toString = function () {
    var e = this;
    return this.name + "[{ " + this._keys.map(function (t) {
      return qr(t) + ": " + e.get(t);
    }).join(", ") + " }]";
  }, e.prototype.observe = function (e, t) {
    return "production" !== process.env.NODE_ENV && gn(!0 !== t, "`observe` doesn't support fireImmediately=true in combination with maps."), Rr(this, e);
  }, e.prototype.intercept = function (e) {
    return Cr(this, e);
  }, e;
}();

function qr(e) {
  return e && e.toString ? e.toString() : new String(e).toString();
}

Mn(Yr.prototype, function () {
  return this.entries();
}), kn(Yr.prototype, Dn(), "Map");

var Kr = Sn("ObservableMap", Yr),
    Zr = {},
    Qr = function () {
  function e(e, t, n) {
    if (void 0 === t && (t = Yn), void 0 === n && (n = "ObservableSet@" + hn()), this.name = n, this.$mobx = Zr, this._data = new Set(), this._atom = Bn(this.name), "function" != typeof Set) throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
    this.enhancer = function (e, i) {
      return t(e, i, n);
    }, e && this.replace(e);
  }

  return e.prototype.dehanceValue = function (e) {
    return void 0 !== this.dehancer ? this.dehancer(e) : e;
  }, e.prototype.clear = function () {
    var e = this;
    Tr(function () {
      vi(function () {
        e._data.forEach(function (t) {
          e.delete(t);
        });
      });
    });
  }, e.prototype.forEach = function (e, t) {
    var n = this;

    this._data.forEach(function (i) {
      e.call(t, i, i, n);
    });
  }, Object.defineProperty(e.prototype, "size", {
    get: function get() {
      return this._atom.reportObserved(), this._data.size;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.add = function (e) {
    var t = this;
    if ((mi(this._atom), Sr(this)) && !(r = Er(this, {
      type: "add",
      object: this,
      newValue: e
    }))) return this;

    if (!this.has(e)) {
      Tr(function () {
        t._data.add(t.enhancer(e, void 0)), t._atom.reportChanged();
      });
      var n = Ji(),
          i = Or(this),
          r = i || n ? {
        type: "add",
        object: this,
        newValue: e
      } : null;
      n && "production" !== process.env.NODE_ENV && er(r), i && Ir(this, r), n && "production" !== process.env.NODE_ENV && nr();
    }

    return this;
  }, e.prototype.delete = function (e) {
    var t = this;
    if (Sr(this) && !(r = Er(this, {
      type: "delete",
      object: this,
      oldValue: e
    }))) return !1;

    if (this.has(e)) {
      var n = Ji(),
          i = Or(this),
          r = i || n ? {
        type: "delete",
        object: this,
        oldValue: e
      } : null;
      return n && "production" !== process.env.NODE_ENV && er(_an({}, r, {
        name: this.name
      })), Tr(function () {
        t._atom.reportChanged(), t._data.delete(e);
      }), i && Ir(this, r), n && "production" !== process.env.NODE_ENV && nr(), !0;
    }

    return !1;
  }, e.prototype.has = function (e) {
    return this._atom.reportObserved(), this._data.has(this.dehanceValue(e));
  }, e.prototype.entries = function () {
    var e = 0,
        t = On(this.keys()),
        n = On(this.values());
    return Fn({
      next: function next() {
        var i = e;
        return e += 1, i < n.length ? {
          value: [t[i], n[i]],
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, e.prototype.keys = function () {
    return this.values();
  }, e.prototype.values = function () {
    this._atom.reportObserved();

    var e,
        t = this,
        n = 0;
    return void 0 !== this._data.values ? e = On(this._data.values()) : (e = [], this._data.forEach(function (t) {
      return e.push(t);
    })), Fn({
      next: function next() {
        return n < e.length ? {
          value: t.dehanceValue(e[n++]),
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, e.prototype.replace = function (e) {
    var t = this;
    return Jr(e) && (e = e.toJS()), Tr(function () {
      Array.isArray(e) || En(e) ? (t.clear(), e.forEach(function (e) {
        return t.add(e);
      })) : null != e && dn("Cannot initialize set from " + e);
    }), this;
  }, e.prototype.observe = function (e, t) {
    return "production" !== process.env.NODE_ENV && gn(!0 !== t, "`observe` doesn't support fireImmediately=true in combination with sets."), Rr(this, e);
  }, e.prototype.intercept = function (e) {
    return Cr(this, e);
  }, e.prototype.toJS = function () {
    return new Set(this);
  }, e.prototype.toString = function () {
    return this.name + "[ " + On(this.keys()).join(", ") + " ]";
  }, e;
}();

Mn(Qr.prototype, function () {
  return this.values();
}), kn(Qr.prototype, Dn(), "Set");

var Jr = Sn("ObservableSet", Qr),
    $r = function () {
  function e(e, t, n) {
    this.target = e, this.name = t, this.defaultEnhancer = n, this.values = {};
  }

  return e.prototype.read = function (e, t) {
    if ("production" !== process.env.NODE_ENV || this.target === e || (this.illegalAccess(e, t), this.values[t])) return this.values[t].get();
  }, e.prototype.write = function (e, t, n) {
    var i = this.target;
    "production" === process.env.NODE_ENV && i !== e && this.illegalAccess(e, t);
    var r = this.values[t];
    if (r instanceof Fi) r.set(n);else {
      if (Sr(this)) {
        if (!(s = Er(this, {
          type: "update",
          object: i,
          name: t,
          newValue: n
        }))) return;
        n = s.newValue;
      }

      if ((n = r.prepareNewValue(n)) !== Bi.UNCHANGED) {
        var o = Or(this),
            a = Ji(),
            s = o || a ? {
          type: "update",
          object: i,
          oldValue: r.value,
          name: t,
          newValue: n
        } : null;
        a && er(_an({}, s, {
          name: this.name,
          key: t
        })), r.setNewValue(n), o && Ir(this, s), a && nr();
      }
    }
  }, e.prototype.remove = function (e) {
    if (this.values[e]) {
      var t = this.target;
      if (Sr(this)) if (!(o = Er(this, {
        object: t,
        name: e,
        type: "remove"
      }))) return;

      try {
        Wi();
        var n = Or(this),
            i = Ji(),
            r = this.values[e].get();
        this.keys && this.keys.remove(e), delete this.values[e], delete this.target[e];
        var o = n || i ? {
          type: "remove",
          object: t,
          oldValue: r,
          name: e
        } : null;
        i && er(_an({}, o, {
          name: this.name,
          key: e
        })), n && Ir(this, o), i && nr();
      } finally {
        Hi();
      }
    }
  }, e.prototype.illegalAccess = function (e, t) {
    console.warn("Property '" + t + "' of '" + e + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
  }, e.prototype.observe = function (e, t) {
    return "production" !== process.env.NODE_ENV && gn(!0 !== t, "`observe` doesn't support the fire immediately property for observable objects."), Rr(this, e);
  }, e.prototype.intercept = function (e) {
    return Cr(this, e);
  }, e.prototype.getKeys = function () {
    var e = this;
    return void 0 === this.keys && (this.keys = new Nr(Object.keys(this.values).filter(function (t) {
      return e.values[t] instanceof Ai;
    }), qn, "keys(" + this.name + ")", !0)), this.keys.slice();
  }, e;
}();

function eo(e, t, n) {
  void 0 === t && (t = ""), void 0 === n && (n = Yn);
  var i = e.$mobx;
  return i || ("production" !== process.env.NODE_ENV && gn(Object.isExtensible(e), "Cannot make the designated object observable; it is not extensible"), wn(e) || (t = (e.constructor.name || "ObservableObject") + "@" + hn()), t || (t = "ObservableObject@" + hn()), kn(e, "$mobx", i = new $r(e, t, n)), i);
}

var to = Object.create(null),
    no = Object.create(null);

function io(e) {
  var t = e.$mobx;
  return t || (Gn(e), e.$mobx);
}

var ro = Sn("ObservableObjectAdministration", $r);

function oo(e) {
  return !!bn(e) && (Gn(e), ro(e.$mobx));
}

function ao(e, t) {
  if ("object" == typeof e && null !== e) {
    if (Vr(e)) return void 0 !== t && dn("production" !== process.env.NODE_ENV && "It is not possible to get index atoms from arrays"), e.$mobx.atom;
    if (Jr(e)) return e.$mobx;

    if (Kr(e)) {
      var n = e;
      return void 0 === t ? ao(n._keys) : ((i = n._data.get(t) || n._hasMap.get(t)) || dn("production" !== process.env.NODE_ENV && "the entry '" + t + "' does not exist in the observable map '" + so(e) + "'"), i);
    }

    var i;
    if (Gn(e), t && !e.$mobx && e[t], oo(e)) return t ? ((i = e.$mobx.values[t]) || dn("production" !== process.env.NODE_ENV && "no observable property '" + t + "' found on the observable object '" + so(e) + "'"), i) : dn("production" !== process.env.NODE_ENV && "please specify a property");
    if (Ln(e) || Di(e) || Zi(e)) return e;
  } else if ("function" == typeof e && Zi(e.$mobx)) return e.$mobx;

  return dn("production" !== process.env.NODE_ENV && "Cannot obtain atom from " + e);
}

function so(e, t) {
  return (void 0 !== t ? ao(e, t) : oo(e) || Kr(e) || Jr(e) ? function e(t, n) {
    return t || dn("Expecting some object"), void 0 !== n ? e(ao(t, n)) : Ln(t) || Di(t) || Zi(t) || Kr(t) || Jr(t) ? t : (Gn(t), t.$mobx ? t.$mobx : void dn("production" !== process.env.NODE_ENV && "Cannot obtain administration from " + t));
  }(e) : ao(e)).name;
}

var lo = Object.prototype.toString;

function uo(e, t, n) {
  return void 0 === n && (n = -1), function e(t, n, i, r, o) {
    if (t === n) return 0 !== t || 1 / t == 1 / n;
    if (null == t || null == n) return !1;
    if (t != t) return n != n;
    var a = typeof t;
    if ("function" !== a && "object" !== a && "object" != typeof n) return !1;
    t = co(t), n = co(n);
    var s = lo.call(t);
    if (s !== lo.call(n)) return !1;

    switch (s) {
      case "[object RegExp]":
      case "[object String]":
        return "" + t == "" + n;

      case "[object Number]":
        return +t != +t ? +n != +n : 0 == +t ? 1 / +t == 1 / n : +t == +n;

      case "[object Date]":
      case "[object Boolean]":
        return +t == +n;

      case "[object Symbol]":
        return "undefined" != typeof Symbol && Symbol.valueOf.call(t) === Symbol.valueOf.call(n);
    }

    var l = "[object Array]" === s;

    if (!l) {
      if ("object" != typeof t || "object" != typeof n) return !1;
      var u = t.constructor,
          c = n.constructor;
      if (u !== c && !("function" == typeof u && u instanceof u && "function" == typeof c && c instanceof c) && "constructor" in t && "constructor" in n) return !1;
    }

    if (0 === i) return !1;
    i < 0 && (i = -1);
    o = o || [];
    var p = (r = r || []).length;

    for (; p--;) {
      if (r[p] === t) return o[p] === n;
    }

    if (r.push(t), o.push(n), l) {
      if ((p = t.length) !== n.length) return !1;

      for (; p--;) {
        if (!e(t[p], n[p], i - 1, r, o)) return !1;
      }
    } else {
      var f = Object.keys(t),
          h = void 0;
      if (p = f.length, Object.keys(n).length !== p) return !1;

      for (; p--;) {
        if (h = f[p], !po(n, h) || !e(t[h], n[h], i - 1, r, o)) return !1;
      }
    }

    return r.pop(), o.pop(), !0;
  }(e, t, n);
}

function co(e) {
  return Vr(e) ? e.peek() : Cn(e) || Kr(e) || En(e) || Jr(e) ? On(e.entries()) : e;
}

function po(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}

try {
  process.env.NODE_ENV;
} catch (e) {
  var fo = fn();
  "undefined" == typeof process && (fo.process = {}), fo.process.env = {};
}

!function () {
  if ("testCodeMinification" !== function () {}.name && "production" !== process.env.NODE_ENV && "true" !== process.env.IGNORE_MOBX_MINIFY_WARNING) {
    var e = ["process", "env", "NODE_ENV"].join(".");
    console.warn("[mobx] you are running a minified build, but '" + e + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
  }
}();

if ("object" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: ir,
  extras: {
    getDebugName: so
  },
  $mobx: "$mobx"
}), "production" !== process.env.NODE_ENV && "undefined" != typeof module && void 0 !== module.exports) {
  var ho = !1;
  Object.defineProperty(module.exports, "default", {
    enumerable: !1,
    get: function get() {
      ho || (ho = !0, console.warn('The MobX package does not have a default export. Use \'import { thing } from "mobx"\' (recommended) or \'import * as mobx from "mobx"\' instead."'));
    }
  }), ["extras", "Atom", "BaseAtom", "asFlat", "asMap", "asReference", "asStructure", "autorunAsync", "createTranformer", "expr", "isModifierDescriptor", "isStrictModeEnabled", "map", "useStrict", "whyRun"].forEach(function (e) {
    Object.defineProperty(module.exports, e, {
      enumerable: !1,
      get: function get() {
        dn("'" + e + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
      },
      set: function set() {}
    });
  });
}

var go = function () {
  function e(e, t) {
    this.from = e, this.to = t;
  }

  return e.prototype.contains = function (e) {
    return this.from <= e && e <= this.to;
  }, e.prototype.clamp = function (e) {
    return Math.min(Math.max(this.from, e), this.to);
  }, e;
}(),
    mo = new go(-1, 1),
    yo = function () {
  function e(e) {
    this.engineMediator = e, this.state = nn;
  }

  return e.prototype.editAdjustments = function (e) {
    var t = e.type,
        n = e.value,
        i = mo.clamp(n);
    this.state[t] = i;
  }, e.prototype.reset = function () {
    var e = this;
    lr(function () {
      -1 === e.indexInContainer && (Object.keys(nn).forEach(function (t) {
        e.state[t] = nn[t];
      }), e.orderHelper.removeIndex(P.ADJUSTMENT));
    });
  }, Object.defineProperty(e.prototype, "indexInContainer", {
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "orderHelper", {
    get: function get() {
      return this.engineMediator.orderHelper;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setAdjustmentEffect = function (e) {
    var t = this.orderHelper.addIndex(P.ADJUSTMENT);
    return this.effect ? this.effect.setProperties(e) : this.effect = this.engineMediator.engine.addAdjustments(e, this.engineMediator.image.container, t), this.effect.getProperties();
  }, e.prototype.removeAdjustmentEffect = function () {
    this.effect && (this.engineMediator.engine.removeEffect(this.effect), -1 === this.indexInContainer && (this.effect = void 0));
  }, w([ai], e.prototype, "state", void 0), w([sr], e.prototype, "editAdjustments", null), w([sr], e.prototype, "reset", null), e;
}(),
    _o = function () {
  function e(t, n) {
    var i = this;
    this.assets = [], this.withoutItems = function (e) {
      e.items;
      return b(e, ["items"]);
    }, this.entityMapper = function (t, n) {
      return e.isCategory(t) ? i.categoryMapper(t, n) : i.itemMapper(t, n);
    }, this.categoryMapper = function (e, t) {
      return e ? _v2(_v2({}, e), {
        thumbnailURI: i.getCategoryURI(e),
        type: z.LARGE,
        delay: .08 * t,
        name: i.config.locale[e.identifier] || e.name,
        items: e.items.map(i.itemMapper)
      }) : null;
    }, this.itemMapper = function (e, t) {
      return e ? _v2(_v2({}, e), {
        thumbnailURI: i.getItemURI(e),
        type: z.MEDIUM,
        delay: .08 * t,
        name: i.config.locale[e.identifier] || e.name
      }) : null;
    }, this.getCategoryURI = function (e) {
      return de(e) && i.config.categoryDynamicKey ? e[i.config.categoryDynamicKey] : e.thumbnailURI && Qe(e.thumbnailURI) ? e.thumbnailURI : i.config.getAssetPath(e[i.config.categoryKey] || "");
    }, this.getItemURI = function (e) {
      return he(e) && i.config.itemDynamicKey ? e[i.config.itemDynamicKey] : e.thumbnailURI && Qe(e.thumbnailURI) ? e.thumbnailURI : i.config.getAssetPath(e[i.config.itemKey] || "");
    }, this.config = n, this.assets = t.map(this.entityMapper).filter(Boolean);
  }

  return e.isCategory = function (e) {
    return Object.prototype.hasOwnProperty.call(e, "items");
  }, Object.defineProperty(e.prototype, "categories", {
    get: function get() {
      return this.assets.reduce(function (t, n) {
        if (e.isCategory(n)) return C(t, [n]);
      }, []).filter(Boolean);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getCategories = function (e) {
    this.assets.findIndex(function (t) {
      return t.identifier === e;
    });
    return this.categories;
  }, Object.defineProperty(e.prototype, "items", {
    get: function get() {
      return this.assets.reduce(function (t, n) {
        return e.isCategory(n) ? C(t, n.items) : C(t, [n]);
      }, []).filter(Boolean);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.itemsOfCategory = function (e) {
    var t = this.assets.findIndex(function (t) {
      return t.identifier === e;
    });
    return -1 !== t ? this.categories[t].items : [];
  }, e.prototype.getEntities = function (e) {
    if (this.config.flattenCategories) return this.items;

    if (e) {
      var t = this.assets.findIndex(function (t) {
        return t.identifier === e;
      });

      if (-1 !== t) {
        var n = this.categories[t].items;
        return C(this.categories.slice(0, t + 1), n, this.categories.slice(t + 1)).map(this.withoutItems);
      }
    }

    return this.categories.map(this.withoutItems);
  }, e;
}(),
    vo = function () {
  function e(e) {
    var t = this;
    this.dirty = ai.box(!1), this.reset = function () {
      t.pureReset(), t.addSnapshot("delete", t.locale.controls.buttonReset), t.editor.render();
    }, this.editor = e, this.adjustmentsStore = new yo(this.editor.engineMediator), this.selectedOption = "";
    var n = this.editor.assetProvider.getAssets("adjustment");
    this.entityManager = new _o(n, _v2(_v2({}, this.config), {
      flattenCategories: !1,
      categoryKey: "",
      itemKey: "thumbnailURI",
      locale: _v2(_v2({}, this.locale.items), this.locale.categories),
      getAssetPath: this.editor.getAssetPath("adjustment")
    }));
  }

  return e.prototype.editAdjustments = function (e) {
    var t = e.type,
        n = e.value;
    this.pureSetAdjustment({
      type: t,
      value: n
    }), this.editor.render();
  }, e.prototype.toolSnapshot = function () {
    this.dirty.set(!0), this.addSnapshot("edit", P.ADJUSTMENT);
  }, e.prototype.addSnapshot = function (e, t) {
    this.editor.addSnapshot(void 0, e, t);
  }, e.prototype.toggleOptionSelection = function (e) {
    this.selectedOption = e;
  }, e.prototype.pureSetAdjustment = function (e) {
    var t,
        n = e.type,
        i = e.value,
        r = this.adjustmentsStore.setAdjustmentEffect(((t = {})[n] = i, t));
    this.adjustmentsStore.editAdjustments({
      type: n,
      value: r[n]
    });
  }, e.prototype.pureReset = function () {
    this.dirty.set(!1), this.adjustmentsStore.removeAdjustmentEffect(), this.adjustmentsStore.reset(), this.selectedOption = "";
  }, e.prototype.updateStateFromHistory = function (e) {
    var t = this;
    lr(function () {
      Object.keys(e).forEach(function (n) {
        t.pureSetAdjustment({
          type: n,
          value: e[n]
        });
      });
    });
  }, e.prototype.updateStateFromSerialization = function (e) {
    this.updateStateFromHistory(e);
  }, Object.defineProperty(e.prototype, "selectedAdjustmentType", {
    get: function get() {
      return this.selectedOption;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isDirty", {
    get: function get() {
      return this.dirty.get();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "state", {
    get: function get() {
      return this.adjustmentsStore.state;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "selectedOptionLabel", {
    get: function get() {
      var e = this,
          t = this.items.find(function (t) {
        return !!t && t.identifier === e.selectedOption;
      });
      return t ? t.name : "";
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "brightness", {
    get: function get() {
      return this.state.brightness;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "saturation", {
    get: function get() {
      return this.state.saturation;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "contrast", {
    get: function get() {
      return this.state.contrast;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "gamma", {
    get: function get() {
      return this.state.gamma;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "clarity", {
    get: function get() {
      return this.state.clarity;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "exposure", {
    get: function get() {
      return this.state.exposure;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "shadows", {
    get: function get() {
      return this.state.shadows;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "highlights", {
    get: function get() {
      return this.state.highlights;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "whites", {
    get: function get() {
      return this.state.whites;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "blacks", {
    get: function get() {
      return this.state.blacks;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "temperature", {
    get: function get() {
      return this.state.temperature;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "sharpness", {
    get: function get() {
      return this.state.sharpness;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "categories", {
    get: function get() {
      return this.entityManager.categories;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "items", {
    get: function get() {
      return this.entityManager.categories.reduce(function (e, t) {
        return C(e, _o.isCategory(t) ? t.items : [t]);
      }, []);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.ADJUSTMENT];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.ADJUSTMENT];
    },
    enumerable: !0,
    configurable: !0
  }), w([ai], e.prototype, "selectedOption", void 0), w([ai], e.prototype, "dirty", void 0), w([sr], e.prototype, "editAdjustments", null), w([sr], e.prototype, "toggleOptionSelection", null), w([sr], e.prototype, "pureSetAdjustment", null), w([sr], e.prototype, "pureReset", null), w([sr], e.prototype, "reset", void 0), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "updateStateFromSerialization", null), w([fi], e.prototype, "selectedAdjustmentType", null), w([fi], e.prototype, "isDirty", null), w([fi], e.prototype, "state", null), w([fi], e.prototype, "selectedOptionLabel", null), w([fi], e.prototype, "brightness", null), w([fi], e.prototype, "saturation", null), w([fi], e.prototype, "contrast", null), w([fi], e.prototype, "gamma", null), w([fi], e.prototype, "clarity", null), w([fi], e.prototype, "exposure", null), w([fi], e.prototype, "shadows", null), w([fi], e.prototype, "highlights", null), w([fi], e.prototype, "whites", null), w([fi], e.prototype, "blacks", null), w([fi], e.prototype, "temperature", null), w([fi], e.prototype, "sharpness", null), w([fi], e.prototype, "categories", null), w([fi], e.prototype, "items", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), e;
}(),
    bo = {
  identifier: "identity",
  intensity: 1,
  isDuotone: !1
},
    wo = new go(0, 1),
    xo = function () {
  function e(e) {
    var t = this;
    this.setEffectProperties = function (e) {
      var n = e.intensity;
      return t.effect ? (t.state.isDuotone ? t.effect.setProperties({
        colorIntensity: n
      }) : t.effect.setProperties({
        intensity: n
      }), t.effect.getProperties()) : null;
    }, this.engineMediator = e, this.state = bo;
  }

  return e.prototype.changeIdentifier = function (e) {
    this.state.identifier = e;
  }, e.prototype.changeIfDuotone = function (e) {
    this.state.isDuotone = e;
  }, e.prototype.changeIntensity = function (e) {
    var t = wo.clamp(e);
    this.state.intensity = t;
  }, e.prototype.reset = function () {
    -1 === this.indexInContainer && (this.state.identifier = bo.identifier, this.state.intensity = bo.intensity, this.removeIndex());
  }, Object.defineProperty(e.prototype, "indexInContainer", {
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setFilterEffect = function (e) {
    var t = this,
        n = e.identifier,
        i = e.intensity,
        r = e.isDuotone,
        o = this.state;
    this.changeIdentifier(n), this.changeIntensity(i), this.changeIfDuotone(r), this.removeFilterEffect();
    var a = this.engineMediator.orderHelper.addIndex(P.FILTER);
    return new Promise(r ? function (e, r) {
      t.engineMediator.engine.addDuoToneFilterFromAssets(n, t.engineMediator.image.container, a).then(function (n) {
        t.effect = n, t.effect.setProperties({
          colorIntensity: i
        }), e();
      }).catch(function (e) {
        t.fallbackOnError(o), r(e);
      });
    } : function (e, r) {
      t.engineMediator.engine.addLUTFilterFromAssets(n, t.engineMediator.image.container, a).then(function (n) {
        t.effect = n, t.effect.setProperties({
          intensity: i
        }), e();
      }).catch(function (e) {
        t.fallbackOnError(o), r(e);
      });
    });
  }, e.prototype.removeFilterEffect = function () {
    this.effect && (this.engineMediator.engine.removeEffect(this.effect), -1 === this.indexInContainer && (this.effect = void 0));
  }, e.prototype.removeIndex = function () {
    this.engineMediator.orderHelper.removeIndex(P.FILTER);
  }, e.prototype.fallbackOnError = function (e) {
    this.changeIdentifier(e.identifier), this.changeIntensity(e.intensity), "identity" === e.identifier && this.removeIndex();
  }, w([ai], e.prototype, "state", void 0), w([sr], e.prototype, "changeIdentifier", null), w([sr], e.prototype, "changeIfDuotone", null), w([sr], e.prototype, "changeIntensity", null), w([sr], e.prototype, "reset", null), e;
}(),
    ko = function () {
  function e(e) {
    var t = this;
    this.changeIntensity = function (e) {
      var n = t.isOptionDuoTone(t.identifier),
          i = t.filterStore.setEffectProperties({
        intensity: e
      });

      if (i) {
        var r = n ? i.colorIntensity : i.intensity;
        t.filterStore.changeIntensity(r), t.editor.render();
      }
    }, this.reset = function () {
      t.pureReset(), t.addSnapshot("delete", t.locale.controls.buttonReset), t.editor.render();
    }, this.editor = e, this.selectedCategory = "identity", this.filterStore = new xo(this.editor.engineMediator);
    var n = this.config,
        i = this.editor.configStore.assetProvider.getAssets("filter");
    this.entityManager = new _o(i, _v2(_v2({}, n), {
      categoryKey: "thumbnailURI",
      itemKey: "thumbnailURI",
      locale: this.locale.items,
      getAssetPath: this.editor.getAssetPath("filter")
    }));
  }

  return e.prototype.selectFilter = function (e, t) {
    return void 0 === t && (t = 1), x(this, void 0, void 0, function () {
      return k(this, function (n) {
        switch (n.label) {
          case 0:
            return e === this.identifier ? [3, 2] : [4, this.filterStore.setFilterEffect({
              identifier: e,
              intensity: t,
              isDuotone: this.isOptionDuoTone(e)
            })];

          case 1:
            n.sent(), this.editor.render(), this.addSnapshot("add", P.FILTER), n.label = 2;

          case 2:
            return [2];
        }
      });
    });
  }, e.prototype.setImageAndGetPreviews = function () {
    return x(this, void 0, void 0, function () {
      var e;
      return k(this, function (t) {
        switch (t.label) {
          case 0:
            return this.config.enablePreviewThumbnails ? (e = this.editor.activeStore.state.image, [4, this.editor.previewThumbnails.addImageToContainer(e)]) : [3, 3];

          case 1:
            return t.sent(), [4, this.getAllFilterPreview()];

          case 2:
            t.sent(), t.label = 3;

          case 3:
            return [2];
        }
      });
    });
  }, e.prototype.getAllFilterPreview = function () {
    return x(this, void 0, void 0, function () {
      var e,
          t,
          n,
          i,
          r,
          o = this;
      return k(this, function (a) {
        switch (a.label) {
          case 0:
            return e = this.entityManager.items.map(function (e) {
              return {
                identifier: e.identifier,
                isDuotone: o.isOptionDuoTone(e.identifier)
              };
            }), [4, this.editor.previewThumbnails.getAllFilterPreviewThumbnails(e)];

          case 1:
            return t = a.sent(), [4, this.editor.wait()];

          case 2:
            return a.sent(), n = this.config, i = this.editor.configStore.assetProvider.getAssets("filter").map(function (e) {
              return _v2(_v2({}, e), {
                items: e.items.map(function (e) {
                  return _v2(_v2({}, e), {
                    thumbnail: t[e.identifier]
                  });
                })
              });
            }), this.entityManager = new _o(i, _v2(_v2({}, n), {
              categoryKey: "thumbnailURI",
              itemDynamicKey: "thumbnail",
              itemKey: "thumbnailURI",
              locale: this.locale.items,
              getAssetPath: this.editor.getAssetPath("filter")
            })), r = this.editor.activeStore.tool, this.editor.activeStore.selectTool(P.LIBRARY), this.editor.activeStore.selectTool(r), [2];
        }
      });
    });
  }, e.prototype.toolSnapshot = function () {
    this.addSnapshot("edit", this.locale.controls.sliderIntensity);
  }, e.prototype.addSnapshot = function (e, t) {
    this.editor.addSnapshot(void 0, e, t);
  }, e.prototype.pureReset = function () {
    this.selectedCategory = "identity", this.filterStore.removeFilterEffect(), this.filterStore.reset();
  }, e.prototype.toggleCategorySelection = function (e) {
    this.selectedCategory = this.selectedCategory === e ? "identity" : e;
  }, e.prototype.updateStateFromSerialization = function (e) {
    var t = e.identifier,
        n = e.intensity,
        i = this.doesFilterAssetExist(t);

    if (i) {
      var r = ee(i);
      return this.filterStore.setFilterEffect({
        identifier: t,
        intensity: n,
        isDuotone: r
      });
    }

    return new Promise(function (e, n) {
      n(new Error("Filter Asset " + t + " doesn't exist"));
    });
  }, e.prototype.updateStateFromHistory = function (e) {
    return x(this, void 0, void 0, function () {
      return k(this, function (t) {
        return "identity" === e.identifier ? (this.pureReset(), [2, new Promise(function (e) {
          e();
        })]) : [2, this.filterStore.setFilterEffect(e)];
      });
    });
  }, Object.defineProperty(e.prototype, "state", {
    get: function get() {
      return this.filterStore.state;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.state.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "intensity", {
    get: function get() {
      return this.state.intensity;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isDuotone", {
    get: function get() {
      return this.state.isDuotone;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "selectedCategoryIdentifier", {
    get: function get() {
      return this.selectedCategory;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isOptionSelected", {
    get: function get() {
      return "identity" !== this.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.FILTER];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.FILTER];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "categories", {
    get: function get() {
      return this.entityManager.getCategories(this.selectedCategoryIdentifier);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "flattenCategories", {
    get: function get() {
      return this.config.flattenCategories;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "entities", {
    get: function get() {
      return this.entityManager.getEntities(this.selectedCategoryIdentifier);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.doesFilterAssetExist = function (e) {
    return this.entityManager.items.find(function (t) {
      return e === t.identifier;
    });
  }, e.prototype.isOptionDuoTone = function (e) {
    var t = this.doesFilterAssetExist(e);
    return !!t && ee(t);
  }, w([ai], e.prototype, "selectedCategory", void 0), w([sr], e.prototype, "selectFilter", null), w([sr], e.prototype, "changeIntensity", void 0), w([sr], e.prototype, "pureReset", null), w([sr], e.prototype, "reset", void 0), w([sr], e.prototype, "toggleCategorySelection", null), w([sr], e.prototype, "updateStateFromSerialization", null), w([sr], e.prototype, "updateStateFromHistory", null), w([fi], e.prototype, "state", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "intensity", null), w([fi], e.prototype, "isDuotone", null), w([fi], e.prototype, "selectedCategoryIdentifier", null), w([fi], e.prototype, "isOptionSelected", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "categories", null), w([fi], e.prototype, "flattenCategories", null), w([fi], e.prototype, "entities", null), e;
}(),
    To = {
  blurRadius: 40,
  gradientSize: .2
},
    So = {
  identifier: "identity",
  linear: _v2({
    start: {
      x: 0,
      y: 0
    },
    end: {
      x: 0,
      y: 0
    }
  }, To),
  radial: _v2({
    center: {
      x: 0,
      y: 0
    },
    radius: 0
  }, To),
  mirrored: _v2({
    origin: {
      x: 0,
      y: 0
    },
    rotation: 0,
    size: 0
  }, To),
  gaussian: To
},
    Co = function () {
  function e(e) {
    this.editor = e, this.engineMediator = this.editor.engineMediator, this.state = So;
  }

  return e.prototype.selectFocus = function (e, t) {
    var n = this;
    lr(function () {
      n.state.identifier = e, t && (n.state[e].blurRadius = t);
    });
  }, e.prototype.changeBlurRadius = function (e, t) {
    "identity" !== e && (this.state[e].blurRadius = t);
  }, e.prototype.reset = function () {
    -1 === this.indexInContainer && (this.state.identifier = So.identifier, "identity" !== this.state.identifier && (this.state[this.state.identifier].blurRadius = So[this.state.identifier].blurRadius));
  }, e.prototype.setLinear = function (e) {
    var t = e.start,
        n = e.end;
    this.state.linear.start.x = t.x, this.state.linear.start.y = t.y, this.state.linear.end.x = n.x, this.state.linear.end.y = n.y;
  }, e.prototype.setLinearStart = function (e) {
    this.state.linear.start.x = e.x, this.state.linear.start.y = e.y;
  }, e.prototype.setLinearEnd = function (e) {
    this.state.linear.end.x = e.x, this.state.linear.end.y = e.y;
  }, e.prototype.setRadialCenter = function (e) {
    this.state.radial.center.x = e.x, this.state.radial.center.y = e.y;
  }, e.prototype.setRadialRadius = function (e) {
    this.state.radial.radius = e;
  }, e.prototype.setMirroredOrigin = function (e) {
    this.state.mirrored.origin.x = e.x, this.state.mirrored.origin.y = e.y;
  }, e.prototype.setMirroredRotation = function (e) {
    this.state.mirrored.rotation = e;
  }, e.prototype.setMirroredSize = function (e) {
    this.state.mirrored.size = e;
  }, Object.defineProperty(e.prototype, "indexInContainer", {
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "order", {
    get: function get() {
      return this.engineMediator.orderHelper.addIndex(P.FOCUS);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getEffectProperties = function () {
    return this.effect ? this.effect.getProperties() : null;
  }, e.prototype.setLinearFocus = function (e) {
    this.effect = this.engineMediator.engine.addLinearBlur(e, this.imageContainer, this.order), this.updateLinearState(this.effect.getProperties());
  }, e.prototype.setGaussianFocus = function (e) {
    this.effect = this.engineMediator.engine.addGaussianBlur(e, this.imageContainer, this.order), this.updateGaussianState(this.effect.getProperties());
  }, e.prototype.setRadialFocus = function (e) {
    this.effect = this.engineMediator.engine.addRadialBlur(e, this.imageContainer, this.order), this.updateRadialState(this.effect.getProperties());
  }, e.prototype.setMirroredFocus = function (e) {
    this.effect = this.engineMediator.engine.addMirroredBlur(e, this.imageContainer, this.order), this.updateMirroredState(this.effect.getProperties());
  }, e.prototype.updateFromEngineState = function (e) {
    var t = this.getEffectProperties();
    if (t && "identity" !== e) switch (e) {
      case ne.LINEAR:
        this.updateLinearState(t);
        break;

      case ne.RADIAL:
        this.updateRadialState(t);
        break;

      case ne.MIRRORED:
        this.updateMirroredState(t);
    }
  }, e.prototype.updateGaussianState = function (e) {
    this.changeBlurRadius(ne.GAUSSIAN, e.blurRadius);
  }, e.prototype.updateMirroredState = function (e) {
    var t = this.editor.worldToPreview(e.mirrorAxisOrigin),
        n = new R(this.editor.worldToPreview(e.mirrorAxisDirection)).subtract(t),
        i = Math.atan2(n.y, n.x);
    this.setMirroredOrigin(this.editor.worldToPreview(e.mirrorAxisOrigin)), this.setMirroredRotation(i), this.setMirroredSize(this.editor.worldToPreview(e.clearAreaWidth)), this.changeBlurRadius(ne.MIRRORED, e.blurRadius);
  }, e.prototype.updateRadialState = function (e) {
    this.setRadialCenter(this.editor.worldToPreview(e.center)), this.setRadialRadius(this.editor.worldToPreview(e.radius)), this.changeBlurRadius(ne.RADIAL, e.blurRadius);
  }, e.prototype.updateLinearState = function (e) {
    this.setLinearStart(this.editor.worldToPreview(e.start)), this.setLinearEnd(this.editor.worldToPreview(e.end)), this.changeBlurRadius(ne.LINEAR, e.blurRadius);
  }, e.prototype.setEffectProperties = function (e) {
    return this.effect ? (this.effect.setProperties(e), this.effect.getProperties()) : null;
  }, e.prototype.removeFocus = function () {
    this.effect && (this.engineMediator.engine.removeEffect(this.effect), this.engineMediator.orderHelper.removeIndex(P.FOCUS));
  }, Object.defineProperty(e.prototype, "imageContainer", {
    get: function get() {
      return this.engineMediator.image.container;
    },
    enumerable: !0,
    configurable: !0
  }), w([ai], e.prototype, "state", void 0), w([sr], e.prototype, "selectFocus", null), w([sr], e.prototype, "changeBlurRadius", null), w([sr], e.prototype, "reset", null), w([sr], e.prototype, "setLinear", null), w([sr], e.prototype, "setLinearStart", null), w([sr], e.prototype, "setLinearEnd", null), w([sr], e.prototype, "setRadialCenter", null), w([sr], e.prototype, "setRadialRadius", null), w([sr], e.prototype, "setMirroredOrigin", null), w([sr], e.prototype, "setMirroredRotation", null), w([sr], e.prototype, "setMirroredSize", null), w([sr], e.prototype, "updateFromEngineState", null), e;
}(),
    Eo = function Eo(e, t, n) {
  void 0 === t && (t = 0), void 0 === n && (n = 3);
  var i = Math.tan(t),
      r = Math.sqrt(Math.pow(i, 2) + 1);
  return {
    x: e.x + n / r,
    y: e.y + n * i / r
  };
},
    Oo = function () {
  function e(e) {
    var t = this;
    this.changeIntensity = function (e) {
      var n = t.focusStore.setEffectProperties({
        blurRadius: e
      });
      n && (t.focusStore.changeBlurRadius(t.identifier, n.blurRadius), t.editor.render());
    }, this.reset = function () {
      t.pureReset(), t.editor.render(), t.addSnapshot("delete", t.locale.controls.buttonReset);
    }, this.editor = e, this.focusStore = new Co(this.editor);
    var n = this.editor.assetProvider.getAssets("focus");
    this.entityManager = new _o([{
      identifier: "",
      name: "",
      items: n
    }], _v2(_v2({}, this.config), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !0,
      locale: this.locale.items,
      getAssetPath: this.editor.getAssetPath("focus")
    }));
  }

  return Object.defineProperty(e, "minIntensity", {
    get: function get() {
      return 0;
    },
    enumerable: !0,
    configurable: !0
  }), e.doesFocusIdentifierExist = function (e) {
    return -1 !== Object.keys(ne).map(function (e) {
      return ne[e];
    }).findIndex(function (t) {
      return t === e;
    });
  }, e.prototype.selectFocus = function (e) {
    if (e !== this.identifier) {
      this.focusStore.removeFocus();
      var t = .2 * this.maxIntensity,
          n = this.editor.engine.getOutputContainer().getBounds().width,
          i = .2 * this.editor.shortestOutputSide;

      switch (e) {
        case ne.LINEAR:
          var r = this.editor.outputToWorld({
            x: -n / 2,
            y: 0
          }),
              o = this.editor.outputToWorld({
            x: n / 2,
            y: 0
          });
          this.setLinearFocus({
            start: r,
            end: o,
            blurRadius: t
          });
          break;

        case ne.RADIAL:
          var a = this.editor.outputToWorld({
            x: 0,
            y: 0
          });
          this.setRadialFocus({
            center: a,
            radius: i,
            blurRadius: t
          });
          break;

        case ne.MIRRORED:
          var s = this.editor.outputToWorld({
            x: 0,
            y: 0
          }),
              l = i,
              u = this.editor.outputToWorld(Eo({
            x: 0,
            y: 0
          }, 0));
          this.setMirroredFocus({
            mirrorAxisOrigin: s,
            clearAreaWidth: l,
            blurRadius: t,
            mirrorAxisDirection: u
          });
          break;

        case ne.GAUSSIAN:
          this.setGaussianFocus({
            blurRadius: t
          });
      }

      this.focusStore.selectFocus(e, t), this.editor.render(), this.addSnapshot("add", P.FOCUS);
    }
  }, e.prototype.toolSnapshot = function (e) {
    this.addSnapshot("edit", e);
  }, e.prototype.addSnapshot = function (e, t) {
    this.editor.addSnapshot(void 0, e, t);
  }, e.prototype.clickableCanvas = function (e) {
    this.editor.clickableCanvas(e);
  }, e.prototype.pureReset = function () {
    this.focusStore.removeFocus(), this.focusStore.reset();
  }, e.prototype.setStart = function (e) {
    var t = this.focusStore.setEffectProperties({
      start: this.editor.previewToWorld(e)
    });
    t && (this.focusStore.setLinearStart(this.editor.worldToPreview(t.start)), this.editor.render());
  }, e.prototype.setEnd = function (e) {
    var t = this.focusStore.setEffectProperties({
      end: this.editor.previewToWorld(e)
    });
    t && (this.focusStore.setLinearEnd(this.editor.worldToPreview(t.end)), this.editor.render());
  }, e.prototype.setCenter = function (e) {
    var t = this.focusStore.setEffectProperties({
      center: this.editor.previewToWorld(e)
    });
    t && (this.focusStore.setRadialCenter(this.editor.worldToPreview(t.center)), this.editor.render());
  }, e.prototype.setRadius = function (e) {
    var t = this.focusStore.setEffectProperties({
      radius: this.editor.previewToWorld(e)
    });
    t && (this.focusStore.setRadialRadius(this.editor.worldToPreview(t.radius)), this.editor.render());
  }, e.prototype.setOrigin = function (e) {
    var t = this.focusStore.setEffectProperties({
      mirrorAxisOrigin: this.editor.previewToWorld(e),
      mirrorAxisDirection: this.editor.previewToWorld(Eo(e, this.rotation))
    });
    t && (this.focusStore.setMirroredOrigin(this.editor.worldToPreview(t.mirrorAxisOrigin)), this.editor.render());
  }, e.prototype.setSize = function (e) {
    var t = this.focusStore.setEffectProperties({
      clearAreaWidth: this.editor.previewToWorld(e)
    });
    t && (this.focusStore.setMirroredSize(this.editor.worldToPreview(t.clearAreaWidth)), this.editor.render());
  }, e.prototype.setRotation = function (e) {
    this.focusStore.setEffectProperties({
      mirrorAxisDirection: this.editor.previewToWorld(Eo(this.origin, e))
    }), this.focusStore.setMirroredRotation(e), this.editor.render();
  }, e.prototype.updateStateFromHistory = function (e, t) {
    var n = this;
    this.focusStore.removeFocus();
    var i = t.magnitude;
    lr(function () {
      switch (e.identifier) {
        case ne.LINEAR:
          n.focusStore.selectFocus(ne.LINEAR), n.setLinearFocus({
            start: n.editor.previewToWorld(new R(e.linear.start).multiply(t)),
            end: n.editor.previewToWorld(new R(e.linear.end).multiply(t)),
            blurRadius: e.linear.blurRadius
          });
          break;

        case ne.GAUSSIAN:
          n.focusStore.selectFocus(ne.GAUSSIAN), n.setGaussianFocus({
            blurRadius: e.gaussian.blurRadius
          });
          break;

        case ne.RADIAL:
          n.focusStore.selectFocus(ne.RADIAL), n.setRadialFocus({
            center: n.editor.previewToWorld(new R(e.radial.center).multiply(t)),
            radius: n.editor.previewToWorld(e.radial.radius * i),
            blurRadius: e.radial.blurRadius
          });
          break;

        case ne.MIRRORED:
          n.focusStore.selectFocus(ne.MIRRORED), n.setMirroredFocus({
            mirrorAxisOrigin: n.editor.previewToWorld(new R(e.mirrored.origin).multiply(t)),
            clearAreaWidth: n.editor.previewToWorld(e.mirrored.size * i),
            blurRadius: e.mirrored.blurRadius,
            mirrorAxisDirection: n.editor.previewToWorld(Eo(e.mirrored.origin, e.mirrored.rotation))
          });
          break;

        case "identity":
          n.pureReset();
      }
    });
  }, e.prototype.updateStateFromSerialization = function (t) {
    return x(this, void 0, void 0, function () {
      var n = this;
      return k(this, function (i) {
        if (!e.doesFocusIdentifierExist(t.identifier)) throw new Error("Focus identifier " + t.identifier + " doesn't exist");
        return this.focusStore.removeFocus(), lr(function () {
          switch (n.focusStore.selectFocus(t.identifier), t.identifier) {
            case ne.LINEAR:
              n.setLinearFocus(t.linear);
              break;

            case ne.GAUSSIAN:
              n.setGaussianFocus(t.gaussian);
              break;

            case ne.RADIAL:
              n.setRadialFocus(t.radial);
              break;

            case ne.MIRRORED:
              n.setMirroredFocus({
                mirrorAxisOrigin: t.mirrored.origin,
                clearAreaWidth: t.mirrored.size,
                blurRadius: t.mirrored.blurRadius,
                mirrorAxisDirection: Eo(t.mirrored.origin, t.mirrored.rotation)
              });
          }
        }), [2];
      });
    });
  }, e.prototype.updateCanvasControls = function () {
    this.focusStore.updateFromEngineState(this.identifier);
  }, Object.defineProperty(e.prototype, "state", {
    get: function get() {
      return this.focusStore.state;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "serializableState", {
    get: function get() {
      switch (this.identifier) {
        case ne.LINEAR:
          return {
            identifier: this.identifier,
            linear: this.focusStore.getEffectProperties()
          };

        case ne.RADIAL:
          return {
            identifier: this.identifier,
            radial: this.focusStore.getEffectProperties()
          };

        case ne.MIRRORED:
          var e = this.focusStore.getEffectProperties();
          return {
            identifier: this.identifier,
            mirrored: {
              blurRadius: e.blurRadius,
              origin: e.mirrorAxisOrigin,
              rotation: xr(this.state.mirrored.rotation),
              size: e.clearAreaWidth
            }
          };

        case ne.GAUSSIAN:
          return {
            identifier: this.identifier,
            gaussian: this.focusStore.getEffectProperties()
          };
      }

      return So;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getFocusStateForHistory = function () {
    var e = this.editor.canvasStore.sizeVector,
        t = this.focusStore.state.linear,
        n = this.focusStore.state.radial,
        i = this.focusStore.state.mirrored,
        r = e,
        o = r.magnitude;
    return _v2(_v2({}, this.focusStore.state), {
      linear: _v2(_v2({}, t), {
        start: new R(t.start).divide(r),
        end: new R(t.end).divide(r)
      }),
      radial: _v2(_v2({}, n), {
        center: new R(n.center).divide(r),
        radius: n.radius / o
      }),
      mirrored: _v2(_v2({}, i), {
        origin: new R(i.origin).divide(r),
        size: i.size / o
      }),
      gaussian: _v2({}, this.focusStore.state.gaussian)
    });
  }, Object.defineProperty(e.prototype, "start", {
    get: function get() {
      return this.focusStore.state.linear.start;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "startOnPreview", {
    get: function get() {
      var e = this.editor.applyFlipToPreview(this.focusStore.state.linear.start);
      return {
        x: Math.abs(e.x),
        y: Math.abs(e.y)
      };
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "end", {
    get: function get() {
      return this.focusStore.state.linear.end;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "endOnPreview", {
    get: function get() {
      var e = this.editor.applyFlipToPreview(this.focusStore.state.linear.end);
      return {
        x: Math.abs(e.x),
        y: Math.abs(e.y)
      };
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "center", {
    get: function get() {
      return this.focusStore.state.radial.center;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "radius", {
    get: function get() {
      return this.focusStore.state.radial.radius;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "origin", {
    get: function get() {
      return this.focusStore.state.mirrored.origin;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotation", {
    get: function get() {
      return this.focusStore.state.mirrored.rotation;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotationOnPreview", {
    get: function get() {
      var e = this.editor.outputContainer.getData(),
          t = e.flipHorizontally,
          n = e.flipVertically;
      return Wt({
        rotation: this.focusStore.state.mirrored.rotation,
        flipHorizontally: t,
        flipVertically: n
      });
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "size", {
    get: function get() {
      return this.focusStore.state.mirrored.size;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "mirroredAreaWidth", {
    get: function get() {
      var e = this.editor.canvasStore.canvasSize,
          t = e.width,
          n = e.height;
      return 2 * Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2));
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.state.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "intensity", {
    get: function get() {
      return "identity" === this.identifier ? So.gaussian.blurRadius : this.state[this.identifier].blurRadius;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "maxIntensity", {
    get: function get() {
      return this.editor.shortestOutputSide / 10;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isOptionSelected", {
    get: function get() {
      return "identity" !== this.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.FOCUS];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.FOCUS];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "entities", {
    get: function get() {
      return this.entityManager.items;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setGaussianFocus = function (e) {
    var t = e.blurRadius;
    this.focusStore.setGaussianFocus({
      blurRadius: t
    });
  }, e.prototype.setLinearFocus = function (e) {
    var t = e.start,
        n = e.end,
        i = e.blurRadius;
    this.focusStore.setLinearFocus({
      start: t,
      end: n,
      blurRadius: i
    });
  }, e.prototype.setRadialFocus = function (e) {
    var t = e.center,
        n = e.radius,
        i = e.blurRadius;
    this.focusStore.setRadialFocus({
      center: t,
      radius: n,
      blurRadius: i
    });
  }, e.prototype.setMirroredFocus = function (e) {
    var t = e.mirrorAxisOrigin,
        n = e.clearAreaWidth,
        i = e.blurRadius,
        r = e.mirrorAxisDirection;
    this.focusStore.setMirroredFocus({
      mirrorAxisOrigin: t,
      clearAreaWidth: n,
      blurRadius: i,
      mirrorAxisDirection: r
    });
  }, w([sr], e.prototype, "selectFocus", null), w([sr], e.prototype, "changeIntensity", void 0), w([sr], e.prototype, "clickableCanvas", null), w([sr], e.prototype, "pureReset", null), w([sr], e.prototype, "reset", void 0), w([sr], e.prototype, "setStart", null), w([sr], e.prototype, "setEnd", null), w([sr], e.prototype, "setCenter", null), w([sr], e.prototype, "setRadius", null), w([sr], e.prototype, "setOrigin", null), w([sr], e.prototype, "setSize", null), w([sr], e.prototype, "setRotation", null), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "updateStateFromSerialization", null), w([sr], e.prototype, "updateCanvasControls", null), w([fi], e.prototype, "state", null), w([fi], e.prototype, "start", null), w([fi], e.prototype, "startOnPreview", null), w([fi], e.prototype, "end", null), w([fi], e.prototype, "endOnPreview", null), w([fi], e.prototype, "center", null), w([fi], e.prototype, "radius", null), w([fi], e.prototype, "origin", null), w([fi], e.prototype, "rotation", null), w([fi], e.prototype, "rotationOnPreview", null), w([fi], e.prototype, "size", null), w([fi], e.prototype, "mirroredAreaWidth", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "intensity", null), w([fi], e.prototype, "maxIntensity", null), w([fi], e.prototype, "isOptionSelected", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "entities", null), e;
}(),
    Ro = {
  identifier: "identity",
  opacity: 1,
  blendMode: re.LIGHTEN
},
    Io = new go(0, 1),
    Ao = function () {
  function e(e, t) {
    var n = this;
    this.correctOverlayFlip = function () {
      var e = n.editor.outputContainer.getData(),
          t = e.flipHorizontally,
          i = e.flipVertically;
      n.effect && (n.effect.setFlipHorizontally(t), n.effect.setFlipVertically(i));
    }, this.engineMediator = e, this.editor = t, this.state = Ro;
  }

  return e.prototype.changeIdentifier = function (e) {
    this.state.identifier = e;
  }, e.prototype.changeOpacity = function (e) {
    var t = Io.clamp(e);
    this.state.opacity = t;
  }, e.prototype.changeBlendMode = function (e) {
    this.state.blendMode = e;
  }, e.prototype.reset = function () {
    -1 === this.indexInContainer && (this.state.identifier = Ro.identifier, this.state.opacity = Ro.opacity, this.state.blendMode = Ro.blendMode, this.removeIndex());
  }, Object.defineProperty(e.prototype, "indexInContainer", {
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.removeOverlayEffect = function () {
    this.effect && (this.removeIndex(), this.engineMediator.engine.removeEffect(this.effect), this.effect = void 0);
  }, e.prototype.setEffectProperties = function (e) {
    return this.effect ? (this.effect.setProperties(e), this.effect.getProperties()) : null;
  }, e.prototype.setOverlayEffect = function (e) {
    var t = this,
        n = e.identifier,
        i = e.blendMode,
        r = e.opacity,
        o = _v2({}, this.state);

    this.changeIdentifier(n), this.changeOpacity(r), this.changeBlendMode(i), this.removeOverlayEffect();
    var a = this.engineMediator.orderHelper.addIndex(P.OVERLAY);
    return new Promise(function (e, s) {
      t.engineMediator.engine.addOverlayFromAssets(n, t.engineMediator.image.container, a).then(function (n) {
        t.effect = n, t.effect.setProperties({
          blendMode: i,
          opacity: r
        }), t.correctOverlayFlip(), e();
      }).catch(function (e) {
        t.changeIdentifier(o.identifier), t.changeOpacity(o.opacity), t.changeBlendMode(o.blendMode), "identity" === o.identifier && t.removeIndex(), s(e);
      });
    });
  }, e.prototype.removeIndex = function () {
    this.engineMediator.orderHelper.removeIndex(P.OVERLAY);
  }, w([ai], e.prototype, "state", void 0), w([sr], e.prototype, "changeIdentifier", null), w([sr], e.prototype, "changeOpacity", null), w([sr], e.prototype, "changeBlendMode", null), w([sr], e.prototype, "reset", null), w([sr], e.prototype, "correctOverlayFlip", void 0), e;
}(),
    Mo = function () {
  function e(e) {
    var t = this;
    this.changeOpacity = function (e) {
      var n = t.overlayStore.setEffectProperties({
        opacity: e
      });
      n && (t.overlayStore.changeOpacity(n.opacity), t.editor.render());
    }, this.reset = function () {
      t.pureReset(), t.addSnapshot("delete", t.locale.controls.buttonReset), t.editor.render();
    }, this.correctOverlayFlip = function () {
      t.overlayStore.correctOverlayFlip();
    }, this.editor = e, this.overlayStore = new Ao(this.editor.engineMediator, e);
    var n = this.editor.assetProvider.getAssets("overlay"),
        i = this.config;
    this.entityManager = new _o([{
      identifier: "",
      name: "",
      items: n
    }], _v2(_v2({}, i), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !0,
      locale: this.locale.items,
      getAssetPath: this.editor.getAssetPath("overlay")
    }));
  }

  return e.prototype.selectOverlay = function (e) {
    return x(this, void 0, void 0, function () {
      var t;
      return k(this, function (n) {
        switch (n.label) {
          case 0:
            return e === this.identifier ? [3, 2] : (t = this.defaultBlendModeForIdentifier(e), [4, this.overlayStore.setOverlayEffect({
              identifier: e,
              opacity: 1,
              blendMode: t
            })]);

          case 1:
            n.sent(), this.addSnapshot("add", P.OVERLAY), this.editor.render(), n.label = 2;

          case 2:
            return [2];
        }
      });
    });
  }, e.prototype.toolSnapshot = function () {
    this.addSnapshot("edit", this.locale.controls.sliderOpacity);
  }, e.prototype.addSnapshot = function (e, t) {
    this.editor.addSnapshot(void 0, e, t);
  }, e.prototype.changeBlendMode = function (e) {
    var t = this.overlayStore.setEffectProperties({
      blendMode: e
    });
    t && (this.overlayStore.changeBlendMode(t.blendMode), this.addSnapshot("edit", this.locale.controls.carouselBlendMode), this.editor.render());
  }, e.prototype.pureReset = function () {
    this.overlayStore.removeOverlayEffect(), this.overlayStore.reset();
  }, e.prototype.updateStateFromSerialization = function (e) {
    return x(this, void 0, void 0, function () {
      return k(this, function (t) {
        return this.entityManager.items.find(function (t) {
          return t.identifier === e.identifier;
        }) ? [2, this.overlayStore.setOverlayEffect(e)] : [2, new Promise(function (t, n) {
          n(new Error("Overlay Asset " + e.identifier + " doesn't exist"));
        })];
      });
    });
  }, e.prototype.updateStateFromHistory = function (e) {
    return x(this, void 0, void 0, function () {
      return k(this, function (t) {
        return "identity" === e.identifier ? (this.pureReset(), [2, new Promise(function (e) {
          e();
        })]) : [2, this.overlayStore.setOverlayEffect(e)];
      });
    });
  }, Object.defineProperty(e.prototype, "state", {
    get: function get() {
      return this.overlayStore.state;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.overlayStore.state.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "opacity", {
    get: function get() {
      return this.overlayStore.state.opacity;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "blendMode", {
    get: function get() {
      return this.overlayStore.state.blendMode;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isOptionSelected", {
    get: function get() {
      return "identity" !== this.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.OVERLAY];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.OVERLAY];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "entities", {
    get: function get() {
      return this.entityManager.getEntities();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "allBlendModes", {
    get: function get() {
      var e = this.locale.controls;
      return Object.keys(re).map(function (t) {
        var n = re[t],
            i = "blendMode" + n.charAt(0).toUpperCase() + n.slice(1);
        return {
          identifier: n,
          value: e[i]
        };
      });
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.defaultBlendModeForIdentifier = function (e) {
    var t = this.entityManager.items.findIndex(function (t) {
      return t.identifier === e;
    });
    return -1 !== t ? this.entityManager.items[t].defaultBlendMode : re.LIGHTEN;
  }, w([sr], e.prototype, "selectOverlay", null), w([sr], e.prototype, "changeOpacity", void 0), w([sr], e.prototype, "changeBlendMode", null), w([sr], e.prototype, "pureReset", null), w([sr], e.prototype, "reset", void 0), w([sr], e.prototype, "updateStateFromSerialization", null), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "correctOverlayFlip", void 0), w([fi], e.prototype, "state", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "opacity", null), w([fi], e.prototype, "blendMode", null), w([fi], e.prototype, "isOptionSelected", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "entities", null), w([fi], e.prototype, "allBlendModes", null), e;
}(),
    Fo = {
  identifier: "identity",
  opacity: 1,
  tintColor: Jt.white,
  tintMode: "none",
  resizeMode: "keepAspect"
},
    Do = {},
    Po = /^\s+|\s+$/g,
    zo = /^[-+]0x[0-9a-f]+$/i,
    Lo = /^0b[01]+$/i,
    Bo = /^0o[0-7]+$/i,
    No = parseInt,
    Uo = "object" == typeof d && d && d.Object === Object && d,
    jo = "object" == typeof self && self && self.Object === Object && self,
    Wo = Uo || jo || Function("return this")(),
    Ho = Object.prototype.toString,
    Go = Math.max,
    Vo = Math.min,
    Xo = function Xo() {
  return Wo.Date.now();
};

function Yo(e, t, n) {
  var i,
      r,
      o,
      a,
      s,
      l,
      u = 0,
      c = !1,
      p = !1,
      f = !0;
  if ("function" != typeof e) throw new TypeError("Expected a function");

  function h(t) {
    var n = i,
        o = r;
    return i = r = void 0, u = t, a = e.apply(o, n);
  }

  function d(e) {
    return u = e, s = setTimeout(m, t), c ? h(e) : a;
  }

  function g(e) {
    var n = e - l;
    return void 0 === l || n >= t || n < 0 || p && e - u >= o;
  }

  function m() {
    var e = Xo();
    if (g(e)) return y(e);
    s = setTimeout(m, function (e) {
      var n = t - (e - l);
      return p ? Vo(n, o - (e - u)) : n;
    }(e));
  }

  function y(e) {
    return s = void 0, f && i ? h(e) : (i = r = void 0, a);
  }

  function _() {
    var e = Xo(),
        n = g(e);

    if (i = arguments, r = this, l = e, n) {
      if (void 0 === s) return d(l);
      if (p) return s = setTimeout(m, t), h(l);
    }

    return void 0 === s && (s = setTimeout(m, t)), a;
  }

  return t = Ko(t) || 0, qo(n) && (c = !!n.leading, o = (p = "maxWait" in n) ? Go(Ko(n.maxWait) || 0, t) : o, f = "trailing" in n ? !!n.trailing : f), _.cancel = function () {
    void 0 !== s && clearTimeout(s), u = 0, i = l = r = s = void 0;
  }, _.flush = function () {
    return void 0 === s ? a : y(Xo());
  }, _;
}

function qo(e) {
  var t = typeof e;
  return !!e && ("object" == t || "function" == t);
}

function Ko(e) {
  if ("number" == typeof e) return e;
  if (function (e) {
    return "symbol" == typeof e || function (e) {
      return !!e && "object" == typeof e;
    }(e) && "[object Symbol]" == Ho.call(e);
  }(e)) return NaN;

  if (qo(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = qo(t) ? t + "" : t;
  }

  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(Po, "");
  var n = Lo.test(e);
  return n || Bo.test(e) ? No(e.slice(2), n ? 2 : 8) : zo.test(e) ? NaN : +e;
}

var Zo = function Zo(e, t, n) {
  var i = !0,
      r = !0;
  if ("function" != typeof e) throw new TypeError("Expected a function");
  return qo(n) && (i = "leading" in n ? !!n.leading : i, r = "trailing" in n ? !!n.trailing : r), Yo(e, t, {
    leading: i,
    maxWait: t,
    trailing: r
  });
},
    Qo = /^\s+|\s+$/g,
    Jo = /^[-+]0x[0-9a-f]+$/i,
    $o = /^0b[01]+$/i,
    ea = /^0o[0-7]+$/i,
    ta = parseInt,
    na = "object" == typeof d && d && d.Object === Object && d,
    ia = "object" == typeof self && self && self.Object === Object && self,
    ra = na || ia || Function("return this")(),
    oa = Object.prototype.toString,
    aa = Math.max,
    sa = Math.min,
    la = function la() {
  return ra.Date.now();
};

function ua(e) {
  var t = typeof e;
  return !!e && ("object" == t || "function" == t);
}

function ca(e) {
  if ("number" == typeof e) return e;
  if (function (e) {
    return "symbol" == typeof e || function (e) {
      return !!e && "object" == typeof e;
    }(e) && "[object Symbol]" == oa.call(e);
  }(e)) return NaN;

  if (ua(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = ua(t) ? t + "" : t;
  }

  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(Qo, "");
  var n = $o.test(e);
  return n || ea.test(e) ? ta(e.slice(2), n ? 2 : 8) : Jo.test(e) ? NaN : +e;
}

var pa = function pa(e, t, n) {
  var i,
      r,
      o,
      a,
      s,
      l,
      u = 0,
      c = !1,
      p = !1,
      f = !0;
  if ("function" != typeof e) throw new TypeError("Expected a function");

  function h(t) {
    var n = i,
        o = r;
    return i = r = void 0, u = t, a = e.apply(o, n);
  }

  function d(e) {
    return u = e, s = setTimeout(m, t), c ? h(e) : a;
  }

  function g(e) {
    var n = e - l;
    return void 0 === l || n >= t || n < 0 || p && e - u >= o;
  }

  function m() {
    var e = la();
    if (g(e)) return y(e);
    s = setTimeout(m, function (e) {
      var n = t - (e - l);
      return p ? sa(n, o - (e - u)) : n;
    }(e));
  }

  function y(e) {
    return s = void 0, f && i ? h(e) : (i = r = void 0, a);
  }

  function _() {
    var e = la(),
        n = g(e);

    if (i = arguments, r = this, l = e, n) {
      if (void 0 === s) return d(l);
      if (p) return s = setTimeout(m, t), h(l);
    }

    return void 0 === s && (s = setTimeout(m, t)), a;
  }

  return t = ca(t) || 0, ua(n) && (c = !!n.leading, o = (p = "maxWait" in n) ? aa(ca(n.maxWait) || 0, t) : o, f = "trailing" in n ? !!n.trailing : f), _.cancel = function () {
    void 0 !== s && clearTimeout(s), u = 0, i = l = r = s = void 0;
  }, _.flush = function () {
    return void 0 === s ? a : y(la());
  }, _;
},
    fa = /^\[object .+?Constructor\]$/,
    ha = "object" == typeof d && d && d.Object === Object && d,
    da = "object" == typeof self && self && self.Object === Object && self,
    ga = ha || da || Function("return this")();

var ma,
    ya = Array.prototype,
    _a = Function.prototype,
    va = Object.prototype,
    ba = ga["__core-js_shared__"],
    wa = (ma = /[^.]+$/.exec(ba && ba.keys && ba.keys.IE_PROTO || "")) ? "Symbol(src)_1." + ma : "",
    xa = _a.toString,
    ka = va.hasOwnProperty,
    Ta = va.toString,
    Sa = RegExp("^" + xa.call(ka).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
    Ca = ya.splice,
    Ea = Pa(ga, "Map"),
    Oa = Pa(Object, "create");

function Ra(e) {
  var t = -1,
      n = e ? e.length : 0;

  for (this.clear(); ++t < n;) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}

function Ia(e) {
  var t = -1,
      n = e ? e.length : 0;

  for (this.clear(); ++t < n;) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}

function Aa(e) {
  var t = -1,
      n = e ? e.length : 0;

  for (this.clear(); ++t < n;) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}

function Ma(e, t) {
  for (var n, i, r = e.length; r--;) {
    if ((n = e[r][0]) === (i = t) || n != n && i != i) return r;
  }

  return -1;
}

function Fa(e) {
  return !(!La(e) || (t = e, wa && wa in t)) && (function (e) {
    var t = La(e) ? Ta.call(e) : "";
    return "[object Function]" == t || "[object GeneratorFunction]" == t;
  }(e) || function (e) {
    var t = !1;
    if (null != e && "function" != typeof e.toString) try {
      t = !!(e + "");
    } catch (e) {}
    return t;
  }(e) ? Sa : fa).test(function (e) {
    if (null != e) {
      try {
        return xa.call(e);
      } catch (e) {}

      try {
        return e + "";
      } catch (e) {}
    }

    return "";
  }(e));
  var t;
}

function Da(e, t) {
  var n,
      i,
      r = e.__data__;
  return ("string" == (i = typeof (n = t)) || "number" == i || "symbol" == i || "boolean" == i ? "__proto__" !== n : null === n) ? r["string" == typeof t ? "string" : "hash"] : r.map;
}

function Pa(e, t) {
  var n = function (e, t) {
    return null == e ? void 0 : e[t];
  }(e, t);

  return Fa(n) ? n : void 0;
}

function za(e, t) {
  if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");

  var n = function n() {
    var i = arguments,
        r = t ? t.apply(this, i) : i[0],
        o = n.cache;
    if (o.has(r)) return o.get(r);
    var a = e.apply(this, i);
    return n.cache = o.set(r, a), a;
  };

  return n.cache = new (za.Cache || Aa)(), n;
}

function La(e) {
  var t = typeof e;
  return !!e && ("object" == t || "function" == t);
}

Ra.prototype.clear = function () {
  this.__data__ = Oa ? Oa(null) : {};
}, Ra.prototype.delete = function (e) {
  return this.has(e) && delete this.__data__[e];
}, Ra.prototype.get = function (e) {
  var t = this.__data__;

  if (Oa) {
    var n = t[e];
    return "__lodash_hash_undefined__" === n ? void 0 : n;
  }

  return ka.call(t, e) ? t[e] : void 0;
}, Ra.prototype.has = function (e) {
  var t = this.__data__;
  return Oa ? void 0 !== t[e] : ka.call(t, e);
}, Ra.prototype.set = function (e, t) {
  return this.__data__[e] = Oa && void 0 === t ? "__lodash_hash_undefined__" : t, this;
}, Ia.prototype.clear = function () {
  this.__data__ = [];
}, Ia.prototype.delete = function (e) {
  var t = this.__data__,
      n = Ma(t, e);
  return !(n < 0) && (n == t.length - 1 ? t.pop() : Ca.call(t, n, 1), !0);
}, Ia.prototype.get = function (e) {
  var t = this.__data__,
      n = Ma(t, e);
  return n < 0 ? void 0 : t[n][1];
}, Ia.prototype.has = function (e) {
  return Ma(this.__data__, e) > -1;
}, Ia.prototype.set = function (e, t) {
  var n = this.__data__,
      i = Ma(n, e);
  return i < 0 ? n.push([e, t]) : n[i][1] = t, this;
}, Aa.prototype.clear = function () {
  this.__data__ = {
    hash: new Ra(),
    map: new (Ea || Ia)(),
    string: new Ra()
  };
}, Aa.prototype.delete = function (e) {
  return Da(this, e).delete(e);
}, Aa.prototype.get = function (e) {
  return Da(this, e).get(e);
}, Aa.prototype.has = function (e) {
  return Da(this, e).has(e);
}, Aa.prototype.set = function (e, t) {
  return Da(this, e).set(e, t), this;
}, za.Cache = Aa;
var Ba,
    Na = za,
    Ua = [],
    ja = "ResizeObserver loop completed with undelivered notifications.";
!function (e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
}(Ba || (Ba = {}));

var Wa,
    Ha = function () {
  function e(e, t, n, i) {
    return this.x = e, this.y = t, this.width = n, this.height = i, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Object.freeze(this);
  }

  return e.prototype.toJSON = function () {
    var e = this;
    return {
      x: e.x,
      y: e.y,
      top: e.top,
      right: e.right,
      bottom: e.bottom,
      left: e.left,
      width: e.width,
      height: e.height
    };
  }, e.fromRect = function (t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(),
    Ga = function Ga(e) {
  return e instanceof SVGElement && "getBBox" in e;
},
    Va = function Va(e) {
  if (Ga(e)) {
    var t = e.getBBox(),
        n = t.width,
        i = t.height;
    return !n && !i;
  }

  var r = e,
      o = r.offsetWidth,
      a = r.offsetHeight;
  return !(o || a || e.getClientRects().length);
},
    Xa = function Xa(e) {
  var t,
      n,
      i = null === (n = null === (t = e) || void 0 === t ? void 0 : t.ownerDocument) || void 0 === n ? void 0 : n.defaultView;
  return !!(i && e instanceof i.Element);
},
    Ya = "undefined" != typeof window ? window : {},
    qa = new Map(),
    Ka = /auto|scroll/,
    Za = /^tb|vertical/,
    Qa = /msie|trident/i.test(Ya.navigator && Ya.navigator.userAgent),
    Ja = function Ja(e) {
  return parseFloat(e || "0");
},
    $a = function $a(e, t, n) {
  return void 0 === e && (e = 0), void 0 === t && (t = 0), void 0 === n && (n = !1), Object.freeze({
    inlineSize: (n ? t : e) || 0,
    blockSize: (n ? e : t) || 0
  });
},
    es = Object.freeze({
  devicePixelContentBoxSize: $a(),
  borderBoxSize: $a(),
  contentBoxSize: $a(),
  contentRect: new Ha(0, 0, 0, 0)
}),
    ts = function ts(e) {
  if (qa.has(e)) return qa.get(e);
  if (Va(e)) return qa.set(e, es), es;

  var t = getComputedStyle(e),
      n = Ga(e) && e.ownerSVGElement && e.getBBox(),
      i = !Qa && "border-box" === t.boxSizing,
      r = Za.test(t.writingMode || ""),
      o = !n && Ka.test(t.overflowY || ""),
      a = !n && Ka.test(t.overflowX || ""),
      s = n ? 0 : Ja(t.paddingTop),
      l = n ? 0 : Ja(t.paddingRight),
      u = n ? 0 : Ja(t.paddingBottom),
      c = n ? 0 : Ja(t.paddingLeft),
      p = n ? 0 : Ja(t.borderTopWidth),
      f = n ? 0 : Ja(t.borderRightWidth),
      h = n ? 0 : Ja(t.borderBottomWidth),
      d = c + l,
      g = s + u,
      m = (n ? 0 : Ja(t.borderLeftWidth)) + f,
      y = p + h,
      _ = a ? e.offsetHeight - y - e.clientHeight : 0,
      v = o ? e.offsetWidth - m - e.clientWidth : 0,
      b = i ? d + m : 0,
      w = i ? g + y : 0,
      x = n ? n.width : Ja(t.width) - b - v,
      k = n ? n.height : Ja(t.height) - w - _,
      T = x + d + v + m,
      S = k + g + _ + y,
      C = Object.freeze({
    devicePixelContentBoxSize: $a(Math.round(x * devicePixelRatio), Math.round(k * devicePixelRatio), r),
    borderBoxSize: $a(T, S, r),
    contentBoxSize: $a(x, k, r),
    contentRect: new Ha(c, s, x, k)
  });

  return qa.set(e, C), C;
},
    ns = function ns(e, t) {
  var n = ts(e),
      i = n.borderBoxSize,
      r = n.contentBoxSize,
      o = n.devicePixelContentBoxSize;

  switch (t) {
    case Ba.DEVICE_PIXEL_CONTENT_BOX:
      return o;

    case Ba.BORDER_BOX:
      return i;

    default:
      return r;
  }
},
    is = function is(e) {
  var t = ts(e);
  this.target = e, this.contentRect = t.contentRect, this.borderBoxSize = [t.borderBoxSize], this.contentBoxSize = [t.contentBoxSize], this.devicePixelContentBoxSize = [t.devicePixelContentBoxSize];
},
    rs = function rs(e) {
  if (Va(e)) return 1 / 0;

  for (var t = 0, n = e.parentNode; n;) {
    t += 1, n = n.parentNode;
  }

  return t;
},
    os = function os() {
  var e = 1 / 0,
      t = [];
  Ua.forEach(function (n) {
    if (0 !== n.activeTargets.length) {
      var i = [];
      n.activeTargets.forEach(function (t) {
        var n = new is(t.target),
            r = rs(t.target);
        i.push(n), t.lastReportedSize = ns(t.target, t.observedBox), r < e && (e = r);
      }), t.push(function () {
        n.callback.call(n.observer, i, n.observer);
      }), n.activeTargets.splice(0, n.activeTargets.length);
    }
  });

  for (var n = 0, i = t; n < i.length; n++) {
    (0, i[n])();
  }

  return e;
},
    as = function as(e) {
  qa.clear(), Ua.forEach(function (t) {
    t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function (n) {
      n.isActive() && (rs(n.target) > e ? t.activeTargets.push(n) : t.skippedTargets.push(n));
    });
  });
},
    ss = function ss() {
  var e,
      t = 0;

  for (as(t); Ua.some(function (e) {
    return e.activeTargets.length > 0;
  });) {
    t = os(), as(t);
  }

  return Ua.some(function (e) {
    return e.skippedTargets.length > 0;
  }) && ("function" == typeof ErrorEvent ? e = new ErrorEvent("error", {
    message: ja
  }) : ((e = document.createEvent("Event")).initEvent("error", !1, !1), e.message = ja), window.dispatchEvent(e)), t > 0;
},
    ls = [],
    us = function us(e) {
  if (!Wa) {
    var t = 0,
        n = document.createTextNode("");
    new MutationObserver(function () {
      return ls.splice(0).forEach(function (e) {
        return e();
      });
    }).observe(n, {
      characterData: !0
    }), Wa = function Wa() {
      n.textContent = "" + (t ? t-- : t++);
    };
  }

  ls.push(e), Wa();
},
    cs = 0,
    ps = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
},
    fs = ["resize", "load", "transitionend", "animationend", "animationstart", "animationiteration", "keyup", "keydown", "mouseup", "mousedown", "mouseover", "mouseout", "blur", "focus"],
    hs = !1,
    ds = new (function () {
  function e() {
    var e = this;
    this.stopped = !0, this.listener = function () {
      return e.schedule();
    };
  }

  return e.prototype.run = function (e) {
    var t,
        n = this;
    hs || (hs = !0, t = function t() {
      var t = !1;

      try {
        t = ss();
      } finally {
        if (hs = !1, !cs) return;
        t ? n.run(60) : e ? n.run(e - 1) : n.start();
      }
    }, us(function () {
      requestAnimationFrame(t);
    }));
  }, e.prototype.schedule = function () {
    this.stop(), this.run(12);
  }, e.prototype.observe = function () {
    var e = this,
        t = function t() {
      return e.observer && e.observer.observe(document.body, ps);
    };

    document.body ? t() : Ya.addEventListener("DOMContentLoaded", t);
  }, e.prototype.start = function () {
    var e = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), fs.forEach(function (t) {
      return Ya.addEventListener(t, e.listener, !0);
    }));
  }, e.prototype.stop = function () {
    var e = this;
    this.stopped || (this.observer && this.observer.disconnect(), fs.forEach(function (t) {
      return Ya.removeEventListener(t, e.listener, !0);
    }), this.stopped = !0);
  }, e;
}())(),
    gs = function gs(e) {
  !cs && e > 0 && ds.start(), !(cs += e) && ds.stop();
},
    ms = function () {
  function e(e, t) {
    this.target = e, this.observedBox = t || Ba.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }

  return e.prototype.isActive = function () {
    var e,
        t = ns(this.target, this.observedBox);
    return e = this.target, Ga(e) || function (e) {
      switch (e.tagName) {
        case "INPUT":
          if ("image" !== e.type) break;

        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
          return !0;
      }

      return !1;
    }(e) || "inline" !== getComputedStyle(e).display || (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(),
    ys = function ys(e, t) {
  this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = t;
},
    _s = new Map(),
    vs = function vs(e, t) {
  for (var n = 0; n < e.length; n += 1) {
    if (e[n].target === t) return n;
  }

  return -1;
},
    bs = function () {
  function e() {}

  return e.connect = function (e, t) {
    var n = new ys(e, t);
    Ua.push(n), _s.set(e, n);
  }, e.observe = function (e, t, n) {
    if (_s.has(e)) {
      var i = _s.get(e);

      vs(i.observationTargets, t) < 0 && (i.observationTargets.push(new ms(t, n && n.box)), gs(1), ds.schedule());
    }
  }, e.unobserve = function (e, t) {
    if (_s.has(e)) {
      var n = _s.get(e),
          i = vs(n.observationTargets, t);

      i >= 0 && (n.observationTargets.splice(i, 1), gs(-1));
    }
  }, e.disconnect = function (e) {
    if (_s.has(e)) {
      var t = _s.get(e);

      Ua.splice(Ua.indexOf(t), 1), _s.delete(e), gs(-t.observationTargets.length);
    }
  }, e;
}(),
    ws = function () {
  function e(e) {
    if (0 === arguments.length) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if ("function" != typeof e) throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    bs.connect(this, e);
  }

  return e.prototype.observe = function (e, t) {
    if (0 === arguments.length) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Xa(e)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    bs.observe(this, e, t);
  }, e.prototype.unobserve = function (e) {
    if (0 === arguments.length) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Xa(e)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    bs.unobserve(this, e);
  }, e.prototype.disconnect = function () {
    bs.disconnect(this);
  }, e.toString = function () {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}(),
    xs = !("undefined" == typeof window || !window.document || !window.document.createElement),
    ks = function ks() {
  if ("undefined" == typeof document) return 0;
  if (Ze()) return window.innerWidth - document.documentElement.clientWidth;
  var e = document.body,
      t = document.createElement("div"),
      n = t.style;
  n.position = "fixed", n.left = "0", n.visibility = "hidden", n.overflowY = "scroll", e.appendChild(t);
  var i = t.getBoundingClientRect().right;
  return e.removeChild(t), i;
},
    Ts = "photoeditorsdk-simplebar",
    Ss = function () {
  function e(t, n) {
    var i = this;
    this.minScrollbarWidth = 20, this.initDOM = function () {
      if (Array.prototype.filter.call(i.el.children, function (e) {
        return e.classList.contains(i.classNames.wrapper);
      }).length) i.wrapperEl = i.el.querySelector("." + i.classNames.wrapper), i.contentWrapperEl = i.el.querySelector("." + i.classNames.contentWrapper), i.offsetEl = i.el.querySelector("." + i.classNames.offset), i.maskEl = i.el.querySelector("." + i.classNames.mask), i.contentEl = i.el.querySelector("." + i.classNames.contentEl), i.placeholderEl = i.el.querySelector("." + i.classNames.placeholder), i.heightAutoObserverWrapperEl = i.el.querySelector("." + i.classNames.heightAutoObserverWrapperEl), i.heightAutoObserverEl = i.el.querySelector("." + i.classNames.heightAutoObserverEl), i.axis.x.track.el = i.el.querySelector("." + i.classNames.track + "." + i.classNames.horizontal), i.axis.y.track.el = i.el.querySelector("." + i.classNames.track + "." + i.classNames.vertical);else {
        for (i.wrapperEl = document.createElement("div"), i.contentWrapperEl = document.createElement("div"), i.offsetEl = document.createElement("div"), i.maskEl = document.createElement("div"), i.contentEl = document.createElement("div"), i.placeholderEl = document.createElement("div"), i.heightAutoObserverWrapperEl = document.createElement("div"), i.heightAutoObserverEl = document.createElement("div"), i.wrapperEl.classList.add(i.classNames.wrapper), i.contentWrapperEl.classList.add(i.classNames.contentWrapper), i.offsetEl.classList.add(i.classNames.offset), i.maskEl.classList.add(i.classNames.mask), i.contentEl.classList.add(i.classNames.contentEl), i.placeholderEl.classList.add(i.classNames.placeholder), i.heightAutoObserverWrapperEl.classList.add(i.classNames.heightAutoObserverWrapperEl), i.heightAutoObserverEl.classList.add(i.classNames.heightAutoObserverEl); i.el.firstChild;) {
          i.contentEl.appendChild(i.el.firstChild);
        }

        i.contentWrapperEl.appendChild(i.contentEl), i.offsetEl.appendChild(i.contentWrapperEl), i.maskEl.appendChild(i.offsetEl), i.heightAutoObserverWrapperEl.appendChild(i.heightAutoObserverEl), i.wrapperEl.appendChild(i.heightAutoObserverWrapperEl), i.wrapperEl.appendChild(i.maskEl), i.wrapperEl.appendChild(i.placeholderEl), i.el.appendChild(i.wrapperEl);
      }

      if (!i.axis.x.track.el || !i.axis.y.track.el) {
        var e = document.createElement("div"),
            t = document.createElement("div");
        e.classList.add(i.classNames.track), t.classList.add(i.classNames.scrollbar), e.appendChild(t), i.axis.x.track.el = e.cloneNode(!0), i.axis.x.track.el.classList.add(i.classNames.horizontal), i.axis.y.track.el = e.cloneNode(!0), i.axis.y.track.el.classList.add(i.classNames.vertical), i.el.appendChild(i.axis.x.track.el), i.el.appendChild(i.axis.y.track.el);
      }

      i.axis.x.scrollbar.el = i.axis.x.track.el.querySelector("." + i.classNames.scrollbar), i.axis.y.scrollbar.el = i.axis.y.track.el.querySelector("." + i.classNames.scrollbar), i.options.autoHide || (i.axis.x.scrollbar.el.classList.add(i.classNames.visible), i.axis.y.scrollbar.el.classList.add(i.classNames.visible)), i.el.setAttribute("data-simplebar", "init");
    }, this.initListeners = function () {
      i.options.autoHide && i.el.addEventListener("mouseenter", i.onMouseEnter), ["mousedown", "click", "dblclick", "touchstart", "touchend", "touchmove"].forEach(function (e) {
        i.el.addEventListener(e, i.onPointerEvent, {
          capture: !0,
          passive: !0
        });
      }), i.el.addEventListener("mousemove", i.onMouseMove), i.el.addEventListener("mouseleave", i.onMouseLeave), i.contentWrapperEl.addEventListener("scroll", i.onScroll), window.addEventListener("resize", i.onWindowResize), i.resizeObserver = new ws(i.recalculate), i.resizeObserver.observe(i.el), i.resizeObserver.observe(i.contentEl);
    }, this.recalculate = function () {
      var e = i.heightAutoObserverEl.offsetHeight <= 1,
          t = i.heightAutoObserverEl.offsetWidth <= 1;
      i.elStyles = window.getComputedStyle(i.el), i.isRtl = "rtl" === i.elStyles.direction, i.contentEl.style.padding = i.elStyles.paddingTop + " " + i.elStyles.paddingRight + " " + i.elStyles.paddingBottom + " " + i.elStyles.paddingLeft, i.wrapperEl.style.margin = "-" + i.elStyles.paddingTop + " -" + i.elStyles.paddingRight + " -" + i.elStyles.paddingBottom + " -" + i.elStyles.paddingLeft, i.contentWrapperEl.style.height = e ? "auto" : "100%", i.placeholderEl.style.width = t ? i.contentEl.offsetWidth + "px" : "auto", i.placeholderEl.style.height = i.contentEl.scrollHeight + "px", i.axis.x.isOverflowing = i.contentWrapperEl.scrollWidth > i.contentWrapperEl.offsetWidth, i.axis.y.isOverflowing = i.contentWrapperEl.scrollHeight > i.contentWrapperEl.offsetHeight, i.axis.x.isOverflowing = "hidden" !== i.elStyles.overflowX && i.axis.x.isOverflowing, i.axis.y.isOverflowing = "hidden" !== i.elStyles.overflowY && i.axis.y.isOverflowing, i.axis.x.forceVisible = "x" === i.options.forceVisible || !0 === i.options.forceVisible, i.axis.y.forceVisible = "y" === i.options.forceVisible || !0 === i.options.forceVisible, i.hideNativeScrollbar(), i.axis.x.track.rect = i.axis.x.track.el.getBoundingClientRect(), i.axis.y.track.rect = i.axis.y.track.el.getBoundingClientRect(), i.axis.x.scrollbar.size = i.getScrollbarSize("x"), i.axis.y.scrollbar.size = i.getScrollbarSize("y"), i.axis.x.scrollbar.el.style.width = i.axis.x.scrollbar.size + "px", i.axis.y.scrollbar.el.style.height = i.axis.y.scrollbar.size + "px", i.positionScrollbar("x"), i.positionScrollbar("y"), i.toggleTrackVisibility("x"), i.toggleTrackVisibility("y");
    }, this.getScrollbarSize = function (e) {
      void 0 === e && (e = "y");
      var t,
          n = i.scrollbarWidth ? i.contentWrapperEl[i.axis[e].scrollSizeAttr] : i.contentWrapperEl[i.axis[e].scrollSizeAttr] - i.minScrollbarWidth,
          r = i.axis[e].track.rect[i.axis[e].sizeAttr];

      if (i.axis[e].isOverflowing) {
        var o = r / n;
        return t = Math.max(~~(o * r), i.options.scrollbarMinSize), i.options.scrollbarMaxSize && (t = Math.min(t, i.options.scrollbarMaxSize)), t;
      }
    }, this.positionScrollbar = function (t) {
      void 0 === t && (t = "y");
      var n = i.contentWrapperEl[i.axis[t].scrollSizeAttr],
          r = i.axis[t].track.rect[i.axis[t].sizeAttr],
          o = parseInt(i.elStyles[i.axis[t].sizeAttr], 10),
          a = i.axis[t].scrollbar,
          s = i.contentWrapperEl[i.axis[t].scrollOffsetAttr],
          l = (s = "x" === t && i.isRtl && e.getRtlHelpers().isRtlScrollingInverted ? -s : s) / (n - o),
          u = ~~((r - a.size) * l);
      u = "x" === t && i.isRtl && e.getRtlHelpers().isRtlScrollbarInverted ? u + (r - a.size) : u, a.el.style.transform = "x" === t ? "translate3d(" + u + "px, 0, 0)" : "translate3d(0, " + u + "px, 0)";
    }, this.toggleTrackVisibility = function (e) {
      void 0 === e && (e = "y");
      var t = i.axis[e].track.el,
          n = i.axis[e].scrollbar.el;
      i.axis[e].isOverflowing || i.axis[e].forceVisible ? (t.style.visibility = "visible", i.contentWrapperEl.style[i.axis[e].overflowAttr] = "scroll") : (t.style.visibility = "hidden", i.contentWrapperEl.style[i.axis[e].overflowAttr] = "hidden"), n.style.display = i.axis[e].isOverflowing ? "block" : "none";
    }, this.onScroll = function () {
      i.scrollXTicking || (window.requestAnimationFrame(i.scrollX), i.scrollXTicking = !0), i.scrollYTicking || (window.requestAnimationFrame(i.scrollY), i.scrollYTicking = !0);
    }, this.scrollX = function () {
      i.axis.x.isOverflowing && (i.showScrollbar("x"), i.positionScrollbar("x")), i.scrollXTicking = !1;
    }, this.scrollY = function () {
      i.axis.y.isOverflowing && (i.showScrollbar("y"), i.positionScrollbar("y")), i.scrollYTicking = !1;
    }, this.onMouseEnter = function () {
      i.showScrollbar("x"), i.showScrollbar("y");
    }, this.onMouseMove = function (e) {
      i.mouseX = e.clientX, i.mouseY = e.clientY, (i.axis.x.isOverflowing || i.axis.x.forceVisible) && i.onMouseMoveForAxis("x"), (i.axis.y.isOverflowing || i.axis.y.forceVisible) && i.onMouseMoveForAxis("y");
    }, this.onMouseMoveForAxis = function (e) {
      void 0 === e && (e = "y"), i.axis[e].track.rect = i.axis[e].track.el.getBoundingClientRect(), i.axis[e].scrollbar.rect = i.axis[e].scrollbar.el.getBoundingClientRect(), i.isWithinBounds(i.axis[e].scrollbar.rect) ? i.axis[e].scrollbar.el.classList.add(i.classNames.hover) : i.axis[e].scrollbar.el.classList.remove(i.classNames.hover), i.isWithinBounds(i.axis[e].track.rect) ? (i.showScrollbar(e), i.axis[e].track.el.classList.add(i.classNames.hover)) : i.axis[e].track.el.classList.remove(i.classNames.hover);
    }, this.onMouseLeave = function () {
      i.onMouseMove.cancel(), (i.axis.x.isOverflowing || i.axis.x.forceVisible) && i.onMouseLeaveForAxis("x"), (i.axis.y.isOverflowing || i.axis.y.forceVisible) && i.onMouseLeaveForAxis("y"), i.mouseX = -1, i.mouseY = -1;
    }, this.onWindowResize = function () {
      i.scrollbarWidth = ks(), i.hideNativeScrollbar();
    }, this.hideScrollbars = function () {
      i.axis.x.track.rect = i.axis.x.track.el.getBoundingClientRect(), i.axis.y.track.rect = i.axis.y.track.el.getBoundingClientRect(), i.isWithinBounds(i.axis.y.track.rect) || (i.axis.y.scrollbar.el.classList.remove(i.classNames.visible), i.axis.y.isVisible = !1), i.isWithinBounds(i.axis.x.track.rect) || (i.axis.x.scrollbar.el.classList.remove(i.classNames.visible), i.axis.x.isVisible = !1);
    }, this.onPointerEvent = function (e) {
      var t, n;
      i.axis.x.scrollbar.rect = i.axis.x.scrollbar.el.getBoundingClientRect(), i.axis.y.scrollbar.rect = i.axis.y.scrollbar.el.getBoundingClientRect(), (i.axis.x.isOverflowing || i.axis.x.forceVisible) && (n = i.isWithinBounds(i.axis.x.scrollbar.rect)), (i.axis.y.isOverflowing || i.axis.y.forceVisible) && (t = i.isWithinBounds(i.axis.y.scrollbar.rect)), (t || n) && (e.preventDefault(), e.stopPropagation(), "mousedown" === e.type && (t && i.onDragStart(e, "y"), n && i.onDragStart(e, "x")));
    }, this.drag = function (t) {
      var n = i.axis[i.draggedAxis],
          r = n.track,
          o = n.scrollbar,
          a = r.rect[i.axis[i.draggedAxis].sizeAttr];
      t.preventDefault(), t.stopPropagation();
      var s = (("y" === i.draggedAxis ? t.pageY : t.pageX) - r.rect[i.axis[i.draggedAxis].offsetAttr] - i.axis[i.draggedAxis].dragOffset) / r.rect[i.axis[i.draggedAxis].sizeAttr] * i.contentWrapperEl[i.axis[i.draggedAxis].scrollSizeAttr];
      "x" === i.draggedAxis && (s = i.isRtl && e.getRtlHelpers().isRtlScrollbarInverted ? s - (a + o.size) : s, s = i.isRtl && e.getRtlHelpers().isRtlScrollingInverted ? -s : s), i.contentWrapperEl[i.axis[i.draggedAxis].scrollOffsetAttr] = s;
    }, this.onEndDrag = function (e) {
      e.preventDefault(), e.stopPropagation(), i.el.classList.remove(i.classNames.dragging), document.removeEventListener("mousemove", i.drag, !0), document.removeEventListener("mouseup", i.onEndDrag, !0), i.removePreventClickId = window.setTimeout(function () {
        document.removeEventListener("click", i.preventClick, !0), document.removeEventListener("dblclick", i.preventClick, !0), i.removePreventClickId = null;
      });
    }, this.preventClick = function (e) {
      e.preventDefault(), e.stopPropagation();
    }, this.el = t, this.options = _v2(_v2({}, e.defaultOptions), n), this.classNames = _v2(_v2({}, e.defaultOptions.classNames), this.options.classNames), this.axis = {
      x: {
        scrollOffsetAttr: "scrollLeft",
        sizeAttr: "width",
        scrollSizeAttr: "scrollWidth",
        offsetAttr: "left",
        overflowAttr: "overflowX",
        dragOffset: 0,
        isOverflowing: !0,
        isVisible: !1,
        forceVisible: !1,
        track: {},
        scrollbar: {}
      },
      y: {
        scrollOffsetAttr: "scrollTop",
        sizeAttr: "height",
        scrollSizeAttr: "scrollHeight",
        offsetAttr: "top",
        overflowAttr: "overflowY",
        dragOffset: 0,
        isOverflowing: !0,
        isVisible: !1,
        forceVisible: !1,
        track: {},
        scrollbar: {}
      }
    }, this.removePreventClickId = null, this.el.SimpleBar || (this.recalculate = Zo(this.recalculate, 64), this.onMouseMove = Zo(this.onMouseMove, 64), this.hideScrollbars = pa(this.hideScrollbars, this.options.timeout), this.onWindowResize = pa(this.onWindowResize, 64, {
      leading: !0
    }), e.getRtlHelpers = Na(e.getRtlHelpers), this.init());
  }

  return e.getRtlHelpers = function () {
    var t = document.createElement("div");
    t.innerHTML = '<div class="photoeditorsdk-hs-dummy-scrollbar-size"><div style="height: 200% width: 200% margin: 10px 0"></div></div>';
    var n = t.firstElementChild;
    document.body.appendChild(n);
    var i = n.firstElementChild;
    n.scrollLeft = 0;
    var r = e.getOffset(n),
        o = e.getOffset(i);
    n.scrollLeft = 999;
    var a = e.getOffset(i);
    return {
      isRtlScrollingInverted: r.left !== o.left && o.left - a.left != 0,
      isRtlScrollbarInverted: r.left !== o.left
    };
  }, e.initHtmlApi = function () {
    this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this), "undefined" != typeof MutationObserver && (this.globalObserver = new MutationObserver(function (t) {
      t.forEach(function (t) {
        Array.prototype.forEach.call(t.addedNodes, function (t) {
          1 === t.nodeType && (t.hasAttribute("data-simplebar") && !t.SimpleBar ? new e(t, e.getElOptions(t)) : Array.prototype.forEach.call(t.querySelectorAll("[data-simplebar]"), function (t) {
            t.SimpleBar || new e(t, e.getElOptions(t));
          }));
        }), Array.prototype.forEach.call(t.removedNodes, function (e) {
          1 === e.nodeType && (e.hasAttribute("data-simplebar") && e.SimpleBar ? e.SimpleBar.unMount() : Array.prototype.forEach.call(e.querySelectorAll("[data-simplebar]"), function (e) {
            e.SimpleBar && e.SimpleBar.unMount();
          }));
        });
      });
    }), this.globalObserver.observe(document, {
      childList: !0,
      subtree: !0
    })), "complete" === document.readyState || "loading" !== document.readyState && !document.documentElement.scroll ? window.setTimeout(this.initDOMLoadedElements) : (document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements), window.addEventListener("load", this.initDOMLoadedElements));
  }, e.getElOptions = function (e) {
    return Array.prototype.reduce.call(e.attributes, function (e, t) {
      var n = t.name.match(/data-simplebar-(.+)/);

      if (n) {
        var i = n[1].replace(/\W+(.)/g, function (e, t) {
          return t.toUpperCase();
        });

        switch (t.value) {
          case "true":
            e[i] = !0;
            break;

          case "false":
            e[i] = !1;
            break;

          case void 0:
            e[i] = !0;
            break;

          default:
            e[i] = t.value;
        }
      }

      return e;
    }, {});
  }, e.removeObserver = function () {
    this.globalObserver.disconnect();
  }, e.initDOMLoadedElements = function () {
    document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements), window.removeEventListener("load", this.initDOMLoadedElements), Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"), function (t) {
      t.SimpleBar || new e(t, e.getElOptions(t));
    });
  }, e.getOffset = function (e) {
    var t = e.getBoundingClientRect();
    return {
      top: t.top + (window.pageYOffset || document.documentElement.scrollTop),
      left: t.left + (window.pageXOffset || document.documentElement.scrollLeft)
    };
  }, e.prototype.init = function () {
    this.el.SimpleBar = this, xs && (this.initDOM(), this.scrollbarWidth = ks(), this.recalculate(), this.initListeners());
  }, e.prototype.hideNativeScrollbar = function () {
    if (this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + (this.scrollbarWidth || this.minScrollbarWidth) + "px" : 0, this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + (this.scrollbarWidth || this.minScrollbarWidth) + "px" : 0, !this.scrollbarWidth) {
      var e = this.isRtl ? "paddingLeft" : "paddingRight";
      this.contentWrapperEl.style[e] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? this.minScrollbarWidth + "px" : 0, this.contentWrapperEl.style.paddingBottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? this.minScrollbarWidth + "px" : 0;
    }
  }, e.prototype.onMouseLeaveForAxis = function (e) {
    void 0 === e && (e = "y"), this.axis[e].track.el.classList.remove(this.classNames.hover), this.axis[e].scrollbar.el.classList.remove(this.classNames.hover);
  }, e.prototype.showScrollbar = function (e) {
    void 0 === e && (e = "y");
    var t = this.axis[e].scrollbar.el;
    this.axis[e].isVisible || (t.classList.add(this.classNames.visible), this.axis[e].isVisible = !0), this.options.autoHide && this.hideScrollbars();
  }, e.prototype.onDragStart = function (e, t) {
    void 0 === t && (t = "y");
    var n = this.axis[t].scrollbar.el,
        i = "y" === t ? e.pageY : e.pageX;
    this.axis[t].dragOffset = i - n.getBoundingClientRect()[this.axis[t].offsetAttr], this.draggedAxis = t, this.el.classList.add(this.classNames.dragging), document.addEventListener("mousemove", this.drag, !0), document.addEventListener("mouseup", this.onEndDrag, !0), null === this.removePreventClickId ? (document.addEventListener("click", this.preventClick, !0), document.addEventListener("dblclick", this.preventClick, !0)) : (window.clearTimeout(this.removePreventClickId), this.removePreventClickId = null);
  }, e.prototype.getContentElement = function () {
    return this.contentEl;
  }, e.prototype.getScrollElement = function () {
    return this.contentWrapperEl;
  }, e.prototype.removeListeners = function () {
    var e = this;
    this.options.autoHide && this.el.removeEventListener("mouseenter", this.onMouseEnter), ["mousedown", "click", "dblclick", "touchstart", "touchend", "touchmove"].forEach(function (t) {
      e.el.removeEventListener(t, e.onPointerEvent, {
        capture: !0,
        passive: !0
      });
    }), this.el.removeEventListener("mousemove", this.onMouseMove), this.el.removeEventListener("mouseleave", this.onMouseLeave), this.contentWrapperEl.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onWindowResize), this.mutationObserver && this.mutationObserver.disconnect(), this.resizeObserver.disconnect(), this.recalculate.cancel(), this.onMouseMove.cancel(), this.hideScrollbars.cancel(), this.onWindowResize.cancel();
  }, e.prototype.unMount = function () {
    this.removeListeners(), this.el.SimpleBar = null;
  }, e.prototype.isChildNode = function (e) {
    return null !== e && (e === this.el || this.isChildNode(e.parentNode));
  }, e.prototype.isWithinBounds = function (e) {
    return this.mouseX >= e.left && this.mouseX <= e.left + e.width && this.mouseY >= e.top && this.mouseY <= e.top + e.height;
  }, e.defaultOptions = {
    autoHide: !0,
    forceVisible: !1,
    classNames: {
      contentEl: Ts + "-content",
      contentWrapper: Ts + "-content-wrapper",
      offset: Ts + "-offset",
      mask: Ts + "-mask",
      wrapper: Ts + "-wrapper",
      placeholder: Ts + "-placeholder",
      scrollbar: Ts + "-scrollbar",
      track: Ts + "-track",
      heightAutoObserverWrapperEl: Ts + "-height-auto-observer-wrapper",
      heightAutoObserverEl: Ts + "-height-auto-observer",
      visible: Ts + "-visible",
      horizontal: Ts + "-horizontal",
      vertical: Ts + "-vertical",
      hover: Ts + "-hover",
      dragging: Ts + "-dragging"
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1e3
  }, e;
}();

xs && Ss.initHtmlApi();

var Cs = function () {
  function e(e) {
    var t = e.license,
        n = e.assetProvider,
        i = e.crossOrigin;
    this.crossOrigin = i, this.engine = new qt({
      license: t,
      crossOrigin: i,
      assetProvider: n,
      downscaleOptions: {
        maxDimensions: {
          width: 100,
          height: 100
        }
      }
    });
  }

  return e.isImageElement = function (e) {
    return e instanceof HTMLImageElement;
  }, e.prototype.getAllFilterPreviewThumbnails = function (e) {
    var t = this;
    return new Promise(function (n, i) {
      var r = {};
      e.reduce(function (e, n) {
        return x(t, void 0, void 0, function () {
          var t;
          return k(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, e];

              case 1:
                return (t = i.sent()).identifier && (r[t.identifier] = t.imageData), [2, this.getFilterPreviewThumbnail(n)];
            }
          });
        });
      }, Promise.resolve({
        identifier: "",
        imageData: ""
      })).then(function (e) {
        r[e.identifier] = e.imageData, n(r);
      }).catch(function (e) {
        i(e);
      });
    });
  }, e.prototype.getFilterPreviewThumbnail = function (e) {
    var t = this,
        n = e.identifier,
        i = e.isDuotone;
    return "" !== n ? (this.effect && (this.engine.removeEffect(this.effect), this.effect.getIndexInParent() || (this.effect = void 0)), new Promise(i ? function (e, i) {
      t.engine.addDuoToneFilterFromAssets(n, t.container).then(function (r) {
        r.setProperties({
          colorIntensity: .5
        }), t.effect = r, t.engine.export(Y.DATA_URL, q.PNG, .2).then(function (t) {
          e({
            identifier: n,
            imageData: t
          });
        }).catch(function (e) {
          i(e);
        });
      }).catch(function (e) {
        i(e);
      });
    } : function (e, i) {
      t.engine.addLUTFilterFromAssets(n, t.container).then(function (r) {
        r.setProperties({
          intensity: 1
        }), t.effect = r, t.engine.export(Y.DATA_URL, q.PNG, .2).then(function (t) {
          e({
            identifier: n,
            imageData: t
          });
        }).catch(function (e) {
          i(e);
        });
      }).catch(function (e) {
        i(e);
      });
    })) : new Promise(function (e) {
      return e({
        identifier: "",
        imageData: ""
      });
    });
  }, e.prototype.addImageToContainer = function (t) {
    var n = this;
    return new Promise(function (i, r) {
      var o;
      e.isImageElement(t) ? (o = t, n.setBackgroundImage(o), i()) : n.getImageElement(t).then(function (e) {
        o = e, n.setBackgroundImage(o), i();
      }).catch(function (e) {
        r({
          identifier: "imageLoading",
          message: e.message
        });
      });
    });
  }, e.prototype.getImageElement = function (e) {
    var t = this;
    return new Promise(function (n, i) {
      var r = new Image();
      r.addEventListener("load", function () {
        n(r);
      }), r.addEventListener("error", function (e) {
        i(e);
      }), r.crossOrigin = t.crossOrigin, r.src = e;
    });
  }, e.prototype.setBackgroundImage = function (e) {
    this.container ? this.container.setData({
      image: e
    }) : this.container = this.engine.addImage({
      image: e,
      blendMode: re.NORMAL,
      opacity: 1
    });
    var t = this.container.getBounds().size;
    this.engine.getOutputContainer().setResolution(t);
  }, e;
}(),
    Es = {
  tool: null,
  isWebcam: !1,
  image: ""
},
    Os = function () {
  function e(e) {
    var t = this;
    this.newImage = function (e) {
      t.editor.init(e);
    }, this.editor = e, this.state = ai(Es);
  }

  return e.prototype.selectTool = function (e, t) {
    void 0 === t && (t = !1), e = this.state.tool === e && t ? null : e, this.editor.onToolChange(this.state.tool, e), this.state.tool = e;
    var n = this.editor.engineMediator.engine.getOutputDimensions(),
        i = Math.max(.05 * Math.min(n.width, n.height), 1);

    switch (e) {
      case P.TEXT:
        this.editor.spriteStore.textToolStore.addOrselect();
        break;

      case P.TEXT_DESIGN:
        this.editor.spriteStore.textDesignToolStore.addOrselect();
        break;

      case P.BRUSH:
        this.editor.brushToolStore.changeSize(i);
        break;

      case P.TRANSFORM:
        this.editor.transformToolStore.applyDefaultCrop();
    }
  }, e.prototype.selectWebcam = function (e) {
    this.state.isWebcam = e;
  }, e.prototype.setImage = function (e) {
    "string" != typeof e || Qe(e) ? this.state.image = e : this.state.image = this.editor.assetProvider.getPath(e), this.isWebcam && (this.state.isWebcam = !1);
  }, Object.defineProperty(e.prototype, "webcamLabel", {
    get: function get() {
      return this.editor.libraryStore.locale.controls.buttonWebcamClose;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "tool", {
    get: function get() {
      return this.state.tool;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isWebcam", {
    get: function get() {
      return this.state.isWebcam;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "image", {
    get: function get() {
      return this.state.image;
    },
    enumerable: !0,
    configurable: !0
  }), w([sr], e.prototype, "selectTool", null), w([sr], e.prototype, "selectWebcam", null), w([sr], e.prototype, "setImage", null), w([sr], e.prototype, "newImage", void 0), w([fi], e.prototype, "webcamLabel", null), w([fi], e.prototype, "tool", null), w([fi], e.prototype, "isWebcam", null), w([fi], e.prototype, "image", null), e;
}(),
    Rs = function () {
  function e(t) {
    this.canvasClickDisabled = ai.box(!1), this.editor = t, this.state = ai(e.initialState);
  }

  return e.prototype.setCanvasElement = function (e) {
    this.canvas = e, this.editor.engineMediator.preview.createPreview(e), this.updateCanvasDimensions(), this.editor.init(this.editor.configStore.config.image);
  }, e.prototype.updateCanvasDimensions = function () {
    var e = Yl.devicePixelRatio;
    this.canvas.width = this.canvasSize.width * e, this.canvas.height = this.canvasSize.height * e, this.canvas.style.width = this.canvasSize.width + "px", this.canvas.style.height = this.canvasSize.height + "px";
  }, e.prototype.saveDimensions = function (t) {
    var n = t.height,
        i = t.width,
        r = t.render,
        o = this.editor.configStore.isLayoutAdvanced ? 0 : this.editor.configStore.measurements.basicCanvasOffset;
    n - o > e.MIN_CANVAS_SIZE.height && i > e.MIN_CANVAS_SIZE.width && (this.state.canvasSize.height = n - o, this.state.canvasSize.width = i, r && this.editor.resize());
  }, e.prototype.disableCanvasClick = function () {
    this.canvasClickDisabled.set(!0);
  }, e.prototype.enableCanvasClick = function () {
    this.canvasClickDisabled.set(!1);
  }, Object.defineProperty(e.prototype, "isCanvasClickable", {
    get: function get() {
      return !this.canvasClickDisabled.get();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "canvasSize", {
    get: function get() {
      return this.state.canvasSize;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "sizeVector", {
    get: function get() {
      return R.fromSize(this.state.canvasSize);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "sizeVectorMagnitude", {
    get: function get() {
      return this.sizeVector.magnitude;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getContainersAtPreviewPoint = function (e) {
    var t = this,
        n = this.editor.engine.getContainersAtPreviewPoint(e, this.editor.engineMediator.preview.previewTransformWithoutDpr).map(function (e) {
      return e.getID();
    }).filter(function (e) {
      return e !== t.editor.engineMediator.image.getImgageContainerId();
    });
    this.editor.spriteStore.onCanvasClick(n);
  }, e.MIN_CANVAS_SIZE = {
    height: 150,
    width: 150
  }, e.initialState = {
    canvasSize: e.MIN_CANVAS_SIZE
  }, w([sr], e.prototype, "setCanvasElement", null), w([sr], e.prototype, "updateCanvasDimensions", null), w([sr], e.prototype, "saveDimensions", null), w([sr], e.prototype, "disableCanvasClick", null), w([sr], e.prototype, "enableCanvasClick", null), w([fi], e.prototype, "isCanvasClickable", null), w([fi], e.prototype, "canvasSize", null), w([fi], e.prototype, "sizeVector", null), w([fi], e.prototype, "sizeVectorMagnitude", null), e;
}();

function Is(e) {
  return e && "object" == typeof e && "[object RegExp]" !== Object.prototype.toString.call(e) && "[object Date]" !== Object.prototype.toString.call(e);
}

function As(e, t) {
  var n;
  return t && !0 === t.clone && Is(e) ? Ms((n = e, Array.isArray(n) ? [] : {}), e, t) : e;
}

function Ms(e, t, n) {
  return Array.isArray(t) ? Array.isArray(e) ? t : As(t, n) : function (e, t, n) {
    var i = {};
    return Is(e) && Object.keys(e).forEach(function (t) {
      i[t] = As(e[t], n);
    }), Object.keys(t).forEach(function (r) {
      var o = Is(t[r]) && e[r];
      i[r] = o ? Ms(e[r], t[r], n) : As(t[r], n);
    }), i;
  }(e, t, n);
}

function Fs(e, t) {
  if (void 0 === t && (t = null), !Array.isArray(e) || e.length < 2) throw new Error("first argument should be an array with at least two elements");
  return e.reduce(function (e, n) {
    return Ms(e, n, t);
  });
}

var Ds = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return _(t, e), t.prototype.onExport = function (e) {
    this.emit(ve.EXPORT, e);
  }, t.prototype.onClose = function () {
    this.emit(ve.CLOSE);
  }, t.prototype.onHistoryChange = function () {
    this.emit(ve.HISTORY_CHANGE);
  }, t.prototype.onEditorReady = function () {
    this.emit(ve.EDITOR_READY);
  }, t;
}(Te),
    Ps = {
  common: {
    error: "Error",
    warning: "Warning",
    color: {
      colorPicker: {
        hex: "Hex",
        r: "R",
        g: "G",
        b: "B",
        sliderHue: "Color",
        sliderOpacity: "Color Opacity"
      }
    }
  },
  mainCanvasActions: {
    buttonExport: "Export Image",
    buttonUndo: "Undo",
    buttonRedo: "Redo",
    buttonClose: "Close"
  },
  infoModals: {
    exporting: {
      heading: "Exporting...",
      body: "Just a few seconds..."
    },
    saving: {
      heading: "Saving...",
      body: "Just a few seconds..."
    },
    loading: {
      heading: "Loading...",
      body: "Just a few seconds..."
    },
    resizing: {
      heading: "Resizing...",
      body: "Just a few seconds..."
    },
    loadingFonts: {
      heading: "Loading Fonts...",
      body: "Just a few seconds..."
    }
  },
  errorModals: {
    imageLoading: {
      body: "Failed to load image. This can have multiple reasons, e.g. the file is corrupted or the file type is not supported",
      buttonYes: "Reload"
    },
    rendering: {
      body: "An error has occurred while rendering the image",
      buttonYes: "Reload"
    },
    fontLoading: {
      heading: "Failed to load font",
      body: "The following fonts could not be loaded: ${error}",
      buttonNo: "Close"
    },
    webcamUnavailable: {
      body: "Unable to display webcam image (Error: ${error})",
      buttonYes: "Close"
    },
    stickerLoading: {
      body: "Unable to load the sticker",
      buttonNo: "Close"
    },
    unexpectedError: {
      body: "An unexpected error has occured ${error}",
      buttonYes: "Reload"
    }
  },
  warningModals: {
    imageResized: {
      heading: "Image resized",
      body: "Your image has been resized to ${width}x${height} pixels"
    },
    unsupportedSerializationVersion: {
      body: "Your data was restored from a legacy data format and might look different",
      buttonYes: "Apply changes",
      buttonNo: "Cancel"
    },
    discardChanges: {
      body: "You have unsaved changes. Are you sure you want to discard the changes?",
      buttonYes: "Discard changes",
      buttonNo: "Keep Changes"
    },
    unsavedChanges: {
      body: "You have unsaved changes. Are you sure you want to exit?",
      buttonYes: "Exit without saving",
      buttonNo: "Cancel"
    }
  },
  library: {
    title: "Library",
    controls: {
      buttonUpload: "Upload Image",
      buttonWebcamOpen: "Open Webcam",
      buttonWebcamClose: "Close Webcam",
      placeholderSearch: "Search Library",
      noResults: "No Results"
    }
  },
  filter: {
    title: "Filters",
    controls: {
      buttonReset: "Remove Filter",
      sliderIntensity: "Filter Intensity"
    },
    categories: {
      imgly_filter_category_duotone: "DuoTone",
      imgly_filter_category_bw: "B & W",
      imgly_filter_category_vintage: "Vintage",
      imgly_filter_category_smooth: "Smooth",
      imgly_filter_category_cold: "Cold",
      imgly_filter_category_warm: "Warm",
      imgly_filter_category_legacy: "Legacy"
    },
    items: {
      imgly_lut_celsius: "Inferno",
      imgly_lut_chest: "Chestnut",
      imgly_lut_fixie: "Fixie",
      imgly_lut_fridge: "Fridge",
      imgly_lut_front: "Sunny 70s",
      imgly_lut_k2: "Flat Black",
      imgly_lut_mellow: "Mellow",
      imgly_lut_sin: "Hard Stuff",
      imgly_lut_texas: "Oldtimer",
      imgly_lut_ad1920: "1920 A.D.",
      imgly_lut_ancient: "Ancient",
      imgly_lut_bleached: "Kalmen",
      imgly_lut_bleachedblue: "Joran",
      imgly_lut_blues: "Polaroid",
      imgly_lut_blueshadows: "Zephyr",
      imgly_lut_breeze: "Levante",
      imgly_lut_bw: "Greyed",
      imgly_lut_classic: "Classic",
      imgly_lut_colorful: "Colorful",
      imgly_lut_cool: "Snappy",
      imgly_lut_cottoncandy: "Candy",
      imgly_lut_creamy: "Creamy",
      imgly_lut_eighties: "Low Fire",
      imgly_lut_elder: "Colla",
      imgly_lut_evening: "Sunrise",
      imgly_lut_fall: "Moss",
      imgly_lut_food: "Food",
      imgly_lut_glam: "Glam",
      imgly_lut_gobblin: "Gobblin",
      imgly_lut_highcarb: "High Carb",
      imgly_lut_highcontrast: "Hicon",
      imgly_lut_k1: "K1",
      imgly_lut_k6: "K6",
      imgly_lut_kdynamic: "Pebble",
      imgly_lut_keen: "Keen",
      imgly_lut_lenin: "Lemon",
      imgly_lut_litho: "Litho",
      imgly_lut_lomo: "Lomo",
      imgly_lut_lomo100: "Lomo 100",
      imgly_lut_lucid: "Lucid",
      imgly_lut_neat: "Neat",
      imgly_lut_nogreen: "Pumpkin",
      imgly_lut_orchid: "Solanus",
      imgly_lut_pale: "Pale",
      imgly_lut_pitched: "Pitched",
      imgly_lut_plate: "Weathered",
      imgly_lut_pola669: "Green Gap",
      imgly_lut_polasx: "Pola SX",
      imgly_lut_pro400: "Pro 400",
      imgly_lut_quozi: "Quozi",
      imgly_lut_sepiahigh: "Sepia",
      imgly_lut_settled: "Settled",
      imgly_lut_seventies: "Seventies",
      imgly_lut_soft: "Soft",
      imgly_lut_steel: "Steel",
      imgly_lut_summer: "Summer",
      imgly_lut_sunset: "Golden",
      imgly_lut_tender: "Tender",
      imgly_lut_twilight: "Twilight",
      imgly_lut_winter: "Softy",
      imgly_lut_x400: "Dusty",
      imgly_duotone_desert: "Desert",
      imgly_duotone_peach: "Peach",
      imgly_duotone_clash: "Clash",
      imgly_duotone_plum: "Plum",
      imgly_duotone_breezy: "Breezy",
      imgly_duotone_deepblue: "Deep Blue",
      imgly_duotone_frog: "Frog",
      imgly_duotone_sunset: "Sunset"
    }
  },
  adjustment: {
    title: "Adjust",
    controls: {
      buttonReset: "Reset Adjustment"
    },
    categories: {
      basics: "Basic",
      refinements: "Refinements"
    },
    items: {
      brightness: "Brightness",
      saturation: "Saturation",
      contrast: "Contrast",
      gamma: "Gamma",
      sharpness: "Sharpness",
      clarity: "Clarity",
      exposure: "Exposure",
      shadows: "Shadows",
      highlights: "Highlights",
      whites: "Whites",
      blacks: "Blacks",
      temperature: "Temperature"
    }
  },
  focus: {
    title: "Focus",
    controls: {
      buttonReset: "Remove Focus",
      sliderIntensity: "Focus Intensity"
    },
    items: {
      radial: "Radial",
      mirrored: "Mirrored",
      linear: "Linear",
      gaussian: "Gaussian"
    },
    history: {
      focusPosition: "Focus Position",
      focusSize: "Focus Size"
    }
  },
  overlay: {
    title: "Overlays",
    controls: {
      buttonReset: "Remove Overlay",
      sliderOpacity: "Overlay Opacity",
      carouselBlendMode: "Overlay Blend mode",
      blendModeNormal: "Normal",
      blendModeOverlay: "Overlay",
      blendModeHardLight: "Hard Light",
      blendModeSoftLight: "Soft Light",
      blendModeMultiply: "Multiply",
      blendModeDarken: "Darken",
      blendModeLighten: "Lighten",
      blendModeScreen: "Screen",
      blendModeColorBurn: "Color Burn",
      tabOpacity: "Opacity",
      tabBlendMode: "Blend Mode"
    },
    items: {
      imgly_overlay_bokeh: "Bokeh",
      imgly_overlay_chop: "Chop",
      imgly_overlay_clouds: "Clouds",
      imgly_overlay_golden: "Golden",
      imgly_overlay_grain: "Grain",
      imgly_overlay_hearts: "Hearts",
      imgly_overlay_lightleak1: "Light Leak 1",
      imgly_overlay_lightleak2: "Light Leak 2",
      imgly_overlay_metal: "Metal",
      imgly_overlay_mosaic: "Mosaic",
      imgly_overlay_painting: "Painting",
      imgly_overlay_paper: "Paper",
      imgly_overlay_rain: "Rain",
      imgly_overlay_vintage: "Vintage",
      imgly_overlay_wall1: "Wall",
      imgly_overlay_wall2: "Wall 2",
      imgly_overlay_wood: "Wood"
    }
  },
  sticker: {
    title: "Stickers",
    controls: {
      buttonUpload: "Upload Sticker",
      sliderOpacity: "Sticker Opacity",
      selectColor: "Sticker Color",
      tabColor: "Color",
      tabOpacity: "Opacity"
    },
    categories: {
      imgly_sticker_emoticons: "Emoticons",
      imgly_sticker_shapes: "Shapes",
      imgly_sticker_custom: "Custom"
    },
    items: {
      imgly_sticker_emoticons_alien: "Alien",
      imgly_sticker_emoticons_angel: "Angel",
      imgly_sticker_emoticons_angry: "Angry",
      imgly_sticker_emoticons_anxious: "Anxious",
      imgly_sticker_emoticons_asleep: "Asleep",
      imgly_sticker_emoticons_attention: "Attention",
      imgly_sticker_emoticons_baby_chicken: "Baby Chicken",
      imgly_sticker_emoticons_batman: "Batman",
      imgly_sticker_emoticons_beer: "Beer",
      imgly_sticker_emoticons_black: "Black",
      imgly_sticker_emoticons_blue: "Blue",
      imgly_sticker_emoticons_blush: "Blush",
      imgly_sticker_emoticons_boxer: "Boxer",
      imgly_sticker_emoticons_business: "Business",
      imgly_sticker_emoticons_chicken: "Chicken",
      imgly_sticker_emoticons_cool: "Cool",
      imgly_sticker_emoticons_cry: "Cry",
      imgly_sticker_emoticons_deceased: "Deceased",
      imgly_sticker_emoticons_devil: "Devil",
      imgly_sticker_emoticons_duckface: "Duckface",
      imgly_sticker_emoticons_furious: "Furious",
      imgly_sticker_emoticons_grin: "Grin",
      imgly_sticker_emoticons_guitar: "Guitar",
      imgly_sticker_emoticons_harry_potter: "Harry Potter",
      imgly_sticker_emoticons_hippie: "Hippie",
      imgly_sticker_emoticons_hitman: "Hitman",
      imgly_sticker_emoticons_humourous: "Humourous",
      imgly_sticker_emoticons_idea: "Idea",
      imgly_sticker_emoticons_impatient: "Impatient",
      imgly_sticker_emoticons_kiss: "Kiss",
      imgly_sticker_emoticons_kisses: "Kisses",
      imgly_sticker_emoticons_laugh: "Laugh",
      imgly_sticker_emoticons_loud_cry: "Loud Cry",
      imgly_sticker_emoticons_loving: "Loving",
      imgly_sticker_emoticons_masked: "Masked",
      imgly_sticker_emoticons_music: "Music",
      imgly_sticker_emoticons_nerd: "Nerd",
      imgly_sticker_emoticons_ninja: "Ninja",
      imgly_sticker_emoticons_not_speaking_to_you: "Not speaking to you",
      imgly_sticker_emoticons_pig: "Pig",
      imgly_sticker_emoticons_pumpkin: "Pumpkin",
      imgly_sticker_emoticons_question: "Question",
      imgly_sticker_emoticons_rabbit: "Rabbit",
      imgly_sticker_emoticons_sad: "Sad",
      imgly_sticker_emoticons_sick: "Sick",
      imgly_sticker_emoticons_skateboard: "Skateboard",
      imgly_sticker_emoticons_skull: "Skull",
      imgly_sticker_emoticons_sleepy: "Sleepy",
      imgly_sticker_emoticons_smile: "Smile",
      imgly_sticker_emoticons_smoking: "Smoking",
      imgly_sticker_emoticons_sobbing: "Sobbing",
      imgly_sticker_emoticons_star: "Star",
      imgly_sticker_emoticons_steaming_furious: "Steaming Furious",
      imgly_sticker_emoticons_sunbathing: "Sunbathing",
      imgly_sticker_emoticons_tired: "Tired",
      imgly_sticker_emoticons_tongue_out_wink: "Tongue out wink",
      imgly_sticker_emoticons_wave: "Wave",
      imgly_sticker_emoticons_wide_grin: "Wide Grin",
      imgly_sticker_emoticons_wink: "Wink",
      imgly_sticker_emoticons_wrestler: "Wrestler",
      imgly_sticker_shapes_arrow_02: "Arrow 1",
      imgly_sticker_shapes_arrow_03: "Arrow 2",
      imgly_sticker_shapes_badge_01: "Badge 1",
      imgly_sticker_shapes_badge_11: "Badge 5",
      imgly_sticker_shapes_badge_12: "Badge 6",
      imgly_sticker_shapes_badge_13: "Badge 7",
      imgly_sticker_shapes_badge_15: "Badge 8",
      imgly_sticker_shapes_badge_18: "Badge 9",
      imgly_sticker_shapes_badge_19: "Badge 10",
      imgly_sticker_shapes_badge_20: "Badge 11",
      imgly_sticker_shapes_badge_28: "Badge 12",
      imgly_sticker_shapes_badge_32: "Badge 13",
      imgly_sticker_shapes_badge_35: "Badge 14",
      imgly_sticker_shapes_badge_36: "Badge 15",
      imgly_sticker_shapes_badge_04: "Badge 2",
      imgly_sticker_shapes_badge_06: "Badge 3",
      imgly_sticker_shapes_badge_08: "Badge 4",
      imgly_sticker_shapes_spray_01: "Spray 1",
      imgly_sticker_shapes_spray_03: "Spray 2",
      imgly_sticker_shapes_spray_04: "Spray 3"
    },
    canvasActions: {
      buttonDelete: "Delete",
      buttonBringToFront: "Move to front",
      buttonDuplicate: "Duplicate",
      buttonFlipHorizontal: "Flip",
      buttonFlipVertical: "Flip"
    },
    history: {
      add: "Sticker",
      resize: "Sticker resize",
      position: "Sticker position",
      color: "Sticker color",
      delete: "Sticker delete",
      order: "Sticker order",
      opacity: "Sticker opacity",
      flip: "Sticker flip"
    }
  },
  text: {
    title: "Text",
    controls: {
      buttonNew: "New Text",
      dropdownFontFamily: "Font Family",
      textFontSize: "Font Size",
      selectAlignment: "Alignment",
      selectFontColor: "Font Color",
      selectBackgroundColor: "Background Color",
      sliderLineSpacing: "Line Spacing",
      tabColor: "Color",
      tabBgColor: "Bg Color",
      tabAlignment: "Alignment",
      tabLineHeight: "Line Height",
      tabFontSize: "Font Size"
    },
    canvasControls: {
      placeholderText: "Write Something",
      buttonSave: "Done",
      buttonClose: "Cancel",
      inputText: "Text Input"
    },
    canvasActions: {
      buttonEdit: "Edit",
      buttonDelete: "Delete",
      buttonBringToFront: "Move to front",
      buttonDuplicate: "Duplicate"
    },
    history: {
      add: "Text",
      edit: "Text edit",
      resize: "Text resize",
      position: "Text position",
      alignment: "Text alignment",
      textColor: "Text color",
      backgroundColor: "Text background color",
      fontFamily: "Font family",
      fontStyle: "Font style",
      lineSpacing: "Line spacing",
      width: "Text width",
      delete: "Text delete",
      order: "Text order"
    }
  },
  textdesign: {
    title: "Text Design",
    controls: {
      buttonNew: "New Text Design",
      buttonShuffle: "Shuffle Layout",
      selectColor: "Text Color",
      tabColor: "Color",
      tabShuffle: "Shuffle"
    },
    canvasControls: {
      placeholderText: "Write Something With Style",
      buttonSave: "Done",
      buttonClose: "Schließen",
      inputText: "Text Input"
    },
    canvasActions: {
      buttonEdit: "Edit",
      buttonInvert: "Invert",
      buttonDelete: "Delete",
      buttonBringToFront: "Move to front",
      buttonDuplicate: "Duplicate"
    },
    history: {
      add: "Text design",
      edit: "Text design edit",
      resize: "Text design resize",
      position: "Text design position",
      color: "Text design color",
      shuffle: "Text design shuffle",
      invert: "Text design invert",
      padding: "Text design padding",
      order: "Text design order",
      delete: "Text design delete"
    }
  },
  frame: {
    title: "Frames",
    controls: {
      buttonReset: "Remove Frame",
      sliderOpacity: "Frame Opacity",
      sliderSize: "Frame Size",
      selectColor: "Frame Color",
      tabColor: "Color",
      tabOpacity: "Opacity",
      tabSize: "Size"
    },
    items: {
      imgly_frame_dia: "Dia",
      imgly_frame_art_decor: "Art Decor",
      imgly_frame_black_passepartout: "Black",
      imgly_frame_lowpoly_shadow: "Low Poly",
      imgly_frame_wood_passepartout: "Wood"
    }
  },
  brush: {
    title: "Brush",
    controls: {
      buttonReset: "Remove Brush",
      sliderSize: "Brush Size",
      sliderHardness: "Brush Hardness",
      selectColor: "Brush Color",
      tabSize: "Size",
      tabHardness: "Hardness",
      tabColor: "Color"
    },
    history: {
      brushStroke: "Brush Stroke"
    }
  },
  transform: {
    title: "Transform",
    controls: {
      buttonReset: "Reset to default",
      checkboxKeepResolution: "Keep Resolution",
      inputCropSize: "Crop Size",
      inputHeight: "h",
      inputWidth: "w",
      tabFlipAndRotate: "Flip & Rotate",
      tabResolution: "Resolution",
      tabCropSize: "Crop Size"
    },
    categories: {
      imgly_transforms_common: "Common",
      imgly_transforms_facebook: "Facebook",
      imgly_transforms_twitter: "Twitter",
      imgly_transforms_instagram: "Instagram"
    },
    items: {
      imgly_transform_common_custom: "Custom",
      imgly_transform_common_square: "Square",
      imgly_transform_common_4: "4:3",
      imgly_transform_common_16: "16:9",
      imgly_transform_common_3: "3:4",
      imgly_transform_common_9: "9:16",
      imgly_transform_facebook_profile: "Profile",
      imgly_transform_facebook_title: "Title",
      imgly_transform_facebook_post: "Post",
      imgly_transform_instagram_story: "Story",
      imgly_transform_instagram_landscape: "Landscape",
      imgly_transform_instagram_portrait: "Portrait",
      imgly_transform_instagram_square: "Square",
      imgly_transform_twitter_profile: "Profile",
      imgly_transform_twitter_title: "Title",
      imgly_transform_twitter_post: "Post"
    },
    transformActions: {
      buttonFlipHorizontal: "Flip Horizontal",
      buttonFlipVertical: "Flip Vertical",
      buttonRotateClockwise: "Rotate Clockwise",
      buttonRotateAntiClockwise: "Rotate Counterclockwise"
    }
  }
},
    zs = {
  common: {
    error: "Fehler",
    warning: "Warnung",
    color: {
      colorPicker: {
        hex: "Hex",
        r: "R",
        g: "G",
        b: "B",
        sliderHue: "Farbe",
        sliderOpacity: "Farbe Transparenz"
      }
    }
  },
  mainCanvasActions: {
    buttonExport: "Bild Exportieren",
    buttonUndo: "Rückgängig machen",
    buttonRedo: "Wiederholen",
    buttonClose: "Schließen"
  },
  infoModals: {
    exporting: {
      heading: "Exportieren...",
      body: "Einen Moment bitte..."
    },
    saving: {
      heading: "Speichere...",
      body: "Einen Moment bitte..."
    },
    loading: {
      heading: "Lade...",
      body: "Einen Moment bitte..."
    },
    resizing: {
      heading: "Bild wird bearbeitet...",
      body: "Einen Moment bitte..."
    },
    loadingFonts: {
      heading: "Lade Schriftarten...",
      body: "Einen Moment bitte..."
    }
  },
  errorModals: {
    imageLoading: {
      body: "Laden des Bildes fehlgeschlagen. Dies kann verschiedene Gründe haben, beispielsweise kann die Datei defekt sein oder der Dateityp wird nicht unterstützt",
      buttonYes: "Neu Laden"
    },
    rendering: {
      body: "Beim Rendern des Bildes ist ein Fehler aufgetreten",
      buttonYes: "Neu Laden"
    },
    fontLoading: {
      heading: "Laden von Schriftarten ist fehlgeschlagen",
      body: "Die folgenden Schriftarten konnten nicht geladen werden: ${error}",
      buttonNo: "Schließen"
    },
    webcamUnavailable: {
      body: "Webcam-Bild kann nicht dargestellt werden. (Fehler: ${error})",
      buttonYes: "Schließen"
    },
    stickerLoading: {
      body: "Laden des Stickers fehlgeschlagen.",
      buttonNo: "Schließen"
    },
    unexpectedError: {
      body: "Ein unerwarteter Fehler ist aufgetreten, ${error}",
      buttonYes: "Neu Laden"
    }
  },
  warningModals: {
    imageResized: {
      heading: "Bild verkleinert",
      body: "Das Bild wurde es auf ${width}x${height} Pixel verkleinert"
    },
    discardChanges: {
      body: "Sind Sie sicher, dass Sie die Änderungen verwerfen wollen?",
      buttonYes: "Änderungen verwerfen",
      buttonNo: "Änderungen beibehalten"
    },
    unsavedChanges: {
      body: "Sind Sie sicher, dass Sie die Änderungen verwerfen wollen?",
      buttonYes: "Beenden ohne zu speichern",
      buttonNo: "Schließen"
    },
    unsupportedSerializationVersion: {
      body: "Ihre Daten wurden von einem veralteten Format geladen und könnten anders aussehen",
      buttonYes: "Änderungen anwenden",
      buttonNo: "Abbrechen"
    }
  },
  library: {
    title: "Bibliothek",
    controls: {
      buttonUpload: "Bild Hochladen",
      buttonWebcamOpen: "Webcam Öffnen",
      buttonWebcamClose: "Webcam Schließen",
      placeholderSearch: "Bibliothek durchsuchen",
      noResults: "Keine Ergebnisse"
    }
  },
  filter: {
    title: "Filter",
    controls: {
      buttonReset: "Zurücksetzen",
      sliderIntensity: "Filter Intensität"
    },
    categories: {
      imgly_filter_category_duotone: "DuoTone",
      imgly_filter_category_bw: "B & W",
      imgly_filter_category_vintage: "Vintage",
      imgly_filter_category_smooth: "Smooth",
      imgly_filter_category_cold: "Cold",
      imgly_filter_category_warm: "Warm",
      imgly_filter_category_legacy: "Legacy"
    },
    items: {
      imgly_lut_celsius: "Inferno",
      imgly_lut_chest: "Chestnut",
      imgly_lut_fixie: "Fixie",
      imgly_lut_fridge: "Fridge",
      imgly_lut_front: "Sunny 70s",
      imgly_lut_k2: "Flat Black",
      imgly_lut_mellow: "Mellow",
      imgly_lut_sin: "Hard Stuff",
      imgly_lut_texas: "Oldtimer",
      imgly_lut_ad1920: "1920 A.D.",
      imgly_lut_ancient: "Ancient",
      imgly_lut_bleached: "Kalmen",
      imgly_lut_bleachedblue: "Joran",
      imgly_lut_blues: "Polaroid",
      imgly_lut_blueshadows: "Zephyr",
      imgly_lut_breeze: "Levante",
      imgly_lut_bw: "Greyed",
      imgly_lut_classic: "Classic",
      imgly_lut_colorful: "Colorful",
      imgly_lut_cool: "Snappy",
      imgly_lut_cottoncandy: "Candy",
      imgly_lut_creamy: "Creamy",
      imgly_lut_eighties: "Low Fire",
      imgly_lut_elder: "Colla",
      imgly_lut_evening: "Sunrise",
      imgly_lut_fall: "Moss",
      imgly_lut_food: "Food",
      imgly_lut_glam: "Glam",
      imgly_lut_gobblin: "Gobblin",
      imgly_lut_highcarb: "High Carb",
      imgly_lut_highcontrast: "Hicon",
      imgly_lut_k1: "K1",
      imgly_lut_k6: "K6",
      imgly_lut_kdynamic: "Pebble",
      imgly_lut_keen: "Keen",
      imgly_lut_lenin: "Lemon",
      imgly_lut_litho: "Litho",
      imgly_lut_lomo: "Lomo",
      imgly_lut_lomo100: "Lomo 100",
      imgly_lut_lucid: "Lucid",
      imgly_lut_neat: "Neat",
      imgly_lut_nogreen: "Pumpkin",
      imgly_lut_orchid: "Solanus",
      imgly_lut_pale: "Pale",
      imgly_lut_pitched: "Pitched",
      imgly_lut_plate: "Weathered",
      imgly_lut_pola669: "Green Gap",
      imgly_lut_polasx: "Pola SX",
      imgly_lut_pro400: "Pro 400",
      imgly_lut_quozi: "Quozi",
      imgly_lut_sepiahigh: "Sepia",
      imgly_lut_settled: "Settled",
      imgly_lut_seventies: "Seventies",
      imgly_lut_soft: "Soft",
      imgly_lut_steel: "Steel",
      imgly_lut_summer: "Summer",
      imgly_lut_sunset: "Golden",
      imgly_lut_tender: "Tender",
      imgly_lut_twilight: "Twilight",
      imgly_lut_winter: "Softy",
      imgly_lut_x400: "Dusty",
      imgly_duotone_desert: "Desert",
      imgly_duotone_peach: "Peach",
      imgly_duotone_clash: "Clash",
      imgly_duotone_plum: "Plum",
      imgly_duotone_breezy: "Breezy",
      imgly_duotone_deepblue: "Deep Blue",
      imgly_duotone_frog: "Frog",
      imgly_duotone_sunset: "Sunset"
    }
  },
  adjustment: {
    title: "Korrekturen",
    controls: {
      buttonReset: "Zurücksetzen"
    },
    categories: {
      basics: "Grundlagen",
      refinements: "Feinheiten"
    },
    items: {
      brightness: "Helligkeit",
      saturation: "Sättigung",
      contrast: "Kontrast",
      gamma: "Gamma",
      sharpness: "Schärfe",
      clarity: "Klarheit",
      exposure: "Belichtung",
      shadows: "Schatten",
      highlights: "Lichter",
      whites: "Weiß",
      blacks: "Schwarz",
      temperature: "Temperatur"
    }
  },
  focus: {
    title: "Weichzeichnen",
    controls: {
      buttonReset: "Zurücksetzen",
      sliderIntensity: "Focus Intensität"
    },
    items: {
      radial: "Kreisförmig",
      mirrored: "Gespiegelt",
      linear: "Linear",
      gaussian: "Gaußsch"
    },
    history: {
      focusPosition: "Focus Position",
      focusSize: "Focus Größe"
    }
  },
  overlay: {
    title: "Overlays",
    controls: {
      buttonReset: "Zurücksetzen",
      sliderOpacity: "Overlay Transparenz",
      carouselBlendMode: "Overlay Mischmodus",
      blendModeNormal: "Normal",
      blendModeOverlay: "Überblenden",
      blendModeHardLight: "Hartes Licht",
      blendModeSoftLight: "Weiches Licht",
      blendModeMultiply: "Multiplizieren",
      blendModeDarken: "Abdunkeln",
      blendModeLighten: "Aufhellen",
      blendModeScreen: "Screen",
      blendModeColorBurn: "Color Burn",
      tabOpacity: "Transparenz",
      tabBlendMode: "Mischmodus"
    },
    items: {
      imgly_overlay_bokeh: "Bokeh",
      imgly_overlay_chop: "Chop",
      imgly_overlay_clouds: "Clouds",
      imgly_overlay_golden: "Golden",
      imgly_overlay_grain: "Grain",
      imgly_overlay_hearts: "Hearts",
      imgly_overlay_lightleak1: "Light Leak 1",
      imgly_overlay_lightleak2: "Light Leak 2",
      imgly_overlay_metal: "Metal",
      imgly_overlay_mosaic: "Mosaic",
      imgly_overlay_painting: "Painting",
      imgly_overlay_paper: "Paper",
      imgly_overlay_rain: "Rain",
      imgly_overlay_vintage: "Vintage",
      imgly_overlay_wall1: "Wall",
      imgly_overlay_wall2: "Wall 2",
      imgly_overlay_wood: "Wood"
    }
  },
  sticker: {
    title: "Sticker",
    controls: {
      buttonUpload: "Sticker Hochladen",
      sliderOpacity: "Sticker Transparenz",
      selectColor: "Stickerfarbe",
      tabColor: "Farbe",
      tabOpacity: "Transparenz"
    },
    categories: {
      imgly_sticker_emoticons: "Emoticons",
      imgly_sticker_shapes: "Shapes",
      imgly_sticker_custom: "Custom"
    },
    items: {
      imgly_sticker_emoticons_alien: "Alien",
      imgly_sticker_emoticons_angel: "Angel",
      imgly_sticker_emoticons_angry: "Angry",
      imgly_sticker_emoticons_anxious: "Anxious",
      imgly_sticker_emoticons_asleep: "Asleep",
      imgly_sticker_emoticons_attention: "Attention",
      imgly_sticker_emoticons_baby_chicken: "Baby Chicken",
      imgly_sticker_emoticons_batman: "Batman",
      imgly_sticker_emoticons_beer: "Beer",
      imgly_sticker_emoticons_black: "Black",
      imgly_sticker_emoticons_blue: "Blue",
      imgly_sticker_emoticons_blush: "Blush",
      imgly_sticker_emoticons_boxer: "Boxer",
      imgly_sticker_emoticons_business: "Business",
      imgly_sticker_emoticons_chicken: "Chicken",
      imgly_sticker_emoticons_cool: "Cool",
      imgly_sticker_emoticons_cry: "Cry",
      imgly_sticker_emoticons_deceased: "Deceased",
      imgly_sticker_emoticons_devil: "Devil",
      imgly_sticker_emoticons_duckface: "Duckface",
      imgly_sticker_emoticons_furious: "Furious",
      imgly_sticker_emoticons_grin: "Grin",
      imgly_sticker_emoticons_guitar: "Guitar",
      imgly_sticker_emoticons_harry_potter: "Harry Potter",
      imgly_sticker_emoticons_hippie: "Hippie",
      imgly_sticker_emoticons_hitman: "Hitman",
      imgly_sticker_emoticons_humourous: "Humourous",
      imgly_sticker_emoticons_idea: "Idea",
      imgly_sticker_emoticons_impatient: "Impatient",
      imgly_sticker_emoticons_kiss: "Kiss",
      imgly_sticker_emoticons_kisses: "Kisses",
      imgly_sticker_emoticons_laugh: "Laugh",
      imgly_sticker_emoticons_loud_cry: "Loud Cry",
      imgly_sticker_emoticons_loving: "Loving",
      imgly_sticker_emoticons_masked: "Masked",
      imgly_sticker_emoticons_music: "Music",
      imgly_sticker_emoticons_nerd: "Nerd",
      imgly_sticker_emoticons_ninja: "Ninja",
      imgly_sticker_emoticons_not_speaking_to_you: "Not speaking to you",
      imgly_sticker_emoticons_pig: "Pig",
      imgly_sticker_emoticons_pumpkin: "Pumpkin",
      imgly_sticker_emoticons_question: "Question",
      imgly_sticker_emoticons_rabbit: "Rabbit",
      imgly_sticker_emoticons_sad: "Sad",
      imgly_sticker_emoticons_sick: "Sick",
      imgly_sticker_emoticons_skateboard: "Skateboard",
      imgly_sticker_emoticons_skull: "Skull",
      imgly_sticker_emoticons_sleepy: "Sleepy",
      imgly_sticker_emoticons_smile: "Smile",
      imgly_sticker_emoticons_smoking: "Smoking",
      imgly_sticker_emoticons_sobbing: "Sobbing",
      imgly_sticker_emoticons_star: "Star",
      imgly_sticker_emoticons_steaming_furious: "Steaming Furious",
      imgly_sticker_emoticons_sunbathing: "Sunbathing",
      imgly_sticker_emoticons_tired: "Tired",
      imgly_sticker_emoticons_tongue_out_wink: "Tongue out wink",
      imgly_sticker_emoticons_wave: "Wave",
      imgly_sticker_emoticons_wide_grin: "Wide Grin",
      imgly_sticker_emoticons_wink: "Wink",
      imgly_sticker_emoticons_wrestler: "Wrestler",
      imgly_sticker_shapes_arrow_02: "Arrow 1",
      imgly_sticker_shapes_arrow_03: "Arrow 2",
      imgly_sticker_shapes_badge_01: "Badge 1",
      imgly_sticker_shapes_badge_11: "Badge 5",
      imgly_sticker_shapes_badge_12: "Badge 6",
      imgly_sticker_shapes_badge_13: "Badge 7",
      imgly_sticker_shapes_badge_15: "Badge 8",
      imgly_sticker_shapes_badge_18: "Badge 9",
      imgly_sticker_shapes_badge_19: "Badge 10",
      imgly_sticker_shapes_badge_20: "Badge 11",
      imgly_sticker_shapes_badge_28: "Badge 12",
      imgly_sticker_shapes_badge_32: "Badge 13",
      imgly_sticker_shapes_badge_35: "Badge 14",
      imgly_sticker_shapes_badge_36: "Badge 15",
      imgly_sticker_shapes_badge_04: "Badge 2",
      imgly_sticker_shapes_badge_06: "Badge 3",
      imgly_sticker_shapes_badge_08: "Badge 4",
      imgly_sticker_shapes_spray_01: "Spray 1",
      imgly_sticker_shapes_spray_03: "Spray 2",
      imgly_sticker_shapes_spray_04: "Spray 3"
    },
    canvasActions: {
      buttonDelete: "Löschen",
      buttonBringToFront: "In den Vordergrund",
      buttonDuplicate: "Duplizieren",
      buttonFlipHorizontal: "Horizontal spiegeln",
      buttonFlipVertical: "Vertikal spiegeln"
    },
    history: {
      add: "Sticker",
      resize: "Sticker resize",
      position: "Sticker position",
      color: "Sticker color",
      delete: "Sticker delete",
      order: "Sticker order",
      opacity: "Sticker opacity",
      flip: "Sticker flip"
    }
  },
  text: {
    title: "Text",
    controls: {
      buttonNew: "Neuer Text",
      dropdownFontFamily: "Schriftart",
      textFontSize: "Schriftgröße",
      selectAlignment: "Ausrichtung",
      selectFontColor: "Schriftfarbe",
      selectBackgroundColor: "Hintergrundfarbe",
      sliderLineSpacing: "Zeilenabstand",
      tabColor: "Farbe",
      tabBgColor: "Hintergrund",
      tabAlignment: "Ausrichtung",
      tabLineHeight: "Zeilenhöhe",
      tabFontSize: "Schriftgröße"
    },
    canvasControls: {
      placeholderText: "Etwas aufschreiben",
      buttonSave: "Fertig",
      buttonClose: "Abbrechen",
      inputText: "Texteingabe"
    },
    canvasActions: {
      buttonEdit: "Bearbeiten",
      buttonDelete: "Löschen",
      buttonBringToFront: "In den Vordergrund",
      buttonDuplicate: "Duplizieren"
    },
    history: {
      add: "Text",
      edit: "Text edit",
      resize: "Text resize",
      position: "Text position",
      alignment: "Text alignment",
      textColor: "Text color",
      backgroundColor: "Text background color",
      fontFamily: "Font family",
      fontStyle: "Font style",
      lineSpacing: "Line spacing",
      width: "Text width",
      delete: "Text delete",
      order: "Text order"
    }
  },
  textdesign: {
    title: "Text Design",
    controls: {
      buttonNew: "Neues Text Design",
      buttonShuffle: "Shuffle Layout",
      selectColor: "Textfarbe",
      tabColor: "Farbe",
      tabShuffle: "Shuffle"
    },
    canvasControls: {
      placeholderText: "Etwas aufschreiben mit Style",
      buttonSave: "Done",
      buttonClose: "Schließen",
      inputText: "Texteingabe"
    },
    canvasActions: {
      buttonEdit: "Bearbeiten",
      buttonInvert: "Invertieren",
      buttonDelete: "Löschen",
      buttonBringToFront: "In den Vordergrund",
      buttonDuplicate: "Duplizieren"
    },
    history: {
      add: "Text design",
      edit: "Text design edit",
      resize: "Text design resize",
      position: "Text design position",
      color: "Text design color",
      shuffle: "Text design shuffle",
      invert: "Text design invert",
      padding: "Text design padding",
      order: "Text design order",
      delete: "Text design delete"
    }
  },
  frame: {
    title: "Rahmen",
    controls: {
      buttonReset: "Zurücksetzen",
      sliderOpacity: "Rahmen Transparenz",
      sliderSize: "Rahmen Dicke",
      selectColor: "Rahmen Farbe",
      tabColor: "Farbe",
      tabOpacity: "Transparenz",
      tabSize: "Dicke"
    },
    items: {
      imgly_frame_dia: "Dia",
      imgly_frame_art_decor: "Art Decor",
      imgly_frame_black_passepartout: "Black",
      imgly_frame_lowpoly_shadow: "Low Poly",
      imgly_frame_wood_passepartout: "Wood"
    }
  },
  brush: {
    title: "Malen",
    controls: {
      buttonReset: "Zurücksetzen",
      sliderSize: "Dicke",
      sliderHardness: "Härte",
      selectColor: "Farbe",
      tabSize: "Dicke",
      tabHardness: "Härte",
      tabColor: "Farbe"
    },
    history: {
      brushStroke: "Brush Stroke"
    }
  },
  transform: {
    title: "Zuschneiden",
    controls: {
      buttonReset: "Zurücksetzen",
      checkboxKeepResolution: "Fixiere Auflösung",
      inputCropSize: "Bildgröße",
      inputHeight: "h",
      inputWidth: "b",
      tabFlipAndRotate: "Spiegeln & Drehen",
      tabResolution: "Auflösung",
      tabCropSize: "Bildgröße"
    },
    categories: {
      imgly_transforms_common: "Standard",
      imgly_transforms_facebook: "Facebook",
      imgly_transforms_twitter: "Twitter",
      imgly_transforms_instagram: "Instagram"
    },
    items: {
      imgly_transform_common_custom: "Frei",
      imgly_transform_common_square: "Quadratisch",
      imgly_transform_common_4: "4:3",
      imgly_transform_common_16: "16:9",
      imgly_transform_common_3: "3:4",
      imgly_transform_common_9: "9:16",
      imgly_transform_facebook_profile: "Profile",
      imgly_transform_facebook_title: "Titel",
      imgly_transform_facebook_post: "Post",
      imgly_transform_instagram_story: "Story",
      imgly_transform_instagram_landscape: "Landscape",
      imgly_transform_instagram_portrait: "Portrait",
      imgly_transform_instagram_square: "Square",
      imgly_transform_twitter_profile: "Profile",
      imgly_transform_twitter_title: "Title",
      imgly_transform_twitter_post: "Post"
    },
    transformActions: {
      buttonFlipHorizontal: "Horizontal spiegeln",
      buttonFlipVertical: "Vertikal spiegeln",
      buttonRotateClockwise: "Drehe im Uhrzeigersinn",
      buttonRotateAntiClockwise: "Drehe gegen Uhrzeigersinn"
    }
  }
},
    Ls = function Ls(e) {
  return "de" === e ? zs : Ps;
},
    Bs = function () {
  function e() {}

  return e.addScrollStyles = function (t) {
    void 0 === t && (t = "rgba(255, 255, 255, 0.2)");
    var n = "\n    /* Injected by PhotoEditorSDK */\n    " + e.styles(t) + "\n  ",
        i = document.createElement("style");
    i.innerHTML = n, document.head.appendChild(i);
  }, e.styles = function (e) {
    return "\n    [data-simplebar] {\n      position: relative;\n      flex-direction: column;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      align-content: flex-start;\n      align-items: flex-start;\n    }\n\n    .photoeditorsdk-simplebar-wrapper {\n      overflow: hidden;\n      width: inherit;\n      height: inherit;\n      max-width: inherit;\n      max-height: inherit;\n    }\n\n    .photoeditorsdk-simplebar-mask {\n      direction: inherit;\n      position: absolute;\n      padding: 0;\n      margin: 0;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      width: auto !important;\n      height: auto !important;\n      z-index: 0;\n    }\n\n    .photoeditorsdk-simplebar-offset {\n      direction: inherit !important;\n      box-sizing: inherit !important;\n      resize: none !important;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      padding: 0;\n      margin: 0;\n      -webkit-overflow-scrolling: touch;\n    }\n\n    .photoeditorsdk-simplebar-content-wrapper {\n      direction: inherit;\n      box-sizing: border-box !important;\n      position: relative;\n      display: block;\n      height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n      width: auto;\n      visibility: visible;\n      overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\n      max-width: 100%; /* Not required for horizontal scroll to trigger */\n      max-height: 100%; /* Needed for vertical scroll to trigger */\n    }\n\n    .photoeditorsdk-simplebar-content:before,\n    .photoeditorsdk-simplebar-content:after {\n      content: ' ';\n      display: table;\n    }\n\n    .photoeditorsdk-simplebar-placeholder {\n      max-height: 100%;\n      max-width: 100%;\n      width: 100%;\n      pointer-events: none;\n    }\n\n    .photoeditorsdk-simplebar-height-auto-observer-wrapper {\n      box-sizing: inherit !important;\n      height: 100%;\n      width: 100%;\n      max-width: 1px;\n      position: relative;\n      float: left;\n      max-height: 1px;\n      overflow: hidden;\n      z-index: -1;\n      padding: 0;\n      margin: 0;\n      pointer-events: none;\n      flex-grow: inherit;\n      flex-shrink: 0;\n      flex-basis: 0;\n    }\n\n    .photoeditorsdk-simplebar-height-auto-observer {\n      box-sizing: inherit;\n      display: block;\n      opacity: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 1000%;\n      width: 1000%;\n      min-height: 1px;\n      min-width: 1px;\n      overflow: hidden;\n      pointer-events: none;\n      z-index: -1;\n    }\n\n    .photoeditorsdk-simplebar-track {\n      z-index: 1;\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      pointer-events: none;\n      overflow: hidden;\n    }\n\n    [data-simplebar].photoeditorsdk-simplebar-dragging .photoeditorsdk-simplebar-track {\n      pointer-events: all;\n    }\n\n    .photoeditorsdk-simplebar-scrollbar {\n      position: absolute;\n      right: 2px;\n      width: 7px;\n      min-height: 10px;\n    }\n\n    .photoeditorsdk-simplebar-scrollbar:before {\n      position: absolute;\n      content: '';\n      background: " + e + ";\n      border-radius: 7px;\n      left: 0;\n      right: 0;\n      opacity: 0;\n      transition: opacity 0.2s linear;\n    }\n\n    .photoeditorsdk-simplebar-track .photoeditorsdk-simplebar-scrollbar.photoeditorsdk-simplebar-visible:before {\n      /* When hovered, remove all transitions from drag handle */\n      opacity: 0.5;\n      transition: opacity 0s linear;\n    }\n\n    .photoeditorsdk-simplebar-track.photoeditorsdk-simplebar-vertical {\n      top: 0;\n      width: 11px;\n    }\n\n    .photoeditorsdk-simplebar-track.photoeditorsdk-simplebar-vertical .photoeditorsdk-simplebar-scrollbar:before {\n      top: 2px;\n      bottom: 2px;\n    }\n\n    .photoeditorsdk-simplebar-track.photoeditorsdk-simplebar-vertical .photoeditorsdk-simplebar-scrollbar {\n      right: 0px;\n      width: 4px;\n    }\n\n    .photoeditorsdk-simplebar-track.photoeditorsdk-simplebar-horizontal {\n      left: 0;\n      height: 11px;\n    }\n\n    .photoeditorsdk-simplebar-track.photoeditorsdk-simplebar-horizontal .photoeditorsdk-simplebar-scrollbar:before {\n      height: 100%;\n      left: 2px;\n      right: 2px;\n    }\n\n    .photoeditorsdk-simplebar-track.photoeditorsdk-simplebar-horizontal .photoeditorsdk-simplebar-scrollbar {\n      right: auto;\n      left: 0;\n      min-height: 0;\n      min-width: 10px;\n      width: auto;\n      top: 7px;\n      height: 4px;\n    }\n\n    /* Rtl support */\n    [data-simplebar-direction='rtl'] .photoeditorsdk-simplebar-track.photoeditorsdk-simplebar-vertical {\n      right: auto;\n      left: 0;\n    }\n\n    .photoeditorsdk-hs-dummy-scrollbar-size {\n      direction: rtl;\n      position: fixed;\n      opacity: 0;\n      visibility: hidden;\n      height: 500px;\n      width: 500px;\n      overflow-y: hidden;\n      overflow-x: scroll;\n    }\n  ";
  }, e;
}(),
    Ns = function Ns(e) {
  var t = void 0 === e ? {
    primary: "#365afc",
    background: "#0B0B0B",
    foreground: "#FFFFFF"
  } : e,
      n = t.primary,
      i = void 0 === n ? "#365afc" : n,
      r = t.background,
      o = void 0 === r ? "#0B0B0B" : r,
      a = t.foreground,
      s = void 0 === a ? "#FFFFFF" : a,
      l = "rgba(255, 255, 255, 0.90)",
      u = "rgba(255, 255, 255, 0.60)",
      c = "rgba(255, 255, 255, 0.38)";
  return {
    shape: {
      radiusSmall: 2,
      radiusMedium: 4,
      radiusLarge: 4
    },
    typography: {
      fontFamily: "Fira Sans",
      provider: "google"
    },
    background: o,
    foreground: s,
    primary: i,
    warning: "#ffba5c",
    error: "#c2393a",
    success: "#39c26c",
    focusOutlineColor: "rgba(255, 255, 255, 0.12)",
    scrollbar: {
      handleColor: "rgba(255, 255, 255, 0.2)"
    },
    button: {
      outlinedBorderColor: "#333333",
      activeForeground: i,
      containedPrimaryBackground: i,
      containedPrimaryForeground: l,
      outlinedPrimaryBackground: "#242424",
      outlinedPrimaryForeground: l,
      outlinedSecondaryBackground: "transparent",
      outlinedSecondaryForeground: u,
      textPrimaryForeground: i,
      textSecondaryForeground: u,
      outlinedInactiveOverlayColor: "rgba(0, 0, 0, 0.3)",
      textInactiveOpacity: "0.5",
      hoverOverlayColor: "rgba(255, 255, 255, 0.08)"
    },
    checkbox: {
      background: "#333333",
      foreground: s,
      activeForeground: s,
      activeBackground: i,
      inactiveOpacity: "0.3",
      hoverOpacity: "0.8"
    },
    modal: {
      background: "#242424",
      bodyForeground: l,
      headerForeground: u,
      backdrop: "rgba(0, 0, 0, 0.6)"
    },
    card: {
      background: "#333333",
      foreground: l,
      activeBorderColor: i,
      activeOverlayColor: "rgba(89, 121, 252, 0.20)",
      labelBackground: "linear-gradient(transparent, rgba(0, 0, 0, 0.6))",
      labelForeground: l,
      inactiveOverlayColor: "rgba(0, 0, 0, 0.3)",
      hoverOverlayColor: "rgba(255, 255, 255, 0.08)"
    },
    tabTitle: {
      foreground: u,
      background: "transparent",
      activeBackground: "transparent",
      activeBorderColor: i,
      activeForeground: l
    },
    dropdown: {
      background: "transparent",
      foreground: l,
      hoverBorderColor: u,
      borderColor: "#333333",
      caretColor: c,
      listBackground: "#333333",
      listBorderColor: "#333333",
      listItemHoverBackground: "#424242",
      listForeground: u,
      listShadow: "0 12px 17px 2px rgba(0,0,0,0.14),\n        0 5px 22px 4px rgba(0,0,0,0.12),\n        0 7px 8px -4px rgba(0,0,0,0.20)",
      inactiveOpacity: "0.3"
    },
    textInput: {
      foreground: l,
      hoverBorderColor: "rgba(255, 255, 255, 0.40)",
      background: "transparent",
      borderColor: "#333333",
      inactiveOpacity: "0.3"
    },
    slider: {
      trackColor: "rgba(255, 255, 255, 0.4)",
      activeTrackColor: i,
      thumbBackground: "#171717",
      thumbBorderColor: i,
      inactiveOpacity: "0.3",
      hoverOpacity: "0.7"
    },
    selectColor: {
      activeBorderColor: i,
      inactiveOpacity: "0.3"
    },
    toolbar: {
      foreground: l,
      background: "#242424",
      activeBackground: "transparent",
      activeForeground: i,
      borderColor: "transparent"
    },
    tooltip: {
      background: "#424242",
      foreground: l
    },
    toolControlBar: {
      background: "rgba(23, 23, 23, 0.9)",
      borderColor: "transparent",
      shadow: "none",
      separatorColor: "#333333",
      titleForeground: u,
      inputLabelForeground: u,
      inputLabelInactiveOpacity: "0.3"
    },
    mainCanvasActionBar: {
      background: "linear-gradient(0deg, transparent 0%,  rgba(0, 0, 0, 0.6) 98%)",
      foreground: l,
      borderColor: "none"
    },
    canvasActionBar: {
      background: "#424242",
      foreground: l,
      separatorColor: c
    },
    canvas: {
      background: "#0B0B0B",
      controlsOutline: "rgba(255, 255, 255, 0.5)",
      controlsColor: "#ffffff",
      cropBackdrop: "rgba(0, 0, 0, 0.5)"
    },
    colorPicker: {
      listBackground: "#333333",
      listShadow: "0 12px 17px 2px rgba(0,0,0,0.14),\n        0 5px 22px 4px rgba(0,0,0,0.12),\n        0 7px 8px -4px rgba(0,0,0,0.20)",
      controlsColor: "#ffffff",
      inputBorderColor: "#424242"
    },
    colorItem: {
      borderRadius: "2px",
      margin: "1px"
    },
    webcam: {
      backdrop: "rgba(0, 0, 0, 0.3)",
      floatButton: s,
      background: "#0B0B0B"
    },
    snapping: {
      positionGuideColor: "#f0f",
      rotationGuideColor: "#0ff"
    },
    transform: {
      crops: {
        main: "#424242",
        highlight: "#565656",
        shadow: "#333333"
      }
    }
  };
},
    Us = function Us(e) {
  var t = void 0 === e ? {
    primary: "#1e47fb",
    background: "#FBFBFB",
    foreground: "#000000"
  } : e,
      n = t.primary,
      i = void 0 === n ? "#1e47fb" : n,
      r = t.background,
      o = void 0 === r ? "#FBFBFB" : r,
      a = t.foreground,
      s = void 0 === a ? "#000000" : a,
      l = "rgba(0, 0, 0, 0.90)",
      u = "rgba(0, 0, 0, 0.60)",
      c = "rgba(0, 0, 0, 0.38)";
  return {
    shape: {
      radiusSmall: 2,
      radiusMedium: 4,
      radiusLarge: 4
    },
    typography: {
      fontFamily: "Fira Sans",
      provider: "google"
    },
    background: o,
    foreground: s,
    primary: i,
    warning: "#ffb045",
    error: "#c01a1b",
    success: "#17c658",
    focusOutlineColor: "rgba(125, 125, 125, 0.12)",
    scrollbar: {
      handleColor: "rgba(0, 0, 0, 0.2)"
    },
    button: {
      outlinedBorderColor: "#D4D4D4",
      activeForeground: i,
      containedPrimaryBackground: i,
      containedPrimaryForeground: "rgba(255, 255, 255, 0.9)",
      outlinedPrimaryBackground: "#E6E6E6",
      outlinedPrimaryForeground: l,
      outlinedSecondaryBackground: "transparent",
      outlinedSecondaryForeground: u,
      textPrimaryForeground: i,
      textSecondaryForeground: u,
      outlinedInactiveOverlayColor: "rgba(0, 0, 0, 0.3)",
      textInactiveOpacity: "0.5",
      hoverOverlayColor: "rgba(125, 125, 125, 0.12)"
    },
    checkbox: {
      background: "#D4D4D4",
      foreground: s,
      activeForeground: s,
      activeBackground: i,
      inactiveOpacity: "0.3",
      hoverOpacity: "0.8"
    },
    modal: {
      background: "#E6E6E6",
      bodyForeground: l,
      headerForeground: u,
      backdrop: "rgba(0, 0, 0, 0.6)"
    },
    card: {
      background: "#D4D4D4",
      foreground: l,
      activeBorderColor: i,
      activeOverlayColor: "rgba(30, 71, 251, 0.2)",
      labelBackground: "linear-gradient(transparent, rgba(0, 0, 0, 0.6))",
      labelForeground: "rgba(255, 255, 255, 0.87)",
      inactiveOverlayColor: "rgba(0, 0, 0, 0.3)",
      hoverOverlayColor: "rgba(125, 125, 125, 0.12)"
    },
    tabTitle: {
      foreground: u,
      background: "transparent",
      activeBackground: "transparent",
      activeBorderColor: i,
      activeForeground: l
    },
    dropdown: {
      background: "transparent",
      foreground: l,
      hoverBorderColor: u,
      borderColor: "#D4D4D4",
      listBackground: "#D4D4D4",
      caretColor: c,
      listForeground: u,
      listBorderColor: "#D4D4D4",
      listItemHoverBackground: "#CCCCCC",
      listShadow: "0 8px 10px 1px rgba(0,0,0,0.14),\n        0 3px 14px 2px rgba(0,0,0,0.12),\n        0 5px 5px -3px rgba(0,0,0,0.20)",
      inactiveOpacity: "0.3"
    },
    textInput: {
      foreground: l,
      hoverBorderColor: l,
      background: "transparent",
      borderColor: "#D4D4D4",
      inactiveOpacity: "0.3"
    },
    slider: {
      trackColor: "#CCCCCC",
      activeTrackColor: i,
      thumbBackground: "#EEEEEE",
      thumbBorderColor: i,
      inactiveOpacity: "0.3",
      hoverOpacity: "0.7"
    },
    selectColor: {
      activeBorderColor: i,
      inactiveOpacity: "0.3"
    },
    toolbar: {
      foreground: l,
      background: "#D4D4D4",
      activeBackground: "transparent",
      activeForeground: i,
      borderColor: "transparent"
    },
    tooltip: {
      background: "#CCCCCC",
      foreground: l
    },
    toolControlBar: {
      background: "rgba(238, 238, 238, 0.9)",
      borderColor: "#EEEEEE",
      shadow: "none",
      separatorColor: "#D4D4D4",
      titleForeground: u,
      inputLabelForeground: u,
      inputLabelInactiveOpacity: "0.3"
    },
    mainCanvasActionBar: {
      background: "transparent",
      foreground: l,
      borderColor: "none"
    },
    canvasActionBar: {
      background: "#CCCCCC",
      foreground: l,
      separatorColor: c
    },
    canvas: {
      background: "#FBFBFB",
      controlsOutline: "rgba(255, 255, 255, 0.6)",
      controlsColor: "#ffffff",
      cropBackdrop: "rgba(255, 255, 255, 0.3)"
    },
    colorPicker: {
      listBackground: "#D4D4D4",
      listShadow: "0 8px 10px 1px rgba(0,0,0,0.14),\n        0 3px 14px 2px rgba(0,0,0,0.12),\n        0 5px 5px -3px rgba(0,0,0,0.20)",
      controlsColor: "#ffffff",
      inputBorderColor: "#CCCCCC"
    },
    colorItem: {
      borderRadius: "2px",
      margin: "1px"
    },
    webcam: {
      backdrop: "rgba(0, 0, 0, 0.3)",
      floatButton: s,
      background: "#FBFBFB"
    },
    snapping: {
      positionGuideColor: "#f0f",
      rotationGuideColor: "#0ff"
    },
    transform: {
      crops: {
        main: "#B8B8B8",
        highlight: "#E6E6E6",
        shadow: "#D4D4D4"
      }
    }
  };
},
    js = {
  headline1: {
    size: 16,
    letterSpacing: 1.5,
    case: "uppercase"
  },
  headline2: {
    size: 14,
    letterSpacing: .8,
    case: "uppercase"
  },
  body: {
    size: 13,
    letterSpacing: 0,
    case: "none"
  },
  label: {
    size: 13,
    letterSpacing: 0,
    case: "capitalize"
  },
  label2: {
    size: 12,
    letterSpacing: 0,
    case: "capitalize"
  },
  button1: {
    size: 12,
    letterSpacing: 1.2,
    case: "uppercase"
  },
  button2: {
    size: 14,
    letterSpacing: 0,
    case: "capitalize"
  }
},
    Ws = {
  toast: 2,
  controlsBar: 5,
  buttonGroup: 5,
  toolControlBar: 6,
  toolbar: 7,
  label: 10,
  disable: 11,
  canvas: {
    knob: 4,
    bar: 5,
    controls: 5,
    snappingGuide: 1,
    crop: {
      grid: 2,
      dragImage: 3,
      backdrop: 4
    },
    webcam: {
      backdrop: 7
    }
  },
  input: {
    list: 6
  },
  button: {
    float: 5
  },
  modal: {
    backdrop: 100
  },
  colorItem: {
    overlay: 2,
    background: 1,
    tiledBackground: 0
  }
},
    Hs = function Hs() {
  return {
    advancedUIToolbar: {
      width: 55,
      itemHeight: 48,
      seperatorHeight: 20,
      marginBottom: 0
    },
    advancedUIToolControlBar: {
      width: 230,
      padding: "16px 24px",
      marginBottom: 0
    },
    advancedCard: {
      small: {
        height: 166 / 3,
        width: 166 / 3
      },
      medium: {
        height: 87,
        width: 87
      },
      large: {
        height: 86,
        width: 182
      }
    },
    advancedSpacer: 8,
    basicCanvasOffset: 23,
    basicUIToolbar: {
      openHeight: 88,
      closeHeight: 35
    },
    basicToolControlBar: {
      itemsBarHeight: 72,
      controlsBarHeight: 80,
      maxHeight: 111,
      maxWidth: 300
    },
    basicCard: {
      medium: {
        height: 56,
        width: 90
      },
      large: {
        height: 60,
        width: 110
      }
    },
    basicSpacer: 8,
    mainCanvasActionBar: {
      height: 50
    },
    crop: {
      minSize: 50
    },
    canvas: {
      marginTop: 0
    },
    canvasControls: {
      sprite: {
        controlOffset: 16,
        rotateHandle: {
          height: 16
        },
        minSize: 30,
        controlPadding: 16
      },
      knob: {
        size: 16,
        touchable: {
          desktop: 24
        }
      },
      corner: {
        size: 14,
        touchable: {
          desktop: 24,
          mobile: 48
        },
        borderWidth: 4
      },
      width: {
        size: 14
      }
    },
    buttons: {
      float: {
        size: 56
      }
    },
    colorItem: {
      size: 20
    },
    color: {
      colorPicker: {
        width: 214,
        saturationSlider: {
          height: 150
        },
        thumb: {
          size: 14
        },
        arrow: {
          width: 36
        }
      }
    },
    fontSystem: js,
    zIndex: Ws
  };
},
    Gs = Ns(),
    Vs = Hs(),
    Xs = _v2(_v2({}, Gs), {
  measurements: Vs
}),
    Ys = function Ys(e, t) {
  var n = function (e) {
    return "light" === e ? Us : Ns;
  }(e);

  if (t && t[e]) {
    var i = t[e],
        r = {
      primary: i.primary,
      background: i.background,
      foreground: i.foreground
    };
    return Fs([n(Object.keys(r).reduce(function (e, t) {
      var n;
      return r[t] ? _v2(_v2({}, e), ((n = {})[t] = r[t], n)) : e;
    }, {})), t[e]]);
  }

  return n() || Gs;
},
    qs = ["canvas", "advancedUIToolbar", "advancedUIToolControlBar", "basicUIToolbar", "mainCanvasActionBar", "colorItem"],
    Ks = {
  config: tn,
  locale: Ps,
  theme: Gs,
  measurements: Vs
},
    Zs = function () {
  function e() {
    this.checkDefaultToolAvailability = function (e, t) {
      return -1 !== t.indexOf(e);
    }, this.state = ai(Ks), this.events = new Ds();
  }

  return e.prototype.saveConfig = function (e) {
    e.mainCanvasActions && 4 !== e.mainCanvasActions.length && (e.mainCanvasActions.length = 4);

    var t,
        n,
        i = Fs([tn, e]),
        r = (t = i.language, (n = i.custom.languages) && n[t] ? Fs([Ls(t), n[t]]) : Ls(t) || Ps),
        o = Ys(i.theme, i.custom.themes),
        a = function (e) {
      var t = Hs();

      if (e) {
        var n = {};
        return Object.keys(e).forEach(function (t) {
          -1 !== qs.indexOf(t) && (n[t] = e[t]);
        }), Fs([t, n]);
      }

      return t;
    }(i.custom.measurements),
        s = i.library.provider;

    delete i.language, delete i.custom.languages, delete i.custom.themes, delete i.library.provider;
    var l = i.tools.reduce(function (e, t) {
      return C(e, "object" == typeof t ? t : [t]);
    }, []);
    l.length || (console.error("Empty list input for tools"), l = en.reduce(function (e, t) {
      return C(e, "object" == typeof t ? t : [t]);
    }, [])), this.checkDefaultToolAvailability(i.defaultTool, l) || (console.warn("Configured default tool " + i.defaultTool + " is not a part of configured list of tools: " + l.join(" ") + ", using fallback default Tool " + l[0] + " is being used, pls change config.defaultTool to change the fallback tool")[i.defaultTool] = l), this.state.config = i, this.state.locale = r, this.state.theme = o, this.state.measurements = a, Bs.addScrollStyles(this.state.theme.scrollbar.handleColor);
    var u = this.buildCustomAssetsConfig();
    return this.assetProvider = new $e(u), this.loadThemeFont(), s;
  }, Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.state.config;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.state.locale;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "theme", {
    get: function get() {
      return this.state.theme;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "measurements", {
    get: function get() {
      return this.state.measurements;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "tools", {
    get: function get() {
      return this.config.tools.reduce(function (e, t) {
        return "string" == typeof t ? C(e, [t]) : C(e, [""], t);
      }, []);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "defaultTool", {
    get: function get() {
      return this.config.defaultTool;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isOrderDefault", {
    get: function get() {
      return "default" === this.config.order;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isLayoutAdvanced", {
    get: function get() {
      return "advanced" === this.config.layout;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "displayCloseButton", {
    get: function get() {
      return -1 !== this.config.mainCanvasActions.indexOf(D.CLOSE);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.loadThemeFont = function () {
    var e = this.theme.typography;
    e.skipLoading || this.assetProvider.getFontManager().injectFonts([e]);
  }, e.prototype.buildCustomAssetsConfig = function () {
    var e = this.tools,
        t = xr(this.state.config),
        n = this.state.config.assetBaseUrl,
        i = this.state.theme,
        r = -1 !== e.indexOf(P.FILTER) ? t[P.FILTER] : void 0,
        o = -1 !== e.indexOf(P.FOCUS) ? t[P.FOCUS] : void 0,
        a = -1 !== e.indexOf(P.ADJUSTMENT) ? t[P.ADJUSTMENT] : void 0;
    return {
      basePath: n,
      theme: i,
      filter: r,
      focus: o,
      sticker: -1 !== e.indexOf(P.STICKER) ? t[P.STICKER] : void 0,
      frame: -1 !== e.indexOf(P.FRAME) ? t[P.FRAME] : void 0,
      overlay: -1 !== e.indexOf(P.OVERLAY) ? t[P.OVERLAY] : void 0,
      transform: -1 !== e.indexOf(P.TRANSFORM) ? t[P.TRANSFORM] : void 0,
      text: -1 !== e.indexOf(P.TEXT) ? t[P.TEXT] : void 0,
      adjustment: a,
      textdesign: -1 !== e.indexOf(P.TEXT_DESIGN) ? t[P.TEXT_DESIGN] : void 0
    };
  }, w([sr], e.prototype, "saveConfig", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "theme", null), w([fi], e.prototype, "measurements", null), w([fi], e.prototype, "tools", null), w([fi], e.prototype, "defaultTool", null), w([fi], e.prototype, "isOrderDefault", null), w([fi], e.prototype, "isLayoutAdvanced", null), w([fi], e.prototype, "displayCloseButton", null), e;
}(),
    Qs = function () {
  function e(e) {
    this.editor = e;
  }

  return e.prototype.setBackgroundImage = function (e) {
    this.container ? this.container.setData({
      image: e,
      originalImage: e
    }) : this.container = this.engine.addImage({
      image: e,
      originalImage: e,
      blendMode: re.NORMAL,
      opacity: 1
    });
  }, e.prototype.getchildren = function () {
    return this.container.getChildren();
  }, e.prototype.addImageToContainer = function () {
    var e = this;
    return new Promise(function (t, n) {
      var i = e.editor.activeStore.image;
      if (function (e) {
        return e instanceof HTMLImageElement;
      }(i)) e.setBackgroundImage(i), t();else {
        var r = e.editor.libraryStore.getRawUrl(i);
        e.getImageElement(r).then(function (n) {
          e.setBackgroundImage(n), t();
        }).catch(function (e) {
          n({
            identifier: "imageLoading",
            message: e.message
          });
        });
      }
    });
  }, e.prototype.getImageElement = function (e) {
    var t = this;
    return new Promise(function (n, i) {
      var r = new Image();
      r.addEventListener("load", function () {
        n(r);
      }), r.addEventListener("error", function (e) {
        i(e);
      }), r.crossOrigin = t.editor.configStore.config.engine.crossOrigin, r.src = e;
    });
  }, e.prototype.getImgageContainerId = function () {
    return this.container ? this.container.getID() : "";
  }, Object.defineProperty(e.prototype, "engine", {
    get: function get() {
      return this.editor.engine;
    },
    enumerable: !0,
    configurable: !0
  }), e;
}(),
    Js = function () {
  function e(e) {
    var t = this;
    this.applyNewImageTransform = function () {
      var e = t.editor.engineMediator.image.container.getBounds(),
          n = e.size,
          i = e.width,
          r = e.height,
          o = t.container;
      o.setTransform(O.IDENTITY), o.setResolution(n), o.setPivot(.5, .5), o.setPosition({
        x: i / 2,
        y: r / 2
      });
    }, this.editor = e;
  }

  return Object.defineProperty(e.prototype, "engine", {
    get: function get() {
      return this.editor.engine;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "container", {
    get: function get() {
      return this.engine.getOutputContainer();
    },
    enumerable: !0,
    configurable: !0
  }), e;
}();

function $s(e, t) {
  return e.width / e.height > t.width / t.height ? e.height / t.height : e.width / t.width;
}

var el,
    tl,
    nl = {
  transform: O.IDENTITY
},
    il = function () {
  function e(e) {
    this.initialTransform = O.IDENTITY, this.editor = e, this.state = ai(nl);
  }

  return e.prototype.createPreview = function (e) {
    this.container = this.editor.engine.createPreview(e);
  }, e.prototype.updateTransform = function (e, t) {
    void 0 === e && (e = 0), void 0 === t && (t = !0);
    var n = this.calculateTransform(e);
    return !!n.scale.x && (t ? this.saveInitialTransform(n) : this.savePreviewTransform(n), this.container.setTransform(this.state.transform), !0);
  }, e.prototype.saveInitialTransform = function (e) {
    this.initialTransform = e, this.savePreviewTransform(e);
  }, e.prototype.savePreviewTransform = function (e) {
    var t = this;
    lr(function () {
      t.state.transform.position = e.position, t.state.transform.scale = e.scale, t.state.transform.rotation = e.rotation;
      var n = Yl.devicePixelRatio;
      t.previewTransformWithoutDpr = {
        position: new R(e.position).divide(n),
        scale: new R(e.scale).divide(n),
        rotation: e.rotation
      };
    });
  }, Object.defineProperty(e.prototype, "transform", {
    get: function get() {
      return this.state.transform;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "position", {
    get: function get() {
      return this.state.transform.position;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "scale", {
    get: function get() {
      return this.state.transform.scale;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotation", {
    get: function get() {
      return this.state.transform.rotation;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.calculateTransform = function (e) {
    void 0 === e && (e = 0);
    var t = Yl.devicePixelRatio,
        n = this.editor.canvasStore.canvasSize,
        i = n.width,
        r = n.height,
        o = this.editor.engine.getOutputDimensions(),
        a = $s({
      width: i,
      height: r
    }, o),
        s = .95;
    window.innerWidth < 600 && (s = .98), a *= s;
    var l = r - o.height * a,
        u = 2 * this.editor.configStore.measurements.mainCanvasActionBar.height;
    return l < u && (a = $s({
      width: i,
      height: r - u
    }, o), a *= s), new O({
      x: i * t / 2,
      y: r * t / 2
    }, {
      x: a *= t,
      y: a
    }, e);
  }, w([sr], e.prototype, "updateTransform", null), w([sr], e.prototype, "savePreviewTransform", null), w([fi], e.prototype, "transform", null), w([fi], e.prototype, "position", null), w([fi], e.prototype, "scale", null), w([fi], e.prototype, "rotation", null), e;
}(),
    rl = function () {
  function e() {
    this.imageContainerOrder = [], this.spriteContainerOrder = [];
  }

  return e.checkTool = function (e) {
    if (-1 !== [P.STICKER, P.TEXT, P.TEXT_DESIGN, P.BRUSH, P.FRAME].indexOf(e)) throw new Error("addIndex is used for non sprites, for sprites use addSprite");
  }, e.remove = function (e, t) {
    var n = t.findIndex(function (t) {
      return t === e;
    });
    -1 !== n && t.splice(n, 1);
  }, e.indexForOrder = function (e, t, n) {
    var i = e[n],
        r = t.findIndex(function (e) {
      return e === n;
    });
    if (-1 !== r) return {
      index: r,
      order: t
    };
    var o = t.length;

    if (o) {
      var a = void 0;

      for (a = 0; a < o; a += 1) {
        if (i < e[t[a]]) return {
          index: a,
          order: t = C(t.slice(0, a), [n], t.slice(a))
        };
      }
    }

    return t.push(n), {
      index: t.length - 1,
      order: t
    };
  }, e.prototype.addIndex = function (t) {
    e.checkTool(t);
    var n = e.indexForOrder(e.IMAGE_CONTAINER_INDEX, this.imageContainerOrder, t),
        i = n.index,
        r = n.order;
    return this.imageContainerOrder = r, i;
  }, e.prototype.removeIndex = function (t) {
    e.checkTool(t), e.remove(t, this.imageContainerOrder);
  }, e.prototype.addSprite = function (e) {
    return this.spriteContainerOrder.push(e), this.imageContainerOrder.length + this.spriteContainerOrder.length - 1;
  }, e.prototype.removeSprite = function (t) {
    e.remove(t, this.spriteContainerOrder);
  }, e.prototype.renameSprite = function (e, t) {
    var n = this.spriteContainerOrder.findIndex(function (t) {
      return t === e;
    });
    -1 !== n && (this.spriteContainerOrder[n] = t);
  }, e.prototype.bringToFront = function (e) {
    var t = this.spriteContainerOrder.findIndex(function (t) {
      return t === e;
    });
    return -1 !== t && (this.spriteContainerOrder.splice(t, 1), this.spriteContainerOrder.push(e)), this.getLastSpriteIndex();
  }, e.prototype.getLastSpriteId = function () {
    var e = this.spriteContainerOrder.length;
    return this.spriteContainerOrder[e - 1];
  }, e.prototype.getSpriteIndex = function (e) {
    return this.spriteContainerOrder.findIndex(function (t) {
      return t === e;
    }) + this.imageContainerOrder.length - 1;
  }, e.prototype.getLastSpriteIndex = function () {
    return this.imageContainerOrder.length + this.spriteContainerOrder.length - 1;
  }, e.IMAGE_CONTAINER_INDEX = ((el = {})[P.ART_FILTER] = 0, el[P.FILTER] = 1, el[P.ADJUSTMENT] = 2, el[P.FOCUS] = 3, el[P.OVERLAY] = 4, el), e;
}(),
    ol = function () {
  function e(e) {
    this.orderHelper = new rl();
    var t = e.configStore.config.engine;
    this.engine = new qt(_v2(_v2({}, t), {
      license: e.configStore.config.license,
      assetProvider: e.configStore.assetProvider
    })), this.image = new Qs(e), this.output = new Js(e), this.preview = new il(e), this.editor = e;
  }

  return e.prototype.render = function (e) {
    return this.engine.render(e);
  }, e.prototype.previewSpaceToWorldSpace = function (e, t) {
    var n = this.preview.previewTransformWithoutDpr;

    if (M(e)) {
      var i = this.editor.engine.convertPointFromPreviewIntoWorldSpace(R.ZERO, n, t),
          r = this.editor.engine.convertPointFromPreviewIntoWorldSpace({
        x: e,
        y: 0
      }, n, t);
      return R.distance(new R(i), new R(r));
    }

    return this.editor.engine.convertPointFromPreviewIntoWorldSpace(e, n, t);
  }, e.prototype.worldSpaceToPreviewSpace = function (e) {
    var t = this.preview.previewTransformWithoutDpr;

    if (M(e)) {
      var n = this.editor.engine.convertPointFromWorldIntoPreviewSpace(R.ZERO, t),
          i = this.editor.engine.convertPointFromWorldIntoPreviewSpace({
        x: e,
        y: 0
      }, t);
      return R.distance(new R(n), new R(i));
    }

    return this.editor.engine.convertPointFromWorldIntoPreviewSpace(e, t);
  }, e.prototype.outputSpaceToWorldSpace = function (e) {
    return M(e) ? (t = e, n = this.editor.engine.getOutputContainer(), i = new R(t, 0), r = new R(st(i, n)), o = new R(st(R.ZERO, n)), R.distance(r, o)) : st(e, this.editor.engine.getOutputContainer());
    var t, n, i, r, o;
  }, e.prototype.previewSpaceToOutputSpace = function (e) {
    var t = this.preview.previewTransformWithoutDpr;

    if (M(e)) {
      var n = this.editor.engine.convertPointFromPreviewIntoOutputSpace(R.ZERO, t),
          i = this.editor.engine.convertPointFromPreviewIntoOutputSpace({
        x: e,
        y: 0
      }, t);
      return R.distance(new R(n), new R(i));
    }

    return this.editor.engine.convertPointFromPreviewIntoOutputSpace(e, t);
  }, e.prototype.previewSpaceToFlippedPreviewSpace = function (e) {
    return this.editor.engine.convertPointFromPreviewIntoFlippedPreviewSpace(e);
  }, e;
}(),
    al = function () {
  function e() {
    this.snapshots = [], this.observeIndex = ai.box(-1);
  }

  return e.prototype.addSnapshot = function (e) {
    this.index === this.snapshots.length - 1 ? this.snapshots = this.snapshots.concat(JSON.stringify(e)) : this.snapshots = C(this.snapshots.slice(0, this.index + 1), [JSON.stringify(e)]), this.observeIndex.set(this.snapshots.length - 1);
  }, e.prototype.getCurrentState = function () {
    return this.snapshots[this.index];
  }, e.prototype.reset = function () {
    this.snapshots = [], this.observeIndex.set(-1);
  }, e.prototype.undo = function () {
    return this.canUndo ? (this.observeIndex.set(this.index - 1), JSON.parse(this.getCurrentState())) : null;
  }, e.prototype.redo = function () {
    return this.canRedo ? (this.observeIndex.set(this.index + 1), JSON.parse(this.getCurrentState())) : null;
  }, e.prototype.discardSnapshotsfromIndex = function (e) {
    e > 0 && e < this.snapshots.length - 1 && (this.snapshots = this.snapshots.slice(0, e), this.observeIndex.set(this.snapshots.length - 1));
  }, Object.defineProperty(e.prototype, "index", {
    get: function get() {
      return this.observeIndex.get();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "canUndo", {
    get: function get() {
      return this.index > 0;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "canRedo", {
    get: function get() {
      return this.snapshots.length - 1 > this.index;
    },
    enumerable: !0,
    configurable: !0
  }), w([fi], e.prototype, "index", null), w([fi], e.prototype, "canUndo", null), w([fi], e.prototype, "canRedo", null), e;
}(),
    sl = function () {
  function e(e) {
    var t = this;
    this.localTransformStartIndex = null, this.awaitHistoryChange = !1, this.undo = function () {
      return x(t, void 0, void 0, function () {
        var e;
        return k(this, function (t) {
          switch (t.label) {
            case 0:
              return this.awaitHistoryChange ? [3, 2] : (this.awaitHistoryChange = !0, e = this.appHistoryManager.undo(), [4, this.applyState(e)]);

            case 1:
              t.sent(), this.awaitHistoryChange = !1, t.label = 2;

            case 2:
              return [2];
          }
        });
      });
    }, this.redo = function () {
      return x(t, void 0, void 0, function () {
        var e;
        return k(this, function (t) {
          switch (t.label) {
            case 0:
              return this.awaitHistoryChange ? [3, 2] : (this.awaitHistoryChange = !0, e = this.appHistoryManager.redo(), [4, this.applyState(e)]);

            case 1:
              t.sent(), this.awaitHistoryChange = !1, t.label = 2;

            case 2:
              return [2];
          }
        });
      });
    }, this.editor = e, this.appHistoryManager = new al();
  }

  return Object.defineProperty(e.prototype, "canUndo", {
    get: function get() {
      return this.appHistoryManager.canUndo;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "canRedo", {
    get: function get() {
      return this.appHistoryManager.canRedo;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getHistoryState = function () {
    var e,
        t = xr(this.editor.adjustmentsToolStore.state),
        n = xr(this.editor.filterToolStore.state),
        i = this.editor.focusToolStore.getFocusStateForHistory(),
        r = xr(this.editor.overlayToolStore.state),
        o = xr(this.editor.frameToolStore.state),
        a = this.editor.brushToolStore.strokes || {
      strokes: []
    },
        s = this.editor.spriteStore.getSpriteHistoryState(),
        l = this.editor.transformToolStore.serializableState;
    return (e = {})[P.ADJUSTMENT] = t, e[P.FILTER] = n, e[P.FOCUS] = i, e[P.OVERLAY] = r, e[P.FRAME] = o, e[P.BRUSH] = a, e.sprite = s, e[P.TRANSFORM] = l, e;
  }, e.prototype.addInitialSnapshot = function () {
    var e = this.getHistoryState();
    this.appHistoryManager.addSnapshot({
      state: e,
      type: "add",
      description: "Initial State"
    });
  }, e.prototype.addSnapshot = function (e, t, n) {
    void 0 === e && (e = this.getHistoryState()), e && ((e.sprite || e.transform) && (e = _v2(_v2({}, this.getHistoryState()), e)), this.appHistoryManager.addSnapshot({
      state: e,
      type: t,
      description: n
    }), this.editor.configStore.events.onHistoryChange());
  }, e.prototype.saveTransformLocalSnapshotIndex = function () {
    null === this.localTransformStartIndex && (this.localTransformStartIndex = this.appHistoryManager.snapshots.length);
  }, e.prototype.removeTransformLocalSnapshots = function () {
    null !== this.localTransformStartIndex && (this.appHistoryManager.discardSnapshotsfromIndex(this.localTransformStartIndex - 1), this.localTransformStartIndex = null);
  }, e.prototype.applyState = function (e) {
    var t = e.state;
    return x(this, void 0, void 0, function () {
      var e, n, i, r, o, a, s, l;
      return k(this, function (u) {
        switch (u.label) {
          case 0:
            if (u.trys.push([0, 28,, 29]), !t) return [3, 27];
            e = Object.keys(t), u.label = 1;

          case 1:
            u.trys.push([1, 23, 24, 25]), n = T(e), i = n.next(), u.label = 2;

          case 2:
            if (i.done) return [3, 22];

            switch (r = i.value, r) {
              case P.FILTER:
                return [3, 3];

              case P.ADJUSTMENT:
                return [3, 5];

              case P.OVERLAY:
                return [3, 7];

              case P.FRAME:
                return [3, 9];

              case P.FOCUS:
                return [3, 11];

              case P.BRUSH:
                return [3, 13];

              case "sprite":
                return [3, 15];

              case "localTransform":
                return [3, 17];

              case P.TRANSFORM:
                return [3, 19];
            }

            return [3, 21];

          case 3:
            return [4, this.editor.filterToolStore.updateStateFromHistory(t[r])];

          case 4:
            return u.sent(), [3, 21];

          case 5:
            return [4, this.editor.adjustmentsToolStore.updateStateFromHistory(t[r])];

          case 6:
            return u.sent(), [3, 21];

          case 7:
            return [4, this.editor.overlayToolStore.updateStateFromHistory(t[r])];

          case 8:
            return u.sent(), [3, 21];

          case 9:
            return [4, this.editor.frameToolStore.updateStateFromHistory(t[r])];

          case 10:
            return u.sent(), [3, 21];

          case 11:
            return [4, this.editor.focusToolStore.updateStateFromHistory(t[r], this.editor.canvasStore.sizeVector)];

          case 12:
            return u.sent(), [3, 21];

          case 13:
            return [4, this.editor.brushToolStore.updateStateFromHistory(t[r])];

          case 14:
            return u.sent(), [3, 21];

          case 15:
            return [4, this.editor.spriteStore.updateStateFromHistory(t[r])];

          case 16:
            return u.sent(), [3, 21];

          case 17:
            return [4, this.editor.transformToolStore.updateLocalStateFromHistory(t.localTransform)];

          case 18:
            return u.sent(), [3, 21];

          case 19:
            return this.editor.outputContainer.pauseChildrenUpdates(), this.editor.transformToolStore.onEnter(), this.editor.transformToolStore.updateStateFromSerialization(t[r], !1), this.editor.transformToolStore.onLeave(), this.editor.transformToolStore.onEnter(), this.editor.transformToolStore.onLeave(), this.editor.outputContainer.resumeChildrenUpdates(), [4, this.editor.wait()];

          case 20:
            return u.sent(), [3, 21];

          case 21:
            return i = n.next(), [3, 2];

          case 22:
            return [3, 25];

          case 23:
            return o = u.sent(), s = {
              error: o
            }, [3, 25];

          case 24:
            try {
              i && !i.done && (l = n.return) && l.call(n);
            } finally {
              if (s) throw s.error;
            }

            return [7];

          case 25:
            return [4, this.editor.renderPromise()];

          case 26:
            u.sent(), u.label = 27;

          case 27:
            return [3, 29];

          case 28:
            return a = u.sent(), console.error(a), this.editor.modalStore.showActionModal({
              identifier: "unexpectedError",
              error: a,
              handlers: {
                buttonYes: function buttonYes() {
                  window.location.reload();
                }
              }
            }), [3, 29];

          case 29:
            return [2];
        }
      });
    });
  }, e.prototype.isDirty = function () {
    return this.appHistoryManager.snapshots.length > 1;
  }, e.prototype.reset = function () {
    this.appHistoryManager.reset();
  }, w([sr], e.prototype, "undo", void 0), w([sr], e.prototype, "redo", void 0), w([fi], e.prototype, "canUndo", null), w([fi], e.prototype, "canRedo", null), e;
}(),
    ll = {
  type: null,
  modalIdentifier: null,
  show: !1
},
    ul = function () {
  function e(e) {
    var t = this;
    this.errorMessage = "", this.showActionModal = function (e) {
      var n = e.identifier,
          i = e.error,
          r = e.handlers;
      t.state.show = !0, t.state.modalIdentifier = n, t.handlers = _v2(_v2({}, r || {}), {
        close: t.hideModal
      }), t.errorMessage = i || "";
    }, this.hideModal = function () {
      t.state.show = !1, t.state.type = null;
    }, this.configStore = e.configStore, this.state = ai(ll);
  }

  return e.prototype.showInfoModal = function (e) {
    this.state.type = Nt.INFO, this.state.modalIdentifier = e, this.state.show = !0;
  }, e.prototype.showModalOfType = function (e) {
    this.state.type = e, this.state.show = !0;
  }, Object.defineProperty(e.prototype, "infoModalProps", {
    get: function get() {
      if (this.state.modalIdentifier) {
        var e = this.configStore.locale.infoModals[this.state.modalIdentifier];
        return {
          show: this.state.show,
          heading: e ? e.heading : "",
          body: e ? e.body : ""
        };
      }

      return {
        show: !1,
        heading: "",
        body: ""
      };
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "actionModalProps", {
    get: function get() {
      var e = this.configStore.locale,
          t = this.getProps(Nt.WARNING) || this.getProps(Nt.ERROR),
          n = {
        error: e.common.error,
        warning: e.common.warning
      };

      if (this.show && t && t.message) {
        var i = t.type,
            r = t.message,
            o = this.errorMessage;
        return r.body = r.body ? r.body.replace("${error}", o) : "", {
          type: i,
          message: r,
          show: this.show,
          handlers: this.handlers,
          preHeadingLocale: n
        };
      }

      return {
        show: ll.show,
        handlers: this.handlers,
        preHeadingLocale: n
      };
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "show", {
    get: function get() {
      return this.state.show;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "type", {
    get: function get() {
      return this.state.type;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.state.modalIdentifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "positionOffset", {
    get: function get() {
      var e = this.configStore,
          t = e.isLayoutAdvanced,
          n = e.measurements,
          i = n.advancedUIToolControlBar.width + n.advancedUIToolbar.width,
          r = n.basicCanvasOffset;
      return t ? {
        x: i / 2,
        y: 0
      } : {
        x: 0,
        y: -r
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getProps = function (e) {
    var t = this.state.modalIdentifier,
        n = this.configStore.locale;
    return e && Object.prototype.hasOwnProperty.call(n[e + "Modals"], t) ? {
      type: e,
      message: n[e + "Modals"][t]
    } : null;
  }, w([sr], e.prototype, "showActionModal", void 0), w([sr], e.prototype, "showInfoModal", null), w([sr], e.prototype, "showModalOfType", null), w([fi], e.prototype, "infoModalProps", null), w([sr], e.prototype, "hideModal", void 0), w([fi], e.prototype, "actionModalProps", null), w([fi], e.prototype, "show", null), w([fi], e.prototype, "type", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "positionOffset", null), e;
}(),
    cl = function () {
  function e(e) {
    var t = this;
    this.defaultScale = 1, this.SCALE_LEVELS = [8.33, 12.5, 16.66, 25, 33.33, 50, 66.66, 100, 125, 150, 200, 300, 400, 500, 600].map(function (e) {
      return e / 100;
    }), this.state = {
      position: {
        x: 0,
        y: 0
      },
      scaleIndex: -1
    }, this.offset = {
      x: 0,
      y: 0
    }, this.in = function () {
      t.canZoomIn && (t.state.scaleIndex += 1, t.scaleRender());
    }, this.out = function () {
      if (t.canZoomOut) {
        t.state.scaleIndex -= 1;
        var e = t.checkOffset({
          x: 0,
          y: 0
        }),
            n = e.canDragX,
            i = e.canDragY,
            r = e.maxOffsetX,
            o = e.maxOffsetY;
        i || (t.offset.y = o), n || (t.offset.x = r), t.savePosition(), t.scaleRender();
      }
    }, this.setOffset = function (e) {
      var n = t.checkOffset(e),
          i = n.canDragX,
          r = n.canDragY;
      i && (t.offset.x = e.x), r && (t.offset.y = e.y), t.scaleRender();
    }, this.editor = e;
  }

  return e.prototype.setInitialTransform = function (e) {
    var t = this;
    void 0 === e && (e = 0);
    var n = this.editor.engineMediator.preview.transform;
    lr(function () {
      t.setDefaultScale(Math.abs(e || n.scale.x)), t.setPosition(n.position);
    });
  }, e.prototype.resetScale = function () {
    this.state.scaleIndex = -1;
  }, e.prototype.resetPosition = function () {
    var e = this.editor.canvasStore.canvas,
        t = e.width,
        n = e.height;
    this.setPosition({
      x: t / 2,
      y: n / 2
    });
  }, e.prototype.resetOffset = function () {
    this.offset = {
      x: 0,
      y: 0
    };
  }, e.prototype.setPosition = function (e) {
    this.state.position.x = e.x, this.state.position.y = e.y;
  }, e.prototype.savePosition = function () {
    this.setPosition(this.getPositionWithOffset()), this.offset = {
      x: 0,
      y: 0
    };
  }, e.prototype.setDefaultScale = function (e) {
    var t = this;
    1 !== this.defaultScale && -1 !== (n = this.SCALE_LEVELS.findIndex(function (e) {
      return e === t.defaultScale;
    })) && (this.SCALE_LEVELS = C(this.SCALE_LEVELS.slice(0, n), this.SCALE_LEVELS.slice(n + 1)));
    var n,
        i = this.SCALE_LEVELS.findIndex(function (n, i) {
      return 0 === i ? e < n : i === t.SCALE_LEVELS.length - 1 ? n < e : t.SCALE_LEVELS[i - 1] < e && e < n;
    });
    -1 !== i ? (this.SCALE_LEVELS = C(this.SCALE_LEVELS.slice(0, i), [e], this.SCALE_LEVELS.slice(i)), i === this.state.scaleIndex && this.resetScale(), this.state.scaleIndex = i, this.defaultScale = e) : ((n = this.SCALE_LEVELS.findIndex(function (t) {
      return t === e;
    })) === this.state.scaleIndex && this.resetScale(), -1 !== n && (this.state.scaleIndex = n, this.defaultScale = e));
  }, e.prototype.setScaleToDefault = function () {
    this.state.scaleIndex = this.defaultIndex;
  }, e.prototype.checkOffset = function (e) {
    var t = window.devicePixelRatio || 1,
        n = this.scaledSize,
        i = this.previewSize,
        r = this.editor.engineMediator.preview.initialTransform.position,
        o = this.getPositionWithOffset(e),
        a = (n.width - i.width) * t / 2,
        s = (n.height - i.height) * t / 2,
        l = r.x - o.x,
        u = r.y - o.y,
        c = Math.abs(l) - a,
        p = Math.abs(u) - s;
    return {
      canDragX: c < 0,
      canDragY: p < 0,
      maxOffsetX: l > 0 ? -c : c,
      maxOffsetY: u > 0 ? -p : p
    };
  }, e.prototype.calculateScale = function (e, t, n) {
    void 0 === e && (e = 0), void 0 === t && (t = this.previewSize), void 0 === n && (n = this.defaultScale);
    var i = t.width,
        r = t.height,
        o = new R({
      x: i,
      y: r
    }),
        a = new R(Math.abs(o.x * Math.cos(e)) + Math.abs(o.y * Math.sin(e)), Math.abs(o.x * Math.sin(e)) + Math.abs(o.y * Math.cos(e))),
        s = o.subtract(a).divide(2).multiply(n).abs;
    return s.y > s.x ? 2 * s.y / o.y + n : 2 * s.x / o.x + n;
  }, Object.defineProperty(e.prototype, "defaultIndex", {
    get: function get() {
      var e = this;
      return this.SCALE_LEVELS.findIndex(function (t) {
        return t === e.defaultScale;
      });
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getPositionWithOffset = function (e) {
    void 0 === e && (e = this.offset);
    var t = this.position;
    return {
      x: t.x - e.x,
      y: t.y - e.y
    };
  }, e.prototype.scaleRender = function (e) {
    void 0 === e && (e = !1);
    var t = this.editor.scale.getPositionWithOffset(),
        n = e ? this.defaultScale : this.scale,
        i = {
      x: n,
      y: n
    };
    this.editor.engineMediator.preview.container.setScale(i), this.editor.engineMediator.preview.container.setPosition(t), this.editor.engineMediator.preview.savePreviewTransform({
      scale: i,
      position: t,
      rotation: 0
    }), e || this.editor.render();
  }, Object.defineProperty(e.prototype, "scale", {
    get: function get() {
      var e = this.state.scaleIndex;
      return -1 !== e ? this.SCALE_LEVELS[e] : this.defaultScale;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "zoomLevel", {
    get: function get() {
      var e = window.devicePixelRatio || 1;
      return (this.scale / e * 100).toFixed(1);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "canDrag", {
    get: function get() {
      return this.defaultScale < this.scale;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "canZoomOut", {
    get: function get() {
      return this.state.scaleIndex > this.defaultIndex;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "canZoomIn", {
    get: function get() {
      return this.SCALE_LEVELS.length - 1 > this.state.scaleIndex;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "position", {
    get: function get() {
      return this.state.position;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "scaledSize", {
    get: function get() {
      var e = this.state.scaleIndex,
          t = -1 !== e ? this.SCALE_LEVELS[e] : this.defaultScale,
          n = this.previewSize;
      return {
        width: n.width * t / this.defaultScale,
        height: n.height * t / this.defaultScale
      };
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "previewSize", {
    get: function get() {
      return this.editor.getPreviewSize();
    },
    enumerable: !0,
    configurable: !0
  }), w([ai], e.prototype, "state", void 0), w([sr], e.prototype, "in", void 0), w([sr], e.prototype, "out", void 0), w([sr], e.prototype, "setInitialTransform", null), w([sr], e.prototype, "resetScale", null), w([sr], e.prototype, "resetPosition", null), w([sr], e.prototype, "setPosition", null), w([sr], e.prototype, "savePosition", null), w([sr], e.prototype, "setDefaultScale", null), w([sr], e.prototype, "setScaleToDefault", null), w([fi], e.prototype, "scale", null), w([fi], e.prototype, "zoomLevel", null), w([fi], e.prototype, "canDrag", null), w([fi], e.prototype, "canZoomOut", null), w([fi], e.prototype, "canZoomIn", null), w([fi], e.prototype, "position", null), w([fi], e.prototype, "scaledSize", null), e;
}(),
    pl = /^data:image\/(.+?);base64,/,
    fl = function () {
  function e(e) {
    var t = this;
    this.applySerialization = function (e, n, i, r) {
      return x(t, void 0, void 0, function () {
        var t, o, a, s, l, u, c;
        return k(this, function (p) {
          switch (p.label) {
            case 0:
              return this.editor.resetToolStates(), (t = this.editor.activeStore.tool === P.TRANSFORM) || this.editor.transformToolStore.onEnter(), this.editor.transformToolStore.reset(), t || this.editor.transformToolStore.onLeave(), o = new n(this.editor), a = "Unexpected error occured", (s = n.deserializeImage(e)).image && s.image.data ? (l = s.image.data, [4, this.editor.setImage(l)]) : [3, 3];

            case 1:
              return p.sent(), this.editor.scale.defaultScale = 1, this.editor.scale.resetOffset(), this.editor.transformToolStore.reset(), this.editor.activeStore.setImage(l), [4, this.editor.engineMediator.image.addImageToContainer()];

            case 2:
              p.sent(), this.editor.engineMediator.output.applyNewImageTransform(), this.editor.engineMediator.preview.updateTransform(), this.editor.scale.setInitialTransform(), this.editor.transformToolStore.setCropDefaults(), this.editor.historyStore.addInitialSnapshot(), this.editor.transformToolStore.saveTransforms(), p.label = 3;

            case 3:
              return (u = o.deserializeTransformation(e)) ? [4, this.applyStateOnUI(u)] : [3, 9];

            case 4:
              return p.sent(), (c = o.deserialize(e)) ? [4, this.applyStateOnUI(c)] : [3, 7];

            case 5:
              return p.sent(), [4, this.editor.render()];

            case 6:
              return p.sent(), "loading" === this.editor.modalStore.identifier && this.editor.modalStore.hideModal(), i(), [3, 8];

            case 7:
              r(a), p.label = 8;

            case 8:
              return [3, 10];

            case 9:
              r(a), p.label = 10;

            case 10:
              return [2];
          }
        });
      });
    }, this.editor = e;
  }

  return e.prototype.serialize = function (t) {
    var n = this,
        i = (void 0 === t ? {
      image: !1
    } : t).image,
        r = this.editor.activeStore.tool === P.TRANSFORM;
    return this.editor.modalStore.showInfoModal("saving"), new Promise(function (t, o) {
      import("./index-a70711a2.js").then(function (a) {
        var s = a.Serializer;
        return x(n, void 0, void 0, function () {
          var n, a, l, u, c, p, f, h, d, g, m, y, _;

          return k(this, function (v) {
            switch (v.label) {
              case 0:
                return v.trys.push([0, 2,, 3]), r && this.editor.transformToolStore.onLeave(), [4, this.editor.wait()];

              case 1:
                return v.sent(), this.editor.transformToolStore.applyDefaultCrop(!1), n = this.editor.imageContainer.getData().originalImage, a = this.editor.engineMediator.output.container.getResolution(), l = {
                  width: n.width,
                  height: n.height
                }, u = new s(this.editor.transformToolStore.defaultCropMaskPosition, this.editor.transformToolStore.maxCropMaskSize, a, l, this.editor.engine.getRootContainers()[0], this.editor.engine.getOutputContainer()), (_ = {})[P.ADJUSTMENT] = xr(this.editor.adjustmentsToolStore.state), _[P.FILTER] = xr(this.editor.filterToolStore.state), _[P.FOCUS] = xr(this.editor.focusToolStore.serializableState), _[P.OVERLAY] = xr(this.editor.overlayToolStore.state), _[P.FRAME] = xr(this.editor.frameToolStore.state), _[P.BRUSH] = this.editor.brushToolStore.strokes || {
                  strokes: []
                }, c = _, p = this.editor.spriteStore.serializableState, f = p.sprite, h = p.customStickers, f.spriteIdList = f.spriteIdList.sort(function (e, t) {
                  return f.common[e].order - f.common[t].order;
                }), c.sprite = f, c.customStickers = h, c.transform = this.editor.transformToolStore.serializableState, d = void 0, g = void 0, i && (m = e.getDataURL(n), g = function (e) {
                  return e.match(/^data:([^;]+)/)[1];
                }(m), d = function (e) {
                  return e.replace(pl, "");
                }(m)), this.editor.modalStore.hideModal(), t(u.serialise(c, d, g)), r && this.editor.transformToolStore.onEnter(), [3, 3];

              case 2:
                return y = v.sent(), this.editor.modalStore.hideModal(), o(y), [3, 3];

              case 3:
                return [2];
            }
          });
        });
      });
    });
  }, e.prototype.deserialize = function (e) {
    var t = this;
    return this.editor.modalStore.showInfoModal("loading"), new Promise(function (n, i) {
      try {
        import("./index-a70711a2.js").then(function (r) {
          var o = r.Deserializer;
          o.checkIsSerialisationValid(e) ? t.applySerialization(e, o, n, i) : (t.editor.modalStore.hideModal(), t.editor.modalStore.showActionModal({
            identifier: "unsupportedSerializationVersion",
            handlers: {
              buttonYes: function buttonYes() {
                return t.applySerialization(e, o, n, i);
              }
            }
          }));
        });
      } catch (e) {
        "loading" === t.editor.modalStore.identifier && t.editor.modalStore.hideModal(), i(e);
      }
    });
  }, e.getDataURL = function (e) {
    if (e instanceof HTMLCanvasElement) return e.toDataURL(q.PNG);
    var t,
        n = e.src;
    if (t = n, pl.test(t)) return n;
    var i = document.createElement("canvas");
    return i.width = e.width, i.height = e.height, i.getContext("2d").drawImage(e, 0, 0), i.toDataURL(q.PNG);
  }, e.prototype.applyStateOnUI = function (e) {
    return x(this, void 0, void 0, function () {
      var t, n;
      return k(this, function (i) {
        switch (i.label) {
          case 0:
            t = this.editor.activeStore.tool === P.TRANSFORM, i.label = 1;

          case 1:
            return i.trys.push([1, 15,, 16]), e.transform ? (t || this.editor.transformToolStore.onEnter(), this.editor.transformToolStore.updateStateFromSerialization(e.transform, !0), [4, this.editor.wait()]) : [3, 4];

          case 2:
            return i.sent(), t ? [3, 4] : (this.editor.transformToolStore.onLeave(), this.editor.transformToolStore.onEnter(), [4, this.editor.wait()]);

          case 3:
            i.sent(), this.editor.transformToolStore.onLeave(), i.label = 4;

          case 4:
            return e.filter ? [4, this.editor.filterToolStore.updateStateFromSerialization(e.filter)] : [3, 6];

          case 5:
            i.sent(), i.label = 6;

          case 6:
            return e.adjustment && this.editor.adjustmentsToolStore.updateStateFromSerialization(e.adjustment), e.focus ? [4, this.editor.focusToolStore.updateStateFromSerialization(e.focus)] : [3, 8];

          case 7:
            i.sent(), i.label = 8;

          case 8:
            return e.overlay ? [4, this.editor.overlayToolStore.updateStateFromSerialization(e.overlay)] : [3, 10];

          case 9:
            i.sent(), i.label = 10;

          case 10:
            return e.sprite ? (e.sprite.spriteIdList = e.sprite.spriteIdList.sort(function (t, n) {
              return e.sprite.common[t].order - e.sprite.common[n].order;
            }), [4, this.editor.spriteStore.updateStateFromSerialization(e.sprite, e.customStickers)]) : [3, 12];

          case 11:
            i.sent(), i.label = 12;

          case 12:
            return e.brush && this.editor.brushToolStore.updateStateFromHistory(e.brush), e.frame ? [4, this.editor.frameToolStore.updateStateFromSerialization(e.frame)] : [3, 14];

          case 13:
            i.sent(), i.label = 14;

          case 14:
            return this.editor.outputContainer.updateChildrenContainers(), [3, 16];

          case 15:
            return n = i.sent(), console.error(n), this.editor.modalStore.showActionModal({
              identifier: "unexpectedError",
              error: n,
              handlers: {
                buttonYes: function buttonYes() {
                  window.location.reload();
                }
              }
            }), [3, 16];

          case 16:
            return [2];
        }
      });
    });
  }, e;
}(),
    hl = {
  identifier: "identity",
  opacity: 1,
  width: 0,
  color: Jt.white
},
    dl = new go(0, 1),
    gl = function () {
  function e(e) {
    this.engineMediator = e, this.state = hl;
  }

  return e.prototype.changeIdentifier = function (e) {
    this.state.identifier = e;
  }, e.prototype.changeOpacity = function (e) {
    var t = dl.clamp(e);
    this.state.opacity = t;
  }, e.prototype.changeWidth = function (e) {
    this.state.width = e;
  }, e.prototype.changeColor = function (e) {
    this.state.color = e;
  }, e.prototype.reset = function () {
    -1 === this.indexInContainer && (this.state.identifier = hl.identifier, this.state.opacity = hl.opacity, this.state.width = hl.width, this.state.color = hl.color, this.removeIndex());
  }, Object.defineProperty(e.prototype, "engine", {
    get: function get() {
      return this.engineMediator.engine;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "imageContainer", {
    get: function get() {
      return this.engineMediator.image.container;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "indexInContainer", {
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.removeFrameEffect = function () {
    this.effect && (this.engine.removeEffect(this.effect), this.effect = void 0);
  }, e.prototype.setEffectProperties = function (e) {
    return this.effect ? (this.removeIndex(), this.effect.setProperties(e), this.effect.getProperties()) : null;
  }, e.prototype.setFrameEffect = function (e) {
    var t = this,
        n = e.identifier,
        i = e.width,
        r = e.opacity,
        o = e.color,
        a = _v2({}, this.state);

    this.changeIdentifier(n), this.changeWidth(i), this.changeOpacity(r), this.changeColor(o), this.removeFrameEffect();
    var s = this.engineMediator.orderHelper.addSprite(n);
    return new Promise(function (e, l) {
      t.engine.addFrameFromAssets(n, t.engineMediator.image.container, s).then(function (n) {
        t.effect = n, t.effect.setProperties({
          tintColor: o,
          opacity: r,
          width: i
        }), e();
      }).catch(function (e) {
        t.changeIdentifier(a.identifier), t.changeOpacity(a.opacity), t.changeWidth(a.width), t.changeColor(a.color), "identity" === a.identifier && t.removeIndex(), l(e);
      });
    });
  }, e.prototype.removeIndex = function () {
    this.engineMediator.orderHelper.removeSprite(this.state.identifier);
  }, w([ai], e.prototype, "state", void 0), w([sr], e.prototype, "changeIdentifier", null), w([sr], e.prototype, "changeOpacity", null), w([sr], e.prototype, "changeWidth", null), w([sr], e.prototype, "changeColor", null), w([sr], e.prototype, "reset", null), e;
}(),
    ml = function () {
  function e(e) {
    var t = this;
    this.changeOpacity = function (e) {
      var n = t.frameStore.setEffectProperties({
        opacity: e
      });
      n && (t.frameStore.changeOpacity(n.opacity), t.editor.render());
    }, this.changeWidth = function (e) {
      var n = t.frameStore.setEffectProperties({
        width: e
      });
      n && (t.frameStore.changeWidth(n.width), t.editor.render());
    }, this.changeColor = function (e) {
      var n = t.frameStore.setEffectProperties({
        tintColor: e
      });
      n && (t.frameStore.changeColor(n.tintColor), t.editor.render());
    }, this.colorSnapshot = function () {
      t.addSnapshot("edit", t.locale.controls.selectColor);
    }, this.reset = function () {
      t.pureReset(), t.addSnapshot("delete", t.locale.controls.buttonReset), t.editor.render();
    }, this.editor = e, this.frameStore = new gl(this.editor.engineMediator);
    var n = this.editor.assetProvider.getAssets("frame"),
        i = this.config;
    this.entityManager = new _o([{
      identifier: "",
      name: "",
      items: n
    }], _v2(_v2({}, i), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !0,
      locale: this.locale.items,
      getAssetPath: this.editor.getAssetPath("frame")
    }));
  }

  return Object.defineProperty(e, "colors", {
    get: function get() {
      return Yl.defaultColors;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.selectFrame = function (e) {
    return x(this, void 0, void 0, function () {
      var t;
      return k(this, function (n) {
        switch (n.label) {
          case 0:
            return e === this.identifier ? [3, 2] : (t = .1 * this.editor.shortestOutputSide, [4, this.frameStore.setFrameEffect({
              identifier: e,
              width: t,
              opacity: 1,
              color: hl.color
            })]);

          case 1:
            n.sent(), this.editor.render(), this.addSnapshot("add", P.FRAME), n.label = 2;

          case 2:
            return [2];
        }
      });
    });
  }, e.prototype.toolSnapshot = function (e) {
    this.addSnapshot("edit", e);
  }, e.prototype.addSnapshot = function (e, t) {
    this.editor.addSnapshot(void 0, e, t);
  }, e.prototype.pureReset = function () {
    this.frameStore.removeFrameEffect(), this.frameStore.reset();
  }, e.prototype.updateStateFromHistory = function (e) {
    return "identity" === e.identifier ? (this.pureReset(), new Promise(function (e) {
      e();
    })) : this.frameStore.setFrameEffect(e);
  }, e.prototype.updateStateFromSerialization = function (e) {
    return x(this, void 0, void 0, function () {
      return k(this, function (t) {
        return this.entityManager.items.find(function (t) {
          return t.identifier === e.identifier;
        }) ? [2, this.frameStore.setFrameEffect(e)] : [2, new Promise(function (e, t) {
          t(new Error("Frame Asset doesn't exist"));
        })];
      });
    });
  }, Object.defineProperty(e.prototype, "state", {
    get: function get() {
      return this.frameStore.state;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.state.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "color", {
    get: function get() {
      return this.state.color;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "size", {
    get: function get() {
      return this.state.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "tintable", {
    get: function get() {
      var e = this,
          t = this.entityManager.items.find(function (t) {
        return t.identifier === e.identifier;
      });
      return t && t.tintable || !1;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "opacity", {
    get: function get() {
      return this.state.opacity;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "minSize", {
    get: function get() {
      return .05 * this.editor.shortestOutputSide;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "maxSize", {
    get: function get() {
      return .3 * this.editor.shortestOutputSide;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.FRAME];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.FRAME];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "localeColor", {
    get: function get() {
      return this.editor.configStore.locale.common.color;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "entities", {
    get: function get() {
      return this.entityManager.getEntities();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isOptionSelected", {
    get: function get() {
      return "identity" !== this.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), w([sr], e.prototype, "selectFrame", null), w([sr], e.prototype, "changeOpacity", void 0), w([sr], e.prototype, "changeWidth", void 0), w([sr], e.prototype, "changeColor", void 0), w([sr], e.prototype, "pureReset", null), w([sr], e.prototype, "reset", void 0), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "updateStateFromSerialization", null), w([fi], e.prototype, "state", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "color", null), w([fi], e.prototype, "size", null), w([fi], e.prototype, "tintable", null), w([fi], e.prototype, "opacity", null), w([fi], e.prototype, "minSize", null), w([fi], e.prototype, "maxSize", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "localeColor", null), w([fi], e.prototype, "entities", null), w([fi], e.prototype, "isOptionSelected", null), e;
}(),
    yl = {
  options: [],
  query: ""
},
    _l = function () {
  function e(e) {
    var t = this;
    this.initProvider = function (e) {
      e && (t.libraryProvider = new e());
    }, this.addOptionsToSelectedCategory = function (e, t, n) {
      var i = e.findIndex(function (e) {
        return e.identifier === t;
      });
      return -1 !== i ? C(e.slice(0, i + 1), n, e.slice(i + 1)) : e;
    }, this.configStore = e.configStore, this.state = ai(yl), this.selectedCategory = "";
  }

  return e.prototype.saveScrollbar = function (e) {
    this.scrollbar = e;
  }, e.prototype.recalculateScrollContainer = function () {
    var e = this;
    setTimeout(function () {
      return e.scrollbar.recalculate();
    }, 0);
  }, e.prototype.fetchImages = function (e) {
    return void 0 === e && (e = ""), x(this, void 0, void 0, function () {
      var t,
          n,
          i,
          r,
          o,
          a = this;
      return k(this, function (s) {
        switch (s.label) {
          case 0:
            return this.libraryProvider ? (t = [this.libraryProvider.getCategories(), this.libraryProvider.searchImages(e)], [4, Promise.all(t)]) : [3, 2];

          case 1:
            n = S.apply(void 0, [s.sent(), 2]), i = n[0], r = n[1], o = i.map(function (e) {
              var t = r.filter(function (t) {
                return t.category === e.name;
              });
              return {
                identifier: e.name,
                defaultName: e.name,
                coverImage: e.coverImageUrl,
                options: t.map(function (e, t) {
                  return {
                    defaultName: "image" + t,
                    identifier: e.thumbUrl,
                    coverImage: e.thumbUrl,
                    rawUrl: e.rawUrl
                  };
                })
              };
            }).filter(function (e) {
              return e.options.length;
            }), lr(function () {
              a.state.query = e, a.state.options = o;
            }), s.label = 2;

          case 2:
            return [2];
        }
      });
    });
  }, e.prototype.toggleCategorySelection = function (e) {
    this.selectedCategory = this.selectedCategory !== e ? e : "";
  }, Object.defineProperty(e.prototype, "selectedCategoryIdentifier", {
    get: function get() {
      return this.selectedCategory;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "images", {
    get: function get() {
      return this.state.options.map(function (e) {
        return e.options;
      }).reduce(function (e, t) {
        return C(e, t);
      }, []);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "query", {
    get: function get() {
      return this.state.query;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.configStore.config[P.LIBRARY];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.configStore.locale[P.LIBRARY];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "categories", {
    get: function get() {
      return this.state.options.map(function (e, t) {
        return {
          type: z.LARGE,
          identifier: e.defaultName,
          defaultName: e.defaultName,
          coverImage: e.coverImage,
          delay: .08 * t,
          items: e.options.map(function (e, t) {
            return _v2({
              type: z.MEDIUM,
              delay: .08 * t
            }, e);
          })
        };
      });
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "options", {
    get: function get() {
      var e = this.selectedCategory,
          t = this.state.options.findIndex(function (t) {
        return t.defaultName === e;
      });
      return -1 !== t ? this.state.options[t].options.map(function (e, t) {
        return _v2({
          type: z.MEDIUM,
          delay: .08 * t
        }, e);
      }) : [];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "categoriesAndOptions", {
    get: function get() {
      return this.addOptionsToSelectedCategory(this.categories, this.selectedCategory, this.options);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getRawUrl = function (e) {
    var t = this.images.findIndex(function (t) {
      return t.identifier === e;
    });
    return -1 !== t ? this.images[t].rawUrl : e;
  }, w([ai], e.prototype, "selectedCategory", void 0), w([sr], e.prototype, "saveScrollbar", null), w([sr], e.prototype, "recalculateScrollContainer", null), w([sr], e.prototype, "initProvider", void 0), w([sr], e.prototype, "fetchImages", null), w([sr], e.prototype, "toggleCategorySelection", null), w([fi], e.prototype, "selectedCategoryIdentifier", null), w([fi], e.prototype, "images", null), w([fi], e.prototype, "query", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "categories", null), w([fi], e.prototype, "options", null), w([fi], e.prototype, "categoriesAndOptions", null), e;
}(),
    vl = function vl(e) {
  for (var t = atob(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], i = new ArrayBuffer(t.length), r = new Uint8Array(i), o = 0; o < t.length; o += 1) {
    r[o] = t.charCodeAt(o);
  }

  return new Blob([i], {
    type: n
  });
},
    bl = {
  size: 10,
  color: Jt.white,
  hardness: .5
},
    wl = function () {
  function e(e) {
    var t = this;
    this.dirty = ai.box(!1), this.id = "", this.containerId = function () {
      return t.id;
    }, this.changeColor = function (e) {
      t.state.color = e;
    }, this.changeSize = function (e) {
      t.state.size = e;
    }, this.changeHardness = function (e) {
      t.state.hardness = e;
    }, this.reset = function () {
      t.pureReset(), t.addSnapshot("delete", t.locale.controls.buttonReset), t.editor.render();
    }, this.editor = e, this.state = bl;
  }

  return Object.defineProperty(e, "colors", {
    get: function get() {
      return Yl.defaultColors;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.addSnapshot = function (e, t) {
    this.editor.addSnapshot(void 0, e, t);
  }, e.prototype.clickableCanvas = function (e) {
    this.editor.clickableCanvas(e);
  }, e.prototype.beginStroke = function (e) {
    if (void 0 === e && (e = []), !this.drawingContainer) {
      var t = this.editor.orderHelper.addSprite(P.BRUSH);
      this.drawingContainer = this.editor.engine.addDrawing({
        strokes: e
      }, this.editor.imageContainer, t);
    }

    this.id = this.drawingContainer.getID(), this.drawingContainer.beginStroke({
      id: "imgly_brush_radial",
      color: xr(this.state.color),
      size: this.state.size,
      hardness: this.state.hardness
    });
  }, e.prototype.strokePosition = function (e) {
    if (this.drawingContainer) {
      var t = this.editor.previewToWorld(e, !1);
      this.drawingContainer.addPointToCurrentStroke(t), this.editor.render();
    }
  }, e.prototype.endStroke = function () {
    this.drawingContainer && (this.drawingContainer.endStroke(), this.editor.render(), this.strokes = this.drawingContainer.getData(), this.addSnapshot("edit", this.locale.history.brushStroke), this.dirty.set(!0));
  }, e.prototype.updateStateFromHistory = function (e) {
    if (e = e || {
      strokes: []
    }, this.drawingContainer) {
      if (this.strokes && this.strokes.strokes.length === e.strokes.length) return;
      this.strokes = e, this.drawingContainer.setData(this.strokes), 0 !== e.strokes.length && this.dirty.set(!0);
    } else {
      var t = this.editor.orderHelper.addSprite(P.BRUSH);
      this.drawingContainer = this.editor.engine.addDrawing({
        strokes: e.strokes
      }, this.editor.imageContainer, t), this.strokes = this.drawingContainer.getData();
    }

    this.id = this.drawingContainer.getID();
  }, e.prototype.pureReset = function () {
    this.dirty.set(!1), this.strokes = {
      strokes: []
    }, this.drawingContainer && (this.editor.engine.removeContainer(this.drawingContainer), this.drawingContainer = void 0);
  }, Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.BRUSH];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.BRUSH];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "localeColor", {
    get: function get() {
      return this.editor.configStore.locale.common.color;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "color", {
    get: function get() {
      return this.state.color;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "size", {
    get: function get() {
      return this.state.size;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "sizeOnScreenSpace", {
    get: function get() {
      return this.editor.worldToPreview(this.state.size);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "hardness", {
    get: function get() {
      return this.state.hardness;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isDirty", {
    get: function get() {
      return this.dirty.get();
    },
    enumerable: !0,
    configurable: !0
  }), w([ai], e.prototype, "state", void 0), w([ai], e.prototype, "dirty", void 0), w([sr], e.prototype, "changeColor", void 0), w([sr], e.prototype, "changeSize", void 0), w([sr], e.prototype, "changeHardness", void 0), w([sr], e.prototype, "clickableCanvas", null), w([sr], e.prototype, "beginStroke", null), w([sr], e.prototype, "strokePosition", null), w([sr], e.prototype, "endStroke", null), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "reset", void 0), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "localeColor", null), w([fi], e.prototype, "color", null), w([fi], e.prototype, "size", null), w([fi], e.prototype, "sizeOnScreenSpace", null), w([fi], e.prototype, "hardness", null), w([fi], e.prototype, "isDirty", null), e;
}();

!function (e) {
  e.LEADING = "leading", e.CENTER = "center", e.TRAILING = "trailing";
}(tl || (tl = {}));

var xl = {
  horizontalGuides: [],
  verticalGuides: [],
  rotationGuides: []
},
    kl = function () {
  function e(e) {
    var t = this;
    this.previewTopLeftPosition = {
      x: 0,
      y: 0
    }, this.getGuideValue = function (e, n) {
      var i = t.editor.getPreviewSize(),
          r = i.height,
          o = i.width,
          a = t.configStore.config.snapping.position,
          s = a.snapToLeft,
          l = a.snapToRight,
          u = a.snapToTop,
          c = a.snapToBottom,
          p = Math.min(r, o),
          f = 0;
      return "bottom" === n ? f = Math.round(r - p * c) : "top" === n ? f = Math.round(p * u) : "right" === n ? f = Math.round(o - p * l) : "left" === n ? f = Math.round(p * s) : "vertical" === e && "center" === n ? f = Math.round(o / 2) : "horizontal" === e && "center" === n && (f = Math.round(r / 2)), f;
    }, this.getVerticalGuidesFromConfig = function () {
      var e = t.configStore.config.snapping.position,
          n = e.snapToVerticalCenter,
          i = e.snapToLeft,
          r = e.snapToRight,
          o = [];
      return n && o.push({
        value: t.getGuideValue("vertical", "center"),
        edge: tl.CENTER,
        isVisible: !1,
        direction: "vertical"
      }), i && o.push({
        value: t.getGuideValue("vertical", "left"),
        edge: tl.LEADING,
        isVisible: !1,
        direction: "vertical"
      }), r && o.push({
        value: t.getGuideValue("vertical", "right"),
        edge: tl.TRAILING,
        isVisible: !1,
        direction: "vertical"
      }), o;
    }, this.getHorizontalGuidesFromConfig = function () {
      var e = t.configStore.config.snapping.position,
          n = e.snapToHorizontalCenter,
          i = e.snapToTop,
          r = e.snapToBottom,
          o = [];
      return n && o.push({
        value: t.getGuideValue("horizontal", "center"),
        edge: tl.CENTER,
        isVisible: !1,
        direction: "horizontal"
      }), i && o.push({
        value: t.getGuideValue("horizontal", "top"),
        edge: tl.LEADING,
        isVisible: !1,
        direction: "horizontal"
      }), r && o.push({
        value: t.getGuideValue("horizontal", "bottom"),
        edge: tl.TRAILING,
        isVisible: !1,
        direction: "horizontal"
      }), o;
    }, this.getRotationGuidesFromConfig = function () {
      var e = t.configStore.config.snapping.rotation.angles,
          n = [];
      return e.forEach(function (e) {
        n.push(e), n.push(e + 360), n.push(e - 360);
      }), n.filter(function (e, t) {
        return n.indexOf(e) === t;
      }).map(function (e) {
        return {
          value: e * Math.PI / 180,
          edge: tl.CENTER,
          isVisible: !1,
          position: {
            x: 0,
            y: 0
          }
        };
      });
    }, this.getSpriteDimensions = function (e) {
      var t = e.leftTop,
          n = e.leftBottom,
          i = e.rightTop,
          r = e.rightBottom,
          o = Math.min(t.y, i.y, n.y, r.y),
          a = Math.max(t.y, i.y, n.y, r.y),
          s = Math.min(t.x, i.x, n.x, r.x),
          l = Math.max(t.x, i.x, n.x, r.x);
      return {
        height: Math.round(a - o),
        width: Math.round(l - s)
      };
    }, this.mapRange = function (e) {
      var t = e.value,
          n = e.fromMin,
          i = e.fromLength,
          r = e.toMin;
      return (t - n) * e.toLength / i + r;
    }, this.updateGuides = function () {
      t.state.horizontalGuides = t.getHorizontalGuidesFromConfig(), t.state.verticalGuides = t.getVerticalGuidesFromConfig();
    }, this.mapToSnapSystem = function (e, n, i, r) {
      if (0 === n.length) return e;
      if (n[0] > e) return e - i;

      for (var o = 0; o < n.length - 1; o += 1) {
        var a = n[o],
            s = n[o + 1],
            l = a + i,
            u = s - i,
            c = 0;
        r && (l += c = o * i * 2, u += c + 2 * i);
        if (a <= e && e <= s) return e <= a + 1e-5 ? a + c : e >= s - 1e-5 ? s + c + (r ? 2 * i : 0) : t.mapRange({
          value: e,
          fromMin: a,
          fromLength: s - a,
          toMin: l,
          toLength: u - l
        });
      }

      return r ? e + (n.length - 1) * i * 2 + i : e;
    }, this.mapFromSnapSystem = function (e, n, i, r) {
      if (0 === n.length) return e;
      if (n[0] > e) return e >= n[0] - i ? n[0] : e + i;

      for (var o = e, a = 0; a < n.length - 1; a += 1) {
        var s = n[a],
            l = n[a + 1],
            u = s + i,
            c = l - i,
            p = l;
        if (r && (c += 2 * i, p += 2 * i, o = e - a * i * 2), s <= o && o <= p) return u <= o && o <= c ? t.mapRange({
          value: o,
          fromMin: u,
          fromLength: c - u,
          toMin: s,
          toLength: l - s
        }) : o < u ? s : l;
      }

      o -= 3 * i;
      var f = n[n.length - 1];
      return o <= f ? f : o;
    }, this.centerSnapValue = function (e, t) {
      var n = .5 * t,
          i = e.value,
          r = e.edge,
          o = i;
      return r === tl.LEADING ? o += n : r === tl.TRAILING && (o -= n), o;
    }, this.mapSnappingGuidesToCenter = function (e, n) {
      var i = [];
      return e.forEach(function (e) {
        i.push(t.centerSnapValue(e, n));
      }), i;
    }, this.calcSnapThresholdInRadians = function (e, t) {
      return 0 === e ? 0 : t / e;
    }, this.calculatePreviewTopLeftPosition = function () {
      var e = t.editor.engineMediator.preview.container.getPosition(),
          n = t.editor.getPreviewSize(),
          i = Yl.devicePixelRatio;
      t.previewTopLeftPosition = {
        x: e.x / i - n.width / 2,
        y: e.y / i - n.height / 2
      };
    }, this.snapToRotation = function (e, n, i) {
      var r = t.state.rotationGuides,
          o = t.configStore.config.snapping.rotation,
          a = o.enabled,
          s = o.threshold,
          l = t.previewTopLeftPosition,
          u = l.x,
          c = l.y,
          p = t.editor.getPreviewSize().width,
          f = (e + 2 * Math.PI) % (2 * Math.PI);

      if (a) {
        var h = new R(n).magnitude,
            d = r.map(function (e) {
          return e.value;
        }).sort(function (e, t) {
          return e - t;
        }),
            g = t.calcSnapThresholdInRadians(h, s);

        if (!t.rotationOffset) {
          var m = t.mapToSnapSystem(e, d, g, !1);
          t.rotationOffset = m - f;
        }

        f = t.mapFromSnapSystem(f + t.rotationOffset, d, g, !1);
        var y = {
          x: i.position.x - u - p,
          y: i.position.y - c
        };
        return r.forEach(function (e) {
          e.isVisible = e.value === f, e.position = y;
        }), f;
      }

      return e;
    }, this.snapToPosition = function (e, n) {
      var i = t.state,
          r = i.horizontalGuides,
          o = i.verticalGuides,
          a = t.configStore.config.snapping.position,
          s = a.enabled,
          l = a.threshold,
          u = new R(t.previewTopLeftPosition),
          c = t.getSpriteDimensions(n),
          p = c.height,
          f = c.width,
          h = new R(e).subtract(u),
          d = h.x,
          g = h.y;

      if (s) {
        var m = t.mapSnappingGuidesToCenter(r, p).sort(function (e, t) {
          return e - t;
        }),
            y = t.mapSnappingGuidesToCenter(o, f).sort(function (e, t) {
          return e - t;
        });

        if (!t.positionOffset) {
          var _ = t.mapToSnapSystem(d, y, l, !0),
              v = t.mapToSnapSystem(g, m, l, !0);

          t.positionOffset = new R(_, v).subtract(new R(d, g));
        }

        var b = t.mapFromSnapSystem(d + t.positionOffset.x, y, l, !0),
            w = t.mapFromSnapSystem(g + t.positionOffset.y, m, l, !0);
        return b = Math.round(b), w = Math.round(w), r.forEach(function (e) {
          var n = Math.round(t.centerSnapValue(e, p));
          e.isVisible = n === w;
        }), o.forEach(function (e) {
          var n = Math.round(t.centerSnapValue(e, f));
          e.isVisible = n === b;
        }), new R(b, w).add(u);
      }

      return {
        x: d,
        y: g
      };
    }, this.editor = e, this.configStore = e.configStore, this.state = ai(xl), this.rotationOffset = null, this.positionOffset = null, this.state.horizontalGuides = this.getHorizontalGuidesFromConfig(), this.state.verticalGuides = this.getVerticalGuidesFromConfig(), this.state.rotationGuides = this.getRotationGuidesFromConfig();
  }

  return e.prototype.hidePositionGuides = function () {
    this.positionOffset = null, this.state.verticalGuides = this.state.verticalGuides.map(function (e) {
      return _v2(_v2({}, e), {
        isVisible: !1
      });
    }), this.state.horizontalGuides = this.state.horizontalGuides.map(function (e) {
      return _v2(_v2({}, e), {
        isVisible: !1
      });
    });
  }, e.prototype.hideRotationGuides = function () {
    this.rotationOffset = null, this.state.rotationGuides = this.state.rotationGuides.map(function (e) {
      return _v2(_v2({}, e), {
        isVisible: !1
      });
    });
  }, Object.defineProperty(e.prototype, "positionGuides", {
    get: function get() {
      var e = this.state;
      return C(e.verticalGuides, e.horizontalGuides);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotationGuides", {
    get: function get() {
      return this.state.rotationGuides;
    },
    enumerable: !0,
    configurable: !0
  }), w([ai], e.prototype, "state", void 0), w([sr], e.prototype, "snapToRotation", void 0), w([sr], e.prototype, "snapToPosition", void 0), w([sr], e.prototype, "hidePositionGuides", null), w([sr], e.prototype, "hideRotationGuides", null), w([fi], e.prototype, "positionGuides", null), w([fi], e.prototype, "rotationGuides", null), e;
}(),
    Tl = {
  text: "Write Something",
  identifier: "imgly_font_open_sans_bold",
  fontSize: 73.3,
  defaultFontSize: 73.3,
  fontFamily: "Open Sans",
  fontStyle: "",
  fontWeight: "bold",
  lineHeight: 1,
  alignment: "center",
  textColor: Jt.white,
  backgroundColor: Jt.transparent || [0, 0, 0, 0],
  width: 0
},
    Sl = {},
    Cl = {
  100: "Extra Light",
  200: "Light",
  300: "Book",
  400: "Regular",
  500: "Medium",
  600: "Semibold",
  700: "Bold",
  800: "Black",
  900: "Extra Black",
  bold: "Bold",
  normal: "Regular",
  lighter: "Lighter"
},
    El = function () {
  function e(e) {
    var t = this;
    this.state = ai.map(Sl), this.loadingObservable = ai.box(!1), this.add = function () {
      t.loadfonts(function () {
        t.editor.spriteStore.addText({
          state: {
            identifier: Tl.identifier,
            text: Tl.text,
            textColor: Tl.textColor,
            backgroundColor: Tl.backgroundColor,
            lineHeight: Tl.lineHeight,
            alignment: Tl.alignment,
            fontSize: 0
          }
        });
      });
    }, this.setEditMode = function (e) {
      t.editor.spriteStore.setEditMode(e);
    }, this.changeFont = function (e) {
      var n = t.fonts.find(function (t) {
        return t.identifier === e;
      });
      t.changeIdentifier(n, t.id), t.id && t.addSnapshot("edit", t.locale.history.fontFamily);
    }, this.changeIdentifier = function (e, n) {
      lr(function () {
        if (e && n) {
          var i = t.state.get(n);

          if (i) {
            t.editor.spriteStore.setContainerProperties(n, {
              fontIdentifier: e.identifier
            }, !0);
            var r = t.editor.spriteStore.getContainerProperties(n);
            i.identifier = r.fontIdentifier, i.fontFamily = e.fontFamily, i.fontStyle = e.fontStyle, i.fontWeight = e.fontWeight, i.fontSize = r.fontSize, i.width = r.width, i.defaultFontSize = i.fontSize, t.state.set(n, i);
          }
        }
      });
    }, this.changeFontSize = function (e, n) {
      if (void 0 === n && (n = !1), t.id) {
        var i = t.state.get(t.id);
        i && (i.fontSize = e, n && (i.defaultFontSize = e), t.state.set(t.id, i));
      }
    }, this.updateDefaultFontSize = function () {
      if (t.id) {
        var e = t.state.get(t.id);
        e && (e.defaultFontSize = e.fontSize, t.state.set(t.id, e));
      }
    }, this.changeSize = function (e, n) {
      var i = t.state.get(e);
      i && (i.width = n.width, i.fontSize = n.fontSize, i.defaultFontSize = n.fontSize, t.state.set(e, i));
    }, this.changeWidth = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);
        n && (n.width = e, t.state.set(t.id, n));
      }
    }, this.changeText = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            text: e
          }, !0);
          var i = t.editor.spriteStore.getContainerProperties(t.id),
              r = t.editor.outputContainer.getSizeInOutputSpace(),
              o = t.editor.spriteStore.getSize(t.id);
          t.config.disableAutoScaling || o.height > r.height && t.editor.spriteStore.setContainerProperties(t.id, {
            fontSize: t.calculateFitFontSize(t.id, r.height)
          }, !0), i = t.editor.spriteStore.getContainerProperties(t.id), n.text = i.text, n.fontSize = i.fontSize, n.defaultFontSize = i.fontSize, t.state.set(t.id, n), t.addSnapshot("edit", t.locale.history.edit);
        }
      }
    }, this.changeLineHeight = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n && e) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            lineHeight: e
          }, !0);
          var i = t.editor.spriteStore.getContainerProperties(t.id);
          n.lineHeight = i.lineHeight, t.state.set(t.id, n);
        }
      }
    }, this.changeColor = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            textColor: e
          });
          var i = t.editor.spriteStore.getContainerProperties(t.id);
          n.textColor = i.textColor, t.state.set(t.id, n);
        }
      }
    }, this.changeBackgroundColor = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            backgroundColor: e
          });
          var i = t.editor.spriteStore.getContainerProperties(t.id);
          n.backgroundColor = i.backgroundColor, t.state.set(t.id, n);
        }
      }
    }, this.colorSnapshot = function () {
      t.addSnapshot("edit", t.locale.history.textColor);
    }, this.backgroundColorSnapshot = function () {
      t.addSnapshot("edit", t.locale.history.backgroundColor);
    }, this.changeAlignment = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            alignment: e
          });
          var i = t.editor.spriteStore.getContainerProperties(t.id);
          n.alignment = i.alignment, t.state.set(t.id, n), t.addSnapshot("edit", t.locale.history.alignment);
        }
      }
    }, this.setFontSize = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            fontSize: e
          }, !0);
          var i = t.editor.spriteStore.getContainerProperties(t.id);
          n.fontSize = i.fontSize, n.defaultFontSize = i.fontSize, t.state.set(t.id, n);
        }
      }
    }, this.editor = e, this.fonts.find(function (e) {
      return e.identifier === Tl.identifier;
    }) || (Tl.identifier = this.fonts[0].identifier), Tl.text = this.locale.canvasControls.placeholderText;
  }

  return e.defaultText = function () {
    return Tl.text;
  }, Object.defineProperty(e, "defaultColors", {
    get: function get() {
      return Yl.defaultColors;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultBackgroundColors", {
    get: function get() {
      return Yl.defaultBackgroundColors;
    },
    enumerable: !0,
    configurable: !0
  }), e.getDisplayFontStyle = function (e) {
    return ((e.fontWeight && "regular" !== Cl[e.fontWeight].toLowerCase() ? Cl[e.fontWeight] : "") + " " + (e.fontStyle && "normal" !== e.fontStyle.toLowerCase() ? e.fontStyle : "")).trim();
  }, e.prototype.loadfonts = function (e) {
    var t = this;
    if (this.fontsLoaded) e();else {
      var n = this.editor.assetProvider.getFontManager(),
          i = this.editor.assetProvider.getFontAssetsForText().map(function (e) {
        return e.identifier;
      });
      n.loadFontsWithIdentifiers(i).then(function () {
        t.loadingObservable.set(!0), e();
      }).catch(function (e) {
        t.editor.modalStore.showActionModal({
          identifier: "fontLoading",
          handlers: {},
          error: e
        });
      });
    }
  }, e.prototype.doesTextAssetExist = function (e) {
    return -1 !== this.editor.assetProvider.getFontAssets().findIndex(function (t) {
      return t.identifier === e;
    });
  }, e.prototype.addOrselect = function () {
    this.state.size ? this.selectLast() : this.add();
  }, e.prototype.selectLast = function () {
    this.editor.spriteStore.selectHighestOrderSprite(Array.from(this.state.keys()));
  }, e.prototype.duplicate = function () {
    if (this.id) {
      var e = this.editor.spriteStore.getDuplicateContainerTransform(this.id);
      this.editor.spriteStore.addText({
        state: {
          identifier: this.identifier,
          text: this.text,
          textColor: xr(this.textColor),
          lineHeight: this.lineHeight,
          alignment: this.alignment,
          fontSize: this.fontSize,
          backgroundColor: xr(this.backgroundColor),
          width: this.width
        },
        transform: e
      });
    }
  }, e.prototype.bringToFront = function () {
    this.id && this.editor.spriteStore.bringToFront(this.id);
  }, e.prototype.delete = function () {
    if (this.id) {
      var e = this.id;
      this.editor.spriteStore.removeSprite(e), this.state.delete(e), this.selectLast();
    }
  }, e.prototype.calculateFitFontSize = function (t, n) {
    if (!e.measureContext) {
      var i = document.createElement("canvas");
      e.measureContext = i.getContext("2d");
    }

    for (var r = this.editor.spriteStore.getContainerProperties(t), o = this.editor.engine.assetProvider.getFontManager().getFontWithId(r.fontIdentifier), a = this.config.minFontSizeForAutoScaling, s = Bt(e.measureContext, r.text, o, r.fontSize, r.lineHeight, r.width, o.textMetrics), l = Math.min(Math.floor(r.fontSize * (n / s.height)), 1), u = Math.round(r.fontSize), c = 0, p = u - l, f = Math.floor(2 * (u - l)), h = p; c <= f;) {
      p = c + Math.floor((f - c) / 2);
      var d = Bt(e.measureContext, r.text, o, p, r.lineHeight, r.width, o.textMetrics);
      if (n < d.height) f = p - 1, h = p - 1;else {
        if (!(n > d.height)) {
          h = p;
          break;
        }

        if (c = p + 1, l + p >= u) return u;
      }
    }

    return a && h < a ? a : h;
  }, e.prototype.toolSnapshot = function () {
    this.addSnapshot("edit", this.locale.history.lineSpacing);
  }, e.prototype.addSnapshot = function (e, t) {
    this.currentText && this.editor.spriteStore.addSnapshot(e, t);
  }, e.prototype.updateStateFromHistory = function (e, t) {
    this.setState(e, t), this.editor.spriteStore.setContainerProperties(e, t);
  }, e.prototype.setState = function (e, t) {
    var n = this.state.get(e);
    if (n) t.alignment && (n.alignment = t.alignment), t.text && (n.text = t.text), t.lineHeight && (n.lineHeight = t.lineHeight), t.textColor && (n.textColor = t.textColor), t.backgroundColor && (n.backgroundColor = t.backgroundColor), t.fontIdentifier && (n.identifier = t.fontIdentifier), t.fontSize && (n.fontSize = t.fontSize, n.defaultFontSize = t.fontSize), t.width && (n.width = t.width);else {
      var i = this.fonts.find(function (e) {
        return e.identifier === t.fontIdentifier;
      });
      this.state.set(e, {
        text: t.text,
        identifier: t.fontIdentifier,
        alignment: t.alignment,
        textColor: t.textColor ? t.textColor : Tl.textColor,
        backgroundColor: t.backgroundColor ? t.backgroundColor : Tl.backgroundColor,
        fontFamily: i.fontFamily,
        fontStyle: i.fontStyle,
        fontSize: t.fontSize,
        fontWeight: i.fontWeight,
        lineHeight: t.lineHeight,
        width: t.width,
        defaultFontSize: t.fontSize
      });
    }
  }, e.prototype.pureReset = function () {
    this.state = ai.map(Sl);
  }, Object.defineProperty(e.prototype, "isEditMode", {
    get: function get() {
      return this.editor.spriteStore.isEditMode;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isTextSelected", {
    get: function get() {
      return this.editor.spriteStore.isSpriteText;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "fontsLoaded", {
    get: function get() {
      return this.loadingObservable.get();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "currentText", {
    get: function get() {
      if (this.isTextSelected) {
        var e = this.state.get(this.id);
        if (e) return e;
      }
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "text", {
    get: function get() {
      return this.currentText ? this.currentText.text : Tl.text;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "fontSize", {
    get: function get() {
      return this.currentText ? this.currentText.fontSize : Tl.fontSize;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "defaultFontSize", {
    get: function get() {
      return this.currentText ? this.currentText.defaultFontSize : Tl.defaultFontSize;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "width", {
    get: function get() {
      return this.currentText ? this.currentText.width : Tl.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "fontFamily", {
    get: function get() {
      return this.currentText ? this.currentText.fontFamily : Tl.fontFamily;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "fontStyle", {
    get: function get() {
      return this.currentText ? this.currentText.fontStyle : Tl.fontStyle;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "fontWeight", {
    get: function get() {
      return this.currentText ? this.currentText.fontWeight : Tl.fontWeight;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "lineHeight", {
    get: function get() {
      return this.currentText ? this.currentText.lineHeight : Tl.lineHeight;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.currentText ? this.currentText.identifier : Tl.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "id", {
    get: function get() {
      if (this.isTextSelected) return this.editor.spriteStore.id;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "alignment", {
    get: function get() {
      return this.currentText ? this.currentText.alignment : Tl.alignment;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "textColor", {
    get: function get() {
      return this.currentText ? this.currentText.textColor : Tl.textColor;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "backgroundColor", {
    get: function get() {
      return this.currentText ? this.currentText.backgroundColor : Tl.backgroundColor;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.TEXT];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.TEXT];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "localeColor", {
    get: function get() {
      return this.editor.configStore.locale.common.color;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rawOptions", {
    get: function get() {
      return this.editor.assetProvider.getFontAssetsForText();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "availableOptions", {
    get: function get() {
      return this.config.fonts.length ? this.config.fonts.map(function (e) {
        return e.identifier;
      }) : this.rawOptions.map(function (e) {
        return e.identifier;
      });
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "fonts", {
    get: function get() {
      var e = this;
      return this.rawOptions.reduce(function (t, n) {
        return -1 !== e.availableOptions.indexOf(n.identifier) ? C(t, [{
          identifier: n.identifier,
          fontFamily: n.fontFamily,
          fontStyle: n.fontStyle || "",
          fontWeight: n.fontWeight || ""
        }]) : t;
      }, []);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "fontFamilies", {
    get: function get() {
      return C(new Set(this.fonts));
    },
    enumerable: !0,
    configurable: !0
  }), w([sr], e.prototype, "addOrselect", null), w([sr], e.prototype, "selectLast", null), w([sr], e.prototype, "add", void 0), w([sr], e.prototype, "duplicate", null), w([sr], e.prototype, "bringToFront", null), w([sr], e.prototype, "delete", null), w([sr], e.prototype, "setEditMode", void 0), w([sr], e.prototype, "changeFont", void 0), w([sr], e.prototype, "changeIdentifier", void 0), w([sr], e.prototype, "changeFontSize", void 0), w([sr], e.prototype, "updateDefaultFontSize", void 0), w([sr], e.prototype, "changeSize", void 0), w([sr], e.prototype, "changeWidth", void 0), w([sr], e.prototype, "changeText", void 0), w([sr], e.prototype, "changeLineHeight", void 0), w([sr], e.prototype, "changeColor", void 0), w([sr], e.prototype, "changeBackgroundColor", void 0), w([sr], e.prototype, "changeAlignment", void 0), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "setState", null), w([sr], e.prototype, "setFontSize", void 0), w([sr], e.prototype, "pureReset", null), w([fi], e.prototype, "isEditMode", null), w([fi], e.prototype, "isTextSelected", null), w([fi], e.prototype, "fontsLoaded", null), w([fi], e.prototype, "currentText", null), w([fi], e.prototype, "text", null), w([fi], e.prototype, "fontSize", null), w([fi], e.prototype, "defaultFontSize", null), w([fi], e.prototype, "width", null), w([fi], e.prototype, "fontFamily", null), w([fi], e.prototype, "fontStyle", null), w([fi], e.prototype, "fontWeight", null), w([fi], e.prototype, "lineHeight", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "id", null), w([fi], e.prototype, "alignment", null), w([fi], e.prototype, "textColor", null), w([fi], e.prototype, "backgroundColor", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "localeColor", null), w([fi], e.prototype, "rawOptions", null), w([fi], e.prototype, "availableOptions", null), w([fi], e.prototype, "fonts", null), w([fi], e.prototype, "fontFamilies", null), e;
}(),
    Ol = {
  identifier: "imgly_text_design_blocks",
  color: Jt.white,
  isInverted: !1,
  text: "Write Something With Style",
  seed: 0,
  padding: 0,
  width: 0
},
    Rl = {
  imgly_text_design_blocks: 835,
  imgly_text_design_rotated: 6,
  imgly_text_design_blocks_light: 3,
  imgly_text_design_equal_width: 727,
  imgly_text_design_masked: 259,
  imgly_text_design_celebrate: 579,
  imgly_text_design_sunshine: 77,
  imgly_text_design_masked_badge: 683,
  imgly_text_design_blocks_condensed: 673,
  imgly_text_design_celebrate_simple: 425,
  imgly_text_design_equal_width_fat: 961,
  imgly_text_design_watercolor: 671,
  imgly_text_design_particles: 683,
  imgly_text_design_masked_speech_bubble: 317,
  imgly_text_design_masked_speech_bubble_comic: 229,
  imgly_text_design_multiline: 831
},
    Il = {},
    Al = function () {
  function e(e) {
    var t = this;
    this.state = ai.map(Il), this.fontsLoaded = !1, this.add = function () {
      t.loadfonts(function () {
        t.editor.spriteStore.addTextDesign({
          state: {
            identifier: Ol.identifier,
            text: Ol.text,
            color: Ol.color,
            isInverted: Ol.isInverted,
            seed: Rl[Ol.identifier] || Ol.seed,
            padding: 0
          }
        });
      });
    }, this.changeText = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            text: e
          }, !0);
          var i = t.editor.spriteStore.getContainerProperties(t.id);
          n.text = i.text, t.state.set(t.id, n), t.addSnapshot("edit", t.locale.history.edit);
        }
      }
    }, this.setEditMode = function (e) {
      t.editor.spriteStore.setEditMode(e);
    }, this.changeSeed = function () {
      if (t.id) {
        var e = t.state.get(t.id);

        if (e) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            seed: -1
          }, !0);
          var n = t.editor.spriteStore.getContainerProperties(t.id);
          e.seed = n.seed, t.state.set(t.id, e), t.addSnapshot("edit", t.locale.history.shuffle);
        }
      }
    }, this.changeIdentifier = function (e, n, i, r) {
      if (void 0 === n && (n = !0), void 0 === i && (i = null), void 0 === r && (r = t.id), r && e !== t.identifier) {
        var o = t.state.get(r),
            a = t.editor.spriteStore.getContainerTransform(r);
        t.editor.spriteStore.addTextDesign({
          spriteId: r,
          state: {
            identifier: e,
            text: o.text,
            color: xr(o.color),
            isInverted: o.isInverted,
            seed: i || Rl[e] || o.seed,
            padding: o.padding,
            width: o.width
          },
          transform: a
        }, n, !0);
      }
    }, this.changeColor = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            color: e
          });
          var i = t.editor.spriteStore.getContainerProperties(t.id);
          n.color = i.color, t.state.set(t.id, n);
        }
      }
    }, this.colorSnapshot = function () {
      t.addSnapshot("edit", t.locale.history.color);
    }, this.invertBackground = function () {
      if (t.id) {
        var e = t.state.get(t.id);

        if (e) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            inverted: !e.isInverted
          }, !0);
          var n = t.editor.spriteStore.getContainerProperties(t.id);
          e.isInverted = n.inverted, t.state.set(t.id, e), t.addSnapshot("edit", t.locale.history.invert);
        }
      }
    }, this.changeWidth = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);
        n && (n.width = e, t.state.set(t.id, n));
      }
    }, this.changePadding = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);
        n && (n.padding = e, t.state.set(t.id, n));
      }
    }, this.editor = e, this.entityManager = new _o([{
      identifier: "",
      name: "",
      items: this.editor.assetProvider.getAssets("textdesign")
    }], _v2(_v2({}, this.config), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !0,
      locale: {},
      getAssetPath: this.editor.getAssetPath("textdesign")
    })), this.entityManager.items.find(function (e) {
      return e.identifier === Ol.identifier;
    }) || (Ol.identifier = this.entityManager.items[0].identifier), Ol.text = this.locale.canvasControls.placeholderText;
  }

  return Object.defineProperty(e, "colors", {
    get: function get() {
      return Yl.defaultColors;
    },
    enumerable: !0,
    configurable: !0
  }), e.defaultText = function () {
    return Ol.text;
  }, e.prototype.loadfonts = function (e) {
    var t = this;
    if (this.fontsLoaded) e();else {
      var n = this.editor.assetProvider.getFontManager(),
          i = this.editor.assetProvider.getFontAssetsForTextDesign().map(function (e) {
        return e.identifier;
      });
      n.loadFontsWithIdentifiers(i).then(function () {
        t.fontsLoaded = !0, e();
      }).catch(function () {
        t.editor.modalStore.showActionModal({
          identifier: "fontLoading",
          handlers: {},
          error: i[0]
        });
      });
    }
  }, e.prototype.doesTextDesignAssetExist = function (e) {
    return -1 !== this.entityManager.items.findIndex(function (t) {
      return t.identifier === e;
    });
  }, e.prototype.addOrselect = function () {
    this.state.size ? this.selectLast() : this.add();
  }, e.prototype.selectLast = function () {
    this.editor.spriteStore.selectHighestOrderSprite(Array.from(this.state.keys()));
  }, e.prototype.updateStateFromHistory = function (e, t) {
    var n = this.state.get(e);
    t.identifier === n.identifier ? (this.setState(e, t), this.editor.spriteStore.setContainerProperties(e, t)) : this.changeIdentifier(t.identifier, !1, t.seed, e);
  }, e.prototype.setState = function (e, t) {
    var n = this.state.get(e);
    n ? (t.inverted && (n.isInverted = t.inverted), t.seed && (n.seed = t.seed), t.color && (n.color = t.color), t.padding && (n.padding = t.padding), t.width && (n.width = t.width)) : this.state.set(e, {
      width: t.width,
      text: t.text,
      isInverted: t.inverted,
      identifier: t.identifier,
      seed: t.seed,
      color: t.color ? t.color : Ol.color,
      padding: t.padding
    });
  }, e.prototype.duplicate = function () {
    if (this.id) {
      var e = this.editor.spriteStore.getDuplicateContainerTransform(this.id);
      this.editor.spriteStore.addTextDesign({
        state: {
          identifier: this.identifier,
          text: this.text,
          color: xr(this.color),
          isInverted: this.isInverted,
          seed: this.seed,
          padding: this.padding,
          width: this.width
        },
        transform: e
      });
    }
  }, e.prototype.bringToFront = function () {
    this.id && this.editor.spriteStore.bringToFront(this.id);
  }, e.prototype.addSnapshot = function (e, t) {
    this.currentTextDesign && this.editor.spriteStore.addSnapshot(e, t);
  }, e.prototype.delete = function (e) {
    void 0 === e && (e = this.id), e && (this.editor.spriteStore.removeSprite(e), this.state.delete(e), this.selectLast());
  }, e.prototype.pureReset = function () {
    this.state = ai.map(Il);
  }, Object.defineProperty(e.prototype, "isTextDesignSelected", {
    get: function get() {
      return this.editor.spriteStore.isSpriteTextDesign;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isEditMode", {
    get: function get() {
      return this.editor.spriteStore.isEditMode;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "currentTextDesign", {
    get: function get() {
      if (this.isTextDesignSelected && this.id) {
        var e = this.state.get(this.id);
        if (e) return e;
      }
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "id", {
    get: function get() {
      if (this.isTextDesignSelected) return this.editor.spriteStore.id;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "text", {
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.text : Ol.text;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "seed", {
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.seed : Ol.seed;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "padding", {
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.padding : Ol.padding;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "width", {
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.width : Ol.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.identifier : null;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isInverted", {
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.isInverted : Ol.isInverted;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "color", {
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.color : Ol.color;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.TEXT_DESIGN];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.TEXT_DESIGN];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "localeColor", {
    get: function get() {
      return this.editor.configStore.locale.common.color;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "entities", {
    get: function get() {
      return this.entityManager.getEntities();
    },
    enumerable: !0,
    configurable: !0
  }), w([sr], e.prototype, "addOrselect", null), w([sr], e.prototype, "selectLast", null), w([sr], e.prototype, "add", void 0), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "setState", null), w([sr], e.prototype, "changeText", void 0), w([sr], e.prototype, "setEditMode", void 0), w([sr], e.prototype, "duplicate", null), w([sr], e.prototype, "bringToFront", null), w([sr], e.prototype, "delete", null), w([sr], e.prototype, "changeSeed", void 0), w([sr], e.prototype, "changeIdentifier", void 0), w([sr], e.prototype, "changeColor", void 0), w([sr], e.prototype, "invertBackground", void 0), w([sr], e.prototype, "changeWidth", void 0), w([sr], e.prototype, "changePadding", void 0), w([sr], e.prototype, "pureReset", null), w([fi], e.prototype, "isTextDesignSelected", null), w([fi], e.prototype, "isEditMode", null), w([fi], e.prototype, "currentTextDesign", null), w([fi], e.prototype, "id", null), w([fi], e.prototype, "text", null), w([fi], e.prototype, "seed", null), w([fi], e.prototype, "padding", null), w([fi], e.prototype, "width", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "isInverted", null), w([fi], e.prototype, "color", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "localeColor", null), w([fi], e.prototype, "entities", null), e;
}(),
    Ml = [[0, 0], [0, 1], [1, 0], [1, 1]],
    Fl = [[0, 1, 2, 3], [2, 3, 0, 1], [1, 0, 3, 2], [3, 2, 1, 0]],
    Dl = function () {
  function e(t, n, i, r, o) {
    void 0 === i && (i = "center"), void 0 === r && (r = !0), void 0 === o && (o = !1), this.considerRotation = !0, this.considerFlip = !0, this.store = n, this.m = "center" === i ? e.movePivotTo([.5, .5]) : Ml, this.considerRotation = r, this.considerFlip = o, this.configStore = t.configStore;
  }

  return e.getFlippedEdgeIndex = function (e, t, n) {
    return Fl[(t ? 1 : 0) + (n ? 2 : 0)][e];
  }, e.movePivotTo = function (e) {
    return Ml.map(function (t) {
      return [t[0] - e[0], t[1] - e[1]];
    });
  }, Object.defineProperty(e.prototype, "position", {
    get: function get() {
      return this.store.position;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "size", {
    get: function get() {
      return this.store.size;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotation", {
    get: function get() {
      return this.considerRotation ? this.store.rotationWRTOutputRotation : 0;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "flipHorizontally", {
    get: function get() {
      return !!this.considerFlip && this.store.isFlippedHorizontal;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "flipVertically", {
    get: function get() {
      return !!this.considerFlip && this.store.isFlippedVertical;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "flipCenter", {
    get: function get() {
      return this.considerFlip ? this.store.flipCenter : null;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.handleOrigin = function (t, n, i) {
    var r = e.getFlippedEdgeIndex(t, n, i);
    return {
      width: this.m[r][0] * this.size.width,
      height: this.m[r][1] * this.size.height
    };
  }, Object.defineProperty(e.prototype, "leftTop", {
    get: function get() {
      var t = this.position,
          n = this.flipHorizontally,
          i = this.flipVertically,
          r = this.handleOrigin(0, n, i);
      return e.coordinatesWithRotation(r, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftBottom", {
    get: function get() {
      var t = this.position,
          n = this.flipHorizontally,
          i = this.flipVertically,
          r = this.handleOrigin(1, n, i);
      return e.coordinatesWithRotation(r, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightTop", {
    get: function get() {
      var t = this.position,
          n = this.flipHorizontally,
          i = this.flipVertically,
          r = this.handleOrigin(2, n, i);
      return e.coordinatesWithRotation(r, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightBottom", {
    get: function get() {
      var t = this.position,
          n = this.flipHorizontally,
          i = this.flipVertically,
          r = this.handleOrigin(3, n, i);
      return e.coordinatesWithRotation(r, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftBottomHandle", {
    get: function get() {
      var t = this.position,
          n = this.flipHorizontally,
          i = this.flipVertically,
          r = this.handleOrigin(1, n, i);
      return r.height += this.configStore.measurements.canvasControls.sprite.rotateHandle.height, e.coordinatesWithRotation(r, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightBottomHandle", {
    get: function get() {
      var t = this.position,
          n = this.flipHorizontally,
          i = this.flipVertically,
          r = this.handleOrigin(3, n, i);
      return r.height += this.configStore.measurements.canvasControls.sprite.rotateHandle.height, e.coordinatesWithRotation(r, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftMid", {
    get: function get() {
      var e = new R(this.leftTop),
          t = new R(this.leftBottom);
      return e.add(t).divide(2);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightMid", {
    get: function get() {
      var e = new R(this.rightTop),
          t = new R(this.rightBottom);
      return e.add(t).divide(2);
    },
    enumerable: !0,
    configurable: !0
  }), e.coordinatesWithRotation = function (e, t, n, i, r, o) {
    var a = e.width,
        s = e.height,
        l = a * Math.cos(t) - s * Math.sin(t) + o.x,
        u = a * Math.sin(t) + s * Math.cos(t) + o.y;
    return n && (l = 2 * r.x - l), i && (u = 2 * r.y - u), new R({
      x: l,
      y: u
    }).rounded;
  }, w([fi], e.prototype, "position", null), w([fi], e.prototype, "size", null), w([fi], e.prototype, "rotation", null), w([fi], e.prototype, "flipHorizontally", null), w([fi], e.prototype, "flipVertically", null), w([fi], e.prototype, "flipCenter", null), w([fi], e.prototype, "leftTop", null), w([fi], e.prototype, "leftBottom", null), w([fi], e.prototype, "rightTop", null), w([fi], e.prototype, "rightBottom", null), w([fi], e.prototype, "leftBottomHandle", null), w([fi], e.prototype, "rightBottomHandle", null), w([fi], e.prototype, "leftMid", null), w([fi], e.prototype, "rightMid", null), e;
}();

function Pl(e, t) {
  return void 0 === t && (t = !1), new Promise(function (n, i) {
    var r = new Image();
    r.addEventListener("load", function () {
      var i = null;

      if (t) {
        var o = document.createElement("canvas"),
            a = o.getContext("2d"),
            s = 150 * r.height / r.width;
        o.width = 150, o.height = s, a.drawImage(r, 0, 0, 150, s), i = o.toDataURL();
      }

      n({
        image: e,
        smallImage: i
      });
    }), r.addEventListener("error", function () {
      i();
    }), r.src = e;
  });
}

function zl(e, t) {
  var n = this;
  return void 0 === t && (t = !1), new Promise(function (i, r) {
    var o = new FileReader();
    o.onload = function (o) {
      return x(n, void 0, void 0, function () {
        return k(this, function (n) {
          return Pl(o.target.result, t).then(function (t) {
            i(_v2(_v2({}, t), {
              name: e.name || "",
              type: e.type,
              id: F()
            }));
          }).catch(function (e) {
            r(e);
          }), [2];
        });
      });
    }, o.readAsDataURL(e);
  });
}

var Ll,
    Bl = function Bl(e) {
  return {
    height: e.y,
    width: e.x
  };
},
    Nl = {},
    Ul = {
  x: 0,
  y: 0
},
    jl = function () {
  function e(e) {
    var t = this;
    this.state = ai.map(Nl), this.selectedId = ai.box("none"), this.editMode = ai.box(!1), this.dragMode = ai.box(!1), this.minLength = 0, this.setEditMode = function (e) {
      t.currentSprite && -1 !== [P.TEXT, P.TEXT_DESIGN].indexOf(t.tool) && (e ? t.editor.modalStore.showModalOfType(Nt.TEXT_EDIT) : t.editor.modalStore.hideModal(), t.editMode.set(e));
    }, this.onWidthDrag = function (e) {
      var n = e.x,
          i = e.y,
          r = new R(t.currentSprite.position),
          o = new R(n, i).subtract(r).magnitude,
          a = t.editor.previewToWorld(2 * o);

      if (a > t.minLength && (t.setContainerProperties(t.id, {
        width: a
      }, !0), t.isSpriteText)) {
        var s = t.getContainerProperties(t.id);
        t.textToolStore.changeWidth(s.width);
      }
    }, this.onPaddingDrag = function (e) {
      var n = e.x,
          i = e.y;

      if (t.isSpriteTextDesign) {
        var r = t.getContainerProperties(t.id),
            o = new R(t.currentSprite.position),
            a = new R(n, i).subtract(o).magnitude,
            s = Math.max(t.editor.previewToWorld(a) - r.width / 2, 0);
        t.setContainerProperties(t.id, {
          padding: s
        }, !0), t.isSpriteTextDesign && (r = t.getContainerProperties(t.id), t.textDesignToolStore.changePadding(r.padding));
      }
    }, this.correctTextFlip = function () {
      var e = t.editor.outputContainer.getData(),
          n = e.flipHorizontally,
          i = e.flipVertically;
      Object.values(t.container).forEach(function (e) {
        "text" !== e.type && "text-design" !== e.type || (e.setFlipHorizontally(n), e.setFlipVertically(i));
      });
    }, this.reverseTextHorizontally = function () {
      Object.values(t.container).forEach(function (e) {
        "text" !== e.type && "text-design" !== e.type || e.setFlipHorizontally(!e.getFlipHorizontally());
      });
    }, this.reverseTextVertically = function () {
      Object.values(t.container).forEach(function (e) {
        "text" !== e.type && "text-design" !== e.type || e.setFlipVertically(!e.getFlipVertically());
      });
    }, this.updatePositionAndSize = function (e, n) {
      void 0 === e && (e = t.id), void 0 === n && (n = !1);
      var i = t.getSizePositionFromContainer(e),
          r = i.position,
          o = i.size,
          a = t.state.get(e);

      if (a) {
        if (a.position.x = r.x, a.position.y = r.y, a.size.width = o.width, a.size.height = o.height, n) {
          var s = t.container[e].getRotation();
          t.container[e].setRotation(s), a.rotation = t.container[e].getRotation();
        }

        t.state.set(e, a);
      }
    }, this.getSize = function (e) {
      void 0 === e && (e = t.id);
      var n = t.container[e];
      return n ? t.editor.worldSizeToPreview(n.getSizeInWorldSpace()) : {
        width: 0,
        height: 0
      };
    }, this.editor = e, this.container = {}, this.stickerToolStore = new ql(e), this.textToolStore = new El(e), this.textDesignToolStore = new Al(e), this.rect = new Dl(this.editor, this), this.minLength = this.editor.configStore.measurements.canvasControls.sprite.minSize / Math.sqrt(2);
  }

  return e.magnitude = function (e, t) {
    return new R(e, t || e).magnitude;
  }, e.sizeMagnitude = function (e) {
    return Math.sqrt(e.width * e.width + e.height * e.height);
  }, e.prototype.addSticker = function (e, t) {
    return void 0 === t && (t = !0), x(this, void 0, void 0, function () {
      return k(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this.addStickerAsync(e, t)];

          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, e.prototype.addStickerAsync = function (t, n) {
    var i = t.spriteId,
        r = t.state,
        o = t.transform;
    return void 0 === n && (n = !0), x(this, void 0, void 0, function () {
      var t = this;
      return k(this, function (a) {
        return [2, new Promise(function (a, s) {
          o = t.getInitialTransform(o);
          var l = r.identifier,
              u = t.editor.orderHelper.addSprite(l);
          t.editor.engine.addStickerFromAssets(l, t.editor.engineMediator.image.container, u).then(function (s) {
            return x(t, void 0, void 0, function () {
              var t, u, c, p, f, h, d, g, m;
              return k(this, function (y) {
                switch (y.label) {
                  case 0:
                    return i && s.setData({
                      id: i
                    }), t = s.getID(), this.container[t] = s, this.editor.orderHelper.renameSprite(l, t), (u = this.getSize(t)).width *= s.getScale().x, u.height *= s.getScale().y, s.setPivot(.5, .5), o.scale ? c = o.scale : o.size ? c = {
                      x: o.size.width / u.width,
                      y: o.size.height / u.height
                    } : (p = .4 * this.editor.shortestOutputSide, f = e.magnitude(p) / e.sizeMagnitude(s.getSizeInWorldSpace()), c = {
                      x: f,
                      y: f
                    }), h = this.editor.outputContainer.getData(), d = h.flipHorizontally, g = h.flipVertically, s.setFlipHorizontally(d), s.setFlipVertically(g), s.setTransform({
                      position: o.position,
                      scale: c,
                      rotation: o.rotation
                    }), void 0 !== r.flipHorizontally && s.setFlipHorizontally(r.flipHorizontally !== d), void 0 !== r.flipVertically && s.setFlipVertically(r.flipVertically !== g), this.setContainerProperties(t, _v2({}, r)), m = s.getData(), this.setInitialSpriteState(t, P.STICKER), this.stickerToolStore.setState(t, _v2(_v2({}, m), {
                      identifier: l
                    })), [4, this.editor.renderPromise()];

                  case 1:
                    return y.sent(), n && (this.selectedId.set(t), this.addSnapshot("add", this.stickerLocale.add)), a(), [2];
                }
              });
            });
          }).catch(function (e) {
            console.error(e), s();
          });
        })];
      });
    });
  }, e.prototype.addText = function (e, t) {
    return void 0 === t && (t = !0), x(this, void 0, void 0, function () {
      return k(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this.addTextAsync(e, t)];

          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, e.prototype.addTextAsync = function (e, t) {
    var n = this,
        i = e.spriteId,
        r = e.state,
        o = e.transform;
    return void 0 === t && (t = !0), new Promise(function (e, a) {
      o = n.getInitialTransform(o);
      var s = n.editor.orderHelper.addSprite(r.identifier),
          l = n.editor.shortestOutputSide,
          u = {
        fontIdentifier: r.identifier,
        text: r.text,
        width: r.width || .6 * l,
        fontSize: r.fontSize || .1 * l,
        lineHeight: r.lineHeight,
        alignment: r.alignment,
        textColor: r.textColor,
        backgroundColor: r.backgroundColor
      };
      r.backgroundColor === Tl.backgroundColor && delete u.backgroundColor, n.editor.engine.addTextWithFontLoading(u, n.editor.engineMediator.image.container, s).then(function (a) {
        return x(n, void 0, void 0, function () {
          var n, s, l, u, c;
          return k(this, function (p) {
            switch (p.label) {
              case 0:
                return i && a.setData({
                  id: i
                }), n = a.getID(), this.container[n] = a, this.editor.orderHelper.renameSprite(r.identifier, this.id), s = this.editor.outputContainer.getData(), l = s.flipHorizontally, u = s.flipVertically, a.setFlipHorizontally(l), a.setFlipVertically(u), a.setPivot(.5, .5), a.setPosition(o.position), a.setRotation(o.rotation), this.setInitialSpriteState(n, P.TEXT), c = a.getData(), this.textToolStore.setState(n, _v2({}, c)), [4, this.editor.renderPromise()];

              case 1:
                return p.sent(), t && (this.selectedId.set(n), this.addSnapshot("add", this.textLocale.add)), e(), [2];
            }
          });
        });
      }).catch(function (e) {
        console.error(e), a();
      });
    });
  }, e.prototype.addTextDesign = function (e, t, n) {
    return void 0 === t && (t = !0), void 0 === n && (n = !1), x(this, void 0, void 0, function () {
      return k(this, function (i) {
        switch (i.label) {
          case 0:
            return [4, this.addTextDesignAsync(e, t, n)];

          case 1:
            return i.sent(), [2];
        }
      });
    });
  }, e.prototype.addTextDesignAsync = function (e, t, n) {
    var i = this,
        r = e.spriteId,
        o = e.state,
        a = e.transform;
    return void 0 === t && (t = !0), void 0 === n && (n = !1), new Promise(function (e, s) {
      a = i.getInitialTransform(a);
      var l = i.editor.orderHelper.addSprite(o.identifier),
          u = i.editor.shortestOutputSide,
          c = {
        width: o.width || .6 * u,
        text: o.text,
        color: o.color,
        inverted: o.isInverted,
        seed: o.seed,
        padding: o.padding
      };
      i.editor.engine.addTextDesignAsync(o.identifier, c, i.editor.engineMediator.image.container, l).then(function (s) {
        return x(i, void 0, void 0, function () {
          var i, l, u, c, p;
          return k(this, function (f) {
            switch (f.label) {
              case 0:
                return r && (n && (this.pureRemoveSprite(r), this.textDesignToolStore.state.delete(r)), s.setData({
                  id: r
                })), i = s.getID(), this.container[i] = s, this.editor.orderHelper.renameSprite(o.identifier, this.id), l = this.editor.outputContainer.getData(), u = l.flipHorizontally, c = l.flipVertically, s.setFlipHorizontally(u), s.setFlipVertically(c), s.setPivot(.5, .5), s.setPosition(a.position), s.setRotation(a.rotation), this.setInitialSpriteState(i, P.TEXT_DESIGN), p = s.getData(), this.textDesignToolStore.setState(i, _v2(_v2({}, p), {
                  identifier: o.identifier
                })), [4, this.editor.renderPromise()];

              case 1:
                return f.sent(), t && (this.selectedId.set(i), this.addSnapshot("add", this.textDesignLocale.add)), e(), [2];
            }
          });
        });
      }).catch(function (e) {
        console.error(e), s();
      });
    });
  }, e.prototype.spriteLocalTransform = function () {
    return {
      position: this.editor.previewToOutput(this.position),
      size: this.size,
      rotation: this.rotation
    };
  }, e.prototype.clickableCanvas = function (e) {
    this.editor.clickableCanvas(e);
  }, e.prototype.setContainerProperties = function (e, t, n) {
    void 0 === n && (n = !1), this.container[e].setData(t), n && this.updatePositionAndSize(), this.editor.render();
  }, e.prototype.setContainerPosition = function (e, t) {
    this.container[e].setPosition(t);
  }, e.prototype.pureRemoveSprite = function (e) {
    return this.editor.engine.removeContainer(this.container[e]), -1 === this.container[e].getIndexInParent() && (delete this.container[e], this.state.delete(e), this.editor.orderHelper.removeSprite(e), !0);
  }, e.prototype.deleteSprite = function (e) {
    void 0 === e && (e = this.id);
    var t = this.state.get(e);
    t.tool === P.STICKER ? this.stickerToolStore.delete() : t.tool === P.TEXT ? this.textToolStore.delete() : t.tool === P.TEXT_DESIGN && this.textDesignToolStore.delete();
  }, e.prototype.removeSprite = function (e) {
    this.pureRemoveSprite(e) && (this.selectLast(), this.spriteSnapshot("delete"), this.editor.render());
  }, e.prototype.addSnapshot = function (e, t) {
    this.editor.addSnapshot(void 0, e, t);
  }, e.prototype.spriteSnapshot = function (e) {
    this.addSnapshot("edit", this.historyLocale[e]);
  }, e.prototype.updateStateFromHistory = function (e) {
    return x(this, void 0, void 0, function () {
      var t,
          n,
          i,
          r,
          o,
          a,
          s,
          l,
          u,
          c,
          p,
          f = this;
      return k(this, function (h) {
        switch (h.label) {
          case 0:
            if (t = Object.keys(this.container), (n = e.spriteIdList).length === t.length) return [3, 9];
            i = t.filter(function (e) {
              return -1 === n.indexOf(e);
            }), r = n.filter(function (e) {
              return -1 === t.indexOf(e);
            }), i.forEach(function (e) {
              f.pureRemoveSprite(e);
            }), o = 0, h.label = 1;

          case 1:
            return o < r.length ? (a = r[o], s = e.common ? e.common[a] : void 0, l = e.text ? e.text[a] : void 0, u = e.sticker ? e.sticker[a] : void 0, c = e.textdesign ? e.textdesign[a] : void 0, s ? (p = {
              spriteId: a,
              transform: {
                size: s.size ? Bl(R.fromSize(s.size)) : void 0,
                position: new R(s.position),
                rotation: s.rotation
              }
            }, l ? [4, this.addNewText(p, l)] : [3, 3]) : [3, 7]) : [3, 8];

          case 2:
            return h.sent(), [3, 7];

          case 3:
            return c ? [4, this.addNewTextDesign(p, c)] : [3, 5];

          case 4:
            return h.sent(), [3, 7];

          case 5:
            return u ? [4, this.addNewSticker(p, _v2(_v2({}, u), {
              flipHorizontally: s.flipHorizontally,
              flipVertically: s.flipVertically
            }))] : [3, 7];

          case 6:
            h.sent(), h.label = 7;

          case 7:
            return o += 1, [3, 1];

          case 8:
            return [3, 10];

          case 9:
            this.updateSpriteStateFromHistory(e), h.label = 10;

          case 10:
            return [2];
        }
      });
    });
  }, e.prototype.addNewText = function (e, t) {
    return x(this, void 0, void 0, function () {
      return k(this, function (n) {
        switch (n.label) {
          case 0:
            return this.textToolStore.doesTextAssetExist(t.identifier) ? [4, this.addTextAsync(_v2(_v2({}, e), {
              state: t
            }), !1)] : [3, 2];

          case 1:
            return n.sent(), [3, 3];

          case 2:
            throw new Error("Text identifier " + t.identifier + " doesn't exist");

          case 3:
            return [2];
        }
      });
    });
  }, e.prototype.addNewTextDesign = function (e, t) {
    return x(this, void 0, void 0, function () {
      return k(this, function (n) {
        switch (n.label) {
          case 0:
            return this.textDesignToolStore.doesTextDesignAssetExist(t.identifier) ? [4, this.addTextDesignAsync(_v2(_v2({}, e), {
              state: t
            }), !1)] : [3, 2];

          case 1:
            return n.sent(), [3, 3];

          case 2:
            throw new Error("TextDesign identifier " + t.identifier + " doesn't exist");

          case 3:
            return [2];
        }
      });
    });
  }, e.prototype.addNewSticker = function (e, t) {
    return x(this, void 0, void 0, function () {
      return k(this, function (n) {
        switch (n.label) {
          case 0:
            return this.stickerToolStore.doesStickerAssetExist(t.identifier) ? [4, this.addStickerAsync(_v2(_v2({}, e), {
              state: t
            }), !1)] : [3, 2];

          case 1:
            return n.sent(), [3, 3];

          case 2:
            throw new Error("Sticker identifier " + t.identifier + " doesn't exist");

          case 3:
            return [2];
        }
      });
    });
  }, e.prototype.updateSpriteStateFromHistory = function (e) {
    return x(this, void 0, void 0, function () {
      var t = this;
      return k(this, function (n) {
        return Object.keys(this.container).forEach(function (n) {
          var i = e.common ? e.common[n] : void 0,
              r = e.sticker ? e.sticker[n] : void 0,
              o = e.text ? e.text[n] : void 0,
              a = e.textdesign ? e.textdesign[n] : void 0,
              s = t.state.get(n);

          if (s && i) {
            t.state.set(n, s);
            var l = t.container[n];
            l.setPosition(new R(i.position)), l.setRotation(i.rotation), s.rotation = l.getRotation(), void 0 !== i.flipHorizontally && l.setFlipHorizontally(i.flipHorizontally), void 0 !== i.flipVertically && l.setFlipVertically(i.flipVertically), r ? (l.setSizeInWorldSpace(i.size), t.stickerToolStore.updateStateFromHistory(n, r)) : o ? t.textToolStore.updateStateFromHistory(n, _v2(_v2({}, o), {
              fontIdentifier: o.identifier
            })) : a && t.textDesignToolStore.updateStateFromHistory(n, _v2(_v2({}, a), {
              inverted: a.isInverted
            })), t.updatePositionAndSize(n);
          }
        }), [2];
      });
    });
  }, e.prototype.getSpriteHistoryState = function () {
    var e,
        t = this,
        n = xr(this.state),
        i = xr(this.textToolStore.state),
        r = xr(this.textDesignToolStore.state),
        o = ((e = {
      common: n
    })[P.STICKER] = xr(this.stickerToolStore.state), e[P.TEXT] = i, e[P.TEXT_DESIGN] = r, e.spriteIdList = Object.keys(this.container), e);
    return Object.keys(o.common).forEach(function (e) {
      o.common[e].size = t.container[e].getSizeInWorldSpace(), o.common[e].position = t.container[e].getPosition(), o.common[e].order = t.container[e].getIndexInParent();
    }), o;
  }, e.prototype.updateStateFromSerialization = function (e, t) {
    return x(this, void 0, void 0, function () {
      var n, i, r, o, a, s, l, u, c, p, f, h, d, g, m, y;
      return k(this, function (_) {
        switch (_.label) {
          case 0:
            if (!t || !t.length) return [3, 5];
            _.label = 1;

          case 1:
            return _.trys.push([1, 4,, 5]), n = t.map(function (e) {
              return Pl(e.raster.data, !0);
            }), [4, Promise.all(n)];

          case 2:
            return i = _.sent(), [4, this.stickerToolStore.addCustomStickerAsset(t.map(function (e, t) {
              return {
                image: i[t].image,
                smallImage: i[t].smallImage,
                name: e.name,
                type: e.raster.type,
                id: e.identifier
              };
            }))];

          case 3:
            return _.sent(), [3, 5];

          case 4:
            return _.sent(), this.editor.modalStore.hideModal(), this.editor.modalStore.showActionModal({
              identifier: "stickerLoading"
            }), [3, 5];

          case 5:
            r = 0, _.label = 6;

          case 6:
            return r < e.spriteIdList.length ? (o = e.spriteIdList[r], a = e.common ? e.common[o] : void 0, s = e.sticker ? e.sticker[o] : void 0, l = e.text ? e.text[o] : void 0, u = e.textdesign ? e.textdesign[o] : void 0, a ? ((c = a.size) && (c = {
              width: this.editor.worldToPreview(a.size.width),
              height: this.editor.worldToPreview(a.size.height)
            }), p = this.editor.outputContainer.getData(), f = p.flipHorizontally, h = p.flipVertically, d = this.editor.outputContainer.getRotation(), g = h !== f ? a.rotation - d : a.rotation + d, m = h !== f ? -g : g, y = {
              spriteId: o,
              transform: {
                size: c,
                position: a.position,
                rotation: m
              }
            }, l ? [4, this.addNewText(y, l)] : [3, 8]) : [3, 12]) : [3, 13];

          case 7:
            return _.sent(), [3, 12];

          case 8:
            return u ? [4, this.addNewTextDesign(y, u)] : [3, 10];

          case 9:
            return _.sent(), [3, 12];

          case 10:
            return s ? [4, this.addNewSticker(y, _v2(_v2({}, s), {
              flipHorizontally: a.flipHorizontally,
              flipVertically: a.flipVertically
            }))] : [3, 12];

          case 11:
            _.sent(), _.label = 12;

          case 12:
            return r += 1, [3, 6];

          case 13:
            return [2];
        }
      });
    });
  }, Object.defineProperty(e.prototype, "serializableState", {
    get: function get() {
      var e = this,
          t = this.editor.spriteStore.getSpriteHistoryState();
      Object.keys(t.common).forEach(function (n) {
        var i = e.editor.outputContainer.getData(),
            r = i.flipHorizontally,
            o = i.flipVertically,
            a = e.editor.outputContainer.getRotation(),
            s = o !== r ? -t.common[n].rotation : t.common[n].rotation;
        t.common[n].rotation = o !== r ? s + a : s - a;
      });
      var n = this.editor.spriteStore.stickerToolStore.customStickerIds.map(function (t) {
        var n = t.identifier,
            i = t.type,
            r = e.editor.spriteStore.stickerToolStore.entities.find(function (e) {
          return n === e.identifier;
        });

        if (r) {
          var o = e.editor.assetProvider.getStickerAsset(r.identifier);
          if (he(o)) return {
            identifier: n,
            raster: {
              type: i,
              name: r.name,
              data: o.sticker
            }
          };
        }
      }).filter(Boolean);
      return {
        sprite: t,
        customStickers: n
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.updateCanvasControls = function () {
    var e = this;
    Object.keys(this.container).forEach(function (t) {
      e.updatePositionAndSize(t, !0);
      var n = e.state.get(t);
      if (n) if (n.tool === P.TEXT) {
        var i = e.getContainerProperties(t);
        e.textToolStore.changeSize(t, i);
      } else if (n.tool === P.TEXT_DESIGN) {
        i = e.getContainerProperties(t);
        e.textToolStore.changeWidth(i.width);
      }
    });
  }, e.prototype.setDragMode = function (e) {
    this.dragMode.set(e);
  }, e.prototype.setPosition = function (e) {
    var t = this.currentSprite,
        n = this.container[this.id];

    if (t && n) {
      n.setPosition(this.editor.previewToWorld(e));
      var i = this.getSizePositionFromContainer().position;
      t.position.x = i.x, t.position.y = i.y, this.state.set(this.id, t), this.editor.render();
    }
  }, e.prototype.setSize = function (e) {
    var t = this.currentSprite;
    t && (t.size.width = e.width, t.size.height = e.height, this.state.set(this.id, t));
  }, e.prototype.setRotation = function (e) {
    var t = this.currentSprite;

    if (t) {
      var n = this.editor.outputContainer.getData(),
          i = n.flipHorizontally,
          r = n.flipVertically,
          o = this.editor.outputContainer.getRotation(),
          a = Wt({
        rotation: e + o,
        flipHorizontally: i,
        flipVertically: r
      });
      this.container[this.id].setRotation(a), t.rotation = this.container[this.id].getRotation(), this.state.set(this.id, t), this.editor.render();
    }
  }, e.prototype.onCanvasClick = function (e) {
    this.isEditMode || this.selectHighestOrderSprite(e);
  }, e.prototype.select = function (e) {
    var t = this.state.get(e);
    t && (this.editor.activeStore.tool !== t.tool && this.editor.activeStore.selectTool(t.tool), this.selectedId.set(e));
  }, e.prototype.selectLast = function () {
    var e = this.editor.orderHelper.getLastSpriteId();
    e && this.select(e);
  }, e.prototype.selectNext = function () {
    var e = this;

    if (this.currentSprite) {
      var t = this.container[this.id].getIndexInParent();

      if (t) {
        var n = Object.keys(this.container).find(function (n) {
          return e.container[n].getIndexInParent() === t - 1;
        });
        n && this.select(n);
      }
    }
  }, e.prototype.deselect = function () {
    this.selectedId.set("none");
  }, e.prototype.bringToFront = function (e) {
    var t = this.editor.orderHelper.bringToFront(e);
    this.container[e].setIndexInParent(t), this.spriteSnapshot("order"), this.editor.render();
  }, e.prototype.flipHorizontally = function (e) {
    var t = this.state.get(e),
        n = this.container[e];
    n.setFlipHorizontally(!n.getFlipHorizontally()), t.flipHorizontally = n.getFlipHorizontally(), this.spriteSnapshot("flip"), this.state.set(e, t), this.editor.render();
  }, e.prototype.pureReset = function () {
    var e = this;
    this.selectedId.set("none"), Array.from(this.state.keys()).forEach(function (t) {
      e.pureRemoveSprite(t);
    }), this.stickerToolStore.pureReset(), this.textToolStore.pureReset(), this.textDesignToolStore.pureReset();
  }, e.prototype.selectHighestOrderSprite = function (e) {
    var t = this,
        n = this.editor.brushToolStore.containerId();
    if ((e = e.filter(function (e) {
      return e !== n;
    })).length < 1) this.deselect();else {
      var i = "",
          r = 0;
      e.forEach(function (e) {
        var n = t.container[e],
            o = n && n.getIndexInParent() || 0;
        o >= r && (r = o, i = e);
      }), this.select(i);
    }
  }, e.prototype.onCornerDrag = function (t) {
    var n = t.x,
        i = t.y;

    if (this.currentSprite) {
      var r = new R(this.currentSprite.position),
          o = new R(n, i),
          a = o.subtract(r).magnitude,
          s = this.getSize(),
          l = 2 * a / e.sizeMagnitude(s);
      if (a > this.minLength) if (this.isSpriteSticker) {
        if ("unrestricted" !== this.stickerToolStore.resizeMode) this.setStickerSize({
          width: s.width * l,
          height: s.height * l
        });else {
          var u = this.rotationWRTOutputRotation,
              c = o.subtract(r),
              p = Math.cos(u),
              f = Math.sin(u),
              h = Math.max(Math.abs(c.x * p * 2 + c.y * f * 2), this.minLength),
              d = Math.max(Math.abs(c.x * -f * 2 + c.y * p * 2), this.minLength);
          this.setStickerSize({
            width: h,
            height: d
          });
        }
      } else this.isSpriteText ? this.setTextSize(s.width * l) : this.isSpriteTextDesign && this.setTextDesignScale(l);
      this.editor.render();
    }
  }, Object.defineProperty(e.prototype, "currentSprite", {
    get: function get() {
      if (this.isSpriteSelected) return this.state.get(this.id);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "padding", {
    get: function get() {
      return this.textDesignToolStore.padding;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isEditMode", {
    get: function get() {
      return this.editMode.get();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isDragMode", {
    get: function get() {
      return this.dragMode.get();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "id", {
    get: function get() {
      return this.selectedId.get();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isSpriteSelected", {
    get: function get() {
      return "none" !== this.id;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "position", {
    get: function get() {
      if (this.currentSprite) return this.currentSprite.position;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "tool", {
    get: function get() {
      if (this.currentSprite) return this.currentSprite.tool;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "size", {
    get: function get() {
      if (this.currentSprite) return this.currentSprite.size;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotation", {
    get: function get() {
      if (this.currentSprite) return this.currentSprite.rotation;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotationWRTOutputRotation", {
    get: function get() {
      if (this.currentSprite) {
        var e = this.editor.outputContainer.getData(),
            t = e.flipHorizontally,
            n = e.flipVertically,
            i = this.editor.outputContainer.getRotation();
        return Wt({
          rotation: this.currentSprite.rotation - i,
          flipHorizontally: t,
          flipVertically: n
        });
      }
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "flipHorizontal", {
    get: function get() {
      if (this.currentSprite) return this.currentSprite.flipHorizontally;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isSpriteSticker", {
    get: function get() {
      return this.tool === P.STICKER;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isSpriteText", {
    get: function get() {
      return this.tool === P.TEXT;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isSpriteTextDesign", {
    get: function get() {
      return this.tool === P.TEXT_DESIGN;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "spritePosition", {
    get: function get() {
      if (this.currentSprite) {
        var e = this.currentSprite.position,
            t = e.x,
            n = e.y,
            i = this.currentSprite.size,
            r = i.height,
            o = i.width;
        return {
          x: Math.round(t - o / 2),
          y: Math.round(n - r / 2)
        };
      }
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "currentRect", {
    get: function get() {
      if (this.currentSprite) return this.rect;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftTopPosition", {
    get: function get() {
      if (this.currentSprite) return this.rect.leftTop;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftBottomPosition", {
    get: function get() {
      if (this.currentSprite) return this.rect.leftBottom;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftMidPosition", {
    get: function get() {
      if (this.currentSprite) return this.rect.leftMid;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftMidPadPosition", {
    get: function get() {
      if (this.currentSprite) {
        var e = this.rect.leftMid;
        return {
          x: e.x - this.editor.worldToPreview(this.padding),
          y: e.y
        };
      }
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightTopPosition", {
    get: function get() {
      if (this.currentSprite) return this.rect.rightTop;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightBottomPosition", {
    get: function get() {
      if (this.currentSprite) return this.rect.rightBottom;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightMidPosition", {
    get: function get() {
      if (this.currentSprite) return this.rect.rightMid;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightMidPadPosition", {
    get: function get() {
      if (this.currentSprite) {
        var e = this.rect.rightMid;
        return {
          x: e.x + this.editor.worldToPreview(this.padding),
          y: e.y
        };
      }
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftBottomHandlePosition", {
    get: function get() {
      if (this.currentSprite) return this.rect.leftBottomHandle;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightBottomHandlePosition", {
    get: function get() {
      if (this.currentSprite) return this.rect.rightBottomHandle;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "historyLocale", {
    get: function get() {
      return this.isSpriteSticker ? this.stickerLocale : this.isSpriteText ? this.textDesignLocale : this.textLocale;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "stickerLocale", {
    get: function get() {
      return this.editor.configStore.locale[P.STICKER].history;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "textLocale", {
    get: function get() {
      return this.editor.configStore.locale[P.TEXT].history;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "textDesignLocale", {
    get: function get() {
      return this.editor.configStore.locale[P.TEXT_DESIGN].history;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getOutputProperties = function () {
    return this.editor.outputContainer.getData();
  }, e.prototype.getContainerProperties = function (e) {
    return this.container[e].getData();
  }, e.prototype.getContainerTransform = function (e) {
    return this.container[e].getTransform();
  }, e.prototype.getDuplicateContainerTransform = function (e) {
    var t = this.container[e].getTransform(),
        n = .1 * this.editor.shortestOutputSide,
        i = new R(t.position).add(new R(n, n));
    return _v2(_v2({}, t), {
      position: i
    });
  }, e.prototype.getDuplicateContainerFlip = function (e) {
    return {
      flipHorizontally: this.container[e].getFlipHorizontally(),
      flipVertically: this.container[e].getFlipVertically()
    };
  }, e.prototype.getInitialTransform = function (e) {
    var t = this.editor.outputToWorld(Ul);
    return e ? _v2({
      position: t
    }, e) : {
      rotation: this.editor.outputContainer.getRotation(),
      position: t
    };
  }, e.prototype.setInitialSpriteState = function (e, t) {
    var n = this.container[e],
        i = this.getSizePositionFromContainer(e),
        r = i.position,
        o = i.size,
        a = n.getRotation(),
        s = t === P.STICKER && n.getFlipHorizontally(),
        l = t === P.STICKER && n.getFlipVertically();
    this.state.set(e, {
      tool: t,
      position: r,
      rotation: a,
      size: o,
      flipHorizontally: s,
      flipVertically: l
    });
  }, e.prototype.setStickerSize = function (e) {
    var t = this.container[this.id];
    t.setSizeInWorldSpace(this.editor.previewSizeToWorld(e));
    var n = this.currentSprite;
    n && (n.size = this.editor.worldSizeToPreview(t.getSizeInWorldSpace()), this.state.set(this.id, n));
  }, e.prototype.setTextSize = function (e) {
    var t = this.getContainerProperties(this.id),
        n = {
      width: this.editor.previewToWorld(e)
    },
        i = n.width / t.width,
        r = {
      fontSize: Math.round(t.fontSize * i)
    },
        o = this.isSpriteText ? _v2(_v2({}, n), r) : n;
    n.width > this.minLength && r.fontSize && (this.setContainerProperties(this.id, o, !0), t = this.getContainerProperties(this.id), this.textToolStore.changeFontSize(t.fontSize, !0), this.textToolStore.changeWidth(t.width));
  }, e.prototype.setTextDesignScale = function (e) {
    var t = this.getContainerProperties(this.id),
        n = t.width * e;

    if (n > this.minLength) {
      this.setContainerProperties(this.id, {
        width: n
      }, !0);
      var i = this.getContainerProperties(this.id).width;
      this.textDesignToolStore.changeWidth(i), t = this.getContainerProperties(this.id), this.textDesignToolStore.changePadding(t.padding);
    }
  }, e.prototype.getSizePositionFromContainer = function (e) {
    void 0 === e && (e = this.id);
    var t = this.container[e];
    return t ? {
      position: this.editor.worldToPreview(t.getPosition()),
      size: this.editor.worldSizeToPreview(t.getSizeInWorldSpace())
    } : {
      position: {
        x: 0,
        y: 0
      },
      size: {
        height: 1,
        width: 1
      }
    };
  }, w([sr], e.prototype, "addSticker", null), w([sr], e.prototype, "addStickerAsync", null), w([sr], e.prototype, "addText", null), w([sr], e.prototype, "addTextAsync", null), w([sr], e.prototype, "addTextDesign", null), w([sr], e.prototype, "addTextDesignAsync", null), w([sr], e.prototype, "clickableCanvas", null), w([sr], e.prototype, "setContainerProperties", null), w([sr], e.prototype, "setContainerPosition", null), w([sr], e.prototype, "pureRemoveSprite", null), w([sr], e.prototype, "deleteSprite", null), w([sr], e.prototype, "removeSprite", null), w([sr], e.prototype, "addSnapshot", null), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "addNewText", null), w([sr], e.prototype, "addNewTextDesign", null), w([sr], e.prototype, "addNewSticker", null), w([sr], e.prototype, "updateSpriteStateFromHistory", null), w([sr], e.prototype, "updateStateFromSerialization", null), w([sr], e.prototype, "updateCanvasControls", null), w([sr], e.prototype, "setEditMode", void 0), w([sr], e.prototype, "setDragMode", null), w([sr], e.prototype, "setPosition", null), w([sr], e.prototype, "setSize", null), w([sr], e.prototype, "setRotation", null), w([sr], e.prototype, "onCanvasClick", null), w([sr], e.prototype, "select", null), w([sr], e.prototype, "selectLast", null), w([sr], e.prototype, "selectNext", null), w([sr], e.prototype, "deselect", null), w([sr], e.prototype, "bringToFront", null), w([sr], e.prototype, "flipHorizontally", null), w([sr], e.prototype, "pureReset", null), w([sr], e.prototype, "onCornerDrag", null), w([sr], e.prototype, "onWidthDrag", void 0), w([sr], e.prototype, "onPaddingDrag", void 0), w([sr], e.prototype, "correctTextFlip", void 0), w([sr], e.prototype, "reverseTextHorizontally", void 0), w([sr], e.prototype, "reverseTextVertically", void 0), w([fi], e.prototype, "currentSprite", null), w([fi], e.prototype, "padding", null), w([fi], e.prototype, "isEditMode", null), w([fi], e.prototype, "isDragMode", null), w([fi], e.prototype, "id", null), w([fi], e.prototype, "isSpriteSelected", null), w([fi], e.prototype, "position", null), w([fi], e.prototype, "tool", null), w([fi], e.prototype, "size", null), w([fi], e.prototype, "rotation", null), w([fi], e.prototype, "rotationWRTOutputRotation", null), w([fi], e.prototype, "flipHorizontal", null), w([fi], e.prototype, "isSpriteSticker", null), w([fi], e.prototype, "isSpriteText", null), w([fi], e.prototype, "isSpriteTextDesign", null), w([fi], e.prototype, "spritePosition", null), w([fi], e.prototype, "currentRect", null), w([fi], e.prototype, "leftTopPosition", null), w([fi], e.prototype, "leftBottomPosition", null), w([fi], e.prototype, "leftMidPosition", null), w([fi], e.prototype, "leftMidPadPosition", null), w([fi], e.prototype, "rightTopPosition", null), w([fi], e.prototype, "rightBottomPosition", null), w([fi], e.prototype, "rightMidPosition", null), w([fi], e.prototype, "rightMidPadPosition", null), w([fi], e.prototype, "leftBottomHandlePosition", null), w([fi], e.prototype, "rightBottomHandlePosition", null), w([fi], e.prototype, "historyLocale", null), w([fi], e.prototype, "stickerLocale", null), w([fi], e.prototype, "textLocale", null), w([fi], e.prototype, "textDesignLocale", null), e;
}(),
    Wl = {
  position: {
    x: 0,
    y: 0
  },
  size: {
    height: 0,
    width: 0
  },
  lockResolution: !1,
  forceDimensions: !1,
  ratio: "*"
},
    Hl = {
  identifier: "identity",
  outputRotation: 0,
  rotationInDegrees: 0,
  flipHorizontally: !1,
  flipVertically: !1,
  cropState: ai.map({})
},
    Gl = function () {
  function e(e, t) {
    this.minCropSize = 0, this.state = Hl, this.configStore = e.configStore, this.minCropSize = this.configStore.measurements.crop.minSize, this.defaults = t;
  }

  return e.prototype.changeIdentifier = function (e) {
    this.state.identifier = e, this.state.cropState.get(e) || this.state.cropState.set(e, _v2({}, Wl));
  }, e.prototype.changeRatio = function (e) {
    var t = this.state.cropState.get(this.identifier);
    t && this.state.cropState.set(this.identifier, _v2(_v2({}, t), {
      ratio: e
    }));
  }, e.prototype.changeSize = function (e) {
    var t = this.state.cropState.get(this.identifier);
    t && (e.width && e.width > 0 && (t.size.width = Math.round(e.width)), e.height && e.height > 0 && (t.size.height = Math.round(e.height)), this.state.cropState.set(this.identifier, t));
  }, e.prototype.changeHeight = function (e) {
    var t = this.state.cropState.get(this.identifier);
    t && e && (t.size.height = Math.round(e), this.state.cropState.set(this.identifier, t));
  }, e.prototype.changeWidth = function (e) {
    var t = this.state.cropState.get(this.identifier);
    t && e && (t.size.width = Math.round(e), this.state.cropState.set(this.identifier, t));
  }, e.prototype.changePositionX = function (e, t) {
    var n = this.state.cropState.get(this.identifier);
    return !!(n && e <= t - this.minCropSize && e >= 0) && (n.position.x = Math.round(e), this.state.cropState.set(this.identifier, n), !0);
  }, e.prototype.changePositionY = function (e, t) {
    var n = this.state.cropState.get(this.identifier);
    return !!(n && e <= t - this.minCropSize && e >= 0) && (n.position.y = Math.round(e), this.state.cropState.set(this.identifier, n), !0);
  }, e.prototype.changePosition = function (e, t) {
    var n = this.state.cropState.get(this.identifier);
    return !!(n && e.x <= t.width - this.minCropSize && e.x >= 0 && e.y <= t.height - this.minCropSize && e.y >= 0) && (n.position.x = Math.round(e.x), n.position.y = Math.round(e.y), this.state.cropState.set(this.identifier, n), !0);
  }, e.prototype.changeLockResolution = function (e) {
    var t = this.state.cropState.get(this.identifier);
    t && (t.lockResolution = void 0 !== e ? e : !t.lockResolution, this.state.cropState.set(this.identifier, t));
  }, e.prototype.changeForceDimensions = function (e) {
    var t = this.state.cropState.get(this.identifier);
    t && (t.forceDimensions = e, this.state.cropState.set(this.identifier, t));
  }, e.prototype.setRotation = function (e) {
    this.state.rotationInDegrees = e;
  }, e.prototype.resetRotation = function () {
    this.state.rotationInDegrees = 0;
  }, e.prototype.resetOutputRotation = function () {
    this.state.outputRotation = 0;
  }, e.prototype.resetFlip = function () {
    this.state.flipHorizontally = !1, this.state.flipVertically = !1;
  }, e.prototype.updateFlip = function (e) {
    var t = e.flipHorizontally,
        n = e.flipVertically;
    this.state.flipHorizontally = t, this.state.flipVertically = n;
  }, e.prototype.setOutputRotation = function (e) {
    this.state.outputRotation = e;
  }, e.prototype.flipHorizontally = function () {
    this.state.flipHorizontally = !this.state.flipHorizontally;
  }, e.prototype.flipVertically = function () {
    this.state.flipVertically = !this.state.flipVertically;
  }, Object.defineProperty(e.prototype, "flipCenter", {
    get: function get() {
      var e = this.defaults.maxCropMaskSize,
          t = e.width,
          n = e.height;
      return new R(t / 2, n / 2);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isFlippedHorizontal", {
    get: function get() {
      return this.state.flipHorizontally;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isFlippedVertical", {
    get: function get() {
      return this.state.flipVertically;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.state.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "height", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.size.height : Wl.size.height;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "width", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.size.width : Wl.size.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "position", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.position : Wl.position;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "ratio", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.ratio : Wl.ratio;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "size", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.size : Wl.size;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "x", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.position.x : Wl.position.x;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "y", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.position.y : Wl.position.y;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "lockResolution", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.lockResolution : Wl.lockResolution;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "forceDimensions", {
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.forceDimensions : Wl.forceDimensions;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "selectedCrop", {
    get: function get() {
      return this.state.cropState.get(this.identifier);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotationInDegrees", {
    get: function get() {
      return this.state.rotationInDegrees;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "outputRotation", {
    get: function get() {
      return this.state.outputRotation;
    },
    enumerable: !0,
    configurable: !0
  }), w([ai], e.prototype, "state", void 0), w([sr], e.prototype, "changeIdentifier", null), w([sr], e.prototype, "changeRatio", null), w([sr], e.prototype, "changeSize", null), w([sr], e.prototype, "changeHeight", null), w([sr], e.prototype, "changeWidth", null), w([sr], e.prototype, "changePositionX", null), w([sr], e.prototype, "changePositionY", null), w([sr], e.prototype, "changePosition", null), w([sr], e.prototype, "changeLockResolution", null), w([sr], e.prototype, "changeForceDimensions", null), w([sr], e.prototype, "setRotation", null), w([sr], e.prototype, "resetRotation", null), w([sr], e.prototype, "resetOutputRotation", null), w([sr], e.prototype, "resetFlip", null), w([sr], e.prototype, "updateFlip", null), w([sr], e.prototype, "setOutputRotation", null), w([sr], e.prototype, "flipHorizontally", null), w([sr], e.prototype, "flipVertically", null), w([fi], e.prototype, "flipCenter", null), w([fi], e.prototype, "isFlippedHorizontal", null), w([fi], e.prototype, "isFlippedVertical", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "height", null), w([fi], e.prototype, "width", null), w([fi], e.prototype, "position", null), w([fi], e.prototype, "ratio", null), w([fi], e.prototype, "size", null), w([fi], e.prototype, "x", null), w([fi], e.prototype, "y", null), w([fi], e.prototype, "lockResolution", null), w([fi], e.prototype, "forceDimensions", null), w([fi], e.prototype, "selectedCrop", null), w([fi], e.prototype, "rotationInDegrees", null), w([fi], e.prototype, "outputRotation", null), e;
}(),
    Vl = function () {
  function e(e) {
    this.transforms = {
      output: JSON.stringify(O.IDENTITY),
      preview: JSON.stringify(O.IDENTITY)
    }, this.editor = e, this.overlayOpacity = 0, this.frameOpacity = 0;
  }

  return e.rotateOutput = function (e, t) {
    switch (e %= 360) {
      case 90:
      case -270:
        return t.swapped.multiply(-1, 1);

      case 180:
      case -180:
        return t.multiply(-1);

      case 270:
      case -90:
        return t.swapped.multiply(1, -1);

      default:
        return t;
    }
  }, e.prototype.onLeave = function () {
    var e = this.transformToolStore.rotateFlipState,
        t = e.flipHorizontally,
        n = e.flipVertically,
        i = e.rotation,
        r = e.outputRotation;
    "identity" !== this.editor.overlayToolStore.identifier && this.editor.overlayToolStore.changeOpacity(this.overlayOpacity), "identity" !== this.editor.frameToolStore.identifier && this.editor.frameToolStore.changeOpacity(this.frameOpacity);
    var o = this.editor.previewToWorld(new R(this.transformToolStore.leftTopRespectFlip).add(new R(this.transformToolStore.rightBottomRespectFlip)).divide(2).add(new R(this.transformToolStore.unRotatedDefaults.cropMaskPosition)), !0),
        a = this.engineMediator.preview.container,
        s = this.editor.outputContainer;
    s.setResolution(xr(this.transformToolStore.localOutputImageSize)), s.setData({
      flipVertically: n,
      flipHorizontally: t
    });
    var l = a.getScale();
    this.editor.overlayToolStore.correctOverlayFlip(), this.saveTransforms();
    var u = 1;

    if (this.transformToolStore.lockResolution) {
      var c = this.transformToolStore,
          p = c.cropMaskSize,
          f = c.defaultImageSize,
          h = this.transformToolStore.maxCropMaskSize;
      u = {
        height: p.height * f.height / h.height,
        width: p.width * f.width / h.width
      }.width / this.transformToolStore.localOutputImageSize.width;
    }

    var d = u / (Math.abs(l.x) / this.transformToolStore.defaultScale),
        g = {
      x: d,
      y: d
    },
        m = -(i - r);
    s.setTransform({
      scale: g,
      position: o,
      rotation: m
    }), this.editor.engineMediator.preview.updateTransform(0, !1), this.editor.scale.setInitialTransform(), this.editor.spriteStore.updateCanvasControls(), this.editor.focusToolStore.updateCanvasControls();
  }, e.prototype.onEnter = function () {
    "identity" !== this.editor.overlayToolStore.identifier && (this.overlayOpacity = this.editor.overlayToolStore.opacity, this.editor.overlayToolStore.changeOpacity(0)), "identity" !== this.editor.frameToolStore.identifier && (this.frameOpacity = this.editor.frameToolStore.opacity, this.editor.frameToolStore.changeOpacity(0)), this.editor.scale.setScaleToDefault();
    var e = this.engineMediator.preview.container,
        t = this.editor.outputContainer,
        n = JSON.parse(this.transforms.preview);
    t.setResolution(xr(this.transformToolStore.defaultImageSize)), e.setTransform(n), t.setTransform(JSON.parse(this.transforms.output));
    var i = n.scale;
    t.setData({
      flipVertically: !1,
      flipHorizontally: !1
    }), this.transformToolStore.transformStore.updateFlip({
      flipVertically: i.y < 0,
      flipHorizontally: i.x < 0
    }), this.engineMediator.preview.savePreviewTransform(n);
    var r = this.engineMediator.preview.calculateTransform().scale;
    this.editor.scale.setInitialTransform(r.x);
  }, e.prototype.rotateOutputContainer = function (e) {
    var t = this;
    void 0 === e && (e = !1), this.editor.outputContainer.rotate90(e), this.transformToolStore.transformStore.setOutputRotation(this.editor.outputContainer.getRotation());
    var n = this.transformToolStore.rotateFlipState.rotation;
    this.engineMediator.preview.updateTransform(n), lr(function () {
      t.editor.scale.setInitialTransform();
      var e = t.getScaleWithFlip(n);
      t.engineMediator.preview.container.setScale(e), t.transformToolStore.setCropDefaults(!0), t.transformToolStore.updateCropMask();
    }), this.editor.render();
  }, e.prototype.applyPreviewTransform = function () {
    var e = this.transformToolStore.rotateFlipState,
        t = e.rotation,
        n = e.flipHorizontally,
        i = e.flipVertically,
        r = this.editor.scale.getPositionWithOffset(),
        o = this.getScaleWithFlip(),
        a = t;
    n && (a = jt(a)), i && (a = jt(a));
    var s = {
      position: r,
      rotation: a,
      scale: o
    };
    this.engineMediator.preview.savePreviewTransform(s), this.engineMediator.preview.container.setTransform(s);
  }, e.prototype.getScaleWithFlip = function (e) {
    void 0 === e && (e = this.transformToolStore.rotateFlipState.rotation);
    var t = this.transformToolStore.rotateFlipState,
        n = t.flipHorizontally ? -1 : 1,
        i = t.flipVertically ? -1 : 1,
        r = this.editor.scale.calculateScale(e);
    return {
      x: r * n,
      y: r * i
    };
  }, e.prototype.saveTransforms = function () {
    var e = JSON.stringify(this.engineMediator.preview.container.getTransform()),
        t = JSON.stringify(this.editor.outputContainer.getTransform());
    this.transforms = {
      preview: e,
      output: t
    };
  }, e.prototype.saveTransformsBasedOnFlip = function () {
    var e = this.engineMediator.preview.container.getTransform(),
        t = e.scale,
        n = this.editor.outputContainer.getData(),
        i = n.flipVertically,
        r = n.flipHorizontally,
        o = JSON.stringify(this.editor.outputContainer.getTransform());
    this.transforms = {
      preview: JSON.stringify(_v2(_v2({}, e), {
        scale: {
          x: r ? -t.x : t.x,
          y: i ? -t.y : t.y
        }
      })),
      output: o
    };
  }, Object.defineProperty(e.prototype, "engineMediator", {
    get: function get() {
      return this.editor.engineMediator;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "transformToolStore", {
    get: function get() {
      return this.editor.transformToolStore;
    },
    enumerable: !0,
    configurable: !0
  }), e;
}(),
    Xl = function () {
  function e(t) {
    var n = this;
    this.unRotatedDefaults = {
      cropMaskPosition: {
        x: 0,
        y: 0
      },
      scale: 1
    }, this.defaultAngle = 0, this.dragMode = ai.box(!1), this.minCropSize = 0, this.localSnapshotEnabled = !0, this.defaults = {
      cropMaskPosition: {
        x: 0,
        y: 0
      },
      maxCropMaskSize: {
        width: 0,
        height: 0
      },
      imageSize: {
        width: 0,
        height: 0
      },
      scale: 1
    }, this.localOutputSize = {
      width: 0,
      height: 0
    }, this.defaultIdentifier = "imgly_transform_common_custom", this.checkIfTransformThumbnailExits = function (e) {
      var t = n.editor.configStore.config.assetBaseUrl;
      if ("/" !== t[t.length - 1] && (t += "/"), t + "transform" === e) return !1;
      var i = new Image();

      try {
        return i.src = e, !0;
      } catch (e) {
        return !1;
      }
    }, this.reset = function () {
      n.transformStore.resetRotation(), n.transformStore.resetOutputRotation(), n.transformStore.resetFlip(), n.editor.spriteStore.correctTextFlip(), n.editor.overlayToolStore.correctOverlayFlip(), n.setDefaultAngle(0), 0 !== n.editor.outputContainer.getRotation() && n.engineMediator.output.applyNewImageTransform(), n.engineMediator.output.container.setData({
        flipHorizontally: !1,
        flipVertically: !1
      }), n.engineMediator.preview.updateTransform(), n.editor.scale.setInitialTransform(), n.setCropDefaults(), n.applyInitialCrop(), n.editor.render();
    }, this.changeLocalOutputSize = function (e) {
      n.localOutputSize.height = Math.round(e.height), n.localOutputSize.width = Math.round(e.width);
    }, this.changeDefaultScale = function (e) {
      n.defaults.scale = e;
    }, this.changeLocalOutputHeight = function (e) {
      n.localOutputSize.height = Math.round(e);
    }, this.changeLocalOutputWidth = function (e) {
      n.localOutputSize.width = Math.round(e);
    }, this.changeLockResolution = function () {
      n.transformStore.changeLockResolution(), n.addLocalSnapshot();
    }, this.rotateClockwise = function () {
      n.rotateOutputContainer(n.isFlippedVertical !== n.isFlippedHorizontal);
    }, this.rotateAntiClockwise = function () {
      n.rotateOutputContainer(n.isFlippedVertical === n.isFlippedHorizontal);
    }, this.flipHorizontally = function (e) {
      void 0 === e && (e = !0), n.transformStore.flipHorizontally(), n.editor.spriteStore.reverseTextHorizontally(), n.transformRender(e), e && n.addLocalSnapshot();
    }, this.flipVertically = function (e) {
      void 0 === e && (e = !0), n.transformStore.flipVertically(), n.editor.spriteStore.reverseTextVertically(), n.transformRender(e), e && n.addLocalSnapshot();
    }, this.applyDefaultCrop = function (e) {
      void 0 === e && (e = !1), "identity" === n.identifier && n.changeIdentifier(n.defaultIdentifier, e);
    }, this.updateCropMask = function () {
      n.changeIdentifier(n.identifier, !0);
    }, this.onLeftTop = function (e) {
      var t = e.x,
          i = e.y,
          r = n.getRatio(),
          o = n.rightBottom,
          a = n,
          s = a.minCropMaskSize,
          l = a.maxCropMaskSize,
          u = Math.min(Math.max(0, t), o.x - s.width),
          c = Math.min(Math.max(0, i), o.y - s.height),
          p = o.x - u,
          f = o.y - c,
          h = {
        width: Math.max(n.minCropSize, Math.min(p, l.width - u)),
        height: Math.max(n.minCropSize, Math.min(f, l.height - c))
      };
      if ("*" === r) n.changePosition({
        x: u,
        y: c
      }) && n.changeCropAndOutputSize(h);else {
        var d = n.proportionalSize(r, h),
            g = new R(o).rounded.subtract({
          x: d.width,
          y: d.height
        });
        n.changePosition(g) && n.changeCropAndOutputSize(d);
      }
    }, this.onLeftBottom = function (e) {
      var t = e.x,
          i = e.y,
          r = n.getRatio(),
          o = n.rightTop,
          a = n,
          s = a.minCropMaskSize,
          l = a.maxCropMaskSize,
          u = Math.min(Math.max(0, t), o.x - s.width),
          c = Math.max(0, i, o.y + s.height),
          p = o.x - u,
          f = c - o.y,
          h = {
        width: Math.max(1, Math.min(p, l.width - u)),
        height: Math.max(1, Math.min(f, l.height - o.y))
      };

      if ("*" === r) {
        n.changeCropAndOutputSize(h) && n.changePositionX(u);
      } else {
        var d = n.proportionalSize(r, h);
        n.changePositionX(Math.round(o.x) - d.width) && n.changeCropAndOutputSize(d);
      }
    }, this.onRightTop = function (e) {
      var t = e.x,
          i = e.y,
          r = n.getRatio(),
          o = n.leftBottom,
          a = n,
          s = a.minCropMaskSize,
          l = a.maxCropMaskSize,
          u = Math.max(0, t, o.x + s.width),
          c = Math.min(Math.max(0, i), o.y - s.height),
          p = u - o.x,
          f = o.y - c,
          h = {
        width: Math.max(1, Math.min(p, l.width - o.x)),
        height: Math.max(1, Math.min(f, l.height - c))
      };
      if ("*" === r) n.changePositionY(c) && n.changeCropAndOutputSize(h);else {
        var d = n.proportionalSize(r, h);
        n.changePositionY(Math.round(o.y) - d.height) && n.changeCropAndOutputSize(d);
      }
    }, this.onRightBottom = function (e) {
      var t = e.x,
          i = e.y,
          r = n.getRatio(),
          o = n.leftTop,
          a = n,
          s = a.minCropMaskSize,
          l = a.maxCropMaskSize,
          u = Math.max(0, t, o.x + s.width),
          c = Math.max(0, i, o.y + s.height),
          p = u - o.x,
          f = c - o.y,
          h = {
        width: Math.max(1, Math.min(p, l.width - o.x)),
        height: Math.max(1, Math.min(f, l.height - o.y))
      };
      if ("*" === r) n.changeCropAndOutputSize(h);else {
        var d = n.proportionalSize(r, h);
        n.changeCropAndOutputSize(d);
      }
    }, this.onPixelWidth = function () {
      var t = JSON.stringify(xr(n.localOutputSize)),
          i = n.localOutputSize.width || n.minCropSize,
          r = n.entityManager.items.find(function (e) {
        return e.identifier === n.identifier;
      }),
          o = n.defaults.imageSize;

      if (r && r.ratio) {
        var a = Math.max(i > o.width ? o.width : i, n.minCropSize),
            s = n.localOutputSize.height;
        if ("*" === r.ratio) n.changeLocalOutputWidth(a);else {
          var l = e.placeCropMask(r.ratio, o);
          s = (a = Math.min(a, l.width)) / r.ratio, n.changeLocalOutputSize({
            height: s,
            width: a
          });
        }
        n.updatePreviewSizeWRTImageSize(), n.checkAndAddSnapshot(JSON.parse(t));
      }
    }, this.onPixelHeight = function () {
      var t = JSON.stringify(xr(n.localOutputSize)),
          i = n.localOutputSize.height || n.minCropSize,
          r = n.entityManager.items.find(function (e) {
        return e.identifier === n.identifier;
      }),
          o = n.defaults.imageSize;

      if (r && r.ratio) {
        var a = Math.max(i > o.height ? o.height : i, n.minCropSize),
            s = n.localOutputSize.width;
        if ("*" === r.ratio) n.changeLocalOutputHeight(a);else {
          var l = e.placeCropMask(r.ratio, o);
          s = (a = Math.min(a, l.height)) * r.ratio, n.changeLocalOutputSize({
            height: a,
            width: s
          });
        }
        n.updatePreviewSizeWRTImageSize(), n.checkAndAddSnapshot(JSON.parse(t));
      }
    }, this.editor = t, this.selectedCategory = "identity", this.transformStore = new Gl(t, this.defaults), this.transformations = new Vl(t);
    var i = this.config,
        r = (i.enableRotation, i.enableFlip, b(i, ["enableRotation", "enableFlip"])),
        o = this.editor.assetProvider.getAssets("transform");
    this.entityManager = new _o(o, _v2(_v2({}, r), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !1,
      locale: _v2(_v2({}, this.locale.items), this.locale.categories),
      getAssetPath: this.editor.getAssetPath("transform")
    })), this.rect = new Dl(this.editor, this.transformStore, "topLeft", !1, !1), this.rectForUi = new Dl(this.editor, this.transformStore, "topLeft", !1, !0), this.defaultIdentifier = this.entityManager.items[0].identifier, this.minCropSize = this.editor.configStore.measurements.crop.minSize;
  }

  return e.inRadians = function (e) {
    return e * Math.PI / 180;
  }, e.placeCropMask = function (e, t) {
    if (t.height * e > t.width) return {
      height: t.width / e,
      width: t.width,
      yChanged: !0
    };
    var n = t.height * e;
    return {
      height: t.height,
      width: n,
      yChanged: !1
    };
  }, e.prototype.changeIdentifier = function (e, t) {
    void 0 === t && (t = !1), this.transformStore.changeIdentifier(e);
    var n = this.getCropMask(e, this.defaults.imageSize);
    n && (this.transformStore.changeRatio(n.ratio), this.changeLocalOutputSize(n), this.updatePreviewSizeWRTImageSize(), void 0 !== n.yChanged && this.updateInitialCropMaskPosition(n.yChanged), n.dimensions && this.changeLocalOutputSize({
      width: n.dimensions.x,
      height: n.dimensions.y
    }), t && this.addLocalSnapshot());
  }, e.prototype.setDragMode = function (e) {
    this.dragMode.set(e);
  }, e.prototype.getCropMask = function (t, n) {
    var i = this.getTransform(t);

    if (i) {
      var r = i.ratio,
          o = i.forceDimensions,
          a = i.lockDimensions,
          s = i.dimensions,
          l = void 0 === s ? null : s;

      if (o && this.transformStore.changeForceDimensions(o), a && this.transformStore.changeLockResolution(a), !r) {
        var u = i.dimensions,
            c = u.x,
            p = u.y;
        return _v2(_v2({}, e.placeCropMask(c / p, n)), {
          ratio: null,
          dimensions: l
        });
      }

      switch (r) {
        case "*":
          return this.changePosition({
            x: 0,
            y: 0
          }), _v2(_v2({}, n), {
            yChanged: void 0,
            ratio: "*",
            dimensions: l
          });

        default:
          return _v2(_v2({}, e.placeCropMask(i.ratio, n)), {
            ratio: i.ratio,
            dimensions: l
          });
      }
    }

    return null;
  }, e.prototype.setCropDefaults = function (e) {
    void 0 === e && (e = !1);
    var t = this.editor.outputContainer.getResolution();
    this.setDefaultImageSize(t);
    var n = this.editor.getPreviewSize(),
        i = this.editor.engineMediator.preview.previewTransformWithoutDpr.position;
    this.setMaxCropSize(n), this.setDefaultCropPosition({
      x: i.x - n.width / 2,
      y: i.y - n.height / 2
    }), this.changeDefaultScale(this.editor.scale.defaultScale), e || (this.unRotatedDefaults.cropMaskPosition = this.defaultCropMaskPosition, this.unRotatedDefaults.scale = this.defaultScale);
  }, e.prototype.setDefaultImageSize = function (e) {
    this.defaults.imageSize = _v2({}, xr(e)), this.lockResolution || (this.localOutputSize = _v2({}, xr(e)));
  }, e.prototype.setMaxCropSize = function (e) {
    this.defaults.maxCropMaskSize.height = e.height, this.defaults.maxCropMaskSize.width = e.width;
  }, e.prototype.setDefaultCropPosition = function (e) {
    this.defaults.cropMaskPosition.x = e.x, this.defaults.cropMaskPosition.y = e.y;
  }, e.prototype.resetCrop = function () {
    this.state.cropState = ai.map({}), this.state.identifier = "identity";
  }, e.prototype.toggleCategorySelection = function (e) {
    this.selectedCategory = this.selectedCategory === e ? "identity" : e;
  }, e.prototype.pureReset = function () {
    this.transformStore.resetRotation(), this.transformStore.resetOutputRotation(), this.transformStore.resetFlip(), this.editor.spriteStore.correctTextFlip(), this.editor.overlayToolStore.correctOverlayFlip(), this.resetCrop();
  }, e.prototype.changePosition = function (e) {
    return this.transformStore.changePosition(e, this.defaults.maxCropMaskSize);
  }, e.prototype.changePositionX = function (e) {
    return this.transformStore.changePositionX(e, this.defaults.maxCropMaskSize.width);
  }, e.prototype.changePositionY = function (e) {
    return this.transformStore.changePositionY(e, this.defaults.maxCropMaskSize.height);
  }, e.prototype.changeCropAndOutputHeight = function (e) {
    return !!(e && e >= this.minCropSize) && (this.transformStore.changeHeight(e), this.lockResolution || this.changeLocalOutputHeight(e * this.defaults.imageSize.height / this.defaults.maxCropMaskSize.height), !0);
  }, e.prototype.changeCropAndOutputWidth = function (e) {
    return !!(e && e >= this.minCropSize) && (this.transformStore.changeWidth(e), this.lockResolution || this.changeLocalOutputWidth(e * this.defaults.imageSize.width / this.defaults.maxCropMaskSize.width), !0);
  }, e.prototype.changeCropAndOutputSize = function (e) {
    return {
      widthChanged: this.changeCropAndOutputHeight(e.height),
      heightChanged: this.changeCropAndOutputWidth(e.width)
    };
  }, e.prototype.transformRender = function (e) {
    void 0 === e && (e = !0), this.transformations.applyPreviewTransform(), e && this.editor.render();
  }, e.prototype.addLocalSnapshot = function (e) {
    if (void 0 === e && (e = "Local " + this.locale.title), this.localSnapshotEnabled) {
      var t = this.state,
          n = (t.cropState, b(t, ["cropState"]));
      this.editor.addLocalTransformSnapshot(_v2(_v2(_v2({}, n), this.cropState), {
        localOutputSize: xr(this.localOutputSize),
        outputSize: this.engineMediator.output.container.getResolution(),
        defaults: xr(this.defaults),
        previewTransform: this.engineMediator.preview.container.getTransform(),
        outputTransform: this.engineMediator.output.container.getTransform()
      }), e);
    }
  }, e.prototype.updateLocalStateFromHistory = function (e) {
    this.editor.activeStore.tool === P.TRANSFORM && (this.transformStore.changeLockResolution(e.lockResolution), this.transformStore.changeForceDimensions(e.forceDimensions), this.transformStore.changeIdentifier(e.identifier), this.transformStore.setRotation(e.rotationInDegrees), this.setDefaultAngle(e.rotationInDegrees), this.transformStore.setOutputRotation(e.outputRotation), this.transformStore.updateFlip(e), this.engineMediator.output.container.setRotation(e.outputRotation), this.setDefaultImageSize(e.defaults.imageSize), this.localOutputSize = e.defaults.imageSize, this.changeLocalOutputSize(e.localOutputSize), this.transformStore.changeSize(e.size), this.changePosition(e.position), this.setMaxCropSize(e.defaults.maxCropMaskSize), this.setDefaultCropPosition(e.defaults.cropMaskPosition), this.changeDefaultScale(e.defaults.scale), this.engineMediator.output.container.setResolution(e.outputSize), this.engineMediator.preview.container.setTransform(e.previewTransform), this.engineMediator.output.container.setTransform(e.outputTransform));
  }, e.prototype.updateStateFromHistory = function (e) {
    this.editor.activeStore.tool !== P.TRANSFORM && (this.engineMediator.output.container.setTransform(e.outputTransform), this.engineMediator.preview.container.setTransform(e.previewTransform), this.engineMediator.output.container.setResolution(e.outputSize), this.changeLocalOutputSize(e.outputSize));
  }, Object.defineProperty(e.prototype, "serializableState", {
    get: function get() {
      var e = this.rotateFlipState,
          t = e.flipHorizontally,
          n = e.flipVertically,
          i = 180 * this.editor.engineMediator.output.container.getRotation() / Math.PI % 360,
          r = this.identifier,
          o = this.rotationInDegrees,
          a = o * Math.PI / 180,
          s = i + o;
      s = (360 - (s = (s = 90 * Math.round(s / 90)) < 0 ? s + 360 : s)) % 360;
      var l = this.convertUIToOperationOptions(a, s);
      return {
        flipHorizontally: t,
        flipVertically: n,
        rotation: a,
        start: l.start,
        end: l.end,
        identifier: r,
        outputRotation: s
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getStartEndForOperation = function (e) {
    var t = this.leftTop,
        n = this.rightBottom,
        i = this.maxCropMaskSize,
        r = t.y,
        o = t.x,
        a = n.x,
        s = n.y;

    switch (e) {
      case 270:
        return {
          leftTop: {
            x: i.height - s,
            y: o
          },
          rightBottom: {
            x: i.height - r,
            y: a
          }
        };

      case 180:
        return {
          leftTop: {
            x: i.width - a,
            y: i.height - s
          },
          rightBottom: {
            x: i.width - o,
            y: i.height - r
          }
        };

      case 90:
        return {
          leftTop: {
            x: r,
            y: i.width - a
          },
          rightBottom: {
            x: s,
            y: i.width - o
          }
        };
    }

    return {
      leftTop: {
        x: o,
        y: r
      },
      rightBottom: {
        x: a,
        y: s
      }
    };
  }, e.prototype.getStartEndForUI = function (e, t, n) {
    var i = this.maxCropMaskSize,
        r = t.y,
        o = t.x,
        a = n.x,
        s = n.y;

    switch (e) {
      case 90:
        return {
          leftTop: {
            x: r,
            y: i.height - a
          },
          rightBottom: {
            x: s,
            y: i.height - o
          }
        };

      case 180:
        return {
          leftTop: {
            x: i.width - a,
            y: i.height - s
          },
          rightBottom: {
            x: i.width - o,
            y: i.height - r
          }
        };

      case 270:
        return {
          leftTop: {
            x: i.width - s,
            y: o
          },
          rightBottom: {
            x: i.width - r,
            y: a
          }
        };
    }

    return {
      leftTop: {
        x: o,
        y: r
      },
      rightBottom: {
        x: a,
        y: s
      }
    };
  }, e.prototype.convertOperationOptionsToUI = function (e) {
    var t = e.start,
        n = e.end,
        i = e.rotation,
        r = e.outputRotation,
        o = 90 === r || 270 === r,
        a = o ? R.fromSize(this.defaultImageSize).swapped : R.fromSize(this.defaultImageSize),
        s = Math.cos(i),
        l = Math.sin(i),
        u = this.calculateScale(i),
        c = new R(Math.min(t.x, n.x), Math.min(t.y, n.y)),
        p = new R(Math.max(t.x, n.x), Math.max(t.y, n.y)).subtract(c).divide(2),
        f = c.add(p).multiply(a).subtract(a.multiply(.5)),
        h = new R(f.x * s - f.y * l, f.x * l + f.y * s).multiply(u),
        d = a.multiply(.5).add(h).divide(a),
        g = d.subtract(p.multiply(u)),
        m = d.add(p.multiply(u)),
        y = o ? R.fromSize(this.maxCropMaskSize).swapped : R.fromSize(this.maxCropMaskSize),
        _ = g.multiply(y),
        v = m.multiply(y),
        b = this.getStartEndForUI(r, _, v),
        w = b.leftTop,
        x = b.rightBottom;

    return {
      start: new R(w),
      end: new R(x)
    };
  }, e.prototype.convertUIToOperationOptions = function (e, t) {
    var n = 90 === t || 270 === t,
        i = n ? R.fromSize(this.defaultImageSize).swapped : R.fromSize(this.defaultImageSize),
        r = n ? R.fromSize(this.maxCropMaskSize).swapped : R.fromSize(this.maxCropMaskSize),
        o = Math.cos(-e),
        a = Math.sin(-e),
        s = this.calculateScale(e, n),
        l = this.getStartEndForOperation(t),
        u = l.leftTop,
        c = l.rightBottom,
        p = new R(u).divide(r),
        f = new R(c).divide(r).subtract(p).divide(2),
        h = p.add(f).multiply(i).subtract(i.multiply(.5)),
        d = new R(h.x * o - h.y * a, h.x * a + h.y * o).divide(s),
        g = i.multiply(.5).add(d).divide(i);
    return {
      start: g.subtract(f.divide(s)),
      end: g.add(f.divide(s))
    };
  }, e.prototype.calculateScale = function (e, t) {
    void 0 === t && (t = !1);
    var n = t ? R.fromSize(this.defaultImageSize).swapped : R.fromSize(this.defaultImageSize),
        i = new R(Math.abs(n.x * Math.cos(e)) + Math.abs(n.y * Math.sin(e)), Math.abs(n.x * Math.sin(e)) + Math.abs(n.y * Math.cos(e))),
        r = n.subtract(i.clone()).divide(2).abs;
    return r.y > r.x ? 2 * r.y / n.y + 1 : 2 * r.x / n.x + 1;
  }, e.prototype.updateStateFromSerialization = function (e, t) {
    this.localSnapshotEnabled = t, this.transformStore.resetRotation(), this.transformStore.resetOutputRotation(), this.transformStore.resetFlip(), this.setDefaultAngle(0), 0 !== this.editor.outputContainer.getRotation() && this.engineMediator.output.applyNewImageTransform(), this.engineMediator.output.container.setData({
      flipHorizontally: !1,
      flipVertically: !1
    }), this.engineMediator.preview.updateTransform(), this.editor.scale.setInitialTransform(), this.setCropDefaults(), this.applyInitialCrop();
    var n = Math.round(180 * e.rotation / Math.PI);
    this.transformStore.setRotation(n > 180 ? n - 360 : n), this.applyOutputRotationFromSerialization(e), e.identifier && this.transformStore.changeIdentifier(e.identifier);
    var i = e.outputRotation < 0 ? e.outputRotation + 360 : e.outputRotation;

    if (i = (360 - i) % 360, e.start && e.end) {
      0 !== e.end.x && 0 !== e.end.y || (e.end.x = 1, e.end.y = 1);
      var r = this.convertOperationOptionsToUI({
        start: new R(e.start),
        end: new R(e.end),
        rotation: e.rotation,
        outputRotation: i
      }),
          o = r.start,
          a = r.end;
      this.changePositionX(o.x), this.changePositionY(o.y);
      var s = a.x - o.x,
          l = a.y - o.y;
      this.transformStore.changeSize({
        width: s,
        height: l
      });
      var u = this.defaults,
          c = u.maxCropMaskSize,
          p = u.imageSize,
          f = {
        height: l * p.height / c.height,
        width: s * p.width / c.width
      };
      this.changeLocalOutputSize(f);
    }

    this.editor.outputContainer.setData({
      flipHorizontally: e.flipHorizontally,
      flipVertically: e.flipVertically
    }), e.flipHorizontally && this.flipHorizontally(!1), e.flipVertically && this.flipVertically(!1), this.editor.overlayToolStore.correctOverlayFlip(), this.localSnapshotEnabled = !0;
  }, e.prototype.applyOutputRotationFromSerialization = function (e) {
    if (void 0 !== e.outputRotation) switch (e.outputRotation) {
      case 90:
        this.transformations.rotateOutputContainer();
        break;

      case 180:
        this.transformations.rotateOutputContainer(), this.transformations.rotateOutputContainer();
        break;

      case 270:
        this.transformations.rotateOutputContainer(!0);
    }
    this.transformations.rotateOutputContainer(!0), this.transformations.rotateOutputContainer();
  }, e.prototype.setDefaultAngle = function (e) {
    this.defaultAngle = e;
  }, e.prototype.updateCanvasControls = function (e) {
    var t = xr(this.cropMaskPosition),
        n = xr(this.cropMaskSize),
        i = xr(this.defaults.maxCropMaskSize);
    this.changeCropAndOutputSize({
      height: i.height * n.height / e.height,
      width: i.width * n.width / e.width
    }), this.changePosition({
      y: i.height * t.y / e.height,
      x: i.width * t.x / e.width
    });
  }, e.prototype.onLeave = function () {
    this.transformations.onLeave();
  }, e.prototype.onEnter = function () {
    this.transformations.onEnter();
  }, e.prototype.saveTransforms = function () {
    this.transformations.saveTransforms();
  }, e.prototype.saveTransformsBasedOnFlip = function () {
    this.transformations.saveTransformsBasedOnFlip();
  }, e.prototype.setRotation = function (e) {
    this.transformStore.setRotation(e), this.transformRender();
  }, e.prototype.rotateOutputContainer = function (e) {
    return void 0 === e && (e = !1), x(this, void 0, void 0, function () {
      return k(this, function (t) {
        switch (t.label) {
          case 0:
            return this.setDragMode(!0), this.transformations.rotateOutputContainer(e), [4, this.editor.wait()];

          case 1:
            return t.sent(), this.setDragMode(!1), [2];
        }
      });
    });
  }, e.prototype.applyInitialCrop = function () {
    this.changeIdentifier(this.defaultIdentifier, !1);
  }, e.prototype.clickableCanvas = function (e) {
    this.editor.clickableCanvas(e);
  }, e.prototype.proportionalSize = function (e, t, n, i) {
    void 0 === n && (n = this.defaults.maxCropMaskSize), void 0 === i && (i = this.minCropSize);
    var r = {
      width: t.height * e,
      height: t.height
    };
    return (r.width > n.width || r.width < i || r.height < i) && (r.width = t.width, r.height = t.width / e), r.width = Math.round(r.width), r.height = Math.round(r.height), r;
  }, e.prototype.checkAndAddSnapshot = function (e) {
    var t = xr(this.localOutputSize);
    e.width === t.width && e.height === t.height || this.addLocalSnapshot();
  }, e.prototype.updateInitialCropMaskPosition = function (e) {
    var t = this.cropMaskSize,
        n = this.defaults.maxCropMaskSize;
    e ? this.changePosition({
      x: 0,
      y: Math.abs(n.height - t.height) / 2
    }) : this.changePosition({
      x: Math.abs(n.width - t.width) / 2,
      y: 0
    });
  }, e.prototype.updatePreviewSizeWRTImageSize = function () {
    var e = xr(this.localOutputSize),
        t = xr(this.defaults.imageSize),
        n = xr(this.defaults.maxCropMaskSize),
        i = {
      height: n.height * e.height / t.height,
      width: n.width * e.width / t.width
    };
    this.transformStore.changeSize(i);
  }, e.prototype.getScaleWithFlip = function (e) {
    return void 0 === e && (e = this.rotateFlipState.rotation), this.transformations.getScaleWithFlip(e);
  }, Object.defineProperty(e.prototype, "cropState", {
    get: function get() {
      return this.transformStore.selectedCrop;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      return this.transformStore.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "ratio", {
    get: function get() {
      return this.transformStore.ratio;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "height", {
    get: function get() {
      return this.transformStore.height;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "width", {
    get: function get() {
      return this.transformStore.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "localOutputImageSize", {
    get: function get() {
      return this.localOutputSize;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "localOutputHeight", {
    get: function get() {
      return this.localOutputSize.height;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "localOutputWidth", {
    get: function get() {
      return this.localOutputSize.width;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "lockResolution", {
    get: function get() {
      return this.transformStore.lockResolution;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "forceDimensions", {
    get: function get() {
      return this.transformStore.forceDimensions;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotationInDegrees", {
    get: function get() {
      return this.transformStore.rotationInDegrees;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "outputRotation", {
    get: function get() {
      return this.transformStore.outputRotation;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isDragMode", {
    get: function get() {
      return this.dragMode.get();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rotateFlipState", {
    get: function get() {
      var t = this.transformStore.state,
          n = t.flipHorizontally,
          i = t.flipVertically,
          r = t.rotationInDegrees,
          o = t.outputRotation;
      return {
        flipHorizontally: n,
        flipVertically: i,
        rotation: e.inRadians(r),
        outputRotation: o
      };
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "selectedCategoryIdentifier", {
    get: function get() {
      return this.selectedCategory;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "categories", {
    get: function get() {
      return this.entityManager.categories;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "entities", {
    get: function get() {
      return this.entityManager.getEntities(this.selectedCategoryIdentifier);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "items", {
    get: function get() {
      return this.entityManager.categories.reduce(function (e, t) {
        return C(e, _o.isCategory(t) ? t.items : [t]);
      }, []);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.TRANSFORM];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.TRANSFORM];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isOptionSelected", {
    get: function get() {
      return "identity" !== this.identifier;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftTop", {
    get: function get() {
      return this.rect.leftTop;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftBottom", {
    get: function get() {
      return this.rect.leftBottom;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightTop", {
    get: function get() {
      return this.rect.rightTop;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightBottom", {
    get: function get() {
      return this.rect.rightBottom;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isFlippedHorizontal", {
    get: function get() {
      return this.transformStore.isFlippedHorizontal;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isFlippedVertical", {
    get: function get() {
      return this.transformStore.isFlippedVertical;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftTopRespectFlip", {
    get: function get() {
      return this.rectForUi.leftTop;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leftBottomRespectFlip", {
    get: function get() {
      return this.rectForUi.leftBottom;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightTopRespectFlip", {
    get: function get() {
      return this.rectForUi.rightTop;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "rightBottomRespectFlip", {
    get: function get() {
      return this.rectForUi.rightBottom;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "cropMaskPosition", {
    get: function get() {
      return this.transformStore.position;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "cropMaskSize", {
    get: function get() {
      return this.transformStore.size;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "state", {
    get: function get() {
      return this.transformStore.state;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "defaultImageSize", {
    get: function get() {
      return this.defaults.imageSize;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "maxCropMaskSize", {
    get: function get() {
      return this.defaults.maxCropMaskSize;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "minCropMaskSize", {
    get: function get() {
      var e = this.getRatio();
      return "*" === e || 1 === e ? {
        width: this.minCropSize,
        height: this.minCropSize
      } : e > 1 ? {
        width: this.minCropSize * e,
        height: this.minCropSize
      } : {
        width: this.minCropSize,
        height: this.minCropSize * e
      };
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "defaultCropMaskPosition", {
    get: function get() {
      return this.defaults.cropMaskPosition;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "defaultScale", {
    get: function get() {
      return this.defaults.scale;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "engineMediator", {
    get: function get() {
      return this.editor.engineMediator;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getRatio = function () {
    var e = this.getTransform(this.identifier);

    if (e) {
      if (Object.prototype.hasOwnProperty.call(e, "ratio")) return this.lockResolution ? this.localOutputWidth / this.localOutputHeight : e.ratio;
      var t = e.dimensions;
      return t.x / t.y;
    }

    return "*";
  }, e.prototype.getTransform = function (e) {
    return this.entityManager.items.find(function (t) {
      return t.identifier === e;
    });
  }, w([ai], e.prototype, "selectedCategory", void 0), w([ai], e.prototype, "defaults", void 0), w([ai], e.prototype, "localOutputSize", void 0), w([sr], e.prototype, "changeIdentifier", null), w([sr], e.prototype, "setDragMode", null), w([sr], e.prototype, "setCropDefaults", null), w([sr], e.prototype, "setDefaultImageSize", null), w([sr], e.prototype, "setMaxCropSize", null), w([sr], e.prototype, "setDefaultCropPosition", null), w([sr], e.prototype, "resetCrop", null), w([sr], e.prototype, "toggleCategorySelection", null), w([sr], e.prototype, "pureReset", null), w([sr], e.prototype, "reset", void 0), w([sr], e.prototype, "changePosition", null), w([sr], e.prototype, "changePositionX", null), w([sr], e.prototype, "changePositionY", null), w([sr], e.prototype, "changeCropAndOutputHeight", null), w([sr], e.prototype, "changeCropAndOutputWidth", null), w([sr], e.prototype, "changeCropAndOutputSize", null), w([sr], e.prototype, "onLeave", null), w([sr], e.prototype, "onEnter", null), w([sr], e.prototype, "changeLocalOutputSize", void 0), w([sr], e.prototype, "changeDefaultScale", void 0), w([sr], e.prototype, "changeLocalOutputHeight", void 0), w([sr], e.prototype, "changeLocalOutputWidth", void 0), w([sr], e.prototype, "changeLockResolution", void 0), w([sr], e.prototype, "setRotation", null), w([sr], e.prototype, "rotateClockwise", void 0), w([sr], e.prototype, "rotateAntiClockwise", void 0), w([sr], e.prototype, "rotateOutputContainer", null), w([sr], e.prototype, "flipHorizontally", void 0), w([sr], e.prototype, "flipVertically", void 0), w([sr], e.prototype, "applyDefaultCrop", void 0), w([sr], e.prototype, "applyInitialCrop", null), w([sr], e.prototype, "updateCropMask", void 0), w([sr], e.prototype, "clickableCanvas", null), w([sr], e.prototype, "onLeftTop", void 0), w([sr], e.prototype, "onLeftBottom", void 0), w([sr], e.prototype, "onRightTop", void 0), w([sr], e.prototype, "onRightBottom", void 0), w([sr], e.prototype, "proportionalSize", null), w([sr], e.prototype, "onPixelWidth", void 0), w([sr], e.prototype, "onPixelHeight", void 0), w([sr], e.prototype, "updateInitialCropMaskPosition", null), w([sr], e.prototype, "updatePreviewSizeWRTImageSize", null), w([fi], e.prototype, "cropState", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "ratio", null), w([fi], e.prototype, "height", null), w([fi], e.prototype, "width", null), w([fi], e.prototype, "localOutputImageSize", null), w([fi], e.prototype, "localOutputHeight", null), w([fi], e.prototype, "localOutputWidth", null), w([fi], e.prototype, "lockResolution", null), w([fi], e.prototype, "forceDimensions", null), w([fi], e.prototype, "rotationInDegrees", null), w([fi], e.prototype, "outputRotation", null), w([fi], e.prototype, "isDragMode", null), w([fi], e.prototype, "rotateFlipState", null), w([fi], e.prototype, "selectedCategoryIdentifier", null), w([fi], e.prototype, "categories", null), w([fi], e.prototype, "entities", null), w([fi], e.prototype, "items", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "isOptionSelected", null), w([fi], e.prototype, "leftTop", null), w([fi], e.prototype, "leftBottom", null), w([fi], e.prototype, "rightTop", null), w([fi], e.prototype, "rightBottom", null), w([fi], e.prototype, "isFlippedHorizontal", null), w([fi], e.prototype, "isFlippedVertical", null), w([fi], e.prototype, "leftTopRespectFlip", null), w([fi], e.prototype, "leftBottomRespectFlip", null), w([fi], e.prototype, "rightTopRespectFlip", null), w([fi], e.prototype, "rightBottomRespectFlip", null), w([fi], e.prototype, "cropMaskPosition", null), w([fi], e.prototype, "cropMaskSize", null), w([fi], e.prototype, "state", null), w([fi], e.prototype, "defaultImageSize", null), w([fi], e.prototype, "maxCropMaskSize", null), w([fi], e.prototype, "minCropMaskSize", null), w([fi], e.prototype, "defaultCropMaskPosition", null), w([fi], e.prototype, "defaultScale", null), e;
}(),
    Yl = function () {
  function e(e) {
    var t = this;
    this.checkImageResize = function () {
      t.engine.on(De.BEGAN_IMAGE_DOWNSCALING, function () {
        t.modalStore.showInfoModal("resizing");
      }), t.engine.on(De.IMAGE_DOWNSCALED, function () {});
    }, this.init = function (e) {
      t.historyStore.isDirty() ? t.modalStore.showActionModal({
        identifier: "discardChanges",
        handlers: {
          buttonYes: function buttonYes() {
            t.setImage(e), t.resetToolStates();
          },
          buttonNo: function buttonNo() {
            t.setImage(e, !0);
          }
        }
      }) : (t.setImage(e, !0), t.historyStore.reset()), t.libraryStore.fetchImages();
    }, this.setImage = function (e, n) {
      return void 0 === n && (n = !1), x(t, void 0, void 0, function () {
        var t, i, r, o;
        return k(this, function (a) {
          switch (a.label) {
            case 0:
              return a.trys.push([0, 4,, 5]), this.modalStore.showInfoModal(this.configStore.config.displayResizeWarning ? "resizing" : "loading"), this.scale.defaultScale = 1, this.scale.resetOffset(), this.activeStore.setImage(e), [4, this.engineMediator.image.addImageToContainer()];

            case 1:
              return a.sent(), this.engineMediator.output.applyNewImageTransform(), this.engineMediator.preview.updateTransform(), this.scale.setInitialTransform(), this.transformToolStore.setCropDefaults(), this.historyStore.addInitialSnapshot(), t = this.transformToolStore.rotateFlipState, i = t.flipHorizontally, r = t.flipVertically, this.outputContainer.setData({
                flipVertically: r,
                flipHorizontally: i
              }), n ? (this.focusToolStore.updateCanvasControls(), this.spriteStore.updateCanvasControls(), this.transformToolStore.resetCrop(), this.transformToolStore.applyDefaultCrop(), this.transformToolStore.saveTransformsBasedOnFlip(), this.transformToolStore.onEnter(), this.transformToolStore.setRotation(this.transformToolStore.rotationInDegrees), this.transformToolStore.onLeave(), this.transformToolStore.onEnter(), this.transformToolStore.onLeave()) : this.transformToolStore.saveTransforms(), this.snappingStore.calculatePreviewTopLeftPosition(), [4, this.renderPromise()];

            case 2:
              return a.sent(), [4, this.filterToolStore.setImageAndGetPreviews()];

            case 3:
              return a.sent(), this.activeStore.tool || this.onReady(), this.modalStore.hideModal(), [3, 5];

            case 4:
              return o = a.sent(), this.modalStore.hideModal(), this.modalStore.showActionModal({
                identifier: o.identifier ? o.identifier : "rendering",
                error: o,
                handlers: {
                  buttonYes: function buttonYes() {
                    window.location.reload();
                  }
                }
              }), [3, 5];

            case 5:
              return [2];
          }
        });
      });
    }, this.onToolChange = function (e, n, i) {
      if (void 0 === n && (n = null), void 0 === i && (i = !0), e !== n && t.engineMediator.preview.container) {
        if (-1 !== [e, n].indexOf(P.TRANSFORM)) {
          var r = t.canvasStore.canvasSize,
              o = t.configStore.measurements.basicToolControlBar.controlsBarHeight;

          if (e === P.TRANSFORM) {
            t.transformToolStore.onLeave(), t.historyStore.removeTransformLocalSnapshots();
            var a = t.engineMediator.preview.container.getScale().x,
                s = t.engineMediator.output.container.getResolution(),
                l = t.transformToolStore.defaultImageSize;
            (1 !== a || l.width !== s.width || l.height !== s.height) && t.addSnapshot(void 0, "edit", t.configStore.locale.transform.title), t.snappingStore.calculatePreviewTopLeftPosition(), t.configStore.isLayoutAdvanced || (t.canvasStore.state.canvasSize.height = r.height + o, t.resize(!0));
          } else n === P.TRANSFORM && (t.configStore.isLayoutAdvanced || (t.canvasStore.state.canvasSize.height = r.height - o, t.resize(), t.render()), t.transformToolStore.onEnter(), t.transformToolStore.addLocalSnapshot(), t.historyStore.saveTransformLocalSnapshotIndex());
        } else t.scale.resetOffset(), t.scale.resetPosition(), t.scale.setScaleToDefault(), t.scale.scaleRender(!0);

        i && t.render();
      }
    }, this.resize = function (e) {
      void 0 === e && (e = !1);

      try {
        t.transformToolStore.applyDefaultCrop(), t.canvasStore.updateCanvasDimensions();
        var n = xr(t.transformToolStore.maxCropMaskSize),
            i = t.activeStore.tool === P.TRANSFORM;
        i && !e || t.transformToolStore.onEnter();
        var r = t.engineMediator.preview.container.getRotation();

        if (t.engineMediator.preview.updateTransform(r)) {
          t.scale.setInitialTransform(), t.transformToolStore.setCropDefaults(), t.transformToolStore.updateCanvasControls(n), t.focusToolStore.updateCanvasControls(), t.spriteStore.updateCanvasControls();
          var o = t.transformToolStore.getScaleWithFlip(r);
          t.engineMediator.preview.container.setScale(o), i && !e || (t.transformToolStore.onLeave(), t.transformToolStore.onEnter(), t.transformToolStore.onLeave()), t.snappingStore.calculatePreviewTopLeftPosition(), t.render();
        }
      } catch (e) {
        t.modalStore.showActionModal({
          identifier: "rendering",
          handlers: {
            buttonYes: function buttonYes() {
              window.location.reload();
            }
          }
        });
      }
    }, this.export = function (e) {
      void 0 === e && (e = {});
      var n = e.preventExportEvent,
          i = b(e, ["preventExportEvent"]);
      return new Promise(function (e, r) {
        t.modalStore.showInfoModal("exporting");
        var o = t.activeStore.tool === P.TRANSFORM;
        o && t.transformToolStore.onLeave();

        var a = t.configStore.config,
            s = _v2(_v2({}, a.export.image), i),
            l = s.exportType,
            u = s.format,
            c = s.quality,
            p = s.enableDownload;

        t.engineMediator.engine.export(l, u, c).then(function (i) {
          p && t.triggerFileDownload(a.export.filename, u, l, i), n || t.configStore.events.onExport(i), e(i), o && t.transformToolStore.onEnter(), t.modalStore.hideModal();
        }).catch(function (e) {
          r(e), o && t.transformToolStore.onEnter(), t.modalStore.hideModal();
        });
      });
    }, this.serialize = function (e) {
      var n = (void 0 === e ? {
        image: !0
      } : e).image;
      return t.serializationMediator.serialize({
        image: n
      });
    }, this.deserialize = function (e) {
      return t.serializationMediator.deserialize(e);
    }, this.close = function () {
      t.hasChanges() && t.configStore.config.displayCloseWarning ? t.modalStore.showActionModal({
        identifier: "unsavedChanges",
        handlers: {
          buttonYes: function buttonYes() {
            t.configStore.events.onClose();
          }
        }
      }) : t.configStore.events.onClose();
    }, this.hasChanges = function () {
      return t.historyStore.isDirty();
    }, this.wait = function (e) {
      return void 0 === e && (e = 0), new Promise(function (t) {
        return setTimeout(t, e);
      });
    }, this.clickableCanvas = function (e) {
      return x(t, void 0, void 0, function () {
        return k(this, function (t) {
          switch (t.label) {
            case 0:
              return e ? [4, new Promise(function (e) {
                return setTimeout(e, 0);
              })] : [3, 2];

            case 1:
              return t.sent(), this.canvasStore.enableCanvasClick(), [3, 3];

            case 2:
              this.canvasStore.disableCanvasClick(), t.label = 3;

            case 3:
              return [2];
          }
        });
      });
    }, this.onReady = function () {
      return x(t, void 0, void 0, function () {
        var e, t, n, i, r, o;
        return k(this, function (a) {
          return e = this.configStore.config, t = e.layout, n = e.forceCrop, "advanced" === t && this.activeStore.selectTool(this.configStore.defaultTool), n && (i = this.transformToolStore.localOutputImageSize, r = i.width / i.height, -1 !== (o = this.transformToolStore.entityManager.items.map(function (e) {
            return "*" === e.ratio || e.ratio ? e.ratio : e.dimensions.x / e.dimensions.y;
          })).indexOf("*") ? console.error('ForceCrop will not work if "*" is one of the ratios') : -1 === o.indexOf(r.toFixed(2)) && this.activeStore.selectTool(P.TRANSFORM)), this.configStore.events.onEditorReady(), [2];
        });
      });
    }, this.addSnapshot = function (e, n, i) {
      t.historyStore.addSnapshot(e, n, i);
    }, this.addLocalTransformSnapshot = function (e, n, i) {
      void 0 === i && (i = "edit"), t.historyStore.addSnapshot({
        localTransform: e
      }, i, n);
    }, this.resetToolStates = function () {
      t.filterToolStore.pureReset(), t.focusToolStore.pureReset(), t.adjustmentsToolStore.pureReset(), t.overlayToolStore.pureReset(), t.frameToolStore.pureReset(), t.brushToolStore.pureReset(), t.spriteStore.pureReset(), t.transformToolStore.pureReset(), t.historyStore.reset(), t.render();
    }, this.getAssetPath = function (e) {
      return t.assetProvider.getPathForCategory(e);
    }, this.render = function () {
      return x(t, void 0, void 0, function () {
        return k(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this.renderPromise()];

            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, this.applyFlipToPreview = function (e) {
      return t.engineMediator.previewSpaceToFlippedPreviewSpace(e);
    }, this.getPreviewSize = function () {
      var e = t.engine.getOutputDimensions(),
          n = e.width,
          i = e.height;
      return n && i ? {
        width: Math.round(t.worldToPreview(t.outputToWorld(n))),
        height: Math.round(t.worldToPreview(t.outputToWorld(i)))
      } : {
        height: i,
        width: n
      };
    }, this.triggerFileDownload = function (e, n, i, r) {
      var o = e + (n === q.JPEG && i !== Y.MSBLOB ? ".jpeg" : ".png"),
          a = t.blobFromExportData(r);
      t.triggerBlobDownload(o, a);
    }, this.triggerBlobDownload = function (e, t) {
      if (navigator.msSaveBlob) navigator.msSaveBlob(t, e);else {
        var n = document.createElement("a"),
            i = URL.createObjectURL(t);
        n.href = i, n.download = e, document.body.appendChild(n), n.click(), document.body.removeChild(n), void 0 === r && (r = qe()), r.match(/iP(hone|od|ad)|AppleWebKit/) || URL.revokeObjectURL(i);
      }
      var r;
    }, this.blobFromExportData = function (e) {
      return "string" == typeof e ? vl(e) : e instanceof HTMLImageElement ? vl(e.src) : e;
    }, this.configStore = new Zs();
    var n = this.configStore.saveConfig(e);

    if (this.engineMediator = new ol(this), this.serializationMediator = new fl(this), this.spriteStore = new jl(this), this.scale = new cl(this), this.filterToolStore = new ko(this), this.adjustmentsToolStore = new vo(this), this.focusToolStore = new Oo(this), this.overlayToolStore = new Mo(this), this.frameToolStore = new ml(this), this.brushToolStore = new wl(this), this.transformToolStore = new Xl(this), this.libraryStore = new _l(this), this.modalStore = new ul(this), this.snappingStore = new kl(this), this.activeStore = new Os(this), this.canvasStore = new Rs(this), this.historyStore = new sl(this), this.modalStore.showInfoModal("loading"), this.libraryStore.initProvider(n), this.configStore.config.displayResizeWarning && this.checkImageResize(), this.configStore.config.filter.enablePreviewThumbnails) {
      var i = this.configStore.config.engine;
      this.previewThumbnails = new Cs(_v2(_v2({}, i), {
        license: this.configStore.config.license,
        assetProvider: this.configStore.assetProvider
      }));
    }
  }

  return Object.defineProperty(e, "defaultColors", {
    get: function get() {
      return Object.keys(Jt).map(function (e) {
        var t = Jt[e];
        return {
          identifier: e,
          color: t,
          colorString: Qt(t)
        };
      });
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultBackgroundColors", {
    get: function get() {
      return Object.keys($t).map(function (e) {
        var t = $t[e];
        return {
          identifier: e,
          color: t,
          colorString: Qt(t)
        };
      });
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "devicePixelRatio", {
    get: function get() {
      return window.devicePixelRatio || 1;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "shortestOutputSide", {
    get: function get() {
      var e = this.outputContainer.getBounds();
      return Math.min(e.width, e.height);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "assetProvider", {
    get: function get() {
      return this.configStore.assetProvider;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "engine", {
    get: function get() {
      return this.engineMediator.engine;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "imageContainer", {
    get: function get() {
      return this.engineMediator.image.container;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "orderHelper", {
    get: function get() {
      return this.engineMediator.orderHelper;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.renderPromise = function () {
    return this.engineMediator.render(this.engineMediator.preview.container);
  }, e.prototype.previewToWorld = function (e, t) {
    return M(e), this.engineMediator.previewSpaceToWorldSpace(e, t);
  }, e.prototype.worldToPreview = function (e) {
    return M(e), this.engineMediator.worldSpaceToPreviewSpace(e);
  }, e.prototype.worldSizeToPreview = function (e) {
    return {
      width: this.engineMediator.worldSpaceToPreviewSpace(e.width),
      height: this.engineMediator.worldSpaceToPreviewSpace(e.height)
    };
  }, e.prototype.previewSizeToWorld = function (e, t) {
    return {
      width: this.engineMediator.previewSpaceToWorldSpace(e.width, t),
      height: this.engineMediator.previewSpaceToWorldSpace(e.height, t)
    };
  }, e.prototype.outputToWorld = function (e) {
    return M(e), this.engineMediator.outputSpaceToWorldSpace(e);
  }, e.prototype.previewToOutput = function (e) {
    return M(e), this.engineMediator.previewSpaceToOutputSpace(e);
  }, Object.defineProperty(e.prototype, "outputContainer", {
    get: function get() {
      return this.engineMediator.output.container;
    },
    enumerable: !0,
    configurable: !0
  }), w([sr], e.prototype, "resize", void 0), w([sr], e.prototype, "export", void 0), w([sr], e.prototype, "clickableCanvas", void 0), e;
}(),
    ql = function () {
  function e(e) {
    var t = this;
    this.state = ai.map(Do), this.customStickerIds = [], this.changeOpacity = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          t.editor.spriteStore.setContainerProperties(t.id, {
            opacity: e
          });
          var i = t.editor.spriteStore.getContainerProperties(t.id);
          n.opacity = i.opacity, t.state.set(t.id, n);
        }
      }
    }, this.changeTintColor = function (e) {
      if (t.id) {
        var n = t.state.get(t.id);

        if (n) {
          var i = t.entityManager.items.find(function (e) {
            return e.identifier === t.identifier;
          }).tintMode;
          t.editor.spriteStore.setContainerProperties(t.id, {
            tintColor: e,
            tintMode: i
          });
          var r = t.editor.spriteStore.getContainerProperties(t.id);
          n.tintColor = r.tintColor, n.tintMode = r.tintMode || Fo.tintMode, t.state.set(t.id, n);
        }
      }
    }, this.tintColorSnapshot = function () {
      t.addSnapshot("edit", t.locale.history.color);
    }, this.editor = e, this.selectedCategory = "identity";
    var n = this.config,
        i = this.editor.assetProvider.getAssets("sticker");
    this.entityManager = new _o(i, _v2(_v2({}, n), {
      categoryKey: "thumbnailURI",
      categoryDynamicKey: "thumbnail",
      itemKey: "stickerURI",
      itemDynamicKey: "sticker",
      locale: _v2(_v2({}, this.locale.items), this.locale.categories),
      getAssetPath: this.editor.getAssetPath("sticker")
    }));
  }

  return Object.defineProperty(e, "defaultColors", {
    get: function get() {
      return Yl.defaultColors;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.selectLast = function () {
    this.editor.spriteStore.selectHighestOrderSprite(Array.from(this.state.keys()));
  }, e.prototype.doesStickerAssetExist = function (e) {
    return -1 !== this.entityManager.items.findIndex(function (t) {
      return t.identifier === e;
    });
  }, e.prototype.add = function (e) {
    var t = this.entities.find(function (t) {
      return t.identifier === e;
    }),
        n = t ? t.tintMode : Fo.tintMode,
        i = t ? t.resizeMode : Fo.resizeMode;
    this.editor.spriteStore.addSticker({
      state: {
        identifier: e,
        tintMode: n,
        tintColor: Fo.tintColor,
        opacity: Fo.opacity,
        resizeMode: i
      }
    });
  }, e.prototype.duplicate = function () {
    if (this.id) {
      var e = this.editor.spriteStore.getDuplicateContainerTransform(this.id),
          t = this.editor.spriteStore.getDuplicateContainerFlip(this.id),
          n = this.editor.outputContainer.getData(),
          i = n.flipHorizontally,
          r = n.flipVertically;
      this.editor.spriteStore.addSticker({
        state: {
          identifier: this.identifier,
          tintColor: xr(this.tintColor),
          tintMode: this.tintMode,
          resizeMode: this.resizeMode,
          opacity: this.opacity,
          flipHorizontally: i !== t.flipHorizontally,
          flipVertically: r !== t.flipVertically
        },
        transform: e
      });
    }
  }, e.prototype.bringToFront = function () {
    this.id && this.editor.spriteStore.bringToFront(this.id);
  }, e.prototype.flipHorizontally = function () {
    this.id && this.editor.spriteStore.flipHorizontally(this.id);
  }, e.prototype.delete = function () {
    if (this.id) {
      var e = this.id;
      this.editor.spriteStore.removeSprite(e), this.state.delete(e), this.selectLast();
    }
  }, e.prototype.updateStateFromHistory = function (e, t) {
    this.setState(e, t), this.editor.spriteStore.setContainerProperties(e, t);
  }, e.prototype.setState = function (e, t) {
    var n = this.state.get(e);
    n ? ("opacity" in t && (n.opacity = t.opacity), t.tintColor && (n.tintColor = t.tintColor), t.tintMode && (n.tintMode = t.tintMode), t.resizeMode && (n.resizeMode = t.resizeMode), this.state.set(e, n)) : this.state.set(e, {
      identifier: t.identifier,
      opacity: t.opacity,
      tintMode: t.tintMode,
      resizeMode: t.resizeMode,
      tintColor: t.tintColor ? t.tintColor : Fo.tintColor
    });
  }, e.prototype.addFiles = function (e) {
    return x(this, void 0, void 0, function () {
      var t, n, i;
      return k(this, function (r) {
        switch (r.label) {
          case 0:
            if (this.editor.modalStore.showInfoModal("loading"), !e.length) return [3, 4];

            for (t = 0, n = [], t = 0; t < e.length; t += 1) {
              n.push(zl(e[t], !0));
            }

            r.label = 1;

          case 1:
            return r.trys.push([1, 3,, 4]), [4, Promise.all(n)];

          case 2:
            return i = r.sent(), this.addCustomStickerAsset(i), [3, 4];

          case 3:
            return r.sent(), this.editor.modalStore.hideModal(), this.editor.modalStore.showActionModal({
              identifier: "stickerLoading"
            }), [3, 4];

          case 4:
            return [2];
        }
      });
    });
  }, e.prototype.addCustomStickerAsset = function (e) {
    return x(this, void 0, void 0, function () {
      var t,
          n,
          i,
          r,
          o = this;
      return k(this, function (a) {
        switch (a.label) {
          case 0:
            return t = e.map(function (e) {
              return {
                sticker: e.image,
                thumbnailURI: e.smallImage,
                name: e.name,
                tintMode: o.customStickerTintMode,
                resizeMode: "keepAspect",
                identifier: e.id,
                type: e.type
              };
            }), this.customStickerIds = this.customStickerIds.concat(t.map(function (e) {
              return {
                identifier: e.identifier,
                type: e.type
              };
            })), n = this.locale.categories.imgly_sticker_custom, this.editor.assetProvider.addCustomStickerAsset(t, "imgly_sticker_custom", n), i = this.editor.assetProvider.getAssets("sticker"), r = this.config, this.entityManager = new _o(i, _v2(_v2({}, r), {
              categoryKey: "thumbnailURI",
              categoryDynamicKey: "thumbnail",
              itemDynamicKey: "thumbnailURI",
              itemKey: "stickerURI",
              locale: this.locale.items,
              getAssetPath: this.editor.getAssetPath("sticker")
            })), this.selectedCategory = Fo.identifier, [4, this.editor.wait()];

          case 1:
            return a.sent(), this.selectedCategory = "imgly_sticker_custom", this.editor.modalStore.hideModal(), [2];
        }
      });
    });
  }, e.prototype.toolSnapshot = function () {
    this.addSnapshot("edit", this.locale.history.opacity);
  }, e.prototype.addSnapshot = function (e, t) {
    this.currentSticker && this.editor.spriteStore.addSnapshot(e, t);
  }, e.prototype.toggleCategorySelection = function (e) {
    this.selectedCategory = this.selectedCategory === e ? "identity" : e;
  }, e.prototype.pureReset = function () {
    this.state = ai.map(Do);
  }, Object.defineProperty(e.prototype, "isStickerSelected", {
    get: function get() {
      return this.editor.spriteStore.isSpriteSticker;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isCustomStickerEnabled", {
    get: function get() {
      return this.config.enableCustomUpload;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "customStickerTintMode", {
    get: function get() {
      return this.config.customStickerTintMode;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "currentSticker", {
    get: function get() {
      if (this.isStickerSelected) {
        var e = this.state.get(this.id);
        if (e) return e;
      }
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "identifier", {
    get: function get() {
      if (this.isStickerSelected) {
        var e = this.state.get(this.id);
        if (e) return e.identifier;
      }

      return "none";
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "id", {
    get: function get() {
      if (this.isStickerSelected) return this.editor.spriteStore.id;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "opacity", {
    get: function get() {
      return this.currentSticker ? this.currentSticker.opacity : Fo.opacity;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "tintMode", {
    get: function get() {
      return this.currentSticker ? this.currentSticker.tintMode : Fo.tintMode;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "resizeMode", {
    get: function get() {
      return this.currentSticker ? this.currentSticker.resizeMode : Fo.resizeMode;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "tintable", {
    get: function get() {
      return !!this.currentSticker && ("solid" === this.currentSticker.tintMode || "colorized" === this.currentSticker.tintMode);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "tintColor", {
    get: function get() {
      return this.currentSticker ? this.currentSticker.tintColor : Fo.tintColor;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "config", {
    get: function get() {
      return this.editor.configStore.config[P.STICKER];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "locale", {
    get: function get() {
      return this.editor.configStore.locale[P.STICKER];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "localeColor", {
    get: function get() {
      return this.editor.configStore.locale.common.color;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "selectedCategoryIdentifier", {
    get: function get() {
      return this.selectedCategory;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "entities", {
    get: function get() {
      return this.entityManager.getEntities(this.selectedCategoryIdentifier);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "categories", {
    get: function get() {
      return this.entityManager.getCategories(this.selectedCategoryIdentifier);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "flattenCategories", {
    get: function get() {
      return this.config.flattenCategories;
    },
    enumerable: !0,
    configurable: !0
  }), w([ai], e.prototype, "selectedCategory", void 0), w([sr], e.prototype, "selectLast", null), w([sr], e.prototype, "add", null), w([sr], e.prototype, "duplicate", null), w([sr], e.prototype, "bringToFront", null), w([sr], e.prototype, "flipHorizontally", null), w([sr], e.prototype, "delete", null), w([sr], e.prototype, "updateStateFromHistory", null), w([sr], e.prototype, "setState", null), w([sr], e.prototype, "changeOpacity", void 0), w([sr], e.prototype, "changeTintColor", void 0), w([sr], e.prototype, "addFiles", null), w([sr], e.prototype, "addCustomStickerAsset", null), w([sr], e.prototype, "toggleCategorySelection", null), w([sr], e.prototype, "pureReset", null), w([fi], e.prototype, "isStickerSelected", null), w([fi], e.prototype, "isCustomStickerEnabled", null), w([fi], e.prototype, "customStickerTintMode", null), w([fi], e.prototype, "currentSticker", null), w([fi], e.prototype, "identifier", null), w([fi], e.prototype, "id", null), w([fi], e.prototype, "opacity", null), w([fi], e.prototype, "tintMode", null), w([fi], e.prototype, "resizeMode", null), w([fi], e.prototype, "tintable", null), w([fi], e.prototype, "tintColor", null), w([fi], e.prototype, "config", null), w([fi], e.prototype, "locale", null), w([fi], e.prototype, "localeColor", null), w([fi], e.prototype, "selectedCategoryIdentifier", null), w([fi], e.prototype, "entities", null), w([fi], e.prototype, "categories", null), w([fi], e.prototype, "flattenCategories", null), e;
}(),
    Kl = new RegExp(/\uFE0F|\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\uD000-\uDFFF]|[\u0D7A-\u0D7F]|[\u110e-\u11e0]|\uffba|\u03A7|\u03C7|\u0E09|\u10B9|\u10E9|\u132A|\u1396|\u1665|\u166D|\u1842|\u1D61|\u1D6A|\uD834|\uD835|\uDEBE|\uDED8|\uDEF8|\uDF0E|\uDF12|\uDF32|\uDF4C|\uDF6C|\uDF86|\uDFA6|\uDFC0|[\u1C50-\u1C56]|[\uA700-\uA707]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]/g),
    Zl = e.div(Ll || (Ll = E(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: row;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  -webkit-touch-callout: none;\n  user-select: none;\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: '", "', sans-serif;\n    /* css reset for a global box-sizing: border-box */\n    box-sizing: content-box;\n    /* todo: fix the issue with these settings */\n    font-size: inherit;\n    color: inherit;\n    line-height: normal;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: row;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  -webkit-touch-callout: none;\n  user-select: none;\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: '", "', sans-serif;\n    /* css reset for a global box-sizing: border-box */\n    box-sizing: content-box;\n    /* todo: fix the issue with these settings */\n    font-size: inherit;\n    color: inherit;\n    line-height: normal;\n  }\n"])), function (e) {
  return e.theme.background;
}, function (e) {
  return e.theme.foreground;
}, function (e) {
  return e.theme.typography.fontFamily;
});

Zl.defaultProps = {
  theme: Xs
};
var Ql,
    Jl,
    $l,
    eu = t(Ql || (Ql = E(["\n  from { transform: translate(-50%, 0%); }\n  to { transform: translate(-50%, 50%); }\n"], ["\n  from { transform: translate(-50%, 0%); }\n  to { transform: translate(-50%, 50%); }\n"]))),
    tu = e.div($l || ($l = E(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  transform: translate(-50%, 50%);\n  background: black;\n  color: white;\n  border-radius: ", "px;\n  padding: 10px 16px;\n  text-align: center;\n  z-index: ", ";\n  visibility: hidden;\n\n  ", "\n"], ["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  transform: translate(-50%, 50%);\n  background: black;\n  color: white;\n  border-radius: ", "px;\n  padding: 10px 16px;\n  text-align: center;\n  z-index: ", ";\n  visibility: hidden;\n\n  ", "\n"])), function (e) {
  return e.position.y;
}, function (e) {
  return e.position.x;
}, function (e) {
  return e.theme.shape.radiusMedium;
}, function (e) {
  return e.theme.measurements.zIndex.toast;
}, function (e) {
  return e.show && n(Jl || (Jl = E(["\n      visibility: visible;\n      animation: ", " 0.5s, fadeout 0.5s 2.5s;\n    "], ["\n      visibility: visible;\n      animation: ", " 0.5s, fadeout 0.5s 2.5s;\n    "])), eu);
});
/** @license mobx-react v5.4.4
 * index.module.js
 *
 * Copyright (c) 2015 Michel Weststrate.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function nu(e) {
  return (nu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function iu(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function ru(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}

function ou(e, t, n) {
  return t && ru(e.prototype, t), n && ru(e, n), e;
}

function au(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function su(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && uu(e, t);
}

function lu(e) {
  return (lu = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function uu(e, t) {
  return (uu = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function cu(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e) : t;
}

function pu(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var fu,
    hu = pu(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = "function" == typeof Symbol && Symbol.for,
      i = n ? Symbol.for("react.element") : 60103,
      r = n ? Symbol.for("react.portal") : 60106,
      o = n ? Symbol.for("react.fragment") : 60107,
      a = n ? Symbol.for("react.strict_mode") : 60108,
      s = n ? Symbol.for("react.profiler") : 60114,
      l = n ? Symbol.for("react.provider") : 60109,
      u = n ? Symbol.for("react.context") : 60110,
      c = n ? Symbol.for("react.async_mode") : 60111,
      p = n ? Symbol.for("react.concurrent_mode") : 60111,
      f = n ? Symbol.for("react.forward_ref") : 60112,
      h = n ? Symbol.for("react.suspense") : 60113,
      d = n ? Symbol.for("react.memo") : 60115,
      g = n ? Symbol.for("react.lazy") : 60116;

  function m(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;

      switch (t) {
        case i:
          switch (e = e.type) {
            case c:
            case p:
            case o:
            case s:
            case a:
              return e;

            default:
              switch (e = e && e.$$typeof) {
                case u:
                case f:
                case l:
                  return e;

                default:
                  return t;
              }

          }

        case r:
          return t;
      }
    }
  }

  function y(e) {
    return m(e) === p;
  }

  t.typeOf = m, t.AsyncMode = c, t.ConcurrentMode = p, t.ContextConsumer = u, t.ContextProvider = l, t.Element = i, t.ForwardRef = f, t.Fragment = o, t.Profiler = s, t.Portal = r, t.StrictMode = a, t.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === o || e === p || e === s || e === a || e === h || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === d || e.$$typeof === l || e.$$typeof === u || e.$$typeof === f);
  }, t.isAsyncMode = function (e) {
    return y(e) || m(e) === c;
  }, t.isConcurrentMode = y, t.isContextConsumer = function (e) {
    return m(e) === u;
  }, t.isContextProvider = function (e) {
    return m(e) === l;
  }, t.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === i;
  }, t.isForwardRef = function (e) {
    return m(e) === f;
  }, t.isFragment = function (e) {
    return m(e) === o;
  }, t.isProfiler = function (e) {
    return m(e) === s;
  }, t.isPortal = function (e) {
    return m(e) === r;
  }, t.isStrictMode = function (e) {
    return m(e) === a;
  };
});
(fu = hu) && fu.__esModule && Object.prototype.hasOwnProperty.call(fu, "default") && fu.default;
hu.typeOf, hu.AsyncMode, hu.ConcurrentMode, hu.ContextConsumer, hu.ContextProvider, hu.Element, hu.ForwardRef, hu.Fragment, hu.Profiler, hu.Portal, hu.StrictMode, hu.isValidElementType, hu.isAsyncMode, hu.isConcurrentMode, hu.isContextConsumer, hu.isContextProvider, hu.isElement, hu.isForwardRef, hu.isFragment, hu.isProfiler, hu.isPortal, hu.isStrictMode;
var du = pu(function (e) {
  e.exports = hu;
}),
    gu = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
},
    mu = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
},
    yu = {};
yu[du.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
};
var _u = Object.defineProperty,
    vu = Object.getOwnPropertyNames,
    bu = Object.getOwnPropertySymbols,
    wu = Object.getOwnPropertyDescriptor,
    xu = Object.getPrototypeOf,
    ku = Object.prototype;

var Tu = function e(t, n, i) {
  if ("string" != typeof n) {
    if (ku) {
      var r = xu(n);
      r && r !== ku && e(t, r, i);
    }

    var o = vu(n);
    bu && (o = o.concat(bu(n)));

    for (var a = yu[t.$$typeof] || gu, s = yu[n.$$typeof] || gu, l = 0; l < o.length; ++l) {
      var u = o[l];

      if (!(mu[u] || i && i[u] || s && s[u] || a && a[u])) {
        var c = wu(n, u);

        try {
          _u(t, u, c);
        } catch (e) {}
      }
    }

    return t;
  }

  return t;
},
    Su = function () {
  function e() {
    iu(this, e), this.listeners = [];
  }

  return ou(e, [{
    key: "on",
    value: function value(e) {
      var t = this;
      return this.listeners.push(e), function () {
        var n = t.listeners.indexOf(e);
        -1 !== n && t.listeners.splice(n, 1);
      };
    }
  }, {
    key: "emit",
    value: function value(e) {
      this.listeners.forEach(function (t) {
        return t(e);
      });
    }
  }]), e;
}();

function Cu(e) {
  function t(t, n, i, r, o, a) {
    for (var s = arguments.length, l = new Array(s > 6 ? s - 6 : 0), u = 6; u < s; u++) {
      l[u - 6] = arguments[u];
    }

    return vi(function () {
      if (r = r || "<<anonymous>>", a = a || i, null == n[i]) {
        if (t) {
          var s = null === n[i] ? "null" : "undefined";
          return new Error("The " + o + " `" + a + "` is marked as required in `" + r + "`, but its value is `" + s + "`.");
        }

        return null;
      }

      return e.apply(void 0, [n, i, r, o, a].concat(l));
    });
  }

  var n = t.bind(null, !1);
  return n.isRequired = t.bind(null, !0), n;
}

function Eu(e) {
  var t = nu(e);
  return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
    return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol;
  }(t, e) ? "symbol" : t;
}

function Ou(e, t) {
  return Cu(function (n, i, r, o, a) {
    return vi(function () {
      if (e && Eu(n[i]) === t.toLowerCase()) return null;
      var o;

      switch (t) {
        case "Array":
          o = Vr;
          break;

        case "Object":
          o = oo;
          break;

        case "Map":
          o = Kr;
          break;

        default:
          throw new Error("Unexpected mobxType: ".concat(t));
      }

      var s = n[i];

      if (!o(s)) {
        var l = function (e) {
          var t = Eu(e);

          if ("object" === t) {
            if (e instanceof Date) return "date";
            if (e instanceof RegExp) return "regexp";
          }

          return t;
        }(s),
            u = e ? " or javascript `" + t.toLowerCase() + "`" : "";

        return new Error("Invalid prop `" + a + "` of type `" + l + "` supplied to `" + r + "`, expected `mobx.Observable" + t + "`" + u + ".");
      }

      return null;
    });
  });
}

function Ru(e, t) {
  return Cu(function (n, i, r, o, a) {
    for (var s = arguments.length, l = new Array(s > 5 ? s - 5 : 0), u = 5; u < s; u++) {
      l[u - 5] = arguments[u];
    }

    return vi(function () {
      if ("function" != typeof t) return new Error("Property `" + a + "` of component `" + r + "` has invalid PropType notation.");
      var s = Ou(e, "Array")(n, i, r);
      if (s instanceof Error) return s;

      for (var u = n[i], c = 0; c < u.length; c++) {
        if ((s = t.apply(void 0, [u, c, r, o, a + "[" + c + "]"].concat(l))) instanceof Error) return s;
      }

      return null;
    });
  });
}

Ou(!1, "Array"), Ru.bind(null, !1), Ou(!1, "Map"), Ou(!1, "Object"), Ou(!0, "Array"), Ru.bind(null, !0);
var Iu = Ou(!0, "Object");
var Au = 0;
var Mu = {};

function Fu(e) {
  return Mu[e] || (Mu[e] = function (e) {
    if ("function" == typeof Symbol) return Symbol(e);
    var t = "__$mobx-react ".concat(e, " (").concat(Au, ")");
    return Au++, t;
  }(e)), Mu[e];
}

var Du = Fu("patchMixins"),
    Pu = Fu("patchedDefinition");

function zu(e, t) {
  var n = e[Du] = e[Du] || {},
      i = n[t] = n[t] || {};
  return i.locks = i.locks || 0, i.methods = i.methods || [], i;
}

function Lu(e, t) {
  for (var n = this, i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), o = 2; o < i; o++) {
    r[o - 2] = arguments[o];
  }

  t.locks++;

  try {
    var a;
    return null != e && (a = e.apply(this, r)), a;
  } finally {
    t.locks--, 0 === t.locks && t.methods.forEach(function (e) {
      e.apply(n, r);
    });
  }
}

function Bu(e, t) {
  return function () {
    for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++) {
      i[r] = arguments[r];
    }

    Lu.call.apply(Lu, [this, e, t].concat(i));
  };
}

function Nu(e, t, n, i, r) {
  var o,
      a = Bu(r, i);
  return au(o = {}, Pu, !0), au(o, "get", function () {
    return a;
  }), au(o, "set", function (r) {
    if (this === e) a = Bu(r, i);else {
      var o = Nu(this, t, n, i, r);
      Object.defineProperty(this, t, o);
    }
  }), au(o, "configurable", !0), au(o, "enumerable", n), o;
}

var Uu = {
  mobxStores: Iu
};
Object.seal(Uu);
var ju = {
  contextTypes: {
    get: function get() {
      return Uu;
    },
    set: function set(e) {
      console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
    },
    configurable: !0,
    enumerable: !1
  },
  isMobxInjector: {
    value: !0,
    writable: !0,
    configurable: !0,
    enumerable: !0
  }
};

function Wu(e, t, n) {
  var i = "inject-" + (t.displayName || t.name || t.constructor && t.constructor.name || "Unknown");
  n && (i += "-with-" + n);

  var r = function (n) {
    function i() {
      var e, t;
      iu(this, i);

      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
        r[o] = arguments[o];
      }

      return (t = cu(this, (e = lu(i)).call.apply(e, [this].concat(r)))).storeRef = function (e) {
        t.wrappedInstance = e;
      }, t;
    }

    return su(i, a), ou(i, [{
      key: "render",
      value: function value() {
        var n = {};

        for (var i in this.props) {
          this.props.hasOwnProperty(i) && (n[i] = this.props[i]);
        }

        var r = e(this.context.mobxStores || {}, n, this.context) || {};

        for (var o in r) {
          n[o] = r[o];
        }

        return function (e) {
          return !(e.prototype && e.prototype.render);
        }(t) || (n.ref = this.storeRef), l(t, n);
      }
    }]), i;
  }();

  return r.displayName = i, Tu(r, t), r.wrappedComponent = t, Object.defineProperties(r, ju), r;
}

function Hu(e) {
  return function (t, n) {
    return e.forEach(function (e) {
      if (!(e in n)) {
        if (!(e in t)) throw new Error("MobX injector: Store '" + e + "' is not available! Make sure it is provided by some Provider");
        n[e] = t[e];
      }
    }), n;
  };
}

function Gu() {
  var e;
  if ("function" == typeof arguments[0]) return e = arguments[0], function (t) {
    var n = Wu(e, t);
    return n.isMobxInjector = !1, (n = uc(n)).isMobxInjector = !0, n;
  };

  for (var t = [], n = 0; n < arguments.length; n++) {
    t[n] = arguments[n];
  }

  return e = Hu(t), function (n) {
    return Wu(e, n, t.join("-"));
  };
}

var Vu = Fu("isUnmounted"),
    Xu = !1,
    Yu = !1,
    qu = "undefined" != typeof WeakMap ? new WeakMap() : void 0,
    Ku = new Su(),
    Zu = Fu("skipRender"),
    Qu = Fu("isForcingUpdate"),
    Ju = "function" == typeof o && o(function (e, t) {}).$$typeof;

function $u(e, t, n) {
  Object.hasOwnProperty.call(e, t) ? e[t] = n : Object.defineProperty(e, t, {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: n
  });
}

function ec(e) {
  if (f) try {
    return f(e);
  } catch (e) {
    return null;
  }
  return null;
}

function tc(e) {
  var t = ec(e);
  t && qu && qu.set(t, e), Ku.emit({
    event: "render",
    renderTime: e.__$mobRenderEnd - e.__$mobRenderStart,
    totalTime: Date.now() - e.__$mobRenderStart,
    component: e,
    node: t
  });
}

var nc = new Su();

function ic(e, t) {
  !function (e, t) {
    for (var n = zu(e, t), i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), o = 2; o < i; o++) {
      r[o - 2] = arguments[o];
    }

    for (var a = 0; a < r.length; a++) {
      var s = r[a];
      n.methods.indexOf(s) < 0 && n.methods.push(s);
    }

    var l = Object.getOwnPropertyDescriptor(e, t);

    if (!l || !l[Pu]) {
      var u = e[t],
          c = Nu(e, t, l ? l.enumerable : void 0, n, u);
      Object.defineProperty(e, t, c);
    }
  }(e, t, sc[t]);
}

function rc(e, t) {
  if (oc(e, t)) return !0;
  if ("object" !== nu(e) || null === e || "object" !== nu(t) || null === t) return !1;
  var n = Object.keys(e),
      i = Object.keys(t);
  if (n.length !== i.length) return !1;

  for (var r = 0; r < n.length; r++) {
    if (!hasOwnProperty.call(t, n[r]) || !oc(e[n[r]], t[n[r]])) return !1;
  }

  return !0;
}

function oc(e, t) {
  return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
}

function ac(e) {
  var t = this;

  function n() {
    var e = this;
    s = !1;
    var t = void 0,
        n = void 0;
    if (l.track(function () {
      Xu && (e.__$mobRenderStart = Date.now());

      try {
        n = function (e, t) {
          var n,
              i = Ri(e);

          try {
            n = t();
          } finally {
            Ii(i);
          }

          return n;
        }(!1, o);
      } catch (e) {
        t = e;
      }

      Xu && (e.__$mobRenderEnd = Date.now());
    }), t) throw nc.emit(t), t;
    return n;
  }

  var i = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>",
      r = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
  $u(this, Zu, !1), $u(this, Qu, !1);
  var o = e.bind(this),
      s = !1,
      l = new Xi("".concat(i, "#").concat(r, ".render()"), function () {
    if (!s && (s = !0, "function" == typeof t.componentWillReact && t.componentWillReact(), !0 !== t[Vu])) {
      var e = !0;

      try {
        $u(t, Qu, !0), t[Zu] || a.prototype.forceUpdate.call(t), e = !1;
      } finally {
        $u(t, Qu, !1), e && l.dispose();
      }
    }
  });
  return l.reactComponent = this, n.$mobx = l, this.render = n, n.call(this);
}

var sc = {
  componentWillUnmount: function componentWillUnmount() {
    if (this.render.$mobx && this.render.$mobx.dispose(), this[Vu] = !0, Xu) {
      var e = ec(this);
      e && qu && qu.delete(e), Ku.emit({
        event: "destroy",
        component: this,
        node: e
      });
    }
  },
  componentDidMount: function componentDidMount() {
    Xu && tc(this);
  },
  componentDidUpdate: function componentDidUpdate() {
    Xu && tc(this);
  },
  shouldComponentUpdate: function shouldComponentUpdate(e, t) {
    return this.state !== t || !rc(this.props, e);
  }
};

function lc(e, t) {
  var n = Fu("reactProp_".concat(t, "_valueHolder")),
      i = Fu("reactProp_".concat(t, "_atomHolder"));

  function r() {
    return this[i] || $u(this, i, Bn("reactive " + t)), this[i];
  }

  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !0,
    get: function get() {
      return r.call(this).reportObserved(), this[n];
    },
    set: function set(e) {
      this[Qu] || rc(this[n], e) ? $u(this, n, e) : ($u(this, n, e), $u(this, Zu, !0), r.call(this).reportChanged(), $u(this, Zu, !1));
    }
  });
}

function uc(e, t) {
  if ("string" == typeof e) throw new Error("Store names should be provided as array");
  if (Array.isArray(e)) return Yu || (Yu = !0, console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`')), t ? Gu.apply(null, e)(uc(t)) : function (t) {
    return uc(e, t);
  };
  var n = e;

  if (!0 === n.isMobxInjector && console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'"), n.__proto__ === s && console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together"), Ju && n.$$typeof === Ju) {
    var i = n.render;
    if ("function" != typeof i) throw new Error("render property of ForwardRef was not a function");
    return o(function () {
      var e = arguments;
      return r.createElement(cc, null, function () {
        return i.apply(void 0, e);
      });
    });
  }

  if (!("function" != typeof n || n.prototype && n.prototype.render || n.isReactClass || a.isPrototypeOf(n))) {
    var l,
        u,
        c = uc((u = l = function (e) {
      function t() {
        return iu(this, t), cu(this, lu(t).apply(this, arguments));
      }

      return su(t, a), ou(t, [{
        key: "render",
        value: function value() {
          return n.call(this, this.props, this.context);
        }
      }]), t;
    }(), l.displayName = n.displayName || n.name, l.contextTypes = n.contextTypes, l.propTypes = n.propTypes, l.defaultProps = n.defaultProps, u));
    return Tu(c, n), c;
  }

  if (!n) throw new Error("Please pass a valid component to 'observer'");
  var p = n.prototype || n;
  !function (e) {
    ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (t) {
      ic(e, t);
    }), e.shouldComponentUpdate ? e.shouldComponentUpdate !== sc.shouldComponentUpdate && console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.") : e.shouldComponentUpdate = sc.shouldComponentUpdate;
  }(p), n.isMobXReactObserver = !0, lc(p, "props"), lc(p, "state");
  var f = p.render;
  return p.render = function () {
    return ac.call(this, f);
  }, n;
}

var cc = uc(function (e) {
  var t = e.children,
      n = e.inject,
      i = e.render,
      o = t || i;
  if (void 0 === o) return null;
  if (!n) return o();
  console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
  var a = Gu(n)(o);
  return r.createElement(a, null);
});
cc.displayName = "Observer";

var pc = function pc(e, t, n, i, r) {
  var o = "children" === t ? "render" : "children";
  return "function" == typeof e[t] && "function" == typeof e[o] ? new Error("Invalid prop,do not use children and render in the same time in`" + n) : "function" != typeof e[t] && "function" != typeof e[o] ? new Error("Invalid prop `" + r + "` of type `" + nu(e[t]) + "` supplied to `" + n + "`, expected `function`.") : void 0;
};

function fc() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  null != e && this.setState(e);
}

function hc(e) {
  this.setState(function (t) {
    var n = this.constructor.getDerivedStateFromProps(e, t);
    return null != n ? n : null;
  }.bind(this));
}

function dc(e, t) {
  try {
    var n = this.props,
        i = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, i);
  } finally {
    this.props = n, this.state = i;
  }
}

cc.propTypes = {
  render: pc,
  children: pc
}, fc.__suppressDeprecationWarning = !0, hc.__suppressDeprecationWarning = !0, dc.__suppressDeprecationWarning = !0;

var gc = {
  children: !0,
  key: !0,
  ref: !0
},
    mc = function (e) {
  function t(e, n) {
    var i;
    return iu(this, t), (i = cu(this, lu(t).call(this, e, n))).state = {}, yc(e, i.state), i;
  }

  return su(t, a), ou(t, [{
    key: "render",
    value: function value() {
      return u.only(this.props.children);
    }
  }, {
    key: "getChildContext",
    value: function value() {
      var e = {};
      return yc(this.context.mobxStores, e), yc(this.props, e), {
        mobxStores: e
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function value(e, t) {
      if (!e) return null;
      if (!t) return e;
      if (Object.keys(e).filter(_c).length !== Object.keys(t).filter(_c).length && console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children"), !e.suppressChangedStoreWarning) for (var n in e) {
        _c(n) && t[n] !== e[n] && console.warn("MobX Provider: Provided store '" + n + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
      }
      return e;
    }
  }]), t;
}();

function yc(e, t) {
  if (e) for (var n in e) {
    _c(n) && (t[n] = e[n]);
  }
}

function _c(e) {
  return !gc[e] && "suppressChangedStoreWarning" !== e;
}

mc.contextTypes = {
  mobxStores: Iu
}, mc.childContextTypes = {
  mobxStores: Iu.isRequired
}, function (e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
  if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
  var n = null,
      i = null,
      r = null;

  if ("function" == typeof t.componentWillMount ? n = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (n = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? i = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (i = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? r = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (r = "UNSAFE_componentWillUpdate"), null !== n || null !== i || null !== r) {
    var o = e.displayName || e.name,
        a = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + o + " uses " + a + " but also contains the following legacy lifecycles:" + (null !== n ? "\n  " + n : "") + (null !== i ? "\n  " + i : "") + (null !== r ? "\n  " + r : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
  }

  if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = fc, t.componentWillReceiveProps = hc), "function" == typeof t.getSnapshotBeforeUpdate) {
    if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
    t.componentWillUpdate = dc;
    var s = t.componentDidUpdate;

    t.componentDidUpdate = function (e, t, n) {
      var i = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : n;
      s.call(this, e, t, i);
    };
  }
}(mc);
Fu("disposeOnUnmount");
if (!a) throw new Error("mobx-react requires React to be available");
if (!ir) throw new Error("mobx-react requires mobx to be available");

if ("function" == typeof p && function (e) {
  var t = e.enforceActions,
      n = e.computedRequiresReaction,
      i = e.computedConfigurable,
      r = e.disableErrorBoundaries,
      o = e.arrayBuffer,
      a = e.reactionScheduler,
      s = e.reactionRequiresObservable,
      l = e.observableRequiresReaction;

  if (!0 === e.isolateGlobalState && ((Bi.pendingReactions.length || Bi.inBatch || Bi.isRunningReactions) && dn("isolateGlobalState should be called before MobX is running any reactions"), Li = !0, zi && (0 == --fn().__mobxInstanceCount && (fn().__mobxGlobals = void 0), Bi = new Pi())), void 0 !== t) {
    "boolean" != typeof t && "strict" !== t || yn("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
    var u = void 0;

    switch (t) {
      case !0:
      case "observed":
        u = !0;
        break;

      case !1:
      case "never":
        u = !1;
        break;

      case "strict":
      case "always":
        u = "strict";
        break;

      default:
        dn("Invalid value for 'enforceActions': '" + t + "', expected 'never', 'always' or 'observed'");
    }

    Bi.enforceActions = u, Bi.allowStateChanges = !0 !== u && "strict" !== u;
  }

  void 0 !== n && (Bi.computedRequiresReaction = !!n), void 0 !== s && (Bi.reactionRequiresObservable = !!s), void 0 !== l && (Bi.observableRequiresReaction = !!l, Bi.allowStateReads = !Bi.observableRequiresReaction), void 0 !== i && (Bi.computedConfigurable = !!i), void 0 !== r && (!0 === r && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on."), Bi.disableErrorBoundaries = !!r), "number" == typeof o && Hr(o), a && Qi(a);
}({
  reactionScheduler: p
}), "object" === ("undefined" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ ? "undefined" : nu(__MOBX_DEVTOOLS_GLOBAL_HOOK__))) {
  var vc = {
    spy: ir,
    extras: {
      getDebugName: so
    }
  },
      bc = {
    renderReporter: Ku,
    componentByNodeRegistry: qu,
    componentByNodeRegistery: qu,
    trackComponents: function trackComponents() {
      if ("undefined" == typeof WeakMap) throw new Error("[mobx-react] tracking components is not supported in this browser.");
      Xu || (Xu = !0);
    }
  };

  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(bc, vc);
}

var wc,
    xc,
    kc = n(wc || (wc = E(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", ";\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", ";\n  pointer-events: none;\n"])), function (e) {
  return e.theme.measurements.colorItem.size;
}, function (e) {
  return e.theme.measurements.colorItem.size;
}, function (e) {
  return e.theme.colorItem.borderRadius || e.theme.shape.radiusSmall + "px";
}),
    Tc = e.div.attrs(function (e) {
  return {
    style: {
      background: e.color
    }
  };
})(xc || (xc = E(["\n  ", "\n  z-index: ", ";\n"], ["\n  ", "\n  z-index: ", ";\n"])), kc, function (e) {
  return e.theme.measurements.zIndex.colorItem.background;
});
Tc.defaultProps = {
  theme: Xs
};
var Sc,
    Cc = e.div.attrs(function (e) {
  return {
    style: e.url ? {
      backgroundImage: "url(" + e.url + ")"
    } : {}
  };
})(Sc || (Sc = E(["\n  ", "\n  z-index: ", ";\n"], ["\n  ", "\n  z-index: ", ";\n"])), kc, function (e) {
  return e.theme.measurements.zIndex.colorItem.tiledBackground;
});
Cc.defaultProps = {
  theme: Xs
};

var Ec,
    Oc,
    Rc,
    Ic = e.div(Oc || (Oc = E(["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: ", ";\n\n  box-sizing: border-box;\n  border: 2px solid transparent;\n  border-radius: ", ";\n  transition: border-color 300ms ease-in-out;\n  ", "\n"], ["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: ", ";\n\n  box-sizing: border-box;\n  border: 2px solid transparent;\n  border-radius: ", ";\n  transition: border-color 300ms ease-in-out;\n  ", "\n"])), kc, function (e) {
  return e.theme.measurements.zIndex.colorItem.overlay;
}, function (e) {
  return e.theme.colorItem.borderRadius || e.theme.shape.radiusSmall + "px";
}, function (e) {
  return e.isActive && n(Ec || (Ec = E(["\n      border-color: ", ";\n    "], ["\n      border-color: ", ";\n    "])), e.theme.selectColor.activeBorderColor);
}),
    Ac = e.span(Rc || (Rc = E(["\n  display: inline-block;\n  height: 2px;\n  width: 2px;\n  border-radius: 50%;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.6);\n  background: rgba(255, 255, 255, 0.87);\n  margin: 1px;\n  pointer-events: none;\n"], ["\n  display: inline-block;\n  height: 2px;\n  width: 2px;\n  border-radius: 50%;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.6);\n  background: rgba(255, 255, 255, 0.87);\n  margin: 1px;\n  pointer-events: none;\n"]))),
    Mc = function Mc(e) {
  var t = e.isActive,
      n = e.className,
      i = e.style;
  return r.createElement(Ic, {
    isActive: t,
    className: n,
    style: i
  }, t && r.createElement(r.Fragment, null, r.createElement(Ac, null), r.createElement(Ac, null), r.createElement(Ac, null)));
};

Ic.defaultProps = {
  theme: Xs
};

var Fc,
    Dc,
    Pc,
    zc,
    Lc,
    Bc,
    Nc,
    Uc,
    jc,
    Wc,
    Hc,
    Gc,
    Vc,
    Xc,
    Yc,
    qc,
    Kc,
    Zc,
    Qc,
    Jc,
    $c,
    ep,
    tp,
    np,
    ip,
    rp,
    op,
    ap,
    sp,
    lp,
    up,
    cp,
    pp,
    fp,
    hp,
    dp = n(Fc || (Fc = E(["\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 2px ", ";\n  }\n  &:-moz-focusring {\n    outline: none;\n    box-shadow: 0 0 2px ", ";\n  }\n"], ["\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 2px ", ";\n  }\n  &:-moz-focusring {\n    outline: none;\n    box-shadow: 0 0 2px ", ";\n  }\n"])), function (e) {
  return e.theme.focusOutlineColor;
}, function (e) {
  return e.theme.focusOutlineColor;
}),
    gp = n(Dc || (Dc = E(["\n  position: absolute !important;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */\n  clip: rect(1px, 1px, 1px, 1px);\n"], ["\n  position: absolute !important;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */\n  clip: rect(1px, 1px, 1px, 1px);\n"]))),
    mp = n(Pc || (Pc = E(["\n  -webkit-overflow-scrolling: touch;\n  &::-webkit-scrollbar {\n    display: none;\n    /* Safari */\n    -webkit-appearance: none; /* stylelint-disable-line */\n    width: 0;\n    height: 0;\n  }\n  -ms-overflow-style: none; /* IE 11 */\n  scrollbar-width: none; /* Firefox 64 */\n"], ["\n  -webkit-overflow-scrolling: touch;\n  &::-webkit-scrollbar {\n    display: none;\n    /* Safari */\n    -webkit-appearance: none; /* stylelint-disable-line */\n    width: 0;\n    height: 0;\n  }\n  -ms-overflow-style: none; /* IE 11 */\n  scrollbar-width: none; /* Firefox 64 */\n"]))),
    yp = t(zc || (zc = E(["\nfrom {\n  opacity: 1;\n  transform: scale(0);\n}\nto {\n  opacity: 0;\n  transform: scale(10);\n}\n"], ["\nfrom {\n  opacity: 1;\n  transform: scale(0);\n}\nto {\n  opacity: 0;\n  transform: scale(10);\n}\n"]))),
    _p = t(Lc || (Lc = E(["\n  0% {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n"]))),
    vp = t(Bc || (Bc = E(["\n  0% {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n"]))),
    bp = e.span(Nc || (Nc = E(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"]))),
    wp = e(bp)(Uc || (Uc = E([""], [""]))),
    xp = e(bp)(jc || (jc = E([""], [""]))),
    kp = e(bp)(Wc || (Wc = E([""], [""]))),
    Tp = {
  display: "none",
  left: 0,
  top: 0
},
    Sp = e(bp)(Hc || (Hc = E(["\n  display: ", ";\n  left: ", "px;\n  top: ", "px;\n  pointer-events: none;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.12);\n  animation: ", " 1.2s;\n  width: 100px;\n  height: 100px;\n  margin-top: -50px;\n  margin-left: -50px;\n  opacity: 0;\n"], ["\n  display: ", ";\n  left: ", "px;\n  top: ", "px;\n  pointer-events: none;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.12);\n  animation: ", " 1.2s;\n  width: 100px;\n  height: 100px;\n  margin-top: -50px;\n  margin-left: -50px;\n  opacity: 0;\n"])), function (e) {
  return e.display;
}, function (e) {
  return e.left;
}, function (e) {
  return e.top;
}, yp),
    Cp = n(Gc || (Gc = E(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (e) {
  return e.theme.button.activeForeground;
}),
    Ep = e.button(Vc || (Vc = E(["\n  &&& {\n    box-sizing: border-box;\n  }\n  text-align: center;\n  position: relative;\n  padding: 4px 8px;\n  min-height: 32px;\n  border-radius: ", "px;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  font-family: ", ", sans-serif;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  overflow: hidden;\n  ", "\n\n  /* Active */\n\n  &:active {\n    ", "\n  }\n\n  ", "\n\n  /* Disabled */\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  /* Hover */\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"], ["\n  &&& {\n    box-sizing: border-box;\n  }\n  text-align: center;\n  position: relative;\n  padding: 4px 8px;\n  min-height: 32px;\n  border-radius: ", "px;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  font-family: ", ", sans-serif;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  overflow: hidden;\n  ", "\n\n  /* Active */\n\n  &:active {\n    ", "\n  }\n\n  ", "\n\n  /* Disabled */\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  /* Hover */\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"])), function (e) {
  return e.theme.shape.radiusMedium;
}, function (e) {
  return e.theme.measurements.fontSystem.button1.size;
}, function (e) {
  return e.theme.measurements.fontSystem.button1.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.button1.case;
}, function (e) {
  return e.theme.typography.fontFamily;
}, dp, Cp, function (e) {
  return e.isActive && Cp;
}, xp, function (e) {
  return e.theme.button.outlinedInactiveOverlayColor;
}, kp, function (e) {
  return e.theme.button.hoverOverlayColor;
}),
    Op = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = Tp, t.timeout = null, t.onClick = function (e) {
      var n = e.currentTarget.getBoundingClientRect(),
          i = e.pageX - n.left,
          r = e.pageY - n.top;
      "block" === t.state.display ? t.setState({
        display: "none"
      }, function () {
        t.setRippleState(i, r);
      }) : t.setRippleState(i, r), t.props.onClick(e);
    }, t.setRippleState = function (e, n) {
      t.setState({
        left: e,
        top: n,
        display: "block"
      }), t.timeout = setTimeout(function () {
        t.setState({
          display: "none"
        });
      }, 1200);
    }, t;
  }

  return _(t, e), t.prototype.componentWillUnmount = function () {
    clearTimeout(this.timeout);
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.isActive,
        n = e.isDisabled,
        i = e.label,
        o = e.ariaLabel,
        a = e.children,
        s = e.className,
        l = b(e, ["isActive", "isDisabled", "label", "ariaLabel", "children", "className"]),
        u = this.state,
        c = u.left,
        p = u.top,
        f = u.display;
    return r.createElement(Ep, _v2({
      "data-test-id": o,
      className: s,
      isActive: t,
      disabled: n,
      "aria-label": o
    }, l, {
      onClick: this.onClick
    }), i, a, r.createElement(Sp, {
      display: f,
      left: c,
      top: p
    }), r.createElement(xp, null), r.createElement(kp, null));
  }, t.defaultProps = {
    type: "button",
    isDisabled: !1,
    isActive: !1
  }, t;
}(r.Component),
    Rp = e(Op)(Yc || (Yc = E(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
  return e.fullWidth && n(Xc || (Xc = E(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
}),
    Ip = e.div(qc || (qc = E(["\n  &:focus {\n    outline: none;\n  }\n\n  > img {\n    height: 18px;\n    width: 18px;\n  }\n\n  > svg {\n    height: 18px;\n    width: 18px;\n  }\n  display: none;\n\n  @media all and (min-width: 0) and (max-width: 599px) {\n    display: flex;\n  }\n"], ["\n  &:focus {\n    outline: none;\n  }\n\n  > img {\n    height: 18px;\n    width: 18px;\n  }\n\n  > svg {\n    height: 18px;\n    width: 18px;\n  }\n  display: none;\n\n  @media all and (min-width: 0) and (max-width: 599px) {\n    display: flex;\n  }\n"]))),
    Ap = e.div(Zc || (Zc = E(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"])), function (e) {
  return e.hasIcon && n(Kc || (Kc = E(["\n      @media all and (min-width: 0) and (max-width: 599px) {\n        display: none;\n      }\n    "], ["\n      @media all and (min-width: 0) and (max-width: 599px) {\n        display: none;\n      }\n    "])));
}),
    Mp = function Mp(e) {
  var t = e.label,
      n = e.children,
      i = e.icon,
      o = e.fullWidth,
      a = b(e, ["label", "children", "icon", "fullWidth"]),
      s = r.createElement(Ap, {
    hasIcon: !!i
  }, t, n);
  return r.createElement(Rp, _v2({
    fullWidth: o
  }, a), i && r.createElement(Ip, null, i), (n || t) && s);
},
    Fp = e(Mp)(Qc || (Qc = E(["\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  font-size: ", "px;\n  min-width: 32px;\n"], ["\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  font-size: ", "px;\n  min-width: 32px;\n"])), function (e) {
  return e.theme.button.outlinedPrimaryBackground;
}, function (e) {
  return e.theme.button.outlinedPrimaryForeground;
}, function (e) {
  return e.theme.button.outlinedBorderColor;
}, function (e) {
  return e.theme.measurements.fontSystem.button1.size;
}),
    Dp = e(Op)(Jc || (Jc = E(["\n  color: ", ";\n  font-size: ", "px;\n\n  /* Repeat active styles so they are not overwritten */\n  ", "\n\n  ", " {\n    display: none;\n  }\n\n  &:disabled {\n    opacity: ", ";\n  }\n"], ["\n  color: ", ";\n  font-size: ", "px;\n\n  /* Repeat active styles so they are not overwritten */\n  ", "\n\n  ", " {\n    display: none;\n  }\n\n  &:disabled {\n    opacity: ", ";\n  }\n"])), function (e) {
  return e.theme.button.textSecondaryForeground;
}, function (e) {
  return e.theme.measurements.fontSystem.button1.size;
}, function (e) {
  return e.isActive && Cp;
}, xp, function (e) {
  return e.theme.button.textInactiveOpacity;
}),
    Pp = e(Mp)($c || ($c = E(["\n  &&& {\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    font-size: ", "px;\n  }\n"], ["\n  &&& {\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    font-size: ", "px;\n  }\n"])), function (e) {
  return e.theme.button.outlinedSecondaryBackground;
}, function (e) {
  return e.theme.button.outlinedSecondaryForeground;
}, function (e) {
  return e.theme.button.outlinedBorderColor;
}, function (e) {
  return e.theme.measurements.fontSystem.button1.size;
}),
    zp = e(Op)(ep || (ep = E(["\n  color: ", ";\n  /* Repeat active styles so they are not overwritten */\n  ", "\n\n  ", " {\n    display: none;\n  }\n\n  &:disabled {\n    opacity: ", ";\n  }\n"], ["\n  color: ", ";\n  /* Repeat active styles so they are not overwritten */\n  ", "\n\n  ", " {\n    display: none;\n  }\n\n  &:disabled {\n    opacity: ", ";\n  }\n"])), function (e) {
  return e.theme.foreground;
}, function (e) {
  return e.isActive && Cp;
}, xp, function (e) {
  return e.theme.button.textInactiveOpacity;
}),
    Lp = e.div(tp || (tp = E(["\n  display: flex;\n  &:focus {\n    outline: none;\n  }\n"], ["\n  display: flex;\n  &:focus {\n    outline: none;\n  }\n"]))),
    Bp = function Bp(e) {
  e.label;
  var t = e.icon,
      n = (e.children, b(e, ["label", "icon", "children"]));
  return r.createElement(zp, _v2({}, n), r.createElement(Lp, null, t));
},
    Np = e(Mp)(np || (np = E(["\n  &&& {\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    font-size: ", "px;\n\n    &:active {\n      color: ", ";\n    }\n  }\n"], ["\n  &&& {\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    font-size: ", "px;\n\n    &:active {\n      color: ", ";\n    }\n  }\n"])), function (e) {
  return e.theme.button.containedPrimaryBackground;
}, function (e) {
  return e.theme.button.containedPrimaryForeground;
}, function (e) {
  return e.theme.button.containedPrimaryBackground;
}, function (e) {
  return e.theme.measurements.fontSystem.button1.size;
}, function (e) {
  return e.theme.button.containedPrimaryForeground;
}),
    Up = n(rp || (rp = E(["\n  border: 1px solid ", ";\n  ", " {\n    background-color: ", ";\n  }\n"], ["\n  border: 1px solid ", ";\n  ", " {\n    background-color: ", ";\n  }\n"])), function (e) {
  return e.theme.card.activeBorderColor;
}, wp, function (e) {
  return e.theme.card.activeOverlayColor;
}),
    jp = e.button.attrs(function (e) {
  var t = {};
  return e.image && (t.backgroundImage = "url(" + e.image + ")"), {
    style: t
  };
})(op || (op = E(["\n  &&& {\n    box-sizing: border-box;\n  }\n\n  padding: 0;\n  cursor: pointer;\n  /* Safari will change the height of the toolbar and position the category cards at the bottom for some reason */\n  vertical-align: top;\n  border: none;\n  box-sizing: border-box;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  ", ";\n  animation-fill-mode: both;\n  overflow: hidden;\n\n  ", "\n\n  /* Active */\n\n  /* No :active styles on purpose. */\n\n  ", "\n\n  /* Disabled */\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  /* Hover */\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"], ["\n  &&& {\n    box-sizing: border-box;\n  }\n\n  padding: 0;\n  cursor: pointer;\n  /* Safari will change the height of the toolbar and position the category cards at the bottom for some reason */\n  vertical-align: top;\n  border: none;\n  box-sizing: border-box;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  ", ";\n  animation-fill-mode: both;\n  overflow: hidden;\n\n  ", "\n\n  /* Active */\n\n  /* No :active styles on purpose. */\n\n  ", "\n\n  /* Disabled */\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  /* Hover */\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"])), function (e) {
  return e.theme.card.background;
}, function (e) {
  return e.theme.card.foreground;
}, function (e) {
  return e.theme.shape.radiusMedium;
}, function () {
  return n(ip || (ip = E(["\n    animation: ", " 0.2s linear;\n  "], ["\n    animation: ", " 0.2s linear;\n  "])), vp);
}, dp, function (e) {
  return e.isActive && Up;
}, xp, function (e) {
  return e.theme.card.inactiveOverlayColor;
}, kp, function (e) {
  return e.theme.card.hoverOverlayColor;
}),
    Wp = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = Tp, t.timeout = null, t.onKeyDown = function (e) {
      "Space" !== e.key && "Enter" !== e.key || t.props.onClick && t.props.onClick();
    }, t.onClick = function (e) {
      var n = e.currentTarget.getBoundingClientRect(),
          i = e.pageX - n.left,
          r = e.pageY - n.top;
      "block" === t.state.display ? t.setState({
        display: "none"
      }, function () {
        t.setRippleState(i, r);
      }) : t.setRippleState(i, r), t.props.onClick(e);
    }, t.setRippleState = function (e, n) {
      t.setState({
        left: e,
        top: n,
        display: "block"
      }), t.timeout = setTimeout(function () {
        t.setState({
          display: "none"
        });
      }, 1200);
    }, t;
  }

  return _(t, e), t.prototype.componentWillUnmount = function () {
    clearTimeout(this.timeout);
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.children,
        n = e.label,
        i = e.isActive,
        o = e.isDisabled,
        a = e.image,
        s = e.style,
        l = e.className,
        u = this.state,
        c = u.left,
        p = u.top,
        f = u.display;
    return r.createElement(jp, {
      isActive: i,
      "data-test-id": n,
      "aria-label": n,
      disabled: o,
      image: a,
      onClick: this.onClick,
      onKeyDown: this.onKeyDown,
      style: s,
      className: l
    }, t, r.createElement(Sp, {
      display: f,
      left: c,
      top: p
    }), r.createElement(wp, null), r.createElement(xp, null), r.createElement(kp, null));
  }, t;
}(r.Component),
    Hp = e.div(ap || (ap = E(["\n  &&& {\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    left: 50%;\n    position: absolute;\n    transform: translateX(-50%);\n    top: 13px;\n    width: 100%;\n  }\n"], ["\n  &&& {\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    left: 50%;\n    position: absolute;\n    transform: translateX(-50%);\n    top: 13px;\n    width: 100%;\n  }\n"])), function (e) {
  return e.theme.measurements.fontSystem.label.size;
}, function (e) {
  return e.theme.measurements.fontSystem.label.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.label.case;
}),
    Gp = e.div(up || (up = E(["\n  position: absolute;\n  bottom: 0px;\n  border-radius: ", "px;\n  left: 0;\n  ", "\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  bottom: 0px;\n  border-radius: ", "px;\n  left: 0;\n  ", "\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n"])), function (e) {
  return e.theme.shape.radiusMedium;
}, function (e) {
  return e.withBackground ? n(sp || (sp = E(["\n          color: ", ";\n          height: 40px;\n          background: ", ";\n        "], ["\n          color: ", ";\n          height: 40px;\n          background: ", ";\n        "])), e.theme.card.labelForeground, e.theme.card.labelBackground) : n(lp || (lp = E(["\n          color: ", ";\n          height: 32px;\n        "], ["\n          color: ", ";\n          height: 32px;\n        "])), e.theme.card.foreground);
}),
    Vp = e.div(cp || (cp = E(["\n  position: absolute;\n  top: 6px;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid ", ";\n  transform: rotate(", "deg);\n  display: inline-block;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in;\n"], ["\n  position: absolute;\n  top: 6px;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid ", ";\n  transform: rotate(", "deg);\n  display: inline-block;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in;\n"])), function (e) {
  return e.theme.card.labelForeground;
}, function (e) {
  return e.rotation || 0;
}),
    Xp = e.span(pp || (pp = E(["\n  position: relative;\n  padding-left: 10px;\n"], ["\n  position: relative;\n  padding-left: 10px;\n"]))),
    Yp = e.div(fp || (fp = E(["\n  ", "\n"], ["\n  ", "\n"])), gp),
    qp = function qp(e) {
  var t = e.children,
      n = e.className,
      i = e.caret,
      o = e.isActive,
      a = e.style,
      s = e.withBackground;
  if (e.hidden) return r.createElement(Yp, null, t);
  return r.createElement(Gp, {
    className: n,
    withBackground: s,
    style: a
  }, r.createElement(Hp, null, t, i && r.createElement(Xp, null, r.createElement(Vp, {
    "aria-hidden": !0,
    rotation: o ? 180 : 0
  }))));
},
    Kp = {
  Focused: dp,
  HiddenScrollbar: mp,
  VisuallyHidden: gp
},
    Zp = {
  ripple: yp,
  scale: _p,
  slide: vp
},
    Qp = e.button.attrs({
  type: "button"
})(hp || (hp = E(["\n  &&& {\n    box-sizing: border-box;\n  }\n  position: relative;\n  background: transparent;\n  border: none;\n  height: ", "px;\n  width: ", "px;\n  margin: ", ";\n  padding: 0;\n  cursor: pointer;\n  border-radius: ", ";\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  ", "\n\n  &:disabled {\n    opacity: ", ";\n    cursor: default;\n  }\n"], ["\n  &&& {\n    box-sizing: border-box;\n  }\n  position: relative;\n  background: transparent;\n  border: none;\n  height: ", "px;\n  width: ", "px;\n  margin: ", ";\n  padding: 0;\n  cursor: pointer;\n  border-radius: ", ";\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  ", "\n\n  &:disabled {\n    opacity: ", ";\n    cursor: default;\n  }\n"])), function (e) {
  return e.theme.measurements.colorItem.size;
}, function (e) {
  return e.theme.measurements.colorItem.size;
}, function (e) {
  return e.theme.colorItem.margin;
}, function (e) {
  return e.theme.colorItem.borderRadius || e.theme.shape.radiusSmall + "px";
}, Kp.Focused, function (e) {
  return e.theme.selectColor.inactiveOpacity;
});

Qp.defaultProps = {
  theme: Xs
};
var Jp,
    $p,
    ef = Gu("config")(uc(function (e) {
  var t = e.isActive,
      n = e.onClick,
      i = e.color,
      o = e.label,
      a = e.isDisabled,
      s = e.tiledBackgroundUrl,
      l = e.className,
      u = e.style,
      c = e.children;
  return r.createElement(Qp, {
    disabled: a,
    onClick: n,
    "aria-label": o,
    className: l,
    style: u
  }, r.createElement(Cc, {
    url: s
  }), r.createElement(Tc, {
    color: i
  }), r.createElement(Mc, {
    isActive: t
  }), c);
})),
    tf = n(Jp || (Jp = E(["\n  opacity: 1;\n  visibility: visible;\n  display: block;\n"], ["\n  opacity: 1;\n  visibility: visible;\n  display: block;\n"]))),
    nf = e.div($p || ($p = E(["\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: ", ";\n  text-align: left;\n  background: ", ";\n  transition: opacity 0.25s ease;\n  display: none;\n  height: 100%;\n  width: 100%;\n  ", "\n"], ["\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: ", ";\n  text-align: left;\n  background: ", ";\n  transition: opacity 0.25s ease;\n  display: none;\n  height: 100%;\n  width: 100%;\n  ", "\n"])), function (e) {
  return e.theme.measurements.zIndex.modal.backdrop;
}, function (e) {
  return e.theme.modal.backdrop;
}, function (e) {
  return e.show && tf;
});
nf.defaultProps = {
  theme: Xs
};

var rf,
    of,
    af,
    sf = e.div(rf || (rf = E(["\n  position: relative;\n  height: inherit;\n  width: inherit;\n"], ["\n  position: relative;\n  height: inherit;\n  width: inherit;\n"]))),
    lf = e.div.attrs(function (e) {
  return {
    role: "dialog",
    "aria-hidden": !1,
    "aria-labelledby": e.heading
  };
})(of || (of = E(["\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  transition: top 0.25s ease;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  transform: translate(-50%, -50%);\n  border-radius: ", "px;\n  background: ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  transition: top 0.25s ease;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  transform: translate(-50%, -50%);\n  border-radius: ", "px;\n  background: ", ";\n  color: ", ";\n"])), function (e) {
  return e.y;
}, function (e) {
  return e.x;
}, function (e) {
  return e.width;
}, function (e) {
  return e.height;
}, function (e) {
  return e.theme.shape.radiusLarge;
}, function (e) {
  return e.theme.modal.background;
}, function (e) {
  return e.theme.modal.bodyForeground;
}),
    uf = e.div(af || (af = E(["\n  &&& {\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: row;\n    overflow: hidden;\n    width: inherit;\n    padding: 11px 20px;\n    box-sizing: border-box;\n  }\n"], ["\n  &&& {\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: row;\n    overflow: hidden;\n    width: inherit;\n    padding: 11px 20px;\n    box-sizing: border-box;\n  }\n"]))),
    cf = function cf(e) {
  var t = e.show,
      n = e.height,
      i = e.width,
      o = e.position,
      a = e.children,
      s = e.footer,
      l = e.heading,
      u = e.className,
      c = o ? {
    x: "calc(50% + " + o.x + "px)",
    y: "calc(50% + " + o.y + "px)"
  } : {
    x: "50%",
    y: "50%"
  },
      p = c.x,
      f = c.y;
  return r.createElement(nf, {
    show: t,
    className: u
  }, r.createElement(sf, null, r.createElement(lf, {
    heading: l,
    x: p,
    y: f,
    height: n,
    width: i
  }, r.createElement(uf, null, a), s && s())));
};

lf.defaultProps = {
  theme: Xs
};

var pf,
    ff,
    hf,
    df,
    gf,
    mf,
    yf,
    _f = t(pf || (pf = E(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]))),
    vf = n(ff || (ff = E(["\n  animation: ", " 2s infinite ease 1.5s;\n"], ["\n  animation: ", " 2s infinite ease 1.5s;\n"])), _f),
    bf = n(hf || (hf = E(["\n  animation: ", " 2s infinite ease;\n"], ["\n  animation: ", " 2s infinite ease;\n"])), _f),
    wf = e.div(df || (df = E(["\n  margin-left: 30px;\n  h3 {\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    color: ", ";\n  }\n  p {\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    color: ", ";\n  }\n"], ["\n  margin-left: 30px;\n  h3 {\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    color: ", ";\n  }\n  p {\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    color: ", ";\n  }\n"])), function (e) {
  return e.theme.measurements.fontSystem.headline2.size;
}, function (e) {
  return e.theme.measurements.fontSystem.headline2.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.body.case;
}, function (e) {
  return e.theme.modal.headerForeground;
}, function (e) {
  return e.theme.measurements.fontSystem.label.size;
}, function (e) {
  return e.theme.measurements.fontSystem.label.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.label.case;
}, function (e) {
  return e.theme.modal.bodyForeground;
}),
    xf = (e.div(gf || (gf = E(["\n  height: 4px;\n  padding: 0;\n  margin: 0;\n  background: rgba(54, 90, 252, 0.5);\n  &:after {\n    position: absolute;\n    bottom: 0px;\n    content: '';\n    width: ", "%;\n    border-bottom: 4px solid ", ";\n  }\n"], ["\n  height: 4px;\n  padding: 0;\n  margin: 0;\n  background: rgba(54, 90, 252, 0.5);\n  &:after {\n    position: absolute;\n    bottom: 0px;\n    content: '';\n    width: ", "%;\n    border-bottom: 4px solid ", ";\n  }\n"])), function (e) {
  return e.percentage;
}, function (e) {
  return e.theme.primary;
}), e.div(mf || (mf = E(["\n  color: ", ";\n  margin: 12px 0;\n  position: relative;\n  width: 40px;\n  height: 40px;\n  box-shadow: inset 0 0 0 2px;\n  transform: translateZ(0);\n  border-radius: 50%;\n  &:before,\n  &:after {\n    border-radius: 50%;\n    position: absolute;\n    content: '';\n  }\n  &:before {\n    width: 25px;\n    height: 45px;\n    background: ", ";\n    border-radius: 45px 0 0 45px;\n    top: -2.5px;\n    left: -2.5px;\n    transform-origin: 25px 25px;\n    ", ";\n  }\n  &:after {\n    width: 25px;\n    height: 45px;\n    background: ", ";\n    border-radius: 0 45px 45px 0;\n    top: -2.5px;\n    left: 25px;\n    transform-origin: 0px 25px;\n    ", ";\n  }\n"], ["\n  color: ", ";\n  margin: 12px 0;\n  position: relative;\n  width: 40px;\n  height: 40px;\n  box-shadow: inset 0 0 0 2px;\n  transform: translateZ(0);\n  border-radius: 50%;\n  &:before,\n  &:after {\n    border-radius: 50%;\n    position: absolute;\n    content: '';\n  }\n  &:before {\n    width: 25px;\n    height: 45px;\n    background: ", ";\n    border-radius: 45px 0 0 45px;\n    top: -2.5px;\n    left: -2.5px;\n    transform-origin: 25px 25px;\n    ", ";\n  }\n  &:after {\n    width: 25px;\n    height: 45px;\n    background: ", ";\n    border-radius: 0 45px 45px 0;\n    top: -2.5px;\n    left: 25px;\n    transform-origin: 0px 25px;\n    ", ";\n  }\n"])), function (e) {
  return e.theme.primary;
}, function (e) {
  return e.theme.modal.background;
}, vf, function (e) {
  return e.theme.modal.background;
}, bf)),
    kf = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return _(t, e), t.prototype.render = function () {
    var e = this.props,
        t = e.show,
        n = e.heading,
        i = e.body,
        o = e.position,
        a = e.className;
    return r.createElement(cf, {
      show: t,
      position: o,
      height: "90px",
      width: "350px",
      className: a
    }, r.createElement(xf, null), r.createElement(wf, null, r.createElement("h3", null, n), r.createElement("p", null, i)));
  }, t.defaultProps = {
    position: {
      x: 0,
      y: 0
    }
  }, t;
}(r.PureComponent),
    Tf = e.div(yf || (yf = E(["\n  padding-bottom: ", "px;\n"], ["\n  padding-bottom: ", "px;\n"])), function (e) {
  return 8 * (e.count || 1);
});

Tf.defaultProps = {
  count: 1
};

var Sf,
    Cf,
    Ef,
    Of = e.label(Sf || (Sf = E(["\n  ", "\n"], ["\n  ", "\n"])), Kp.VisuallyHidden),
    Rf = e.label(Ef || (Ef = E(["\n  &&& {\n    display: block;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    color: ", ";\n    margin: 0;\n\n    ", "\n  }\n"], ["\n  &&& {\n    display: block;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    color: ", ";\n    margin: 0;\n\n    ", "\n  }\n"])), function (e) {
  return e.theme.measurements.fontSystem.body.size;
}, function (e) {
  return e.theme.measurements.fontSystem.body.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.body.case;
}, function (e) {
  return e.theme.toolControlBar.inputLabelForeground;
}, function (e) {
  return e.isDisabled && n(Cf || (Cf = E(["\n        opacity: ", ";\n        cursor: default;\n        pointer-events: none;\n      "], ["\n        opacity: ", ";\n        cursor: default;\n        pointer-events: none;\n      "])), function (e) {
    return e.theme.toolControlBar.inputLabelInactiveOpacity;
  });
}),
    If = function If(e) {
  var t = e.label,
      n = e.htmlFor,
      i = e.show,
      o = e.style,
      a = e.isDisabled,
      s = e.className,
      l = i ? Rf : Of,
      u = n || (t ? t.replace(" ", "-") : void 0);
  return r.createElement(l, {
    style: o,
    isDisabled: a,
    htmlFor: u,
    className: s
  }, t);
};

If.defaultProps = {
  show: !0
}, Rf.defaultProps = {
  theme: Xs
};

var Af,
    Mf,
    Ff,
    Df = n(Af || (Af = E(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  width: 100%;\n  height: 26px;\n  color: ", ";\n  padding-bottom: 7px;\n  border: none;\n  appearance: none;\n  border-bottom: 1px solid ", ";\n  background: ", ";\n  font-family: '", "', sans-serif;\n  transition: border-color 0.4s ease-in-out;\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:-moz-focusring {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:disabled {\n    opacity: ", ";\n    pointer-events: none;\n  }\n\n  &:hover {\n    border-color: ", ";\n  }\n"], ["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  width: 100%;\n  height: 26px;\n  color: ", ";\n  padding-bottom: 7px;\n  border: none;\n  appearance: none;\n  border-bottom: 1px solid ", ";\n  background: ", ";\n  font-family: '", "', sans-serif;\n  transition: border-color 0.4s ease-in-out;\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:-moz-focusring {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:disabled {\n    opacity: ", ";\n    pointer-events: none;\n  }\n\n  &:hover {\n    border-color: ", ";\n  }\n"])), function (e) {
  return e.theme.measurements.fontSystem.body.size;
}, function (e) {
  return e.theme.measurements.fontSystem.body.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.body.case;
}, function (e) {
  return e.theme.textInput.foreground;
}, function (e) {
  return e.theme.textInput.borderColor;
}, function (e) {
  return e.theme.textInput.background;
}, function (e) {
  return e.theme.typography.fontFamily;
}, function (e) {
  return e.theme.textInput.hoverBorderColor;
}, function (e) {
  return e.theme.textInput.hoverBorderColor;
}, function (e) {
  return e.theme.textInput.inactiveOpacity;
}, function (e) {
  return e.theme.textInput.hoverBorderColor;
}),
    Pf = e.input(Mf || (Mf = E(["\n  ", "\n  /* override user agent style */\n  padding: 0;\n  &:disabled {\n    opacity: ", ";\n    cursor: default;\n    pointer-events: none;\n  }\n"], ["\n  ", "\n  /* override user agent style */\n  padding: 0;\n  &:disabled {\n    opacity: ", ";\n    cursor: default;\n    pointer-events: none;\n  }\n"])), Df, function (e) {
  return e.theme.textInput.inactiveOpacity;
}),
    zf = e.div(Ff || (Ff = E(["\n  position: relative;\n  &:first-child {\n    margin-right: 15px;\n  }\n"], ["\n  position: relative;\n  &:first-child {\n    margin-right: 15px;\n  }\n"]))),
    Lf = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.onChange = function (e) {
      var n = t.props.onChange;
      n && n(e.target.value);
    }, t;
  }

  return _(t, e), t.prototype.render = function () {
    var e = this.props,
        t = e.id,
        n = e.testId,
        i = e.value,
        o = e.type,
        a = e.min,
        s = e.max,
        l = e.onBlur,
        u = e.onFocus,
        c = e.onKeyUp,
        p = e.onKeyDown,
        f = e.onMouseUp,
        h = e.onTouchEnd,
        d = e.isDisabled,
        g = e.className,
        m = e.children;
    return r.createElement(zf, {
      className: g
    }, r.createElement(Pf, {
      id: t,
      "data-test-id": n,
      "aria-hidden": d,
      disabled: d,
      value: i,
      type: o,
      min: a,
      max: s,
      onChange: this.onChange,
      onBlur: l,
      onFocus: u,
      onKeyUp: c,
      onKeyDown: p,
      onMouseUp: f,
      onTouchEnd: h
    }), m);
  }, t.defaultProps = {
    type: "text"
  }, t;
}(r.Component);

Pf.defaultProps = {
  theme: Xs
};

var Bf,
    Nf,
    Uf,
    jf,
    Wf,
    Hf,
    Gf,
    Vf,
    Xf,
    Yf = e.div(Uf || (Uf = E(["\n  ", "\n"], ["\n  ", "\n"])), Ze() ? n(Bf || (Bf = E([""], [""]))) : n(Nf || (Nf = E(["\n        display: flex;\n        flex: 0 1 auto;\n        flex-direction: column;\n      "], ["\n        display: flex;\n        flex: 0 1 auto;\n        flex-direction: column;\n      "])))),
    qf = function (e) {
  function t(n) {
    var i = e.call(this, n) || this;
    return i.node = null, i.handleOutsideClick = function (e) {
      var t = i.props.value;
      i.node && i.node.current && i.node.current.contains(e.target) || i.setState({
        isActive: !1,
        value: t
      });
    }, i.onSubmit = function () {
      var e = i.props.onSubmit,
          n = i.state.value;

      if (e) {
        var r = parseFloat(t.cleanValue(n));
        Number.isNaN(r) || e("" + r);
      }

      i.setState({
        isActive: !1
      });
    }, i.onFocus = function () {
      i.setState({
        isActive: !0
      });
    }, i.onKeyDown = function (e) {
      var n = i.state.value;
      if ("Enter" === e.key) i.onSubmit();else if ("ArrowUp" === e.key) {
        "number" == typeof (r = parseFloat(t.cleanValue(n))) && i.setState({
          value: (r + 1).toString(),
          isActive: !0
        });
      } else if ("ArrowDown" === e.key) {
        var r;
        "number" == typeof (r = parseFloat(t.cleanValue(n))) && i.setState({
          value: (r - 1).toString(),
          isActive: !0
        });
      }
    }, i.onChange = function (e) {
      i.setState({
        value: e,
        isActive: !0
      });
    }, i.state = {
      value: i.props.value || "",
      isActive: !1
    }, i.node = r.createRef(), document.addEventListener("mousedown", i.handleOutsideClick, !1), document.addEventListener("touchstart", i.handleOutsideClick, !1), i;
  }

  return _(t, e), t.getDerivedStateFromProps = function (e, t) {
    var n = e.value,
        i = t.value,
        r = t.isActive;
    return n === i || r ? null : {
      value: n
    };
  }, t.cleanValue = function (e) {
    return e ? e.replace(",", ".").replace(/[a-zA-Z]/g, "").trim() : "";
  }, t.prototype.componentWillUnmount = function () {
    document.removeEventListener("mousedown", this.handleOutsideClick, !1), document.removeEventListener("touchstart", this.handleOutsideClick, !1);
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.id,
        n = e.label,
        i = e.isDisabled,
        o = e.ariaHidden,
        a = e.onMouseUp,
        s = e.onTouchEnd,
        l = e.className,
        u = this.state.value;
    return r.createElement(Yf, {
      ref: this.node,
      className: l
    }, r.createElement(If, {
      htmlFor: t,
      label: n,
      show: !!n,
      isDisabled: i
    }), !!n && r.createElement(Tf, null), r.createElement(Lf, {
      id: t,
      value: u,
      isDisabled: i,
      "aria-hidden": o,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onBlur: this.handleOutsideClick,
      onFocus: this.onFocus,
      onMouseUp: a,
      onTouchEnd: s
    }));
  }, t.defaultProps = {
    showLabel: !0
  }, t;
}(r.Component),
    Kf = n(jf || (jf = E(["\n  width: 20px;\n  height: 20px;\n  background: ", ";\n  border: 2px solid ", ";\n  border-radius: 50%;\n  cursor: pointer;\n"], ["\n  width: 20px;\n  height: 20px;\n  background: ", ";\n  border: 2px solid ", ";\n  border-radius: 50%;\n  cursor: pointer;\n"])), function (e) {
  return e.theme.slider.thumbBackground;
}, function (e) {
  return e.theme.slider.thumbBorderColor;
}),
    Zf = e.input(Gf || (Gf = E(["\n  display: flex;\n  flex: 1 0 auto;\n  appearance: none;\n  max-width: calc(100% - 50px);\n  outline: none;\n  border-radius: 0; /* iOS */\n  ", "\n  &::-moz-focus-outer {\n    /** This is to remove the dotted focus lines in firefox */\n    border: 0;\n  }\n  &:disabled {\n    opacity: ", ";\n    pointer-events: none;\n  }\n  ", "\n  &:hover {\n    opacity: ", ";\n  }\n  &::-webkit-slider-runnable-track {\n    cursor: pointer;\n    appearance: none;\n  }\n  &::-moz-range-track {\n    appearance: none;\n    cursor: pointer;\n  }\n  &::-ms-track {\n    cursor: pointer;\n    height: 5px;\n    appearance: none;\n    background: transparent;\n    color: transparent;\n    border-color: transparent;\n    border-width: 6px 0;\n  }\n  &::-webkit-slider-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-moz-range-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-ms-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-ms-fill-lower {\n    background: ", ";\n  }\n  &::-ms-fill-upper {\n    background: ", ";\n  }\n  &::-ms-tooltip {\n    display: none;\n  }\n  @media all and (min-width: 0) and (max-width: 599px) {\n    width: 200px;\n  }\n"], ["\n  display: flex;\n  flex: 1 0 auto;\n  appearance: none;\n  max-width: calc(100% - 50px);\n  outline: none;\n  border-radius: 0; /* iOS */\n  ", "\n  &::-moz-focus-outer {\n    /** This is to remove the dotted focus lines in firefox */\n    border: 0;\n  }\n  &:disabled {\n    opacity: ", ";\n    pointer-events: none;\n  }\n  ", "\n  &:hover {\n    opacity: ", ";\n  }\n  &::-webkit-slider-runnable-track {\n    cursor: pointer;\n    appearance: none;\n  }\n  &::-moz-range-track {\n    appearance: none;\n    cursor: pointer;\n  }\n  &::-ms-track {\n    cursor: pointer;\n    height: 5px;\n    appearance: none;\n    background: transparent;\n    color: transparent;\n    border-color: transparent;\n    border-width: 6px 0;\n  }\n  &::-webkit-slider-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-moz-range-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-ms-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-ms-fill-lower {\n    background: ", ";\n  }\n  &::-ms-fill-upper {\n    background: ", ";\n  }\n  &::-ms-tooltip {\n    display: none;\n  }\n  @media all and (min-width: 0) and (max-width: 599px) {\n    width: 200px;\n  }\n"])), Ke() || Ze() ? n(Wf || (Wf = E(["\n        margin-top: 10px;\n        height: 24px;\n      "], ["\n        margin-top: 10px;\n        height: 24px;\n      "]))) : n(Hf || (Hf = E(["\n        height: 2px;\n        background: ", ";\n      "], ["\n        height: 2px;\n        background: ", ";\n      "])), function (e) {
  return "linear-gradient(to right, " + function (e) {
    var t = 100 * (e.value - e.min) / (e.max - e.min);
    return e.adjust ? e.value > 0 ? (t = e.value * (e.max / 2) * 100, e.theme.slider.trackColor + " 0%,\n      " + e.theme.slider.trackColor + " 50%,\n      " + e.theme.slider.activeTrackColor + " 50%,\n      " + e.theme.slider.activeTrackColor + " " + (50 + t) + "%,\n      " + e.theme.slider.trackColor + " " + (50 + t) + "%,\n      " + e.theme.slider.trackColor + " 100%\n      ") : e.value < 0 ? (t = e.value * (e.min / 2) * 100, e.theme.slider.trackColor + " 0%,\n      " + e.theme.slider.trackColor + " " + (50 - t) + "%,\n      " + e.theme.slider.activeTrackColor + " " + (50 - t) + "%,\n      " + e.theme.slider.activeTrackColor + " 50%,\n      " + e.theme.slider.trackColor + " 50%,\n      " + e.theme.slider.trackColor + " 100%\n      ") : e.theme.slider.trackColor + " 0%,\n    " + e.theme.slider.trackColor + " 100%" : e.theme.slider.activeTrackColor + " 0%,\n    " + e.theme.slider.activeTrackColor + " " + t + "%,\n    " + e.theme.slider.trackColor + " " + t + "%,\n    " + e.theme.slider.trackColor + " 100%";
  }(e) + ")";
}), function (e) {
  return e.theme.slider.inactiveOpacity;
}, Kp.Focused, function (e) {
  return e.theme.slider.hoverOpacity;
}, Kf, Kf, Kf, function (e) {
  return "" + e.theme.slider.activeTrackColor;
}, function (e) {
  return "" + e.theme.slider.trackColor;
}),
    Qf = e.div(Vf || (Vf = E(["\n  display: flex;\n  align-items: center;\n  height: 26px;\n  margin-right: ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  height: 26px;\n  margin-right: ", "px;\n"])), function (e) {
  return e.centerSlider ? -56 : 0;
}),
    Jf = e(qf)(Xf || (Xf = E(["\n  max-width: 50px;\n  padding-left: 16px;\n  > div > input {\n    text-align: center;\n  }\n"], ["\n  max-width: 50px;\n  padding-left: 16px;\n  > div > input {\n    text-align: center;\n  }\n"]))),
    $f = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.onSubmit = function (e) {
      var t = n.props,
          i = t.onChange,
          r = t.suffix,
          o = t.divider,
          a = t.min,
          s = t.max,
          l = t.value,
          u = e.replace(r, ""),
          c = u ? parseFloat(u) / o : l,
          p = Math.max(a, Math.min(s, c));
      Number.isNaN(p) || (i(p), n.props.onMouseUp ? n.props.onMouseUp() : n.props.onTouchEnd && n.props.onTouchEnd());
    }, n.onSliderChange = function (e) {
      (0, n.props.onChange)(parseFloat(e.target.value));
    }, n.randomId = F(), n;
  }

  return _(t, e), t.prototype.render = function () {
    var e = this.props,
        t = e.value,
        n = e.snap,
        i = e.min,
        o = e.max,
        a = e.divider,
        s = e.suffix,
        l = e.decimal,
        u = e.showLabel,
        c = e.showInput,
        p = e.style,
        f = e.centerSlider,
        h = e.adjust,
        d = e.label,
        g = e.isDisabled,
        m = e.step,
        y = e["aria-hidden"],
        _ = e.onMouseUp,
        v = e.onTouchEnd,
        b = e.className,
        w = "photoeditorsdk-slider-" + this.randomId,
        x = w + "-list",
        k = w + "-input",
        T = "number" == typeof n,
        S = T && r.createElement("datalist", {
      id: x
    }, r.createElement("option", {
      value: n
    })),
        C = "" + (t * a).toFixed(l) + s,
        E = c && r.createElement(Jf, {
      id: k,
      value: C,
      isDisabled: g,
      "aria-hidden": y,
      onSubmit: this.onSubmit
    });
    return r.createElement("div", {
      className: b
    }, r.createElement(If, {
      isDisabled: g,
      label: d,
      show: u
    }), r.createElement(Tf, {
      count: .25
    }), r.createElement(Qf, {
      centerSlider: c && f
    }, r.createElement(Zf, {
      type: "range",
      role: "slider",
      "aria-hidden": y,
      tabIndex: 0,
      value: t,
      min: i,
      max: o,
      step: m,
      style: p,
      disabled: g,
      id: w,
      list: T ? x : void 0,
      onChange: this.onSliderChange,
      adjust: h,
      name: d,
      onKeyUp: this.onSliderChange,
      onKeyDown: this.onSliderChange,
      onMouseUp: _,
      onTouchEnd: v
    }), S, E));
  }, t.defaultProps = {
    showLabel: !0,
    showInput: !0,
    adjust: !1,
    centerSlider: !1,
    min: -1,
    max: 1,
    value: 0,
    step: .01,
    decimal: 0,
    divider: 100,
    suffix: ""
  }, t;
}(r.Component);

Zf.defaultProps = {
  theme: Xs
};
var eh,
    th = e.input.attrs({
  type: "search"
})(eh || (eh = E(["\n  ", "\n"], ["\n  ", "\n"])), Df);
th.defaultProps = {
  theme: Xs
};

var nh,
    ih,
    rh,
    oh,
    ah,
    sh,
    lh,
    uh = e(Op)(nh || (nh = E(["\n  height: inherit;\n  background: transparent;\n  color: ", ";\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n"], ["\n  height: inherit;\n  background: transparent;\n  color: ", ";\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n"])), function (e) {
  return e.theme.button.textPrimaryForeground;
}, function (e) {
  return e.theme.measurements.fontSystem.label.size;
}, function (e) {
  return e.theme.measurements.fontSystem.label.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.label.case;
}),
    ch = e(Op)(ih || (ih = E(["\n  height: inherit;\n  background: transparent;\n  font-size: ", "px;\n  color: ", ";\n  letter-spacing: ", "px;\n  text-transform: ", ";\n"], ["\n  height: inherit;\n  background: transparent;\n  font-size: ", "px;\n  color: ", ";\n  letter-spacing: ", "px;\n  text-transform: ", ";\n"])), function (e) {
  return e.theme.measurements.fontSystem.label.size;
}, function (e) {
  return e.theme.button.textSecondaryForeground;
}, function (e) {
  return e.theme.measurements.fontSystem.label.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.label.case;
}),
    ph = e.div(rh || (rh = E(["\n  display: flex;\n  justify-content: flex-end;\n  width: inherit;\n  text-align: right;\n  height: 40px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  width: inherit;\n  text-align: right;\n  height: 40px;\n"]))),
    fh = e.div(oh || (oh = E(["\n  textarea {\n    caret-color: ", ";\n    ", "\n    height: 44px;\n    outline-offset: -8px;\n    color: ", ";\n    resize: none;\n    font-family: '", "', sans-serif;\n    &:selection, &:-moz-selection {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  textarea {\n    caret-color: ", ";\n    ", "\n    height: 44px;\n    outline-offset: -8px;\n    color: ", ";\n    resize: none;\n    font-family: '", "', sans-serif;\n    &:selection, &:-moz-selection {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"])), function (e) {
  return e.theme.primary;
}, Df, function (e) {
  return e.theme.modal.bodyForeground;
}, function (e) {
  return e.theme.typography.fontFamily;
}, function (e) {
  return e.theme.primary;
}, function (e) {
  return e.theme.foreground;
}),
    hh = e.label(ah || (ah = E(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n"], ["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n"])), function (e) {
  return e.theme.measurements.fontSystem.label.size;
}, function (e) {
  return e.theme.measurements.fontSystem.label.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.label.case;
}, function (e) {
  return e.theme.modal.headerForeground;
}),
    dh = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.state = {
      value: ""
    }, n.handleKeydown = function (e) {
      switch (e.key) {
        case "Escape":
          n.close();
      }
    }, n.close = function () {
      n.props.close(!1);
    }, n.save = function () {
      var e = n.input.value;
      e && (n.props.save(e), n.close());
    }, n.onChange = function (e) {
      var t = function (e) {
        return e.replace(Kl, "");
      }(e.target.value);

      n.input.value = t, n.setState({
        value: t
      });
    }, n.onSubmit = function (e) {
      e.preventDefault();
    }, n.inputRef = function (e) {
      n.input = e;
    }, n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    var e = this.props,
        t = e.text,
        n = e.defaultText;
    this.input.focus(), this.input.value = t || n || "", this.setState({
      value: this.input.value
    }), document.addEventListener("keydown", this.handleKeydown, !1), t === n && this.input.select();
  }, t.prototype.componentWillUnmount = function () {
    document.removeEventListener("keydown", this.handleKeydown, !1);
  }, t.prototype.componentDidUpdate = function (e) {
    e.show !== this.props.show && this.props.show && this.input.focus();
  }, t.prototype.render = function () {
    var e = this,
        t = this.props,
        n = t.show,
        i = t.position,
        o = t.maxLength;
    return r.createElement(cf, {
      show: n || !1,
      height: "fit-content",
      width: "350px",
      position: i,
      footer: function footer() {
        return r.createElement(ph, null, r.createElement(ch, {
          ariaLabel: e.props.closeLabel,
          onClick: e.close
        }, e.props.closeLabel || "Cancel"), r.createElement(uh, {
          ariaLabel: e.props.saveLabel,
          isDisabled: !e.state.value,
          onClick: e.save
        }, e.props.saveLabel || "Done"));
      },
      "aria-describedby": "Edit the selected text content"
    }, r.createElement("form", {
      style: {
        width: "inherit"
      },
      onSubmit: this.onSubmit
    }, r.createElement(hh, {
      htmlFor: "photoeditorsdk-TextInput"
    }, this.props.editLabel || "Text Input"), r.createElement(Tf, null), r.createElement(fh, null, r.createElement("textarea", {
      id: "photoeditorsdk-TextInput",
      placeholder: "Write Something",
      rows: 3,
      autoFocus: !0,
      onChange: this.onChange,
      maxLength: o,
      ref: this.inputRef
    }))));
  }, t.defaultProps = {
    defaultText: "Write Something"
  }, t;
}(r.Component),
    gh = e.input.attrs({
  type: "file",
  id: "fileUpload",
  accept: "image/png, image/jpeg"
})(sh || (sh = E(["\n  display: none;\n"], ["\n  display: none;\n"]))),
    mh = e.ul.attrs(function (e) {
  var t = e.scrollable;
  return {
    "data-simplebar": t ? "init" : null,
    "data-simplebar-auto-hide": t ? "false" : null
  };
})(lh || (lh = E(["\n  list-style: none;\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  box-shadow: ", ";\n  visibility: hidden;\n  opacity: 0;\n  min-width: 5rem;\n  position: absolute;\n  transition: all 0.5s ease;\n  left: -1px;\n  display: none;\n  padding: unset;\n  width: 100%;\n  z-index: ", ";\n  max-height: 160px;\n  overflow-x: hidden;\n  margin: 5px 0;\n  border-radius: 0 0 ", "px ", "px;\n  &[data-simplebar] {\n    position: absolute;\n  }\n"], ["\n  list-style: none;\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  box-shadow: ", ";\n  visibility: hidden;\n  opacity: 0;\n  min-width: 5rem;\n  position: absolute;\n  transition: all 0.5s ease;\n  left: -1px;\n  display: none;\n  padding: unset;\n  width: 100%;\n  z-index: ", ";\n  max-height: 160px;\n  overflow-x: hidden;\n  margin: 5px 0;\n  border-radius: 0 0 ", "px ", "px;\n  &[data-simplebar] {\n    position: absolute;\n  }\n"])), function (e) {
  return e.theme.dropdown.listBackground;
}, function (e) {
  return e.theme.dropdown.listForeground;
}, function (e) {
  return e.theme.dropdown.listBorderColor;
}, function (e) {
  return e.theme.dropdown.listShadow;
}, function (e) {
  return e.theme.measurements.zIndex.input.list;
}, function (e) {
  return e.theme.shape.radiusMedium;
}, function (e) {
  return e.theme.shape.radiusMedium;
});

mh.defaultProps = {
  theme: Xs,
  scrollable: !0
};

var yh,
    _h,
    vh,
    bh,
    wh = n(yh || (yh = E(["\n  outline: none;\n"], ["\n  outline: none;\n"]))),
    xh = n(_h || (_h = E(["\n  opacity: ", ";\n  pointer-events: none;\n"], ["\n  opacity: ", ";\n  pointer-events: none;\n"])), function (e) {
  return e.theme.dropdown.inactiveOpacity;
}),
    kh = e.div(bh || (bh = E(["\n  color: ", ";\n  background-color: ", ";\n  display: block;\n  position: relative;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  width: 100%;\n  white-space: nowrap;\n  transition-duration: 0.5s;\n\n  &:focus a {\n    ", "\n  }\n\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:disabled {\n    ", "\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  background-color: ", ";\n  display: block;\n  position: relative;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  width: 100%;\n  white-space: nowrap;\n  transition-duration: 0.5s;\n\n  &:focus a {\n    ", "\n  }\n\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:disabled {\n    ", "\n  }\n\n  ", "\n"])), function (e) {
  return e.theme.dropdown.foreground;
}, function (e) {
  return e.theme.dropdown.background;
}, function (e) {
  return e.theme.measurements.fontSystem.label.size;
}, function (e) {
  return e.theme.measurements.fontSystem.label.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.label.case;
}, wh, function (e) {
  return e.isOpen && n(vh || (vh = E(["\n      a {\n        ", "\n      }\n      ", " {\n        visibility: visible;\n        opacity: 1;\n        display: block;\n      }\n    "], ["\n      a {\n        ", "\n      }\n      ", " {\n        visibility: visible;\n        opacity: 1;\n        display: block;\n      }\n    "])), wh, mh);
}, function (e) {
  return e.theme.dropdown.hoverBorderColor;
}, xh, function (e) {
  return e.isDisabled && xh;
});

kh.defaultProps = {
  theme: Xs
};
var Th,
    Sh,
    Ch = e.li(Sh || (Sh = E(["\n  padding: 10px 16px;\n  text-overflow: ellipsis;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  white-space: nowrap;\n  color: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n  }\n\n  ", "\n\n  ", "\n"], ["\n  padding: 10px 16px;\n  text-overflow: ellipsis;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  white-space: nowrap;\n  color: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n  }\n\n  ", "\n\n  ", "\n"])), function (e) {
  return e.theme.measurements.fontSystem.button2.size;
}, function (e) {
  return e.theme.measurements.fontSystem.button2.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.button2.case;
}, function (e) {
  return e.theme.dropdown.foreground;
}, function (e) {
  return e.theme.dropdown.listItemHoverBackground;
}, function (e) {
  return e.isActive && n(Th || (Th = E(["\n      border-left: 2px solid ", ";\n    "], ["\n      border-left: 2px solid ", ";\n    "])), function (e) {
    return e.theme.primary;
  });
}, Kp.Focused);
Ch.defaultProps = {
  theme: Xs
};

var Eh,
    Oh,
    Rh,
    Ih,
    Ah,
    Mh,
    Fh,
    Dh,
    Ph = e.div(Eh || (Eh = E(["\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid ", ";\n  transform: rotate(", "deg);\n  display: inline-block;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in;\n  right: 0;\n  top: 13px;\n"], ["\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid ", ";\n  transform: rotate(", "deg);\n  display: inline-block;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in;\n  right: 0;\n  top: 13px;\n"])), function (e) {
  return e.theme.dropdown.caretColor;
}, function (e) {
  return e.rotation || 0;
}),
    zh = e.div(Oh || (Oh = E(["\n  line-height: 17px;\n  color: ", ";\n  background-color: ", ";\n  border: none;\n  border-bottom: 1px solid ", ";\n  padding: 5px 0;\n  cursor: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n  transition: border-color 0.4s ease-in-out;\n  ", "\n"], ["\n  line-height: 17px;\n  color: ", ";\n  background-color: ", ";\n  border: none;\n  border-bottom: 1px solid ", ";\n  padding: 5px 0;\n  cursor: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n  transition: border-color 0.4s ease-in-out;\n  ", "\n"])), function (e) {
  return e.theme.dropdown.foreground;
}, function (e) {
  return e.theme.dropdown.background;
}, function (e) {
  return e.theme.dropdown.borderColor;
}, function (e) {
  return e.showList ? "pointer" : "default";
}, function (e) {
  return e.theme.dropdown.hoverBorderColor;
}, Kp.Focused),
    Lh = e.div(Rh || (Rh = E([""], [""]))),
    Bh = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.state = {
      isOpen: !1
    }, n.handleOutsideClick = function (e) {
      n.node && n.node.contains(e.target) || n.setState({
        isOpen: !1
      });
    }, n.onSelect = function (e) {
      n.props.onSelect(e), n.setState({
        isOpen: !1
      });
    }, n.onClick = function () {
      n.setState(function (e) {
        return {
          isOpen: !e.isOpen
        };
      });
    }, n.listItem = function (e) {
      var t = n.props,
          i = t.itemStyle,
          o = t.selectedItem,
          a = e.value,
          s = e.label,
          l = {};
      return "function" == typeof i ? l = i(e) : null !== i && "object" == typeof i && (l = i), r.createElement(Ch, {
        "aria-hidden": !n.state.isOpen,
        tabIndex: 0,
        style: l,
        onClick: function onClick() {
          return n.onSelect(a);
        },
        key: a,
        isActive: o === a
      }, s);
    }, n.onKeyDown = function (e) {
      "Space" !== e.code && "Enter" !== e.code || n.onClick();
    }, n.nodeRef = function (e) {
      n.node = e;
    }, n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    document.addEventListener("mousedown", this.handleOutsideClick, !1);
  }, t.prototype.componentWillUnmount = function () {
    document.removeEventListener("mousedown", this.handleOutsideClick, !1);
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.selectedItem,
        n = e.list,
        i = e.label,
        o = e.style,
        a = e.isDisabled,
        s = this.state.isOpen,
        l = n.length > 1,
        u = a ? {} : {
      tabIndex: 0
    };
    return r.createElement(Lh, null, r.createElement(If, {
      isDisabled: a,
      style: {
        paddingLeft: "0px"
      },
      label: i
    }), r.createElement(Tf, null), r.createElement("div", {
      ref: this.nodeRef
    }, r.createElement(kh, {
      id: i.replace(" ", "-"),
      isOpen: s,
      isDisabled: a
    }, r.createElement(zh, _v2({
      "aria-hidden": a
    }, u, {
      showList: l,
      style: o,
      onClick: l ? this.onClick : void 0,
      onKeyDown: this.onKeyDown
    }), t, l && r.createElement(Ph, {
      rotation: s ? 180 : 0
    })), r.createElement(mh, {
      scrollable: n.length > 4
    }, l && n.map(this.listItem)))));
  }, t;
}(r.PureComponent),
    Nh = e.div(Ih || (Ih = E(["\n  display: flex;\n  position: relative;\n  margin-bottom: 12px;\n  max-width: ", "px;\n"], ["\n  display: flex;\n  position: relative;\n  margin-bottom: 12px;\n  max-width: ", "px;\n"])), function (e) {
  return e.theme.measurements.basicToolControlBar.maxWidth;
}),
    Uh = e.input.attrs({
  type: "checkbox",
  tabIndex: 0
})(Ah || (Ah = E(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  margin: 0;\n  padding: 0;\n  ", "\n"], ["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  margin: 0;\n  padding: 0;\n  ", "\n"])), Kp.Focused),
    jh = e.div.attrs({
  tabIndex: 0
})(Dh || (Dh = E(["\n  position: relative;\n  height: 16px;\n  width: 16px;\n  cursor: pointer;\n  background-color: ", ";\n  border-radius: ", "px;\n  transition-timing-function: ease-in;\n  transition-duration: 0.3s;\n  &::after {\n    content: '';\n    position: absolute;\n    display: inline-block;\n    left: 5px;\n    width: 5px;\n    height: 10px;\n    border-style: solid;\n    border-width: 0 2px 2px 0;\n    border-color: transparent;\n    transform: rotate(45deg) scale(0.8);\n  }\n\n  &:first-child {\n    margin-right: 8px;\n  }\n\n  &:last-child {\n    margin-left: 8px;\n  }\n\n  ", "\n\n  &:hover {\n    opacity: ", ";\n  }\n  ", "\n  ", "\n"], ["\n  position: relative;\n  height: 16px;\n  width: 16px;\n  cursor: pointer;\n  background-color: ", ";\n  border-radius: ", "px;\n  transition-timing-function: ease-in;\n  transition-duration: 0.3s;\n  &::after {\n    content: '';\n    position: absolute;\n    display: inline-block;\n    left: 5px;\n    width: 5px;\n    height: 10px;\n    border-style: solid;\n    border-width: 0 2px 2px 0;\n    border-color: transparent;\n    transform: rotate(45deg) scale(0.8);\n  }\n\n  &:first-child {\n    margin-right: 8px;\n  }\n\n  &:last-child {\n    margin-left: 8px;\n  }\n\n  ", "\n\n  &:hover {\n    opacity: ", ";\n  }\n  ", "\n  ", "\n"])), function (e) {
  return e.theme.checkbox.background;
}, function (e) {
  return e.theme.shape.radiusSmall;
}, Kp.Focused, function (e) {
  return e.theme.checkbox.hoverOpacity;
}, function (e) {
  return e.isChecked && n(Mh || (Mh = E(["\n      background-color: ", ";\n      &::after {\n        color: ", ";\n        border-color: ", ";\n      }\n      &:hover {\n        background-color: ", ";\n        opacity: 0.8;\n      }\n    "], ["\n      background-color: ", ";\n      &::after {\n        color: ", ";\n        border-color: ", ";\n      }\n      &:hover {\n        background-color: ", ";\n        opacity: 0.8;\n      }\n    "])), e.theme.checkbox.activeBackground, e.theme.checkbox.activeForeground, e.theme.checkbox.foreground, e.theme.checkbox.activeBackground);
}, function (e) {
  return e.isDisabled && n(Fh || (Fh = E(["\n      opacity: 0.5;\n      cursor: default;\n      pointer-events: none;\n    "], ["\n      opacity: 0.5;\n      cursor: default;\n      pointer-events: none;\n    "])));
}),
    Wh = function Wh(e) {
  var t = e.label,
      n = e.value,
      i = e.checkMarkPosition,
      o = e.onClick,
      a = e.isDisabled,
      s = e.className,
      l = e.style,
      u = "photoeditorsdk-" + t.replace(" ", "-");
  return r.createElement(Nh, {
    className: s,
    style: l
  }, "left" === i && r.createElement(jh, {
    onClick: o,
    isDisabled: a,
    isChecked: n
  }), r.createElement(If, {
    isDisabled: a,
    label: t,
    htmlFor: u
  }), r.createElement(Uh, {
    id: u,
    disabled: a,
    checked: n,
    onChange: o
  }), "right" === i && r.createElement(jh, {
    onClick: o,
    isDisabled: a,
    isChecked: n
  }));
};

Wh.defaultProps = {
  value: !1,
  checkMarkPosition: "left"
};

var Hh,
    Gh,
    Vh,
    Xh,
    Yh,
    qh,
    Kh,
    Zh,
    Qh,
    Jh,
    $h,
    ed = e(Op)(Hh || (Hh = E(["\n  color: ", ";\n  padding: 1px 7px 2px;\n"], ["\n  color: ", ";\n  padding: 1px 7px 2px;\n"])), function (e) {
  return e.theme.button.textSecondaryForeground;
}),
    td = e.div(Gh || (Gh = E(["\n  display: flex;\n  justify-content: space-between;\n  width: ", "px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  width: ", "px;\n"])), function (e) {
  return e.theme.measurements.advancedUIToolControlBar.width - 48;
}),
    nd = e.article(Vh || (Vh = E(["\n  width: ", "px;\n  font-size: ", "px;\n  text-transform: ", ";\n  text-align: center;\n  margin-top: 9px;\n  display: inline-block;\n  color: ", ";\n"], ["\n  width: ", "px;\n  font-size: ", "px;\n  text-transform: ", ";\n  text-align: center;\n  margin-top: 9px;\n  display: inline-block;\n  color: ", ";\n"])), function (e) {
  return .6 * e.theme.measurements.advancedUIToolControlBar.width;
}, function (e) {
  return e.theme.measurements.fontSystem.headline2.size;
}, function (e) {
  return e.theme.measurements.fontSystem.body.case;
}, function (e) {
  return e.theme.toolControlBar.inputLabelForeground;
}),
    id = e.div(Xh || (Xh = E(["\n  width: ", "px;\n  transform: translateZ(0);\n  overflow: hidden;\n  transition: all 500ms ease-out;\n"], ["\n  width: ", "px;\n  transform: translateZ(0);\n  overflow: hidden;\n  transition: all 500ms ease-out;\n"])), function (e) {
  return .6 * e.theme.measurements.advancedUIToolControlBar.width;
}),
    rd = e.span(Yh || (Yh = E(["\n  width: ", "px;\n  margin-left: -", "px;\n  position: relative;\n  display: inline-block;\n  transform: translateZ(0);\n  transition: all 600ms cubic-bezier(0.77, 0, 0.175, 1);\n  font-family: '", "', sans-serif;\n"], ["\n  width: ", "px;\n  margin-left: -", "px;\n  position: relative;\n  display: inline-block;\n  transform: translateZ(0);\n  transition: all 600ms cubic-bezier(0.77, 0, 0.175, 1);\n  font-family: '", "', sans-serif;\n"])), function (e) {
  return Math.round(.6 * e.length * e.theme.measurements.advancedUIToolControlBar.width);
}, function (e) {
  return .6 * e.activeIndex * e.theme.measurements.advancedUIToolControlBar.width;
}, function (e) {
  return e.theme.typography.fontFamily;
}),
    od = e.div(Zh || (Zh = E(["\n  border: solid ", ";\n  border-width: 0 2px 2px 0;\n  padding: 3px;\n  height: 0;\n  width: 0;\n\n  ", "\n"], ["\n  border: solid ", ";\n  border-width: 0 2px 2px 0;\n  padding: 3px;\n  height: 0;\n  width: 0;\n\n  ", "\n"])), function (e) {
  return e.theme.card.foreground;
}, function (e) {
  var t = e.direction;
  return n("left" === t ? qh || (qh = E(["\n          margin-left: 2px;\n          transform: rotate(135deg);\n        "], ["\n          margin-left: 2px;\n          transform: rotate(135deg);\n        "])) : Kh || (Kh = E(["\n          margin-right: 2px;\n          transform: rotate(-45deg);\n        "], ["\n          margin-right: 2px;\n          transform: rotate(-45deg);\n        "])));
}),
    ad = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.updateIndex = function (e, t) {
      void 0 === t && (t = !1);
      var i = e + (t ? -1 : 1),
          r = n.props.list.length - 1;
      i > r && (i = 0), i < 0 && (i = r), n.props.onSelect(n.props.list[i].identifier);
    }, n.getActiveIndex = function (e) {
      var t = n.props.list.findIndex(function (t) {
        return t.identifier === e;
      });
      return -1 !== t ? t : 0;
    }, n.throttledUpdateIndex = Zo(n.updateIndex, 600), n;
  }

  return _(t, e), t.prototype.render = function () {
    var e = this,
        t = this.props,
        n = t.list,
        i = t.label,
        o = t.showLabel,
        a = void 0 === o || o,
        s = this.getActiveIndex(this.props.defaultIdentifier),
        l = n.length <= 1;
    return r.createElement("div", null, r.createElement(If, {
      show: a,
      label: i
    }), a ? r.createElement(Tf, null) : null, r.createElement(td, {
      id: "photoeditorsdk-" + i.replace(" ", "-")
    }, r.createElement(ed, {
      ariaLabel: "Select Previous",
      isDisabled: l,
      onClick: function onClick() {
        return e.throttledUpdateIndex(s, !0);
      }
    }, r.createElement(od, {
      direction: "left"
    })), r.createElement(id, null, r.createElement(rd, {
      activeIndex: s,
      length: n.length
    }, n.map(function (e) {
      return r.createElement(nd, {
        key: e.identifier
      }, e.value);
    }))), r.createElement(ed, {
      ariaLabel: "Select Next",
      isDisabled: l,
      onClick: function onClick() {
        return e.throttledUpdateIndex(s);
      }
    }, r.createElement(od, {
      direction: "right"
    }))));
  }, t.defaultProps = {
    showLabel: !0
  }, t;
}(r.PureComponent),
    sd = e.div(Qh || (Qh = E([""], [""]))),
    ld = function ld(e) {
  var t = e.label,
      n = e.children,
      i = e.inline,
      o = e.showLabel,
      a = e.isDisabled;
  return r.createElement(sd, null, r.createElement(If, {
    isDisabled: a,
    label: t,
    show: o
  }), o && r.createElement(Tf, null) || null, r.createElement(ud, {
    id: "photoeditorsdk-" + t.replace(" ", "-"),
    inline: !!i
  }, n));
},
    ud = e.div($h || ($h = E(["\n  display: inline-flex;\n  ", "\n"], ["\n  display: inline-flex;\n  ", "\n"])), function (e) {
  return !e.inline && n(Jh || (Jh = E(["\n        flex-wrap: wrap;\n      "], ["\n        flex-wrap: wrap;\n      "]))) || "";
});

function cd(e, t) {
  for (var n = 0, i = e.length; n < i; n += 1) {
    if (t.apply(t, [e[n], n, e])) return e[n];
  }

  return null;
}

function pd(e) {
  return "function" == typeof e || "[object Function]" === Object.prototype.toString.call(e);
}

function fd(e) {
  return "number" == typeof e && !Number.isNaN(e);
}

function hd(e) {
  return parseInt(e, 10);
}

ld.defaultProps = {
  showLabel: !0
};
var dd = ["Moz", "Webkit", "O", "ms"];

function gd(e, t) {
  return t ? "" + t + function (e) {
    var t,
        n = "",
        i = !0;

    for (t = 0; t < e.length; t += 1) {
      i ? (n += e[t].toUpperCase(), i = !1) : "-" === e[t] ? i = !0 : n += e[t];
    }

    return n;
  }(e) : e;
}

var md = function (e) {
  if (void 0 === e && (e = "transform"), "undefined" == typeof window || void 0 === window.document) return "";
  var t,
      n = window.document.documentElement.style;
  if (e in n) return "";

  for (t = 0; t < dd.length; t += 1) {
    if (gd(e, dd[t]) in n) return dd[t];
  }

  return "";
}(),
    yd = "";

function _d(e, t) {
  return yd || (yd = cd(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function (t) {
    return pd(e[t]);
  })), !!pd(e[yd]) && e[yd](t);
}

function vd(e, t, n) {
  var i = e;

  do {
    if (_d(i, t)) return !0;
    if (i === n) return !1;
    i = i.parentNode;
  } while (i);

  return !1;
}

function bd(e, t, n) {
  e && (e.attachEvent ? e.attachEvent("on" + t, n) : e.addEventListener ? e.addEventListener(t, n, !0) : e["on" + t] = n);
}

function wd(e, t, n) {
  e && (e.detachEvent ? e.detachEvent("on" + t, n) : e.removeEventListener ? e.removeEventListener(t, n, !0) : e["on" + t] = null);
}

function xd(e) {
  var t = e.clientHeight,
      n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += hd(n.borderTopWidth), t += hd(n.borderBottomWidth);
}

function kd(e) {
  var t = e.clientWidth,
      n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += hd(n.borderLeftWidth), t += hd(n.borderRightWidth);
}

function Td(e) {
  var t = e.clientHeight,
      n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= hd(n.paddingTop), t -= hd(n.paddingBottom);
}

function Sd(e) {
  var t = e.clientWidth,
      n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= hd(n.paddingLeft), t -= hd(n.paddingRight);
}

function Cd(e, t) {
  var n = null;
  return e.targetTouches && (n = cd(e.targetTouches, function (e) {
    return t === e.identifier;
  })), e.changedTouches && !n && (n = cd(e.changedTouches, function (e) {
    return t === e.identifier;
  })), n;
}

function Ed(e) {
  return e.targetTouches && e.targetTouches[0] ? e.targetTouches[0].identifier : e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].identifier : null;
}

function Od(e) {
  var t = c.findDOMNode(e);
  if (!t) throw new Error("<DraggableCore>: Unmounted during event!");
  return t;
}

function Rd(e, t, n) {
  var i = e.state,
      r = !fd(i.lastX),
      o = Od(e);
  return r ? {
    node: o,
    deltaX: 0,
    deltaY: 0,
    lastX: t,
    lastY: n,
    x: t,
    y: n
  } : {
    node: o,
    deltaX: t - i.lastX,
    deltaY: n - i.lastY,
    lastX: i.lastX,
    lastY: i.lastY,
    x: t,
    y: n
  };
}

function Id(e, t) {
  return {
    node: t.node,
    x: e.state.x + t.deltaX,
    y: e.state.y + t.deltaY,
    deltaX: t.deltaX,
    deltaY: t.deltaY,
    lastX: e.state.x,
    lastY: e.state.y
  };
}

function Ad(e) {
  return "both" === e.props.axis || "x" === e.props.axis;
}

function Md(e) {
  return "both" === e.props.axis || "y" === e.props.axis;
}

function Fd(e, t) {
  var n = Od(t),
      i = t.props.offsetParent;
  return !i && n instanceof HTMLElement && (i = n.offsetParent || n.ownerDocument.body), function (e, t) {
    var n = t === t.ownerDocument.body ? {
      left: 0,
      top: 0
    } : t.getBoundingClientRect();
    return {
      x: e.clientX + t.scrollLeft - n.left,
      y: e.clientY + t.scrollTop - n.top
    };
  }(e, i);
}

var Dd,
    Pd,
    zd,
    Ld,
    Bd,
    Nd,
    Ud,
    jd,
    Wd,
    Hd,
    Gd,
    Vd,
    Xd,
    Yd,
    qd,
    Kd,
    Zd,
    Qd,
    Jd,
    $d,
    eg,
    tg = {
  start: "touchstart",
  move: "touchmove",
  stop: "touchend"
},
    ng = {
  start: "mousedown",
  move: "mousemove",
  stop: "mouseup"
},
    ig = ng,
    rg = {
  cancel: null,
  disabled: !1,
  offsetParent: null,
  handle: null,
  transform: null,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {}
},
    og = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      dragging: !1,
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: void 0
    }, t.getTouchFromEvent = function (e) {
      var n = Ed(e);
      return t.setState({
        touchIdentifier: n
      }), Cd(e, n);
    }, t.preventDefault = function (e) {
      e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation();
    }, t.handleDragStart = function (e) {
      var n = c.findDOMNode(t);
      if (!n || !n.ownerDocument || !n.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
      var i = n.ownerDocument;
      if (t.props.disabled || !(e.target instanceof Node) || t.props.handle && !vd(e.target, t.props.handle, n) || t.props.cancel && vd(e.target, t.props.cancel, n)) return !1;
      var r = Fd(e, t);
      if (null == r) return !1;
      var o = r.x,
          a = r.y,
          s = Rd(t, o, a);
      if (!1 === t.props.onStart(e, s)) return !1;
      t.setState({
        dragging: !0,
        lastX: o,
        lastY: a
      }), "touchmove" === ig.move ? bd(i, ig.move, t.onTouchDrag) : bd(i, ig.move, t.onMouseDrag), bd(i, ig.stop, t.handleDragStop);
    }, t.handleDrag = function (e) {
      var n = Fd(e, t);

      if (null != n) {
        var i = n.x,
            r = n.y,
            o = Rd(t, i, r);
        if (!1 !== t.props.onDrag(e, o)) t.setState({
          lastX: i,
          lastY: r
        });else try {
          t.handleDragStop(new MouseEvent("mouseup"));
        } catch (e) {
          var a = document.createEvent("MouseEvents");
          a.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), t.handleDragStop(a);
        }
      }
    }, t.handleDragStop = function (e) {
      if (t.state.dragging) {
        var n = Fd(e, t);

        if (null != n) {
          var i = n.x,
              r = n.y,
              o = Rd(t, i, r),
              a = c.findDOMNode(t);
          t.setState({
            dragging: !1,
            lastX: NaN,
            lastY: NaN
          }), t.props.onStop(e, o), a && ("touchmove" === ig.move ? wd(a.ownerDocument, ig.move, t.onTouchDrag) : wd(a.ownerDocument, ig.move, t.onMouseDrag), wd(a.ownerDocument, ig.stop, t.handleDragStop));
        }
      }
    }, t.onMouseDown = function (e) {
      return t.preventDefault(e), ig = ng, t.props.onMouseDown(e), (!e.button || "number" != typeof e.button || 0 === e.button) && t.handleDragStart(e);
    }, t.onMouseDrag = function (e) {
      return t.preventDefault(e), t.handleDrag(e);
    }, t.onMouseUp = function (e) {
      return t.preventDefault(e), ig = ng, t.handleDragStop(e);
    }, t.onTouchStart = function (e) {
      t.preventDefault(e), ig = tg;
      var n = t.getTouchFromEvent(e);
      return t.handleDragStart(n);
    }, t.onTouchDrag = function (e) {
      t.preventDefault(e), ig = tg;
      var n = t.getTouchFromEvent(e);
      return t.handleDrag(n);
    }, t.onTouchEnd = function (e) {
      t.preventDefault(e), ig = tg;
      var n = t.getTouchFromEvent(e);
      return t.handleDragStop(n);
    }, t;
  }

  return _(t, e), t.prototype.componentWillUnmount = function () {
    var e = c.findDOMNode(this);

    if (e) {
      var t = e.ownerDocument;
      wd(t, ng.move, this.onMouseDrag), wd(t, tg.move, this.onTouchDrag), wd(t, ng.stop, this.handleDragStop), wd(t, tg.stop, this.handleDragStop);
    }
  }, t.prototype.render = function () {
    return r.cloneElement(r.Children.only(this.props.children), {
      style: _v2({
        touchAction: "none"
      }, this.props.children.props.style),
      onMouseDown: this.onMouseDown,
      onTouchStart: this.onTouchStart,
      onMouseUp: this.onMouseUp,
      onTouchEnd: this.onTouchEnd
    });
  }, t.defaultProps = rg, t.displayName = "DraggableCore", t;
}(r.Component),
    ag = _v2(_v2({}, rg), {
  axis: "both",
  bounds: !1,
  defaultClassName: "draggable",
  defaultClassNameDragging: "draggable-dragging",
  defaultClassNameDragged: "draggable-dragged",
  defaultPosition: {
    x: 0,
    y: 0
  },
  position: null,
  rotation: 0,
  updateOnPosition: !1
}),
    sg = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.onDragStart = function (e, t) {
      if (!1 === n.props.onStart(e, Id(n, t))) return !1;
      n.setState({
        dragging: !0,
        dragged: !0
      });
    }, n.onDrag = function (e, t) {
      var i = n.props,
          r = i.position,
          o = i.defaultPosition,
          a = i.onDrag,
          s = i.bounds;
      if (!n.state.dragging) return !1;
      var l = Id(n, t),
          u = Boolean(r),
          c = {
        x: u ? l.x : o.x,
        y: u ? l.y : o.y,
        slackX: 0,
        slackY: 0
      };

      if (s) {
        var p = c.x,
            f = c.y;
        c.x += n.state.slackX, c.y += n.state.slackY;
        var h = S(function (e, t, n) {
          if (!e.props.bounds) return [t, n];
          var i = e.props.bounds;
          i = "string" == typeof i ? i : _v2({}, i);
          var r = Od(e);

          if ("string" == typeof i) {
            var o = r.ownerDocument,
                a = o.defaultView,
                s = "parent" === i ? r.parentNode : o.querySelector(i);
            if (!(s instanceof HTMLElement)) throw new Error('Bounds selector "' + i + '" could not find an element.');

            if (r instanceof HTMLElement) {
              var l = a.getComputedStyle(r),
                  u = a.getComputedStyle(s);
              i = {
                left: -r.offsetLeft + hd(u.paddingLeft) + hd(l.marginLeft),
                top: -r.offsetTop + hd(u.paddingTop) + hd(l.marginTop),
                right: Sd(s) - kd(r) - r.offsetLeft + hd(u.paddingRight) - hd(l.marginRight),
                bottom: Td(s) - xd(r) - r.offsetTop + hd(u.paddingBottom) - hd(l.marginBottom)
              };
            }
          }

          return fd((i = i).right) && (t = Math.min(t, i.right)), fd(i.bottom) && (n = Math.min(n, i.bottom)), fd(i.left) && (t = Math.max(t, i.left)), fd(i.top) && (n = Math.max(n, i.top)), [t, n];
        }(n, c.x, c.y), 2),
            d = h[0],
            g = h[1];
        c.x = d, c.y = g, c.slackX = n.state.slackX + (p - c.x), c.slackY = n.state.slackY + (f - c.y), l.x = c.x, l.y = c.y, l.deltaX = c.x - n.state.x, l.deltaY = c.y - n.state.y;
      }

      if (!1 === a(e, l)) return !1;
      n.setState(c);
    }, n.onDragStop = function (e, t) {
      if (!n.state.dragging) return !1;
      if (!1 === n.props.onStop(e, Id(n, t))) return !1;
      var i = {
        dragging: !1,
        slackX: 0,
        slackY: 0,
        x: 0,
        y: 0
      };

      if (Boolean(n.props.position)) {
        var r = n.props.position,
            o = r.x,
            a = r.y;
        i.x = o, i.y = a;
      }

      n.setState(i);
    }, n.state = {
      dragging: !1,
      dragged: !1,
      x: t.position ? t.position.x : t.defaultPosition.x,
      y: t.position ? t.position.y : t.defaultPosition.y,
      slackX: 0,
      slackY: 0
    }, n;
  }

  return _(t, e), t.prototype.componentDidUpdate = function (e) {
    Boolean(this.props.position) && (this.props.updateOnPosition ? (e.position && e.position.x !== this.props.position.x || e.position.y !== this.props.position.y) && this.setState({
      x: this.props.position.x,
      y: this.props.position.y
    }) : (e.position && this.props.position.x !== this.state.x || this.props.position.y !== this.state.y) && this.setState({
      x: this.props.position.x,
      y: this.props.position.y
    }));
  }, t.prototype.componentWillUnmount = function () {
    this.setState({
      dragging: !1
    });
  }, t.prototype.render = function () {
    var e,
        t = this.props,
        n = t.position,
        i = t.defaultPosition,
        o = t.rotation,
        a = t.defaultClassName,
        s = t.defaultClassNameDragging,
        l = t.defaultClassNameDragged,
        u = b(t, ["position", "defaultPosition", "rotation", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged"]),
        c = this.state,
        p = c.x,
        f = c.y,
        h = c.dragging,
        d = c.dragged,
        g = !Boolean(n) || h,
        m = n || i;

    e = function (e) {
      var t,
          n = "translate(" + e.x + "px," + e.y + "px) rotate(" + e.rotation + "rad)";
      return (t = {})[gd("transform", md)] = n, t;
    }({
      x: Ad(this) && g ? p : m.x,
      y: Md(this) && g ? f : m.y,
      rotation: o
    });

    var y = r.Children.only(this.props.children),
        _ = [y.props.className || "", a, h ? s : "", d ? l : ""].join(" ").trim(),
        w = r.cloneElement(y, {
      className: _,
      style: _v2(_v2({}, y.props.style), e)
    });

    return r.createElement(og, _v2({}, u, {
      onStart: this.onDragStart,
      onDrag: this.onDrag,
      onStop: this.onDragStop
    }), w);
  }, t.defaultProps = ag, t.displayName = "Draggable", t;
}(r.Component),
    lg = e(ph)(Dd || (Dd = E(["\n  border-top: 2px solid ", ";\n"], ["\n  border-top: 2px solid ", ";\n"])), function (e) {
  return "error" === e.type ? e.theme.error : e.theme.warning;
}),
    ug = e.div(Pd || (Pd = E(["\n  display: block;\n"], ["\n  display: block;\n"]))),
    cg = e.h3(zd || (zd = E(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n"], ["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n"])), function (e) {
  return e.theme.measurements.fontSystem.headline2.size;
}, function (e) {
  return e.theme.measurements.fontSystem.headline2.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.headline2.case;
}, function (e) {
  return e.theme.modal.headerForeground;
}),
    pg = e.p(Ld || (Ld = E(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n"], ["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n"])), function (e) {
  return e.theme.measurements.fontSystem.body.size;
}, function (e) {
  return e.theme.measurements.fontSystem.body.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.body.case;
}, function (e) {
  return e.theme.modal.bodyForeground;
}),
    fg = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.closeModal = function (e) {
      t.props.handlers.close && t.props.handlers.close(), e && e();
    }, t;
  }

  return _(t, e), t.prototype.render = function () {
    var e = this,
        t = this.props,
        n = t.type,
        i = t.handlers,
        o = t.message,
        a = t.show,
        s = t.position,
        l = t.preHeadingLocale,
        u = "error" === n ? l.error : l.warning;
    return r.createElement(cf, {
      heading: o ? o.heading : "",
      show: a || !1,
      width: "350px",
      height: "fit-content",
      position: s,
      footer: function footer() {
        return i && o ? r.createElement(lg, {
          type: n
        }, o.buttonNo && r.createElement(ch, {
          ariaLabel: o.buttonNo,
          onClick: function onClick() {
            return e.closeModal(i.buttonNo);
          }
        }, o.buttonNo), o.buttonYes && r.createElement(uh, {
          ariaLabel: o.buttonYes,
          onClick: function onClick() {
            return e.closeModal(i.buttonYes);
          }
        }, o.buttonYes)) : null;
      }
    }, r.createElement(ug, null, o ? r.createElement(cg, null, u, ": ", o.heading || "") : null, o && o.body ? r.createElement(pg, null, o.body) : null));
  }, t.defaultProps = {
    preHeadingLocale: {
      error: "Error",
      warning: "Warning"
    }
  }, t;
}(r.PureComponent),
    hg = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return _(t, e), t.prototype.getChildren = function () {
    var e = this,
        t = [],
        n = [];
    return r.Children.forEach(this.props.children, function (i) {
      switch (i.type.componentName) {
        case "case":
          e.props.type === i.props.value && t.push(i);
          break;

        case "default":
          n.push(i);
      }
    }), t.length > 0 ? t : n;
  }, t.prototype.render = function () {
    var e = this.getChildren();
    return 0 === e.length ? null : r.createElement(r.Fragment, null, e);
  }, t;
}(r.Component),
    dg = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return _(t, e), t.prototype.render = function () {
    return this.props.children;
  }, t.componentName = "case", t;
}(r.Component),
    gg = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return _(t, e), t.prototype.render = function () {
    return this.props.children;
  }, t.componentName = "default", t;
}(r.Component),
    mg = {
  Container: Zl,
  ColorItem: ef,
  ColorItemBase: Qp,
  ColorItemBackground: Tc,
  ColorItemTiledBackground: Cc,
  ColorItemActiveOverlay: Mc,
  Loader: kf,
  Spacer: Tf,
  Modal: fg,
  Draggable: sg,
  DraggableCore: og,
  Toast: tu,
  Input: {
    Label: If,
    File: gh,
    Search: function Search(e) {
      return r.createElement("div", null, r.createElement(If, {
        show: !1,
        label: "photoeditorsdk-Search"
      }), r.createElement(th, {
        id: "photoeditorsdk-Search",
        onChange: function onChange(t) {
          e.onChange(t.target.value);
        },
        placeholder: e.placeholder
      }));
    },
    Slider: $f,
    CarouselSlider: ad,
    Selection: ld,
    Checkbox: Wh,
    CheckboxBase: Nh,
    CheckboxInput: Uh,
    CheckboxCheckMark: jh,
    Dropdown: Bh,
    Text: Lf,
    NummericInput: qf,
    TextEdit: dh,
    Form: function Form(e) {
      var t = e.children;
      return r.createElement("form", {
        onSubmit: function onSubmit(e) {
          e.preventDefault();
        }
      }, t);
    }
  },
  Switch: {
    Index: hg,
    Case: dg,
    Default: gg
  }
},
    yg = e(Wp)(Bd || (Bd = E(["\n  width: ", "px;\n  height: ", "px;\n  margin-bottom: ", "px;\n  color: ", ";\n  &:nth-child(3n + 1),\n  &:nth-child(3n + 2) {\n    margin-right: ", "px;\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  margin-bottom: ", "px;\n  color: ", ";\n  &:nth-child(3n + 1),\n  &:nth-child(3n + 2) {\n    margin-right: ", "px;\n  }\n"])), function (e) {
  return e.theme.measurements.advancedCard.small.width;
}, function (e) {
  return e.theme.measurements.advancedCard.small.height;
}, function (e) {
  return e.theme.measurements.advancedSpacer;
}, function (e) {
  return e.theme.card.foreground;
}, function (e) {
  return e.theme.measurements.advancedSpacer;
}),
    _g = e(Wp)(Nd || (Nd = E(["\n  width: ", "px;\n  height: ", "px;\n  margin-bottom: ", "px;\n  color: ", ";\n  &:nth-child(2n + 1) {\n    margin-right: ", "px;\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  margin-bottom: ", "px;\n  color: ", ";\n  &:nth-child(2n + 1) {\n    margin-right: ", "px;\n  }\n"])), function (e) {
  return e.theme.measurements.advancedCard.medium.width;
}, function (e) {
  return e.theme.measurements.advancedCard.medium.height;
}, function (e) {
  return e.theme.measurements.advancedSpacer;
}, function (e) {
  return e.theme.card.foreground;
}, function (e) {
  return e.theme.measurements.advancedSpacer;
}),
    vg = e(Wp)(Ud || (Ud = E(["\n  width: ", "px;\n  height: ", "px;\n  margin-bottom: ", "px;\n  color: ", ";\n"], ["\n  width: ", "px;\n  height: ", "px;\n  margin-bottom: ", "px;\n  color: ", ";\n"])), function (e) {
  return e.theme.measurements.advancedCard.large.width;
}, function (e) {
  return e.theme.measurements.advancedCard.large.height;
}, function (e) {
  return e.theme.measurements.advancedSpacer;
}, function (e) {
  return e.theme.card.foreground;
}),
    bg = function bg(e) {
  e.isActive;
  var t = b(e, ["isActive"]);
  return r.createElement(vg, _v2({}, t));
},
    wg = function wg(e) {
  var t = e.type === z.LARGE,
      n = e.type === z.SMALL,
      i = _g;
  return t ? i = bg : n && (i = yg), r.createElement(i, _v2({}, e));
},
    xg = e.div(jd || (jd = E(["\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n"]))),
    kg = qp,
    Tg = e(Mp)(Wd || (Wd = E(["\n  &&& {\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    color: ", ";\n\n    ", " {\n      display: none;\n    }\n\n    &:disabled {\n      opacity: ", ";\n    }\n  }\n"], ["\n  &&& {\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    color: ", ";\n\n    ", " {\n      display: none;\n    }\n\n    &:disabled {\n      opacity: ", ";\n    }\n  }\n"])), function (e) {
  return e.theme.measurements.fontSystem.button2.size;
}, function (e) {
  return e.theme.measurements.fontSystem.button2.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.button2.case;
}, function (e) {
  return e.theme.button.textSecondaryForeground;
}, xp, function (e) {
  return e.theme.button.textInactiveOpacity;
}),
    Sg = e(Op)(Hd || (Hd = E(["\n  width: 60px;\n  height: 60px;\n  background-color: gray;\n  border-radius: 50%;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: ", ";\n  font-size: ", "px;\n  padding: 2px;\n"], ["\n  width: 60px;\n  height: 60px;\n  background-color: gray;\n  border-radius: 50%;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: ", ";\n  font-size: ", "px;\n  padding: 2px;\n"])), function (e) {
  return e.theme.measurements.zIndex.button.float;
}, function (e) {
  return e.theme.measurements.fontSystem.button1.size;
}),
    Cg = e.div(Gd || (Gd = E(["\n  height: 56px;\n  width: 56px;\n  border-radius: 50%;\n  background-color: ", ";\n"], ["\n  height: 56px;\n  width: 56px;\n  border-radius: 50%;\n  background-color: ", ";\n"])), function (e) {
  return e.theme.webcam.floatButton;
}),
    Eg = e.div(Vd || (Vd = E(["\n  display: inline-flex;\n"], ["\n  display: inline-flex;\n"]))),
    Og = e(Mp)(Xd || (Xd = E(["\n  &&& {\n    font-size: ", "px;\n    background: ", ";\n    color: ", ";\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    padding: 4px 10px;\n    position: relative;\n    /* for safari */\n    margin: 0;\n    &:last-child:after {\n      opacity: 0;\n    }\n  }\n"], ["\n  &&& {\n    font-size: ", "px;\n    background: ", ";\n    color: ", ";\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    padding: 4px 10px;\n    position: relative;\n    /* for safari */\n    margin: 0;\n    &:last-child:after {\n      opacity: 0;\n    }\n  }\n"])), function (e) {
  return e.theme.measurements.fontSystem.button1.size;
}, function (e) {
  return e.theme.canvasActionBar.background;
}, function (e) {
  return e.theme.canvasActionBar.foreground;
}, function (e) {
  return e.theme.measurements.fontSystem.button2.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.button2.case;
}),
    Rg = e.div(Kd || (Kd = E(["\n  ", ";\n  position: absolute;\n  transform: translate(-50%, -100%);\n  background: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  white-space: nowrap;\n  transition: opacity 0.3s ease-in-out;\n  z-index: ", ";\n\n  ", " {\n    &:after {\n      content: '';\n      position: absolute;\n      right: 0px;\n      top: 6px;\n      height: calc(100% - 12px);\n      border-right: 1px solid ", ";\n      &:last-child {\n        border-right: unset;\n      }\n    }\n  }\n"], ["\n  ", ";\n  position: absolute;\n  transform: translate(-50%, -100%);\n  background: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  white-space: nowrap;\n  transition: opacity 0.3s ease-in-out;\n  z-index: ", ";\n\n  ", " {\n    &:after {\n      content: '';\n      position: absolute;\n      right: 0px;\n      top: 6px;\n      height: calc(100% - 12px);\n      border-right: 1px solid ", ";\n      &:last-child {\n        border-right: unset;\n      }\n    }\n  }\n"])), function (e) {
  var t = e.show;
  return n(t ? Yd || (Yd = E(["\n          opacity: 1;\n        "], ["\n          opacity: 1;\n        "])) : qd || (qd = E(["\n          opacity: 0;\n        "], ["\n          opacity: 0;\n        "])));
}, function (e) {
  return e.theme.canvasActionBar.background;
}, function (e) {
  return e.theme.canvasActionBar.foreground;
}, function (e) {
  return e.theme.canvasActionBar.borderRadius ? e.theme.canvasActionBar.borderRadius : e.theme.shape.radiusMedium;
}, function (e) {
  return e.theme.measurements.zIndex.buttonGroup;
}, Og, function (e) {
  return e.theme.canvasActionBar.separatorColor;
}),
    Ig = e.div(Zd || (Zd = E(["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"], ["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"]))),
    Ag = e.canvas(Qd || (Qd = E(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"]))),
    Mg = e.div(eg || (eg = E(["\n  &&& {\n    display: ", ";\n    flex-direction: row;\n    align-items: center;\n    height: ", "px;\n    color: ", ";\n    border-bottom: 1px solid ", ";\n    padding: 8px 24px;\n    box-sizing: border-box;\n    position: absolute;\n    width: 100%;\n    z-index: ", ";\n    background: ", ";\n    ", "\n  }\n"], ["\n  &&& {\n    display: ", ";\n    flex-direction: row;\n    align-items: center;\n    height: ", "px;\n    color: ", ";\n    border-bottom: 1px solid ", ";\n    padding: 8px 24px;\n    box-sizing: border-box;\n    position: absolute;\n    width: 100%;\n    z-index: ", ";\n    background: ", ";\n    ", "\n  }\n"])), function (e) {
  return e.hide ? "none" : "flex";
}, function (e) {
  return e.theme.measurements.mainCanvasActionBar.height;
}, function (e) {
  return e.theme.mainCanvasActionBar.foreground;
}, function (e) {
  return e.theme.mainCanvasActionBar.borderColor;
}, function (e) {
  return e.theme.measurements.zIndex.canvas.bar;
}, function (e) {
  return e.transparentBackgound ? "transparent" : e.theme.mainCanvasActionBar.background;
}, function (e) {
  return e.bottom ? n(Jd || (Jd = E(["\n            justify-content: space-around;\n            bottom: 0;\n            transform: rotate(180deg);\n          "], ["\n            justify-content: space-around;\n            bottom: 0;\n            transform: rotate(180deg);\n          "]))) : n($d || ($d = E(["\n            justify-content: space-between;\n          "], ["\n            justify-content: space-between;\n          "])));
});

Mg.defaultProps = {
  theme: Xs
};
var Fg,
    Dg,
    Pg,
    zg = e.div.attrs({
  role: "main"
})(Fg || (Fg = E(["\n  background-color: ", ";\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* added this for safari, else the webcam overlay did not know the height */\n  height: 100%;\n  width: 100%;\n  margin-top: ", "px;\n"], ["\n  background-color: ", ";\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* added this for safari, else the webcam overlay did not know the height */\n  height: 100%;\n  width: 100%;\n  margin-top: ", "px;\n"])), function (e) {
  return e.theme.canvas.background;
}, function (e) {
  return e.theme.measurements.canvas.marginTop;
}),
    Lg = e.canvas(Dg || (Dg = E(["\n  position: absolute;\n  top: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n"]))),
    Bg = e.div(Pg || (Pg = E(["\n  position: relative;\n  transition: all 0.4s cubic-bezier(0.17, 0.04, 0.03, 0.94);\n  height: 100%;\n  width: 100%;\n  z-index: ", ";\n  background-color: ", ";\n"], ["\n  position: relative;\n  transition: all 0.4s cubic-bezier(0.17, 0.04, 0.03, 0.94);\n  height: 100%;\n  width: 100%;\n  z-index: ", ";\n  background-color: ", ";\n"])), function (e) {
  return e.theme.measurements.zIndex.canvas.webcam.backdrop;
}, function (e) {
  return e.theme.webcam.background;
});
Bg.defaultProps = {
  theme: Xs
};
var Ng,
    Ug,
    jg = e.video(Ng || (Ng = E(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"]))),
    Wg = e.div.attrs(function (e) {
  var t = e.radius;
  return {
    style: {
      height: 2 * t + "px",
      width: 2 * t + "px"
    }
  };
})(Ug || (Ug = E(["\n  border-radius: 50%;\n  border: 2px solid ", ";\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2), inset 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n  cursor: move;\n"], ["\n  border-radius: 50%;\n  border: 2px solid ", ";\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2), inset 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n  cursor: move;\n"])), function (e) {
  return e.theme.canvas.controlsOutline;
});
Wg.defaultProps = {
  theme: Xs
};
var Hg,
    Gg = e.div(Hg || (Hg = E(["\n  position: absolute;\n  color: ", ";\n"], ["\n  position: absolute;\n  color: ", ";\n"])), function (e) {
  return e.theme.canvas.controlsOutline;
});
Gg.defaultProps = {
  theme: Xs
};
var Vg,
    Xg = e.div(Vg || (Vg = E(["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  margin-left: -10px;\n  margin-top: -10px;\n  z-index: ", ";\n  will-change: transform;\n  cursor: ew-resize;\n  &:before {\n    display: block;\n    position: absolute;\n    content: '';\n    background: ", ";\n    border-radius: 50%;\n    width: ", "px;\n    height: ", "px;\n    top: ", "px;\n    left: ", "px;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);\n  }\n"], ["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  margin-left: -10px;\n  margin-top: -10px;\n  z-index: ", ";\n  will-change: transform;\n  cursor: ew-resize;\n  &:before {\n    display: block;\n    position: absolute;\n    content: '';\n    background: ", ";\n    border-radius: 50%;\n    width: ", "px;\n    height: ", "px;\n    top: ", "px;\n    left: ", "px;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);\n  }\n"])), function (e) {
  return e.theme.measurements.canvasControls.knob.touchable.desktop;
}, function (e) {
  return e.theme.measurements.canvasControls.knob.touchable.desktop;
}, function (e) {
  return e.theme.measurements.zIndex.canvas.knob;
}, function (e) {
  return e.theme.canvas.controlsColor;
}, function (e) {
  return e.theme.measurements.canvasControls.knob.size;
}, function (e) {
  return e.theme.measurements.canvasControls.knob.size;
}, function (e) {
  return e.theme.measurements.canvasControls.knob.size / 4;
}, function (e) {
  return e.theme.measurements.canvasControls.knob.size / 4;
});
Xg.defaultProps = {
  theme: Xs
};
var Yg,
    qg,
    Kg,
    Zg,
    Qg,
    Jg,
    $g,
    em,
    tm,
    nm,
    im,
    rm,
    om,
    am,
    sm,
    lm,
    um,
    cm,
    pm,
    fm,
    hm,
    dm,
    gm = e.div(function (e) {
  var t = e.theme.measurements.canvasControls.corner.touchable,
      i = t.desktop,
      r = t.mobile,
      o = i / 4,
      a = r / 2;
  return n(om || (om = E(["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  ", "\n  ", "\n  ", "\n  ", "\n  @media all and (min-width: 0) and (max-width: 599px) {\n    width: ", "px;\n    height: ", "px;\n    ", "\n    ", "\n  }\n"], ["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  ", "\n  ", "\n  ", "\n  ", "\n  @media all and (min-width: 0) and (max-width: 599px) {\n    width: ", "px;\n    height: ", "px;\n    ", "\n    ", "\n  }\n"])), i, i, function (e) {
    return "top" === e.vertical ? n(Yg || (Yg = E(["\n          top: 0px;\n        "], ["\n          top: 0px;\n        "]))) : n(qg || (qg = E(["\n          bottom: 0px;\n        "], ["\n          bottom: 0px;\n        "])));
  }, function (e) {
    return "left" === e.horizontal ? n(Kg || (Kg = E(["\n          left: 0px;\n        "], ["\n          left: 0px;\n        "]))) : n(Zg || (Zg = E(["\n          right: 0px;\n        "], ["\n          right: 0px;\n        "])));
  }, function (e) {
    return "top" === e.vertical ? n(Qg || (Qg = E(["\n          margin-top: -", "px;\n        "], ["\n          margin-top: -", "px;\n        "])), o) : n(Jg || (Jg = E(["\n          margin-bottom: -", "px;\n        "], ["\n          margin-bottom: -", "px;\n        "])), o);
  }, function (e) {
    return "left" === e.horizontal ? n($g || ($g = E(["\n          margin-left: -", "px;\n        "], ["\n          margin-left: -", "px;\n        "])), o) : n(em || (em = E(["\n          margin-right: -", "px;\n        "], ["\n          margin-right: -", "px;\n        "])), o);
  }, r, r, function (e) {
    return "top" === e.vertical ? n(tm || (tm = E(["\n            margin-top: -", "px;\n          "], ["\n            margin-top: -", "px;\n          "])), a) : n(nm || (nm = E(["\n            margin-bottom: -", "px;\n          "], ["\n            margin-bottom: -", "px;\n          "])), a);
  }, function (e) {
    return "left" === e.horizontal ? n(im || (im = E(["\n            margin-left: -", "px;\n          "], ["\n            margin-left: -", "px;\n          "])), a) : n(rm || (rm = E(["\n            margin-right: -", "px;\n          "], ["\n            margin-right: -", "px;\n          "])), a);
  });
}),
    mm = e(gm)(function (e) {
  var t = "right" === e.horizontal ? e.borderWidth : 0,
      i = "bottom" === e.vertical ? e.borderWidth : 0,
      r = "left" === e.horizontal ? e.borderWidth : 0,
      o = ("top" === e.vertical ? e.borderWidth : 0) + "px " + t + "px " + i + "px " + r + "px",
      a = "left" === e.horizontal && "bottom" === e.vertical || "right" === e.horizontal && "top" === e.vertical ? "nesw-resize" : "nwse-resize",
      s = e.theme.measurements.canvasControls.corner.touchable.desktop / 4 - e.borderWidth,
      l = e.theme.measurements.canvasControls.corner.touchable.mobile / 4 + e.borderWidth;
  return n(dm || (dm = E(["\n    &:before {\n      display: block;\n      position: absolute;\n      content: '';\n      width: ", "px;\n      height: ", "px;\n      z-index: ", ";\n      border-color: ", ";\n      border-style: solid;\n      border-width: ", ";\n      pointer-events: auto;\n      ", "\n      ", "\n      @media all and (min-width: 0) and (max-width: 599px) {\n        ", "\n        ", "\n      }\n    }\n    cursor: ", ";\n    pointer-events: none;\n  "], ["\n    &:before {\n      display: block;\n      position: absolute;\n      content: '';\n      width: ", "px;\n      height: ", "px;\n      z-index: ", ";\n      border-color: ", ";\n      border-style: solid;\n      border-width: ", ";\n      pointer-events: auto;\n      ", "\n      ", "\n      @media all and (min-width: 0) and (max-width: 599px) {\n        ", "\n        ", "\n      }\n    }\n    cursor: ", ";\n    pointer-events: none;\n  "])), function (e) {
    return e.theme.measurements.canvasControls.corner.size;
  }, function (e) {
    return e.theme.measurements.canvasControls.corner.size;
  }, function (e) {
    return e.theme.measurements.zIndex.canvas.controls;
  }, function (e) {
    return e.theme.canvas.controlsColor;
  }, o, "top" === e.vertical ? n(am || (am = E(["\n            top: ", "px;\n          "], ["\n            top: ", "px;\n          "])), s) : n(sm || (sm = E(["\n            bottom: ", "px;\n          "], ["\n            bottom: ", "px;\n          "])), s), "left" === e.horizontal ? n(lm || (lm = E(["\n            left: ", "px;\n          "], ["\n            left: ", "px;\n          "])), s) : n(um || (um = E(["\n            right: ", "px;\n          "], ["\n            right: ", "px;\n          "])), s), "top" === e.vertical ? n(cm || (cm = E(["\n              margin-top: ", "px;\n            "], ["\n              margin-top: ", "px;\n            "])), l) : n(pm || (pm = E(["\n              margin-bottom: ", "px;\n            "], ["\n              margin-bottom: ", "px;\n            "])), l), "left" === e.horizontal ? n(fm || (fm = E(["\n              margin-left: ", "px;\n            "], ["\n              margin-left: ", "px;\n            "])), l) : n(hm || (hm = E(["\n              margin-right: ", "px;\n            "], ["\n              margin-right: ", "px;\n            "])), l), a);
});
mm.defaultProps = {
  theme: Xs
};

var ym,
    _m = e.div(ym || (ym = E(["\n  position: absolute;\n  height: ", "px;\n  width: 4px;\n  z-index: ", ";\n  background: ", ";\n  cursor: pointer;\n"], ["\n  position: absolute;\n  height: ", "px;\n  width: 4px;\n  z-index: ", ";\n  background: ", ";\n  cursor: pointer;\n"])), function (e) {
  return e.theme.measurements.canvasControls.width.size;
}, function (e) {
  return e.theme.measurements.zIndex.canvas.controls;
}, function (e) {
  return e.theme.canvas.controlsColor;
});

_m.defaultProps = {
  theme: Xs
};
var vm,
    bm = e.div.attrs(function (e) {
  return {
    style: {
      height: e.height + "px",
      width: e.width + "px"
    }
  };
})(vm || (vm = E(["\n  border-style: solid;\n  border-width: 2px 0 2px 0;\n  border-color: ", ";\n  box-shadow: 0 -6px 6px -6px rgba(0, 0, 0, 0.2), inset 0 6px 6px -6px rgba(0, 0, 0, 0.2);\n  cursor: move;\n  position: absolute;\n"], ["\n  border-style: solid;\n  border-width: 2px 0 2px 0;\n  border-color: ", ";\n  box-shadow: 0 -6px 6px -6px rgba(0, 0, 0, 0.2), inset 0 6px 6px -6px rgba(0, 0, 0, 0.2);\n  cursor: move;\n  position: absolute;\n"])), function (e) {
  return e.theme.canvas.controlsOutline;
});
bm.defaultProps = {
  theme: Xs
};
var wm,
    xm = e.div.attrs(function (e) {
  var t = e.height,
      n = e.width,
      i = e.theme;
  return {
    style: {
      height: t + i.measurements.canvasControls.sprite.controlPadding + "px",
      width: n + i.measurements.canvasControls.sprite.controlPadding + "px"
    }
  };
})(wm || (wm = E(["\n  left: -", "px;\n  top: -", "px;\n  transform-origin: center center;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ", ";\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2), inset 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n  cursor: move;\n  will-change: transform;\n  position: absolute;\n"], ["\n  left: -", "px;\n  top: -", "px;\n  transform-origin: center center;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ", ";\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2), inset 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n  cursor: move;\n  will-change: transform;\n  position: absolute;\n"])), function (e) {
  return e.theme.measurements.canvasControls.sprite.controlPadding / 2;
}, function (e) {
  return e.theme.measurements.canvasControls.sprite.controlPadding / 2;
}, function (e) {
  return e.theme.canvas.controlsColor;
});
xm.defaultProps = {
  theme: Xs
};

var km,
    Tm,
    Sm,
    Cm,
    Em,
    Om,
    Rm,
    Im,
    Am,
    Mm,
    Fm = e.div.attrs(function (e) {
  return {
    style: {
      left: e.x + "px"
    }
  };
})(km || (km = E(["\n  position: absolute;\n  bottom: -", "px;\n  height: ", "px;\n  width: 2px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  bottom: -", "px;\n  height: ", "px;\n  width: 2px;\n  background-color: ", ";\n"])), function (e) {
  return e.theme.measurements.canvasControls.sprite.rotateHandle.height;
}, function (e) {
  return e.theme.measurements.canvasControls.sprite.rotateHandle.height;
}, function (e) {
  return e.theme.canvas.controlsOutline;
}),
    Dm = e.div(Tm || (Tm = E(["\n  position: relative;\n  height: inherit;\n  width: inherit;\n"], ["\n  position: relative;\n  height: inherit;\n  width: inherit;\n"]))),
    Pm = e.div.attrs({
  tabIndex: 0
})(Sm || (Sm = E(["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  top: 0;\n  left: 0;\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  top: 0;\n  left: 0;\n  &:focus {\n    outline: 0;\n  }\n"])), function (e) {
  return e.height;
}, function (e) {
  return e.width;
}),
    zm = (void 0 === Cm && (Cm = qe()), -1 !== Cm.indexOf("Safari") && -1 === Cm.indexOf("Chrome") ? n(Em || (Em = E(["\n      transition: unset;\n    "], ["\n      transition: unset;\n    "]))) : n(Om || (Om = E(["\n      transition: all 0.4s ease-in-out;\n    "], ["\n      transition: all 0.4s ease-in-out;\n    "])))),
    Lm = e.div(Rm || (Rm = E(["\n  position: absolute;\n  background: ", ";\n  z-index: ", ";\n  ", "\n"], ["\n  position: absolute;\n  background: ", ";\n  z-index: ", ";\n  ", "\n"])), function (e) {
  return e.theme.canvas.cropBackdrop;
}, function (e) {
  return e.theme.measurements.zIndex.canvas.crop.backdrop;
}, zm),
    Bm = e.div.attrs({
  "data-test-id": "CropMask"
})(Im || (Im = E(["\n  position: absolute;\n  box-shadow: inset 0 0 0 2px ", ";\n  cursor: move;\n  ", "\n"], ["\n  position: absolute;\n  box-shadow: inset 0 0 0 2px ", ";\n  cursor: move;\n  ", "\n"])), function (e) {
  return e.theme.canvas.controlsOutline;
}, zm),
    Nm = e.div(Am || (Am = E(["\n  position: absolute;\n  background: ", ";\n  z-index: ", ";\n  ", "\n"], ["\n  position: absolute;\n  background: ", ";\n  z-index: ", ";\n  ", "\n"])), function (e) {
  return e.theme.canvas.controlsOutline;
}, function (e) {
  return e.theme.measurements.zIndex.canvas.crop.grid;
}, zm),
    Um = e(mm)(Mm || (Mm = E(["\n  z-index: ", ";\n  ", ";\n"], ["\n  z-index: ", ";\n  ", ";\n"])), function (e) {
  return e.theme.measurements.zIndex.canvas.controls;
}, zm),
    jm = {
  Index: Ag,
  Area: Ig,
  Bar: {
    Index: Mg,
    ButtonGroup: Eg
  },
  Button: {
    TextSecondary: Tg,
    Float: function Float(e) {
      return r.createElement(Sg, _v2({}, e), r.createElement(Cg, null));
    }
  },
  Container: zg,
  Element: Lg,
  Wrapper: Bg,
  Webcam: jg,
  Controls: {
    Knob: Xg,
    Circle: Wg,
    Corner: mm,
    Line: Gg,
    Area: bm,
    Sprite: xm,
    RotateHandle: Fm,
    Container: Dm,
    Wrapper: Pm,
    SpriteActionsWrapper: Rg,
    SpriteActionButton: Og,
    Width: _m
  },
  Crop: {
    Mask: Bm,
    GridLine: Nm,
    Backdrop: Lm,
    Control: Um
  }
},
    Wm = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.init = function () {
      navigator.mediaDevices && navigator.mediaDevices.getUserMedia ? navigator.mediaDevices.getUserMedia({
        video: !0
      }).then(function (e) {
        n.video.srcObject = e;
      }).catch(function (e) {
        n.props.modal.showActionModal({
          identifier: "webcamUnavailable",
          error: e,
          handlers: n.modalHandler
        });
      }) : n.props.modal.showActionModal({
        identifier: "webcamUnavailable",
        error: "Webcam not supported",
        handlers: n.modalHandler
      });
    }, n.stop = function () {
      var e = n.props.active;
      n.video.srcObject.getTracks().forEach(function (e) {
        e.stop();
      }), n.video.srcObject = null, e.selectWebcam(!1);
    }, n.captureAndCloseWebcam = function () {
      n.canvas.width = n.video.videoWidth, n.canvas.height = n.video.videoHeight, n.canvas.getContext("2d").drawImage(n.video, 0, 0), n.props.active.newImage(n.canvas.toDataURL("image/webp")), n.stop();
    }, n.videoRef = r.createRef(), n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    var e = this;
    this.canvas = document.createElement("canvas"), this.video = this.videoRef.current, this.modalHandler = {
      buttonYes: function buttonYes() {
        e.props.active.selectWebcam(!1);
      }
    }, this.init();
  }, t.prototype.render = function () {
    var e = this.props.editor,
        t = e.getPreviewSize(),
        n = t.height,
        i = t.width,
        o = e.configStore.measurements,
        a = this.props.canvas.canvasSize.height,
        s = (a - n) / 2,
        l = s < 24 + o.buttons.float.size ? a - 48 - o.buttons.float.size / 2 : a - s + 24,
        u = this.props.active.webcamLabel;
    return r.createElement(jm.Wrapper, null, r.createElement(jm.Bar.Index, {
      transparentBackgound: !0,
      style: {
        justifyContent: "flex-end"
      }
    }, r.createElement(jm.Bar.ButtonGroup, null, r.createElement(Pp, {
      ariaLabel: u,
      onClick: this.stop
    }, u))), r.createElement(jm.Webcam, {
      style: {
        height: n,
        width: i
      },
      autoPlay: !0,
      ref: this.videoRef
    }), r.createElement(jm.Button.Float, {
      ariaLabel: "Click and Save",
      style: {
        top: l
      },
      onClick: this.captureAndCloseWebcam
    }));
  }, t;
}(r.Component),
    Hm = Gu("active", "canvas", "modal", "editor")(uc(Wm)),
    Gm = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.wrapperElementRef = null, n.timeout = null, n.updateDimensions = function (e) {
      void 0 === e && (e = !0), e ? (clearTimeout(n.timeout), n.timeout = setTimeout(function () {
        n.update(e);
      }, 100)) : n.update(e);
    }, n.update = function (e) {
      void 0 === e && (e = !0);
      var t = n.wrapperElementRef.current;
      n.props.canvas.saveDimensions({
        width: t && t.clientWidth || 0,
        height: t && t.clientHeight || 0,
        render: e
      });
    }, n.wrapperElementRef = r.createRef(), n.resizeObserver = new ws(function () {
      n.updateDimensions(!0);
    }), n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    var e = this;
    this.updateDimensions(!1), window.addEventListener("resize", function () {
      return e.updateDimensions(!0);
    }), this.wrapperElementRef.current && this.resizeObserver.observe(this.wrapperElementRef.current);
  }, t.prototype.componentWillUnmount = function () {
    var e = this;
    window.removeEventListener("resize", function () {
      return e.updateDimensions(!0);
    }), this.timeout && clearTimeout(this.timeout);
  }, t.prototype.render = function () {
    return r.createElement(jm.Container, {
      "data-test-id": "CanvasContainer",
      ref: this.wrapperElementRef
    }, this.props.children);
  }, t;
}(a),
    Vm = Gu("canvas")(uc(Gm)),
    Xm = function Xm(e, t) {
  return void 0 !== e && void 0 !== t && !Number.isNaN(e) && !Number.isNaN(t);
},
    Ym = e(jm.Controls.Knob)(Zm || (Zm = E(["\n  margin-top: -", "px;\n  margin-left: -", "px;\n"], ["\n  margin-top: -", "px;\n  margin-left: -", "px;\n"])), function (e) {
  return e.theme.measurements.canvasControls.knob.touchable.desktop / 2;
}, function (e) {
  return e.theme.measurements.canvasControls.knob.touchable.desktop / 2;
}),
    qm = e(jm.Controls.Container)(Qm || (Qm = E(["\n  overflow: unset;\n"], ["\n  overflow: unset;\n"]))),
    Km = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.start = function (e, n) {
      var i = n.x,
          r = n.y;
      Xm(i, r) && t.focusTool.setStart({
        x: i,
        y: r
      });
    }, t.end = function (e, n) {
      var i = n.x,
          r = n.y;
      Xm(i, r) && t.focusTool.setEnd({
        x: i,
        y: r
      });
    }, t.onKnob1DragStart = function (e, n) {
      t.focusTool.clickableCanvas(!1), t.start(e, n);
    }, t.onKnob1DragStop = function (e, n) {
      t.addSnapshot(n, t.historyLocale.focusPosition), t.start(e, n), t.focusTool.clickableCanvas(!0);
    }, t.onKnob2DragStart = function (e, n) {
      t.focusTool.clickableCanvas(!1), t.end(e, n);
    }, t.onKnob2DragStop = function (e, n) {
      t.addSnapshot(n, t.historyLocale.focusPosition), t.end(e, n), t.focusTool.clickableCanvas(!0);
    }, t.addSnapshot = function (e, n) {
      var i = e.x,
          r = e.y;
      Xm(i, r) && t.focusTool.toolSnapshot(n);
    }, t.getLine = function () {
      var e = t.props.canvas.canvasSize,
          n = e.height,
          i = e.width,
          o = t.focusTool.startOnPreview,
          a = t.focusTool.endOnPreview;
      return r.createElement("svg", {
        focusable: "false",
        height: n,
        width: i
      }, r.createElement("line", {
        x1: o.x,
        y1: o.y,
        x2: a.x,
        y2: a.y,
        strokeWidth: "2",
        stroke: "currentColor"
      }));
    }, t;
  }

  return _(t, e), Object.defineProperty(t.prototype, "focusTool", {
    get: function get() {
      return this.props.focusTool;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "historyLocale", {
    get: function get() {
      return this.focusTool.locale.history;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    return r.createElement(qm, null, r.createElement(jm.Controls.Line, null, this.getLine()), r.createElement(mg.Draggable, {
      bounds: "parent",
      position: this.focusTool.startOnPreview,
      onStart: this.onKnob1DragStart,
      onDrag: this.start,
      onStop: this.onKnob1DragStop
    }, r.createElement(Ym, null)), r.createElement(mg.Draggable, {
      bounds: "parent",
      onStart: this.onKnob2DragStart,
      onDrag: this.end,
      onStop: this.onKnob2DragStop,
      position: this.focusTool.endOnPreview
    }, r.createElement(Ym, null)));
  }, t;
}(r.Component);

Ym.defaultProps = {
  theme: Xs
};

var Zm,
    Qm,
    Jm,
    $m,
    ey = Gu("canvas", "focusTool")(uc(Km)),
    ty = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      knobAngle: 2.35
    }, t.onCircle = function (e, n) {
      var i = n.x,
          r = n.y;

      if (Xm(i, r)) {
        var o = t.focusTool.radius;
        t.focusTool.setCenter({
          x: i + o,
          y: r + o
        });
      }
    }, t.onKnob = function (e, n) {
      var i = n.x,
          r = n.y;

      if (Xm(i, r)) {
        var o = t.focusTool.center,
            a = new R(i, r),
            s = new R(o.x, o.y).subtract(a),
            l = s.magnitude,
            u = -Math.atan2(s.y, s.x);
        t.setState({
          knobAngle: u
        }), t.focusTool.setRadius(l);
      }
    }, t.onCircleDragStart = function (e, n) {
      t.focusTool.clickableCanvas(!1), t.onCircle(e, n);
    }, t.onCircleDragStop = function (e, n) {
      t.addSnapshot(n, t.historyLocale.focusPosition), t.onCircle(e, n), t.focusTool.clickableCanvas(!0);
    }, t.onKnobDragStart = function (e, n) {
      t.focusTool.clickableCanvas(!1), t.onKnob(e, n);
    }, t.onKnobDragStop = function (e, n) {
      t.addSnapshot(n, t.historyLocale.focusSize), t.onKnob(e, n), t.focusTool.clickableCanvas(!0);
    }, t.addSnapshot = function (e, n) {
      var i = e.x,
          r = e.y;
      Xm(i, r) && t.focusTool.toolSnapshot(n);
    }, t;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    this.setState({
      knobAngle: 2.35
    });
  }, Object.defineProperty(t.prototype, "historyLocale", {
    get: function get() {
      return this.focusTool.locale.history;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "focusTool", {
    get: function get() {
      return this.props.focusTool;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this.focusTool,
        t = e.center,
        n = e.radius,
        i = {
      x: t.x - n,
      y: t.y - n
    },
        o = Math.PI - this.state.knobAngle,
        a = {
      x: t.x + n * Math.cos(o),
      y: t.y + n * Math.sin(o)
    };
    return r.createElement(jm.Controls.Container, null, r.createElement(mg.Draggable, {
      bounds: "parent",
      onStart: this.onKnobDragStart,
      onDrag: this.onKnob,
      onStop: this.onKnobDragStop,
      position: a
    }, r.createElement(jm.Controls.Knob, null)), r.createElement(mg.Draggable, {
      onStart: this.onCircleDragStart,
      onDrag: this.onCircle,
      onStop: this.onCircleDragStop,
      position: i
    }, r.createElement(jm.Controls.Circle, {
      radius: n
    })));
  }, t;
}(r.Component),
    ny = Gu("focusTool", "canvas")(uc(ty)),
    iy = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.getKnobPosition = function () {
      var e = t.focusTool.origin,
          n = t.focusTool.size / 2,
          i = Math.PI / 2 + t.focusTool.rotation;
      return {
        x: e.x + n * Math.cos(i),
        y: e.y + n * Math.sin(i)
      };
    }, t.onArea = function (e, n) {
      var i = n.x,
          r = n.y,
          o = t.props.editor.configStore.measurements.canvasControls.knob.size;

      if (Xm(i, r)) {
        var a = t.props.canvas,
            s = t.focusTool,
            l = s.size,
            u = i + s.mirroredAreaWidth / 2,
            c = r + l / 2,
            p = new R(t.getKnobPosition()),
            f = new R({
          x: i,
          y: r
        }).subtract(new R(t.areaPosition)),
            h = p.add(f);
        h.x > o && h.x < a.canvasSize.width - o && h.y > o && h.y < a.canvasSize.height - o && t.focusTool.setOrigin({
          x: u,
          y: c
        });
      }
    }, t.onKnob = function (e, n) {
      var i = n.x,
          r = n.y;

      if (Xm(i, r)) {
        var o = new R(t.focusTool.origin),
            a = new R(i, r),
            s = o.subtract(a),
            l = s.magnitude,
            u = Math.PI / 2 + Math.atan2(s.y, s.x);
        t.focusTool.setSize(2 * l), t.focusTool.setRotation(u);
      }
    }, t.onAreaDragStop = function (e, n) {
      t.addSnapshot(n, t.historyLocale.focusPosition), t.onArea(e, n);
    }, t.onKnobDragStop = function (e, n) {
      t.addSnapshot(n, t.historyLocale.focusSize), t.onKnob(e, n);
    }, t.addSnapshot = function (e, n) {
      var i = e.x,
          r = e.y;
      Xm(i, r) && t.focusTool.toolSnapshot(n);
    }, t;
  }

  return _(t, e), Object.defineProperty(t.prototype, "historyLocale", {
    get: function get() {
      return this.focusTool.locale.history;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "focusTool", {
    get: function get() {
      return this.props.focusTool;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "areaPosition", {
    get: function get() {
      var e = this.focusTool,
          t = e.origin,
          n = e.size,
          i = e.mirroredAreaWidth;
      return {
        x: t.x - i / 2,
        y: t.y - n / 2
      };
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this.areaPosition,
        t = e.x,
        n = e.y;
    return r.createElement(jm.Controls.Container, null, r.createElement(mg.Draggable, {
      bounds: "parent",
      onStart: this.onKnob,
      onDrag: this.onKnob,
      onStop: this.onKnobDragStop,
      position: this.getKnobPosition()
    }, r.createElement(jm.Controls.Knob, null)), r.createElement(mg.Draggable, {
      onStart: this.onArea,
      onDrag: this.onArea,
      onStop: this.onAreaDragStop,
      position: {
        x: t,
        y: n
      },
      rotation: this.focusTool.rotation
    }, r.createElement(jm.Controls.Area, {
      height: this.focusTool.size,
      width: this.focusTool.mirroredAreaWidth
    })));
  }, t;
}(r.Component),
    ry = Gu("focusTool", "canvas", "editor")(uc(iy)),
    oy = Gu("focusTool")(uc(function (e) {
  var t = e.focusTool,
      n = t.state,
      i = function () {
    switch (n.identifier) {
      case ne.LINEAR:
        return ey;

      case ne.RADIAL:
        return ny;

      case ne.MIRRORED:
        return ry;
    }

    return null;
  }();

  return t.isOptionSelected && i ? r.createElement(i, null) : null;
})),
    ay = e(jm.Controls.Container)(Jm || (Jm = E(["\n  cursor: none;\n"], ["\n  cursor: none;\n"]))),
    sy = e.div($m || ($m = E(["\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border-width: 2px;\n  border-style: solid;\n  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 1);\n"], ["\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border-width: 2px;\n  border-style: solid;\n  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 1);\n"]))),
    ly = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.INITIAL_POSITION = {
      x: void 0,
      y: void 0
    }, n.state = _v2(_v2({}, n.INITIAL_POSITION), {
      isDrawing: !1
    }), n.containerElementRef = null, n.getCursorCoordinates = function (e) {
      var t = 0,
          i = 0;

      if (-1 !== e.type.indexOf("touch")) {
        if (!(r = e).touches.length) return _v2(_v2({}, n.INITIAL_POSITION), {
          height: 0,
          width: 0
        });
        t = r.touches[0].clientX, i = r.touches[0].clientY;
      } else {
        var r;
        t = (r = e).clientX, i = r.clientY;
      }

      var o = n.containerElementRef.current.getBoundingClientRect();
      return {
        x: t - o.left,
        y: i - o.top,
        height: o.height,
        width: o.width
      };
    }, n.draw = function (e) {
      e.preventDefault(), e.stopPropagation(), n.touchDraw(e);
    }, n.touchDraw = function (e) {
      var t = n.getCursorCoordinates(e),
          i = t.x,
          r = t.y;
      void 0 !== i && void 0 !== r && (n.setState({
        x: i,
        y: r
      }), n.state.isDrawing && n.brushTool.strokePosition({
        x: i,
        y: r
      }));
    }, n.start = function () {
      n.brushTool.clickableCanvas(!1), n.setState({
        isDrawing: !0
      }), n.brushTool.beginStroke();
    }, n.stop = function (e) {
      n.state.isDrawing && (e.preventDefault(), e.stopPropagation(), n.setState({
        isDrawing: !1
      }), n.brushTool.endStroke(), n.brushTool.clickableCanvas(!0));
    }, n.setInitialPosition = function () {
      n.setState(_v2({}, n.INITIAL_POSITION));
    }, n.mouseOut = function (e) {
      var t = n.props.config;
      e.preventDefault(), e.stopPropagation();
      var i = n.brushTool.sizeOnScreenSpace / 2,
          r = n.getCursorCoordinates(e),
          o = r.x,
          a = r.y,
          s = r.height,
          l = r.width;
      o && a && (o < 0 || a < 0 || o > l - i || a > s - i || a < t.measurements.mainCanvasActionBar.height) && n.setInitialPosition();
    }, n.touchEnd = function (e) {
      e.preventDefault(), e.stopPropagation();
      var t = n.state,
          i = t.x,
          r = t.y;
      i && r && n.setInitialPosition();
    }, n.getCursor = function () {
      var e = n.state,
          t = e.x,
          i = e.y;

      if (t && i) {
        var o = Qt(n.brushTool.color),
            a = n.brushTool.sizeOnScreenSpace + "px",
            s = {
          left: n.state.x + "px",
          top: n.state.y + "px",
          borderColor: o,
          height: a,
          width: a
        };
        return r.createElement(sy, {
          style: s
        });
      }

      return null;
    }, n.containerElementRef = r.createRef(), n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    document.addEventListener("mouseup", this.stop, !1), document.addEventListener("touchend", this.stop, {
      passive: !1
    });
  }, t.prototype.componentWillUnmount = function () {
    document.removeEventListener("mouseup", this.stop, !1), document.removeEventListener("touchend", this.stop, !1);
  }, Object.defineProperty(t.prototype, "brushTool", {
    get: function get() {
      return this.props.brushTool;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    return r.createElement(ay, {
      ref: this.containerElementRef,
      onMouseMove: this.draw,
      onTouchMove: this.touchDraw,
      onMouseDown: this.start,
      onTouchStart: this.start,
      onMouseOut: this.mouseOut,
      onTouchEnd: this.touchEnd
    }, this.getCursor());
  }, t;
}(r.Component),
    uy = Gu("brushTool", "config")(uc(ly));

var cy = function cy(e) {
  var t = e.height,
      n = e.width,
      i = e.x,
      o = e.className,
      a = e.style;
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n,
    height: t,
    viewBox: "0 0 102 3",
    className: o,
    style: a
  }, r.createElement("pattern", {
    id: "photoeditorsdk-slider-dots",
    fill: "currentColor",
    patternUnits: "userSpaceOnUse",
    width: "102",
    height: "3"
  }, r.createElement("rect", {
    width: "3",
    height: "3",
    x: "99",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), r.createElement("rect", {
    width: "3",
    height: "3",
    x: "88",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), r.createElement("rect", {
    width: "3",
    height: "3",
    x: "77",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), r.createElement("rect", {
    width: "3",
    height: "3",
    x: "66",
    y: "0",
    rx: "1.5"
  }), r.createElement("rect", {
    width: "3",
    height: "3",
    x: "55",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), r.createElement("rect", {
    width: "3",
    height: "3",
    x: "44",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), r.createElement("rect", {
    width: "3",
    height: "3",
    x: "33",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), r.createElement("rect", {
    width: "3",
    height: "3",
    x: "22",
    y: "0",
    opacity: "0.5",
    rx: "1.5"
  }), r.createElement("rect", {
    width: "3",
    height: "3",
    x: "11",
    y: "0",
    rx: "1.5"
  })), r.createElement("rect", {
    fill: "url(#photoeditorsdk-slider-dots)",
    x: 1.5 * -n,
    y: "0",
    width: 4 * n,
    height: "3",
    transform: "translate(" + i + ", 0)"
  }));
};

cy.defaultProps = {
  height: 3,
  width: 102,
  x: -102
};

var py = function py(e) {
  var t = e.alt,
      n = e.className;
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 16 16",
    className: n
  }, r.createElement("title", null, t), r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-rotate-icon",
    d: "M132 0l1.25 1.57a8.01 8.01 0 0110.41.77 8.015 8.015 0 010 11.32c-.33.33-.67.62-1.04.859-1.38.991-3 1.481-4.62 1.481v-2c1.22 0 2.44-.37 3.47-1.111a6 6 0 00.77-9.129 5.992 5.992 0 00-7.73-.63L136 5h-5l1-5zm2.43 12.82c.5.38 1.06.67 1.66.87l-.64 1.89a7.56 7.56 0 01-1.48-.67l-.03-.01v-.01h-.02v-.01h-.01c0-.01-.01-.01-.01-.01h-.01v-.01h-.02v-.01h-.01l-.01-.01s-.01 0-.01-.01h-.01c-.2-.12-.4-.26-.6-.4zm-2.15-3.02c.18.6.47 1.17.83 1.68l-1.63 1.16v-.01s-.01 0-.01-.01c0 0 0-.01-.01-.01v-.01h-.01v-.01c-.01 0-.01-.01-.01-.01v-.01h-.01v-.01h-.01v-.01c0-.01-.01-.01-.01-.01v-.01c-.01 0-.01 0-.01-.01-.27-.39-.49-.79-.68-1.21-.01 0-.01-.01-.01-.01v-.01h-.01v-.02l-.01-.01c0-.02-.01-.02-.01-.02v-.02h-.01v-.02h-.01v-.03h-.01v-.02h-.01v-.02c-.01 0-.01 0-.01-.01v-.01c-.1-.23-.19-.47-.26-.7z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    transform: "translate(-130)"
  }, r.createElement("mask", {
    fill: "none"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-rotate-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-rotate-icon"
  })));
};

py.defaultProps = {
  alt: "Rotate"
};

var fy,
    hy,
    dy,
    gy,
    my,
    yy,
    _y,
    vy,
    by,
    wy,
    xy,
    ky,
    Ty,
    Sy,
    Cy,
    Ey,
    Oy,
    Ry,
    Iy,
    Ay = e.svg.attrs({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
})(fy || (fy = E([""], [""]))),
    My = {
  adjustment: function adjustment() {
    return r.createElement("svg", {
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Adjustments",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, r.createElement("g", null, r.createElement("g", {
      fill: "#D8D8D8",
      opacity: "0"
    }, r.createElement("rect", {
      width: "48",
      height: "48"
    })), r.createElement("g", {
      transform: "translate(12 12)"
    }, r.createElement("rect", {
      fill: "#D8D8D8",
      opacity: "0",
      width: "24",
      height: "24"
    }), r.createElement("g", {
      transform: "translate(2 13)",
      fill: "currentColor"
    }, r.createElement("path", {
      d: "M3.02746439,4 C3.00931666,4.16416693 3,4.33099545 3,4.5 C3,4.66900455 3.00931666,4.83583307 3.02746439,5 L0,5 L0,4 L3.02746439,4 Z M13,4 L20,4 L20,5 L13,5 L13,4 Z",
      fillOpacity: "0.2"
    }), r.createElement("path", {
      d: "M5.09842503,6.29819429 C5.0340931,6.05140089 5,5.7851211 5,5.5 C5,3.56700338 6.56700338,2 8.5,2 C8.7851211,2 9.05140089,2.0340931 9.29819429,2.09842503 C10.0278893,2.64566496 10.5,3.5176988 10.5,4.5 C10.5,6.15685425 9.15685425,7.5 7.5,7.5 C6.5176988,7.5 5.64566496,7.02788926 5.09842503,6.29819429 Z M11.1637159,7.11349161 C10.874061,7.51881791 10.5188179,7.87406095 10.1134916,8.16371592 C10.5772175,7.93004328 10.9300433,7.5772175 11.1637159,7.11349161 Z",
      fillOpacity: "0.2"
    }), r.createElement("path", {
      d: "M7.5,7.5 C9.15685425,7.5 10.5,6.15685425 10.5,4.5 C10.5,2.84314575 9.15685425,1.5 7.5,1.5 C5.84314575,1.5 4.5,2.84314575 4.5,4.5 C4.5,6.15685425 5.84314575,7.5 7.5,7.5 Z M7.5,9 C5.01471863,9 3,6.98528137 3,4.5 C3,2.01471863 5.01471863,0 7.5,0 C9.98528137,0 12,2.01471863 12,4.5 C12,6.98528137 9.98528137,9 7.5,9 Z",
      fillOpacity: "0.87"
    })), r.createElement("g", {
      transform: "rotate(-180 11 5.5)",
      fill: "currentColor"
    }, r.createElement("path", {
      d: "M11.9725356,4 L20,4 L20,5 L11.9725356,5 C11.9906833,4.83583307 12,4.66900455 12,4.5 C12,4.33099545 11.9906833,4.16416693 11.9725356,4 Z M0,4 L2,4 L2,5 L0,5 L0,4 Z",
      fillOpacity: "0.2"
    }), r.createElement("g", {
      transform: "rotate(-180 5 3.5)",
      fillOpacity: "0.2"
    }, r.createElement("path", {
      d: "M0.0984250251,4.29819429 C0.0340930963,4.05140089 0,3.7851211 0,3.5 C0,1.56700338 1.56700338,0 3.5,0 C3.7851211,0 4.05140089,0.0340930963 4.29819429,0.0984250251 C5.02788926,0.645664963 5.5,1.5176988 5.5,2.5 C5.5,4.15685425 4.15685425,5.5 2.5,5.5 C1.5176988,5.5 0.645664963,5.02788926 0.0984250251,4.29819429 Z M6.16371592,5.11349161 C5.87406095,5.51881791 5.51881791,5.87406095 5.11349161,6.16371592 C5.5772175,5.93004328 5.93004328,5.5772175 6.16371592,5.11349161 Z"
    })), r.createElement("path", {
      d: "M7.5,7.5 C9.15685425,7.5 10.5,6.15685425 10.5,4.5 C10.5,2.84314575 9.15685425,1.5 7.5,1.5 C5.84314575,1.5 4.5,2.84314575 4.5,4.5 C4.5,6.15685425 5.84314575,7.5 7.5,7.5 Z M7.5,9 C5.01471863,9 3,6.98528137 3,4.5 C3,2.01471863 5.01471863,-3.6739404e-16 7.5,-3.6739404e-16 C9.98528137,-3.6739404e-16 12,2.01471863 12,4.5 C12,6.98528137 9.98528137,9 7.5,9 Z",
      fillOpacity: "0.87"
    }))))));
  },
  filter: function filter() {
    return r.createElement("svg", {
      "aria-hidden": "true",
      focusable: "false",
      "aria-label": "Filter",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, r.createElement("g", null, r.createElement("g", {
      fill: "#D8D8D8",
      opacity: "0"
    }, r.createElement("rect", {
      width: "48",
      height: "48"
    })), r.createElement("g", {
      transform: "translate(16 14)",
      fill: "currentColor"
    }, r.createElement("g", null, r.createElement("path", {
      d: "M1.53468397,11.3244256 C2.30584171,10.1516526 4.0927284,8.69757613 8,10 C11.5643313,11.1881104 13.1877038,10.2588113 13.9183327,9.30853287 C14.2918933,10.1286474 14.5,11.0400207 14.5,12 C14.5,15.5898509 11.5898509,18.5 8,18.5 C4.41014913,18.5 1.5,15.5898509 1.5,12 C1.5,11.7718729 1.51175212,11.5464906 1.53468397,11.3244256 Z",
      fillOpacity: "0.2"
    }), r.createElement("path", {
      d: "M1.53471819,12.6759057 C2.39408133,13.5811739 4.12541941,14.1109247 5.5,13.5 C9.81068889,11.5841383 9.99203585,9.66827654 14.3948028,10.8290113 C14.4639074,11.2088572 14.5,11.6002137 14.5,12 C14.5,15.5898509 11.5898509,18.5 8,18.5 C4.63838968,18.5 1.87279864,15.9481381 1.53471819,12.6759057 Z",
      fillOpacity: "0.25"
    }), r.createElement("path", {
      d: "M11,1.44328993e-15 L11,4.58151705 C13.9318303,5.7682918 16,8.64262245 16,12 C16,16.418278 12.418278,20 8,20 C3.581722,20 0,16.418278 0,12 C0,8.64262245 2.06816966,5.7682918 5,4.58151705 L5,1.60982339e-15 L6.5,1.44328993e-15 L6.5,5.67393184 C3.6333,6.35109564 1.5,8.92641836 1.5,12 C1.5,15.5898509 4.41014913,18.5 8,18.5 C11.5898509,18.5 14.5,15.5898509 14.5,12 C14.5,8.92641836 12.3667,6.35109564 9.5,5.67393184 L9.5,1.77635684e-15 L11,1.44328993e-15 Z",
      fillOpacity: "0.87"
    }))))));
  },
  library: function library() {
    return r.createElement("svg", {
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Library",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, r.createElement("g", {
      transform: "translate(15 15)",
      fill: "currentColor"
    }, r.createElement("g", null, r.createElement("polygon", {
      fillOpacity: "0.2",
      points: "3 3 12.5 1.5 12.5 15.5 1.5 15.5"
    }), r.createElement("path", {
      d: "M1.5,1.5 L1.5,15.5 L12.5,15.5 L12.5,1.5 L1.5,1.5 Z M0,0 L14,0 L14,17 L0,17 L0,0 Z",
      fillOpacity: "0.87"
    }), r.createElement("polygon", {
      fillOpacity: "0.25",
      points: "3 11 6 7 8 9 9 8.5 11 11"
    }), r.createElement("circle", {
      fillOpacity: "0.25",
      cx: "9",
      cy: "5",
      r: "1"
    }), r.createElement("rect", {
      fillOpacity: "0.25",
      x: "3",
      y: "13",
      width: "8",
      height: "1"
    }), r.createElement("g", {
      transform: "rotate(14 -2.352 56.952)",
      fillOpacity: "0.2"
    }, r.createElement("path", {
      d: "M1.32904158,1.07500967e-13 L5,1.07500967e-13 L5,14.7234101 L4,10.7126291 L4,1 L1.57836958,1 L1.32904158,1.07500967e-13 Z M5,14.9745817 L5,16 L0.887271787,16 L5,14.9745817 Z"
    }), r.createElement("path", {
      d: "M1.82769758,2 L3,2 L3,6.70184819 L1.82769758,2 Z"
    }))))));
  },
  overlay: function overlay() {
    return r.createElement("svg", {
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Overlays",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, r.createElement("g", {
      transform: "translate(15 15)",
      fill: "currentColor"
    }, r.createElement("path", {
      d: "M13.5,4 L13.5,13.5 L4,13.5 L4,5 C4,4.44771525 4.44771525,4 5,4 L13.5,4 Z M15,4 L17,4 C17.5522847,4 18,4.44771525 18,5 L18,17 C18,17.5522847 17.5522847,18 17,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,15 L14,15 C14.5522847,15 15,14.5522847 15,14 L15,4 Z",
      fillOpacity: "0.2"
    }), r.createElement("path", {
      d: "M1.5,1.5 L1.5,13.5 L13.5,13.5 L13.5,1.5 L1.5,1.5 Z M1,0 L14,0 C14.5522847,-1.01453063e-16 15,0.44771525 15,1 L15,14 C15,14.5522847 14.5522847,15 14,15 L1,15 C0.44771525,15 6.76353751e-17,14.5522847 0,14 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
      fillOpacity: "0.87"
    }))));
  },
  focus: function focus() {
    return r.createElement("svg", {
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Focus",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, r.createElement("g", null, r.createElement("g", {
      fill: "#D8D8D8",
      opacity: "0"
    }, r.createElement("rect", {
      width: "48",
      height: "48"
    })), r.createElement("g", {
      transform: "translate(12 12)"
    }, r.createElement("rect", {
      fill: "#D8D8D8",
      opacity: "0",
      width: "24",
      height: "24"
    }), r.createElement("g", {
      transform: "translate(4 2)",
      fill: "currentColor"
    }, r.createElement("path", {
      d: "M8.51312274,19.9836057 C8.77273397,19.9669655 9.02898229,19.9377873 9.2812837,19.8966625 C9.14309542,19.9643562 9.04607398,20 9,20 C8.83633495,20 8.67398178,19.9944755 8.51312274,19.9836057 Z M2.27242753,15.0235117 C2.09503729,14.4174909 2,13.7771617 2,13.115 C2,8.89625769 7.39855682,4.1952443 9.03524007,2.8669743 C9.66704719,3.45933018 10.2896864,4.09178959 10.8802638,4.75434357 C12.9939648,7.12565193 14.310818,9.45010207 14.481291,11.4644804 C14.4937541,11.6117488 14.5,11.7569175 14.5,11.9 C14.5,15.5490785 11.5855665,18.5 8,18.5 C5.525182,18.5 3.37015673,17.0943182 2.27242753,15.0235117 Z M15.999821,11.9547651 C15.9999402,11.9698392 16,11.9849176 16,12 C16,12.0581275 15.9984809,12.1163475 15.9954873,12.1746435 C15.9978914,12.1015915 15.9993401,12.0282946 15.999821,11.9547651 Z",
      fillOpacity: "0.2"
    }), r.createElement("path", {
      d: "M3.47269084,16.6357644 C3.47244857,13.6389249 9.59189484,15.3529683 12,11.5 C13.2066771,9.56931667 12.316614,7.05620551 11.0727604,4.97270186 C13.0737756,7.26814668 14.316054,9.51197209 14.481291,11.4644804 C14.4937541,11.6117488 14.5,11.7569175 14.5,11.9 C14.5,15.5490785 11.5855665,18.5 8,18.5 C6.2411126,18.5 4.64375705,17.7899702 3.47269084,16.6357644 Z",
      fillOpacity: "0.25"
    }), r.createElement("path", {
      d: "M7.73975027,2.16383649 C6.84545319,2.94914111 5.95084629,3.82194197 5.11973623,4.75434357 C3.00603518,7.12565193 1.68918197,9.45010207 1.51870896,11.4644804 C1.50624591,11.6117488 1.5,11.7569175 1.5,11.9 C1.5,15.5492218 4.41434886,18.5 8,18.5 C11.5855665,18.5 14.5,15.5490785 14.5,11.9 C14.5,11.7569175 14.4937541,11.6117488 14.481291,11.4644804 C14.310818,9.45010207 12.9939648,7.12565193 10.8802638,4.75434357 C10.0491537,3.82194197 9.15454681,2.94914111 8.26024973,2.16383649 C8.17157048,2.08596503 8.08476013,2.01060875 8,1.93784184 C7.91523987,2.01060875 7.82842952,2.08596503 7.73975027,2.16383649 Z M8,20 C3.581722,20 0,16.3735065 0,11.9 C0,6.05 8,0 8,0 C8,0 16,6.05 16,11.9 C16,16.3732777 12.418278,20 8,20 Z",
      fillOpacity: "0.87"
    }))))));
  },
  sticker: function sticker() {
    return r.createElement("svg", {
      focusable: "false",
      "aria-hidden": "true",
      width: "48px",
      height: "48px",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Stickers",
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, r.createElement("g", null, r.createElement("g", {
      transform: "translate(14.000000, 14.000000)",
      fill: "currentColor"
    }, r.createElement("g", {
      transform: "translate(2.000000, 2.000000)",
      fillOpacity: "0.2"
    }, r.createElement("path", {
      d: "M11.5840291,0.290311095 C14.1040281,1.4637822 15.9529364,3.83641178 16.3972985,6.6747443 C11.4538042,7.5567274 7.55733385,11.4556991 6.68374109,16.3973312 C3.83946575,15.9530468 1.46423317,14.1041207 0.290132399,11.5832649 C0.0988489957,10.7650202 3.01980663e-14,9.89786431 3.01980663e-14,9 C3.01980663e-14,6.64646143 0.903391324,4.50392121 2.38232909,2.90022422 C4.02683831,1.11698861 6.38297582,-3.55271368e-15 9,-3.55271368e-15 C9.89814387,-3.55271368e-15 10.7655602,0.0989105588 11.5840291,0.290311095 Z"
    }), r.createElement("path", {
      d: "M17.9877222,8 L8,17.9877222 C8.2591955,12.5923102 12.5906864,8.26470667 17.9877222,8 Z"
    })), r.createElement("path", {
      d: "M9.87290303,14.9211604 C9.09408801,14.4293124 5,11.7146562 5,9 C5,7.34 6.34,6 8,6 C8.77,6 9.47,6.52 10,7 C10.53,6.52 11.23,6 12,6 C13.66,6 15,7.34 15,9 C15,9.30171667 14.9494261,9.60343334 14.8584511,9.90209822 C12.7354304,11.0373368 10.9933363,12.7905402 9.87290303,14.9211604 Z",
      fillOpacity: "0.25"
    }), r.createElement("path", {
      d: "M10,1.5 C5.30557963,1.5 1.5,5.30557963 1.5,10 C1.5,14.2449983 4.61102233,17.7611603 8.68374109,18.3973312 C9.55733385,13.4556991 13.4538042,9.5567274 18.3972985,8.6747443 C17.7608961,4.60976745 14.2436106,1.5 10,1.5 Z M0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C14.5988732,10.2649073 10.2649073,14.5988732 10.0116954,19.9999933 C4.4771525,20 0,15.5228475 0,10 Z",
      fillOpacity: "0.87"
    })))));
  },
  text: function text() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 48 48",
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Texts",
      width: "48",
      height: "48"
    }, r.createElement("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("path", {
      fillOpacity: "0.2",
      d: "M17.883 19.5H16.07L11.702 6.833l1.235-1.411L17.883 19.5z",
      transform: "translate(12 12)"
    }), r.createElement("path", {
      fillOpacity: "0.87",
      d: "M10.8 8.818L8.483 14.5h4.275l-1.96-5.682zM10 6.5l3.5-4 5.973 17H21V21h-8v-1.5h1.483L13.276 16H7.873l-1.426 3.5H8V21H3v-1.5h1.704L10 6.5zm1.702.333L16.069 19.5h1.814L12.937 5.422l-1.235 1.411z",
      transform: "translate(12 12)"
    }), r.createElement("path", {
      fillOpacity: "0.2",
      d: "M19.55 15l-.35-1H21v1h-1.45zm1.05 3l-.35-1H21v1h-.4zM7.639 8L7.25 9H3V8h4.639zm1.167-3l-.39 1H7V5h1.806zm-2.334 6l-.389 1H6v-1h.472zm-1.166 3l-.39 1H3v-1h2.306zm-1.167 3l-.389 1H3v-1h1.139zM15.35 3L15 2h1v1h-.65zm3.15 9l-.35-1H21v1h-2.5zm-1.05-3l-.35-1H21v1h-3.55zM16.4 6l-.35-1H18v1h-1.6zm-5.9-3H9V2h2.5l-1 1zM3 5h3v1H3V5zm16 0h2v1h-2V5zM3 11h2v1H3v-1zm18-8h-4V2h4v1zM8 3H3V2h5v1z",
      transform: "translate(12 12)"
    })));
  },
  textdesign: function textdesign() {
    return r.createElement("svg", {
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Text Design",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg"
    }, r.createElement("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("path", {
      fillOpacity: "0.87",
      d: "M1 0h14a1 1 0 011 1v19l-8-6-8 6V1a1 1 0 011-1zm.5 1.5V17L8 12.125 14.5 17V1.5h-13z",
      transform: "translate(14 14) translate(2)"
    }), r.createElement("path", {
      fillOpacity: "0.2",
      d: "M1.5 1.5h13V17L8 12.125 1.5 17V1.5z",
      transform: "translate(14 14) translate(2)"
    }), r.createElement("path", {
      fillOpacity: "0.25",
      d: "M9 4l2.52 7H10.2l-.7-1.85H6.45L5.77 11H4.49L6.9 4H9zm-1.04.78h-.05L6.73 8.14H9.2L7.96 4.78z",
      transform: "translate(14 14) translate(2)"
    })));
  },
  frame: function frame() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Frames",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      transform: "translate(12 12)"
    }, r.createElement("path", {
      fillOpacity: "0.2",
      d: "M8 8L17 7 17 17 7 17z"
    }), r.createElement("path", {
      fillOpacity: "0.87",
      d: "M4.5 19.5h15v-15h-15v15zM3 3h18v18H3V3z"
    }), r.createElement("path", {
      fillOpacity: "0.87",
      d: "M7 17h10V7H7v10zM6 6h12v12H6V6z"
    }), r.createElement("path", {
      fillOpacity: "0.25",
      d: "M9 15L11 12 13 14 14 13.5 15 15z"
    })));
  },
  transform: function transform() {
    return r.createElement("svg", {
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Transform",
      width: "48",
      height: "48",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      transform: "translate(12 12)"
    }, r.createElement("path", {
      fillOpacity: "0.2",
      d: "M10 10L15 9 15 15 9 15z"
    }), r.createElement("path", {
      fillOpacity: "0.87",
      d: "M9 15h6V9H9v6zm-1.5 0V7.5H15V3h1.5v13.5H3V15h4.5zm0 2.5H9V21H7.5v-3.5zM21 7.5V9h-3.5V7.5H21z"
    }), r.createElement("g", {
      fillOpacity: "0.2"
    }, r.createElement("path", {
      d: "M0 10h1a9.003 9.003 0 015.5-8.294L7 3 10.942.044C10.632.014 10.318 0 10 0 4.477 0 0 4.477 0 10z",
      transform: "translate(2 2)"
    }), r.createElement("path", {
      d: "M9 20h1a9.003 9.003 0 015.5-8.294L16 13l3.942-2.956c-.31-.03-.624-.044-.942-.044-5.523 0-10 4.477-10 10z",
      transform: "translate(2 2) rotate(-180 14.47 15)"
    }))));
  },
  brush: function brush() {
    return r.createElement("svg", {
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Brush",
      width: "48",
      height: "48",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("path", {
      fillOpacity: "0.87",
      d: "M14.73 18.86C13.293 19.503 11.624 20 10 20 2 20 0 13 0 10c.486.972 2.37 5.848 7.537 4.165C7.873 17.125 10.427 19 13 19c.6 0 1.177-.05 1.73-.14zM8.422 8.63a7.352 7.352 0 00-1.127 1.616L2.401 3.705c-.215-.287-.178-.807.072-1.056l.088-.088L8.5 8.5l-.078.13z",
      opacity: "0.5",
      transform: "translate(12 12) translate(2 2)"
    }), r.createElement("path", {
      fillOpacity: "0.87",
      d: "M7.295 10.246c-.27.526-.48 1.09-.615 1.68L1.2 4.603c-.663-.885-.564-2.24.212-3.015l.176-.176c.78-.78 2.121-.881 3.015-.212l7.245 5.421a6.088 6.088 0 00-1.67.624L3.706 2.401c-.294-.22-.801-.184-1.056.072l-.176.176c-.25.25-.287.769-.072 1.056l4.894 6.54z",
      transform: "translate(12 12) translate(2 2)"
    }), r.createElement("path", {
      fillOpacity: "0.87",
      d: "M9.702 6.554c-.185-.869-.151-.71-.207-.955C8.88 2.902 8.145 2 6 2 3.98 2 2 4.08 2 6.5c0 2.294 1.835 4 4 4 1.545 0 2.915-.342 4.544-1.088-.332-.7-.578-1.619-.842-2.858z",
      opacity: "0.5",
      transform: "translate(12 12) translate(2 2) translate(7 7)"
    }), r.createElement("path", {
      fillOpacity: "0.25",
      d: "M10.379 9.027c.053.135.108.263.165.385C8.914 10.158 7.545 10.5 6 10.5c-2.165 0-4-1.706-4-4 0-1.528.79-2.921 1.88-3.74-.882 2.084-1.025 6.482 6.499 6.267z",
      transform: "translate(12 12) translate(2 2) translate(7 7)"
    }), r.createElement("path", {
      fillOpacity: "0.87",
      d: "M9.702 6.554c-.185-.869-.151-.71-.207-.955C8.88 2.902 8.145 2 6 2 3.98 2 2 4.08 2 6.5c0 2.294 1.835 4 4 4 1.545 0 2.915-.342 4.544-1.088-.332-.7-.578-1.619-.842-2.858zM6 12C3.239 12 .5 9.842.5 6.5S3.239.5 6 .5c6.5 0 4 8 7 9.342C11 10.947 8.761 12 6 12z",
      transform: "translate(12 12) translate(2 2) translate(7 7)"
    })));
  }
},
    Fy = {
  left: function left() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 48 48",
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Left Align",
      width: "26",
      height: "26"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-align-left-icon",
      d: "M27 30v3H12v-3h15zm9-7.5v3H12v-3h24zm0-7.5v3H12v-3h24z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("mask", {
      fill: "#fff"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-align-left-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      xlinkHref: "#photoeditorsdk-align-left-icon"
    })));
  },
  right: function right() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 48 48",
      width: "26",
      height: "26",
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Right Align"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-align-right-icon",
      d: "M27 30v3H12v-3h15zm9-7.5v3H12v-3h24zm0-7.5v3H12v-3h24z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("path", {
      d: "M0 0H48V48H0z"
    }), r.createElement("mask", {
      fill: "#fff"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-align-right-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      transform: "matrix(-1 0 0 1 48 0)",
      xlinkHref: "#photoeditorsdk-align-right-icon"
    })));
  },
  center: function center() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 48 48",
      focusable: "false",
      "aria-hidden": "true",
      "aria-label": "Center Align",
      width: "26",
      height: "26"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-align-center-icon",
      d: "M31.5 30v3h-15v-3h15zm4.5-7.5v3H12v-3h24zm0-7.5v3H12v-3h24z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("mask", {
      fill: "#fff"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-align-center-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      xlinkHref: "#photoeditorsdk-align-center-icon"
    })));
  }
},
    Dy = {
  addText: function addText() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-icon-add-text",
      d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm1 6h-2v5H6v2h5v5h2v-5h5v-2h-5V6z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("mask", {
      fill: "currentColor"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-icon-add-text"
    })), r.createElement("use", {
      fill: "currentColor",
      fillRule: "nonzero",
      xlinkHref: "#photoeditorsdk-icon-add-text"
    })));
  },
  openWebcam: function openWebcam() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("path", {
      fill: "currentColor",
      fillOpacity: "0.9",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      d: "M12 1c5.523 0 10 4.477 10 10a9.98 9.98 0 01-3.678 7.749c1.877.92 3.445 2.251 4.502 3.88l.176.283-1.743 1.02c-1.04-1.735-2.824-3.102-4.995-3.884A9.94 9.94 0 0112 21a9.962 9.962 0 01-4.255-.948c-2.076.748-3.797 2.033-4.852 3.661l-.147.237L1 22.935c1.053-1.766 2.694-3.204 4.684-4.183A9.975 9.975 0 012 11C2 5.477 6.477 1 12 1zm0 2a8 8 0 100 16 8 8 0 000-16zm0 5a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6zm1-4v1h-2V6h2z"
    }));
  },
  reset: function reset() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("path", {
      fill: "currentColor",
      fillOpacity: "0.9",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      d: "M16.23 10.885a2.292 2.292 0 00-2.285-2.286 2.292 2.292 0 00-2.286 2.286 2.292 2.292 0 002.286 2.286 2.292 2.292 0 002.286-2.286zM13.946.599C8.265.6 3.66 5.205 3.66 10.885H.231l4.571 4.571 4.572-4.571H5.945c0-4.423 3.577-8 8-8s8 3.577 8 8a7.994 7.994 0 01-12.64 6.514l-1.623 1.646a10.3 10.3 0 006.263 2.126c5.68 0 10.286-4.606 10.286-10.286S19.625.599 13.945.599z",
      transform: "rotate(56 11.298 10.261)"
    }));
  },
  shuffle: function shuffle() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-shuffle-icon",
      d: "M24 10v8a3 3 0 01-3 3H6v3l-6-4 6-4v3h15a1 1 0 001-1v-8h2zM18 0l6 4-6 4V5H3a1 1 0 00-1 1v8H0V6a3 3 0 013-3h15V0z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("mask", {
      fill: "currentColor"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-shuffle-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      fillOpacity: "0.9",
      xlinkHref: "#photoeditorsdk-shuffle-icon"
    })));
  },
  uploadImage: function uploadImage() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-upload-icon",
      d: "M4.143 17.286l-.001 3.142h15.715v-3.142H23v6.285H1v-6.285h3.143zM12 0l9.429 9.429-2.2 2.2L13.57 5.97v9.743H10.43V5.971L4.77 11.63l-2.2-2.2L12 0z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("mask", {
      fill: "currentColor"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-upload-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      xlinkHref: "#photoeditorsdk-upload-icon"
    })));
  }
},
    Py = function Py() {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-undo-icon",
    d: "M4 10.065C4 4.506 8.365 0 13.75 0s9.75 4.506 9.75 10.065v9.29h-3v-9.29c0-3.849-3.022-6.968-6.75-6.968S7 6.217 7 10.065v7.741h3L5.5 24 1 17.806h3v-7.741z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-undo-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    transform: "rotate(90 12.25 12)",
    xlinkHref: "#photoeditorsdk-undo-icon"
  })));
},
    zy = function zy() {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-redo-icon",
    d: "M4 10.065C4 4.506 8.365 0 13.75 0s9.75 4.506 9.75 10.065v9.29h-3v-9.29c0-3.849-3.022-6.968-6.75-6.968S7 6.217 7 10.065v7.741h3L5.5 24 1 17.806h3v-7.741z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-redo-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    transform: "matrix(0 1 1 0 .25 -.25)",
    xlinkHref: "#photoeditorsdk-redo-icon"
  })));
},
    Ly = function Ly() {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-close-icon",
    d: "M21.583 0L24 2.416 14.416 12 24 21.584 21.583 24 12 14.416 2.417 24 0 21.584 9.584 12 0 2.416 2.417 0 12 9.584 21.583 0z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-close-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#photoeditorsdk-close-icon"
  })));
},
    By = function By() {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-export-icon",
    d: "M22 1.5a1.5 1.5 0 011.493 1.356L23.5 3H22h1.5v17a1.5 1.5 0 01-1.5 1.5H12a1.5 1.5 0 01-1.493-1.356L10.5 20v-6h2v5.499h9v-16h-9V9h-2V3A1.5 1.5 0 0112 1.5h10zM6.15 5.817L7.634 7.3l-3.171 3.171h13.978v2H4.47l3.171 3.17-1.483 1.483L.5 11.467l5.65-5.65z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("mask", {
    fill: "#fff"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-export-icon"
  })), r.createElement("use", {
    fill: "currentcolor",
    fillOpacity: "0.9",
    transform: "rotate(90 12 11.5)",
    xlinkHref: "#photoeditorsdk-export-icon"
  })));
},
    Ny = {
  categories: (hy = {}, hy[_e.CommonCategory] = function () {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillOpacity: "0.9",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      fill: "currentColor",
      transform: "translate(13 13)"
    }, r.createElement("path", {
      d: "M22 3.701h-1.642V1.644l-2.06-.001V0h2.538c.421 0 .682.174.827.32.322.322.337.748.337.83v2.551z"
    }), r.createElement("path", {
      d: "M1.643 3.701H0V1.165C0 .743.174.482.32.336.64.016 1.06 0 1.147 0H3.701v1.643H1.644l-.001 2.058z"
    }), r.createElement("path", {
      d: "M13.7232174 1.5486087L17.4249565 1.5486087 17.4249565 0 13.7232174 0z"
    }), r.createElement("path", {
      d: "M9.15008696 1.5486087L12.8508696 1.5486087 12.8508696 0 9.15008696 0z"
    }), r.createElement("path", {
      d: "M4.57504348 1.5486087L8.27678261 1.5486087 8.27678261 0 4.57504348 0z"
    }), r.createElement("path", {
      d: "M0 8.27582609L1.5486087 8.27582609 1.5486087 4.57504348 0 4.57504348z"
    }), r.createElement("path", {
      d: "M20.4513913 8.27582609L22 8.27582609 22 4.57504348 20.4513913 4.57504348z"
    }), r.createElement("path", {
      d: "M0 12.8508696L1.5486087 12.8508696 1.5486087 9.14913043 0 9.14913043z"
    }), r.createElement("path", {
      d: "M0 17.4249565L1.5486087 17.4249565 1.5486087 13.7232174 0 13.7232174z"
    }), r.createElement("path", {
      d: "M20.4513913 12.8508696L22 12.8508696 22 9.14913043 20.4513913 9.14913043z"
    }), r.createElement("path", {
      d: "M20.4513913 17.4249565L22 17.4249565 22 13.7232174 20.4513913 13.7232174z"
    }), r.createElement("path", {
      d: "M3.702 22H1.165c-.421 0-.682-.174-.828-.32-.322-.322-.337-.748-.337-.83v-2.552h1.643v2.059h2.059V22z"
    }), r.createElement("path", {
      d: "M20.853 22h-2.554v-1.642h2.057l.001-2.06H22v2.538c0 .42-.174.682-.319.827-.32.32-.742.337-.828.337"
    }), r.createElement("path", {
      d: "M4.57504348 22L8.27678261 22 8.27678261 20.4513913 4.57504348 20.4513913z"
    }), r.createElement("path", {
      d: "M9.15008696 22L12.8508696 22 12.8508696 20.4513913 9.15008696 20.4513913z"
    }), r.createElement("path", {
      d: "M13.7232174 22L17.4249565 22 17.4249565 20.4513913 13.7232174 20.4513913z"
    }))));
  }, hy[_e.FacebookCategory] = function () {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("path", {
      fill: "currentColor",
      d: "M29.967 13.005L26.984 13c-3.35 0-5.516 2.222-5.516 5.66v2.61h-2.999c-.26 0-.469.21-.469.47v3.78c0 .26.21.47.469.47h2.999v9.541c0 .26.21.469.469.469h3.912c.26 0 .47-.21.47-.469V25.99h3.506c.259 0 .469-.21.469-.47l.001-3.78a.47.47 0 00-.469-.47h-3.508v-2.212c0-1.064.254-1.603 1.639-1.603l2.01-.001c.258 0 .468-.21.468-.47v-3.51a.47.47 0 00-.468-.47z"
    })));
  }, hy[_e.TwitterCategory] = function () {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillOpacity: "0.9",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("path", {
      fill: "currentColor",
      d: "M36 17.305c-.892.402-1.843.668-2.835.797a4.997 4.997 0 002.165-2.79 9.685 9.685 0 01-3.12 1.222 4.874 4.874 0 00-3.595-1.596c-2.723 0-4.916 2.267-4.916 5.047 0 .4.032.785.113 1.151-4.09-.205-7.71-2.215-10.141-5.278a5.18 5.18 0 00-.673 2.55c0 1.748.877 3.297 2.185 4.194a4.766 4.766 0 01-2.223-.621v.055c0 2.452 1.705 4.49 3.942 4.958-.4.113-.837.167-1.29.167-.315 0-.633-.019-.931-.087.637 1.999 2.446 3.468 4.597 3.516a9.73 9.73 0 01-6.1 2.152c-.404 0-.791-.018-1.178-.07a13.601 13.601 0 007.548 2.266c9.054 0 14.004-7.693 14.004-14.36 0-.224-.008-.439-.018-.653A9.958 9.958 0 0036 17.305z"
    })));
  }, hy[_e.InstagramCategory] = function () {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      fill: "currentColor",
      transform: "translate(13 13)"
    }, r.createElement("path", {
      d: "M15.125 0h-8.25A6.876 6.876 0 000 6.875v8.25A6.876 6.876 0 006.875 22h8.25A6.876 6.876 0 0022 15.125v-8.25A6.876 6.876 0 0015.125 0zm4.813 15.125a4.818 4.818 0 01-4.813 4.813h-8.25a4.818 4.818 0 01-4.813-4.813v-8.25a4.818 4.818 0 014.813-4.813h8.25a4.818 4.818 0 014.813 4.813v8.25z"
    }), r.createElement("path", {
      d: "M11 5.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 8.938A3.442 3.442 0 017.562 11 3.441 3.441 0 0111 7.562 3.441 3.441 0 0114.438 11 3.442 3.442 0 0111 14.438z"
    }), r.createElement("circle", {
      cx: "16.913",
      cy: "5.088",
      r: "1"
    }))));
  }, hy),
  crops: (dy = {}, dy[_e.Custom] = function (e) {
    var t = e.highlight,
        n = void 0 === t ? "#565656" : t,
        i = e.width,
        o = void 0 === i ? 32 : i,
        a = e.height,
        s = void 0 === a ? 32 : a;
    return r.createElement(Ay, {
      width: o,
      height: s,
      viewBox: "0 0 32 32"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      fill: n,
      transform: "translate(-8 -8)"
    }, r.createElement("g", {
      transform: "translate(8 8)"
    }, r.createElement("g", null, r.createElement("path", {
      d: "M.941 31.992h2.824v-.94L.941 31.05v-2.822h-.94v2.846s-.004.918.94.918"
    }), r.createElement("path", {
      d: "M31.974 31.051v-2.823h-.942v2.823h-2.823v.941h2.846s.919.003.919-.94"
    }), r.createElement("path", {
      d: "M4.62305882 31.9926588L8.38776471 31.9926588 8.38776471 31.0514824 4.62305882 31.0514824z"
    }), r.createElement("path", {
      d: "M9.32894118 31.9926588L13.0936471 31.9926588 13.0936471 31.0514824 9.32894118 31.0514824z"
    }), r.createElement("path", {
      d: "M14.0348235 31.9926588L17.7995294 31.9926588 17.7995294 31.0514824 14.0348235 31.0514824z"
    }), r.createElement("path", {
      d: "M18.7407059 31.9926588L22.5054118 31.9926588 22.5054118 31.0514824 18.7407059 31.0514824z"
    }), r.createElement("path", {
      d: "M23.4465882 31.9926588L27.2112941 31.9926588 27.2112941 31.0514824 23.4465882 31.0514824z"
    }), r.createElement("path", {
      d: "M0 .94v2.824h.941L.942.941h2.823V0H.919S0-.002 0 .94"
    }), r.createElement("path", {
      d: "M31.032 0H28.21v.94l2.823.002v2.822h.942V.92s.002-.92-.942-.92"
    }), r.createElement("path", {
      d: "M4.62305882 0.940423529L8.38776471 0.940423529 8.38776471 -0.000752941176 4.62305882 -0.000752941176z"
    }), r.createElement("path", {
      d: "M9.32894118 0.940423529L13.0936471 0.940423529 13.0936471 -0.000752941176 9.32894118 -0.000752941176z"
    }), r.createElement("path", {
      d: "M14.0348235 0.940423529L17.7995294 0.940423529 17.7995294 -0.000752941176 14.0348235 -0.000752941176z"
    }), r.createElement("path", {
      d: "M18.7407059 0.940423529L22.5054118 0.940423529 22.5054118 -0.000752941176 18.7407059 -0.000752941176z"
    }), r.createElement("path", {
      d: "M23.4465882 0.940423529L27.2112941 0.940423529 27.2112941 -0.000752941176 23.4465882 -0.000752941176z"
    }), r.createElement("path", {
      d: "M0 8.46324706L0.941176471 8.46324706 0.941176471 4.69854118 0 4.69854118z"
    }), r.createElement("path", {
      d: "M0 13.1691294L0.941176471 13.1691294 0.941176471 9.40442353 0 9.40442353z"
    }), r.createElement("path", {
      d: "M0 17.8750118L0.941176471 17.8750118 0.941176471 14.1103059 0 14.1103059z"
    }), r.createElement("path", {
      d: "M0 22.5808941L0.941176471 22.5808941 0.941176471 18.8161882 0 18.8161882z"
    }), r.createElement("path", {
      d: "M0 27.2867765L0.941176471 27.2867765 0.941176471 23.5220706 0 23.5220706z"
    }), r.createElement("path", {
      d: "M30.976 8.46324706L31.9171765 8.46324706 31.9171765 4.69854118 30.976 4.69854118z"
    }), r.createElement("path", {
      d: "M30.976 13.1691294L31.9171765 13.1691294 31.9171765 9.40442353 30.976 9.40442353z"
    }), r.createElement("path", {
      d: "M30.976 17.8750118L31.9171765 17.8750118 31.9171765 14.1103059 30.976 14.1103059z"
    }), r.createElement("path", {
      d: "M30.976 22.5808941L31.9171765 22.5808941 31.9171765 18.8161882 30.976 18.8161882z"
    }), r.createElement("path", {
      d: "M30.976 27.2867765L31.9171765 27.2867765 31.9171765 23.5220706 30.976 23.5220706z"
    }))))));
  }, dy[_e.Square] = function (e) {
    var t = e.highlight,
        n = void 0 === t ? "#565656" : t,
        i = e.mask,
        o = void 0 === i ? "#fff" : i,
        a = e.width,
        s = void 0 === a ? 32 : a,
        l = e.height,
        u = void 0 === l ? 32 : l;
    return r.createElement(Ay, {
      width: s,
      height: u,
      viewBox: "0 0 32 32"
    }, r.createElement("defs", null, r.createElement("rect", {
      id: "photoeditorsdk-square-icon",
      width: "32",
      height: "32",
      x: "0.92",
      y: "0.707",
      rx: "1"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      transform: "translate(-8 -8)"
    }, r.createElement("g", {
      transform: "translate(7.08 7.293)"
    }, r.createElement("mask", {
      fill: o
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-square-icon"
    })), r.createElement("use", {
      fill: n,
      xlinkHref: "#photoeditorsdk-square-icon"
    })))));
  }, dy[_e.ThreeByFour] = function (e) {
    var t = e.highlight,
        n = void 0 === t ? "#565656" : t,
        i = e.width,
        o = void 0 === i ? 32 : i,
        a = e.height,
        s = void 0 === a ? 42 : a;
    return r.createElement(Ay, {
      width: o,
      height: s,
      viewBox: "0 0 32 42"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      fill: n,
      transform: "translate(-8 -3)"
    }, r.createElement("rect", {
      width: "42",
      height: "32",
      x: "3",
      y: "8",
      rx: "0.5",
      transform: "rotate(90 24 24)"
    }))));
  }, dy[_e.FourByThree] = function (e) {
    var t = e.highlight,
        n = void 0 === t ? "#565656" : t,
        i = e.width,
        o = void 0 === i ? 32 : i,
        a = e.height,
        s = void 0 === a ? 48 : a;
    return r.createElement(Ay, {
      width: o,
      height: s,
      viewBox: "0 0 42 32"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      fill: n,
      transform: "translate(-3 -8)"
    }, r.createElement("rect", {
      width: "42",
      height: "32",
      x: "3",
      y: "8",
      rx: "0.5"
    }))));
  }, dy[_e.NineBySixteen] = function (e) {
    var t = e.highlight,
        n = void 0 === t ? "#565656" : t,
        i = e.width,
        o = void 0 === i ? 26 : i,
        a = e.height,
        s = void 0 === a ? 46 : a;
    return r.createElement(Ay, {
      width: o,
      height: s,
      viewBox: "0 0 26 46"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      fill: n,
      transform: "translate(-11 -1)"
    }, r.createElement("path", {
      d: "M1 11.496A.5.5 0 011.5 11h45a.5.5 0 01.5.496v25.008a.5.5 0 01-.5.496h-45a.5.5 0 01-.5-.496V11.496z",
      transform: "rotate(90 24 24)"
    }))));
  }, dy[_e.SixteenByNine] = function (e) {
    var t = e.highlight,
        n = void 0 === t ? "#565656" : t,
        i = e.width,
        o = void 0 === i ? 26 : i,
        a = e.height,
        s = void 0 === a ? 46 : a;
    return r.createElement(Ay, {
      width: o,
      height: s,
      viewBox: "0 0 26 46"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      fill: n,
      transform: "translate(-11 -1)"
    }, r.createElement("path", {
      d: "M1 11.496A.5.5 0 011.5 11h45a.5.5 0 01.5.496v25.008a.5.5 0 01-.5.496h-45a.5.5 0 01-.5-.496V11.496z"
    }))));
  }, dy[_e.FacebookPost] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("rect", {
      width: "28",
      height: "3",
      x: "12",
      y: "41",
      fill: n,
      rx: "0.5",
      transform: "matrix(-1 0 0 1 52 0)"
    }), r.createElement("rect", {
      width: "34",
      height: "28",
      x: "7",
      y: "8",
      fill: o,
      rx: "0.5",
      transform: "matrix(1 0 0 -1 0 44)"
    }), r.createElement("rect", {
      width: "3",
      height: "3",
      x: "8",
      y: "41",
      fill: n,
      rx: "0.5",
      transform: "matrix(-1 0 0 1 19 0)"
    }), r.createElement("rect", {
      width: "28",
      height: "3",
      x: "12",
      y: "37",
      fill: n,
      rx: "0.5",
      transform: "matrix(-1 0 0 1 52 0)"
    }), r.createElement("rect", {
      width: "28",
      height: "3",
      x: "12",
      y: "4",
      fill: n,
      rx: "0.5",
      transform: "matrix(1 0 0 -1 0 11)"
    }), r.createElement("rect", {
      width: "3",
      height: "3",
      x: "8",
      y: "37",
      fill: n,
      rx: "0.5",
      transform: "matrix(-1 0 0 1 19 0)"
    }), r.createElement("rect", {
      width: "3",
      height: "3",
      x: "8",
      y: "4",
      fill: n,
      rx: "0.5",
      transform: "matrix(1 0 0 -1 0 11)"
    })));
  }, dy[_e.FacebookProfile] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", null, r.createElement("path", {
      fill: n,
      d: "M42 5a1 1 0 011 1v13a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h36zM21.505 18h-2.01a.494.494 0 00-.495.5c0 .268.222.5.495.5h2.01c.28 0 .495-.224.495-.5l-.008-.088a.503.503 0 00-.487-.412zm8.004 0h-5.018a.5.5 0 000 1h5.018a.5.5 0 00.491-.5l-.008-.088A.5.5 0 0029.51 18z"
    }), r.createElement("rect", {
      width: "22",
      height: "11",
      x: "20",
      y: "29",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "13",
      height: "10",
      x: "6",
      y: "23",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "22",
      height: "5",
      x: "20",
      y: "23",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "7",
      height: "7",
      x: "9",
      y: "14",
      fill: o,
      rx: "1"
    }), r.createElement("rect", {
      width: "13",
      height: "9",
      x: "6",
      y: "34",
      fill: n,
      rx: "1"
    }))));
  }, dy[_e.FacebookTitle] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("g", {
      transform: "translate(5 5)"
    }, r.createElement("path", {
      fill: o,
      d: "M37 0a1 1 0 011 1v13a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h36zM16.505 13h-2.01a.494.494 0 00-.495.5c0 .268.222.5.495.5h2.01c.28 0 .495-.224.495-.5l-.008-.088a.503.503 0 00-.487-.412zm8.004 0h-5.018a.5.5 0 000 1h5.018a.5.5 0 00.491-.5l-.008-.088A.5.5 0 0024.51 13z"
    }), r.createElement("rect", {
      width: "22",
      height: "11",
      x: "15",
      y: "24",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "13",
      height: "10",
      x: "1",
      y: "18",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "22",
      height: "5",
      x: "15",
      y: "18",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "7",
      height: "7",
      x: "4",
      y: "9",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "13",
      height: "9",
      x: "1",
      y: "29",
      fill: n,
      rx: "1"
    }))));
  }, dy[_e.InstagramLandscape] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("rect", {
      width: "26",
      height: "7",
      x: "7",
      y: "18",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "9",
      height: "7",
      x: "34",
      y: "11",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "9",
      height: "8",
      x: "34",
      y: "19",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "3",
      height: "3",
      x: "40",
      y: "6",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "26",
      height: "21",
      x: "7",
      y: "27",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "26",
      height: "16",
      x: "7",
      y: "5",
      fill: o,
      rx: "1"
    })));
  }, dy[_e.InstagramPortrait] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("rect", {
      width: "26",
      height: "7",
      x: "7",
      y: "34",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "26",
      height: "32",
      x: "7",
      y: "5",
      fill: o,
      rx: "1"
    }), r.createElement("rect", {
      width: "9",
      height: "7",
      x: "34",
      y: "11",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "9",
      height: "8",
      x: "34",
      y: "19",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "3",
      height: "3",
      x: "40",
      y: "6",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "26",
      height: "5",
      x: "7",
      y: "43",
      fill: n,
      rx: "1"
    })));
  }, dy[_e.InstagramSquare] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("rect", {
      width: "26",
      height: "7",
      x: "7",
      y: "28",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "26",
      height: "26",
      x: "7",
      y: "5",
      fill: o,
      rx: "1"
    }), r.createElement("rect", {
      width: "9",
      height: "7",
      x: "34",
      y: "11",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "9",
      height: "8",
      x: "34",
      y: "19",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "3",
      height: "3",
      x: "40",
      y: "6",
      fill: n,
      rx: "1"
    }), r.createElement("rect", {
      width: "26",
      height: "11",
      x: "7",
      y: "37",
      fill: n,
      rx: "1"
    })));
  }, dy[_e.InstagramStory] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("rect", {
      width: "20",
      height: "34",
      x: "14",
      y: "10",
      fill: o,
      rx: "1.5"
    }), r.createElement("rect", {
      width: "3",
      height: "3",
      x: "14",
      y: "5",
      fill: n,
      rx: "1"
    })));
  }, dy[_e.TwitterPost] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.shadow,
        s = void 0 === a ? "#333333" : a,
        l = e.width,
        u = void 0 === l ? "48px" : l,
        c = e.height,
        p = void 0 === c ? "48px" : c;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: u,
      height: p,
      viewBox: "0 0 48 48"
    }, r.createElement("defs", null, r.createElement("filter", {
      id: "photoeditorsdk-twitter-post-icon",
      width: "166.7%",
      height: "166.7%",
      x: "-33.3%",
      y: "-33.3%",
      filterUnits: "objectBoundingBox"
    }, r.createElement("feGaussianBlur", {
      in: "SourceGraphic",
      stdDeviation: "1"
    }))), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("rect", {
      width: "38",
      height: "15",
      x: "5",
      y: "5",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "24",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "26",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "28",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "13",
      x: "17",
      y: "24",
      fill: o,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "3",
      x: "17",
      y: "38",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "3",
      x: "17",
      y: "42",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "9",
      height: "9",
      x: "8",
      y: "13",
      fill: s,
      filter: "url(#photoeditorsdk-twitter-post-icon)",
      rx: "1"
    }), r.createElement("rect", {
      width: "7",
      height: "7",
      x: "9",
      y: "14",
      fill: n,
      rx: "1"
    })));
  }, dy[_e.TwitterProfile] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("rect", {
      width: "38",
      height: "15",
      x: "5",
      y: "5",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "24",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "26",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "28",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "13",
      x: "17",
      y: "24",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "3",
      x: "17",
      y: "38",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "3",
      x: "17",
      y: "42",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "7",
      height: "7",
      x: "9",
      y: "14",
      fill: o,
      rx: "1"
    })));
  }, dy[_e.TwitterTitle] = function (e) {
    var t = e.main,
        n = void 0 === t ? "#424242" : t,
        i = e.highlight,
        o = void 0 === i ? "#565656" : i,
        a = e.width,
        s = void 0 === a ? "48px" : a,
        l = e.height,
        u = void 0 === l ? "48px" : l;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: s,
      height: u,
      viewBox: "0 0 48 48"
    }, r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("rect", {
      width: "38",
      height: "15",
      x: "5",
      y: "5",
      fill: o,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "24",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "26",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "11",
      height: "1",
      x: "5",
      y: "28",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "13",
      x: "17",
      y: "24",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "3",
      x: "17",
      y: "38",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "26",
      height: "3",
      x: "17",
      y: "42",
      fill: n,
      rx: "0.5"
    }), r.createElement("rect", {
      width: "7",
      height: "7",
      x: "9",
      y: "14",
      fill: n,
      rx: "1"
    })));
  }, dy),
  dots: cy,
  duplicate: function duplicate() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-duplicate-icon",
      d: "M3.429 8.571v12h12v-12h-12zM1.714 5.143h15.429c.947 0 1.714.767 1.714 1.714v15.429c0 .946-.767 1.714-1.714 1.714H1.714A1.714 1.714 0 010 22.286V6.857c0-.947.768-1.714 1.714-1.714zM22.286 0C23.232 0 24 .768 24 1.714v15.429c0 .947-.768 1.714-1.714 1.714H20.57V3.429L5.142 3.428V1.714C5.143.768 5.91 0 6.858 0h15.429z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("mask", {
      fill: "currentColor"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-duplicate-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      fillOpacity: "0.9",
      xlinkHref: "#photoeditorsdk-duplicate-icon"
    })));
  },
  edit: function edit() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      d: "M2.087 7.115h7.66v15.32h5.027l.223-15.32h7.438V2.087H2.087v5.028zM14.075 24h-4.15a2.42 2.42 0 01-1.718-.711 2.423 2.423 0 01-.711-1.717V9.01H2.429c-.67 0-1.278-.273-1.718-.713A2.426 2.426 0 010 6.579V2.43C0 1.76.272 1.153.711.713A2.424 2.424 0 012.43 0h19.142c.671 0 1.278.272 1.718.713.439.44.711 1.047.711 1.718v4.148c0 .671-.272 1.278-.711 1.718-.44.44-1.047.713-1.718.713h-5.067v12.562c0 .67-.272 1.278-.711 1.717a2.42 2.42 0 01-1.718.711z"
    }));
  },
  bringToFront: function bringToFront() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-bring-to-front-icon",
      d: "M21 16a2 2 0 012 2v4a2 2 0 01-2 2H3a2 2 0 01-2-2v-4a2 2 0 012-2h18zM12.006 1l5.996 5.996-1.414 1.414-3.578-3.577V12h-2.008V4.833L7.418 8.417 6.004 7.003 12.006 1z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("path", {
      d: "M0 0H24V24H0z"
    }), r.createElement("mask", {
      fill: "currentColor"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-bring-to-front-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      fillOpacity: "0.9",
      xlinkHref: "#photoeditorsdk-bring-to-front-icon"
    })));
  },
  delete: function _delete() {
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-delete-icon",
      d: "M20 6l-2.312 15.718A1.5 1.5 0 0116.204 23H5.796a1.5 1.5 0 01-1.484-1.282L2 6h18zM7 1a1 1 0 011-1h6a1 1 0 011 1v1h7v2H0V2h7V1z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1"
    }, r.createElement("mask", {
      fill: "currentColor"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-delete-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      fillOpacity: "0.9",
      xlinkHref: "#photoeditorsdk-delete-icon"
    })));
  },
  flipHorizontal: function flipHorizontal(e) {
    var t = e.className;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 15 14",
      transform: "scale(-1, 1)",
      className: t
    }, r.createElement("title", null, "Flip Horizontal"), r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-flip-horizontal-icon",
      d: "M42 1v14h-1.167v-1.167H37a2 2 0 01-2-2V4.167a2 2 0 012-2l3.833-.001V1H42zm5.833 11.958a.875.875 0 01-.875.875h-3.791v-1.166l3.499-.001V3.333h-3.5V2.167h3.792c.446 0 .815.333.869.765l.006.11v9.916z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      transform: "translate(-34 -1)"
    }, r.createElement("mask", {
      fill: "none"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-flip-horizontal-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      fillOpacity: "0.9",
      xlinkHref: "#photoeditorsdk-flip-horizontal-icon"
    })));
  },
  flipVertical: function flipVertical(e) {
    var t = e.className;
    return r.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 15 14",
      className: t
    }, r.createElement("title", null, "Flip Vertical"), r.createElement("defs", null, r.createElement("path", {
      id: "photoeditorsdk-flip-vertical-icon",
      d: "M42 1v14h-1.167v-1.167H37a2 2 0 01-2-2V4.167a2 2 0 012-2l3.833-.001V1H42zm5.833 11.958a.875.875 0 01-.875.875h-3.791v-1.166l3.499-.001V3.333h-3.5V2.167h3.792c.446 0 .815.333.869.765l.006.11v9.916z"
    })), r.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      transform: "translate(-34 -1)"
    }, r.createElement("mask", {
      fill: "none"
    }, r.createElement("use", {
      xlinkHref: "#photoeditorsdk-flip-vertical-icon"
    })), r.createElement("use", {
      fill: "currentColor",
      fillOpacity: "0.9",
      transform: "rotate(-90 41.417 8)",
      xlinkHref: "#photoeditorsdk-flip-vertical-icon"
    })));
  },
  rotate: py
},
    Uy = ((gy = {})[Z.BRIGHTNESS] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-brightness-icon",
    d: "M22.185 33.836c.594.109 1.2.164 1.815.164v2c-.735 0-1.462-.066-2.175-.197zm5.58-.568l.753 1.852c-.675.275-1.375.487-2.093.635l-.402-1.96c.597-.122 1.18-.299 1.741-.527zm-9.446-1.037c.5.346 1.03.646 1.586.895l-.82 1.824c-.666-.3-1.303-.66-1.903-1.074zm12.884-1.295l1.44 1.388a12.06 12.06 0 01-1.65 1.429l-1.167-1.625a10.06 10.06 0 001.377-1.192zm-15.758-1.754c.316.52.679 1.01 1.083 1.464l-1.493 1.33a12.038 12.038 0 01-1.3-1.756zm17.97-1.802l1.882.676a11.948 11.948 0 01-.925 1.982l-1.727-1.008a9.948 9.948 0 00.77-1.65zM24 18c.091 0 .182.002.273.006L24 18a6.071 6.071 0 01.668.037l.192.024a5.974 5.974 0 011.847.585l.01.005a5.992 5.992 0 011.154.768A5.99 5.99 0 0130 24c0 3.309-2.691 6-6 6a5.985 5.985 0 01-4.404-1.929l.163.17a6.052 6.052 0 01-1.353-2.07A5.951 5.951 0 0118 24c0-3.309 2.691-6 6-6zm2.827 3.173l-5.654 5.654A3.988 3.988 0 0024 28c2.206 0 4-1.794 4-4a3.988 3.988 0 00-1.173-2.827zM14.08 25.268c.076.606.208 1.2.392 1.777l-1.905.608a11.936 11.936 0 01-.472-2.134zm21.885-2.192a12.16 12.16 0 01-.032 2.198l-1.989-.21a10.193 10.193 0 00.027-1.836zM12.522 20.49l1.912.584a9.943 9.943 0 00-.37 1.783l-1.987-.226c.083-.73.232-1.445.445-2.14zm22.059-2.155c.345.643.63 1.316.853 2.013l-1.905.608a9.934 9.934 0 00-.71-1.676zm-19.587-2.266l1.5 1.323c-.402.456-.762.948-1.075 1.47l-1.715-1.03c.376-.625.808-1.215 1.29-1.763zm16.272-1.62c.58.442 1.12.936 1.61 1.476l-1.479 1.346c-.41-.45-.859-.862-1.343-1.23zm-12.241-1.372l.83 1.82a9.986 9.986 0 00-1.58.903l-1.147-1.638a11.986 11.986 0 011.897-1.085zm7.7-.766c.714.166 1.408.396 2.076.688L28 14.832a9.916 9.916 0 00-1.727-.573zm-2.857-.31l.021 2c-.613.006-1.22.068-1.812.184l-.383-1.964a12.046 12.046 0 012.174-.22z"
  })), r.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("mask", null, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-brightness-icon"
  })), r.createElement("use", {
    fillOpacity: "0.9",
    transform: "rotate(-45 24.039 24)",
    xlinkHref: "#photoeditorsdk-brightness-icon"
  })));
}, gy[Z.CONTRAST] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-contrast-icon",
    d: "M24 34V14c5.51 0 10 4.49 10 10s-4.49 10-10 10m0-22c-6.62 0-12 5.38-12 12s5.38 12 12 12 12-5.38 12-12-5.38-12-12-12"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-contrast-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-contrast-icon"
  })));
}, gy[Z.SATURATION] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-saturation-icon",
    d: "M17 31c1.334 1.099 2 2.177 2 3.234 0 .797-.454 1.39-1.211 1.655-.165.057-.428.094-.789.111l-.172-.01a2.54 2.54 0 01-.617-.101C15.454 35.624 15 35.03 15 34.234c0-1.057.666-2.135 2-3.234zm8.7-6l-4.24 4H17v-3.81l.2-.19h8.5zm-.7-7.59l4.24 4.25L26.76 24h-8.54L25 17.41zm7.778-3.532a3 3 0 01.135 4.1l-.135.143-1.414 1.414 1.414 1.415-1.414 1.414-7.07-7.071 1.413-1.414 1.414 1.413 1.414-1.414a3.001 3.001 0 014.243 0z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-saturation-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-saturation-icon"
  })));
}, gy[Z.CLARITY] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-clarity-icon",
    d: "M24 12L13 24.001 24 36l11-11.999L24 12zm-8.29 12.001H21l3-9.041 8.29 9.041-8.28 9.029L28 24.001h-7l2.99 9.029-8.28-9.029z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-clarity-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-clarity-icon"
  })));
}, gy[Z.SHADOWS] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-shadows-icon",
    d: "M30.365 17.637l3.076 3.076c.382 1.09.566 2.234.56 3.387l-5.05-5.049-1.414 1.414 6.123 6.124a9.674 9.674 0 01-.792 2.036l-6.746-6.745-1.414 1.414 7.036 7.036c-.212.254-.43.502-.672.742-.24.24-.488.46-.742.672l-7.036-7.036-1.414 1.414 6.745 6.746a9.674 9.674 0 01-2.036.792l-6.124-6.123-1.414 1.414L24.101 34a10.012 10.012 0 01-3.388-.558l-3.076-3.076-.707.707c-3.896-3.896-3.896-10.246 0-14.142 3.896-3.896 10.246-3.896 14.142 0l-.707.707zm-14.849-2.12c-4.688 4.687-4.688 12.281 0 16.97a12.036 12.036 0 004.108 2.693c.064.022.127.057.191.078 4.264 1.577 9.242.658 12.671-2.772 3.43-3.429 4.35-8.407 2.772-12.67-.02-.065-.056-.128-.078-.192a12.036 12.036 0 00-2.694-4.108c-4.688-4.688-12.282-4.688-16.97 0z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-shadows-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-shadows-icon"
  })));
}, gy[Z.HIGHLIGHTS] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-highlights-icon",
    d: "M31.07 31.07A9.932 9.932 0 0124 34c-2.67 0-5.18-1.04-7.07-2.93l14.14-14.14c3.9 3.9 3.9 10.24 0 14.14m1.42-15.56A11.995 11.995 0 0024 12c-3.07 0-6.14 1.17-8.49 3.51-4.68 4.69-4.68 12.29 0 16.98C17.86 34.83 20.93 36 24 36c3.07 0 6.14-1.17 8.49-3.51 4.68-4.69 4.68-12.29 0-16.98"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-highlights-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-highlights-icon"
  })));
}, gy[Z.EXPOSURE] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-exposure-icon",
    d: "M24 34V14c5.51 0 10 4.49 10 10s-4.49 10-10 10m0-22c6.62 0 12 5.38 12 12s-5.38 12-12 12-12-5.38-12-12 5.38-12 12-12zm-3.536 8.464l-2.121 2.122-2.121-2.122-1.414 1.415L16.929 24l-2.121 2.121 1.414 1.415 2.121-2.122 2.121 2.122 1.415-1.415L19.757 24l2.122-2.121-1.415-1.415zm5.304 4.597l4.242-4.243 1.415 1.414-4.243 4.243-1.414-1.414z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-exposure-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    transform: "rotate(45 24 24)",
    xlinkHref: "#photoeditorsdk-exposure-icon"
  })));
}, gy[Z.GAMMA] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-gamma-icon",
    d: "M22.185 33.836c.594.109 1.2.164 1.815.164v2c-.735 0-1.462-.066-2.175-.197zm5.58-.568l.753 1.852c-.675.275-1.375.487-2.093.635l-.402-1.96c.597-.122 1.18-.299 1.741-.527zm-9.446-1.037c.5.346 1.03.646 1.586.895l-.82 1.824c-.666-.3-1.303-.66-1.903-1.074zm12.884-1.295l1.44 1.388a12.06 12.06 0 01-1.65 1.429l-1.167-1.625a10.06 10.06 0 001.377-1.192zm-15.758-1.754c.316.52.679 1.01 1.083 1.464l-1.493 1.33a12.038 12.038 0 01-1.3-1.756zm17.97-1.802l1.882.676a11.948 11.948 0 01-.925 1.982l-1.727-1.008a9.948 9.948 0 00.77-1.65zM24 18c.091 0 .182.002.273.006L24 18a6.071 6.071 0 01.668.037l.192.024a5.974 5.974 0 011.847.585l.01.005a5.992 5.992 0 011.154.768A5.99 5.99 0 0130 24c0 3.309-2.691 6-6 6a5.985 5.985 0 01-4.404-1.929l.163.17a6.052 6.052 0 01-1.353-2.07A5.951 5.951 0 0118 24c0-3.309 2.691-6 6-6zm2.827 3.173l-5.654 5.654A3.988 3.988 0 0024 28c2.206 0 4-1.794 4-4a3.988 3.988 0 00-1.173-2.827zM14.08 25.268c.076.606.208 1.2.392 1.777l-1.905.608a11.936 11.936 0 01-.472-2.134zm21.885-2.192a12.16 12.16 0 01-.032 2.198l-1.989-.21a10.193 10.193 0 00.027-1.836zM12.522 20.49l1.912.584a9.943 9.943 0 00-.37 1.783l-1.987-.226c.083-.73.232-1.445.445-2.14zm22.059-2.155c.345.643.63 1.316.853 2.013l-1.905.608a9.934 9.934 0 00-.71-1.676zm-19.587-2.266l1.5 1.323c-.402.456-.762.948-1.075 1.47l-1.715-1.03c.376-.625.808-1.215 1.29-1.763zm16.272-1.62c.58.442 1.12.936 1.61 1.476l-1.479 1.346c-.41-.45-.859-.862-1.343-1.23zm-12.241-1.372l.83 1.82a9.986 9.986 0 00-1.58.903l-1.147-1.638a11.986 11.986 0 011.897-1.085zm7.7-.766c.714.166 1.408.396 2.076.688L28 14.832a9.916 9.916 0 00-1.727-.573zm-2.857-.31l.021 2c-.613.006-1.22.068-1.812.184l-.383-1.964a12.046 12.046 0 012.174-.22z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "#fff"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-gamma-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-gamma-icon"
  })));
}, gy[Z.BLACKS] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-blacks-icon",
    d: "M24 12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12m0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10m4 12c0 2.788-2.326 3.879-7 3V18.5c4.148-.459 6.516.226 6.516 2.623 0 1.207-.492 1.998-1.512 2.474C27.504 23.999 28 24.619 28 26zm-5-6v3c2.244.068 2.775-.719 2.775-1.536 0-1.22-.531-1.812-2.775-1.464zm0 7.5c2.19.193 3.038-.04 3.038-1.484 0-1.37-1.096-1.695-3.038-1.516v3z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-blacks-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-blacks-icon"
  })));
}, gy[Z.WHITES] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-whites-icon",
    d: "M24 12c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm-2 6.46h-2c.221 4.539.762 9.051 1 11.04h1.5l1.5-5.52 1.5 5.52H27c.238-1.989.779-6.501 1-11.04h-2c-.051 1.071-.432 7.446-.5 7.973-.459-1.717-.541-3.111-1-4.811h-1c-.442 1.7-.541 2.975-1 4.811-.051-.527-.466-6.902-.5-7.973z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-whites-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-whites-icon"
  })));
}, gy[Z.TEMPERATURE] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-temperature-icon",
    d: "M24 12a4 4 0 014 4v7.255a7 7 0 11-8 0V16a4 4 0 014-4zm0 2a2 2 0 00-2 2v8.298l-.856.597a5 5 0 105.712 0L26 24.298V16a2 2 0 00-2-2zm1 6v5.126A4.002 4.002 0 0124 33a4 4 0 01-1-7.874V20h2z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-temperature-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-temperature-icon"
  })));
}, gy[Z.SHARPNESS] = function () {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, r.createElement("defs", null, r.createElement("path", {
    id: "photoeditorsdk-sharpness-icon",
    d: "M24 12l11 24H13l11-24zm0 4.8V34h7.883L24 16.8z"
  })), r.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, r.createElement("path", {
    d: "M0 0H48V48H0z"
  }), r.createElement("mask", {
    fill: "currentColor"
  }, r.createElement("use", {
    xlinkHref: "#photoeditorsdk-sharpness-icon"
  })), r.createElement("use", {
    fill: "currentColor",
    fillOpacity: "0.9",
    xlinkHref: "#photoeditorsdk-sharpness-icon"
  })));
}, gy),
    jy = e.div(my || (my = E(["\n  overflow: hidden;\n  display: inline-block;\n  position: relative;\n  transform: unset !important;\n  vertical-align: bottom;\n"], ["\n  overflow: hidden;\n  display: inline-block;\n  position: relative;\n  transform: unset !important;\n  vertical-align: bottom;\n"]))),
    Wy = e.div(yy || (yy = E(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  align-self: center;\n"], ["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  align-self: center;\n"]))),
    Hy = e.div(_y || (_y = E(["\n  font-size: 15px;\n  display: inline-block;\n  width: 33px;\n  text-align: right;\n  color: ", ";\n  z-index: 1;\n  margin: 2px;\n"], ["\n  font-size: 15px;\n  display: inline-block;\n  width: 33px;\n  text-align: right;\n  color: ", ";\n  z-index: 1;\n  margin: 2px;\n"])), function (e) {
  return e.theme.foreground;
}),
    Gy = e.div(vy || (vy = E(["\n  transform: translate(0, 0) !important;\n"], ["\n  transform: translate(0, 0) !important;\n"]))),
    Vy = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.SLIDER_WIDTH = 213, t.MAX_ROTATION = 45, t.DEGREES_PER_PIXEL = 2 * t.MAX_ROTATION / t.SLIDER_WIDTH, t.drag = function (e, n) {
      var i = n.x,
          r = t.transformTool.rotateFlipState;
      r.flipHorizontally !== r.flipVertically && (i *= -1);
      var o = t.transformTool.defaultAngle - i * t.DEGREES_PER_PIXEL,
          a = Math.min(t.MAX_ROTATION, Math.max(o, -1 * t.MAX_ROTATION));
      t.transformTool.setRotation(parseInt("" + a, 10));
    }, t.stop = function () {
      t.transformTool.setDefaultAngle(t.transformTool.rotationInDegrees), t.transformTool.addLocalSnapshot();
    }, t;
  }

  return _(t, e), Object.defineProperty(t.prototype, "transformTool", {
    get: function get() {
      return this.props.transformTool;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this.transformTool.rotateFlipState,
        t = e.flipHorizontally,
        n = e.flipVertically,
        i = this.transformTool.rotationInDegrees - this.transformTool.defaultAngle,
        o = t === n ? -1 * i : i,
        a = t !== n ? -1 * this.props.transformTool.rotationInDegrees : this.props.transformTool.rotationInDegrees;
    return r.createElement(Wy, null, r.createElement(mg.Draggable, {
      axis: "x",
      position: {
        x: 0,
        y: 0
      },
      onStart: this.drag,
      onDrag: this.drag,
      onStop: this.stop,
      updateOnPosition: !0
    }, r.createElement(Gy, null, r.createElement(jy, null, r.createElement(Ny.dots, {
      width: 90,
      height: 15,
      x: o
    })), r.createElement(Hy, null, a, "°"), r.createElement(jy, null, r.createElement(Ny.dots, {
      width: 90,
      height: 15,
      x: o
    })))));
  }, t;
}(r.Component),
    Xy = Gu("transformTool")(uc(Vy)),
    Yy = e(Ny.rotate)(by || (by = E(["\n  height: 16px;\n  width: 16px;\n  transform: scaleX(-1);\n"], ["\n  height: 16px;\n  width: 16px;\n  transform: scaleX(-1);\n"]))),
    qy = e(Ny.rotate)(wy || (wy = E(["\n  height: 16px;\n  width: 16px;\n"], ["\n  height: 16px;\n  width: 16px;\n"]))),
    Ky = e(Ny.flipHorizontal)(xy || (xy = E(["\n  height: 16px;\n  width: 16px;\n"], ["\n  height: 16px;\n  width: 16px;\n"]))),
    Zy = e(Ny.flipVertical)(ky || (ky = E(["\n  height: 16px;\n  width: 16px;\n"], ["\n  height: 16px;\n  width: 16px;\n"]))),
    Qy = e.div(Ty || (Ty = E(["\n  display: inline-flex;\n  transform: scale(0.9);\n\n  @media all and (min-width: 0) and (max-width: 599px) {\n    transform: scale(0.7);\n  }\n"], ["\n  display: inline-flex;\n  transform: scale(0.9);\n\n  @media all and (min-width: 0) and (max-width: 599px) {\n    transform: scale(0.7);\n  }\n"]))),
    Jy = Gu("transformTool", "config", "custom")(uc(function (e) {
  var t = e.transformTool,
      n = e.config,
      i = e.custom,
      o = t.locale.transformActions,
      a = function a(e) {
    var t = e.customButtonKey,
        n = e.onClick,
        o = e.label,
        a = e.icon,
        s = i.getButton(t);
    return r.createElement(s, {
      key: o,
      onClick: n,
      label: o,
      ariaLabel: o,
      icon: a,
      style: {
        margin: "0 5px"
      }
    });
  },
      s = a({
    label: o.buttonFlipHorizontal,
    icon: r.createElement(Ky, null),
    onClick: function onClick() {
      t.flipHorizontally();
    },
    customButtonKey: "transformActionFlipHorizontal"
  }),
      l = a({
    label: o.buttonFlipVertical,
    icon: r.createElement(Zy, null),
    onClick: function onClick() {
      t.flipVertically();
    },
    customButtonKey: "transformActionFlipVertical"
  }),
      u = a({
    label: o.buttonRotateClockwise,
    icon: r.createElement(Yy, null),
    onClick: t.rotateClockwise,
    customButtonKey: "transformActionRotateClockwise"
  }),
      c = a({
    label: o.buttonRotateAntiClockwise,
    icon: r.createElement(qy, null),
    onClick: t.rotateAntiClockwise,
    customButtonKey: "transformActionRotateAntiClockwise"
  }),
      p = n.isLayoutAdvanced ? {
    transform: "rotate(180deg)"
  } : {};

  return r.createElement(Qy, {
    style: p
  }, t.config.enableFlip && s || null, t.config.enableFlip && l || null, t.config.enableRotation && r.createElement(Xy, null) || null, t.config.enableRotation && c || null, t.config.enableRotation && u || null);
})),
    $y = jm.Crop.GridLine,
    e_ = jm.Crop.Mask,
    t_ = mg.Draggable,
    n_ = e(Um)(Sy || (Sy = E(["\n  left: ", "px;\n  top: ", "px;\n  @media all and (min-width: 0) and (max-width: 599px) {\n    left: 6px;\n    top: 6px;\n  }\n"], ["\n  left: ", "px;\n  top: ", "px;\n  @media all and (min-width: 0) and (max-width: 599px) {\n    left: 6px;\n    top: 6px;\n  }\n"])), 3, 3),
    i_ = e(Um)(function (e) {
  var t = e.theme.measurements.canvasControls.corner.touchable.desktop,
      i = t / 4 - e.borderWidth;
  return n(Cy || (Cy = E(["\n    left: ", "px;\n    top: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      left: -30px;\n      top: 6px;\n    }\n  "], ["\n    left: ", "px;\n    top: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      left: -30px;\n      top: 6px;\n    }\n  "])), i - t, 3);
}),
    r_ = e(Um)(function (e) {
  var t = e.theme.measurements.canvasControls.corner.touchable.desktop,
      i = t / 4 - e.borderWidth;
  return n(Ey || (Ey = E(["\n    left: ", "px;\n    top: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      left: -30px;\n      top: -30px;\n    }\n  "], ["\n    left: ", "px;\n    top: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      left: -30px;\n      top: -30px;\n    }\n  "])), i - t, i - t);
}),
    o_ = e(Um)(function (e) {
  var t = e.theme.measurements.canvasControls.corner.touchable.desktop,
      i = t / 4 - e.borderWidth;
  return n(Oy || (Oy = E(["\n    top: ", "px;\n    left: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      top: -30px;\n      left: 6px;\n    }\n  "], ["\n    top: ", "px;\n    left: ", "px;\n    @media all and (min-width: 0) and (max-width: 599px) {\n      top: -30px;\n      left: 6px;\n    }\n  "])), i - t, 3);
}),
    a_ = Gu("transformTool")(uc(function (e) {
  var t = e.transformTool,
      n = t,
      i = n.leftTopRespectFlip,
      o = n.leftBottomRespectFlip,
      a = n.rightTopRespectFlip,
      s = n.rightBottomRespectFlip,
      l = t.cropMaskSize,
      u = l.height,
      c = l.width,
      p = t,
      f = p.maxCropMaskSize,
      h = p.defaultCropMaskPosition,
      d = t,
      g = d.isFlippedHorizontal,
      m = d.isFlippedVertical,
      y = f.width / 2,
      _ = f.height / 2,
      b = _v2(_v2({}, f), {
    left: h.x,
    top: h.y
  }),
      w = {
    height: u,
    width: c
  },
      x = t.isDragMode ? {
    transition: "unset"
  } : {},
      k = function k(e) {
    return g ? 2 * y - e : e;
  },
      T = function T(e) {
    return m ? 2 * _ - e : e;
  },
      S = function S(e, n, i) {
    var r = k(e),
        o = T(n);

    switch (Dl.getFlippedEdgeIndex(i, g, m)) {
      case 0:
        t.onLeftTop({
          x: r,
          y: o
        });
        break;

      case 1:
        t.onLeftBottom({
          x: r,
          y: o
        });
        break;

      case 2:
        t.onRightTop({
          x: r,
          y: o
        });
        break;

      case 3:
        t.onRightBottom({
          x: r,
          y: o
        });
    }
  },
      C = function C(e, n, i) {
    t.setDragMode(!0), t.clickableCanvas(!1), S(e, n, i);
  },
      E = function E(e, t, n) {
    S(e, t, n);
  },
      O = function O(e, n, i) {
    t.setDragMode(!1), S(e, n, i), t.clickableCanvas(!0), t.addLocalSnapshot();
  },
      R = function R(e, n) {
    var i = k(e + c / 2) - c / 2,
        r = T(n + u / 2) - u / 2;
    t.changePosition({
      x: i,
      y: r
    });
  };

  return r.createElement("div", {
    style: _v2(_v2({}, b), {
      position: "absolute"
    })
  }, r.createElement(t_, {
    bounds: "parent",
    position: i,
    onStart: function onStart(e, n) {
      var i = n.x,
          r = n.y;
      t.setDragMode(!0), t.clickableCanvas(!1), R(i, r);
    },
    onDrag: function onDrag(e, t) {
      var n = t.x,
          i = t.y;
      R(n, i);
    },
    onStop: function onStop(e, n) {
      var i = n.x,
          r = n.y;
      t.setDragMode(!1), R(i, r), t.clickableCanvas(!0), t.addLocalSnapshot();
    }
  }, r.createElement(e_, {
    style: _v2(_v2({}, w), x)
  })), r.createElement($y, {
    style: _v2({
      left: i.x + c / 3,
      top: i.y,
      height: u,
      width: 1
    }, x)
  }), r.createElement($y, {
    style: _v2({
      left: i.x + c / 3 * 2,
      top: i.y,
      height: u,
      width: 1
    }, x)
  }), r.createElement($y, {
    style: _v2({
      left: i.x,
      top: i.y + u / 3,
      height: 1,
      width: c
    }, x)
  }), r.createElement($y, {
    style: _v2({
      left: i.x,
      top: i.y + u / 3 * 2,
      height: 1,
      width: c
    }, x)
  }), r.createElement(t_, {
    bounds: "parent",
    position: _v2({}, i),
    onStart: function onStart(e, t) {
      var n = t.x,
          i = t.y;
      C(n, i, 0);
    },
    onDrag: function onDrag(e, t) {
      var n = t.x,
          i = t.y;
      E(n, i, 0);
    },
    onStop: function onStop(e, t) {
      var n = t.x,
          i = t.y;
      O(n, i, 0);
    }
  }, r.createElement(n_, {
    vertical: "top",
    horizontal: "left",
    borderWidth: 3,
    style: x
  })), r.createElement(t_, {
    bounds: "parent",
    position: o,
    onStart: function onStart(e, t) {
      var n = t.x,
          i = t.y;
      C(n, i, 1);
    },
    onDrag: function onDrag(e, t) {
      var n = t.x,
          i = t.y;
      E(n, i, 1);
    },
    onStop: function onStop(e, t) {
      var n = t.x,
          i = t.y;
      O(n, i, 1);
    }
  }, r.createElement(o_, {
    vertical: "bottom",
    horizontal: "left",
    borderWidth: 3,
    style: x
  })), r.createElement(t_, {
    bounds: "parent",
    position: a,
    onStart: function onStart(e, t) {
      var n = t.x,
          i = t.y;
      C(n, i, 2);
    },
    onDrag: function onDrag(e, t) {
      var n = t.x,
          i = t.y;
      E(n, i, 2);
    },
    onStop: function onStop(e, t) {
      var n = t.x,
          i = t.y;
      O(n, i, 2);
    }
  }, r.createElement(i_, {
    vertical: "top",
    horizontal: "right",
    borderWidth: 3,
    style: x
  })), r.createElement(t_, {
    bounds: "parent",
    position: s,
    onStart: function onStart(e, t) {
      var n = t.x,
          i = t.y;
      C(n, i, 3);
    },
    onDrag: function onDrag(e, t) {
      var n = t.x,
          i = t.y;
      E(n, i, 3);
    },
    onStop: function onStop(e, t) {
      var n = t.x,
          i = t.y;
      O(n, i, 3);
    }
  }, r.createElement(r_, {
    vertical: "bottom",
    horizontal: "right",
    borderWidth: 3,
    style: x
  })));
})),
    s_ = jm.Bar.Index,
    l_ = jm.Crop.Backdrop,
    u_ = Gu("transformTool", "canvas", "config")(uc(function (e) {
  var t = e.transformTool,
      n = e.canvas,
      i = e.config,
      o = t,
      a = o.leftTopRespectFlip,
      s = o.leftBottomRespectFlip,
      l = o.rightTopRespectFlip,
      u = t.cropMaskSize.height,
      c = n.canvasSize,
      p = c.height,
      f = c.width,
      h = t.defaultCropMaskPosition,
      d = t.isDragMode ? {
    transition: "unset"
  } : {};
  return r.createElement(jm.Controls.Container, null, r.createElement(l_, {
    style: _v2({
      left: 0,
      top: 0,
      width: f,
      height: a.y + h.y
    }, d)
  }), r.createElement(l_, {
    style: _v2({
      left: 0,
      top: a.y + h.y,
      width: h.x + a.x,
      height: u
    }, d)
  }), r.createElement(l_, {
    style: _v2({
      left: l.x + h.x,
      top: l.y + h.y,
      width: f - l.x - h.x,
      height: u
    }, d)
  }), r.createElement(l_, {
    style: _v2({
      left: 0,
      top: s.y + h.y,
      width: f,
      height: p - s.y - h.y + i.measurements.basicToolControlBar.controlsBarHeight
    }, d)
  }), r.createElement(a_, null), i.isLayoutAdvanced ? r.createElement(s_, {
    bottom: !0
  }, r.createElement(Jy, null)) : null);
})),
    c_ = e(jm.Controls.Container)(Iy || (Iy = E(["\n  ", "\n  z-index: ", ";\n"], ["\n  ", "\n  z-index: ", ";\n"])), function (e) {
  return e.activeCursor ? n(Ry || (Ry = E(["\n          cursor: move;\n        "], ["\n          cursor: move;\n        "]))) : "";
}, function (e) {
  return e.theme.measurements.zIndex.canvas.crop.dragImage;
}),
    p_ = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.INITIAL_POSITION = {
      x: void 0,
      y: void 0
    }, n.state = _v2(_v2({}, n.INITIAL_POSITION), {
      isDragging: !1
    }), n.containerRef = null, n.getCursorCoordinates = function (e) {
      var t = 0,
          i = 0;

      if (-1 !== e.type.indexOf("touch")) {
        if (!(r = e).touches.length) return n.INITIAL_POSITION;
        t = r.touches[0].clientX, i = r.touches[0].clientY;
      } else {
        var r;
        t = (r = e).clientX, i = r.clientY;
      }

      var o = n.containerRef.current.getBoundingClientRect();
      return {
        x: t - o.left,
        y: i - o.top
      };
    }, n.move = function (e) {
      if (n.scale.canDrag) {
        var t = n.getCursorCoordinates(e),
            i = t.x,
            r = t.y;

        if (void 0 !== i && void 0 !== r && n.state.isDragging) {
          var o = {
            x: n.state.x - i,
            y: n.state.y - r
          };
          n.scale.setOffset(o);
        }
      }
    }, n.touchDrag = function (e) {
      if (n.scale.canDrag) {
        var t = n.getCursorCoordinates(e),
            i = t.x,
            r = t.y;
        void 0 !== i && void 0 !== r && n.setState({
          x: i,
          y: r,
          isDragging: !0
        });
      }
    }, n.drag = function (e) {
      e.preventDefault(), n.touchDrag(e);
    }, n.stop = function () {
      n.scale.canDrag && (n.scale.savePosition(), n.setState(_v2(_v2({}, n.INITIAL_POSITION), {
        isDragging: !1
      })));
    }, n.touchEnd = function (e) {
      e.preventDefault(), e.stopPropagation();
      var t = n.state,
          i = t.x,
          r = t.y;
      i && r && n.setState(_v2(_v2({}, n.INITIAL_POSITION), {
        isDragging: !1
      }));
    }, n.containerRef = r.createRef(), n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    document.addEventListener("mouseup", this.stop, !1), document.addEventListener("touchend", this.stop, {
      passive: !0
    });
  }, t.prototype.componentWillUnmount = function () {
    document.removeEventListener("mouseup", this.stop, !1), document.removeEventListener("touchend", this.stop, !1);
  }, Object.defineProperty(t.prototype, "scale", {
    get: function get() {
      return this.props.scale;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    return r.createElement(c_, {
      ref: this.containerRef,
      onMouseMove: this.move,
      onTouchMove: this.move,
      onMouseDown: this.drag,
      onTouchStart: this.touchDrag,
      onMouseUp: this.stop,
      onTouchEnd: this.touchEnd,
      activeCursor: this.scale.canDrag
    });
  }, t;
}(r.Component),
    f_ = Gu("scale")(uc(p_));

var h_,
    d_,
    g_ = e.img(h_ || (h_ = E(["\n  position: absolute;\n  left: -24px;\n  top: calc(50% - 12px);\n  cursor: ew-resize;\n"], ["\n  position: absolute;\n  left: -24px;\n  top: calc(50% - 12px);\n  cursor: ew-resize;\n"]))),
    m_ = e.img(d_ || (d_ = E(["\n  position: absolute;\n  right: -24px;\n  top: calc(50% - 12px);\n  cursor: ew-resize;\n"], ["\n  position: absolute;\n  right: -24px;\n  top: calc(50% - 12px);\n  cursor: ew-resize;\n"]))),
    y_ = new R(0, 0),
    __ = new R(0, 0),
    v_ = Gu("sprite")(uc(function (e) {
  var t = e.sprite,
      n = t.leftMidPosition,
      i = t.rightMidPosition,
      o = function o(e, r) {
    t.setDragMode(!0), t.clickableCanvas(!1);
    var o = e.clientX,
        a = e.clientY;
    y_ = new R(o, a), __ = new R("left" === r ? n : i);
  },
      a = function a() {
    t.clickableCanvas(!0), t.setDragMode(!1), t.addSnapshot("edit", t.textDesignLocale.padding), y_ = new R(0, 0), __ = new R(0, 0);
  },
      s = function s(e) {
    var n = e.clientX,
        i = e.clientY;

    if (void 0 !== n && void 0 !== i) {
      var r = __.subtract(y_.subtract(new R(n, i)));

      t.onPaddingDrag(r);
    }
  };

  return r.createElement(r.Fragment, null, r.createElement(mg.Draggable, {
    onStart: function onStart(e) {
      return o(e, "left");
    },
    onDrag: s,
    onStop: a
  }, r.createElement(g_, {
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAANJJREFUSA3tlEsKwjAURUv9Vq3gBlyjKxF/c0EQxIEgggjiwP/ILbgU6ykYuLMGeRlp4JJH+3JOEmij6D9C3UCWZTWSBOEDbpM7eZCOqQRgSm7EjZ6ZAGIOvzoycz8kfGAJb7Hbi+x8aA0/C3xkCW8CPgl8bA0/CnzyDTwuWPSS9wmyon5p9ygBNshBTjGlNpfkO9+LZBZCUge6E8mcuuRxCf4tAPOf21YkC+qyP8Gj8yPZiGQZQlIFuhaJ3VftDgm8QlbkSbruuekMOCapKfQ3YW/1Myhh/78bMQAAAABJRU5ErkJggg=="
  })), r.createElement(mg.Draggable, {
    onStart: function onStart(e) {
      return o(e, "right");
    },
    onDrag: s,
    onStop: a
  }, r.createElement(m_, {
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAPhJREFUSA3tlLkKwlAQRYOVnXZ+gEshIiJ+hAgiCBJc8Sf8XgsVFBVLt2g8UwhBMomZtLlwIMxy3uMVcZwsaV/A9/1iWoe6j3wFV+iqQ9YG0hJcQHKDntWl7iHtwPeQO999ddjaQNqGM0geMLC61D2kLTiBRA4ZqsPWBtImHEHyhJHVpe4hbcABJHKIqw5bG0jrsAeJB5MoVy6qqfQ86u9AL/gdKBs+uW0NdiCR248NmvAVZFUIyiOfJtyiVBFXYAuSF0yV0eRlZL/yWXKLsoG8DBuQyM3nymjyMrI8rEEi8kVyS8wGUhfkJ7eMGbW3kRfs29nmHy/wAUVpDIFPWLFFAAAAAElFTkSuQmCC"
  })));
})),
    b_ = e(jm.Controls.Width)(S_ || (S_ = E(["\n  cursor: ew-resize;\n  @media all and (min-width: 0) and (max-width: 599px) {\n    display: none;\n  }\n"], ["\n  cursor: ew-resize;\n  @media all and (min-width: 0) and (max-width: 599px) {\n    display: none;\n  }\n"]))),
    w_ = e(b_)(C_ || (C_ = E(["\n  left: -3px;\n  top: calc(50% - ", "px);\n"], ["\n  left: -3px;\n  top: calc(50% - ", "px);\n"])), function (e) {
  return e.theme.measurements.canvasControls.width.size / 2;
}),
    x_ = e(b_)(E_ || (E_ = E(["\n  right: -3px;\n  top: calc(50% - ", "px);\n"], ["\n  right: -3px;\n  top: calc(50% - ", "px);\n"])), function (e) {
  return e.theme.measurements.canvasControls.width.size / 2;
}),
    k_ = new R(0, 0),
    T_ = new R(0, 0);

w_.defaultProps = {
  theme: Xs
}, x_.defaultProps = {
  theme: Xs
};

var S_,
    C_,
    E_,
    O_ = Gu("sprite", "textTool")(uc(function (e) {
  var t = e.sprite,
      n = e.textTool,
      i = t.leftMidPadPosition,
      o = t.rightMidPadPosition,
      a = function a(e, n) {
    t.setDragMode(!0), t.clickableCanvas(!1);
    var r = e.clientX,
        a = e.clientY;
    k_ = new R(r, a), T_ = new R("left" === n ? i : o);
  },
      s = function s() {
    t.clickableCanvas(!0), t.setDragMode(!1), t.addSnapshot("edit", t.textLocale.width), n.updateDefaultFontSize(), k_ = new R(0, 0), T_ = new R(0, 0);
  },
      l = function l(e) {
    var n = e.clientX,
        i = e.clientY;

    if (void 0 !== n && void 0 !== i) {
      var r = T_.subtract(k_.subtract(new R(n, i)));
      t.onWidthDrag(r);
    }
  };

  return r.createElement(r.Fragment, null, r.createElement(mg.Draggable, {
    onStart: function onStart(e) {
      return a(e, "left");
    },
    onDrag: l,
    onStop: s
  }, r.createElement(w_, null)), r.createElement(mg.Draggable, {
    onStart: function onStart(e) {
      return a(e, "right");
    },
    onDrag: l,
    onStop: s
  }, r.createElement(x_, null)));
})),
    R_ = Gu("textTool", "sprite", "custom")(uc(function (e) {
  var t,
      n = e.textTool,
      i = e.sprite,
      o = e.custom,
      a = n.locale.canvasActions,
      s = ((t = {})[D.EDIT] = {
    key: D.EDIT,
    customButtonKey: "canvasActionEdit",
    onClick: function onClick() {
      return n.setEditMode(!0);
    },
    label: a.buttonEdit,
    icon: r.createElement(Ny.edit, null)
  }, t[D.BRING_TO_FRONT] = {
    key: D.BRING_TO_FRONT,
    customButtonKey: "canvasActionBringToFront",
    onClick: function onClick(e) {
      e.stopPropagation(), n.bringToFront();
    },
    label: a.buttonBringToFront,
    icon: r.createElement(Ny.bringToFront, null)
  }, t[D.DUPLICATE] = {
    key: D.DUPLICATE,
    customButtonKey: "canvasActionDuplicate",
    onClick: function onClick() {
      return n.duplicate();
    },
    label: a.buttonDuplicate,
    icon: r.createElement(Ny.duplicate, null)
  }, t[D.DELETE] = {
    key: D.DELETE,
    customButtonKey: "canvasActionDelete",
    onClick: function onClick(e) {
      e.stopPropagation(), n.delete();
    },
    label: a.buttonDelete,
    icon: r.createElement(Ny.delete, null)
  }, t),
      l = n.config.canvasActions.map(function (e) {
    return s[e] ? function (e) {
      var t = e.key,
          n = e.customButtonKey,
          i = e.onClick,
          a = e.label,
          s = e.icon,
          l = o.getButton(n);
      return r.createElement(l, {
        key: t,
        onClick: i,
        label: a,
        ariaLabel: a,
        icon: s
      });
    }(s[e]) : null;
  });
  return i.isSpriteText ? r.createElement(jm.Bar.ButtonGroup, null, l) : null;
})),
    I_ = Gu("stickerTool", "custom")(uc(function (e) {
  var t,
      n = e.stickerTool,
      i = e.custom,
      o = n.locale.canvasActions,
      a = ((t = {})[D.BRING_TO_FRONT] = {
    key: D.BRING_TO_FRONT,
    customButtonKey: "canvasActionBringToFront",
    onClick: function onClick(e) {
      e.stopPropagation(), n.bringToFront();
    },
    label: o.buttonBringToFront,
    icon: r.createElement(Ny.bringToFront, null)
  }, t[D.FLIP] = {
    key: D.FLIP,
    customButtonKey: "canvasActionFlip",
    onClick: function onClick(e) {
      e.stopPropagation(), n.flipHorizontally();
    },
    label: o.buttonFlipHorizontal,
    icon: r.createElement(Ny.flipHorizontal, null)
  }, t[D.DUPLICATE] = {
    key: D.DUPLICATE,
    customButtonKey: "canvasActionDuplicate",
    onClick: function onClick() {
      return n.duplicate();
    },
    label: o.buttonDuplicate,
    icon: r.createElement(Ny.duplicate, null)
  }, t[D.DELETE] = {
    key: D.DELETE,
    customButtonKey: "canvasActionDelete",
    onClick: function onClick(e) {
      e.stopPropagation(), n.delete();
    },
    label: o.buttonDelete,
    icon: r.createElement(Ny.delete, null)
  }, t),
      s = n.config.canvasActions.map(function (e) {
    return a[e] ? function (e) {
      var t = e.key,
          n = e.customButtonKey,
          o = e.onClick,
          a = e.label,
          s = e.icon,
          l = i.getButton(n);
      return r.createElement(l, {
        key: t,
        onClick: o,
        label: a,
        ariaLabel: a,
        icon: s
      });
    }(a[e]) : null;
  });
  return n.isStickerSelected ? r.createElement(jm.Bar.ButtonGroup, null, s) : null;
})),
    A_ = Gu("textDesignTool", "custom")(uc(function (e) {
  var t,
      n = e.textDesignTool,
      i = e.custom,
      o = n.locale.canvasActions,
      a = ((t = {})[D.EDIT] = {
    key: D.EDIT,
    customButtonKey: "canvasActionEdit",
    onClick: function onClick() {
      return n.setEditMode(!0);
    },
    label: o.buttonEdit,
    icon: r.createElement(Ny.edit, null)
  }, t[D.BRING_TO_FRONT] = {
    key: D.BRING_TO_FRONT,
    customButtonKey: "canvasActionBringToFront",
    onClick: function onClick(e) {
      e.stopPropagation(), n.bringToFront();
    },
    label: o.buttonBringToFront,
    icon: r.createElement(Ny.bringToFront, null)
  }, t[D.INVERT] = {
    key: D.INVERT,
    customButtonKey: "canvasActionInvert",
    onClick: function onClick(e) {
      e.stopPropagation(), n.invertBackground();
    },
    label: o.buttonInvert,
    icon: r.createElement(Ny.flipHorizontal, null)
  }, t[D.DUPLICATE] = {
    key: D.DUPLICATE,
    customButtonKey: "canvasActionDuplicate",
    onClick: function onClick() {
      return n.duplicate();
    },
    label: o.buttonDuplicate,
    icon: r.createElement(Ny.duplicate, null)
  }, t[D.DELETE] = {
    key: D.DELETE,
    customButtonKey: "canvasActionDelete",
    onClick: function onClick(e) {
      e.stopPropagation(), n.delete();
    },
    label: o.buttonDelete,
    icon: r.createElement(Ny.delete, null)
  }, t),
      s = n.config.canvasActions.map(function (e) {
    return a[e] ? function (e) {
      var t = e.key,
          n = e.customButtonKey,
          o = e.onClick,
          a = e.label,
          s = e.icon,
          l = i.getButton(n);
      return r.createElement(l, {
        key: t,
        onClick: o,
        label: a,
        ariaLabel: a,
        icon: s
      });
    }(a[e]) : null;
  });
  return n.isTextDesignSelected ? r.createElement(jm.Bar.ButtonGroup, null, s) : null;
})),
    M_ = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.actionsRef = null, n.spriteControlPosition = function () {
      var e = n.props,
          t = e.config,
          i = e.sprite,
          r = e.canvas.canvasSize,
          o = t.measurements.canvasControls.sprite,
          a = o.controlPadding,
          s = o.controlOffset,
          l = i.position,
          u = l.x,
          c = l.y,
          p = i.currentSprite.size,
          f = p.height,
          h = p.width,
          d = i.rotationWRTOutputRotation,
          g = n.actionsRef.current,
          m = new R(0, 0);

      if (g) {
        var y = g.getBoundingClientRect();
        m = new R(y.width / 2 + s, y.height + s);
      }

      var _ = Math.abs(h * Math.sin(d)) + Math.abs(f * Math.cos(d)),
          v = new R(u, c - _ / 2 - a - s).clamp(m, new R(r.width, r.height).subtract(m));

      return {
        left: v.x,
        top: v.y
      };
    }, n.getSpriteControls = function () {
      switch (n.props.sprite.tool) {
        case P.TEXT:
          return r.createElement(R_, null);

        case P.TEXT_DESIGN:
          return r.createElement(A_, null);

        case P.STICKER:
          return r.createElement(I_, null);
      }

      return null;
    }, n.actionsRef = r.createRef(), n.state = {
      isMounted: !1
    }, n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    this.setState({
      isMounted: !0
    });
  }, t.prototype.render = function () {
    var e = this.props.sprite,
        t = this.state.isMounted,
        n = !e.isDragMode && !e.isEditMode,
        i = this.spriteControlPosition();
    return r.createElement(jm.Controls.SpriteActionsWrapper, {
      ref: this.actionsRef,
      show: n && t,
      style: _v2({}, i)
    }, this.getSpriteControls());
  }, t;
}(r.Component),
    F_ = Gu("sprite", "config", "editor", "canvas")(uc(M_)),
    D_ = e(jm.Controls.Knob)(L_ || (L_ = E(["\n  margin-left: -11px;\n  margin-top: 0px;\n  cursor: url(", ") 9 9, ew-resize;\n  &:before {\n    top: unset;\n    bottom: 0px;\n    left: calc(50% - ", "px);\n  }\n"], ["\n  margin-left: -11px;\n  margin-top: 0px;\n  cursor: url(", ") 9 9, ew-resize;\n  &:before {\n    top: unset;\n    bottom: 0px;\n    left: calc(50% - ", "px);\n  }\n"])), function (e) {
  return e.url;
}, function (e) {
  return e.theme.measurements.canvasControls.knob.size / 2;
}),
    P_ = new R(0, 0),
    z_ = new R(0, 0);

D_.defaultProps = {
  theme: Xs
};

var L_,
    B_,
    N_ = Gu("sprite", "snapping", "config")(uc(function (e) {
  var t = e.config,
      n = e.sprite,
      i = e.snapping,
      o = n.rightBottomHandlePosition,
      a = n.leftBottomHandlePosition,
      s = {
    x: (o.x + a.x) / 2,
    y: (o.y + a.y) / 2
  },
      l = t.assetProvider.getPath("controls", "/" + (function (e) {
    return void 0 === e && (e = qe()), !!e.match(/windows/i);
  }() ? "rotate-windows" : "rotate-osx") + ".png");
  return r.createElement(mg.Draggable, {
    onStart: function onStart(e) {
      var t = e.clientX,
          i = e.clientY;
      P_ = new R(t, i), z_ = new R(s), n.setDragMode(!0), n.clickableCanvas(!1);
    },
    onDrag: function onDrag(e) {
      !function (e) {
        var t = e.clientX,
            r = e.clientY;

        if (void 0 !== t && void 0 !== r) {
          var o = z_.subtract(P_.subtract(new R(t, r))),
              a = n.position,
              s = new R(a.x, a.y),
              l = o.subtract(s),
              u = Math.atan2(l.y, l.x) - Math.PI / 2,
              c = i.snapToRotation(u, l, n.currentRect);
          n.setRotation(c);
        }
      }(e);
    },
    onStop: function onStop() {
      n.clickableCanvas(!0), n.setDragMode(!1), n.spriteSnapshot("rotation"), i.hideRotationGuides(), P_ = new R(0, 0), z_ = new R(0, 0);
    }
  }, r.createElement(D_, {
    url: l
  }));
})),
    U_ = jm.Controls.Corner,
    j_ = mg.Draggable,
    W_ = new R(0, 0),
    H_ = new R(0, 0),
    G_ = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return _(t, e), Object.defineProperty(t.prototype, "sprite", {
    get: function get() {
      return this.props.sprite;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this.props,
        t = e.sprite,
        n = e.config,
        i = t,
        o = i.leftTopPosition,
        a = i.leftBottomPosition,
        s = i.rightTopPosition,
        l = i.rightBottomPosition,
        u = n.measurements.canvasControls.corner.borderWidth,
        c = function c(e) {
      var n = e.clientX,
          i = e.clientY;
      void 0 !== n && void 0 !== i && t.onCornerDrag(H_.subtract(W_.subtract(new R(n, i))));
    },
        p = function p(e, n) {
      var i = e.clientX,
          r = e.clientY;
      W_ = new R(i, r), H_ = new R(function (e) {
        switch (e) {
          case "leftTop":
            return o;

          case "leftBottom":
            return a;

          case "rightTop":
            return s;

          case "rightBottom":
            return l;

          default:
            return o;
        }
      }(n)), t.clickableCanvas(!1), t.setDragMode(!0);
    },
        f = function f() {
      t.clickableCanvas(!0), t.setDragMode(!1), t.spriteSnapshot("size"), W_ = new R(0, 0), H_ = new R(0, 0);
    };

    return r.createElement(r.Fragment, null, r.createElement(j_, {
      onStop: f,
      onDrag: c,
      onStart: function onStart(e) {
        return p(e, "leftTop");
      }
    }, r.createElement(U_, {
      vertical: "top",
      horizontal: "left",
      borderWidth: u
    })), r.createElement(j_, {
      onStop: f,
      onDrag: c,
      onStart: function onStart(e) {
        return p(e, "leftBottom");
      }
    }, r.createElement(U_, {
      vertical: "bottom",
      horizontal: "left",
      borderWidth: u
    })), r.createElement(j_, {
      onStop: f,
      onDrag: c,
      onStart: function onStart(e) {
        return p(e, "rightTop");
      }
    }, r.createElement(U_, {
      vertical: "top",
      horizontal: "right",
      borderWidth: u
    })), r.createElement(j_, {
      onStop: f,
      onDrag: c,
      onStart: function onStart(e) {
        return p(e, "rightBottom");
      }
    }, r.createElement(U_, {
      vertical: "bottom",
      horizontal: "right",
      borderWidth: u
    })));
  }, t;
}(r.Component),
    V_ = Gu("sprite", "config")(uc(G_)),
    X_ = mg.Draggable,
    Y_ = new R(0, 0),
    q_ = new R(0, 0),
    K_ = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.onAreaDrag = function (e) {
      var n = e.clientX,
          i = e.clientY,
          r = t.props.snapping,
          o = q_.subtract(Y_.subtract(new R(n, i))),
          a = r.snapToPosition({
        x: o.x,
        y: o.y
      }, t.sprite.currentRect),
          s = a.x,
          l = a.y;
      t.sprite.setPosition({
        x: s,
        y: l
      });
    }, t.onAreaDragStart = function (e) {
      var n = t.props.snapping,
          i = e.clientX,
          r = e.clientY;
      Y_ = new R(i, r), q_ = new R(t.sprite.position), t.sprite.setDragMode(!0), n.updateGuides();
    }, t.onAreaDragStop = function () {
      var e = t.props.snapping;
      Y_ = new R(0, 0), q_ = new R(0, 0), t.sprite.setDragMode(!1), t.sprite.spriteSnapshot("position"), e.hidePositionGuides();
    }, t.onDoubleClick = function (e) {
      e.preventDefault(), e.stopPropagation(), t.sprite.setEditMode(!0);
    }, t.isSpriteSelected = function () {
      var e = t.props.active.tool,
          n = t.sprite.tool;
      return t.sprite.isSpriteSelected && e === n;
    }, t;
  }

  return _(t, e), Object.defineProperty(t.prototype, "sprite", {
    get: function get() {
      return this.props.sprite;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this.props,
        t = e.sprite,
        n = e.config;
    if (!this.isSpriteSelected()) return null;
    var i = this.sprite.isSpriteText,
        o = this.sprite.isSpriteTextDesign && this.sprite.textDesignToolStore.isInverted,
        a = t.size,
        s = a.height,
        l = a.width,
        u = t.spritePosition,
        c = t.rotationWRTOutputRotation,
        p = n.measurements.canvasControls.sprite.controlPadding;
    return r.createElement(jm.Controls.Container, null, r.createElement(X_, {
      onStart: this.onAreaDragStart,
      onDrag: this.onAreaDrag,
      onStop: this.onAreaDragStop,
      rotation: c,
      position: u
    }, r.createElement(jm.Controls.Sprite, {
      onDoubleClick: this.onDoubleClick,
      height: s,
      width: l
    }, i && r.createElement(O_, null) || null, o && r.createElement(v_, null) || null, r.createElement(V_, null), r.createElement(jm.Controls.RotateHandle, {
      x: l / 2 + p / 2
    }, r.createElement(N_, null)))), r.createElement(F_, null));
  }, t;
}(r.Component),
    Z_ = Gu("sprite", "active", "snapping", "config")(uc(K_)),
    Q_ = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.containerElementRef = null, n.getControls = function (e) {
      switch (n.props.active.tool) {
        case P.FOCUS:
          return r.createElement(oy, null);

        case P.TEXT:
        case P.TEXT_DESIGN:
        case P.STICKER:
          return r.createElement(Z_, null);

        case P.BRUSH:
          return r.createElement(uy, null);

        case P.TRANSFORM:
          return r.createElement(u_, null);

        default:
          return r.createElement(jm.Controls.Container, null, e);
      }
    }, n.canvasClicked = function (e) {
      if (e.preventDefault(), e.stopPropagation(), n.props.canvas.isCanvasClickable) {
        var t = e.clientX,
            i = e.clientY;

        if (-1 !== e.type.indexOf("touch")) {
          var r = e;
          if (!r.touches.length) return;
          t = r.touches[0].clientX, i = r.touches[0].clientY;
        }

        var o = n.containerElementRef.current.getBoundingClientRect(),
            a = t - o.left,
            s = i - o.top;
        n.props.canvas.getContainersAtPreviewPoint({
          x: a,
          y: s
        });
      }
    }, n.onKeyDown = function (e) {
      "Tab" === e.code && n.props.sprite.selectLast();
    }, n.containerElementRef = r.createRef(), n;
  }

  return _(t, e), t.prototype.render = function () {
    var e = this.props.children,
        t = this.props.canvas.canvasSize,
        n = {
      height: t.height,
      width: t.width
    };
    return r.createElement(jm.Controls.Wrapper, _v2({
      "aria-hidden": !0,
      ref: this.containerElementRef,
      onClick: this.canvasClicked,
      onKeyDown: this.onKeyDown
    }, n), e, this.getControls(r.createElement(f_, null)));
  }, t;
}(r.Component),
    J_ = Gu("active", "canvas", "sprite")(uc(Q_)),
    $_ = e.div(B_ || (B_ = E(["\n  display: ", ";\n  position: absolute;\n  z-index: ", ";\n"], ["\n  display: ", ";\n  position: absolute;\n  z-index: ", ";\n"])), function (e) {
  return e.isVisible ? "block" : "none";
}, function (e) {
  return e.theme.measurements.zIndex.canvas.snappingGuide;
}),
    ev = function ev(e) {
  var t = e.isVisible,
      n = e.className;
  return r.createElement($_, {
    isVisible: t,
    className: n
  });
};

ev.defaultProps = {
  direction: "horizontal",
  left: 0,
  top: 0
};

var tv,
    nv,
    iv,
    rv,
    ov,
    av,
    sv = e(ev)(iv || (iv = E(["\n  background: ", ";\n  ", "\n"], ["\n  background: ", ";\n  ", "\n"])), function (e) {
  return e.theme.snapping.positionGuideColor;
}, function (e) {
  return "horizontal" === e.direction ? n(tv || (tv = E(["\n        width: 100%;\n        height: 2px;\n        top: ", "px;\n      "], ["\n        width: 100%;\n        height: 2px;\n        top: ", "px;\n      "])), function () {
    return e.position;
  }) : n(nv || (nv = E(["\n      width: 2px;\n      height: 100%;\n      left: ", "px;\n    "], ["\n      width: 2px;\n      height: 100%;\n      left: ", "px;\n    "])), function () {
    return e.position;
  });
}),
    lv = e(ev)(rv || (rv = E(["\n  border: none;\n  border-top: 2px dashed ", ";\n  background: transparent;\n  left: ", "px;\n  top: ", "px;\n  transform: rotate(", "rad);\n  width: 200%;\n"], ["\n  border: none;\n  border-top: 2px dashed ", ";\n  background: transparent;\n  left: ", "px;\n  top: ", "px;\n  transform: rotate(", "rad);\n  width: 200%;\n"])), function (e) {
  return e.theme.snapping.rotationGuideColor;
}, function (e) {
  return e.position.x;
}, function (e) {
  return e.position.y;
}, function (e) {
  return e.rotation;
}),
    uv = e.div(ov || (ov = E(["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  top: ", "px;\n  left: ", "px;\n  overflow: hidden;\n"], ["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  top: ", "px;\n  left: ", "px;\n  overflow: hidden;\n"])), function (e) {
  return e.width;
}, function (e) {
  return e.height;
}, function (e) {
  return e.top;
}, function (e) {
  return e.left;
}),
    cv = Gu("snapping", "editor")(uc(function (e) {
  var t = e.snapping,
      n = e.editor.getPreviewSize(),
      i = n.width,
      o = n.height,
      a = t.previewTopLeftPosition,
      s = a.x,
      l = a.y,
      u = t.positionGuides.map(function (e, t) {
    var n = e.direction,
        i = e.value,
        o = e.isVisible;
    return r.createElement(sv, {
      key: "positionGuide-" + t,
      direction: n,
      position: i,
      isVisible: o
    });
  }),
      c = t.rotationGuides.find(function (e) {
    return e.isVisible;
  });
  return r.createElement(uv, {
    width: i,
    height: o,
    left: s,
    top: l
  }, u, r.createElement(lv, {
    key: "rotationGuide",
    rotation: c ? c.value : 0,
    position: c ? c.position : {
      x: 0,
      y: 0
    },
    isVisible: !!c
  }));
})),
    pv = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.previewCanvasRef = null, n.previewCanvasRef = r.createRef(), n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    var e = this.previewCanvasRef.current;
    this.props.canvas.setCanvasElement(e);
  }, t.prototype.render = function () {
    return r.createElement(Vm, null, this.props.active.isWebcam ? r.createElement(Hm, null) : null, r.createElement(jm.Element, {
      ref: this.previewCanvasRef,
      "aria-label": "Canvas"
    }), r.createElement(J_, null, r.createElement(cv, null)));
  }, t;
}(r.Component),
    fv = Gu("active", "canvas")(uc(pv)),
    hv = jm.Button.TextSecondary,
    dv = e.span(av || (av = E(["\n  font-size: 14px;\n  padding: 3px 1px 2px;\n  color: ", ";\n  display: flex;\n  align-self: center;\n"], ["\n  font-size: 14px;\n  padding: 3px 1px 2px;\n  color: ", ";\n  display: flex;\n  align-self: center;\n"])), function (e) {
  return e.theme.canvasActionBar.foreground;
}),
    gv = Gu("scale", "active")(uc(function (e) {
  var t = e.scale,
      n = e.active,
      i = t.canZoomIn,
      o = t.canZoomOut,
      a = t.zoomLevel;
  return -1 !== [P.TRANSFORM, P.BRUSH, P.FOCUS, P.STICKER, P.TEXT, P.TEXT_DESIGN].indexOf(n.tool) ? null : r.createElement(jm.Bar.ButtonGroup, null, r.createElement(hv, {
    ariaLabel: "Zoom out",
    isDisabled: !o,
    onClick: t.out
  }, "-"), r.createElement(dv, null, a, " %"), r.createElement(hv, {
    ariaLabel: "Zoom in",
    isDisabled: !i,
    onClick: t.in
  }, "+"));
}));

dv.defaultProps = {
  theme: Xs
};

var mv,
    yv,
    _v,
    vv,
    bv,
    wv,
    xv,
    kv,
    Tv,
    Sv = e(jm.Bar.ButtonGroup)(mv || (mv = E(["\n  > :last-child {\n    margin-left: 10px;\n  }\n  > :first-child {\n    margin-left: 0;\n  }\n"], ["\n  > :last-child {\n    margin-left: 10px;\n  }\n  > :first-child {\n    margin-left: 0;\n  }\n"]))),
    Cv = Gu("config", "editor", "history", "custom")(uc(function (e) {
  var t = e.config,
      n = e.editor,
      i = e.history,
      o = e.custom,
      a = t.locale.mainCanvasActions,
      s = i.canUndo,
      l = i.canRedo,
      u = t.config.mainCanvasActions,
      c = function c() {
    n.export();
  },
      p = function p() {
    if (n.activeStore.tool === P.TRANSFORM) return null;
    var e = o.getButton("mainCanvasActionUndo");
    return r.createElement(e, {
      key: "mainCanvasActionUndo",
      onClick: i.undo,
      isDisabled: !s,
      label: a.buttonUndo,
      ariaLabel: a.buttonUndo,
      icon: r.createElement(Py, null)
    });
  },
      f = function f() {
    if (n.activeStore.tool === P.TRANSFORM) return null;
    var e = o.getButton("mainCanvasActionRedo");
    return r.createElement(e, {
      key: "mainCanvasActionRedo",
      onClick: i.redo,
      isDisabled: !l,
      label: a.buttonRedo,
      ariaLabel: a.buttonRedo,
      icon: r.createElement(zy, null)
    });
  },
      h = function h() {
    var e = o.getButton("mainCanvasActionExport");
    return r.createElement(e, {
      key: "mainCanvasActionExport",
      onClick: c,
      label: a.buttonExport,
      ariaLabel: a.buttonExport,
      icon: r.createElement(By, null)
    });
  },
      d = function d() {
    if (!t.displayCloseButton) return null;
    var e = o.getButton("mainCanvasActionClose");
    return r.createElement(e, {
      key: "mainCanvasActionClose",
      "data-test-id": "MainCanvasBarActionClose",
      onClick: n.close,
      label: a.buttonClose,
      ariaLabel: a.buttonClose,
      icon: r.createElement(Ly, null)
    });
  },
      g = u.map(function (e) {
    switch (e) {
      case D.UNDO:
        return p;

      case D.REDO:
        return f;

      case D.EXPORT:
        return h;

      case D.CLOSE:
        return d;
    }

    return null;
  });

  return r.createElement(jm.Bar.Index, null, r.createElement(Sv, null, g[0] && g[0]() || null, g[1] && g[1]() || null), t.config.enableZoom ? r.createElement(gv, null) : null, r.createElement(Sv, null, g[2] && g[2]() || null, g[3] && g[3]() || null));
})),
    Ev = e.div(yv || (yv = E(["\n  display: inline-flex;\n  justify-content: space-between;\n  max-width: ", "px;\n"], ["\n  display: inline-flex;\n  justify-content: space-between;\n  max-width: ", "px;\n"])), function (e) {
  return e.theme.measurements.advancedUIToolControlBar.width;
}),
    Ov = e.span(_v || (_v = E(["\n  font-size: ", "px;\n  margin-top: 10px;\n  margin-right: 13px;\n"], ["\n  font-size: ", "px;\n  margin-top: 10px;\n  margin-right: 13px;\n"])), function (e) {
  return e.theme.measurements.fontSystem.label.size;
}),
    Rv = e.div(vv || (vv = E(["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n"], ["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n"]))),
    Iv = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.onWidthChange = function (e) {
      t.props.onChangeWidth(parseInt(e, 10) || 0);
    }, t.onHeightChange = function (e) {
      t.props.onChangeHeight(parseInt(e, 10) || 0);
    }, t.onKeyUpWidth = function (e) {
      13 === e.keyCode && t.props.onPixelWidth();
    }, t.onKeyUpHeight = function (e) {
      13 === e.keyCode && t.props.onPixelHeight();
    }, t.onPixelHeight = function () {
      t.props.onPixelHeight();
    }, t.onPixelWidth = function () {
      t.props.onPixelWidth();
    }, t;
  }

  return _(t, e), t.prototype.render = function () {
    var e = this.props,
        t = e.label,
        n = e.showLabel,
        i = e.isDisabled,
        o = e.labelWidth,
        a = e.labelHeight,
        s = e.valueWidth,
        l = e.valueHeight;
    return r.createElement("div", null, r.createElement(mg.Input.Label, {
      label: t,
      show: n
    }), r.createElement(Ev, null, r.createElement(mg.Input.Text, {
      id: "photoeditorsdk-transformScaleWidth",
      testId: "TransformScaleWidth",
      value: s,
      isDisabled: i,
      onChange: this.onWidthChange,
      onBlur: this.onPixelWidth,
      onKeyUp: this.onKeyUpWidth
    }, r.createElement(Rv, null, r.createElement(mg.Input.Label, {
      label: o,
      htmlFor: "photoeditorsdk-transformScaleWidth"
    }))), r.createElement(Ov, null, "x"), r.createElement(mg.Input.Text, {
      id: "photoeditorsdk-transformScaleHeight",
      testId: "TransformScaleHeight",
      value: l,
      isDisabled: i,
      onChange: this.onHeightChange,
      onBlur: this.onPixelHeight,
      onKeyUp: this.onKeyUpHeight
    }, r.createElement(Rv, null, r.createElement(mg.Input.Label, {
      label: a,
      htmlFor: "photoeditorsdk-transformScaleHeight"
    })))));
  }, t.defaultProps = {
    showLabel: !0
  }, t;
}(r.Component),
    Av = Gu("textTool", "textDesignTool", "modal", "custom", "config")(uc(function (e) {
  var t = e.modal,
      n = e.textTool,
      i = e.textDesignTool,
      o = e.custom,
      a = e.config,
      s = t,
      l = s.type,
      u = s.infoModalProps,
      c = s.actionModalProps,
      p = t.positionOffset,
      f = o.getLoader();

  switch (l) {
    case Nt.INFO:
      return "loading" === t.identifier ? r.createElement(f, _v2({}, u, {
        position: p
      })) : r.createElement(mg.Loader, _v2({}, u, {
        position: p
      }));

    case Nt.TEXT_EDIT:
      return n.isTextSelected ? r.createElement(mg.Input.TextEdit, {
        defaultText: El.defaultText(),
        show: t.show,
        save: n.changeText,
        close: n.setEditMode,
        text: n.text,
        position: p,
        saveLabel: n.locale.canvasControls.buttonSave,
        closeLabel: n.locale.canvasControls.buttonClose,
        editLabel: n.locale.canvasControls.inputText,
        maxLength: a.config.text.maxCharacterLimit
      }) : i.isTextDesignSelected ? r.createElement(mg.Input.TextEdit, {
        defaultText: Al.defaultText(),
        show: t.show,
        save: i.changeText,
        close: i.setEditMode,
        text: i.text,
        position: p,
        saveLabel: n.locale.canvasControls.buttonSave,
        closeLabel: n.locale.canvasControls.buttonClose,
        editLabel: n.locale.canvasControls.inputText
      }) : null;

    default:
      return r.createElement(mg.Modal, _v2({}, c, {
        position: p
      }));
  }
})),
    Mv = function Mv(e, t) {
  var n = this;
  void 0 === e && (e = {}), void 0 === t && (t = {}), this.getAdvancedCategoryCard = function () {
    return n.components.advancedUICategoryCard;
  }, this.getAdvancedItemCard = function () {
    return n.components.advancedUIItemCard;
  }, this.getAdvancedToolbarItem = function () {
    return n.components.advancedUIToolbarItem;
  }, this.getLoader = function () {
    return n.components.loader;
  }, this.getButton = function (e) {
    return n.components.buttons[e];
  }, this.getColorItem = function () {
    return n.components.colorItem;
  }, this.getCheckbox = function () {
    return n.components.checkbox;
  };
  var i = {
    loader: mg.Loader,
    colorItem: mg.ColorItem,
    checkbox: mg.Input.Checkbox,
    buttons: {
      mainCanvasActionUndo: jm.Button.TextSecondary,
      mainCanvasActionRedo: jm.Button.TextSecondary,
      mainCanvasActionExport: Np,
      mainCanvasActionClose: Pp,
      canvasActionEdit: jm.Controls.SpriteActionButton,
      canvasActionBringToFront: jm.Controls.SpriteActionButton,
      canvasActionDuplicate: jm.Controls.SpriteActionButton,
      canvasActionDelete: jm.Controls.SpriteActionButton,
      canvasActionInvert: jm.Controls.SpriteActionButton,
      canvasActionFlip: jm.Controls.SpriteActionButton,
      transformActionFlipHorizontal: Bp,
      transformActionFlipVertical: Bp,
      transformActionRotateClockwise: Bp,
      transformActionRotateAntiClockwise: Bp,
      textAlignment: Bp
    }
  };
  this.components = Fs([i, t, e]);
},
    Fv = e.div(bv || (bv = E(["\n  position: relative;\n"], ["\n  position: relative;\n"]))),
    Dv = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    n.onClick = function (e) {
      return function (t) {
        var i = n.props,
            r = i.onAddSnapshot,
            o = i.config,
            a = i.onChange,
            s = i.colorPickerDirection,
            l = n.state,
            u = l.activeIdentifier,
            c = l.showColorPicker,
            p = l.colorList.find(function (t) {
          return t.identifier === e;
        });
        if (u !== p.identifier || c) c ? n.setState({
          showColorPicker: !1
        }) : (a(p.color), n.setState({
          activeIdentifier: e
        }), r && r());else {
          n.UIComponent || import("./index-d238644c.js").then(function (e) {
            var t = e.ColorPicker;
            n.UIComponent = t, n.forceUpdate();
          });
          var f = t.currentTarget.getBoundingClientRect(),
              h = f.left,
              d = f.width,
              g = f.top,
              m = f.height,
              y = t.currentTarget.parentElement.getBoundingClientRect(),
              _ = y.left,
              v = y.top,
              b = o.measurements.color.colorPicker,
              w = h - _ + d / 2 - 2,
              x = "bottom" === s ? g - v + m + b.arrow.width / 2 : g - v - b.arrow.width / 2,
              k = -24,
              T = b.width - b.arrow.width - 12;
          w > T && (w -= k += w - T), n.setState({
            showColorPicker: !0,
            arrowOffset: w,
            topOffset: x,
            leftOffset: k
          });
        }
      };
    }, n.onChange = function (e) {
      var t = e.color,
          i = e.colorString,
          r = n.props.onChange,
          o = n.state,
          a = o.activeIdentifier,
          s = o.colorList,
          l = s.findIndex(function (e) {
        return e.identifier === a;
      });

      if (-1 !== l) {
        var u = C(s);
        u[l] = {
          identifier: s[l].identifier,
          colorString: i,
          color: t
        }, n.setState({
          colorList: u
        });
      }

      r(t);
    }, n.onChangeColorPicker = function (e) {
      var t = e.color,
          i = e.colorString;
      n.onChange({
        color: [t[0] / 255, t[1] / 255, t[2] / 255, t[3]],
        colorString: i
      });
    }, n.closeColorPicker = function () {
      n.setState({
        showColorPicker: !1
      });
    }, n.getColorPicker = function () {
      var e = n.props,
          t = e.activeColor,
          i = e.parentId,
          o = e.labelsColor,
          a = e.colorPickerDirection,
          s = e.onAddSnapshot,
          l = n.state,
          u = l.showColorPicker,
          c = l.arrowOffset,
          p = l.leftOffset,
          f = l.topOffset;
      if (!n.UIComponent) return null;
      var h = n.UIComponent;
      return r.createElement(h, {
        parentId: i,
        color: xr(t),
        show: u,
        direction: a,
        arrowOffset: c,
        leftOffset: p,
        topOffset: f,
        labelHex: o.hex,
        labelR: o.r,
        labelG: o.g,
        labelB: o.b,
        labelSliderOpacity: o.sliderOpacity,
        labelSliderHue: o.sliderHue,
        onChange: n.onChangeColorPicker,
        onRequestClose: n.closeColorPicker,
        onAddSnapshot: s
      });
    };
    var i = n.props.colors;
    return n.state = {
      activeIdentifier: "",
      activeSprite: "",
      colorList: C(i),
      showColorPicker: !1,
      arrowOffset: 0,
      leftOffset: 0,
      topOffset: 0
    }, n.UIComponent = null, n;
  }

  return _(t, e), t.getDerivedStateFromProps = function (e, t) {
    var n = e.activeSprite,
        i = e.activeColor,
        r = t.activeSprite,
        o = t.colorList;

    if (n !== r || !n) {
      var a = Qt(xr(i)),
          s = o.find(function (e) {
        return e.colorString === a;
      });
      return {
        activeSprite: n,
        activeIdentifier: s ? s.identifier : ""
      };
    }

    return null;
  }, t.prototype.render = function () {
    var e = this,
        t = this.props,
        n = t.isDisabled,
        i = t.custom,
        o = t.config,
        a = this.state,
        s = a.activeIdentifier,
        l = a.colorList,
        u = i.getColorItem(),
        c = o.assetProvider.getPath("controls", "/tiled-background.png"),
        p = l.map(function (t) {
      return r.createElement(u, {
        key: t.colorString + "-item-" + t.identifier,
        isActive: t.identifier === s,
        isDisabled: n,
        onClick: e.onClick(t.identifier),
        color: t.colorString,
        label: t.identifier,
        tiledBackgroundUrl: c
      });
    });
    return r.createElement(Fv, null, p, this.getColorPicker());
  }, t.defaultProps = {
    colorPickerDirection: "bottom",
    isDisabled: !1
  }, t = w([Gu("config", "custom"), uc], t);
}(r.Component),
    Pv = e.div(kv || (kv = E(["\n  z-index: ", ";\n  flex-shrink: 0;\n  background-color: ", ";\n  color: ", ";\n  ", "\n  width: ", "px;\n  margin-bottom: ", "px;\n"], ["\n  z-index: ", ";\n  flex-shrink: 0;\n  background-color: ", ";\n  color: ", ";\n  ", "\n  width: ", "px;\n  margin-bottom: ", "px;\n"])), function (e) {
  return e.theme.measurements.zIndex.toolbar;
}, function (e) {
  return e.theme.toolbar.background;
}, function (e) {
  return e.theme.toolbar.foreground;
}, function (e) {
  return e.reverse ? n(xv || (xv = E(["\n          border-left: 1px solid ", ";\n        "], ["\n          border-left: 1px solid ", ";\n        "])), e.theme.toolbar.borderColor) : n(wv || (wv = E(["\n          border-right: 1px solid ", ";\n        "], ["\n          border-right: 1px solid ", ";\n        "])), e.theme.toolbar.borderColor);
}, function (e) {
  return e.theme.measurements.advancedUIToolbar.width;
}, function (e) {
  return e.theme.measurements.advancedUIToolbar.marginBottom;
}),
    zv = e.ul.attrs(function () {
  return {
    role: "menubar",
    "aria-label": "Tool Navigation",
    "data-simplebar": "init",
    "data-simplebar-auto-hide": "false"
  };
})(Tv || (Tv = E(["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  list-style: none;\n  overflow-x: hidden;\n  overflow-y: overlay;\n  height: 100%;\n  .simplebar-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  list-style: none;\n  overflow-x: hidden;\n  overflow-y: overlay;\n  height: 100%;\n  .simplebar-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"]))),
    Lv = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      reverse: !1
    }, t;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    var e = document.getElementById("photoeditorsdk-AdvancedToolbar");
    e && e.offsetLeft > window.innerWidth / 2 && this.setState({
      reverse: !0
    });
  }, t.prototype.render = function () {
    return r.createElement(Pv, {
      reverse: this.state.reverse
    }, r.createElement(zv, {
      id: "photoeditorsdk-AdvancedToolbar"
    }, this.props.children(this.state.reverse)));
  }, t;
}(r.Component);

Pv.defaultProps = {
  theme: Xs
}, zv.defaultProps = {
  theme: Xs
};
var Bv,
    Nv,
    Uv,
    jv,
    Wv,
    Hv = e(Dp)(jv || (jv = E(["\n  width: inherit;\n  height: inherit;\n  padding: 0;\n  margin: 0;\n  ", "\n\n  ", "\n"], ["\n  width: inherit;\n  height: inherit;\n  padding: 0;\n  margin: 0;\n  ", "\n\n  ", "\n"])), Ze() ? n(Bv || (Bv = E(["\n        background-color: transparent;\n      "], ["\n        background-color: transparent;\n      "]))) : n(Nv || (Nv = E(["\n        background-color: inherit;\n      "], ["\n        background-color: inherit;\n      "]))), function (e) {
  return e.isActive && n(Uv || (Uv = E(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), e.theme.toolbar.activeBackground, e.theme.toolbar.activeForeground);
}),
    Gv = e.li.attrs({
  "aria-haspopup": !0,
  "aria-hidden": !0,
  role: "menuitem"
})(Wv || (Wv = E(["\n  height: ", "px;\n  cursor: pointer;\n  position: relative;\n"], ["\n  height: ", "px;\n  cursor: pointer;\n  position: relative;\n"])), function (e) {
  return e.theme.measurements.advancedUIToolbar.itemHeight;
});
Gv.defaultProps = {
  theme: Xs
};
var Vv,
    Xv = e.li.attrs({
  role: "none"
})(Vv || (Vv = E(["\n  height: ", "px;\n  cursor: pointer;\n  position: relative;\n"], ["\n  height: ", "px;\n  cursor: pointer;\n  position: relative;\n"])), function (e) {
  return e.theme.measurements.advancedUIToolbar.seperatorHeight;
});
Xv.defaultProps = {
  theme: Xs
};

var Yv,
    qv,
    Kv,
    Zv,
    Qv,
    Jv,
    $v,
    eb = e.div(Jv || (Jv = E(["\n  ", "\n  position: -ms-device-fixed;\n  top: ", "px;\n  left: ", "px;\n  z-index: ", ";\n  transition: opacity 0.5s ease-in-out, left 0.25s ease-in-out, right 0.25s ease-in-out, visibility 0.5s ease-in-out;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  cursor: pointer;\n  line-height: normal;\n\n  &:before {\n    content: ' ';\n    position: absolute;\n    top: 10px;\n    left: -8px;\n    width: 0;\n    height: 0;\n    border-right: 8px solid ", ";\n    border-bottom: 6px solid transparent;\n    border-top: 6px solid transparent;\n  }\n\n  &:after {\n    content: '", "';\n    position: absolute;\n    transition: margin-left 0.15s ease-in-out, opacity 0.15s ease-in-out;\n    color: ", ";\n    background: ", ";\n    padding: 8px 12px;\n    text-align: center;\n    vertical-align: super;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    border-radius: ", "px;\n    white-space: nowrap;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n  position: -ms-device-fixed;\n  top: ", "px;\n  left: ", "px;\n  z-index: ", ";\n  transition: opacity 0.5s ease-in-out, left 0.25s ease-in-out, right 0.25s ease-in-out, visibility 0.5s ease-in-out;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  cursor: pointer;\n  line-height: normal;\n\n  &:before {\n    content: ' ';\n    position: absolute;\n    top: 10px;\n    left: -8px;\n    width: 0;\n    height: 0;\n    border-right: 8px solid ", ";\n    border-bottom: 6px solid transparent;\n    border-top: 6px solid transparent;\n  }\n\n  &:after {\n    content: '", "';\n    position: absolute;\n    transition: margin-left 0.15s ease-in-out, opacity 0.15s ease-in-out;\n    color: ", ";\n    background: ", ";\n    padding: 8px 12px;\n    text-align: center;\n    vertical-align: super;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-transform: ", ";\n    border-radius: ", "px;\n    white-space: nowrap;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), Ze() ? n(Yv || (Yv = E(["\n          position: -ms-device-fixed;\n        "], ["\n          position: -ms-device-fixed;\n        "]))) : n(qv || (qv = E(["\n          position: fixed;\n        "], ["\n          position: fixed;\n        "]))), function (e) {
  return e.position.y - 5;
}, function (e) {
  return e.position.x + e.theme.measurements.advancedUIToolbar.width - 10;
}, function (e) {
  return e.theme.measurements.zIndex.toolbar;
}, function (e) {
  return e.theme.tooltip.background;
}, function (e) {
  return e.label;
}, function (e) {
  return e.theme.tooltip.foreground;
}, function (e) {
  return e.theme.tooltip.background;
}, function (e) {
  return e.theme.measurements.fontSystem.label.size;
}, function (e) {
  return e.theme.measurements.fontSystem.label.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.label.case;
}, function (e) {
  return e.theme.shape.radiusSmall;
}, function (e) {
  return e.reverse && n(Kv || (Kv = E(["\n      left: unset;\n      right: ", "px;\n      direction: rtl;\n\n      &:before {\n        border-left: 8px solid ", ";\n        border-right: unset;\n        right: -8px;\n        left: unset;\n        top: 10px;\n      }\n    "], ["\n      left: unset;\n      right: ", "px;\n      direction: rtl;\n\n      &:before {\n        border-left: 8px solid ", ";\n        border-right: unset;\n        right: -8px;\n        left: unset;\n        top: 10px;\n      }\n    "])), e.position.x + e.theme.measurements.advancedUIToolbar.width - 10, e.theme.tooltip.background);
}, function (e) {
  return e.show && !e.reverse && n(Zv || (Zv = E(["\n      opacity: 1;\n      visibility: visible;\n      left: ", "px;\n    "], ["\n      opacity: 1;\n      visibility: visible;\n      left: ", "px;\n    "])), e.position.x + e.theme.measurements.advancedUIToolbar.width + 16);
}, function (e) {
  return e.show && e.reverse && n(Qv || (Qv = E(["\n      opacity: 1;\n      visibility: visible;\n      right: ", "px;\n    "], ["\n      opacity: 1;\n      visibility: visible;\n      right: ", "px;\n    "])), e.position.x + e.theme.measurements.advancedUIToolbar.width + 16);
}),
    tb = e.span($v || ($v = E(["\n  display: none;\n"], ["\n  display: none;\n"]))),
    nb = function nb(e) {
  var t = e.show,
      n = e.reverse,
      i = e.position,
      o = e.children,
      a = "string" == typeof o ? o : "";
  return r.createElement(eb, {
    "data-test-id": "Tooltip",
    show: t,
    reverse: n,
    position: i,
    label: a
  }, r.createElement(tb, null, a));
};

eb.defaultProps = {
  theme: Xs
}, nb.defaultProps = {
  show: !1
};

var ib,
    rb,
    ob,
    ab,
    sb = e.div(ob || (ob = E(["\n  flex-shrink: 0;\n  background: ", ";\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.4s ease-in;\n  width: ", "px;\n  margin-bottom: ", "px;\n  ", "\n  z-index: ", ";\n  /* for Firefox */\n  min-height: 0;\n"], ["\n  flex-shrink: 0;\n  background: ", ";\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.4s ease-in;\n  width: ", "px;\n  margin-bottom: ", "px;\n  ", "\n  z-index: ", ";\n  /* for Firefox */\n  min-height: 0;\n"])), function (e) {
  return e.theme.toolControlBar.background;
}, function (e) {
  return e.theme.measurements.advancedUIToolControlBar.width;
}, function (e) {
  return e.theme.measurements.advancedUIToolControlBar.marginBottom;
}, function (e) {
  return e.reverse ? n(rb || (rb = E(["\n          border-left: 1px solid ", ";\n        "], ["\n          border-left: 1px solid ", ";\n        "])), e.theme.toolControlBar.borderColor) : n(ib || (ib = E(["\n          border-right: 1px solid ", ";\n        "], ["\n          border-right: 1px solid ", ";\n        "])), e.theme.toolControlBar.borderColor);
}, function (e) {
  return e.theme.measurements.zIndex.toolControlBar;
}),
    lb = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      reverse: !1
    }, t;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    var e = document.getElementById("photoeditorsdk-Sidebar");
    e && e.offsetLeft > window.innerWidth / 2 && this.setState({
      reverse: !0
    });
  }, t.prototype.render = function () {
    return r.createElement(sb, {
      id: "photoeditorsdk-Sidebar",
      reverse: this.state.reverse
    }, this.props.children);
  }, t;
}(r.Component),
    ub = e.h2(ab || (ab = E(["\n  /* Center text horizontally and vertically */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 0;\n  padding: 0 4px;\n  margin: 0;\n  min-height: ", "px;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  background: ", ";\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  font-weight: 500;\n  text-align: center;\n"], ["\n  /* Center text horizontally and vertically */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 0;\n  padding: 0 4px;\n  margin: 0;\n  min-height: ", "px;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  background: ", ";\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  font-weight: 500;\n  text-align: center;\n"])), function (e) {
  return e.theme.measurements.mainCanvasActionBar.height - 2;
}, function (e) {
  return e.theme.measurements.fontSystem.headline1.size;
}, function (e) {
  return e.theme.measurements.fontSystem.headline1.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.headline1.case;
}, function (e) {
  return e.theme.toolControlBar.background;
}, function (e) {
  return e.theme.toolControlBar.titleForeground;
}, function (e) {
  return e.theme.toolControlBar.separatorColor;
});

ub.defaultProps = {
  theme: Xs
};

var cb,
    pb,
    fb = e.div(cb || (cb = E(["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: ", "px;\n  opacity: ", ";\n  visibility: ", ";\n  overflow: ", ";\n  transition: ", ";\n  background: ", ";\n  color: ", ";\n"], ["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: ", "px;\n  opacity: ", ";\n  visibility: ", ";\n  overflow: ", ";\n  transition: ", ";\n  background: ", ";\n  color: ", ";\n"])), function (e) {
  return e.height;
}, function (e) {
  return e.opacity;
}, function (e) {
  return e.visibility;
}, function (e) {
  var t = e.shouldAnimateOverflow,
      n = e.overflow;
  return t ? n : void 0;
}, function (e) {
  return e.shouldAnimateHeight ? "opacity 0.5s ease-in, height 0.4s ease-out" : "opacity 0.5s ease-in";
}, function (e) {
  return e.theme.toolControlBar.background;
}, function (e) {
  return e.theme.toolControlBar.inputLabelForeground;
}),
    hb = e.div(pb || (pb = E(["\n  position: relative;\n  padding: ", ";\n"], ["\n  position: relative;\n  padding: ", ";\n"])), function (e) {
  return e.theme.measurements.advancedUIToolControlBar.padding;
}),
    db = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.contentRef = null, n.enableOverflow = function () {
      n.props.show && n.contentRef.current && n.setState({
        overflow: !0
      });
    }, n.contentRef = r.createRef(), n.state = {
      height: 0,
      mounted: !1,
      overflow: !1
    }, n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    var e = this.props.overflowAfterExpand;
    this.contentRef.current && (e && this.contentRef.current.addEventListener("transitionend", this.enableOverflow), this.setState({
      height: this.contentRef.current.scrollHeight,
      mounted: !0
    }));
  }, t.prototype.componentWillUnmount = function () {
    this.contentRef.current && this.contentRef.current.removeEventListener("transitionend", this.enableOverflow);
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.show,
        n = e.shouldAnimateOverflow,
        i = e.shouldAnimateHeight,
        o = e.children,
        a = this.state,
        s = a.height,
        l = a.mounted,
        u = a.overflow,
        c = l && (t && n || !n),
        p = c ? s : 0,
        f = c ? 1 : 0,
        h = c ? "visible" : "hidden";
    return r.createElement(fb, {
      "data-test-id": "ToolControlBar",
      ref: this.contentRef,
      height: p,
      opacity: f,
      visibility: h,
      overflow: u ? "visible" : "hidden",
      shouldAnimateHeight: i,
      shouldAnimateOverflow: n
    }, r.createElement(hb, null, o));
  }, t.defaultProps = {
    show: !0,
    shouldAnimateOverflow: !0,
    shouldAnimateHeight: !0
  }, t;
}(r.Component);

fb.defaultProps = {
  theme: Xs
};
var gb,
    mb = e.div.attrs({
  "data-simplebar": "init",
  "data-simplebar-auto-hide": "false"
})(gb || (gb = E(["\n  &&& {\n    flex-grow: 1;\n    position: relative;\n    box-sizing: border-box;\n    padding: ", ";\n    width: ", "px;\n    overflow: visible;\n    /* for Firefox */\n    min-height: 0;\n    transition: height 0.4s cubic-bezier(0.17, 0.04, 0.03, 0.94);\n    background: ", ";\n    color: ", ";\n\n    ", "\n    .photoeditorsdk-simplebar-placeholder {\n      height: 0px !important;\n    }\n  }\n"], ["\n  &&& {\n    flex-grow: 1;\n    position: relative;\n    box-sizing: border-box;\n    padding: ", ";\n    width: ", "px;\n    overflow: visible;\n    /* for Firefox */\n    min-height: 0;\n    transition: height 0.4s cubic-bezier(0.17, 0.04, 0.03, 0.94);\n    background: ", ";\n    color: ", ";\n\n    ", "\n    .photoeditorsdk-simplebar-placeholder {\n      height: 0px !important;\n    }\n  }\n"])), function (e) {
  return e.theme.measurements.advancedUIToolControlBar.padding;
}, function (e) {
  return e.theme.measurements.advancedUIToolControlBar.width;
}, function (e) {
  return e.theme.toolControlBar.background;
}, function (e) {
  return e.theme.toolControlBar.inputLabelForeground;
}, Kp.HiddenScrollbar);
mb.defaultProps = {
  theme: Xs
};

var yb,
    _b = e.h2(yb || (yb = E(["\n  color: ", ";\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  font-weight: 500;\n  height: ", "px;\n  line-height: ", "px;\n"], ["\n  color: ", ";\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  font-weight: 500;\n  height: ", "px;\n  line-height: ", "px;\n"])), function (e) {
  return e.theme.toolControlBar.titleForeground;
}, function (e) {
  return e.theme.measurements.fontSystem.headline2.size;
}, function (e) {
  return e.theme.measurements.fontSystem.headline2.letterSpacing;
}, function (e) {
  return e.theme.measurements.fontSystem.headline2.case;
}, function (e) {
  return 2 * e.theme.measurements.advancedSpacer;
}, function (e) {
  return 2 * e.theme.measurements.advancedSpacer;
});

_b.defaultProps = {
  theme: Xs
};
var vb,
    bb,
    wb = e.div(bb || (bb = E(["\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0px;\n    ", "\n    border-bottom: 2px solid ", ";\n  }\n"], ["\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0px;\n    ", "\n    border-bottom: 2px solid ", ";\n  }\n"])), function (e) {
  return e.full ? n(vb || (vb = E(["\n            left: -", "px;\n            width: calc(100% + ", "px);\n          "], ["\n            left: -", "px;\n            width: calc(100% + ", "px);\n          "])), 3 * e.theme.measurements.advancedSpacer / 2, 3 * e.theme.measurements.advancedSpacer) : "\n      left: " + 3 * e.theme.measurements.advancedSpacer / 2 + "px;\n      width: calc(100% - " + 3 * e.theme.measurements.advancedSpacer + "px);\n    ";
}, function (e) {
  return e.theme.toolControlBar.separatorColor;
});
wb.defaultProps = {
  theme: Xs
};

var xb,
    kb,
    Tb,
    Sb,
    Cb,
    Eb,
    Ob,
    Rb,
    Ib,
    Ab,
    Mb,
    Fb,
    Db,
    Pb,
    zb,
    Lb,
    Bb,
    Nb = {
  Card: wg,
  CardContainer: xg,
  CardLabel: kg,
  Toolbar: {
    Index: Lv,
    Item: function Item(e) {
      return r.createElement(Gv, null, r.createElement(Hv, _v2({
        isActive: e.isActive,
        "data-test-id": e.ariaLabel
      }, e)));
    },
    Separator: Xv,
    Tooltip: nb
  },
  Itemsbar: mb,
  BarSeparator: "",
  ItemsSeparator: wb,
  Controlsbar: db,
  Sidebar: {
    Index: lb,
    Heading: ub,
    SubHeading: _b
  }
},
    Ub = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.ref = null, n.updatePosition = function () {
      var e = n.props.isReverse,
          t = {
        x: 0,
        y: 0
      };

      if (n.ref.current) {
        var i = n.ref.current.getBoundingClientRect(),
            r = i.top,
            o = i.height,
            a = i.left,
            s = i.right;
        t.y = r + o / 4, t.x = e ? window.innerWidth - s : a;
      }

      n.setState({
        tooltipPosition: t
      });
    }, n.mouseOver = function (e) {
      n.updatePosition(), n.setState({
        hoverTool: e
      });
    }, n.mouseOut = function () {
      n.setState({
        hoverTool: null
      });
    }, n.state = {
      hoverTool: null,
      tooltipPosition: {
        x: 0,
        y: 0
      }
    }, n.ref = r.createRef(), n;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    this.updatePosition();
  }, t.prototype.componentDidUpdate = function (e) {
    this.props.isReverse !== e.isReverse && this.updatePosition();
  }, t.prototype.render = function () {
    var e = this,
        t = this.props,
        n = t.tool,
        i = t.isActive,
        o = t.isReverse,
        a = t.icon,
        s = t.label,
        l = t.onClick,
        u = t.className,
        c = this.state,
        p = c.hoverTool,
        f = c.tooltipPosition;
    return r.createElement(jb, {
      ref: this.ref,
      onMouseOver: function onMouseOver() {
        return e.mouseOver(n);
      },
      onMouseOut: function onMouseOut() {
        return e.mouseOut();
      },
      className: u
    }, r.createElement(Nb.Toolbar.Item, {
      ariaLabel: s,
      isActive: i,
      onClick: function onClick() {
        return l(n);
      }
    }, a), r.createElement(Nb.Toolbar.Tooltip, {
      position: f,
      reverse: o,
      show: p === n
    }, s));
  }, t;
}(r.Component),
    jb = e.div(xb || (xb = E(["\n  position: relative;\n"], ["\n  position: relative;\n"]))),
    Wb = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.renderIcon = function (e) {
      var t = My[e];
      return r.createElement(t, null) || null;
    }, t.update = function (e) {
      t.props.active.selectTool(e);
    }, t;
  }

  return _(t, e), t.prototype.getToolTitle = function (e) {
    return this.props.config.locale[e].title;
  }, t.prototype.render = function () {
    var e = this,
        t = this.props.active.tool,
        n = this.props,
        i = n.tool,
        o = n.custom;

    if (i) {
      var a = o.getAdvancedToolbarItem();
      return r.createElement(a, {
        key: i,
        isActive: i === t,
        isReverse: this.props.isReverse,
        icon: this.renderIcon(i),
        onClick: function onClick() {
          return e.update(i);
        },
        tool: i,
        label: this.getToolTitle(i)
      });
    }

    return r.createElement(Nb.Toolbar.Separator, null);
  }, t = w([Gu("active", "config", "custom"), uc], t);
}(r.Component),
    Hb = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.renderTools = function (e) {
      return t.props.config.tools.map(function (t, n) {
        return r.createElement(Wb, {
          key: t || n,
          tool: t,
          isReverse: e
        });
      });
    }, t;
  }

  return _(t, e), t.prototype.render = function () {
    return r.createElement(Nb.Toolbar.Index, null, this.renderTools);
  }, t = w([Gu("config"), uc], t);
}(r.Component),
    Gb = Gu("library", "active")(uc(function (e) {
  var t = e.library,
      n = e.active,
      i = t.locale.controls.placeholderSearch,
      o = t,
      a = o.config,
      s = o.libraryProvider,
      l = function l(e) {
    var t = e.target.files;

    if (t.length) {
      var i = new FileReader();
      i.onload = function (e) {
        n.newImage(e.target.result);
      }, i.readAsDataURL(t[0]);
    }
  },
      u = function u() {
    n.selectWebcam(!0);
  },
      c = function c() {
    var e = document.getElementById("fileUpload");
    e && e.click();
  };

  return r.createElement(Nb.Controlsbar, {
    shouldAnimateHeight: !1,
    shouldAnimateOverflow: !1
  }, r.createElement(mg.Spacer, null), s ? r.createElement(r.Fragment, null, r.createElement(mg.Input.Search, {
    onChange: function onChange(e) {
      t.fetchImages(e);
    },
    placeholder: i
  }), r.createElement(mg.Spacer, {
    count: 2
  })) : null, a.enableUpload ? r.createElement(Fp, {
    ariaLabel: t.locale.controls.buttonUpload,
    onClick: c,
    fullWidth: !0
  }, t.locale.controls.buttonUpload, r.createElement(mg.Input.File, {
    onChange: l
  })) : null, r.createElement(mg.Spacer, null), a.enableWebcam ? r.createElement(Pp, {
    ariaLabel: t.locale.controls.buttonWebcamOpen,
    onClick: u,
    fullWidth: !0
  }, t.locale.controls.buttonWebcamOpen) : null, r.createElement(Nb.ItemsSeparator, null));
})),
    Vb = e.div(Cb || (Cb = E(["\n  transition: max-height 0.8s ease-out, transform 0.8s ease-out;\n  background: ", ";\n  visibility: hidden;\n  opacity: 0;\n  display: none;\n  flex-wrap: wrap;\n\n  ", "\n"], ["\n  transition: max-height 0.8s ease-out, transform 0.8s ease-out;\n  background: ", ";\n  visibility: hidden;\n  opacity: 0;\n  display: none;\n  flex-wrap: wrap;\n\n  ", "\n"])), function (e) {
  return e.theme.toolControlBar.background;
}, function (e) {
  return e.show && n(Sb || (Sb = E(["\n      opacity: 1;\n      visibility: visible;\n      ", "\n    "], ["\n      opacity: 1;\n      visibility: visible;\n      ", "\n    "])), Ze() ? n(kb || (kb = E(["\n            display: block;\n          "], ["\n            display: block;\n          "]))) : n(Tb || (Tb = E(["\n            display: flex;\n          "], ["\n            display: flex;\n          "]))));
}),
    Xb = Gu("library", "active", "custom")(uc(function (e) {
  var t = e.active,
      n = e.library,
      i = e.custom,
      o = n,
      a = o.query,
      s = o.selectedCategoryIdentifier,
      l = o.categories,
      u = o.images,
      c = function c(e, n) {
    var o = i.getAdvancedItemCard();
    return r.createElement(o, {
      tool: P.LIBRARY,
      type: z.MEDIUM,
      onClick: function onClick() {
        return n = e.identifier, void t.newImage(n);
        var n;
      },
      key: e.identifier,
      image: e.coverImage,
      label: e.defaultName,
      style: {
        animationDelay: .08 * n + "s"
      }
    }, r.createElement(Nb.CardLabel, {
      hidden: !0
    }, e.defaultName));
  },
      p = n.locale.controls.noResults;

  return r.createElement(Nb.Itemsbar, null, r.createElement(Nb.CardContainer, null, a ? u.length ? u.map(c) : r.createElement("p", null, p) : l.map(function (e) {
    var t = s === e.identifier,
        o = i.getAdvancedCategoryCard();
    return r.createElement("div", {
      key: e.identifier
    }, r.createElement(o, {
      isActive: t,
      tool: P.LIBRARY,
      type: z.LARGE,
      onClick: function onClick() {
        return t = e.identifier, void n.toggleCategorySelection(t);
        var t;
      },
      image: e.coverImage,
      label: e.defaultName,
      style: {
        animationDelay: (e.delay || 0) + "s"
      }
    }, r.createElement(Nb.CardLabel, {
      withBackground: !0,
      caret: !0,
      isActive: t
    }, e.defaultName)), r.createElement(Vb, {
      show: t,
      key: e.identifier + "-items"
    }, e.items.map(c)));
  })));
})),
    Yb = Gu("library")(uc(function (e) {
  var t = e.library,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(Gb, null), r.createElement(Xb, null));
})),
    qb = Gu("filterTool")(uc(function (e) {
  var t = e.filterTool,
      n = t.locale.controls,
      i = t.state,
      o = function o() {
    t.toolSnapshot();
  };

  return r.createElement(Nb.Controlsbar, {
    show: t.isOptionSelected
  }, r.createElement(mg.Input.Form, null, r.createElement(Pp, {
    ariaLabel: n.buttonReset,
    onClick: function onClick() {
      t.reset();
    },
    fullWidth: !0
  }, n.buttonReset), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Slider, {
    "aria-hidden": !t.isOptionSelected,
    label: n.sliderIntensity,
    value: i.intensity,
    min: 0,
    max: 1,
    onChange: t.changeIntensity,
    onMouseUp: o,
    onTouchEnd: o,
    snap: i.isDuotone ? .5 : null
  }), r.createElement(mg.Spacer, null)), r.createElement(Nb.ItemsSeparator, null));
})),
    Kb = e.div(Ib || (Ib = E(["\n  background: ", ";\n  visibility: hidden;\n  opacity: 0;\n  transform-origin: 0 0;\n  display: none;\n  flex-wrap: wrap;\n\n  ", "\n"], ["\n  background: ", ";\n  visibility: hidden;\n  opacity: 0;\n  transform-origin: 0 0;\n  display: none;\n  flex-wrap: wrap;\n\n  ", "\n"])), function (e) {
  return e.theme.toolControlBar.background;
}, function (e) {
  return e.show && n(Rb || (Rb = E(["\n      opacity: 1;\n      visibility: visible;\n      ", "\n    "], ["\n      opacity: 1;\n      visibility: visible;\n      ", "\n    "])), Ze() ? n(Eb || (Eb = E(["\n            display: block;\n          "], ["\n            display: block;\n          "]))) : n(Ob || (Ob = E(["\n            display: flex;\n          "], ["\n            display: flex;\n          "]))));
}),
    Zb = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.onFilterClick = function (e) {
      t.filterTool.selectFilter(e.identifier, e.defaultIntensity);
    }, t.onCatgoryClick = function (e) {
      t.filterTool.toggleCategorySelection(e);
    }, t.renderItemCard = function (e) {
      var n = t.filterTool.locale.items[e.identifier] || e.name,
          i = t.custom.getAdvancedItemCard();
      return r.createElement(i, {
        tool: P.FILTER,
        type: z.MEDIUM,
        onClick: function onClick() {
          return t.onFilterClick(e);
        },
        key: e.identifier,
        image: e.thumbnail || e.thumbnailURI,
        label: n,
        style: {
          animationDelay: (e.delay || 0) + "s"
        },
        isActive: t.filterTool.identifier === e.identifier
      }, r.createElement(Nb.CardLabel, {
        withBackground: !0
      }, n));
    }, t.renderCategoryCard = function (e) {
      var n = t.filterTool.selectedCategoryIdentifier === e.identifier,
          i = t.filterTool.locale.categories[e.identifier] || e.name,
          o = t.custom.getAdvancedCategoryCard();
      return r.createElement("div", {
        key: e.identifier
      }, r.createElement(o, {
        isActive: n,
        tool: P.FILTER,
        type: z.LARGE,
        onClick: function onClick() {
          return t.onCatgoryClick(e.identifier);
        },
        image: e.thumbnailURI,
        label: i,
        style: {
          animationDelay: (e.delay || 0) + "s"
        }
      }, r.createElement(Nb.CardLabel, {
        withBackground: !0,
        caret: !0,
        isActive: n
      }, i)), r.createElement(Kb, {
        show: n
      }, e.items.map(t.renderItemCard)));
    }, t;
  }

  return _(t, e), Object.defineProperty(t.prototype, "filterTool", {
    get: function get() {
      return this.props.filterTool;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "custom", {
    get: function get() {
      return this.props.custom;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this.filterTool,
        t = e.categories,
        n = e.flattenCategories,
        i = e.entities;
    return r.createElement(Nb.Itemsbar, {
      key: "filterToolItemsbar"
    }, r.createElement(Nb.CardContainer, null, n ? i.map(this.renderItemCard) : t.map(this.renderCategoryCard)));
  }, t;
}(r.Component),
    Qb = Gu("filterTool", "custom")(uc(Zb)),
    Jb = Gu("filterTool")(uc(function (e) {
  var t = e.filterTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(qb, null), r.createElement(Qb, null));
})),
    $b = Gu("focusTool")(uc(function (e) {
  var t = e.focusTool,
      n = t.locale.controls,
      i = function i() {
    t.toolSnapshot(n.sliderIntensity);
  };

  return r.createElement(Nb.Controlsbar, {
    show: t.isOptionSelected
  }, r.createElement(mg.Input.Form, null, r.createElement(Pp, {
    ariaLabel: n.buttonReset,
    onClick: function onClick() {
      t.reset();
    },
    fullWidth: !0
  }, n.buttonReset), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Slider, {
    "aria-hidden": !t.isOptionSelected,
    label: n.sliderIntensity,
    value: t.intensity,
    min: Oo.minIntensity,
    max: t.maxIntensity,
    divider: 1,
    onChange: t.changeIntensity,
    onMouseUp: i,
    onTouchEnd: i
  })), r.createElement(mg.Spacer, {
    count: 1
  }), r.createElement(Nb.ItemsSeparator, null));
})),
    ew = Gu("focusTool", "custom")(uc(function (e) {
  var t = e.focusTool,
      n = e.custom,
      i = t.entities;
  return r.createElement(Nb.Itemsbar, null, r.createElement(Nb.CardContainer, null, i.map(function (e) {
    var i = t.locale.items[e.identifier] || e.name,
        o = n.getAdvancedItemCard();
    return r.createElement(o, {
      tool: P.FOCUS,
      type: z.LARGE,
      onClick: function onClick() {
        return t.selectFocus(e.identifier);
      },
      key: e.identifier,
      image: e.thumbnailURI,
      label: i,
      style: {
        animationDelay: (e.delay || 0) + "s"
      },
      isActive: e.identifier === t.identifier
    }, r.createElement(Nb.CardLabel, {
      withBackground: !0
    }, i));
  })));
})),
    tw = Gu("focusTool")(uc(function (e) {
  var t = e.focusTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement($b, null), r.createElement(ew, null));
})),
    nw = Gu("adjustmentsTool")(uc(function (e) {
  var t = e.adjustmentsTool,
      n = t,
      i = n.categories,
      o = n.items,
      a = n.config,
      s = function s() {
    t.toolSnapshot();
  },
      l = function l(e) {
    return r.createElement("div", {
      key: e.identifier
    }, r.createElement(mg.Input.Slider, {
      adjust: !0,
      key: e.identifier,
      label: t.locale.items[e.identifier] || e.name,
      value: t[e.identifier],
      onChange: function onChange(n) {
        return function (e, n) {
          t.editAdjustments({
            type: e,
            value: n
          });
        }(e.identifier, n);
      },
      onMouseUp: s,
      onTouchEnd: s,
      snap: 0
    }), r.createElement(mg.Spacer, {
      count: 2
    }));
  },
      u = function u(e) {
    return r.createElement("div", {
      style: {
        position: "relative"
      }
    }, e.map(l));
  };

  return r.createElement(Nb.Itemsbar, null, a.flattenCategories ? u(o) : r.createElement(r.Fragment, null, i.map(function (e, n) {
    return e.items && r.createElement("div", {
      style: {
        position: "relative"
      },
      key: e.identifier
    }, 0 !== n ? r.createElement(mg.Spacer, {
      count: 2
    }) : null, r.createElement(Nb.Sidebar.SubHeading, null, t.locale.categories[e.identifier] || e.name), e.items.map(l), r.createElement(mg.Spacer, {
      count: 2
    }), n !== i.length - 1 ? r.createElement(Nb.ItemsSeparator, {
      full: !0
    }) : null) || null;
  }), u(i.filter(function (e) {
    return !e.items;
  }))));
})),
    iw = Gu("adjustmentsTool")(uc(function (e) {
  var t = e.adjustmentsTool,
      n = t.locale.controls;
  return r.createElement(Nb.Controlsbar, {
    show: t.isDirty
  }, r.createElement(Pp, {
    ariaLabel: n.buttonReset,
    onClick: function onClick() {
      t.reset();
    },
    fullWidth: !0
  }, n.buttonReset), r.createElement(Nb.ItemsSeparator, null));
})),
    rw = Gu("adjustmentsTool")(uc(function (e) {
  var t = e.adjustmentsTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(iw, null), r.createElement(nw, null));
})),
    ow = Gu("overlayTool")(uc(function (e) {
  var t = e.overlayTool,
      n = t.locale.controls,
      i = t.allBlendModes,
      o = t.blendMode,
      a = function a() {
    t.toolSnapshot();
  };

  return r.createElement(Nb.Controlsbar, {
    show: t.isOptionSelected
  }, r.createElement(Pp, {
    ariaLabel: n.buttonReset,
    onClick: function onClick() {
      t.reset();
    },
    fullWidth: !0
  }, n.buttonReset), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.CarouselSlider, {
    label: n.carouselBlendMode,
    defaultIdentifier: o,
    onSelect: function onSelect(e) {
      t.changeBlendMode(e);
    },
    list: i
  }), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Slider, {
    "aria-hidden": !t.isOptionSelected,
    label: n.sliderOpacity,
    value: t.opacity,
    min: 0,
    max: 1,
    onChange: t.changeOpacity,
    onMouseUp: a,
    onTouchEnd: a
  }), r.createElement(mg.Spacer, null), r.createElement(Nb.ItemsSeparator, null));
})),
    aw = Gu("overlayTool", "custom")(uc(function (e) {
  var t = e.overlayTool,
      n = e.custom;
  return r.createElement(Nb.Itemsbar, null, r.createElement(Nb.CardContainer, null, t.entities.map(function (e) {
    var i = t.locale.items[e.identifier] || e.name,
        o = n.getAdvancedItemCard();
    return r.createElement(o, {
      tool: P.OVERLAY,
      type: z.MEDIUM,
      onClick: function onClick() {
        return t.selectOverlay(e.identifier);
      },
      key: e.identifier,
      image: e.thumbnailURI,
      label: i,
      style: {
        animationDelay: (e.delay || 0) + "s"
      },
      isActive: e.identifier === t.identifier
    }, r.createElement(Nb.CardLabel, {
      withBackground: !0
    }, i));
  })));
})),
    sw = Gu("overlayTool")(uc(function (e) {
  var t = e.overlayTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(ow, null), r.createElement(aw, null));
})),
    lw = e.input.attrs({
  type: "file",
  id: "fileUpload",
  accept: "image/*",
  multiple: !0
})(Ab || (Ab = E(["\n  ", "\n"], ["\n  ", "\n"])), Kp.VisuallyHidden),
    uw = Gu("stickerTool")(uc(function (e) {
  var t = e.stickerTool,
      n = t.locale.controls,
      i = t.localeColor.colorPicker,
      o = ql.defaultColors,
      a = function a() {
    t.toolSnapshot();
  },
      s = function s() {
    var e = document.getElementById("fileUpload");
    e && (e.value = null, e.click());
  },
      l = function l(e) {
    var n = e.target.files;
    t.addFiles(n);
  },
      u = !t.isStickerSelected || !t.tintable && t.isStickerSelected;

  return r.createElement(Nb.Controlsbar, {
    shouldAnimateHeight: !1,
    shouldAnimateOverflow: !1,
    overflowAfterExpand: !0
  }, r.createElement(mg.Input.Form, null, t.isCustomStickerEnabled ? r.createElement(Fp, {
    ariaLabel: n.buttonUpload,
    onClick: s,
    fullWidth: !0
  }, n.buttonUpload, r.createElement(lw, {
    onChange: l
  })) : null, r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Slider, {
    isDisabled: !t.isStickerSelected,
    label: n.sliderOpacity,
    value: t.opacity,
    min: 0,
    max: 1,
    onChange: t.changeOpacity,
    onMouseUp: a,
    onTouchEnd: a
  }), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Selection, {
    isDisabled: u,
    label: n.selectColor
  }, r.createElement(Dv, {
    activeSprite: t.id,
    parentId: n.selectColor,
    activeColor: t.tintColor,
    colors: o,
    labelsColor: i,
    isDisabled: u,
    onChange: t.changeTintColor,
    onAddSnapshot: t.tintColorSnapshot
  }))), r.createElement(Nb.ItemsSeparator, null));
})),
    cw = e.div(Pb || (Pb = E(["\n  opacity: 0;\n  visibility: hidden;\n  display: none;\n  flex-wrap: wrap;\n\n  ", "\n"], ["\n  opacity: 0;\n  visibility: hidden;\n  display: none;\n  flex-wrap: wrap;\n\n  ", "\n"])), function (e) {
  return e.show && n(Db || (Db = E(["\n      opacity: 1;\n      visibility: visible;\n      ", "\n    "], ["\n      opacity: 1;\n      visibility: visible;\n      ", "\n    "])), Ze() ? n(Mb || (Mb = E(["\n            display: block;\n          "], ["\n            display: block;\n          "]))) : n(Fb || (Fb = E(["\n            display: flex;\n          "], ["\n            display: flex;\n          "]))));
}),
    pw = Gu("stickerTool", "custom")(uc(function (e) {
  var t = e.stickerTool,
      n = e.custom,
      i = t,
      o = i.categories,
      a = i.selectedCategoryIdentifier,
      s = i.flattenCategories,
      l = i.entities,
      u = function u(e) {
    var i = t.locale.items[e.identifier] || e.name,
        o = n.getAdvancedItemCard();
    return r.createElement(o, {
      key: e.identifier,
      tool: P.STICKER,
      type: z.SMALL,
      onClick: function onClick() {
        return t.add(e.identifier);
      },
      image: e.thumbnailURI,
      label: i,
      style: {
        backgroundSize: "75%",
        animationDelay: (.3 * e.delay || 0) + "s"
      }
    }, r.createElement(Nb.CardLabel, {
      hidden: !0
    }, i));
  };

  return r.createElement(Nb.Itemsbar, null, r.createElement(Nb.CardContainer, null, s ? l.map(u) : o.map(function (e) {
    var i = a === e.identifier,
        o = t.locale.categories[e.identifier] || e.name,
        s = n.getAdvancedCategoryCard();
    return r.createElement("div", {
      key: e.identifier
    }, r.createElement(s, {
      isActive: i,
      tool: P.STICKER,
      type: z.LARGE,
      onClick: function onClick() {
        return t.toggleCategorySelection(e.identifier);
      },
      image: e.thumbnailURI,
      label: o,
      style: {
        animationDelay: (e.delay || 0) + "s"
      }
    }, r.createElement(Nb.CardLabel, {
      withBackground: !0,
      caret: !0,
      isActive: i
    }, o)), r.createElement(cw, {
      show: i,
      key: e.identifier + "-items"
    }, e.items.map(u)));
  })));
})),
    fw = Gu("stickerTool")(uc(function (e) {
  var t = e.stickerTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(uw, null), r.createElement(pw, null));
})),
    hw = e.div(zb || (zb = E(["\n  position: relative;\n"], ["\n  position: relative;\n"]))),
    dw = e.div(Lb || (Lb = E(["\n  display: flex;\n  justify-content: space-between;\n\n  ", " {\n    min-width: 50%;\n  }\n\n  ", " {\n    padding-left: 8px;\n    width: 50%;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n\n  ", " {\n    min-width: 50%;\n  }\n\n  ", " {\n    padding-left: 8px;\n    width: 50%;\n  }\n"])), Lh, sd),
    gw = Gu("textTool", "custom")(uc(function (e) {
  var t,
      n = e.textTool,
      i = e.custom,
      o = n.locale.controls,
      a = n.localeColor.colorPicker,
      s = n,
      l = s.fontFamilies,
      u = s.alignment,
      c = s.isTextSelected,
      p = s.fontFamily,
      f = s.fontStyle,
      h = s.fontWeight,
      d = El.defaultColors,
      g = El.defaultBackgroundColors,
      m = ["left", "center", "right"],
      y = function y() {
    n.toolSnapshot();
  },
      _ = l.map(function (e) {
    return {
      label: e.fontFamily + " " + El.getDisplayFontStyle(e),
      fontWeight: e.fontWeight || "",
      fontStyle: e.fontStyle || "",
      fontFamily: e.fontFamily || "",
      value: e.identifier
    };
  }),
      v = _.filter(function (e) {
    return e.value === n.identifier;
  })[0];

  return r.createElement(Nb.Controlsbar, {
    show: !0,
    overflowAfterExpand: !0,
    shouldAnimateHeight: !1
  }, r.createElement(mg.Input.Form, null, r.createElement(Fp, {
    ariaLabel: o.buttonNew,
    onClick: function onClick() {
      n.add();
    },
    fullWidth: !0
  }, o.buttonNew), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Dropdown, {
    isDisabled: !c,
    style: {
      fontFamily: p,
      fontStyle: f,
      fontWeight: h
    },
    itemStyle: function itemStyle(e) {
      return {
        fontFamily: e.fontFamily,
        fontStyle: e.fontStyle,
        fontWeight: e.fontWeight
      };
    },
    label: o.dropdownFontFamily,
    list: _,
    onSelect: n.changeFont,
    selectedItem: v.label
  }), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(dw, null, r.createElement(mg.Input.NummericInput, {
    value: n.fontSize.toFixed(0),
    onSubmit: function onSubmit(e) {
      var t = e ? parseFloat(e) : 0;
      n.setFontSize(Math.max(10, Math.min(690, t)));
    },
    label: o.textFontSize,
    isDisabled: !c
  }), r.createElement(mg.Input.Selection, {
    isDisabled: !c,
    inline: !0,
    label: o.selectAlignment
  }, (t = i.getButton("textAlignment"), m.map(function (e) {
    var i = Fy[e];
    return r.createElement(t, {
      isDisabled: !c,
      ariaLabel: "Align " + e,
      isActive: e === u,
      key: e,
      style: {
        padding: "1px 3px 2px"
      },
      icon: r.createElement(i, null),
      onClick: function onClick() {
        return n.changeAlignment(e);
      }
    });
  })))), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(hw, null, r.createElement(Nb.ItemsSeparator, {
    full: !0
  })), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Selection, {
    isDisabled: !c,
    label: o.selectFontColor
  }, r.createElement(Dv, {
    activeSprite: n.id,
    parentId: o.selectFontColor,
    activeColor: n.textColor,
    colors: d,
    labelsColor: a,
    isDisabled: !c,
    onChange: n.changeColor,
    onAddSnapshot: n.colorSnapshot
  })), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Selection, {
    isDisabled: !c,
    label: o.selectBackgroundColor
  }, r.createElement(Dv, {
    activeSprite: n.id,
    parentId: o.selectBackgroundColor,
    activeColor: n.backgroundColor,
    colors: g,
    labelsColor: a,
    isDisabled: !c,
    onChange: n.changeBackgroundColor,
    onAddSnapshot: n.backgroundColorSnapshot
  })), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(hw, null, r.createElement(Nb.ItemsSeparator, {
    full: !0
  })), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Slider, {
    isDisabled: !c,
    label: o.sliderLineSpacing,
    value: n.lineHeight,
    min: .5,
    max: 3,
    onChange: n.changeLineHeight,
    onMouseUp: y,
    onTouchEnd: y,
    snap: 1,
    divider: 1,
    decimal: 1
  }), r.createElement(mg.Spacer, {
    count: 1
  })));
})),
    mw = Gu("textTool")(uc(function (e) {
  var t = e.textTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(gw, null), r.createElement(Nb.Itemsbar, null));
})),
    yw = Gu("textDesignTool")(uc(function (e) {
  var t = e.textDesignTool,
      n = t.locale.controls,
      i = t.localeColor.colorPicker,
      o = Al.colors,
      a = t.isTextDesignSelected;
  return r.createElement(Nb.Controlsbar, {
    shouldAnimateOverflow: !1,
    shouldAnimateHeight: !1
  }, r.createElement(mg.Input.Form, null, r.createElement(Fp, {
    ariaLabel: n.buttonNew,
    onClick: function onClick() {
      t.add();
    },
    fullWidth: !0
  }, n.buttonNew), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(Pp, {
    ariaLabel: n.buttonShuffle,
    isDisabled: !a,
    onClick: function onClick() {
      t.changeSeed();
    },
    fullWidth: !0
  }, n.buttonShuffle), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Selection, {
    isDisabled: !a,
    label: n.selectColor
  }, r.createElement(Dv, {
    activeSprite: t.id,
    parentId: n.selectColor,
    activeColor: t.color,
    colors: o,
    labelsColor: i,
    isDisabled: !a,
    onChange: t.changeColor,
    onAddSnapshot: t.colorSnapshot
  }))), r.createElement(Nb.ItemsSeparator, null));
})),
    _w = Gu("textDesignTool", "custom")(uc(function (e) {
  var t = e.textDesignTool,
      n = e.custom,
      i = t.entities,
      o = t.identifier;
  return r.createElement(Nb.Itemsbar, null, r.createElement(Nb.CardContainer, null, i.map(function (e) {
    var i = n.getAdvancedItemCard();
    return r.createElement(i, {
      key: e.identifier,
      tool: P.TEXT_DESIGN,
      type: z.MEDIUM,
      onClick: function onClick() {
        return n = e.identifier, void t.changeIdentifier(n);
        var n;
      },
      image: e.thumbnailURI,
      label: e.name || "",
      style: {
        animationDelay: (e.delay || 0) + "s",
        backgroundSize: "60%"
      },
      isDisabled: !t.isTextDesignSelected,
      isActive: o === e.identifier
    }, r.createElement(Nb.CardLabel, {
      hidden: !0
    }, e.name));
  })));
})),
    vw = Gu("textDesignTool")(uc(function (e) {
  var t = e.textDesignTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(yw, null), r.createElement(_w, null));
})),
    bw = Gu("frameTool", "custom")(uc(function (e) {
  var t = e.frameTool,
      n = e.custom,
      i = t.entities,
      o = t.state ? t.state.identifier : null;
  return r.createElement(Nb.Itemsbar, null, r.createElement(Nb.CardContainer, null, i.map(function (e) {
    var i = t.locale.items[e.identifier] || e.name,
        a = n.getAdvancedItemCard();
    return r.createElement(a, {
      tool: P.FRAME,
      type: z.MEDIUM,
      onClick: function onClick() {
        return t.selectFrame(e.identifier);
      },
      key: e.identifier,
      image: e.thumbnailURI,
      label: i,
      style: {
        backgroundSize: "75%",
        animationDelay: (e.delay || 0) + "s"
      },
      isActive: e.identifier === o
    }, r.createElement(Nb.CardLabel, {
      hidden: !0
    }, i));
  })));
})),
    ww = Gu("frameTool")(uc(function (e) {
  var t = e.frameTool,
      n = t.locale.controls,
      i = t.localeColor.colorPicker,
      o = t.tintable,
      a = ml.colors,
      s = function s(e) {
    t.toolSnapshot(e);
  };

  return r.createElement(Nb.Controlsbar, {
    show: t.isOptionSelected,
    overflowAfterExpand: !0
  }, r.createElement(Pp, {
    ariaLabel: n.buttonReset,
    onClick: function onClick() {
      t.reset();
    },
    fullWidth: !0
  }, n.buttonReset), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Slider, {
    "aria-hidden": !t.isOptionSelected,
    label: n.sliderOpacity,
    value: t.opacity,
    min: 0,
    max: 1,
    onChange: t.changeOpacity,
    onMouseUp: function onMouseUp() {
      s(n.sliderOpacity);
    },
    onTouchEnd: function onTouchEnd() {
      s(n.sliderOpacity);
    }
  }), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Slider, {
    "aria-hidden": !t.isOptionSelected,
    label: n.sliderSize,
    value: t.size,
    min: t.minSize,
    max: t.maxSize,
    divider: 1,
    onChange: t.changeWidth,
    onMouseUp: function onMouseUp() {
      s(n.sliderSize);
    },
    onTouchEnd: function onTouchEnd() {
      s(n.sliderSize);
    }
  }), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Selection, {
    isDisabled: !o,
    label: n.selectColor
  }, r.createElement(Dv, {
    parentId: n.selectColor,
    activeColor: t.color,
    colors: a,
    labelsColor: i,
    isDisabled: !o,
    onChange: t.changeColor,
    onAddSnapshot: t.colorSnapshot
  })), r.createElement(Nb.ItemsSeparator, null));
})),
    xw = Gu("frameTool")(uc(function (e) {
  var t = e.frameTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(ww, null), r.createElement(bw, null));
})),
    kw = Gu("brushTool")(uc(function (e) {
  var t = e.brushTool,
      n = t.locale.controls,
      i = t.localeColor.colorPicker,
      o = wl.colors;
  return r.createElement(r.Fragment, null, r.createElement(Nb.Controlsbar, {
    show: t.isDirty
  }, r.createElement(Pp, {
    ariaLabel: n.buttonReset,
    onClick: t.reset,
    fullWidth: !0
  }, n.buttonReset), r.createElement(Nb.ItemsSeparator, null)), r.createElement(Nb.Controlsbar, {
    overflowAfterExpand: !0
  }, r.createElement(mg.Input.Selection, {
    label: n.selectColor
  }, r.createElement(Dv, {
    parentId: n.selectColor,
    activeColor: t.color,
    colors: o,
    labelsColor: i,
    onChange: t.changeColor
  })), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(mg.Input.Slider, {
    label: n.sliderSize,
    value: t.size,
    min: 1,
    max: 100,
    divider: 1,
    onChange: t.changeSize
  }), r.createElement(mg.Spacer, {
    count: 3
  }), r.createElement(mg.Input.Slider, {
    label: n.sliderHardness,
    value: t.hardness,
    min: 0,
    max: 1,
    onChange: t.changeHardness
  }), r.createElement(mg.Spacer, null)));
})),
    Tw = Gu("brushTool")(uc(function (e) {
  var t = e.brushTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(kw, null), r.createElement(Nb.Itemsbar, null));
})),
    Sw = Gu("transformTool", "custom")(uc(function (e) {
  var t = e.transformTool,
      n = e.custom,
      i = t.locale.controls,
      o = t,
      a = o.forceDimensions,
      s = o.lockResolution,
      l = o.localOutputHeight,
      u = o.localOutputWidth,
      c = n.getCheckbox();
  return r.createElement(Nb.Controlsbar, {
    shouldAnimateHeight: !1
  }, r.createElement(mg.Input.Form, null, r.createElement(Pp, {
    ariaLabel: i.buttonReset,
    onClick: function onClick() {
      t.reset();
    },
    fullWidth: !0
  }, i.buttonReset), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(c, {
    isDisabled: a,
    value: s,
    label: i.checkboxKeepResolution,
    checkMarkPosition: "right",
    onClick: t.changeLockResolution,
    style: {
      paddingTop: "5px",
      justifyContent: "space-between"
    }
  }), r.createElement(mg.Spacer, {
    count: 2
  }), r.createElement(Iv, {
    isDisabled: a,
    showLabel: !0,
    valueHeight: l,
    valueWidth: u,
    onPixelWidth: t.onPixelWidth,
    onPixelHeight: t.onPixelHeight,
    onChangeHeight: t.changeLocalOutputHeight,
    onChangeWidth: t.changeLocalOutputWidth,
    label: i.inputCropSize,
    labelHeight: i.inputHeight,
    labelWidth: i.inputWidth
  }), r.createElement(mg.Spacer, {
    count: 1
  })), r.createElement(Nb.ItemsSeparator, null));
})),
    Cw = Gu("transformTool", "custom", "editor")(uc(function (e) {
  var t = e.transformTool,
      n = e.custom,
      i = e.editor,
      o = t,
      a = o.categories,
      s = o.items,
      l = o.identifier,
      u = o.config,
      c = function c(e) {
    var o = e.identifier === l,
        a = i.configStore,
        s = a.theme,
        u = a.measurements;

    if (e.thumbnailURI && t.checkIfTransformThumbnailExits(e.thumbnailURI)) {
      var c = t.locale.items[e.identifier] || e.name,
          p = n.getAdvancedItemCard();
      return r.createElement(p, {
        key: e.identifier,
        tool: P.TRANSFORM,
        type: z.MEDIUM,
        onClick: function onClick() {
          return t.changeIdentifier(e.identifier, !0);
        },
        image: e.thumbnailURI,
        label: c,
        style: {
          backgroundSize: "80%",
          animationDelay: (e.delay || 0) + "s"
        },
        isActive: o
      }, r.createElement(Nb.CardLabel, null, c));
    }

    var f = e.identifier.includes("imgly_transform_common"),
        d = Ny.crops[e.identifier] || Ny.crops.imgly_transform_common_custom,
        g = r.createElement(d, {
      width: u.advancedCard.medium.width - (f ? 42 : 0),
      height: u.advancedCard.medium.height - (f ? 42 : 0),
      main: s.transform.crops.main,
      highlight: s.transform.crops.highlight,
      shadow: s.transform.crops.shadow
    }),
        m = t.locale.categories[e.identifier] || e.name,
        y = n.getAdvancedItemCard();
    return r.createElement(y, {
      tool: P.TRANSFORM,
      type: z.MEDIUM,
      onClick: function onClick() {
        return t.changeIdentifier(e.identifier, !0);
      },
      key: e.identifier,
      image: "'data:image/svg+xml," + encodeURIComponent(h(g)) + "'",
      label: m,
      style: {
        animationDelay: (e.delay || 0) + "s",
        backgroundSize: Ze() || Ke() ? "auto" : "unset"
      },
      isActive: o
    }, r.createElement(Nb.CardLabel, null, m));
  },
      p = function p(e) {
    return r.createElement("div", {
      style: {
        position: "relative"
      }
    }, r.createElement(Nb.CardContainer, null, e.map(c)));
  };

  return r.createElement(Nb.Itemsbar, null, u.flattenCategories ? p(s) : r.createElement(r.Fragment, null, a.map(function (e, t) {
    return e.items && r.createElement("div", {
      style: {
        position: "relative"
      },
      key: e.identifier
    }, 0 !== t ? r.createElement(mg.Spacer, {
      count: 2
    }) : null, r.createElement(Nb.Sidebar.SubHeading, null, e.name), r.createElement(Nb.CardContainer, null, e.items.map(c)), r.createElement(mg.Spacer, {
      count: 2
    }), t !== a.length - 1 ? r.createElement(Nb.ItemsSeparator, {
      full: !0
    }) : null) || null;
  }), p(a.filter(function (e) {
    return !e.items;
  }))));
})),
    Ew = Gu("transformTool")(uc(function (e) {
  var t = e.transformTool,
      n = e.displayTitle;
  return r.createElement(r.Fragment, null, n && r.createElement(Nb.Sidebar.Heading, null, t.locale.title), r.createElement(Sw, null), r.createElement(Cw, null));
})),
    Ow = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return _(t, e), t.prototype.render = function () {
    var e = this.props.active.tool,
        t = this.props.config.config.displayToolControlBarTitle;
    return r.createElement(Nb.Sidebar.Index, null, r.createElement(mg.Switch.Index, {
      type: e
    }, r.createElement(mg.Switch.Case, {
      value: P.LIBRARY
    }, r.createElement(Yb, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.FILTER
    }, r.createElement(Jb, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.FOCUS
    }, r.createElement(tw, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.ADJUSTMENT
    }, r.createElement(rw, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.OVERLAY
    }, r.createElement(sw, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.STICKER
    }, r.createElement(fw, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.TEXT
    }, r.createElement(mw, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.TEXT_DESIGN
    }, r.createElement(vw, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.FRAME
    }, r.createElement(xw, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.BRUSH
    }, r.createElement(Tw, {
      displayTitle: t
    })), r.createElement(mg.Switch.Case, {
      value: P.TRANSFORM
    }, r.createElement(Ew, {
      displayTitle: t
    }))));
  }, t = w([Gu("active", "config"), uc], t);
}(r.Component),
    Rw = e.div(Bb || (Bb = E(["\n  position: absolute;\n  height: 100%;\n  width: ", "px;\n  top: 0;\n  background: ", ";\n  z-index: ", ";\n"], ["\n  position: absolute;\n  height: 100%;\n  width: ", "px;\n  top: 0;\n  background: ", ";\n  z-index: ", ";\n"])), function (e) {
  return e.theme.measurements.advancedUIToolbar.width + e.theme.measurements.advancedUIToolControlBar.width;
}, function (e) {
  return e.theme.webcam.backdrop;
}, function (e) {
  return e.theme.measurements.zIndex.disable;
}),
    Iw = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      hasError: !1
    }, t;
  }

  return _(t, e), t.getDerivedStateFromError = function (e) {
    return console.error(e), {
      hasError: !0
    };
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.config,
        n = e.active;
    return t.isOrderDefault ? r.createElement(mg.Container, {
      "data-test-id": "EditorContainer"
    }, n.isWebcam ? r.createElement(Rw, {
      style: {
        left: 0
      }
    }) : null, r.createElement(Av, null), r.createElement(Hb, null), r.createElement(Ow, null), r.createElement(Ig, null, r.createElement(Cv, null), r.createElement(fv, null))) : r.createElement(mg.Container, {
      "data-test-id": "EditorContainer"
    }, n.isWebcam ? r.createElement(Rw, {
      style: {
        right: 0
      }
    }) : null, r.createElement(Av, null), r.createElement(Ig, null, r.createElement(Cv, null), r.createElement(fv, null)), r.createElement(Ow, null), r.createElement(Hb, null));
  }, t;
}(r.Component),
    Aw = Gu("config", "active")(uc(Iw)),
    Mw = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    this.editor = this.props.editor, this.storeProps = this.props.storeProps;
    var e = new Mv(this.editor.configStore.config.custom.components, {
      advancedUICategoryCard: Nb.Card,
      advancedUIItemCard: Nb.Card,
      advancedUIToolbarItem: Ub
    }),
        t = {
      getAdvancedCategoryCard: e.getAdvancedCategoryCard,
      getAdvancedItemCard: e.getAdvancedItemCard,
      getAdvancedToolbarItem: e.getAdvancedToolbarItem,
      getLoader: e.getLoader,
      getButton: e.getButton,
      getColorItem: e.getColorItem,
      getCheckbox: e.getCheckbox
    };
    this.storeProps.custom = t, this.forceUpdate();
  }, t.prototype.render = function () {
    return this.storeProps ? r.createElement(mc, _v2({}, this.storeProps), r.createElement(i, {
      theme: _v2(_v2({}, this.editor.configStore.theme), {
        measurements: this.editor.configStore.measurements
      })
    }, r.createElement(Aw, null))) : null;
  }, t;
}(r.Component),
    Fw = Nb.CardLabel,
    Dw = Object.freeze({
  __proto__: null,
  AdvancedUI: Mw,
  ToolbarItem: Ub,
  CardLabel: Fw
});

document.onkeydown = function (e) {
  13 === e.keyCode && document.activeElement && document.activeElement.click();
};

var Pw = function (e) {
  function t(t, n) {
    var i = e.call(this) || this;
    return i.dispose = function () {
      i.container && (c.unmountComponentAtNode(i.container), i.removeAllListeners(ve.EXPORT), i.removeAllListeners(ve.HISTORY_CHANGE), i.removeAllListeners(ve.EDITOR_READY));
    }, i.serialize = function (e) {
      return i.editor.serialize(e);
    }, i.deserialize = function (e) {
      return i.editor.deserialize(e);
    }, i.export = function (e) {
      return i.editor.export(e);
    }, i.close = function () {
      return i.editor.close();
    }, i.setImage = function (e) {
      return i.editor.setImage(e);
    }, i.container = n, i.editor = new Yl(_v2({}, t)), i.editor.configStore.events.on(ve.EXPORT, function (e) {
      i.emit(ve.EXPORT, e);
    }), i.editor.configStore.events.on(ve.CLOSE, function () {
      i.dispose(), i.emit(ve.CLOSE);
    }), i.editor.configStore.events.on(ve.HISTORY_CHANGE, function () {
      i.emit(ve.HISTORY_CHANGE);
    }), i;
  }

  return _(t, e), t.prototype.hasChanges = function () {
    return this.editor.hasChanges();
  }, t;
}(Te),
    zw = function () {
  function e() {
    this.container = null;
  }

  return e.prototype.init = function (e) {
    var t = this;
    return new Promise(function (n, i) {
      t.container = "string" == typeof e.container ? document.querySelector(e.container) : e.container, t.container ? (t.editorApi = new Pw(e, t.container), c.render(r.createElement(Lw, {
        editor: t.editorApi.editor
      }), t.container), t.editorApi.editor.configStore.events.on(ve.EDITOR_READY, function () {
        setTimeout(function () {
          t.editorApi.emit(ve.EDITOR_READY);
        }, 0), n(t.editorApi);
      })) : i(new Error("Provide a container"));
    });
  }, e;
}(),
    Lw = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.UIComponent = null, t;
  }

  return _(t, e), t.prototype.componentDidMount = function () {
    var e = this;
    this.editor = this.props.editor, this.storeProps = {
      filterTool: this.editor.filterToolStore,
      focusTool: this.editor.focusToolStore,
      adjustmentsTool: this.editor.adjustmentsToolStore,
      overlayTool: this.editor.overlayToolStore,
      frameTool: this.editor.frameToolStore,
      brushTool: this.editor.brushToolStore,
      transformTool: this.editor.transformToolStore,
      scale: this.editor.scale,
      sprite: this.editor.spriteStore,
      stickerTool: this.editor.spriteStore.stickerToolStore,
      textTool: this.editor.spriteStore.textToolStore,
      textDesignTool: this.editor.spriteStore.textDesignToolStore,
      library: this.editor.libraryStore,
      modal: this.editor.modalStore,
      snapping: this.editor.snappingStore,
      config: this.editor.configStore,
      active: this.editor.activeStore,
      canvas: this.editor.canvasStore,
      history: this.editor.historyStore,
      editor: this.editor
    }, "basic" === this.editor.configStore.config.layout ? import("./index-db953767.js").then(function (t) {
      var n = t.BasicUI;
      e.UIComponent = n, e.forceUpdate();
    }) : Promise.resolve().then(function () {
      return Dw;
    }).then(function (t) {
      var n = t.AdvancedUI;
      e.UIComponent = n, e.forceUpdate();
    });
  }, t.prototype.componentWillUnmount = function () {
    this.editor.engine.dispose(), this.editor.configStore.events.removeAllListeners(ve.EXPORT), this.editor.configStore.events.removeAllListeners(ve.CLOSE), this.editor.configStore.events.removeAllListeners(ve.HISTORY_CHANGE), this.editor.configStore.events.removeAllListeners(ve.EDITOR_READY);
  }, t.prototype.render = function () {
    if (this.editor) {
      var e = this.UIComponent;
      return this.storeProps && e ? r.createElement(e, {
        editor: this.editor,
        storeProps: this.storeProps
      }) : null;
    }

    return null;
  }, t;
}(r.Component),
    Bw = {
  init: function init(e) {
    return new zw().init(e);
  }
},
    Nw = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;
    return n.ui = new Te(), n.serialize = function (e) {
      return n.editor.serialize(e);
    }, n.deserialize = function (e) {
      return n.editor.deserialize(e);
    }, n.export = function (e) {
      return n.editor.export(e);
    }, n.close = function () {
      return n.editor.close();
    }, n.setImage = function (e) {
      return n.editor.setImage(e);
    }, n.editor = new Yl(_v2({}, t)), n.editor.configStore.events.on(ve.EXPORT, function (e) {
      n.ui.emit(ve.EXPORT, e);
    }), n.editor.configStore.events.on(ve.CLOSE, function () {
      n.componentWillUnmount(), n.ui.emit(ve.CLOSE);
    }), n.editor.configStore.events.on(ve.HISTORY_CHANGE, function () {
      n.ui.emit(ve.HISTORY_CHANGE);
    }), n.editor.configStore.events.on(ve.EDITOR_READY, function () {
      n.ui.emit(ve.EDITOR_READY);
    }), n.storeProps = {
      filterTool: n.editor.filterToolStore,
      focusTool: n.editor.focusToolStore,
      adjustmentsTool: n.editor.adjustmentsToolStore,
      overlayTool: n.editor.overlayToolStore,
      frameTool: n.editor.frameToolStore,
      brushTool: n.editor.brushToolStore,
      transformTool: n.editor.transformToolStore,
      scale: n.editor.scale,
      sprite: n.editor.spriteStore,
      stickerTool: n.editor.spriteStore.stickerToolStore,
      textTool: n.editor.spriteStore.textToolStore,
      textDesignTool: n.editor.spriteStore.textDesignToolStore,
      library: n.editor.libraryStore,
      modal: n.editor.modalStore,
      snapping: n.editor.snappingStore,
      config: n.editor.configStore,
      active: n.editor.activeStore,
      canvas: n.editor.canvasStore,
      history: n.editor.historyStore,
      editor: n.editor
    }, "basic" === n.editor.configStore.config.layout ? import("./index-db953767.js").then(function (e) {
      var t = e.BasicUI;
      n.UIComponent = t, n.forceUpdate();
    }) : Promise.resolve().then(function () {
      return Dw;
    }).then(function (e) {
      var t = e.AdvancedUI;
      n.UIComponent = t, n.forceUpdate();
    }), n;
  }

  return _(t, e), t.prototype.componentWillUnmount = function () {
    this.ui.removeAllListeners(ve.EXPORT), this.ui.removeAllListeners(ve.HISTORY_CHANGE), this.ui.removeAllListeners(ve.EDITOR_READY);
  }, t.prototype.hasChanges = function () {
    return this.editor.hasChanges();
  }, t.prototype.render = function () {
    if (this.editor) {
      var e = this.UIComponent;
      return this.storeProps && e ? r.createElement(e, {
        editor: this.editor,
        storeProps: this.storeProps
      }) : null;
    }

    return null;
  }, t;
}(r.Component),
    Uw = mg.Loader,
    jw = mg.Input,
    Ww = mg.ColorItem,
    Hw = mg.ColorItemBase,
    Gw = mg.ColorItemBackground,
    Vw = mg.ColorItemTiledBackground,
    Xw = mg.ColorItemActiveOverlay,
    Yw = jw.Label,
    qw = jw.Checkbox,
    Kw = jw.CheckboxBase,
    Zw = jw.CheckboxInput,
    Qw = jw.CheckboxCheckMark,
    Jw = wg,
    $w = wg;

export { fe as $, Jw as A, Og as B, Fw as C, q as D, K as E, Q as F, Z as G, J as H, Bp as I, $ as J, ee as K, Uw as L, te as M, ie as N, Pp as O, Bw as P, ne as Q, oe as R, X as S, Ub as T, ae as U, j as V, se as W, le as X, ce as Y, pe as Z, re as _, m as a, he as a0, de as a1, ge as a2, me as a3, ye as a4, be as a5, we as a6, xe as a7, _e as a8, ve as a9, Dv as aA, ql as aB, Fy as aC, Al as aD, ml as aE, wl as aF, Iv as aG, Jy as aH, Av as aI, Ig as aJ, Cv as aK, fv as aL, Mv as aM, mc as aN, S as aO, T as aP, pa as aQ, ot as aR, ct as aS, F as aT, C as aU, R as aV, ut as aW, Te as aa, Wp as ab, E as ac, _v2 as ad, Kp as ae, b as af, qp as ag, Xs as ah, Op as ai, _ as aj, Zp as ak, Dp as al, Rg as am, mg as an, Gu as ao, uc as ap, My as aq, Ss as ar, Uy as as, El as at, Ay as au, Ny as av, w as aw, Dy as ax, Oo as ay, Fp as az, $w as b, d as c, Tg as d, Np as e, Yw as f, qw as g, Kw as h, Zw as i, Qw as j, Ww as k, Hw as l, Gw as m, Vw as n, Xw as o, Nw as p, tn as q, Fs as r, N as s, U as t, D as u, P as v, z as w, W as x, H as y, Y as z };